	Date.prototype.getWeek = function() {
		var onejan = new Date(this.getFullYear(),0,1);
	 return Math.ceil((((this - onejan) / 86400000) + onejan.getDay()+1)/7);
  };
    
	Date.prototype.addDays = function(days) {
		this.setDate(this.getDate() + parseInt(days));
	 return this;
	};

	angular.module('AngularApp',
	['ui.bootstrap', 'ngRoute', 'LocalStorageModule', 'flow', 'ui.utils', 'angular.filter',
	'ngAnimate', 'ngBootbox', 'ngImgCrop', 'ngSanitize', 'textAngular', 'ui.select', 'ui.calendar', 'mgo-angular-wizard', 'toastr',
	'RxC.Utils', 'RxC.pages', 'ngSessionStorage', 'ui.toggle', 'pubnub.angular.service', 'uiSwitch', 'ngSanitize', 'ngCsv','ng.deviceDetector']);

  function CollapseDemoCtrl($scope) {
	  $scope.isCollapsed = false;
  }



//var mainUrl = 'http://159.89.204.187'; //Production Server
//var mainUrl = 'http://128.199.183.249'; //Development Server
  // var mainUrl = 'https://dev.epicare.net'; // Developmwent Server
  var mainUrl = 'https://dev.epicare.net'; // Test Server

//var mainUrl = 'http://165.22.55.139'; //Performance Server
//var mainUrl = 'http://localhost'; //Local Development
  angular.module('AngularApp').value('mainUrl', mainUrl); 
  angular.module('AngularApp').value('serviceBaseUrl', mainUrl+'/wrapper/service/');
  angular.module('AngularApp').value('dashboardBaseUrl', mainUrl+'/wrapper/dashboard/'); 
  angular.module('AngularApp').value('registerBaseUrl', mainUrl+':/wrapper/registration/'); 
  angular.module('AngularApp').value('helyxonApiUrl', mainUrl+'/helyxonapi/'); 

//Define routes for the application
	angular.module('AngularApp').config(['$routeProvider', '$httpProvider',function ($routeProvider, $httpProvider) {
		$httpProvider.defaults.timeout = 5000;
	//angular Application Route configuration
		$routeProvider
		.when("/login/:email?/:pwd?", {
			controller: "loginController",
			templateUrl: "views/login/login.htm"
		})
	  .when("/changepassword/:pwd?", {
			controller: "changePwdController",
			templateUrl: "views/changepassword.htm"
		})
	  .when("/register", {
			controller: "registerController",
			templateUrl: "views/patient/register.htm"
    })
    .when("/dischargeSummary", {
			controller: "dischargeController1",
			templateUrl: "views/discharge/dischargeSummary.htm"
    })
    .when("/dischargeEntry", {
			controller: "dischargeController2",
			templateUrl: "views/discharge/dischargeEntry.htm"
    })
    .when("/dischargeCard", {
			controller: "dischargeController3",
			templateUrl: "views/discharge/dischargeCard.htm"
    })
    .when("/followupschedule", {
			controller: "dischargeController5",
			templateUrl: "views/discharge/FollowUpSchedule.htm"
    })
    .when("/pcfollowupschedule", {
			controller: "dischargeController6",
			templateUrl: "views/discharge/PcFollowupSchedule.htm"
    })
    .when("/engage-master", {
			controller: "engagementController",
			templateUrl: "views/engage/engage_master.htm"
    }) 
    .when("/multicenterStudy", {
			controller: "multicenterStudyController",
			templateUrl: "views/multicenter/multicenterStudy.htm"
    })
    .when("/inandout", {
			controller: "inandoutController",
			templateUrl: "views/inandout/inandout_content.htm"
    })
    .when("/subscription-master", {
			controller: "subscriptionController",
			templateUrl: "views/subscription/subscr_master.htm"
    })
    .when("/engage-content", {
			controller: "engagementController",
			templateUrl: "views/engage/engage_content.htm"
    })
    .when("/frontdesk_master", {
			controller: "frontdeskController",
			templateUrl: "views/frontdesk/frontdesk_master.htm"
    })
    .when("/report_master", {
			controller: "reportmaster_Controller",
			templateUrl: "views/report/report_master.htm"
    })
    .when("/ivrs_master", {
			controller: "ivrsController",
			templateUrl: "views/ivrs/ivrs_master.htm"
    })
    .when("/admissionList", {
      controller: "dischargeController4",
      templateUrl: "views/discharge/admissionList.htm"
     })
	  .when("/home", {
			controller: "homeController",
			templateUrl: "views/home.htm"
		})
		.when("/appointment", {
			controller: "homeController",
			templateUrl: "views/appointment.htm"
		})
		.when("/accountlist/:Id?", {
			controller: "accountController",
			templateUrl: "views/accountlist.htm"
		})
		.when("/patientview/:Id?", {
			controller: "patientviewController",
			templateUrl: "views/patienttemplate.htm"
		})
		.when("/patientlist", {
			controller: "patientlistController",
			templateUrl: "views/patientlist.htm"
		})
		.when("/SMSnotify", {
			controller: "smsnotifyController",
			templateUrl: "views/sendnotificationpopup.htm"
		})
		.when("/Emailnotify", {
			controller: "emailnotifyController",
			templateUrl: "views/emailnotification.htm"
		})
    .when("/Viewsms", {
			controller: "viewnotificationController",
			templateUrl: "views/viewnotification.htm"
		})
		.when("/Viewemail", {
			controller: "viewemailController",
			templateUrl: "views/viewnotification.htm"
		})
		.when("/vacschedule", {
			controller: "homeController",
			templateUrl: "views/vacschedule.htm"
		})
    .when("/vendormaster", {
      controller: "vendorController",
      templateUrl: "views/vendormaster.htm"
    })
		.when("/vaccineinventory", {
			controller: "vendorController",
			templateUrl: "views/vaccineinventory.htm"
		})
		.when("/vaccinationvendor", {
			controller: "vendorController",
			templateUrl: "views/vaccinationvendor.htm"
		})
		.when("/updatevendor", {
			controller: "vendorController",
			templateUrl: "views/updatevendor.htm"
		})
	  .when("/order", {
			controller: "vendorController",
			templateUrl: "views/order.htm"
		})
    .when("/details", {
      controller: "vendorController",
      templateUrl: "views/details.htm"
    })
    .when("/payment", {
      controller: "patientviewController",
      templateUrl: "views/patient/payment.htm"
    })
  //.when("/paymentmodule", {
    //controller: "paymentController",
    //templateUrl: "views/payment/paymentHistory.htm"
  //})
    .when("/paymenthistory", {
      controller: "paymentController",
      templateUrl: "views/payment/paymentHistory.htm"
    })
    .when("/rangeHistory", {
      controller: "rangeController",
      templateUrl: "views/payment/rangeHistory.htm"
    })
    .when("/vaccinereport", {
      controller: "vaccineReminderController",
      templateUrl: "views/vaccineReport.htm"
    })
    .when("/settings", {
      controller: "settingsController",
      templateUrl: "views/settings.htm"
    })
    .when("/schedule", {
      controller: "appointmentController",
      templateUrl: "views/schedule.htm"
    })
    .when("/appointment", {
      controller: "appointmentController",
      templateUrl: "views/appointment.htm"
    })
    .when("/time", {
      controller: "appointmentController",
      templateUrl: "views/time.htm"
    })
    .when("/calendarupdate", {
      controller: "appointmentController",
      templateUrl: "views/calendarupdate.htm"
    })
    .when("/bookapt", {
      controller: "patientlistController",
      templateUrl: "views/bookapt.htm"
    })
    .when("/appointmentbydate", {
      controller: "homeController",
      templateUrl: "views/appointmentbydate.htm"
    })
    .when("/reports", {
      controller: "reportController",
      templateUrl: "views/reports.htm"
    })
    .when("/milestoneConfig", {
      controller: "milestoneController",
      templateUrl: "views/milestone/milestoneConfig.htm"
    })
    .when('/newMilestone', {
      controller: "milestoneController",
      templateUrl: "views/milestone/addMilestone.htm"
    })
    .when('/updateMilestone', {
      controller: "milestoneController",
      templateUrl: "views/milestone/updateMilestone.htm"
    })
    .when('/lifelogConfig', {
      controller: "lifelogController",
      templateUrl: "views/lifelog/lifelogConfig.htm"
    })
    .when('/labtestConfig', { 
      controller: "labtestController",
      templateUrl: "views/labReport/labtestConfig.htm"
    })
    .when('/newLifelog', {
      controller: "lifelogController",
      templateUrl: "views/lifelog/addLifelog.htm"
    })
    .when('/newLabtest', {
      controller: "labtestController",
      templateUrl: "views/labReport/addpackages.htm"
    })
    .when('/newLabtestgroup', {
      controller: "labtestController",
      templateUrl: "views/labReport/grouppackages.htm"
    })
    .when('/complaint/:Id?', {
      controller: "complaintController",
      templateUrl: 'views/complaint/complaint.htm'
    })
    .when('/profile', {
      controller: "profileController",
      templateUrl: 'views/doctorProfile/profile.htm'
    })
    .when('/tab', {
      controller: "tabController",
      templateUrl: 'views/tab/tab.htm'
    })
    .when('/location', {
      controller: "locationController",
      templateUrl: 'views/settings/listLocation.htm'
    })
    .when('/addLocation', {
      controller: "locationController",
      templateUrl: 'views/settings/addLocation.htm'
    })
    .when('/advice', {
      controller: "adviceController",
      templateUrl: 'views/advice/listAdvice.htm'
    })
    .when('/addAdvice', {
      controller: "adviceController",
      templateUrl: 'views/advice/addAdvice.htm'
    })
    .when('/payment-master', {
      controller: "paymentController",
      templateUrl: 'views/payment/paymentMaster.htm'
    })
    .when('/chat', {
      controller: "chatController",
      templateUrl: 'views/chat/chat.htm'
    })
    .when('/chatSetting', {
      controller: "settingsController",
      templateUrl: 'views/settings/chatSetting.htm'
    })
    .when('/complaintSetting', {
      controller: "complaintMasterController",
      templateUrl: 'views/complaint/complaintMaster.htm'
    })
    .when('/vacEngageDashboard', {
      controller: "barController",
      templateUrl: 'views/vacEngageDashboard.htm'
    })
    .when('/dashboardRatings', {
      controller: "dashboardController",
      templateUrl: 'views/feedbackDashboard.htm'
    })
    .when('/hvReport1', {
      controller: "homevisitController",
      templateUrl: 'views/homevisit/hvReportHome.htm'
    })
    .when('/hvReport2', {
      controller: "homevisitController",
      templateUrl: 'views/homevisit/hvReportHome.htm'
    })
    .when('/hvReport3', {
      controller: "homevisitController",
      templateUrl: 'views/homevisit/hvReportHome.htm'
    })
    .when('/hvReport4', {
      controller: "homevisitController",
      templateUrl: 'views/homevisit/hvReportHome.htm'
    })
    .when('/hvReport4', {
      controller: "homevisitController",
      templateUrl: 'views/homevisit/hvReportHome.htm'
    })
    .when('/patientRegistration', {
      controller: "patientRegistrationController",
      templateUrl: "views/patientRegistrationReport.htm"
    })
    .when('/videocallReports', {
      controller: "videocallReportController",
      templateUrl: 'views/videocallReports.htm'
    })
    .when('/growthchartreports', {
      controller: "growthchartReportController",
      templateUrl: 'views/growthchartReports.htm'
    })
    .when('/subexpiryreports', {
      controller: "subexpiryReportController",
      templateUrl: 'views/subscriptionexpirytReports.htm'
    })
    .when('/walletTransact', {
      controller: "walletController",
      templateUrl: "views/walletTransact.htm"
    })
    .when('/videocall', {
      controller: "videocall_Controller",
      templateUrl: "views/video_call.htm"
    })
    .when('/videoCall', {
      controller: "videocallController",
      templateUrl: "views/videoCall.htm"
    })
    .when('/manage-doctor',{
      controller: "profileController",
			templateUrl: 'views/doctorProfile/profile.htm'
    })
    .when('/followupReport',{
      controller: "followupreportController",
			templateUrl: 'views/followupreport.htm'
    })
    .when('/payout',{
      controller: "payoutController",
			templateUrl: 'views/payout/payoutsettings.htm'
    })
    .when('/others',{
      controller: "othersettingController",
			templateUrl: 'views/othersetting.htm'
    })
    .when('/complaintchooser',{
      controller: "complaintchooserController",
			templateUrl: 'views/complaintchooser/complaintchooserSettings.htm'
    })
    .when('/commonsettings',{
      controller: "commonsettingsController",
			templateUrl: 'views/commonsettings.htm'
    })
    .when('/eshopsettings',{
      controller: "eshopsettingsController",
			templateUrl: 'views/eshopsettings.htm'
    })
    .when('/verification',{
      controller: "twostepverifyController",
			templateUrl: 'views/twostepverify.htm'
    })
    .when('/feedbacksettings',{
      controller: "feedbackController",
			templateUrl: 'views/feedbackform_settings.htm'
    })
    .when('/printoutsettings',{
      controller: "printoutController",
			templateUrl: 'views/printout-settings.htm'
    })
    .when('/agentsettings',{
      controller: "agentController",
			templateUrl: 'views/agents/agent_settings.htm'
    })
    .when('/agentform',{
      controller: "agentController2",
			templateUrl: 'views/agents/agent_form.htm'
    })
    .when('/incentivesettings',{
      controller: "incentiveController",
			templateUrl: 'views/incentive/incentive-settings.htm'
    })
    .when('/multicenterstudyreports',{
      controller: "multicenterstudyreportsController",
			templateUrl: 'views/multicenterstudy_reports.htm'
    })
    .when('/baby-registration',{
      controller: "babyregistrationController",
			templateUrl: 'views/multicenterstudy/baby_registration.htm'
    })
    .when('/babiesvs-communityvisit',{
      controller: "babiesvscommunityvisitController",
			templateUrl: 'views/multicenterstudy/babiesvs_communityvisit.htm'
    })
    .when('/deadvs-timeafterdelivery',{
      controller: "deadvstimeafterdeliveryController",
			templateUrl: 'views/multicenterstudy/deadvs_timeafterdelivery.htm'
    })
    .when('/babygrowth-everystagecommunity',{
      controller: "babygrowtheverystagecommunityController",
			templateUrl: 'views/multicenterstudy/babygrowth_everystagecommunity.htm'
    })
    .when('/babystatusicds',{
      controller: "babystatusicdsController",
			templateUrl: 'views/multicenterstudy/babystatusicds.htm'
    })
    .when('/babymalnutritionicds',{
      controller: "babymalnutritionicdsController",
			templateUrl: 'views/multicenterstudy/babymalnutritionicds.htm'
    })
    .when('/notinterestedbabyicds',{
      controller: "disinterestedBabyController",
			templateUrl: 'views/multicenterstudy/disinterested_baby.htm'
    })
    .when('/supervisorreport',{
      controller: "supervisorController",
			templateUrl: 'views/multicenterstudy/supervisor_report.htm'
    })
    .when('/careprovidermaster',{
      controller: "careproviderController",
			templateUrl: 'views/careprovider/careprovider_master.htm'
    })
    .when('/careprovider_form',{
      controller: "careproviderController2",
			templateUrl: 'views/careprovider/careprovider_form.htm'
    })
    .when('/xenopatient',{
      controller: "xenovexController",
      templateUrl: 'views/xenovex/xenov.htm'
    })
    .when('/health',{
      controller: "healthController",
      templateUrl: 'views/health.htm'
    })
    .when('/communityvisitreport',{
      controller: "communityvisitReportController",
      templateUrl: 'views/communityvisitreport.htm'
    })
    .when('/institutionalvisitreport',{
      controller: "institutionalvisitReportController",
      templateUrl: 'views/institutionalvisitreport.htm'
    })
    .when('/phcalltrackreport',{
      controller: "phcalltrackReportController",
      templateUrl: 'views/phcalltrackreport.htm'
    })
    .when('/patientOverall',{
      controller: "patientoverallcontroller",
      templateUrl: 'views/patientOverall.htm'
    })
    .when('/milestonereport',{
      controller: "milestonereportController",
			templateUrl: 'views/milestone/milestoneReport.htm'
    })
    .when('/redemSettings',{
      controller: "redemController1",
			templateUrl: 'views/redeem/redemmainSettings.htm'
    })
    .when('/redeemReports',{
      controller: "redemController",
      templateUrl: 'views/redeem/redemSettings.htm'
    })
    .when('/redeemConfig',{
      controller: "redemController2",
      templateUrl: 'views/redeem/redemConfig.htm'
    })
    .when('/redeemMaster',{
      controller: "redemController3",
      templateUrl: 'views/redeem/redemMaster.htm'
    })
    .when('/registrationReport',{
      controller: "registrationReportController",
			templateUrl: 'views/registrationReportController.htm'
    })
    .otherwise({
      redirectTo: '/login'
    });
	//add authInterceptor service to add Authentication headers to all http requests
		$httpProvider.interceptors.push('authInterceptorService');
	}]);

  angular.module('AngularApp').config(function(toastrConfig) {
    angular.extend(toastrConfig, {
      allowHtml: false,
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      extendedTimeOut: 1000,
      iconClasses: {
        error: 'toast-error',
        info: 'toast-info',
        success: 'toast-success',
        warning: 'toast-warning'
      },  
      messageClass: 'toast-message',
      onHidden: null,
      onShown: null,
      onTap: null,
      progressBar: true,
      preventOpenDuplicates: true,
      tapToDismiss: true,
      templates: {
        toast: 'directives/toast/toast.html',
        progressbar: 'directives/progressbar/progressbar.html'
      },
      timeOut: 1000,
      titleClass: 'toast-title',
      toastClass: 'toast'
    });
  });

  angular.module('AngularApp').directive('numberMask', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      $(element).numeric();
	    }
	  };
  });

  //directive for error source image set default image
  angular.module('AngularApp').directive('errSrc', function () {
    return {
      link: function (scope, element, attrs) {
        scope.$watch(function () {
          return attrs['ngSrc'];
        }, function (value) {
            if (!value) {
              element.attr('src', attrs.errSrc);
            }
        });

        element.bind('error', function () {
          element.attr('src', attrs.errSrc);
        });
      }
    };
  });

  angular.module('AngularApp').directive('datepickerTimezone', function () {
    return {
      restrict: 'A',
      priority: 1,
      require: 'ngModel',
      link: function (scope, element, attrs, ctrl) {
        ctrl.$formatters.push(function (value) {
            var date = new Date(Date.parse(value));
                date = new Date(date.getTime() + (60000 * date.getTimezoneOffset()));
          return date;
        });

        ctrl.$parsers.push(function (value) {
            var date = new Date(value.getTime() - (60000 * value.getTimezoneOffset()));
          return date;
        });
      }
    };
  });

  angular.module('AngularApp').directive('scrollBottom', function () {
    return {
      scope: {
        scrollBottom: "="
      },
      link: function (scope, element) {
        scope.$watchCollection('scrollBottom', function (newValue) {
          if (newValue) {
            $(element).scrollTop($(element)[0].scrollHeight);
          }
        });
      }
    }
  });

  angular.module('AngularApp').directive('showErrors', function($timeout) {
    return {
      restrict: 'A',
      require: '^form',
      link: function (scope, el, attrs, formCtrl) {
        // find the text box element, which has the 'name' attribute
        var inputEl   = el[0].querySelector("[name]");
        // convert the native text box element to an angular element
        var inputNgEl = angular.element(inputEl);
        // get the name on the text box
        var inputName = inputNgEl.attr('name');

        // only apply the has-error class after the user leaves the text box
        var blurred = false;
        inputNgEl.bind('blur', function() {
          blurred = true;
          el.toggleClass('has-error', formCtrl[inputName].$invalid);
        });

        scope.$watch(function() {
          return formCtrl[inputName].$invalid;
        }, function(invalid) {
          // we only want to toggle the has-error class after the blur
          // event or if the control becomes valid
          if (!blurred && invalid) {
						return;
					}
          el.toggleClass('has-error', invalid);
        });

        scope.$on('show-errors-check-validity', function() {
          el.toggleClass('has-error', formCtrl[inputName].$invalid);
        });

        scope.$on('show-errors-reset', function() {
          $timeout(function() {
            el.removeClass('has-error');
          }, 0, false);
        });
      }
    };
  });

  angular.module('AngularApp').directive("passwordVerify", function() {
    return {
      require: "ngModel",
      scope: {
        passwordVerify: '='
      },
      link: function(scope, element, attrs, ctrl) {
        scope.$watch(function() {
            var combined;

            if (scope.passwordVerify || ctrl.$viewValue) {
               combined = scope.passwordVerify + '_' + ctrl.$viewValue;
            }
            return combined;
        }, function(value) {
            if (value) {
                ctrl.$parsers.unshift(function(viewValue) {
                    var origin = scope.passwordVerify;
                    if (origin !== viewValue) {
                        ctrl.$setValidity("passwordVerify", false);
                        return undefined;
                    } else {
                        ctrl.$setValidity("passwordVerify", true);
                        return viewValue;
                    }
                });
            }
        });
      }
    };
  });

angular.module('AngularApp').directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9.]/g, '');

                    if(transformedInput.split('.').length>2){
                        var tempinput = transformedInput.split('.');
                        transformedInput = tempinput[0] + '.' + tempinput[1];
                    }
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

angular.module('AngularApp').filter('fractionSymbol', function () {
    return function (text) {
        if(text){
            var fullText = text;
            if ( fullText.split('/').length > 1 ){
                var fractionText = fullText.split('/');
                var checkBeforeChar = fractionText[0].split(' ');
                if ( checkBeforeChar.length > 1){
                    if ( checkBeforeChar.length > 2 ){
                        var beforeChar = '';
                        for ( i = 0; i < checkBeforeChar.length - 1; i++){
                            beforeChar = beforeChar + checkBeforeChar[i];
                        }
                        var transformedInput = beforeChar + ' <sup>' + checkBeforeChar[checkBeforeChar.length - 1] + '</sup>/<sub>' + fractionText[1] + '</sub>';
                        return transformedInput;
                    }
                    var transformedInput = checkBeforeChar[checkBeforeChar.length - 2] + ' <sup>' + checkBeforeChar[checkBeforeChar.length - 1] + '</sup>/<sub>' + fractionText[1] + '</sub>';
                    return transformedInput;
                }
                else{
                    var transformedInput = '<sup>' + fractionText[0] + '</sup>/<sub>' + fractionText[1] + '</sub>';
                    return transformedInput;
                }
            }
            return text;
        }
    };
  });
 
  angular.module('AngularApp').filter('parseUrl', function() {
    var urls = /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim

    return function(text) {        
        if(text.match(urls)) {
            text = text.replace(urls, "<a href=\"$1\" target=\"_blank\">$1</a>");
        }

        return text       
    }
  });

var blink = angular.module('AngularApp')
    .directive('blink', function($timeout) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {},
        controller: function($scope, $element) {
            function showElement() {
                $element.css("display", "inline");
                $timeout(hideElement, 3000);
            }

            function hideElement() {
                $element.css("display", "none");
                $timeout(showElement, 1000);
            }
            showElement();
        },
        template: '<span ng-transclude></span>',
        replace: true
    };
});

angular
  .module('AngularApp')
  .directive('alert', function($uibModal) {

    function show(action, event) {
      return $uibModal.open({
        templateUrl: 'views/modalContent.htm',
        controller: function() {
          var vm = this;
          vm.action = action;
          vm.event = event;
        },
        controllerAs: 'vm'
      });
    }

    return {
      show: show
    };

});

angular.module('AngularApp').filter('mmss', function () {
	return function (time) {
	    var sec_num = parseInt(time, 10); // don't forget the second param
	   // var hours   = Math.floor(sec_num / 3600);
	    var minutes = Math.floor((sec_num) / 60);
	    var seconds = sec_num - (minutes * 60);

	  //  if (hours   < 10) {hours   = "0"+hours;}
	    if (minutes < 10) {minutes = "0"+minutes;}
	    if (seconds < 10) {seconds = "0"+seconds;}
	    var time    = minutes+':'+seconds;
	    return time;
	  }
});

angular.module('AngularApp').directive("preventTypingGreater", function() {
    return {
            link: function(scope, element, attributes) {
            var oldVal = null;
            element.on("keydown keyup", function(e) {
            if (Number(element.val()) > Number(attributes.max) &&
                e.keyCode != 46 // delete
                &&
                e.keyCode != 8 // backspace
                ) {
                e.preventDefault();
                element.val(oldVal);
                } else {
                oldVal = Number(element.val());
                }
            });
            }
    };
});

angular.module("AngularApp").directive('confirmOnExit', function() {
    return {
        link: function($scope, elem, attrs) {
                window.onbeforeunload = function(){
                    if ($scope[attrs["name"]].$dirty&&!$scope[attrs["name"]].$submitted) {
                        return "You have not saved the form, Do you wish to leave this page?";
                    }
                }
                $scope.$on('$locationChangeStart', function(event, next, current) {
                    if ($scope[attrs["name"]].$dirty&&!$scope[attrs["name"]].$submitted) {
                        if(!confirm("You have not saved the form")) {
                            event.preventDefault();
                        }
                    }
                });
        }
    };
});

angular.module('AngularApp').filter('capitalize', function() {
    return function(input) {
      return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    };
});

angular.module('AngularApp').filter('sumByColumn', function () {
    return function (collection, column) {
        var total = 0;

        if(collection != undefined){
            collection.forEach(function (item) {
                total += parseInt(item[column]);
            });
        }

      return total;
    };
});
//show panels  in examination findings
/*angular.module('ui.bootstrap').directive('showHide', function() {
    return {
      restrict: 'E',
      rootScope: {
        items : '=',
        index: '='
      },
      template: '<div class="panel panel-default ">\
           <!-- Default panel contents -->\
           <div class="panel-heading" ng-click= "hidevar=false">Problems</div>\
           <!-- List group -->\
           <ul class="list-group" ng-hide="hidevar" >\
             <li class="list-group-item" data-toggle="collapse" data-target="#demo" ng-repeat="issue in opReview.complaint.issues" ng-click="hidevar=true;showdes(item)"><a>{{issue.complaint_category | capitalize}}</a> </li>\
           </ul>\
           <div class="panel-body" ng-show="hidevar"  id="demo">\
             {{opReview.complaint.other_information}}\
           </div>\
         </div>',
      link: function(rootScope, elm, attr) {
        rootScope.showdes = function(item){     
            rootScope.itemdesc=item;
            rootScope.hidevar=true;
        }
      }
    };
  }); */

angular.module('AngularApp').directive('input', [function() {
    return {
        restrict: 'E',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
            if (
                   'undefined' !== typeof attrs.type
                && 'number' === attrs.type
                && ngModel
            ) {
                ngModel.$formatters.push(function(modelValue) {
                    return Number(modelValue);
                });

                ngModel.$parsers.push(function(viewValue) {
                    return Number(viewValue);
                });
            }
        }
    }
}]);

angular.module('AngularApp').directive('uppercaseOnly', [
  function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ctrl) {
        element.on('keypress', function(e) {
          var char = e.char || String.fromCharCode(e.charCode);
          if (!/^[A-Z0-9]$/i.test(char)) {
            e.preventDefault();
            return false;
          }
        });

        function parser(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }
          var formatedValue = value.toUpperCase();
          if (ctrl.$viewValue !== formatedValue) {
            ctrl.$setViewValue(formatedValue);
            ctrl.$render();
          }
          return formatedValue;
        }

        function formatter(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }
          return value.toUpperCase();
        }

        ctrl.$formatters.push(formatter);
        ctrl.$parsers.push(parser);
      }
    };
  }
]);

angular.module('AngularApp').run(['$rootScope', 'authService', '$templateCache','$sessionStorage', function ($rootScope, authService, $templateCache, $sessionStorage) {
		//To load Authorization data from localstorage
        authService.loadAuthData();
        if(JSON.parse($sessionStorage.get('preference'))){
          $rootScope.isChatEnabled = JSON.parse($sessionStorage.get('preference')).chat;
        }
        $("#loading").hide()
        $("#headerContainer").show();
        $("#footerContainer").show();
        $("#internetContainer").show();

       
}]);

angular.module('AngularApp').run(function($window, $rootScope, $route) {
    $rootScope.InternetStatus = navigator.onLine;
    // angular.element($window).on('orientationchange', function() {
    //   console.log(screen.orientation.type);
    // });
    $window.addEventListener("orientationchange", function() {                   
      if (window.matchMedia("(orientation: portrait)").matches) {
         //alert("PORTRAIT")
         $("#landscapemodemsg").hide();
       }
      if (window.matchMedia("(orientation: landscape)").matches) {
        //alert("LANSCAPE")
        $("#landscapemodemsg").show();
       }
  }, false);
    $window.addEventListener("offline", function () {
      $rootScope.$apply(function() {
        $rootScope.InternetStatus = false;
      });
    }, false);
    $window.addEventListener("online", function () {
      $rootScope.$apply(function() {
        $rootScope.InternetStatus = true;
        $route.reload();
      });
    }, false);
});

/**
 * @author Helyxon
 * created on Dec 2016
 */
(function () {
  "use strict";

  /** @ngInject */
  function BudsStore(){
    var self = {};
    self.reset = function () {
      self.store = {};

      /*Make hrs array for dropdowns*/
      var hrs = [], i, j;
      for(i=0; i<12; i++) {
          for(j=0; j<2; j++) {
         //hrs.push((i<10? "0"+i : i)+(i===0? 12:"")+ ":" + (j===0 ? "00" : 30*j)+(i>=12? "PM":"AM"));
          hrs.push((i<10? i : i)+(i===0? 12:"") + ":" + (j===0 ? "00" : 30*j)+" am");
        }}
          
      for(i=0; i<12; i++) {
          for(j=0; j<2; j++) {
          hrs.push((i<10? i : i)+(i===0? 12:"")+ ":" + (j===0 ? "00" : 30*j)+" pm");
        }}
        for(j=0;j<1;j++){
          hrs.push("11:59" +" pm");
        }

    self.store.hrs = hrs;
    };
 
    self.bloodGroups = ["A+","A-","B+","B-","O+","O-","AB+","AB-"];
    
    return self;
  }

  angular.module("buds.store", [])
  .service("BudsStore", BudsStore);

})();

/**
 * @author Helyxon
 * created on Dec 2016
 */
(function () {
  "use strict";

  angular.module("RxC.pages",
  ["RxC.pages.Settings","RxC.pages.Schedule","RxC.pages.AptConfig","RxC.pages.Patient","RxC.pages.Appointment","RxC.pages.Vac","RxC.pages.BabyProfile", "RxC.pages.Drug"]);

})();

/**
 * @author Helyxon
 * created on Dec 2016
 */

(function () {
  "use strict";

  /** @ngInject */
  function routeConfig($routeProvider){
    $routeProvider
   .when("/apt-book", {
     templateUrl: 'app/apt-book/view.tpl.html',
     controllerAs:"apt",
     controller:"AppointmentCtrl"
   })
   .when("/apt-cancel", {
     templateUrl: 'app/apt-book/apt-cancel.tpl.html',
     controllerAs:"apt",
     controller:"AppointmentCancelCtrl"
   });
  }


/** @ngInject */
function AppointmentService($http, $q, serviceBaseUrl, authService, BudsStore){
  var self = {};

  self.getAvailability = function(dt,type,searchBy,mr_number){
		var deferred = $q.defer();
    var url = "";
    if (searchBy && searchBy==="mr"){
      url = serviceBaseUrl+"appointmentlistmrnumber?" + authService.authentication.account_id + "/" + mr_number;
    }else if (searchBy && searchBy ==="dt"){
      url = serviceBaseUrl+"appointmentdate?" + authService.authentication.account_id + "&" + dt;
    } else {
      url = serviceBaseUrl+"getschedulecalendaravailability?account_email=" + authService.authentication.account_id+"&appt_date="+dt+"&doctor_id="+authService.authentication.doctor_id;
    }
		$http.get(url)
    .success(function (response) {
      console.log('response at appointmentdate', response);
			deferred.resolve(response);
		})
    .error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

  self.getAvailabilitybycategory = function (dt, type, searchBy, mr_number) {
    var deferred = $q.defer();
    $http.get(serviceBaseUrl + "checktokenavailability?account_email=" + authService.authentication.account_id + "&appt_date=" + dt + "&doctor_id=" + authService.authentication.doctor_id + '&appt_type=' + type)
      .success(function (response) {
        deferred.resolve(response);
      })
      .error(function (error, status) {
        deferred.reject(error);
      });
    return deferred.promise;
  };
/*
  self.getVaccinationList = function(child_account){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+"listcalendar",{"child_account":child_account,account_email: authService.authentication.account_id} )
    .success(function (response) {
			deferred.resolve(response);
		})
    .error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
  };
*/  
  self.getLocation = function() {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getlocation?account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

  self.getSettings = function() {
    var deferred = $q.defer();
    $http.get(serviceBaseUrl+'getsettings?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
      deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
  };

  self.getPaymentSetting = function() {
      var deferred = $q.defer();
      $http.get(serviceBaseUrl+'getpaymentsetting?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
          deferred.resolve(response);
      }).error(function (error, status) {
          deferred.reject(error);
      });

      return deferred.promise;
  };

  self.raiseInvoice = function(data) {
    var deferred = $q.defer();
    $http.post(serviceBaseUrl+'raiseinvoice',data).success(function (response) {
        deferred.resolve(response);
    }).error(function (error, status) {
        deferred.reject(error);
    });
    return deferred.promise;
};

self.getWalletBalance = function(data) {
  var deferred = $q.defer();
  $http.post(serviceBaseUrl+'walletbalance',data).success(function (response) {
      deferred.resolve(response);
  }).error(function (error, status) {
      deferred.reject(error);
  });
  return deferred.promise;
};


self.getCalenderSlots = function(dt){
  var deferred = $q.defer();
  $http.get(serviceBaseUrl+'getschedulecalendar?account_email='+authService.authentication.account_id+'&appt_date='+dt+'&doctor_id='+authService.authentication.doctor_id)
  .success(function (response) {
    deferred.resolve(response);
  })
  .error(function (error, status) {
    deferred.reject(error);
  });
  return deferred.promise;
};

  self.getCalenderSlotsbycategory = function (dt, type) {
    var deferred = $q.defer();
    $http.get(serviceBaseUrl + 'checkappointmenttoken?account_email=' + authService.authentication.account_id + '&appt_date=' + dt + '&doctor_id=' + authService.authentication.doctor_id + '&appt_type=' + type)
      .success(function (response) {
        deferred.resolve(response);
      })
      .error(function (error, status) {
        deferred.reject(error);
      });
    return deferred.promise;
  };

  self.bookAppointment = function(data){
		var deferred = $q.defer();
    data.account_email=authService.authentication.account_id;
    data.doctor_id=authService.authentication.doctor_id;
  
		$http.post(serviceBaseUrl+'doctorbooktokenappointment',data)
    .success(function (response) {
			deferred.resolve(response);
		})
    .error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

  self.sendbookingsms = function(data) {
    var deferred = $q.defer();
    $http.post(serviceBaseUrl+'updatewebtoken',data).success(function (response) {
        deferred.resolve(response);
    }).error(function (error, status) {
        deferred.reject(error);
    });
    return deferred.promise;
  };

  /*Helyxon */
  // self.linkVaccineCalendar = function(linkPayload){
  //   var deferred = $q.defer();
  //   linkPayload.account_email=authService.authentication.account_id;
  //   $http.post(serviceBaseUrl+'linkappointment',linkPayload)
  //   .success(function (response) {
		// 	deferred.resolve(response);
		// })
  //   .error(function (error, status) {
		// 	deferred.reject(error);
		// });
		// return deferred.promise;
  // };
  /** */

  self.cancelAppointment = function(payload){
		var deferred = $q.defer();
    payload.account_email=authService.authentication.account_id;
    payload.doctor_id=authService.authentication.doctor_id;
		$http.post(serviceBaseUrl+'canceltokenappointmentbydoctor', payload)
    .success(function (response) {
			deferred.resolve(response);
		})
    .error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

  return self;
}

/** @ngInject */
function AppointmentCancelCtrl(RxCUtils,AppointmentService,toastr,authService,$ngBootbox,$filter){
  var vm = this;
  vm.fresh = true;
  vm.searchBy="dt";
  vm.dateOptions = {
    maxDate: new Date(2020, 5, 22),
    minDate: new Date(),
    startingDay: 1
  };

  vm.date = new Date();
  vm.getBookings = function (){
    vm.calender = [];
    if (vm.searchBy==="mr"){
      AppointmentService.getAvailability("", "", vm.searchBy, vm.mr_number.toUpperCase())
       .then(
         function(response){
           vm.calender = response.appointments;
           angular.forEach(vm.calender,function(slot){
             
            //  var today = new Date(new Date().toISOString());
            var today = new Date();
             //  slot.localSlot = RxCUtils.toLocalDate(slot.slot);
             var date = new Date(slot.slot);;
             var newDate = new Date(date);
             
             var offset = date.getTimezoneOffset();
             var minutes = date.getMinutes();
             
             newDate.setMinutes(minutes - offset);
             
             slot.localSlot = newDate;
             
             if(today > slot.localSlot){
               slot.button = false;
             }
             else{
               slot.button = true;
             }
            
           });
           vm.fresh = false;
         },
         function(err, response){
           vm.fresh = false;
            toastr.error((err && err.error? err.error :"Unknown error in fetching the bookings."));
         }
       );
    }else{
      AppointmentService.getCalenderSlots(vm.date.toJSON().slice(0,10))
      .then(function(response){
        AppointmentService.getAvailability(vm.date.toJSON().slice(0,10), "", vm.searchBy)
        .then(
          function(data){
            if( data ) {
              if( authService.authentication.doctor_id ) {
               vm.respAvl = ($filter('filter')(data, {'with_doctor_id':authService.authentication.doctor_id}));
              }
              //$scope.AppList = response;
          }
            //vm.calender = response.appointments;
            vm.fresh = false;
            /*Set available flag*/
            var j=0,i=0;
            //var avl = respAvl;/*commented by Manisha*/
            var avl = [];
            angular.forEach(vm.respAvl,function(item){
              if (item.status==="confirmed"){
                avl.push(item);
              }
            });
            var slots = response.schedule;
          //var v_slots = response.schedule;

          for(i=0;i<avl.length;i++){

              if (avl[i].type==="consultation"){
                for(j=0;j<slots.length;j++){
                  if (slots[j].token===avl[i].token){
                    slots[j].available=true;
                    slots[j].type="consultation";
                    break;
                  }
                }
              }
              else if (avl[i].type==="voice_call"){
                for(j=0;j<slots.length;j++){
                  if (slots[j].token===avl[i].token){
                    slots[j].available=true;
                    slots[j].type="voice_call";
                    break;
                  }
                }
              }
              else if (avl[i].type==="vaccination"){
                for(j=0;j<slots.length;j++){
                  if (slots[j].token===avl[i].token){
                    slots[j].available=true;
                    slots[j].type="vaccination";
                    break;
                  }
                }
              }
              else if (avl[i].type==="video_call"){
                for(j=0;j<slots.length;j++){
                  if (slots[j].token===avl[i].token){
                    slots[j].available=true;
                    slots[j].type="video_call";
                    break;
                  }
                }
              }
              else if (avl[i].type==="appointment"){
                for(j=0;j<slots.length;j++){
                  if (slots[j].token===avl[i].token){
                    slots[j].available=true;
                    slots[j].type="appointment";
                    break;
                  }
                }
              }
              // else{
              //   for(j=0;j<v_slots.length;j++){
              //     if (v_slots[j].token===avl[i].token){
              //       v_slots[j].available=true;
              //       v_slots[j].type="vaccination";
              //       break;
              //     }
              //   }
              // }
            }

            /*Merge both slots*/
            // for (i=0; i<v_slots.length; i++){
            //   slots.push(v_slots[i]);
            // }
            vm.slots = slots;

            for(i=0;i< vm.slots.length;i++){
              /*convert start date to local*/
              vm.slots[i].start_local = RxCUtils.toLocalTime(vm.slots[i].start.substr(11,5));
              // vm.slots[i].start_local = new Date(vm.slots[i].start).toLocaleTimeString('en-IN', { hour: 'numeric', minute: 'numeric',hour12: false });
            }


            /*Chunk to display format*/
            response._chunked = RxCUtils.chunks(slots, 10, true);
            /*The slots are not correct from API, so this is a temp fix*/
            for(i=1;i<20;i++){
              response.slots.push("+" + i);
            }
            response.slots = response.slots.splice(0,10);
            /*temp fix end*/

            vm.calender = response;
            vm.fresh = false;

          },
          function(){
             vm.fresh = false;
             toastr.error("No bookings available to cancel.");
          }
        );
      });


    }
  };

  vm.toggleChunk = function(chunk) {
    angular.forEach(chunk,function(item){
      if (item.available===true && !item.dummy)
        item.cancel = chunk.cancel;
    });
  };

  vm.cancelBookings = function(token){
    var options = {
          message: 'Are you sure to cancel the selected tokens?',
          title: 'Cancel Appointments?',
          buttons: {
               warning: {
                   label: "Cancel",
                   className: "btn-warning"
               },
               success: {
                   label: "Ok",
                   className: "btn-success",
                   callback: function() {
                       if (token && token.token){
                         _cancelBooking([token]);
                       } else {
                         _cancelBookings();
                       }
                   }
               }
          }
      };

      if (token && token.token)
        options.message = 'Are you sure to cancel the ' + token.type + ' appointment on '+ token.slot + ' for the token number ' + token.token + ' ?';

      $ngBootbox.customDialog(options);
  };

  function _cancelBookings(){
    var v_tokens = [];
    var c_tokens = [];

    /*Separate tokens by types*/
    for(var i=0;i<vm.calender._chunked.length;i++){
      var chunk = vm.calender._chunked[i];
      var tmp =[];
      for(var j=0;j<chunk.length;j++){
        if ( chunk[j] && chunk[j].cancel===true){
          if (chunk[j].type==="vaccination"){
            v_tokens.push(chunk[j]);
          } else{
            c_tokens.push(chunk[j]);
          }
        }
      }
    }

    if (v_tokens.length >0)
      _cancelBooking(v_tokens);

    if (c_tokens.length >0)
      _cancelBooking(c_tokens);
  }

  function _cancelBooking(tokens){
    var temp = [];
    for(var i=0;i<tokens.length;i++){
      temp.push(tokens[i].token);
    }
    var t= tokens[0];
    var dt = t.slot||t.start;
    var payload = {
        /*token: temp,
        appt_datetime: dt.substr(0,10) + "T00:00:00Z",
        appt_type: t.type*//*commented by Manisha*/
        token: temp,
        appt_datetime: dt.substr(0,10) + dt.substr(10,19)+"Z",
        appt_type: t.type

    };

    AppointmentService.cancelAppointment(payload)
    .then(
      function(response){
        if(payload.appt_type==='vaccination'){
          
        }
        //calls++;
        //if (tokens.length===calls){
          toastr.success("Appointments cancelled");
          vm.getBookings();
        //}
      },
      function (err, response) {
         //calls++;
         //if (tokens.length===calls){
            toastr.error(err.error);
          //  vm.getBookings();
         //}
      });
  }

}

/** @ngInject */
    function AppointmentCtrl(RxCUtils, AppointmentService, subscribeService, toastr, authService, WizardHandler, $ngBootbox, paymentService){
var vm = this;
angular.element('#txtPatientSearch').focus()
vm.PatientList={loaded:true};
vm.type="consultation";
vm.dateOptions = {
  maxDate: new Date(2020, 5, 22),
  minDate: new Date()
};

vm.date = new Date();

vm.displaycategory = function(){
  paymentService.getPaymentSetting().then(function(response) {
    vm.displayvideocall = function(myres, attr, value) {
        for(var i = 0; i < myres.length; i++) {
            if(myres[i][attr] === value) {
                if(myres[i].status === 1){
                    vm.showvideocall = true
                } else {
                  vm.showvideocall = false
                }
            }
        }
        return -1;
    }
    vm.displayvoicecall = function(myres, attr, value) {
      for(var i = 0; i < myres.length; i++) {
          if(myres[i][attr] === value) {
              if(myres[i].status === 1){
                  vm.showvoicecall = true
              } else {
                vm.showvoicecall = false
              }
          }
      }
      return -1;
  }
    vm.displayvideocall(response,'module','video_call_appointment_fee')
    vm.displayvoicecall(response,'module','voice_call_appointment_fee')
}, function(error){
    toastr.error(error);
    analytics('getPaymentConfiguration',error);
})
}
vm.displaycategory();

vm.subscribeValidity = function(email){
    subscribeService.getSubscribeValidity(email).then(function(response) {
       vm.isPatientSubscribed = response.is_subscribed;
     //toastr.success("Subscribe validation.");    
    }, function(error) {
      //toastr.error(error);
    });
};

vm.setSelectedRecord = function(record){
  vm.selectedRecord = record;
//vm.getVaccinationList(record.email);
  vm.subscribeValidity(record.email);
};

vm.tokenArr = [];
vm.tempArr = [];
vm.booktoken = [];
vm.selectToken = function(token){
  if (token.available&&token.allow_click){
    if(vm.tokenArr.length<2){
      if(token.isSelected){
        token.isSelected = false;
        var index = vm.tokenArr.indexOf(token.token)
        vm.tokenArr.splice(index,1);
        vm.tempArr.splice(index,1);
        vm.booktoken.splice(index,1);
        vm.selectedToken = vm.tempArr[0];
      } else {
        if(vm.tokenArr.length==1){
          var start = token.start < vm.selectedToken.start ? vm.selectedToken.start : token.start;
          var end = token.start < vm.selectedToken.start ? token.start : vm.selectedToken.start;
          var dif = moment.utc(moment(start).diff(moment(end))).format("hh:mm");
          if(dif=='12:'+vm.slotTime){
            token.isSelected = true;
            vm.tokenArr.push(token.token);
            vm.tempArr.push(token);
            vm.booktoken.push({slot_id: token.id,appt_type:'consultation'});
            vm.selectedToken = token;
          }else {
            toastr.error("Please choose consecutive tokens.")
          }
        } else if(vm.tokenArr.length<1){
            token.isSelected = true;
            vm.tokenArr.push(token.token);
            vm.tempArr.push(token);
            vm.booktoken.push({slot_id: token.id,appt_type:'consultation'});
            vm.selectedToken = token;
        }
      }
    }else{
      if(vm.tokenArr.length==2&&token.isSelected){
        token.isSelected = false;
        var index = vm.tokenArr.indexOf(token.token)
        vm.tokenArr.splice(index,1);
        vm.tempArr.splice(index,1);
        vm.booktoken.splice(index,1);
        vm.selectedToken = vm.tempArr[0];
      } else {
        toastr.error("You can selected a maximum of 2 slots.");
      }
    }
  }else{
    vm.selectedToken = undefined;
    toastr.error("Selected token is not available.");
  }
};
/*
vm.getVaccinationList = function (record_id){
  AppointmentService.getVaccinationList(record_id)
  .then(function(response){
    vm.vaccinationList = response.entries;
  },function (err, response) {
     toastr.error(err.error);
  });
};
*/
vm.loadLocationList = function (){
  AppointmentService.getLocation().then(function(response){
    vm.locationList = response;
  },function (err, response) {
     toastr.error(err.error);
  });
};

vm.getLocationStatus = function() {
  AppointmentService.getSettings().then(function(response) {
    if(response.multilocation){
      vm.locationStatus = response.multilocation;
      if(vm.locationStatus == 1){
        vm.loadLocationList();
      }
      else{

      }
    }
    else{
      vm.locationStatus = 0;      
    }
  },function(error) {
      toastr.error(error);
  })
};

vm.clearSelected = function() {
  vm.tokenArr = [];
}
vm.getPaymentConfiguration = function() {
  AppointmentService.getPaymentSetting().then(function(response) {
    vm.paymentMaster = {
      consultation:''
    };
    vm.raisepaymentall = function(myres) {
      for(var i = 0; i < myres.length; i++) {
              if(myres[i].module === "appointment"){
                vm.paymentMaster.consultation = myres[i].doctor_charge;
              }
      }
      return -1;
  }
  vm.raisepaymentall(response)
    // angular.forEach(response,function(item){
    //   if (item.module==="appointment"){
    //     vm.paymentMaster.consultation = item.doctor_charge;
    //   }
    // });
  }, function(error){
      toastr.error(error);
  })
};

vm.getLocationStatus();
vm.getPaymentConfiguration();

vm.canEnterToSelectSlots = function (){
  if (vm.selectedRecord){
    return true;
  }
  toastr.error("Please select a patient and then try again.");
  return false;
};

vm.canEnterToConfirm = function (){
  if (vm.selectedRecord && vm.selectedToken){
    return true;
  }
  toastr.error("Please select a patient and token to proceed.");
  return false;
};

vm.slotTime = undefined;
vm.getAvailability = function(){
  vm.spinner = true;
  vm.calenderData = false;
  vm.calender = [];
  vm.selectedToken = undefined;
  var gmtDate = RxCUtils.toGMTDate(vm.date.toJSON().slice(0,10),true);
  AppointmentService.getCalenderSlotsbycategory(gmtDate,vm.type) //vm.date.toJSON().slice(0,10)
    .then(function (response) {
      /*Fetch Availability*/
      AppointmentService.getAvailabilitybycategory(gmtDate, vm.type)
        .then(function (respAvl) {
          if (vm.type == 'consultation') {
            vm.showtype = 'consultation'
          }
          if (vm.type == 'vaccination') {
            vm.showtype = 'vaccination'
          }
          if (vm.type == 'voice_call') {
            vm.showtype = 'voice call'
          }
          if (vm.type == 'video_call') {
            vm.showtype = 'video call'
          }
          /*Set available flag*/
          var j=0,i=0;
          var avl =respAvl.schedule_availability;
          if (avl.length > 0) {
            var slots = [];

            slots = response.schedule;

            if (slots[0].start!=undefined) {

              vm.slotTime = moment.utc(moment(slots[1].start).diff(moment(slots[0].start))).format("mm");
              for (i = 0; i < slots.length; i++) {
                  /*convert start date to local*/
                  slots[i].start_local = RxCUtils.toLocalTime(slots[i].start.substr(11, 5));
                  // slots[i].start_local = new Date(slots[i].start).toLocaleTimeString('en-IN', { hour: 'numeric', minute: 'numeric',hour12: true });
                  var dateIST = new Date(slots[i].start);
                  dateIST.setHours(dateIST.getHours() + 5);
                  dateIST.setMinutes(dateIST.getMinutes() + 30);
                  if (slots[i].location != null) {
                      //  if location service ON then Show the slots 
                      slots[i].location_match = slots[i].location == vm.location ? true : false;

                      if (slots[i].location_match) {
                          slots[i].allow_click = new Date(dateIST) > new Date() ? true : false;
                      }
                      else {
                          slots[i].allow_click = false;
                      }
                  } else if (slots[i].location == null && vm.locationStatus == 0) {
                      //  if location service OFF then Show the slots 
                      slots[i].location_match = true;
                      slots[i].allow_click = new Date(dateIST) > new Date() ? true : false;
                  }  else {
                      //  if location service is changed but appointment config not happened
                      toastr.error("Please reconfigure your appointments");
                      break;
                  }
              }

              for (i = 0; i < avl.length; i++) {
                  for (j = 0; j < slots.length; j++) {
                      if (slots[j].token === avl[i].token) {
                          slots[j].available = true;
                          slots[j].isSelected = false;
                          break;
                      }
                  }
              }

              /*Chunk to display format*/
              response._chunked = RxCUtils.chunks(slots, response.slots.length < 10 ? response.slots.length : 10, true);
              /*The slots are not correct from API, so this is a temp fix*/
              //for(i=1;i<20;i++){
              //response.slots.push("++" + i);
              //}

              response.slots = response.slots.splice(0, 10);
              vm.calenderData = true;
              vm.calender = response;

          } else {

                var options = {
                    message: response.schedule[0],
                    //title: 'Alert',
                    closeButton: false,
                    buttons: {
                      warning: {
                          label: "Cancel",
                          className: "btn-warning"
                      },
                    }
                };

                $ngBootbox.customDialog(options);
          }

      } else {

          toastr.error('There is no availability on the selected date');
      }
          /*temp fix end*/
          vm.spinner = false;
      },function (err, respAvl) {
         vm.spinner = false;
         vm.calenderData = true;
         toastr.error(err.error);
       });
  },function (err, response) {
     vm.spinner = false;
     vm.calenderData = true;
     toastr.error(err.error);
  });
};
/*
vm.setVaccine = function () {
  vm.vaccine="";
  if (vm.type==="vaccination"){
    for(var i=0;i<vm.vaccinationList.length;i++){
      if (vm.vaccinationList[i].selected===true){
        if (vm.vaccine!==""){
          vm.vaccine += " & ";
          vm.vaccine_id += " & ";
        }
        vm.vaccine += vm.vaccinationList[i].vaccination_name;
        vm.vaccine_id = vm.vaccinationList[i].id;
      }
    }
  }
};
*/
vm.appointmentService  = function (data) {

AppointmentService.bookAppointment(data)
.then(
  function(response) {
    /**Helyxon*/

    vm.sendsmsforapt = function(){
      var data = {
        "account_email": authService.authentication.account_id,
        "patient_email": vm.selectedRecord.email,
        "doctor_id": authService.authentication.doctor_id,
        "a_id": vm.appointment_id,
        "slot": vm.selectedToken.start + "Z",
        "token": vm.tokenArr,
        "mode": "EPICARE"
      }
      AppointmentService.sendbookingsms(data).then(function(response) {
        console.log(response,"ehbjhwvjbfwhbfib")
      })
    }

    var linkPayload = {};
      linkPayload.calendar_id = data.vaccine_id;
      linkPayload.appointment_id = response.id;
    vm.appointment_id = response[0].id;
    if(data.appt_type=="vaccination") {
      if(vm.date.toJSON().slice(0,10) != new Date().toJSON().slice(0,10)) {
        if(vm.paymentMaster.consultation != null || vm.paymentMaster.consultation != "0.00"){
          if(vm.isPatientSubscribed==false){
            vm.raiseInvoice();
          }  
        }
      }

      
      toastr.success("Vaccination booked.");
      vm.tokenArr = [];
      vm.tempArr = [];
      vm.booktoken = [];
      WizardHandler.wizard().cancel();       

      
      // AppointmentService.linkVaccineCalendar(linkPayload)
      // .then(
      //   function(response) {
      //     toastr.success("Appointment booked.");
      //     vm.tokenArr = [];
      //     vm.tempArr = [];
      //     vm.booktoken = [];
      //     vm.appointment_id = response[0].id;
      //     WizardHandler.wizard().cancel();       

      //     if(vm.date.toJSON().slice(0,10) != new Date().toJSON().slice(0,10)) { 
      //       if(vm.paymentMaster.consultation != null || vm.paymentMaster.consultation != "0.00"){
      //         if(vm.isPatientSubscribed==false){
      //           vm.raiseInvoice();
      //         }  
      //       }
      //     }
      
      //   },
      //   function (err, response) {
      //     toastr.error(err.error);
      //   });
    }
    
    if(data.appt_type!="vaccination") {
      vm.appointment_id = response[0].id;
      if(vm.date.toJSON().slice(0,10) != new Date().toJSON().slice(0,10)) { 
        if( vm.paymentMaster.consultation != null || vm.paymentMaster.consultation != "0.00"){
          if(data.appt_type=="consultation"){
            if(vm.isPatientSubscribed==false){
              vm.raiseInvoice();
          }
          }  else {
            vm.raiseInvoice();
          }
        }
      }
      if(data.appt_type == "video_call"){
        vm.sendsmsforapt()
      }
      //$rootScope.loadBanner();
        toastr.success("Appointment booked.");
        vm.tokenArr = [];
        vm.tempArr = [];
        WizardHandler.wizard().cancel();

    }
  },
  function (err, response) {
     toastr.error(err.error);
  });

}

vm.raiseInvoice = function () {
   
  if(vm.booktoken.length == 2) {
    vm.paymentConsultation = vm.paymentMaster.consultation * 2;
  } else if(vm.booktoken.length == 1) {
    vm.paymentConsultation = vm.paymentMaster.consultation;
  }

  var data = {
    account_email: authService.authentication.account_id,
    patient_email: vm.selectedRecord.email,
    doctor_id : authService.authentication.doctor_id,
    category: "appointment",
    description: "",
    doctor_charges: vm.paymentConsultation,
    user_type:"doctor",
    slots:vm.booktoken,
    type: 3,
    appointment_id: vm.appointment_id,
  }

  AppointmentService.raiseInvoice(data).then(function(response) {
    var msg = "Patient has to pay "+response.amount+" for appointment booking. Payment information was sent to patient mobile app.";
    vm.tokenArr = [];
    vm.tempArr = [];
    vm.booktoken = [];
    toastr.success(msg);
    // toastr.error(error);
    //WizardHandler.wizard().cancel();
  }, function(error) {
    toastr.success("Appointment booked.");
  });

}

vm.bookAppointment  = function() {
    var payload = {
      token: vm.tokenArr,
      appt_datetime: vm.selectedToken.start + "Z",
      patient_account: vm.selectedRecord.email,
      appt_type: vm.type,
      location : vm.location ? vm.location : null
    };

    if (vm.type==="vaccination" && vm.vaccine==="") {
      toastr.error("Please select a vaccine and try again");
      return;
    } else if (vm.type==="vaccination"){
      payload.vaccine = vm.vaccine;
      payload.vaccine_id = vm.vaccine_id;
    }
    vm.appointmentService(payload);
};

vm.getVaccinationStatus = function(vaccine) {
	 	if(vaccine.administration_status=='complete')
	 		return 1;
		// if(vaccine.administration_status=='deferred')
	 	// 	return 4;
	 	if(vaccine.administration_status=='due') {
	 		if(new Date(vaccine.due_date)<new Date()) {
	 			return 3; //overdue
	 		}

	 		return 2; // upcoming
	 	}
	return 1; //done
};

vm.getPatientSearchApt = function(val) {
    if(val.length>=3){
    vm.PatientList.loaded = false;
    vm.selectedRecord = undefined;
      //if(!val){$scope.getPatientLatest();}
      authService.getPatientSearch(val)
      .then(function(response){
         var dobMoment = moment();
                var patientlistData = response.map(function(item){
                    return {
                       age:{
                            years:parseInt(moment(item.bday).diff(dobMoment,'year',true)),
                            months:parseInt(moment(item.bday).diff(dobMoment,'month',true)%12),
                            days:parseInt(moment(item.bday).diff(dobMoment,'day',true)%365)
                       },
                      date: new Date(item.bday),
                      bday:new Date(item.bday),
                      mr_number:item.mr_number,
                      name_given:item.name_given,
                      father_name_given:item.father_name_given,
                      mother_name_given:item.mother_name_given,
                      father_tel_number:item.father_tel_number,
                      email:item.email,
                      father_email: item.father_email,
                      gender:item.gender,
                      record_id:item.record_id,
                      uhid:item.uhid

                  };
               });

              vm.PatientList2 = patientlistData;
              vm.PatientList.loaded = true;

       },function (err, response) {
          toastr.error(err.Message);
        });
      } else {
          toastr.error("Please enter 3 or more chars");
      }
  };

}



/*Setup the Module*/
angular.module("RxC.pages.Appointment", ["buds.store"])
.config(routeConfig)
.service("AppointmentService", AppointmentService)
.controller("AppointmentCtrl", AppointmentCtrl)
.controller("AppointmentCancelCtrl", AppointmentCancelCtrl);

})();

/**
 * @author Helyxon
 * created on Dec 2016
 */
(function () {
    'use strict';

    /** @ngInject */
    function routeConfig($routeProvider) {
        $routeProvider
            .when("/apt-config", {
                templateUrl: 'app/apt-config/view.tpl.html',
                controllerAs: "config",
                controller: "AptConfigCtrl"
            })
            .when("/leave-plan", {
                templateUrl: 'app/apt-config/plan.html',
                controller: "appointmentController"
            });
    }

    /** @ngInject */
    function AptConfigService($http, $q, BudsStore, SettingsService) {
        var self = {};
        BudsStore.reset();
        return self;
    }

    /** @ngInject */
    function AptConfigCtrl(AptConfigService, BudsStore, RxCUtils, SettingsService, ScheduleService, locationService, toastr, authService, $ngBootbox, WizardHandler, $location, recordService, $q) {
        var vm = this;
        // vm.settings = {
        //   avg_time_per_patient:4,
        //   appointment_system:"token",
        //   emergency_call:false
        // };'
        vm.viewaptConfigdays = function(){
            recordService.getaptConfigdays().then(function (response) {
                console.log("aptconfigcountresponse",response)
                if(response.success == 1){
                    var cdate = response.details[0].date_of_config
                    var toconvert = cdate.split("-").reverse().join("-")
                    vm.configureddate = toconvert
                    //vm.remdays = parseInt(10)
                    vm.remdays = parseInt(response.details[0].days)
                    if(vm.remdays <= 10){
                        vm.showredalert = true;
                    } else if (vm.remdays > 10){
                        vm.showredalert = false;
                    }
                }
            })
         }
        vm.viewaptConfigdays()

        vm.getLocationStatus = function () {
            locationService.getSettings().then(function (response) {
                if (response.multilocation) {
                    vm.locationStatus = response.multilocation;
                    if (vm.locationStatus == 1) {
                        vm.loadLocationList();
                    }
                    else {

                    }
                }
                else {
                    vm.locationStatus = 0;
                    vm.locationList = [];
                }

            }, function (error) {
                toastr.error(error);
            })
        };

        vm.loadLocationList = function () {
            locationService.getLocation().then(function (response) {
                vm.locationList = [];
                angular.forEach(response, function (value) {
                    vm.locationList.push(value.location);
                });
            }, function (error) {
                toastr.error(error);
            })
        };

        vm.getLocationStatus();

        vm.saveStep1 = function () {
            var validSave = true;
            var timeconflict = false;
            var savecheckarray = [];

            if (vm.settings.emergency_call == undefined) {
                vm.settings.emergency_call = false;
            }
            
            if (!isValidSchedule(vm.sessions)) {
                return;
            }
            
            vm.checkAppointmentTimeValidationAsync(vm.sessions).then(function (message) {
                if(vm.slotsNotValid == false) {

                    var payload = preparePayloadForSaveSchedule(vm.sessions);
                    vm.sch = payload;
    
                    if (payload.data.schedule.length > 0) {
                        var saveScheduleData = {
                            "account_email": authService.authentication.account_id,
                            "config": vm.settings,
                            "schedule": payload.data.schedule,
                            "doctor_id": authService.authentication.doctor_id
                        }
                    } else {
                        toastr.error("Please fill location in all the Sessions");
                    }

            console.log(vm.strtHrs);
            for(var k=0;k<vm.strtHrs.length;k++)
            {
                savecheckarray=savecheckarray.concat(vm.strtHrs[k])
            }
            console.log(savecheckarray)

            for(var m=0;m<savecheckarray.length;m++)
            {
                for(var n=m+1;n<savecheckarray.length; n++)
                {
                    if(savecheckarray[m]==savecheckarray[n])
                    {
                        validSave=false;
                        break;
                    }
                }
            }

            for(var k=0;k<vm.strtHrs.length;k++)
            {
                if(vm.strtHrs[k].length == 0){
                    timeconflict = true;
                    break;
                }
            }
                if(timeconflict) {
                    toastr.error("Invalid time range. Please check the session");
                }
                else if(validSave)
                {
                    
                    ScheduleService.saveSchedule(saveScheduleData)
                            .then(function (response) {
                                WizardHandler.wizard().cancel();
                                //vm.reconfig=false;
                                vm.getSchedule();
                                toastr.success("Appointment settings configuration saved");
                            });
                }
                else {
                    toastr.error("Conflict in the session. Please check");
                }

            } else {

                    vm.invalidTimeAlert();
                }
            }, function (message) {
                vm.ruleValidationConsent(message.join(', '), 'Reconfigure Appointent schedule?');
            });
            // vm.checkAppointmentTimeValidationAsync2(vm.sessions)
        };
        
        vm.changepath = function () {
            $location.path('/leave-plan');
        }

        vm.checkNonNegative = function () {
            if (vm.settings.avg_time_per_patient < 0 || !vm.settings.avg_time_per_patient) {
                vm.settings.avg_time_per_patient = 4;
            }
        };

        vm.manageSession = function (action, index) {
            console.log('manageSession', action, index);
            if (action === "remove") {
                vm.sessions.splice(index, 1);
                vm.strtHrs.splice(index, 1);
                vm.endHrs.splice(index, 1);
            } else {
                if (vm.slotsNotValid == false) {
                    if(vm.sessions.length == 0){
                        vm.sessions.push({ days: angular.copy(days) });
                            vm.reconfig = true;
                    }
                    vm.checkAppointmentTimeValidationAsync(vm.sessions).then(function (message) {
                        if(vm.slotsNotValid == false) {
                            vm.sessions.push({ days: angular.copy(days) });
                            vm.reconfig = true;
                        } else {
                            vm.invalidTimeAlert();
                        }
                    },
                     function (message) {
                        vm.ruleValidationConsent(message.join(', '), 'Reconfigure Appointent schedule?');
                    });
                } 
            }
        };

        vm.redirectLocation = function(){
            vm.bottomnote = false
            if(sessionStorage.redirectLocation == "on"){
                $location.path('/location')
                sessionStorage.removeItem("popup")
                sessionStorage.redirectLocation = "off"
            }
        }

        vm.invalidTimeAlert = function () {
            var options = {
                message: 'The time required to complete the consultations configured is more than the session time, please adjust the slot counts.',
                title: 'Invalid time range',
                buttons: {
                    // warning: {
                    //     label: "Cancel",
                    //     className: "btn-warning"
                    // },
                    success: {
                        label: "Ok",
                        className: "btn-success",
                        callback: function () {
                            WizardHandler.wizard().next();
                        }
                    }
                }
            };
            $ngBootbox.customDialog(options);
        };

        vm.getSchedule = function () {
            vm.reconfig = false;
            vm.savedStep1 = false;
            vm.savedStep2 = false;
            vm.loaded = false;
            ScheduleService.getSchedule().then(function (response) {
                if(response.error){
                    vm.loaded = true;
                    vm.sessions = []
                } else {
                    vm.schedule = response;
                    vm.settings = response.config;
                    
                    if (vm.settings.appointment_system == undefined) {
                        vm.settings.appointment_system = "token";
                    }
    
    
                    var sessions = {};
                    var sessions2 = {};
                    var timeArray = [];
                    if (vm.locationStatus == 0) {
                        /*Format data as required by UI*/
                        angular.forEach(vm.schedule.schedule, function (item) {
                            /*Strip off time zzz*/
                            item.start_time = RxCUtils.toLocalTime(item.start_time);//item.start_time.slice(0,5);
                            item.end_time = RxCUtils.toLocalTime(item.end_time); // item.end_time.slice(0,5);
                            item.key = item.start_time;
                            item.location = null;
                            sessions2[item.start_time] = item;
                            timeArray.push(sessions2[item.start_time].start_time);
                        });
                        var dateArr = timeArray.sort(function (a, b) {
                            return new Date('1970/01/01 ' + a) - new Date('1970/01/01 ' + b);
                        });
    
                        angular.forEach(timeArray, function (item2) {
                            angular.forEach(sessions2, function (item1) {
                                if (item1.start_time == item2) {
                                    sessions[item1.start_time] = item1;
                                }
                            });
                        });
    
                    } else {
                        /*Format data as required by UI*/
                        angular.forEach(vm.schedule.schedule, function (item) {
                            /*Strip off time zzz*/
                            item.start_time = RxCUtils.toLocalTime(item.start_time); //item.start_time.slice(0,5);
                            item.end_time = RxCUtils.toLocalTime(item.end_time); // item.end_time.slice(0,5);
                            item.key = item.start_time;
                            sessions2[item.start_time] = item;
                            timeArray.push(sessions2[item.start_time].start_time);
                        });
                        var dateArr = timeArray.sort(function (a, b) {
                            return new Date('1970/01/01 ' + a) - new Date('1970/01/01 ' + b);
                        });
    
                        angular.forEach(timeArray, function (item2) {
                            angular.forEach(sessions2, function (item1) {
                                if (item1.start_time == item2) {
                                    sessions[item1.start_time] = item1;
                                }
                            });
                        });
                    }
    
                    var sArray = [];
                    angular.forEach(sessions, function (item) {
                        sArray.push(item);
                    });
    
                    vm.strtHrs = [];
                    vm.endHrs = [];
                    console.log(sArray);
                    
                    for (var l = 0; l < sArray.length; l++) {
    
                        var strtArray = [];
                        var endArray = [];
    
                        var splitStartAP = sArray[l].start_time.split(" ");
                        var splitStartT = sArray[l].start_time.split(":");
    
                        var splitEndAP = sArray[l].end_time.split(" ");
                        var splitEndT = sArray[l].end_time.split(":");
    
    
                        if (splitStartAP[1] == "am") {
    
       
                            if (splitStartT[0] == "12") {
    
                                var tempSt = parseInt(splitStartT[0])- 12;
                                    if(splitEndT[0]=="12")
                                    {   
                                        if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
                                        var tempEd = parseInt(splitEndT[0]) ;
                                        }
                                        else{
                                            var tempEd = parseInt(splitEndT[0]) -12;
                                        }
                                    }
                                    else{
                                      //  var tempEd = parseInt(splitEndT[0]) +12;
                                      if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
                                        var tempEd = parseInt(splitEndT[0]) +12;
                                        }
                                        else{
                                            var tempEd = parseInt(splitEndT[0]);
                                        }
                                    }
    
                                    console.log("amtempSt12***"+tempSt);
                                    console.log("amtempEd12**"+tempEd);
                                    if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
    
                                                if(splitStartT[1]=="00 am"&&splitEndT[1]=="00 pm")
                                                {
                                                //    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 pm")
                                                {
                                                //    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                                else if(splitStartT[1]=="30 am"&&splitEndT[1]=="00 pm")
                                                {
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else{
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                    }
                                    else if (parseInt(splitStartT[0]) >= parseInt(splitEndT[0])) {
    
                                        var tempSt = parseInt(splitStartT[0])-12;
                                        var tempEd = parseInt(splitEndT[0]);
                
                                                console.log("amtopmtempSt"+tempSt);
                                                console.log("amtopmtempEd"+tempEd);
                                                if(tempSt+12 == tempEd){
                                                    if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 am")
                                                    strtArray.push(tempSt + "");
                                                }
                                                else if(splitStartT[1]=="00 am"&&splitEndT[1]=="00 am")
                                                    {
                                                     //   strtArray.push(tempSt+"H")
                                                        for (var k = tempSt; k < tempEd; k++) 
                                                        {
                                                        strtArray.push(k + "");
                                                        strtArray.push(k + "H");
                                                        }
                                                    }
                                                    else if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 am")
                                                    {
                                                     //   strtArray.push(tempSt+"H")
                                                        for (var k = tempSt; k < tempEd; k++) 
                                                        {
                                                        strtArray.push(k + "");
                                                        strtArray.push(k + "H");
                                                        }
                                                        strtArray.push(tempEd+ "");
                                                    }
                                                    else if(splitStartT[1]=="30 am"&&splitEndT[1]=="00 am")
                                                    {
                                                        strtArray.push(tempSt+"H")
                                                        for (var k = tempSt+1; k < tempEd; k++) 
                                                        {
                                                        strtArray.push(k + "");
                                                        strtArray.push(k + "H");
                                                        }
                                                    }
                                                    else if(splitStartT[1]=="30 am"&&splitEndT[1]=="30 am"){
                                                        strtArray.push(tempSt+"H")
                                                        for (var k = tempSt; k < tempEd; k++) 
                                                        {
                                                        strtArray.push(k + "");
                                                        strtArray.push(k + "H");
                                                        }
                                                        strtArray.push(tempEd+ "");
                                                    }
                                        }
        
                               
                            }
    
                            if (splitStartT[0] != "12") {
                                //am to pm
                                if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
                                    //alert("hello")
        
                                    if (splitStartT[0] != "12") {
        
            
                                            var tempSt = parseInt(splitStartT[0]);
                                            if(splitEndT[0]=="12")
                                            {
                                                var tempEd = parseInt(splitEndT[0]);
                                            }
                                            else
                                            {
                                                var tempEd = parseInt(splitEndT[0]) + 12;
                                            }
            
                                            console.log("amtopmtempSt"+tempSt);
                                            console.log("amtopmtempEd"+tempEd);
    
                                                if(splitStartT[1]=="00 am"&&splitEndT[1]=="00 pm")
                                                {
                                                 //   strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 pm")
                                                {
                                                 //   strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                                else if(splitStartT[1]=="30 am"&&splitEndT[1]=="00 pm")
                                                {
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else{
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                            }
                                }
    
                                else if (parseInt(splitStartT[0]) <= parseInt(splitEndT[0])) {
    
                                    var tempSt = parseInt(splitStartT[0]);
                                    var tempEd = parseInt(splitEndT[0]);
            
                                            console.log("amtopmtempSt"+tempSt);
                                            console.log("amtopmtempEd"+tempEd);
    
                                            if(tempSt == tempEd ){
                                                if (splitStartT[1]=="00 am"&&splitEndT[1]=="30 am")
                                                strtArray.push(tempSt + "");
                                            }
                                             else if(splitStartT[1]=="00 am"&&splitEndT[1]=="00 am")
                                                {
                                                 //   strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 am")
                                                {
                                                 //   strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                                else if(splitStartT[1]=="30 am"&&splitEndT[1]=="00 am")
                                                {
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="30 am"&&splitEndT[1]=="30 am"){
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                            }
    
                            }
    
    
                        } 
                        
                        else if (splitStartAP[1] == "pm") {
    
    
                            if (splitStartT[0] == "12") {
                                
                                    var tempSt = parseInt(splitStartT[0]);
                                    if(splitEndT[0]=="12")
                                    {
                                        var tempEd = parseInt(splitEndT[0]) ;
                                    }
                                    else if(splitEndT[1]=="00 am"||splitEndT[1]=="30 am"){
                                        var tempEd = parseInt(splitEndT[0]);
                                    }
                                    else{
                                        var tempEd= parseInt(splitEndT[0]) +12;
                                    }
    
                                    console.log("pmtopm"+tempSt);
                                    console.log("pmtopm"+tempEd);
                                    if(tempSt == tempEd){
                                       if (splitStartT[1]=="00 pm"&&splitEndT[1]=="30 pm")
                                        strtArray.push(tempSt + "");
                                    }
    
                                    else if(splitStartT[1]=="00 pm"&&splitEndT[1]=="00 pm")
                                                {
                                                //    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="00 pm"&&splitEndT[1]=="30 pm")
                                                {
                                                //    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                                else if(splitStartT[1]=="30 pm"&&splitEndT[1]=="00 pm")
                                                {
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="30 pm"&&splitEndT[1]=="30 pm"){
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                  
                            }
    
    
                            if (splitStartT[0] != "12") {
    
                                if ((parseInt(splitStartT[0]) + 12) <= (parseInt(splitEndT[0]) + 12)) {
    
                                    var tempSt = parseInt(splitStartT[0]) + 12;
                               //     var tempEd = parseInt(splitEndT[0]) + 12;
                                    if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
                                        var tempEd = parseInt(splitEndT[0])+12 ;
                                        }
                                        else{
                                            var tempEd = parseInt(splitEndT[0]) ;
                                        }
    
                                    console.log("pmtempSt"+tempSt);
                                    console.log("pmtempEd"+tempEd);
    
                                    if(tempSt == tempEd){
                                        if(splitStartT[1]=="00 pm"&&splitEndT[1]=="30 pm")
                                        strtArray.push(tempSt + "");
                                    }
                                    else if(splitStartT[1]=="00 pm"&&splitEndT[1]=="00 pm"&&tempSt<tempEd)
                                                {
                                                //    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="00 pm"&&splitEndT[1]=="30 pm")
                                                {
                                                //    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                                else if(splitStartT[1]=="30 pm"&&splitEndT[1]=="00 pm")
                                                {
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="30 pm"&&splitEndT[1]=="30 pm"){
                                                    console.log("welcome")
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                            }
                                }
                        }
                         vm.strtHrs.push(strtArray);
                        console.log("starting array*****");
                         console.log(vm.strtHrs);
                        }
                    
                    vm.sessions = sArray;
    
                    /* var sArray = [], sArray2 = [], sArray3 = [];
                       angular.forEach(sessions,function(item){
                         sArray2.push(item);
                       });
                       var objct1  = sArray2[0];
                       var objct2  = {"ivrs":0};
                       var sArray3 = Object.assign(objct1, objct2);
                       sArray.push(sArray3);
                       vm.sessions = sArray; */
    
                    /*IF NO SESSIONS ADD A ROW*/
                    if (sArray.length === 0) {
                        vm.manageSession('add', 0);
                    }
                    vm.reconfig = false;
                    angular.forEach(vm.sessions, function (item) {
                        /*Create all sessions from schedules*/
                        item.days = angular.copy(days);
                        angular.forEach(vm.schedule.schedule, function (s) {
                            /*Create days array*/
                            if (s.start_time === item.key) {
                                if (s.day_of_week === "0") {
                                    item.days.mon = true;
                                } else if (s.day_of_week === "1") {
                                    item.days.tue = true;
                                } else if (s.day_of_week === "2") {
                                    item.days.wed = true;
                                } else if (s.day_of_week === "3") {
                                    item.days.thu = true;
                                } else if (s.day_of_week === "4") {
                                    item.days.fri = true;
                                } else if (s.day_of_week === "5") {
                                    item.days.sat = true;
                                } else if (s.day_of_week === "6") {
                                    item.days.sun = true;
                                }
                            }
                        });
                    });
                    vm.loaded = true;
                }
                
            }, function (err, response) {
                vm.loaded = true;
                vm.sessions = [];
            });

        };

        vm.saveStep2 = function () {
            if (!isValidSchedule(vm.sessions)) {
                return;
            }
            var payload = preparePayloadForSaveSchedule(vm.sessions);
            vm.sch = payload;

            if (payload.data.schedule.length > 0) {
                ScheduleService.saveSchedule(payload).then(function (response) {
                    vm.savedStep2 = true;
                    toastr.success("Schedule changes saved.");
                });
            } else {
                toastr.error("Please fill location in all the Sessions");
            }

        };

        vm.goToPrepareStep = function () {
            if (!isValidSchedule(vm.sessions)) {
                return;
            }

            WizardHandler.wizard().next();

        };

        function isValidSchedule(sessions) {
            var sSlots = [], eSlots = [];
            var inputError = false;
            angular.forEach(sessions, function (session) {
                sSlots.push(session.start_time);
                eSlots.push(session.end_time);
                if (!session.start_time || !session.end_time ||
                    !(session.days.mon || session.days.tue || session.days.wed || session.days.thu || session.days.fri || session.days.sat || session.days.sun)) {
                    inputError = true;
                } 
            });

            if (inputError) {
                toastr.error("Start Time, End Time, Appointment Type and atleast one day is required.");
                return false;
            }

            if (RxCUtils.hasDupesInArray(sSlots) || RxCUtils.hasDupesInArray(eSlots)) {
                toastr.error("Start Time, End Time should not be same.");
                return false;
            }        
            return true;
        }

        vm.prepareSchedule = function () {
            ScheduleService.prepareSchedule({
                "date": vm.prepare.date.toString().slice(4, 15),
                "appointment_system": vm.settings.appointment_system,
                "doctor_id": authService.authentication.doctor_id
            })
                .then(function (response) {
                    WizardHandler.wizard().cancel();
                    vm.reconfig = false;
                    toastr.success("Schedule prepared till date : " + vm.prepare.date.toLocaleDateString().split('/').reverse().join('-'));
                    vm.getSchedule();
                });
        };

        function covert24Hrs(dateVal) {
            //var time = $("#starttime").val();
            var time = dateVal;
            var hours = Number(time.match(/^(\d+)/)[1]);
            var minutes = Number(time.match(/:(\d+)/)[1]);
            var AMPM = time.match(/\s(.*)$/)[1];
            if (AMPM == "pm" && hours < 12) hours = hours + 12;
            if (AMPM == "am" && hours == 12) hours = hours - 12;
            var sHours = hours.toString();
            var sMinutes = minutes.toString();
            if (hours < 10) sHours = "0" + sHours;
            if (minutes < 10) sMinutes = "0" + sMinutes;
         return sHours + ":" + sMinutes;
        }

        function preparePayloadForSaveSchedule(sessions) {
            /*Format payload for service*/
            var Monday = { "day": 0, "items": [] };
            var Tuesday = { "day": 1, "items": [] };
            var Wednesday = { "day": 2, "items": [] };
            var Thursday = { "day": 3, "items": [] };
            var Friday = { "day": 4, "items": [] };
            var Saturday = { "day": 5, "items": [] };
            var Sunday = { "day": 6, "items": [] };

            angular.forEach(sessions, function (item) {

                var startTime, endTime;
                if ((vm.locationList.length == 0 && item.location == null) || (vm.locationList.length > 0 && item.location != null)) {
                    startTime = item.start_time;
                    endTime = item.end_time;

                    /*  if (item.start_time.slice(5)==="PM"||item.start_time.slice(5)===" PM"){
                            startTime = (parseInt(item.start_time.split(" ")[0]) + 12).toString() + ":" + item.start_time.split(" ")[0].split(":")[1];            
                        }
                        if (item.end_time.slice(5)==="PM"||item.end_time.slice(5)===" PM"){
                            endTime = (parseInt(item.end_time.split(" ")[0]) + 12).toString() + ":" + item.end_time.split(" ")[0].split(":")[1];           
                        }       
                        if (item.start_time.slice(5)==="AM"||item.start_time.slice(5)===" AM"){
                            startTime = (parseInt(item.start_time.split(" ")[0])).toString() + ":" + item.start_time.split(" ")[0].split(":")[1];      
                        }
                        if (item.end_time.slice(5)==="AM"||item.end_time.slice(5)===" AM"){
                            endTime = (parseInt(item.end_time.split(" ")[0])).toString() + ":" + item.end_time.split(" ")[0].split(":")[1];
                        } */

                    startTime = covert24Hrs(item.start_time);
                    endTime = covert24Hrs(item.end_time);

                    var sTime = RxCUtils.toGMTTime(startTime);
                    var eTime = RxCUtils.toGMTTime(endTime);

                    if (item.location == undefined) {
                        item.location = null;
                    }

                    item.online = item.online ? item.online : 0;
                    item.ivrs = item.ivrs ? item.ivrs : 0;
                    item.web = item.web ? item.web : 0;
                    item.tele = item.tele ? item.tele : 0;
                    item.offline = item.offline ? item.offline : 0;

                    if (item.days.mon) {
                        Monday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.tue) {
                        Tuesday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.wed) {
                        Wednesday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.thu) {
                        Thursday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.fri) {
                        Friday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.sat) {
                        Saturday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.sun) {
                        Sunday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                }

            });


            var payload = {
                "data": { "schedule": [] }
            };

            if (Monday.items.length > 0) {
                payload.data.schedule.push(Monday);
            }
            if (Tuesday.items.length > 0) {
                payload.data.schedule.push(Tuesday);
            }
            if (Wednesday.items.length > 0) {
                payload.data.schedule.push(Wednesday);
            }
            if (Thursday.items.length > 0) {
                payload.data.schedule.push(Thursday);
            }
            if (Friday.items.length > 0) {
                payload.data.schedule.push(Friday);
            }
            if (Saturday.items.length > 0) {
                payload.data.schedule.push(Saturday);
            }
            if (Sunday.items.length > 0) {
                payload.data.schedule.push(Sunday);
            }
            return payload;
        }

        vm.totalTime = 0;
        vm.teleMax = 0;

        vm.timeCal = function (item, slot_type) {
            var timeDiff = {
                startTime1: '',
                endTime1: '',
                duration: '',
                hours: '',
                minutes: ''
            }
            timeDiff.startTime1 = moment(item.start_time, "HH:mm A");
            timeDiff.endTime1 = moment(item.end_time, "HH:mm A");
            timeDiff.duration = moment.duration(timeDiff.endTime1.diff(timeDiff.startTime1));
            timeDiff.hours = parseInt(timeDiff.duration.asHours());
            timeDiff.minutes = parseInt(timeDiff.duration.asMinutes()) % 60;
            vm.totalHours = parseInt((timeDiff.hours * 60) + timeDiff.minutes);

            if (slot_type == 'inperson') {
                return parseInt((((timeDiff.hours) * 60) + (timeDiff.minutes)) / vm.settings.avg_time_per_patient);
            } else if (slot_type == 'tele') {
                return 0;
                // return parseInt( ( ( (timeDiff.hours)/2 * 60 ) + (timeDiff.minutes)/2 ) / vm.settings.avg_time_per_patient_tele );
            }
        };

        vm.offlineNum = 0;
        vm.teleNum = 0;
        vm.totalSlotTime = 0;
        vm.slotsNotValid = false;


        vm.calculateOnlineOffline = function (data) {

            //alert('calc');

            if (data.start_time && data.end_time) {

                //alert('calc2');

                // data.offline = vm.timeCal(data, 'inperson');
                // data.tele = vm.timeCal(data, 'tele');

                //offlineNum = vm.timeCal(data, 'inperson');
                //teleNum = vm.timeCal(data, 'tele');

                // data.offline = vm.timeCal(data, 'inperson');
                // data.tele = vm.timeCal(data, 'tele');
                // data.total = data.offline + data.tele; 

                vm.offlineNum = vm.timeCal(data, 'inperson');
                vm.teleNum = vm.timeCal(data, 'tele');

                if ((vm.offlineNum + vm.teleNum) < 0) {
                    toastr.error('Invalid time range');
                    data.end_time = data.start_time;
                    data.offline = 0;
                    data.total = 0;
                    data.online = 0;
                    data.web = 0;
                    data.tele = 0;
                    //vm.slotsNotValid=false;
                } else {

                    if (vm.settings.avg_time_per_patient && vm.settings.avg_time_per_patient_tele) {

                        vm.totalSlotTime = parseInt((vm.settings.avg_time_per_patient * vm.offlineNum) + (vm.settings.avg_time_per_patient_tele * vm.teleNum));

                        // console.log('vm.totalSlotTime',  vm.totalSlotTime);
                        // console.log('vm.totalHours', vm.totalHours);
                        //alert( 'Total time: '+ vm.totalHours  + 'Total slot time: ' +vm.totalSlotTime);

                        if (vm.totalHours >= vm.totalSlotTime) {

                            if (vm.totalSlotTime <= vm.totalHours) {
                                vm.timevariance = vm.totalHours - vm.totalSlotTime;

                                if (vm.settings.avg_time_per_patient <= vm.timevariance) {
                                    //  console.log('offline floor',Math.floor(vm.timevariance/vm.settings.avg_time_per_patient));
                                    vm.offlineNum += Math.floor(vm.timevariance / vm.settings.avg_time_per_patient);
                                    // console.log('offline', vm.offlineNum)
                                    vm.timevariance = vm.timevariance - vm.settings.avg_time_per_patient;
                                }
                                if (vm.settings.avg_time_per_patient_tele <= vm.timevariance) {
                                    //    console.log('in-floor',Math.floor(vm.timevariance/vm.settings.avg_time_per_patient_tele));
                                    vm.teleNum += Math.floor(vm.timevariance / vm.settings.avg_time_per_patient_tele);
                                    // console.log('In',vm.teleNum);
                                    vm.timevariance = vm.timevariance - vm.settings.avg_time_per_patient_tele;
                                }
                            }
                            data.offline = vm.offlineNum;
                            data.tele = vm.teleNum;
                            data.total = data.offline;
                            // data.total = data.offline + data.tele;
                            data.totalTime = vm.totalHours
                            data.offline = vm.offlineNum;
                            data.web = 0;
                            data.online = 0;
                            data.ivrs = 0;
                            data.teleMax = Math.floor(vm.totalHours / vm.settings.avg_time_per_patient_tele);
                            // data.onlineMax = data.offline;

                            vm.slotsNotValid = false;
                        } else {
                            vm.slotsNotValid = true;
                            vm.invalidTimeAlert();
                            data.total = 0;
                            data.offline = 0;
                            data.web = 0;
                            data.online = 0;
                            data.ivrs = 0;
                        }

                    } else if (vm.settings.avg_time_per_patient) {
                        vm.totalSlotTime = parseInt((vm.settings.avg_time_per_patient * vm.offlineNum));
                        if (vm.totalHours >= vm.totalSlotTime) {

                            if (vm.totalSlotTime <= vm.totalHours) {
                                vm.timevariance = vm.totalHours - vm.totalSlotTime;

                                if (vm.settings.avg_time_per_patient <= vm.timevariance) {
                                    vm.offlineNum += Math.floor(vm.timevariance / vm.settings.avg_time_per_patient);
                                    vm.timevariance = vm.timevariance - vm.settings.avg_time_per_patient;
                                }
                            }
                            data.offline = vm.offlineNum;
                            data.total = data.offline;
                            data.offline = vm.offlineNum;
                            data.web = 0;
                            data.online = 0;
                            data.ivrs = 0;

                            vm.slotsNotValid = false;
                        }
                    }
                }
            }
        };

        vm.timeCheck1 = function (data, time) {

            alert('time check..');
            if (time == "startTime") {

                var strArr;
                var strBool;
                

                var splitStartAP = data.start_time.split(" ");
                var splitStartT = data.start_time.split(":");
                if (splitStartAP[1] == "am") {

                    if (splitStartT[0] == "12") {

                        if (splitStartT[1] == "30 am") {
                            strArr = "0";
                        } else {

                            strArr = "0H";
                        }

                    }

                    if (splitStartT[0] != "12") {

                        if (splitStartT[1] == "30 am") {
                            strArr = splitStartT[0] + "H";
                        } else {
                            strArr = splitStartT[0];
                        }
                    }


                } else if (splitStartAP[1] == "pm") {

                    if (splitStartT[0] == "12") {
                        if (splitStartT[1] == "30 pm") {
                            strArr = "12H";
                        } else {
                            strArr = "12";
                        }
                    }

                    if (splitStartT[0] != "12") {

                        if (splitStartT[1] == "30 pm") {
                            strArr = (parseInt(splitStartT[0]) + 12) + "H";
                        } else {
                            strArr = (parseInt(splitStartT[0]) + 12) + "";
                        }

                    }
                }

                console.log(vm.strtHrs);
                console.log("checking var"+ strArr);
                //checkarr.push(strArr);

                //console.log("checking arr"+ checkarr);
                
                angular.forEach(vm.strtHrs, function (value) {
                    //console.log(value);
                    for (var i = 0; i < value.length; i++) {
                        console.log(value[i]);
                        if (strArr == value[i]) {
                            strBool = true;
                        }
                    }

                });

                if (strBool == true) {
                    toastr.error('Time already taken.');
                    data.start_time = "";

                } else {
   
                    vm.calculateOnlineOffline(data);
                }


            } else if (time == "endTime") {

                var endArr;
                var endBool;

                var splitEndAP = data.end_time.split(" ");
                var splitEndT = data.end_time.split(":");

                if (splitEndAP[1] == "am") {

                    if (splitEndT[0] == "12") {

                        if (splitEndT[1] == "30 am") {
                            endArr = "0";
                        } else {

                            endArr = "0H";
                        }

                    }

                    if (splitEndT[0] != "12") {

                        if (splitEndT[1] == "30 am") {
                            endArr = splitEndT[0] + "H";
                        } else {
                            endArr = splitEndT[0];
                        }
                    }


                } else if (splitEndAP[1] == "pm") {

                    if (splitEndT[0] == "12") {
                        if (splitEndT[1] == "30 pm") {
                            endArr = "12H";
                        } else {
                            endArr = "12";
                        }
                    }

                    if (splitEndT[0] != "12") {

                        if (splitEndT[1] == "30 pm") {
                            endArr = (parseInt(splitEndT[0]) + 12) + "H";
                        } else {
                            endArr = (parseInt(splitEndT[0]) + 12) + "";
                        }

                    }
                }

                //alert(endArr)
                angular.forEach(vm.endHrs, function (value) {
                    for (var i = 0; i < value.length; i++) {
                        if (endArr == value[i]) {
                            endBool = true;
                        }
                    }
                });

                if (endBool == true) {
                    toastr.error('Time already taken.');
                    data.end_time = "";
                } else {
           
                    vm.calculateOnlineOffline(data);
                }
            } else {
                vm.calculateOnlineOffline(data);
            }
        }

        vm.timeChanged = function (data, time, changeindex) {
           vm.timeCheck(data, time, changeindex);
        }

        //Justin code

        vm.timeCheck = function (data, time, changeindex) {

          
          if (!isValidateSessions(vm.sessions)) {
            return;
        } 
        inbetweenSlotTimes(vm.sessions,data,time,changeindex);

         
        }

        function isValidateSessions(sessions) {
            var sSlots = [], eSlots = [];
            
            angular.forEach(sessions, function (session) {
                sSlots.push(session.start_time);
                eSlots.push(session.end_time);
                // console.log(sSlots)
                // console.log(eSlots)

                 if (session.start_time == session.end_time) {
                    toastr.error("Start Time, End Time should not be same");
                    return false;
                }
                // if (session.start_time >= session.end_time) {
                //     toastr.error("Start Time, End Time should not be samesads");
                //     return false;
                // }   
            });
            if (RxCUtils.hasDupesInArray(sSlots) || RxCUtils.hasDupesInArray(eSlots)) {
                toastr.error("conflict the Sessions time");
                return false;
            }        
            return true;
        }

        function inbetweenSlotTimes(sessions,data,time,changeindex) {
            
            // var myEl = angular.element(document.querySelector( '#start_0') );
            // myEl.addClass('error');
            var sArray = [];
                angular.forEach(sessions, function (item) {
                    sArray.push(item);
                });

                vm.strtHrs = [];
                vm.endHrs = [];
                console.log(sArray);
                
                for (var l = 0; l < sArray.length; l++) {

                    var strtArray = [];
                    var endArray = [];

                    var splitStartAP = sArray[l].start_time.split(" ");
                    var splitStartT = sArray[l].start_time.split(":");

                    var splitEndAP = sArray[l].end_time.split(" ");
                    var splitEndT = sArray[l].end_time.split(":");


                    if (splitStartAP[1] == "am") {

   
                        if (splitStartT[0] == "12") {

                            var tempSt = parseInt(splitStartT[0])- 12;
                                if(splitEndT[0]=="12")
                                {   
                                    if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
                                    var tempEd = parseInt(splitEndT[0]) ;
                                    }
                                    else{
                                        var tempEd = parseInt(splitEndT[0]) -12;
                                    }
                                }
                                else{
                                  //  var tempEd = parseInt(splitEndT[0]) +12;
                                  if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
                                    var tempEd = parseInt(splitEndT[0]) +12;
                                    }
                                    else{
                                        var tempEd = parseInt(splitEndT[0]);
                                    }
                                }

                                console.log("amtempSt12***"+tempSt);
                                console.log("amtempEd12**"+tempEd);
                                if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {

                                            if(splitStartT[1]=="00 am"&&splitEndT[1]=="00 pm")
                                            {
                                            //    strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 pm")
                                            {
                                            //    strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                            else if(splitStartT[1]=="30 am"&&splitEndT[1]=="00 pm")
                                            {
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else{
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                }
                                else if (parseInt(splitStartT[0]) >= parseInt(splitEndT[0])) {

                                    var tempSt = parseInt(splitStartT[0])-12;
                                    var tempEd = parseInt(splitEndT[0]);
            
                                            console.log("amtopmtempSt"+tempSt);
                                            console.log("amtopmtempEd"+tempEd);
                                            if(tempSt+12 == tempEd){
                                                if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 am")
                                                strtArray.push(tempSt + "");
                                            }
                                            else if(splitStartT[1]=="00 am"&&splitEndT[1]=="00 am")
                                                {
                                                 //   strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 am")
                                                {
                                                 //   strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                                else if(splitStartT[1]=="30 am"&&splitEndT[1]=="00 am")
                                                {
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt+1; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                }
                                                else if(splitStartT[1]=="30 am"&&splitEndT[1]=="30 am"){
                                                    strtArray.push(tempSt+"H")
                                                    for (var k = tempSt; k < tempEd; k++) 
                                                    {
                                                    strtArray.push(k + "");
                                                    strtArray.push(k + "H");
                                                    }
                                                    strtArray.push(tempEd+ "");
                                                }
                                    }
    
                           
                        }

                        if (splitStartT[0] != "12") {
                            //am to pm
                            if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
                                //alert("hello")
    
                                if (splitStartT[0] != "12") {
    
        
                                        var tempSt = parseInt(splitStartT[0]);
                                        if(splitEndT[0]=="12")
                                        {
                                            var tempEd = parseInt(splitEndT[0]);
                                        }
                                        else
                                        {
                                            var tempEd = parseInt(splitEndT[0]) + 12;
                                        }
        
                                        console.log("amtopmtempSt"+tempSt);
                                        console.log("amtopmtempEd"+tempEd);

                                            if(splitStartT[1]=="00 am"&&splitEndT[1]=="00 pm")
                                            {
                                             //   strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 pm")
                                            {
                                             //   strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                            else if(splitStartT[1]=="30 am"&&splitEndT[1]=="00 pm")
                                            {
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else{
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                        }
                            }

                            else if (parseInt(splitStartT[0]) <= parseInt(splitEndT[0])) {

                                var tempSt = parseInt(splitStartT[0]);
                                var tempEd = parseInt(splitEndT[0]);
        
                                        console.log("amtopmtempSt"+tempSt);
                                        console.log("amtopmtempEd"+tempEd);

                                        if(tempSt == tempEd ){
                                            if (splitStartT[1]=="00 am"&&splitEndT[1]=="30 am")
                                            strtArray.push(tempSt + "");
                                        }
                                         else if(splitStartT[1]=="00 am"&&splitEndT[1]=="00 am")
                                            {
                                             //   strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else if(splitStartT[1]=="00 am"&&splitEndT[1]=="30 am")
                                            {
                                             //   strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                            else if(splitStartT[1]=="30 am"&&splitEndT[1]=="00 am")
                                            {
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else if(splitStartT[1]=="30 am"&&splitEndT[1]=="30 am"){
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                        }

                        }


                    } 
                    
                    else if (splitStartAP[1] == "pm") {


                        if (splitStartT[0] == "12") {
                            
                                var tempSt = parseInt(splitStartT[0]);
                                if(splitEndT[0]=="12")
                                {
                                    var tempEd = parseInt(splitEndT[0]) ;
                                }
                                else if(splitEndT[1]=="00 am"||splitEndT[1]=="30 am"){
                                    var tempEd = parseInt(splitEndT[0]);
                                }
                                else{
                                    var tempEd= parseInt(splitEndT[0]) +12;
                                }

                                console.log("pmtopm"+tempSt);
                                console.log("pmtopm"+tempEd);
                                if(tempSt == tempEd){
                                   if (splitStartT[1]=="00 pm"&&splitEndT[1]=="30 pm")
                                    strtArray.push(tempSt + "");
                                }

                                else if(splitStartT[1]=="00 pm"&&splitEndT[1]=="00 pm")
                                            {
                                            //    strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else if(splitStartT[1]=="00 pm"&&splitEndT[1]=="30 pm")
                                            {
                                            //    strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                            else if(splitStartT[1]=="30 pm"&&splitEndT[1]=="00 pm")
                                            {
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else if(splitStartT[1]=="30 pm"&&splitEndT[1]=="30 pm"){
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                              
                        }


                        if (splitStartT[0] != "12") {

                            if ((parseInt(splitStartT[0]) + 12) <= (parseInt(splitEndT[0]) + 12)) {

                                var tempSt = parseInt(splitStartT[0]) + 12;
                           //     var tempEd = parseInt(splitEndT[0]) + 12;
                                if (splitEndT[1] == "00 pm" || splitEndT[1] == "30 pm") {
                                    var tempEd = parseInt(splitEndT[0])+12 ;
                                    }
                                    else{
                                        var tempEd = parseInt(splitEndT[0]) ;
                                    }

                                console.log("pmtempSt"+tempSt);
                                console.log("pmtempEd"+tempEd);

                                if(tempSt == tempEd){
                                    if(splitStartT[1]=="00 pm"&&splitEndT[1]=="30 pm")
                                    strtArray.push(tempSt + "");
                                }
                                else if(splitStartT[1]=="00 pm"&&splitEndT[1]=="00 pm"&&tempSt<tempEd)
                                            {
                                            //    strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else if(splitStartT[1]=="00 pm"&&splitEndT[1]=="30 pm")
                                            {
                                            //    strtArray.push(tempSt+"H")
                                                for (var k = tempSt; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                            else if(splitStartT[1]=="30 pm"&&splitEndT[1]=="00 pm")
                                            {
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                            }
                                            else if(splitStartT[1]=="30 pm"&&splitEndT[1]=="30 pm"){
                                                console.log("welcome")
                                                strtArray.push(tempSt+"H")
                                                for (var k = tempSt+1; k < tempEd; k++) 
                                                {
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                                }
                                                strtArray.push(tempEd+ "");
                                            }
                                        }
                            }
                    }
                     vm.strtHrs.push(strtArray);
                    console.log("starting array*****");
                     console.log(vm.strtHrs);
                    

                    if (time == "startTime") {
                        var strArr;
                        var strBool=false;
                        var starttimeheckarray = [];
                        var splitStartAP = data.start_time.split(" ");
                        var splitStartT = data.start_time.split(":");
                        if (splitStartAP[1] == "am") {
        
                            if (splitStartT[0] == "12") {
        
                                if (splitStartT[1] == "30 am") {
                                    strArr = "0H";
                                } else {
        
                                    strArr = "0";
                                }
        
                            }
        
                            if (splitStartT[0] != "12") {
        
                                if (splitStartT[1] == "30 am") {
                                    strArr = splitStartT[0] + "H";
                                } else {
                                    strArr = splitStartT[0];
                                }
                            }
        
        
                        } else if (splitStartAP[1] == "pm") {
        
                            if (splitStartT[0] == "12") {
                                if (splitStartT[1] == "30 pm") {
                                    strArr = "12H";
                                } else {
                                    strArr = "12";
                                }
                            }
        
                            if (splitStartT[0] != "12") {
        
                                if (splitStartT[1] == "30 pm") {
                                    strArr = (parseInt(splitStartT[0]) + 12) + "H";
                                } else {
                                    strArr = (parseInt(splitStartT[0]) + 12) + "";
                                }
        
                            }
                        }
        
                        console.log(vm.strtHrs);
                     //   alert(changeindex)
                        console.log("Selected start value*****"+ strArr);
                        
                        // angular.forEach(vm.strtHrs, function (value) {
                        //     for (var i = 0; i < value.length; i++) {
                        //         if(i != changeindex) { 
                        //             console.log(changeindex)      
                        //             if (strArr == value[i]) {
                        //             strBool = true;
                        //         }
                        //       }
                        //     }
        
                        // });
                        for(var k=0;k<vm.strtHrs.length;k++)
                        {
                            if(k!=changeindex)
                            {
                                starttimeheckarray=starttimeheckarray.concat(vm.strtHrs[k])
                            }
                            
                        }
                        console.log(starttimeheckarray)

                        for(var m=0;m<starttimeheckarray.length;m++)
                        {
                            if(strArr == starttimeheckarray[m])
                            {
                                strBool=true;console.log(strBool)
                                break;
                            }
                        }
                        

                        if(vm.strtHrs[changeindex]!=undefined)
                        {
                        for(var i=0;i<vm.strtHrs[changeindex].length;i++)
                        {
                            for(var j=0;j<vm.strtHrs.length;j++)
                            {
                                if(j!=changeindex)
                                {
                                for(var k=0;k<vm.strtHrs[j].length;k++)
                                {
                                    if(vm.strtHrs[changeindex][i]==vm.strtHrs[j][k])
                                    {
                                        strBool=true;
                                        break;
                                    }
                                }
                            }
                            }
                        }
                        }

                        vm.offlineNum = vm.timeCal(data, 'inperson');
                        vm.teleNum = vm.timeCal(data, 'tele');

                        if ((vm.offlineNum + vm.teleNum) < 0) {
                            toastr.error('Invalid time range');
                        }
                        
                        else if (strBool == true) {
                            
                            toastr.error('Time already taken.');
                        } else {
                            vm.calculateOnlineOffline(data);
                        }
        
        
                    } else if (time == "endTime") {
        
                        var endArr;
                        var endBool=false;
                        var aroundTime=false;
        
                        var splitEndAP = data.end_time.split(" ");
                        var splitEndT = data.end_time.split(":");
        
                        if (splitEndAP[1] == "am") {
        
                            if (splitEndT[0] == "12") {
        
                                if (splitEndT[1] == "30 am") {
                                    endArr = "0";
                                } else {
        
                                    endArr = "0H";
                                }
        
                            }
        
                            if (splitEndT[0] != "12") {
        
                                if (splitEndT[1] == "30 am") {
                                    endArr = splitEndT[0] + "H";
                                } else {
                                    endArr = splitEndT[0];
                                }
                            }
        
        
                        } else if (splitEndAP[1] == "pm") {
        
                            if (splitEndT[0] == "12") {
                                if (splitEndT[1] == "30 pm") {
                                    endArr = "12H";
                                } else {
                                    endArr = "12";
                                }
                            }
        
                            if (splitEndT[0] != "12") {
        
                                if (splitEndT[1] == "30 pm") {
                                    endArr = (parseInt(splitEndT[0]) + 12) + "H";
                                } else {
                                    endArr = (parseInt(splitEndT[0]) + 12) + "";
                                }
        
                            }
                        }
        
                        console.log("Selected End value*****"+ endArr);
                        // angular.forEach(vm.strtHrs, function (value) {
                        //     for (var i = 0; i < value.length; i++) {
                        //         if (endArr == value[i]) {
                        //             endBool = true;
                        //         }
                        //     }
                        // });

                        if(vm.strtHrs[changeindex]!=undefined)
                        {
                        for(var i=0;i<vm.strtHrs[changeindex].length;i++)
                        {
                            for(var j=0;j<vm.strtHrs.length;j++)
                            {
                                if(j!=changeindex)
                                {
                                for(var k=0;k<vm.strtHrs[j].length;k++)
                                {
                                    if(vm.strtHrs[changeindex][i]==vm.strtHrs[j][k])
                                    {
                                        endBool=true;
                                    }
                                }
                            }
                            }
                        }
                        }

                        vm.offlineNum = vm.timeCal(data, 'inperson');
                        vm.teleNum = vm.timeCal(data, 'tele');

                        if ((vm.offlineNum + vm.teleNum) < 0) {
                            toastr.error('Invalid time range');
                        }
        
                        else if (endBool == true) {
                            toastr.error('Time already taken.');
                           // data.end_time = "";
                        }
                        // else if(aroundTime)
                        // {
                        //     toastr.error('Conflicting sessions')
                        // } 
                        else {
                            vm.calculateOnlineOffline(data);
                        }
                    } else {
                        
                        vm.calculateOnlineOffline(data);
                    }
                }
        }

        vm.avgTimeChanged = function (data) {
            angular.forEach(data, function (value) {
                vm.timeChanged(value);
            });
        }

        vm.changeIvrs = function (data) {
            data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
        };

        vm.changeWeb = function (data) {
            data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
        };

        vm.changeTele = function (data) {
            data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
        };

        vm.changeOnline = function (data) {
            if (!data.total) {
                vm.calculateOnlineOffline(data);
            }
            // if (data.total == data.offline) {
            //     data.offline = 0;
            // }
            if (data.online < data.total) {
                if (data.offline != 0) {

                    //alert('offline not zero..');

                    data.offline = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                } else {

                    // alert('ivrs not zero');
                    if (data.ivrs != 0) {
                        data.ivrs = Math.floor((data.totalTime - (((data.offline + data.web + data.online) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else if (data.web != 0) {
                        data.web = Math.floor((data.totalTime - (((data.offline + data.online + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else if (data.tele != 0) {
                        data.tele = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient))) / (vm.settings.avg_time_per_patient_tele))
                    } else {
                        data.offline = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    }

                    //data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);

                }
            } else if (data.online == data.total) {
                data.ivrs = 0;
                data.offline = 0;
                data.tele = 0;
                data.web = 0;

            } else if ((data.online + data.ivrs + data.web + data.tele) == data.total) {
                data.offline = 0;
            }
        };

        vm.changeIvrs = function (data) {
            if (!data.total) {
                vm.calculateOnlineOffline(data);
            }
            //  if (data.total == data.offline) {
            //      data.offline = 0;
            //  }
            if (data.ivrs < data.total) {
                if (data.offline != 0) {
                    data.offline = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                } else {

                    if (data.online != 0) {
                        data.online = Math.floor((data.totalTime - (((data.offline + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else if (data.web != 0) {
                        data.web = Math.floor((data.totalTime - (((data.offline + data.online + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else if (data.tele != 0) {
                        data.tele = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient))) / (vm.settings.avg_time_per_patient_tele))
                    } else {
                        data.offline = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    }

                }
            } else if (data.ivrs == data.total) {
                data.online = 0;
                data.offline = 0;
                data.tele = 0;
                data.web = 0;
            } else if ((data.online + data.ivrs + data.web + data.tele) == data.total) {
                data.offline = 0;
            }
        };

        vm.changeWeb = function (data) {
            if (!data.total) {
                vm.calculateOnlineOffline(data);
            }
            // if (data.total == data.offline) {
            //     data.offline = 0;
            // }
            if (data.ivrs <= data.total) {
                if (data.offline != 0) {
                    data.offline = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                } else {

                    if (data.online != 0) {
                        data.online = Math.floor((data.totalTime - (((data.offline + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else if (data.ivrs != 0) {
                        data.ivrs = Math.floor((data.totalTime - (((data.offline + data.web + data.online) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else if (data.tele != 0) {
                        data.tele = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient))) / (vm.settings.avg_time_per_patient_tele))
                    } else {
                        data.offline = Math.floor((data.totalTime - (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    }

                }
            } else if (data.web == data.total) {
                data.online = 0;
                data.offline = 0;
                data.tele = 0;
                data.ivrs = 0;
            } else if ((data.online + data.ivrs + data.web + data.tele) == data.total) {
                data.offline = 0;
            }
        };

        vm.TimeSlotOverRideMessage = function (session) {
            return '<br>Please check the slot ' + session + ' selection, conflict with tele and in person';
        }
        vm.InPersonTimeMessage = function (bal, session) {
            return '<br>Please check the slot ' + session + ' selection, conflict with tele and in person';
        }
        vm.TeleTimeMessage = function (bal, session) {
            return '<br>Please check the slot ' + session + ' selection, conflict with tele and in person';
        }
        vm.InPersonandTeleTimeMessage = function (inPersonBal, inTeleBal, session) {
            return vm.InPersonTimeMessage(inPersonBal, session) + ' & ' + vm.TeleTimeMessage(inTeleBal, session);
        }
        vm.extraSlotMessage = function (session){
            return '<br>Dr, For the session time you can add one more slot either in Tele-consultation or in others.';
        }

        vm.checkAppointmentTimeValidationAsync = function (sessions) {

            var message = [];
            return $q(function (resolve, reject) {
                angular.forEach(sessions, function (data, index) {
                    var sessionTime = data.totalTime
                    var currentTotalSlotTime = ((vm.settings.avg_time_per_patient * (data.offline + data.online + data.ivrs + data.web)) + (vm.settings.avg_time_per_patient_tele * data.tele));
                    if(data.tele == undefined || data.online == undefined || data.web == undefined || data.ivrs == undefined || data.offline == undefined) {                      
                        message.push(vm.TimeSlotOverRideMessage(index+1));
                    } 
                    if(sessionTime != currentTotalSlotTime && sessionTime != undefined){
                        if((sessionTime-currentTotalSlotTime) >= vm.settings.avg_time_per_patient){
                            message.push(vm.extraSlotMessage(index+1));
                        }
                        if((sessionTime-currentTotalSlotTime) >= vm.settings.avg_time_per_patient_tele){
                            message.push(vm.extraSlotMessage(index+1));
                        }
                        
                    }
                    //else if (vm.totalSlotTime > currentTotalSlotTime) {
                    //     var balanceTime = vm.totalSlotTime - currentTotalSlotTime;
                    //     if(vm.settings.avg_time_per_patient > vm.settings.avg_time_per_patient_tele) {        
                    //         if(balanceTime >= vm.settings.avg_time_per_patient) {
                    //             message.push(vm.InPersonTimeMessage(balanceTime,index+1));
                    //             var remainingBalanceTime = (balanceTime % vm.settings.avg_time_per_patient);
                    //             if(remainingBalanceTime >= vm.settings.avg_time_per_patient){
                    //                 message.push(vm.InPersonandTeleTimeMessage(remainingBalanceTime,(balanceTime - remainingBalanceTime), index+1));
                    //             }
                    //         } else if(balanceTime >= vm.settings.avg_time_per_patient_tele){
                    //             message.push(vm.TeleTimeMessage(balanceTime, index+1));
                    //         }        
                    //     } else if(vm.settings.avg_time_per_patient < vm.settings.avg_time_per_patient_tele) {

                    //         if(balanceTime >= vm.settings.avg_time_per_patient_tele){
                    //             message.push(vm.TeleTimeMessage(balanceTime, index+1));
                    //             var remainingBalanceTime = (balanceTime % vm.settings.avg_time_per_patient_tele);
                    //             if(remainingBalanceTime >= vm.settings.avg_time_per_patient){
                    //                 message.push(vm.InPersonandTeleTimeMessage(remainingBalanceTime,(balanceTime - remainingBalanceTime), index+1));
                    //             }                             
                    //         } else if(balanceTime >= vm.settings.avg_time_per_patient) {
                    //             message.push(vm.InPersonTimeMessage(balanceTime,index+1));                              
                    //         }
                    //     }                
                    // }
                    if (sessions.length === (index + 1)) {
                        if (message.length == 0) {
                            resolve();
                        }
                        if (message.length > 0) {
                            reject(message);
                        }
                    }
                });
            });
        }

        vm.checkAppointmentTimeValidationAsync2 = function (sessions) {

            var message = [];
            return $q(function (resolve, reject) {
                angular.forEach(sessions, function (data, index) {
                    var currentTotalSlotTime = ((vm.settings.avg_time_per_patient * (data.offline + data.online + data.ivrs + data.web)) + (vm.settings.avg_time_per_patient_tele * data.tele));
                    var sessionTime = data.totalTime
                    if(sessionTime != currentTotalSlotTime && sessionTime != undefined){
                        if((sessionTime-currentTotalSlotTime) >= vm.settings.avg_time_per_patient){
                            toastr.error("Please check the slot selection")
                        }
                        if((sessionTime-currentTotalSlotTime) >= vm.settings.avg_time_per_patient_tele){
                            toastr.error("Please check the slot selection")
                        }
                        
                    }
                    if (sessions.length === (index + 1)) {
                        if (message.length == 0) {
                            resolve();
                        }
                        if (message.length > 0) {
                            reject(message);
                        }
                    }
                });
            });
        }

        vm.changeTele = function (data) {
            if (!data.total) {
                vm.calculateOnlineOffline(data);
            }
            // if (data.total == data.offline) {
            //     data.offline = 0;
            // }
            if (data.ivrs <= data.total) {
                if (data.offline != 0) {
                    // if (data.online + data.web + data.ivrs > 0) {
                    //     data.teleMax = Math.floor(((((data.online + data.ivrs + data.web + data.offline) * vm.settings.avg_time_per_patient) +  (data.tele*vm.settings.avg_time_per_patient_tele)) / vm.settings.avg_time_per_patient_tele))
                    // }
                    // console.log(data.teleMax)
                    
                    // if(vm.settings.avg_time_per_patient < vm.settings.avg_time_per_patient_tele){
                    //     data.offline = data.total - (data.online + data.ivrs + data.web + (data.tele)*(Math.ceil(vm.settings.avg_time_per_patient_tele/vm.settings.avg_time_per_patient)));
                    // } else if (vm.settings.avg_time_per_patient > vm.settings.avg_time_per_patient_tele){
                    //data.offline = data.total - (data.online + data.ivrs + data.web + (data.tele)*(Math.ceil(vm.settings.avg_time_per_patient/vm.settings.avg_time_per_patient_tele)));
                    // if(vm.settings.avg_time_per_patient%vm.settings.avg_time_per_patient_tele == 0){
                    //     data.offline = Math.ceil(data.total - (data.online + data.ivrs + data.web + (data.tele)*((vm.settings.avg_time_per_patient_tele/vm.settings.avg_time_per_patient))));

                    // } else {
                    //console.log("111")
                    //if((((data.online+data.web+data.ivrs)*(vm.settings.avg_time_per_patient))+(data.tele*vm.settings.avg_time_per_patient_tele))+(vm.settings.avg_time_per_patient_tele)<vm.totalHours){
                        if (data.offline * vm.settings.avg_time_per_patient < vm.settings.avg_time_per_patient_tele) {
                            data.offline = 0;
                            if (data.online != 0) {
                                data.online = Math.floor((data.totalTime - (((data.offline + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                            } else if (data.web != 0) {
                                //data.web = data.total - (data.ivrs+data.online+data.tele)
                                data.web = Math.floor((data.totalTime - (((data.offline + data.online + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                            } else if (data.ivrs != 0) {
                                //  data.ivrs = data.total - (data.web+data.online+data.tele)
                                data.ivrs = Math.floor((data.totalTime - (((data.offline + data.web + data.online) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                            }
                        }
                    
                        data.offline = Math.floor((data.totalTime - (((data.online + data.ivrs + data.web) * vm.settings.avg_time_per_patient) + (data.tele) * (vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                        //data.teleMax = ((data.online+data.web+data.ivrs+data.offline)*vm.settings.avg_time_per_patient)/vm.settings.avg_time_per_patient_tele
                        //data.teleMax = (Math.floor(vm.totalHours/vm.settings.avg_time_per_patient_tele))-(vm.totalHours - (((data.online+data.web+data.ivrs+data.offline)*vm.settings.avg_time_per_patient)+(data.tele*vm.settings.avg_time_per_patient_tele)))
                        console.log(data.totalTime)
                     

                    // }
                    //    if(vm.settings.avg_time_per_patient>vm.settings.avg_time_per_patient_tele){
                    //         if(vm.settings.avg_time_per_patient%vm.settings.avg_time_per_patient_tele != 0){
                    //             data.teleMax = (Math.floor(vm.totalHours/vm.settings.avg_time_per_patient_tele))-(vm.totalHours - (((data.online+data.web+data.ivrs+data.offline)*vm.settings.avg_time_per_patient)+(data.tele*vm.settings.avg_time_per_patient_tele)))
                    //         }
                    //         if(vm.settings.avg_time_per_patient%vm.settings.avg_time_per_patient_tele == 0){
                    //             data.teleMax = Math.floor(vm.totalHours/vm.settings.avg_time_per_patient_tele);
                    //         }
                    //        } else if (vm.settings.avg_time_per_patient<vm.settings.avg_time_per_patient_tele){
                    //             if(vm.settings.avg_time_per_patient%vm.settings.avg_time_per_patient_tele != 0){
                    //             data.teleMax = (Math.floor(vm.totalHours/vm.settings.avg_time_per_patient_tele))-(vm.totalHours - (((data.online+data.web+data.ivrs+data.offline)*vm.settings.avg_time_per_patient)+(data.tele*vm.settings.avg_time_per_patient_tele)))
                    //         }
                    //         if(vm.settings.avg_time_per_patient%vm.settings.avg_time_per_patient_tele == 0){
                    //             data.teleMax = Math.floor(vm.totalHours/vm.settings.avg_time_per_patient_tele);
                    //         }
                    //        }
                    //data.onlineMax = data.offline
                    //}
                    //  }
                } else {
                    if (((data.online * vm.settings.avg_time_per_patient) < vm.settings.avg_time_per_patient_tele) && ((data.web * vm.settings.avg_time_per_patient) < vm.settings.avg_time_per_patient_tele) && ((data.ivrs * vm.settings.avg_time_per_patient) < vm.settings.avg_time_per_patient_tele) && (((data.online + data.web + data.ivrs) * vm.settings.avg_time_per_patient) >= vm.settings.avg_time_per_patient_tele)) {
                        data.online = 0;
                        data.ivrs = 0;
                        data.web = 0;
                    }
                    if (data.online * vm.settings.avg_time_per_patient < vm.settings.avg_time_per_patient_tele) {
                        data.online = 0;
                    }
                    if (data.web * vm.settings.avg_time_per_patient < vm.settings.avg_time_per_patient_tele) {
                        data.web = 0;
                    }
                    if (data.ivrs * vm.settings.avg_time_per_patient < vm.settings.avg_time_per_patient_tele) {
                        data.ivrs = 0;
                    }
                    if (data.online != 0) {

                        data.online = Math.floor((data.totalTime - (((data.offline + data.web + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else if (data.web != 0) {
                        //data.web = data.total - (data.ivrs+data.online+data.tele)
                        data.web = Math.floor((data.totalTime - (((data.offline + data.online + data.ivrs) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else if (data.ivrs != 0) {
                        //  data.ivrs = data.total - (data.web+data.online+data.tele)
                        data.ivrs = Math.floor((data.totalTime - (((data.offline + data.web + data.online) * vm.settings.avg_time_per_patient) + (data.tele * vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                    } else {
                        data.offline = Math.floor((data.totalTime - (data.online + data.ivrs + data.web + (data.tele) * (vm.settings.avg_time_per_patient_tele))) / (vm.settings.avg_time_per_patient))
                        console.log(data.total)
                        //data.onlineMax = data.offline
                    }
                }
            } else if (data.tele == data.total) {
                data.online = 0;
                data.offline = 0;
                data.ivrs = 0;
                data.web = 0;
            } else if ((data.online + data.ivrs + data.web + data.tele) == data.total) {
                data.offline = 0;
            }
        };

        vm.ruleValidationConsent = function (message, title) {

            var options = {
                message: "",
                templateUrl: 'app/apt-config/alertmessage.html',
                title: '<h5  style="color:white">Reconfigure Appointent schedule?</h5>' ,
                buttons: {
                    success: {
                        label: "Ok",
                        className: "btn-success",
                        callback: function () {
                            vm.reconfig = true;
                            WizardHandler.wizard().next();
                        }
                    }
                }
            };
            $ngBootbox.customDialog(options); 
        }
        vm.reconfigConsent = function () {
            var options = {
                message: 'By clicking on configure you are accepting to overwrite your existing appointment configurations. Are you sure to confirm?',
                title: 'Reconfigure Appointment schedule?',
                buttons: {
                    warning: {
                        label: "Cancel",
                        className: "btn-warning"
                    },
                    success: {
                        label: "Ok",
                        className: "btn-success",
                        callback: function () {
                            vm.bottomnote = true;
                            vm.reconfig = true;
                            sessionStorage.popup = "off"
                            WizardHandler.wizard().next();
                        }
                    }
                }
            };
            $ngBootbox.customDialog(options);
        };

        var aptpop = sessionStorage.getItem("popup")
        if(aptpop == "on"){
            vm.reconfigConsent();
        }
        vm.hasReconfigConsent = function () {
            return vm.reconfig;
        };

        /*Init...*/
        var days = { "sun": false, "mon": false, "tue": false, "wed": false, "thu": false, "fri": false, "sat": false };

        vm.hrs = BudsStore.store.hrs;
        vm.avgTime = [];

        for (var i = 1; i <= 60; i++) {
            vm.avgTime.push(i);
        }

        vm.dateOptions = {
            maxDate: new Date(2020, 5, 22),
            minDate: new Date(),
            startingDay: 1
        };

        vm.aptTill = {
            opened: false
        };

        vm.aptSettings = { last_date: '', last_appointment: '' };
        // SettingsService.getSettings().then(function(response) {
        //       vm.settings = response;

        //       /*Default apt_type to token*/
        //       vm.settings.appointment_system="token";

        // });

        SettingsService.getLastAppConfigDate().then(function (response) {
            vm.aptSettings.last_date = response.last_date;
            vm.aptSettings.last_appointment = response.last_appointment;
        });
        vm.getSchedule();
        vm.reconfig = false;
    }
    /*Setup the Module*/
    angular.module("RxC.pages.AptConfig", ['buds.store'])
        .config(routeConfig)
        .service("AptConfigService", AptConfigService)
        .controller("AptConfigCtrl", AptConfigCtrl);

})();
/**
 * @author Helyxon
 * created on April 2017
 */
(function() {
    'use strict';

    /** @ngInject */
    function BabyProfileService($http, $q, BudsStore, RxCUtils, serviceBaseUrl, authService) {
        var self = {};

        self.updateProfile = function(payload) {
            var deferred = $q.defer();
            payload.account_email = authService.authentication.account_id;

            $http.post(serviceBaseUrl + 'demographicsupdate', payload)
                .success(function(response) {
                    deferred.resolve(response);
                })
                .error(function(error, status) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };

        /*Generic method toupdate baby history*/
        self.manageHistory = function(ep, payload) {
            var deferred = $q.defer();
            payload.account_email = authService.authentication.account_id;
            payload.user_type = "doctor";
            $http.post(serviceBaseUrl + ep, payload)
                .success(function(response) {
                    deferred.resolve(response);
                })
                .error(function(error, status) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };

        return self;
    } /*End BabyProfileService*/

    /** @ngInject */
    function BabyProfileCtrl(BabyProfileService, RxCUtils, BudsStore, recordService, $route, toastr, $filter, $rootScope, multipartFormdata, authService) {
        var vm = this;
        
        authService.loadHelyxonApiUrl();
        vm.helyxonApiUrl = authService.helyxonApi.url;

        vm.dateOptions = {
            minDate: new Date(),
            startingDay: 1
        };
        vm.mode_basic = 'view';
        vm.mode_birth = 'view';
        vm.mode_sibHis = 'view';
        vm.clearForm = function(pageType) {
            if (pageType === 'basic') {
                vm.basic = angular.copy(vm.o_basic);
            } else if (pageType === 'soc_history') {
                vm.social_history = angular.copy(vm.o_social_history);
            } else if (pageType == 'antenatal') {
                vm.antenatal = angular.copy(vm.o_antenatal);
            } else if (pageType == 'atbirth') {
                vm.birth_history = angular.copy(vm.o_birth_history);
            } else if (pageType == 'newborn') {
                vm.new_born_history = angular.copy(vm.o_new_born_history);
            } else if (pageType == 'hosp') {
                vm.hospitalizations = angular.copy(vm.o_hospitalizations);
            } else if (pageType == 'opvist') {
                vm.opvists = angular.copy(vm.o_opvists);
            } else if (pageType == 'medpb') {
                vm.medical_problems = angular.copy(vm.o_medical_problems);
            } else if (pageType == 'parents') {
                vm.parents_history = angular.copy(vm.o_parents_history);
            } else if (pageType == 'sibling') {
                vm.sibling_history = angular.copy(vm.o_sibling_history);
            }
        };
        vm.childDatePicker = {
            maxDate: new Date(),
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
            dateOptions: {
                maxDate: new Date(),
                formatYear: 'yyyy',
                startingDay: 1
            }
        };
        var recordId = $route.current.params.Id;
        vm.bloodGroups = BudsStore.bloodGroups;
        var patient_email = "";

        /*load record info*/
        recordService.getRecordInfo(recordId)
            .then(function(recordInfoResponse) {
                var t = recordInfoResponse.demographics;
                patient_email = recordInfoResponse.record_info.Record.account_email; //"rx13@rxcarenet.org";
                var date3, date, date1;
                if (t) {
                    date = new Date(t.bday);
                    if (t.corrected_bday != null) {
                        date1 = new Date(t.corrected_bday);
                    }
                    //  date3 = $filter('date')(date, "yyyy-MM-dd");
                }

                if(t.birth_weight==null){
                    t.birth_weight=0;
                }
                if(t.birth_height==null){
                    t.birth_height=0;
                }

                vm.basic = {
                    "record_id": recordInfoResponse.record_info.Record.id, 
                    "mrNumber": t.mr_number,
                    "patientSince": t.patient_since,
                    "image":   recordInfoResponse.demographics.image,
                    "cover": recordInfoResponse.demographics.cover,
                    "image_id": recordInfoResponse.image_id,
                    "update_image": false,
                    "picme_baby": t.picme_baby,
                    "district_id": t.district_id,
                    "block_id": t.block_id,
                    "village_id": t.village_id,
                    "childInfo": {
                        "gender": t.gender,
                        "dob": date,
                        "dob1": date1,
                        "firstName": t.name_given,
                        "lastName": t.name_family,
                        "birthWeight": t.birth_weight,
                        "birthHeight": t.birth_height,
                        "bloodGroup": t.blood_group,
                        "uhid": t.uhid,
                    },
                    "fatherInfo": {
                        "firstName": t.father_name_given,
                        "lastName": t.father_name_family,
                        "phone": t.father_tel_number,
                        "email": t.father_email,
                        "dob": t.father_bday ? t.father_bday : ""
                    },
                    "motherInfo": { 
                        "firstName": t.mother_name_given, 
                        "lastName": t.mother_name_family,
                        "dob": t.mother_bday ? t.mother_bday : "", 
                        "phone": t.mother_tel_number ? t.mother_tel_number : "" },
                    "address": {
                        "country": t.adr_country,
                        "city": t.adr_city,
                        "postalcode": t.adr_postalcode,
                        "region": t.adr_region,
                        "street": t.adr_street,
                    },
                    "patient_email": patient_email,
                    "kce_id" : t.kce_id   
                };
                vm.o_basic = angular.copy(vm.basic);

                /*Load Mothers Antenatal*/
                vm.antenatal = { "patient_email": patient_email };
                BabyProfileService.manageHistory("doctorgetantenatal", vm.antenatal)
                    .then(function(r) {
                        vm.antenatal = r.antenatal;
                        vm.o_antenatal = angular.copy(vm.antenatal);
                    });

                /*Load At birth history*/
                vm.birth_history = { "patient_email": patient_email };
                BabyProfileService.manageHistory("getbirthhistory", vm.birth_history)
                    .then(function(r) {
                        vm.birth_history = r.birth_history;
                        vm.birth_history.patient_email = patient_email;
                       // vm.birth_history.birth_height = Number(r.birth_history.birth_height);
                        //  vm.birth_history.birth_weight = Number(r.birth_history.birth_weight);
                        //vm.birth_history.discharge_weight = Number(r.birth_history.discharge_weight);
                        //vm.birth_history.discharge_height = Number(r.birth_history.discharge_height);
                        //vm.birth_history.birth_head_circumference = Number(r.birth_history.birth_head_circumference);
                        //vm.birth_history.discharge_head_circumference = Number(r.birth_history.discharge_head_circumference);
                        vm.o_birth_history = angular.copy(vm.birth_history);
                    });

                /*Load new born history*/
                vm.new_born_history = { "patient_email": patient_email };
                BabyProfileService.manageHistory("getnewbornhistory", vm.new_born_history)
                    .then(function(r) {
                        vm.new_born_history = r.new_born_history;
                        vm.new_born_history.patient_email = patient_email;
                        vm.new_born_history.record_exist = true;
                        vm.o_new_born_history = angular.copy(vm.new_born_history);
                    });


                /*Load hospitalization history*/
                BabyProfileService.manageHistory("gethospitalization", { "patient_email": patient_email })
                    .then(function(r) {
                        if (r.hospitalizations.length === 0) {
                            vm.hospitalizations = [];
                            vm.hospitalizations.push({});
                        } else {
                            vm.hospitalizations = r.hospitalizations;
                            angular.forEach(vm.hospitalizations, function(item) {
                                item.admitted_on = new Date(item.admitted_on);
                            });
                        }
                        vm.o_hospitalizations = angular.copy(vm.hospitalizations);
                    });

                /*Load op visits history*/
                vm.op_visit = { "patient_email": patient_email };
                BabyProfileService.manageHistory("getopvisits", vm.op_visit)
                    .then(function(r) {
                        if (r.op_visits.length === 0) {
                            vm.opvists = [];
                            vm.opvists.push({});
                        } else {
                            vm.opvists = r.op_visits;
                            angular.forEach(vm.opvists, function(item) {
                                item.date = new Date(item.date);
                            });
                        }
                        vm.o_opvists = angular.copy(vm.opvists);
                    });

                /*reset the form*/
                vm.removeItem = function(index, type) {
                    if (type == "opvisit") {
                        if (vm.opvists.length > 1) {
                            vm.opvists.splice(index, 1);
                        } else {
                            vm.opvists = [];
                            vm.opvists.push({});
                        }
                    } else if (type == "hosp") {
                        if (vm.hospitalizations.length > 1) {
                            vm.hospitalizations.splice(index, 1);
                        } else {
                            vm.hospitalizations = [];
                            vm.hospitalizations.push({});
                        }
                    } else if (type == "medical_problems") {
                        if (vm.medical_problems.length > 1) {
                            vm.medical_problems.splice(index, 1);
                        } else {
                            vm.medical_problems = [];
                            vm.medical_problems.push({});
                        }
                    }
                };

                /*Load med problem history*/
                vm.medical_problem = { "patient_email": patient_email };
                BabyProfileService.manageHistory("getmedicalproblems", vm.medical_problem)
                    .then(function(r) {
                        //vm.medical_problem.record_exist = true;
                        if (r.medical_problems.length === 0) {
                            vm.medical_problems = [];
                            vm.medical_problems.push({});
                        } else {
                            vm.medical_problems = r.medical_problems;
                            angular.forEach(vm.medical_problems, function(item) {
                                item.date = new Date(item.date);
                            });
                        }
                        vm.o_medical_problems = angular.copy(vm.medical_problems);
                    });

                /*Load family history - parents*/
                vm.parent_history = { "patient_email": patient_email };
    
                BabyProfileService.manageHistory("getparentshistory", vm.parent_history)
                    .then(function(r) {
                        vm.parents_history = r.parents_history;
                        if (r.parents_history.length === 0) {
                            vm.parents_history = [];
                            vm.parents_history.push({ "relation": "father" });
                            vm.parents_history.push({ "relation": "mother" });
                        } else if (r.parents_history.length === 1 && vm.parents_history[0].relation === "mother") {
                            vm.parents_history.push({ "relation": "father" });
                        } else if (r.parents_history.length === 1 && vm.parents_history[0].relation === "father") {
                            vm.parents_history.push({ "relation": "mother" });
                        }
                       if (vm.parents_history.length > 1) {
                            angular.forEach(vm.parents_history, function(item) {
                                if (item.dob != null) {
                                   item.dob = new Date(item.dob);                            }
                            });
                        }
                      //  getRecordInfo();
                        vm.o_parents_history = angular.copy(vm.parents_history);
                    });

                /*Load family history - sibling*/
                vm.sibling_history = { "patient_email": patient_email };
                BabyProfileService.manageHistory("getsiblinghistory", vm.sibling_history)
                    .then(function(r) {
                        if (r.sibling_history.length === 0) {
                            vm.sibling_history = [];
                            vm.sibling_history.push({});
                        } else {
                            vm.sibling_history = r.sibling_history;
                            angular.forEach(vm.sibling_history, function(item) {
                                if (item.dob != null) {
                                    item.dob = new Date(item.dob);
                                }
                            });
                        }
                        vm.o_sibling_history = angular.copy(vm.sibling_history);

                    });

                /*Load Social history*/
                vm.social_history = { "patient_email": patient_email };
                BabyProfileService.manageHistory("getsocialhistory", vm.social_history)
                    .then(function(r) {
                        if (r.social_history) {
                            vm.social_history = r.social_history;
                        } else {
                            vm.social_history = {};
                        }
                        vm.social_history.patient_email = patient_email;
                        vm.o_social_history = angular.copy(vm.social_history);
                    });
            });
            
        vm.updateProfile = function() {
            if(!vm.basic.fatherInfo.phone){
                toastr.error('Phone number is mandatory');
                vm.mode_basic = 'edit';
                return;
            }
            if(vm.basic.fatherInfo.dob || vm.basic.motherInfo.dob){
                if(vm.basic.childInfo.dob < vm.basic.fatherInfo.dob || vm.basic.childInfo.dob < vm.basic.motherInfo.dob){
                    toastr.error('Parents DOB is not valid one...');
                    vm.mode_basic = 'edit';
                    return;
                }
            }
            var payload = angular.copy(vm.basic);
            payload.childInfo.dob = payload.childInfo.dob.toISOString().substr(0, 10);
            if (payload.childInfo.dob1 != null) {
                payload.childInfo.dob1 = payload.childInfo.dob1.toISOString().substr(0, 10);
            }
            BabyProfileService.updateProfile(payload).then(function(response) {
                vm.o_basic = angular.copy(vm.basic);
                vm.mode_basic = 'view';
                vm.loadRecord();
            });
        };
        
        var recordId = $route.current.params.Id;
        vm.loadRecord = function() {
            recordService.getRecordInfo(recordId).then(function(recordInfoResponse) {
                $rootScope.updatedDemo = {
                    name: recordInfoResponse.record_info.Record.label,
                    dob: new Date(recordInfoResponse.demographics.bday),
                    dob1: new Date(recordInfoResponse.demographics.corrected_bday),
                    gender: recordInfoResponse.demographics.gender,
                    mr_number: recordInfoResponse.demographics.mr_number,
                    image: recordInfoResponse.demographics.image,
                    mobile: recordInfoResponse.demographics.father_tel_number,
                    birth_weight: recordInfoResponse.demographics.birth_weight,
                    birth_height: recordInfoResponse.demographics.birth_height 
                };
                if($rootScope.updatedDemo.birth_weight==null){
                    $rootScope.updatedDemo.birth_weight = 0;
                }
                if($rootScope.updatedDemo.birth_height){
                    $rootScope.updatedDemo.birth_height = 0;
                }
            })
        };

        vm.updateAntenatal = function() {
            /*The APIs need booleans to be converted to strings*/
            var m = vm.antenatal;
            var p = {
                "patient_email": patient_email,
                "check_up": m.check_up ? m.check_up : "",
                "delivery": m.delivery ? m.delivery : "",
                "diabetes": m.diabetes ? (m.diabetes == "true" ? m.diabetes : "false") : "",
                "hypo_thyroidism": m.hypo_thyroidism ? (m.hypo_thyroidism == "true" ? m.hypo_thyroidism : "false") : "",
                "fits": m.fits ? (m.fits == "true" ? m.fits : "false") : "",
                "urinary_infection": m.urinary_infection ? (m.urinary_infection == "true" ? m.urinary_infection : "false") : ""
            };
            /*p.id = undefined;*/
            var ep = "doctorcreateantenatal";
            if (m.id) {
                ep = "doctorupdateantenatal";
            }
            // if(p.check_up == "")
            //   {
            //     toastr.error("Please enter all mandatory fields");
            //     return 
            //   }

            BabyProfileService.manageHistory(ep, { antenatal: p })
                .then(function(r) {
                        toastr.success("Mother antenatal History Saved.");
                        vm.antenatal = { "patient_email": patient_email };
                BabyProfileService.manageHistory("doctorgetantenatal", vm.antenatal)
                    .then(function(r) {
                        vm.antenatal = r.antenatal;
                        vm.o_antenatal = angular.copy(vm.antenatal);
                    });
                    },
                    function(r) {
                        toastr.error(r.error);
                    });
        };

        vm.changeMode = function() {
          vm.mode_birth = 'edit';
        }

        vm.updateBabyHistoryAtBirth = function() {
            /*The APIs need booleans to be converted to strings*/

            vm.birth_history.delivery = vm.birth_history.delivery ? vm.birth_history.delivery : "";
            vm.birth_history.feeding = vm.birth_history.feeding ? vm.birth_history.feeding : "";
            
            if (vm.birth_history.delivery == "" || vm.birth_history.feeding == "") {
                toastr.error("Please enter all mandatory fields");
                return vm.mode_birth = 'edit';
            }
            var m = angular.copy(vm.birth_history);
            var m = vm.birth_history;
            m.discharge_duration = m.discharge_duration ? m.discharge_duration : "";
            m.birth_height = m.birth_height != null ? m.birth_height.toString() : "";
            //  m.birth_weight = m.birth_weight!=null ? m.birth_weight.toString():'';
            m.discharge_weight = m.discharge_weight != null ? m.discharge_weight.toString() : "";
            m.discharge_height = m.discharge_height != null ? m.discharge_height.toString() : "";
            m.birth_head_circumference = m.birth_head_circumference != null ? m.birth_head_circumference.toString() : "";
            m.discharge_head_circumference = m.discharge_head_circumference != null ? m.discharge_head_circumference.toString() : '';
            m.score = m.score != null ? m.score.toString() : "";
            m.patient_email = patient_email;
          //  m.id=p.id;
          if(m.score==null || m.score=="")
          {
              m.score=="";
          }
         
          if(m.discharge_head_circumference=="NaN"){
            m.discharge_head_circumference="";
          }
            var ep = "addbirthhistory";
            if (vm.birth_history.id) {
                ep = "updatebirthhistory";
            }
            vm.mode_birth = 'view';

            BabyProfileService.manageHistory(ep, { birth_history: m })
                .then(function(r) {
                        vm.mode_birth = 'view';
                        toastr.success("Baby at birth history saved.");
                        vm.birth_history = { "patient_email": patient_email };
                        BabyProfileService.manageHistory("getbirthhistory", vm.birth_history).then(function(r) {
                            vm.birth_history = r.birth_history;
                            vm.birth_history.patient_email = patient_email;
                            vm.o_birth_history = angular.copy(vm.birth_history);
                        });
                    },
                    function(r) {
                        toastr.error(r.error);
                        vm.mode_birth = 'edit';
                    });
        };

        vm.updateBabyHistoryNewBorn = function() {
            vm.new_born_history.id= vm.new_born_history.id?vm.new_born_history.id:vm.new_born_history.id;
           // vm.new_born_history.record_exist=vm.new_born_history.record_exist=true?true:false;
            vm.new_born_history.admitted = vm.new_born_history.admitted ? vm.new_born_history.admitted : "";
            vm.new_born_history.admitted_reason = vm.new_born_history.admitted_reason ? vm.new_born_history.admitted_reason : "";
            vm.new_born_history.breadth_difficulty = vm.new_born_history.breadth_difficulty ? vm.new_born_history.breadth_difficulty : "";
            vm.new_born_history.breadth_difficulty_text=vm.new_born_history.breadth_difficulty_text?vm.new_born_history.breadth_difficulty_text:"";
            vm.new_born_history.eye = vm.new_born_history.eye ? vm.new_born_history.eye : "";
            vm.new_born_history.femorals = vm.new_born_history.femorals ? vm.new_born_history.femorals : "";
            vm.new_born_history.fits = vm.new_born_history.fits ? vm.new_born_history.fits : "";
            vm.new_born_history.fits_text=vm.new_born_history.fits_text?vm.new_born_history.fits_text:"";
            vm.new_born_history.hearing = vm.new_born_history.hearing ? vm.new_born_history.hearing : "";
            vm.new_born_history.heart_problems = vm.new_born_history.heart_problems ? vm.new_born_history.heart_problems : "";
            vm.new_born_history.heart_problems_text=vm.new_born_history.heart_problems_text?vm.new_born_history.heart_problems_text:"";
            vm.new_born_history.hip_examination = vm.new_born_history.hip_examination ? vm.new_born_history.hip_examination : "";
            vm.new_born_history.infection = vm.new_born_history.infection ? vm.new_born_history.infection : "";
            vm.new_born_history.infection_text=vm.new_born_history.infection_text?vm.new_born_history.infection_text:"";
            vm.new_born_history.jaundice = vm.new_born_history.jaundice ? vm.new_born_history.jaundice : "";
            vm.new_born_history.jaundice_level= vm.new_born_history.jaundice_level?vm.new_born_history.jaundice_level:"0";
            vm.new_born_history.other_problem = vm.new_born_history.other_problem ? vm.new_born_history.other_problem : "";
            vm.new_born_history.other_problem_text=vm.new_born_history.other_problem_text?vm.new_born_history.other_problem_text:"";
            vm.new_born_history.other_screening = vm.new_born_history.other_screening ? vm.new_born_history.other_screening : "";
            vm.new_born_history.physical_findings = vm.new_born_history.physical_findings ? vm.new_born_history.physical_findings : "";
            vm.new_born_history.pulse_screening = vm.new_born_history.pulse_screening ? vm.new_born_history.pulse_screening : "";
            vm.new_born_history.sugar = vm.new_born_history.sugar ? vm.new_born_history.sugar : "";
            vm.new_born_history.sugar_level=vm.new_born_history.sugar_level?vm.new_born_history.sugar_level:"0";
           
            vm.new_born_history.testicles_descended=vm.new_born_history.testicles_descended?vm.new_born_history.testicles_descended:"";
           
            vm.new_born_history.thyroid_screening = vm.new_born_history.thyroid_screening ? vm.new_born_history.thyroid_screening : "";
          //"id"=m.id;
          //vm.new_born_history.user_type="doctor";
           
            var m = angular.copy(vm.new_born_history);
            vm.new_born_history.patient_email = patient_email;
            var ep = "addnewbornhistory";
            if (vm.new_born_history.id) {
                ep = "updatenewbornhistory";
            }

            BabyProfileService.manageHistory(ep, { new_born_history: m })
                .then(function(r) {
                        toastr.success("Baby new born history saved.");
                        vm.new_born_history = { "patient_email": patient_email };
                        BabyProfileService.manageHistory("getnewbornhistory", vm.new_born_history).then(function(r) {
                            vm.new_born_history = r.new_born_history;
                            vm.new_born_history.patient_email = patient_email;
                            vm.new_born_history.record_exist = true;
                            vm.o_new_born_history = angular.copy(vm.new_born_history);
                        });
                    },
                    function(r) {
                        toastr.error("Failed to save baby new born history.");
                    });
        };

        vm.updateMedHospitalizationHistory = function(item) {
            var ep = "addhospitalization";
            if (item.id) {
                ep = "updatehospitalization";
            }

            var p = angular.copy(item);
            p.patient_email = patient_email;
            p.admitted_on = RxCUtils.toRxDate(item.admitted_on);

            BabyProfileService.manageHistory(ep, { "hospitalization": p })
                .then(function(r) {
                        toastr.success("Hospitalisation Medical History Saved.");
                    },
                    function(r) {
                        toastr.error("Failed to save Hospitalisation Medical history.");
                    });
        };

        vm.updateMedOPHistory = function(item) {
            var ep = "addopvisit";
            if (item.id) {
                ep = "updateopvisit";
            }

            var p = angular.copy(item);
            p.patient_email = patient_email;
            p.date = RxCUtils.toRxDate(item.date);

            BabyProfileService.manageHistory(ep, { "op_visit": p })
                .then(function(r) {
                        toastr.success("OP Visit Medical History Saved.");
                    },
                    function(r) {
                        toastr.error("Failed to save OP Visit Medical history.");
                    });
        };

        vm.updateMedProblemHistory = function(item) {
            var ep = "addmedicalproblem";
            if (item.id) {
                ep = "updatemedicalproblems";
            }

            var p = angular.copy(item);
            p.patient_email = patient_email;
            p.date = RxCUtils.toRxDate(item.date);

            BabyProfileService.manageHistory(ep, { "medical_problem": p })
                .then(function(r) {
                        toastr.success("Medical Problems History Saved.");
                    },
                    function(r) {
                        toastr.error("Failed to save Medical Problems history.");
                    });
        };

        vm.updateParentsHistory = function(p) {
            vm.parent_history = { "patient_email": patient_email };
            
            var parent = angular.copy(p);
            var ep = "addparenthistory";
            if (parent.id) {
                ep = "updateparenthistory";
            }
            parent.patient_email = patient_email;
            parent.dob = RxCUtils.toLocalDateOnly(parent.dob);
            if(isNaN(parent.dob)){
                parent.dob=null;
            }
            // parent.medication = p.medication ? (p.medication === "True" ? true : false) : "",
            // parent.hospitalization = p.hospitalization ? (p.hospitalization === "True" ? true : false) : "";
               
            BabyProfileService.manageHistory(ep, { "parent_history": parent })
                .then(function(r) {
                        toastr.success("Parents History Saved.");
                        vm.parent_history = { "patient_email": patient_email };
                        BabyProfileService.manageHistory("getparentshistory", vm.parent_history).then(function(r) {
                            vm.parents_history = r.parents_history;
                            if (r.parents_history.length === 0) {
                                vm.parents_history = [];
                                vm.parents_history.push({ "relation": "father" });
                                vm.parents_history.push({ "relation": "mother" });
                            } else if (r.parents_history.length === 1 && vm.parents_history[0].relation === "mother") {
                                vm.parents_history.push({ "relation": "father" });
                            } else if (r.parents_history.length === 1 && vm.parents_history[0].relation === "father") {
                                vm.parents_history.push({ "relation": "mother" });
                            }
                            if (vm.parents_history.length > 1) {
                                angular.forEach(vm.parents_history, function(item) {
                                    if (item.dob != null) {
                                        item.dob = new Date(item.dob);
                                    }
                                });
                            }
                            //  getRecordInfo();
                            vm.o_parents_history = angular.copy(vm.parents_history);
                        });
                    },
                    function(r) {
                        toastr.error(r.error);
                    });
                    //updateParentsHistory();     
        };

        vm.required = function() {
            var empt = document.myForm.value;
        //var empt=angular.element(getElementsByClassName("form-control"));
            if(empt=="") {
                confirm("Please Enter All the Fields");
            return false;
            } else {
                confirm('Datas Added Successfully');
            return true; 
            }
        };

        vm.updateSiblingHistory = function(item) {

            var p = angular.copy(item);
            
            p.dob = item.dob ? RxCUtils.toLocalDateOnly(item.dob) : null;
            p.patient_email = patient_email;
            
            if (!p.first_name || !p.last_name) {
                toastr.error("First & Last name are mandatory fields");
                vm.mode_sibHis = 'edit';
                return;
            }

            var ep = "addsiblinghistory";
            if (item.id) {
                ep = "updatesiblinghistory";
            }

           p.medication = p.medication ? (p.medication === "True" ? true : false) : "",
           p.hospitalization = p.hospitalization ? (p.hospitalization === "True" ? true : false) : "";
            if (!p.medication_text) {
                p.medication_text = "";
            }
            if (!p.hospitalization_text) {
                p.hospitalization_text = "";
            }
            vm.buttonClicked = true;

            BabyProfileService.manageHistory(ep, { "sibling_history": p }).then(function(r) {
                vm.mode_sibHis = 'view';
                toastr.success("Siblings History Saved.");
                vm.sibling_history = { "patient_email": patient_email };
                BabyProfileService.manageHistory("getsiblinghistory", vm.sibling_history).then(function(r) {
                    if (r.sibling_history.length === 0) {
                        vm.sibling_history = [];
                        vm.sibling_history.push({});
                    } else {
                        vm.sibling_history = r.sibling_history;
                        angular.forEach(vm.sibling_history, function(item) {
                            if (item.dob != null) {
                                item.dob = new Date(item.dob);
                            }
                        });
                    }
                    vm.o_sibling_history = angular.copy(vm.sibling_history);

                });
            },
            function(r) {
                toastr.error(r.error);
            });
        };

        vm.updateSocialHistory = function(p) {
            vm.social_history.patient_email = patient_email;
            var p =angular.copy(vm.social_history);
            var m = vm.social_history;
           // p.id=;
            var p = {
            //p.id=m.id,
                "id":m.id,
                "patient_email": patient_email,
                "house_type": m.house_type ? m.house_type : "",
                "number_of_people": m.number_of_people ? m.number_of_people : null,
                "number_of_rooms": m.number_of_rooms ? m.number_of_rooms : null,
                "smokers": m.smokers ? m.smokers : "",
                "stove_type": m.stove_type ? m.stove_type : "",
                "distance": m.distance ? m.distance : "",
                "distance_units": m.distance_units ? m.distance_units : "",
                "transportation": m.transportation ? m.transportation : "",
                "problem_coming_to_hospital": m.problem_coming_to_hospital ? m.problem_coming_to_hospital : "",
                "house_on_main_road": m.house_on_main_road ? m.house_on_main_road : "",
                "drinking_water_available": m.drinking_water_available ? m.drinking_water_available : "",
                "toilet_available": m.toilet_available ? m.toilet_available : "",
                "pollution": m.pollution ? m.pollution : "",
                "user_type": "doctor"
            };
            var ep = "addsocialhistory";
            if ( m.id) {
                ep = "updatesocialhistory";
            }                 

            //var p =angular.copy(vm.social_history);
            //m.id=p.id;
            //p.drinking_water_available = (p.drinking_water_available==="true"||p.drinking_water_available===true?"true":"false");
            //p.house_on_main_road = (p.house_on_main_road==="true"||p.house_on_main_road===true?"true":"false");
            //p.toilet_available = (p.toilet_available==="true"||p.toilet_available===true?"true":"false");
            BabyProfileService.manageHistory(ep, { "social_history": p })
                .then(function(r) {
                        toastr.success("Social History Saved.");
                        vm.social_history = r;
                        vm.social_history.patient_email = patient_email;
                        vm.o_social_history = angular.copy(vm.social_history);
                    },
                    function(r) {
                        toastr.error(r.error);
                    });

        };

    /*  vm.uploadFile = function(file, event, flow) {
            if({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {
              //var data = new FormData();
              //data.append('file', file.file);
                vm.uploadPatientImage = file.file; 
                    
                var reader = new FileReader();
                reader.onload = function(e) {
                    vm.basic.image = reader.result;
                    vm.basic.update_image = true;

                    multipartFormdata.uploadFileToUrl(vm.helyxonApiUrl, vm.uploadPatientImage).then(function(response){
                        vm.mode_basic = 'view';  
                      //vm.basic.image = response.image[0].filename;
                    }); 
                };
               reader.readAsDataURL(file.file);
            } else {
                alert("Upload only Images");
             return false;
            }
            flow.file = [];
        };*/

        vm.uploadFile = function(file, event, flow) {
            if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {
                var data = new FormData();
                data.append('file', file.file);
                vm.uploadPatientImage = file.file;    
                var reader = new FileReader();
                reader.onload = function(e) {
                 vm.basic.image = reader.result;
                    vm.basic.update_image = true;
                    multipartFormdata.uploadFileToUrl(vm.helyxonApiUrl, vm.uploadPatientImage).then(function(response){
                        vm.basic.image=response.image[0].filename;
                    })
               };
               reader.readAsDataURL(file.file);
            }else {
                alert("Upload only Images");
                return false;
            }
            flow.file = [];
        };


    } /*End BabyProfileCtrl*/
    

    /*Setup the Module*/
    angular.module("RxC.pages.BabyProfile", ['buds.store'])
        .service("BabyProfileService", BabyProfileService)
        .controller("BabyProfileCtrl", BabyProfileCtrl);

})();
/**
 * @author Helyxon
 * created on Dec 2016
 */
(function () {
  'use strict';

  /** @ngInject */
  function routeConfig($routeProvider) {
    $routeProvider
    .when("/patient-list", {
     templateUrl: 'app/patient/patient-list.tpl.html',
     controllerAs:"patients",
     controller:"PatientListCtrl"
    })
    .when("/init-patient/:Id?", {
			controller: "InitPatientCtrl",controllerAs:"patient",
			templateUrl: "app/patient/init.tpl.html"
		})
    .when("/dig-patient/:Id?", {
      controller: "PatientDigCtrl",controllerAs:"dig",
      templateUrl: "app/patient/dig.tpl.html"
    });
  }

  /** @ngInject */
  function PatientService($http, $q, serviceBaseUrl, authService){
    var self = {};

    self.SaveVitals = function (payload) {
      return $http.post( serviceBaseUrl + "document",payload).then(
          function success(response) {
              console.log("Sucess...Call Service to save vitals",payload);
          },
          function failure(reason) {
              console.log("Fail...Call Service to save vitals",payload);
          });
    };

    self.saveDiagnosis = function (payload) {
        return $http.post( serviceBaseUrl + "savediagnosis",payload).then(
            function success(response) {
                console.log("Sucess...Call Service to save savediagnosis",payload);
            },
            function failure(reason) {
                console.log("Fail...Call Service to save savediagnosis",payload);
            });
      };

      self.getPatientsCount = function(){
        var deferred = $q.defer();
    		$http.get(serviceBaseUrl+"patientcount?account_email=" + authService.authentication.account_id)
        .success(function (response) {
    			deferred.resolve(response);
    		})
        .error(function (error, status) {
    			deferred.reject(error);
    		});
    		return deferred.promise;
      };

      // self.saveOverview = function (payload) {
      //     return $http.post( serviceBaseUrl + "overview",payload).then(
      //         function success(response) {
      //             console.log("Sucess...Call Service to save saveOverview",payload);
      //         },
      //         function failure(reason) {
      //             console.log("Fail...Call Service to save saveOverview",payload);
      //         });
      //   };

        // self.createTemplate = function (payload) {
        //     payload.account_email=authService.authentication.account_id;
        //     return $http.post( serviceBaseUrl + "adddoctortemplate",payload);
        //   };

        // self.searchTemplate = function (payload) {
        //     payload.account_email = authService.authentication.account_id;
        //     return $http.post( serviceBaseUrl + "searchdoctortemplate",payload);
        //   };

    return self;
  }

  /** @ngInject */
  function PatientListCtrl($rootScope,$location,toastr,subscribeService, PatientService, authService,$sessionStorage) {
    var vm = this;
    angular.element('#searchPatient').focus()
    vm.PatientList = [];
    $sessionStorage.put('patientDetail','{}');
    $sessionStorage.put('patientAccEmail','');
    $sessionStorage.put('appointment_id','');
    $sessionStorage.put('prescription_id','');
    $sessionStorage.put('consult', '');
    $sessionStorage.put('status', '');
    $sessionStorage.put('enableConsulation', '');
    vm.po = { totalPatients:0, size:20, curruntPage:1, maxSize:5};
    $rootScope.loadBanner();
    $rootScope.videoScreenShowing = false;
    vm.viewGrowthData = function(patient){
      $location.path('/init-patient/'+ patient.record_id);
    };
    vm.viewPatient = function(record){
      /*This rootscope should be removed asap, added to fix BAB-44 / 45*/
      $rootScope.pay = {
        cell_number:record.father_tel_number,
        acc_email:$rootScope.authentication.account_id,
        record_id:record.record_id,
        mr:record.mr_number
      };
      var patient_account_email =record.email;
      
      $sessionStorage.put('enableConsulation', 'false');
      $sessionStorage.put('patientDetail',JSON.stringify($rootScope.pay));
      $sessionStorage.put('patientAccEmail',patient_account_email);
      sessionStorage.setItem('patientid',record.record_id)
      $location.path('/patientview/' + record.record_id);
    };

    vm.view=false;
    vm.pageChanged = function() {
      vm.getPatients((vm.po.curruntPage*vm.po.size) - vm.po.size);
    };

    function toSmallLetters(val) {
      if(val!=null && val!="") {
        var stringVal = val;
        var str = stringVal.toLowerCase();   
        return str.charAt(0).toUpperCase() + str.slice(1);
      } else {
        return val;
      }
    }

  function _processPatient(item) {
    var dobMoment = moment();
        return {
            age: {
              years: parseInt(moment(item.bday).diff(dobMoment,'year',true)),
              months: parseInt(moment(item.bday).diff(dobMoment,'month',true)%12),
              days: parseInt(moment(item.bday).diff(dobMoment,'day',true)%365)
            },
          date: new Date(item.bday),
          bday: new Date(item.bday),
          registration_date: item.registration_date,
          mr_number: item.mr_number,
          name_given: item.name_given,
          father_name_given: item.father_name_given,
          mother_name_given: item.mother_name_given,
          father_tel_number: item.father_tel_number,
          mother_tel_number: item.mother_tel_number,
          email: item.email,
          gender: item.gender,
          record_id: item.record_id,
          uhid: item.uhid,
          village_name: toSmallLetters(item.villagename),
          panchayat_name: toSmallLetters(item.panchayatname),
          district_name: toSmallLetters(item.districtname),
          kce_id: item.kce_id,
          block_name: toSmallLetters(item.blockname),
          staff_name: toSmallLetters(item.staffname),
        };
  }

vm.subscribeList = function(data) {
  vm.subscribePatient_email = data.email;
        
  subscribeService.getSubscribeList().then(function(response) {
    vm.subscribeModel = response.result;
  },function(error) {
        toastr.error(error);
  });

};

vm.saveSubscribeData = function(data) {
    vm.subscribe_setting_id = data.id;
};

vm.subscriptionPayment = function() {

  var data = {
		"account_email": $rootScope.authentication.account_id,
    "patient_email": vm.subscribePatient_email,
    "type": 3,
    "doctor_id": authService.authentication.doctor_id,
    "subscription_setting_id": vm.subscribe_setting_id,
  }
 
  subscribeService.subscribePayment(data).then(function(response) {    
    toastr.success(response.message);
  },function(error) {
    toastr.error(error);
  });
          
}; 

var initTime;
var timeInterVar;
function clearCallback() {
  clearInterval(timeInterVar);
}

function callbackPatientList() {
  initTime = 0;
  timeInterVar = setInterval(function() {    
    vm.getPatients();
    initTime++;
    if(initTime==3) {
      clearCallback();
      alert('Server is busy. Try again later.');
    }      
  }, 3000);
}

PatientService.getPatientsCount()
  .then(function(response) {
    vm.po.totalPatients = response.patient_count;
});

var initPatientSearch = 0;
vm.getPatients = function(startAt) {
  if(startAt!=0) {
      if(startAt==undefined) {
        startAt = 0;
      }

      vm.view = true;
      vm.loaded = false;
      authService.getPatientSearchStart(startAt).then(function(response) {
        if(initTime>0){
          clearCallback();
        }
        var patientlistData = response.map(_processPatient);
        vm.PatientList = patientlistData;
        console.log(vm.PatientList);
        for( var i=0;i<vm.PatientList.length;i++){
          vm.patientListReg = vm.PatientList[i].registration_date
          vm.patientListRegSplit = vm.patientListReg.split('-')
          console.log(vm.patientListRegSplit);
          vm.patientListRegReverse = vm.patientListRegSplit.reverse()
          console.log(vm.patientListRegReverse);
          vm.patientListRegJoin = vm.patientListRegReverse.join('-')
          console.log(vm.patientListRegJoin);
          vm.PatientList[i].registration_date = vm.patientListRegJoin
          // vm.PatientList.push(vm.patientListRegJoin)
          // console.log(vm.PatientList);
          // vm.patientListRegDate = vm.PatientList[i].registration_date.length
          console.log(vm.patientListReg);
          // console.log(vm.patientListRegDate);
        }
        vm.loaded = true;
        vm.view = false;
        if(vm.po.totalPatients == 0){
          PatientService.getPatientsCount()
          .then(function(response) {
            vm.po.totalPatients = response.patient_count;
          });
        }
      },function (err, response) {
        vm.loaded = true;
      //toastr.error(err.error);
        vm.po.totalPatients = 0;
        initPatientSearch++;
        if( initPatientSearch==1 ) {
          callbackPatientList();
        } 
      });
  }
};
    
  vm.filterPatientSearch = 'all';
  document.getElementById("search_bar").setAttribute("name", "all");
  vm.placeholder = "";
  vm.searchBarEnable = 'false';
  vm.patientRadioCheck = function(val) {
    vm.filterPatientSearch = val;  
    if(val=='all') {
      vm.placeholder = "";
      document.getElementById("search_bar").setAttribute("name", "all");
      document.getElementById("search_bar").value="";
      vm.searchBarEnable = 'false'; 
      vm.getPatients();
    } else if(val=='mr_number') {
      vm.searchBarEnable = 'true';
      vm.placeholder = "Enter MR Number";
      document.getElementById("search_bar").setAttribute("name", "mr_number");
      document.getElementById("search_bar").value="";
    } else if(val=='patient_name') {
      vm.searchBarEnable = 'true';
      vm.placeholder = "Enter Patient Name";
      document.getElementById("search_bar").setAttribute("name", "patient_name");
      document.getElementById("search_bar").value="";  
    } else if(val=='phone') {
      vm.searchBarEnable = 'true';
      vm.placeholder = "Enter Phone Number";
      document.getElementById("search_bar").setAttribute("name", "phone");
      document.getElementById("search_bar").value="";     
    } else if(val=='picme') {
      vm.searchBarEnable = 'true';
      vm.placeholder = "Enter PICME Number";
      document.getElementById("search_bar").setAttribute("name", "picme");
      document.getElementById("search_bar").value="";     
    }    
  }

  vm.getPatientSearch = function(val) {
    var picme_param;

    if(vm.search_value) {

      if(val!=undefined) {
          if(vm.filterPatientSearch=='mr_number') {
             val = 'MR'+val;
             picme_param = false;
          } else if(vm.filterPatientSearch=='picme'){
             picme_param = true;
          }
      } 

      if(val==undefined) {
        if(vm.filterPatientSearch=='mr_number') {
           val = 'MR'+document.getElementById("search_bar").value;
           picme_param = false;
        } else if(vm.filterPatientSearch=='picme') {
           val = document.getElementById("search_bar").value;
           picme_param = true;
        } else {  
           val = document.getElementById("search_bar").value;
           picme_param = false;
        }
      }

      if(val.length==0 || val.length>=3) {
        vm.po.totalPatients = 0;
        vm.view = true;
        vm.loaded = false;
        //if(!val){vm.getPatients();}
        authService.getPatientSearch(val,picme_param).then(function(response){
          var patientlistData = response.map(_processPatient);
            vm.PatientList = patientlistData;
            //vm.po.totalPatients = vm.PatientList.length;
            vm.loaded = true;
            vm.view = false;
        },function (err, response) {
          vm.loaded = true;
          toastr.error(err.error);
        });      
      } else {
        toastr.error("Please enter atlease 3 characters.");
      }
    }
  };

  vm.getPatients();

}

  /** @ngInject */
  function PatientDigCtrl(PatientService,recordService,toastr,$route,$location) {
    var vm = this;
    vm.recordId = $route.current.params.Id;
    vm.currentView = "fever";

    var dur = ['1 to 3 days','3 to 5 days','1 week above'];
    vm.fever = [
      { name: "fever_duration", label: "How many days child have fever?", opt:dur},
      { name: "fever_pattern", label: "Fever Pattern", opt:['Continous','Remittent','Intremittent']},
      { name: "fever_dangerous_symptoms", label: "Symptoms",opt:['Vomiting everything','Not passing urine','Change in skin color']},
      { name: "fever_drugs_taken_so_far", label: " Drugs given so far",opt:['Paracetamol','Antibiotics','others']}
    ];
    vm.cold = [
      { name: "cold_duration", label: "How many days child have cold?",opt:dur},
      { name: "cold_sore_nose", label: "How many days child have sore nose?",bool:true},
      { name: "cold_ear_pain", label: "Pain in ears?",bool:true},
      { name: "cold_tumor", label: "Small tumor in neck?",bool:true }
    ];
    vm.cough = [
      {name: "cough_duration",label: "How many time your child continiously have cough?",opt:["4","8","above 8"] },
      { name: "cough_pattern",label: "Time gap between coughs?",opt:["5 min","10 min","above 10 min"]}
    ];
    vm.stomach = [
      { name: "stomach_pain_duration",label: "How many days child have stomach pain?",opt:dur},
      { name: "stomach_worms_in_stool",label: "Worm in stool?", bool:true},
      { name: "stomach_stool_color", label: "Stool Character", opt:["Dark","Other"]}
    ];
    vm.vomiting = [
      {name: "vomiting_duration",label: "How many days child have vomiting?", opt:dur},
      { name: "vomiting_color", label: "Vomiting color", opt:["Yellowish","Greenish","Other"]}
    ];
    vm.urine = [
      { name: "urinary_problem_duration", label: "How many days child have urine problem?",opt:dur},
      { name: "urinary_color", label: "Urine color", opt:["Yellowish","Greenish","Redwish","Other"]},
      { name: "urinary_pain_irritation_while_urinating", label: "Pain / irritation while urinating", bool:true},
      { name: "urinary_pain_irritation_in_organ",label: "A burning sensation when urinating", bool:true}
    ];
  vm.motion = [
      { name: "loose_motion_duration", label: "How many days your child have motion problem?",opt:dur},
      { name: "loose_motion_blood_in_stool", label: "Blood in stool" , bool:true}
    ];
  vm.constipation = [
      {name: "constipation_duration",label: "How many days your child have constipation problem?",opt:dur},
      {name: "constipation_blood_in_stool",label: "Blood in stool", bool:true},
      {name: "constipation_dry_stool",label: "Dry stool", bool:true},
      { name: "constipation_pain_while_defecation", label: "Pain in Defecation", bool:true}
    ];
    vm.other = [
          {name: "other_issues_head", label: "Head", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_belly_button",label: "Belly Button", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_face",label: "Face", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_chest",label: "Chest", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_nose",label: "Nose", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_leg",label: "Leg", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_ears",label: "Ears", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_eyes", label: "Eyes", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_stomach", label: "Stomach" , pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_hand", label: "Hand", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_neck",label: "Neck`", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_back", label: "Back", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_anal", label: "Anal", pain:"no",skin:"no",injury:"no",swelling:"no"},
          {name: "other_issues_mouth", label: "Mouth", pain:"no",skin:"no",injury:"no",swelling:"no"}
      ];

      vm.otherPain = [
        {name: "pain_on_touch",label: "Pain on touch", bool:true},
        {name: "pus_formation", label: "Pus formation", bool:true}
      ];

    vm.goToView = function(view) {
      if (view=="cancel" && vm.currentView == "fever"){
        $location.path('/init-patient/'+vm.recordId);
      }if (view=="cancel"){
        vm.currentView = "fever";
      } else if (vm.currentView == "fever" ){
        vm.currentView = "cold";
      } else if (vm.currentView == "cold"){
        vm.currentView = "abd";
      } else if (vm.currentView == "abd" ){
        vm.currentView = "mnc";
      } else if (vm.currentView == "mnc"){
        vm.currentView = "other";
      } else if (vm.currentView == "other"){
        _saveDignosis();
        //vm.currentView = "vac";
      }
      /*else if (vm.currentView == "vac"){
        vm.currentView = "vac";
      }*/ else {
        vm.currentView = "fever";
      }
    };

     function _loadChartData (){
    		 vm.dataLoaded = false;
    		 recordService.getRecordInfo(vm.recordId).then(function(recordInfoResponse){
    		 	 vm.record = {
    				 	name: recordInfoResponse.record_info.Record.label,
    				 	dob: new Date(recordInfoResponse.demographics[0].bday),
    				 	gender:recordInfoResponse.demographics[0].gender,
    				 	mr_number: recordInfoResponse.demographics[0].mr_number,
    				 	image:recordInfoResponse.image,
    				 	mobile: recordInfoResponse.demographics[0].father_tel_number
    			};
    			//vm.record1 =vm.record
    			//_loadVitalSigns();
    			//vm.mobilevalidity();
    			//vm.getAccountemail();
    		   },function (err, response) {
            toastr.error(err.error);
          });
    	}
      _loadChartData();
      vm.isDisabled = false;
      function _saveDignosis(){
        vm.isDisabled = true;
        var _other_issue={
          name: "other_issues",
          Models: { Model: { name: "HelChildOtherIssues", Field: [] } }
        };

        /*build other issues for save*/
        var other_pain=angular.copy(_other_issue);
        other_pain.Models.Model.Field.push({ name: "other_issues_type", text: "pain"});
        var other_skin=angular.copy(_other_issue);
        other_skin.Models.Model.Field.push({ name: "other_issues_type", text: "change in skin color"});
        var other_injury=angular.copy(_other_issue);
        other_injury.Models.Model.Field.push({ name: "other_issues_type", text: "injury"});
        var other_swelling=angular.copy(_other_issue);
        other_swelling.Models.Model.Field.push({ name: "other_issues_type", text: "swelling"});

        angular.forEach(vm.other,function(item){
          other_pain.Models.Model.Field.push({ name:item.name , text:item.pain });
          other_skin.Models.Model.Field.push({ name:item.name , text:item.skin });
          other_injury.Models.Model.Field.push({ name:item.name , text:item.injury });
          other_swelling.Models.Model.Field.push({ name:item.name , text:item.swelling });
        });

        angular.forEach(vm.otherPain,function(item){
          if(item.pain==undefined){
            item.pain = "no";
          }
          other_pain.Models.Model.Field.push({ name:item.name , text:item.pain });
        });

        var payload = {
          record_id:vm.recordId,type: "Diagnosis",
          data:{
            Models:{
              Model:{
                name:"HelChildDiagnosis",
                Field:[
                  {name: "diagnosis_date",text: new Date()},
                  other_pain, other_skin, other_injury, other_swelling
                ]
              }
            }
          }
        };

        _pushDignosis(payload,vm.fever);
        _pushDignosis(payload,vm.cold);
        _pushDignosis(payload,vm.cough);
        _pushDignosis(payload,vm.stomach);
        _pushDignosis(payload,vm.vomiting);
        _pushDignosis(payload,vm.urine);
        _pushDignosis(payload,vm.motion);
        _pushDignosis(payload,vm.constipation);

        /*console.log("payload to save dignosis : ",payload);*/
        PatientService.saveDiagnosis(payload).then(function(response) {
          toastr.success("Dignosis details saved.");
        });
      }

      function _pushDignosis(payload,area){
        angular.forEach(area,function(item){
          payload.data.Models.Model.Field.push({name:item.name , text:item.value||"NA"});
        });
      }

  }

  /** @ngInject */
  function InitPatientCtrl(PatientService,$route,recordService,toastr,$location) {
    var vm = this;

    vm.recordId = $route.current.params.Id;
    //vm.recordId = "a6311b1c-fd57-45a5-8058-43eac1d86cb6";
    vm.vitalLabels = ["Weight","Height","Temperature","Arm circumference","Head circumference","Chest circumference","Date"];
    vm.vitals = {
        record_id:vm.recordId,
        type: "Vitals",
        data: {
            Models: {
                Model: {
                    name: "HelChildVitalSigns",
                    Field: [
                        {name: "weight", text: ""},
                        {name: "height", text: ""},
                        {name: "temperature", text: ""},
                        {name: "arm_circumference", text: ""},
                        {name: "head_circumference", text: ""},
                        {name: "chest_circumference", text: ""}
                    ]
                }
            }
        }
    };

    /*Load Record info*/
    recordService.getRecordInfo(vm.recordId).then(function(recordInfoResponse){
        vm.record = recordInfoResponse;
    },function (err, response) {
       toastr.error(err.error);
    });

    recordService.getVitalSigns(vm.recordId)
    .then(function(vitalResponse){},
          function (err, response) {
            toastr.error(err.error);
    });

    vm.calculateAge = function (birthday) { // birthday is a date
      var a = moment();
      var b = moment(birthday);
      var diffDuration = moment.duration(a.diff(b));
      return diffDuration.years() + " Y " + diffDuration.months() + " M " + diffDuration.days() + " D";
    };
    vm.isDisabled = false;
     vm.SaveVitals = function(){
       vm.isDisabled = true;
        vm.vitals.data.Models.Model.Field.push({name: "date",text: new Date()});
        angular.forEach(vm.vitals.data.Models.Model.Field,function(value,key){
            if (Number.isInteger(value.text)) 
            {
              if(value.name=="height"){value.text=value.text/100}
              value.text = value.text.toString();
            }
          
        })
        PatientService.SaveVitals(vm.vitals).then(function(response) {
          toastr.success("Patient Vitals saved.");
          $location.path("/dig-patient/"+vm.recordId);
        });
     };
  }

/*Setup the Module*/
angular.module("RxC.pages.Patient", ['buds.store'])
.config(routeConfig)
.controller("PatientListCtrl", PatientListCtrl)
.controller("InitPatientCtrl", InitPatientCtrl)
.controller("PatientDigCtrl", PatientDigCtrl)
.service("PatientService", PatientService);

})();

/**
 * @author Helyxon
 * created on Dec 2016
 */
(function () {
  "use strict";


/** @ngInject */
function ScheduleService($http, $q, serviceBaseUrl, authService, BudsStore){
  var self = {};

  self.getSchedule = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+"getschedule?account_email="+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


	self.saveSchedule = function(data){
		var deferred = $q.defer();
        data.account_email= authService.authentication.account_id;
		$http.post(serviceBaseUrl+'saveschedule',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	self.prepareSchedule  = function(data){
		var deferred = $q.defer();
        data.account_email = authService.authentication.account_id;
		$http.post(serviceBaseUrl+'preparecalendar',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

  return self;
}


/*Setup the Module*/
angular.module("RxC.pages.Schedule", ["buds.store"])
.service("ScheduleService", ScheduleService);


})();

/**
 * @author Helyxon
 * created on May 2017
 */
(function () {
  'use strict';

  /** @ngInject */
  function routeConfig($routeProvider) {
    $routeProvider
   .when("/drug-master", {
     templateUrl: 'app/prescription/drug_master.tpl.html',
     controllerAs: "vm",
     controller: "drugListCtrl"
   })
   ;
  }

/** @ngInject */
function DrugMasterService($http, $q, $route, BudsStore, serviceBaseUrl,
  authService, recordService,$sessionStorage,$rootScope){
  var self = {};
  var drug;
  var screen;
  self.syncAfterUpdate = false;
  self.setCurrentDrug = function(payload){
    drug = payload;
  };

  self.getCurrentDrug = function(){
    return drug;
  };
  var patient_email;
  var patient_details;

  recordService.getRecordInfo($route.current.params.Id)
  .then(function(recordInfoResponse){
    patient_details = recordInfoResponse.demographics[0];
    patient_email = recordInfoResponse.record_info.Record.account_email;
  });

  self.loadDrugs = function(){
   var deferred = $q.defer();
   var payload = {};
   payload.account_email=authService.authentication.account_id;
   $http.post(serviceBaseUrl+'loaddrugdata',payload)
    .success(function (response) {
     deferred.resolve(response);
   })
    .error(function (error, status) {
     deferred.reject(error);
   });
   return deferred.promise;
 };
 self.searchDrug = function(drug_name, payload){
  var deferred = $q.defer();
  self.setCurrentDrug();
  $http.get(serviceBaseUrl+'searchdrug?account_email='  +
  authService.authentication.account_id + '&term=' + drug_name)
   .success(function (response) {
    deferred.resolve(response);
  })
   .error(function (error, status) {
    deferred.reject(error);
  });
  return deferred.promise;
};

self.listDrug = function(){
  var deferred = $q.defer();
  self.setCurrentDrug();
  $http.get(serviceBaseUrl+'searchdrug?account_email='  +
  authService.authentication.account_id)
   .success(function (response) {
    deferred.resolve(response);
  })
   .error(function (error, status) {
    deferred.reject(error);
  });
  return deferred.promise;
};

self.deleteDrug = function(data){
  var deferred = $q.defer();
  self.setCurrentDrug();
  $http.post(serviceBaseUrl+'deletedrug',
  data)
   .success(function (response) {
    deferred.resolve(response);
  })
   .error(function (error, status) {
    deferred.reject(error);
  });
  return deferred.promise;
};

self.favoritedelete = function(data){
  var deferred = $q.defer();
  $http.post(serviceBaseUrl+'favoritedelete',data)
  .success(function (response) {
    deferred.resolve(response);
  })
  .error(function (error, status) {
    deferred.reject(error);
  });
  return deferred.promise;
};

self.searchFavourite = function(name){
  var deferred = $q.defer();
  self.setCurrentDrug();
  $http.post(serviceBaseUrl+'favoritessearch',{account_email: authService.authentication.account_id, search_term: name})
  .success(function (response) {
    deferred.resolve(response);
  })
  .error(function (error, status) {
    deferred.reject(error);
  });
  return deferred.promise;
};

self.getFavourite = function(){
  var deferred = $q.defer();
  $http.get(serviceBaseUrl+'favorites?account_email='+authService.authentication.account_id)
  .success(function (response) {
    deferred.resolve(response);
  })
  .error(function (error, status) {
    deferred.reject(error);
  });
  return deferred.promise;
};

 self.manageDrugMaster= function (operation,object) {
   var deferred = $q.defer();
   var url;
   var payload={};
     if (operation=='update') {
       url = serviceBaseUrl + "updatedrugdetail";
       payload.drug = {
         drug_id:object.id,
         brand : object.brand.toUpperCase(),
         composition_name : object.composition_name ? object.composition_name.toUpperCase() : "",
         generic : object.generic ? object.generic.toUpperCase() : "",
         formulation : object.formulation.toUpperCase(),
         strength : object.strength,
         strength_unit : object.strength_unit ? object.strength_unit : "",
         dose : object.dose ? object.dose : "",
         dose_option : object.dose_option ? object.dose_option : "",
         route : object.route ? object.route : "",
         when : object.when ? object.when : "",
         special_instruction : object.special_instruction ? object.special_instruction : "",
         frequency : object.frequency ? object.frequency : "",
         duration : object.duration ? object.duration : "",
         duration_type : object.duration_type ? object.duration_type : "",
         minimum_buyable_qty : object.minimum_buyable_qty ? object.minimum_buyable_qty : ""
        };
     }else if (operation=='add'){
       url = serviceBaseUrl + "adddrug";
       payload.drug = {
         brand : object.brand.toUpperCase(),
         composition_name : object.composition_name ? object.composition_name.toUpperCase() : "",
         generic : object.generic ? object.generic.toUpperCase() : "",
         formulation : object.formulation.toUpperCase(),
         strength : object.strength,
         strength_unit : object.strength_unit ? object.strength_unit : "",
         dose : object.dose ? object.dose : "",
         dose_option : object.dose_option ? object.dose_option : "",
         route : object.route ? object.route : "",
         when : object.when ? object.when : "",
         special_instruction : object.special_instruction ? object.special_instruction : "",
         frequency : object.frequency ? object.frequency : "",
         duration : object.duration ? object.duration : "",
         duration_type : object.duration_type ? object.duration_type : "",
         minimum_buyable_qty : object.minimum_buyable_qty ? object.minimum_buyable_qty : ""
        };
     }
     payload.account_email = authService.authentication.account_id;

   $http.post(url,payload)
   .success(function (response) {
     //self.setReloadMaster(true);
     deferred.resolve(response);
   })
   .error(function (error, status) {
     deferred.reject(error);
   });
   return deferred.promise;
 };

 self.managePrescription= function (operation,object) {
   var deferred = $q.defer();
   var url;
   var payload={};
   payload.account_email = authService.authentication.account_id;
     if (operation=='update') {
       url = serviceBaseUrl + "updatedrugdetail";
       payload.drug = {
         drug_id : object.id,
         brand : object.brand,
         generic : object.generic,
         formulation : object.formulation,
         strength : object.strength
        };
     }else if (operation=='add'){
       url = serviceBaseUrl + "addprescriptiondata";
       payload.prescription = {};
       payload.prescription.patient_email = $sessionStorage.get('patientAccEmail');
       payload.prescription.entries = [];
       angular.forEach(object, function(item){
         if (item.frequency == 'As and When Required' || item.frequency == 'Others'){
           item.frequency = item.frequencytext;
         }
         var entry = {"drug_id": item.id,
                "dose": item.dose ? item.dose : "",
                "dose_option": item.dose_option ? item.dose_option : "",
                "frequency": item.frequency ? item.frequency : "",
                "route": item.route ? item.route : "",
                "when": item.when ? item.when : "",
                "duration": item.duration ? item.duration : "",
                "duration_type": item.duration_type ? item.duration_type : "",
                "quantity": item.quantity ? item.quantity : "",
                "special_instruction" : item.special_instruction ? item.special_instruction : "",
                "minimum_buyable_qty" : item.minimum_buyable_qty ? item.minimum_buyable_qty : ""
              };
          payload.prescription.entries.push(entry);
       });
      /*   = {brand:object.brand,
         generic:object.generic,
         formulation:object.formulation,
         strength:object.strength};*/
     }else if (operation=='updatePrescription'){
      url = serviceBaseUrl + "updateprescriptiondata";
      payload.prescription = {};
      payload.prescription.patient_email = $sessionStorage.get('patientAccEmail');
      payload.prescription.prescription_id = $rootScope.prescriptionId;
      payload.prescription.entries = [];
      angular.forEach(object, function(item){
        if (item.frequency == 'As and When Required' || item.frequency == 'Others'){
          item.frequency = item.frequencytext;
        }
        var entry = {
          "drug_id": item.id,
          "dose": item.dose ? item.dose : "",
          "dose_option": item.dose_option ? item.dose_option : "",
          "frequency": item.frequency ? item.frequency : "",
          "route": item.route ? item.route : "",
          "when": item.when ? item.when : "",
          "duration": item.duration ? item.duration : "",
          "duration_type": item.duration_type ? item.duration_type : "",
          "quantity": item.quantity ? item.quantity : "",
          "special_instruction" : item.special_instruction ? item.special_instruction : "",
          "minimum_buyable_qty" : item.minimum_buyable_qty ? item.minimum_buyable_qty : "",
          "operation": item.operation!=undefined? item.operation: "add"
        };
        payload.prescription.entries.push(entry);
      });
     /*   = {brand:object.brand,
        generic:object.generic,
        formulation:object.formulation,
        strength:object.strength};*/
    }


   $http.post(url,payload)
   .success(function (response) {
     //self.setReloadMaster(true);
     if (operation=='add'||operation=='update' || operation=='updatePrescription') {
      //  latestPrescription = undefined;
     }
     deferred.resolve(response);
   })
   .error(function (error, status) {
     deferred.reject(error);
   });
   return deferred.promise;
 };

 var latestPrescription; /*For, Caching the latest prescription*/
 self.clearLatestPrescription = function(pateintemail) {
  //  latestPrescription = undefined;
 };

 self.getLatestPrescription = function(pateintemail) {
   var deferred = $q.defer();
   if (latestPrescription){
     deferred.resolve(latestPrescription);
     return deferred.promise;
   }
   var url = serviceBaseUrl + "latestprescription";
   var payload={};
   payload.account_email = authService.authentication.account_id;
   //payload.patient_email = pateintemail;
   payload.patient_email = $sessionStorage.get('patientAccEmail');
   if($sessionStorage.get('patientAccEmail')){
     $http.post(url,payload)
     .success(function (response) {
       latestPrescription = response;
       deferred.resolve(response);
     })
     .error(function (error, status) {
       latestPrescription = {}; /*Avoids extra calls, in case of errors*/ 
       deferred.reject(error);
     });
   }
   return deferred.promise;
 };

 return self;

} /*end DrugMasterService*/

/** @ngInject */
function DrugEditCtrl(DrugMasterService, toastr, $ngBootbox,authService) {
  var vm = this;
  vm.frequency = {'Once a day':'Once a day',
  'Twice a day':'Twice a day',
  'Three times a day':'Three times a day',
  'Four times a day':'Four times a day',
  // 'Stat(Once)':'Stat(Once)',
  // 'As and When Required':'As and When Required',
  'Every 2 hours':'Every 2 hours',
  'Every 4 hours':'Every 4 hours',
  'Every 6 hours':'Every 6 hours',
  'Every 8 hours':'Every 8 hours',
  'SOS' : 'SOS'
  // 'Others':'Others'
};
  vm.routeofadmin = {'Oral':'Oral','Inhale':'Inhale','Subcutaneous':'Subcutaneous','Intravenus':'Intravenus',
  'Perrectal':'Perrectal','Toppical':'Toppical','Pervaginal':'Pervaginal','Others':'Others'};
  vm.durationType = {'days':'Days','months':'Months','day':'Day','month':'Month'};
  vm.doseOption = {'milliliter':'milliliter','milligram':'milligram','microgram':'microgram','gram':'gram','mole':'mole','millimole':'millimole'};
  vm.whenOption = {'af': 'After Food', 'bf': 'Before Food','Not Related to Food':'Not Related to Food','With Food':'With Food'};
  //vm.pageData = DrugMasterService.getCurrentDrug();

   vm.clearForm= function (){
    vm.drug= {"new":true};
    $ngBootbox.hideAll();
  };
  vm.clearForm();
  if (DrugMasterService.getCurrentDrug()){
    vm.drug= angular.copy(DrugMasterService.getCurrentDrug());
  }


  vm.manageDrugMaster = function (){
    var operation = "update";
    if (vm.drug.new===true){
      operation = "add" ;
    }

    DrugMasterService.manageDrugMaster(operation,vm.drug).
    then(
      function(response){
        if (vm.drug.new===true){
          DrugMasterService.listDrug();
          vm.drug.id=response.drug.id;
          vm.drug.new = false;
        }else{
          DrugMasterService.syncAfterUpdate = true;
        }
        $ngBootbox.hideAll();
        toastr.success(response.response || "Drug Saved successfully" );
      },
      function(error,response){
        console.log("error",error,response);
        toastr.error(error.error);
      }
    );

  };

  vm.managePrescription = function(operation){
    DrugMasterService.managePrescription(operation,vm.prescritpionList).
    then(
      function(response){
        console.log("response",response);
      });};
  vm.searchDrugbrand= function (drug_name) {
    vm.drugs=[];
    console.log(vm.drugs);
    DrugMasterService.searchDrug(drug_name, {})
    .then(function(r){
      vm.drugs = r.results;
    },
    function(r){
      toastr.error("Failed to load drug list.");
    });
  };
  vm.searchDrugname = function(drug_name) {
    vm.drugs=[];
  return DrugMasterService.searchDrug(drug_name).then(function(r){
        vm.drugs=r.results;
        return vm.drugs;     
        console.log(vm.drugs);  
    },
    function(r){
      toastr.error("Failed to load drug list.");
    });
  };
} /*end DrugEditCtrl*/

/** @ngInject */
function drugListCtrl(DrugMasterService, toastr, $ngBootbox, $interval,authService) {

var vm = this;

$interval(function(){
  /*Reload after update*/
  var cd = DrugMasterService.getCurrentDrug();
  if (!vm.selected && cd) {
    vm.drugs=[];
    vm.drugs.push(cd);
  }
  /*In case of update apply the updates to list*/
  if (DrugMasterService.syncAfterUpdate===true){
    vm.drugname = vm.drugname || cd.generic;
    // vm.searchDrug(vm.drugname);
    vm.listDrug();
    DrugMasterService.syncAfterUpdate = false;
    vm.selected = {};
  }
}, 1000);



  vm.searchDrug = function (drug_name) {
    vm.drugs=[];
    if (!drug_name || drug_name.trim()===""){
      return;
    }
    DrugMasterService.searchDrug(drug_name, {})
    .then(function(r){
      vm.drugs = r.results;
    },
    function(r){
      console.log("Failed to load drug list.");
      vm.searchDrug(drug_name);
    });
  };

  vm.listDrug = function() {
    DrugMasterService.listDrug().then(function(r) {
      vm.drugs = r.results;
    }, function(r) {
      toastr.error("Failed to load drug list");
    })
  };

  vm.listDrug();

  vm.deleteDrug = function(data) {
    var options = {
      message: 'Are you sure to delete this drug ?',
      title: 'Confirmation',
      buttons: {
           warning: {
               label: "Cancel",
               className: "btn-warning"
           },
           success: {
               label: "Ok",
               className: "btn-success",
               callback: function() {
                var drugData = { account_email:authService.authentication.account_id,drug_id:data.id}
                DrugMasterService.deleteDrug(drugData).then(function(response) {
                  toastr.success(response.response)
                  vm.listDrug();
                  vm.selected = {};
                },function(error) {
                  toastr.error(error);
                })
               }
          }
        }
        };
  $ngBootbox.customDialog(options);
  };

  vm.SelectRecord  = function (rec){
    vm.selected = rec;
    DrugMasterService.setCurrentDrug(vm.selected);
  };
  
  vm.loadDrugs = function(){
    DrugMasterService.loadDrugs()
    .then(function(r){
      toastr.success(r);
    },
    function(r){
      toastr.error("Failed to load drug list.");
    });
  };
}/*End drugListCtrl controller*/

/** @ngInject */
function PrescriptionCntrl(DrugMasterService, toastr, recordService, $route, $location,$rootScope,$sessionStorage) {
  var vm = this;
  vm.isPrescription = true;
  vm.prescritpionList = [];
  vm.formulationOption = { 
    'Injection' : 'Injection', 'Lotion' : 'Lotion', 'Oinment' : 'Oinment', 'Soap' : 'Soap',
    'Tablet' : 'Tablet', 'Suspension' : 'Suspension', 'Cream' : 'Cream', 'Capsules' : 'Capsules',
    'Drops' : 'Drops', 'Oil' : 'Oil', 'Gel' : 'Gel', 'Powder' : 'Powder', 'Syrup' : 'Syrup', 'Inhalation' : 'Inhalation', 'Sachet' : 'Sachet', 'Vaccination' : 'Vaccination', 'Others' : 'Others'};
  vm.frequency = {'Once a day (Every 24 hours)':'Once a day (Every 24 hours)',
  'Twice a day (Every 12 hours)':'Twice a day (Every 12 hours)',
  'Three times a day (Every 8 hours)':'Three times a day (Every 8 hours)',
  'Four times a day (Every 6 hours)':'Four times a day (Every 6 hours)',
  'Stat(Once)':'Stat(Once)','At Night':'At Night',
  'As and When Required':'As and When Required',
  'Every 2 hours':'Every 2 hours',
  'Every 4 hours':'Every 4 hours',
  'Others':'Others'};
  vm.routeofadmin = {'Oral':'Oral','Inhalation':'Inhalation','Intramuscular':'Intramuscular','Intradermal':'Intradermal',
  'Subcutaneous':'Subcutaneous','Intravenus':'Intravenus','Nubliser':'Nubliser','Eye':'Eye',
  'Ear':'Ear', 'Nose':'Nose', 'Skin':'Skin', 'Anus':'Anus', 'Genital':'Genital','Others':'Others'};
  vm.durationType = {'day':'Day','days':'Days','week':'Week','weeks':'Weeks','month':'Month','months':'Months'};
  vm.doseOption = {'ml':'ml','nos':'nos','cap':'cap','tab':'tab','puff':'puff','drops':'drops'};
  vm.whenOption = {'af': 'After Food', 'bf': 'Before Food','SOS':'SOS','Not Related to Food':'Not Related to Food'};
  vm.addToList = function(){
   // vm.selectedDrug.total = "1";
    if(vm.selectedDrug.reason==undefined){
      vm.selectedDrug.reason="";
    }
    var cp = angular.copy(vm.selectedDrug);
    vm.prescritpionList.push(cp);
    $rootScope.prescriptionPatient = vm.prescritpionList;
    vm.clearForm();
  };
  vm.updateForm = function() {
    if(vm.selectedDrug.frequency != 'Others' && vm.selectedDrug.frequency != 'As and When Required') {
      vm.selectedDrug.frequencytext = '';
    }
  };
  vm.clearForm = function(){
    vm.selectFav = undefined;
    vm.selectedDrug = undefined;
    vm.mode = undefined;
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0) + string.slice(1).toLowerCase();
  }

  vm.setTodrug = function(data,type){
    if(type=='fav'){
      vm.selectedDrug = data;
      vm.selectedDrug.id = data.drug_id;
      vm.selectedDrug.dose = vm.selectedDrug.dose ? vm.selectedDrug.dose : "1";
      vm.selectedDrug.dose_option = vm.selectedDrug.dose_option ? vm.selectedDrug.dose_option : "ml";
      vm.selectedDrug.frequency = vm.selectedDrug.frequency ? vm.selectedDrug.frequency : "Once a day (Every 24 hours)";
      vm.selectedDrug.route = vm.selectedDrug.route ? vm.selectedDrug.route : "Oral";
      vm.selectedDrug.duration = vm.selectedDrug.duration ? vm.selectedDrug.duration : "1";
      vm.selectedDrug.duration_type = vm.selectedDrug.duration_type ? vm.selectedDrug.duration_type : 'Days';
      vm.selectedDrug.when = vm.selectedDrug.when ? vm.selectedDrug.when : 'After Food';
      if(vm.selectedDrug.formulation == "Syrup") {
        vm.selectedDrug.minimum_buyable_qty = vm.selectedDrug.minimum_buyable_qty ? vm.selectedDrug.minimum_buyable_qty : "1";
      }
      if (!vm.selectedDrug.quantity) {
        vm.calculateTotalOfTablets();
      }
    }
    if(type=='select'){
      vm.selectedDrug = data;
      vm.selectedDrug.dose = vm.selectedDrug.dose ? vm.selectedDrug.dose : "1";
      vm.selectedDrug.dose_option = vm.selectedDrug.dose_option ? vm.selectedDrug.dose_option : "ml";
      vm.selectedDrug.formulation = vm.selectedDrug.formulation ? capitalizeFirstLetter(vm.selectedDrug.formulation) : "Injection";
      vm.selectedDrug.frequency = vm.selectedDrug.frequency ? vm.selectedDrug.frequency : "Once a day (Every 24 hours)";
      vm.selectedDrug.route = vm.selectedDrug.route ? vm.selectedDrug.route : "Oral";
      vm.selectedDrug.duration = vm.selectedDrug.duration ? vm.selectedDrug.duration : "1";
      vm.selectedDrug.duration_type = vm.selectedDrug.duration_type ? vm.selectedDrug.duration_type : 'Days';
      vm.selectedDrug.when = vm.selectedDrug.when ? vm.selectedDrug.when : 'After Food';
      if(vm.selectedDrug.formulation == "Syrup") {
        vm.selectedDrug.minimum_buyable_qty = vm.selectedDrug.minimum_buyable_qty ? vm.selectedDrug.minimum_buyable_qty : "1";
      }
      if (!vm.selectedDrug.quantity) {
        vm.calculateTotalOfTablets();
      }
    }
  };

function frequencyForTotal(){
  if (vm.selectedDrug.frequency === "Once a day (Every 24 hours)" ){
    return 1;
  }else if (vm.selectedDrug.frequency === "Twice a day (Every 12 hours)" ){
    return 2;
  }else if (vm.selectedDrug.frequency === "Three times a day (Every 8 hours)" ){
    return 3;
  }else if (vm.selectedDrug.frequency === "Four times a day (Every 6 hours)" ){
    return 4;
  }else if (vm.selectedDrug.frequency === "Every 2 hours" ){
    return 12;
  }else if (vm.selectedDrug.frequency === "Every 4 hours" ){
    return 6;
  }else {
    return 1;
  }
}
function durationTypeForTotal(){
  if (vm.selectedDrug.duration_type === "Weeks" ){
    return 7;
  }else if (vm.selectedDrug.duration_type === "Months" ){
    return 30;
  }else {
    return 1;
  }
}
  vm.calculateTotalOfTablets  = function(){
    if(vm.selectedDrug.formulation != "Syrup"){
      var total = 0;
      var dur = durationTypeForTotal();
      var fre = frequencyForTotal();
      var dosageInt = parseInt(vm.selectedDrug.dose);
      total = dosageInt * fre * vm.selectedDrug.duration * dur ;
      vm.selectedDrug.quantity = total;
    } 
    else {
      vm.selectedDrug.quantity = "";
    }
  };
  $rootScope.LoadPresRecord = function(){
    if($rootScope.prescriptionResult){
      vm.prescritpionList = $rootScope.prescriptionResult;
      $rootScope.prescriptionPatient = vm.prescritpionList;
    }
  }
  $rootScope.LoadPresRecord();

  vm.deletePrescriptionEntry = function(data) {
    vm.prescritpionList[data].operation = "delete";
  };

  vm.removeFavourite = function(data) {
    var saveData = {
            account_email: $rootScope.authentication.account_id,
            favorite_id:data.id
          };
          DrugMasterService.favoritedelete(saveData).then(function(response){
            toastr.success(response.response);
          })

  };
  vm.disabled = false;
  vm.savePrescription = function(operation){
    DrugMasterService.managePrescription(operation,vm.prescritpionList)
    .then(function(r){
      vm.disabled = true;
      $rootScope.prescript = r.prescription.id;
      $sessionStorage.put('prescription_id',r.prescription.id);
      toastr.success("added prescription successfully.");
    },
    function(r){
      vm.disabled = false;
      toastr.error("Failed to add Prescription.", r);
    });
  };

  $rootScope.savePrescriptionOverview = function() {
    vm.savePrescription('add');
  };

/*  vm.getLatestPrescription = function(){
    vm.pateintemail;
    recordService.getRecordInfo($route.current.params.Id)
    .then(function(recordInfoResponse){
      vm.patient_details = recordInfoResponse;
      vm.pateintemail = recordInfoResponse.record_info.Record.account_email;
      DrugMasterService.getLatestPrescription(vm.pateintemail)
      .then(function(r){
        console.log("prescriptionList==",r);
        vm.prescriptionList =  r;
        console.log("vm.patient_details2==",vm.pateintemail);
      });
    });


  };
  vm.getLatestPrescription();
  vm.printToCart = function(printSection) {
    var innerContents = document.getElementById('printSection').innerHTML;
    var popupWinindow = window.open('', '_blank',
    'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
    popupWinindow.document.close();
  };*/
} /*end PrescriptionCntrlr*/

/** @ngInject */
function DrugsTypeaheadCtrl(DrugMasterService, toastr) {
  var vm=this;
    vm.location = 'app/prescription/dropdownTemplate.html';

    vm.searchDrug = function(val) {
      return DrugMasterService.searchDrug(val).then(function(r){
        return r.results;
      },
      function(r){
        console.log("Failed to load drug list.");
        vm.searchDrug(val);
      });
    };
    
    vm.searchFavourite = function(val) {
      return DrugMasterService.searchFavourite(val).then(function(response) {
        return response.favorites;
      },
      function(error) {
        toastr.error(error);
      })
    };

    vm.getFavourite = function() {
      return DrugMasterService.getFavourite().then(function(response) {
        vm.allFavourite = response.favorites;
      },
      function(error) {
        toastr.error(error);
      })
    }

}


/*Setup the Module*/
angular.module("RxC.pages.Drug", ['buds.store'])
.config(routeConfig)
.service("DrugMasterService", DrugMasterService)
.controller("drugListCtrl", drugListCtrl)
.controller("DrugEditCtrl", DrugEditCtrl)
.controller("PrescriptionCntrl",PrescriptionCntrl)
.controller("DrugsTypeaheadCtrl",DrugsTypeaheadCtrl)

;
})();

/**
 * @author Helyxon
 * created on Dec 2016
 */
(function () {
  "use strict";


/** @ngInject */
function SettingsService($http, $q, serviceBaseUrl, authService, BudsStore){
  var self = {};

  self.getSettings = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+"settings?"+authService.authentication.account_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


	self.saveSettings = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+"settings",{"account_email":authService.authentication.account_id,"data":{"settings":data}}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	self.getLastAppConfigDate = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+"getlastappconfigdate?account_email="+authService.authentication.account_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

  return self;
}


/*Setup the Module*/
angular.module("RxC.pages.Settings", ["buds.store"])
.service("SettingsService", SettingsService);


})();

/**
 * @author Helyxon
 * created on Dec 2016
 */
(function () {
  "use strict";

  /** @ngInject */
  function Utils(){
    var self = {};

  /************************************ Array conversions**************************/
  /*Check if the array has duplicate values*/
  self.hasDupesInArray =  function (array){
    array.sort();
    for (var i = 0; i < array.length -1; i++){
      if (array[i+1] == array[i])
      {
        return true;
      }
    }
    return false;
  };

  /*Spilt an array into matrix*/
  self.chunks = function(array, size, fill) {
    var results = [];
    var dummy = angular.copy(array[array.length-1]);
    dummy.dummy=true;

    while (array.length) {
      var t = array.splice(0, size);
      if (fill){
        /*Fill last chunk to make all checks of same size*/
        if (t.length < size){
            var index = 1;
            while (t.length < size) {
              t.push(angular.copy(dummy));
            }
        }
      }
      results.push(t);
    }
    return results;
  };

  /*************************************Date and time conversions**************************/

  /*return GMTTime Ex: 10:06*/
  self.toGMTTime = function (localTime) {
    var dt = new Date("2017-01-22 " + localTime);
    return ("0" + dt.getUTCHours()).slice(-2) + ":" + ("0" + dt.getUTCMinutes()).slice(-2);
  };

  self.toGMTDate = function (localDate,iso) {
  	var dt = new Date(localDate);
    if (iso){
      return dt.toISOString().slice(0,10);/*ex:"2017-05-20"*/
    }
  	return dt.toGMTString().slice(0,16); /*ex:"Sat, 20 May 2017"*/
  };

  /*Returns date time formated as 2017-02-25T11:00:00Z
  This format is used by Helixon app for saving datetime
  So whule add or update the date field need to
  convert GMT datetime using this function
  */
  self.toRxDate = function (gmtDate,hour12){
    function pad(s) { return (s < 10) ? '0' + s : s; }
	  var d = new Date(gmtDate);
	  return [d.getFullYear(),pad(d.getMonth()+1),pad(d.getDate())].join('-') + "T" + d.toLocaleTimeString('en-IN', { hour: 'numeric', minute: 'numeric',hour12:(hour12||false) }) + ":00Z";
  };

  self.toGMTDateTime = function (localDateTime,iso) {
  	var dt = new Date(localDateTime);
    if (iso){
      return dt.toISOString(); /*ex:"2017-05-20T10:06:11.302Z"*/
    }
  	return dt.toGMTString(); /*ex:"Sat, 20 May 2017 10:06:11 GMT"*/
  };

  /*Returns time like 15:36*/
  self.toLocalTime = function (gmtTime,hour12) {
  	var dt = new Date();
  	var t = gmtTime.split(":");
  	dt.setUTCHours(t[0]);
  	dt.setUTCMinutes(t[1]);
    return dt.toLocaleTimeString('en-IN', { hour: 'numeric', hour12:true, minute: 'numeric' });//toLocaleTimeString('en-IN', { hour: 'numeric', minute: 'numeric',hour12: true });
  	//return (dt.toLocaleTimeString().slice(0,5).indexOf(":")===1 ? "0" + dt.toLocaleTimeString().slice(0,4) : dt.toLocaleTimeString().slice(0,5));
  };

  self.toLocalDate = function (gmtDate,hour12) {
    var dt = new Date(gmtDate);
  	return dt.toLocaleString();
  };
  /*returns date as yyyy-mm-dd*/
  self.toLocalDateOnly = function (gmtDate,hour12) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
	  var d = new Date(gmtDate);
	  return [d.getFullYear(),pad(d.getMonth()+1),pad(d.getDate())].join('-');
  };



  self.toLocalDateTime = function (gmtDate,hour12) {
    function pad(s) { return (s < 10) ? '0' + s : s;
  console.log(s); }
	  var d = new Date(gmtDate);
    return [d.getFullYear(),pad(d.getMonth()+1),pad(d.getDate())].join('-') + " " + d.toLocaleTimeString('en-IN', { hour: 'numeric', hour12:(hour12||false), minute: 'numeric' });

  	//var dt = new Date(gmtDate);
  	//return dt.toLocaleString();
  };


    return self;
  }

  angular.module("RxC.Utils", [])
  .service("RxCUtils", Utils);

})();

/**
 * @author Helyxon
 * created on Dec 2016
 */
 (function () {
    'use strict';
  
    /** @ngInject */
    function routeConfig($routeProvider) {
      $routeProvider
     .when("/vac-master", {
       templateUrl: 'app/vac/vac_master.tpl.html',
       controllerAs:"vm",
       controller:"VacCtrl"
     });
    }
  
  /** @ngInject */
  function VacService($http, $q, BudsStore, serviceBaseUrl,authService , $sce , $rootScope){
    var self = {};
  
    var pageName;
    self.getPageName = function () {
      return pageName;
    };
    self.setPageName = function (name) {
      pageName = name;
    };
  
    var pageData = {};
    self.setPageData = function (data,clear) {
      pageData = data;
    };
    self.getPageData = function () {
      return pageData;
    };
  
    var selected = {};
    self.getSelected = function () {
      return selected;
    };
    self.SetSelected = function (data) {
      selected = data;
    };
  
    /*A flag to determine if the master list should be reloaded*/
    var reloadMaster = false;
    self.setReloadMaster = function (flag){
      reloadMaster = flag;
    };
    self.getReloadMaster = function (){
      return reloadMaster;
    };
  
    $rootScope.add_array = [];
  
    self.get_inventory_details = function(){
      
      var deferred = $q.defer();
      var url = serviceBaseUrl+"getvendorvaccine?account_email=" + authService.authentication.account_id;
    
      $http.get(url).success(function (response) {
      deferred.resolve(response);
    })
    .error(function (error, status) {
      deferred.reject(error);
    });
    return deferred.promise;
  
  }
  
  self.update_inventory= function (data) {
      var deferred = $q.defer();
      var url = serviceBaseUrl+"savevendorvaccine"
      $http.post(url,data)
      .success(function (response) {
        deferred.resolve(response);
      })
      .error(function (error, status) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
  
    self.getMaster_List = function(type,filter_text){
        console.log("56", type,filter_text);
        var deferred = $q.defer();
        var url = serviceBaseUrl+"getnewvaccinedata?account_email=" + authService.authentication.account_id;
      
        $http.get(url).success(function (response) {
        deferred.resolve(response);
      //  console.log("agegroup 62", response.age_group);
       for(var i=0;i< response.age_group.length;i++){
           $rootScope.add_array.push(response.age_group[i].toString());
       }
       $rootScope.add_array = response.age_group;
      })
      .error(function (error, status) {
        deferred.reject(error);
      });
      return deferred.promise;
  
    }
  
    self.getMasterList= function (type,filter_text) {
  
      console.log("type,filter_text", type,filter_text);
      var deferred = $q.defer();
      var url;
      if (type && type ==="vac-master"){
        url = serviceBaseUrl+"viewvaccinations?account_email=" + authService.authentication.account_id + "&filter=" + (filter_text || "active");
      } 
      // else if (type && type ==="vac-content"){
        // url = serviceBaseUrl+"listcontent?account_email=" + authService.authentication.account_id + "&filter=" + (filter_text || "active");
      // }
  
      $http.get(url)
      .success(function (response) {
        reloadMaster = false;
        console.log("response", response.vaccinations);
        console.log("response", response.vaccinations.length);
      //   for(var i=0;i<response.vaccinations.length ; i++){
      //     $http.get(serviceBaseUrl + "getvaccinationbrandlist/?account_email=" + authService.authentication.account_id + "&s_no=" + response.vaccinations[i].sno )
      //     .success(function (response) {
      //         console.log("response inside", response)
      //     });
      //   }
  
        deferred.resolve(response);
      })
      .error(function (error, status) {
        deferred.reject(error);
      });
      return deferred.promise;
  };
  
  self.AddRecord= function (type,object,update) {
    var deferred = $q.defer();
    var url;
    var payload;
    if (type && type ==="vac-master"){
      if (update) {
        url = serviceBaseUrl + "vaccinationupdate";
        payload = {
          active:object.active,
          age_in_days:object.age_in_days,
          description:object.description,
          disease:object.disease,
          drug_name:object.drug_name,
          gender:object.gender,
          id:object.id,
          mandatory:object.mandatory,
          remarks:object.remarks,
          side_effects:object.side_effects,
          site:object.site,
          sno:object.sno
        };
      }else {
        url = serviceBaseUrl + "vaccinationadd";
        payload = {
          age_in_days:object.age_in_days?object.age_in_days:"",
          description:object.description?object.description:"",
          disease:object.disease?object.disease:"",
          drug_name:object.drug_name?object.drug_name:"",
          gender:object.gender?object.gender:"",
          mandatory:object.mandatory?object.mandatory:"",
          remarks:object.remarks?object.remarks:"",
          side_effects:object.side_effects?object.side_effects:"",
          site:object.site?object.site:""
        };
      }
      payload.account_email = authService.authentication.account_id;
    } 
    // else if (type && type ==="vac-content"){
    //   payload =  { "account_email": authService.authentication.account_id };
    //   if (update) {
    //     url = serviceBaseUrl + "updatecontent";
    //     payload.content = { "vaccination_id": object.vaccine.id, "about": object.about,
    //     "disease": object.disease, "side_effects":object.side_effects,
    //     "active" : object.active };
    //   }else {
    //     url = serviceBaseUrl + "addcontent";
    //     payload.content = { "vaccination_id": object.vaccine.id, "about": object.about, "disease": object.disease, "side_effects":object.side_effects };
    //   }
  
    // }
  
  
    $http.post(url,payload)
    .success(function (response) {
      self.setReloadMaster(true);
      deferred.resolve(response);
    })
    .error(function (error, status) {
      deferred.reject(error);
    });
    return deferred.promise;
  };
  
  
    return self;
  } /*end VacService*/
  
  /** @ngInject */
  function ListEditCtrl(VacService, toastr, $ngBootbox,$location , authService , $rootScope , $http , serviceBaseUrl , $sce) {
    var vm = this;
    $rootScope.vacbrands = [];
    $rootScope.updateremovetag = [];
    vm.pageData = VacService.getPageData();
    vm.pageName = VacService.getPageName();
    vm.dateOptions = {
      minDate: new Date(),
      startingDay: 1
    };
  
  
    vm.clearForm= function (){
      vm.o= {"new":true,gender:"both",site:"Intramuscular (IM)",mandatory:"true",active:"true"};
    }
    vm.clearForm();
  
    if (VacService.getSelected()){
      vm.o= angular.copy(VacService.getSelected());
    }
    
    /* map the active inactive values if set*/
    if (vm.o.active===true || vm.o.active==="true"){
      vm.o.active = "true";
    } else if (vm.o.active===false || vm.o.active==="false"){
      vm.o.active = "false";
    } else { /*Patch for vendor master*/
      vm.o.active = "true";
    }
  
    /*map preferred flag*/
    if (vm.o.preferred==="false"){
      vm.o.preferred = "false";
    } else {
      vm.o.preferred = "true";
    }
  
    /* Fix BAB-175 */
    var masterFilterText = "all";
    if (vm.o.new ===true){
      masterFilterText = "active";
    }
  
  
    VacService.getMasterList("vac-master",masterFilterText)
    .then(function (response) {
      vm.vacOptions = response.vaccinations;
      /*Set selected*/
      var name = vm.o.vaccination_name || vm.o.vaccination || vm.o.vaccination_id || (vm.o.order_details ? vm.o.order_details[0].vaccination_name:"");
      if ( name ){
        for(i=0;i<vm.vacOptions.length;i++){
          if (name===vm.vacOptions[i].drug_name || name===vm.vacOptions[i].id) {
            vm.o.vaccine= vm.vacOptions[i]
            break;
          }
        }
      }
    });
  
   
    $rootScope.removetag = function(data){
        console.log("data", data);
        $rootScope.updateremovetag.push(data.id)
  
        for( var i = 0; i < $rootScope.vacbrands.length; i++){ 
          console.log('hello',$rootScope.vacbrands[i] , data.brand_name)
              if ( $rootScope.vacbrands[i].brand_name === data.brand_name) { 
                  $rootScope.vacbrands.splice(i, 1); 
              }
          
          }
    }
  
    $rootScope.Entervac = function(){
      var val = document.getElementById('inputtag');
        $rootScope.data1.push({
            "is_active": true,
            "id": "",
            "brand": val.value
        });
      // $rootScope.data1.push(val.value);
      document.getElementById('inputtag').value = "";
    }
  
    $rootScope.Updatebrands = function(data){
         
      $http.get(serviceBaseUrl + "getvaccinationbrandlist/?account_email=" + authService.authentication.account_id + "&s_no=" + data.sno +"&id="+data.id)
      .success(function (response) {
            console.log("response", response);
            for(var i=0;i<response.details.length;i++){
                $rootScope.vacbrands.push(response.details[i])
            }
  
            var options = {
              title : "<h4 style='color:white'>Update Brands</h4>",
              templateUrl : 'app/vac/updateaddbrand.html',
              size : 'lg',
              // onEscape : function() {$scope.$apply();},
              closeButton: true,
              buttons : {
          
                  ok : {
                      label : "Update",
                      className: "btn-primary fa fa-save",
                      callback: function(event) {
                            var params = {
                                 "brand_id":  $rootScope.updateremovetag,
                                 "account_email": authService.authentication.account_id,
                             }
                             console.log("params", params);  
                             $http.post(serviceBaseUrl + 'updatevaccinationbrand/', params).success(function(response) {
                                     console.log("response", response);
                                     if(response.success == 1){
                                         for(var i=0;i<response.details.length;i++){
                                             $rootScope.vacbrands = [];
                                             toastr.success(response.message);
                                          //    $rootScope.vacbrands.push(response.details[i])
                                              vm.reloadList();
                                              self.getMasterList("vac-master", "active");
                                         }
                                     }
                                }).error(function(error, status) {
                             });
                          
                      }
                  },
                  close : {
                      label: " Cancel",
                      className: "btn-danger fa fa-times-circle",
                      callback: function() {
      
                      }
                  }
                 
                  
              }
          };
          $ngBootbox.customDialog(options);
      })
      .error(function (error, status) {
       
      });
    }
  
  
    vm.addToList = function (object){
      if (vm.pageData.constructor !== Array){
        vm.pageData = [];
      }
      vm.pageData.push(object);
      $ngBootbox.hideAll();
    }
  
    vm.UpdateRecord = function (type){
        VacService.AddRecord(type,vm.o,true).
        then(
          function(response){
            toastr.success(response.response || "Record updated successfully" );
            $ngBootbox.hideAll();
            // VacService.setReloadMaster(true);
            // location.reload();
          },
          function(error,response){
            console.log("error",error,response);
            toastr.error(error.error);
          }
        );
    };
  
  }/*End controller*/
  
  
  /** @ngInject */
  function VacCtrl($scope , VacService, toastr, $ngBootbox, $location, $interval , authService ,serviceBaseUrl, $http , $rootScope , multipartFormdata , $sce) {
    var vm = this;
    $scope.helyxonApiUrl = authService.helyxonApi.url;
    
    vm.groupvaccines = [];
    $rootScope.updatedrugs = [];
    $scope.deleted_drugs_arr = [];
    $scope.brand_inventory_arr = []
    $rootScope.vaccinename;
    $rootScope.vaccinedays;
    vm.showAll = "active";
    vm.taginput;
  
    $rootScope.data1 = [];
  //   vm.tags = [];
    $rootScope.actualtag = [];
    vm.pageName = "vac-master"
    VacService.setPageName(vm.pageName);
  
    $rootScope.uploadedphoto = "img_1627892582XfoNPRkurW.png"
  
    $interval(function(){
      vm.showSave = false;
      angular.forEach(vm.records,function(row){
        if (row.new){
          vm.showSave = true;
        }
      });
  
      /*Reload after update*/
      if (VacService.getReloadMaster()){
        vm.reloadList();
      }
    }, 1000);
  
    $rootScope.changeinput = function(){
        var val = document.getElementById('inputtag');
        val.addEventListener("keydown", function (e) {
            console.log("e", e);
          if (e.code === "Enter") {  //checks whether the pressed key is "Enter"
              if(e.target.value != ""){
                  validate(e);
              }
          }
      });
    }
  
  function validate(e) {
      var text = e.target.value;
     console.log("text", text);
      $rootScope.data1.push({
          "is_active": true,
          "id": "",
          "brand": text
      });
    
     document.getElementById('inputtag').value = "";
  
  }
  
  $rootScope.closetag = function(data){
      for( var i = 0; i < $rootScope.data1.length; i++){ 
          console.log("$rootScope.data[i]", $rootScope.data1[i]);
          if ( $rootScope.data1[i].brand === data.brand) {
              $rootScope.data1[i].is_active = false
              $scope.deleted_drugs_arr.push($rootScope.data1[i])
              $rootScope.data1.splice(i, 1);
          }
      
      }
  }
  
  
  
  $rootScope.uploadmyfile = function(file, event, flow) {
      console.log("399", file, event, flow)
      console.log("$scope.helyxonApiUrl", $scope.helyxonApiUrl);
      if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {
          var data = new FormData();
          data.append('file', file.file);
          $scope.uploadPatientImage = file.file;    
          var reader = new FileReader();
          reader.onload = function(e) {
              console.log("event",e)
              if(e.loaded){
                  $rootScope.uploadingimage = true;
              }
              $scope.image = reader.result;
              $scope.update_image = true;
              multipartFormdata.uploadFileToUrl("https://test.epicare.net/helyxonapi//", $scope.uploadPatientImage).then(function(response){
                  $rootScope.imagee = "https://test.epicare.net/helyxonapi/cloud/image/upload/"+response.image[0].filename;
                  console.log("$scope.image", $rootScope.imagee)
                  $rootScope.uploadingimage = false;
                  $rootScope.uploadimage = response.image[0].filename;
              })
         };
         reader.readAsDataURL(file.file);
      }else {
          alert("Upload only Images");
          return false;
      }
      flow.file = [];
         
  };
  
  $rootScope.playaudio = function(){
  
  }
  
  $scope.uploadingaudiofile = false;
  
  $rootScope.uploadaudiofile = function(file, event, flow) {
      console.log("$scope.helyxonApiUrl", $scope.helyxonApiUrl);
      if ({ mp3: 1 }[file.getExtension()]) {
          var data = new FormData();
          data.append('file', file.file);
          $scope.uploadPatientImage = file.file;    
          var reader = new FileReader();
          reader.onload = function(e) {
              console.log("event",e)
              if(e.loaded){
                  $rootScope.uploadingaudio = true;
              }
              $scope.image = reader.result;
              $scope.uploadingaudiofile = true;
              multipartFormdata.uploadaudioToUrl("https://test.epicare.net/helyxonapi//", $scope.uploadPatientImage).then(function(response){
               console.log("res audio", response);     
              $rootScope.audioplays = "https://test.epicare.net/helyxonapi/cloud/mp3/upload/"+response.mp3[0].filename;
              $scope.uploadingaudiofile = false;
                  //  $rootScope.audioplays = "aud_1627896590vzwJI9a4jh.mp3"
                  $rootScope.uploadingaudio = false;
                  $rootScope.uploadaudio = response.mp3[0].filename;
                  console.log("audio", response);
  
              })
         };
         reader.readAsDataURL(file.file);
      }else {
          alert("Upload only mp3 file");
          return false;
      }
      flow.file = [];
         
  };
  
  $scope.rowchecked;
  $rootScope.groupedvaccines = [];
  // $rootScope.disablecheck = false;
  $scope.groupchecked = function(data,id,index,data1){
      console.log('$rootScope.groupedvaccines', $rootScope.groupedvaccines);
      if(data1 == true){
          $rootScope.groupedvaccines.push(data);
          // $rootScope.disablecheck = true;
          console.log("$rootScope.groupedvaccines", $rootScope.groupedvaccines);
      }else{
          for(var i=0;i<$rootScope.groupedvaccines.length;i++){
              if ( $rootScope.groupedvaccines[i].id === id) {      
                  $rootScope.groupedvaccines.splice(i, 1); 
              }
          }
      }
  }
  
  $rootScope.removecombine = function(data){
      console.log('rem combine', data)
      for(var i=0;i<$rootScope.groupedvaccines.length;i++){
          if ( $rootScope.groupedvaccines[i].id === data.id) {      
              $rootScope.groupedvaccines.splice(i, 1); 
          }
      }
  }
  
  $scope.combainvaccine = function(){
      console.log("combine 2 vaccines", $rootScope.groupedvaccines);
  
      var options = {
          title: "<h4 style='color:white'>Combine Vaccines</h4>",
          templateUrl : 'app/vac/combinevac.html',
          size : 'lg',
  
          closeButton: true,
          buttons : {
      
              ok : {
                  label : " Combine",
                  className: "btn-primary fa fa-save",
                  callback: function(event) {
                    
                      
                  }
              },
              close : {
                  label: " Cancel",
                  className: "btn-danger fa fa-times-circle",
                  callback: function() {
  
                  }
              }
             
              
          }
      };
      $ngBootbox.customDialog(options);
  
  }
  
  
  $rootScope.uploadvideofile = function(file, event, flow) {
      console.log("$scope.helyxonApiUrl", $scope.helyxonApiUrl);
      if ({ mp4: 1 }[file.getExtension()]) {
          var data = new FormData();
          data.append('file', file.file);
          $scope.uploadPatientImage = file.file;    
          var reader = new FileReader();
          reader.onload = function(e) {
              console.log("event",e)
              console.log("ee", e.loaded , e.total);
  
              if(e.loaded){
                  $rootScope.uploadingvideo = true;
              }
              // Math.round((response.loaded / response.total) * 100);
              $scope.image = reader.result;
              $scope.update_image = true;
              multipartFormdata.uploadvideoToUrl("https://test.epicare.net/helyxonapi/", $scope.uploadPatientImage).then(function(response){
                  console.log("video", response.loaded , response.total); 
                  console.log("video", response);
                  $rootScope.uploadingvideo = false;
                  $rootScope.uploadvideo = response.video[0].filename;
                  $rootScope.videoplaysrc = "https://test.epicare.net/helyxonapi/cloud/image/upload/"+response.video[0].filename
                   $rootScope.videoplays = $sce.trustAsResourceUrl($rootScope.videoplaysrc)
  
              })
         };
         reader.readAsDataURL(file.file);
      }else {
          alert("Upload only Images");
          return false;
      }
      flow.file = [];
         
  };
  
     $rootScope.callmedia = function(data){
         console.log("Media data", data);
         $rootScope.media = data;
         if(data == 'plaintext'){
          $rootScope.mediatype = ""
          $rootScope.mediatype = "Add" +" "+data;
         }else if(data == 'Image'){
          $rootScope.mediatype = ""
          $rootScope.mediatype = "Upload" +" "+data;
         }else if(data == 'Audio'){
          $rootScope.mediatype = ""
          $rootScope.mediatype = "Upload" +" "+data;
         }else if(data == 'Video'){
          $rootScope.mediatype = ""
          $rootScope.mediatype = "Upload" +" "+data;
         }else if(data == 'Links'){
          $rootScope.mediatype = ""
          $rootScope.mediatype = "Upload" +" "+data;
         }
         var options = {
          title: "<h4 style='color:white'>Add Message</h4>",
          templateUrl : 'app/vac/addmedia.html',
          size : 'lg',
          closeButton: true,
          buttons : {
              ok : {
                  label : "Add",
                  className: "btn-primary fa fa-save",
                  callback: function(event) {
                 
                       console.log('$rootScope.mediatype', $rootScope.mediatype);
                      if($rootScope.mediatype == "Add plaintext"){
                         var text = document.getElementById("textmedia").value
                          $rootScope.messageurl = "txt-"+text;
                          console.log("$rootScope.messageurl", $rootScope.messageurl);
                      }else if($rootScope.mediatype == "Upload Image"){
                          $rootScope.messageurl = $rootScope.uploadimage;
                          console.log("Image upload", $rootScope.messageurl)
                      }else if($rootScope.mediatype == "Upload Audio"){
                          $rootScope.messageurl = $rootScope.uploadaudio;
                          console.log("Image upload", $rootScope.messageurl)
                      }else if($rootScope.mediatype == "Upload Video"){
                          $rootScope.messageurl = $rootScope.uploadvideo;
                          console.log("Image upload", $rootScope.messageurl)
                      }else if($rootScope.mediatype == "Upload Links"){
                          var link = document.getElementById("linksmedia").value
                          $rootScope.messageurl = link
                          console.log("Image upload", $rootScope.messageurl)
                      }
  
                      // if($rootScope.messageurl != ""){
  
                      //     var params = {
                      //                 "account_email": authService.authentication.account_id,
                      //                 "vaccine_id": $rootScope.masterdata.id,
                      //                 "message_url": $rootScope.messageurl
                      //             }
                              
                      //         console.log("params", params);
                          
                      //         $http.post(serviceBaseUrl + 'updatenewvaccineurl', params).success(function(response) {
                      //                 console.log("response", response);
                      //                 if(response.success == 1){
  
                      //                     toastr.success(response.message);
                      //                     bootbox.hideAll();
                      //                 }
                      //            }).error(function(error, status) {
                      //         });
                      // }
                      // console.log("array to be sent",  $rootScope.actualtag);
                      // var vacgroup = [];
                      // for(var i=0;i<$rootScope.actualtag.length;i++){
                      //     vacgroup.push($rootScope.actualtag[i].name);
                      // }
                      // var params = {
                      //     "data": vacgroup,
                      //     "s_no": $rootScope.drug_sno,
                      //     "account_email": authService.authentication.account_id,
                      //     "id": data.id
                      // }
                      // console.log("params", params);
                  
                      // $http.post(serviceBaseUrl + 'savevaccinationbrandmaster/', params).success(function(response) {
                      //         console.log("response", response);
                      //         if(response.success == 1){
                      //             toastr.success(response.message);
                                 
                      //             bootbox.hideAll();
                      //         }
                      //    }).error(function(error, status) {
                      // });
                      
                  }
              },
              close : {
                  label: " Cancel",
                  className: "btn-danger fa fa-times-circle",
                  callback: function() {
  
                  }
              }
             
              
          }
      };
      $ngBootbox.customDialog(options);
  
     }
  
     $rootScope.addbrand = function(data,data1){
      $rootScope.drug_sno = data.sno
         if ($rootScope.data1.length == 0) {
             for (var i = 0; i < data1.length; i++) {
                 $rootScope.data1.push({
                     "is_active": true,
                     'id': data1[i].id,
                     "brand": data1[i].brand_name
                 })
             }
         }
      // $rootScope.data1 = data1
  
      console.log("data1" , data1);
  
      var options = {
          title: "<h4 style='color:white'>Add Vaccine Brands</h4>",
          templateUrl : 'app/vac/addbrand.html',
          size : 'lg',
  
          closeButton: true,
          buttons : {
      
              ok : {
                  label : "Add",
                  className: "btn-primary fa fa-save",
                  callback: function(event) {
                      $rootScope.updatedrugs = $rootScope.data1.concat($scope.deleted_drugs_arr)
                      console.log("$rootScope.updatedrugs ", $rootScope.updatedrugs )
  
                    //   console.log("array to be sent",  $rootScope.actualtag);
                      var vacgroup = [];
                      // for(var i=0;i<$rootScope.actualtag.length;i++){
                      //     vacgroup.push($rootScope.actualtag[i].name);
                      // }
                      var params = {
                          "data": $rootScope.updatedrugs,
                          "s_no": $rootScope.drug_sno,
                          "account_email": authService.authentication.account_id,
                          "id": data.id,
                          "doctor_id": 1
                      }
                      console.log("params", params);
                  
                      $http.post(serviceBaseUrl + 'savevaccinationbrandmaster/', params).success(function(response) {
                              console.log("response", response);
                              if(response.success == 1){
                                $rootScope.taginput = "";
                                $scope.deleted_drugs_arr = []
                                // $rootScope.Update_Record2()
                                VacService.getMaster_List(vm.pageName,vm.showAll).then(function(response){
                                    console.log("response 638", response)
                                    
                                    if(response.success == 1){
                                        vm.masterlist = response.details
                                        vm.updateSelectRecord2(response.details[$scope.refresh_updateSelectRecord_index])
                                    }
                          
                                })
                                  toastr.success(response.message);
                                  vm.reloadList();
                                //   self.getMasterList("vac-master", "active");
                                  
                                  
                                $scope.$apply();
                                  e.preventDefault()
                              }
                         }).error(function(error, status) {
                      });
                      
                  }
              },
              close : {
                  label: " Cancel",
                  className: "btn-danger fa fa-times-circle",
                  callback: function() {
                    $rootScope.taginput = "";
                    // $rootScope.data1.length = 0
                  }
              }
             
              
          }
      };
      $ngBootbox.customDialog(options);
  
  
    }
  
    vm.get_inventory_list = function(){
      VacService.get_inventory_details().then(function(response){
            console.log("111111", response)
            for(var i=0; i<response.message[0].length; i++){
                if(response.message[0][i].stock_quantity > 0){
                  response.message[0][i].stock_status = 'In Stock'
                } else {
                  response.message[0][i].stock_status = 'Out of Stock'
                }
            }
            $rootScope.getinventory_data = response.message[0]
  
        }),
        function(error,response){
          console.log("error",error,response);
        }
    }
  
    vm.get_inventory_list()
  
      $rootScope.updateinventory_data = function (vaccine_id, eshop_id, eshop_name) {
          var vacc_id = {
              "vaccine_id": vaccine_id
          }
          for (var i = 0; i < $scope.brand_inventory_arr.length; i++) {
              Object.assign($scope.brand_inventory_arr[i], vacc_id);
          }
          var params = {
              "account_email": authService.authentication.account_id,
              "vaccine_details": $scope.brand_inventory_arr
          }
          VacService.update_inventory(params).then(function (response) {
              console.log(response, "inventory")
          })
      }
  
    vm.reload_List = function(){
      VacService.getMaster_List(vm.pageName,vm.showAll).then(function(response){
            console.log("response 638", response)
            
            if(response.success == 1){
                vm.masterlist = response.details
                console.log("vm.masterlist", vm.masterlist);
            }
  
        }),
        function(error,response){
          console.log("error",error,response);
        }
    }
  
    vm.reload_List()
  
    vm.reloadList  = function (){
      VacService.getMasterList(vm.pageName,vm.showAll)
      .then(
        function(response){
          vm.records = response.vaccinations;
          angular.forEach(vm.records,function (v) {
              if (v.age_in_days == 0) {
                  v.due = "At Birth";
              } else if (v.age_in_days > 0 && v.age_in_days < 7) {
                  var age = v.age_in_days;
                  v.due = age + " Days";
              } else if (v.age_in_days < 99) {
                  var age = parseInt(v.age_in_days / 7);
                  v.due = age + " Weeks";
              }
             /* else if(v.age_in_days < 366){
                  var age = parseInt(v.age_in_days / 30);
                  v.due = age+" Months";
              } else {
                  var age = parseInt(v.age_in_days / 365);
                  v.due = age+" Years";
              } */
              else {
                  var age = parseInt(v.age_in_days) / 30.417;
                  v.due = Math.ceil(age) + " Months";
              }
          });
          VacService.setPageData(vm.records);
          VacService.SetSelected();
        },
        function(error,response){
          console.log("error",error,response);
        }
      );
    };
  
    vm.reloadList();
  
  
    $rootScope.closetags = function(data){
      for( var i = 0; i < $rootScope.data2.length; i++){ 
          console.log("$rootScope.data[i]", $rootScope.data2[i]);
          if ( $rootScope.data2[i] === data) {
              $rootScope.data2.splice(i, 1); 
          }
      
      }
    }
  
    $rootScope.change_inputs = function(){
      var val = document.getElementById('inputtags');
      $rootScope.data2.push(val.value);
      document.getElementById('inputtags').value = "";
    }
  
    $rootScope.changeinputs = function(){
      var val = document.getElementById('inputtags');
      val.addEventListener("keydown", function (e) {
          console.log("e", e);
        if (e.code === "Enter") {  //checks whether the pressed key is "Enter"
            if(e.target.value != ""){
                validates(e);
            }
        }
    });
  }
  
  $rootScope.data2 = []
  
  
  
  function validates(e) {
      var texts = e.target.value;
     console.log("text", texts);
     $rootScope.data2.push(texts);
    
     document.getElementById('inputtags').value = "";
  
  }
  
  
  $rootScope.Addmasterdataclear = function(){
      var data1 = $rootScope.addmastervaccine1;
      $rootScope.addmastervaccine1 = {
          "vaccinename": "",
          "vaccinedays":""
      }
  
      $rootScope.addmastervaccine = {
          "account_email": authService.authentication.account_id,
          "age_group": "",
          "name": "",
          "description": "",
          "disease": "",
          "gender": "",
          "site": "",
          "side_effects": "",
          "brands": "",
          "mandatory": "",
          "remarks": "",
          "message_url": "",
      }
      $ngBootbox.hideAll();
  }
  
  $rootScope.addmasterbrand = function(){
      
      var options = {
          title: "<h4 style='color:white'>Add Vaccine Brands</h4>",
          templateUrl : 'app/vac/addmasterbrand.html',
          size : 'lg',
  
          closeButton: true,
          buttons : {
      
              ok : {
                  label : "Add",
                  className: "btn-primary fa fa-save",
                  callback: function(event) {
                  
                   $rootScope.brandmaster   = $rootScope.data2
                   $rootScope.finalbrandlist = $rootScope.brandmaster
                   console.log("finalbrandlist", $rootScope.finalbrandlist);
                      
                  }
              },
              close : {
                  label: " Cancel",
                  className: "btn-danger fa fa-times-circle",
                  callback: function() {
  
                  }
              }
             
              
          }
      };
      $ngBootbox.customDialog(options);
  
  }
  
    $rootScope.Addmasterdata = function(){
  
      var data1 = $rootScope.addmastervaccine1;
      $rootScope.addmastervaccine1 = {
          "vaccinename": data1.vaccinename,
          "vaccinedays": data1.vaccinedays
      }
       console.log(" $rootScope.addmastervaccine1",  $rootScope.addmastervaccine1);
  
      if($rootScope.addmastervaccine1.vaccinename != ""){
          var dependence = $rootScope.addmastervaccine1.vaccinename +"+"+ $rootScope.addmastervaccine1.vaccinedays
      }
  
      console.log("dependence", dependence);
      if($rootScope.messageurl !== ""){
          $rootScope.messageur = $rootScope.messageurl
      }else{
          $rootScope.messageur = "";
      }
  
        var data = $rootScope.addmastervaccine
      var params = {
          "account_email": authService.authentication.account_id,
          "age_group": data.age_group,
          "name": data.name,
          "description": data.description,
          "disease": data.disease,
          "gender": data.gender,
          "site": data.site,
          "side_effects": data.side_effects,
          "mandatory": data.status,
          "dependency":dependence,
          "brands":$rootScope.finalbrandlist,
          "remarks": data.remarks,
          "message_url": $rootScope.messageur,
      }
  
      console.log("dataa  767", params); 
  
      if((data.site !== "") && (data.name !== "")&&(data.gender !== "") && (params.brands != undefined)){
          $http.post(serviceBaseUrl + 'savevaccinedetails/', params).success(function(response) {
              if(response.success == 1){
                  toastr.success(response.message);
                  vm.reload_List()
                  $ngBootbox.hideAll();
              } else {
                  toastr.error("Vaccination name alreay exists")
              }
          });
      }else{
          toastr.error("fill all mandatory fields")
      }
    }
  
  
  //   $rootScope.copying = function() {
  //     let textarea = document.getElementById("text_area");
  //     textarea.select();
  //     document.execCommand("copy");
  //   }
  
    $rootScope.Addmastervaccine = function(){
  
      $rootScope.Addmasterdataclear();
      var options = {
          title : "<h4 style='color:white'>ADD</h4>",
          templateUrl : 'app/vac/addmaster.html',
          size : 'md',
          closeButton: true,
          buttons : {         
              
          }
      };
      $ngBootbox.customDialog(options);
    }
  
    $rootScope.viewstock = function(){
  
      var options = {
          title : "<h4 style='color:white'>Stock data</h4>",
          templateUrl : 'app/vac/viewinventory.html',
          size : 'md',
          closeButton: true,
          buttons : {         
              
          }
      };
      $ngBootbox.customDialog(options);
    }
  
  $rootScope.Update_Record = function(){
       console.log("$rootScope.masterdata 660" , $rootScope.masterdata);
      $scope.drugs = []
       var data = $rootScope.masterdata;
       var drug = $rootScope.updatedrugs
      if (drug == '') {
          for (var i = 0; i < $rootScope.brandsdata.length; i++) {
              $scope.drugs.push($rootScope.brandsdata[i].brand_name)
          }
          //   $scope.drugs =  $rootScope.brandsdata
      } else {
          for (var i = 0; i < $rootScope.updatedrugs.length; i++) {
              $scope.drugs.push($rootScope.updatedrugs[i].brand)
          }
          //    $scope.drugs = drug;
      }
  
  
  
      if($rootScope.dependencydata.vaccinename != ''){
          var nextvac = $rootScope.dependencydata.vaccinename+"+"+$rootScope.dependencydata.vaccinedays;
      }
  
       var params = { 
          "account_email": authService.authentication.account_id,
          "id": data.id,
          "created_at": data.created_at,
          "modified_at": data.modified_at,
          "sno": data.sno,
          "days_after_birth": data.days_after_birth,
          "age_group": data.age_group,
          "brands": $scope.drugs,
          "dependency": nextvac,
          "name": data.name,
          "vaccineId": data.vaccineId,
          "with_doctor_id": data.with_doctor_id,
          "description": data.description,
          "creator_id": data.creator_id,
          "doctor_account_id": data.doctor_account_id,
          "status": data.status,
          "message_url": $rootScope.messageurl,
          "disease": data.disease,
          "gender": data.gender,
          "mandatory": data.mandatory,
          "remarks": data.remarks,
          "side_effects": data.side_effects,
          "site": data.site,
       }
       console.log("params", params)
  
       $http.post(serviceBaseUrl + 'updatevaccinedetails/', params).success(function(response) {
           if(response.success == 1){
               toastr.success(response.message);
               vm.reload_List()
               $ngBootbox.hideAll();
           } else {
               toastr.error("Vaccination name alreay exists")
           }
       });
       
  }
  
  vm.updateSelectRecord = function(data,index){
      $scope.refresh_updateSelectRecord_index = index
      $rootScope.data1 = []
       
          var brands_data = data.brands
          $rootScope.brandsdata = brands_data
       var dependencyvac = data.dependency;
       var dependencysplit = dependencyvac.split("+");
       var dependencyvaccinename = dependencysplit[1];
       var dependencyvaccinedays = dependencysplit[0];
  
       $rootScope.dependencydata={
           "vaccinedays": dependencyvaccinename ,
           "vaccinename": dependencyvaccinedays
       }
  
      $rootScope.masterdata = {
                  "id": data.id,
                  "created_at": data.created_at,
                  "modified_at": data.modified_at,
                  "sno": data.sno,
                  "days_after_birth": data.days_after_birth,
                  "age_group": data.age_group,
                  "brands": $rootScope.data1,
                  "dependency": data.dependency,
                  "name": data.name,
                  "vaccineId": data.vaccineId,
                  "with_doctor_id": data.with_doctor_id,
                  "description": data.description,
                  "creator_id": data.creator_id,
                  "doctor_account_id": data.doctor_account_id,
                  "status": data.status,
                  "message_url": data.message_url,
                  "disease": data.disease,
                  "gender": data.gender,
                  "mandatory": data.mandatory,
                  "remarks": data.remarks,
                  "side_effects": data.side_effects,
                  "site": data.site,
                //   "eshop_product_id" : data.eshop_product_id ,
                //   "eshop_product_name" : data.eshop_product_name
      }
  
      var options = {
          title : "<h4 style='color:white'>Update</h4>",
          templateUrl : 'app/vac/updatedetails.html',
          size : 'md',
          closeButton: false,
          buttons : {
              
          }
      };
      $ngBootbox.customDialog(options);
  }

      vm.updateSelectRecord2 = function (data) {
          var brands_data = data.brands
          $rootScope.brandsdata = brands_data
      }

      $rootScope.clearalldata = function () {
          $rootScope.masterdata = ""
          $rootScope.taginput = "";
          $scope.deleted_drugs_arr = []
          $scope.brand_inventory_arr = []
          $rootScope.data1 = []
          vm.reload_List()
          $ngBootbox.hideAll();
      }
  
      $rootScope.change_eshop_values = function (brandname, brandid, eshopdata) {
          var eshopdata = JSON.parse(eshopdata)
          if ($scope.brand_inventory_arr.length == 0) {
              $scope.brand_inventory_arr.push({
                  "brand_name": brandname,
                  "brand_id": brandid,
                  "eshop_product_id": eshopdata.id,
                  "eshop_product_name": eshopdata.name
              })
          }
          else if ($scope.brand_inventory_arr.length > 0) {
              for (var i = 0; i < $scope.brand_inventory_arr.length; i++) {
                  if ($scope.brand_inventory_arr[i].brand_name == brandname) {
                      $scope.brand_inventory_arr.splice(i, 1)
                      $scope.brand_inventory_arr.push({
                          "brand_name": brandname,
                          "brand_id": brandid,
                          "eshop_product_id": eshopdata.id,
                          "eshop_product_name": eshopdata.name
                      })
                      break;

                  } else {

                      $scope.brand_inventory_arr.push({
                          "brand_name": brandname,
                          "brand_id": brandid,
                          "eshop_product_id": eshopdata.id,
                          "eshop_product_name": eshopdata.name
                      })
                      break;
                  }
              }
          }
      }
  
    vm.openmedia = function(data){
        console.log("data", data);
        if(data.message_url != null){
  
          var startletter = data.message_url
          $rootScope.type = startletter.charAt(0)
          console.log("type",  $rootScope.type);
          if( $rootScope.type == 'i'){
              $rootScope.imagesource = "https://test.epicare.net/helyxonapi/cloud/image/upload/"+ data.message_url
          }else if( $rootScope.type == 'a'){
              $rootScope.audiosourc = "https://test.epicare.net/helyxonapi/cloud/mp3/upload/"+ data.message_url
              $rootScope.audiosource = $sce.trustAsResourceUrl($rootScope.audiosourc)
              console.log("$rootScope.audiosource", $rootScope.audiosource);
          }else if( $rootScope.type == 'v'){
              $rootScope.videosourc = "https://test.epicare.net/helyxonapi/cloud/image/upload/"+ data.message_url
              $rootScope.videosource = $sce.trustAsResourceUrl($rootScope.videosourc);
          }else if($rootScope.type == 't'){
              var text = data.message_url;
              var text1 = text.split("-");
              console.log("text1", text1);
              $rootScope.EnteredText = text1[1]
  
          }else if($rootScope.type == 'h'){
                $rootScope.link_source = data.message_url;
          }
        }else{
            toastr.error("Upload Media")
        }
    var options = {
        title : "<h4 style='color:white'>Media</h4>",
        templateUrl : 'app/vac/viewmedia.html',
        size : 'lg',
        closeButton: true,
        buttons : {         
            
        }
    };
    $ngBootbox.customDialog(options);
  }
  
    vm.SelectRecord  = function (rec){
      vm.selected = rec;
      VacService.SetSelected(vm.selected);
    };
  
    vm.AddRecord = function (){
        angular.forEach(vm.records,function(row){
          if (row.new){
            VacService.AddRecord(vm.pageName,row).
            then(
              function(response){
                row.new = false;
                toastr.success(response.message);
              },
              function(error,response){
                console.log("error",error,response);
                toastr.error(error.error);
              }
            );
          }
        });
    };
  }/*End controller*/
  
  
  /** @ngInject */
  // function VacContentCtrl(VacService, toastr, $ngBootbox, $location, $interval) {
  //   var vm = this;
  //   vm.showAll = "active";
  //   vm.pageName = "vac-content";
  //   VacService.setPageName(vm.pageName);
  
  //   $interval(function(){
  //     vm.showSave = false;
  //     angular.forEach(vm.records,function(row){
  //       if (row.new){
  //         vm.showSave = true;
  //       }
  //     });
  //     /*Reload after update*/
  //     if (VacService.getReloadMaster()){
  //       vm.reloadList();
  //     }
  //   }, 1000);
  
  //   vm.reloadList  = function (){
  //     VacService.getMasterList(vm.pageName,vm.showAll)
  //     .then(
  //       function(response){
  //         vm.records = response.contents_list;
  //         VacService.setPageData(vm.records);
  //         VacService.SetSelected();
  //       },
  //       function(error,response){
  //         console.log("error",error,response);
  //       }
  //     );
  //   };
  
  //   vm.reloadList();
  
  //   vm.SelectRecord  = function (rec){
  //     vm.selected = rec;
  //     VacService.SetSelected(vm.selected);
  //   };
  
  //   vm.AddRecord = function (){
  //       angular.forEach(vm.records,function(row){
  //         if (row.new){
  //           VacService.AddRecord(vm.pageName,row).
  //           then(
  //             function(response){
  //               row.new = false;
  //               toastr.success(response.response);
  //             },
  //             function(error,response){
  //               console.log("error",error,response);
  //               toastr.error(error.error);
  //             }
  //           );
  //         }
  //       });
  //   };
  // } /*End controller*/
  
  
  /*Setup the Module*/
  angular.module("RxC.pages.Vac", ['buds.store'])
  .config(routeConfig)
  .service("VacService", VacService)
  .controller("ListEditCtrl", ListEditCtrl)
  .controller("VacCtrl", VacCtrl)
  // .controller("VacContentCtrl",VacContentCtrl)
  ;
  
  })();
   /**
    * @author Helyxon
    * created on Dec 2016
    */
   (function () {
    'use strict';
  
    /** @ngInject */
    function routeConfig($routeProvider) {
        $routeProvider
            .when("/apt-config", {
                templateUrl: 'app/apt-config/view.tpl.html',
                controllerAs: "config",
                controller: "AptConfigCtrl"
            })
            .when("/leave-plan", {
                templateUrl: 'app/apt-config/plan.html',
                controller: "appointmentController"
            });
    }
  
    /** @ngInject */
    function AptConfigService($http, $q, BudsStore, SettingsService) {
        var self = {};
        BudsStore.reset();
        return self;
    }
  
    /** @ngInject */
  -    function AptConfigCtrl(AptConfigService, BudsStore, RxCUtils, SettingsService, ScheduleService, locationService, toastr, authService, $ngBootbox, WizardHandler, $location) {
  +    function AptConfigCtrl(AptConfigService, BudsStore, RxCUtils, SettingsService, ScheduleService, locationService, toastr, authService, $ngBootbox, WizardHandler, $location, $q) {
        var vm = this;
        // vm.settings = {
        //   avg_time_per_patient:4,
        //   appointment_system:"token",
        //   emergency_call:false
        // };
        vm.getLocationStatus = function () {
            locationService.getSettings().then(function (response) {
                if (response.multilocation) {
                    vm.locationStatus = response.multilocation;
                    if (vm.locationStatus == 1) {
                        vm.loadLocationList();
                    }
                    else {
  
                    }
                }
                else {
                    vm.locationStatus = 0;
                    vm.locationList = [];
                }
  
            }, function (error) {
                toastr.error(error);
            })
        };
  
        vm.loadLocationList = function () {
            locationService.getLocation().then(function (response) {
                vm.locationList = [];
                angular.forEach(response, function (value) {
                    vm.locationList.push(value.location);
                });
            }, function (error) {
                toastr.error(error);
            })
        };
  
        vm.getLocationStatus();
  
        vm.saveStep1 = function () {
            if (vm.settings.emergency_call == undefined) {
                vm.settings.emergency_call = false;
            }
           
            if (!isValidSchedule(vm.sessions)) {
                return;
            }
  
              vm.checkAppointmentTimeValidationAsync(vm.sessions).then(function(message) {                
                  if(vm.slotsNotValid==false) {
  
                      var payload = preparePayloadForSaveSchedule(vm.sessions);
                      vm.sch = payload;
      
                      if (payload.data.schedule.length > 0) {
                              var saveScheduleData = {
                                  "account_email": authService.authentication.account_id,
                                  "config": vm.settings,
                                  "schedule": payload.data.schedule,
                                  "doctor_id": authService.authentication.doctor_id
                              }
                      } else {
                          toastr.error("Please fill location in all the Sessions");
                      }
                          
                          ScheduleService.saveSchedule(saveScheduleData)
                              .then(function (response) {
                                  WizardHandler.wizard().cancel();
                                  //vm.reconfig=false;
                                  vm.getSchedule();
                                  toastr.success("Appointment settings configuration saved");
                          });
      
                } else {
        
      
                      vm.invalidTimeAlert();
                  }  
              }, function(message) {
                  vm.ruleValidationConsent(message.join(', '),'Reconfigure Appointent schedule?');
              });             
        };
  
        vm.changepath = function () {
            $location.path('/leave-plan');
        }
  
        vm.checkNonNegative = function () {
            if (vm.settings.avg_time_per_patient < 0 || !vm.settings.avg_time_per_patient) {
                vm.settings.avg_time_per_patient = 4;
            }
        };
  
        vm.manageSession = function (action, index) {
            console.log('manageSession',action, index);
            if (action === "remove") {
                vm.sessions.splice(index, 1);
                vm.strtHrs.splice(index, 1);
                vm.endHrs.splice(index, 1);
            } else {
  
                if( vm.slotsNotValid==false ) {
                    vm.sessions.push({ days: angular.copy(days) });
                    vm.reconfig = true;
                   
                } else {
                    vm.invalidTimeAlert();
                }
            }
        };
  
        vm.invalidTimeAlert = function () {
            var options = {
                message: 'The time required to complete the consultations configured is more than the session time, please adjust the slot counts.',
                title: 'Invalid time range',
                buttons: {
                    // warning: {
                    //     label: "Cancel",
                    //     className: "btn-warning"
                    // },
                    success: {
                        label: "Ok",
                        className: "btn-success",
                        callback: function () {
                            WizardHandler.wizard().next();
                        }
                    }
                }
            };
            $ngBootbox.customDialog(options);
        };
  
        vm.getSchedule = function () {
            vm.reconfig = false;
            vm.savedStep1 = false;
            vm.savedStep2 = false;
            vm.loaded = false;
            ScheduleService.getSchedule().then(function (response) {
                vm.schedule = response;
                vm.settings = response.config;
                if (vm.settings.appointment_system == undefined) {
                   vm.settings.appointment_system = "token";
                } 
  
                var sessions={};
                var sessions2={};
                var timeArray=[];
                if (vm.locationStatus == 0) {
                    /*Format data as required by UI*/
                    angular.forEach(vm.schedule.schedule, function (item) {
                        /*Strip off time zzz*/
                        item.start_time = RxCUtils.toLocalTime(item.start_time);//item.start_time.slice(0,5);
                        item.end_time = RxCUtils.toLocalTime(item.end_time); // item.end_time.slice(0,5);
                        item.key = item.start_time;
                        item.location = null;
                        sessions2[item.start_time] = item;
                        timeArray.push(sessions2[item.start_time].start_time);
                    });
                    var dateArr = timeArray.sort(function (a, b) {
                        return new Date('1970/01/01 ' + a) - new Date('1970/01/01 ' + b);
                    });
                  
                    angular.forEach(timeArray,function(item2){
                        angular.forEach(sessions2,function(item1){
                          if(item1.start_time==item2){
                            sessions[item1.start_time] = item1; 
                          }              
                        });
                    });
                    
                } else {
                    /*Format data as required by UI*/
                    angular.forEach(vm.schedule.schedule, function (item) {
                        /*Strip off time zzz*/
                        item.start_time = RxCUtils.toLocalTime(item.start_time); //item.start_time.slice(0,5);
                        item.end_time = RxCUtils.toLocalTime(item.end_time); // item.end_time.slice(0,5);
                        item.key = item.start_time;
                        sessions2[item.start_time] = item;
                        timeArray.push(sessions2[item.start_time].start_time);
                    });
                    var dateArr = timeArray.sort(function (a, b) {
                        return new Date('1970/01/01 ' + a) - new Date('1970/01/01 ' + b);
                    });
                  
                    angular.forEach(timeArray,function(item2){
                        angular.forEach(sessions2,function(item1){
                          if(item1.start_time==item2){
                            sessions[item1.start_time] = item1; 
                          }              
                        });
                    });               
                }
  
                var sArray = [];
                angular.forEach(sessions, function (item) {
                    sArray.push(item);
                });
  
                vm.strtHrs = [];
                vm.endHrs = [];
  
                for (var i = 0; i < sArray.length; i++) {
  
                    var strtArray = [];
                    var endArray = [];
  
                    var splitStartAP = sArray[i].start_time.split(" ");
                    var splitStartT = sArray[i].start_time.split(":");
  
                    var splitEndAP = sArray[i].end_time.split(" ");
                    var splitEndT = sArray[i].end_time.split(":");
  
                    if (splitStartAP[1] == "am") {
  
                        if (splitStartT[0] == "12") {
  
                            if (splitStartT[1] == "30 am") {
                                strtArray.push("0H");
                            } else {
                                strtArray.push("0");
                            }
                        }
  
                        if (splitStartT[0] != "12") {
  
                            if (parseInt(splitStartT[0]) < parseInt(splitEndT[0])) {
  
                                var tempSt = parseInt(splitStartT[0]);
                                var tempEd = parseInt(splitEndT[0]);
  
                                for (var j = tempSt; j < tempEd; j++) {
  
                                    if (tempEd == j) {
                                        strtArray.push(j + "");
  
                                        if (splitEndT[1] == "30 am") {
                                            strtArray.push(j + "H");
                                        }
                                    } else {
                                        if (tempSt == j) {
  
                                            if (splitStartT[1] == "30 am") {
                                                strtArray.push(j + "H");
                                            } else {
  
                                                strtArray.push(j + "");
                                                strtArray.push(j + "H");
                                            }
  
                                        } else {
                                            strtArray.push(j + "");
                                            strtArray.push(j + "H");
                                        }
                                    }
  
                                }
                            }
  
                            /*  if(splitStartT[1]=="30") {
                                  strtArray.push( splitStartT[0]+"H" );
                                } else {
                                  strtArray.push( splitStartT[0] );
                                } */
  
                        }
  
  
                    } else if (splitStartAP[1] == "pm") {
  
                        //alert("pm");
  
                        if (splitStartT[0] == "12") {
                            strtArray.push(splitStartT[0]);
  
                            if (splitStartT[1] == "30 pm") {
                                strtArray.push(splitStartT[0] + "H");
                            } else {
                                strtArray.push(splitStartT[0]);
                            }
                        }
  
  
                        if (splitStartT[0] != "12") {
  
                            /*   if(splitStartT[1]=="30"){
                                 strtArray.push( (parseInt(splitStartT[0])+12) +"H" );
                               }else{
                                 strtArray.push( (parseInt(splitStartT[0])+12) +"" );
                               }  */
  
  
  
                            if ((parseInt(splitStartT[0]) + 12) < (parseInt(splitEndT[0]) + 12)) {
  
                                var tempSt = parseInt(splitStartT[0]) + 12;
                                var tempEd = parseInt(splitEndT[0]) + 12;
  
                                for (var k = tempSt; k < tempEd; k++) {
  
                                    if (tempEd == k) {
                                        strtArray.push(k + "");
                                        //alert(splitEndT[1]);
                                        if (splitEndT[1] == "30 pm") {
                                            strtArray.push(k + "H");
                                        }
                                    } else {
                                        if (tempSt == k) {
  
                                            if (splitStartT[1] == "30 m") {
                                                strtArray.push(k + "H");
                                            } else {
  
                                                strtArray.push(k + "");
                                                strtArray.push(k + "H");
                                            }
  
                                        } else {
                                            strtArray.push(k + "");
                                            strtArray.push(k + "H");
                                        }
                                    }
  
                                }
                            }
  
  
                        }
                    }
  
  
                    if (splitEndAP[1] == "am") {
  
                        if (splitEndT[0] == "12") {
  
                            if (splitEndT[1] == "30 am") {
                                endArray.push("0H");
                            } else {
                                endArray.push("0");
                            }
                        }
  
                        if (splitEndT[0] != "12") {
  
                            if (parseInt(splitStartT[0]) < parseInt(splitEndT[0])) {
  
                                var tempSt = parseInt(splitStartT[0]);
                                var tempEd = parseInt(splitEndT[0]);
  
                                for (var j = tempSt; j <= tempEd; j++) {
  
                                    if (tempEd == j) {
                                        endArray.push(j + "");
  
                                        if (splitEndT[1] == "30 am") {
                                            endArray.push(j + "H");
                                        }
                                    } else {
                                        if (tempSt == j) {
  
                                            if (splitStartT[1] == "30 am") {
                                                endArray.push(j + "H");
                                            } else {
  
                                                // endArray.push(j+""); 
                                                endArray.push(j + "H");
                                            }
  
                                        } else {
                                            endArray.push(j + "");
                                            endArray.push(j + "H");
                                        }
  
  
                                    }
  
                                }
                            }
  
                            /*  if(splitStartT[1]=="30"){
                                  strtArray.push( splitStartT[0]+"H" );
                                }else{
                                  strtArray.push( splitStartT[0] );
                                } */
  
                        }
  
  
                    } else if (splitEndAP[1] == "pm") {
  
                        //alert("pm");
  
                        if (splitEndT[0] == "12") {
                            endArray.push(splitStartT[0]);
  
                            if (splitEndT[1] == "30 pm") {
                                endArray.push(splitEndT[0] + "H");
                            } else {
                                endArray.push(splitEndT[0]);
                            }
                        }
  
  
                        if (splitEndT[0] != "12") {
  
                            /*   if(splitStartT[1]=="30"){
                                  strtArray.push( (parseInt(splitStartT[0])+12) +"H" );
                                }else{
                                  strtArray.push( (parseInt(splitStartT[0])+12) +"" );
                                }  */
  
  
  
                            if ((parseInt(splitStartT[0]) + 12) < (parseInt(splitEndT[0]) + 12)) {
  
                                var tempSt = parseInt(splitStartT[0]) + 12;
                                var tempEd = parseInt(splitEndT[0]) + 12;
  
                                for (var k = tempSt; k <= tempEd; k++) {
  
                                    if (tempEd == k) {
                                        endArray.push(k + "");
                                        //alert(splitEndT[1]);
                                        if (splitEndT[1] == "30 pm") {
                                            endArray.push(k + "H");
                                        }
                                    } else {
                                        if (tempSt == k) {
  
                                            if (splitStartT[1] == "30 pm") {
                                                endArray.push(k + "H");
                                            } else {
  
                                                //endArray.push(k+""); 
                                                endArray.push(k + "H");
                                            }
  
                                        } else {
                                            endArray.push(k + "");
                                            endArray.push(k + "H");
                                        }
                                    }
  
                                }
                            }
  
                        }
                    }
  
                    vm.strtHrs.push(strtArray);
                    vm.endHrs.push(endArray);
  
                }
  
                vm.sessions = sArray;
  
                /* var sArray = [], sArray2 = [], sArray3 = [];
                   angular.forEach(sessions,function(item){
                     sArray2.push(item);
                   });
                   var objct1  = sArray2[0];
                   var objct2  = {"ivrs":0};
                   var sArray3 = Object.assign(objct1, objct2);
                   sArray.push(sArray3);
                   vm.sessions = sArray; */
  
                /*IF NO SESSIONS ADD A ROW*/
                if (sArray.length === 0) {
                    vm.manageSession('add', 0);
                }
                vm.reconfig = false;
                angular.forEach(vm.sessions, function (item) {
                    /*Create all sessions from schedules*/
                    item.days = angular.copy(days);
                    angular.forEach(vm.schedule.schedule, function (s) {
                        /*Create days array*/
                        if (s.start_time === item.key) {
                            if (s.day_of_week === "0") {
                                item.days.mon = true;
                            } else if (s.day_of_week === "1") {
                                item.days.tue = true;
                            } else if (s.day_of_week === "2") {
                                item.days.wed = true;
                            } else if (s.day_of_week === "3") {
                                item.days.thu = true;
                            } else if (s.day_of_week === "4") {
                                item.days.fri = true;
                            } else if (s.day_of_week === "5") {
                                item.days.sat = true;
                            } else if (s.day_of_week === "6") {
                                item.days.sun = true;
                            }
                        }
                    });
                });
                vm.loaded = true;
            }, function (err, response) {
                vm.loaded = true;
                vm.sessions = [];
            });
  
        };
  
        vm.saveStep2 = function () {
            if (!isValidSchedule(vm.sessions)) {
                return;
            }
            var payload = preparePayloadForSaveSchedule(vm.sessions);
            vm.sch = payload;
  
            if (payload.data.schedule.length > 0) {
                ScheduleService.saveSchedule(payload).then(function (response) {
                    vm.savedStep2 = true;
                    toastr.success("Schedule changes saved.");
                });
            } else {
                toastr.error("Please fill location in all the Sessions");
            }
  
        };
  
        vm.goToPrepareStep = function () {
            if (!isValidSchedule(vm.sessions)) {
                return;
            }
  
            WizardHandler.wizard().next();
  
        };
  
        function isValidSchedule(sessions) {
            var sSlots = [], eSlots = [];
            var inputError = false;
            angular.forEach(sessions, function (session) {
                sSlots.push(session.start_time);
                eSlots.push(session.end_time);
                if (!session.start_time || !session.end_time || !(session.offline || session.online) ||
                    !(session.days.mon || session.days.tue || session.days.wed || session.days.thu || session.days.fri || session.days.sat || session.days.sun)) {
                    inputError = true;
                }
            });
  
            if (inputError) {
                toastr.error("Start Time, End Time, Appointment Type and atleast one day is required.");
                return false;
            }
  
            if (RxCUtils.hasDupesInArray(sSlots) || RxCUtils.hasDupesInArray(eSlots)) {
                toastr.error("Start Time, End Time should not be duplicated.");
                return false;
              }            
            return true;
        }
  
        vm.prepareSchedule = function () {
            ScheduleService.prepareSchedule({
                "date": vm.prepare.date.toString().slice(4, 15),
                "appointment_system": vm.settings.appointment_system,
                "doctor_id": authService.authentication.doctor_id
            })
                .then(function (response) {
                    WizardHandler.wizard().cancel();
                    vm.reconfig = false;
                    toastr.success("Schedule prepared till date : " + vm.prepare.date.toLocaleDateString().split('/').reverse().join('-'));
                    vm.getSchedule();
                });
        };
  
        function covert24Hrs(dateVal) {
            //var time = $("#starttime").val();
            var time = dateVal;
            var hours = Number(time.match(/^(\d+)/)[1]);
            var minutes = Number(time.match(/:(\d+)/)[1]);
            var AMPM = time.match(/\s(.*)$/)[1];
            if (AMPM == "pm" && hours < 12) hours = hours + 12;
            if (AMPM == "am" && hours == 12) hours = hours - 12;
            var sHours = hours.toString();
            var sMinutes = minutes.toString();
            if (hours < 10) sHours = "0" + sHours;
            if (minutes < 10) sMinutes = "0" + sMinutes;
         return sHours + ":" + sMinutes;
        }
  
        function preparePayloadForSaveSchedule(sessions) {
            /*Format payload for service*/
            var Monday = { "day": 0, "items": [] };
            var Tuesday = { "day": 1, "items": [] };
            var Wednesday = { "day": 2, "items": [] };
            var Thursday = { "day": 3, "items": [] };
            var Friday = { "day": 4, "items": [] };
            var Saturday = { "day": 5, "items": [] };
            var Sunday = { "day": 6, "items": [] };
  
            angular.forEach(sessions, function (item) {
  
                var startTime, endTime;
                if ((vm.locationList.length == 0 && item.location == null) || (vm.locationList.length > 0 && item.location != null)) {
                    startTime = item.start_time;
                    endTime = item.end_time;
  
                    /*  if (item.start_time.slice(5)==="PM"||item.start_time.slice(5)===" PM"){
                            startTime = (parseInt(item.start_time.split(" ")[0]) + 12).toString() + ":" + item.start_time.split(" ")[0].split(":")[1];            
                        }
                        if (item.end_time.slice(5)==="PM"||item.end_time.slice(5)===" PM"){
                            endTime = (parseInt(item.end_time.split(" ")[0]) + 12).toString() + ":" + item.end_time.split(" ")[0].split(":")[1];           
                        }       
                        if (item.start_time.slice(5)==="AM"||item.start_time.slice(5)===" AM"){
                            startTime = (parseInt(item.start_time.split(" ")[0])).toString() + ":" + item.start_time.split(" ")[0].split(":")[1];      
                        }
                        if (item.end_time.slice(5)==="AM"||item.end_time.slice(5)===" AM"){
                            endTime = (parseInt(item.end_time.split(" ")[0])).toString() + ":" + item.end_time.split(" ")[0].split(":")[1];
                        } */
  
                    startTime = covert24Hrs(item.start_time);
                    endTime = covert24Hrs(item.end_time);
  
                    var sTime = RxCUtils.toGMTTime(startTime);
                    var eTime = RxCUtils.toGMTTime(endTime);
  
                    if (item.location == undefined) {
                        item.location = null;
                    }
  
                    item.online = item.online ? item.online : 0;
                    item.ivrs = item.ivrs ? item.ivrs : 0;
                    item.web = item.web ? item.web : 0;
                    item.tele = item.tele ? item.tele : 0;
                    item.offline = item.offline ? item.offline : 0;
  
                    if (item.days.mon) {
                        Monday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.tue) {
                        Tuesday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.wed) {
                        Wednesday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.thu) {
                        Thursday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.fri) {
                        Friday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.sat) {
                        Saturday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                    if (item.days.sun) {
                        Sunday.items.push({ "start_time": sTime, "end_time": eTime, "online": item.online, "ivrs": item.ivrs, "web": item.web, "tele": item.tele, "offline": item.offline, "location": item.location });
                    }
                }
  
            });
  
  
            var payload = {
                "data": { "schedule": [] }
            };
  
            if (Monday.items.length > 0) {
                payload.data.schedule.push(Monday);
            }
            if (Tuesday.items.length > 0) {
                payload.data.schedule.push(Tuesday);
            }
            if (Wednesday.items.length > 0) {
                payload.data.schedule.push(Wednesday);
            }
            if (Thursday.items.length > 0) {
                payload.data.schedule.push(Thursday);
            }
            if (Friday.items.length > 0) {
                payload.data.schedule.push(Friday);
            }
            if (Saturday.items.length > 0) {
                payload.data.schedule.push(Saturday);
            }
            if (Sunday.items.length > 0) {
                payload.data.schedule.push(Sunday);
            }
            return payload;
        }
  
        vm.totalTime = 0;
  
        vm.timeCal = function (item, slot_type) {
            var timeDiff = {
                startTime1: '',
                endTime1: '',
                duration: '',
                hours: '',
                minutes: ''
            }
            timeDiff.startTime1 = moment(item.start_time, "HH:mm A");
            timeDiff.endTime1 = moment(item.end_time, "HH:mm A");
            timeDiff.duration = moment.duration(timeDiff.endTime1.diff(timeDiff.startTime1));
            timeDiff.hours = parseInt(timeDiff.duration.asHours());
            timeDiff.minutes = parseInt(timeDiff.duration.asMinutes()) % 60;
            vm.totalHours = parseInt( (timeDiff.hours*60) + timeDiff.minutes );
            
            if( slot_type == 'inperson' ) {
                return parseInt( ( ( (timeDiff.hours/2) * 60 ) + (timeDiff.minutes/2) ) / vm.settings.avg_time_per_patient );
            } else if( slot_type == 'tele' ) {
                return parseInt( ( ( (timeDiff.hours/2) * 60 ) + (timeDiff.minutes/2) ) / vm.settings.avg_time_per_patient_tele );
            }    
        };
  
        vm.offlineNum = 0 ;
        vm.teleNum = 0;
        vm.totalSlotTime = 0; 
        vm.slotsNotValid=false;
  
        vm.calculateOnlineOffline = function (data) {
  
            //alert('calc');
            
            if (data.start_time && data.end_time) {
  
                //alert('calc2');
  
                // data.offline = vm.timeCal(data, 'inperson');
                // data.tele = vm.timeCal(data, 'tele');
  
                //offlineNum = vm.timeCal(data, 'inperson');
                //teleNum = vm.timeCal(data, 'tele');
  
                // data.offline = vm.timeCal(data, 'inperson');
                // data.tele = vm.timeCal(data, 'tele');
                // data.total = data.offline + data.tele; 
  
                vm.offlineNum = vm.timeCal(data, 'inperson');
                vm.teleNum = vm.timeCal(data, 'tele');
  
                if ( (vm.offlineNum+vm.teleNum) < 0) {
                    toastr.error('Invalid time range');
                    data.end_time = data.start_time;
                    data.offline = 0;
                    data.total = 0;
                    data.online = 0;
                    data.web = 0;
                    data.tele = 0;
                    //vm.slotsNotValid=false;
                } else {
  
                    if( vm.settings.avg_time_per_patient && vm.settings.avg_time_per_patient_tele ) {
  
                            vm.totalSlotTime = parseInt( ( vm.settings.avg_time_per_patient *  vm.offlineNum ) + ( vm.settings.avg_time_per_patient_tele * vm.teleNum ) );
                            
                            // console.log('vm.totalSlotTime',  vm.totalSlotTime);
                            // console.log('vm.totalHours', vm.totalHours);
                            //alert( 'Total time: '+ vm.totalHours  + 'Total slot time: ' +vm.totalSlotTime);
  
                            if( vm.totalHours >= vm.totalSlotTime){
  
                                if(vm.totalSlotTime <= vm.totalHours){
                                     vm.timevariance = vm.totalHours - vm.totalSlotTime;
                                
                                     if(vm.settings.avg_time_per_patient  <= vm.timevariance){
                                        //  console.log('offline floor',Math.floor(vm.timevariance/vm.settings.avg_time_per_patient));
                                                    vm.offlineNum += Math.floor(vm.timevariance/vm.settings.avg_time_per_patient) ;
                                                    // console.log('offline', vm.offlineNum)
                                                    vm.timevariance =  vm.timevariance - vm.settings.avg_time_per_patient;    
                                    }
                                    
                                    if(vm.settings.avg_time_per_patient_tele <= vm.timevariance){
                                        //    console.log('in-floor',Math.floor(vm.timevariance/vm.settings.avg_time_per_patient_tele));
                                            vm.teleNum += Math.floor(vm.timevariance/vm.settings.avg_time_per_patient_tele);
                                            // console.log('In',vm.teleNum);
                                            vm.timevariance =  vm.timevariance - vm.settings.avg_time_per_patient_tele;     
                                    }
  
                                }
                            
                                data.offline = vm.offlineNum; 
                                data.tele = vm.teleNum;          
                                data.total = data.offline + data.tele; 
                                data.offline = vm.offlineNum; 
                                data.web = 0;       
                                data.online = 0; 
                                data.ivrs = 0;      
                                
                                vm.slotsNotValid=false;
  
                            } else {
                                vm.slotsNotValid=true;
                                vm.invalidTimeAlert();
                                data.total = 0;
                                data.offline = 0;
                                data.web = 0;       
                                data.online = 0; 
                                data.ivrs = 0;
  
                            }
                    
                    } else if(vm.settings.avg_time_per_patient){
                        vm.totalSlotTime = parseInt( ( vm.settings.avg_time_per_patient *  vm.offlineNum ));
                        if( vm.totalHours >= vm.totalSlotTime){
  
                            if(vm.totalSlotTime <= vm.totalHours){
                                 vm.timevariance = vm.totalHours - vm.totalSlotTime;
                            
                                 if(vm.settings.avg_time_per_patient  <= vm.timevariance){
                                                vm.offlineNum += Math.floor(vm.timevariance/vm.settings.avg_time_per_patient);
                                                vm.timevariance =  vm.timevariance - vm.settings.avg_time_per_patient;    
                                }
                            }
                        
                            data.offline = vm.offlineNum;        
                            data.total = data.offline ; 
                            data.offline = vm.offlineNum; 
                            data.web = 0;       
                            data.online = 0; 
                            data.ivrs = 0;      
                            
                            vm.slotsNotValid=false;
  
                        }
                    }
                }
            }
        };
  
        vm.timeCheck = function (data, time) {
  
            //alert('time check..');
            if (time == "startTime") {
  
                var strArr;
                var strBool;
  
                var splitStartAP = data.start_time.split(" ");
                var splitStartT = data.start_time.split(":");
                if (splitStartAP[1] == "am") {
  
                    if (splitStartT[0] == "12") {
  
                        if (splitStartT[1] == "30 am") {
                            strArr = "0";
                        } else {
  
                            strArr = "0H";
                        }
  
                    }
  
                    if (splitStartT[0] != "12") {
  
                        if (splitStartT[1] == "30 am") {
                            strArr = splitStartT[0] + "H";
                        } else {
                            strArr = splitStartT[0];
                        }
                    }
  
  
                } else if (splitStartAP[1] == "pm") {
  
                    if (splitStartT[0] == "12") {
                        if (splitStartT[1] == "30 pm") {
                            strArr = "12H";
                        } else {
                            strArr = "12";
                        }
                    }
  
                    if (splitStartT[0] != "12") {
  
                        if (splitStartT[1] == "30 pm") {
                            strArr = (parseInt(splitStartT[0]) + 12) + "H";
                        } else {
                            strArr = (parseInt(splitStartT[0]) + 12) + "";
                        }
  
                    }
                }
  
                // alert(strArr);
  
                angular.forEach(vm.strtHrs, function (value) {
  
                    for (var i = 0; i < value.length; i++) {
  
                        if (strArr == value[i]) {
                            strBool = true;
                        }
                    }
  
                });
  
                if (strBool == true) {
                    toastr.error('Time already taken.');
                    data.start_time = "";
  
                } else {
   
                    vm.calculateOnlineOffline(data);
                }
  
  
            } else if (time == "endTime") {
  
                var endArr;
                var endBool;
  
                var splitEndAP = data.end_time.split(" ");
                var splitEndT = data.end_time.split(":");
  
                if (splitEndAP[1] == "am") {
  
                    if (splitEndT[0] == "12") {
  
                        if (splitEndT[1] == "30 am") {
                            endArr = "0";
                        } else {
  
                            endArr = "0H";
                        }
  
                    }
  
                    if (splitEndT[0] != "12") {
  
                        if (splitEndT[1] == "30 am") {
                            endArr = splitEndT[0] + "H";
                        } else {
                            endArr = splitEndT[0];
                        }
                    }
  
  
                } else if (splitEndAP[1] == "pm") {
  
                    if (splitEndT[0] == "12") {
                        if (splitEndT[1] == "30 pm") {
                            endArr = "12H";
                        } else {
                            endArr = "12";
                        }
                    }
  
                    if (splitEndT[0] != "12") {
  
                        if (splitEndT[1] == "30 pm") {
                            endArr = (parseInt(splitEndT[0]) + 12) + "H";
                        } else {
                            endArr = (parseInt(splitEndT[0]) + 12) + "";
                        }
  
                    }
                }
  
                //alert(endArr)
                angular.forEach(vm.endHrs, function (value) {
                    for (var i = 0; i < value.length; i++) {
                        if (endArr == value[i]) {
                            endBool = true;
                        }
                    }
                });
  
                if (endBool == true) {
                    toastr.error('Time already taken.');
                    data.end_time = "";
                } else {
           
                    vm.calculateOnlineOffline(data);
                }
            } else {
  
                vm.calculateOnlineOffline(data);
            }
        }
  
          vm.timeChanged = function (data, time) { 
            vm.timeCheck(data, time);
        }
  
  
          vm.avgTimeChanged = function (data) {    
            angular.forEach(data, function (value) {
                vm.timeChanged(value);
            });
        }
  
        vm.changeIvrs = function (data) {
            data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
        };
  
        vm.changeWeb = function (data) {
            data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
        };
  
  
          vm.changeTele = function (data) {            
            data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
        };
  
        vm.changeOnline = function (data) {
            if (!data.total) {
                vm.calculateOnlineOffline(data);
            }
            if (data.total == data.offline) {
                data.offline = 0;
            }
            if (data.online < data.total) {
                if (data.offline != 0) {
  
                    //alert('offline not zero..');
  
                    data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
                } else {
                   
                       // alert('ivrs not zero');
                        if(data.ivrs!=0) {
                            data.ivrs = data.total - ( data.online + data.web + data.tele );
                        } else if(data.web!=0) {
                            data.web = data.total - ( data.online + data.ivrs + data.tele );
                        } else if(data.tele!=0) {
                            data.tele = data.total - ( data.online + data.web + data.ivrs);
                        } else {
                            data.offline = data.total - data.online; 
                        }
  
                        //data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
                    
                }
            } else if (data.online == data.total) {
                data.ivrs = 0;
                data.offline = 0;
                data.tele = 0;
                data.web = 0;
  
            } else if ( (data.online + data.ivrs + data.web + data.tele ) == data.total ) {
                data.offline = 0;
            }
        };
  
        vm.changeIvrs = function (data) {
            if (!data.total) {
                vm.calculateOnlineOffline(data);
            }
            if (data.total == data.offline) {
                data.offline = 0;
            }
            if (data.ivrs  < data.total) {
                if (data.offline != 0) {
                    data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
                } else {
               
                        if(data.online!=0) {
                            data.online = data.total - ( data.ivrs + data.web + data.tele );
                        } else if(data.web!=0) {
                            data.web = data.total - ( data.ivrs + data.online + data.tele );
                        } else if(data.tele!=0) {
                            data.tele = data.total - ( data.ivrs + data.web + data.online);
                        }else {
                            data.offline = data.total - data.ivrs; 
                        }
                   
                }
            } else if (data.ivrs == data.total) {
                data.online = 0;
                data.offline = 0;
                data.tele = 0;
                data.web = 0;
            } else if ((data.online + data.ivrs + data.web + data.tele) == data.total) {
                data.offline = 0;
            }
        };
  
        vm.changeWeb = function (data) {
            if (!data.total) {
                vm.calculateOnlineOffline(data);
            }
            if (data.total == data.offline) {
                data.offline = 0;
            }
            if (data.ivrs  < data.total) {
                if (data.offline != 0) {
                    data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
                } else {
               
                        if(data.online!=0) {
                            data.online = data.total - ( data.ivrs + data.web + data.tele );
                        } else if(data.ivrs!=0) {
                            data.ivrs = data.total - ( data.web + data.online + data.tele );
                        } else if(data.tele!=0) {
                            data.tele = data.total - ( data.ivrs + data.web + data.online);
                        }else {
                            data.offline = data.total - data.web; 
                        }
                   
                }
            } else if (data.web == data.total) {
                data.online = 0;
                data.offline = 0;
                data.tele = 0;
                data.ivrs = 0;
            } else if ((data.online + data.ivrs + data.web + data.tele) == data.total) {
                data.offline = 0;
            }
        };
  
          vm.TimeSlotOverRideMessage = function(session) {
              return 'Session ' +session+ ' OverRide totalSlot. Please reschedule';
          }
          vm.InPersonTimeMessage = function(bal, session) {
              return 'You have '+bal+' In-Person consulation slot available in session '+ session;
          }
          vm.TeleTimeMessage = function(bal, session) {
              return 'You have '+bal+' tele consulation slot available in Session ' + session;
          }
          vm.InPersonandTeleTimeMessage = function(inPersonBal, inTeleBal, session) {
              return vm.InPersonTimeMessage(inPersonBal,session) + ' & ' + vm.TeleTimeMessage(inTeleBal,session);
          }
  
          vm.checkAppointmentTimeValidationAsync = function(sessions){
            
              var message = [];
              return $q(function(resolve, reject) {                
                  angular.forEach(sessions, function (data, index) {
                      var currentTotalSlotTime = ((vm.settings.avg_time_per_patient * (data.offline + data.online + data.ivrs + data.web)) + (vm.settings.avg_time_per_patient_tele * data.tele));
                      if(vm.totalSlotTime < currentTotalSlotTime) {                      
                          message.push(vm.TimeSlotOverRideMessage(index+1));
                      } else if (vm.totalSlotTime > currentTotalSlotTime) {
                          var balanceTime = vm.totalSlotTime - currentTotalSlotTime;
                          if(vm.settings.avg_time_per_patient > vm.settings.avg_time_per_patient_tele) {        
                              if(balanceTime >= vm.settings.avg_time_per_patient) {
                                  message.push(vm.InPersonTimeMessage(balanceTime,index+1));
                                  var remainingBalanceTime = (balanceTime % vm.settings.avg_time_per_patient);
                                  if(remainingBalanceTime >= vm.settings.avg_time_per_patient){
                                      message.push(vm.InPersonandTeleTimeMessage(remainingBalanceTime,(balanceTime - remainingBalanceTime), index+1));
                                  }
                              } else if(balanceTime >= vm.settings.avg_time_per_patient_tele){
                                  message.push(vm.TeleTimeMessage(balanceTime, index+1));
                              }        
                          } else if(vm.settings.avg_time_per_patient < vm.settings.avg_time_per_patient_tele) {
          
                              if(balanceTime >= vm.settings.avg_time_per_patient_tele){
                                  message.push(vm.TeleTimeMessage(balanceTime, index+1));
                                  var remainingBalanceTime = (balanceTime % vm.settings.avg_time_per_patient_tele);
                                  if(remainingBalanceTime >= vm.settings.avg_time_per_patient){
                                      message.push(vm.InPersonandTeleTimeMessage(remainingBalanceTime,(balanceTime - remainingBalanceTime), index+1));
                                  }                             
                              } else if(balanceTime >= vm.settings.avg_time_per_patient) {
                                  message.push(vm.InPersonTimeMessage(balanceTime,index+1));                              
                              }
                          }                
                      }
                      if(sessions.length === (index+1)){                       
                          if(message.length == 0){
                              resolve();
                          }                         
                          if(message.length > 0) {                            
                              reject(message);
                          }                        
                      }
                     
                  });
                });
          }
          vm.changeTele = function (data) {         
            if (!data.total) {
                vm.calculateOnlineOffline(data);
            }
            if (data.total == data.offline) {
                data.offline = 0;
            }
            if (data.ivrs  < data.total) {
                if (data.offline != 0) {
                    data.offline = data.total - (data.online + data.ivrs + data.web + data.tele);
                } else {
               
                        if(data.online!=0) {
                            data.online = data.total - ( data.ivrs + data.web + data.tele );
                        } else if(data.web!=0) {
                            data.web = data.total - ( data.ivrs + data.online + data.tele );
                        } else if(data.ivrs!=0) {
                            data.ivrs = data.total - ( data.tele + data.web + data.online);
                        }else {
                            data.offline = data.total - data.tele; 
                        }
                   
                }
            } else if (data.tele == data.total) {
                data.online = 0;
                data.offline = 0;
                data.ivrs = 0;
                data.web = 0;
            } else if ((data.online + data.ivrs + data.web + data.tele) == data.total) {
                data.offline = 0;
  
              }           
         };
  
          vm.ruleValidationConsent = function (message, title) {
  
              var options = {
                  message: message,
                  title: title,
                  buttons: {
                      warning: {
                          label: "Cancel",
                          className: "btn-warning"
                      },
                      success: {
                          label: "Ok",
                          className: "btn-success",
                          callback: function () {
                              vm.reconfig = true;
                              WizardHandler.wizard().next();
                          }
                      }
                  }
              };
              $ngBootbox.customDialog(options); 
          }
        vm.reconfigConsent = function () {
            var options = {
                message: 'By clicking on configure you are accepting to overwrite your existing appointment configurations. Are you sure to confirm?',
                title: 'Reconfigure Appointment schedule?',
                buttons: {
                    warning: {
                        label: "Cancel",
                        className: "btn-warning"
                    },
                    success: {
                        label: "Ok",
                        className: "btn-success",
                        callback: function () {
                            vm.reconfig = true;
                            WizardHandler.wizard().next();
                        }
                    }
                }
            };
            $ngBootbox.customDialog(options);
        };
  
        vm.hasReconfigConsent = function () {
            return vm.reconfig;
        };
  
        /*Init...*/
        var days = { "sun": false, "mon": false, "tue": false, "wed": false, "thu": false, "fri": false, "sat": false };
  
        vm.hrs = BudsStore.store.hrs;
        vm.avgTime = [];
  
        for (var i = 1; i <= 60; i++) {
            vm.avgTime.push(i);
        }
  
        vm.dateOptions = {
            maxDate: new Date(2020, 5, 22),
            minDate: new Date(),
            startingDay: 1
        };
  
        vm.aptTill = {
            opened: false
        };
  
        vm.aptSettings = { last_date: '', last_appointment: '' };
        // SettingsService.getSettings().then(function(response) {
        //       vm.settings = response;
  
        //       /*Default apt_type to token*/
        //       vm.settings.appointment_system="token";
  
        // });
  
        SettingsService.getLastAppConfigDate().then(function (response) {
            vm.aptSettings.last_date = response.last_date;
            vm.aptSettings.last_appointment = response.last_appointment;
        });
        vm.getSchedule();
        vm.reconfig = false;
    }
    /*Setup the Module*/
    angular.module("RxC.pages.AptConfig", ['buds.store'])
        .config(routeConfig)
        .service("AptConfigService", AptConfigService)
        .controller("AptConfigCtrl", AptConfigCtrl);
  }
  })();
  
  
  
  
  
'use strict';
angular.module('AngularApp').directive('combinedChartFemale', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:5%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;
//             .tickFormat(function(d) {
//     return d % 1 ? d + .1 : d;
//   })     

            var heightData = [];
            var weightData = [];

            if(vitalData.height){
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x>59 && vitalData.height[i].x<217) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            if(vitalData.weight) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x>59 && vitalData.weight[i].x<217) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var set1 = [{x:60,y:97.2},{x:66,y:99.8},{x:72,y:102.3},{x:78,y:104.9},{x:84,y:107.4},{x:90,y:110},
                        {x:96,y:112.6},{x:102,y:115.2},{x:108,y:117.8},{x:114,y:120.5},{x:120,y:123.3},{x:126,y:126.1},{x:132,y:128.8},
                        {x:138,y:131.5},{x:144,y:134},{x:150,y:136.3},{x:156,y:138.2},{x:162,y:139.9},{x:168,y:141.3},{x:174,y:142.4},
                        {x:180,y:143.3},{x:186,y:144.1},{x:192,y:144.7},{x:198,y:145.2},{x:204,y:145.7},{x:210,y:146.2},{x:216,y:146.6}];

            var set2 = [{x:60,y:100.5},{x:66,y:103.2},{x:72,y:106},{x:78,y:108.7},{x:84,y:111.4},{x:90,y:114.1},{x:96,y:116.8},
                        {x:102,y:119.6},{x:108,y:122.4},{x:114,y:125.2},{x:120,y:128.1},{x:126,y:130.9},{x:132,y:133.7},
                        {x:138,y:136.4},{x:144,y:138.9},{x:150,y:141.1},{x:156,y:142.9},{x:162,y:144.5},{x:168,y:145.8},{x:174,y:146.8},
                        {x:180,y:147.5},{x:186,y:148.1},{x:192,y:148.6},{x:198,y:149.1},{x:204,y:149.5},{x:210,y:149.8},{x:216,y:150.2}];
                    
            var set3 = [{x:60,y:103.9},{x:66,y:106.8},{x:72,y:109.7},{x:78,y:112.5},{x:84,y:115.4},{x:90,y:118.2},{x:96,y:121.1},
                        {x:102,y:124},{x:108,y:126.9},{x:114,y:129.9},{x:120,y:132.8},{x:126,y:135.7},{x:132,y:138.6},
                        {x:138,y:141.2},{x:144,y:143.7},{x:150,y:145.8},{x:156,y:147.6},{x:162,y:149.1},{x:168,y:150.2},{x:174,y:151.1},
                        {x:180,y:151.8},{x:186,y:152.3},{x:192,y:152.7},{x:198,y:153.1},{x:204,y:153.4},{x:210,y:153.6},{x:216,y:153.9}];

            var set4 = [{x:60,y:107.5},{x:66,y:110.5},{x:72,y:113.5},{x:78,y:116.5},{x:84,y:119.4},{x:90,y:122.4},{x:96,y:125.4},
                        {x:102,y:128.4},{x:108,y:131.4},{x:114,y:134.4},{x:120,y:137.4},{x:126,y:140.4},{x:132,y:143.3},
                        {x:138,y:145.9},{x:144,y:148.4},{x:150,y:150.5},{x:156,y:152.2},{x:162,y:153.6},{x:168,y:154.7},{x:174,y:155.5},
                        {x:180,y:156.1},{x:186,y:156.6},{x:192,y:156.9},{x:198,y:157.2},{x:204,y:157.4},{x:210,y:157.6},{x:216,y:157.8}];

            var set5 = [{x:60,y:111.3},{x:66,y:114.4},{x:72,y:117.4},{x:78,y:120.5},{x:84,y:123.5},{x:90,y:126.6},{x:96,y:129.6},
                        {x:102,y:132.7},{x:108,y:135.8},{x:114,y:138.9},{x:120,y:142},{x:126,y:145},{x:132,y:147.9},
                        {x:138,y:150.6},{x:144,y:153},{x:150,y:155.1},{x:156,y:156.8},{x:162,y:158.2},{x:168,y:159.2},{x:174,y:160},
                        {x:180,y:160.5},{x:186,y:160.9},{x:192,y:161.2},{x:198,y:161.4},{x:204,y:161.6},{x:210,y:161.7},{x:216,y:161.9}];

            var set6 = [{x:60,y:115.2},{x:66,y:118.3},{x:72,y:121.5},{x:78,y:124.6},{x:84,y:127.7},{x:90,y:130.8},{x:96,y:133.9},
                        {x:102,y:137},{x:108,y:140.2},{x:114,y:143.3},{x:120,y:146.4},{x:126,y:149.5},{x:132,y:152.4},
                        {x:138,y:155.1},{x:144,y:157.5},{x:150,y:159.6},{x:156,y:161.3},{x:162,y:162.7},{x:168,y:163.7},{x:174,y:164.5},
                        {x:180,y:165},{x:186,y:165.3},{x:192,y:165.6},{x:198,y:165.7},{x:204,y:165.9},{x:210,y:166},{x:216,y:166.1}];

            var set7 = [{x:60,y:119.3},{x:66,y:122.5},{x:72,y:125.6},{x:78,y:128.7},{x:84,y:131.9},{x:90,y:135},{x:96,y:138.1},
                        {x:102,y:141.3},{x:108,y:144.5},{x:114,y:147.6},{x:120,y:150.8},{x:126,y:153.9},{x:132,y:156.8},
                        {x:138,y:159.6},{x:144,y:162},{x:150,y:164.1},{x:156,y:165.9},{x:162,y:167.2},{x:168,y:168.2},{x:174,y:169},
                        {x:180,y:169.5},{x:186,y:169.8},{x:192,y:170.1},{x:198,y:170.2},{x:204,y:170.4},{x:210,y:170.5},{x:216,y:170.6}];
            
            var set8 = [{x:60,y:12.3},{x:66,y:13},{x:72,y:13.7},{x:78,y:14.4},{x:84,y:15.1},{x:90,y:15.9},{x:96,y:16.7},
                        {x:102,y:17.5},{x:108,y:18.5},{x:114,y:19.5},{x:120,y:20.7},{x:126,y:22},{x:132,y:23.3},
                        {x:138,y:24.8},{x:144,y:26.2},{x:150,y:27.6},{x:156,y:28.9},{x:162,y:30.2},{x:168,y:31.3},{x:174,y:32.3},
                        {x:180,y:33.1},{x:186,y:34},{x:192,y:34.7},{x:198,y:35.5},{x:204,y:36.2},{x:210,y:36.9},{x:216,y:37.6}];

            var set9 = [{x:60,y:13.4},{x:66,y:14.3},{x:72,y:15.1},{x:78,y:15.9},{x:84,y:16.8},{x:90,y:17.7},{x:96,y:18.7},
                        {x:102,y:19.7},{x:108,y:20.9},{x:114,y:22.1},{x:120,y:23.5},{x:126,y:25.1},{x:132,y:26.7},
                        {x:138,y:28.4},{x:144,y:30},{x:150,y:31.6},{x:156,y:33.1},{x:162,y:34.4},{x:168,y:35.6},{x:174,y:36.6},
                        {x:180,y:37.5},{x:186,y:38.3},{x:192,y:39.1},{x:198,y:39.8},{x:204,y:40.5},{x:210,y:41.1},{x:216,y:41.8}];

            var set10 = [{x:60,y:14.8},{x:66,y:15.7},{x:72,y:16.7},{x:78,y:17.7},{x:84,y:18.7},{x:90,y:19.9},{x:96,y:21.1},
                        {x:102,y:22.3},{x:108,y:23.7},{x:114,y:25.3},{x:120,y:26.9},{x:126,y:28.8},{x:132,y:30.7},
                        {x:138,y:32.6},{x:144,y:34.5},{x:150,y:36.3},{x:156,y:37.9},{x:162,y:39.4},{x:168,y:40.6},{x:174,y:41.7},
                        {x:180,y:42.5},{x:186,y:43.3},{x:192,y:44},{x:198,y:44.7},{x:204,y:45.3},{x:210,y:46},{x:216,y:46.6}];

            var set11 = [{x:60,y:16.4},{x:66,y:17.6},{x:72,y:18.7},{x:78,y:19.9},{x:84,y:21.2},{x:90,y:22.5},{x:96,y:24},
                        {x:102,y:25.5},{x:108,y:27.2},{x:114,y:29},{x:120,y:31},{x:126,y:33.2},{x:132,y:35.4},
                        {x:138,y:37.6},{x:144,y:39.8},{x:150,y:41.8},{x:156,y:43.6},{x:162,y:45.1},{x:168,y:46.4},{x:174,y:47.5},
                        {x:180,y:48.4},{x:186,y:49.1},{x:192,y:49.7},{x:198,y:50.3},{x:204,y:50.9},{x:210,y:51.5},{x:216,y:52}];

            var set12 = [{x:60,y:18.5},{x:66,y:19.9},{x:72,y:21.3},{x:78,y:22.7},{x:84,y:24.2},{x:90,y:25.9},{x:96,y:27.6},
                        {x:102,y:29.5},{x:108,y:31.5},{x:114,y:33.6},{x:120,y:36},{x:126,y:38.4},{x:132,y:41},
                        {x:138,y:43.6},{x:144,y:46},{x:150,y:48.2},{x:156,y:50.2},{x:162,y:51.8},{x:168,y:53.2},{x:174,y:54.3},
                        {x:180,y:55.1},{x:186,y:55.8},{x:192,y:56.3},{x:198,y:56.9},{x:204,y:57.3},{x:210,y:57.8},{x:216,y:58.2}];

            var set13 = [{x:60,y:21.3},{x:66,y:22.9},{x:72,y:24.6},{x:78,y:26.3},{x:84,y:28.2},{x:90,y:30.1},{x:96,y:32.2},
                        {x:102,y:34.4},{x:108,y:36.7},{x:114,y:39.3},{x:120,y:42},{x:126,y:44.8},{x:132,y:47.7},
                        {x:138,y:50.6},{x:144,y:53.4},{x:150,y:55.8},{x:156,y:57.9},{x:162,y:59.7},{x:168,y:61.1},{x:174,y:62.2},
                        {x:180,y:62.9},{x:186,y:63.5},{x:192,y:64},{x:198,y:64.4},{x:204,y:64.7},{x:210,y:65},{x:216,y:65.3}];

            var set14 = [{x:60,y:25},{x:66,y:27},{x:72,y:29.1},{x:78,y:31.2},{x:84,y:33.4},{x:90,y:35.7},{x:96,y:38.1},
                        {x:102,y:40.7},{x:108,y:43.4},{x:114,y:46.3},{x:120,y:49.4},{x:126,y:52.6},{x:132,y:55.9},
                        {x:138,y:59.1},{x:144,y:62.1},{x:150,y:64.8},{x:156,y:67.1},{x:162,y:69},{x:168,y:70.4},{x:174,y:71.4},
                        {x:180,y:72.1},{x:186,y:72.5},{x:192,y:72.8},{x:198,y:73.1},{x:204,y:73.3},{x:210,y:73.4},{x:216,y:73.5}];

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrapheight = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var wrapweight = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnterheight = wrapheight.enter().append('g').attr('class', 'd3line').append('g');
            var gEnterweight = wrapweight.enter().append('g').attr('class', 'd3line').append('g');

            gEnterheight.append('g').attr('class', 'lines');
            gEnterheight.append('g').attr('class', 'point-clips');
            gEnterheight.append('g').attr('class', 'point-paths');

            gEnterheight.append('g').attr('class', 'lines');
            gEnterheight.append('g').attr('class', 'point-clips');
            gEnterheight.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("cardinal");
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xVal = [5,5.6,6,6.6,7,7.6,8,8.6,9,9.6,10,10.6,11,11.6,12,12.6,13,13.6,14,14.6,15,15.6,16,16.6,17,17.6,18];
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,190]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,190]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ "."+ result[1].toString() + " years ";
            };

            // plot user data points
            var heightpoint = wrapheight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
            
            var weightpoint = wrapweight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" Kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("IAP Girls Height & Weight Chart");
            
            svg.append("text")
                .attr("x", -250 )
                .attr("y", 800 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", -320 )
                .attr("y", -30 )
                .attr("transform","translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", -150 )
                .attr("y", -30 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", -80 )
                .attr("y", 800 )
                .attr("transform","translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 310 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 300 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 290 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 280 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 268 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 255 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 235 )
                .style("text-anchor", "start")
                .text("97");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 100 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 90 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 80 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 70 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 60 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 50 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 40 )
                .style("text-anchor", "start")
                .text("97");
            
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set13),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});
'use strict';
angular.module('AngularApp').directive('combinedChartMale', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:5%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var heightData = [];
            var weightData = [];

            if(vitalData.height){
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x>59 && vitalData.height[i].x<217) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            if(vitalData.weight) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x>59 && vitalData.weight[i].x<217) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var set1 = [{x:60,y:99},{x:66,y:101.6},{x:72,y:104.2},{x:78,y:106.8},{x:84,y:109.3},{x:90,y:111.8},
                        {x:96,y:114.3},{x:102,y:116.7},{x:108,y:119},{x:114,y:121.3},{x:120,y:123.6},{x:126,y:125.9},{x:132,y:128.2},
                        {x:138,y:130.7},{x:144,y:133.2},{x:150,y:135.7},{x:156,y:138.3},{x:162,y:140.9},{x:168,y:143.4},{x:174,y:145.8},
                        {x:180,y:148},{x:186,y:150},{x:192,y:151.8},{x:198,y:153.4},{x:204,y:155},{x:210,y:156.6},{x:216,y:158.1}];

            var set2 = [{x:60,y:102.3},{x:66,y:105},{x:72,y:107.7},{x:78,y:110.4},{x:84,y:113},{x:90,y:115.7},
                        {x:96,y:118.2},{x:102,y:120.8},{x:108,y:123.2},{x:114,y:125.6},{x:120,y:128.1},{x:126,y:130.5},{x:132,y:133},
                        {x:138,y:135.6},{x:144,y:138.3},{x:150,y:141},{x:156,y:143.7},{x:162,y:146.4},{x:168,y:149},{x:174,y:151.5},
                        {x:180,y:153.7},{x:186,y:155.7},{x:192,y:157.4},{x:198,y:159.1},{x:204,y:160.6},{x:210,y:162.1},{x:216,y:163.6}];
                    
            var set3 = [{x:60,y:105.6},{x:66,y:108.4},{x:72,y:111.2},{x:78,y:114},{x:84,y:116.8},{x:90,y:119.6},{x:96,y:122.3},
                        {x:102,y:124.9},{x:108,y:127.5},{x:114,y:130},{x:120,y:132.6},{x:126,y:135.2},{x:132,y:137.8},{x:138,y:140.6},
                        {x:144,y:143.3},{x:150,y:146.2},{x:156,y:149},{x:162,y:151.8},{x:168,y:154.5},{x:174,y:157},
                        {x:180,y:159.2},{x:186,y:161.2},{x:192,y:162.9},{x:198,y:164.5},{x:204,y:165.9},{x:210,y:167.3},{x:216,y:168.7}];

            var set4 = [{x:60,y:108.9},{x:66,y:111.9},{x:72,y:114.8},{x:78,y:117.8},{x:84,y:120.7},{x:90,y:123.5},{x:96,y:126.4},
                        {x:102,y:129.1},{x:108,y:131.8},{x:114,y:134.5},{x:120,y:137.2},{x:126,y:139.9},{x:132,y:142.7},{x:138,y:145.5},
                        {x:144,y:148.4},{x:150,y:151.4},{x:156,y:154.3},{x:162,y:157.2},{x:168,y:159.9},{x:174,y:162.3},
                        {x:180,y:164.5},{x:186,y:166.5},{x:192,y:168.1},{x:198,y:169.6},{x:204,y:171},{x:210,y:172.3},{x:216,y:173.6}];

            var set5 = [{x:60,y:112.4},{x:66,y:115.4},{x:72,y:118.5},{x:78,y:121.6},{x:84,y:124.6},{x:90,y:127.6},{x:96,y:130.5},
                        {x:102,y:133.4},{x:108,y:136.3},{x:114,y:139.1},{x:120,y:141.9},{x:126,y:144.7},{x:132,y:147.6},{x:138,y:150.5},
                        {x:144,y:153.5},{x:150,y:156.5},{x:156,y:159.5},{x:162,y:162.4},{x:168,y:165.1},{x:174,y:167.6},
                        {x:180,y:169.7},{x:186,y:171.6},{x:192,y:173.1},{x:198,y:174.5},{x:204,y:175.8},{x:210,y:177},{x:216,y:178.2}];

            var set6 = [{x:60,y:115.9},{x:66,y:119},{x:72,y:122.2},{x:78,y:125.4},{x:84,y:128.6},{x:90,y:131.7},{x:96,y:134.8},
                        {x:102,y:137.8},{x:108,y:140.7},{x:114,y:143.7},{x:120,y:146.6},{x:126,y:149.5},{x:132,y:152.5},{x:138,y:155.6},
                        {x:144,y:158.6},{x:150,y:161.7},{x:156,y:164.7},{x:162,y:167.6},{x:168,y:170.3},{x:174,y:172.7},
                        {x:180,y:174.8},{x:186,y:176.5},{x:192,y:178},{x:198,y:179.3},{x:204,y:180.4},{x:210,y:181.5},{x:216,y:182.5}];

            var set7 = [{x:60,y:119.4},{x:66,y:122.7},{x:72,y:126},{x:78,y:129.3},{x:84,y:132.6},{x:90,y:135.9},{x:96,y:139.1},
                        {x:102,y:142.2},{x:108,y:145.3},{x:114,y:148.3},{x:120,y:151.4},{x:126,y:154.4},{x:132,y:157.5},{x:138,y:160.6},
                        {x:144,y:163.7},{x:150,y:166.8},{x:156,y:169.9},{x:162,y:172.7},{x:168,y:175.4},{x:174,y:177.7},
                        {x:180,y:179.7},{x:186,y:181.4},{x:192,y:182.7},{x:198,y:183.8},{x:204,y:184.8},{x:210,y:185.8},{x:216,y:186.7}];
            
            var set8 = [{x:60,y:13.2},{x:66,y:13.8},{x:72,y:14.5},{x:78,y:15.3},{x:84,y:16},{x:90,y:16.7},{x:96,y:17.5},
                        {x:102,y:18.3},{x:108,y:19.1},{x:114,y:19.9},{x:120,y:20.7},{x:126,y:21.6},{x:132,y:22.6},{x:138,y:23.8},
                        {x:144,y:24.9},{x:150,y:26.1},{x:156,y:27.5},{x:162,y:29},{x:168,y:30.7},{x:174,y:32.6},
                        {x:180,y:34.5},{x:186,y:36.1},{x:192,y:37.5},{x:198,y:38.7},{x:204,y:39.8},{x:210,y:40.8},{x:216,y:41.8}];

            var set9 = [{x:60,y:14.3},{x:66,y:15},{x:72,y:15.8},{x:78,y:16.8},{x:84,y:17.6},{x:90,y:18.5},{x:96,y:19.5},
                        {x:102,y:20.5},{x:108,y:21.5},{x:114,y:22.4},{x:120,y:23.5},{x:126,y:24.6},{x:132,y:25.9},{x:138,y:27.3},
                        {x:144,y:28.7},{x:150,y:30.2},{x:156,y:31.8},{x:162,y:33.6},{x:168,y:35.5},{x:174,y:37.7},
                        {x:180,y:39.8},{x:186,y:41.6},{x:192,y:43.1},{x:198,y:44.4},{x:204,y:45.6},{x:210,y:46.7},{x:216,y:47.7}];

            var set10 = [{x:60,y:15.6},{x:66,y:16.5},{x:72,y:17.4},{x:78,y:18.6},{x:84,y:19.6},{x:90,y:20.7},{x:96,y:21.9},
                        {x:102,y:23.2},{x:108,y:24.3},{x:114,y:25.6},{x:120,y:26.9},{x:126,y:28.3},{x:132,y:29.8},{x:138,y:31.6},
                        {x:144,y:33.3},{x:150,y:35.1},{x:156,y:37},{x:162,y:39.1},{x:168,y:41.3},{x:174,y:43.7},
                        {x:180,y:45.9},{x:186,y:47.9},{x:192,y:49.5},{x:198,y:50.9},{x:204,y:52.1},{x:210,y:53.2},{x:216,y:54.3}];

            var set11 = [{x:60,y:17.1},{x:66,y:18.2},{x:72,y:19.3},{x:78,y:20.7},{x:84,y:21.9},{x:90,y:23.3},{x:96,y:24.8},
                        {x:102,y:26.4},{x:108,y:27.9},{x:114,y:29.4},{x:120,y:31.1},{x:126,y:32.8},{x:132,y:34.7},{x:138,y:36.9},
                        {x:144,y:39},{x:150,y:41.2},{x:156,y:43.3},{x:162,y:45.7},{x:168,y:48.2},{x:174,y:50.8},
                        {x:180,y:53.1},{x:186,y:55.2},{x:192,y:56.8},{x:198,y:58.2},{x:204,y:59.5},{x:210,y:60.6},{x:216,y:61.6}];

            var set12 = [{x:60,y:19},{x:66,y:20.3},{x:72,y:21.7},{x:78,y:23.3},{x:84,y:24.9},{x:90,y:26.6},{x:96,y:28.5},
                        {x:102,y:30.5},{x:108,y:32.3},{x:114,y:34.3},{x:120,y:36.3},{x:126,y:38.5},{x:132,y:40.9},{x:138,y:43.5},
                        {x:144,y:46},{x:150,y:48.6},{x:156,y:51.1},{x:162,y:53.8},{x:168,y:56.4},{x:174,y:59.1},
                        {x:180,y:61.6},{x:186,y:63.6},{x:192,y:65.2},{x:198,y:66.6},{x:204,y:67.8},{x:210,y:68.7},{x:216,y:69.7}];

            var set13 = [{x:60,y:21.3},{x:66,y:22.9},{x:72,y:24.6},{x:78,y:26.6},{x:84,y:28.6},{x:90,y:30.8},{x:96,y:33.2},
                        {x:102,y:35.7},{x:108,y:38},{x:114,y:40.5},{x:120,y:43},{x:126,y:45.8},{x:132,y:48.7},{x:138,y:51.8},
                        {x:144,y:54.8},{x:150,y:57.8},{x:156,y:60.7},{x:162,y:63.6},{x:168,y:66.3},{x:174,y:69.1},
                        {x:180,y:71.5},{x:186,y:73.4},{x:192,y:74.8},{x:198,y:76.1},{x:204,y:77.1},{x:210,y:77.8},{x:216,y:78.6}];

            var set14 = [{x:60,y:24.2},{x:66,y:26.1},{x:72,y:28.3},{x:78,y:30.8},{x:84,y:33.4},{x:90,y:36.2},{x:96,y:39.4},
                        {x:102,y:42.6},{x:108,y:45.5},{x:114,y:48.6},{x:120,y:51.8},{x:126,y:55.2},{x:132,y:58.7},{x:138,y:62.5},
                        {x:144,y:66.1},{x:150,y:69.5},{x:156,y:72.6},{x:162,y:75.6},{x:168,y:78.3},{x:174,y:80.9},
                        {x:180,y:83.1},{x:186,y:84.7},{x:192,y:85.8},{x:198,y:86.8},{x:204,y:87.5},{x:210,y:88},{x:216,y:88.4}];

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrapheight = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var wrapweight = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnterheight = wrapheight.enter().append('g').attr('class', 'd3line').append('g');
            var gEnterweight = wrapweight.enter().append('g').attr('class', 'd3line').append('g');
            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("cardinal");

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xVal = [5,5.6,6,6.6,7,7.6,8,8.6,9,9.6,10,10.6,11,11.6,12,12.6,13,13.6,14,14.6,15,15.6,16,16.6,17,17.6,18];
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,190]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,190]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ "."+ result[1].toString() + " years ";
                    
            };
            
            // plot user data points
            var heightpoint = wrapheight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
            
            var weightpoint = wrapweight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +"Kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("IAP Boys Height & Weight Chart");
            
            svg.append("text")
                .attr("x", -250 )
                .attr("y", 800 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", -320 )
                .attr("y", -30 )
                .attr("transform","translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", -150 )
                .attr("y", -30 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", -80 )
                .attr("y", 800 )
                .attr("transform","translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 305 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 290 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 275 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 260 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 245 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 225 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 205 )
                .style("text-anchor", "start")
                .text("97");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 70 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 60 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 50 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 40 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 30 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 20 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 10 )
                .style("text-anchor", "start")
                .text("97");
            
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set13),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});
'use strict';
angular.module('AngularApp').directive('myDate', function (){
    return {
        restrict: 'EAC',
        require: 'ngModel',
        link: function(scope, element, attr, controller) {
      //remove the default formatter from the input directive to prevent conflict
      controller.$formatters.shift();
  }
}
});
'use strict';
angular.module('AngularApp').directive('feverGraph',['$filter', function($filter) {

     var colorcodes = {
        "85":"rgb(76, 174, 237)",
        "94":"rgb(109, 198, 186)",
        "96":"rgb(96, 164, 72)",
        "98.6":"rgb(96, 164, 72)",
        "103":"rgb(251, 204, 0)",
        "110":"rgb(246, 46, 46)"
    };

    var plotLines = ([94,96,98.6,103]).map(function(item){
        return {
                    value: item,
                    color: '#888',//colorcodes[item.toString()],
                    dashStyle: 'LongDash',
                    width: 1.5,
                    label: {
                        text: item.toString(),
                        style: {
                            color: '#111'
                        }
                    },
                    zIndex:1
                };
    });

    var plotBands = ([
            {name:"Hypothermia", range:[85,94], color:"#145681"},
            {name:"Low", range:[94,96], color:"#35749E"},
            {name:"Normal", range:[96,98.6], color:"#337D17"},
            {name:"Fever", range:[98.6,103], color:"#B96751"},
            {name:"Hyperthermia", range:[103,110], color:"#6E0C0C"}
        ]).map(function(item){
        return { 
                from: item.range[0],
                to: item.range[1],
                color:{
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, colorcodes[item.range[1].toString()]],
                        [1, colorcodes[item.range[0].toString()]]
                    ]
                }, 
                label: {
                    align:"center",
                    text: item.name,
                    style: {
                        color: item.color
                    }
                },
                zIndex:0
            }
    });

  return {
  	restrict: 'E',
  	template :'<div id="container" style="height:auto;width:100%;"></div>',
  	scope : {
        data : "="
    },
    link : function($scope, element, attributes) {
     	element.find("#container").highcharts({
            chart: {
                type: 'spline',
                 zoomType: 'x'
            },
        title: {
            text: 'Fever Graph',
            x: -20 //center
        },
          xAxis: {
            type: 'datetime',
            title: {
                text: 'Date'
            },
            dateTimeLabelFormats:{
               month: '%e %b %y'
            }
        },
        yAxis: {
            title: {
                text: 'Temperature (°F)'
            },
            min:85,
            max:106,
            gridLineColor:'rgba(3,3,3,0.05)',
            plotBands:plotBands
            /*[{ 
                from: 85,
                to: 94,
                color:{
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, colorcodes["94"]],
                        [1, colorcodes["85"]]
                    ]
                }, 
                label: {
                    align:"center",
                    text: 'Hypothermia',
                    style: {
                        color: '#145681'
                    }
                },
                zIndex:0
            },{ 
                from: 94,
                to: 96,
                color:{
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, colorcodes["96"]],
                        [1, colorcodes["94"]]
                    ]
                }, 
                label: {
                    align:"center",
                    text: 'Low',
                    style: {
                        color: '#145681'
                    }
                },
                zIndex:0
            },{ 
                from: 96,
                to: 99.5,
                color: 'rgb(150, 228, 121)',
                label: {
                    align:"center",
                    text: 'Normal',
                    style: {
                        color: '#337D17'
                    }
                },
                zIndex:0
            },{
                from: 99.5,
                to: 100.9,
                color: {
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, 'rgb(251, 204, 0)'],
                        [1, 'rgb(150, 228, 121)']
                    ]
                },//'rgba(251, 204, 0, 0.6)',
                label: {
                    align:"center",
                    text: 'Fever',
                    style: {
                        color: '#87700E'
                    }
                },
                zIndex:0
            },{
                from: 100.9,
                to: 106.7,
                color: {
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, 'rgb(251, 104, 72)'],
                        [1, 'rgb(251, 204, 0)']
                    ]
                },//'rgba(249, 93, 20, 0.5)',
                label: {
                    align:"center",
                    text: 'Hyperthermia',
                    style: {
                        color: 'rgba(249, 93, 20, 1)'
                    }
                },
                zIndex:0
            }/*,{
                from: 106.7,
                to: 110,
                color: 'rgba(255, 0, 0, 0.5)',
                label: {
                    align:"center",
                    text: 'Hyperpyrexia',
                    style: {
                        color: '#6E0C0C'
                    }
                }
            }],*/
            ,
                plotLines: plotLines
        },
        tooltip: {
             formatter: function() {
                   return $filter('date')(new Date(this.x), "dd/MM/yyyy hh:mm a")+'<br/>Temperature: '+ this.y+" °F";
                }
        },

        plotOptions: {
            spline: {
                marker: {
                    enabled: true
                },
                color: '#333'
            }
        },
        legend: {
            enabled: false
        },
        series: [{
            type:'spline',
            name: 'Temperature',
            data: $scope.data.map(function(item){
                return [Date.UTC(item[0].getFullYear(), item[0].getMonth(), item[0].getDate(), item[0].getHours(),item[0].getMinutes()),item[1]];
            })
        }]
    });
    }
  };
}]);
'use strict';
angular.module('AngularApp').directive('iapBmiChartMale', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:5%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var bmiData = [];

            if(vitalData.bmi){
                for(var i = 0; i < vitalData.bmi.length; i++){
                    if(vitalData.bmi[i].x>59 && vitalData.bmi[i].x<217) {
                        bmiData.push(vitalData.bmi[i]);
                    }
                }
            }

            var set1 = [{x:60,y:12.1},{x:66,y:12.15},{x:72,y:12.2},{x:78,y:12.25},{x:84,y:12.3},{x:90,y:12.4},{x:96,y:12.5},{x:102,y:12.6},
                        {x:108,y:12.7},{x:114,y:12.8},{x:120,y:12.9},{x:126,y:13},{x:132,y:13.1},{x:138,y:13.2},
                        {x:144,y:13.3},{x:150,y:13.4},{x:156,y:13.55},{x:162,y:13.7},{x:168,y:13.8},{x:174,y:14},
                        {x:180,y:14.2},{x:186,y:14.4},{x:192,y:14.6},{x:198,y:14.9},{x:204,y:15.1},{x:210,y:15.4},{x:216,y:15.6}];

            var set2 = [{x:60,y:12.4},{x:66,y:12.4},{x:72,y:12.5},{x:78,y:12.5},{x:84,y:12.6},{x:90,y:12.7},{x:96,y:12.8},{x:102,y:12.9},
                        {x:108,y:13},{x:114,y:13.1},{x:120,y:13.2},{x:126,y:13.3},{x:132,y:13.5},{x:138,y:13.6},
                        {x:144,y:13.8},{x:150,y:13.9},{x:156,y:14},{x:162,y:14.2},{x:168,y:14.3},{x:174,y:14.5},
                        {x:180,y:14.7},{x:186,y:14.9},{x:192,y:15.1},{x:198,y:15.4},{x:204,y:15.6},{x:210,y:15.9},{x:216,y:16.2}];
                    
            var set3 = [{x:60,y:12.8},{x:66,y:12.9},{x:72,y:12.9},{x:78,y:13},{x:84,y:13.1},{x:90,y:13.2},{x:96,y:13.3},{x:102,y:13.4},
                        {x:108,y:13.5},{x:114,y:13.7},{x:120,y:13.8},{x:126,y:14},{x:132,y:14.1},{x:138,y:14.3},
                        {x:144,y:14.5},{x:150,y:14.6},{x:156,y:14.8},{x:162,y:14.9},{x:168,y:15.1},{x:174,y:15.3},
                        {x:180,y:15.5},{x:186,y:15.8},{x:192,y:16},{x:198,y:16.3},{x:204,y:16.6},{x:210,y:16.8},{x:216,y:17.1}];

            var set4 = [{x:60,y:13.6},{x:66,y:13.7},{x:72,y:13.7},{x:78,y:13.8},{x:84,y:13.9},{x:90,y:14.1},{x:96,y:14.2},{x:102,y:14.4},
                        {x:108,y:14.5},{x:114,y:14.7},{x:120,y:14.9},{x:126,y:15.1},{x:132,y:15.4},{x:138,y:15.6},
                        {x:144,y:15.8},{x:150,y:16},{x:156,y:16.3},{x:162,y:16.5},{x:168,y:16.7},{x:174,y:16.9},
                        {x:180,y:17.2},{x:186,y:17.4},{x:192,y:17.7},{x:198,y:18},{x:204,y:18.3},{x:210,y:18.6},{x:216,y:18.9}];

            var set5 = [{x:60,y:14.7},{x:66,y:14.8},{x:72,y:14.9},{x:78,y:15},{x:84,y:15.1},{x:90,y:15.3},{x:96,y:15.5},{x:102,y:15.7},
                        {x:108,y:15.9},{x:114,y:16.2},{x:120,y:16.4},{x:126,y:16.7},{x:132,y:17},{x:138,y:17.3},
                        {x:144,y:17.7},{x:150,y:17.9},{x:156,y:18.2},{x:162,y:18.5},{x:168,y:18.7},{x:174,y:19},
                        {x:180,y:19.3},{x:186,y:19.6},{x:192,y:19.9},{x:198,y:20.2},{x:204,y:20.5},{x:210,y:20.8},{x:216,y:21.1}];

            var set6 = [{x:60,y:15.7},{x:66,y:15.8},{x:72,y:16},{x:78,y:16.1},{x:84,y:16.3},{x:90,y:16.5},{x:96,y:16.7},{x:102,y:17},
                        {x:108,y:17.3},{x:114,y:17.6},{x:120,y:18},{x:126,y:18.3},{x:132,y:18.7},{x:138,y:19.1},
                        {x:144,y:19.5},{x:150,y:19.9},{x:156,y:20.2},{x:162,y:20.5},{x:168,y:20.8},{x:174,y:21.1},
                        {x:180,y:21.4},{x:186,y:21.7},{x:192,y:22},{x:198,y:22.3},{x:204,y:22.6},{x:210,y:22.9},{x:216,y:23.2}];

            var set7 = [{x:60,y:17.5},{x:66,y:17.6},{x:72,y:17.8},{x:78,y:18},{x:84,y:18.2},{x:90,y:18.5},{x:96,y:18.8},{x:102,y:19.2},
                        {x:108,y:19.6},{x:114,y:20.1},{x:120,y:20.5},{x:126,y:21},{x:132,y:21.5},{x:138,y:22.1},
                        {x:144,y:22.6},{x:150,y:23},{x:156,y:23.4},{x:162,y:23.8},{x:168,y:24.2},{x:174,y:24.5},
                        {x:180,y:24.9},{x:186,y:25.2},{x:192,y:25.5},{x:198,y:25.8},{x:204,y:26},{x:210,y:26.3},{x:216,y:26.6}];
            

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([bmiData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            gEnter.append('g').attr('class', 'lines');
            gEnter.append('g').attr('class', 'point-clips');
            gEnter.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([10,35]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([10,35]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 +.1 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 +.1 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(26).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(26).innerTickSize(-width)
                            .outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString())	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("IAP Boys BMI Chart 5 - 18 years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-980,900) rotate(-90)")
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("Reviesed IAP growth charts for height, weight & body mass index for 5 to 18 year old indian children.");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,900) rotate(-90)")
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("V.Khadilkar et al. from Indian Academy of Pediatrics Growth Chart Committee Indian Pediatrics. Jan 2015, volume 52");

            svg.append("text")
                .attr("x", 690 )
                .attr("y", 745 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 725 )
                .style("text-anchor", "start")
                .text("5");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 690 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 630 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 540 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 460 )
                .attr("y", 300 )
                .attr("transform", "rotate(-10)")
                .style("text-anchor", "start")
                .text("23 Adult equivalent (Overweight)");
            
            svg.append("text")
                .attr("x", 470 )
                .attr("y", 245 )
                .attr("transform", "rotate(-10)")
                .style("text-anchor", "start")
                .text("27 Adult equivalent (Obesity)");
               
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "orange",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(bmiData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    }
});
'use strict';
angular.module('AngularApp').directive('iapBmiChartFemale', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:5%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var bmiData = [];

            if(vitalData.bmi){
                for(var i = 0; i < vitalData.bmi.length; i++){
                    if(vitalData.bmi[i].x>59 && vitalData.bmi[i].x<217) {
                        bmiData.push(vitalData.bmi[i]);
                    }
                }
            }

            var set1 = [{x:60,y:11.9},{x:66,y:11.9},{x:72,y:12},{x:78,y:12.1},{x:84,y:12.1},{x:90,y:12.2},{x:96,y:12.3},{x:102,y:12.3},
                        {x:108,y:12.4},{x:114,y:12.5},{x:120,y:12.7},{x:126,y:12.8},{x:132,y:13},{x:138,y:13.2},
                        {x:144,y:13.4},{x:150,y:13.7},{x:156,y:13.9},{x:162,y:14.1},{x:168,y:14.3},{x:174,y:14.5},
                        {x:180,y:14.7},{x:186,y:14.9},{x:192,y:15},{x:198,y:15.2},{x:204,y:15.4},{x:210,y:15.5},{x:216,y:15.7}];

            var set2 = [{x:60,y:12.1},{x:66,y:12.2},{x:72,y:12.2},{x:78,y:12.3},{x:84,y:12.4},{x:90,y:12.5},{x:96,y:12.6},{x:102,y:12.7},
                        {x:108,y:12.8},{x:114,y:12.9},{x:120,y:13.1},{x:126,y:13.2},{x:132,y:13.4},{x:138,y:13.7},
                        {x:144,y:13.9},{x:150,y:14.2},{x:156,y:14.4},{x:162,y:14.6},{x:168,y:14.9},{x:174,y:15.1},
                        {x:180,y:15.2},{x:186,y:15.4},{x:192,y:15.6},{x:198,y:15.8},{x:204,y:16},{x:210,y:16.1},{x:216,y:16.3}];
                    
            var set3 = [{x:60,y:12.5},{x:66,y:12.6},{x:72,y:12.7},{x:78,y:12.8},{x:84,y:12.8},{x:90,y:12.9},{x:96,y:13.1},{x:102,y:13.2},
                        {x:108,y:13.3},{x:114,y:13.5},{x:120,y:13.7},{x:126,y:13.9},{x:132,y:14.1},{x:138,y:14.4},
                        {x:144,y:14.7},{x:150,y:15},{x:156,y:15.2},{x:162,y:15.5},{x:168,y:15.7},{x:174,y:16},
                        {x:180,y:16.1},{x:186,y:16.3},{x:192,y:16.5},{x:198,y:16.7},{x:204,y:16.9},{x:210,y:17.1},{x:216,y:17.3}];

            var set4 = [{x:60,y:13.3},{x:66,y:13.4},{x:72,y:13.5},{x:78,y:13.6},{x:84,y:13.7},{x:90,y:13.9},{x:96,y:14},{x:102,y:14.2},
                        {x:108,y:14.4},{x:114,y:14.6},{x:120,y:14.9},{x:126,y:15.2},{x:132,y:15.5},{x:138,y:15.8},
                        {x:144,y:16.1},{x:150,y:16.5},{x:156,y:16.8},{x:162,y:17.1},{x:168,y:17.3},{x:174,y:17.6},
                        {x:180,y:17.8},{x:186,y:18},{x:192,y:18.2},{x:198,y:18.4},{x:204,y:18.6},{x:210,y:18.7},{x:216,y:18.9}];

            var set5 = [{x:60,y:14.3},{x:66,y:14.4},{x:72,y:14.5},{x:78,y:14.7},{x:84,y:14.9},{x:90,y:15.1},{x:96,y:15.3},{x:102,y:15.6},
                        {x:108,y:15.8},{x:114,y:16.1},{x:120,y:16.5},{x:126,y:16.8},{x:132,y:17.2},{x:138,y:17.6},
                        {x:144,y:18},{x:150,y:18.4},{x:156,y:18.8},{x:162,y:19.1},{x:168,y:19.4},{x:174,y:19.7},
                        {x:180,y:19.9},{x:186,y:20.1},{x:192,y:20.3},{x:198,y:20.4},{x:204,y:20.6},{x:210,y:20.8},{x:216,y:21}];

            var set6 = [{x:60,y:15.5},{x:66,y:15.7},{x:72,y:15.9},{x:78,y:16.1},{x:84,y:16.4},{x:90,y:16.6},{x:96,y:16.9},{x:102,y:17.2},
                        {x:108,y:17.6},{x:114,y:18},{x:120,y:18.4},{x:126,y:18.8},{x:132,y:19.3},{x:138,y:19.8},
                        {x:144,y:20.2},{x:150,y:20.7},{x:156,y:21.1},{x:162,y:21.5},{x:168,y:21.8},{x:174,y:22},
                        {x:180,y:22.3},{x:186,y:22.4},{x:192,y:22.6},{x:198,y:22.8},{x:204,y:22.9},{x:210,y:23.1},{x:216,y:23.2}];

            var set7 = [{x:60,y:18},{x:66,y:18.3},{x:72,y:18.6},{x:78,y:18.9},{x:84,y:19.3},{x:90,y:19.7},{x:96,y:20.1},{x:102,y:20.5},
                        {x:108,y:21},{x:114,y:21.4},{x:120,y:21.9},{x:126,y:22.5},{x:132,y:23},{x:138,y:23.6},
                        {x:144,y:24.1},{x:150,y:24.7},{x:156,y:25.2},{x:162,y:25.6},{x:168,y:25.9},{x:174,y:26.2},
                        {x:180,y:26.3},{x:186,y:26.4},{x:192,y:26.5},{x:198,y:26.6},{x:204,y:26.7},{x:210,y:26.7},{x:216,y:26.8}];
            

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([bmiData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            gEnter.append('g').attr('class', 'lines');
            gEnter.append('g').attr('class', 'point-clips');
            gEnter.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([10,35]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([10,35]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 +.1 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 +.1 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(26).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(26).innerTickSize(-width)
                            .outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };
            
            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString())	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("IAP Girls BMI Chart 5 - 18 years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-980,900) rotate(-90)")
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("Reviesed IAP growth charts for height, weight & body mass index for 5 to 18 year old indian children.");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,900) rotate(-90)")
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("V.Khadilkar et al. from Indian Academy of Pediatrics Growth Chart Committee Indian Pediatrics. Jan 2015, volume 52");

            svg.append("text")
                .attr("x", 690 )
                .attr("y", 735 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 710 )
                .style("text-anchor", "start")
                .text("5");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 680 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 615 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 540 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 400 )
                .attr("y", 285 )
                .attr("transform", "rotate(-10)")
                .style("text-anchor", "start")
                .text("23 Adult equivalent (Overweight)");
            
            svg.append("text")
                .attr("x", 410 )
                .attr("y", 225 )
                .attr("transform", "rotate(-10)")
                .style("text-anchor", "start")
                .text("27 Adult equivalent (Obesity)");
               
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "orange",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(bmiData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    }
});
'use strict';
angular.module('AngularApp').directive('lifelogChart', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' class='chart'></svg>",
        link: function(scope, element, attrs){
            var lifelogData = scope[attrs.chartData];
            var rawSvg = element.find("svg")[0];
            // var rawSvg = ".chart";
            var width = 1000, height = 300;
            var svg = d3.select(rawSvg)
                        .attr("width", width)
                        .attr("height", height);
            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 1);

            var imageList = ["cough", "cold", "constipation", "fever", "motion", "stomach", "urine", "vomiting"];
            // scale for x and y axis
            var start = new Date(lifelogData.end);
            var xScale = d3.time.scale().domain([d3.time.day.offset(start, -1), d3.time.day.offset(start, 3)]).range([0, width]);
            var yScale = d3.scale.linear().domain([30, 0]).range([0, height-75]);

            var zoom = d3.behavior.zoom().x(xScale).y(yScale).scaleExtent([1,1]).on("zoom", zoomed);

            // setting up axis
            var xAxis = d3.svg.axis().scale(xScale).orient("bottom").ticks(d3.time.hour, 12).innerTickSize(-(height-75)).outerTickSize(2);
            
            var yAxis = d3.svg.axis().scale(yScale).orient("left").outerTickSize(2).ticks(0).tickFormat(function(d){
                return '';
            }).tickPadding(10);

            var g = svg.append("g").attr("transform","translate(20,10)");

             // axis
            g.append("rect")
                .attr("width", width)
                .attr("height", height-75)
                .style("fill", "none")
                .style("pointer-events", "all")
                .call(zoom);

            g.append("g")
                .attr("class", "x-axis")
                .attr("transform","translate(0,"+(height-75)+")")
                .call(xAxis)
                .selectAll("text")	
                .style("text-anchor", "center");
    
            g.append("g")
                .attr("class", "y-axis")
                .call(yAxis);
            
            g.selectAll(null)
                    .data(lifelogData.data)
                    .enter()
                    .append("image")
                    .attr("width", '25px')
                    .attr("height", '25px')
                    .attr({'x':function(d){ return xScale(d.x); },
                        'y':function(d){ return yScale(d.y); }
                    })
                    .attr("xlink:href", function(d){
                        if(lifelogData.data.includes(d.item)){
                            return "Content/Images/lifelog/"+d.item+".png"
                        } else {
                            return "Content/Images/lifelog/other.png"
                        }
                        
                    })
                    .style("cursor", "pointer")
                    .on("mouseover", function(d) {
                        console.log(d);	
                        div.transition()		
                            .duration(200)		
                            .style("opacity", .9);		
                        div	.html("Date: "+ (d.x).toDateString() +"<br>" +"Log: "+d.item)	
                            .style("left", (d3.event.pageX) + "px")		
                            .style("top", (d3.event.pageY - 28) + "px");	
                        })					
                    .on("mouseout", function(d) {		
                        div.transition()		
                            .duration(500)		
                            .style("opacity", 0);	
                    });
            

            function zoomed(){
                // g.attr("transform", "translate(" + d3.event.translate + ")" + " scale(" + d3.event.scale + ")").call(xAxis)
                g.select('.x-axis')
                    .call(xAxis);
                g.selectAll('image')
                    .attr('x',function(d){
                        return xScale(d.x);
                    })
            }

        }

    }
});
'use strict';
angular.module('AngularApp').directive('hcChart', function () {
    return {
        restrict: 'E',
        template: '<div></div>',
        scope: {
            options: '='
        },
        link: function (scope, element) {
            Highcharts.chart(element[0], scope.options);
        }
    };
})
'use strict';
angular.module('AngularApp').directive('milestoneChart', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionIdMilestone' class='chart'></svg>",
        link: function(scope, element, attrs){
            // color code for each status
            var colors = ['#03C653', '#FF5733', '#FEC617', '#B2B2B2', "#DB7093"];
            // selecting charting area
            var rawSvg = element.find("svg")[0];
            // var rawSvg = ".chart";
            var width = 1000, height = 700;
            var svg = d3.select(rawSvg)
                        .attr("width", width)
                        .attr("height", height);

            function drawGraph(milestones){

            var age = milestones.age;
            
            // scale for x and y axis
            var x = d3.scale.linear().domain([0, 38]).range([0, width]);
            var y = d3.scale.linear().domain([(milestones.data.length+1), 0]).range([0, height-75]);

            var g = svg.append("g").attr("transform","translate(20,10)");

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 1);

            // setting up axis
            var xAxis = d3.svg.axis().scale(x).orient("bottom").ticks(36).innerTickSize(-(height-75)).outerTickSize(2).tickFormat(function(d){
                if(d==37){
                    return '';
                }else {
                    return d;
                }
            });
            
            var yAxis = d3.svg.axis().scale(y).orient("left").outerTickSize(2).ticks(0).tickFormat(function(d){
                return '';
            }).tickPadding(10);

            // axis
            g.append("g")
                .attr("class", "x-axis")
                .attr("transform","translate(0,"+(height-75)+")")
                .call(xAxis)
                .selectAll("text")	
                .style("text-anchor", "center");
    
            g.append("g")
                .attr("class", "y-axis")
                .call(yAxis);
            
            // milestones
            g.selectAll(null)
                .data(milestones.data)
                .enter()
                .append("line")
                .attr({'x1':function(d){ return x(d.start); },
                       'y1':function(d){ return y(d.sno); },
                       'x2':function(d){ return x(d.end); },
                       'y2':function(d){ return y(d.sno); }
                }) 
                .style("stroke-width", 10)
                .attr("stroke", function(d) {
                    if(d.end<=age){
                        return colors[3];
                    }else {
                        return colors[4];
                    }
                })
                .style("fill", "none");

            if(milestones.survey){
                g.selectAll(null)
                    .data(milestones.survey)
                    .enter()
                    .append("line")
                    .attr({'x1':function(d){ return x(d.start); },
                        'y1':function(d){ return y(d.sno); },
                        'x2':function(d){ return x(d.end); },
                        'y2':function(d){ return y(d.sno); }
                    }) 
                    .style("stroke-width", 10)
                    .attr("stroke", function(d) {
                        if(d.status=="Yes") {
                            return colors[0];
                        }else if(d.status=="Not Yet") {
                            return colors[1];
                        }else if(d.status=="Sometimes") {
                            return colors[2];
                        }
                    })
                    .style("fill", "none")
                    .style("cursor", "pointer")
                    .on("mouseover", function(d) {		
                        div.transition()		
                            .duration(200)		
                            .style("opacity", .9);		
                        div	.html("Date: "+ d.date +"<br>" +"Status: "+d.status)	
                            .style("left", (d3.event.pageX) + "px")		
                            .style("top", (d3.event.pageY - 28) + "px");	
                        })					
                    .on("mouseout", function(d) {		
                        div.transition()		
                            .duration(500)		
                            .style("opacity", 0);	
                    });
            }

            g.selectAll(null)
                .data(milestones.data)
                .enter()
                .append("text")
                .text(function(d) {
                    return (d.item).toUpperCase();
                })
                .attr("x", function(d) {
                    if(d.sno>=14){
                        return x(d.start-0.2);    
                    }else{
                        return x(d.end+0.2);
                    }
                })
                .attr("y", function(d) {
                    return y(d.sno);
                })
                .attr("dy", 5)
                .attr("text-anchor", function(d){
                    if(d.sno>=14){
                        return "end";
                    }
                    else{
                        return "start";
                    }
                })
                .attr("id", "printSectionIdMilestone");

            g.append("line")
                .attr("x1", x(age))  
                .attr("y1", 0)
                .attr("x2", x(age))  
                .attr("y2", height - 75)
                .style("stroke-width", 4)
                .style("stroke", "#00a0e3")
                .style("fill", "none")
                .style("cursor", "pointer")
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html("Age: "+ age + " months")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });;
            
            g.append("text")
                .attr("x", width/2 )
                .attr("y", height-50 )
                .style("text-anchor", "middle")
                .text("Age in Months");

        };

        scope.$watch(attrs.chartData, function(newValue) {
            if (newValue) {
                svg.selectAll("*").remove();
                drawGraph(scope[attrs.chartData]);
            }
        }, true);            

        }
    }
});
(function (angular) {
    "use strict";

    angular.module("ng.deviceDetector", ["reTree", "uaDeviceDetector"])
        .service("detectUtils", ["deviceDetector", "uaDeviceDetector",
            function (deviceDetector, uaDeviceDetector) {
                var deviceInfo = deviceDetector;

                this.isMobile = function () {
                    return deviceInfo.device !== 'unknown';
                };

                this.isAndroid = function () {
                    return (deviceInfo.device === uaDeviceDetector.DEVICES.ANDROID || deviceInfo.OS === uaDeviceDetector.OS.ANDROID);
                };

                this.isIOS = function () {
                    return (deviceInfo.os === uaDeviceDetector.OS.IOS || deviceInfo.device === uaDeviceDetector.DEVICES.I_POD ||
                        deviceInfo.device === uaDeviceDetector.DEVICES.IPHONE);
                };
            }
        ])
        .provider("deviceDetector", function () {
            var customDetectors = [];
            this.addCustom = function (customDetectorName, customDetectorRE) {
                customDetectors.push({ name: customDetectorName, re: customDetectorRE });
            };
            this.$get = [
                "$window",
                "uaDeviceDetector",
                "reTree",
                function (
                    $window,
                    uaDeviceDetector,
                    reTree
                ) {
                    var ua = $window.navigator.userAgent;
                    var platform = $window.navigator.platform;
                    var maxTouchPoints= $window.navigator.maxTouchPoints;
                    var deviceInfo = uaDeviceDetector.parseUserAgent(ua, customDetectors, platform, maxTouchPoints );
                    deviceInfo.parseUserAgent = function (ua, platform, maxTouchPoints) { return uaDeviceDetector.parseUserAgent(ua, customDetectors, platform, maxTouchPoints) };
                    return deviceInfo;
                }];
        }
        )
        .directive('deviceDetector', ["deviceDetector", function (deviceDetector) {
            function customClassName(name) {
                return 'is-' + name.toLowerCase().replace(/[^0-9a-z]+/g, '-');
            }

            return {
                restrict: "A",
                link: function (scope, elm/*, attrs*/) {
                    elm.addClass('os-' + deviceDetector.os);
                    elm.addClass('browser-' + deviceDetector.browser);
                    elm.addClass('device-' + deviceDetector.device);
                    elm.toggleClass('is-mobile', deviceDetector.isMobile());
                    elm.toggleClass('is-tablet', deviceDetector.isTablet());
                    elm.toggleClass('is-desktop', deviceDetector.isDesktop());
                    Object.keys(deviceDetector.custom).forEach(function (customKey) {
                        elm.toggleClass(customClassName(customKey), deviceDetector.custom[customKey]);
                    });
                }
            };
        }]);
})(angular);

'use strict';
angular.module('AngularApp').directive('hlPostnatalFemaleDirective', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 440 - margin.top - margin.bottom;
              var width = 960 - margin.left - margin.right;
  
            var headConst = -20;
            var lengthConst = -14;

            var hcData = [];
            if(vitalData.postnatalHc) {
                for(var i = 0; i < vitalData.postnatalHc.length; i++){
                    hcData.push({x:vitalData.postnatalHc[i].x, y:parseFloat(vitalData.postnatalHc[i].y) + headConst});
                }
            }

            var lengthData = [];
            if(vitalData.postnatalHeight) {
                for(var i = 0; i < vitalData.postnatalHeight.length; i++){
                    lengthData.push({x:vitalData.postnatalHeight[i].x, y:parseFloat(vitalData.postnatalHeight[i].y) + lengthConst});
                }
            }
  
              // Start of Head data
              var set1 = [{x:27,y:20.7+headConst},{x:28,y:22.1+headConst},{x:29,y:23.4+headConst},{x:30,y:24.5+headConst},{x:31,y:25.6+headConst},{x:32,y:26.6+headConst},{x:33,y:27.5+headConst},{x:34,y:28.4+headConst},{x:35,y:29.1+headConst},{x:36,y:29.9+headConst},{x:37,y:30.6+headConst},{x:38,y:31.2+headConst},{x:39,y:31.8+headConst},{x:40,y:32.4+headConst},{x:41,y:32.9+headConst},{x:42,y:33.4+headConst},{x:43,y:33.9+headConst},{x:44,y:34.3+headConst},{x:45,y:34.8+headConst},{x:46,y:35.2+headConst},{x:47,y:35.6+headConst},{x:48,y:35.9+headConst},{x:49,y:36.3+headConst},{x:50,y:36.6+headConst},{x:51,y:36.9+headConst},{x:52,y:37.2+headConst},{x:53,y:37.5+headConst},{x:54,y:37.8+headConst},{x:55,y:38+headConst},{x:56,y:38.3+headConst},{x:57,y:38.5+headConst},{x:58,y:38.8+headConst},{x:59,y:39+headConst},{x:60,y:39.2+headConst},{x:61,y:39.4+headConst},{x:62,y:39.6+headConst},{x:63,y:39.8+headConst},{x:64,y:40+headConst}];
    
              var set2 = [{x:27,y:21.8+headConst},{x:28,y:23.1+headConst},{x:29,y:24.3+headConst},{x:30,y:25.4+headConst},{x:31,y:26.4+headConst},{x:32,y:27.3+headConst},{x:33,y:28.2+headConst},{x:34,y:29+headConst},{x:35,y:29.8+headConst},{x:36,y:30.5+headConst},{x:37,y:31.2+headConst},{x:38,y:31.8+headConst},{x:39,y:32.4+headConst},{x:40,y:33+headConst},{x:41,y:33.5+headConst},{x:42,y:34+headConst},{x:43,y:34.5+headConst},{x:44,y:34.9+headConst},{x:45,y:35.4+headConst},{x:46,y:35.8+headConst},{x:47,y:36.1+headConst},{x:48,y:36.5+headConst},{x:49,y:36.9+headConst},{x:50,y:37.2+headConst},{x:51,y:37.5+headConst},{x:52,y:37.8+headConst},{x:53,y:38.1+headConst},{x:54,y:38.4+headConst},{x:55,y:38.7+headConst},{x:56,y:38.9+headConst},{x:57,y:39.2+headConst},{x:58,y:39.4+headConst},{x:59,y:39.7+headConst},{x:60,y:39.9+headConst},{x:61,y:40.1+headConst},{x:62,y:40.3+headConst},{x:63,y:40.5+headConst},{x:64,y:40.7+headConst}];
                      
              var set3 = [{x:27,y:24+headConst},{x:28,y:25.1+headConst},{x:29,y:26.2+headConst},{x:30,y:27.1+headConst},{x:31,y:28.1+headConst},{x:32,y:28.9+headConst},{x:33,y:29.7+headConst},{x:34,y:30.5+headConst},{x:35,y:31.2+headConst},{x:36,y:31.9+headConst},{x:37,y:32.5+headConst},{x:38,y:33.1+headConst},{x:39,y:33.7+headConst},{x:40,y:34.2+headConst},{x:41,y:34.8+headConst},{x:42,y:35.3+headConst},{x:43,y:35.7+headConst},{x:44,y:36.2+headConst},{x:45,y:36.6+headConst},{x:46,y:37+headConst},{x:47,y:37.4+headConst},{x:48,y:37.8+headConst},{x:49,y:38.1+headConst},{x:50,y:38.5+headConst},{x:51,y:38.8+headConst},{x:52,y:39.2+headConst},{x:53,y:39.5+headConst},{x:54,y:39.8+headConst},{x:55,y:40+headConst},{x:56,y:40.3+headConst},{x:57,y:40.6+headConst},{x:58,y:40.8+headConst},{x:59,y:41.1+headConst},{x:60,y:41.3+headConst},{x:61,y:41.6+headConst},{x:62,y:41.8+headConst},{x:63,y:42+headConst},{x:64,y:42.2+headConst}];
  
              var set4 = [{x:27,y:26.2+headConst},{x:28,y:27.2+headConst},{x:29,y:28.1+headConst},{x:30,y:28.9+headConst},{x:31,y:29.7+headConst},{x:32,y:30.5+headConst},{x:33,y:31.2+headConst},{x:34,y:31.9+headConst},{x:35,y:32.6+headConst},{x:36,y:33.2+headConst},{x:37,y:33.8+headConst},{x:38,y:34.4+headConst},{x:39,y:35+headConst},{x:40,y:35.5+headConst},{x:41,y:36+headConst},{x:42,y:36.5+headConst},{x:43,y:37+headConst},{x:44,y:37.4+headConst},{x:45,y:37.9+headConst},{x:46,y:38.3+headConst},{x:47,y:38.7+headConst},{x:48,y:39.1+headConst},{x:49,y:39.4+headConst},{x:50,y:39.8+headConst},{x:51,y:40.1+headConst},{x:52,y:40.5+headConst},{x:53,y:40.8+headConst},{x:54,y:41.1+headConst},{x:55,y:41.4+headConst},{x:56,y:41.7+headConst},{x:57,y:42+headConst},{x:58,y:42.3+headConst},{x:59,y:42.5+headConst},{x:60,y:42.8+headConst},{x:61,y:43+headConst},{x:62,y:43.3+headConst},{x:63,y:43.5+headConst},{x:64,y:43.7+headConst}];
  
              var set5 = [{x:27,y:27.2+headConst},{x:28,y:28.1+headConst},{x:29,y:28.9+headConst},{x:30,y:29.7+headConst},{x:31,y:30.5+headConst},{x:32,y:31.2+headConst},{x:33,y:31.9+headConst},{x:34,y:32.6+headConst},{x:35,y:33.2+headConst},{x:36,y:33.9+headConst},{x:37,y:34.5+headConst},{x:38,y:35+headConst},{x:39,y:35.6+headConst},{x:40,y:36.1+headConst},{x:41,y:36.6+headConst},{x:42,y:37.1+headConst},{x:43,y:37.6+headConst},{x:44,y:38+headConst},{x:45,y:38.4+headConst},{x:46,y:38.9+headConst},{x:47,y:39.3+headConst},{x:48,y:39.7+headConst},{x:49,y:40+headConst},{x:50,y:40.4+headConst},{x:51,y:40.7+headConst},{x:52,y:41.1+headConst},{x:53,y:41.4+headConst},{x:54,y:41.7+headConst},{x:55,y:42.1+headConst},{x:56,y:42.4+headConst},{x:57,y:42.6+headConst},{x:58,y:42.9+headConst},{x:59,y:43.2+headConst},{x:60,y:43.5+headConst},{x:61,y:43.7+headConst},{x:62,y:44+headConst},{x:63,y:44.2+headConst},{x:64,y:44.5+headConst}];
              // End of Head data
  
              // Start of Length data
              var set6 = [{x:27,y:27.8+lengthConst},{x:28,y:29.7+lengthConst},{x:29,y:31.5+lengthConst},{x:30,y:33.2+lengthConst},{x:31,y:34.8+lengthConst},{x:32,y:36.4+lengthConst},{x:33,y:37.8+lengthConst},{x:34,y:39.2+lengthConst},{x:35,y:40.5+lengthConst},{x:36,y:41.7+lengthConst},{x:37,y:42.9+lengthConst},{x:38,y:44+lengthConst},{x:39,y:45+lengthConst},{x:40,y:46+lengthConst},{x:41,y:47+lengthConst},{x:42,y:47.9+lengthConst},{x:43,y:48.7+lengthConst},{x:44,y:49.6+lengthConst},{x:45,y:50.3+lengthConst},{x:46,y:51.1+lengthConst},{x:47,y:51.8+lengthConst},{x:48,y:52.5+lengthConst},{x:49,y:53.1+lengthConst},{x:50,y:53.8+lengthConst},{x:51,y:54.4+lengthConst},{x:52,y:54.9+lengthConst},{x:53,y:55.5+lengthConst},{x:54,y:56+lengthConst},{x:55,y:56.6+lengthConst},{x:56,y:57.1+lengthConst},{x:57,y:57.6+lengthConst},{x:58,y:58+lengthConst},{x:59,y:58.5+lengthConst},{x:60,y:58.9+lengthConst},{x:61,y:59.4+lengthConst},{x:62,y:59.8+lengthConst},{x:63,y:60.2+lengthConst},{x:64,y:60.6+lengthConst}];
  
              var set7 = [{x:27,y:29+lengthConst},{x:28,y:30.9+lengthConst},{x:29,y:32.7+lengthConst},{x:30,y:34.3+lengthConst},{x:31,y:35.9+lengthConst},{x:32,y:37.5+lengthConst},{x:33,y:38.9+lengthConst},{x:34,y:40.3+lengthConst},{x:35,y:41.5+lengthConst},{x:36,y:42.8+lengthConst},{x:37,y:43.9+lengthConst},{x:38,y:45+lengthConst},{x:39,y:46.1+lengthConst},{x:40,y:47.1+lengthConst},{x:41,y:48+lengthConst},{x:42,y:48.9+lengthConst},{x:43,y:49.8+lengthConst},{x:44,y:50.6+lengthConst},{x:45,y:51.4+lengthConst},{x:46,y:52.1+lengthConst},{x:47,y:52.9+lengthConst},{x:48,y:53.6+lengthConst},{x:49,y:54.2+lengthConst},{x:50,y:54.9+lengthConst},{x:51,y:55.5+lengthConst},{x:52,y:56.1+lengthConst},{x:53,y:56.6+lengthConst},{x:54,y:57.2+lengthConst},{x:55,y:57.7+lengthConst},{x:56,y:58.2+lengthConst},{x:57,y:58.7+lengthConst},{x:58,y:59.2+lengthConst},{x:59,y:59.7+lengthConst},{x:60,y:60.2+lengthConst},{x:61,y:60.6+lengthConst},{x:62,y:61+lengthConst},{x:63,y:61.5+lengthConst},{x:64,y:61.9+lengthConst}];
                      
              var set8 = [{x:27,y:31.7+lengthConst},{x:28,y:33.5+lengthConst},{x:29,y:35.2+lengthConst},{x:30,y:36.8+lengthConst},{x:31,y:38.4+lengthConst},{x:32,y:39.9+lengthConst},{x:33,y:41.3+lengthConst},{x:34,y:42.6+lengthConst},{x:35,y:43.9+lengthConst},{x:36,y:45.1+lengthConst},{x:37,y:46.2+lengthConst},{x:38,y:47.3+lengthConst},{x:39,y:48.3+lengthConst},{x:40,y:49.3+lengthConst},{x:41,y:50.3+lengthConst},{x:42,y:51.2+lengthConst},{x:43,y:52.1+lengthConst},{x:44,y:52.9+lengthConst},{x:45,y:53.7+lengthConst},{x:46,y:54.5+lengthConst},{x:47,y:55.2+lengthConst},{x:48,y:55.9+lengthConst},{x:49,y:56.6+lengthConst},{x:50,y:57.3+lengthConst},{x:51,y:57.9+lengthConst},{x:52,y:58.5+lengthConst},{x:53,y:59.1+lengthConst},{x:54,y:59.7+lengthConst},{x:55,y:60.3+lengthConst},{x:56,y:60.8+lengthConst},{x:57,y:61.3+lengthConst},{x:58,y:61.9+lengthConst},{x:59,y:62.4+lengthConst},{x:60,y:62.9+lengthConst},{x:61,y:63.3+lengthConst},{x:62,y:63.8+lengthConst},{x:63,y:64.2+lengthConst},{x:64,y:64.7+lengthConst}];
  
              var set9 = [{x:27,y:34.6+lengthConst},{x:28,y:36.3+lengthConst},{x:29,y:38+lengthConst},{x:30,y:39.5+lengthConst},{x:31,y:41+lengthConst},{x:32,y:42.4+lengthConst},{x:33,y:43.8+lengthConst},{x:34,y:45.1+lengthConst},{x:35,y:46.3+lengthConst},{x:36,y:47.5+lengthConst},{x:37,y:48.6+lengthConst},{x:38,y:49.7+lengthConst},{x:39,y:50.7+lengthConst},{x:40,y:51.7+lengthConst},{x:41,y:52.7+lengthConst},{x:42,y:53.6+lengthConst},{x:43,y:54.5+lengthConst},{x:44,y:55.3+lengthConst},{x:45,y:56.1+lengthConst},{x:46,y:56.9+lengthConst},{x:47,y:57.7+lengthConst},{x:48,y:58.4+lengthConst},{x:49,y:59.1+lengthConst},{x:50,y:59.8+lengthConst},{x:51,y:60.5+lengthConst},{x:52,y:61.1+lengthConst},{x:53,y:61.7+lengthConst},{x:54,y:62.3+lengthConst},{x:55,y:62.9+lengthConst},{x:56,y:63.5+lengthConst},{x:57,y:64.1+lengthConst},{x:58,y:64.6+lengthConst},{x:59,y:65.2+lengthConst},{x:60,y:65.7+lengthConst},{x:61,y:66.2+lengthConst},{x:62,y:66.7+lengthConst},{x:63,y:67.2+lengthConst},{x:64,y:67.6+lengthConst}];
  
              var set10 = [{x:27,y:36.1+lengthConst},{x:28,y:37.8+lengthConst},{x:29,y:39.3+lengthConst},{x:30,y:40.9+lengthConst},{x:31,y:42.3+lengthConst},{x:32,y:43.7+lengthConst},{x:33,y:45+lengthConst},{x:34,y:46.3+lengthConst},{x:35,y:47.5+lengthConst},{x:36,y:48.7+lengthConst},{x:37,y:49.8+lengthConst},{x:38,y:50.9+lengthConst},{x:39,y:51.9+lengthConst},{x:40,y:52.9+lengthConst},{x:41,y:53.8+lengthConst},{x:42,y:54.7+lengthConst},{x:43,y:55.6+lengthConst},{x:44,y:56.5+lengthConst},{x:45,y:57.3+lengthConst},{x:46,y:58.1+lengthConst},{x:47,y:58.9+lengthConst},{x:48,y:59.6+lengthConst},{x:49,y:60.3+lengthConst},{x:50,y:61+lengthConst},{x:51,y:61.7+lengthConst},{x:52,y:62.4+lengthConst},{x:53,y:63+lengthConst},{x:54,y:63.6+lengthConst},{x:55,y:64.2+lengthConst},{x:56,y:64.8+lengthConst},{x:57,y:65.4+lengthConst},{x:58,y:66+lengthConst},{x:59,y:66.5+lengthConst},{x:60,y:67+lengthConst},{x:61,y:67.6+lengthConst},{x:62,y:68.1+lengthConst},{x:63,y:68.6+lengthConst},{x:64,y:69.1+lengthConst}];
              // End of Length data
              
              var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([lengthData]);
            var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([65,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([65,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,61]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,61]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%2==0 ? yAxisLeftFake(d):'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%2==0 ? yAxisRightFake(d):'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var yAxisLeftFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return '';
                case 14:return 28;
                case 16:return 30;
                case 18:return 32;
                case 20:return 34;
                case 22:return 36;
                case 24:return 38;
                case 26:return 40;
                case 28:return 42;
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var yAxisRightFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return 32;
                case 14:return 34;
                case 16:return 36;
                case 18:return 38;
                case 20:return 40;
                case 22:return 42;
                case 24:return 44;
                case 26:return 46;
                case 28:return '';
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Postmensural age (weeks)");
            
            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            

            svg.append("text")
                .attr("x", -350 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head (cm)");
            
            svg.append("text")
                .attr("x", -180 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -300 )
                .attr("y", 850 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -100 )
                .attr("y", 850 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 95 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 80 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 65 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 50 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 35 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 260 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 250 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 240 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 230 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 220 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set6),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set8),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set10),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(hcData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
                  
                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(lengthData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('hlPostnatalMaleDirective', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var headConst = -20;
            var lengthConst = -14;

            var hcData = [];
            if(vitalData.postnatalHc) {
                for(var i = 0; i < vitalData.postnatalHc.length; i++){
                    hcData.push({x:vitalData.postnatalHc[i].x, y:parseFloat(vitalData.postnatalHc[i].y) + headConst});
                }
            }

            var lengthData = [];
            if(vitalData.postnatalHeight) {
                for(var i = 0; i < vitalData.postnatalHeight.length; i++){
                    lengthData.push({x:vitalData.postnatalHeight[i].x, y:parseFloat(vitalData.postnatalHeight[i].y) + lengthConst});
                }
            }

            // Start of Head data
            var set1 = [{x:27,y:21.5+headConst},{x:28,y:22.9+headConst},{x:29,y:24.2+headConst},{x:30,y:25.3+headConst},{x:31,y:26.4+headConst},{x:32,y:27.4+headConst},{x:33,y:28.3+headConst},{x:34,y:29.2+headConst},{x:35,y:29.9+headConst},{x:36,y:30.7+headConst},{x:37,y:31.4+headConst},{x:38,y:32+headConst},{x:39,y:32.6+headConst},{x:40,y:33.2+headConst},{x:41,y:33.7+headConst},{x:42,y:34.2+headConst},{x:43,y:34.7+headConst},{x:44,y:35.1+headConst},{x:45,y:35.6+headConst},{x:46,y:36+headConst},{x:47,y:36.4+headConst},{x:48,y:36.7+headConst},{x:49,y:37.1+headConst},{x:50,y:37.4+headConst},{x:51,y:37.7+headConst},{x:52,y:38+headConst},{x:53,y:38.3+headConst},{x:54,y:38.6+headConst},{x:55,y:38.8+headConst},{x:56,y:39.1+headConst},{x:57,y:39.3+headConst},{x:58,y:39.6+headConst},{x:59,y:39.8+headConst},{x:60,y:40+headConst},{x:61,y:40.2+headConst},{x:62,y:40.4+headConst},{x:63,y:40.6+headConst},{x:64,y:40.8+headConst}];

            var set2 = [{x:27,y:22.6+headConst},{x:28,y:23.9+headConst},{x:29,y:25.1+headConst},{x:30,y:26.2+headConst},{x:31,y:27.2+headConst},{x:32,y:28.1+headConst},{x:33,y:29+headConst},{x:34,y:29.8+headConst},{x:35,y:30.6+headConst},{x:36,y:31.3+headConst},{x:37,y:32+headConst},{x:38,y:32.6+headConst},{x:39,y:33.2+headConst},{x:40,y:33.8+headConst},{x:41,y:34.3+headConst},{x:42,y:34.8+headConst},{x:43,y:35.3+headConst},{x:44,y:35.7+headConst},{x:45,y:36.2+headConst},{x:46,y:36.6+headConst},{x:47,y:36.9+headConst},{x:48,y:37.3+headConst},{x:49,y:37.7+headConst},{x:50,y:38+headConst},{x:51,y:38.3+headConst},{x:52,y:38.6+headConst},{x:53,y:38.9+headConst},{x:54,y:39.2+headConst},{x:55,y:39.5+headConst},{x:56,y:39.7+headConst},{x:57,y:40+headConst},{x:58,y:40.2+headConst},{x:59,y:40.5+headConst},{x:60,y:40.7+headConst},{x:61,y:40.9+headConst},{x:62,y:41.1+headConst},{x:63,y:41.3+headConst},{x:64,y:41.5+headConst}];
                    
            var set3 = [{x:27,y:24.8+headConst},{x:28,y:25.9+headConst},{x:29,y:27+headConst},{x:30,y:27.9+headConst},{x:31,y:28.9+headConst},{x:32,y:29.7+headConst},{x:33,y:30.5+headConst},{x:34,y:31.3+headConst},{x:35,y:32+headConst},{x:36,y:32.7+headConst},{x:37,y:33.3+headConst},{x:38,y:33.9+headConst},{x:39,y:34.5+headConst},{x:40,y:35+headConst},{x:41,y:35.6+headConst},{x:42,y:36.1+headConst},{x:43,y:36.5+headConst},{x:44,y:37+headConst},{x:45,y:37.4+headConst},{x:46,y:37.8+headConst},{x:47,y:38.2+headConst},{x:48,y:38.6+headConst},{x:49,y:38.9+headConst},{x:50,y:39.3+headConst},{x:51,y:39.6+headConst},{x:52,y:40+headConst},{x:53,y:40.3+headConst},{x:54,y:40.6+headConst},{x:55,y:40.8+headConst},{x:56,y:41.1+headConst},{x:57,y:41.4+headConst},{x:58,y:41.6+headConst},{x:59,y:41.9+headConst},{x:60,y:42.1+headConst},{x:61,y:42.4+headConst},{x:62,y:42.6+headConst},{x:63,y:42.8+headConst},{x:64,y:43+headConst}];

            var set4 = [{x:27,y:27+headConst},{x:28,y:28+headConst},{x:29,y:28.9+headConst},{x:30,y:29.7+headConst},{x:31,y:30.5+headConst},{x:32,y:31.3+headConst},{x:33,y:32+headConst},{x:34,y:32.7+headConst},{x:35,y:33.4+headConst},{x:36,y:34+headConst},{x:37,y:34.6+headConst},{x:38,y:35.2+headConst},{x:39,y:35.8+headConst},{x:40,y:36.3+headConst},{x:41,y:36.8+headConst},{x:42,y:37.3+headConst},{x:43,y:37.8+headConst},{x:44,y:38.2+headConst},{x:45,y:38.7+headConst},{x:46,y:39.1+headConst},{x:47,y:39.5+headConst},{x:48,y:39.9+headConst},{x:49,y:40.2+headConst},{x:50,y:40.6+headConst},{x:51,y:40.9+headConst},{x:52,y:41.3+headConst},{x:53,y:41.6+headConst},{x:54,y:41.9+headConst},{x:55,y:42.2+headConst},{x:56,y:42.5+headConst},{x:57,y:42.8+headConst},{x:58,y:43.1+headConst},{x:59,y:43.3+headConst},{x:60,y:43.6+headConst},{x:61,y:43.8+headConst},{x:62,y:44.1+headConst},{x:63,y:44.3+headConst},{x:64,y:44.5+headConst}];

            var set5 = [{x:27,y:28+headConst},{x:28,y:28.9+headConst},{x:29,y:29.7+headConst},{x:30,y:30.5+headConst},{x:31,y:31.3+headConst},{x:32,y:32+headConst},{x:33,y:32.7+headConst},{x:34,y:33.4+headConst},{x:35,y:34+headConst},{x:36,y:34.7+headConst},{x:37,y:35.3+headConst},{x:38,y:35.8+headConst},{x:39,y:36.4+headConst},{x:40,y:36.9+headConst},{x:41,y:37.4+headConst},{x:42,y:37.9+headConst},{x:43,y:38.4+headConst},{x:44,y:38.8+headConst},{x:45,y:39.2+headConst},{x:46,y:39.7+headConst},{x:47,y:40.1+headConst},{x:48,y:40.5+headConst},{x:49,y:40.8+headConst},{x:50,y:41.2+headConst},{x:51,y:41.6+headConst},{x:52,y:41.9+headConst},{x:53,y:42.2+headConst},{x:54,y:42.5+headConst},{x:55,y:42.9+headConst},{x:56,y:43.2+headConst},{x:57,y:43.4+headConst},{x:58,y:43.7+headConst},{x:59,y:44+headConst},{x:60,y:44.3+headConst},{x:61,y:44.5+headConst},{x:62,y:44.8+headConst},{x:63,y:45+headConst},{x:64,y:45.3+headConst}];
            // End of Head data

            // Start of Length data
            var set6 = [{x:27,y:28.7+lengthConst},{x:28,y:30.7+lengthConst},{x:29,y:32.5+lengthConst},{x:30,y:34.3+lengthConst},{x:31,y:36+lengthConst},{x:32,y:37.5+lengthConst},{x:33,y:39+lengthConst},{x:34,y:40.5+lengthConst},{x:35,y:41.8+lengthConst},{x:36,y:43.1+lengthConst},{x:37,y:44.3+lengthConst},{x:38,y:45.4+lengthConst},{x:39,y:46.5+lengthConst},{x:40,y:47.5+lengthConst},{x:41,y:48.5+lengthConst},{x:42,y:49.4+lengthConst},{x:43,y:50.3+lengthConst},{x:44,y:51.1+lengthConst},{x:45,y:51.9+lengthConst},{x:46,y:52.7+lengthConst},{x:47,y:53.4+lengthConst},{x:48,y:54.2+lengthConst},{x:49,y:54.8+lengthConst},{x:50,y:55.5+lengthConst},{x:51,y:56.1+lengthConst},{x:52,y:56.7+lengthConst},{x:53,y:57.3+lengthConst},{x:54,y:57.8+lengthConst},{x:55,y:58.4+lengthConst},{x:56,y:58.9+lengthConst},{x:57,y:59.4+lengthConst},{x:58,y:59.9+lengthConst},{x:59,y:60.4+lengthConst},{x:60,y:60.8+lengthConst},{x:61,y:61.3+lengthConst},{x:62,y:61.7+lengthConst},{x:63,y:62.1+lengthConst},{x:64,y:62.5+lengthConst}];

            var set7 = [{x:27,y:29.9+lengthConst},{x:28,y:31.9+lengthConst},{x:29,y:33.7+lengthConst},{x:30,y:35.4+lengthConst},{x:31,y:37.1+lengthConst},{x:32,y:38.7+lengthConst},{x:33,y:40.1+lengthConst},{x:34,y:41.5+lengthConst},{x:35,y:42.9+lengthConst},{x:36,y:44.1+lengthConst},{x:37,y:45.3+lengthConst},{x:38,y:46.5+lengthConst},{x:39,y:47.5+lengthConst},{x:40,y:48.6+lengthConst},{x:41,y:49.6+lengthConst},{x:42,y:50.5+lengthConst},{x:43,y:51.4+lengthConst},{x:44,y:52.2+lengthConst},{x:45,y:53+lengthConst},{x:46,y:53.8+lengthConst},{x:47,y:54.6+lengthConst},{x:48,y:55.3+lengthConst},{x:49,y:56+lengthConst},{x:50,y:56.6+lengthConst},{x:51,y:57.2+lengthConst},{x:52,y:57.9+lengthConst},{x:53,y:58.4+lengthConst},{x:54,y:59+lengthConst},{x:55,y:59.6+lengthConst},{x:56,y:60.1+lengthConst},{x:57,y:60.6+lengthConst},{x:58,y:61.1+lengthConst},{x:59,y:61.6+lengthConst},{x:60,y:62.1+lengthConst},{x:61,y:62.5+lengthConst},{x:62,y:63+lengthConst},{x:63,y:63.4+lengthConst},{x:64,y:63.8+lengthConst}];
                    
            var set8 = [{x:27,y:32.7+lengthConst},{x:28,y:34.6+lengthConst},{x:29,y:36.3+lengthConst},{x:30,y:38+lengthConst},{x:31,y:39.6+lengthConst},{x:32,y:41.1+lengthConst},{x:33,y:42.6+lengthConst},{x:34,y:44+lengthConst},{x:35,y:45.3+lengthConst},{x:36,y:46.5+lengthConst},{x:37,y:47.7+lengthConst},{x:38,y:48.8+lengthConst},{x:39,y:49.9+lengthConst},{x:40,y:50.9+lengthConst},{x:41,y:51.9+lengthConst},{x:42,y:52.8+lengthConst},{x:43,y:53.7+lengthConst},{x:44,y:54.6+lengthConst},{x:45,y:55.4+lengthConst},{x:46,y:56.2+lengthConst},{x:47,y:57+lengthConst},{x:48,y:57.7+lengthConst},{x:49,y:58.4+lengthConst},{x:50,y:59.1+lengthConst},{x:51,y:59.8+lengthConst},{x:52,y:60.4+lengthConst},{x:53,y:61+lengthConst},{x:54,y:61.6+lengthConst},{x:55,y:62.2+lengthConst},{x:56,y:62.8+lengthConst},{x:57,y:63.3+lengthConst},{x:58,y:63.8+lengthConst},{x:59,y:64.4+lengthConst},{x:60,y:64.9+lengthConst},{x:61,y:65.4+lengthConst},{x:62,y:65.8+lengthConst},{x:63,y:66.3+lengthConst},{x:64,y:66.8+lengthConst}];

            var set9 = [{x:27,y:35.7+lengthConst},{x:28,y:37.5+lengthConst},{x:29,y:39.2+lengthConst},{x:30,y:40.8+lengthConst},{x:31,y:42.3+lengthConst},{x:32,y:43.8+lengthConst},{x:33,y:45.2+lengthConst},{x:34,y:46.5+lengthConst},{x:35,y:47.8+lengthConst},{x:36,y:49+lengthConst},{x:37,y:50.2+lengthConst},{x:38,y:51.3+lengthConst},{x:39,y:52.4+lengthConst},{x:40,y:53.4+lengthConst},{x:41,y:54.4+lengthConst},{x:42,y:55.3+lengthConst},{x:43,y:56.2+lengthConst},{x:44,y:57.1+lengthConst},{x:45,y:57.9+lengthConst},{x:46,y:58.7+lengthConst},{x:47,y:59.5+lengthConst},{x:48,y:60.3+lengthConst},{x:49,y:61+lengthConst},{x:50,y:61.7+lengthConst},{x:51,y:62.4+lengthConst},{x:52,y:63.1+lengthConst},{x:53,y:63.7+lengthConst},{x:54,y:64.3+lengthConst},{x:55,y:64.9+lengthConst},{x:56,y:65.5+lengthConst},{x:57,y:66.1+lengthConst},{x:58,y:66.7+lengthConst},{x:59,y:67.2+lengthConst},{x:60,y:67.8+lengthConst},{x:61,y:68.3+lengthConst},{x:62,y:68.8+lengthConst},{x:63,y:69.3+lengthConst},{x:64,y:69.8+lengthConst}];

            var set10 = [{x:27,y:37.3+lengthConst},{x:28,y:39+lengthConst},{x:29,y:40.6+lengthConst},{x:30,y:42.2+lengthConst},{x:31,y:43.7+lengthConst},{x:32,y:45.1+lengthConst},{x:33,y:46.5+lengthConst},{x:34,y:47.8+lengthConst},{x:35,y:49+lengthConst},{x:36,y:50.2+lengthConst},{x:37,y:51.4+lengthConst},{x:38,y:52.5+lengthConst},{x:39,y:53.6+lengthConst},{x:40,y:54.6+lengthConst},{x:41,y:55.6+lengthConst},{x:42,y:56.5+lengthConst},{x:43,y:57.4+lengthConst},{x:44,y:58.3+lengthConst},{x:45,y:59.1+lengthConst},{x:46,y:60+lengthConst},{x:47,y:60.7+lengthConst},{x:48,y:61.5+lengthConst},{x:49,y:62.3+lengthConst},{x:50,y:63+lengthConst},{x:51,y:63.7+lengthConst},{x:52,y:64.4+lengthConst},{x:53,y:65+lengthConst},{x:54,y:65.7+lengthConst},{x:55,y:66.3+lengthConst},{x:56,y:66.9+lengthConst},{x:57,y:67.5+lengthConst},{x:58,y:68.1+lengthConst},{x:59,y:68.6+lengthConst},{x:60,y:69.2+lengthConst},{x:61,y:69.7+lengthConst},{x:62,y:70.2+lengthConst},{x:63,y:70.8+lengthConst},{x:64,y:71.3+lengthConst}];
            // End of Length data
            
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([lengthData]);
            var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([65,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([65,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,61]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,61]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%2==0 ? yAxisLeftFake(d):'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%2==0 ? yAxisRightFake(d):'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var yAxisLeftFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return '';
                case 14:return 28;
                case 16:return 30;
                case 18:return 32;
                case 20:return 34;
                case 22:return 36;
                case 24:return 38;
                case 26:return 40;
                case 28:return 42;
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var yAxisRightFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return 32;
                case 14:return 34;
                case 16:return 36;
                case 18:return 38;
                case 20:return 40;
                case 22:return 42;
                case 24:return 44;
                case 26:return 46;
                case 28:return '';
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Postmensural age (weeks)");
            
            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            

            svg.append("text")
                .attr("x", -350 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head (cm)");
            
            svg.append("text")
                .attr("x", -180 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -300 )
                .attr("y", 850 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -100 )
                .attr("y", 850 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 85 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 70 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 55 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 40 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 25 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 260 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 250 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 240 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 230 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 220 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set6),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set8),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set10),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(hcData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(lengthData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('postnatalWeightFemaleDirective', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var weightData = [];

            if(vitalData.postnatalWeight) {
                for(var i = 0; i < vitalData.postnatalWeight.length; i++){
                    if(vitalData.postnatalWeight[i].y<10.5 && vitalData.postnatalWeight[i].y>0) {
                        weightData.push(vitalData.postnatalWeight[i]);
                    }
                }
            }

            var set1 = [{x:27,y:0.41},{x:28,y:0.52},{x:29,y:0.64},{x:30,y:0.77},{x:31,y:0.91},{x:32,y:1.06},{x:33,y:1.22},{x:34,y:1.38},{x:35,y:1.55},{x:36,y:1.72},{x:37,y:1.89},{x:38,y:2.06},{x:39,y:2.23},{x:40,y:2.41},{x:41,y:2.58},{x:42,y:2.75},{x:43,y:2.91},{x:44,y:3.08},{x:45,y:3.24},{x:46,y:3.4},{x:47,y:3.55},{x:48,y:3.7},{x:49,y:3.85},{x:50,y:3.99},{x:51,y:4.13},{x:52,y:4.26},{x:53,y:4.4},{x:54,y:4.52},{x:55,y:4.64},{x:56,y:4.76},{x:57,y:4.88},{x:58,y:4.99},{x:59,y:5.1},{x:60,y:5.2},{x:61,y:5.3},{x:62,y:5.4},{x:63,y:5.49},{x:64,y:5.58}];

            var set2 = [{x:27,y:0.47},{x:28,y:0.59},{x:29,y:0.72},{x:30,y:0.86},{x:31,y:1.01},{x:32,y:1.18},{x:33,y:1.34},{x:34,y:1.52},{x:35,y:1.7},{x:36,y:1.88},{x:37,y:2.06},{x:38,y:2.25},{x:39,y:2.43},{x:40,y:2.62},{x:41,y:2.8},{x:42,y:2.98},{x:43,y:3.16},{x:44,y:3.34},{x:45,y:3.51},{x:46,y:3.68},{x:47,y:3.84},{x:48,y:4.01},{x:49,y:4.16},{x:50,y:4.32},{x:51,y:4.46},{x:52,y:4.61},{x:53,y:4.75},{x:54,y:4.89},{x:55,y:5.02},{x:56,y:5.15},{x:57,y:5.27},{x:58,y:5.39},{x:59,y:5.51},{x:60,y:5.62},{x:61,y:5.73},{x:62,y:5.83},{x:63,y:5.93},{x:64,y:6.03}];

            var set3 = [{x:27,y:0.61},{x:28,y:0.76},{x:29,y:0.91},{x:30,y:1.09},{x:31,y:1.27},{x:32,y:1.46},{x:33,y:1.65},{x:34,y:1.86},{x:35,y:2.07},{x:36,y:2.28},{x:37,y:2.49},{x:38,y:2.71},{x:39,y:2.92},{x:40,y:3.13},{x:41,y:3.35},{x:42,y:3.55},{x:43,y:3.76},{x:44,y:3.96},{x:45,y:4.16},{x:46,y:4.36},{x:47,y:4.55},{x:48,y:4.74},{x:49,y:4.92},{x:50,y:5.1},{x:51,y:5.27},{x:52,y:5.44},{x:53,y:5.6},{x:54,y:5.76},{x:55,y:5.92},{x:56,y:6.07},{x:57,y:6.21},{x:58,y:6.35},{x:59,y:6.49},{x:60,y:6.62},{x:61,y:6.75},{x:62,y:6.87},{x:63,y:6.99},{x:64,y:7.11}];

            var set4 = [{x:27,y:0.8},{x:28,y:0.97},{x:29,y:1.16},{x:30,y:1.37},{x:31,y:1.58},{x:32,y:1.8},{x:33,y:2.03},{x:34,y:2.27},{x:35,y:2.51},{x:36,y:2.76},{x:37,y:3.01},{x:38,y:3.26},{x:39,y:3.5},{x:40,y:3.75},{x:41,y:3.99},{x:42,y:4.24},{x:43,y:4.48},{x:44,y:4.71},{x:45,y:4.94},{x:46,y:5.17},{x:47,y:5.39},{x:48,y:5.61},{x:49,y:5.82},{x:50,y:6.02},{x:51,y:6.22},{x:52,y:6.42},{x:53,y:6.61},{x:54,y:6.8},{x:55,y:6.98},{x:56,y:7.15},{x:57,y:7.32},{x:58,y:7.49},{x:59,y:7.65},{x:60,y:7.8},{x:61,y:7.95},{x:62,y:8.1},{x:63,y:8.24},{x:64,y:8.38}];

            var set5 = [{x:27,y:0.91},{x:28,y:1.1},{x:29,y:1.3},{x:30,y:1.52},{x:31,y:1.75},{x:32,y:1.99},{x:33,y:2.24},{x:34,y:2.5},{x:35,y:2.76},{x:36,y:3.02},{x:37,y:3.29},{x:38,y:3.55},{x:39,y:3.82},{x:40,y:4.08},{x:41,y:4.34},{x:42,y:4.6},{x:43,y:4.85},{x:44,y:5.11},{x:45,y:5.35},{x:46,y:5.6},{x:47,y:5.83},{x:48,y:6.06},{x:49,y:6.29},{x:50,y:6.51},{x:51,y:6.73},{x:52,y:6.94},{x:53,y:7.14},{x:54,y:7.34},{x:55,y:7.54},{x:56,y:7.73},{x:57,y:7.91},{x:58,y:8.09},{x:59,y:8.26},{x:60,y:8.43},{x:61,y:8.59},{x:62,y:8.75},{x:63,y:8.9},{x:64,y:9.05}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([64,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([64,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0.0,10.5, 0.5)).tickFormat(function(d){
                return d%1==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0.0, 10.5, 0.5)).tickFormat(function(d){
                return d%1==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Postmenstrual age (Weeks)");

            svg.append("text")
                .attr("x", -200 )
                .attr("y", -35)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (Kg)");
            
                svg.append("text")
                .attr("x", 770 )
                .attr("y", 185 )
                .style("text-anchor", "start")
                .text("3rd");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 165 )
                .style("text-anchor", "start")
                .text("10th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 125 )
                .style("text-anchor", "start")
                .text("50th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 80 )
                .style("text-anchor", "start")
                .text("90th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 55 )
                .style("text-anchor", "start")
                .text("97th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('postnatalWeightMaleDirective', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var weightData = [];

            if(vitalData.postnatalWeight) {
                for(var i = 0; i < vitalData.postnatalWeight.length; i++){
                    if(vitalData.postnatalWeight[i].y<10.5 && vitalData.postnatalWeight[i].y>0) {
                        weightData.push(vitalData.postnatalWeight[i]);
                    }
                }
            }

            var set1 = [{x:27,y:0.45},{x:28,y:0.57},{x:29,y:0.7},{x:30,y:0.85},{x:31,y:1},{x:32,y:1.17},{x:33,y:1.34},{x:34,y:1.51},{x:35,y:1.7},{x:36,y:1.88},{x:37,y:2.07},{x:38,y:2.26},{x:39,y:2.45},{x:40,y:2.64},{x:41,y:2.82},{x:42,y:3.01},{x:43,y:3.19},{x:44,y:3.37},{x:45,y:3.55},{x:46,y:3.72},{x:47,y:3.89},{x:48,y:4.06},{x:49,y:4.22},{x:50,y:4.37},{x:51,y:4.52},{x:52,y:4.67},{x:53,y:4.81},{x:54,y:4.95},{x:55,y:5.09},{x:56,y:5.22},{x:57,y:5.34},{x:58,y:5.47},{x:59,y:5.58},{x:60,y:5.7},{x:61,y:5.81},{x:62,y:5.92},{x:63,y:6.02},{x:64,y:6.12}];

            var set2 = [{x:27,y:0.51},{x:28,y:0.64},{x:29,y:0.79},{x:30,y:0.94},{x:31,y:1.11},{x:32,y:1.29},{x:33,y:1.47},{x:34,y:1.66},{x:35,y:1.86},{x:36,y:2.06},{x:37,y:2.26},{x:38,y:2.46},{x:39,y:2.67},{x:40,y:2.87},{x:41,y:3.07},{x:42,y:3.27},{x:43,y:3.46},{x:44,y:3.66},{x:45,y:3.84},{x:46,y:4.03},{x:47,y:4.21},{x:48,y:4.39},{x:49,y:4.56},{x:50,y:4.73},{x:51,y:4.89},{x:52,y:5.05},{x:53,y:5.2},{x:54,y:5.35},{x:55,y:5.5},{x:56,y:5.64},{x:57,y:5.77},{x:58,y:5.9},{x:59,y:6.03},{x:60,y:6.15},{x:61,y:6.27},{x:62,y:6.39},{x:63,y:6.5},{x:64,y:6.61}];

            var set3 = [{x:27,y:0.67},{x:28,y:0.83},{x:29,y:1},{x:30,y:1.19},{x:31,y:1.39},{x:32,y:1.6},{x:33,y:1.81},{x:34,y:2.04},{x:35,y:2.26},{x:36,y:2.5},{x:37,y:2.73},{x:38,y:2.96},{x:39,y:3.2},{x:40,y:3.43},{x:41,y:3.66},{x:42,y:3.89},{x:43,y:4.12},{x:44,y:4.34},{x:45,y:4.56},{x:46,y:4.78},{x:47,y:4.99},{x:48,y:5.19},{x:49,y:5.39},{x:50,y:5.59},{x:51,y:5.77},{x:52,y:5.96},{x:53,y:6.14},{x:54,y:6.31},{x:55,y:6.48},{x:56,y:6.65},{x:57,y:6.8},{x:58,y:6.96},{x:59,y:7.11},{x:60,y:7.25},{x:61,y:7.39},{x:62,y:7.53},{x:63,y:7.66},{x:64,y:7.79}];

            var set4 = [{x:27,y:0.88},{x:28,y:1.07},{x:29,y:1.27},{x:30,y:1.5},{x:31,y:1.73},{x:32,y:1.98},{x:33,y:2.23},{x:34,y:2.49},{x:35,y:2.75},{x:36,y:3.02},{x:37,y:3.29},{x:38,y:3.57},{x:39,y:3.84},{x:40,y:4.11},{x:41,y:4.38},{x:42,y:4.64},{x:43,y:4.9},{x:44,y:5.16},{x:45,y:5.41},{x:46,y:5.66},{x:47,y:5.9},{x:48,y:6.14},{x:49,y:6.37},{x:50,y:6.6},{x:51,y:6.82},{x:52,y:7.03},{x:53,y:7.24},{x:54,y:7.45},{x:55,y:7.64},{x:56,y:7.83},{x:57,y:8.02},{x:58,y:8.2},{x:59,y:8.38},{x:60,y:8.55},{x:61,y:8.71},{x:62,y:8.87},{x:63,y:9.03},{x:64,y:9.18}];

            var set5 = [{x:27,y:0.99},{x:28,y:1.2},{x:29,y:1.43},{x:30,y:1.67},{x:31,y:1.92},{x:32,y:2.18},{x:33,y:2.46},{x:34,y:2.74},{x:35,y:3.02},{x:36,y:3.31},{x:37,y:3.6},{x:38,y:3.89},{x:39,y:4.18},{x:40,y:4.47},{x:41,y:4.76},{x:42,y:5.04},{x:43,y:5.32},{x:44,y:5.59},{x:45,y:5.86},{x:46,y:6.13},{x:47,y:6.39},{x:48,y:6.64},{x:49,y:6.89},{x:50,y:7.13},{x:51,y:7.37},{x:52,y:7.6},{x:53,y:7.83},{x:54,y:8.04},{x:55,y:8.26},{x:56,y:8.46},{x:57,y:8.66},{x:58,y:8.86},{x:59,y:9.05},{x:60,y:9.23},{x:61,y:9.41},{x:62,y:9.58},{x:63,y:9.75},{x:64,y:9.91}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([64,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([64,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0.0,10.5, 0.5)).tickFormat(function(d){
                return d%1==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0.0, 10.5, 0.5)).tickFormat(function(d){
                return d%1==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Postmenstrual age (Weeks)");

            svg.append("text")
                .attr("x", -200 )
                .attr("y", -35)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (Kg)");
            
                svg.append("text")
                .attr("x", 770 )
                .attr("y", 165 )
                .style("text-anchor", "start")
                .text("3rd");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 145 )
                .style("text-anchor", "start")
                .text("10th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 100 )
                .style("text-anchor", "start")
                .text("50th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 50 )
                .style("text-anchor", "start")
                .text("90th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 25 )
                .style("text-anchor", "start")
                .text("97th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('hlwPretermChartFemaleDirective', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 440 - margin.top - margin.bottom;
              var width = 960 - margin.left - margin.right;
  
            var headConst = -17;
            var lengthConst = -2;
            var weightConst = 42;

            var hcData = [];
            if(vitalData.pretermHc) {
                for(var i = 0; i < vitalData.pretermHc.length; i++){
                    hcData.push({x:vitalData.pretermHc[i].x,y:vitalData.pretermHc[i].y + headConst});
                }
            }

            var heightData = [];
            if(vitalData.pretermHeight) {
                for(var i = 0; i < vitalData.pretermHeight.length; i++){
                    heightData.push({x:vitalData.pretermHeight[i].x,y:vitalData.pretermHeight[i].y + lengthConst});
                }
            }
            
            var weightData = [];
            if(vitalData.pretermWeight) {
                for(var i = 0; i < vitalData.pretermWeight.length; i++){
                    weightData.push({x:vitalData.pretermWeight[i].x,y:(vitalData.pretermWeight[i].y *10) + weightConst});
                }
            }
  
              // Start of Head data
              var set1 = [{x:168,y:19.2+headConst},{x:169,y:19.3+headConst},{x:170,y:19.4+headConst},{x:171,y:19.5+headConst},{x:172,y:19.7+headConst},{x:173,y:19.8+headConst},{x:174,y:19.9+headConst},{x:175,y:20+headConst},{x:176,y:20.2+headConst},{x:177,y:20.3+headConst},{x:178,y:20.4+headConst},{x:179,y:20.6+headConst},{x:180,y:20.7+headConst},{x:181,y:20.8+headConst},{x:182,y:20.9+headConst},{x:183,y:21.1+headConst},{x:184,y:21.2+headConst},{x:185,y:21.3+headConst},{x:186,y:21.4+headConst},{x:187,y:21.6+headConst},{x:188,y:21.7+headConst},{x:189,y:21.8+headConst},{x:190,y:21.9+headConst},{x:191,y:22.1+headConst},{x:192,y:22.2+headConst},{x:193,y:22.3+headConst},{x:194,y:22.5+headConst},{x:195,y:22.6+headConst},{x:196,y:22.7+headConst},{x:197,y:22.8+headConst},{x:198,y:23+headConst},{x:199,y:23.1+headConst},{x:200,y:23.2+headConst},{x:201,y:23.3+headConst},{x:202,y:23.5+headConst},{x:203,y:23.6+headConst},{x:204,y:23.7+headConst},{x:205,y:23.8+headConst},{x:206,y:24+headConst},{x:207,y:24.1+headConst},{x:208,y:24.2+headConst},{x:209,y:24.4+headConst},{x:210,y:24.5+headConst},{x:211,y:24.6+headConst},{x:212,y:24.7+headConst},{x:213,y:24.9+headConst},{x:214,y:25+headConst},{x:215,y:25.1+headConst},{x:216,y:25.2+headConst},{x:217,y:25.4+headConst},{x:218,y:25.5+headConst},{x:219,y:25.6+headConst},{x:220,y:25.7+headConst},{x:221,y:25.9+headConst},{x:222,y:26+headConst},{x:223,y:26.1+headConst},{x:224,y:26.3+headConst},{x:225,y:26.4+headConst},{x:226,y:26.5+headConst},{x:227,y:26.6+headConst},{x:228,y:26.8+headConst},{x:229,y:26.9+headConst},{x:230,y:27+headConst}];
    
              var set2 = [{x:168,y:20.1+headConst},{x:169,y:20.2+headConst},{x:170,y:20.3+headConst},{x:171,y:20.5+headConst},{x:172,y:20.6+headConst},{x:173,y:20.7+headConst},{x:174,y:20.9+headConst},{x:175,y:21+headConst},{x:176,y:21.1+headConst},{x:177,y:21.2+headConst},{x:178,y:21.4+headConst},{x:179,y:21.5+headConst},{x:180,y:21.6+headConst},{x:181,y:21.7+headConst},{x:182,y:21.9+headConst},{x:183,y:22+headConst},{x:184,y:22.1+headConst},{x:185,y:22.2+headConst},{x:186,y:22.4+headConst},{x:187,y:22.5+headConst},{x:188,y:22.6+headConst},{x:189,y:22.8+headConst},{x:190,y:22.9+headConst},{x:191,y:23+headConst},{x:192,y:23.1+headConst},{x:193,y:23.3+headConst},{x:194,y:23.4+headConst},{x:195,y:23.5+headConst},{x:196,y:23.6+headConst},{x:197,y:23.8+headConst},{x:198,y:23.9+headConst},{x:199,y:24+headConst},{x:200,y:24.1+headConst},{x:201,y:24.3+headConst},{x:202,y:24.4+headConst},{x:203,y:24.5+headConst},{x:204,y:24.7+headConst},{x:205,y:24.8+headConst},{x:206,y:24.9+headConst},{x:207,y:25+headConst},{x:208,y:25.2+headConst},{x:209,y:25.3+headConst},{x:210,y:25.4+headConst},{x:211,y:25.5+headConst},{x:212,y:25.7+headConst},{x:213,y:25.8+headConst},{x:214,y:25.9+headConst},{x:215,y:26.1+headConst},{x:216,y:26.2+headConst},{x:217,y:26.3+headConst},{x:218,y:26.4+headConst},{x:219,y:26.6+headConst},{x:220,y:26.7+headConst},{x:221,y:26.8+headConst},{x:222,y:26.9+headConst},{x:223,y:27.1+headConst},{x:224,y:27.2+headConst},{x:225,y:27.3+headConst},{x:226,y:27.4+headConst},{x:227,y:27.6+headConst},{x:228,y:27.7+headConst},{x:229,y:27.8+headConst},{x:230,y:28+headConst}];
                      
              var set3 = [{x:168,y:22.1+headConst},{x:169,y:22.2+headConst},{x:170,y:22.3+headConst},{x:171,y:22.5+headConst},{x:172,y:22.6+headConst},{x:173,y:22.7+headConst},{x:174,y:22.9+headConst},{x:175,y:23+headConst},{x:176,y:23.1+headConst},{x:177,y:23.2+headConst},{x:178,y:23.4+headConst},{x:179,y:23.5+headConst},{x:180,y:23.6+headConst},{x:181,y:23.7+headConst},{x:182,y:23.9+headConst},{x:183,y:24+headConst},{x:184,y:24.1+headConst},{x:185,y:24.2+headConst},{x:186,y:24.4+headConst},{x:187,y:24.5+headConst},{x:188,y:24.6+headConst},{x:189,y:24.8+headConst},{x:190,y:24.9+headConst},{x:191,y:25+headConst},{x:192,y:25.1+headConst},{x:193,y:25.3+headConst},{x:194,y:25.4+headConst},{x:195,y:25.5+headConst},{x:196,y:25.6+headConst},{x:197,y:25.8+headConst},{x:198,y:25.9+headConst},{x:199,y:26+headConst},{x:200,y:26.1+headConst},{x:201,y:26.3+headConst},{x:202,y:26.4+headConst},{x:203,y:26.5+headConst},{x:204,y:26.7+headConst},{x:205,y:26.8+headConst},{x:206,y:26.9+headConst},{x:207,y:27+headConst},{x:208,y:27.2+headConst},{x:209,y:27.3+headConst},{x:210,y:27.4+headConst},{x:211,y:27.5+headConst},{x:212,y:27.7+headConst},{x:213,y:27.8+headConst},{x:214,y:27.9+headConst},{x:215,y:28+headConst},{x:216,y:28.2+headConst},{x:217,y:28.3+headConst},{x:218,y:28.4+headConst},{x:219,y:28.6+headConst},{x:220,y:28.7+headConst},{x:221,y:28.8+headConst},{x:222,y:28.9+headConst},{x:223,y:29.1+headConst},{x:224,y:29.2+headConst},{x:225,y:29.3+headConst},{x:226,y:29.4+headConst},{x:227,y:29.6+headConst},{x:228,y:29.7+headConst},{x:229,y:29.8+headConst},{x:230,y:30+headConst}];
  
              var set4 = [{x:168,y:24.1+headConst},{x:169,y:24.2+headConst},{x:170,y:24.3+headConst},{x:171,y:24.5+headConst},{x:172,y:24.6+headConst},{x:173,y:24.7+headConst},{x:174,y:24.8+headConst},{x:175,y:25+headConst},{x:176,y:25.1+headConst},{x:177,y:25.2+headConst},{x:178,y:25.4+headConst},{x:179,y:25.5+headConst},{x:180,y:25.6+headConst},{x:181,y:25.7+headConst},{x:182,y:25.9+headConst},{x:183,y:26+headConst},{x:184,y:26.1+headConst},{x:185,y:26.2+headConst},{x:186,y:26.4+headConst},{x:187,y:26.5+headConst},{x:188,y:26.6+headConst},{x:189,y:26.8+headConst},{x:190,y:26.9+headConst},{x:191,y:27+headConst},{x:192,y:27.1+headConst},{x:193,y:27.3+headConst},{x:194,y:27.4+headConst},{x:195,y:27.5+headConst},{x:196,y:27.6+headConst},{x:197,y:27.8+headConst},{x:198,y:27.9+headConst},{x:199,y:28+headConst},{x:200,y:28.1+headConst},{x:201,y:28.3+headConst},{x:202,y:28.4+headConst},{x:203,y:28.5+headConst},{x:204,y:28.7+headConst},{x:205,y:28.8+headConst},{x:206,y:28.9+headConst},{x:207,y:29+headConst},{x:208,y:29.2+headConst},{x:209,y:29.3+headConst},{x:210,y:29.4+headConst},{x:211,y:29.5+headConst},{x:212,y:29.7+headConst},{x:213,y:29.8+headConst},{x:214,y:29.9+headConst},{x:215,y:30+headConst},{x:216,y:30.2+headConst},{x:217,y:30.3+headConst},{x:218,y:30.4+headConst},{x:219,y:30.6+headConst},{x:220,y:30.7+headConst},{x:221,y:30.8+headConst},{x:222,y:30.9+headConst},{x:223,y:31.1+headConst},{x:224,y:31.2+headConst},{x:225,y:31.3+headConst},{x:226,y:31.4+headConst},{x:227,y:31.6+headConst},{x:228,y:31.7+headConst},{x:229,y:31.8+headConst},{x:230,y:32+headConst}];
  
              var set5 = [{x:168,y:25+headConst},{x:169,y:25.2+headConst},{x:170,y:25.3+headConst},{x:171,y:25.4+headConst},{x:172,y:25.5+headConst},{x:173,y:25.7+headConst},{x:174,y:25.8+headConst},{x:175,y:25.9+headConst},{x:176,y:26+headConst},{x:177,y:26.2+headConst},{x:178,y:26.3+headConst},{x:179,y:26.4+headConst},{x:180,y:26.5+headConst},{x:181,y:26.7+headConst},{x:182,y:26.8+headConst},{x:183,y:26.9+headConst},{x:184,y:27.1+headConst},{x:185,y:27.2+headConst},{x:186,y:27.3+headConst},{x:187,y:27.4+headConst},{x:188,y:27.6+headConst},{x:189,y:27.7+headConst},{x:190,y:27.8+headConst},{x:191,y:27.9+headConst},{x:192,y:28.1+headConst},{x:193,y:28.2+headConst},{x:194,y:28.3+headConst},{x:195,y:28.4+headConst},{x:196,y:28.6+headConst},{x:197,y:28.7+headConst},{x:198,y:28.8+headConst},{x:199,y:29+headConst},{x:200,y:29.1+headConst},{x:201,y:29.2+headConst},{x:202,y:29.3+headConst},{x:203,y:29.5+headConst},{x:204,y:29.6+headConst},{x:205,y:29.7+headConst},{x:206,y:29.8+headConst},{x:207,y:30+headConst},{x:208,y:30.1+headConst},{x:209,y:30.2+headConst},{x:210,y:30.3+headConst},{x:211,y:30.5+headConst},{x:212,y:30.6+headConst},{x:213,y:30.7+headConst},{x:214,y:30.9+headConst},{x:215,y:31+headConst},{x:216,y:31.1+headConst},{x:217,y:31.2+headConst},{x:218,y:31.4+headConst},{x:219,y:31.5+headConst},{x:220,y:31.6+headConst},{x:221,y:31.7+headConst},{x:222,y:31.9+headConst},{x:223,y:32+headConst},{x:224,y:32.1+headConst},{x:225,y:32.3+headConst},{x:226,y:32.4+headConst},{x:227,y:32.5+headConst},{x:228,y:32.6+headConst},{x:229,y:32.8+headConst},{x:230,y:32.9+headConst}];
              // End of Head data
  
              // Start of Length data
              var set6 = [{x:168,y:26.9+lengthConst},{x:169,y:27.1+lengthConst},{x:170,y:27.3+lengthConst},{x:171,y:27.4+lengthConst},{x:172,y:27.6+lengthConst},{x:173,y:27.8+lengthConst},{x:174,y:28+lengthConst},{x:175,y:28.2+lengthConst},{x:176,y:28.4+lengthConst},{x:177,y:28.5+lengthConst},{x:178,y:28.7+lengthConst},{x:179,y:28.9+lengthConst},{x:180,y:29.1+lengthConst},{x:181,y:29.3+lengthConst},{x:182,y:29.4+lengthConst},{x:183,y:29.6+lengthConst},{x:184,y:29.8+lengthConst},{x:185,y:30+lengthConst},{x:186,y:30.2+lengthConst},{x:187,y:30.3+lengthConst},{x:188,y:30.5+lengthConst},{x:189,y:30.7+lengthConst},{x:190,y:30.9+lengthConst},{x:191,y:31.1+lengthConst},{x:192,y:31.3+lengthConst},{x:193,y:31.4+lengthConst},{x:194,y:31.6+lengthConst},{x:195,y:31.8+lengthConst},{x:196,y:32+lengthConst},{x:197,y:32.2+lengthConst},{x:198,y:32.3+lengthConst},{x:199,y:32.5+lengthConst},{x:200,y:32.7+lengthConst},{x:201,y:32.9+lengthConst},{x:202,y:33.1+lengthConst},{x:203,y:33.2+lengthConst},{x:204,y:33.4+lengthConst},{x:205,y:33.6+lengthConst},{x:206,y:33.8+lengthConst},{x:207,y:34+lengthConst},{x:208,y:34.2+lengthConst},{x:209,y:34.3+lengthConst},{x:210,y:34.5+lengthConst},{x:211,y:34.7+lengthConst},{x:212,y:34.9+lengthConst},{x:213,y:35.1+lengthConst},{x:214,y:35.2+lengthConst},{x:215,y:35.4+lengthConst},{x:216,y:35.6+lengthConst},{x:217,y:35.8+lengthConst},{x:218,y:36+lengthConst},{x:219,y:36.2+lengthConst},{x:220,y:36.3+lengthConst},{x:221,y:36.5+lengthConst},{x:222,y:36.7+lengthConst},{x:223,y:36.9+lengthConst},{x:224,y:37.1+lengthConst},{x:225,y:37.2+lengthConst},{x:226,y:37.4+lengthConst},{x:227,y:37.6+lengthConst},{x:228,y:37.8+lengthConst},{x:229,y:38+lengthConst},{x:230,y:38.1+lengthConst}];
  
              var set7 = [{x:168,y:28.5+lengthConst},{x:169,y:28.6+lengthConst},{x:170,y:28.8+lengthConst},{x:171,y:29+lengthConst},{x:172,y:29.2+lengthConst},{x:173,y:29.4+lengthConst},{x:174,y:29.5+lengthConst},{x:175,y:29.7+lengthConst},{x:176,y:29.9+lengthConst},{x:177,y:30.1+lengthConst},{x:178,y:30.3+lengthConst},{x:179,y:30.5+lengthConst},{x:180,y:30.6+lengthConst},{x:181,y:30.8+lengthConst},{x:182,y:31+lengthConst},{x:183,y:31.2+lengthConst},{x:184,y:31.4+lengthConst},{x:185,y:31.5+lengthConst},{x:186,y:31.7+lengthConst},{x:187,y:31.9+lengthConst},{x:188,y:32.1+lengthConst},{x:189,y:32.3+lengthConst},{x:190,y:32.4+lengthConst},{x:191,y:32.6+lengthConst},{x:192,y:32.8+lengthConst},{x:193,y:33+lengthConst},{x:194,y:33.2+lengthConst},{x:195,y:33.4+lengthConst},{x:196,y:33.5+lengthConst},{x:197,y:33.7+lengthConst},{x:198,y:33.9+lengthConst},{x:199,y:34.1+lengthConst},{x:200,y:34.3+lengthConst},{x:201,y:34.4+lengthConst},{x:202,y:34.6+lengthConst},{x:203,y:34.8+lengthConst},{x:204,y:35+lengthConst},{x:205,y:35.2+lengthConst},{x:206,y:35.4+lengthConst},{x:207,y:35.5+lengthConst},{x:208,y:35.7+lengthConst},{x:209,y:35.9+lengthConst},{x:210,y:36.1+lengthConst},{x:211,y:36.3+lengthConst},{x:212,y:36.4+lengthConst},{x:213,y:36.6+lengthConst},{x:214,y:36.8+lengthConst},{x:215,y:37+lengthConst},{x:216,y:37.2+lengthConst},{x:217,y:37.3+lengthConst},{x:218,y:37.5+lengthConst},{x:219,y:37.7+lengthConst},{x:220,y:37.9+lengthConst},{x:221,y:38.1+lengthConst},{x:222,y:38.3+lengthConst},{x:223,y:38.4+lengthConst},{x:224,y:38.6+lengthConst},{x:225,y:38.8+lengthConst},{x:226,y:39+lengthConst},{x:227,y:39.2+lengthConst},{x:228,y:39.3+lengthConst},{x:229,y:39.5+lengthConst},{x:230,y:39.7+lengthConst}];
                      
              var set8 = [{x:168,y:31.8+lengthConst},{x:169,y:32+lengthConst},{x:170,y:32.2+lengthConst},{x:171,y:32.3+lengthConst},{x:172,y:32.5+lengthConst},{x:173,y:32.7+lengthConst},{x:174,y:32.9+lengthConst},{x:175,y:33.1+lengthConst},{x:176,y:33.2+lengthConst},{x:177,y:33.4+lengthConst},{x:178,y:33.6+lengthConst},{x:179,y:33.8+lengthConst},{x:180,y:34+lengthConst},{x:181,y:34.1+lengthConst},{x:182,y:34.3+lengthConst},{x:183,y:34.5+lengthConst},{x:184,y:34.7+lengthConst},{x:185,y:34.9+lengthConst},{x:186,y:35.1+lengthConst},{x:187,y:35.2+lengthConst},{x:188,y:35.4+lengthConst},{x:189,y:35.6+lengthConst},{x:190,y:35.8+lengthConst},{x:191,y:36+lengthConst},{x:192,y:36.1+lengthConst},{x:193,y:36.3+lengthConst},{x:194,y:36.5+lengthConst},{x:195,y:36.7+lengthConst},{x:196,y:36.9+lengthConst},{x:197,y:37+lengthConst},{x:198,y:37.2+lengthConst},{x:199,y:37.4+lengthConst},{x:200,y:37.6+lengthConst},{x:201,y:37.8+lengthConst},{x:202,y:38+lengthConst},{x:203,y:38.1+lengthConst},{x:204,y:38.3+lengthConst},{x:205,y:38.5+lengthConst},{x:206,y:38.7+lengthConst},{x:207,y:38.9+lengthConst},{x:208,y:39+lengthConst},{x:209,y:39.2+lengthConst},{x:210,y:39.4+lengthConst},{x:211,y:39.6+lengthConst},{x:212,y:39.8+lengthConst},{x:213,y:40+lengthConst},{x:214,y:40.1+lengthConst},{x:215,y:40.3+lengthConst},{x:216,y:40.5+lengthConst},{x:217,y:40.7+lengthConst},{x:218,y:40.9+lengthConst},{x:219,y:41+lengthConst},{x:220,y:41.2+lengthConst},{x:221,y:41.4+lengthConst},{x:222,y:41.6+lengthConst},{x:223,y:41.8+lengthConst},{x:224,y:41.9+lengthConst},{x:225,y:42.1+lengthConst},{x:226,y:42.3+lengthConst},{x:227,y:42.5+lengthConst},{x:228,y:42.7+lengthConst},{x:229,y:42.9+lengthConst},{x:230,y:43+lengthConst}];
  
              var set9 = [{x:168,y:35.1+lengthConst},{x:169,y:35.3+lengthConst},{x:170,y:35.5+lengthConst},{x:171,y:35.7+lengthConst},{x:172,y:35.8+lengthConst},{x:173,y:36+lengthConst},{x:174,y:36.2+lengthConst},{x:175,y:36.4+lengthConst},{x:176,y:36.6+lengthConst},{x:177,y:36.8+lengthConst},{x:178,y:36.9+lengthConst},{x:179,y:37.1+lengthConst},{x:180,y:37.3+lengthConst},{x:181,y:37.5+lengthConst},{x:182,y:37.7+lengthConst},{x:183,y:37.8+lengthConst},{x:184,y:38+lengthConst},{x:185,y:38.2+lengthConst},{x:186,y:38.4+lengthConst},{x:187,y:38.6+lengthConst},{x:188,y:38.7+lengthConst},{x:189,y:38.9+lengthConst},{x:190,y:39.1+lengthConst},{x:191,y:39.3+lengthConst},{x:192,y:39.5+lengthConst},{x:193,y:39.7+lengthConst},{x:194,y:39.8+lengthConst},{x:195,y:40+lengthConst},{x:196,y:40.2+lengthConst},{x:197,y:40.4+lengthConst},{x:198,y:40.6+lengthConst},{x:199,y:40.7+lengthConst},{x:200,y:40.9+lengthConst},{x:201,y:41.1+lengthConst},{x:202,y:41.3+lengthConst},{x:203,y:41.5+lengthConst},{x:204,y:41.7+lengthConst},{x:205,y:41.8+lengthConst},{x:206,y:42+lengthConst},{x:207,y:42.2+lengthConst},{x:208,y:42.4+lengthConst},{x:209,y:42.6+lengthConst},{x:210,y:42.7+lengthConst},{x:211,y:42.9+lengthConst},{x:212,y:43.1+lengthConst},{x:213,y:43.3+lengthConst},{x:214,y:43.5+lengthConst},{x:215,y:43.6+lengthConst},{x:216,y:43.8+lengthConst},{x:217,y:44+lengthConst},{x:218,y:44.2+lengthConst},{x:219,y:44.4+lengthConst},{x:220,y:44.6+lengthConst},{x:221,y:44.7+lengthConst},{x:222,y:44.9+lengthConst},{x:223,y:45.1+lengthConst},{x:224,y:45.3+lengthConst},{x:225,y:45.5+lengthConst},{x:226,y:45.6+lengthConst},{x:227,y:45.8+lengthConst},{x:228,y:46+lengthConst},{x:229,y:46.2+lengthConst},{x:230,y:46.4+lengthConst}];
  
              var set10 = [{x:168,y:36.7+lengthConst},{x:169,y:36.9+lengthConst},{x:170,y:37+lengthConst},{x:171,y:37.2+lengthConst},{x:172,y:37.4+lengthConst},{x:173,y:37.6+lengthConst},{x:174,y:37.8+lengthConst},{x:175,y:37.9+lengthConst},{x:176,y:38.1+lengthConst},{x:177,y:38.3+lengthConst},{x:178,y:38.5+lengthConst},{x:179,y:38.7+lengthConst},{x:180,y:38.9+lengthConst},{x:181,y:39+lengthConst},{x:182,y:39.2+lengthConst},{x:183,y:39.4+lengthConst},{x:184,y:39.6+lengthConst},{x:185,y:39.8+lengthConst},{x:186,y:39.9+lengthConst},{x:187,y:40.1+lengthConst},{x:188,y:40.3+lengthConst},{x:189,y:40.5+lengthConst},{x:190,y:40.7+lengthConst},{x:191,y:40.9+lengthConst},{x:192,y:41+lengthConst},{x:193,y:41.2+lengthConst},{x:194,y:41.4+lengthConst},{x:195,y:41.6+lengthConst},{x:196,y:41.8+lengthConst},{x:197,y:41.9+lengthConst},{x:198,y:42.1+lengthConst},{x:199,y:42.3+lengthConst},{x:200,y:42.5+lengthConst},{x:201,y:42.7+lengthConst},{x:202,y:42.8+lengthConst},{x:203,y:43+lengthConst},{x:204,y:43.2+lengthConst},{x:205,y:43.4+lengthConst},{x:206,y:43.6+lengthConst},{x:207,y:43.8+lengthConst},{x:208,y:43.9+lengthConst},{x:209,y:44.1+lengthConst},{x:210,y:44.3+lengthConst},{x:211,y:44.5+lengthConst},{x:212,y:44.7+lengthConst},{x:213,y:44.8+lengthConst},{x:214,y:45+lengthConst},{x:215,y:45.2+lengthConst},{x:216,y:45.4+lengthConst},{x:217,y:45.6+lengthConst},{x:218,y:45.7+lengthConst},{x:219,y:45.9+lengthConst},{x:220,y:46.1+lengthConst},{x:221,y:46.3+lengthConst},{x:222,y:46.5+lengthConst},{x:223,y:46.7+lengthConst},{x:224,y:46.8+lengthConst},{x:225,y:47+lengthConst},{x:226,y:47.2+lengthConst},{x:227,y:47.4+lengthConst},{x:228,y:47.6+lengthConst},{x:229,y:47.7+lengthConst},{x:230,y:47.9+lengthConst}];
              // End of Length data
              
              // Start of Weight data
              var set11 = [{x:168,y:(0.42*10)+weightConst},{x:169,y:(0.43*10)+weightConst},{x:170,y:(0.44*10)+weightConst},{x:171,y:(0.44*10)+weightConst},{x:172,y:(0.45*10)+weightConst},{x:173,y:(0.46*10)+weightConst},{x:174,y:(0.47*10)+weightConst},{x:175,y:(0.48*10)+weightConst},{x:176,y:(0.49*10)+weightConst},{x:177,y:(0.5*10)+weightConst},{x:178,y:(0.51*10)+weightConst},{x:179,y:(0.52*10)+weightConst},{x:180,y:(0.53*10)+weightConst},{x:181,y:(0.54*10)+weightConst},{x:182,y:(0.55*10)+weightConst},{x:183,y:(0.56*10)+weightConst},{x:184,y:(0.57*10)+weightConst},{x:185,y:(0.58*10)+weightConst},{x:186,y:(0.59*10)+weightConst},{x:187,y:(0.6*10)+weightConst},{x:188,y:(0.61*10)+weightConst},{x:189,y:(0.62*10)+weightConst},{x:190,y:(0.63*10)+weightConst},{x:191,y:(0.64*10)+weightConst},{x:192,y:(0.66*10)+weightConst},{x:193,y:(0.67*10)+weightConst},{x:194,y:(0.68*10)+weightConst},{x:195,y:(0.69*10)+weightConst},{x:196,y:(0.7*10)+weightConst},{x:197,y:(0.72*10)+weightConst},{x:198,y:(0.73*10)+weightConst},{x:199,y:(0.74*10)+weightConst},{x:200,y:(0.76*10)+weightConst},{x:201,y:(0.77*10)+weightConst},{x:202,y:(0.78*10)+weightConst},{x:203,y:(0.8*10)+weightConst},{x:204,y:(0.81*10)+weightConst},{x:205,y:(0.83*10)+weightConst},{x:206,y:(0.84*10)+weightConst},{x:207,y:(0.86*10)+weightConst},{x:208,y:(0.87*10)+weightConst},{x:209,y:(0.89*10)+weightConst},{x:210,y:(0.9*10)+weightConst},{x:211,y:(0.92*10)+weightConst},{x:212,y:(0.93*10)+weightConst},{x:213,y:(0.95*10)+weightConst},{x:214,y:(0.97*10)+weightConst},{x:215,y:(0.98*10)+weightConst},{x:216,y:(1*10)+weightConst},{x:217,y:(1.02*10)+weightConst},{x:218,y:(1.03*10)+weightConst},{x:219,y:(1.05*10)+weightConst},{x:220,y:(1.07*10)+weightConst},{x:221,y:(1.09*10)+weightConst},{x:222,y:(1.11*10)+weightConst},{x:223,y:(1.12*10)+weightConst},{x:224,y:(1.14*10)+weightConst},{x:225,y:(1.16*10)+weightConst},{x:226,y:(1.18*10)+weightConst},{x:227,y:(1.2*10)+weightConst},{x:228,y:(1.22*10)+weightConst},{x:229,y:(1.24*10)+weightConst},{x:230,y:(1.26*10)+weightConst}];
  
              var set12 = [{x:168,y:(0.47*10)+weightConst},{x:169,y:(0.48*10)+weightConst},{x:170,y:(0.49*10)+weightConst},{x:171,y:(0.5*10)+weightConst},{x:172,y:(0.51*10)+weightConst},{x:173,y:(0.52*10)+weightConst},{x:174,y:(0.53*10)+weightConst},{x:175,y:(0.54*10)+weightConst},{x:176,y:(0.55*10)+weightConst},{x:177,y:(0.56*10)+weightConst},{x:178,y:(0.57*10)+weightConst},{x:179,y:(0.58*10)+weightConst},{x:180,y:(0.59*10)+weightConst},{x:181,y:(0.6*10)+weightConst},{x:182,y:(0.61*10)+weightConst},{x:183,y:(0.62*10)+weightConst},{x:184,y:(0.64*10)+weightConst},{x:185,y:(0.65*10)+weightConst},{x:186,y:(0.66*10)+weightConst},{x:187,y:(0.67*10)+weightConst},{x:188,y:(0.68*10)+weightConst},{x:189,y:(0.7*10)+weightConst},{x:190,y:(0.71*10)+weightConst},{x:191,y:(0.72*10)+weightConst},{x:192,y:(0.74*10)+weightConst},{x:193,y:(0.75*10)+weightConst},{x:194,y:(0.76*10)+weightConst},{x:195,y:(0.78*10)+weightConst},{x:196,y:(0.79*10)+weightConst},{x:197,y:(0.81*10)+weightConst},{x:198,y:(0.82*10)+weightConst},{x:199,y:(0.83*10)+weightConst},{x:200,y:(0.85*10)+weightConst},{x:201,y:(0.86*10)+weightConst},{x:202,y:(0.88*10)+weightConst},{x:203,y:(0.9*10)+weightConst},{x:204,y:(0.91*10)+weightConst},{x:205,y:(0.93*10)+weightConst},{x:206,y:(0.94*10)+weightConst},{x:207,y:(0.96*10)+weightConst},{x:208,y:(0.98*10)+weightConst},{x:209,y:(0.99*10)+weightConst},{x:210,y:(1.01*10)+weightConst},{x:211,y:(1.03*10)+weightConst},{x:212,y:(1.05*10)+weightConst},{x:213,y:(1.07*10)+weightConst},{x:214,y:(1.08*10)+weightConst},{x:215,y:(1.1*10)+weightConst},{x:216,y:(1.12*10)+weightConst},{x:217,y:(1.14*10)+weightConst},{x:218,y:(1.16*10)+weightConst},{x:219,y:(1.18*10)+weightConst},{x:220,y:(1.2*10)+weightConst},{x:221,y:(1.22*10)+weightConst},{x:222,y:(1.24*10)+weightConst},{x:223,y:(1.26*10)+weightConst},{x:224,y:(1.28*10)+weightConst},{x:225,y:(1.31*10)+weightConst},{x:226,y:(1.33*10)+weightConst},{x:227,y:(1.35*10)+weightConst},{x:228,y:(1.37*10)+weightConst},{x:229,y:(1.4*10)+weightConst},{x:230,y:(1.42*10)+weightConst}];
                      
              var set13 = [{x:168,y:(0.6*10)+weightConst},{x:169,y:(0.61*10)+weightConst},{x:170,y:(0.63*10)+weightConst},{x:171,y:(0.64*10)+weightConst},{x:172,y:(0.65*10)+weightConst},{x:173,y:(0.66*10)+weightConst},{x:174,y:(0.68*10)+weightConst},{x:175,y:(0.69*10)+weightConst},{x:176,y:(0.7*10)+weightConst},{x:177,y:(0.71*10)+weightConst},{x:178,y:(0.73*10)+weightConst},{x:179,y:(0.74*10)+weightConst},{x:180,y:(0.76*10)+weightConst},{x:181,y:(0.77*10)+weightConst},{x:182,y:(0.78*10)+weightConst},{x:183,y:(0.8*10)+weightConst},{x:184,y:(0.81*10)+weightConst},{x:185,y:(0.83*10)+weightConst},{x:186,y:(0.85*10)+weightConst},{x:187,y:(0.86*10)+weightConst},{x:188,y:(0.88*10)+weightConst},{x:189,y:(0.89*10)+weightConst},{x:190,y:(0.91*10)+weightConst},{x:191,y:(0.93*10)+weightConst},{x:192,y:(0.94*10)+weightConst},{x:193,y:(0.96*10)+weightConst},{x:194,y:(0.98*10)+weightConst},{x:195,y:(1*10)+weightConst},{x:196,y:(1.01*10)+weightConst},{x:197,y:(1.03*10)+weightConst},{x:198,y:(1.05*10)+weightConst},{x:199,y:(1.07*10)+weightConst},{x:200,y:(1.09*10)+weightConst},{x:201,y:(1.11*10)+weightConst},{x:202,y:(1.13*10)+weightConst},{x:203,y:(1.15*10)+weightConst},{x:204,y:(1.17*10)+weightConst},{x:205,y:(1.19*10)+weightConst},{x:206,y:(1.21*10)+weightConst},{x:207,y:(1.23*10)+weightConst},{x:208,y:(1.25*10)+weightConst},{x:209,y:(1.27*10)+weightConst},{x:210,y:(1.3*10)+weightConst},{x:211,y:(1.32*10)+weightConst},{x:212,y:(1.34*10)+weightConst},{x:213,y:(1.36*10)+weightConst},{x:214,y:(1.39*10)+weightConst},{x:215,y:(1.41*10)+weightConst},{x:216,y:(1.44*10)+weightConst},{x:217,y:(1.46*10)+weightConst},{x:218,y:(1.49*10)+weightConst},{x:219,y:(1.51*10)+weightConst},{x:220,y:(1.54*10)+weightConst},{x:221,y:(1.56*10)+weightConst},{x:222,y:(1.59*10)+weightConst},{x:223,y:(1.62*10)+weightConst},{x:224,y:(1.64*10)+weightConst},{x:225,y:(1.67*10)+weightConst},{x:226,y:(1.7*10)+weightConst},{x:227,y:(1.73*10)+weightConst},{x:228,y:(1.76*10)+weightConst},{x:229,y:(1.79*10)+weightConst},{x:230,y:(1.82*10)+weightConst}];
  
              var set14 = [{x:168,y:(0.77*10)+weightConst},{x:169,y:(0.79*10)+weightConst},{x:170,y:(0.8*10)+weightConst},{x:171,y:(0.82*10)+weightConst},{x:172,y:(0.83*10)+weightConst},{x:173,y:(0.85*10)+weightConst},{x:174,y:(0.87*10)+weightConst},{x:175,y:(0.88*10)+weightConst},{x:176,y:(0.9*10)+weightConst},{x:177,y:(0.92*10)+weightConst},{x:178,y:(0.93*10)+weightConst},{x:179,y:(0.95*10)+weightConst},{x:180,y:(0.97*10)+weightConst},{x:181,y:(0.99*10)+weightConst},{x:182,y:(1.01*10)+weightConst},{x:183,y:(1.02*10)+weightConst},{x:184,y:(1.04*10)+weightConst},{x:185,y:(1.06*10)+weightConst},{x:186,y:(1.08*10)+weightConst},{x:187,y:(1.1*10)+weightConst},{x:188,y:(1.12*10)+weightConst},{x:189,y:(1.14*10)+weightConst},{x:190,y:(1.16*10)+weightConst},{x:191,y:(1.19*10)+weightConst},{x:192,y:(1.21*10)+weightConst},{x:193,y:(1.23*10)+weightConst},{x:194,y:(1.25*10)+weightConst},{x:195,y:(1.27*10)+weightConst},{x:196,y:(1.3*10)+weightConst},{x:197,y:(1.32*10)+weightConst},{x:198,y:(1.34*10)+weightConst},{x:199,y:(1.37*10)+weightConst},{x:200,y:(1.39*10)+weightConst},{x:201,y:(1.42*10)+weightConst},{x:202,y:(1.44*10)+weightConst},{x:203,y:(1.47*10)+weightConst},{x:204,y:(1.5*10)+weightConst},{x:205,y:(1.52*10)+weightConst},{x:206,y:(1.55*10)+weightConst},{x:207,y:(1.58*10)+weightConst},{x:208,y:(1.6*10)+weightConst},{x:209,y:(1.63*10)+weightConst},{x:210,y:(1.66*10)+weightConst},{x:211,y:(1.69*10)+weightConst},{x:212,y:(1.72*10)+weightConst},{x:213,y:(1.75*10)+weightConst},{x:214,y:(1.78*10)+weightConst},{x:215,y:(1.81*10)+weightConst},{x:216,y:(1.84*10)+weightConst},{x:217,y:(1.87*10)+weightConst},{x:218,y:(1.9*10)+weightConst},{x:219,y:(1.94*10)+weightConst},{x:220,y:(1.97*10)+weightConst},{x:221,y:(2*10)+weightConst},{x:222,y:(2.04*10)+weightConst},{x:223,y:(2.07*10)+weightConst},{x:224,y:(2.11*10)+weightConst},{x:225,y:(2.14*10)+weightConst},{x:226,y:(2.18*10)+weightConst},{x:227,y:(2.21*10)+weightConst},{x:228,y:(2.25*10)+weightConst},{x:229,y:(2.29*10)+weightConst},{x:230,y:(2.33*10)+weightConst}];
  
              var set15 = [{x:168,y:(0.87*10)+weightConst},{x:169,y:(0.88*10)+weightConst},{x:170,y:(0.9*10)+weightConst},{x:171,y:(0.92*10)+weightConst},{x:172,y:(0.94*10)+weightConst},{x:173,y:(0.95*10)+weightConst},{x:174,y:(0.97*10)+weightConst},{x:175,y:(0.99*10)+weightConst},{x:176,y:(1.01*10)+weightConst},{x:177,y:(1.03*10)+weightConst},{x:178,y:(1.05*10)+weightConst},{x:179,y:(1.07*10)+weightConst},{x:180,y:(1.09*10)+weightConst},{x:181,y:(1.11*10)+weightConst},{x:182,y:(1.13*10)+weightConst},{x:183,y:(1.15*10)+weightConst},{x:184,y:(1.17*10)+weightConst},{x:185,y:(1.19*10)+weightConst},{x:186,y:(1.22*10)+weightConst},{x:187,y:(1.24*10)+weightConst},{x:188,y:(1.26*10)+weightConst},{x:189,y:(1.28*10)+weightConst},{x:190,y:(1.31*10)+weightConst},{x:191,y:(1.33*10)+weightConst},{x:192,y:(1.36*10)+weightConst},{x:193,y:(1.38*10)+weightConst},{x:194,y:(1.41*10)+weightConst},{x:195,y:(1.43*10)+weightConst},{x:196,y:(1.46*10)+weightConst},{x:197,y:(1.48*10)+weightConst},{x:198,y:(1.51*10)+weightConst},{x:199,y:(1.54*10)+weightConst},{x:200,y:(1.56*10)+weightConst},{x:201,y:(1.59*10)+weightConst},{x:202,y:(1.62*10)+weightConst},{x:203,y:(1.65*10)+weightConst},{x:204,y:(1.68*10)+weightConst},{x:205,y:(1.71*10)+weightConst},{x:206,y:(1.74*10)+weightConst},{x:207,y:(1.77*10)+weightConst},{x:208,y:(1.8*10)+weightConst},{x:209,y:(1.83*10)+weightConst},{x:210,y:(1.86*10)+weightConst},{x:211,y:(1.9*10)+weightConst},{x:212,y:(1.93*10)+weightConst},{x:213,y:(1.96*10)+weightConst},{x:214,y:(2*10)+weightConst},{x:215,y:(2.03*10)+weightConst},{x:216,y:(2.07*10)+weightConst},{x:217,y:(2.1*10)+weightConst},{x:218,y:(2.14*10)+weightConst},{x:219,y:(2.17*10)+weightConst},{x:220,y:(2.21*10)+weightConst},{x:221,y:(2.25*10)+weightConst},{x:222,y:(2.29*10)+weightConst},{x:223,y:(2.33*10)+weightConst},{x:224,y:(2.37*10)+weightConst},{x:225,y:(2.4*10)+weightConst},{x:226,y:(2.45*10)+weightConst},{x:227,y:(2.49*10)+weightConst},{x:228,y:(2.53*10)+weightConst},{x:229,y:(2.57*10)+weightConst},{x:230,y:(2.61*10)+weightConst}];
              // End of Weight data
              
              var rawSvg = element.find("svg")[0];
              var svg = d3.select(rawSvg)
                          .attr("width",width + margin.left + margin.right)
                          .attr("height",height + margin.top + margin.bottom);
              var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
              var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
              var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
              var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');
              var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
              var gEnter = wrap3.enter().append('g').attr('class', 'd3line').append('g');
  
              var div = d3.select("body").append("div")	
                          .attr("class", "tooltip")				
                          .style("opacity", 0);
  
              var lineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("bundle")
                              .tension(.8);
  
              var datalineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("linear");
  
  
              var g = svg.append("g")
                          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
              
              var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
              var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);
  
              var yScale0 = d3.scale.linear().domain([0,73]).range([height, 0]);
              var yScale1 = d3.scale.linear().domain([0,73]).range([height, 0]);
  
              var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                  return '';
              }).innerTickSize(-height)
                              .outerTickSize(0);
              var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                  return '';
              });
              var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                  return d%2==0 ? yAxisLeftFake(d):'';
              }).innerTickSize(-width)
                      .outerTickSize(0);
              var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                  return d%2==0 ? yAxisRightFake(d):'';
              }).innerTickSize(50)
                      .outerTickSize(50).tickPadding(10);
              
              var yAxisLeftFake = function(d){
                  switch (d){
                  case 0:return 18;
                  case 2:return 19;
                  case 4:return 20;
                  case 6:return 21;
                  case 8:return 22;
                  case 10:return 23;
                  case 12:return 24;
                  case 14:return 25;
                  case 16:return 26;
                  case 18:return 27;
                  case 20:return '';
                  case 22:return 24;
                  case 24:return 26;
                  case 26:return 28;
                  case 28:return 30;
                  case 30:return 32;
                  case 32:return 34;
                  case 34:return 36;
                  case 36:return 38;
                  case 38:return 40;
                  case 40:return 42;
                  case 42:return '';
                  case 44:return 0.2;
                  case 46:return 0.4;
                  case 48:return 0.6;
                  case 50:return 0.8;
                  case 52:return '1.0';
                  case 54:return 1.2;
                  case 56:return 1.4;
                  case 58:return 1.6;
                  case 60:return 1.8;
                  case 62:return '2.0';
                  case 64:return 2.2;
                  case 66:return 2.4;
                  case 68:return 2.6;
                  case 70:return 2.8;
                  case 72:return '3.0';
                  }
              };
  
              var yAxisRightFake = function(d){
                  switch (d){
                  case 0:return 18;
                  case 2:return 19;
                  case 4:return 20;
                  case 6:return 21;
                  case 8:return 22;
                  case 10:return 23;
                  case 12:return 24;
                  case 14:return 25;
                  case 16:return 26;
                  case 18:return 27;
                  case 20:return 28;
                  case 22:return 29;
                  case 24:return 30;
                  case 26:return 31;
                  case 28:return 32;
                  case 30:return 33;
                  case 32:return 34;
                  case 34:return '';
                  case 36:return 38;
                  case 38:return 40;
                  case 40:return 42;
                  case 42:return 44;
                  case 44:return 46;
                  case 46:return 48;
                  case 48:return 50;
                  case 50:return '';
                  case 52:return '1.0';
                  case 54:return 1.2;
                  case 56:return 1.4;
                  case 58:return 1.6;
                  case 60:return 1.8;
                  case 62:return '2.0';
                  case 64:return 2.2;
                  case 66:return 2.4;
                  case 68:return 2.6;
                  case 70:return 2.8;
                  case 72:return '3.0';
                  }
              };
  
              var age = function(data) {
                  if(data <= 24){
                      return data.toString().split('.')[0]+ " months";
                  }
                  if(data <=60) {
                      var mon = data/12;
                      var result = mon.toFixed(1).split('.');
                      var mod = data%12;
                      var res = mod.toString().split('.');
                      return result[0].toString()+ " years " + res[0] + " months";
                  }
              };
              
              // plot user data points
              var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" kg")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
  
              // x-axis
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxisBottom);
              
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0,0)")
                  .call(xAxisTop);
  
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height+37 )
                  .style("text-anchor", "middle")
                  .text("Gestational age at birth (weeks)");
              
              // svg.append("text")
              //     .attr("x", width/2 )
              //     .attr("y", -30 )
              //     .style("text-anchor", "middle")
              //     .text("Head Circumference-for-age BOYS");
  
              // svg.append("text")
              //     .attr("x", width/2 )
              //     .attr("y", -12 )
              //     .style("text-anchor", "middle")
              //     .text("Birth to 5 years (percentiles)");
              
              svg.append("text")
                  .attr("x", -10 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("24");
              
              svg.append("text")
                  .attr("x", 79 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("25");
              
              svg.append("text")
                  .attr("x", 159 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("26");
              
              svg.append("text")
                  .attr("x", 244 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("27");
              
              svg.append("text")
                  .attr("x", 330 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("28");
              
              svg.append("text")
                  .attr("x", 415 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("29");
              
              svg.append("text")
                  .attr("x", 500 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("30");
              
              svg.append("text")
                  .attr("x", 585 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("31");
              
              svg.append("text")
                  .attr("x", 670 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("32");
                     
              svg.append("text")
                  .attr("x", 753 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("33");
  
              svg.append("text")
                  .attr("x", -10 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("24");
              
              svg.append("text")
                  .attr("x", 79 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("25");
              
              svg.append("text")
                  .attr("x", 159 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("26");
              
              svg.append("text")
                  .attr("x", 244 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("27");
              
              svg.append("text")
                  .attr("x", 330 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("28");
              
              svg.append("text")
                  .attr("x", 415 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("29");
              
              svg.append("text")
                  .attr("x", 500 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("30");
              
              svg.append("text")
                  .attr("x", 585 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("31");
              
              svg.append("text")
                  .attr("x", 670 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("32");
                     
              svg.append("text")
                  .attr("x", 753 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("33");
              
  
              svg.append("text")
                  .attr("x", -340 )
                  .attr("y", -35 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Head (cm)");
              
              svg.append("text")
                  .attr("x", -220 )
                  .attr("y", -35 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Length (cm)");
  
              svg.append("text")
                  .attr("x", -80 )
                  .attr("y", -35 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Birthweight (kg)");
  
              svg.append("text")
                  .attr("x", -300 )
                  .attr("y", 855 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Head Circumference (cm)");
              
              svg.append("text")
                  .attr("x", -160 )
                  .attr("y", 855 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Length (cm)");
  
              svg.append("text")
                  .attr("x", -50 )
                  .attr("y", 855 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Birthweight (kg)");
              
              // svg.append("text")
              //     .attr("x", -50 )
              //     .attr("y", height+15 )
              //     .style("text-anchor", "start")
              //     .text("Months");
              
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 95 )
                  .style("text-anchor", "start")
                  .text("3 rd");
              
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 85 )
                  .style("text-anchor", "start")
                  .text("10 th");
  
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 65 )
                  .style("text-anchor", "start")
                  .text("50 th");
              
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 35 )
                  .style("text-anchor", "start")
                  .text("90 th");
  
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 20 )
                  .style("text-anchor", "start")
                  .text("97 th");
  
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 195 )
                  .style("text-anchor", "start")
                  .text("3 rd");
              
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 185 )
                  .style("text-anchor", "start")
                  .text("10 th");
  
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 165 )
                  .style("text-anchor", "start")
                  .text("50 th");
              
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 150 )
                  .style("text-anchor", "start")
                  .text("90 th");
  
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 140 )
                  .style("text-anchor", "start")
                  .text("97 th");
  
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 340 )
                  .style("text-anchor", "start")
                  .text("3 rd");
              
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 330 )
                  .style("text-anchor", "start")
                  .text("10 th");
  
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 320 )
                  .style("text-anchor", "start")
                  .text("50 th");
              
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 310 )
                  .style("text-anchor", "start")
                  .text("90 th");
  
              svg.append("text")
                  .attr("x", 770 )
                  .attr("y", 300 )
                  .style("text-anchor", "start")
                  .text("97 th");
                  
              // y-axis
              svg.append("g")
                  .attr("class", "y axis")
                  .call(yAxisLeft);	
  
              svg.append("g")				
                  .attr("class", "y axis")	
                  .attr("transform", "translate(" + width + " ,0)")		
                  .call(yAxisRight);
              
              // path lines
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set1),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set2),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set3),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set4),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set5),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set6),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set7),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set8),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set9),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set10),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set11),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set12),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set13),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set14),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set15),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
              
              // user data
              svg.append("svg:path")
                .attr({
                d: datalineFunc(hcData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(heightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(weightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });
  
          }
      }
  });
  
'use strict';
angular.module('AngularApp').directive('hlwPretermChartMaleDirective', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;


            var headConst = -17;
            var lengthConst = -2;
            var weightConst = 42;

            var hcData = [];
            if(vitalData.pretermHc) {
                for(var i = 0; i < vitalData.pretermHc.length; i++){
                    hcData.push({x:vitalData.pretermHc[i].x,y:vitalData.pretermHc[i].y + headConst});
                }
            }

            var heightData = [];
            if(vitalData.pretermHeight) {
                for(var i = 0; i < vitalData.pretermHeight.length; i++){
                    heightData.push({x:vitalData.pretermHeight[i].x,y:vitalData.pretermHeight[i].y + lengthConst});
                }
            }
            
            var weightData = [];
            if(vitalData.pretermWeight) {
                for(var i = 0; i < vitalData.pretermWeight.length; i++){
                    weightData.push({x:vitalData.pretermWeight[i].x,y:(vitalData.pretermWeight[i].y *10) + weightConst});
                }
            }

            // Start of Head data
            var set1 = [{x:168,y:19.4+headConst},{x:169,y:19.5+headConst},{x:170,y:19.7+headConst},{x:171,y:19.8+headConst},{x:172,y:19.9+headConst},{x:173,y:20+headConst},{x:174,y:20.2+headConst},{x:175,y:20.3+headConst},{x:176,y:20.4+headConst},{x:177,y:20.5+headConst},{x:178,y:20.7+headConst},{x:179,y:20.8+headConst},{x:180,y:20.9+headConst},{x:181,y:21.1+headConst},{x:182,y:21.2+headConst},{x:183,y:21.3+headConst},{x:184,y:21.4+headConst},{x:185,y:21.6+headConst},{x:186,y:21.7+headConst},{x:187,y:21.8+headConst},{x:188,y:21.9+headConst},{x:189,y:22.1+headConst},{x:190,y:22.2+headConst},{x:191,y:22.3+headConst},{x:192,y:22.5+headConst},{x:193,y:22.6+headConst},{x:194,y:22.7+headConst},{x:195,y:22.8+headConst},{x:196,y:23+headConst},{x:197,y:23.1+headConst},{x:198,y:23.2+headConst},{x:199,y:23.3+headConst},{x:200,y:23.5+headConst},{x:201,y:23.6+headConst},{x:202,y:23.7+headConst},{x:203,y:23.8+headConst},{x:204,y:24+headConst},{x:205,y:24.1+headConst},{x:206,y:24.2+headConst},{x:207,y:24.4+headConst},{x:208,y:24.5+headConst},{x:209,y:24.6+headConst},{x:210,y:24.7+headConst},{x:211,y:24.9+headConst},{x:212,y:25+headConst},{x:213,y:25.1+headConst},{x:214,y:25.2+headConst},{x:215,y:25.4+headConst},{x:216,y:25.5+headConst},{x:217,y:25.6+headConst},{x:218,y:25.7+headConst},{x:219,y:25.9+headConst},{x:220,y:26+headConst},{x:221,y:26.1+headConst},{x:222,y:26.3+headConst},{x:223,y:26.4+headConst},{x:224,y:26.5+headConst},{x:225,y:26.6+headConst},{x:226,y:26.8+headConst},{x:227,y:26.9+headConst},{x:228,y:27+headConst},{x:229,y:27.1+headConst},{x:230,y:27.3+headConst}];

            var set2 = [{x:168,y:20.3+headConst},{x:169,y:20.5+headConst},{x:170,y:20.6+headConst},{x:171,y:20.7+headConst},{x:172,y:20.8+headConst},{x:173,y:21+headConst},{x:174,y:21.1+headConst},{x:175,y:21.2+headConst},{x:176,y:21.4+headConst},{x:177,y:21.5+headConst},{x:178,y:21.6+headConst},{x:179,y:21.7+headConst},{x:180,y:21.9+headConst},{x:181,y:22+headConst},{x:182,y:22.1+headConst},{x:183,y:22.2+headConst},{x:184,y:22.4+headConst},{x:185,y:22.5+headConst},{x:186,y:22.6+headConst},{x:187,y:22.8+headConst},{x:188,y:22.9+headConst},{x:189,y:23+headConst},{x:190,y:23.1+headConst},{x:191,y:23.3+headConst},{x:192,y:23.4+headConst},{x:193,y:23.5+headConst},{x:194,y:23.6+headConst},{x:195,y:23.8+headConst},{x:196,y:23.9+headConst},{x:197,y:24+headConst},{x:198,y:24.1+headConst},{x:199,y:24.3+headConst},{x:200,y:24.4+headConst},{x:201,y:24.5+headConst},{x:202,y:24.7+headConst},{x:203,y:24.8+headConst},{x:204,y:24.9+headConst},{x:205,y:25+headConst},{x:206,y:25.2+headConst},{x:207,y:25.3+headConst},{x:208,y:25.4+headConst},{x:209,y:25.5+headConst},{x:210,y:25.7+headConst},{x:211,y:25.8+headConst},{x:212,y:25.9+headConst},{x:213,y:26+headConst},{x:214,y:26.2+headConst},{x:215,y:26.3+headConst},{x:216,y:26.4+headConst},{x:217,y:26.6+headConst},{x:218,y:26.7+headConst},{x:219,y:26.8+headConst},{x:220,y:26.9+headConst},{x:221,y:27.1+headConst},{x:222,y:27.2+headConst},{x:223,y:27.3+headConst},{x:224,y:27.4+headConst},{x:225,y:27.6+headConst},{x:226,y:27.7+headConst},{x:227,y:27.8+headConst},{x:228,y:28+headConst},{x:229,y:28.1+headConst},{x:230,y:28.2+headConst}];
                    
            var set3 = [{x:168,y:22.3+headConst},{x:169,y:22.5+headConst},{x:170,y:22.6+headConst},{x:171,y:22.7+headConst},{x:172,y:22.8+headConst},{x:173,y:23+headConst},{x:174,y:23.1+headConst},{x:175,y:23.2+headConst},{x:176,y:23.4+headConst},{x:177,y:23.5+headConst},{x:178,y:23.6+headConst},{x:179,y:23.7+headConst},{x:180,y:23.9+headConst},{x:181,y:24+headConst},{x:182,y:24.1+headConst},{x:183,y:24.2+headConst},{x:184,y:24.4+headConst},{x:185,y:24.5+headConst},{x:186,y:24.6+headConst},{x:187,y:24.8+headConst},{x:188,y:24.9+headConst},{x:189,y:25+headConst},{x:190,y:25.1+headConst},{x:191,y:25.3+headConst},{x:192,y:25.4+headConst},{x:193,y:25.5+headConst},{x:194,y:25.6+headConst},{x:195,y:25.8+headConst},{x:196,y:25.9+headConst},{x:197,y:26+headConst},{x:198,y:26.1+headConst},{x:199,y:26.3+headConst},{x:200,y:26.4+headConst},{x:201,y:26.5+headConst},{x:202,y:26.7+headConst},{x:203,y:26.8+headConst},{x:204,y:26.9+headConst},{x:205,y:27+headConst},{x:206,y:27.2+headConst},{x:207,y:27.3+headConst},{x:208,y:27.4+headConst},{x:209,y:27.5+headConst},{x:210,y:27.7+headConst},{x:211,y:27.8+headConst},{x:212,y:27.9+headConst},{x:213,y:28+headConst},{x:214,y:28.2+headConst},{x:215,y:28.3+headConst},{x:216,y:28.4+headConst},{x:217,y:28.6+headConst},{x:218,y:28.7+headConst},{x:219,y:28.8+headConst},{x:220,y:28.9+headConst},{x:221,y:29.1+headConst},{x:222,y:29.2+headConst},{x:223,y:29.3+headConst},{x:224,y:29.4+headConst},{x:225,y:29.6+headConst},{x:226,y:29.7+headConst},{x:227,y:29.8+headConst},{x:228,y:29.9+headConst},{x:229,y:30.1+headConst},{x:230,y:30.2+headConst}];

            var set4 = [{x:168,y:24.3+headConst},{x:169,y:24.5+headConst},{x:170,y:24.6+headConst},{x:171,y:24.7+headConst},{x:172,y:24.8+headConst},{x:173,y:25+headConst},{x:174,y:25.1+headConst},{x:175,y:25.2+headConst},{x:176,y:25.4+headConst},{x:177,y:25.5+headConst},{x:178,y:25.6+headConst},{x:179,y:25.7+headConst},{x:180,y:25.9+headConst},{x:181,y:26+headConst},{x:182,y:26.1+headConst},{x:183,y:26.2+headConst},{x:184,y:26.4+headConst},{x:185,y:26.5+headConst},{x:186,y:26.6+headConst},{x:187,y:26.7+headConst},{x:188,y:26.9+headConst},{x:189,y:27+headConst},{x:190,y:27.1+headConst},{x:191,y:27.3+headConst},{x:192,y:27.4+headConst},{x:193,y:27.5+headConst},{x:194,y:27.6+headConst},{x:195,y:27.8+headConst},{x:196,y:27.9+headConst},{x:197,y:28+headConst},{x:198,y:28.1+headConst},{x:199,y:28.3+headConst},{x:200,y:28.4+headConst},{x:201,y:28.5+headConst},{x:202,y:28.7+headConst},{x:203,y:28.8+headConst},{x:204,y:28.9+headConst},{x:205,y:29+headConst},{x:206,y:29.2+headConst},{x:207,y:29.3+headConst},{x:208,y:29.4+headConst},{x:209,y:29.5+headConst},{x:210,y:29.7+headConst},{x:211,y:29.8+headConst},{x:212,y:29.9+headConst},{x:213,y:30+headConst},{x:214,y:30.2+headConst},{x:215,y:30.3+headConst},{x:216,y:30.4+headConst},{x:217,y:30.6+headConst},{x:218,y:30.7+headConst},{x:219,y:30.8+headConst},{x:220,y:30.9+headConst},{x:221,y:31.1+headConst},{x:222,y:31.2+headConst},{x:223,y:31.3+headConst},{x:224,y:31.4+headConst},{x:225,y:31.6+headConst},{x:226,y:31.7+headConst},{x:227,y:31.8+headConst},{x:228,y:31.9+headConst},{x:229,y:32.1+headConst},{x:230,y:32.2+headConst}];

            var set5 = [{x:168,y:25.3+headConst},{x:169,y:25.4+headConst},{x:170,y:25.5+headConst},{x:171,y:25.7+headConst},{x:172,y:25.8+headConst},{x:173,y:25.9+headConst},{x:174,y:26+headConst},{x:175,y:26.2+headConst},{x:176,y:26.3+headConst},{x:177,y:26.4+headConst},{x:178,y:26.5+headConst},{x:179,y:26.7+headConst},{x:180,y:26.8+headConst},{x:181,y:26.9+headConst},{x:182,y:27.1+headConst},{x:183,y:27.2+headConst},{x:184,y:27.3+headConst},{x:185,y:27.4+headConst},{x:186,y:27.6+headConst},{x:187,y:27.7+headConst},{x:188,y:27.8+headConst},{x:189,y:27.9+headConst},{x:190,y:28.1+headConst},{x:191,y:28.2+headConst},{x:192,y:28.3+headConst},{x:193,y:28.4+headConst},{x:194,y:28.6+headConst},{x:195,y:28.7+headConst},{x:196,y:28.8+headConst},{x:197,y:29+headConst},{x:198,y:29.1+headConst},{x:199,y:29.2+headConst},{x:200,y:29.3+headConst},{x:201,y:29.5+headConst},{x:202,y:29.6+headConst},{x:203,y:29.7+headConst},{x:204,y:29.8+headConst},{x:205,y:30+headConst},{x:206,y:30.1+headConst},{x:207,y:30.2+headConst},{x:208,y:30.3+headConst},{x:209,y:30.5+headConst},{x:210,y:30.6+headConst},{x:211,y:30.7+headConst},{x:212,y:30.9+headConst},{x:213,y:31+headConst},{x:214,y:31.1+headConst},{x:215,y:31.2+headConst},{x:216,y:31.4+headConst},{x:217,y:31.5+headConst},{x:218,y:31.6+headConst},{x:219,y:31.7+headConst},{x:220,y:31.9+headConst},{x:221,y:32+headConst},{x:222,y:32.1+headConst},{x:223,y:32.2+headConst},{x:224,y:32.4+headConst},{x:225,y:32.5+headConst},{x:226,y:32.6+headConst},{x:227,y:32.8+headConst},{x:228,y:32.9+headConst},{x:229,y:33+headConst},{x:230,y:33.1+headConst}];
            // End of Head data

            // Start of Length data
            var set6 = [{x:168,y:27.3+lengthConst},{x:169,y:27.5+lengthConst},{x:170,y:27.7+lengthConst},{x:171,y:27.9+lengthConst},{x:172,y:28.1+lengthConst},{x:173,y:28.2+lengthConst},{x:174,y:28.4+lengthConst},{x:175,y:28.6+lengthConst},{x:176,y:28.8+lengthConst},{x:177,y:29+lengthConst},{x:178,y:29.1+lengthConst},{x:179,y:29.3+lengthConst},{x:180,y:29.5+lengthConst},{x:181,y:29.7+lengthConst},{x:182,y:29.9+lengthConst},{x:183,y:30+lengthConst},{x:184,y:30.2+lengthConst},{x:185,y:30.4+lengthConst},{x:186,y:30.6+lengthConst},{x:187,y:30.8+lengthConst},{x:188,y:31+lengthConst},{x:189,y:31.1+lengthConst},{x:190,y:31.3+lengthConst},{x:191,y:31.5+lengthConst},{x:192,y:31.7+lengthConst},{x:193,y:31.9+lengthConst},{x:194,y:32+lengthConst},{x:195,y:32.2+lengthConst},{x:196,y:32.4+lengthConst},{x:197,y:32.6+lengthConst},{x:198,y:32.8+lengthConst},{x:199,y:32.9+lengthConst},{x:200,y:33.1+lengthConst},{x:201,y:33.3+lengthConst},{x:202,y:33.5+lengthConst},{x:203,y:33.7+lengthConst},{x:204,y:33.9+lengthConst},{x:205,y:34+lengthConst},{x:206,y:34.2+lengthConst},{x:207,y:34.4+lengthConst},{x:208,y:34.6+lengthConst},{x:209,y:34.8+lengthConst},{x:210,y:34.9+lengthConst},{x:211,y:35.1+lengthConst},{x:212,y:35.3+lengthConst},{x:213,y:35.5+lengthConst},{x:214,y:35.7+lengthConst},{x:215,y:35.9+lengthConst},{x:216,y:36+lengthConst},{x:217,y:36.2+lengthConst},{x:218,y:36.4+lengthConst},{x:219,y:36.6+lengthConst},{x:220,y:36.8+lengthConst},{x:221,y:36.9+lengthConst},{x:222,y:37.1+lengthConst},{x:223,y:37.3+lengthConst},{x:224,y:37.5+lengthConst},{x:225,y:37.7+lengthConst},{x:226,y:37.8+lengthConst},{x:227,y:38+lengthConst},{x:228,y:38.2+lengthConst},{x:229,y:38.4+lengthConst},{x:230,y:38.6+lengthConst}];

            var set7 = [{x:168,y:28.9+lengthConst},{x:169,y:29.1+lengthConst},{x:170,y:29.2+lengthConst},{x:171,y:29.4+lengthConst},{x:172,y:29.6+lengthConst},{x:173,y:29.8+lengthConst},{x:174,y:30+lengthConst},{x:175,y:30.2+lengthConst},{x:176,y:30.3+lengthConst},{x:177,y:30.5+lengthConst},{x:178,y:30.7+lengthConst},{x:179,y:30.9+lengthConst},{x:180,y:31.1+lengthConst},{x:181,y:31.2+lengthConst},{x:182,y:31.4+lengthConst},{x:183,y:31.6+lengthConst},{x:184,y:31.8+lengthConst},{x:185,y:32+lengthConst},{x:186,y:32.1+lengthConst},{x:187,y:32.3+lengthConst},{x:188,y:32.5+lengthConst},{x:189,y:32.7+lengthConst},{x:190,y:32.9+lengthConst},{x:191,y:33.1+lengthConst},{x:192,y:33.2+lengthConst},{x:193,y:33.4+lengthConst},{x:194,y:33.6+lengthConst},{x:195,y:33.8+lengthConst},{x:196,y:34+lengthConst},{x:197,y:34.1+lengthConst},{x:198,y:34.3+lengthConst},{x:199,y:34.5+lengthConst},{x:200,y:34.7+lengthConst},{x:201,y:34.9+lengthConst},{x:202,y:35.1+lengthConst},{x:203,y:35.2+lengthConst},{x:204,y:35.4+lengthConst},{x:205,y:35.6+lengthConst},{x:206,y:35.8+lengthConst},{x:207,y:36+lengthConst},{x:208,y:36.1+lengthConst},{x:209,y:36.3+lengthConst},{x:210,y:36.5+lengthConst},{x:211,y:36.7+lengthConst},{x:212,y:36.9+lengthConst},{x:213,y:37+lengthConst},{x:214,y:37.2+lengthConst},{x:215,y:37.4+lengthConst},{x:216,y:37.6+lengthConst},{x:217,y:37.8+lengthConst},{x:218,y:38+lengthConst},{x:219,y:38.1+lengthConst},{x:220,y:38.3+lengthConst},{x:221,y:38.5+lengthConst},{x:222,y:38.7+lengthConst},{x:223,y:38.9+lengthConst},{x:224,y:39+lengthConst},{x:225,y:39.2+lengthConst},{x:226,y:39.4+lengthConst},{x:227,y:39.6+lengthConst},{x:228,y:39.8+lengthConst},{x:229,y:40+lengthConst},{x:230,y:40.1+lengthConst}];
                    
            var set8 = [{x:168,y:32.2+lengthConst},{x:169,y:32.4+lengthConst},{x:170,y:32.6+lengthConst},{x:171,y:32.8+lengthConst},{x:172,y:32.9+lengthConst},{x:173,y:33.1+lengthConst},{x:174,y:33.3+lengthConst},{x:175,y:33.5+lengthConst},{x:176,y:33.7+lengthConst},{x:177,y:33.8+lengthConst},{x:178,y:34+lengthConst},{x:179,y:34.2+lengthConst},{x:180,y:34.4+lengthConst},{x:181,y:34.6+lengthConst},{x:182,y:34.8+lengthConst},{x:183,y:34.9+lengthConst},{x:184,y:35.1+lengthConst},{x:185,y:35.3+lengthConst},{x:186,y:35.5+lengthConst},{x:187,y:35.7+lengthConst},{x:188,y:35.8+lengthConst},{x:189,y:36+lengthConst},{x:190,y:36.2+lengthConst},{x:191,y:36.4+lengthConst},{x:192,y:36.6+lengthConst},{x:193,y:36.8+lengthConst},{x:194,y:36.9+lengthConst},{x:195,y:37.1+lengthConst},{x:196,y:37.3+lengthConst},{x:197,y:37.5+lengthConst},{x:198,y:37.7+lengthConst},{x:199,y:37.8+lengthConst},{x:200,y:38+lengthConst},{x:201,y:38.2+lengthConst},{x:202,y:38.4+lengthConst},{x:203,y:38.6+lengthConst},{x:204,y:38.7+lengthConst},{x:205,y:38.9+lengthConst},{x:206,y:39.1+lengthConst},{x:207,y:39.3+lengthConst},{x:208,y:39.5+lengthConst},{x:209,y:39.7+lengthConst},{x:210,y:39.8+lengthConst},{x:211,y:40+lengthConst},{x:212,y:40.2+lengthConst},{x:213,y:40.4+lengthConst},{x:214,y:40.6+lengthConst},{x:215,y:40.7+lengthConst},{x:216,y:40.9+lengthConst},{x:217,y:41.1+lengthConst},{x:218,y:41.3+lengthConst},{x:219,y:41.5+lengthConst},{x:220,y:41.6+lengthConst},{x:221,y:41.8+lengthConst},{x:222,y:42+lengthConst},{x:223,y:42.2+lengthConst},{x:224,y:42.4+lengthConst},{x:225,y:42.6+lengthConst},{x:226,y:42.7+lengthConst},{x:227,y:42.9+lengthConst},{x:228,y:43.1+lengthConst},{x:229,y:43.3+lengthConst},{x:230,y:43.5+lengthConst}];

            var set9 = [{x:168,y:35.5+lengthConst},{x:169,y:35.7+lengthConst},{x:170,y:35.9+lengthConst},{x:171,y:36.1+lengthConst},{x:172,y:36.3+lengthConst},{x:173,y:36.5+lengthConst},{x:174,y:36.6+lengthConst},{x:175,y:36.8+lengthConst},{x:176,y:37+lengthConst},{x:177,y:37.2+lengthConst},{x:178,y:37.4+lengthConst},{x:179,y:37.5+lengthConst},{x:180,y:37.7+lengthConst},{x:181,y:37.9+lengthConst},{x:182,y:38.1+lengthConst},{x:183,y:38.3+lengthConst},{x:184,y:38.4+lengthConst},{x:185,y:38.6+lengthConst},{x:186,y:38.8+lengthConst},{x:187,y:39+lengthConst},{x:188,y:39.2+lengthConst},{x:189,y:39.4+lengthConst},{x:190,y:39.5+lengthConst},{x:191,y:39.7+lengthConst},{x:192,y:39.9+lengthConst},{x:193,y:40.1+lengthConst},{x:194,y:40.3+lengthConst},{x:195,y:40.4+lengthConst},{x:196,y:40.6+lengthConst},{x:197,y:40.8+lengthConst},{x:198,y:41+lengthConst},{x:199,y:41.2+lengthConst},{x:200,y:41.4+lengthConst},{x:201,y:41.5+lengthConst},{x:202,y:41.7+lengthConst},{x:203,y:41.9+lengthConst},{x:204,y:42.1+lengthConst},{x:205,y:42.3+lengthConst},{x:206,y:42.4+lengthConst},{x:207,y:42.6+lengthConst},{x:208,y:42.8+lengthConst},{x:209,y:43+lengthConst},{x:210,y:43.2+lengthConst},{x:211,y:43.3+lengthConst},{x:212,y:43.5+lengthConst},{x:213,y:43.7+lengthConst},{x:214,y:43.9+lengthConst},{x:215,y:44.1+lengthConst},{x:216,y:44.3+lengthConst},{x:217,y:44.4+lengthConst},{x:218,y:44.6+lengthConst},{x:219,y:44.8+lengthConst},{x:220,y:45+lengthConst},{x:221,y:45.2+lengthConst},{x:222,y:45.3+lengthConst},{x:223,y:45.5+lengthConst},{x:224,y:45.7+lengthConst},{x:225,y:45.9+lengthConst},{x:226,y:46.1+lengthConst},{x:227,y:46.3+lengthConst},{x:228,y:46.4+lengthConst},{x:229,y:46.6+lengthConst},{x:230,y:46.8+lengthConst}];

            var set10 = [{x:168,y:37.1+lengthConst},{x:169,y:37.3+lengthConst},{x:170,y:37.5+lengthConst},{x:171,y:37.6+lengthConst},{x:172,y:37.8+lengthConst},{x:173,y:38+lengthConst},{x:174,y:38.2+lengthConst},{x:175,y:38.4+lengthConst},{x:176,y:38.6+lengthConst},{x:177,y:38.7+lengthConst},{x:178,y:38.9+lengthConst},{x:179,y:39.1+lengthConst},{x:180,y:39.3+lengthConst},{x:181,y:39.5+lengthConst},{x:182,y:39.6+lengthConst},{x:183,y:39.8+lengthConst},{x:184,y:40+lengthConst},{x:185,y:40.2+lengthConst},{x:186,y:40.4+lengthConst},{x:187,y:40.6+lengthConst},{x:188,y:40.7+lengthConst},{x:189,y:40.9+lengthConst},{x:190,y:41.1+lengthConst},{x:191,y:41.3+lengthConst},{x:192,y:41.5+lengthConst},{x:193,y:41.6+lengthConst},{x:194,y:41.8+lengthConst},{x:195,y:42+lengthConst},{x:196,y:42.2+lengthConst},{x:197,y:42.4+lengthConst},{x:198,y:42.5+lengthConst},{x:199,y:42.7+lengthConst},{x:200,y:42.9+lengthConst},{x:201,y:43.1+lengthConst},{x:202,y:43.3+lengthConst},{x:203,y:43.5+lengthConst},{x:204,y:43.6+lengthConst},{x:205,y:43.8+lengthConst},{x:206,y:44+lengthConst},{x:207,y:44.2+lengthConst},{x:208,y:44.4+lengthConst},{x:209,y:44.5+lengthConst},{x:210,y:44.7+lengthConst},{x:211,y:44.9+lengthConst},{x:212,y:45.1+lengthConst},{x:213,y:45.3+lengthConst},{x:214,y:45.4+lengthConst},{x:215,y:45.6+lengthConst},{x:216,y:45.8+lengthConst},{x:217,y:46+lengthConst},{x:218,y:46.2+lengthConst},{x:219,y:46.4+lengthConst},{x:220,y:46.5+lengthConst},{x:221,y:46.7+lengthConst},{x:222,y:46.9+lengthConst},{x:223,y:47.1+lengthConst},{x:224,y:47.3+lengthConst},{x:225,y:47.4+lengthConst},{x:226,y:47.6+lengthConst},{x:227,y:47.8+lengthConst},{x:228,y:48+lengthConst},{x:229,y:48.2+lengthConst},{x:230,y:48.4+lengthConst}];
            // End of Length data
            
            // Start of Weight data
            var set11 = [{x:168,y:(0.44*10)+weightConst},{x:169,y:(0.45*10)+weightConst},{x:170,y:(0.46*10)+weightConst},{x:171,y:(0.47*10)+weightConst},{x:172,y:(0.48*10)+weightConst},{x:173,y:(0.49*10)+weightConst},{x:174,y:(0.5*10)+weightConst},{x:175,y:(0.51*10)+weightConst},{x:176,y:(0.52*10)+weightConst},{x:177,y:(0.53*10)+weightConst},{x:178,y:(0.54*10)+weightConst},{x:179,y:(0.55*10)+weightConst},{x:180,y:(0.56*10)+weightConst},{x:181,y:(0.57*10)+weightConst},{x:182,y:(0.58*10)+weightConst},{x:183,y:(0.59*10)+weightConst},{x:184,y:(0.6*10)+weightConst},{x:185,y:(0.61*10)+weightConst},{x:186,y:(0.62*10)+weightConst},{x:187,y:(0.63*10)+weightConst},{x:188,y:(0.65*10)+weightConst},{x:189,y:(0.66*10)+weightConst},{x:190,y:(0.67*10)+weightConst},{x:191,y:(0.68*10)+weightConst},{x:192,y:(0.69*10)+weightConst},{x:193,y:(0.71*10)+weightConst},{x:194,y:(0.72*10)+weightConst},{x:195,y:(0.73*10)+weightConst},{x:196,y:(0.75*10)+weightConst},{x:197,y:(0.76*10)+weightConst},{x:198,y:(0.77*10)+weightConst},{x:199,y:(0.79*10)+weightConst},{x:200,y:(0.8*10)+weightConst},{x:201,y:(0.82*10)+weightConst},{x:202,y:(0.83*10)+weightConst},{x:203,y:(0.84*10)+weightConst},{x:204,y:(0.86*10)+weightConst},{x:205,y:(0.87*10)+weightConst},{x:206,y:(0.89*10)+weightConst},{x:207,y:(0.91*10)+weightConst},{x:208,y:(0.92*10)+weightConst},{x:209,y:(0.94*10)+weightConst},{x:210,y:(0.95*10)+weightConst},{x:211,y:(0.97*10)+weightConst},{x:212,y:(0.99*10)+weightConst},{x:213,y:(1*10)+weightConst},{x:214,y:(1.02*10)+weightConst},{x:215,y:(1.04*10)+weightConst},{x:216,y:(1.06*10)+weightConst},{x:217,y:(1.08*10)+weightConst},{x:218,y:(1.09*10)+weightConst},{x:219,y:(1.11*10)+weightConst},{x:220,y:(1.13*10)+weightConst},{x:221,y:(1.15*10)+weightConst},{x:222,y:(1.17*10)+weightConst},{x:223,y:(1.19*10)+weightConst},{x:224,y:(1.21*10)+weightConst},{x:225,y:(1.23*10)+weightConst},{x:226,y:(1.25*10)+weightConst},{x:227,y:(1.27*10)+weightConst},{x:228,y:(1.29*10)+weightConst},{x:229,y:(1.32*10)+weightConst},{x:230,y:(1.34*10)+weightConst}];

            var set12 = [{x:168,y:(0.5*10)+weightConst},{x:169,y:(0.51*10)+weightConst},{x:170,y:(0.52*10)+weightConst},{x:171,y:(0.53*10)+weightConst},{x:172,y:(0.54*10)+weightConst},{x:173,y:(0.55*10)+weightConst},{x:174,y:(0.56*10)+weightConst},{x:175,y:(0.57*10)+weightConst},{x:176,y:(0.58*10)+weightConst},{x:177,y:(0.59*10)+weightConst},{x:178,y:(0.6*10)+weightConst},{x:179,y:(0.61*10)+weightConst},{x:180,y:(0.63*10)+weightConst},{x:181,y:(0.64*10)+weightConst},{x:182,y:(0.65*10)+weightConst},{x:183,y:(0.66*10)+weightConst},{x:184,y:(0.67*10)+weightConst},{x:185,y:(0.69*10)+weightConst},{x:186,y:(0.7*10)+weightConst},{x:187,y:(0.71*10)+weightConst},{x:188,y:(0.72*10)+weightConst},{x:189,y:(0.74*10)+weightConst},{x:190,y:(0.75*10)+weightConst},{x:191,y:(0.77*10)+weightConst},{x:192,y:(0.78*10)+weightConst},{x:193,y:(0.79*10)+weightConst},{x:194,y:(0.81*10)+weightConst},{x:195,y:(0.82*10)+weightConst},{x:196,y:(0.84*10)+weightConst},{x:197,y:(0.85*10)+weightConst},{x:198,y:(0.87*10)+weightConst},{x:199,y:(0.88*10)+weightConst},{x:200,y:(0.9*10)+weightConst},{x:201,y:(0.92*10)+weightConst},{x:202,y:(0.93*10)+weightConst},{x:203,y:(0.95*10)+weightConst},{x:204,y:(0.97*10)+weightConst},{x:205,y:(0.98*10)+weightConst},{x:206,y:(1*10)+weightConst},{x:207,y:(1.02*10)+weightConst},{x:208,y:(1.03*10)+weightConst},{x:209,y:(1.05*10)+weightConst},{x:210,y:(1.07*10)+weightConst},{x:211,y:(1.09*10)+weightConst},{x:212,y:(1.11*10)+weightConst},{x:213,y:(1.13*10)+weightConst},{x:214,y:(1.15*10)+weightConst},{x:215,y:(1.17*10)+weightConst},{x:216,y:(1.19*10)+weightConst},{x:217,y:(1.21*10)+weightConst},{x:218,y:(1.23*10)+weightConst},{x:219,y:(1.25*10)+weightConst},{x:220,y:(1.27*10)+weightConst},{x:221,y:(1.29*10)+weightConst},{x:222,y:(1.31*10)+weightConst},{x:223,y:(1.34*10)+weightConst},{x:224,y:(1.36*10)+weightConst},{x:225,y:(1.38*10)+weightConst},{x:226,y:(1.41*10)+weightConst},{x:227,y:(1.43*10)+weightConst},{x:228,y:(1.45*10)+weightConst},{x:229,y:(1.48*10)+weightConst},{x:230,y:(1.5*10)+weightConst}];
                    
            var set13 = [{x:168,y:(0.64*10)+weightConst},{x:169,y:(0.65*10)+weightConst},{x:170,y:(0.66*10)+weightConst},{x:171,y:(0.68*10)+weightConst},{x:172,y:(0.69*10)+weightConst},{x:173,y:(0.7*10)+weightConst},{x:174,y:(0.72*10)+weightConst},{x:175,y:(0.73*10)+weightConst},{x:176,y:(0.74*10)+weightConst},{x:177,y:(0.76*10)+weightConst},{x:178,y:(0.77*10)+weightConst},{x:179,y:(0.79*10)+weightConst},{x:180,y:(0.8*10)+weightConst},{x:181,y:(0.82*10)+weightConst},{x:182,y:(0.83*10)+weightConst},{x:183,y:(0.85*10)+weightConst},{x:184,y:(0.86*10)+weightConst},{x:185,y:(0.88*10)+weightConst},{x:186,y:(0.89*10)+weightConst},{x:187,y:(0.91*10)+weightConst},{x:188,y:(0.93*10)+weightConst},{x:189,y:(0.95*10)+weightConst},{x:190,y:(0.96*10)+weightConst},{x:191,y:(0.98*10)+weightConst},{x:192,y:(1*10)+weightConst},{x:193,y:(1.02*10)+weightConst},{x:194,y:(1.03*10)+weightConst},{x:195,y:(1.05*10)+weightConst},{x:196,y:(1.07*10)+weightConst},{x:197,y:(1.09*10)+weightConst},{x:198,y:(1.11*10)+weightConst},{x:199,y:(1.13*10)+weightConst},{x:200,y:(1.15*10)+weightConst},{x:201,y:(1.17*10)+weightConst},{x:202,y:(1.19*10)+weightConst},{x:203,y:(1.21*10)+weightConst},{x:204,y:(1.24*10)+weightConst},{x:205,y:(1.26*10)+weightConst},{x:206,y:(1.28*10)+weightConst},{x:207,y:(1.3*10)+weightConst},{x:208,y:(1.33*10)+weightConst},{x:209,y:(1.35*10)+weightConst},{x:210,y:(1.37*10)+weightConst},{x:211,y:(1.4*10)+weightConst},{x:212,y:(1.42*10)+weightConst},{x:213,y:(1.45*10)+weightConst},{x:214,y:(1.47*10)+weightConst},{x:215,y:(1.5*10)+weightConst},{x:216,y:(1.52*10)+weightConst},{x:217,y:(1.55*10)+weightConst},{x:218,y:(1.57*10)+weightConst},{x:219,y:(1.6*10)+weightConst},{x:220,y:(1.63*10)+weightConst},{x:221,y:(1.66*10)+weightConst},{x:222,y:(1.68*10)+weightConst},{x:223,y:(1.71*10)+weightConst},{x:224,y:(1.74*10)+weightConst},{x:225,y:(1.77*10)+weightConst},{x:226,y:(1.8*10)+weightConst},{x:227,y:(1.83*10)+weightConst},{x:228,y:(1.86*10)+weightConst},{x:229,y:(1.89*10)+weightConst},{x:230,y:(1.92*10)+weightConst}];

            var set14 = [{x:168,y:(0.82*10)+weightConst},{x:169,y:(0.83*10)+weightConst},{x:170,y:(0.85*10)+weightConst},{x:171,y:(0.87*10)+weightConst},{x:172,y:(0.88*10)+weightConst},{x:173,y:(0.9*10)+weightConst},{x:174,y:(0.92*10)+weightConst},{x:175,y:(0.93*10)+weightConst},{x:176,y:(0.95*10)+weightConst},{x:177,y:(0.97*10)+weightConst},{x:178,y:(0.99*10)+weightConst},{x:179,y:(1.01*10)+weightConst},{x:180,y:(1.03*10)+weightConst},{x:181,y:(1.04*10)+weightConst},{x:182,y:(1.06*10)+weightConst},{x:183,y:(1.08*10)+weightConst},{x:184,y:(1.1*10)+weightConst},{x:185,y:(1.13*10)+weightConst},{x:186,y:(1.15*10)+weightConst},{x:187,y:(1.17*10)+weightConst},{x:188,y:(1.19*10)+weightConst},{x:189,y:(1.21*10)+weightConst},{x:190,y:(1.23*10)+weightConst},{x:191,y:(1.26*10)+weightConst},{x:192,y:(1.28*10)+weightConst},{x:193,y:(1.3*10)+weightConst},{x:194,y:(1.33*10)+weightConst},{x:195,y:(1.35*10)+weightConst},{x:196,y:(1.37*10)+weightConst},{x:197,y:(1.4*10)+weightConst},{x:198,y:(1.42*10)+weightConst},{x:199,y:(1.45*10)+weightConst},{x:200,y:(1.48*10)+weightConst},{x:201,y:(1.5*10)+weightConst},{x:202,y:(1.53*10)+weightConst},{x:203,y:(1.56*10)+weightConst},{x:204,y:(1.58*10)+weightConst},{x:205,y:(1.61*10)+weightConst},{x:206,y:(1.64*10)+weightConst},{x:207,y:(1.67*10)+weightConst},{x:208,y:(1.7*10)+weightConst},{x:209,y:(1.73*10)+weightConst},{x:210,y:(1.76*10)+weightConst},{x:211,y:(1.79*10)+weightConst},{x:212,y:(1.82*10)+weightConst},{x:213,y:(1.85*10)+weightConst},{x:214,y:(1.88*10)+weightConst},{x:215,y:(1.92*10)+weightConst},{x:216,y:(1.95*10)+weightConst},{x:217,y:(1.98*10)+weightConst},{x:218,y:(2.02*10)+weightConst},{x:219,y:(2.05*10)+weightConst},{x:220,y:(2.09*10)+weightConst},{x:221,y:(2.12*10)+weightConst},{x:222,y:(2.16*10)+weightConst},{x:223,y:(2.19*10)+weightConst},{x:224,y:(2.23*10)+weightConst},{x:225,y:(2.27*10)+weightConst},{x:226,y:(2.31*10)+weightConst},{x:227,y:(2.35*10)+weightConst},{x:228,y:(2.38*10)+weightConst},{x:229,y:(2.42*10)+weightConst},{x:230,y:(2.46*10)+weightConst}];

            var set15 = [{x:168,y:(0.92*10)+weightConst},{x:169,y:(0.93*10)+weightConst},{x:170,y:(0.95*10)+weightConst},{x:171,y:(0.97*10)+weightConst},{x:172,y:(0.99*10)+weightConst},{x:173,y:(1.01*10)+weightConst},{x:174,y:(1.03*10)+weightConst},{x:175,y:(1.05*10)+weightConst},{x:176,y:(1.07*10)+weightConst},{x:177,y:(1.09*10)+weightConst},{x:178,y:(1.11*10)+weightConst},{x:179,y:(1.13*10)+weightConst},{x:180,y:(1.15*10)+weightConst},{x:181,y:(1.17*10)+weightConst},{x:182,y:(1.2*10)+weightConst},{x:183,y:(1.22*10)+weightConst},{x:184,y:(1.24*10)+weightConst},{x:185,y:(1.26*10)+weightConst},{x:186,y:(1.29*10)+weightConst},{x:187,y:(1.31*10)+weightConst},{x:188,y:(1.33*10)+weightConst},{x:189,y:(1.36*10)+weightConst},{x:190,y:(1.38*10)+weightConst},{x:191,y:(1.41*10)+weightConst},{x:192,y:(1.44*10)+weightConst},{x:193,y:(1.46*10)+weightConst},{x:194,y:(1.49*10)+weightConst},{x:195,y:(1.52*10)+weightConst},{x:196,y:(1.54*10)+weightConst},{x:197,y:(1.57*10)+weightConst},{x:198,y:(1.6*10)+weightConst},{x:199,y:(1.63*10)+weightConst},{x:200,y:(1.66*10)+weightConst},{x:201,y:(1.69*10)+weightConst},{x:202,y:(1.72*10)+weightConst},{x:203,y:(1.75*10)+weightConst},{x:204,y:(1.78*10)+weightConst},{x:205,y:(1.81*10)+weightConst},{x:206,y:(1.84*10)+weightConst},{x:207,y:(1.87*10)+weightConst},{x:208,y:(1.91*10)+weightConst},{x:209,y:(1.94*10)+weightConst},{x:210,y:(1.97*10)+weightConst},{x:211,y:(2.01*10)+weightConst},{x:212,y:(2.04*10)+weightConst},{x:213,y:(2.08*10)+weightConst},{x:214,y:(2.11*10)+weightConst},{x:215,y:(2.15*10)+weightConst},{x:216,y:(2.19*10)+weightConst},{x:217,y:(2.23*10)+weightConst},{x:218,y:(2.26*10)+weightConst},{x:219,y:(2.3*10)+weightConst},{x:220,y:(2.34*10)+weightConst},{x:221,y:(2.38*10)+weightConst},{x:222,y:(2.42*10)+weightConst},{x:223,y:(2.46*10)+weightConst},{x:224,y:(2.5*10)+weightConst},{x:225,y:(2.55*10)+weightConst},{x:226,y:(2.59*10)+weightConst},{x:227,y:(2.63*10)+weightConst},{x:228,y:(2.68*10)+weightConst},{x:229,y:(2.72*10)+weightConst},{x:230,y:(2.77*10)+weightConst}];
            // End of Weight data
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');
            var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap3.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,73]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,73]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
				return '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                return d%2==0 ? yAxisLeftFake(d):'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                return d%2==0 ? yAxisRightFake(d):'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var yAxisLeftFake = function(d){
                switch (d){
                case 0:return 18;
                case 2:return 19;
                case 4:return 20;
                case 6:return 21;
                case 8:return 22;
                case 10:return 23;
                case 12:return 24;
                case 14:return 25;
                case 16:return 26;
                case 18:return 27;
                case 20:return '';
                case 22:return 24;
                case 24:return 26;
                case 26:return 28;
                case 28:return 30;
                case 30:return 32;
                case 32:return 34;
                case 34:return 36;
                case 36:return 38;
                case 38:return 40;
                case 40:return 42;
                case 42:return '';
                case 44:return 0.2;
                case 46:return 0.4;
                case 48:return 0.6;
                case 50:return 0.8;
                case 52:return '1.0';
                case 54:return 1.2;
                case 56:return 1.4;
                case 58:return 1.6;
                case 60:return 1.8;
                case 62:return '2.0';
                case 64:return 2.2;
                case 66:return 2.4;
                case 68:return 2.6;
                case 70:return 2.8;
                case 72:return '3.0';
                }
            };

            var yAxisRightFake = function(d){
                switch (d){
                case 0:return 18;
                case 2:return 19;
                case 4:return 20;
                case 6:return 21;
                case 8:return 22;
                case 10:return 23;
                case 12:return 24;
                case 14:return 25;
                case 16:return 26;
                case 18:return 27;
                case 20:return 28;
                case 22:return 29;
                case 24:return 30;
                case 26:return 31;
                case 28:return 32;
                case 30:return 33;
                case 32:return 34;
                case 34:return '';
                case 36:return 38;
                case 38:return 40;
                case 40:return 42;
                case 42:return 44;
                case 44:return 46;
                case 46:return 48;
                case 48:return 50;
                case 50:return '';
                case 52:return '1.0';
                case 54:return 1.2;
                case 56:return 1.4;
                case 58:return 1.6;
                case 60:return 1.8;
                case 62:return '2.0';
                case 64:return 2.2;
                case 66:return 2.4;
                case 68:return 2.6;
                case 70:return 2.8;
                case 72:return '3.0';
                }
            };

            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" kg")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Gestational age at birth (weeks)");
            
            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            
            svg.append("text")
                .attr("x", -10 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("32");
                   
            svg.append("text")
                .attr("x", 753 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -10 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("32");
                   
            svg.append("text")
                .attr("x", 753 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("33");
            

            svg.append("text")
                .attr("x", -340 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head (cm)");
            
            svg.append("text")
                .attr("x", -220 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -80 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Birthweight (kg)");

            svg.append("text")
                .attr("x", -300 )
                .attr("y", 855 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -160 )
                .attr("y", 855 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -50 )
                .attr("y", 855 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Birthweight (kg)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 95 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 85 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 65 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 35 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 20 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 195 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 185 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 165 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 150 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 140 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 340 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 330 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 320 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 310 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 300 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set6),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set8),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set10),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set11),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set13),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set15),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });
            
            // user data
            svg.append("svg:path")
                .attr({
                d: datalineFunc(hcData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(heightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(weightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('wlratioChartFemaleDirective', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var wlRatioData = [];

            if(vitalData.pretermwhRatio) {
                for(var i = 0; i < vitalData.pretermwhRatio.length; i++){
                    console.log(vitalData.pretermwhRatio[i]);
                    if(vitalData.pretermwhRatio[i].y<7.1) {
                        wlRatioData.push(vitalData.pretermwhRatio[i]);
                    }
                }
            }

            var set1 = [{x:168,y:1.04},{x:169,y:1.06},{x:170,y:1.07},{x:171,y:1.09},{x:172,y:1.1},{x:173,y:1.12},{x:174,y:1.14},
                        {x:175,y:1.15},{x:176,y:1.17},{x:177,y:1.19},{x:178,y:1.21},{x:179,y:1.23},{x:180,y:1.25},{x:181,y:1.27},
                        {x:182,y:1.29},{x:183,y:1.31},{x:184,y:1.34},{x:185,y:1.36},{x:186,y:1.39},{x:187,y:1.41},{x:188,y:1.44},
                        {x:189,y:1.46},{x:190,y:1.49},{x:191,y:1.52},{x:192,y:1.55},{x:193,y:1.58},{x:194,y:1.61},{x:195,y:1.64},
                        {x:196,y:1.67},{x:197,y:1.7},{x:198,y:1.73},{x:199,y:1.77},{x:200,y:1.8},{x:201,y:1.84},{x:202,y:1.87},
                        {x:203,y:1.91},{x:204,y:1.95},{x:205,y:1.99},{x:206,y:2.03},{x:207,y:2.07},{x:208,y:2.11},{x:209,y:2.15},
                        {x:210,y:2.19},{x:211,y:2.23},{x:212,y:2.28},{x:213,y:2.32},{x:214,y:2.37},{x:215,y:2.42},{x:216,y:2.46},
                        {x:217,y:2.51},{x:218,y:2.56},{x:219,y:2.61},{x:220,y:2.66},{x:221,y:2.72},{x:222,y:2.77},{x:223,y:2.82},
                        {x:224,y:2.88},{x:225,y:2.93},{x:226,y:2.99},{x:227,y:3.05},{x:228,y:3.11},{x:229,y:3.17},{x:230,y:3.23}];

            var set2 = [{x:168,y:1.4},{x:169,y:1.42},{x:170,y:1.43},{x:171,y:1.45},{x:172,y:1.46},{x:173,y:1.48},{x:174,y:1.49},
                        {x:175,y:1.51},{x:176,y:1.53},{x:177,y:1.55},{x:178,y:1.57},{x:179,y:1.59},{x:180,y:1.61},{x:181,y:1.63},
                        {x:182,y:1.65},{x:183,y:1.67},{x:184,y:1.7},{x:185,y:1.72},{x:186,y:1.74},{x:187,y:1.77},{x:188,y:1.79},
                        {x:189,y:1.82},{x:190,y:1.85},{x:191,y:1.88},{x:192,y:1.91},{x:193,y:1.93},{x:194,y:1.96},{x:195,y:2},
                        {x:196,y:2.03},{x:197,y:2.06},{x:198,y:2.09},{x:199,y:2.13},{x:200,y:2.16},{x:201,y:2.2},{x:202,y:2.23},
                        {x:203,y:2.27},{x:204,y:2.31},{x:205,y:2.35},{x:206,y:2.38},{x:207,y:2.42},{x:208,y:2.47},{x:209,y:2.51},
                        {x:210,y:2.55},{x:211,y:2.59},{x:212,y:2.64},{x:213,y:2.68},{x:214,y:2.73},{x:215,y:2.78},{x:216,y:2.82},
                        {x:217,y:2.87},{x:218,y:2.92},{x:219,y:2.97},{x:220,y:3.02},{x:221,y:3.07},{x:222,y:3.13},{x:223,y:3.18},
                        {x:224,y:3.24},{x:225,y:3.29},{x:226,y:3.35},{x:227,y:3.41},{x:228,y:3.46},{x:229,y:3.52},{x:230,y:3.58}];
                    
            var set3 = [{x:168,y:2.17},{x:169,y:2.18},{x:170,y:2.2},{x:171,y:2.21},{x:172,y:2.23},{x:173,y:2.24},{x:174,y:2.26},
                        {x:175,y:2.28},{x:176,y:2.29},{x:177,y:2.31},{x:178,y:2.33},{x:179,y:2.35},{x:180,y:2.37},{x:181,y:2.39},
                        {x:182,y:2.41},{x:183,y:2.44},{x:184,y:2.46},{x:185,y:2.48},{x:186,y:2.51},{x:187,y:2.53},{x:188,y:2.56},
                        {x:189,y:2.59},{x:190,y:2.61},{x:191,y:2.64},{x:192,y:2.67},{x:193,y:2.7},{x:194,y:2.73},{x:195,y:2.76},
                        {x:196,y:2.79},{x:197,y:2.82},{x:198,y:2.86},{x:199,y:2.89},{x:200,y:2.93},{x:201,y:2.96},{x:202,y:3},
                        {x:203,y:3.03},{x:204,y:3.07},{x:205,y:3.11},{x:206,y:3.15},{x:207,y:3.19},{x:208,y:3.23},{x:209,y:3.27},
                        {x:210,y:3.31},{x:211,y:3.36},{x:212,y:3.4},{x:213,y:3.45},{x:214,y:3.49},{x:215,y:3.54},{x:216,y:3.59},
                        {x:217,y:3.64},{x:218,y:3.69},{x:219,y:3.74},{x:220,y:3.79},{x:221,y:3.84},{x:222,y:3.89},{x:223,y:3.95},
                        {x:224,y:4},{x:225,y:4.06},{x:226,y:4.11},{x:227,y:4.17},{x:228,y:4.23},{x:229,y:4.29},{x:230,y:4.35}];

            var set4 = [{x:168,y:2.93},{x:169,y:2.95},{x:170,y:2.96},{x:171,y:2.98},{x:172,y:2.99},{x:173,y:3.01},{x:174,y:3.02},
                        {x:175,y:3.04},{x:176,y:3.06},{x:177,y:3.08},{x:178,y:3.1},{x:179,y:3.12},{x:180,y:3.14},{x:181,y:3.16},
                        {x:182,y:3.18},{x:183,y:3.2},{x:184,y:3.23},{x:185,y:3.25},{x:186,y:3.27},{x:187,y:3.3},{x:188,y:3.32},
                        {x:189,y:3.35},{x:190,y:3.38},{x:191,y:3.41},{x:192,y:3.43},{x:193,y:3.46},{x:194,y:3.49},{x:195,y:3.52},
                        {x:196,y:3.56},{x:197,y:3.59},{x:198,y:3.62},{x:199,y:3.66},{x:200,y:3.69},{x:201,y:3.73},{x:202,y:3.76},
                        {x:203,y:3.8},{x:204,y:3.84},{x:205,y:3.87},{x:206,y:3.91},{x:207,y:3.95},{x:208,y:4},{x:209,y:4.04},
                        {x:210,y:4.08},{x:211,y:4.12},{x:212,y:4.17},{x:213,y:4.21},{x:214,y:4.26},{x:215,y:4.31},{x:216,y:4.35},
                        {x:217,y:4.4},{x:218,y:4.45},{x:219,y:4.5},{x:220,y:4.55},{x:221,y:4.6},{x:222,y:4.66},{x:223,y:4.71},
                        {x:224,y:4.77},{x:225,y:4.82},{x:226,y:4.88},{x:227,y:4.94},{x:228,y:4.99},{x:229,y:5.05},{x:230,y:5.11}];

            var set5 = [{x:168,y:3.29},{x:169,y:3.31},{x:170,y:3.32},{x:171,y:3.33},{x:172,y:3.35},{x:173,y:3.37},{x:174,y:3.38},
                        {x:175,y:3.4},{x:176,y:3.42},{x:177,y:3.44},{x:178,y:3.46},{x:179,y:3.47},{x:180,y:3.5},{x:181,y:3.52},
                        {x:182,y:3.54},{x:183,y:3.56},{x:184,y:3.58},{x:185,y:3.61},{x:186,y:3.63},{x:187,y:3.66},{x:188,y:3.68},
                        {x:189,y:3.71},{x:190,y:3.74},{x:191,y:3.76},{x:192,y:3.79},{x:193,y:3.82},{x:194,y:3.85},{x:195,y:3.88},
                        {x:196,y:3.91},{x:197,y:3.95},{x:198,y:3.98},{x:199,y:4.01},{x:200,y:4.05},{x:201,y:4.08},{x:202,y:4.12},
                        {x:203,y:4.16},{x:204,y:4.19},{x:205,y:4.23},{x:206,y:4.27},{x:207,y:4.31},{x:208,y:4.35},{x:209,y:4.4},
                        {x:210,y:4.44},{x:211,y:4.48},{x:212,y:4.53},{x:213,y:4.57},{x:214,y:4.62},{x:215,y:4.66},{x:216,y:4.71},
                        {x:217,y:4.76},{x:218,y:4.81},{x:219,y:4.86},{x:220,y:4.91},{x:221,y:4.96},{x:222,y:5.02},{x:223,y:5.07},
                        {x:224,y:5.12},{x:225,y:5.18},{x:226,y:5.24},{x:227,y:5.29},{x:228,y:5.35},{x:229,y:5.41},{x:230,y:5.47}];

            var set6 = [];

            var set7 = [];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([wlRatioData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<7.1 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<7.1 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Gestational age at birth (weeks)");
            
            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            
            svg.append("text")
                .attr("x", -10 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("32");
                    
            svg.append("text")
                .attr("x", 753 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -10 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("32");
                    
            svg.append("text")
                .attr("x", 753 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -200 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight-length ratio (kg/m)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 200 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 180 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 140 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 100 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 80 )
                .style("text-anchor", "start")
                .text("97 th");
                
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            // svg.append("svg:path")
            //       .attr({
            //         d: lineFunc(set6),
            //         "stroke": "black",
            //         "stroke-width": 2,
            //         "fill": "none",
            //         "class": "path"
            //       });
            // svg.append("svg:path")
            //       .attr({
            //         d: lineFunc(set7),
            //         "stroke": "black",
            //         "stroke-width": 2,
            //         "fill": "none",
            //         "class": "path"
            //       });
            
            // user data
            svg.append("svg:path")
                    .attr({
                    d: datalineFunc(wlRatioData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });

        }
    }
});
            
'use strict';
angular.module('AngularApp').directive('wlratioChartMaleDirective', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var wlRatioData = [];

            if(vitalData.pretermwhRatio) {
                for(var i = 0; i < vitalData.pretermwhRatio.length; i++){
                    console.log(vitalData.pretermwhRatio[i]);
                    if(vitalData.pretermwhRatio[i].y<7.1) {
                        wlRatioData.push(vitalData.pretermwhRatio[i]);
                    }
                }
            }

            var set1 = [{x:168,y:1.18},{x:169,y:1.2},{x:170,y:1.21},{x:171,y:1.23},{x:172,y:1.24},{x:173,y:1.26},{x:174,y:1.27},
                        {x:175,y:1.29},{x:176,y:1.31},{x:177,y:1.33},{x:178,y:1.35},{x:179,y:1.37},{x:180,y:1.39},{x:181,y:1.41},
                        {x:182,y:1.43},{x:183,y:1.45},{x:184,y:1.48},{x:185,y:1.5},{x:186,y:1.52},{x:187,y:1.55},{x:188,y:1.57},
                        {x:189,y:1.6},{x:190,y:1.63},{x:191,y:1.66},{x:192,y:1.68},{x:193,y:1.71},{x:194,y:1.74},{x:195,y:1.78},
                        {x:196,y:1.81},{x:197,y:1.84},{x:198,y:1.87},{x:199,y:1.91},{x:200,y:1.94},{x:201,y:1.98},{x:202,y:2.01},
                        {x:203,y:2.05},{x:204,y:2.09},{x:205,y:2.13},{x:206,y:2.16},{x:207,y:2.2},{x:208,y:2.25},{x:209,y:2.29},
                        {x:210,y:2.33},{x:211,y:2.37},{x:212,y:2.42},{x:213,y:2.46},{x:214,y:2.51},{x:215,y:2.56},{x:216,y:2.6},
                        {x:217,y:2.65},{x:218,y:2.7},{x:219,y:2.75},{x:220,y:2.8},{x:221,y:2.85},{x:222,y:2.91},{x:223,y:2.96},
                        {x:224,y:3.02},{x:225,y:3.07},{x:226,y:3.13},{x:227,y:3.19},{x:228,y:3.24},{x:229,y:3.3},{x:230,y:3.36}];

            var set2 = [{x:168,y:1.54},{x:169,y:1.56},{x:170,y:1.57},{x:171,y:1.58},{x:172,y:1.6},{x:173,y:1.62},{x:174,y:1.63},
                        {x:175,y:1.65},{x:176,y:1.67},{x:177,y:1.69},{x:178,y:1.71},{x:179,y:1.73},{x:180,y:1.75},{x:181,y:1.77},
                        {x:182,y:1.79},{x:183,y:1.81},{x:184,y:1.83},{x:185,y:1.86},{x:186,y:1.88},{x:187,y:1.91},{x:188,y:1.93},
                        {x:189,y:1.96},{x:190,y:1.99},{x:191,y:2.01},{x:192,y:2.04},{x:193,y:2.07},{x:194,y:2.1},{x:195,y:2.13},
                        {x:196,y:2.17},{x:197,y:2.2},{x:198,y:2.23},{x:199,y:2.26},{x:200,y:2.3},{x:201,y:2.33},{x:202,y:2.37},
                        {x:203,y:2.41},{x:204,y:2.45},{x:205,y:2.48},{x:206,y:2.52},{x:207,y:2.56},{x:208,y:2.6},{x:209,y:2.65},
                        {x:210,y:2.69},{x:211,y:2.73},{x:212,y:2.78},{x:213,y:2.82},{x:214,y:2.87},{x:215,y:2.91},{x:216,y:2.96},
                        {x:217,y:3.01},{x:218,y:3.06},{x:219,y:3.11},{x:220,y:3.16},{x:221,y:3.21},{x:222,y:3.27},{x:223,y:3.32},
                        {x:224,y:3.37},{x:225,y:3.43},{x:226,y:3.49},{x:227,y:3.54},{x:228,y:3.6},{x:229,y:3.66},{x:230,y:3.72}];
                    
            var set3 = [{x:168,y:2.31},{x:169,y:2.32},{x:170,y:2.33},{x:171,y:2.35},{x:172,y:2.36},{x:173,y:2.38},{x:174,y:2.4},
                        {x:175,y:2.41},{x:176,y:2.43},{x:177,y:2.45},{x:178,y:2.47},{x:179,y:2.49},{x:180,y:2.51},{x:181,y:2.53},
                        {x:182,y:2.55},{x:183,y:2.58},{x:184,y:2.6},{x:185,y:2.62},{x:186,y:2.65},{x:187,y:2.67},{x:188,y:2.7},
                        {x:189,y:2.72},{x:190,y:2.75},{x:191,y:2.78},{x:192,y:2.81},{x:193,y:2.84},{x:194,y:2.87},{x:195,y:2.9},
                        {x:196,y:2.93},{x:197,y:2.96},{x:198,y:3},{x:199,y:3.03},{x:200,y:3.06},{x:201,y:3.1},{x:202,y:3.14},
                        {x:203,y:3.17},{x:204,y:3.21},{x:205,y:3.25},{x:206,y:3.29},{x:207,y:3.33},{x:208,y:3.37},{x:209,y:3.41},
                        {x:210,y:3.45},{x:211,y:3.5},{x:212,y:3.54},{x:213,y:3.59},{x:214,y:3.63},{x:215,y:3.68},{x:216,y:3.73},
                        {x:217,y:3.77},{x:218,y:3.82},{x:219,y:3.87},{x:220,y:3.93},{x:221,y:3.98},{x:222,y:4.03},{x:223,y:4.08},
                        {x:224,y:4.14},{x:225,y:4.19},{x:226,y:4.25},{x:227,y:4.31},{x:228,y:4.37},{x:229,y:4.43},{x:230,y:4.49}];

            var set4 = [{x:168,y:3.07},{x:169,y:3.09},{x:170,y:3.1},{x:171,y:3.11},{x:172,y:3.13},{x:173,y:3.15},{x:174,y:3.16},
                        {x:175,y:3.18},{x:176,y:3.2},{x:177,y:3.22},{x:178,y:3.23},{x:179,y:3.25},{x:180,y:3.28},{x:181,y:3.3},
                        {x:182,y:3.32},{x:183,y:3.34},{x:184,y:3.36},{x:185,y:3.39},{x:186,y:3.41},{x:187,y:3.44},{x:188,y:3.46},
                        {x:189,y:3.49},{x:190,y:3.52},{x:191,y:3.54},{x:192,y:3.57},{x:193,y:3.6},{x:194,y:3.63},{x:195,y:3.66},
                        {x:196,y:3.69},{x:197,y:3.73},{x:198,y:3.76},{x:199,y:3.79},{x:200,y:3.83},{x:201,y:3.86},{x:202,y:3.9},
                        {x:203,y:3.94},{x:204,y:3.97},{x:205,y:4.01},{x:206,y:4.05},{x:207,y:4.09},{x:208,y:4.13},{x:209,y:4.18},
                        {x:210,y:4.22},{x:211,y:4.26},{x:212,y:4.31},{x:213,y:4.35},{x:214,y:4.4},{x:215,y:4.44},{x:216,y:4.49},
                        {x:217,y:4.54},{x:218,y:4.59},{x:219,y:4.64},{x:220,y:4.69},{x:221,y:4.74},{x:222,y:4.8},{x:223,y:4.85},
                        {x:224,y:4.9},{x:225,y:4.96},{x:226,y:5.02},{x:227,y:5.07},{x:228,y:5.13},{x:229,y:5.19},{x:230,y:5.25}];

            var set5 = [{x:168,y:3.43},{x:169,y:3.44},{x:170,y:3.46},{x:171,y:3.47},{x:172,y:3.49},{x:173,y:3.5},{x:174,y:3.52},
                        {x:175,y:3.54},{x:176,y:3.56},{x:177,y:3.57},{x:178,y:3.59},{x:179,y:3.61},{x:180,y:3.63},{x:181,y:3.65},
                        {x:182,y:3.68},{x:183,y:3.7},{x:184,y:3.72},{x:185,y:3.75},{x:186,y:3.77},{x:187,y:3.8},{x:188,y:3.82},
                        {x:189,y:3.85},{x:190,y:3.87},{x:191,y:3.9},{x:192,y:3.93},{x:193,y:3.96},{x:194,y:3.99},{x:195,y:4.02},
                        {x:196,y:4.05},{x:197,y:4.09},{x:198,y:4.12},{x:199,y:4.15},{x:200,y:4.19},{x:201,y:4.22},{x:202,y:4.26},
                        {x:203,y:4.3},{x:204,y:4.33},{x:205,y:4.37},{x:206,y:4.41},{x:207,y:4.45},{x:208,y:4.49},{x:209,y:4.53},
                        {x:210,y:4.58},{x:211,y:4.62},{x:212,y:4.66},{x:213,y:4.71},{x:214,y:4.76},{x:215,y:4.8},{x:216,y:4.85},
                        {x:217,y:4.9},{x:218,y:4.95},{x:219,y:5},{x:220,y:5.05},{x:221,y:5.1},{x:222,y:5.15},{x:223,y:5.21},
                        {x:224,y:5.26},{x:225,y:5.32},{x:226,y:5.37},{x:227,y:5.43},{x:228,y:5.49},{x:229,y:5.55},{x:230,y:5.61}];

            var set6 = [];

            var set7 = [];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([wlRatioData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
				return '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<7.1 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<7.1 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Gestational age at birth (weeks)");
            
            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            
            svg.append("text")
                .attr("x", -10 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("32");
                   
            svg.append("text")
                .attr("x", 753 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -10 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("32");
                   
            svg.append("text")
                .attr("x", 753 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -200 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight-length ratio (kg/m)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 200 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 180 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 140 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 100 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 80 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            // svg.append("svg:path")
            //       .attr({
            //         d: lineFunc(set6),
            //         "stroke": "black",
            //         "stroke-width": 2,
            //         "fill": "none",
            //         "class": "path"
            //       });
            // svg.append("svg:path")
            //       .attr({
            //         d: lineFunc(set7),
            //         "stroke": "black",
            //         "stroke-width": 2,
            //         "fill": "none",
            //         "class": "path"
            //       });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(wlRatioData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});

/* global window */
/* global angular */
/* global module */

(function (module, window, angular) {
    "use strict";

    function test(string, regex) {
        if (typeof regex === 'string' || regex instanceof String) {
            regex=new RegExp(regex);
        }

        if (regex instanceof RegExp) {
            return regex.test(string);
        }
        else if (regex && Array.isArray(regex.and)) {
            return regex.and.every(function (item) {
                return test(string, item);
            });
        }
        else if (regex && Array.isArray(regex.or)) {
            return regex.or.some(function (item) {
                return test(string, item);
            });
        }
        else if (regex && regex.not) {
            return !test(string, regex.not);
        }
        else {
            return false;
        }
    }

    function exec(string, regex) {
        if (typeof regex === 'string' || regex instanceof String) {
            regex=new RegExp(regex);
        }

        if (regex instanceof RegExp) {
            return regex.exec(string);
        }
        else if (regex && Array.isArray(regex)) {
            return regex.reduce(function (res, item) {
                return (!!res) ? res : exec(string, item);
            }, null);
        }
        else if (regex && Array.isArray(regex.and)) {
            if(test(string,regex))
            {
                return exec(string,regex.and);
            }
            else
            {
                return null;
            }
        }
        else if (regex && Array.isArray(regex.or)) {
            return exec(string,regex.or);
        }
        else if (regex && regex.not) {
            return !exec(string, regex.not)?[]:null;
        }        
        else {
            return null;
        }
    }

    if (!!angular) {
        angular.module("reTree", []).factory("reTree", [function () {
            return {
                test: test,
                exec: exec
            };
        }]);
    }

    if (!!window) {
        window.reTree = {
            test: test,
            exec: exec
        };
    }

    if (!!module && !!(module.exports)) {
        module.exports = {
            test: test,
            exec: exec
        };
    }
})(typeof module === 'undefined' ? null : module, typeof window === 'undefined' ? null : window, typeof angular === 'undefined' ? null : angular);

'use strict';
angular.module('AngularApp').directive('timeLine', function($window) {
    return {
        restrict: 'EA',
        link: function(scope, element, attrs){
            var tempData = []
            angular.forEach(scope[attrs.chartData],function(value) {
                var jsonObj = {type: TimelineChart.TYPE.POINT};
                var date = value.date.split('-');
                var nDate = [];
                nDate.push(date[0]);
                nDate.push(date[1]);
                nDate.push(date[2].split('T')[0]);
                jsonObj.at = "";
                jsonObj.label = value.log_items;
                jsonObj.at = new Date(value.date+'Z');
                tempData.push(jsonObj);
            });
            var data = [{
                label: 'Life Log',
                data: tempData
            }];

            var timeline = new TimelineChart(element[0], 
                                            data,
                                            {'width':'800','height':'150',
                                                tip: function(d) {
                                                return d.label;
                                                }
                                            }
                                    );
        }
    };
});
/* global window */
/* global angular */
/* global module */

(function (module, require, window, angular) {
    "use strict";

    var BROWSERS = {
        CHROME: "chrome",
        FIREFOX: "firefox",
        SAFARI: "safari",
        OPERA: "opera",
        IE: "ie",
        MS_EDGE: "ms-edge",
        MS_EDGE_BETA: "ms-edge-beta",
        FB_MESSENGER: "fb-messenger",
        CORDOVA: "cordova",
        UNKNOWN: "unknown"
    };

    var DEVICES = {
        ANDROID: "android",
        I_PAD: "ipad",
        IPHONE: "iphone",
        I_POD: "ipod",
        BLACKBERRY: "blackberry",
        FIREFOX_OS: "firefox-os",
        CHROME_BOOK: "chrome-book",
        WINDOWS_PHONE: "windows-phone",
        PS4: "ps4",
        VITA: "vita",
        CHROMECAST: "chromecast",
        APPLE_TV: "apple-tv",
        GOOGLE_TV: "google-tv",
        MACINTOSH: "mac",
        UNKNOWN: "unknown"
    };

    var OS = {
        WINDOWS: "windows",
        MAC: "mac",
        IOS: "ios",
        ANDROID: "android",
        LINUX: "linux",
        UNIX: "unix",
        FIREFOX_OS: "firefox-os",
        CHROME_OS: "chrome-os",
        WINDOWS_PHONE: "windows-phone",
        UNKNOWN: "unknown"
    };

    /**
     * @deprecated Will be deleted in future versions. OS versions will not be list-hardcoded.
     */
    var OS_VERSIONS = {
        WINDOWS_3_11: "windows-3-11",
        WINDOWS_95: "windows-95",
        WINDOWS_ME: "windows-me",
        WINDOWS_98: "windows-98",
        WINDOWS_CE: "windows-ce",
        WINDOWS_2000: "windows-2000",
        WINDOWS_XP: "windows-xp",
        WINDOWS_SERVER_2003: "windows-server-2003",
        WINDOWS_VISTA: "windows-vista",
        WINDOWS_7: "windows-7",
        WINDOWS_8_1: "windows-8-1",
        WINDOWS_8: "windows-8",
        WINDOWS_10: "windows-10",
        WINDOWS_PHONE_7_5: "windows-phone-7-5",
        WINDOWS_PHONE_8_1: "windows-phone-8-1",
        WINDOWS_PHONE_10: "windows-phone-10",
        WINDOWS_NT_4_0: "windows-nt-4-0",
        MACOSX_15: "mac-os-x-15",
        MACOSX_14: "mac-os-x-14",
        MACOSX_13: "mac-os-x-13",
        MACOSX_12: "mac-os-x-12",
        MACOSX_11: "mac-os-x-11",
        MACOSX_10: "mac-os-x-10",
        MACOSX_9: "mac-os-x-9",
        MACOSX_8: "mac-os-x-8",
        MACOSX_7: "mac-os-x-7",
        MACOSX_6: "mac-os-x-6",
        MACOSX_5: "mac-os-x-5",
        MACOSX_4: "mac-os-x-4",
        MACOSX_3: "mac-os-x-3",
        MACOSX_2: "mac-os-x-2",
        MACOSX: "mac-os-x",
        UNKNOWN: "unknown"
    };

    var OS_RE = {
        WINDOWS: {
            and: [{
                or: [/\bWindows|(Win\d\d)\b/, /\bWin 9x\b/]
            }, {
                not: /\bWindows Phone\b/
            }]
        },
        MAC: {
            and: [/\bMac OS\b/, {
                not: /Windows Phone/
            }]
        },
        IOS: {
            and: [{
                or: [/\biPad\b/, /\biPhone\b/, /\biPod\b/]
            }, {
                not: /Windows Phone/
            }]
        },
        ANDROID: {
            and: [/\bAndroid\b/, {
                not: /Windows Phone/
            }]
        },
        LINUX: /\bLinux\b/,
        UNIX: /\bUNIX\b/,
        FIREFOX_OS: {
            and: [/\bFirefox\b/, /Mobile\b/]
        },
        CHROME_OS: /\bCrOS\b/,
        WINDOWS_PHONE: {
            or: [/\bIEMobile\b/, /\bWindows Phone\b/]
        },
        PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
        VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
    };

    var BROWSERS_RE = {
        CHROME: {
            and: [{
                or: [/\bChrome\b/, /\bCriOS\b/, /\bHeadlessChrome\b/]
            }, {
                not: {
                    or: [/\bOPR\b/, /\bEdge\b/, /\bEdg\b/, /\bCordova\b/]
                }
            }]
        },
        FIREFOX: {
            and: [{
                or: [/\bFirefox\b/, /\bFxiOS\b/]
            }, {
                not: /\bCordova\b/
            }]
        },
        SAFARI: {
            and: [/^((?!CriOS).)*\Safari\b.*$/, {
                not: {
                    or: [/\bOPR\b/, /\bEdge\b/, /\bEdg\b/, /Windows Phone/, /\bCordova\b/, /\bChrome\b/]
                }
            }]
        },
        OPERA: {
            or: [/Opera\b/, /\bOPR\b/]
        },
        IE: {
            or: [/\bMSIE\b/, /\bTrident\b/, /^Mozilla\/5\.0 \(Windows NT 10\.0; Win64; x64\)$/]
        },
        MS_EDGE: {
            or: [/\bEdge\b/]
        },
        MS_EDGE_BETA: {
            or: [/\bEdg\b/]
        },
        PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
        VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/,
        CORDOVA: /\bCordova\b/,
        FB_MESSENGER: /\bFBAN\/MessengerForiOS\b/
    };

    var DEVICES_RE = {
        ANDROID: {
            and: [/\bAndroid\b/, {
                not: /Windows Phone/
            }]
        },
        I_PAD: /\biPad\b/,
        IPHONE: {
            and: [/\biPhone\b/, {
                not: /Windows Phone/
            }]
        },
        I_POD: /\biPod\b/,
        BLACKBERRY: /\bblackberry\b/,
        FIREFOX_OS: {
            and: [/\bFirefox\b/, /\bMobile\b/]
        },
        CHROME_BOOK: /\bCrOS\b/,
        WINDOWS_PHONE: {
            or: [/\bIEMobile\b/, /\bWindows Phone\b/]
        },
        PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
        CHROMECAST: /\bCrKey\b/,
        APPLE_TV: /^iTunes-AppleTV\/4.1$/,
        GOOGLE_TV: /\bGoogleTV\b/,
        VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/,
        MACINTOSH: /\bMacintosh\b/,
    };

    /**
     * @deprecated Will be deleted in future versions. OS versions will not be list-hardcoded.
     */
    var OS_VERSIONS_RE_OLD = {
        WINDOWS_3_11: /Win16/,
        WINDOWS_95: /(Windows 95|Win95|Windows_95)/,
        WINDOWS_ME: /(Win 9x 4.90|Windows ME)/,
        WINDOWS_98: /(Windows 98|Win98)/,
        WINDOWS_CE: /Windows CE/,
        WINDOWS_2000: /(Windows NT 5.0|Windows 2000)/,
        WINDOWS_XP: /(Windows NT 5.1|Windows XP)/,
        WINDOWS_SERVER_2003: /Windows NT 5.2/,
        WINDOWS_VISTA: /Windows NT 6.0/,
        WINDOWS_7: /(Windows 7|Windows NT 6.1)/,
        WINDOWS_8_1: /(Windows 8.1|Windows NT 6.3)/,
        WINDOWS_8: /(Windows 8|Windows NT 6.2)/,
        WINDOWS_10: /(Windows NT 10.0)/,
        WINDOWS_PHONE_7_5: /(Windows Phone OS 7.5)/,
        WINDOWS_PHONE_8_1: /(Windows Phone 8.1)/,
        WINDOWS_PHONE_10: /(Windows Phone 10)/,
        WINDOWS_NT_4_0: {
            and: [/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/, {
                not: /Windows NT 10.0/
            }]
        },
        MACOSX: /(MAC OS X\s*[^ 0-9])/,
        MACOSX_3: /(Darwin 10.3|Mac OS X 10.3)/,
        MACOSX_4: /(Darwin 10.4|Mac OS X 10.4)/,
        MACOSX_5: /(Mac OS X 10.5)/,
        MACOSX_6: /(Mac OS X 10.6)/,
        MACOSX_7: /(Mac OS X 10.7)/,
        MACOSX_8: /(Mac OS X 10.8)/,
        MACOSX_9: /(Mac OS X 10.9)/,
        MACOSX_10: /(Mac OS X 10.10)/,
        MACOSX_11: /(Mac OS X 10.11)/,
        MACOSX_12: /(Mac OS X 10.12)/,
        MACOSX_13: /(Mac OS X 10.13)/,
        MACOSX_14: /(Mac OS X 10.14)/,
        MACOSX_15: /(Mac OS X 10.15)/
    };

    var OS_VERSIONS_RE_MAP = {
        WINDOWS: [{
            re: /Win16/,
            map: "windows-3-11"
        },
        {
            re: /(Windows 95|Win95|Windows_95)/,
            map: "windows-95"
        },
        {
            re: /(Win 9x 4.90|Windows ME)/,
            map: "windows-me"
        },
        {
            re: /(Windows 98|Win98)/,
            map: "windows-98"
        },
        {
            re: /Windows CE/,
            map: "windows-ce"
        },
        {
            re: /(Windows NT 5.0|Windows 2000)/,
            map: "windows-2000"
        },
        {
            re: /(Windows NT 5.1|Windows XP)/,
            map: "windows-xp"
        },
        {
            re: /Windows NT 5.2/,
            map: "windows-server-2003"
        },
        {
            re: /Windows NT 6.0/,
            map: "windows-vista"
        },
        {
            re: /(Windows 7|Windows NT 6.1)/,
            map: "windows-7"
        },
        {
            re: /(Windows 8.1|Windows NT 6.3)/,
            map: "windows-8-1"
        },
        {
            re: /(Windows 8|Windows NT 6.2)/,
            map: "windows-8"
        },
        {
            re: /(Windows NT 10.0)/,
            map: "windows-10"
        },
        {
            re: {
                and: [/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/, {
                    not: /Windows NT 10.0/
                }]
            },
            map: "windows-nt-4-0"
        },
        ],
        WINDOWS_PHONE: [{
            re: /(Windows Phone OS 7.5)/,
            map: "windows-phone-7-5"
        },
        {
            re: /(Windows Phone 8.1)/,
            map: "windows-phone-8-1"
        },
        {
            re: /(Windows Phone 10)/,
            map: "windows-phone-10"
        },
        ],
        MAC: [{
            re: /(MAC OS X\s*[^ 0-9])/,
            map: 'mac-os-x'
        },
        {
            re: /(Darwin 10.3|Mac OS X 10.3)/,
            map: 'mac-os-x-3'
        },
        {
            re: /(Darwin 10.4|Mac OS X 10.4)/,
            map: 'mac-os-x-4'
        },
        {
            re: /(Mac OS X 10.5)/,
            map: 'mac-os-x-5'
        },
        {
            re: /(Mac OS X 10.6)/,
            map: 'mac-os-x-6'
        },
        {
            re: /(Mac OS X 10.7)/,
            map: 'mac-os-x-7'
        },
        {
            re: /(Mac OS X 10.8)/,
            map: 'mac-os-x-8'
        },
        {
            re: /(Mac OS X 10.9)/,
            map: 'mac-os-x-9'
        },
        {
            re: /(Mac OS X 10.10)/,
            map: 'mac-os-x-10'
        },
        {
            re: /(Mac OS X 10.11)/,
            map: 'mac-os-x-11'
        },
        {
            re: /(Mac OS X 10.12)/,
            map: 'mac-os-x-12'
        },
        {
            re: /(Mac OS X 10.13)/,
            map: 'mac-os-x-13'
        },
        {
            re: /(Mac OS X 10.14)/,
            map: 'mac-os-x-14'
        },
        {
            re: /(Mac OS X 10.15)/,
            map: 'mac-os-x-15'
        }
        ],
        IOS: [{
            re: /OS ([\d_\-.]+)/,
            map: function (match) {
                return match.replace(/_/g, '.');
            }
        }],
        ANDROID: [{
            re: /Android ([\d.]+)/,
            map: function (match) {
                return match;
            }
        }]
    };

    var OS_VERSIONS_RE = Object.keys(OS_VERSIONS_RE_MAP).reduce(function (obj, key) {
        obj[OS[key]] = OS_VERSIONS_RE_MAP[key];
        return obj;
    }, {});

    var BROWSER_VERSIONS_RE_MAP = {
        CHROME: [/\bChrome\/([\d\.]+)\b/, /\bCriOS\/([\d\.]+)\b/, /\bHeadlessChrome Safari\/([\d\.]+)\b/],
        FIREFOX: [/\bFirefox\/([\d\.]+)\b/, /\bFxiOS\/([\d\.]+)\b/],
        SAFARI: /\bVersion\/([\d\.]+)\b/,
        OPERA: [/\bVersion\/([\d\.]+)\b/, /\bOPR\/([\d\.]+)\b/],
        IE: [/\bMSIE ([\d\.]+\w?)\b/, /\brv:([\d\.]+\w?)\b/],
        CORDOVA: /\bCordova\/([\d\.]+)\b/,
        MS_EDGE: /\bEdge\/([\d\.]+)\b/,
        MS_EDGE_BETA: /\bEdg\/([\d\.]+)\b/
    };

    var BROWSER_VERSIONS_RE = Object.keys(BROWSER_VERSIONS_RE_MAP).reduce(function (obj, key) {
        obj[BROWSERS[key]] = BROWSER_VERSIONS_RE_MAP[key];
        return obj;
    }, {});

    /* ES5 polyfills Start*/

    // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
    if (!Object.keys) {
        Object.keys = (function () {
            'use strict';
            var hasOwnProperty = Object.prototype.hasOwnProperty,
                hasDontEnumBug = !({
                    toString: null
                }).propertyIsEnumerable('toString'),
                dontEnums = [
                    'toString',
                    'toLocaleString',
                    'valueOf',
                    'hasOwnProperty',
                    'isPrototypeOf',
                    'propertyIsEnumerable',
                    'constructor'
                ],
                dontEnumsLength = dontEnums.length;

            return function (obj) {
                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
                    throw new TypeError('Object.keys called on non-object');
                }

                var result = [],
                    prop, i;

                for (prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) {
                        result.push(prop);
                    }
                }

                if (hasDontEnumBug) {
                    for (i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) {
                            result.push(dontEnums[i]);
                        }
                    }
                }
                return result;
            };
        }());
    }

    // Production steps of ECMA-262, Edition 5, 15.4.4.21
    // Reference: http://es5.github.io/#x15.4.4.21
    if (!Array.prototype.reduce) {
        Array.prototype.reduce = function (callback /*, initialValue*/) {
            'use strict';
            if (this == null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }
            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }
            var t = Object(this),
                len = t.length >>> 0,
                k = 0,
                value;
            if (arguments.length == 2) {
                value = arguments[1];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }
                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }
                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        };
    }

    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, "find", {
            value: function (predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== "function") {
                    throw new TypeError("predicate must be a function");
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return kValue.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return kValue;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return undefined.
                return undefined;
            }
        });
    }
    /* ES5 polyfills End*/

    function parseUserAgent(options) {
        var reTree = !!options ? options.reTree : {};
        var customDetectors = !!options ? options.customDetectors : [];
        var ua = !!options ? options.userAgent : "";
        var modifiers = {
            platform: !!options ? options.platform : "",
            maxTouchPoints: !!options ? options.maxTouchPoints : ""
        };

        var deviceInfo = {
            raw: {
                userAgent: ua,
                modifiers: modifiers,
                os: {},
                browser: {},
                device: {}
            }
        };

        deviceInfo.raw.os = Object.keys(OS).reduce(function (obj, item) {
            obj[OS[item]] = reTree.test(ua, OS_RE[item]);
            return obj;
        }, {});

        deviceInfo.raw.browser = Object.keys(BROWSERS).reduce(function (obj, item) {
            obj[BROWSERS[item]] = reTree.test(ua, BROWSERS_RE[item]);
            return obj;
        }, {});

        deviceInfo.raw.device = Object.keys(DEVICES).reduce(function (obj, item) {
            obj[DEVICES[item]] = reTree.test(ua, DEVICES_RE[item]);
            return obj;
        }, {});

        deviceInfo.raw.os_version = Object.keys(OS_VERSIONS).reduce(function (obj, item) {
            obj[OS_VERSIONS[item]] = reTree.test(ua, OS_VERSIONS_RE_OLD[item]);
            return obj;
        }, {});

        deviceInfo.os = [
            OS.WINDOWS,
            OS.IOS,
            OS.MAC,
            OS.ANDROID,
            OS.LINUX,
            OS.UNIX,
            OS.FIREFOX_OS,
            OS.CHROME_OS,
            OS.WINDOWS_PHONE
        ].reduce(function (previousValue, currentValue) {
            return (previousValue === OS.UNKNOWN && deviceInfo.raw.os[currentValue]) ? currentValue : previousValue;
        }, OS.UNKNOWN);

        deviceInfo.browser = [
            BROWSERS.CHROME,
            BROWSERS.FIREFOX,
            BROWSERS.SAFARI,
            BROWSERS.OPERA,
            BROWSERS.IE,
            BROWSERS.MS_EDGE,
            BROWSERS.MS_EDGE_BETA,
            BROWSERS.CORDOVA,
            BROWSERS.FB_MESSENGER
        ].reduce(function (previousValue, currentValue) {
            return (previousValue === BROWSERS.UNKNOWN && deviceInfo.raw.browser[currentValue]) ? currentValue : previousValue;
        }, BROWSERS.UNKNOWN);

        deviceInfo.device = [
            DEVICES.ANDROID,
            DEVICES.I_PAD,
            DEVICES.IPHONE,
            DEVICES.I_POD,
            DEVICES.BLACKBERRY,
            DEVICES.FIREFOX_OS,
            DEVICES.CHROME_BOOK,
            DEVICES.WINDOWS_PHONE,
            DEVICES.PS4,
            DEVICES.CHROMECAST,
            DEVICES.APPLE_TV,
            DEVICES.GOOGLE_TV,
            DEVICES.VITA,
            DEVICES.MACINTOSH,
        ].reduce(function (previousValue, currentValue) {
            return (previousValue === DEVICES.UNKNOWN && deviceInfo.raw.device[currentValue]) ? currentValue : previousValue;
        }, DEVICES.UNKNOWN);

        deviceInfo.os_version = "unknown";
        if (deviceInfo.os !== OS.UNKNOWN) {
            var version = (OS_VERSIONS_RE[deviceInfo.os] || [])
                .map(function (reMap) {
                    var res = reTree.exec(ua, reMap.re);
                    if (!!res) {
                        if (typeof reMap.map === 'string' || reMap.map instanceof String) {
                            return reMap.map;
                        } else {
                            return reMap.map.call(null, res[1]);
                        }
                    } else {
                        return null;
                    }
                })
                .find(function (element) {
                    return !!element;
                });
            if (!!version) {
                deviceInfo.os_version = version;
            }
        }

        deviceInfo.browser_version = "0";
        if (deviceInfo.browser !== BROWSERS.UNKNOWN) {
            var re = BROWSER_VERSIONS_RE[deviceInfo.browser];
            var res = reTree.exec(ua, re);
            if (!!res) {
                deviceInfo.browser_version = res[1];
            }
        }

        deviceInfo.isMobile = function () {
            return [
                DEVICES.ANDROID,
                DEVICES.I_PAD,
                DEVICES.IPHONE,
                DEVICES.I_POD,
                DEVICES.BLACKBERRY,
                DEVICES.FIREFOX_OS,
                DEVICES.WINDOWS_PHONE,
                DEVICES.VITA
            ].some(function (item) {
                return deviceInfo.device == item;
            });
        };

        deviceInfo.isTablet = function () {
            return [
                DEVICES.I_PAD,
                DEVICES.FIREFOX_OS
            ].some(function (item) {
                return deviceInfo.device == item;
            });
        };

        deviceInfo.isDesktop = function () {
            return [
                DEVICES.PS4,
                DEVICES.CHROME_BOOK,
                DEVICES.MACINTOSH,
                DEVICES.UNKNOWN
            ].some(function (item) {
                return deviceInfo.device == item;
            });
        };

        deviceInfo.custom = customDetectors.reduce(function (custom, customDetector) {
            custom[customDetector.name] = reTree.test(ua, customDetector.re);
            return custom;
        }, {});

        applyModifiers(deviceInfo, modifiers);

        return deviceInfo;
    }

    function applyModifiers(deviceInfo, modifiers) {
        /* https://github.com/srfrnk/ua-device-detector/issues/17 */
        if (deviceInfo.os === OS.MAC && modifiers.platform === 'MacIntel' && modifiers.maxTouchPoints > 1) {
            deviceInfo.os = OS.IOS;
            deviceInfo.os_version = "13.0";
            deviceInfo.device = DEVICES.IPHONE;
        }
    }

    if (!!angular) {
        angular.module("uaDeviceDetector", ["reTree"])
            .constant("OS_RE", OS_RE)
            .constant("BROWSERS_RE", BROWSERS_RE)
            .constant("DEVICES_RE", DEVICES_RE)
            .constant("OS_VERSIONS_RE", OS_VERSIONS_RE_OLD)
            .constant("BROWSER_VERSIONS_RE_MAP", BROWSER_VERSIONS_RE_MAP)
            .constant("BROWSER_VERSIONS_RE", BROWSER_VERSIONS_RE)
            .constant("BROWSERS", BROWSERS)
            .constant("DEVICES", DEVICES)
            .constant("OS", OS)
            .constant("OS_VERSIONS", OS_VERSIONS)
            .factory("uaDeviceDetector", ["reTree", function (reTree) {
                return {
                    parseUserAgent: function (ua, customDetectors, platform, maxTouchPoints) {
                        return parseUserAgent({
                            reTree: reTree || {},
                            customDetectors: customDetectors || [],
                            userAgent: ua || "",
                            platform: platform,
                            maxTouchPoints: maxTouchPoints
                        });
                    },
                    BROWSERS: BROWSERS,
                    DEVICES: DEVICES,
                    OS: OS
                };
            }]);
    }

    if (!!window) {
        window.uaDeviceDetector = {
            parseUserAgent: function (ua, customDetectors, platform, maxTouchPoints) {
                return parseUserAgent({
                    reTree: window.reTree || {},
                    customDetectors: customDetectors || [],
                    userAgent: ua || "",
                    platform: platform,
                    maxTouchPoints: maxTouchPoints
                });
            },
            BROWSERS: BROWSERS,
            DEVICES: DEVICES,
            OS: OS
        };
    }

    if (!!module) {
        var reTree = (window && window.reTree) || require("re-tree");
        module.exports = {
            parseUserAgent: function (ua, customDetectors, platform, maxTouchPoints) {
                return parseUserAgent({
                    reTree: reTree || {},
                    customDetectors: customDetectors || [],
                    userAgent: ua || "",
                    platform: platform,
                    maxTouchPoints: maxTouchPoints
                });
            },
            BROWSERS: BROWSERS,
            DEVICES: DEVICES,
            OS: OS
        };
    }
})(typeof module === 'undefined' ? null : module, typeof require === 'undefined' ? null : require, typeof window === 'undefined' ? null : window, typeof angular === 'undefined' ? null : angular);
'use strict';
angular.module('AngularApp').directive('weightForHeightLengthFemale', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%; padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var heightweightData = [];

            if(vitalData.hwData) {
                for(var i = 0; i < vitalData.hwData.length; i++){
                    if(vitalData.hwData[i].x<111 && vitalData.hwData[i].x>44) {
                        if(vitalData.hwData[i].y<28 && vitalData.hwData[i].y>0) {
                            heightweightData.push(vitalData.hwData[i]);
                        }
                    }
                }
            }

            var set1 = [{x:45,y:2},{x:45.5,y:2.1},{x:46,y:2.1},{x:46.5,y:2.2},{x:47,y:2.3},{x:47.5,y:2.4},{x:48,y:2.4},{x:48.5,y:2.5},{x:49,y:2.6},{x:49.5,y:2.7},{x:50,y:2.7},{x:50.5,y:2.8},{x:51,y:2.9},{x:51.5,y:3},{x:52,y:3.1},{x:52.5,y:3.2},{x:53,y:3.3},{x:53.5,y:3.4},{x:54,y:3.5},{x:54.5,y:3.6},{x:55,y:3.7},{x:55.5,y:3.8},{x:56,y:3.9},{x:56.5,y:4},{x:57,y:4.1},{x:57.5,y:4.3},{x:58,y:4.4},{x:58.5,y:4.5},{x:59,y:4.6},{x:59.5,y:4.7},{x:60,y:4.8},{x:60.5,y:4.9},{x:61,y:5},{x:61.5,y:5.1},{x:62,y:5.2},{x:62.5,y:5.3},{x:63,y:5.4},{x:63.5,y:5.5},{x:64,y:5.6},{x:64.5,y:5.7},{x:65,y:5.9},{x:65.5,y:6},{x:66,y:6.1},{x:66.5,y:6.2},{x:67,y:6.3},{x:67.5,y:6.4},{x:68,y:6.4},{x:68.5,y:6.5},{x:69,y:6.6},{x:69.5,y:6.7},{x:70,y:6.8},{x:70.5,y:6.9},{x:71,y:6.9},{x:71.5,y:7},{x:72,y:7.1},{x:72.5,y:7.2},{x:73,y:7.3},{x:73.5,y:7.4},{x:74,y:7.4},{x:74.5,y:7.5},{x:75,y:7.6},{x:75.5,y:7.7},{x:76,y:7.7},{x:76.5,y:7.8},{x:77,y:7.9},{x:77.5,y:8},{x:78,y:8},{x:78.5,y:8.1},{x:79,y:8.2},{x:79.5,y:8.3},{x:80,y:8.4},{x:80.5,y:8.5},{x:81,y:8.6},{x:81.5,y:8.6},{x:82,y:8.7},{x:82.5,y:8.8},{x:83,y:8.9},{x:83.5,y:9},{x:84,y:9.1},{x:84.5,y:9.2},{x:85,y:9.3},{x:85.5,y:9.4},{x:86,y:9.5},{x:86.5,y:9.6},{x:87,y:9.7},{x:87.5,y:9.9},{x:88,y:10},{x:88.5,y:10.1},{x:89,y:10.2},{x:89.5,y:10.3},{x:90,y:10.4},{x:90.5,y:10.5},{x:91,y:10.6},{x:91.5,y:10.7},{x:92,y:10.8},{x:92.5,y:10.9},{x:93,y:11},{x:93.5,y:11.1},{x:94,y:11.2},{x:94.5,y:11.3},{x:95,y:11.4},{x:95.5,y:11.5},{x:96,y:11.6},{x:96.5,y:11.7},{x:97,y:11.8},{x:97.5,y:11.9},{x:98,y:12},{x:98.5,y:12.1},{x:99,y:12.2},{x:99.5,y:12.3},{x:100,y:12.4},{x:100.5,y:12.5},{x:101,y:12.7},{x:101.5,y:12.8},{x:102,y:12.9},{x:102.5,y:13},{x:103,y:13.1},{x:103.5,y:13.3},{x:104,y:13.4},{x:104.5,y:13.5},{x:105,y:13.6},{x:105.5,y:13.8},{x:106,y:13.9},{x:106.5,y:14.1},{x:107,y:14.2},{x:107.5,y:14.3},{x:108,y:14.5},{x:108.5,y:14.6},{x:109,y:14.8},{x:109.5,y:14.9},{x:110,y:15.1}];
  
            var set2 = [{x:45,y:2.1},{x:45.5,y:2.2},{x:46,y:2.2},{x:46.5,y:2.3},{x:47,y:2.4},{x:47.5,y:2.4},{x:48,y:2.5},{x:48.5,y:2.6},{x:49,y:2.7},{x:49.5,y:2.8},{x:50,y:2.8},{x:50.5,y:2.9},{x:51,y:3},{x:51.5,y:3.1},{x:52,y:3.2},{x:52.5,y:3.3},{x:53,y:3.4},{x:53.5,y:3.5},{x:54,y:3.6},{x:54.5,y:3.7},{x:55,y:3.9},{x:55.5,y:4},{x:56,y:4.1},{x:56.5,y:4.2},{x:57,y:4.3},{x:57.5,y:4.4},{x:58,y:4.5},{x:58.5,y:4.6},{x:59,y:4.8},{x:59.5,y:4.9},{x:60,y:5},{x:60.5,y:5.1},{x:61,y:5.2},{x:61.5,y:5.3},{x:62,y:5.4},{x:62.5,y:5.5},{x:63,y:5.6},{x:63.5,y:5.7},{x:64,y:5.8},{x:64.5,y:5.9},{x:65,y:6.1},{x:65.5,y:6.2},{x:66,y:6.3},{x:66.5,y:6.4},{x:67,y:6.5},{x:67.5,y:6.6},{x:68,y:6.7},{x:68.5,y:6.8},{x:69,y:6.9},{x:69.5,y:7},{x:70,y:7},{x:70.5,y:7.1},{x:71,y:7.2},{x:71.5,y:7.3},{x:72,y:7.4},{x:72.5,y:7.5},{x:73,y:7.6},{x:73.5,y:7.6},{x:74,y:7.7},{x:74.5,y:7.8},{x:75,y:7.9},{x:75.5,y:8},{x:76,y:8},{x:76.5,y:8.1},{x:77,y:8.2},{x:77.5,y:8.3},{x:78,y:8.4},{x:78.5,y:8.4},{x:79,y:8.5},{x:79.5,y:8.6},{x:80,y:8.7},{x:80.5,y:8.8},{x:81,y:8.9},{x:81.5,y:9},{x:82,y:9.1},{x:82.5,y:9.2},{x:83,y:9.3},{x:83.5,y:9.4},{x:84,y:9.5},{x:84.5,y:9.6},{x:85,y:9.7},{x:85.5,y:9.8},{x:86,y:9.9},{x:86.5,y:10},{x:87,y:10.1},{x:87.5,y:10.2},{x:88,y:10.3},{x:88.5,y:10.4},{x:89,y:10.5},{x:89.5,y:10.6},{x:90,y:10.8},{x:90.5,y:10.9},{x:91,y:11},{x:91.5,y:11.1},{x:92,y:11.2},{x:92.5,y:11.3},{x:93,y:11.4},{x:93.5,y:11.5},{x:94,y:11.6},{x:94.5,y:11.7},{x:95,y:11.8},{x:95.5,y:11.9},{x:96,y:12},{x:96.5,y:12.1},{x:97,y:12.2},{x:97.5,y:12.3},{x:98,y:12.4},{x:98.5,y:12.6},{x:99,y:12.7},{x:99.5,y:12.8},{x:100,y:12.9},{x:100.5,y:13},{x:101,y:13.1},{x:101.5,y:13.3},{x:102,y:13.4},{x:102.5,y:13.5},{x:103,y:13.6},{x:103.5,y:13.8},{x:104,y:13.9},{x:104.5,y:14},{x:105,y:14.2},{x:105.5,y:14.3},{x:106,y:14.5},{x:106.5,y:14.6},{x:107,y:14.7},{x:107.5,y:14.9},{x:108,y:15},{x:108.5,y:15.2},{x:109,y:15.4},{x:109.5,y:15.5},{x:110,y:15.7}];

            var set3 = [{x:45,y:2.5},{x:45.5,y:2.5},{x:46,y:2.6},{x:46.5,y:2.7},{x:47,y:2.8},{x:47.5,y:2.9},{x:48,y:3},{x:48.5,y:3.1},{x:49,y:3.2},{x:49.5,y:3.3},{x:50,y:3.4},{x:50.5,y:3.5},{x:51,y:3.6},{x:51.5,y:3.7},{x:52,y:3.8},{x:52.5,y:3.9},{x:53,y:4},{x:53.5,y:4.2},{x:54,y:4.3},{x:54.5,y:4.4},{x:55,y:4.5},{x:55.5,y:4.7},{x:56,y:4.8},{x:56.5,y:5},{x:57,y:5.1},{x:57.5,y:5.2},{x:58,y:5.4},{x:58.5,y:5.5},{x:59,y:5.6},{x:59.5,y:5.7},{x:60,y:5.9},{x:60.5,y:6},{x:61,y:6.1},{x:61.5,y:6.3},{x:62,y:6.4},{x:62.5,y:6.5},{x:63,y:6.6},{x:63.5,y:6.7},{x:64,y:6.9},{x:64.5,y:7},{x:65,y:7.2},{x:65.5,y:7.4},{x:66,y:7.5},{x:66.5,y:7.6},{x:67,y:7.7},{x:67.5,y:7.8},{x:68,y:7.9},{x:68.5,y:8},{x:69,y:8.1},{x:69.5,y:8.2},{x:70,y:8.3},{x:70.5,y:8.4},{x:71,y:8.5},{x:71.5,y:8.6},{x:72,y:8.7},{x:72.5,y:8.8},{x:73,y:8.9},{x:73.5,y:9},{x:74,y:9.1},{x:74.5,y:9.2},{x:75,y:9.3},{x:75.5,y:9.4},{x:76,y:9.5},{x:76.5,y:9.6},{x:77,y:9.6},{x:77.5,y:9.7},{x:78,y:9.8},{x:78.5,y:9.9},{x:79,y:10},{x:79.5,y:10.1},{x:80,y:10.2},{x:80.5,y:10.3},{x:81,y:10.4},{x:81.5,y:10.6},{x:82,y:10.7},{x:82.5,y:10.8},{x:83,y:10.9},{x:83.5,y:11},{x:84,y:11.1},{x:84.5,y:11.3},{x:85,y:11.4},{x:85.5,y:11.5},{x:86,y:11.6},{x:86.5,y:11.8},{x:87,y:11.9},{x:87.5,y:12},{x:88,y:12.1},{x:88.5,y:12.3},{x:89,y:12.4},{x:89.5,y:12.5},{x:90,y:12.6},{x:90.5,y:12.8},{x:91,y:12.9},{x:91.5,y:13},{x:92,y:13.1},{x:92.5,y:13.3},{x:93,y:13.4},{x:93.5,y:13.5},{x:94,y:13.6},{x:94.5,y:13.8},{x:95,y:13.9},{x:95.5,y:14},{x:96,y:14.1},{x:96.5,y:14.3},{x:97,y:14.4},{x:97.5,y:14.5},{x:98,y:14.7},{x:98.5,y:14.8},{x:99,y:14.9},{x:99.5,y:15.1},{x:100,y:15.2},{x:100.5,y:15.4},{x:101,y:15.5},{x:101.5,y:15.7},{x:102,y:15.8},{x:102.5,y:16},{x:103,y:16.1},{x:103.5,y:16.3},{x:104,y:16.4},{x:104.5,y:16.6},{x:105,y:16.8},{x:105.5,y:16.9},{x:106,y:17.1},{x:106.5,y:17.3},{x:107,y:17.5},{x:107.5,y:17.7},{x:108,y:17.8},{x:108.5,y:18},{x:109,y:18.2},{x:109.5,y:18.4},{x:110,y:18.6}];

            var set4 = [{x:45,y:3.1},{x:45.5,y:3.2},{x:46,y:3.3},{x:46.5,y:3.4},{x:47,y:3.5},{x:47.5,y:3.6},{x:48,y:3.7},{x:48.5,y:3.8},{x:49,y:3.9},{x:49.5,y:4.1},{x:50,y:4.2},{x:50.5,y:4.3},{x:51,y:4.4},{x:51.5,y:4.6},{x:52,y:4.7},{x:52.5,y:4.9},{x:53,y:5},{x:53.5,y:5.2},{x:54,y:5.3},{x:54.5,y:5.5},{x:55,y:5.7},{x:55.5,y:5.8},{x:56,y:6},{x:56.5,y:6.2},{x:57,y:6.3},{x:57.5,y:6.5},{x:58,y:6.7},{x:58.5,y:6.8},{x:59,y:7},{x:59.5,y:7.2},{x:60,y:7.3},{x:60.5,y:7.5},{x:61,y:7.6},{x:61.5,y:7.8},{x:62,y:8},{x:62.5,y:8.1},{x:63,y:8.3},{x:63.5,y:8.4},{x:64,y:8.5},{x:64.5,y:8.7},{x:65,y:9},{x:65.5,y:9.2},{x:66,y:9.3},{x:66.5,y:9.4},{x:67,y:9.6},{x:67.5,y:9.7},{x:68,y:9.8},{x:68.5,y:10},{x:69,y:10.1},{x:69.5,y:10.2},{x:70,y:10.3},{x:70.5,y:10.5},{x:71,y:10.6},{x:71.5,y:10.7},{x:72,y:10.8},{x:72.5,y:11},{x:73,y:11.1},{x:73.5,y:11.2},{x:74,y:11.3},{x:74.5,y:11.4},{x:75,y:11.5},{x:75.5,y:11.7},{x:76,y:11.8},{x:76.5,y:11.9},{x:77,y:12},{x:77.5,y:12.1},{x:78,y:12.2},{x:78.5,y:12.3},{x:79,y:12.5},{x:79.5,y:12.6},{x:80,y:12.7},{x:80.5,y:12.8},{x:81,y:13},{x:81.5,y:13.1},{x:82,y:13.2},{x:82.5,y:13.4},{x:83,y:13.5},{x:83.5,y:13.7},{x:84,y:13.8},{x:84.5,y:14},{x:85,y:14.1},{x:85.5,y:14.3},{x:86,y:14.4},{x:86.5,y:14.6},{x:87,y:14.8},{x:87.5,y:14.9},{x:88,y:15.1},{x:88.5,y:15.2},{x:89,y:15.4},{x:89.5,y:15.5},{x:90,y:15.7},{x:90.5,y:15.9},{x:91,y:16},{x:91.5,y:16.2},{x:92,y:16.3},{x:92.5,y:16.5},{x:93,y:16.6},{x:93.5,y:16.8},{x:94,y:16.9},{x:94.5,y:17.1},{x:95,y:17.3},{x:95.5,y:17.4},{x:96,y:17.6},{x:96.5,y:17.8},{x:97,y:17.9},{x:97.5,y:18.1},{x:98,y:18.3},{x:98.5,y:18.4},{x:99,y:18.6},{x:99.5,y:18.8},{x:100,y:19},{x:100.5,y:19.2},{x:101,y:19.4},{x:101.5,y:19.5},{x:102,y:19.7},{x:102.5,y:19.9},{x:103,y:20.2},{x:103.5,y:20.4},{x:104,y:20.6},{x:104.5,y:20.8},{x:105,y:21},{x:105.5,y:21.2},{x:106,y:21.4},{x:106.5,y:21.7},{x:107,y:21.9},{x:107.5,y:22.1},{x:108,y:22.4},{x:108.5,y:22.6},{x:109,y:22.9},{x:109.5,y:23.1},{x:110,y:23.4}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightweightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([110,45]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([110,45]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,26.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,26.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(45, 111, 1)).tickFormat(function(d){
				return d%2==0? '' : d;
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(45, 111, 1)).tickFormat(function(d){
                return d%2==0? '' : d;
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 26.5, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 26.5, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " cm<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("WHO Boys Weight for Height/Length");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 50 )
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("Ref: IAP Growth Charts. Indian Academy of Pediatrics. [updated 2013 18 Oct, cited 2016 14 Jan] Available from: http://www.iapindia.org/page.php?id=79");

            svg.append("text")
                .attr("x", -190 )
                .attr("y", 855)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (kgs)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 170 )
                .style("text-anchor", "start")
                .text("1(-3)");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 160 )
                .style("text-anchor", "start")
                .text("3(-2)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 120 )
                .style("text-anchor", "start")
                .text("50(0)");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 50 )
                .style("text-anchor", "start")
                .text("99(+3)");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "yellow",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightweightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('weightForHeightLengthMale', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%; padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var heightweightData = [];

            if(vitalData.hwData) {
                for(var i = 0; i < vitalData.hwData.length; i++){
                    if(vitalData.hwData[i].x<111 && vitalData.hwData[i].x>44) {
                        if(vitalData.hwData[i].y<28 && vitalData.hwData[i].y>0) {
                            heightweightData.push(vitalData.hwData[i]);
                        }
                    }
                }
            }

            var set1 = [{x:45,y:2},{x:45.5,y:2.1},{x:46,y:2.1},{x:46.5,y:2.2},{x:47,y:2.3},{x:47.5,y:2.3},{x:48,y:2.4},{x:48.5,y:2.5},{x:49,y:2.6},{x:49.5,y:2.6},{x:50,y:2.7},{x:50.5,y:2.8},{x:51,y:2.9},{x:51.5,y:3},{x:52,y:3.1},{x:52.5,y:3.2},{x:53,y:3.3},{x:53.5,y:3.4},{x:54,y:3.5},{x:54.5,y:3.6},{x:55,y:3.7},{x:55.5,y:3.9},{x:56,y:4},{x:56.5,y:4.1},{x:57,y:4.2},{x:57.5,y:4.4},{x:58,y:4.5},{x:58.5,y:4.6},{x:59,y:4.7},{x:59.5,y:4.8},{x:60,y:5},{x:60.5,y:5.1},{x:61,y:5.2},{x:61.5,y:5.3},{x:62,y:5.4},{x:62.5,y:5.5},{x:63,y:5.6},{x:63.5,y:5.7},{x:64,y:5.8},{x:64.5,y:5.9},{x:65,y:6.2},{x:65.5,y:6.3},{x:66,y:6.4},{x:66.5,y:6.5},{x:67,y:6.6},{x:67.5,y:6.7},{x:68,y:6.8},{x:68.5,y:6.8},{x:69,y:6.9},{x:69.5,y:7},{x:70,y:7.1},{x:70.5,y:7.2},{x:71,y:7.3},{x:71.5,y:7.4},{x:72,y:7.5},{x:72.5,y:7.6},{x:73,y:7.7},{x:73.5,y:7.8},{x:74,y:7.8},{x:74.5,y:7.9},{x:75,y:8},{x:75.5,y:8.1},{x:76,y:8.2},{x:76.5,y:8.2},{x:77,y:8.3},{x:77.5,y:8.4},{x:78,y:8.5},{x:78.5,y:8.5},{x:79,y:8.6},{x:79.5,y:8.7},{x:80,y:8.8},{x:80.5,y:8.9},{x:81,y:8.9},{x:81.5,y:9},{x:82,y:9.1},{x:82.5,y:9.2},{x:83,y:9.3},{x:83.5,y:9.4},{x:84,y:9.5},{x:84.5,y:9.6},{x:85,y:9.7},{x:85.5,y:9.8},{x:86,y:9.9},{x:86.5,y:10},{x:87,y:10.1},{x:87.5,y:10.2},{x:88,y:10.3},{x:88.5,y:10.5},{x:89,y:10.6},{x:89.5,y:10.7},{x:90,y:10.8},{x:90.5,y:10.9},{x:91,y:11},{x:91.5,y:11},{x:92,y:11.1},{x:92.5,y:11.2},{x:93,y:11.3},{x:93.5,y:11.4},{x:94,y:11.5},{x:94.5,y:11.6},{x:95,y:11.7},{x:95.5,y:11.8},{x:96,y:11.9},{x:96.5,y:12},{x:97,y:12.1},{x:97.5,y:12.2},{x:98,y:12.3},{x:98.5,y:12.4},{x:99,y:12.5},{x:99.5,y:12.7},{x:100,y:12.8},{x:100.5,y:12.9},{x:101,y:13},{x:101.5,y:13.1},{x:102,y:13.2},{x:102.5,y:13.3},{x:103,y:13.4},{x:103.5,y:13.6},{x:104,y:13.7},{x:104.5,y:13.8},{x:105,y:13.9},{x:105.5,y:14},{x:106,y:14.2},{x:106.5,y:14.3},{x:107,y:14.4},{x:107.5,y:14.5},{x:108,y:14.7},{x:108.5,y:14.8},{x:109,y:14.9},{x:109.5,y:15.1},{x:110,y:15.2}];

            var set2 = [{x:45,y:2.1},{x:45.5,y:2.1},{x:46,y:2.2},{x:46.5,y:2.3},{x:47,y:2.4},{x:47.5,y:2.4},{x:48,y:2.5},{x:48.5,y:2.6},{x:49,y:2.7},{x:49.5,y:2.7},{x:50,y:2.8},{x:50.5,y:2.9},{x:51,y:3},{x:51.5,y:3.1},{x:52,y:3.2},{x:52.5,y:3.3},{x:53,y:3.4},{x:53.5,y:3.5},{x:54,y:3.6},{x:54.5,y:3.8},{x:55,y:3.9},{x:55.5,y:4},{x:56,y:4.1},{x:56.5,y:4.3},{x:57,y:4.4},{x:57.5,y:4.5},{x:58,y:4.6},{x:58.5,y:4.8},{x:59,y:4.9},{x:59.5,y:5},{x:60,y:5.1},{x:60.5,y:5.3},{x:61,y:5.4},{x:61.5,y:5.5},{x:62,y:5.6},{x:62.5,y:5.7},{x:63,y:5.8},{x:63.5,y:5.9},{x:64,y:6},{x:64.5,y:6.1},{x:65,y:6.4},{x:65.5,y:6.5},{x:66,y:6.6},{x:66.5,y:6.7},{x:67,y:6.8},{x:67.5,y:6.9},{x:68,y:7},{x:68.5,y:7.1},{x:69,y:7.2},{x:69.5,y:7.3},{x:70,y:7.4},{x:70.5,y:7.5},{x:71,y:7.6},{x:71.5,y:7.7},{x:72,y:7.8},{x:72.5,y:7.8},{x:73,y:7.9},{x:73.5,y:8},{x:74,y:8.1},{x:74.5,y:8.2},{x:75,y:8.3},{x:75.5,y:8.4},{x:76,y:8.5},{x:76.5,y:8.5},{x:77,y:8.6},{x:77.5,y:8.7},{x:78,y:8.8},{x:78.5,y:8.8},{x:79,y:8.9},{x:79.5,y:9},{x:80,y:9.1},{x:80.5,y:9.2},{x:81,y:9.3},{x:81.5,y:9.3},{x:82,y:9.4},{x:82.5,y:9.5},{x:83,y:9.6},{x:83.5,y:9.7},{x:84,y:9.8},{x:84.5,y:9.9},{x:85,y:10.1},{x:85.5,y:10.2},{x:86,y:10.3},{x:86.5,y:10.4},{x:87,y:10.5},{x:87.5,y:10.6},{x:88,y:10.7},{x:88.5,y:10.8},{x:89,y:10.9},{x:89.5,y:11},{x:90,y:11.1},{x:90.5,y:11.2},{x:91,y:11.3},{x:91.5,y:11.4},{x:92,y:11.5},{x:92.5,y:11.6},{x:93,y:11.7},{x:93.5,y:11.8},{x:94,y:11.9},{x:94.5,y:12},{x:95,y:12.1},{x:95.5,y:12.2},{x:96,y:12.3},{x:96.5,y:12.4},{x:97,y:12.5},{x:97.5,y:12.7},{x:98,y:12.8},{x:98.5,y:12.9},{x:99,y:13},{x:99.5,y:13.1},{x:100,y:13.2},{x:100.5,y:13.3},{x:101,y:13.4},{x:101.5,y:13.6},{x:102,y:13.7},{x:102.5,y:13.8},{x:103,y:13.9},{x:103.5,y:14},{x:104,y:14.2},{x:104.5,y:14.3},{x:105,y:14.4},{x:105.5,y:14.5},{x:106,y:14.7},{x:106.5,y:14.8},{x:107,y:14.9},{x:107.5,y:15.1},{x:108,y:15.2},{x:108.5,y:15.3},{x:109,y:15.5},{x:109.5,y:15.6},{x:110,y:15.8}];

            var set3 = [{x:45,y:2.4},{x:45.5,y:2.5},{x:46,y:2.6},{x:46.5,y:2.7},{x:47,y:2.8},{x:47.5,y:2.9},{x:48,y:2.9},{x:48.5,y:3},{x:49,y:3.1},{x:49.5,y:3.2},{x:50,y:3.3},{x:50.5,y:3.4},{x:51,y:3.5},{x:51.5,y:3.6},{x:52,y:3.8},{x:52.5,y:3.9},{x:53,y:4},{x:53.5,y:4.1},{x:54,y:4.3},{x:54.5,y:4.4},{x:55,y:4.5},{x:55.5,y:4.7},{x:56,y:4.8},{x:56.5,y:5},{x:57,y:5.1},{x:57.5,y:5.3},{x:58,y:5.4},{x:58.5,y:5.6},{x:59,y:5.7},{x:59.5,y:5.9},{x:60,y:6},{x:60.5,y:6.1},{x:61,y:6.3},{x:61.5,y:6.4},{x:62,y:6.5},{x:62.5,y:6.7},{x:63,y:6.8},{x:63.5,y:6.9},{x:64,y:7},{x:64.5,y:7.1},{x:65,y:7.4},{x:65.5,y:7.6},{x:66,y:7.7},{x:66.5,y:7.8},{x:67,y:7.9},{x:67.5,y:8},{x:68,y:8.1},{x:68.5,y:8.2},{x:69,y:8.4},{x:69.5,y:8.5},{x:70,y:8.6},{x:70.5,y:8.7},{x:71,y:8.8},{x:71.5,y:8.9},{x:72,y:9},{x:72.5,y:9.1},{x:73,y:9.2},{x:73.5,y:9.3},{x:74,y:9.4},{x:74.5,y:9.5},{x:75,y:9.6},{x:75.5,y:9.7},{x:76,y:9.8},{x:76.5,y:9.9},{x:77,y:10},{x:77.5,y:10.1},{x:78,y:10.2},{x:78.5,y:10.3},{x:79,y:10.4},{x:79.5,y:10.5},{x:80,y:10.6},{x:80.5,y:10.7},{x:81,y:10.8},{x:81.5,y:10.9},{x:82,y:11},{x:82.5,y:11.1},{x:83,y:11.2},{x:83.5,y:11.3},{x:84,y:11.4},{x:84.5,y:11.5},{x:85,y:11.7},{x:85.5,y:11.8},{x:86,y:11.9},{x:86.5,y:12},{x:87,y:12.2},{x:87.5,y:12.3},{x:88,y:12.4},{x:88.5,y:12.5},{x:89,y:12.6},{x:89.5,y:12.8},{x:90,y:12.9},{x:90.5,y:13},{x:91,y:13.1},{x:91.5,y:13.2},{x:92,y:13.4},{x:92.5,y:13.5},{x:93,y:13.6},{x:93.5,y:13.7},{x:94,y:13.8},{x:94.5,y:13.9},{x:95,y:14.1},{x:95.5,y:14.2},{x:96,y:14.3},{x:96.5,y:14.4},{x:97,y:14.6},{x:97.5,y:14.7},{x:98,y:14.8},{x:98.5,y:14.9},{x:99,y:15.1},{x:99.5,y:15.2},{x:100,y:15.4},{x:100.5,y:15.5},{x:101,y:15.6},{x:101.5,y:15.8},{x:102,y:15.9},{x:102.5,y:16.1},{x:103,y:16.2},{x:103.5,y:16.4},{x:104,y:16.5},{x:104.5,y:16.7},{x:105,y:16.8},{x:105.5,y:17},{x:106,y:17.2},{x:106.5,y:17.3},{x:107,y:17.5},{x:107.5,y:17.7},{x:108,y:17.8},{x:108.5,y:18},{x:109,y:18.2},{x:109.5,y:18.3},{x:110,y:18.5}];

            var set4 = [{x:45,y:3},{x:45.5,y:3.1},{x:46,y:3.3},{x:46.5,y:3.4},{x:47,y:3.5},{x:47.5,y:3.6},{x:48,y:3.7},{x:48.5,y:3.8},{x:49,y:3.9},{x:49.5,y:4},{x:50,y:4.1},{x:50.5,y:4.2},{x:51,y:4.4},{x:51.5,y:4.5},{x:52,y:4.6},{x:52.5,y:4.8},{x:53,y:4.9},{x:53.5,y:5.1},{x:54,y:5.3},{x:54.5,y:5.4},{x:55,y:5.6},{x:55.5,y:5.8},{x:56,y:5.9},{x:56.5,y:6.1},{x:57,y:6.3},{x:57.5,y:6.5},{x:58,y:6.6},{x:58.5,y:6.8},{x:59,y:7},{x:59.5,y:7.2},{x:60,y:7.3},{x:60.5,y:7.5},{x:61,y:7.7},{x:61.5,y:7.8},{x:62,y:8},{x:62.5,y:8.1},{x:63,y:8.3},{x:63.5,y:8.4},{x:64,y:8.6},{x:64.5,y:8.7},{x:65,y:9.1},{x:65.5,y:9.2},{x:66,y:9.3},{x:66.5,y:9.5},{x:67,y:9.6},{x:67.5,y:9.8},{x:68,y:9.9},{x:68.5,y:10},{x:69,y:10.2},{x:69.5,y:10.3},{x:70,y:10.5},{x:70.5,y:10.6},{x:71,y:10.7},{x:71.5,y:10.9},{x:72,y:11},{x:72.5,y:11.1},{x:73,y:11.3},{x:73.5,y:11.4},{x:74,y:11.5},{x:74.5,y:11.7},{x:75,y:11.8},{x:75.5,y:11.9},{x:76,y:12},{x:76.5,y:12.1},{x:77,y:12.3},{x:77.5,y:12.4},{x:78,y:12.5},{x:78.5,y:12.6},{x:79,y:12.7},{x:79.5,y:12.8},{x:80,y:12.9},{x:80.5,y:13},{x:81,y:13.1},{x:81.5,y:13.3},{x:82,y:13.4},{x:82.5,y:13.5},{x:83,y:13.6},{x:83.5,y:13.8},{x:84,y:13.9},{x:84.5,y:14.1},{x:85,y:14.2},{x:85.5,y:14.3},{x:86,y:14.5},{x:86.5,y:14.6},{x:87,y:14.8},{x:87.5,y:14.9},{x:88,y:15.1},{x:88.5,y:15.2},{x:89,y:15.4},{x:89.5,y:15.5},{x:90,y:15.6},{x:90.5,y:15.8},{x:91,y:15.9},{x:91.5,y:16.1},{x:92,y:16.2},{x:92.5,y:16.3},{x:93,y:16.5},{x:93.5,y:16.6},{x:94,y:16.8},{x:94.5,y:16.9},{x:95,y:17.1},{x:95.5,y:17.2},{x:96,y:17.4},{x:96.5,y:17.5},{x:97,y:17.7},{x:97.5,y:17.9},{x:98,y:18},{x:98.5,y:18.2},{x:99,y:18.4},{x:99.5,y:18.5},{x:100,y:18.7},{x:100.5,y:18.9},{x:101,y:19.1},{x:101.5,y:19.3},{x:102,y:19.5},{x:102.5,y:19.7},{x:103,y:19.9},{x:103.5,y:20.1},{x:104,y:20.3},{x:104.5,y:20.5},{x:105,y:20.7},{x:105.5,y:20.9},{x:106,y:21.1},{x:106.5,y:21.3},{x:107,y:21.5},{x:107.5,y:21.7},{x:108,y:22},{x:108.5,y:22.2},{x:109,y:22.4},{x:109.5,y:22.7},{x:110,y:22.9}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightweightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([110,45]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([110,45]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,26.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,26.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(45, 111, 1)).tickFormat(function(d){
				return d%2==0? '' : d;
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(45, 111, 1)).tickFormat(function(d){
                return d%2==0? '' : d;
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 26.5, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 26.5, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + " cm<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("WHO Boys Weight for Height/Length");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Length (cm)");

                svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 50 )
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("Ref: IAP Growth Charts. Indian Academy of Pediatrics. [updated 2013 18 Oct, cited 2016 14 Jan] Available from: http://www.iapindia.org/page.php?id=79");

            svg.append("text")
                .attr("x", -190 )
                .attr("y", 855)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (kgs)");
            
                svg.append("text")
                .attr("x", 770 )
                .attr("y", 170 )
                .style("text-anchor", "start")
                .text("1(-3)");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 160 )
                .style("text-anchor", "start")
                .text("3(-2)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 120 )
                .style("text-anchor", "start")
                .text("50(0)");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 50 )
                .style("text-anchor", "start")
                .text("99(+3)");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightweightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('wlhcFemale', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 440 - margin.top - margin.bottom;
              var width = 960 - margin.left - margin.right;
  
              var heightData = [];
  
              if(vitalData.height) {
                  for(var i = 0; i < vitalData.height.length; i++){
                      if(vitalData.height[i].x<61) {
                          heightData.push(vitalData.height[i]);
                      }
                  }
              }

            var weightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x<61) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var headData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.hc.length; i++){
                    if(vitalData.hc[i].x<61) {
                        headData.push(vitalData.hc[i]);
                    }
                }
            }
  
            //   Start of Weight data
              var set1 = [{x:0,y:2.3},{x:1,y:3},{x:2,y:3.8},{x:3,y:4.4},{x:4,y:4.8},{x:5,y:5.2},{x:6,y:5.5},{x:7,y:5.8},
                            {x:8,y:6},{x:9,y:6.2},{x:10,y:6.4},{x:11,y:6.6},{x:12,y:6.8},{x:13,y:6.9},{x:14,y:7.1},{x:15,y:7.3},
                            {x:16,y:7.4},{x:17,y:7.6},{x:18,y:7.8},{x:19,y:7.9},{x:20,y:8.1},{x:21,y:8.2},{x:22,y:8.4},
                            {x:23,y:8.5},{x:24,y:8.7},{x:25,y:8.9},{x:26,y:9},{x:27,y:9.2},{x:28,y:9.3},{x:29,y:9.5},{x:30,y:9.6},
                            {x:31,y:9.7},{x:32,y:9.9},{x:33,y:10},{x:34,y:10.1},{x:35,y:10.3},{x:36,y:10.4},{x:37,y:10.5},
                            {x:38,y:10.6},{x:39,y:10.8},{x:40,y:10.9},{x:41,y:11},{x:42,y:11.1},{x:43,y:11.3},{x:44,y:11.4},
                            {x:45,y:11.5},{x:46,y:11.6},{x:47,y:11.7},{x:48,y:11.8},{x:49,y:11.9},{x:50,y:12.1},{x:51,y:12.2},
                            {x:52,y:12.3},{x:53,y:12.4},{x:54,y:12.5},{x:55,y:12.6},{x:56,y:12.7},{x:57,y:12.8},{x:58,y:12.9},
                            {x:59,y:13.1},{x:60,y:13.2}];
  
              var set2 = [{x:0,y:2.5},{x:1,y:3.3},{x:2,y:4.1},{x:3,y:4.7},{x:4,y:5.2},{x:5,y:5.6},{x:6,y:6},{x:7,y:6.3},{x:8,y:6.5},
                            {x:9,y:6.8},{x:10,y:7},{x:11,y:7.2},{x:12,y:7.3},{x:13,y:7.5},{x:14,y:7.7},{x:15,y:7.9},{x:16,y:8.1},
                            {x:17,y:8.2},{x:18,y:8.4},{x:19,y:8.6},{x:20,y:8.7},{x:21,y:8.9},{x:22,y:9.1},{x:23,y:9.2},{x:24,y:9.4},
                            {x:25,y:9.6},{x:26,y:9.8},{x:27,y:9.9},{x:28,y:10.1},{x:29,y:10.2},{x:30,y:10.4},{x:31,y:10.5},{x:32,y:10.7},
                            {x:33,y:10.8},{x:34,y:11},{x:35,y:11.1},{x:36,y:11.3},{x:37,y:11.4},{x:38,y:11.6},{x:39,y:11.7},{x:40,y:11.8},
                            {x:41,y:12},{x:42,y:12.1},{x:43,y:12.2},{x:44,y:12.4},{x:45,y:12.5},{x:46,y:12.6},{x:47,y:12.8},{x:48,y:12.9},
                            {x:49,y:13},{x:50,y:13.2},{x:51,y:13.3},{x:52,y:13.4},{x:53,y:13.5},{x:54,y:13.7},{x:55,y:13.8},{x:56,y:13.9},
                            {x:57,y:14},{x:58,y:14.2},{x:59,y:14.3},{x:60,y:14.4}];
  
              var set3 = [{x:0,y:3.2},{x:1,y:4.2},{x:2,y:5.1},{x:3,y:5.8},{x:4,y:6.4},{x:5,y:6.9},{x:6,y:7.3},{x:7,y:7.6},{x:8,y:7.9},
                            {x:9,y:8.2},{x:10,y:8.5},{x:11,y:8.7},{x:12,y:8.9},{x:13,y:9.2},{x:14,y:9.4},{x:15,y:9.6},{x:16,y:9.8},
                            {x:17,y:10},{x:18,y:10.2},{x:19,y:10.4},{x:20,y:10.6},{x:21,y:10.9},{x:22,y:11.1},{x:23,y:11.3},{x:24,y:11.5},
                            {x:25,y:11.7},{x:26,y:11.9},{x:27,y:12.1},{x:28,y:12.3},{x:29,y:12.5},{x:30,y:12.7},{x:31,y:12.9},{x:32,y:13.1},
                            {x:33,y:13.3},{x:34,y:13.5},{x:35,y:13.7},{x:36,y:13.9},{x:37,y:14},{x:38,y:14.2},{x:39,y:14.4},{x:40,y:14.6},
                            {x:41,y:14.8},{x:42,y:15},{x:43,y:15.2},{x:44,y:15.3},{x:45,y:15.5},{x:46,y:15.7},{x:47,y:15.9},{x:48,y:16.1},
                            {x:49,y:16.3},{x:50,y:16.4},{x:51,y:16.6},{x:52,y:16.8},{x:53,y:17},{x:54,y:17.2},{x:55,y:17.3},{x:56,y:17.5},
                            {x:57,y:17.7},{x:58,y:17.9},{x:59,y:18},{x:60,y:18.2}];
  
              var set4 = [{x:0,y:4.2},{x:1,y:5.4},{x:2,y:6.5},{x:3,y:7.4},{x:4,y:8.1},{x:5,y:8.7},{x:6,y:9.2},{x:7,y:9.6},{x:8,y:10},
                            {x:9,y:10.4},{x:10,y:10.7},{x:11,y:11},{x:12,y:11.3},{x:13,y:11.6},{x:14,y:11.9},{x:15,y:12.2},{x:16,y:12.5},
                            {x:17,y:12.7},{x:18,y:13},{x:19,y:13.3},{x:20,y:13.5},{x:21,y:13.8},{x:22,y:14.1},{x:23,y:14.3},{x:24,y:14.6},
                            {x:25,y:14.9},{x:26,y:15.2},{x:27,y:15.4},{x:28,y:15.7},{x:29,y:16},{x:30,y:16.2},{x:31,y:16.5},{x:32,y:16.8},
                            {x:33,y:17},{x:34,y:17.3},{x:35,y:17.6},{x:36,y:17.8},{x:37,y:18.1},{x:38,y:18.4},{x:39,y:18.6},{x:40,y:18.9},
                            {x:41,y:19.2},{x:42,y:19.5},{x:43,y:19.7},{x:44,y:20},{x:45,y:20.3},{x:46,y:20.6},{x:47,y:20.8},{x:48,y:21.1},
                            {x:49,y:21.4},{x:50,y:21.7},{x:51,y:22},{x:52,y:22.2},{x:53,y:22.5},{x:54,y:22.8},{x:55,y:23.1},{x:56,y:23.3},
                            {x:57,y:23.6},{x:58,y:23.9},{x:59,y:24.2},{x:60,y:24.4}];
            // End of Weight data

            // Start of Head Circumference data
              var set5 = [{x:0,y:31.7},{x:1,y:34.3},{x:2,y:36},{x:3,y:37.2},{x:4,y:38.2},{x:5,y:39},{x:6,y:39.7},{x:7,y:40.4},
                            {x:8,y:40.9},{x:9,y:41.3},{x:10,y:41.7},{x:11,y:42},{x:12,y:42.3},{x:13,y:42.6},{x:14,y:42.9},
                            {x:15,y:43.1},{x:16,y:43.3},{x:17,y:43.5},{x:18,y:43.6},{x:19,y:43.8},{x:20,y:44},{x:21,y:44.1},
                            {x:22,y:44.3},{x:23,y:44.4},{x:24,y:44.6},{x:25,y:44.7},{x:26,y:44.8},{x:27,y:44.9},{x:28,y:45.1},
                            {x:29,y:45.2},{x:30,y:45.3},{x:31,y:45.4},{x:32,y:45.5},{x:33,y:45.6},{x:34,y:45.7},{x:35,y:45.8},
                            {x:36,y:45.9},{x:37,y:45.9},{x:38,y:46},{x:39,y:46.1},{x:40,y:46.2},{x:41,y:46.2},{x:42,y:46.3},
                            {x:43,y:46.4},{x:44,y:46.4},{x:45,y:46.5},{x:46,y:46.5},{x:47,y:46.6},{x:48,y:46.7},{x:49,y:46.7},
                            {x:50,y:46.8},{x:51,y:46.8},{x:52,y:46.9},{x:53,y:46.9},{x:54,y:47},{x:55,y:47},{x:56,y:47.1},
                            {x:57,y:47.1},{x:58,y:47.2},{x:59,y:47.2},{x:60,y:47.2}];
  
              var set6 = [{x:0,y:33.9},{x:1,y:36.5},{x:2,y:38.3},{x:3,y:39.5},{x:4,y:40.6},{x:5,y:41.5},{x:6,y:42.2},{x:7,y:42.8},
                            {x:8,y:43.4},{x:9,y:43.8},{x:10,y:44.2},{x:11,y:44.6},{x:12,y:44.9},{x:13,y:45.2},{x:14,y:45.4},{x:15,y:45.7},
                            {x:16,y:45.9},{x:17,y:46.1},{x:18,y:46.2},{x:19,y:46.4},{x:20,y:46.6},{x:21,y:46.7},{x:22,y:46.9},{x:23,y:47},
                            {x:24,y:47.2},{x:25,y:47.3},{x:26,y:47.5},{x:27,y:47.6},{x:28,y:47.7},{x:29,y:47.8},{x:30,y:47.9},{x:31,y:48},
                            {x:32,y:48.1},{x:33,y:48.2},{x:34,y:48.3},{x:35,y:48.4},{x:36,y:48.5},{x:37,y:48.6},{x:38,y:48.7},{x:39,y:48.7},
                            {x:40,y:48.8},{x:41,y:48.9},{x:42,y:49},{x:43,y:49},{x:44,y:49.1},{x:45,y:49.2},{x:46,y:49.2},{x:47,y:49.3},
                            {x:48,y:49.3},{x:49,y:49.4},{x:50,y:49.4},{x:51,y:49.5},{x:52,y:49.5},{x:53,y:49.6},{x:54,y:49.6},{x:55,y:49.7},
                            {x:56,y:49.7},{x:57,y:49.8},{x:58,y:49.8},{x:59,y:49.9},{x:60,y:49.9}];
  
              var set7 = [{x:0,y:36.1},{x:1,y:38.8},{x:2,y:40.5},{x:3,y:41.9},{x:4,y:43},{x:5,y:43.9},{x:6,y:44.6},{x:7,y:45.3},
                            {x:8,y:45.9},{x:9,y:46.3},{x:10,y:46.8},{x:11,y:47.1},{x:12,y:47.5},{x:13,y:47.7},{x:14,y:48},{x:15,y:48.2},
                            {x:16,y:48.5},{x:17,y:48.7},{x:18,y:48.8},{x:19,y:49},{x:20,y:49.2},{x:21,y:49.4},{x:22,y:49.5},{x:23,y:49.7},
                            {x:24,y:49.8},{x:25,y:49.9},{x:26,y:50.1},{x:27,y:50.2},{x:28,y:50.3},{x:29,y:50.5},{x:30,y:50.6},{x:31,y:50.7},
                            {x:32,y:50.8},{x:33,y:50.9},{x:34,y:51},{x:35,y:51.1},{x:36,y:51.2},{x:37,y:51.3},{x:38,y:51.3},{x:39,y:51.4},
                            {x:40,y:51.5},{x:41,y:51.6},{x:42,y:51.6},{x:43,y:51.7},{x:44,y:51.8},{x:45,y:51.8},{x:46,y:51.9},{x:47,y:51.9},
                            {x:48,y:52},{x:49,y:52.1},{x:50,y:52.1},{x:51,y:52.2},{x:52,y:52.2},{x:53,y:52.3},{x:54,y:52.3},{x:55,y:52.4},
                            {x:56,y:52.4},{x:57,y:52.5},{x:58,y:52.5},{x:59,y:52.6},{x:60,y:52.6}];
            // End of Head Circumference data
              
            // Start of Height/Lenght data
              var set8 = [{x:0,y:44.8},{x:1,y:49.1},{x:2,y:52.3},{x:3,y:54.9},{x:4,y:57.1},{x:5,y:58.9},{x:6,y:60.5},{x:7,y:61.9},
                            {x:8,y:63.2},{x:9,y:64.5},{x:10,y:65.7},{x:11,y:66.9},{x:12,y:68},{x:13,y:69.1},{x:14,y:70.1},{x:15,y:71.1},
                            {x:16,y:72.1},{x:17,y:73},{x:18,y:74},{x:19,y:74.8},{x:20,y:75.7},{x:21,y:76.5},{x:22,y:77.3},{x:23,y:78.1},
                            {x:24,y:78.9},{x:25,y:79},{x:26,y:79.7},{x:27,y:80.4},{x:28,y:81.1},{x:29,y:81.8},{x:30,y:82.5},{x:31,y:83.1},
                            {x:32,y:83.8},{x:33,y:84.4},{x:34,y:85},{x:35,y:85.6},{x:36,y:86.2},{x:37,y:86.8},{x:38,y:87.4},{x:39,y:87.9},
                            {x:40,y:88.5},{x:41,y:89},{x:42,y:89.6},{x:43,y:90.1},{x:44,y:90.7},{x:45,y:91.2},{x:46,y:91.7},{x:47,y:92.2},
                            {x:48,y:92.7},{x:49,y:93.2},{x:50,y:93.7},{x:51,y:94.2},{x:52,y:94.7},{x:53,y:95.2},{x:54,y:95.6},{x:55,y:96.1},
                            {x:56,y:96.6},{x:57,y:97},{x:58,y:97.5},{x:59,y:97.9},{x:60,y:98.4}];
              
              var set9 = [{x:0,y:45.6},{x:1,y:50},{x:2,y:53.2},{x:3,y:55.8},{x:4,y:58},{x:5,y:59.9},{x:6,y:61.5},{x:7,y:62.9},{x:8,y:64.3},
                            {x:9,y:65.6},{x:10,y:66.8},{x:11,y:68},{x:12,y:69.2},{x:13,y:70.3},{x:14,y:71.3},{x:15,y:72.4},{x:16,y:73.3},
                            {x:17,y:74.3},{x:18,y:75.2},{x:19,y:76.2},{x:20,y:77},{x:21,y:77.9},{x:22,y:78.7},{x:23,y:79.6},{x:24,y:80.3},
                            {x:25,y:80.4},{x:26,y:81.2},{x:27,y:81.9},{x:28,y:82.6},{x:29,y:83.4},{x:30,y:84},{x:31,y:84.7},{x:32,y:85.4},
                            {x:33,y:86},{x:34,y:86.7},{x:35,y:87.3},{x:36,y:87.9},{x:37,y:88.5},{x:38,y:89.1},{x:39,y:89.7},{x:40,y:90.3},
                            {x:41,y:90.8},{x:42,y:91.4},{x:43,y:92},{x:44,y:92.5},{x:45,y:93},{x:46,y:93.6},{x:47,y:94.1},{x:48,y:94.6},
                            {x:49,y:95.1},{x:50,y:95.7},{x:51,y:96.2},{x:52,y:96.7},{x:53,y:97.2},{x:54,y:97.6},{x:55,y:98.1},{x:56,y:98.6},
                            {x:57,y:99.1},{x:58,y:99.6},{x:59,y:100},{x:60,y:100.5}];
  
              var set10 = [{x:0,y:49.1},{x:1,y:53.7},{x:2,y:57.1},{x:3,y:59.8},{x:4,y:62.1},{x:5,y:64},{x:6,y:65.7},{x:7,y:67.3},{x:8,y:68.7},
                            {x:9,y:70.1},{x:10,y:71.5},{x:11,y:72.8},{x:12,y:74},{x:13,y:75.2},{x:14,y:76.4},{x:15,y:77.5},{x:16,y:78.6},
                            {x:17,y:79.7},{x:18,y:80.7},{x:19,y:81.7},{x:20,y:82.7},{x:21,y:83.7},{x:22,y:84.6},{x:23,y:85.5},{x:24,y:86.4},
                            {x:25,y:86.6},{x:26,y:87.4},{x:27,y:88.3},{x:28,y:89.1},{x:29,y:89.9},{x:30,y:90.7},{x:31,y:91.4},{x:32,y:92.2},
                            {x:33,y:92.9},{x:34,y:93.6},{x:35,y:94.4},{x:36,y:95.1},{x:37,y:95.7},{x:38,y:96.4},{x:39,y:97.1},{x:40,y:97.7},
                            {x:41,y:98.4},{x:42,y:99},{x:43,y:99.7},{x:44,y:100.3},{x:45,y:100.9},{x:46,y:101.5},{x:47,y:102.1},
                            {x:48,y:102.7},{x:49,y:103.3},{x:50,y:103.9},{x:51,y:104.5},{x:52,y:105},{x:53,y:105.6},{x:54,y:106.2},
                            {x:55,y:106.7},{x:56,y:107.3},{x:57,y:107.8},{x:58,y:108.4},{x:59,y:108.9},{x:60,y:109.4}];
              
              var set11 = [{x:0,y:52.7},{x:1,y:57.4},{x:2,y:60.9},{x:3,y:63.8},{x:4,y:66.2},{x:5,y:68.2},{x:6,y:70},{x:7,y:71.6},{x:8,y:73.2},
                            {x:9,y:74.7},{x:10,y:76.1},{x:11,y:77.5},{x:12,y:78.9},{x:13,y:80.2},{x:14,y:81.4},{x:15,y:82.7},{x:16,y:83.9},
                            {x:17,y:85},{x:18,y:86.2},{x:19,y:87.3},{x:20,y:88.4},{x:21,y:89.4},{x:22,y:90.5},{x:23,y:91.5},{x:24,y:92.5},
                            {x:25,y:92.8},{x:26,y:93.7},{x:27,y:94.6},{x:28,y:95.6},{x:29,y:96.4},{x:30,y:97.3},{x:31,y:98.2},{x:32,y:99},
                            {x:33,y:99.8},{x:34,y:100.6},{x:35,y:101.4},{x:36,y:102.2},{x:37,y:103},{x:38,y:103.7},{x:39,y:104.5},
                            {x:40,y:105.2},{x:41,y:106},{x:42,y:106.7},{x:43,y:107.4},{x:44,y:108.1},{x:45,y:108.8},{x:46,y:109.5},
                            {x:47,y:110.2},{x:48,y:110.8},{x:49,y:111.5},{x:50,y:112.1},{x:51,y:112.8},{x:52,y:113.4},{x:53,y:114.1},
                            {x:54,y:114.7},{x:55,y:115.3},{x:56,y:116},{x:57,y:116.6},{x:58,y:117.2},{x:59,y:117.8},{x:60,y:118.4}];
                // End of Height/Lenght data
              
              var rawSvg = element.find("svg")[0];
              var svg = d3.select(rawSvg)
                          .attr("width",width + margin.left + margin.right)
                          .attr("height",height + margin.top + margin.bottom);
              var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
              var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            
              var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
              var gEnter2 = wrap2.enter().append('g').attr('class', 'd3line').append('g');
  
              var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([headData]);
              var gEnter3 = wrap3.enter().append('g').attr('class', 'd3line').append('g');
  
              var div = d3.select("body").append("div")	
                          .attr("class", "tooltip")				
                          .style("opacity", 0);
  
              var lineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("bundle")
                              .tension(.7);
  
              var datalineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("linear");
  
              var g = svg.append("g")
                          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
              
              var xScale0 = d3.scale.linear().domain([60.5,0]).range([width,0]);
              var xScale1 = d3.scale.linear().domain([60.5,0]).range([width,0]);
  
              var yScale0 = d3.scale.linear().domain([0,131]).range([height, 0]);
              var yScale1 = d3.scale.linear().domain([0,131]).range([height, 0]);
  
              var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(0, 60.5, 1)).tickFormat(function(d){
                  return d%2==0? d : '';
              }).innerTickSize(-height)
                              .outerTickSize(0);
              var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(0, 60.5, 1)).tickFormat(function(d){
                  return d%2==0? d : '';
              });
              var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 131, 5)).tickFormat(function(d){
                  return d%5==0? d : '';
              }).innerTickSize(-width)
                              .outerTickSize(0);
              var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 131, 5)).tickFormat(function(d){
                  return d%5==0? d : '';
              }).innerTickSize(50)
                              .outerTickSize(50).tickPadding(10);
              
              var age = function(data) {
                  if(data <= 24){
                      return data.toString().split('.')[0]+ " months";
                  }
                  if(data <=60) {
                      var mon = data/12;
                      var result = mon.toFixed(1).split('.');
                      var mod = data%12;
                      var res = mod.toString().split('.');
                      return result[0].toString()+ " years " + res[0] + " months";
                  }
              };
  
              // plot user data points
              var heightpoint = wrap.selectAll('circle')
                  .data(function (d) { return d; })
                  .enter().append('circle')
                  .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                  .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                  .attr('r', 5)
                  .attr('fill','red')
                  .on("mouseover", function(d) {		
                      div.transition()		
                          .duration(200)		
                          .style("opacity", .9);		
                      div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                          .style("left", (d3.event.pageX) + "px")		
                          .style("top", (d3.event.pageY - 28) + "px");	
                      })					
                  .on("mouseout", function(d) {		
                      div.transition()		
                          .duration(500)		
                          .style("opacity", 0);	
                  });

            var weightpoint = wrap2.selectAll('circle')
                  .data(function (d) { return d; })
                  .enter().append('circle')
                  .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                  .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                  .attr('r', 5)
                  .attr('fill','red')
                  .on("mouseover", function(d) {		
                      div.transition()		
                          .duration(200)		
                          .style("opacity", .9);		
                      div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" kg")	
                          .style("left", (d3.event.pageX) + "px")		
                          .style("top", (d3.event.pageY - 28) + "px");	
                      })					
                  .on("mouseout", function(d) {		
                      div.transition()		
                          .duration(500)		
                          .style("opacity", 0);	
                  });
  
            var headpoint = wrap3.selectAll('circle')
                  .data(function (d) { return d; })
                  .enter().append('circle')
                  .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                  .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                  .attr('r', 5)
                  .attr('fill','red')
                  .on("mouseover", function(d) {		
                      div.transition()		
                          .duration(200)		
                          .style("opacity", .9);		
                      div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                          .style("left", (d3.event.pageX) + "px")		
                          .style("top", (d3.event.pageY - 28) + "px");	
                      })					
                  .on("mouseout", function(d) {		
                      div.transition()		
                          .duration(500)		
                          .style("opacity", 0);	
                  });
  
              // x-axis
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxisBottom);
              
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0,0)")
                  .call(xAxisTop);
              
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", -30 )
                  .style("text-anchor", "middle")
                  .text("WHO Girls Height, Weight, Head Charts 0-5 years");
              
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height + 35)
                  .style("text-anchor", "middle")
                  .text("Age in Months");
  
                  svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height + 50 )
                  .style("text-anchor", "middle")
                  .style("font-size","10px")
                  .text("Ref: IAP Growth Charts. Indian Academy of Pediatrics. [updated 2013 18 Oct, cited 2016 14 Jan] Available from: http://www.iapindia.org/page.php?id=79");
              
              svg.append("text")
                  .attr("x", -200 )
                  .attr("y", -35)
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .style("font-size","12px")
                  .text("WHO MGRS 2006 Charts; Acta Paediatrics Suppl. 450:2006");
              
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 350 )
                    .style("text-anchor", "start")
                    .text("1 (-3)");
                
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 340 )
                    .style("text-anchor", "start")
                    .text("3 (-2)");
    
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 330 )
                    .style("text-anchor", "start")
                    .text("50 (0)");
                
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 310 )
                    .style("text-anchor", "start")
                    .text("97 (+2)");
                
                svg.append("text")
                    .attr("x", 650 )
                    .attr("y", 300 )
                    .style("text-anchor", "start")
                    .text("Weight");
                
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 250 )
                    .style("text-anchor", "start")
                    .text("3 (-2)");
    
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 238 )
                    .style("text-anchor", "start")
                    .text("50 (0)");
                
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 228 )
                    .style("text-anchor", "start")
                    .text("97 (+2)");

                svg.append("text")
                    .attr("x", 650 )
                    .attr("y", 220 )
                    .style("text-anchor", "start")
                    .text("Head");

                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 100 )
                    .style("text-anchor", "start")
                    .text("1 (-3)");
                
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 90 )
                    .style("text-anchor", "start")
                    .text("3 (-2)");
    
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 60 )
                    .style("text-anchor", "start")
                    .text("50 (0)");
                
                svg.append("text")
                    .attr("x", 770 )
                    .attr("y", 40 )
                    .style("text-anchor", "start")
                    .text("97 (+2)");
                
                svg.append("text")
                    .attr("x", 600 )
                    .attr("y", 40 )
                    .style("text-anchor", "start")
                    .text("Height/Lenght");
                  
              // y-axis
              svg.append("g")
                  .attr("class", "y axis")
                  .call(yAxisLeft);	
  
              svg.append("g")				
                  .attr("class", "y axis")	
                  .attr("transform", "translate(" + width + " ,0)")		
                  .call(yAxisRight);
              
              // path lines
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set1),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set2),
                      "stroke": "yellow",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set3),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set4),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set5),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set6),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set7),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set8),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set9),
                      "stroke": "yellow",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set10),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });

                svg.append("svg:path")
                    .attr({
                      d: lineFunc(set11),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              
              // user data
              svg.append("svg:path")
                    .attr({
                      d: datalineFunc(heightData),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(headData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
          }
      };
  });
'use strict';
angular.module('AngularApp').directive('wlhcMale', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 440'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 440 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var heightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x<61) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            var weightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x<61) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var headData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.hc.length; i++){
                    if(vitalData.hc[i].x<61) {
                        headData.push(vitalData.hc[i]);
                    }
                }
            }

            // Start of Weight data
            var set1 = [{x:0,y:2.3},{x:1,y:3.2},{x:2,y:4.1},{x:3,y:4.8},{x:4,y:5.4},{x:5,y:5.8},{x:6,y:6.1},{x:7,y:6.4},{x:8,y:6.7},
                        {x:9,y:6.9},{x:10,y:7.1},{x:11,y:7.3},{x:12,y:7.5},{x:13,y:7.6},{x:14,y:7.8},{x:15,y:8},{x:16,y:8.1},
                        {x:17,y:8.3},{x:18,y:8.4},{x:19,y:8.6},{x:20,y:8.7},{x:21,y:8.9},{x:22,y:9},{x:23,y:9.2},{x:24,y:9.3},
                        {x:25,y:9.5},{x:26,y:9.6},{x:27,y:9.7},{x:28,y:9.9},{x:29,y:10},{x:30,y:10.1},{x:31,y:10.3},{x:32,y:10.4},
                        {x:33,y:10.5},{x:34,y:10.6},{x:35,y:10.7},{x:36,y:10.8},{x:37,y:11},{x:38,y:11.1},{x:39,y:11.2},{x:40,y:11.3},
                        {x:41,y:11.4},{x:42,y:11.5},{x:43,y:11.7},{x:44,y:11.8},{x:45,y:11.9},{x:46,y:12},{x:47,y:12.1},{x:48,y:12.2},
                        {x:49,y:12.3},{x:50,y:12.4},{x:51,y:12.5},{x:52,y:12.6},{x:53,y:12.7},{x:54,y:12.9},{x:55,y:13},{x:56,y:13.1},
                        {x:57,y:13.2},{x:58,y:13.3},{x:59,y:13.4},{x:60,y:13.5}];

            var set2 = [{x:0,y:2.5},{x:1,y:3.4},{x:2,y:4.4},{x:3,y:5.1},{x:4,y:5.6},{x:5,y:6.1},{x:6,y:6.4},{x:7,y:6.7},{x:8,y:7},
                        {x:9,y:7.2},{x:10,y:7.5},{x:11,y:7.7},{x:12,y:7.8},{x:13,y:8},{x:14,y:8.2},{x:15,y:8.4},{x:16,y:8.5},
                        {x:17,y:8.7},{x:18,y:8.9},{x:19,y:9},{x:20,y:9.2},{x:21,y:9.3},{x:22,y:9.5},{x:23,y:9.7},{x:24,y:9.8},
                        {x:25,y:10},{x:26,y:10.1},{x:27,y:10.2},{x:28,y:10.4},{x:29,y:10.5},{x:30,y:10.7},{x:31,y:10.8},{x:32,y:10.9},
                        {x:33,y:11.1},{x:34,y:11.2},{x:35,y:11.3},{x:36,y:11.4},{x:37,y:11.6},{x:38,y:11.7},{x:39,y:11.8},{x:40,y:11.9},
                        {x:41,y:12.1},{x:42,y:12.2},{x:43,y:12.3},{x:44,y:12.4},{x:45,y:12.5},{x:46,y:12.7},{x:47,y:12.8},{x:48,y:12.9},
                        {x:49,y:13},{x:50,y:13.1},{x:51,y:13.3},{x:52,y:13.4},{x:53,y:13.5},{x:54,y:13.6},{x:55,y:13.7},{x:56,y:13.8},
                        {x:57,y:13.9},{x:58,y:14.1},{x:59,y:14.2},{x:60,y:14.3}];

            var set3 = [{x:0,y:3.3},{x:1,y:4.5},{x:2,y:5.6},{x:3,y:6.4},{x:4,y:7},{x:5,y:7.5},{x:6,y:7.9},{x:7,y:8.3},{x:8,y:8.6},
                        {x:9,y:8.9},{x:10,y:9.2},{x:11,y:9.4},{x:12,y:9.6},{x:13,y:9.9},{x:14,y:10.1},{x:15,y:10.3},{x:16,y:10.5},
                        {x:17,y:10.7},{x:18,y:10.9},{x:19,y:11.1},{x:20,y:11.3},{x:21,y:11.5},{x:22,y:11.8},{x:23,y:12},{x:24,y:12.2},
                        {x:25,y:12.4},{x:26,y:12.5},{x:27,y:12.7},{x:28,y:12.9},{x:29,y:13.1},{x:30,y:13.3},{x:31,y:13.5},{x:32,y:13.7},
                        {x:33,y:13.8},{x:34,y:14},{x:35,y:14.2},{x:36,y:14.3},{x:37,y:14.5},{x:38,y:14.7},{x:39,y:14.8},{x:40,y:15},
                        {x:41,y:15.2},{x:42,y:15.3},{x:43,y:15.5},{x:44,y:15.7},{x:45,y:15.8},{x:46,y:16},{x:47,y:16.2},{x:48,y:16.3},
                        {x:49,y:16.5},{x:50,y:16.7},{x:51,y:16.8},{x:52,y:17},{x:53,y:17.2},{x:54,y:17.3},{x:55,y:17.5},{x:56,y:17.7},
                        {x:57,y:17.8},{x:58,y:18},{x:59,y:18.2},{x:60,y:18.3}];

            var set4 = [{x:0,y:4.3},{x:1,y:5.7},{x:2,y:7},{x:3,y:7.9},{x:4,y:8.6},{x:5,y:9.2},{x:6,y:9.7},{x:7,y:10.2},{x:8,y:10.5},
                        {x:9,y:10.9},{x:10,y:11.2},{x:11,y:11.5},{x:12,y:11.8},{x:13,y:12.1},{x:14,y:12.4},{x:15,y:12.7},{x:16,y:12.9},
                        {x:17,y:13.2},{x:18,y:13.5},{x:19,y:13.7},{x:20,y:14},{x:21,y:14.3},{x:22,y:14.5},{x:23,y:14.8},{x:24,y:15.1},
                        {x:25,y:15.3},{x:26,y:15.6},{x:27,y:15.9},{x:28,y:16.1},{x:29,y:16.4},{x:30,y:16.6},{x:31,y:16.9},{x:32,y:17.1},
                        {x:33,y:17.3},{x:34,y:17.6},{x:35,y:17.8},{x:36,y:18},{x:37,y:18.3},{x:38,y:18.5},{x:39,y:18.7},{x:40,y:19},
                        {x:41,y:19.2},{x:42,y:19.4},{x:43,y:19.7},{x:44,y:19.9},{x:45,y:20.1},{x:46,y:20.4},{x:47,y:20.6},{x:48,y:20.9},
                        {x:49,y:21.1},{x:50,y:21.3},{x:51,y:21.6},{x:52,y:21.8},{x:53,y:22.1},{x:54,y:22.3},{x:55,y:22.5},{x:56,y:22.8},
                        {x:57,y:23},{x:58,y:23.3},{x:59,y:23.5},{x:60,y:23.8}];
            // End of Weight data
            
            // Start of Head data
            var set5 = [{x:0,y:32.1},{x:1,y:35.1},{x:2,y:36.9},{x:3,y:38.3},{x:4,y:39.4},{x:5,y:40.3},{x:6,y:41},{x:7,y:41.7},{x:8,y:42.2},
                        {x:9,y:42.6},{x:10,y:43},{x:11,y:43.4},{x:12,y:43.6},{x:13,y:43.9},{x:14,y:44.1},{x:15,y:44.3},{x:16,y:44.5},
                        {x:17,y:44.7},{x:18,y:44.9},{x:19,y:45},{x:20,y:45.2},{x:21,y:45.3},{x:22,y:45.4},{x:23,y:45.6},{x:24,y:45.7},
                        {x:25,y:45.8},{x:26,y:45.9},{x:27,y:46},{x:28,y:46.1},{x:29,y:46.2},{x:30,y:46.3},{x:31,y:46.4},{x:32,y:46.5},
                        {x:33,y:46.6},{x:34,y:46.6},{x:35,y:46.7},{x:36,y:46.8},{x:37,y:46.9},{x:38,y:46.9},{x:39,y:47},{x:40,y:47},
                        {x:41,y:47.1},{x:42,y:47.2},{x:43,y:47.2},{x:44,y:47.3},{x:45,y:47.3},{x:46,y:47.4},{x:47,y:47.4},{x:48,y:47.5},
                        {x:49,y:47.5},{x:50,y:47.5},{x:51,y:47.6},{x:52,y:47.6},{x:53,y:47.7},{x:54,y:47.7},{x:55,y:47.7},{x:56,y:47.8},
                        {x:57,y:47.8},{x:58,y:47.9},{x:59,y:47.9},{x:60,y:47.9}];

            var set6 = [{x:0,y:34.5},{x:1,y:37.3},{x:2,y:39.1},{x:3,y:40.5},{x:4,y:41.6},{x:5,y:42.6},{x:6,y:43.3},{x:7,y:44},{x:8,y:44.5},
                        {x:9,y:45},{x:10,y:45.4},{x:11,y:45.8},{x:12,y:46.1},{x:13,y:46.3},{x:14,y:46.6},{x:15,y:46.8},{x:16,y:47},
                        {x:17,y:47.2},{x:18,y:47.4},{x:19,y:47.5},{x:20,y:47.7},{x:21,y:47.8},{x:22,y:48},{x:23,y:48.1},{x:24,y:48.3},
                        {x:25,y:48.4},{x:26,y:48.5},{x:27,y:48.6},{x:28,y:48.7},{x:29,y:48.8},{x:30,y:48.9},{x:31,y:49},{x:32,y:49.1},
                        {x:33,y:49.2},{x:34,y:49.3},{x:35,y:49.4},{x:36,y:49.5},{x:37,y:49.5},{x:38,y:49.6},{x:39,y:49.7},{x:40,y:49.7},
                        {x:41,y:49.8},{x:42,y:49.9},{x:43,y:49.9},{x:44,y:50},{x:45,y:50.1},{x:46,y:50.1},{x:47,y:50.2},{x:48,y:50.2},
                        {x:49,y:50.3},{x:50,y:50.3},{x:51,y:50.4},{x:52,y:50.4},{x:53,y:50.4},{x:54,y:50.5},{x:55,y:50.5},{x:56,y:50.6},
                        {x:57,y:50.6},{x:58,y:50.7},{x:59,y:50.7},{x:60,y:50.7}];

            var set7 = [{x:0,y:36.9},{x:1,y:39.5},{x:2,y:41.3},{x:3,y:42.7},{x:4,y:43.9},{x:5,y:44.8},{x:6,y:45.6},{x:7,y:46.3},{x:8,y:46.9},
                        {x:9,y:47.4},{x:10,y:47.8},{x:11,y:48.2},{x:12,y:48.5},{x:13,y:48.8},{x:14,y:49},{x:15,y:49.3},{x:16,y:49.5},
                        {x:17,y:49.7},{x:18,y:49.9},{x:19,y:50},{x:20,y:50.2},{x:21,y:50.4},{x:22,y:50.5},{x:23,y:50.7},{x:24,y:50.8},
                        {x:25,y:50.9},{x:26,y:51.1},{x:27,y:51.2},{x:28,y:51.3},{x:29,y:51.4},{x:30,y:51.6},{x:31,y:51.7},{x:32,y:51.8},
                        {x:33,y:51.9},{x:34,y:52},{x:35,y:52},{x:36,y:52.1},{x:37,y:52.2},{x:38,y:52.3},{x:39,y:52.4},{x:40,y:52.4},
                        {x:41,y:52.5},{x:42,y:52.6},{x:43,y:52.7},{x:44,y:52.7},{x:45,y:52.8},{x:46,y:52.8},{x:47,y:52.9},{x:48,y:53},
                        {x:49,y:53},{x:50,y:53.1},{x:51,y:53.1},{x:52,y:53.2},{x:53,y:53.2},{x:54,y:53.3},{x:55,y:53.3},{x:56,y:53.4},
                        {x:57,y:53.4},{x:58,y:53.5},{x:59,y:53.5},{x:60,y:53.5}];
            // End of Head data

            // Start of Height/Lenght data
            var set8 = [{x:0,y:45.5},{x:1,y:50.2},{x:2,y:53.8},{x:3,y:56.7},{x:4,y:59},{x:5,y:61},{x:6,y:62.6},{x:7,y:64.1},{x:8,y:65.5},
                        {x:9,y:66.8},{x:10,y:68},{x:11,y:69.1},{x:12,y:70.2},{x:13,y:71.3},{x:14,y:72.3},{x:15,y:73.3},{x:16,y:74.2},
                        {x:17,y:75.1},{x:18,y:76},{x:19,y:76.8},{x:20,y:77.7},{x:21,y:78.4},{x:22,y:79.2},{x:23,y:80},{x:24,y:80.7},
                        {x:25,y:80.7},{x:26,y:81.4},{x:27,y:82.1},{x:28,y:82.8},{x:29,y:83.4},{x:30,y:84},{x:31,y:84.6},{x:32,y:85.2},
                        {x:33,y:85.8},{x:34,y:86.4},{x:35,y:86.9},{x:36,y:87.5},{x:37,y:88},{x:38,y:88.5},{x:39,y:89.1},{x:40,y:89.6},
                        {x:41,y:90.1},{x:42,y:90.6},{x:43,y:91.1},{x:44,y:91.6},{x:45,y:92.1},{x:46,y:92.6},{x:47,y:93.1},{x:48,y:93.6},
                        {x:49,y:94},{x:50,y:94.5},{x:51,y:95},{x:52,y:95.5},{x:53,y:95.9},{x:54,y:96.4},{x:55,y:96.9},{x:56,y:97.3},
                        {x:57,y:97.8},{x:58,y:98.3},{x:59,y:98.7},{x:60,y:99.2}];
            
            var set9 = [{x:0,y:46.3},{x:1,y:51.1},{x:2,y:54.7},{x:3,y:57.6},{x:4,y:60},{x:5,y:61.9},{x:6,y:63.6},{x:7,y:65.1},{x:8,y:66.5},
                        {x:9,y:67.7},{x:10,y:69},{x:11,y:70.2},{x:12,y:71.3},{x:13,y:72.4},{x:14,y:73.4},{x:15,y:74.4},{x:16,y:75.4},
                        {x:17,y:76.3},{x:18,y:77.2},{x:19,y:78.1},{x:20,y:78.9},{x:21,y:79.7},{x:22,y:80.5},{x:23,y:81.3},{x:24,y:82.1},
                        {x:25,y:82.1},{x:26,y:82.8},{x:27,y:83.5},{x:28,y:84.2},{x:29,y:84.9},{x:30,y:85.5},{x:31,y:86.2},{x:32,y:86.8},
                        {x:33,y:87.4},{x:34,y:88},{x:35,y:88.5},{x:36,y:89.1},{x:37,y:89.7},{x:38,y:90.2},{x:39,y:90.8},{x:40,y:91.3},
                        {x:41,y:91.9},{x:42,y:92.4},{x:43,y:92.9},{x:44,y:93.4},{x:45,y:93.9},{x:46,y:94.4},{x:47,y:94.9},{x:48,y:95.4},
                        {x:49,y:95.9},{x:50,y:96.4},{x:51,y:96.9},{x:52,y:97.4},{x:53,y:97.9},{x:54,y:98.4},{x:55,y:98.8},{x:56,y:99.3},
                        {x:57,y:99.8},{x:58,y:100.3},{x:59,y:100.8},{x:60,y:101.2}];

            var set10 = [{x:0,y:49.9},{x:1,y:54.7},{x:2,y:58.4},{x:3,y:61.4},{x:4,y:63.9},{x:5,y:65.9},{x:6,y:67.6},{x:7,y:69.2},{x:8,y:70.6},
                        {x:9,y:72},{x:10,y:73.3},{x:11,y:74.5},{x:12,y:75.7},{x:13,y:76.9},{x:14,y:78},{x:15,y:79.1},{x:16,y:80.2},{x:17,y:81.2},
                        {x:18,y:82.3},{x:19,y:83.2},{x:20,y:84.2},{x:21,y:85.1},{x:22,y:86},{x:23,y:86.9},{x:24,y:87.8},{x:25,y:88},{x:26,y:88.8},
                        {x:27,y:89.6},{x:28,y:90.4},{x:29,y:91.2},{x:30,y:91.9},{x:31,y:92.7},{x:32,y:93.4},{x:33,y:94.1},{x:34,y:94.8},{x:35,y:95.4},
                        {x:36,y:96.1},{x:37,y:96.7},{x:38,y:97.4},{x:39,y:98},{x:40,y:98.6},{x:41,y:99.2},{x:42,y:99.9},{x:43,y:100.4},{x:44,y:101},
                        {x:45,y:101.6},{x:46,y:102.2},{x:47,y:102.8},{x:48,y:103.3},{x:49,y:103.9},{x:50,y:104.4},{x:51,y:105},{x:52,y:105.6},
                        {x:53,y:106.1},{x:54,y:106.7},{x:55,y:107.2},{x:56,y:107.8},{x:57,y:108.3},{x:58,y:108.9},{x:59,y:109.4},{x:60,y:110}];

            var set11 = [{x:0,y:53.4},{x:1,y:58.4},{x:2,y:62.2},{x:3,y:65.3},{x:4,y:67.8},{x:5,y:69.9},{x:6,y:71.6},{x:7,y:73.2},
                        {x:8,y:74.7},{x:9,y:76.2},{x:10,y:77.6},{x:11,y:78.9},{x:12,y:80.2},{x:13,y:81.5},{x:14,y:82.7},{x:15,y:83.9},
                        {x:16,y:85.1},{x:17,y:86.2},{x:18,y:87.3},{x:19,y:88.4},{x:20,y:89.5},{x:21,y:90.5},{x:22,y:91.6},{x:23,y:92.6},
                        {x:24,y:93.6},{x:25,y:93.8},{x:26,y:94.8},{x:27,y:95.7},{x:28,y:96.6},{x:29,y:97.5},{x:30,y:98.3},{x:31,y:99.2},
                        {x:32,y:100},{x:33,y:100.8},{x:34,y:101.5},{x:35,y:102.3},{x:36,y:103.1},{x:37,y:103.8},{x:38,y:104.5},
                        {x:39,y:105.2},{x:40,y:105.9},{x:41,y:106.6},{x:42,y:107.3},{x:43,y:108},{x:44,y:108.6},{x:45,y:109.3},
                        {x:46,y:109.9},{x:47,y:110.6},{x:48,y:111.2},{x:49,y:111.8},{x:50,y:112.5},{x:51,y:113.1},{x:52,y:113.7},
                        {x:53,y:114.3},{x:54,y:115},{x:55,y:115.6},{x:56,y:116.2},{x:57,y:116.8},{x:58,y:117.4},{x:59,y:118.1},
                        {x:60,y:118.7}];
            // End of Height/Lenght data
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter2 = wrap2.enter().append('g').attr('class', 'd3line').append('g');

            var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([headData]);
            var gEnter3 = wrap3.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([60.5,0]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([60.5,0]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,131]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,131]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(0, 60.5, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(0, 60.5, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 131, 5)).tickFormat(function(d){
                return d%5==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 131, 5)).tickFormat(function(d){
                return d%5==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var headpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("WHO Boys Height, Weight, Head Charts 0-5 years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Age in Months");

                svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 50 )
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("Ref: IAP Growth Charts. Indian Academy of Pediatrics. [updated 2013 18 Oct, cited 2016 14 Jan] Available from: http://www.iapindia.org/page.php?id=79");
            
            svg.append("text")
                .attr("x", -200 )
                .attr("y", -35)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("WHO MGRS 2006 Charts; Acta Paediatrics Suppl. 450:2006");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 350 )
                .style("text-anchor", "start")
                .text("1 (-3)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 340 )
                .style("text-anchor", "start")
                .text("3 (-2)");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 330 )
                .style("text-anchor", "start")
                .text("50 (0)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 310 )
                .style("text-anchor", "start")
                .text("97 (+2)");
            
            svg.append("text")
                .attr("x", 650 )
                .attr("y", 300 )
                .style("text-anchor", "start")
                .text("Weight");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 250 )
                .style("text-anchor", "start")
                .text("3 (-2)");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 238 )
                .style("text-anchor", "start")
                .text("50 (0)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 228 )
                .style("text-anchor", "start")
                .text("97 (+2)");

            svg.append("text")
                .attr("x", 650 )
                .attr("y", 220 )
                .style("text-anchor", "start")
                .text("Head");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 100 )
                .style("text-anchor", "start")
                .text("1 (-3)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 90 )
                .style("text-anchor", "start")
                .text("3 (-2)");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 60 )
                .style("text-anchor", "start")
                .text("50 (0)");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 40 )
                .style("text-anchor", "start")
                .text("97 (+2)");
            
            svg.append("text")
                .attr("x", 600 )
                .attr("y", 40 )
                .style("text-anchor", "start")
                .text("Height/Lenght");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(headData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
/**
 * @author Helyxon
 * created on Dec 2016
 */
(function () {
  "use strict";


/** @ngInject */
function ScheduleService($http, $q, serviceBaseUrl, authService, BudsStore){
  var self = {};

  self.getSchedule = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+"getschedule?account_email="+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


	self.saveSchedule = function(data){
		var deferred = $q.defer();
    data.account_email= authService.authentication.account_id;
		$http.post(serviceBaseUrl+'saveschedule',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	self.prepareSchedule  = function(data){
		var deferred = $q.defer();
    data.account_email = authService.authentication.account_id;
		$http.post(serviceBaseUrl+'preparecalendar',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

  return self;
}


/*Setup the Module*/
angular.module("RxC.pages.Schedule", ["buds.store"])
.service("ScheduleService", ScheduleService);


})();

'use strict';
angular.module('AngularApp').factory('accountService', ['$http', '$q', function ($http, $q) {
	var UserServiceFactory = {};
	
	var getuserlist = function () {
		var deferred = $q.defer();
		$http.get('json/getuserlist.json').success(function (response) {
		deferred.resolve(response);
	}).error(function (error, status) {
		deferred.reject(error);
	});
	return deferred.promise;
	};
	
	 var getProductList = function() {
		var deferred = $q.defer();
		$http.get('json/getlist.json').success(function (response) {
		deferred.resolve(response);
	}).error(function (error, status) {
		deferred.reject(error);
	});
	return deferred.promise;
	};
	
	var getaccountList = function() {
			var deferred = $q.defer();
			$http.get('json/acc.xml').success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
		};
		
	UserServiceFactory.getuserlist = getuserlist;
	UserServiceFactory.getProductList = getProductList;
	UserServiceFactory.getaccountList = getaccountList;
	
	return UserServiceFactory;
} ]);
'use strict';
angular.module('AngularApp').factory('adviceService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

    this.listAdvice = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'listadvice?account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.addAdvice = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addadvice',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updateAdvice = function(data) {
        var deferred = $q.defer();
        $http.put(serviceBaseUrl+'updateadvice',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('agentService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {


    this.postAgentBiodata = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'createagentdata', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getAgentData = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getagentdata?account_email='+authService.authentication.account_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updateAgentBiodata = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updateagentdata', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.deleteAgentBiodata = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'deleteagentdata', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getAgenttype = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getagentmasterdata?account_email='+authService.authentication.account_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.datavalidateapi = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'validateagentusername', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    return this;

}]);
'use strict';
angular.module('AngularApp').factory('authInterceptorService', ['$q', '$location', 'localStorageService','$sce', function ($q, $location, localStorageService, $sce) {

    var authInterceptorServiceFactory = {};

    //handle all http request to include Authorization Header with token
    var request = function (config) {
        config.headers = config.headers || {};

        var authData = localStorageService.get('authorizationData');
        if (authData) {
            config.headers.Authorization = authData.token;
             
        }

        return config;
    };

    //handle all forbidden access request and redirect to login
    var responseError = function (rejection) {
        if (rejection.status === 403 && $location.path()==='') {
            localStorageService.remove('authorizationData');
            $location.path('/login');
        }
        return $q.reject(rejection);
    };

    authInterceptorServiceFactory.request = request;
    authInterceptorServiceFactory.responseError = responseError;

    return authInterceptorServiceFactory;
} ]);
'use strict';
angular.module('AngularApp').factory('authService', ['$http', '$q', 'localStorageService', 'serviceBaseUrl', 'helyxonApiUrl', 'mainUrl','$location', function ($http, $q, localStorageService, serviceBaseUrl, helyxonApiUrl, mainUrl, $location) {

    this.authentication = {
        isAuth: false,
        account_id: "",
        account_info: {},
        docRecord_id: "",
        doctor_id: "",   
        doctor_name: "",
        doctor_image: "",  
        doctor_cover_image: "",
        doctor_degree: "",
        doctor_speciality: "",
        hospital_name: "",
        doctor_mobile: ""
    }; 

    var authentication = this.authentication;

    this.helyxonApi = {
        url: "",
    };
    var helyxonApi = this.helyxonApi;

    this.mainUrl = {
        url: "",
    }

    var mainUrl = this.mainUrl

//  Login service method

// 	this.login = function (loginData) {
// 	   var deferred = $q.defer();
// 	   $http.post(serviceBaseUrl+'login',loginData).success(function (response) {
//         if(response.account_info.Account.accountType=="0"){
//             authentication.isAuth = true;
//             authentication.account_id = response.account_id;
//             authentication.account_info = response.account_info;
//             authentication.docRecord_id = response.record_id;      
//             localStorageService.set('authorizationData', { token: response.token, account_id: response.account_id, account_info: response.account_info, docRecord_id:response.record_id});
//         }
//         deferred.resolve(response);

/*	this.login = function(loginData) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'login',loginData).success(function (response) {
            if(response.account_info.Account.accountType=="0"){
                authentication.isAuth = true;
                authentication.account_id = response.account_id;
                authentication.account_info = response.account_info;
                authentication.docRecord_id = response.record_id;      
                localStorageService.set('authorizationData', { token: response.token, account_id: response.account_id, account_info: response.account_info, docRecord_id:response.record_id});
            }
            deferred.resolve(response);
         
		}).error(function (error, status) {
			deferred.reject(error);
		});
	    return deferred.promise;
    }; */

    this.login = function(loginData) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'doclogin', loginData).success(function (response) {
            console.log("response.doctors.login.doctor.hospital_name)", response.doctors.login.doctor.hospital_name)
            sessionStorage.setItem("hospital",response.doctors.login.doctor.hospital_name);
            sessionStorage.setItem("token",response.doctors.login.info.token);
            // sessionStorage.setItem("token",response.doctors.login)
            var loginData = response.doctors.login;
            if(loginData.info.account_info.Account.accountType==0) {
                authentication.isAuth = true
               // authentication.isAuthtwofactor = false
                authentication.isAuthtwofactor = loginData.auth_status;
                authentication.account_id = loginData.info.account_id;
                authentication.account_info = loginData.info.account_info;
                authentication.docRecord_id = loginData.info.record_id;   
                authentication.doctor_id = loginData.doctor.doctor_id;   
                authentication.doctor_name = loginData.doctor.display_name;
                authentication.doctor_image = loginData.doctor.avatar;  
                authentication.doctor_cover_image = loginData.doctor.cover_art;  
                authentication.doctor_degree = loginData.doctor.degree;
                authentication.doctor_speciality = loginData.doctor.speciality;
                authentication.hospital_name = loginData.doctor.hospital_name;
                authentication.doctor_mobile = loginData.doctor.mobile;

                localStorageService.set('authorizationData', { 
                    token: loginData.info.token, 
                    account_id: loginData.info.account_id, 
                    account_info: loginData.info.account_info, 
                    docRecord_id: loginData.info.record_id, 
                    doctor_id: loginData.doctor.doctor_id, 
                    doctor_name: loginData.doctor.display_name,
                    doctor_image: loginData.doctor.avatar,  
                    doctor_cover_image: loginData.doctor.cover_art, 
                    doctor_degree: loginData.doctor.degree,
                    doctor_speciality: loginData.doctor.speciality,
                    hospital_name: loginData.doctor.hospital_name,
                    doctor_mobile: loginData.doctor.mobile
                });
               
                localStorageService.set('twofactorapprove',authentication.isAuthtwofactor)
                //    isAuthtwofactor : false,
                //  isAuthtwofactor : loginData.auth_status,
            }
            deferred.resolve(response);
            
        
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    }; 

    //Signup service method
    this.signup = function (signupData) {
        var deferred = $q.defer();
        $http({
            url: appUtil.serviceBaseUrl + 'Customer/Signup',
            method: 'POST',
            headers: {
               'Content-Type': undefined //Set undefined to support multi-part/form-data
            },
            data: signupData,
            transformRequest: function(data) { return data; },
            success: function(response) {
                //success callback
                if (response.Success) {
                    deferred.resolve(response);
                } else {
                    deferred.reject({ error_description: response.Message });
                }
            },
            error: function(err, status) {
                deferred.reject({ error_description: err });
            }
        });

        return deferred.promise;
    };

    // this.changePassword = function(data) {
    //     var deferred = $q.defer();
    //     $http.post(serviceBaseUrl+ 'changepasswd' , data).success(function (response) {
    //         deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
    // };

    this.changePassword = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+ 'updatedoctorpassword' , data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };


    this.addPatient = function(data) {
        var deferred = $q.defer();
        data.doctor_id = authentication.doctor_id;
        $http.post(serviceBaseUrl.replace('service','registration')+ 'userinfo' , data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    //Forgot password service method
    this.forgotPassword = function (data) {
        return appUtil.postData(data, 'Login/ForgotPassword', $http, $q);
    };

    //Activate Account by Mobile
    this.activeaccountMobile = function (data) {
        return appUtil.postData(data, 'Customer/UpdateByMobile?mobileNo=' + data.mobile + '&activationKey=' + data.activekey, $http, $q);
    };

    this.logOut = function () {
        localStorageService.clearAll();
        authentication.isAuth = false;
        authentication.account_id = "";
        authentication.account_info = {};
        authentication.docRecord_id = "";
        authentication.doctor_id = "";   
        authentication.doctor_name = "";
        authentication.doctor_image = "";
        authentication.doctor_cover_image = ""; 
        authentication.doctor_degree = "";
        authentication.doctor_speciality = "";
        authentication.hospital_name = "";
        authentication.doctor_mobile = "";
    };

    //service method to load Authentication data from browser local storage
    this.loadAuthData = function () {
        var authData = localStorageService.get('authorizationData');
        if (authData) {
            authentication.isAuth = true;
            authentication.account_id = authData.account_id;
            authentication.account_info = authData.account_info;
            authentication.docRecord_id = authData.docRecord_id;
            authentication.doctor_id = authData.doctor_id, 
            authentication.doctor_name = authData.doctor_name,
            authentication.doctor_image = authData.doctor_image,  
            authentication.doctor_cover_image = authData.doctor_cover_image; 
            authentication.doctor_degree = authData.doctor_degree;
            authentication.doctor_speciality = authData.doctor_speciality;
            authentication.hospital_name = authData.hospital_name;
            authentication.doctor_mobile = authData.doctor_mobile;
        }
    };

    this.loadHelyxonApiUrl = function() {
        helyxonApi.url = helyxonApiUrl;
    }

    this.loadmainUrl = function(){
        mainUrl.url = mainUrl;
    }

    this.getErrorDetail = function (error) {
        if (error && error.error_description) {
            return error.error_description;
        }
        return appUtil.globalError;
    };
  
    this.getPatientSearch = function(data,picme_param) {
        var deferred = $q.defer();
        if(picme_param==true) {
            SearchData=({'picme':data,"account_email":authentication.account_id });
        }  else {
            if(data == data.match(/^[a-zA-Z]+$/)) {
            var SearchData=({'full_name':data,"account_email":authentication.account_id });
            } else if($.isNumeric(data) && data.length == 10) {
                SearchData=({'contact_no':data,"account_email":authentication.account_id });
            }/*else if($.isNumeric(data) && data.length < 10) {
                SearchData=({'uhid':data,"account_email":authentication.account_id });
            }*/else {
                SearchData=({'mr_number':data.toUpperCase(),"account_email":authentication.account_id });
            }
        }
        $http.post(serviceBaseUrl+ 'search',SearchData).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getPatientSearchStart = function(data){
        var deferred = $q.defer();
        var SearchData=({'offset':data,"record_id":authentication.docRecord_id });
        $http.get(serviceBaseUrl+ 'demolatest?'+authentication.docRecord_id+'/'+data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getPatientSearchApt = function(data){
       
        var deferred = $q.defer();
        if(data == data.match(/^[a-zA-Z]+$/))
        {
        var SearchData=({'name':data,"account_email":authentication.account_id });
        }
        else if($.isNumeric(data) && data.length == 10)
        {
            SearchData=({'cell_number':data,"account_email":authentication.account_id });
        }/*
        else if($.isNumeric(data) && data.length < 10)
        {
            SearchData=({'uhid':data,"account_email":authentication.account_id });
        }*/
        else{
            SearchData=({'mr_number':data,"account_email":authentication.account_id });
        }
        $http.post(serviceBaseUrl+ 'search' ,SearchData ).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };


    this.bookApt = function(data){
        var deferred = $q.defer();
        data.doctor_id=authService.authentication.doctor_id;
        //$http.post(serviceBaseUrl+'docbookapt',data).success(function (response) {
        $http.post(serviceBaseUrl+'doctorbooktokenappointment',data).success(function (response) {

            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.bookdocApt = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'vacappointmentdoc',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.bkWalkin = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'bookwalkinapt',{account_email:authentication.account_id,patient_account:data.email}).success(function (response) {

            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getVaccineList = function(recordId){
        var deferred = $q.defer();
            $http.get(serviceBaseUrl+'immune?'+recordId).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getCRCSurveyList = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'surveyhistory', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.initiatedocauthlogin = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'initiatedocauth', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getstateinfo = function(data){
        var deferred = $q.defer();
            $http.get(serviceBaseUrl+'getrxloginstate?account_email='+authentication.account_id+'&doctor_id='+authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    // this.twofactorauthphpapi = function(data){
    //     var deferred = $q.defer();
    //         $http.get(serviceBasephpUrl+'validate_doctor_auth.php?'+'auth_code='+data).success(function (response) {
    //         deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
    // };

    return this;
} ]);

'use strict';

angular.module('AngularApp').factory('careproviderService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) { 


    this.getDistrict = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getdistrict',data ).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };


    this.getBlock = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getblockcareprovider',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };


    this.getVillage = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getvillagecareprovider',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };


    this.getStaffDetails = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getfieldstaffbyaccount',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.getFieldstaff = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getfieldstaffbycommunity',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.blockCreation = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'createblock',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.villageCreation = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'createvillage',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.staffCreation = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'createfieldstaff',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.getBlockType = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getblocktype?account_email='+data.account_email ).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };


    this.getFieldStaffType = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getfieldstafftype?account_email='+data.account_email ).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.datavalidateapi = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'validateagentusername', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getPatientreport = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getregisrtedpatientvitalreport?account_email='+data.account_email+'&from_date='+data.fromdate+'&to_date='+data.todate ).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    return this;
}]);

'use strict';
angular.module('AngularApp').factory('chatService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {
    
    this.getPatientList = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'chatpatientlist?account_email='+authService.authentication.account_id+'&messages='+data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    this.unread = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'unread?account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};
	
	this.sendMessage = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'sendmessage',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getPreviousMessage = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'chatpatienthistory?account_email='+authService.authentication.account_id+'&patient='+data).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    this.setAsRead = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'setasread', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.refundPay = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'waivepayment', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    return this;

}]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

 'use strict';
 angular.module('AngularApp').factory('commonsettingsService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {
 
     this.getcommonSettings = function () {
         var deferred = $q.defer();
         $http.get(serviceBaseUrl+'getdoctormastersetting?account_email='+authService.authentication.account_id+"&doctor_id="+authService.authentication.doctor_id).success(function (response) {
             deferred.resolve(response);
         }).error(function (error, status) {
             deferred.reject(error);
         });
         return deferred.promise;
     };

     this.whatsappSettings = function () {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getwhatsappsetting?account_email='+authService.authentication.account_id+"&doctor_id="+authService.authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.addwhatsapp_Settings = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addwhatsappsetting',data).success(function(response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    
    this.getProfile = function (recordId) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdoctorprofile?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
 
 
     this.updatecommonSettings = function (data) {
         var deferred = $q.defer();
         $http.post(serviceBaseUrl+'updatedoctormastersetting',data).success(function(response) {
             deferred.resolve(response);
         }).error(function (error, status) {
             deferred.reject(error);
         });
         return deferred.promise;
     };
 
     
 
     return this;
 }]);
'use strict';
angular.module('AngularApp').factory('complaintService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', '$sessionStorage', function ($http, $q, serviceBaseUrl, localStorageService,authService, $sessionStorage) {

    this.getVitalSigns = function (recordId) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'vitals?'+recordId).success(function (response) {
		deferred.resolve(response);
	}).error(function (error, status) {
		deferred.reject(error);
	});
	return deferred.promise;
    };

    this.getRecordInfo = function(recordId){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'recordinfo',{account_email: authService.authentication.account_id,record_id:recordId}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.saveGrowth = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'document' , data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getComplaintList = function(data,complaint){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'listcompliantcategories?account_email='+authService.authentication.account_id+'&filter='+data+'&complaints='+complaint).success(function(response) {
			deferred.resolve(response);			
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getComplaintQuestion = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getcomplaintsurvey?account_email='+authService.authentication.account_id+'&category_id='+data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.saveComplaint = function(data,url){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+url, data).success(function(response){
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.linkappointmentvitals = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl + 'linkappointmentvitals',data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.appointmentVitalsData = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'appointmentvitalsdata?account_email='+authService.authentication.account_id+'&appointment_id='+data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.addNewCategory = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'addcompliantcategory',data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.questionget = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'questionget?'+data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.questionadd = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'questionadd',data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.questionedit = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'questionedit',data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.questiondelete = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'questiondelete',data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};
    return this;    
}]);
'use strict';
angular.module('AngularApp').factory('complaintchooserService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {
    
    this.getregion = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getcomplaintmaster?account_email='+authService.authentication.account_id+"&doctor_id="+authService.authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getcomplaintCategory = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getcomplaintcategory?account_email='+authService.authentication.account_id+"&doctor_id="+authService.authentication.doctor_id+"&body_part_id="+data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getillnesscategory = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getcomplaintillness?account_email='+authService.authentication.account_id+"&doctor_id="+authService.authentication.doctor_id+"&category_id="+data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    

    this.postcategorycomplaint = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'savecomplaintcategory', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.postillnesscomplaint = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'savecomplaintillness', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    return this;

}]);
'use strict';
angular.module('AngularApp').factory('dashboardService', ['$http', '$q', 'serviceBaseUrl', 'dashboardBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, dashboardBaseUrl, localStorageService,authService) {

    this.getReviewData = function (data) {
		var deferred = $q.defer();
		    $http.post(serviceBaseUrl+'review',data).success(function (response) {
		    deferred.resolve(response);
    	}).error(function (error, status) {
		    deferred.reject(error);
	    });
	  return deferred.promise;
	};

	this.vaccinationDashboard = function(data) {
        var deferred = $q.defer();
        $http.post(dashboardBaseUrl+'vaccinationdashboard',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
	  return deferred.promise;
    };
    
    this.vaccinationRangeDashboard = function(data) {
        var deferred = $q.defer();
        $http.post(dashboardBaseUrl+'vaccinationrangedashboard',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
	  return deferred.promise;
    };
    
	this.vaccineEffectiveDashboard = function(data) {
        var deferred = $q.defer();
        $http.post(dashboardBaseUrl+'vaccinationeffectiveness',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
	  return deferred.promise;
    };
    
    this.vaccineEffectiveRangeDashboard = function(data) {
        var deferred = $q.defer();
        $http.post(dashboardBaseUrl+'vaccinationeffectivenessrange',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
	  return deferred.promise;
	};

    return this;   
}]);

'use strict';
angular.module('AngularApp').factory('dischargeService', ['$http', '$q', 'serviceBaseUrl','registerBaseUrl', 'localStorageService', 'authService', function ($http, $q, serviceBaseUrl, registerBaseUrl,localStorageService, authService) {

    this.dischargeCardDetails = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'dischargecarddetails',data).success(function (response) {
            console.log('response',response);
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.viewAdmissionDetails = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'viewadmissiondetails',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getSncuId = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getsnculist_dischargesummary',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getSncuId_DischargeCard = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'get_sncu_list_dischargecard',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getBasicInfo = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getbasicinfo',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    this.getFollowupSchedule = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'followupschedule',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getAdmissionList = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getadmissionlist',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.get_dischargeSummary_data = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'admissionsummarydetails', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.newDischargeAdmission = function (data) {
        var deferred = $q.defer();
        $http.post(registerBaseUrl + 'newadmission', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updateDischargeAdmission = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'updateadmission', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getDistrictList = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getdistrict', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.doctorIncharge = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl + 'getdoctorincharge/?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id+'&type='+data+"&status_type=discharge").success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.getBlockList = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getblock', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

  /*  this.getPanchayatList = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getpanchayat', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };*/

    this.getVillageList = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getvillage', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    }; 

    this.getVhnList = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getstaffprofile', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.getStaffVillageList = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getstaffvillages', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.dischargeSummary = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'dischargesummary', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updatedischargeSummary = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'updateadmissionsummary', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.dischargeCard = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'dischargecard', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getParentDetails = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getparentsdetails', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getFollowupDetailsByDate = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getfollowuplistbydate', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getFollowupDetailsById = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'followupschedule', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updateFollowupDetailsById = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'updatefollowupremarks', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.PhoneCallgetFollowupDetailsByDate = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getfollowupcallbydate', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.PhoneCallgetFollowupDetailsById = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'getcalltracksearch', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    return this;

}]);

'use strict';
angular.module('AngularApp').factory('engagementService', ['$http', '$q', 'serviceBaseUrl','authService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl) {
    
    var helyxonApi_Url = helyxonApiUrl; 
     
	this.addEngageMessage = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'addengage',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
               deferred.reject(error);
        });
	  return deferred.promise;
    };
  
    this.updateEngageMessage = function(data) {
      
        var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'updateengagement',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };
   
    this.getEngagements = function(data){
     
        var deferred = $q.defer();
 
        $http.post(serviceBaseUrl+'getengagements',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.deleteReminderMsg = function(data){
     
        var deferred = $q.defer();
 
        $http.post(serviceBaseUrl+'deletereminder',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.getMhEngageData = function () {
    
        var deferred = $q.defer();
        // $http.get(helyxonApi_Url+'mh/api/v1.6/dbanner.php?demail='+authService.authentication.account_id).success(function (response) {
        $http.get(helyxonApi_Url+'/mh/api/v3.1/dbanner.php?demail='+authService.authentication.account_id).success(function (response) {
            
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.viewEngagement = function(data){
     
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'viewengagement',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.viewBanner = function(data){
     
        var deferred = $q.defer();
        $http.post(helyxonApi_Url+'/mh/api/v3.1/dbanner_update.php',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };



 return this;
}
 
]);
'use strict';
angular.module('AngularApp').factory('frontdeskService', ['$http', '$q', 'serviceBaseUrl','authService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl) {
    
    var helyxonApi_Url = helyxonApiUrl;
     
    this.frontdesk_Data = function(data){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getfrontdeskdetails/?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.frontdesk_postdata = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'createfrontdeskdetails/',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    }

    this.update_Data = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updatefrontdeskdetails/',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    }
 
    this.Status_Toggle = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'statusfrontdeskdetails',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    }

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('homevisitService', ['$http', '$q', 'serviceBaseUrl', 'authService', function($http, $q, serviceBaseUrl, authService) {
		
	this.getVisitDetails = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'crcwiseperformancestatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
               deferred.reject(error);
        });

	  return deferred.promise;
    };

    this.getCrcVillageWiseDetails = function(data) {

      var deferred = $q.defer();
      $http.post(serviceBaseUrl+'villagewiseperformancestatus',data).success(function (response) {
          deferred.resolve(response);
      }).error(function (error, status) {
          deferred.reject(error);
      });
      return deferred.promise;
    }

    this.getCrcHomeVisitCompliance = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'crchomevisitcompliance',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getCrcVillageWiseVisitCompliance = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'crcvillagewisevisitcompliance',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };
   
    this.getCrcWiseBabyHealthStatus = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'crcwisebabyhealthstatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getVillageWiseBabyHealthStatus = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'villagewisebabyhealthstatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getCrcWiseBabyGrowthStatus = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'crcwisebabygrowthstatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getVillageWiseBabyGrowthStatus = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'villagewisebabygrowthstatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getVillageWiseBabyGrowthStatus = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'villagewisebabygrowthstatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getCompleteComplaince = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'completecompliancedetail',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };
    
    this.getCompletePerformance = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'completeperformancedetail',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getCompleteHealthStatus = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'completehealthstatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getCompleteGrowthStatus = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'completebabygrowthstatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

    this.getCrcAndCtsPatientsDetails = function(data) {

        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'crcandctspatientsdetails',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

      return deferred.promise;
    };

  return this;

}]);
'use strict';
angular.module('AngularApp').factory('inoutService', ['$http', '$q', 'serviceBaseUrl', 'authService', 'localStorageService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl, localStorageService) {
	
	this.saveinoutstatus = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createdoctorinoutstatus', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getinoutstatus = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdoctorinoutstatuslog/?doctor_id='+authService.authentication.doctor_id +'&account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

    this.saveinoutsettings = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createdoctorinoutsetting', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}
	
	this.getinoutSettings = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdoctorinoutsetting/?doctor_id='+authService.authentication.doctor_id +'&account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};
    return this;
}
]);
'use strict';
angular.module('AngularApp').factory('incentiveService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {


    this.getIncentive = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getincentive?account_email='+authService.authentication.account_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    

    this.updateIncentive = function(incentivedata) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updateincentive', incentivedata).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    return this;

}]);
'use strict';
angular.module('AngularApp').factory('ivrsService', ['$http', '$q', 'serviceBaseUrl','authService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl) {
    
    var helyxonApi_Url = helyxonApiUrl;
     
    this.ivrs_Data = function(data){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getexistingivrs/?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.masterivrs_Data = function (data){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getmasterivrs/?account_email='+authService.authentication.account_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    }

    this.remove_Ivrs = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'removeivrs/',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    }

    this.create_IVRS = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'createivrs/',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    }
 

    this.audioupload_IVRS = function (data) {
        var deferred = $q.defer();
    //     console.log(helyxonApi_Url,'helyxonApi_Url');
    //     console.log('dataupload',data)
    //     $http.post(helyxonApi_Url+'cloud/mp3/audio.php',data).success(function(response){
    //         deferred.resolve(response);
    //     }).error(function(error,status){
    //         deferred.reject(error);
    //     });
    //   return deferred.promise;

      $http.post(helyxonApi_Url+'cloud/mp3/audio.php', data, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined,'Process-Data': false}
    }).success(function(response) {
        deferred.resolve(response);
    }).error(function (error) {
        deferred.reject(error);
    })

    return deferred.promise;
    }

    this.update_IVRS =function(data){
        var deferred = $q.defer();
        console.log(helyxonApi_Url,'helyxonApi_Url');
        console.log('data',data)
        $http.post(serviceBaseUrl+'upadteivrs/',data).success(function(response){
            console.log('sucess');
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    }
    // this.update_Data = function(data){
    //     var deferred = $q.defer();
    //     $http.post(serviceBaseUrl+'updatefrontdeskdetails/',data).success(function(response){
    //         deferred.resolve(response);
    //     }).error(function(error,status){
    //         deferred.reject(error);
    //     });
    //   return deferred.promise;
    // }
 
    // this.Status_Toggle = function(data){
    //     var deferred = $q.defer();
    //     $http.post(serviceBaseUrl+'statusfrontdeskdetails',data).success(function(response){
    //         deferred.resolve(response);
    //     }).error(function(error,status){
    //         deferred.reject(error);
    //     });
    //   return deferred.promise;
    // }

    this.upload_AudioFile_IVRS = function(url, file) {
        var deferred = $q.defer();
        var fd = new FormData();   
        fd.append('mp3', file);
        $http.post(url+"cloud/mp3/audio.php", fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined,'Process-Data': false}
        }).success(function(response) {
            deferred.resolve(response);
        }).error(function (error) {
            deferred.reject(error);
        });
    
     return deferred.promise;
    };

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('labtestService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

    this.getTestPackages = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'gettestpack?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id+'&filter_option='+data).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getSearchTestPackages = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'gettestpack?account_email='+authService.authentication.account_id+'&filter_option=title_like&filter_value='+'&doctor_id='+authService.authentication.doctor_id+data).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.addlabpack = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addtestpack',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updatePack = function(data) {
        var deferred = $q.defer();
        $http.put(serviceBaseUrl+'updatetestpack',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.deletelabmaster = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'deletelabmaster',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.searchDrug = function(drug_name, payload){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getconsultationinvestigation?account_email=' + authService.authentication.account_id + '&page_no=1'  + '&alphabet=' + drug_name)
         .success(function (response) {
          deferred.resolve(response);
        })
         .error(function (error, status) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

      this.addlabpacknew = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'newconsultationinvestigation',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('lifelogService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

    this.getLifelog = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'listlifelogitems?account_email='+authService.authentication.account_id+'&filter='+data).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updateLifelog = function (data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updatelifelogitem',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.addlifelogitem = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addlifelogitem',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    return this;

}]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Oct 2017
 */

'use strict';
angular.module('AngularApp').factory('locationService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

    this.getSettings = function () {
        var deferred = $q.defer();
        if(authService.authentication.account_id)
        {
            $http.get(serviceBaseUrl+'getsettings?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
                deferred.resolve(response);
            }).error(function (error, status) {
                deferred.reject(error);
            });
        }
        return deferred.promise;
    };

    this.addSettings = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addsettings',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getLocation = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getlocation?account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.addLocation = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addlocation',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updateLocation = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'editlocation',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('milestoneService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

	this.getSettings = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getsettings?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
			deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};
	
	this.addSettings = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addsettings',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

	this.loadMilestone = function(dataload) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'loadmilestone',dataload).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};
	
    this.milestonesList = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'milestoneslist?account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
	
	this.milestonesListBlock = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'listmilestoneblock?account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
	
	this.surveyAdd = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'surveyadd',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

	this.surveyHistoryList = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'surveyhistorylist?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
	
	this.surveyHistoryDetail = function (patient_email,tracker_id) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'surveyhistorydetail?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&tracker_id='+tracker_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateSurvey = function (data) {
		var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updatesurvey',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

	this.getBlockQuestions = function (type,month) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getblockquestions?account_email='+authService.authentication.account_id+'&type='+type+'&month='+month).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getPatientHistory = function (patient_email, type) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getpatienthistory?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&type='+type).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
	
	// this.getBlockQuestions = function () {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getblockquestions?account_email='+authService.authentication.account_id).success(function (response) {
	// 		deferred.resolve(response);
	// }).error(function (error, status) {
	// 	deferred.reject(error);
	// });
	// return deferred.promise;
	// };

	// this.saveMilestone = function (data){
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'addmilestones',data).success(function(response){
	// 		deferred.resolve(response);
	// 	}).error(function (error, status){
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// };

	this.updateMilestone = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatemilestone',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	// this.getCategory = function(data){
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'categorieslist?account_email='+authService.authentication.account_id+'&filter='+data).success(function(response) {
	// 		deferred.resolve(response);			
	// 	}).error(function (error, status){
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// };

	// this.addNewCategory = function (data){
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'addcategory',data).success(function(response){
	// 		deferred.resolve(response);
	// 	}).error(function (error, status){
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// };
	// createMilestonequestion

	this.createMilestonequestion = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatemilestonequestions',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getMilestonesquestion = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getmilestonequestions?id='+data.id+'&account_email='+data.account_email).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.removeMilestonesquestion = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'deletemilestonequestions?milestone_id='+data.milestone_id+'&account_email='+data.account_email+'&question_id='+data.question_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.searchEshopdetails = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'searcheceshopproducts?page_no='+data.page_no+'&account_email='+data.account_email+'&product_name='+data.product_name).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.linkEshopProduct = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createmilestoneproduct',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.searchEshopbyid = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'searchproductbyid?account_email='+data.account_email+'&eshop_product_id='+data.eshop_product_id+'&custom_qa_id='+data.id).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getEshopLinking = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getmilestoneproducts?custom_qa_id='+data.id+'&account_email='+data.account_email).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.removeEshopLinking = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'deletemilestoneproduct?custom_qa_id='+data.id+'&account_email='+data.account_email+'&eshop_product_id='+data.product_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.milestoneDaterange = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'fetchmilestonedaterange',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.activitycreate = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createmilestoneactivity',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getActivitycard = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getmilestoneactivity?account_email='+data.account_email+'&sno='+data.sno).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.deleteActivitycard = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'deletemilestoneactivity?account_email='+data.account_email+'&activity_id='+data.id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.searchEshopbyidactivity = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'searchproductbyid?account_email='+data.account_email+'&eshop_product_id='+data.eshop_product_id).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.activitycardUpdate = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatemilestoneactivity',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getEshopLinkingcoupon = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getmilestoneproducts?'+'account_email='+data.account_email).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

    return this;

}]);
'use strict';
angular.module('AngularApp').factory('multicenterStudyService', ['$http', '$q', 'serviceBaseUrl','authService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl) {
    
    var helyxonApi_Url = helyxonApiUrl; 
     
	
    this.AllDoctorIncharge = function (data) {
        console.log('data',data);
        var deferred = $q.defer();
        // $http.get(helyxonApi_Url+'getdoctorincharge/?demail='+authService.authentication.account_id).success(function (response) {
        $http.get(serviceBaseUrl+'getdoctorincharge/?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id+'&type='+data+'&status_type=discharge').success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.activateDoctorIncharge = function (data) {
        console.log('data',data);
        var deferred = $q.defer();
        // $http.get(helyxonApi_Url+'getdoctorincharge/?demail='+authService.authentication.account_id).success(function (response) {
        $http.get(serviceBaseUrl+'getdoctorincharge/?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id+'&type='+data+'&status_type=discharge').success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };
    
    this.deactivateDoctorIncharge = function (data) {
        console.log('data',data);
        var deferred = $q.defer();
        // $http.get(helyxonApi_Url+'getdoctorincharge/?demail='+authService.authentication.account_id).success(function (response) {
            console.log('authService.authentication.account_id',authService.authentication.account_id ,authService.authentication.doctor_id)
        $http.get(serviceBaseUrl+'getdoctorincharge/?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id+'&type='+data+'&status_type=discharge').success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.DoctorIncharge = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'doctorincharge/',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.DeleteIncharge = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'doctorincharge/',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.update_multicenter = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'doctorincharge/',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    return this;
    }


]);

angular.module('AngularApp').factory('multicenterstudyreportService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

    this.getBabyRegistration = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getbabyregistercount?account_email='+data.account_id+'&from_date='+data.from_date + '&to_date='+data.to_date).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getBabiesvsCommunityVisit  = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getbabiesvscommunityvisit?account_email='+data.account_email+'&from_date='+data.from_date+'&to_date='+data.to_date).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getDeadvsTimeAfterdelivery  = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getdeadvstimeafterdelivery?account_email='+data.account_email+'&start_date='+data.start_date+ '&end_date='+data.end_date).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getBabyGrowthEverystage  = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'babygrowthoneverystagecommunity?account_email='+data.account_email+'&start_dt='+data.start_dt+ '&end_dt='+data.end_dt).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getReadmittedBaby  = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getreadmittedbabystatusicds?account_email='+data.account_email+'&start_date='+data.start_date+ '&end_date='+data.end_date).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getBabyMalnutrition = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getbabymalnutritionicds?account_email='+data.account_email+'&start_date='+data.start_date+ '&end_date='+data.end_date).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getsupervisorReport = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getsupervisorfollowupbydate?account_email='+data.account_id+'&from_date='+data.from_date+ '&to_date='+data.to_date).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getnotinterestedReport = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getbabydisinterestedicds',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.getcommunityfollowbydateReport = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getcommunityfollowbydate',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.getinstitutionalfollowbydateReport = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getinstitutionalfollowbydate',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.gettelephonefollowbydateReport = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'gettelephonefollowbydate',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    };

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('multipartFormdata', ['$http', '$q', 'authService', '$sessionStorage', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl, $sessionStorage) {
   
    this.uploadpdfToUrl = function(url, file) {
        var deferred = $q.defer();
        var data = new FormData();
        data.append('pdf', file);
        
        $http.post(url+"cloud/pdf/pdf.php", data, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined,'Process-Data': false}
        }).success(function(response) {
            deferred.resolve(response);
        }).error(function (error) {
            deferred.reject(error);
        })

        return deferred.promise;
    };

    this.uploadvideoToUrl = function(url, file) {
        var deferred = $q.defer();
        var data = new FormData();
        data.append('video', file);
        
        $http.post(url+"cloud/image/video.php", data, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined,'Process-Data': false}
        }).success(function(response) {
            deferred.resolve(response);
        }).error(function (error) {
            deferred.reject(error);
        })

        return deferred.promise;
    };

    this.uploadaudioToUrl = function(url, file) {
        var deferred = $q.defer();
        var data = new FormData();
        data.append('mp3', file);
        
        $http.post(url+"cloud/mp3/audio.php", data, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined,'Process-Data': false}
        }).success(function(response) {
            deferred.resolve(response);
        }).error(function (error) {
            deferred.reject(error);
        })

        return deferred.promise;
    };

    this.uploadFileToUrl = function(url, file) {
       
        /*  var form = new FormData();
           form.append("photo", file);
   
           var req = {
               url: url+"cloud/image/image.php",
               method: "POST",
               timeout: 0,
               headers: {
                 "Content-Type": "multipart/form-data; boundary=--------------------------695171695258543362953829"
               },
               processData: false,
               mimeType: "multipart/form-data",
               contentType: false,
               data: form
           };
          /* var req = {
               method: 'POST',
               url: url+'cloud/image/data_image.php',
               headers: {
                   'Content-Type': undefined,
               },
               data: file
           }*/
   
        /* $http(payload).then(function(response){
               console.log(response);
               deferred.resolve(response);
           }, function(error){
               console.log(error);
               deferred.reject(error);
           }); */
   
           var deferred = $q.defer();
           var data = new FormData();
           data.append('photo', file);
           
           $http.post(url+"/cloud/image/image.php", data, {
               transformRequest: angular.identity,
               headers: {'Content-Type': undefined,'Process-Data': false}
           }).success(function(response) {
               deferred.resolve(response);
           }).error(function (error) {
               deferred.reject(error);
           })
   
           return deferred.promise;
       };

    this.uploadFileToUrl11 = function(url, file) {
    
    /*  var form = new FormData();
        form.append("photo", file);

        var req = {
            url: url+"cloud/image/image.php",
            method: "POST",
            timeout: 0,
            headers: {
                "Content-Type": "multipart/form-data; boundary=--------------------------695171695258543362953829"
            },
            processData: false,
            mimeType: "multipart/form-data",
            contentType: false,
            data: form
        };
        /* var req = {
            method: 'POST',
            url: url+'cloud/image/data_image.php',
            headers: {
                'Content-Type': undefined,
            },
            data: file
        }*/

    /* $http(payload).then(function(response){
            console.log(response);
            deferred.resolve(response);
        }, function(error){
            console.log(error);
            deferred.reject(error);
        }); */

        var deferred = $q.defer();
        var data = new FormData();
        data.append('photo', file);
        
        $http.post(url+"cloud/image/image.php", data, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined,'Process-Data': false}
        }).success(function(response) {
            deferred.resolve(response);
        }).error(function (error) {
            deferred.reject(error);
        })

        return deferred.promise;
    };

    this.uploadFileBase64 = function(url, data) {
        var deferred = $q.defer();
      //var data = new FormData();
      //data.append('photo', data);

        $http.post( url+"cloud/image/data_image.php", data, {
            transformRequest: angular.identity,
            headers: {'Content-Type': multipart/form-data,'Process-Data': false}
        }).success(function(response) {
            deferred.resolve(response);
        }).error(function (error) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    return this; 
}])
'use strict';
angular.module('AngularApp').factory('notificationlistService', ['$http', '$q', 'serviceBaseUrl', function ($http, $q, serviceBaseUrl) {
		
	this.getnotificationlist = function (doctorId) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl + 'sentnotification',{account_id:doctorId}).success(function (response) {
		deferred.resolve(response);
	}).error(function (error, status) {
		deferred.reject(error);
	});
	return deferred.promise;
	};
	
	 
		return this;
} ]);
'use strict';
angular.module('AngularApp').factory('obstgynecService', ['$http', '$q', 'serviceBaseUrl', 'authService', 'localStorageService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl, localStorageService) {
	
	var helyxonApi_Url = helyxonApiUrl;  	

	this.saveobstHist = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createobsthistory', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getObstDetails = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getobsthistory?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};
	
	this.saveParaDetails = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createpara', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getParaDetails = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getpara?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    

    this.saveAbortionsDetails = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createabortions', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
    }

    this.getAbortionsDetails = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getabortions?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.saveCurrentPregnancy = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createcurrentpregnancy', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}
	
	this.getCurrentPregnancy = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getcurrentpregnancy?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};
	
	this.saveCurrentPregnancyRec = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createpregnancyrecord', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getCurrentPregnancyRec = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getpregnancyrecord?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&status=1').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

	this.getarchivedCurrentPregnancyRec = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getpregnancyrecord?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&status=0').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

	this.savescanreport = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createusscanreport', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getscanreport = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getusscanreport?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&doctor_id='+authService.authentication.doctor_id+'&status=1').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

	this.getarchivedscanreport = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getusscanreport?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&doctor_id='+authService.authentication.doctor_id+'&status=0').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};


	this.savegynecHist = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'creategynaehistory', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}
	
	this.getgynecHist = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getgynaechistory?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

	this.savefollicleStudy = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createfollicular', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getfollicleStudy = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getfollicular?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&status=1').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

	this.getarchivedfollicleStudy = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getfollicular?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&status=0').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

	this.saveriskvalue = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createrisk', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getriskvalue = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getrisk?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&status=1').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

	this.getarchivedriskvalue = function (patient_email) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getrisk?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&status=0').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
	
    return this;
} ]);
'use strict';
angular.module('AngularApp').factory('othersettingService', ['$http', '$q', 'serviceBaseUrl', 'authService', 'localStorageService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl, localStorageService) {
	
	var helyxonApi_Url = helyxonApiUrl;  	

	this.savewaiversettings = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createfollowupsettings', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getwaiversettings = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getfollowupsettings?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};
	
	// this.saveParaDetails = function(data) {
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'createpara', data).success( function(response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// }

	// this.getParaDetails = function (patient_email) {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getpara?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
	// 	    deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
    // };
    

    // this.saveAbortionsDetails = function(data) {
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'createabortions', data).success( function(response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
    // }

    // this.getAbortionsDetails = function (patient_email) {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getabortions?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
	// 	    deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
    // };

    // this.saveCurrentPregnancy = function(data) {
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'createcurrentpregnancy', data).success( function(response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// }
	
	// this.getCurrentPregnancy = function (patient_email) {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getcurrentpregnancy?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
	// 	    deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
	// };
	
	// this.saveCurrentPregnancyRec = function(data) {
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'createpregnancyrecord', data).success( function(response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// }

	// this.getCurrentPregnancyRec = function (patient_email) {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getpregnancyrecord?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
	// 	    deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
	// };

	// this.savescanreport = function(data) {
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'createusscanreport', data).success( function(response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// }

	// this.getscanreport = function (patient_email) {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getusscanreport?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
	// 	    deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
	// };


	// this.savegynecHist = function(data) {
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'creategynaehistory', data).success( function(response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// }
	
	// this.getgynecHist = function (patient_email) {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getgynaechistory?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
	// 	    deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
    // };

	// this.savefollicleStudy = function(data) {
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'createfollicular', data).success( function(response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// }

	// this.getfollicleStudy = function (patient_email) {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getfollicular?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
	// 	    deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
    // };

	// this.saveriskvalue = function(data) {
	// 	var deferred = $q.defer();
	// 	$http.post(serviceBaseUrl+'createrisk', data).success( function(response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// }

	// this.getriskvalue = function (patient_email) {
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getrisk?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
	// 	    deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });
    //     return deferred.promise;
    // };
	
    return this;
} ]);
'use strict';
angular.module('AngularApp').factory('patientlistService', ['$http', '$q', 'serviceBaseUrl', 'authService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl) {
	
	var helyxonApi_Url = helyxonApiUrl;  	
	
	this.getpatientlist = function (doctorId) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl + 'demolist',{record_id:doctorId}).success(function (response) {
		    deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
    
	this.upcomingVaccinationList = function(data){
        var deferred = $q.defer();       
        $http.get(serviceBaseUrl+'upcominvaccination?account_email='+authService.authentication.account_id+data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
	};
	
	this.patientHeightCalc = function(data){
        var deferred = $q.defer();       
        $http.get(helyxonApi_Url+'mh/api/v3.0/growth.php?'+data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    };

	this.getPatientLists = function (doctorId,date1) {
		
		var deferred = $q.defer();
		$http.post(serviceBaseUrl + 'deltademo',{record_id:doctorId,date:new Date()}).success(function (response) {		
		    deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getPatientRegistrationList = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'crcandctspatientsdetails', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

    return this;
} ]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict';
angular.module('AngularApp').factory('paymentService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

    this.getSettings = function () {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getsettings?account_email='+authService.authentication.account_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.addSettings = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addsettings',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    // this.getPaymentSetting = function() {
    //     var deferred = $q.defer();
    //     $http.get(serviceBaseUrl+'getpaymentsetting?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
    //         deferred.resolve(response);
    //     }).error(function (error, status) {
    //         deferred.reject(error);
    //     });

    //     return deferred.promise;
    // };

    this.getPaymentSetting = function() {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getpaymentmaster?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    this.createPaymentSetting = function (){
        var deferred = $q.defer();
        var payload = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id,
        }
        $http.post(serviceBaseUrl+'createservicesetting',payload).success(function (response) {
            deferred.resolve(response);
            console.log('createservicesetting',response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    }

    this.updatePaymentSetting = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updatepaymentsetting', data).success(function(response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    this.raiseInvoice = function(data) {
        var deferred = $q.defer();
        console.log(data);
        $http.post(serviceBaseUrl+'raiseinvoice',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    //wallet balance api
    this.walletBalance=function(data){
        var deferred=$q.defer();
        $http.post(serviceBaseUrl+'walletbalance',data).success(function(response){
            deferred.resolve(response);
         }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    }

    this.add_newconferencevideocall = function(data){
        var deferred=$q.defer();
        $http.post(serviceBaseUrl+'confvideocall/',data).success(function(response){
            deferred.resolve(response);
         }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    }

    this.update_newconferencevideocall = function(data){
        var deferred=$q.defer();
        $http.post(serviceBaseUrl+'confvideocall/',data).success(function(response){
            deferred.resolve(response);
         }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    }

    this.deactivate_confvideocall = function(data){
        var deferred=$q.defer();
        $http.post(serviceBaseUrl+'confvideocall/',data).success(function(response){
            deferred.resolve(response);
         }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    }

    this.getconf_videocall = function(data){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getconfvideocall?account_email='+authService.authentication.account_id+'&app_id='+data.app).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    }

    this.Patientreceipt = function(data,billno){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'patientreceipt?account_email='+authService.authentication.account_id+'&patient_email='+data.patient_email+'&bill_no='+billno+'&status='+data.status+'&doctor_id='+data.doctor_id).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.get_printPayment = function(data,billno){
        var deferred = $q.defer();
        console.log('data patient email',data);
        $http.get(serviceBaseUrl+'patientreceipt?account_email='+authService.authentication.account_id+'&patient_email='+data+'&bill_no='+billno).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.paymentReport = function(data){
        var deferred = $q.defer();
       
        $http.get(serviceBaseUrl+'paymentreport?account_email='+authService.authentication.account_id+data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.DailyCollection=function(data){
        var deferred = $q.defer();
         $http.get(serviceBaseUrl+'reportcollection?account_email='+authService.authentication.account_id+'&date='+data).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });       
        return deferred.promise;
    }
    this.rangeCollection = function(data){
        var defferred = $q.defer();
        $http.get(serviceBaseUrl+'reportcollection?account_email='+authService.authentication.account_id+data).success(function(response){
            defferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
        return defferred.promise;
    }

    /** Get the Wallet Balance*/
    this.getWalletBalance = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'walletbalance',data).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    };
    this.getPendingPayment = function(patient_email){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getpendingpayment?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    this.makepayment = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'makepayment',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getPayCategoryList = function(data){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getcategory?account_email='+authService.authentication.account_id).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.addNewPayCategory = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'addcategory',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updatePayCategory = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'categoryupdate',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getWalletHistory = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getwallethistory',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getDoctorWallet = function(data){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'doctorwalletstatusget?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.addDoctorWalletStatus = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'doctorwalletstatusadd',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.updatemodulestatus = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updatemodulestatus',data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getvideocallhistory = function(data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'getvideocallhistory',data).success(function (response) {
            console.log('response in payment',response);
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    
    this.getgrowthchartreport = function(data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getanthrodaterange?account_email='+authService.authentication.account_id
        +'&from_date='+data.from_date+'&to_date='+data.to_date+'&height_value='+data.height_value+'&weight_value='+data.weight_value+'&hc_value='+data.hc_value).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getsubexpiryreport = function(data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getexpiredsubscribers?account_email='+authService.authentication.account_id
        +'&from_date='+data.from_date+'&to_date='+data.to_date).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getDates = function(data) {
        var deferred = $q.defer();
        
        // rx447@rxcarenet.org
        $http.get(serviceBaseUrl+'getpatientstartdate?account_email='+authService.authentication.account_id
        +'&patient_email='+data.patientemail+'&from_date='+data.dateValue).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    }

    this.covidSurvay = function(patient_email,fromDate,toDate) {
        var deferred = $q.defer();
        
        $http.get(serviceBaseUrl+'getpatientsurveybydate?account_email='+authService.authentication.account_id
        +'&patient_email='+patient_email+'&from_date='+fromDate+'&to_date='+toDate).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    }

    this.ivitalData = function(patient_email,fromDate,toDate) {
        var deferred = $q.defer();
       
        $http.get(serviceBaseUrl+'gethelvitalforcovidsurvey?account_email='+authService.authentication.account_id
        +'&patient_email='+patient_email+'&from_date='+fromDate+'&to_date='+toDate).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    }


    this.followupreport = function(fromDate,toDate) {
        var deferred = $q.defer();
       
        $http.get(serviceBaseUrl+'getfollowup?account_email='+authService.authentication.account_id
        +'&doctor_id='+authService.authentication.doctor_id+'&from_date='+fromDate+'&to_date='+toDate).success(function(response) {
            deferred.resolve(response);         
        }).error(function (error, status){
            deferred.reject(error);
        });
        return deferred.promise;
    }

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('payoutService', ['$http', '$q', 'serviceBaseUrl', 'authService', 'localStorageService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl, localStorageService) {
	
	var helyxonApi_Url = helyxonApiUrl;  	

	this.getdrBankdetails = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdoctorbankdetails?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};
	
    this.getdrwallet = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdoctorwallet?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

    this.getwithdrawalfreq = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getwithdrawfrequency?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

    this.createwithdrawalFreq = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createwithdrawfrequency', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

    return this;
} ]);
'use strict';
angular.module('AngularApp').factory('percentileService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService', function ($http, $q, serviceBaseUrl, localStorageService) {
	var n = [50,50.399,50.798,51.197,51.595,51.994,52.392,52.79,53.188,53.586,53.983,54.38,54.776,55.172,55.567,55.962,56.356,56.749,57.142,57.535,57.926,58.317,58.706,59.095,59.483,59.871,60.257,60.642,61.026,61.409,61.791,62.172,62.552,62.93,63.307,63.683,64.058,64.431,64.803,65.173,65.542,65.91,66.276,66.64,67.003,67.364,67.724,68.082,68.439,68.793,69.146,69.497,69.847,70.194,70.54,70.884,71.226,71.566,71.904,72.24,72.575,72.907,73.237,73.565,73.891,74.215,74.537,74.857,75.175,75.49,75.804,76.115,76.424,76.73,77.035,77.337,77.637,77.935,78.23,78.524,78.814,79.103,79.389,79.673,79.955,80.234,80.511,80.785,81.057,81.327,81.594,81.859,82.121,82.381,82.639,82.894,83.147,83.398,83.646,83.891,84.134,84.375,84.614,84.849,85.083,85.314,85.543,85.769,85.993,86.214,86.433,86.65,86.864,87.076,87.286,87.493,87.698,87.9,88.1,88.298,88.493,88.686,88.877,89.065,89.251,89.435,89.617,89.796,89.973,90.147,90.32,90.49,90.658,90.824,90.988,91.149,91.308,91.466,91.621,91.774,91.924,92.073,92.22,92.364,92.507,92.647,92.785,92.922,93.056,93.189,93.319,93.448,93.574,93.699,93.822,93.943,94.062,94.179,94.295,94.408,94.52,94.63,94.738,94.845,94.95,95.053,95.154,95.254,95.352,95.449,95.543,95.637,95.728,95.818,95.907,95.994,96.08,96.164,96.246,96.327,96.407,96.485,96.562,96.638,96.712,96.784,96.856,96.926,96.995,97.062,97.128,97.193,97.257,97.32,97.381,97.441,97.5,97.558,97.615,97.67,97.725,97.778,97.831,97.882,97.932,97.982,98.03,98.077,98.124,98.169,98.214,98.257,98.3,98.341,98.382,98.422,98.461,98.5,98.537,98.574,98.61,98.645,98.679,98.713,98.745,98.778,98.809,98.84,98.87,98.899,98.928,98.956,98.983,99.01,99.036,99.061,99.086,99.111,99.134,99.158,99.18,99.202,99.224,99.245,99.266,99.286,99.305,99.324,99.343,99.361,99.379,99.396,99.413,99.43,99.446,99.461,99.477,99.492,99.506,99.52,99.534,99.547,99.56,99.573,99.585,99.598,99.609,99.621,99.632,99.643,99.653,99.664,99.674,99.683,99.693,99.702,99.711,99.72,99.728,99.736,99.744,99.752,99.76,99.767,99.774,99.781,99.788,99.795,99.801,99.807,99.813,99.819,99.825,99.831,99.836,99.841,99.846,99.851,99.856,99.861,99.865,99.869,99.874,99.878,99.882,99.886,99.889,99.893,99.896,99.9];
	function power(x,y){
		return Math.pow(x,y);
	}
	function fixDP(r, dps) {
		if (isNaN(r)) return "NaN";
		var msign = '';
		if (r < 0) msign = '-';
		x = Math.abs(r);
		if (x > Math.pow(10, 21)) return msign + x.toString();
		var m = Math.round(x * Math.pow(10, dps)).toString();
		if (dps == 0) return msign + m;
		while (m.length <= dps) m = "0" + m;
		return msign + m.substring(0, m.length - dps) + "." + m.substring(m.length - dps);
	}
	function ZtoPercentile(z){
		var az = Math.abs(z);
		if (z < -3.09) return 0.1;
		if (z > 3.09) return 99.9;
		var thispercentile = n[Math.round(az * 100)];
		if (z >= 0) { return thispercentile }
		else { return 100 - thispercentile }
	}
	var HeightPercentile = function(data) {
        var doCalc = true;

        var Height = data.height;
        var Age_Months =  data.age;
		var L, M, S;

        if(Age_Months >= 24 && Age_Months < 25){L = 1.00720807; M = 86.86160934; S = 0.040395626;};
        if(Age_Months >= 25 && Age_Months < 26){L = 0.837251351; M = 87.65247282; S = 0.040577525;};
        if(Age_Months >= 26 && Age_Months < 27){L = 0.681492975; M = 88.42326434; S = 0.040723122;};
        if(Age_Months >= 27 && Age_Months < 28){L = 0.538779654; M = 89.17549228; S = 0.040833194;};
        if(Age_Months >= 28 && Age_Months < 29){L = 0.407697153; M = 89.91040853; S = 0.040909059;};
        if(Age_Months >= 29 && Age_Months < 30){L = 0.286762453; M = 90.62907762; S = 0.040952433;};
        if(Age_Months >= 30 && Age_Months < 31){L = 0.174489485; M = 91.33242379; S = 0.04096533;};
        if(Age_Months >= 31 && Age_Months < 32){L = 0.069444521; M = 92.02127167; S = 0.040949976;};
        if(Age_Months >= 32 && Age_Months < 33){L = -0.029720564; M = 92.69637946; S = 0.040908737;};
        if(Age_Months >= 33 && Age_Months < 34){L = -0.124251789; M = 93.35846546; S = 0.040844062;};
        if(Age_Months >= 34 && Age_Months < 35){L = -0.215288396; M = 94.00822923; S = 0.040758431;};
        if(Age_Months >= 35 && Age_Months < 36){L = -0.30385434; M = 94.64636981; S = 0.040654312;};
        if(Age_Months >= 36 && Age_Months < 37){L = -0.390918369; M = 95.27359106; S = 0.04053412;};
        if(Age_Months >= 37 && Age_Months < 38){L = -0.254801167; M = 95.91474929; S = 0.040572876;};
        if(Age_Months >= 38 && Age_Months < 39){L = -0.125654535; M = 96.54734328; S = 0.04061691;};
        if(Age_Months >= 39 && Age_Months < 40){L = -0.00316735; M = 97.17191309; S = 0.040666414;};
        if(Age_Months >= 40 && Age_Months < 41){L = 0.11291221; M = 97.78897727; S = 0.040721467;};
        if(Age_Months >= 41 && Age_Months < 42){L = 0.222754969; M = 98.3990283; S = 0.040782045;};
        if(Age_Months >= 42 && Age_Months < 43){L = 0.326530126; M = 99.00254338; S = 0.040848042;};
        if(Age_Months >= 43 && Age_Months < 44){L = 0.42436156; M = 99.599977; S = 0.040919281;};
        if(Age_Months >= 44 && Age_Months < 45){L = 0.516353108; M = 100.191764; S = 0.040995524;};
        if(Age_Months >= 45 && Age_Months < 46){L = 0.602595306; M = 100.7783198; S = 0.041076485;};
        if(Age_Months >= 46 && Age_Months < 47){L = 0.683170764; M = 101.3600411; S = 0.041161838;};
        if(Age_Months >= 47 && Age_Months < 48){L = 0.758158406; M = 101.9373058; S = 0.041251224;};
        if(Age_Months >= 48 && Age_Months < 49){L = 0.827636736; M = 102.5104735; S = 0.041344257;};
        if(Age_Months >= 49 && Age_Months < 50){L = 0.891686306; M = 103.0798852; S = 0.041440534;};
        if(Age_Months >= 50 && Age_Months < 51){L = 0.95039153; M = 103.645864; S = 0.041539635;};
        if(Age_Months >= 51 && Age_Months < 52){L = 1.003830006; M = 104.208713; S = 0.041641136;};
        if(Age_Months >= 52 && Age_Months < 53){L = 1.05213569; M = 104.7687256; S = 0.041744602;};
        if(Age_Months >= 53 && Age_Months < 54){L = 1.0953669; M = 105.3261638; S = 0.041849607;};
        if(Age_Months >= 54 && Age_Months < 55){L = 1.133652119; M = 105.8812823; S = 0.041955723;};
        if(Age_Months >= 55 && Age_Months < 56){L = 1.167104213; M = 106.4343146; S = 0.042062532;};
        if(Age_Months >= 56 && Age_Months < 57){L = 1.195845353; M = 106.9854769; S = 0.042169628;};
        if(Age_Months >= 57 && Age_Months < 58){L = 1.220004233; M = 107.534968; S = 0.042276619;};
        if(Age_Months >= 58 && Age_Months < 59){L = 1.239715856; M = 108.0829695; S = 0.042383129;};
        if(Age_Months >= 59 && Age_Months < 60){L = 1.255121285; M = 108.6296457; S = 0.042488804;};
        if(Age_Months >= 60 && Age_Months < 61){L = 1.266367398; M = 109.1751441; S = 0.042593311;};
        if(Age_Months >= 61 && Age_Months < 62){L = 1.273606657; M = 109.7195954; S = 0.042696342;};
        if(Age_Months >= 62 && Age_Months < 63){L = 1.276996893; M = 110.2631136; S = 0.042797615;};
        if(Age_Months >= 63 && Age_Months < 64){L = 1.276701119; M = 110.8057967; S = 0.042896877;};
        if(Age_Months >= 64 && Age_Months < 65){L = 1.272887366; M = 111.3477265; S = 0.042993904;};
        if(Age_Months >= 65 && Age_Months < 66){L = 1.265728536; M = 111.8889694; S = 0.043088503;};
        if(Age_Months >= 66 && Age_Months < 67){L = 1.255402281; M = 112.4295761; S = 0.043180513;};
        if(Age_Months >= 67 && Age_Months < 68){L = 1.242090871; M = 112.9695827; S = 0.043269806;};
        if(Age_Months >= 68 && Age_Months < 69){L = 1.225981067; M = 113.5090108; S = 0.043356287;};
        if(Age_Months >= 69 && Age_Months < 70){L = 1.207263978; M = 114.0478678; S = 0.043439893;};
        if(Age_Months >= 70 && Age_Months < 71){L = 1.186140222; M = 114.5861486; S = 0.043520597;};
        if(Age_Months >= 71 && Age_Months < 72){L = 1.162796198; M = 115.1238315; S = 0.043598407;};
        if(Age_Months >= 72 && Age_Months < 73){L = 1.137442868; M = 115.6608862; S = 0.043673359;};
        if(Age_Months >= 73 && Age_Months < 74){L = 1.110286487; M = 116.1972691; S = 0.043745523;};
        if(Age_Months >= 74 && Age_Months < 75){L = 1.081536236; M = 116.732925; S = 0.043815003;};
        if(Age_Months >= 75 && Age_Months < 76){L = 1.05140374; M = 117.2677879; S = 0.043881929;};
        if(Age_Months >= 76 && Age_Months < 77){L = 1.020102497; M = 117.8017819; S = 0.043946461;};
        if(Age_Months >= 77 && Age_Months < 78){L = 0.987847213; M = 118.3348215; S = 0.044008785;};
        if(Age_Months >= 78 && Age_Months < 79){L = 0.954853043; M = 118.8668123; S = 0.044069112;};
        if(Age_Months >= 79 && Age_Months < 80){L = 0.921334742; M = 119.397652; S = 0.044127675;};
        if(Age_Months >= 80 && Age_Months < 81){L = 0.887505723; M = 119.9272309; S = 0.044184725;};
        if(Age_Months >= 81 && Age_Months < 82){L = 0.85357703; M = 120.455433; S = 0.044240532;};
        if(Age_Months >= 82 && Age_Months < 83){L = 0.819756239; M = 120.9821362; S = 0.044295379;};
        if(Age_Months >= 83 && Age_Months < 84){L = 0.786246296; M = 121.5072136; S = 0.044349559;};
        if(Age_Months >= 84 && Age_Months < 85){L = 0.753244292; M = 122.0305342; S = 0.044403374;};
        if(Age_Months >= 85 && Age_Months < 86){L = 0.720940222; M = 122.5519634; S = 0.04445713;};
        if(Age_Months >= 86 && Age_Months < 87){L = 0.689515708; M = 123.0713645; S = 0.044511135;};
        if(Age_Months >= 87 && Age_Months < 88){L = 0.659142731; M = 123.588599; S = 0.044565693;};
        if(Age_Months >= 88 && Age_Months < 89){L = 0.629997853; M = 124.1035312; S = 0.044621104;};
        if(Age_Months >= 89 && Age_Months < 90){L = 0.602203984; M = 124.6160161; S = 0.044677662;};
        if(Age_Months >= 90 && Age_Months < 91){L = 0.575908038; M = 125.1259182; S = 0.044735646;};
        if(Age_Months >= 91 && Age_Months < 92){L = 0.55123134; M = 125.6331012; S = 0.044795322;};
        if(Age_Months >= 92 && Age_Months < 93){L = 0.528279901; M = 126.1374319; S = 0.044856941;};
        if(Age_Months >= 93 && Age_Months < 94){L = 0.507143576; M = 126.6387804; S = 0.04492073;};
        if(Age_Months >= 94 && Age_Months < 95){L = 0.487895344; M = 127.1370217; S = 0.044986899;};
        if(Age_Months >= 95 && Age_Months < 96){L = 0.470590753; M = 127.6320362; S = 0.045055632;};
        if(Age_Months >= 96 && Age_Months < 97){L = 0.455267507; M = 128.1237104; S = 0.045127088;};
        if(Age_Months >= 97 && Age_Months < 98){L = 0.441945241; M = 128.6119383; S = 0.045201399;};
        if(Age_Months >= 98 && Age_Months < 99){L = 0.430625458; M = 129.096622; S = 0.045278671;};
        if(Age_Months >= 99 && Age_Months < 100){L = 0.421291648; M = 129.5776723; S = 0.045358979;};
        if(Age_Months >= 100 && Age_Months < 101){L = 0.413909588; M = 130.0550101; S = 0.045442372;};
        if(Age_Months >= 101 && Age_Months < 102){L = 0.408427813; M = 130.5285669; S = 0.045528869;};
        if(Age_Months >= 102 && Age_Months < 103){L = 0.404778262; M = 130.9982857; S = 0.045618459;};
        if(Age_Months >= 103 && Age_Months < 104){L = 0.402877077; M = 131.4641218; S = 0.045711105;};
        if(Age_Months >= 104 && Age_Months < 105){L = 0.402625561; M = 131.9260439; S = 0.045806742;};
        if(Age_Months >= 105 && Age_Months < 106){L = 0.40391127; M = 132.3840348; S = 0.045905281;};
        if(Age_Months >= 106 && Age_Months < 107){L = 0.406609232; M = 132.838092; S = 0.046006604;};
        if(Age_Months >= 107 && Age_Months < 108){L = 0.410583274; M = 133.2882291; S = 0.046110573;};
        if(Age_Months >= 108 && Age_Months < 109){L = 0.415687443; M = 133.7344759; S = 0.046217028;};
        if(Age_Months >= 109 && Age_Months < 110){L = 0.421767514; M = 134.1768801; S = 0.04632579;};
        if(Age_Months >= 110 && Age_Months < 111){L = 0.428662551; M = 134.6155076; S = 0.046436662;};
        if(Age_Months >= 111 && Age_Months < 112){L = 0.436206531; M = 135.0504433; S = 0.04654943;};
        if(Age_Months >= 112 && Age_Months < 113){L = 0.44423; M = 135.4817925; S = 0.046663871;};
        if(Age_Months >= 113 && Age_Months < 114){L = 0.45256176; M = 135.9096813; S = 0.046779748;};
        if(Age_Months >= 114 && Age_Months < 115){L = 0.461030578; M = 136.3342577; S = 0.046896817;};
        if(Age_Months >= 115 && Age_Months < 116){L = 0.469466904; M = 136.7556923; S = 0.047014827;};
        if(Age_Months >= 116 && Age_Months < 117){L = 0.477704608; M = 137.1741794; S = 0.047133525;};
        if(Age_Months >= 117 && Age_Months < 118){L = 0.48558272; M = 137.5899378; S = 0.047252654;};
        if(Age_Months >= 118 && Age_Months < 119){L = 0.492947182; M = 138.0032114; S = 0.047371961;};
        if(Age_Months >= 119 && Age_Months < 120){L = 0.499652617; M = 138.4142703; S = 0.047491194;};
        if(Age_Months >= 120 && Age_Months < 121){L = 0.505564115; M = 138.8234114; S = 0.047610108;};
        if(Age_Months >= 121 && Age_Months < 122){L = 0.510559047; M = 139.2309592; S = 0.047728463;};
        if(Age_Months >= 122 && Age_Months < 123){L = 0.514528903; M = 139.6372663; S = 0.04784603;};
        if(Age_Months >= 123 && Age_Months < 124){L = 0.517381177; M = 140.042714; S = 0.047962592;};
        if(Age_Months >= 124 && Age_Months < 125){L = 0.519041285; M = 140.4477127; S = 0.048077942;};
        if(Age_Months >= 125 && Age_Months < 126){L = 0.519454524; M = 140.8527022; S = 0.048191889;};
        if(Age_Months >= 126 && Age_Months < 127){L = 0.518588072; M = 141.2581515; S = 0.048304259;};
        if(Age_Months >= 127 && Age_Months < 128){L = 0.516433004; M = 141.6645592; S = 0.048414893;};
        if(Age_Months >= 128 && Age_Months < 129){L = 0.513006312; M = 142.072452; S = 0.048523648;};
        if(Age_Months >= 129 && Age_Months < 130){L = 0.508352901; M = 142.4823852; S = 0.048630402;};
        if(Age_Months >= 130 && Age_Months < 131){L = 0.502547502; M = 142.8949403; S = 0.04873505;};
        if(Age_Months >= 131 && Age_Months < 132){L = 0.495696454; M = 143.3107241; S = 0.048837504;};
        if(Age_Months >= 132 && Age_Months < 133){L = 0.487939275; M = 143.7303663; S = 0.048937694;};
        if(Age_Months >= 133 && Age_Months < 134){L = 0.479449924; M = 144.1545167; S = 0.049035564;};
        if(Age_Months >= 134 && Age_Months < 135){L = 0.470437652; M = 144.5838414; S = 0.049131073;};
        if(Age_Months >= 135 && Age_Months < 136){L = 0.461147305; M = 145.0190192; S = 0.049224189;};
        if(Age_Months >= 136 && Age_Months < 137){L = 0.451858946; M = 145.4607359; S = 0.049314887;};
        if(Age_Months >= 137 && Age_Months < 138){L = 0.442886661; M = 145.9096784; S = 0.049403145;};
        if(Age_Months >= 138 && Age_Months < 139){L = 0.434576385; M = 146.3665278; S = 0.049488934;};
        if(Age_Months >= 139 && Age_Months < 140){L = 0.427302633; M = 146.8319513; S = 0.049572216;};
        if(Age_Months >= 140 && Age_Months < 141){L = 0.421464027; M = 147.3065929; S = 0.049652935;};
        if(Age_Months >= 141 && Age_Months < 142){L = 0.417477538; M = 147.7910635; S = 0.049731004;};
        if(Age_Months >= 142 && Age_Months < 143){L = 0.415771438; M = 148.2859294; S = 0.0498063;};
        if(Age_Months >= 143 && Age_Months < 144){L = 0.416777012; M = 148.7917006; S = 0.04987865;};
        if(Age_Months >= 144 && Age_Months < 145){L = 0.420919142; M = 149.3088178; S = 0.049947823;};
        if(Age_Months >= 145 && Age_Months < 146){L = 0.428606007; M = 149.8376391; S = 0.050013518;};
        if(Age_Months >= 146 && Age_Months < 147){L = 0.440218167; M = 150.3784267; S = 0.050075353;};
        if(Age_Months >= 147 && Age_Months < 148){L = 0.456097443; M = 150.9313331; S = 0.050132858;};
        if(Age_Months >= 148 && Age_Months < 149){L = 0.476536014; M = 151.4963887; S = 0.050185471;};
        if(Age_Months >= 149 && Age_Months < 150){L = 0.501766234; M = 152.0734897; S = 0.050232532;};
        if(Age_Months >= 150 && Age_Months < 151){L = 0.531951655; M = 152.6623878; S = 0.050273285;};
        if(Age_Months >= 151 && Age_Months < 152){L = 0.567179725; M = 153.2626819; S = 0.050306885;};
        if(Age_Months >= 152 && Age_Months < 153){L = 0.607456565; M = 153.8738124; S = 0.050332406;};
        if(Age_Months >= 153 && Age_Months < 154){L = 0.652704121; M = 154.495058; S = 0.05034886;};
        if(Age_Months >= 154 && Age_Months < 155){L = 0.702759868; M = 155.1255365; S = 0.050355216;};
        if(Age_Months >= 155 && Age_Months < 156){L = 0.757379106; M = 155.7642086; S = 0.050350423;};
        if(Age_Months >= 156 && Age_Months < 157){L = 0.816239713; M = 156.4098858; S = 0.050333444;};
        if(Age_Months >= 157 && Age_Months < 158){L = 0.878947416; M = 157.0612415; S = 0.050303283;};
        if(Age_Months >= 158 && Age_Months < 159){L = 0.945053486; M = 157.7168289; S = 0.050259018;};
        if(Age_Months >= 159 && Age_Months < 160){L = 1.014046108; M = 158.3750929; S = 0.050199837;};
        if(Age_Months >= 160 && Age_Months < 161){L = 1.085383319; M = 159.034399; S = 0.050125062;};
        if(Age_Months >= 161 && Age_Months < 162){L = 1.158487278; M = 159.6930501; S = 0.05003418;};
        if(Age_Months >= 162 && Age_Months < 163){L = 1.232768816; M = 160.3493168; S = 0.049926861;};
        if(Age_Months >= 163 && Age_Months < 164){L = 1.307628899; M = 161.0014586; S = 0.049802977;};
        if(Age_Months >= 164 && Age_Months < 165){L = 1.382473225; M = 161.6477515; S = 0.04966261;};
        if(Age_Months >= 165 && Age_Months < 166){L = 1.456720479; M = 162.2865119; S = 0.049506051;};
        if(Age_Months >= 166 && Age_Months < 167){L = 1.529810247; M = 162.9161202; S = 0.049333801;};
        if(Age_Months >= 167 && Age_Months < 168){L = 1.601219573; M = 163.535045; S = 0.049146553;};
        if(Age_Months >= 168 && Age_Months < 169){L = 1.670433444; M = 164.1418486; S = 0.04894519;};
        if(Age_Months >= 169 && Age_Months < 170){L = 1.736995571; M = 164.7352199; S = 0.048730749;};
        if(Age_Months >= 170 && Age_Months < 171){L = 1.800483802; M = 165.3139755; S = 0.048504404;};
        if(Age_Months >= 171 && Age_Months < 172){L = 1.860518777; M = 165.8770715; S = 0.048267442;};
        if(Age_Months >= 172 && Age_Months < 173){L = 1.916765525; M = 166.4236087; S = 0.04802123;};
        if(Age_Months >= 173 && Age_Months < 174){L = 1.968934444; M = 166.9528354; S = 0.047767192;};
        if(Age_Months >= 174 && Age_Months < 175){L = 2.016781776; M = 167.4641466; S = 0.047506783;};
        if(Age_Months >= 175 && Age_Months < 176){L = 2.060109658; M = 167.9570814; S = 0.047241456;};
        if(Age_Months >= 176 && Age_Months < 177){L = 2.098765817; M = 168.4313175; S = 0.04697265;};
        if(Age_Months >= 177 && Age_Months < 178){L = 2.132642948; M = 168.8866644; S = 0.046701759;};
        if(Age_Months >= 178 && Age_Months < 179){L = 2.16167779; M = 169.3230548; S = 0.046430122;};
        if(Age_Months >= 179 && Age_Months < 180){L = 2.185849904; M = 169.7405351; S = 0.046159004;};
        if(Age_Months >= 180 && Age_Months < 181){L = 2.205180153; M = 170.139255; S = 0.045889585;};
        if(Age_Months >= 181 && Age_Months < 182){L = 2.219728869; M = 170.5194567; S = 0.045622955;};
        if(Age_Months >= 182 && Age_Months < 183){L = 2.2295937; M = 170.881464; S = 0.045360101;};
        if(Age_Months >= 183 && Age_Months < 184){L = 2.234907144; M = 171.2256717; S = 0.045101913;};
        if(Age_Months >= 184 && Age_Months < 185){L = 2.235833767; M = 171.5525345; S = 0.044849174;};
        if(Age_Months >= 185 && Age_Months < 186){L = 2.232567138; M = 171.8625576; S = 0.044602566;};
        if(Age_Months >= 186 && Age_Months < 187){L = 2.2253265; M = 172.1562865; S = 0.044362674;};
        if(Age_Months >= 187 && Age_Months < 188){L = 2.214353232; M = 172.4342983; S = 0.044129985;};
        if(Age_Months >= 188 && Age_Months < 189){L = 2.199905902; M = 172.6971935; S = 0.043904897;};
        if(Age_Months >= 189 && Age_Months < 190){L = 2.182262864; M = 172.9455898; S = 0.043687723;};
        if(Age_Months >= 190 && Age_Months < 191){L = 2.161704969; M = 173.180112; S = 0.043478698;};
        if(Age_Months >= 191 && Age_Months < 192){L = 2.138524662; M = 173.4013896; S = 0.043277987;};
        if(Age_Months >= 192 && Age_Months < 193){L = 2.113023423; M = 173.6100518; S = 0.043085685;};
        if(Age_Months >= 193 && Age_Months < 194){L = 2.085490286; M = 173.8067179; S = 0.042901835;};
        if(Age_Months >= 194 && Age_Months < 195){L = 2.0562195; M = 173.9919998; S = 0.042726424;};
        if(Age_Months >= 195 && Age_Months < 196){L = 2.025496648; M = 174.1664951; S = 0.042559396;};
        if(Age_Months >= 196 && Age_Months < 197){L = 1.993598182; M = 174.3307855; S = 0.042400652;};
        if(Age_Months >= 197 && Age_Months < 198){L = 1.960789092; M = 174.4854344; S = 0.042250063;};
        if(Age_Months >= 198 && Age_Months < 199){L = 1.927320937; M = 174.6309856; S = 0.042107465;};
        if(Age_Months >= 199 && Age_Months < 200){L = 1.89343024; M = 174.7679617; S = 0.041972676;};
        if(Age_Months >= 200 && Age_Months < 201){L = 1.859337259; M = 174.8968634; S = 0.041845488;};
        if(Age_Months >= 201 && Age_Months < 202){L = 1.825245107; M = 175.0181691; S = 0.041725679;};
        if(Age_Months >= 202 && Age_Months < 203){L = 1.791339209; M = 175.1323345; S = 0.041613015;};
        if(Age_Months >= 203 && Age_Months < 204){L = 1.757787065; M = 175.2397926; S = 0.041507249;};
        if(Age_Months >= 204 && Age_Months < 205){L = 1.724738292; M = 175.340954; S = 0.041408129;};
        if(Age_Months >= 205 && Age_Months < 206){L = 1.692324905; M = 175.4362071; S = 0.041315398;};
        if(Age_Months >= 206 && Age_Months < 207){L = 1.660661815; M = 175.5259191; S = 0.041228796;};
        if(Age_Months >= 207 && Age_Months < 208){L = 1.629847495; M = 175.6104358; S = 0.04114806;};
        if(Age_Months >= 208 && Age_Months < 209){L = 1.599964788; M = 175.690083; S = 0.041072931;};
        if(Age_Months >= 209 && Age_Months < 210){L = 1.571081817; M = 175.7651671; S = 0.04100315;};
        if(Age_Months >= 210 && Age_Months < 211){L = 1.543252982; M = 175.8359757; S = 0.040938463;};
        if(Age_Months >= 211 && Age_Months < 212){L = 1.516519998; M = 175.9027788; S = 0.040878617;};
        if(Age_Months >= 212 && Age_Months < 213){L = 1.490912963; M = 175.9658293; S = 0.040823368;};
        if(Age_Months >= 213 && Age_Months < 214){L = 1.466451429; M = 176.0253641; S = 0.040772475;};
        if(Age_Months >= 214 && Age_Months < 215){L = 1.44314546; M = 176.081605; S = 0.040725706;};
        if(Age_Months >= 215 && Age_Months < 216){L = 1.420996665; M = 176.1347593; S = 0.040682834;};
        if(Age_Months >= 216 && Age_Months < 217){L = 1.399999187; M = 176.1850208; S = 0.04064364;};
        if(Age_Months >= 217 && Age_Months < 218){L = 1.380140651; M = 176.2325707; S = 0.040607913;};
        if(Age_Months >= 218 && Age_Months < 219){L = 1.361403047; M = 176.2775781; S = 0.040575448;};
        if(Age_Months >= 219 && Age_Months < 220){L = 1.343763564; M = 176.3202008; S = 0.040546051;};
        if(Age_Months >= 220 && Age_Months < 221){L = 1.327195355; M = 176.3605864; S = 0.040519532;};
        if(Age_Months >= 221 && Age_Months < 222){L = 1.311668242; M = 176.3988725; S = 0.040495713;};
        if(Age_Months >= 222 && Age_Months < 223){L = 1.297149359; M = 176.4351874; S = 0.040474421;};
        if(Age_Months >= 223 && Age_Months < 224){L = 1.283603728; M = 176.469651; S = 0.040455493;};
        if(Age_Months >= 224 && Age_Months < 225){L = 1.270994782; M = 176.5023751; S = 0.040438773;};
        if(Age_Months >= 225 && Age_Months < 226){L = 1.25928483; M = 176.533464; S = 0.040424111;};
        if(Age_Months >= 226 && Age_Months < 227){L = 1.248435461; M = 176.5630153; S = 0.040411366;};
        if(Age_Months >= 227 && Age_Months < 228){L = 1.23840791; M = 176.5911197; S = 0.040400405;};
        if(Age_Months >= 228 && Age_Months < 229){L = 1.229163362; M = 176.6178621; S = 0.040391101;};
        if(Age_Months >= 229 && Age_Months < 230){L = 1.220663228; M = 176.6433219; S = 0.040383334;};
        if(Age_Months >= 230 && Age_Months < 231){L = 1.212869374; M = 176.6675729; S = 0.04037699;};
        if(Age_Months >= 231 && Age_Months < 232){L = 1.20574431; M = 176.6906844; S = 0.040371962;};
        if(Age_Months >= 232 && Age_Months < 233){L = 1.199251356; M = 176.712721; S = 0.040368149;};
        if(Age_Months >= 233 && Age_Months < 234){L = 1.19335477; M = 176.733743; S = 0.040365456;};
        if(Age_Months >= 234 && Age_Months < 235){L = 1.188019859; M = 176.753807; S = 0.040363795;};
        if(Age_Months >= 235 && Age_Months < 236){L = 1.183213059; M = 176.7729657; S = 0.04036308;};
        if(Age_Months >= 236 && Age_Months < 237){L = 1.178901998; M = 176.7912687; S = 0.040363233;};
        if(Age_Months >= 237 && Age_Months < 238){L = 1.175055543; M = 176.8087622; S = 0.040364179;};
        if(Age_Months >= 238 && Age_Months < 239){L = 1.171643828; M = 176.8254895; S = 0.04036585;};
        if(Age_Months >= 239 && Age_Months < 240){L = 1.16863827; M = 176.8414914; S = 0.04036818;};
        var Z_Score =  (power((Height / M), L) - 1) / (L * S);
		var Z_Score_param,Percentile_param;

        var Percentile =  ZtoPercentile(Z_Score);

		return Percentile
    };

	var WeightPercentile = function(data) {

		var Weight = data.weight
		var Age_Months =  data.age;

		var L,M,S;

		if(Age_Months >= 24 && Age_Months < 25){L = -0.216501213; M = 12.74154396; S = 0.108166006;};
		if(Age_Months >= 25 && Age_Months < 26){L = -0.239790488; M = 12.88102276; S = 0.108274706;};
		if(Age_Months >= 26 && Age_Months < 27){L = -0.266315853; M = 13.01842382; S = 0.108421025;};
		if(Age_Months >= 27 && Age_Months < 28){L = -0.295754969; M = 13.1544966; S = 0.10860477;};
		if(Age_Months >= 28 && Age_Months < 29){L = -0.327729368; M = 13.28989667; S = 0.108825681;};
		if(Age_Months >= 29 && Age_Months < 30){L = -0.361817468; M = 13.42519408; S = 0.109083424;};
		if(Age_Months >= 30 && Age_Months < 31){L = -0.397568087; M = 13.56088113; S = 0.109377581;};
		if(Age_Months >= 31 && Age_Months < 32){L = -0.434520252; M = 13.69737858; S = 0.109707646;};
		if(Age_Months >= 32 && Age_Months < 33){L = -0.472188756; M = 13.83504622; S = 0.110073084;};
		if(Age_Months >= 33 && Age_Months < 34){L = -0.510116627; M = 13.97418299; S = 0.110473254;};
		if(Age_Months >= 34 && Age_Months < 35){L = -0.547885579; M = 14.1150324; S = 0.1109074;};
		if(Age_Months >= 35 && Age_Months < 36){L = -0.58507011; M = 14.25779618; S = 0.111374787;};
		if(Age_Months >= 36 && Age_Months < 37){L = -0.621319726; M = 14.40262749; S = 0.111874514;};
		if(Age_Months >= 37 && Age_Months < 38){L = -0.656295986; M = 14.54964614; S = 0.112405687;};
		if(Age_Months >= 38 && Age_Months < 39){L = -0.689735029; M = 14.69893326; S = 0.112967254;};
		if(Age_Months >= 39 && Age_Months < 40){L = -0.721410388; M = 14.85054151; S = 0.11355811;};
		if(Age_Months >= 40 && Age_Months < 41){L = -0.751175223; M = 15.00449143; S = 0.114176956;};
		if(Age_Months >= 41 && Age_Months < 42){L = -0.778904279; M = 15.16078454; S = 0.114822482;};
		if(Age_Months >= 42 && Age_Months < 43){L = -0.804515498; M = 15.31940246; S = 0.115493292;};
		if(Age_Months >= 43 && Age_Months < 44){L = -0.828003255; M = 15.48030313; S = 0.116187777;};
		if(Age_Months >= 44 && Age_Months < 45){L = -0.849380372; M = 15.64343309; S = 0.116904306;};
		if(Age_Months >= 45 && Age_Months < 46){L = -0.86869965; M = 15.80872535; S = 0.117641148;};
		if(Age_Months >= 46 && Age_Months < 47){L = -0.886033992; M = 15.97610456; S = 0.118396541;};
		if(Age_Months >= 47 && Age_Months < 48){L = -0.901507878; M = 16.14548194; S = 0.119168555;};
		if(Age_Months >= 48 && Age_Months < 49){L = -0.915241589; M = 16.31676727; S = 0.11995532;};
		if(Age_Months >= 49 && Age_Months < 50){L = -0.927377772; M = 16.4898646; S = 0.120754916;};
		if(Age_Months >= 50 && Age_Months < 51){L = -0.938069819; M = 16.66467529; S = 0.121565421;};
		if(Age_Months >= 51 && Age_Months < 52){L = -0.94747794; M = 16.84109948; S = 0.122384927;};
		if(Age_Months >= 52 && Age_Months < 53){L = -0.955765694; M = 17.01903746; S = 0.123211562;};
		if(Age_Months >= 53 && Age_Months < 54){L = -0.963096972; M = 17.1983908; S = 0.124043503;};
		if(Age_Months >= 54 && Age_Months < 55){L = -0.969633434; M = 17.37906341; S = 0.124878992;};
		if(Age_Months >= 55 && Age_Months < 56){L = -0.975532355; M = 17.56096245; S = 0.125716348;};
		if(Age_Months >= 56 && Age_Months < 57){L = -0.980937915; M = 17.74400082; S = 0.126554022;};
		if(Age_Months >= 57 && Age_Months < 58){L = -0.986006518; M = 17.92809121; S = 0.127390453;};
		if(Age_Months >= 58 && Age_Months < 59){L = -0.99086694; M = 18.11315625; S = 0.128224294;};
		if(Age_Months >= 59 && Age_Months < 60){L = -0.995644402; M = 18.29912286; S = 0.129054277;};
		if(Age_Months >= 60 && Age_Months < 61){L = -1.000453886; M = 18.48592413; S = 0.129879257;};
		if(Age_Months >= 61 && Age_Months < 62){L = -1.005399668; M = 18.67349965; S = 0.130698212;};
		if(Age_Months >= 62 && Age_Months < 63){L = -1.010575003; M = 18.86179576; S = 0.131510245;};
		if(Age_Months >= 63 && Age_Months < 64){L = -1.016061941; M = 19.05076579; S = 0.132314586;};
		if(Age_Months >= 64 && Age_Months < 65){L = -1.021931241; M = 19.24037019; S = 0.133110593;};
		if(Age_Months >= 65 && Age_Months < 66){L = -1.028242376; M = 19.43057662; S = 0.133897752;};
		if(Age_Months >= 66 && Age_Months < 67){L = -1.035043608; M = 19.62136007; S = 0.134675673;};
		if(Age_Months >= 67 && Age_Months < 68){L = -1.042372125; M = 19.8127028; S = 0.13544409;};
		if(Age_Months >= 68 && Age_Months < 69){L = -1.050254232; M = 20.0045944; S = 0.13620286;};
		if(Age_Months >= 69 && Age_Months < 70){L = -1.058705595; M = 20.19703171; S = 0.136951959;};
		if(Age_Months >= 70 && Age_Months < 71){L = -1.067731529; M = 20.39001872; S = 0.137691478;};
		if(Age_Months >= 71 && Age_Months < 72){L = -1.077321193; M = 20.58356862; S = 0.138421673;};
		if(Age_Months >= 72 && Age_Months < 73){L = -1.087471249; M = 20.77769565; S = 0.139142773;};
		if(Age_Months >= 73 && Age_Months < 74){L = -1.098152984; M = 20.97242631; S = 0.139855242;};
		if(Age_Months >= 74 && Age_Months < 75){L = -1.10933408; M = 21.16779192; S = 0.140559605;};
		if(Age_Months >= 75 && Age_Months < 76){L = -1.120974043; M = 21.36383013; S = 0.141256489;};
		if(Age_Months >= 76 && Age_Months < 77){L = -1.133024799; M = 21.56058467; S = 0.141946613;};
		if(Age_Months >= 77 && Age_Months < 78){L = -1.145431351; M = 21.75810506; S = 0.142630785;};
		if(Age_Months >= 78 && Age_Months < 79){L = -1.158132499; M = 21.95644627; S = 0.143309898;};
		if(Age_Months >= 79 && Age_Months < 80){L = -1.171061612; M = 22.15566842; S = 0.143984924;};
		if(Age_Months >= 80 && Age_Months < 81){L = -1.184141975; M = 22.35583862; S = 0.144656953;};
		if(Age_Months >= 81 && Age_Months < 82){L = -1.197307185; M = 22.55702268; S = 0.145327009;};
		if(Age_Months >= 82 && Age_Months < 83){L = -1.210475099; M = 22.75929558; S = 0.145996289;};
		if(Age_Months >= 83 && Age_Months < 84){L = -1.223565263; M = 22.9627344; S = 0.146666;};
		if(Age_Months >= 84 && Age_Months < 85){L = -1.236497304; M = 23.16741888; S = 0.147337375;};
		if(Age_Months >= 85 && Age_Months < 86){L = -1.249186293; M = 23.37343341; S = 0.148011715;};
		if(Age_Months >= 86 && Age_Months < 87){L = -1.261555446; M = 23.58086145; S = 0.148690256;};
		if(Age_Months >= 87 && Age_Months < 88){L = -1.273523619; M = 23.78979096; S = 0.149374297;};
		if(Age_Months >= 88 && Age_Months < 89){L = -1.285013783; M = 24.00031064; S = 0.150065107;};
		if(Age_Months >= 89 && Age_Months < 90){L = -1.295952066; M = 24.21251028; S = 0.150763933;};
		if(Age_Months >= 90 && Age_Months < 91){L = -1.306268473; M = 24.42648043; S = 0.151471982;};
		if(Age_Months >= 91 && Age_Months < 92){L = -1.31589753; M = 24.642312; S = 0.152190413;};
		if(Age_Months >= 92 && Age_Months < 93){L = -1.324778843; M = 24.86009596; S = 0.152920322;};
		if(Age_Months >= 93 && Age_Months < 94){L = -1.332857581; M = 25.07992303; S = 0.153662731;};
		if(Age_Months >= 94 && Age_Months < 95){L = -1.340080195; M = 25.30188584; S = 0.154418635;};
		if(Age_Months >= 95 && Age_Months < 96){L = -1.346412105; M = 25.52606977; S = 0.155188768;};
		if(Age_Months >= 96 && Age_Months < 97){L = -1.351813296; M = 25.75256528; S = 0.155973912;};
		if(Age_Months >= 97 && Age_Months < 98){L = -1.356253969; M = 25.9814599; S = 0.156774684;};
		if(Age_Months >= 98 && Age_Months < 99){L = -1.359710858; M = 26.2128399; S = 0.157591579;};
		if(Age_Months >= 99 && Age_Months < 100){L = -1.362167159; M = 26.44679027; S = 0.158424964;};
		if(Age_Months >= 100 && Age_Months < 101){L = -1.363612378; M = 26.68339457; S = 0.159275071;};
		if(Age_Months >= 101 && Age_Months < 102){L = -1.364042106; M = 26.92273494; S = 0.160141995;};
		if(Age_Months >= 102 && Age_Months < 103){L = -1.363457829; M = 27.16489199; S = 0.161025689;};
		if(Age_Months >= 103 && Age_Months < 104){L = -1.361865669; M = 27.40994539; S = 0.161925976;};
		if(Age_Months >= 104 && Age_Months < 105){L = -1.35928261; M = 27.65796978; S = 0.162842452;};
		if(Age_Months >= 105 && Age_Months < 106){L = -1.355720571; M = 27.90904433; S = 0.163774719;};
		if(Age_Months >= 106 && Age_Months < 107){L = -1.351202536; M = 28.16324264; S = 0.164722138;};
		if(Age_Months >= 107 && Age_Months < 108){L = -1.345754408; M = 28.42063744; S = 0.165683945;};
		if(Age_Months >= 108 && Age_Months < 109){L = -1.339405453; M = 28.68130005; S = 0.166659247;};
		if(Age_Months >= 109 && Age_Months < 110){L = -1.332188093; M = 28.94530029; S = 0.167647017;};
		if(Age_Months >= 110 && Age_Months < 111){L = -1.324137479; M = 29.21270645; S = 0.168646104;};
		if(Age_Months >= 111 && Age_Months < 112){L = -1.315291073; M = 29.48358527; S = 0.169655235;};
		if(Age_Months >= 112 && Age_Months < 113){L = -1.30568824; M = 29.75800198; S = 0.170673022;};
		if(Age_Months >= 113 && Age_Months < 114){L = -1.295369867; M = 30.03602021; S = 0.17169797;};
		if(Age_Months >= 114 && Age_Months < 115){L = -1.284374967; M = 30.31770417; S = 0.17272854;};
		if(Age_Months >= 115 && Age_Months < 116){L = -1.272750864; M = 30.60311107; S = 0.173762961;};
		if(Age_Months >= 116 && Age_Months < 117){L = -1.260539193; M = 30.89230072; S = 0.174799493;};
		if(Age_Months >= 117 && Age_Months < 118){L = -1.247783611; M = 31.18532984; S = 0.175836284;};
		if(Age_Months >= 118 && Age_Months < 119){L = -1.234527763; M = 31.48225315; S = 0.176871417;};
		if(Age_Months >= 119 && Age_Months < 120){L = -1.220815047; M = 31.78312329; S = 0.177902912;};
		if(Age_Months >= 120 && Age_Months < 121){L = -1.206688407; M = 32.08799062; S = 0.17892874;};
		if(Age_Months >= 121 && Age_Months < 122){L = -1.19219015; M = 32.39690313; S = 0.17994683;};
		if(Age_Months >= 122 && Age_Months < 123){L = -1.177361786; M = 32.7099062; S = 0.180955078;};
		if(Age_Months >= 123 && Age_Months < 124){L = -1.162243894; M = 33.02704244; S = 0.181951361;};
		if(Age_Months >= 124 && Age_Months < 125){L = -1.146876007; M = 33.34835148; S = 0.182933537;};
		if(Age_Months >= 125 && Age_Months < 126){L = -1.131296524; M = 33.67386973; S = 0.183899465;};
		if(Age_Months >= 126 && Age_Months < 127){L = -1.115542634; M = 34.00363017; S = 0.184847006;};
		if(Age_Months >= 127 && Age_Months < 128){L = -1.099650267; M = 34.33766207; S = 0.185774041;};
		if(Age_Months >= 128 && Age_Months < 129){L = -1.083654055; M = 34.67599076; S = 0.18667847;};
		if(Age_Months >= 129 && Age_Months < 130){L = -1.067587314; M = 35.01863732; S = 0.187558229;};
		if(Age_Months >= 130 && Age_Months < 131){L = -1.051482972; M = 35.36561737; S = 0.18841128;};
		if(Age_Months >= 131 && Age_Months < 132){L = -1.035367321; M = 35.71694723; S = 0.189235738;};
		if(Age_Months >= 132 && Age_Months < 133){L = -1.019277299; M = 36.07262569; S = 0.190029545;};
		if(Age_Months >= 133 && Age_Months < 134){L = -1.003235326; M = 36.43265996; S = 0.190790973;};
		if(Age_Months >= 134 && Age_Months < 135){L = -0.987269866; M = 36.79704392; S = 0.191518224;};
		if(Age_Months >= 135 && Age_Months < 136){L = -0.971406609; M = 37.1657671; S = 0.192209619;};
		if(Age_Months >= 136 && Age_Months < 137){L = -0.955670107; M = 37.53881268; S = 0.192863569;};
		if(Age_Months >= 137 && Age_Months < 138){L = -0.940083834; M = 37.91615721; S = 0.193478582;};
		if(Age_Months >= 138 && Age_Months < 139){L = -0.924670244; M = 38.2977703; S = 0.194053274;};
		if(Age_Months >= 139 && Age_Months < 140){L = -0.909450843; M = 38.6836143; S = 0.194586368;};
		if(Age_Months >= 140 && Age_Months < 141){L = -0.894446258; M = 39.07364401; S = 0.195076705;};
		if(Age_Months >= 141 && Age_Months < 142){L = -0.879676305; M = 39.46780643; S = 0.195523246;};
		if(Age_Months >= 142 && Age_Months < 143){L = -0.865160071; M = 39.86604044; S = 0.195925079;};
		if(Age_Months >= 143 && Age_Months < 144){L = -0.850915987; M = 40.26827652; S = 0.196281418;};
		if(Age_Months >= 144 && Age_Months < 145){L = -0.836961905; M = 40.67443658; S = 0.196591612;};
		if(Age_Months >= 145 && Age_Months < 146){L = -0.823315176; M = 41.08443363; S = 0.19685514;};
		if(Age_Months >= 146 && Age_Months < 147){L = -0.809992726; M = 41.49817164; S = 0.19707162;};
		if(Age_Months >= 147 && Age_Months < 148){L = -0.797011132; M = 41.91554528; S = 0.197240806;};
		if(Age_Months >= 148 && Age_Months < 149){L = -0.784386693; M = 42.33643978; S = 0.197362591;};
		if(Age_Months >= 149 && Age_Months < 150){L = -0.772135506; M = 42.76073078; S = 0.197437004;};
		if(Age_Months >= 150 && Age_Months < 151){L = -0.760273528; M = 43.18828419; S = 0.19746421;};
		if(Age_Months >= 151 && Age_Months < 152){L = -0.748815968; M = 43.61895703; S = 0.197444522;};
		if(Age_Months >= 152 && Age_Months < 153){L = -0.737780398; M = 44.0525931; S = 0.197378345;};
		if(Age_Months >= 153 && Age_Months < 154){L = -0.727181568; M = 44.48903027; S = 0.197266263;};
		if(Age_Months >= 154 && Age_Months < 155){L = -0.717035494; M = 44.92809483; S = 0.197108968;};
		if(Age_Months >= 155 && Age_Months < 156){L = -0.707358338; M = 45.36960315; S = 0.196907274;};
		if(Age_Months >= 156 && Age_Months < 157){L = -0.698166437; M = 45.81336172; S = 0.196662115;};
		if(Age_Months >= 157 && Age_Months < 158){L = -0.689476327; M = 46.25916729; S = 0.196374538;};
		if(Age_Months >= 158 && Age_Months < 159){L = -0.68130475; M = 46.70680701; S = 0.196045701;};
		if(Age_Months >= 159 && Age_Months < 160){L = -0.673668658; M = 47.15605863; S = 0.195676862;};
		if(Age_Months >= 160 && Age_Months < 161){L = -0.666585194; M = 47.60669074; S = 0.19526938;};
		if(Age_Months >= 161 && Age_Months < 162){L = -0.660069969; M = 48.05846572; S = 0.19482473;};
		if(Age_Months >= 162 && Age_Months < 163){L = -0.654142602; M = 48.51113138; S = 0.19434441;};
		if(Age_Months >= 163 && Age_Months < 164){L = -0.648819666; M = 48.96443224; S = 0.193830046;};
		if(Age_Months >= 164 && Age_Months < 165){L = -0.644118611; M = 49.41810374; S = 0.193283319;};
		if(Age_Months >= 165 && Age_Months < 166){L = -0.640056805; M = 49.87187409; S = 0.192705974;};
		if(Age_Months >= 166 && Age_Months < 167){L = -0.636651424; M = 50.32546478; S = 0.192099812;};
		if(Age_Months >= 167 && Age_Months < 168){L = -0.633919328; M = 50.77859121; S = 0.191466681;};
		if(Age_Months >= 168 && Age_Months < 169){L = -0.631876912; M = 51.23096332; S = 0.190808471;};
		if(Age_Months >= 169 && Age_Months < 170){L = -0.63053994; M = 51.68228625; S = 0.190127105;};
		if(Age_Months >= 170 && Age_Months < 171){L = -0.629923353; M = 52.13226113; S = 0.18942453;};
		if(Age_Months >= 171 && Age_Months < 172){L = -0.630041066; M = 52.58058583; S = 0.188702714;};
		if(Age_Months >= 172 && Age_Months < 173){L = -0.630905733; M = 53.02695588; S = 0.187963636;};
		if(Age_Months >= 173 && Age_Months < 174){L = -0.632528509; M = 53.47106525; S = 0.187209281;};
		if(Age_Months >= 174 && Age_Months < 175){L = -0.634918779; M = 53.91260737; S = 0.18644163;};
		if(Age_Months >= 175 && Age_Months < 176){L = -0.638083884; M = 54.35127608; S = 0.185662657;};
		if(Age_Months >= 176 && Age_Months < 177){L = -0.642028835; M = 54.78676659; S = 0.184874323;};
		if(Age_Months >= 177 && Age_Months < 178){L = -0.646756013; M = 55.21877657; S = 0.184078567;};
		if(Age_Months >= 178 && Age_Months < 179){L = -0.652262297; M = 55.64701131; S = 0.183277339;};
		if(Age_Months >= 179 && Age_Months < 180){L = -0.658551638; M = 56.07116407; S = 0.182472427;};
		if(Age_Months >= 180 && Age_Months < 181){L = -0.665609025; M = 56.49095862; S = 0.181665781;};
		if(Age_Months >= 181 && Age_Months < 182){L = -0.673425951; M = 56.90610886; S = 0.18085918;};
		if(Age_Months >= 182 && Age_Months < 183){L = -0.681987284; M = 57.31634059; S = 0.180054395;};
		if(Age_Months >= 183 && Age_Months < 184){L = -0.691273614; M = 57.72138846; S = 0.179253153;};
		if(Age_Months >= 184 && Age_Months < 185){L = -0.701261055; M = 58.12099696; S = 0.178457127;};
		if(Age_Months >= 185 && Age_Months < 186){L = -0.711921092; M = 58.51492143; S = 0.177667942;};
		if(Age_Months >= 186 && Age_Months < 187){L = -0.723218488; M = 58.90293208; S = 0.176887192;};
		if(Age_Months >= 187 && Age_Months < 188){L = -0.735121189; M = 59.28479948; S = 0.176116307;};
		if(Age_Months >= 188 && Age_Months < 189){L = -0.747580416; M = 59.66032626; S = 0.175356814;};
		if(Age_Months >= 189 && Age_Months < 190){L = -0.760550666; M = 60.02931704; S = 0.174610071;};
		if(Age_Months >= 190 && Age_Months < 191){L = -0.773984558; M = 60.39158721; S = 0.173877336;};
		if(Age_Months >= 191 && Age_Months < 192){L = -0.787817728; M = 60.74698785; S = 0.173159953;};
		if(Age_Months >= 192 && Age_Months < 193){L = -0.801993069; M = 61.09536847; S = 0.172459052;};
		if(Age_Months >= 193 && Age_Months < 194){L = -0.816446409; M = 61.43660077; S = 0.171775726;};
		if(Age_Months >= 194 && Age_Months < 195){L = -0.831110299; M = 61.77057372; S = 0.171110986;};
		if(Age_Months >= 195 && Age_Months < 196){L = -0.845914498; M = 62.09719399; S = 0.170465756;};
		if(Age_Months >= 196 && Age_Months < 197){L = -0.860786514; M = 62.41638628; S = 0.169840869;};
		if(Age_Months >= 197 && Age_Months < 198){L = -0.875652181; M = 62.72809362; S = 0.169237063;};
		if(Age_Months >= 198 && Age_Months < 199){L = -0.890436283; M = 63.03227756; S = 0.168654971;};
		if(Age_Months >= 199 && Age_Months < 200){L = -0.905063185; M = 63.32891841; S = 0.168095124;};
		if(Age_Months >= 200 && Age_Months < 201){L = -0.91945749; M = 63.61801537; S = 0.16755794;};
		if(Age_Months >= 201 && Age_Months < 202){L = -0.933544683; M = 63.89958662; S = 0.167043722;};
		if(Age_Months >= 202 && Age_Months < 203){L = -0.947251765; M = 64.17366943; S = 0.166552654;};
		if(Age_Months >= 203 && Age_Months < 204){L = -0.960507855; M = 64.44032016; S = 0.166084798;};
		if(Age_Months >= 204 && Age_Months < 205){L = -0.973244762; M = 64.69961427; S = 0.16564009;};
		if(Age_Months >= 205 && Age_Months < 206){L = -0.985397502; M = 64.95164625; S = 0.165218341;};
		if(Age_Months >= 206 && Age_Months < 207){L = -0.996904762; M = 65.1965295; S = 0.164819236;};
		if(Age_Months >= 207 && Age_Months < 208){L = -1.007705555; M = 65.43440186; S = 0.16444238;};
		if(Age_Months >= 208 && Age_Months < 209){L = -1.017756047; M = 65.66540015; S = 0.164087103;};
		if(Age_Months >= 209 && Age_Months < 210){L = -1.027002713; M = 65.88970117; S = 0.163752791;};
		if(Age_Months >= 210 && Age_Months < 211){L = -1.035402243; M = 66.10749114; S = 0.163438661;};
		if(Age_Months >= 211 && Age_Months < 212){L = -1.042916356; M = 66.31897311; S = 0.163143825;};
		if(Age_Months >= 212 && Age_Months < 213){L = -1.049511871; M = 66.52436618; S = 0.162867311;};
		if(Age_Months >= 213 && Age_Months < 214){L = -1.055160732; M = 66.72390443; S = 0.162608072;};
		if(Age_Months >= 214 && Age_Months < 215){L = -1.059840019; M = 66.91783563; S = 0.162365006;};
		if(Age_Months >= 215 && Age_Months < 216){L = -1.063531973; M = 67.10641956; S = 0.162136973;};
		if(Age_Months >= 216 && Age_Months < 217){L = -1.066224038; M = 67.28992603; S = 0.161922819;};
		if(Age_Months >= 217 && Age_Months < 218){L = -1.067908908; M = 67.46863255; S = 0.161721398;};
		if(Age_Months >= 218 && Age_Months < 219){L = -1.068589885; M = 67.64281378; S = 0.16153153;};
		if(Age_Months >= 219 && Age_Months < 220){L = -1.068261146; M = 67.8127675; S = 0.161352313;};
		if(Age_Months >= 220 && Age_Months < 221){L = -1.066933756; M = 67.97877331; S = 0.161182785;};
		if(Age_Months >= 221 && Age_Months < 222){L = -1.064620976; M = 68.14111022; S = 0.161022184;};
		if(Age_Months >= 222 && Age_Months < 223){L = -1.061341755; M = 68.30004741; S = 0.160869943;};
		if(Age_Months >= 223 && Age_Months < 224){L = -1.057116957; M = 68.4558454; S = 0.160725793;};
		if(Age_Months >= 224 && Age_Months < 225){L = -1.051988979; M = 68.60872174; S = 0.160589574;};
		if(Age_Months >= 225 && Age_Months < 226){L = -1.04599033; M = 68.75889263; S = 0.1604617;};
		if(Age_Months >= 226 && Age_Months < 227){L = -1.039168248; M = 68.90653028; S = 0.160342924;};
		if(Age_Months >= 227 && Age_Months < 228){L = -1.031579574; M = 69.05176427; S = 0.160234478;};
		if(Age_Months >= 228 && Age_Months < 229){L = -1.023291946; M = 69.19467288; S = 0.160138158;};
		if(Age_Months >= 229 && Age_Months < 230){L = -1.014385118; M = 69.33527376; S = 0.160056393;};
		if(Age_Months >= 230 && Age_Months < 231){L = -1.004952366; M = 69.47351373; S = 0.159992344;};
		if(Age_Months >= 231 && Age_Months < 232){L = -0.995101924; M = 69.60925782; S = 0.159949989;};
		if(Age_Months >= 232 && Age_Months < 233){L = -0.984958307; M = 69.74227758; S = 0.159934231;};
		if(Age_Months >= 233 && Age_Months < 234){L = -0.974663325; M = 69.87223885; S = 0.159951004;};
		if(Age_Months >= 234 && Age_Months < 235){L = -0.964376555; M = 69.99868896; S = 0.160007394;};
		if(Age_Months >= 235 && Age_Months < 236){L = -0.954274945; M = 70.12104381; S = 0.160111769;};
		if(Age_Months >= 236 && Age_Months < 237){L = -0.944551187; M = 70.23857482; S = 0.160273918;};
		if(Age_Months >= 237 && Age_Months < 238){L = -0.935410427; M = 70.35039626; S = 0.160505203;};
		if(Age_Months >= 238 && Age_Months < 239){L = -0.927059784; M = 70.45546105; S = 0.160818788;};
		if(Age_Months >= 239 && Age_Months < 240){L = -0.919718461; M = 70.55252127; S = 0.161229617;};
		var Z_Score =  (power((Weight / M), L) - 1) / (L * S);

		// if (doCalc) Z_Score_param.value = fixDP(Z_Score, dp);



		var Percentile =  ZtoPercentile(Z_Score);

		return Percentile;
	};

	this.getPercentile = function (data) {
		var PercentileHeight = HeightPercentile(data);
		var PercentileWeight = WeightPercentile(data);
		var doCalc = true;
		if (doCalc){
			var height, weight;
            if (PercentileHeight < 3){ 
                height = {percentileHeight: PercentileHeight, color: 'red'};
            }
            if ((PercentileHeight < 10) && (PercentileHeight >= 3)){ 
                height = {percentileHeight: PercentileHeight, color: 'orange'};
            }
            if ((PercentileHeight < 97) && (PercentileHeight >= 90)){ 
                height = {percentileHeight: PercentileHeight, color: 'orange'};
            }
            if (PercentileHeight > 97){ 
                height = {percentileHeight: PercentileHeight, color: 'red'};
            }
			if(PercentileHeight < 90 && PercentileHeight >10) {
				height = {percentileHeight: PercentileHeight, color: 'blue'};
			}
			if(PercentileWeight < 3){
				weight = {percentileWeight: PercentileWeight, color: 'red'};
			}
			if((PercentileWeight < 10)&&(PercentileWeight >= 3)){
				weight = {percentileWeight: PercentileWeight, color: 'orange'};
			}
			if((PercentileWeight < 97)&&(PercentileWeight >= 90)){
				weight = {percentileWeight: PercentileWeight, color: 'orange'};
			}
			if(PercentileWeight >97){
				weight = {percentileWeight: PercentileWeight, color: 'red'};
			}
			if(PercentileWeight < 90 && PercentileWeight >10) {
				weight = {percentileHeight: PercentileHeight, color: 'blue'};
			}
			
			return {height:height,weight:weight};
        }
	};
	return this;
}]);
'use strict';
angular.module('AngularApp').factory('printoutService', ['$http', '$q', 'serviceBaseUrl', 'authService', 'localStorageService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl, localStorageService) {  	

    this.createPrintoutTemplate = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createdefaultprescriptiontemplate', data).success( function(response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getPrintoutTemplate = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdefaultprescriptiontemplate?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

    this.defaultTemplate = function () {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdoctortemplate?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id+'&doctor_email='+authService.authentication.account_id+'&cons_screen=1').success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
	};

    return this;
} ]);
'use strict';
angular.module('AngularApp').factory('profileService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', '$sessionStorage', function ($http, $q, serviceBaseUrl, localStorageService,authService, $sessionStorage) {

    this.getProfile = function (recordId) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdoctorprofile?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
		    deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.createProfile = function(data,type) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+type,data).success(function(response) {
            deferred.resolve(response);
        }).error(function (error) {
            deferred.reject(error);
        })
        return deferred.promise;
    };

    return this;
}])
'use strict';
angular.module('AngularApp').factory('recordService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', 'helyxonApiUrl', '$sessionStorage','registerBaseUrl', function ($http, $q, serviceBaseUrl, localStorageService,authService, helyxonApiUrl, $sessionStorage, registerBaseUrl) { 
	
	var helyxonApi_Url = helyxonApiUrl;
	
	this.getVitalSigns = function (recordId) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'vitals?'+recordId).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
   

	this.getAppointmentcount = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getappointmentcount?account_email='+data.acc_id+'&from_date='+data.date1+'&to_date='+data.date2+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
	

	this.viewNotification = function (recordId) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'sentnotification',{account_id: accountId}).success(function (response) {
		    deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getClinicalNotes = function(recordId){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'clinical?'+recordId).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getDrNotes = function(recordId){
			var deferred = $q.defer();
				$http.get(serviceBaseUrl+'investigation?'+recordId).success(function (response) {
				deferred.resolve(response);
			}).error(function (error, status) {
				deferred.reject(error);
			});
			return deferred.promise;
	};

	this.getNotes = function(recordId){
			var deferred = $q.defer();
				$http.get(serviceBaseUrl+'notes?'+recordId).success(function (response) {
				deferred.resolve(response);
			}).error(function (error, status) {
				deferred.reject(error);
			});
			return deferred.promise;
	};


	this.getVisits = function(recordId){
			var deferred = $q.defer();
				$http.get(serviceBaseUrl+'childdiagnosis?'+recordId).success(function (response) {
				deferred.resolve(response);
			}).error(function (error, status) {
				deferred.reject(error);
			});
			return deferred.promise;
	};


	this.getFeverData = function(recordId){
		var deferred = $q.defer();
			$http.get(serviceBaseUrl+'feverwatch?'+recordId).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getVaccineList = function(bday){
		var deferred = $q.defer();
			$http.get(serviceBaseUrl+'getvaccinationcalendar?account_email='+authService.authentication.account_id+'&user_type=doctor&dob='+bday+'&patient_email=' +$sessionStorage.get('patientAccEmail')).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getvaccination_listmonth = function(bday,today,sno){
        var deferred = $q.defer();
			$http.get(serviceBaseUrl+'getvaccinationlistmonth?account_email='+authService.authentication.account_id+'&dob='+bday+'&date='+today+'&patient_email=' +$sessionStorage.get('patientAccEmail')+'&sno='+sno).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.addvaccinationcalendarservice = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'addvaccinationcalendar', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.Addrescheduleddata = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'addrescheduleddata', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updatecalendardataservice = function(data){
        console.log('serviceBaseUr',serviceBaseUrl);
		console.log('calendar data',data)

		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'updatecalendardata', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.setDeferred = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'vaccinedeferred',data)
		.success(function(response){
			
			deferred.resolve(response);
		})
		.error(function(error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
	
	this.getRecordInfo = function(recordId){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'recordinfo',{account_email: authService.authentication.account_id,record_id:recordId}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getPatients = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'records',{account_id: localStorageService.get('authorizationData').account_id}).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getCarenetList = function(recordId){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'carenetlist?'+recordId).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getCarenetAccountList = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+ 'carenetinfo?'+data['carenet_id']).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


	this.getVaccineSchedule = function(year, recordId){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'report?'+recordId+'/'+year).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getVaccineAppointment = function(year, recordId){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'confirmedappointment?'+recordId+'/'+year).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getVaccineWeekInfo = function(year, week, recordId){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'weekinfo',{year: year, week:week, record_id:recordId}).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getPrescriptionList = function(recordId, type){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'prescription?'+recordId + "/" + type).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getLabReportList = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'labreports?account_email='+data.account_email+'&patient_email='+data.patient_email).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.postAttachment = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'docattachment', data, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.docupdate = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'docupdate' , data).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.vacupdate = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'vacupdate' , data).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.docinsert = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'document' , data).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.sendNotification = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'sendnotification', data).success(function(response){
			
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.emailNotification = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'sendmail', data).success(function(response){
			
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getAttachment = function(recordId, documentId){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'getattachment',{record_id:recordId,document_id:documentId}).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.addGrowthData = function(data){
		return this.docinsert(data);
	};

	this.notificationData = function(data){
		return this.sendNotification(data);
	};

    this.emailData = function(data){
		return this.emailNotification(data);
	};

	this.updateVaccineStatus = function(data){
		return this.docupdate(data);
	};

	this.addCarenet = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'carenetcreate', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.addCarenetAccount = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'createcarenet', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.deleteCarenet = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'carenetdelete', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


	this.deleteCarenetAccount = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'deletecarenetacc', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.addfever = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'feverinsert', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getDiagnosis = function(recordId, documentId){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+ 'getdiagnosis', {record_id: recordId,document_id:documentId}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			// deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getDiagnosiss = function (recordId) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+ 'heldiagnosis?'+recordId).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			// deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getAppointments = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'appointmentdate?'+data.acc_id+'&'+data.date1+'&'+data.date2).success(function (response) {
			console.log('repsoser ',response);
		    deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getLastDiagnosis = function(recordId){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+ 'lastheldiagnosis?'+recordId).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			// deferred.reject(error);
		});
		return deferred.promise;
	};

	this.vaccine = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+ 'vaccinelist?'+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			// deferred.reject(error);
		});
		return deferred.promise;
	};

	this.mobilePayment = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'sendcredential',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.resentCredential = function(data){
		var deferred = $q.defer();
		if(data){
           data.reset = 0;
		}
		$http.post(serviceBaseUrl+'resenddetails',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


	this.getSettings = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'settings?'+authService.authentication.account_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


	this.saveSettings = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'settings',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.saveSchedule = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'schedule',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.prepare = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'preparecalendar',{account_email:authService.authentication.account_id,date:data}).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getCal = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'privatecalendar?'+authService.authentication.account_id+'&'+data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateCalendarData = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'privatecalendar',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.deleteEvent = function(data){

		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'deleteprivateevents',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getQueue = function(){

		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'queue?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getpresCate = function(overViewId,tempId){
	    var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdoctortemplate?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id +'&doctor_email='+ authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.prescTemplate = function(overViewId,tempId){
	    var patientemail  = sessionStorage.getItem('patientAccEmail');
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'gettemplatepdf?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id + '&overview_id='+overViewId+'&patient_email='+ patientemail+'&template_id='+tempId).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.receiptTemplate = function(billNo,tempId){
	    var patientemail  = sessionStorage.getItem('patientAccEmail');
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'paymentreceipt',{account_email:authService.authentication.account_id,doctor_id:authService.authentication.doctor_id,bill_no:billNo,patient_email:patientemail,template_id:tempId}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.Mangalabarathi = function(data){
	    var patientemail  = sessionStorage.getItem('patientAccEmail');
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'prescriptionpdf?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id + '&overview_id='+data+'&patient_email='+ patientemail).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.general_Prescription = function(data){
	    var patientEmail  = sessionStorage.getItem('patientAccEmail');
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'generalprescriptionpdf/?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id +'&overview_id='+data+'&patient_email='+patientEmail).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	}

	this.getBanner = function(){

		var deferred = $q.defer();
		if(authService.authentication.account_id)
        {
			$http.get(serviceBaseUrl+'banner?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {

				deferred.resolve(response);
			}).error(function (error, status) {
				deferred.reject(error);
			});
		}
		return deferred.promise;
	};

	this.startConsult = function(data,id){

		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'startcon',{account_email:authService.authentication.account_id,patient_account:data,appointment_id:id}).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.endConsult = function(data,id){

		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'endcon',{account_email:authService.authentication.account_id,patient_account:data,appointment_id:id}).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.paymentStatus = function(apptId,category){

		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getpaymentstatus?appointment_id='+apptId+'&account_email='+authService.authentication.account_id+'&category='+category).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.nextRecord = function(){

		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getnextrecordid?'+authService.authentication.account_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getSchedule = function(year, recordId){
		
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'schedule?'+authService.authentication.account_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getPaymentSetting = function() {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getpaymentsetting?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

	this.mobileValidity = function(recordId) {

			var deferred = $q.defer();
				$http.get(serviceBaseUrl+'checkvalidity?'+authService.authentication.account_id+'&'+recordId).success(function (response) {
				deferred.resolve(response);
			}).error(function (error, status) {
				deferred.reject(error);
			});
			return deferred.promise;
	};

	this.getReports = function() {

		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'accessreport?'+authService.authentication.account_id).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.set_patientarrival = function(data) {

		var deferred = $q.defer();
		data.doctor_id = authService.authentication.doctor_id;

		$http.post(serviceBaseUrl+'setarrival',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
    };

 this.get_patientarrival = function(recordId){

	var deferred = $q.defer();
	$http.get(serviceBaseUrl+'getarrival?'+authService.authentication.account_id+'/'+recordId).success(function (response) {
		deferred.resolve(response);
	}).error(function (error, status) {
		deferred.reject(error);
	});
	return deferred.promise;
};

this.get_patientclassification = function(recordId){

	var deferred = $q.defer();
	$http.get(serviceBaseUrl+'patientclassification?'+authService.authentication.account_id+'/'+recordId).success(function (response) {
		deferred.resolve(response);
	}).error(function (error, status) {
		deferred.reject(error);
	});
	return deferred.promise;
};
/*
this.set_patientarrival = function(data){

var deferred = $q.defer();
$http.post(serviceBaseUrl+'setarrival',data).success(function (response) {
	deferred.resolve(response);
}).error(function (error, status) {
	deferred.reject(error);
});
return deferred.promise;
};*/

this.listMilestone = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'trackerlist',data).success(function (response) {
		deferred.resolve(response);
	}).error(function (error, status) {
		deferred.reject(error);
	});
	return deferred.promise;
};

this.updateMilestone = function (data) {
	var deferred = $q.defer();
	$http.post(serviceBaseUrl+'trackersurvey',data).success(function(response){
		deferred.resolve(response);
	}).error(function(error, status){
		deferred.reject(error);
	});
	return deferred.promise;
};

	this.loadLifelog = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'listlifelogentries',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};
	this.loadLifelogNew= function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'listlifelogentriesold',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};
	
 this.loadLastComplaint = function (data){
	 var deferred = $q.defer();
	 $http.post(serviceBaseUrl+'getcomplaintlatest',data).success(function(response){
		 deferred.resolve(response);
	 }).error(function(error, status){
		 deferred.reject(error);
	 })
	 return deferred.promise;
 };


 	this.getscheduleexceptions = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getscheduleexceptionplanning?account_email='+authService.authentication.account_id+"&doctor_id="+authService.authentication.doctor_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	 };


	this.getSchedule = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+"getschedule?account_email="+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.createscheduleexceptions = function(data){
		var deferred = $q.defer();
	   $http.post(serviceBaseUrl+'createscheduleexceptionplanning',data).success(function(response){
		   deferred.resolve(response);
	   }).error(function(error, status){
		   deferred.reject(error);
	   })
	return deferred.promise;
   };

	this.sendholidaysms = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl + 'sendholidaysms', data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.updatescheduleexceptions = function(data){
		 var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatescheduleexceptionplanning',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
	 return deferred.promise;
	 };
	
	this.getopreview = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getopreview?account_email='+authService.authentication.account_id+'&appointment_id='+data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	 };

	this.gethistoricaldata = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'gethistoricaldata?account_email='+authService.authentication.account_id+'&patient_email='+data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.searchTemplate = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'searchdoctortemplate',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.deleteTemplate = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'deletedoctortemplate',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.editdoctortemplate = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'editdoctortemplate',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.adddoctortemplate = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'adddoctortemplate',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getAllergies = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'allergies',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.addfavorite = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'addfavorite',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.addallergy = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'addallergy',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateallergies = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updateallergies',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.addopreview = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'addopreview',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateopreview = function(data){
		var deferred = $q.defer();
	   	$http.post(serviceBaseUrl+'updateopreview',data).success(function(response){
			deferred.resolve(response);
	   	}).error(function(error, status){
		   deferred.reject(error);
	   	})
		return deferred.promise;
	};

	this.simplevisithistory = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'simplevisithistory?account_email='+authService.authentication.account_id+'&patient_email='+data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.visithistorydetailed = function(data){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'detailedprescription?account_email='+authService.authentication.account_id+'&overview_id='+data+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.administrationInfo = function(data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'getcalendarentry',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.validateentries = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'validateentries',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.attachLabReports = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'labresult',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.setStatus = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'setstatus',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.listAdvice = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'listadvice?account_email='+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.bookWalkin = function (data){
		var deferred = $q.defer();
		if(data){
           data.doctor_id = authService.authentication.doctor_id;
		}
		$http.post(serviceBaseUrl+'walkin',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.getSpecificDoc = function(data) {
		var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'specificdoc', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
		return deferred.promise;
    };

    this.getLatestVitals = function (data) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'helvital?account_email='+authService.authentication.account_id+data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        })
        return deferred.promise;
    };

	this.getvitalGulcometer = function(fromdate,todate){
		var patientEmail  = sessionStorage.getItem('patientAccEmail');
		//var patientEmail = 'rx9260@rxcarenet.org'
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getvitalvalues?account_email='+authService.authentication.account_id+'&patient_email='+patientEmail+'&from_date='+fromdate+'&to_date='+todate).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.deletevital = function(data) {
		var deferred = $q.defer();
        $http.post(serviceBaseUrl + 'deletehelchildvitalsigns/', data).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
		return deferred.promise;
    };

	this.getBpdata = function(data){
		var deferred = $q.defer();
		$http.post('https://ivital.co/ivital/api/v1.5/draw_helvital_charts.php?',data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	
	this.listmedicalhistory = function(data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'listmedicalhistory?account_email='+authService.authentication.account_id+'&patient_email='+data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.medicalhistory = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'medicalhistory',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.medicalhistoryUpdate = function(data) {
		var deferred = $q.defer();
		$http.put(serviceBaseUrl+'medicalhistory',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.deleteScheduleExceptions = function(data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'removescheduleexceptionplanning?account_email='+authService.authentication.account_id+'&exception_id='+data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getlastvisit = function(data) {

		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getlastvisit?account_email='+authService.authentication.account_id+'&patient='+data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.patientqueueclosed = function() {

		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'patientqueueclosed?account_email='+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.appointmentreschedulenotification = function(data) {
		
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'appointmentreschedulenotification',data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.appointmentreschedule_notification = function(data) {
		
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'notifybyvoice',data).success(function(response){
			deferred.resolve(response);
			console.log('response',response)
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.startAudioCall = function(data) {
		
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'makeaudiocall', data).success(function(response){
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};
	
	// var voiceCallURL = "https://nuaworks.com/helyxon/";
	var voiceCallURL = "http://220.226.2.180:8003/api/GetData/";
	var graphApiURL = helyxonApi_Url + "ABC/api/graph.php";

	this.scheduleVoiceCall = function(data) {
		
		var deferred = $q.defer();
		// $http.post(voiceCallURL+'getdial.php',data).success(function(response){
		$http.post(voiceCallURL+'GetDiallingList',data).success(function(response){
			
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.getVoiceDetails = function(data) {
		
		var deferred = $q.defer();
		// $http.post(voiceCallURL+'getvoice.php',data).success(function(response){
		$http.post(voiceCallURL+'GetVoiceFile',data).success(function(response){
			
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.sendDoctorResponse = function(data) {
		
		var deferred = $q.defer();
		// $http.post(voiceCallURL+'getdoctor.php',data).success(function(response){
		$http.post(voiceCallURL+'GetDoctorResponce',data).success(function(response){
			
			deferred.resolve(response);
		}).error(function(error, status){
			deferred.reject(error);
		})
		return deferred.promise;
	};

	this.voiceCallCreate = function(data) {

		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'voicecallcreate',data).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.voiceCallUpdate = function(data) {

		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'voicecallupdate',data).success(function (response) {
			
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};
	
	this.getvoicecallwithreferencenumber = function(data) {

		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getvoicecallwithreferencenumber?account_email='+authService.authentication.account_id+'&appointment_id='+data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getChartAPI = function(gender,type,data) {

		var deferred = $q.defer();
		$http.get(graphApiURL+'?pgender='+gender+'&ctype='+type+'&hdata='+data.height+'&wdata='+data.weight+'&bmidata='+data.bmi+'&hcdata='+data.hc).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

    this.joinVideoCall = function(data) {
		
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createvideoroom',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.notifyVideoCancel = function(data) {
		
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'notifyvideocancel',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.completeVideoCall = function(data) {
		
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'completevideocall',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getaptConfigdays = function(){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+"getappointmentconfigcount?account_email="+authService.authentication.account_id+'&doctor_id='+authService.authentication.doctor_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	// this.getclinicalhistory = function(patient_email){
	// 	var deferred = $q.defer();
	// 	$http.get(serviceBaseUrl+'getcomplaintattachment?account_email='+authService.authentication.account_id+'&patient_email='+patient_email).success(function (response) {
	// 		deferred.resolve(response);
	// 	}).error(function (error, status) {
	// 		deferred.reject(error);
	// 	});
	// 	return deferred.promise;
	// };

	this.getclinicalhistory = function(patient_email){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getcompliantattachment?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&doctor_id='+authService.authentication.doctor_id+'&user_type=patient').success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getlastvisitdetails = function(apt_id,appt_type,doctor_id,patient_email){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getfollowupdetails?account_email='+authService.authentication.account_id+'&patient_email='+patient_email+'&appt_type='+appt_type+'&appointment_id='+apt_id+'&doctor_id='+doctor_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	
	// this.getquestionnaire = function(patient_email) {
	// 	var deferred = $q.defer();

	// 	$http.get(serviceBaseUrl + 'getpatientquestion?account_email='+authService.authentication.account_id+'&patient_email='+patient_email)
	// 		.success(function(response) {
	// 			deferred.resolve(response);
	// 		})
	// 		.error(function(error, status) {
	// 			deferred.reject(error);
	// 		});
	// 	return deferred.promise;
	// };

	this.getquestionnaire = function(patient_email) {
		var deferred = $q.defer();

		$http.get(serviceBaseUrl + 'getsurveypdf?account_email='+authService.authentication.account_id+'&patient_email='+patient_email)
			.success(function(response) {
				deferred.resolve(response);
			})
			.error(function(error, status) {
				deferred.reject(error);
			});
		return deferred.promise;
	};

	this.fieldStaffRegistration = function(data) {
		var deferred = $q.defer();
		$http.post(registerBaseUrl+'userinfo',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getFieldStaffId = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'getfieldstaffbycommunity',data).success(function (response) {

			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	return this;
}]);

'use strict';
angular.module('AngularApp').factory('reportmaster_Service', ['$http', '$q', 'serviceBaseUrl','authService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl) {
    
    var helyxonApi_Url = helyxonApiUrl;
     
    this.reportmaster_Data = function(data){
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getreports/?account_email='+authService.authentication.account_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.reportmaster_postdata = function(data){
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'reportadd',data).success(function(response){
            deferred.resolve(response);
        }).error(function(error,status){
            deferred.reject(error);
        });
      return deferred.promise;
    }
    return this;
}]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict';
angular.module('AngularApp').factory('subscribeService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

    this.getSubscribeList = function () {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'subscriptionmodule?account_email='+authService.authentication.account_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
  
    this.getSubscribeValidity = function (email) {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'subscriptionlist?account_email='+authService.authentication.account_id+"&patient_email="+email).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.subscribePayment = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'subscriptionpayment',data).success(function(response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('subscriptionService', ['$http', '$q', 'serviceBaseUrl','authService', 'helyxonApiUrl', function ($http, $q, serviceBaseUrl, authService, helyxonApiUrl) {
    
    var helyxonApi_Url = helyxonApiUrl; 
     
    this.getListofSubscriptionData = function (data) {
    
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'subscriptionmodule?account_email='+authService.authentication.account_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
      return deferred.promise;
    };

    this.subscriptionadd = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createsubscrpitionsetting',data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
    };
    
    this.subscriptionaUpdate = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatesubscrpitionsetting',data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
    };
    
    this.subscriptionActive = function(data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'deactivatesubscrpitionsetting',data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.renewSubscrip = function(data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'renewalsubscription/?account_email='+authService.authentication.account_id+'&id='+data).success(function(response) {
			deferred.resolve(response);
		}).error(function(error,status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

    
 return this;
}
 
]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict';
angular.module('AngularApp').factory('tabsService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

    this.getconsultionSettings = function () {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getconsultationsetting?account_email='+authService.authentication.account_id+"&doctor_id="+authService.authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.getcategorySettings = function () {
        var deferred = $q.defer();
        $http.get(serviceBaseUrl+'getcategorysettingdoctor?account_email='+authService.authentication.account_id+"&doctor_id="+authService.authentication.doctor_id).success(function (response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.tabssettingUpdate = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updateconsultationsetting',data).success(function(response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.categoryssettingUpdate = function (data) {
        var deferred = $q.defer();
        $http.post(serviceBaseUrl+'updatecategorysetting',data).success(function(response) {
            deferred.resolve(response);
        }).error(function (error, status) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    return this;
}]);
'use strict';
angular.module('AngularApp').factory('vaccineService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) {

	this.addVendor = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'addvendor', data).success(function (response) {
		  deferred.resolve(response);
    	}).error(function (error, status) {
		  deferred.reject(error);
	    });
	  return deferred.promise;
	};

	this.getVaccineReminder = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'vaccinationreminderdaterange', data).success(function (response) {
		  deferred.resolve(response);
    	}).error(function (error, status) {
		  deferred.reject(error);
	    });
	  return deferred.promise;
	};

	this.listVendor = function () {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'listvendor',{"account_email":authService.authentication.account_id}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


    this.listinventory = function () {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'vaccineinventory',{"account_email":authService.authentication.account_id}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateInventory = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatevaccineinventory',{"account_email":authService.authentication.account_id,"data":data}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.vaccivendorlist = function () {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'vaccinationvendorlist',{"account_email":authService.authentication.account_id}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


	this.updateVendor = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatevaccinationvendor',{"account_email":authService.authentication.account_id,"data":data}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.orderList = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'vaccineorderlist?'+authService.authentication.account_id).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateOrder = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatevaccineorder',{"account_email":authService.authentication.account_id,"data":data}).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
	    return deferred.promise;
	};

	this.getOrderDetail = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'vaccineorderdetail?'+authService.authentication.account_id+'/'+data).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getBrandsForVaccine = function(vaccineId){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getbrandsforvaccine'+'?account_email='+authService.authentication.account_id+'&vaccination_id='+vaccineId).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getListBatchExpiry = function(brandId, vaccineId){
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'listbatchexpiry'+'?account_email='+authService.authentication.account_id+'&vaccination_id='+vaccineId+'&brand_id='+brandId).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.vaccineadministration = function(vaccineAdminiterObj){
		var deferred = $q.defer();
			$http.post(serviceBaseUrl+'vaccineadministration',{account_email: authService.authentication.account_id,vaccination_administration:{
				vaccination_id: vaccineAdminiterObj.id,
				calendar_id: vaccineAdminiterObj.calendar_id,
				brand_id: vaccineAdminiterObj.brand_id,
				site: vaccineAdminiterObj.site,
				batch_id: vaccineAdminiterObj.batch_id,
				comments: vaccineAdminiterObj.comments
			}})
			.success(function (response) {
				deferred.resolve(response);
			}).error(function (error, status) {
				deferred.reject(error);
			});
		return deferred.promise;
	};

	return this;

}]);


'use strict';
angular.module('AngularApp').factory('xenovexService', ['$http', '$q', 'serviceBaseUrl', 'localStorageService','authService', function ($http, $q, serviceBaseUrl, localStorageService,authService) { 

    this.patientList = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getxenovexpatientlist?account_email='+ data.account_id + '&sector_code=' + data.sector_code).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

    this.getSector = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getallsectorcodes?account_email='+ data.account_email).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

    this.getDisBloVill = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getdetailsbysectorcode?account_email='+ data.account_id + '&sector_code=' + data.sector_code).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getPatientCoupon = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getpatientcoupons?account_email='+ data.account_id + '&patient_email=' + data.patient_email + '&status=' + data.status).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getCoupon = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'geteceshoppatientcouponreports', data).success(function (response) {
		  deferred.resolve(response);
    	}).error(function (error, status) {
		  deferred.reject(error);
	    });
	  return deferred.promise;
	};

	this.getPatientreport = function (data) {
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'appregistrationreport', data).success(function (response) {
		  deferred.resolve(response);
    	}).error(function (error, status) {
		  deferred.reject(error);
	    });
	  return deferred.promise;
	};

	this.createCoupon = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createeceshopproductcoupons',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateCoupon = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updateeceshopproductcoupondetails',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.deleteCoupon = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'deleteeceshopproductcoupondetails',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.linkEshopcoupon = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'linkcouponproducts',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateLinkedeshopcoupon = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updatelinkedcouponproducts',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updatecouponmaster = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updateeceshopcouponmaster',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getCoupon1 = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getcouponslist?account_email='+data.account_email).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getLinkedeshopcoupon = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getlinkedcouponproducts?account_email='+data.account_email+'&coupon_code='+data.couponcode).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getCouponmaster = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'geteceshopcouponmaster?account_email='+data.account_email).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.createCouponconfig1 = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'createeceshopcoupon',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.updateCouponconfig1 = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'updateeceshopcoupon',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getCouponconfig = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'geteceshopcoupon',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.deleteCouponconfig1 = function (data){
		var deferred = $q.defer();
		$http.post(serviceBaseUrl+'deleteeceshopcoupon',data).success(function(response){
			deferred.resolve(response);
		}).error(function (error, status){
			deferred.reject(error);
		});
		return deferred.promise;
	};

	this.getLinkedproducts = function (data) {
		var deferred = $q.defer();
		$http.get(serviceBaseUrl+'getlinkedcouponproducts?account_email='+data.account_email+'&coupon_code='+data.couponcode).success(function (response) {
			deferred.resolve(response);
		}).error(function (error, status) {
			deferred.reject(error);
		});
		return deferred.promise;
	};


    return this;    
}]);
'use strict';
angular.module('AngularApp').controller('accountController', ['$scope', '$rootScope', '$location', '$route', 'recordService', '$ngBootbox','$uibModal'
   , function ($scope, $rootScope, $location, $route, recordService , $ngBootbox, $uibModal) {

   		$scope.carenetId =  $route.current.params.Id;

$scope.loadCarenetAccountList  = function(){
	   		recordService.getCarenetAccountList({"carenet_id": $scope.carenetId}).then(function(response){
	   			if(response.accountlist){
		   			$scope.carenetAccountList  = response.accountlist;
		   			if(!angular.isArray($scope.carenetAccountList)){
		   				$scope.carenetAccountList = [response.accountlist];
		   			}
		   		}else{
		   			$scope.carenetAccountList = [];
		   		}
		   		if($rootScope.carenetRecords){
			   		$rootScope.carenetRecords.filter(function(item){
			   			if(item.id==$scope.carenetId){
			   				item.count = $scope.carenetAccountList.length;
			   			}
			   		});
			  	}
	   		},function (err, response) {
            $ngBootbox.alert(err.Message);
        });
	   	};

	   	$scope.loadCarenetAccountList();

$scope.deleteCarenet = function(){
   			var options = {
        message: 'Are you sure to delete this carenet?',
        title: 'Delete Carenet',
        buttons: {
             success: {
                 label: " Confirm",
                 className: "btn-primary fa fa-check",
                 callback: function() {
                      recordService.deleteCarenet({carenet_id:$scope.carenetId }).then(function(response){
                        $location.path("/home");
                        $rootScope.loadCarenetList();
                       },function (err, response) {
                          $ngBootbox.alert(err.Message);
                        });

                 }
             },
             warning: {
                 label: " Cancel ",
                 className: "btn-danger fa fa-times",
                 callback: function() {
                  }
             }
        }
    }

        $ngBootbox.customDialog(options);

   		};

$scope.deleteCarenetAccount = function(user){
          var options = {
        message: "Are you sure to remove "+ user.full_name +" from the Carenet?",
        title: 'Remove patient from Carenet',
        buttons: {
              success: {
                 label: " Confirm",
                 className: "btn-primary fa fa-check",
                 callback: function() {
                                recordService.deleteCarenetAccount({account_id:user.email,carenet_id:$scope.carenetId}).then(function(response){
                                  $scope.loadCarenetAccountList();
                                   },function (err, response) {
                                       $ngBootbox.alert(err.Message);
                                   });

                 }
             },
              warning: {
                               label: " Cancel",
                               className: "btn-danger fa fa-times",
                               callback: function() {
                                }
                           }
        }
    }

    $ngBootbox.customDialog(options);

   		};

$scope.addCarenetAccount = function(){

   			$rootScope.addCarenetAccountData = {
   				patientList : angular.copy($rootScope.patientList),
   				addPatient : function(patient){
   					if(!patient.added){
              recordService.addCarenetAccount(
                {
                  record_id: patient.id,
                  carenet_id: $scope.carenetId,
                  write: "false"
                 }).then(function(response){

                   },function (err, response) {
                   $ngBootbox.alert(err.Message);
               });
	   					patient.added = true;
              $scope.loadCarenetAccountList();
	   				}
   				}
   			};


            var options = {
            title: '<b><span class="fa fa-users"></span> Add Patient to Carenet</b>',
            message :'',
            templateUrl: 'views/addcarenetaccountpopup.htm',
            buttons: {
                 close:{
                     label: "Close",
                     className: "btn-danger fa fa-times",
                    callback: function() {}
                 }
            }
        };

        $ngBootbox.customDialog(options);
   		};

      $scope.loadPatient = function(id){
        sessionStorage.setItem('patientid',id)
      $location.path('/patientview/'+id);
    };


	 	$scope.viewRecord = function(user){
	 		$rootScope.recordId = user.id;
	 		$location.path('/patientview/'+user.id);
	 	};


} ]);

'use strict'
angular.module('AngularApp').controller('adviceController',['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','localStorageService','adviceService','authService','toastr',
    function($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter,localStorageService,adviceService,authService,toastr) {

        $scope.loadAdviceList = function() {
            adviceService.listAdvice().then(function(response) {
                $scope.adviceList = response.advice_master;
            },function(error) {
                toastr.error(error);
                analytics('loadAdviceList',error);
            })
        };

        $scope.loadAdviceList();

        $scope.addNewAdvice = function() {
            $location.path('/addAdvice');
        };

        $scope.newData = {disease:'',description:''};

        $scope.saveAdviceData = [{disease:'',description:''}];

        $scope.addLifelog = function(data,index){
            if(data.disease!=""){
                $scope.saveAdviceData[index]=data;
                $scope.saveAdviceData.push({disease:'',description:''});
            }else{
                toastr.error("Please fill all fields, before adding new advice.");
                analytics('addLifelog','Please fill all fields, before adding new advice.');
            }
        };

        $scope.deleteRow = function(data){
            if($scope.saveAdviceData.length>1)
            $scope.saveAdviceData.splice(data,1);
        };

        $scope.saveAdvice = function() {
            var data = {
                account_email: authService.authentication.account_id,
                items : $scope.saveAdviceData,
            }
            adviceService.addAdvice(data).then(function(response) {
                toastr.success('Saved Successfully');
                $location.path('/advice');
                $scope.loadAdviceList();
            },function(error) {
                toastr.error(error);
                analytics('saveAdvice',error);
            })
        };

        $scope.back = function(){
            $location.path('/advice');    
        };

        $rootScope.adviceData = {};

        $scope.updateAdvice = function(data) {
            $rootScope.adviceData = data;
            var options = {
                title: 'Update Advice',
                message:'',
                templateUrl: 'views/advice/updateAdvice.htm',
                size:'medium', 
                onEscape: function() {$scope.$apply();},
                buttons: {
                    ok:{
                        label: " Save",
                        className: "btn-primary fa fa-save",
                        callback: function() {
                            var data = {
                                        account_email: authService.authentication.account_id,
                                        item: {
                                            description: $rootScope.adviceData.description,
                                            id: $rootScope.adviceData.id,
                                            disease: $rootScope.adviceData.disease
                                        }
                                    };

                            adviceService.updateAdvice(data).then(function(response) {
                                toastr.success('Updated Successfully');
                            },function(error) {
                                toastr.error(error);
                                analytics('updateAdvice',error);
                            })

                        }
                    },
                    close:{
                        label: " Close",
                        className: "btn-danger fa fa-times-circle",
                        callback: function() {}
                    }
                }
            };

            $ngBootbox.customDialog(options);
        };

     //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
          'event_category' : 'adviceController',
          'event_label' : aLabel
        });
     }   

}]);
'use strict';
angular.module('AngularApp').controller('agentController', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'agentService', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, agentService) {

    $scope.viewAgentForm = function(){
        $rootScope.updatestatus = false
        $location.path('/agentform')
    }
    
    $scope.getAgentBiodata = function(){
        agentService.getAgentData().then(function (response) {
            $scope.agent_details_arr = response.data
            $rootScope.updatestatus = false
         })
    }

    $scope.getAgentBiodata()

    $scope.updateAgentData = function(data){
        $rootScope.updatestatus = true
        $location.path('/agentform')
        setTimeout(function(){
            $rootScope.setData(data)
            $scope.$apply();
        },500);
    }

    $scope.deleteAgentData = function(data){
        var params = {
            account_email: authService.authentication.account_id,
            id : data.id
        }
        agentService.deleteAgentBiodata(params).then(function (response) {
            if(response.success == 1){
                toastr.success("Deleted successfully")
            } else {
                toastr.error("Unable to delete")
            }
         })
    }
}]);

'use strict';
angular.module('AngularApp').controller('agentController2', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'agentService', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, agentService) {


    $scope.agent = {}
    if($rootScope.updatestatus == undefined){
        $rootScope.updatestatus = false
    }
    
    $scope.datavalidate = function(data){
        var params = {
            account_email : authService.authentication.account_id,
            username : data
        }
        agentService.datavalidateapi(params).then(function (response) {
            if(response.message == 'username available'){
                $scope.username_status = true
            } else {
                $scope.username_status = false
            }
         })
    }

    $scope.addAgentBiodata = function () {
        var item = {
            account_email: authService.authentication.account_id,
            username : $scope.agent.agent_username,
            password : $scope.agent.agent_password,
            first_name: $scope.agent.agent_firstname,
            last_name:  $scope.agent.agent_lastname,
            mobile_number: $scope.agent.agent_mobile,
            email_id: $scope.agent.agent_email,
            address: $scope.agent.agent_address,
            district: $scope.agent.agent_district,
            state: $scope.agent.agent_state,
            pincode: $scope.agent.agent_pincode,
            agent_type: $scope.agent.agent_type,
        }
        agentService.postAgentBiodata(item).then(function (response) {
           if(response.success == 1){
            toastr.success("Created successfully")
            $location.path('/agentsettings')
           } else if (response.success == 2) {
            toastr.error("Data already exits")
           } else {
            toastr.error("Unable to create")
           }
        })
        }

        $scope.updateAgentBiodata = function(){
            var params = { 
                account_email: authService.authentication.account_id,
                "id": $scope.updateid, 
                "first_name": $scope.agent.agent_firstname, 
                "last_name": $scope.agent.agent_lastname, 
                "mobile": $scope.agent.agent_mobile, 
                "email": $scope.agent.agent_email, 
                "address": $scope.agent.agent_address, 
                "district": $scope.agent.agent_district, 
                "state": $scope.agent.agent_state, 
                "pincode": $scope.agent.agent_pincode, 
                "agent_type": parseInt($scope.agent.agent_type) 
            } 
            agentService.updateAgentBiodata(params).then(function (response) {
                if(response.success == 1){
                    toastr.success("Update successfully")
                    $location.path('/agentsettings')
                    $rootScope.updatestatus = false
                   } else {
                    toastr.error("Unable to create")
                   }
             })
        }

        $scope.getmasteragenttype = function(){
            agentService.getAgenttype().then(function (response) {
                $scope.agentmastertype = response.data
             })
        }
        $scope.getmasteragenttype()
    
        $rootScope.setData = function(data){
            console.log(data)
            $scope.updateid = data.id
            $scope.agent.agent_firstname = data.first_name
            $scope.agent.agent_lastname = data.last_name
            $scope.agent.agent_mobile = data.mobile
            $scope.agent.agent_email = data.email
            $scope.agent.agent_address = data.address
            $scope.agent.agent_district = data.district
            $scope.agent.agent_state = data.state
            $scope.agent.agent_pincode = data.pincode
            $scope.agent.agent_type = JSON.stringify(data.agent_type)
            $scope.getmasteragenttype()
            $scope.$apply();
        }

}]);
'use strict';
angular.module('AngularApp').controller('appointmentController', ['$scope', '$rootScope', '$location', '$route', 'recordService', '$ngBootbox','$uibModal', '$filter', 'authService','toastr'
   , function ($scope, $rootScope, $location, $route, recordService , $ngBootbox, $uibModal, $filter, authService,toastr) {
    
// UTC to local time conversion
$scope.convertUTCDateToLocalDate = function(date) {
    var newDate = new Date(date);
    var offset = newDate.getTimezoneOffset();
    var minutes = newDate.getMinutes();
    newDate.setMinutes(minutes - offset);
    return newDate;   
};

// Local to UTC time conversion
$scope.convertLocalDateToUTCDate = function(date) {
    var newDate = new Date(date);
    var offset = newDate.getTimezoneOffset();
    var minutes =newDate.getMinutes();
    newDate.setMinutes((minutes + offset));
    return newDate;
};
    
$scope.getSchedule = function(){
    recordService.getscheduleexceptions().then(function(response) {
        $scope.holidayList= response.data;
        angular.forEach($scope.holidayList, function(value){
            value.showEdit = new Date(value.end_time) > new Date();
            value.start_time = new Date(value.start_time);
            value.end_time = new Date(value.end_time);
        })
    }, function(err){
        toastr.error(err);
        analytics('getSchedule',err);
    })
};

$rootScope.changed = function(){
    if ($rootScope.timeData.startTime && $rootScope.timeData.endTime){
        var a1 = $rootScope.timeData.startTime.split(":");
        var a2 = $rootScope.timeData.endTime.split(":");
        var b1 = new Date().setHours(a1[0],a1[1]);
        var b2 = new Date().setHours(a2[0],a2[1]);
        if(b1 >= b2){
            $rootScope.showTimeRangeError = 'true';
        }else{
            $rootScope.showTimeRangeError = 'false';
        }
    }
};

var times = [], i,j;
for(i=0; i<24; i++) {
    for(j=0; j<2; j++) {
    times.push((i<10? "0"+i : i)+":"+(j==0 ? "00" : j*30));
    }
};
    
$rootScope.times=times;

$rootScope.validate=function(data){
    var minutesOfDay = function(data){
        return data.minutes() + data.hours() * 60;
    }          
    return minutesOfDay(timeData.startTime) > minutesOfDay(timeData.endTime);
    alert("wrong time range");
};
       
$scope.getSchedule();

$rootScope.closeTimepicker=function(){
    $rootScope.openstartTime = false;
    $rootScope.openendTime = false;
};

$rootScope.datepicker= {
    opened :{ childInfo:false, fatherInfo:false, motherInfo:false},
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
    formatYear: 'yyyy',
    startingDay: 1,
    minDate: new Date()
    }
};

$rootScope.minDate = new Date();
$rootScope.endminDate = $rootScope.minDate;
$rootScope.maxDate= moment(new Date()).add(30,'days');

$rootScope.changeMinDate = function(){
    $rootScope.datepicker.dateOptions.minDate = $rootScope.addData.startDate;
};

$scope.popup2 = {
    opened: false
};
$rootScope.openDate = function() {
    $scope.popup2.opened = true;
};

$rootScope.addData = {};

$rootScope.timeData ={};

$scope.$watch('addData', function() {
    if($rootScope.timeData.startTime){            
    }
})

var month = [{name: "Jan" ,key: "01"},{name: "Feb" ,key: "02"},{name: "Mar" ,key: "03"},{name: "Apr" ,key: "04"},
                 {name: "May" ,key: "05"},{name: "Jun" ,key: "06"},{name: "Jul" ,key: "07"},{name: "Aug" ,key: "08"},
                 {name: "Sep" ,key: "09"},{name: "Oct" ,key: "10"},{name: "Nov" ,key: "11"},{name: "Dec" ,key: "12"}]
    
$scope.addNew = function(type,id){
    $rootScope.showTimeRangeError = 'false';
    if(type=='create'){
        $rootScope.showCreate = true;
    }else{
        $rootScope.addData = id;
        $rootScope.addData.startTime = moment(id.start_time).format('HH:mm');
        $rootScope.addData.endTime = moment(id.end_time).format('HH:mm');
        $rootScope.timeData.startTime = $rootScope.addData.startTime;
        $rootScope.timeData.endTime = $rootScope.addData.endTime;
        $rootScope.showCreate = false;
    }
    var options = {
        title: '<b>Holiday / Busy Plan</b>',
        message:'',
        templateUrl: 'app/apt-config/newPlan.html',
        size:'large',
        onEscape: function() { $rootScope.timeData={};$rootScope.addData={};$rootScope.showmultidate = false},
        buttons: {
            preview : {
                label: "Preview SMS",
                callback: function() {
                    $scope.previewsms()
                    e.preventDefault();
                }
            },
            ok:{
                label: " Save",
                className: "btn-primary",
                callback: function() {

                    var exceptionDate = $filter('date')($rootScope.addData.date, "yyyy-MM-dd");
                    var exceptionDate1 = $filter('date')($rootScope.addData.todate, "yyyy-MM-dd");
                    $rootScope.addData.date = new Date($rootScope.addData.date);
                    var d = new Date($rootScope.addData.date);
                    var d1 = new Date($rootScope.addData.todate);
                    var check1 = $rootScope.timeData.startTime.split(":");
                    var check2 = $rootScope.timeData.endTime.split(":");
                    $rootScope.timeData.startTime= d.setHours(check1[0],check1[1]);
                    if($rootScope.addData.todate){
                        $rootScope.timeData.endTime= d1.setHours(check2[0],check2[1]);
                    } else {
                        $rootScope.timeData.endTime= d.setHours(check2[0],check2[1]);
                    }
                    
                    if(!$rootScope.timeData.startTime){
                        $rootScope.timeData.startTime =$scope.convertLocalDateToUTCDate(new Date($rootScope.addData.start_time));
                    }else{
                        $rootScope.timeData.startTime =$scope.convertLocalDateToUTCDate(new Date($rootScope.timeData.startTime));
                    }
                    if(!$rootScope.timeData.endTime){
                        $rootScope.timeData.endTime =$scope.convertLocalDateToUTCDate(new Date($rootScope.addData.end_time));
                    }
                    else{
                        $rootScope.timeData.endTime =$scope.convertLocalDateToUTCDate(new Date($rootScope.timeData.endTime));
                    }
                    
                    var sdate = $rootScope.timeData.startTime.toString().split(" ");
                    var stime = $rootScope.timeData.startTime.toString().split(" ");
                    var mon;
                    var smon = angular.forEach(month, function(value) {
                        if(value.name==sdate[1]){
                                mon = value.key
                        } 
                    })
                    var edate = $rootScope.timeData.endTime.toString().split(" ");
                    var etime = $rootScope.timeData.endTime.toString().split(" ");
                    var enmon;
                    var emon = angular.forEach(month, function(value) {
                        if(value.name==edate[1]){
                                enmon = value.key
                        }
                    }) 
                    
                    if($rootScope.timeData.startTime < $rootScope.timeData.endTime){
                        var start_time = sdate[3]+"-"+mon+"-"+sdate[2]+"T"+stime[4]+"Z";
                        var end_time = edate[3]+"-"+enmon+"-"+edate[2]+"T"+etime[4]+"Z";
                    }else{
                        analytics('addNew','Invalid Time Range');
                        return toastr.error("Invalid Time range");
                    }
                    if($rootScope.addData.todate == undefined){
                        var holidaymessage = $rootScope.holidaycontent.content
                    } else {
                        var holidaymessage = $rootScope.holidaycontent1.content
                    }

                    var data = {
                        account_email:authService.authentication.account_id,
                        doctor_id : authService.authentication.doctor_id,
                        schedule_exception:{
                            start_date:exceptionDate ? exceptionDate : "",
                            end_date : exceptionDate1 ? exceptionDate1 : "",
                            start_time:start_time,
                            end_time:end_time,
                            reason:$rootScope.addData.reason,
                            notes:$rootScope.addData.notes ? $rootScope.addData.notes : ""
                        }
                    }

                    var smsdata = {
                        account_email:authService.authentication.account_id,
                        doctor_id : authService.authentication.doctor_id,
                        from_date: exceptionDate,
                        to_date: exceptionDate1,
                        start_time: start_time,
                        end_time: end_time,
                        duration: $rootScope.addData.patientduration,
                        reason: $rootScope.addData.reason,
                        notes: $rootScope.addData.notes ? $rootScope.addData.notes : "",
                        content: holidaymessage
                        
                    }
                    if(type==='update'){
                        data.planning_exception_id = id.id,
                        recordService.updatescheduleexceptions(data).then(function(response) {
                           if(response.error){
                               toastr.error("Please fill mandatory fields")
                           } else {
                               toastr.success("Updated Successfully")
                           }
                            $rootScope.addData = {};
                            $rootScope.timeData = {};
                            $scope.getSchedule();
                            return; 
                        }, function(err){
                            toastr.error(err);
                            analytics('addNew',err);
                        });
                    }
                    if(type==='create'){
                        recordService.createscheduleexceptions(data).then(function(response) {
                            if(response.error){
                                toastr.error(response.error)
                            } else if (response.data){
                                recordService.sendholidaysms(smsdata).then(function(response) {
                                    if($scope.holidaysmsvalue == true){
                                        if(response.status == 1){
                                            toastr.success(response.message)
                                        } else {
                                            toastr.error(response.message)
                                        }
                                    }
                                    $rootScope.addData = {};
                                    $rootScope.timeData = {};
                                    $scope.getSchedule();
                                    return;
                                }, function(err){
                                    toastr.error(err);
                                    analytics('addNew',err);
                                });
                                toastr.success("Created Successfully")
                            }
                            $rootScope.addData = {};
                            $rootScope.timeData = {};
                            $scope.getSchedule();
                            return;
                        }, function(err){
                            toastr.error(err);
                            analytics('addNew',err);
                        });
                    }
                    $scope.getSchedule();
                    $rootScope.showmultidate = false
                }
            },
            close:{
                label: " Close",
                className: "btn-danger",
                callback: function() {$rootScope.timeData={};$rootScope.addData={};$rootScope.showmultidate = false}
            }
        }
    };
    $ngBootbox.customDialog(options);
};

$rootScope.showmultidates = function(){
   if($rootScope.addData.todate != undefined){
    $rootScope.showmultidate = true
   } else {
    $rootScope.showmultidate = false
   }
}

$scope.holidaysmsvalue = false;

$scope.toggleholidaysms = function(){
    $scope.holidaysmsvalue = !$scope.holidaysmsvalue
}

$scope.previewsms = function(){
    $rootScope.showmultidates()
    var options = {
        title: '<h5 style="color:white">SMS Content</h5>',
        message: '',
        templateUrl: 'app/apt-config/holidaypreviewsms.htm',
        size: 'medium',
        onEscape: function () {
        },
        buttons: {
        }
    }
    $ngBootbox.customDialog(options);
}

$rootScope.holidaycontent = {
    content : "Dear <Patient Name>, \n \nDr <Name of the Dr> will not be available on <Date> in hospital for consultations. If you have booked appointment, please contact hospital reception in <Hospital number>.\n \n Regards,\n <Hospital Name>"
}
$rootScope.holidaycontent1 = {
    content : "Dear <Patient Name>, \n \nDr <Name of the Dr> will not be available from <From date> to <To Date> in hospital for consultations. If you have booked appointment, please contact hospital reception in <Hospital number>.\n \n Regards,\n <Hospital Name>"
}


$scope.deletePlan = function(data){
    recordService.deleteScheduleExceptions(data.id).then(function(response) {
        toastr.success("Deleted Successfully");
        $scope.getSchedule();
    }, function(error) {
        toastr.error(error.error);
        analytics('deletePlan',error.error);
    })
};

//function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'appointmentController',
            'event_label' : aLabel
        });
     }  


}]);


'use strict';

angular.module('AngularApp').controller('babiesvscommunityvisitController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr', 'multicenterstudyreportService',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr, multicenterstudyreportService) { 
    
    $scope.timeInputDisable = true;

    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
        }
    };

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.exportData = function(type) {

      if($scope.babiesCommunityVisit) {
 
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Baby_vs_communityvisit_report_"+$scope.formattedDate;
          
          if($scope.selectedFromDate && $scope.selectedToDate){
              filename = "Baby_vs_communityvisit_report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
          }
          
         /* if(type=='csv') {

              alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
              
          } else*/
          if(type == 'excel') {

              //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                  var blob = new Blob([document.getElementById('printtable').innerHTML], {
                      type: "application/vnd.ms-excel;charset=utf-8"
                  });
               saveAs(blob, filename+".xls");

          } else if(type=='pdf') {

              var pdf_element = document.getElementById('printtable');
              var opt = {
                  margin:      0.2,
                  filename:   filename,
                  image:       { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
              };
                  
              //New Promise-based usage:
              html2pdf().set(opt).from(pdf_element).save();
                  
          }
      }
  }

    $scope.labelHide = true
    $scope.getBabiesvsCommunityVisitStatus = function() {
        var data = {
            account_email: authService.authentication.account_id,
            from_date: $scope.selectedFromDate2,
            to_date : $scope.selectedToDate2
        }
        console.log(data);
        multicenterstudyreportService.getBabiesvsCommunityVisit(data).then(function(response) {
            if(response.data.visit_wise_details.length > 0){
              $scope.labelHide = false
              $scope.babiesCommunityVisit = response.data;
              console.log($scope.babiesCommunityVisit);
            } else {
              $scope.labelHide = true
              $scope.errMsg = 'Data is not available on this period'
            }
        },function(error) {
            if(error){
              toastr.error('Select from & to date')
            }
            // toastr.error(error);
            analytics('getBabiesvsCommunityVisitStatus',error);
        })
    };

    // $scope.getBabiesvsCommunityVisitStatus()
    
}]);

'use strict';

angular.module('AngularApp').controller('babygrowtheverystagecommunityController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr','multicenterstudyreportService',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr, multicenterstudyreportService) { 
  
    $scope.timeInputDisable = true;

    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
        }
    };

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.exportData = function(type) {

      if($scope.babyGrowthEverystage) {
 
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Babygrowth_everystage_report_"+$scope.formattedDate;
          
          if($scope.selectedFromDate && $scope.selectedToDate){
              filename = "Babygrowth_everystage_report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
          }
          
         /* if(type=='csv') {

              alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
              
          } else*/
          if(type == 'excel') {

              //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                  var blob = new Blob([document.getElementById('printtable').innerHTML], {
                      type: "application/vnd.ms-excel;charset=utf-8"
                  });
               saveAs(blob, filename+".xls");

          } else if(type=='pdf') {

              var pdf_element = document.getElementById('printtable');
              var opt = {
                  margin:      0.2,
                  filename:   filename,
                  image:       { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
              };
                  
              //New Promise-based usage:
              html2pdf().set(opt).from(pdf_element).save();
                  
          }
      }
  }

    $scope.labelHide = true
    $scope.getBabyGrowthEverystageStatus = function() {
        var data = {
            account_email: authService.authentication.account_id,
            start_dt: $scope.selectedFromDate2,
            end_dt : $scope.selectedToDate2
        }
        multicenterstudyreportService.getBabyGrowthEverystage(data).then(function(response) {
          if(response.success == 0){
            $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
          } else {
            $scope.labelHide = false
            $scope.babyGrowthEverystage = response[0];
            console.log($scope.babyGrowthEverystage);
          }
            
        },function(error) {
            if(error){
              toastr.error('Select from & to date')
            }
            // toastr.error(error);
            analytics('getBabyGrowthEverystageStatus',error);
        })
    };

    // $scope.getBabyGrowthEverystageStatus()
   
}]);

'use strict';

angular.module('AngularApp').controller('babymalnutritionicdsController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr', 'multicenterstudyreportService',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr, multicenterstudyreportService) { 


    $scope.timeInputDisable = true;

    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
        }
    };

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.exportData = function(type) {

      if($scope.babyMalnutrition) {
 
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Baby_malnutrition_report_"+$scope.formattedDate;
          
          if($scope.selectedFromDate && $scope.selectedToDate){
              filename = "Baby_malnutrition_report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
          }
          
         /* if(type=='csv') {

              alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
              
          } else*/
          if(type == 'excel') {

              //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                  var blob = new Blob([document.getElementById('printtable').innerHTML], {
                      type: "application/vnd.ms-excel;charset=utf-8"
                  });
               saveAs(blob, filename+".xls");

          } else if(type=='pdf') {

              var pdf_element = document.getElementById('printtable');
              var opt = {
                  margin:      0.2,
                  filename:   filename,
                  image:       { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
              };
                  
              //New Promise-based usage:
              html2pdf().set(opt).from(pdf_element).save();
                  
          }
      }
  }

    $scope.labelHide = true
    $scope.getBabyMalnutritionStatus = function() {
        var data = {
            account_email: authService.authentication.account_id,
            start_date: $scope.selectedFromDate2,
            end_date: $scope.selectedToDate2
        }
        multicenterstudyreportService.getBabyMalnutrition(data).then(function(response) {
            if(response.status == 1){
              $scope.labelHide = false
              $scope.babyMalnutrition = response.message[0];
            console.log($scope.babyMalnutrition);
            } else {
              $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
            }
        },function(error) {
            if(error){
              toastr.error('Select from & to date')
            }
            // toastr.error(error);
            analytics('getBabyMalnutritionStatus',error);
        })
    };

    // $scope.getBabyMalnutritionStatus()
}]);

'use strict';

angular.module('AngularApp').controller('babyregistrationController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr','multicenterstudyreportService',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr, multicenterstudyreportService) { 
       

    $scope.timeInputDisable = true;

    $scope.exportData = function(type) {

      if($scope.babyRegistration) {
 
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Baby_registration_report_"+$scope.formattedDate;
          
          if($scope.selectedFromDate && $scope.selectedToDate){
              filename = "Baby_registration_report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
          }
          
         /* if(type=='csv') {

              alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
              
          } else*/
          if(type == 'excel') {

              //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                  var blob = new Blob([document.getElementById('printtable').innerHTML], {
                      type: "application/vnd.ms-excel;charset=utf-8"
                  });
               saveAs(blob, filename+".xls");

          } else if(type=='pdf') {

              var pdf_element = document.getElementById('printtable');
              var opt = {
                  margin:      0.2,
                  filename:   filename,
                  image:       { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
              };
                  
              //New Promise-based usage:
              html2pdf().set(opt).from(pdf_element).save();
                  
          }
      }
  }

    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
        }
    };

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }
    $scope.labelHide = true
    $scope.getBabyRegistrationStatus = function() {
        var data = {
            account_id: authService.authentication.account_id,
            from_date: $scope.selectedFromDate2,
            to_date : $scope.selectedToDate2
        }
        multicenterstudyreportService.getBabyRegistration(data).then(function(response) {
          if(response.data.length > 0){
            $scope.labelHide = false
            $scope.babyRegistration = response;
            console.log($scope.babyRegistration);
          } else {
            $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
          }
           
        },function(error) {
          if(error){
            toastr.error('Select from & to date')
          }
            // toastr.error(error);
          analytics('getBabyRegistrationStatus',error);
        })
    };

    // $scope.getBabyRegistrationStatus()
   
}]);

'use strict';

angular.module('AngularApp').controller('babystatusicdsController', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'locationService', '$ngBootbox', '$sessionStorage', 'toastr', 'multicenterstudyreportService',
  function ($scope, $rootScope, $location, $filter, authService, locationService, $ngBootbox, $sessionStorage, toastr, multicenterstudyreportService) {


    $scope.timeInputDisable = true;

    $scope.rangePicker1 = {
      opened: { fromDate: false, toDate: false },
      maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
      dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
      }
    };

    $scope.rangePicker2 = {
      opened: { fromDate: false, toDate: false },
      maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
      dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
      }
    };

    function getPreviousDate(days, value) {
      var dateOffset = parseInt(days * value);
      var convertDate = new Date();
      convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
      return convertDate;
    }

    function getStringDate(date) {
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      return [year + "-" + month + "-" + day, day + "-" + month + "-" + year];
    }

    function start_endOfWeek(date, start, end) {
      var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
      return new Date(date.setDate(diff));
    }

    $scope.changeDay = function (day) {

      if (day == "5") {
        $scope.timeInputDisable = false;
        $scope.fromDate = "";
        $scope.toDate = "";
        $scope.selectedFromDate = "";
        $scope.selectedToDate = "";
        $scope.selectedFromDate2 = "";
        $scope.selectedToDate2 = "";
        $scope.hidetable1 = 'true';
        $scope.hidetable2 = 'true';

      } else {
        $scope.timeInputDisable = true;
      }

      switch (day) {
        case "4":
          //var tempArray = getPreviousDate(1,30);
          var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
          var datArr = getStringDate(new Date(prevMonthFirstDate));
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          $scope.fromDate = new Date(prevMonthFirstDate);
          var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
          var datArr2 = getStringDate(new Date(prevMonthLastDate));
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];
          $scope.toDate = new Date(prevMonthLastDate);
          break;
        case "3":
          //var tempArray = getPreviousDate(1,7);
          var startLastWeek = start_endOfWeek(new Date(), 1, -6).toString();
          var datArr = getStringDate(new Date(startLastWeek));
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          $scope.fromDate = new Date(startLastWeek);
          var endLastWeek = start_endOfWeek(new Date(), -6, 0).toString();
          var datArr2 = getStringDate(new Date(endLastWeek));
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];
          $scope.toDate = new Date(endLastWeek);
          break;
        case "2":
          var tempArray = getPreviousDate(1, 1);
          $scope.selectedFromDate = tempArray.getDate() + '-' + (tempArray.getMonth() + 1) + '-' + tempArray.getFullYear();
          $scope.selectedFromDate2 = tempArray.getFullYear() + '-' + (tempArray.getMonth() + 1) + '-' + tempArray.getDate();
          $scope.selectedToDate = $scope.selectedFromDate;
          $scope.selectedToDate2 = $scope.selectedFromDate2;
          $scope.fromDate = tempArray;
          $scope.toDate = $scope.fromDate;
          break;
        case "1":
          var datArr = getStringDate(new Date());
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          $scope.selectedToDate = $scope.selectedFromDate;
          $scope.selectedToDate2 = $scope.selectedFromDate2;
          $scope.fromDate = new Date();
          $scope.toDate = $scope.fromDate;
          break;
      }
    }

    $scope.byRange = function (from, to) {

      if (from) {
        $scope.rangePicker2 = {
          opened: { fromDate: false, toDate: false },
          maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
          dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
            minDate: from
          }
        };
      }

      if (to) {
        $scope.rangePicker1 = {
          opened: { fromDate: false, toDate: false },
          maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
          dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: to
          }
        };
      };

      if (from && to) {
        var datArr = getStringDate(from);
        $scope.selectedFromDate = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        var datArr2 = getStringDate(to);
        $scope.selectedToDate = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
      }
    }

    $scope.exportData = function(type) {

      if($scope.readmittedBaby) {
 
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Baby_readmitted_status_report_"+$scope.formattedDate;
          
          if($scope.selectedFromDate && $scope.selectedToDate){
              filename = "Baby_readmitted_status_report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
          }
          
         /* if(type=='csv') {

              alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
              
          } else*/
          if(type == 'excel') {

              //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                  var blob = new Blob([document.getElementById('printtable').innerHTML], {
                      type: "application/vnd.ms-excel;charset=utf-8"
                  });
               saveAs(blob, filename+".xls");

          } else if(type=='pdf') {

              var pdf_element = document.getElementById('printtable');
              var opt = {
                  margin:      0.2,
                  filename:   filename,
                  image:       { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
              };
                  
              //New Promise-based usage:
              html2pdf().set(opt).from(pdf_element).save();
                  
          }
      }
  }

    $scope.labelHide = true
    $scope.getReadmittedBabyStatus = function () {
      var data = {
        account_email: authService.authentication.account_id,
        start_date: $scope.selectedFromDate2,
        end_date: $scope.selectedToDate2
      }
      multicenterstudyreportService.getReadmittedBaby(data).then(function (response) {
        if (response.success == 1) {
          $scope.labelHide = false
          var result = response.data
          var popped = response.data.pop()
          $scope.readmittedBaby = result;
          console.log($scope.readmittedBaby);
        } else {
          $scope.labelHide = true
          $scope.errMsg = 'Data is not available on this period'
        }
      }, function (error) {
        if(error){
          toastr.error('Select from & to date')
        }
        // toastr.error(error);
        analytics('getReadmittedBabyStatus', error);
      })
    };

    // $scope.getReadmittedBabyStatus()

  }]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('barController',  ['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','paymentService','authService','dashboardService','toastr',
function($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter, paymentService, authService, dashboardService, toastr) {
  
  $rootScope.rangePicker1 = {
    opened :{ fromDate:false, toDate:false},
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: new Date()
    }
  };

  $rootScope.rangePicker2 = {
    opened :{ fromDate:false, toDate:false},
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: new Date(),
    }
  };

  $rootScope.rangePicker3 = {  
    opened :{ fromDate:false, toDate:false},
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: new Date()
    }
  };

  $rootScope.rangePicker4 = {  
    opened :{ fromDate:false, toDate:false},
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: new Date()
    }
  };

  $rootScope.rangePicker5 = {  
    opened :{ fromDate:false, toDate:false},
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: new Date()
    }
  };

  $rootScope.rangePicker6 = {  
    opened :{ fromDate:false, toDate:false},
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: new Date()
    }
  };

  $rootScope.chartContainer_Show  = false;
  $rootScope.chartContainer_Show  = false;
  $rootScope.chartContainer2_Show = false;
  $rootScope.chartContainer2_Show = false;
  $rootScope.chartContainer3_Show = false;
  $rootScope.chartContainer3_Show = false;
  $rootScope.chartContainer4_Show = false;
  $rootScope.chartContainer4_Show = false;

  $scope.addSmsPush = function(sms, push){
    return sms+push;
  }

  $scope.highchartsDataFormat = function(data){
    $scope.dashboard_sms  = [];
    $scope.dashboard_push = [];
    $scope.dashboard_date = [];

    angular.forEach(data, function(value, key) {	
       $scope.dashboard_sms.push( value.sms );
       $scope.dashboard_push.push( value.push );
       $scope.dashboard_date.push( value.pdate );
    });

    $scope.vaccinechart($scope.dashboard_sms,$scope.dashboard_push);
  }

  $scope.highchartsDataFormat2 = function(data){
    $scope.dashboard2_sms  = [];
    $scope.dashboard2_push = [];
    $scope.dashboard2_date = [];

    angular.forEach(data, function(value, key) {	
      $scope.dashboard2_sms.push( value.sms );
      $scope.dashboard2_push.push( value.push );
      $scope.dashboard2_date.push( value.pdate );
    });
    $scope.vaccinechart2();
  }

  $scope.highchartsDataFormat3 = function(data){

    $scope.dashboard3_apt_count = [];
    $scope.dashboard3_msg_count = [];
    
    $scope.dashboard3_apt_count.push( $scope.vaccineEngageData3.Appointment_Count );
    $scope.dashboard3_msg_count.push( $scope.vaccineEngageData3.Message_count );

    $scope.vaccinechart3();
  }

  $scope.highchartsDataFormat4 = function(data) {

    $scope.range_apt_count    =  [];
    $scope.range_msg_count    =  [];
    $scope.range_saved_dates  =  [];
    $scope.range_msg_total    =  0;
    $scope.range_apt_total    =  0;
    var first_date            =  ""
    var allow_loop            =  'true';
    
    angular.forEach(data, function(value, key) {
      
      if(first_date==value.pdate){
        allow_loop = 'false';
      }  

      if(allow_loop == 'true') {
          var temp_data = ($filter('filter')(data, {'pdate':value.pdate})); 

          for( var i=0; i<temp_data.length; i++ ){
            if(i==0){
              $scope.range_saved_dates.push(temp_data[i].pdate);
              $scope.range_msg_count.push(temp_data[i].Message_count);
              $scope.range_msg_total += parseInt(temp_data[i].Message_count);
            } else if(i==1){
              $scope.range_apt_count.push(temp_data[i].Appointment_Count);
              $scope.range_apt_total += parseInt(temp_data[i].Appointment_Count);
            }
          }
      }

      if(key==0){
        first_date = value.pdate;
      } 
    });

    $scope.vaccinechart4();
  }

  $scope.getVaccineData = function(dateVal){

    var payload = {
      account_email: authService.authentication.account_id,
      date: dateVal
    };

    dashboardService.vaccinationDashboard(payload).then(function(response){
   
      if(response.message){   
        $rootScope.chartContainer2_Show = false;
        $rootScope.chartContainer2_Show = false;
      } else {
        $scope.vaccineEngageData2 = response;
        $scope.highchartsDataFormat2(response);
        $rootScope.chartContainer2_Show = true;
        $rootScope.chartContainer2_Show = true;
      }

    }, function(error){
        toastr.error(error);
        $rootScope.chartContainer2_Show = false;
        $rootScope.chartContainer2_Show = false;
    });
  }

  $scope.getRangeVaccineData = function(from, to){

    var payload = {
      account_email: authService.authentication.account_id,
      from_date: from,
      to_date: to
    };

    dashboardService.vaccinationRangeDashboard(payload).then(function(response){

      if(response.message){
        $rootScope.chartContainer_Show = false;
        $rootScope.chartContainer_Show = false;
      } else {       
        $scope.vaccineEngageData = response;
        $scope.highchartsDataFormat(response.data);
        $rootScope.chartContainer_Show = true;
        $rootScope.chartContainer_Show = true;
      }
  
    }, function(error){
        toastr.error(error);
        $rootScope.chartContainer_Show = false;
        $rootScope.chartContainer_Show = false;
    });
  }

  $scope.getEffectiveData = function(dateVal){

    var payload = {
      account_email: authService.authentication.account_id,
      date: dateVal
    };

    dashboardService.vaccineEffectiveDashboard(payload).then(function(response) {
      


      if(response.message) {    
        $rootScope.chartContainer3_Show = false;
        $rootScope.chartContainer3_Show = false;
      } else {
        $scope.vaccineEngageData3 = response;
        $scope.highchartsDataFormat3(response);
        $rootScope.chartContainer3_Show = true;
        $rootScope.chartContainer3_Show = true;
      }

    }, function(error) {
       toastr.error(error);
       $rootScope.chartContainer3_Show = false;
       $rootScope.chartContainer3_Show = false;
    });
  }

  $scope.getRangeEffectiveData = function(from, to){

    var payload = {
      account_email: authService.authentication.account_id,
      from_date: from,
      to_date: to
    };

    dashboardService.vaccineEffectiveRangeDashboard(payload).then(function(response){
     
      if(response.message){  
          $rootScope.chartContainer4_Show = false;
          $rootScope.chartContainer4_Show = false;
      } else {
          $scope.vaccineEngageData4 = response;
          $scope.highchartsDataFormat4(response);
          $rootScope.chartContainer4_Show = true;
          $rootScope.chartContainer4_Show = true;
      }
  
    }, function(error){
         toastr.error(error);
         $rootScope.chartContainer4_Show = false;
         $rootScope.chartContainer4_Show = false;
    });
  }

  $scope.byRange2 = function(date,rangeValue) {
    if(date) {
      var return_date = $filter('date')(date, "dd-MM-yyyy"); 
     // if(rangeValue=='1') {
        $scope.getVaccineData(return_date);
    //  } else if(rangeValue=='3') {
        $scope.getEffectiveData(return_date);
   //   }
  // }else {

    }
  }

  $scope.byRange = function(from,to,rangeValue) {
     
    if(from) {
      $rootScope.rangePicker2 = {
          opened :{ fromDate:false, toDate:false},
          maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
          dateOptions : {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
            minDate: from
          }
      };
    }

    if(to) {
      $rootScope.rangePicker1 = {
        opened : {fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: to
        }
      }
    };

    if(from && to) {
      var start_date = $filter('date')(from, "dd-MM-yyyy");
      var end_date = $filter('date')(to, "dd-MM-yyyy");
     // if(rangeValue=='2') {
        $scope.getRangeVaccineData(start_date, end_date);
    //  } else if (rangeValue=='4'){
        $scope.getRangeEffectiveData(start_date, end_date);
    //  }
    }// else {}

  }


  $scope.vaccinechart = function(sms_data, push_data) {

    $('#chartContainers').highcharts({
          chart: {
            type: 'column',
            width: 500,
            height: 250
          },
          credits: {
            enabled: false
          },
          title: {
            text: 'Date Vs Message Sent'
          },
          xAxis: {
            categories: $scope.dashboard_date,
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Total'
            },
          /*  stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'normal',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
              }
            }*/
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
          },
          /*plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
                color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
              },
            }
          },*/
          series: [
            {
              name: 'SMS',
              data: sms_data
            },
            {
              name: 'Push',
              data: push_data
            }]
        });
  };


  $scope.vaccinechart2 = function() {

    $('#chartContainers2').highcharts({
      chart: {
      //plotBackgroundColor: null,
      //plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        height: 250,
        width: 400
    },
    title: {
        text: 'Message Category Split'
    },
    credits:{
      enabled: false
    },
    tooltip: {
        pointFormat: '{series.name:}'+'{point.percentage:.1f}%'
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: false
            },
            showInLegend: true
        }
    },
    series: [{
        name: '',
        colorByPoint: true,
        data: [{
            name: 'SMS',
            y: $scope.vaccineEngageData2.total_sms,
            sliced: true,
            selected: true
        }, {
            name: 'Push',
            y: $scope.vaccineEngageData2.total_push
        } /* , {
            name: 'Firefox',
            y: 10.85
        }, {
            name: 'Edge',
            y: 4.67
        }, {
            name: 'Safari',
            y: 4.18
        }, {
            name: 'Other',
            y: 7.05
        }*/]
    }]
});
/* $('#chartContainers2').highcharts({
          chart: {
            type: 'column',
            width: 500,
            height: 250
          },
          credits: {
            enabled: false
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: $scope.dashboard2_date, 
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Total'
            },
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
              }
            }
          },
          tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
                color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
              }
            }
          },
          series: [{
            name: 'SMS',
            data: $scope.dashboard2_sms
          }, {
            name: 'Push',
            data: $scope.dashboard2_push
          }]
        });*/
  }


 $scope.vaccinechart3 = function() {

  $('#chartContainers3').highcharts({

      chart: {
          type: 'column',
          width: 500,
          height: 250
      },
      credits:{
        enabled: false,
      },
      title: {
          text: 'Message Sent Vs Appointment Booked'
      },
      xAxis: {
          categories: [],
          labels:{
            enabled: false
          } 
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: 'Counts'
        },
      /* stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
          }
       }*/
      },
      tooltip: {
          formatter: function () {
              return '' +
                  this.series.name + ': ' + this.y + '<br/>' +
                  'Total: ' + this.point.stackTotal;
          }
      },
      plotOptions: {
          column: {
              stacking: 'normal'
          }
      },
      series: [{
          name: 'Message Count',
          data: $scope.dashboard3_msg_count,
          stack: 'male'
      }, {
          name: 'Appointment Count',
          data: $scope.dashboard3_apt_count,
          stack: 'female'
      }]
  });
};

$scope.vaccinechart4 = function() {

  $('#chartContainers4').highcharts({
    
      chart: {
          type: 'column',
          width: 500,
          height: 250
      },
      credits:{
        enabled: false,
      },
      title: {
          text: 'Message Sent Vs Appointment Booked'
      },
      xAxis: {
          categories: $scope.range_saved_dates,
      },
      yAxis: {
          allowDecimals: false,
          min: 0,
          title: {
              text: 'Counts'
          },
         /*  stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'normal',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
              }
           }*/
        
      }, 
      tooltip: {
          formatter: function () {
              return '<b>' + this.x + '</b><br/>' +
                  this.series.name + ': ' + this.y;/* + '<br/>' +
                  'Total: ' + this.point.stackTotal;*/
          }
      },
      plotOptions: {
          column: {
              stacking: 'normal'
          }
      },
      series: [{
          name: 'Message Count',
          data: $scope.range_msg_count,
          stack: 'male'
      }, {
          name: 'Appointment Count',
          data: $scope.range_apt_count,
          stack: 'female'
      }]
  });
}

/*$scope.showVaccineChart2 = function() {
      $scope.vaccinechart2();
  }

  $scope.showVaccineChart1 = function() {
      $scope.vaccinechart();
  }*/
//$("#barChart1").trigger("click");

}]);

'use strict';

angular.module('AngularApp').controller('careproviderController', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'locationService', '$ngBootbox', '$sessionStorage', 'toastr', 'careproviderService',
  function ($scope, $rootScope, $location, $filter, authService, locationService, $ngBootbox, $sessionStorage, toastr, careproviderService) { 

    $scope.viewCareproviderForm = function(){
        // $rootScope.updatestatus = false
        $location.path('/careprovider_form')
    }


    $scope.getDistricts = function() {
      
      $scope.district_id = "0";  

      $scope.selected_district = "";

      $scope.selected_district_name = "All";
      
      $scope.districts_list = [];
      
      var data = {
      account_email: authService.authentication.account_id
      };
      
      careproviderService.getDistrict(data).then(function (response) {
        $scope.districts_list = response
        console.log($scope.districts_list,'district list'); 
        if(response.length>0){
          $scope.selected_district_name = response[0].districtname;
          $scope.selected_district = response[0].id;    
          $scope.getFieldstaff(response[0].id,'value');
        }
      }, function (error) {
          //toastr.error(error);
      });
    }

    $scope.getDistricts()

    $scope.getFieldstaff = function(id,value) {
      console.log(value,'value');
      console.log(id,'district id');
      var param = {
        account_email: authService.authentication.account_id,
        doctor_id: authService.authentication.doctor_id,
        district_id: id+'',
        block_id: '0'
      }
      careproviderService.getStaffDetails(param).then(function(response) {
          console.log(response);
          if(response.length > 0){
            $scope.staffDetails = response
            console.log($scope.staffDetails,'FieldStaff');
          }
      },function(error) {
          toastr.error(error);
          analytics('getFieldstaff',error);
      })
    };

    // $scope.getFieldstaff()
  }]);

'use strict';

angular.module('AngularApp').controller('careproviderController2', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'locationService', '$ngBootbox', '$sessionStorage', 'toastr', 'careproviderService',
  function ($scope, $rootScope, $location, $filter, authService, locationService, $ngBootbox, $sessionStorage, toastr, careproviderService) { 
    

    $scope.datavalidate = function(data){
      var params = {
          account_email : authService.authentication.account_id,
          username : data
      }
      careproviderService.datavalidateapi(params).then(function (response) {
          if(response.message == 'username available'){
              $scope.username_status = true
          } else {
              $scope.username_status = false
          }
       })
    }

    $scope.getDistricts = function() {

      // $scope.hidetable2 = 'true';
      // $scope.hidetable1 = 'true';
      // $scope.completeBtnDisable = true;
      
      $scope.district_id = "0";  
      $scope.block_id    = "0";
      $scope.id    = "0";
      $scope.village_id  = "0";

      $scope.selected_district = "";
      $scope.selected_block    = "";
      $scope.selected_vhn      = "";
      $scope.selected_village  = "";

      $scope.selected_district_name = "All";
      $scope.selected_block_name    = "All";
      $scope.selected_vhn_name      = "All";
      $scope.selected_village_name  = "All";
      
      $scope.districts_list = [];
      $scope.blocks_list    = [];
      $scope.vhn_list       = [];
      $scope.villages_list  = [];
      $scope.fieldStaff     = []

      
      var data = {
      account_email: authService.authentication.account_id
      };
      
      careproviderService.getDistrict(data).then(function (response) {
        $scope.districts_list = response
        console.log($scope.districts_list,'district list');
          // if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx133323@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){   
            if(response.length>0){    
            $scope.selected_district_name = response[0].districtname;
            // console.log($scope.selected_district_name,'district 1');
            $scope.selected_district = response[0].id;    
            // console.log($scope.selected_district,'district 2');
            $scope.getBlocks(response[0].id);
          }
      }, function (error) {
          //toastr.error(error);
      });
  }


  $scope.getBlocks = function(id,name) {

      $scope.completeBtnDisable = true;

      $rootScope.selected_districtid = id+"";
      $scope.selected_districtname = name;
      console.log( $scope.selected_districtid,'id');
      console.log( $scope.selected_districtname,'name');
      if(id==null) {
      $scope.district_id = "0"; 
      } else {
      $scope.district_id = id+"";  
      } 

      // $scope.hidetable2 = 'true';
      $scope.block_id   = "0";
      $scope.id   = "0";
      $scope.village_id = "0";

      $scope.selected_block   = "";
      $scope.selected_vhn     = "";
      $scope.selected_village = "";

      $scope.selected_block_name   = "All";
      $scope.selected_vhn_name     = "All";
      $scope.selected_village_name = "All";
      
      $scope.blocks_list   = [];
      $scope.vhn_list      = [];
      $scope.villages_list = [];
      $scope.fieldStaff    = []


      var param = { 
      account_email: authService.authentication.account_id,
      district_id: $scope.district_id 
      }     
      
      careproviderService.getBlock(param).then(function(response) {
        if(response.success==1){
          $scope.blocks_list = response.data; 
          if(response.data.length > 0){
            $scope.blocks_list.push({id: 0, blockname: "Create Block"})
            console.log($scope.blocks_list);
          // if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx133323@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){   
            $scope.selected_block = response.data[0].id; 
            $scope.selected_block_name = response.data[0].blockname;
            $scope.getVillages(response.data[0].id,'district'); 
            // $scope.getFeildstaff('0',response[0].id,'0')
            // $scope.getVhn(response[0].id);
          }
        }else{
          $scope.blocks_list.push({id: 0, blockname: "Create Block"})
        }
      }, function (error) {
         //toastr.error(error);
      });
  }

 
  $scope.getVillages = function(id) {  

      $scope.completeBtnDisable = true;
      $scope.hidetable2 = 'true';

      if(id==0) {
        $rootScope.getBlocktype()
            $rootScope.abc = 123
              var options = {
                title: '<b>Create Block</b>',
                onEscape: function() {$scope.getBlocks($scope.district_id,$scope.selected_districtname);},
                message:'',
                templateUrl: 'views/careprovider/block.htm',
                size:'small', 
            };

            $ngBootbox.customDialog(options);

          $rootScope.createBlock = function () {
            if($rootScope.creationblock == ""){
                toastr.error('Blockname is Empty')
                bootbox.hideAll();
              }else{
              var param = {
                account_email: authService.authentication.account_id, 
                "district_id" : $rootScope.selected_districtid, 
                // "district_name": "Kanchipuram", 
                "block_name" : $rootScope.creationblock, 
                "block_type" : $rootScope.selected_blockType,
                // "block_master_type" : 0 
              }
              console.log(param,'creationblock');
  
              careproviderService.blockCreation(param).then(function(response) {
                console.log(response);
                if(response.success == 1){
                  toastr.success(response.message)
                  bootbox.hideAll();
                  $rootScope.creationblock = ''
                  $scope.getBlocks($scope.district_id,$scope.selected_districtname)
                }else{
                  toastr.error(response.message)
                  bootbox.hideAll();
                  $rootScope.creationblock = ''
                  $rootScope.selected_blockType = ''
                  $scope.getBlocks($scope.district_id,$scope.selected_districtname)
                }
  
              },function (error) {
                // toastr.error(error)
              });
            }

          }
      } else {
          $scope.id          = id+""; 
          // $scope.getFeildstaff($scope.district_id,$scope.id,'0')

          // var tempArr              = ($filter('filter')($scope.vhn_list, {'staffid':id})); 
          // $scope.selected_vhn_name = tempArr[0].staffname;
      }
          
      $scope.village_id            = "0"; 
      $scope.selected_village      = "";
      $scope.selected_village_name = "All";
      $scope.villages_list         = [];
      $scope.fieldStaff            = []

      var param = {	
      account_email: authService.authentication.account_id,
      block_id: $scope.id
      }
      
      careproviderService.getVillage(param).then(function(response) {
        if(response.success==1){
          $scope.villages_list    = response.data;   
          // if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx133323@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){   
          if(response.data.length>0){
            $scope.selected_village      = response.data[0].id
            $scope.selected_village_name = response.data[0].villagename
          
          $scope.villages_list.push({id: 0, villagename: 'Create Village'})
          $scope.getFieldStafftype()
          }
        }else{
          $scope.villages_list.push({id: 0, villagename: 'Create Village'})
        }
      },function (error) {
        //toastr.error(error);
      });  
  }


  $scope.getVillageid = function (vill_id) {
    // alert(vill_id)
    if(vill_id == 0){
      // $rootScope.abc = 123
      var options = {
        title: '<b>Create Village</b>',
        message:'',
        onEscape: function() {$scope.getVillages($scope.id);},
        templateUrl: 'views/careprovider/village.htm',
        size:'small', 
    };

    $ngBootbox.customDialog(options);

    $rootScope.createVillage = function () {
      if($rootScope.creationvillage == ""){
        toastr.error('Village name is Empty')
        bootbox.hideAll();
      }else{
        var param = {
          "account_email": authService.authentication.account_id, 
          "district_id" : $rootScope.selected_districtid, 
          "block_id" : $scope.id,
          "village_name" : $rootScope.creationvillage 
        }
  
        // console.log(param,'village creation');
  
        careproviderService.villageCreation(param).then(function(response) { 
          console.log(response);
          if(response.success == 1){
            toastr.success(response.message)
            bootbox.hideAll();
            $rootScope.creationvillage = ''
            $scope.getVillages($scope.id)
          }else{
            toastr.error(response.message)
            bootbox.hideAll();
            $rootScope.creationvillage = ''
            $scope.getVillages($scope.id)
          }
          },function(error){
  
        });
      }
    }
    }else{
      $scope.get_villageid = vill_id
    }


  }



  $scope.createFieldStaff = function () {

    // console.log($scope.agent_username);
    // console.log($scope.agent_password);
    if(($scope.agent_username == undefined) || ($scope.agent_password == undefined)){
      if($scope.agent_username == undefined){
        toastr.error('Username is Mandatory')
      }else{
        toastr.error('Password is Mandatory')
      }
    }else{
      var param = {
        "account_email": authService.authentication.account_id,
        "district_id": $scope.district_id ,
        "block_id": $scope.id,
        "village_id": $scope.selected_village+'',
        "fieldstaff_firstname": $scope.firstname,
        "fieldstaff_lastname": $scope.lastname,
        "fieldstaff_phonenumber": $scope.mobilenumber,
        "staff_type_id": $scope.selected_stafftype+'',
        "username": $scope.agent_username, 
        "password": $scope.agent_password 
      }
  
      console.log(param);
  
      careproviderService.staffCreation(param).then(function(response) {
        console.log(response);
        if(response.success == 1){
          toastr.success(response.message)
          $scope.firstname = ''
          $scope.lastname = ''
          $scope.mobilenumber = ''
          $scope.agent_username = ''
          $scope.agent_password = ''
        }else{
          toastr.error(response.message)
        }
      },function(error){
  
      });
    }
  }

  $scope.getDistricts()


  $rootScope.getBlocktype = function () {

    var data = {
      account_email: authService.authentication.account_id, 
    }
 
    $rootScope.villages_list = []

    careproviderService.getBlockType(data).then(function(response) {
      console.log(response);
      if(response.success == 1){
        $rootScope.villages_list = response.data
        $rootScope.selected_blockType = response.data[0].name
      }
      },function (error) {

      });
  }


  $rootScope.getFieldStafftype = function () {

    var data = {
      account_email: authService.authentication.account_id, 
    }

    careproviderService.getFieldStaffType(data).then(function(response) {
      console.log(response);
      if(response.success == 1){
        $scope.fieldStaff = response.data
        $scope.selected_stafftype = response.data[0].id
        $scope.selected_staff_type = response.data[0].type_name
      }
      },function (error) {

      });

  }

  $scope.staffType = function (selected_stafftype) {
    $scope.selected_fieldstafftype = selected_stafftype
    // alert($scope.selected_fieldstafftype)
  }
    
  }]);
'use strict';
angular.module('AngularApp').controller('changePwdController', ['$scope','$rootScope', '$location', 'authService','$ngBootbox', 'toastr',
function ($scope, $rootScope, $location, authService, $ngBootbox,toastr) {
    
    $scope.changePwdData = {};

    $scope.validate = false;

    $scope.changePassword = function(){
        $scope.validate = true;
        if($scope.frmChangePassword.$valid){
           if($scope.changePwdData.newPassword==$scope.changePwdData.confirmPassword){
            debugger;
                authService.changePassword({
                    "account_email": authService.authentication.account_id,
                    "current_password": MD5($scope.changePwdData.password),
                    "new_password": MD5($scope.changePwdData.newPassword),
                    "doctor_id": authService.authentication.doctor_id
                }).then(function (response) {
                    if (response.doctors.success == 1) {
                        var options = {
                            message: "Password changed successfully",
                            //  title: '<span class="fa fa-exclamation-triangle" style="color:white"> Alert</span>',
                            title: '<span style="color:white"> Alert</span>',
                            buttons: {
                                success: {
                                    label: "  OK",
                                    className: "btn-primary",
                                    callback: function () {
                                        $location.path('/home');
                                        $scope.$apply()
                                    }
                                }
                            }
                        }
                    $ngBootbox.customDialog(options);
                   } else {
                    $ngBootbox.alert(response.doctors.message);
                   }
                },function (err, response) {
                   $ngBootbox.alert(err.doctors.message);
                    $location.path("/changepassword");
                    analytics('changepassword',err.doctors.message);
                    return;
                });
           }else{
                var options = {
                        message: "Password doesn't match" ,
                        title: '<span class="fa fa-exclamation-triangle">Warning</span>',
                        buttons: {
                             success: {
                                 label: "  OK",
                                 className: "btn-primary",
                                 callback: function() {}

                                 }

                             }
                        }

                    $ngBootbox.customDialog(options);

           }
        }
    };

    
     $scope.backToHome = function () {
       $location.path('/home');
    };

    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'changePwdController',
            'event_label' : aLabel
        });
     }  

}]);
'use strict';
angular.module('AngularApp').controller('chatController', ['$scope', '$rootScope', '$location', 'authService',
'accountService', 'recordService', 'localStorageService', '$filter', '$ngBootbox', '$timeout', 'toastr', '$sessionStorage', 'Pubnub', '$pubnubChannel', 'chatService', 'paymentService', 'multipartFormdata','helyxonApiUrl',
function ($scope, $rootScope, $location, authService,accountService, recordService, localStorageService, $filter, $ngBootbox, $timeout, toastr, $sessionStorage, Pubnub, $pubnubChannel, chatService, paymentService, multipartFormdata,helyxonApiUrl) {
     
// getting started
   $rootScope.channel = authService.authentication.account_id.replace('@','_').replace('.org', '');
   $rootScope.uuid = authService.authentication.account_id;
   $scope.imageUploadUrl = helyxonApiUrl + 'cloud/image/upload/';
   console.log(' $scope.imageUploadUrl ', $scope.imageUploadUrl );
   $scope.vhnimageUploadUrl = authService.helyxonApi.url + 'cloud/vhn/upload/';

// hide footer
   $rootScope.showFooter = false;
// UTC to local time conversion
   $scope.convertUTCDateToLocalDate = function(date) {
      var newDate = new Date(date);
      var offset  = date.getTimezoneOffset();
      var minutes = date.getMinutes();
      newDate.setMinutes(minutes - offset);
    return newDate;   
   };

// get patient list
// $scope.patientList = [];
    $scope.messageType = 'unread';
    $scope.showList = true;
    $scope.refundOption = false;
    $scope.loaded2 = false;
   
    $scope.getPatientList = function(data,load){
        if(load==true){
          $scope.loaded2 = true;
        }
        chatService.getPatientList(data).then(function(response){
            $scope.patientList = response;
            $scope.loaded2 = false;
            angular.forEach($scope.patientList.history, function(value){
                value.last_messaged_on_Local = $scope.convertUTCDateToLocalDate(new Date(value.last_messaged_on));
            });
            $sessionStorage.put('totalUnread', JSON.stringify(response.total_unread));
            $rootScope.totalUnread = JSON.parse($sessionStorage.get('totalUnread'));
        })
    };

    $scope.getPatientList($scope.messageType);

  //search patient
    $scope.patient = {patientList: []};

    paymentService.getPaymentSetting().then(function(response) {
        $scope.selectedPatient = {payment: false};
        if(response.length > 0){
            angular.forEach(response,function(value){
                if (value.module == "chat"){
                    // selected user
                    $scope.selectedPatient = {payment: true};
                    $scope.refundOption = true;
                }
            });
        }
        
    }, function(error){
        toastr.error(error);
        analytics('getPatientList',error);
    })
    
    $scope.searchPatient = function(data) {
        if(data) {
            authService.getPatientSearch(data).then(function(response) {
                $scope.showList = false;
                $scope.patient.patientList = response;
            });
        } else {
            $scope.showList = true;
            $scope.patient.patientList = [];
        }
    };

    $scope.getUnreadCount = function() {
        chatService.unread().then(function(response){
            $sessionStorage.put('totalUnread', JSON.stringify(response.total_unread));
            $rootScope.totalUnread = response.total_unread;
        })
    };

    $scope.getUnreadCount();
    
    $scope.select_patient_name = "Patient";
  //get messages
    $scope.getMessages = function(data) {
        if(data.first_name){
           $scope.select_patient_name = data.first_name;
        } else {
            $scope.select_patient_name = "Patient"; 
        }
        if(data.patient_email) {
            data.email   = data.patient_email;
          //data.payment = true;
            data.payment = $scope.selectedPatient.payment;
            $scope.selectedPatient = data;
        } else {
            $scope.selectedPatient = {
                sender: $rootScope.uuid,
                receiver: data.email,
                dob: data.bday,
                email: data.email,
                first_name:data.name_given,
                gender: data.gender,
                last_name: data.name_family,
                mr_number: data.mr_number,
                patient_email:data.email,
                phone:data.father_tel_number,
                uhid:data.uhid,
              //payment: true
                payment: $scope.selectedPatient.payment
            };
            $scope.patientList.history.unshift($scope.selectedPatient);
        }

        $scope.loaded = true;
        $scope.loaded2 = false;

        chatService.getPreviousMessage(data.email).then(function(response) {

           $rootScope.chatMessages = [];

            $rootScope.chatMessages = angular.forEach(response,function(x) {
                x.message = decodeURIComponent(x.message);
                
                if (x.message.endsWith(".png") || x.message.endsWith(",")) {
                    if (x.message.startsWith("img_")) {

                        var temp = x.message.split(",")
                        console.log('temp image',temp);
                        $scope.imgArray = [];
                        angular.forEach(temp, function(image){
                            if(image != ""){
                                   console.log(' $scope.imageUploadUrl', $scope.imageUploadUrl); 
                                $scope.imgArray.push( $scope.imageUploadUrl + image);
                            }

                        });
                        x.imagemessage = $scope.imgArray;
                        console.log('1. x.imagemessage ', $scope.imageUploadUrl+x.imagemessage );
                    } else {
                        var temp = x.message.split(",")
                        $scope.imgArray = [];
                        angular.forEach(temp, function(image){
                            $scope.imgArray.push( $scope.vhnimageUploadUrl + image.replace(" ",""));
                        });
                        x.imagemessage = $scope.imgArray;
                        console.log('2. x.imagemessage ', x.imagemessage );
                    }
                }

                if (x.message.endsWith(".mp4")) {
                    if(x.message.startsWith("vid_")) {  // equals to if(x.message_type == 0){}
                    
                        var temp = x.message.split(",")
                        $scope.vdoArray = [];
                        angular.forEach(temp, function(video) {
                            $scope.vdoArray.push( $scope.imageUploadUrl+ video );
                        });
                        x.videomessage = $scope.vdoArray;
                    } else {
                        var temp = x.message.split(",")
                        $scope.vdoArray = [];
                        angular.forEach(temp, function(video){
                            $scope.vdoArray.push( $scope.imageUploadUrl + "/VHN/upload/" + video.replace(" ",""));
                        });
                        x.videomessage = $scope.vdoArray;
                    }
                }
                
                if(x.message.startsWith("http://220.226.2.177")) {
                    x.audiomessage = x.message;
                }

                $scope.loaded=false;
                
            }); 
            
            $scope.patient.patientList = [];
            $scope.showList = true;
            $scope.getPatientList($scope.messageType);
            if(data.unread == true){
                if($rootScope.chatMessages.length>0) {
                    chatService.setAsRead({patient: data.email, account_email:authService.authentication.account_id}).then(function(response){
                        data.unread = false;
                    })
                }
            } 

        });
    };

    // mark as read
    $scope.markAsRead = function(data){
        chatService.setAsRead({patient: data.email, account_email:authService.authentication.account_id}).then(function(response){
            data.unread = false;
            $scope.getPatientList($scope.messageType);
        })
    };

    Pubnub.init({
        publishKey: 'pub-c-c3cecd91-62bc-4365-b2d1-a6333576f17f', // pub-c-c3cecd91-62bc-4365-b2d1-a6333576f17f
        subscribeKey: 'sub-c-60c79014-12d7-11e8-b32f-5ea260837941', // sub-c-60c79014-12d7-11e8-b32f-5ea260837941
        uuid: $scope.uuid
    });

    // Send the messages over PubNub Network
    Pubnub.addListener({
        presence: function(m){
            console.log(m.state)
        },
        message: function(message) {
            $scope.getPatientList($scope.messageType);
        }
    });

    // Subscribing to the ‘messages-channel’ and trigering the message callback
    Pubnub.subscribe({
        channels  : [$rootScope.channel],
        withPresence: true,
        triggerEvents: ['callback', 'message', 'presence']
    });
    
    $scope.companion = {};
    Pubnub.hereNow({
            channels: [$rootScope.channel], 
            includeUUIDs: true,
            includeState: true
        },
        function(status, response) {
            // handle status, response
            // angular.forEach(response.channels.$rootScope.channel.occupants, function(value){
            //     if($scope.uuid!==value.uuid){
            //         $scope.companion = value;
            //     }
            // });
        }
    );

    // Listening to the callbacks
    $rootScope.$on(Pubnub.getMessageEventNameFor($rootScope.channel), function (ngEvent, envelope) {
        $scope.$apply(function () {
            // add message to the messages list
            $scope.getPatientList($scope.messageType);
            if (envelope.message.sender===$scope.selectedPatient.email){
                $scope.markAsRead($scope.selectedPatient);
            }
            // toastr.info("New message received.")
            $rootScope.chatMessages.push(envelope.message);
        });
    });

    $scope.calculateAge = function calculateAge(dob) { 
        var dobMoment  = moment(dob);
        var currentDate = moment(new Date());
        var age = parseInt(moment().diff(dobMoment,'year',true)).toString() + ' Yr ' + parseInt(moment().diff(dobMoment,'month',true)%12).toString() + ' m';
        return age
    };

    $scope.fixDate = function(date) {
        return new Date(moment.utc(date).toDate());
    };

    $scope.refundAlert = function() {
		var options = {
			message: 'Are you really want to refund?',
			size: 'small',
            title: 'Refund',
            closeButton: false,
			buttons: {
				warning: {
					label: "No",
					className: "btn-warning"
				},
				success: {
					label: "Yes",
				   	className: "btn-success",
				   	callback: function() {
                        $scope.raiseInvoiceFunc();
					}
			   	}
		  	}
	  	};
	  	$ngBootbox.customDialog(options);
    };
    
    $scope.raiseInvoiceFunc = function() {
        
        $scope.doctor_charge = 0;
        paymentService.getPaymentSetting().then(function(response) {
            angular.forEach(response,function(value){
                if (value.module == "chat"){
                    $scope.doctor_charge = parseInt(value.doctor_charge);
                }
            });

            var data = {
                account_email: $rootScope.authentication.account_id,
                patient_email: $scope.selectedPatient.email,
                category: "chat",
                description: "fee charged for chat",
                doctor_charges: $scope.doctor_charge,
                user_type: "doctor",
                type: 3,
                appointment_id:"",
                doctor_id:$rootScope.authentication.doctor_id
                
            }
           
            paymentService.raiseInvoice(data).then(function(response) {
                 toastr.success('Payment raised successfully');
               /*if(response){
                    $rootScope.bill_no = response.bill_no;
                    $rootScope.walletBalance = response.wallet.wallet[0].amount;
                    sessionStorage.setItem("wallet_ballance",$rootScope.walletBalance);
                }*/          
            }, function(error) {
                toastr.error(error);
                analytics('raiseInvoiceFunc',error);
            });

        }, function(error){
            //toastr.error(error);
            var data = {
                account_email: $rootScope.authentication.account_id,
                patient_email: $scope.selectedPatient.email,
                category: "chat",
                description: "fee charged for chat",
                doctor_charges: 0,
                user_type: "doctor",
                type: 3,
                appointment_id:"",
                doctor_id: $rootScope.authentication.doctor_id
            }
        
            paymentService.raiseInvoice(data).then(function(response) {
                 toastr.success('Payment raised successfully');
               /*if(response){
                    $rootScope.bill_no = response.bill_no;
                    $rootScope.walletBalance = response.wallet.wallet[0].amount;
                    sessionStorage.setItem("wallet_ballance",$rootScope.walletBalance);
                }*/          
            }, function(error) {
                toastr.error(error);
                analytics('raiseInvoiceFunc',error);
            });
        });

    }

    $scope.notifyToken = function(){
        var data = {
            "notification_type": "both",
            "account_email": $rootScope.authentication.account_id,
            "patient_email": $scope.selectedPatient.email,
            "content": "Dear "+$scope.select_patient_name+",\n"+authService.authentication.account_info.Account.fullName+" has replied to your chat, please use My+Health app to view the response.\n"+"https://goo.gl/m7UAjH",
        }
        recordService.appointmentreschedulenotification(data).then(function(response){
            response.message ? toastr.success(response.message) : toastr.success(response);   
        },function(error){
            toastr.error(error);
            $scope.newmem = analytics('notifyToken',error);
        });
    };

    $rootScope.messageContent = {message: ''};
    $scope.enablePay = true;
    $scope.loaded = false;

    $scope.sendMessage = function() {    
        $scope.raiseInvoiceFunc();
        //Don't send an empty message 
        if (!$rootScope.messageContent.message || $rootScope.messageContent.message === '') {
         return;
        }
        // var data = {
        //  content: $rootScope.messageContent.message,
        //  sender_uuid: $scope.uuid,
        //  date: new Date()
        // };

        var data = {
            sender: $rootScope.uuid,
            receiver: $scope.selectedPatient.email,
            message: $scope.messageContent.message,
            type: "doctor",
            message_type: 1,
            date: new Date(),
            payment: $scope.selectedPatient.payment,
            doctor_name: authService.authentication.doctor_name,
            doctor_id:authService.authentication.doctor_id
        }
    
        $scope.loaded = true;   
        $scope.loaded2 = false;
        chatService.sendMessage(data).then(function(response){
            toastr.info(response.message);
            $scope.notifyToken();
            $scope.getPatientList($scope.messageType);
          //push to chat message list
            response.date = new Date(response.date).toISOString();
            $rootScope.chatMessages.push(response);
            chatService.getPreviousMessage(data.receiver).then(function(response) {
                $rootScope.chatMessages = [];
                $rootScope.chatMessages = angular.forEach(response,function(x){
                    x.message = decodeURIComponent(x.message);
                    if(x.message.startsWith("img_")) {  // equals to if(x.message_type == 0){}
                        var temp = x.message.split(",");
                        $scope.tempArray = [];
                        angular.forEach(temp, function(image) {
                            $scope.tempArray.push( $scope.imageUploadUrl + image );
                        });
                        x.imagemessage = $scope.tempArray;
                        console.log('3. x.imagemessage ', x.imagemessage );
                    }
                });
                $scope.loaded = false;            

                $scope.patient.patientList = [];
                $scope.showList = true;
                $scope.getPatientList($scope.messageType);
                if(data.unread == true){
                    if($rootScope.chatMessages.length>0) {
                        chatService.setAsRead({patient: data.email, account_email:authService.authentication.account_id}).then(function(response){
                            data.unread = false;
                        })
                    }
                }
            })
         })

         // Pubnub.publish({
         //    channel: $scope.selectedPatient.email.replace('@','_').replace('.org', ''),
         //    message: data
         // }, function(status, response){
         //       // handle publish response if needed
         // });

        // Reset the messageContent input
         $rootScope.messageContent.message = '';
 
     };

    //get messages
    $rootScope.chatMessages = [];

    //set state
    $scope.setState = function(data) {
        Pubnub.setState({
                state: {isTyping: data},
                channels: [$rootScope.channel]
            },
            function (status, response) {
                // handle status, response
            }
        ); 
    };

    $scope.refund = function(data) {
        if (data=='admin'){
            toastr.error('Contact admin for payment');
            analytics('refund','Contact admin for payment');
            return;
        }
        data.account_email = authService.authentication.account_id;
        data.patient_email = data.receiver;
        data.created_at = data.date;
        data.type = 2;
        data.category = "refund";
        chatService.refundPay(data).then(function(response) {
            toastr.success(response.message);
            $scope.cost = 0;
            paymentService.getPaymentSetting().then(function(response) {
                angular.forEach(response,function(value){
                    if (value.module == "chat"){
                        $scope.cost = parseInt(value.doctor_charge);
                    }
                });
                var raiseData = {
                    account_email: authService.authentication.account_id,
                    patient_email: data.receiver,
                    category: "refund",
                    description: "",
                    doctor_charges: parseInt($scope.cost),
                    fee_paid: parseInt($scope.cost),
                    user_type: "doctor",
                    type: 2,
                    appointment_id:"",
                    doctor_id: authService.authentication.doctor_id
                }
                paymentService.raiseInvoice(raiseData).then(function(response){
                    toastr.success('Raised refund invoice');
                }, function(error) {
                    toastr.error(error);
                    analytics('refund',error);
                })
            }, function(error){
                toastr.error(error);
                analytics('refund',error);
            })
            $scope.loaded=true;
            $scope.loaded2 = false;
            chatService.getPreviousMessage(data.receiver).then(function(response) {
                $rootScope.chatMessages = [];
                $rootScope.chatMessages = angular.forEach(response,function(x){
                    x.message = decodeURIComponent(x.message);
                    if(x.message.startsWith("img_")) { // equals to if(x.message_type == 0){}
                        var temp = x.message.split(",")
                        $scope.imgArray = [];
                        angular.forEach(temp, function(image){
                            $scope.imgArray.push( $scope.imageUploadUrl + image);
                        });
                        x.imagemessage = $scope.imgArray;
                        console.log('4. x.imagemessage ', x.imagemessage );
                    }

                    if(x.message.startsWith("vid_")) { // equals to if(x.message_type == 0){}
                        var temp = x.message.split(",")
                        $scope.videoArray = [];
                        angular.forEach(temp, function(video){
                            $scope.videoArray.push( $scope.imageUploadUrl + video);
                        });
                        x.videomessage = $scope.videoArray;
                    }
                });
                $scope.patient.patientList = [];
                $scope.showList = true;
                $scope.getPatientList($scope.messageType);
                if(data.unread == true){
                    if($rootScope.chatMessages.length>0) {
                        chatService.setAsRead({patient: data.email, account_email:authService.authentication.account_id}).then(function(response){
                            data.unread = false;
                        })
                    }
                }
                $scope.loaded=false;
            });
        }, function(error){
            toastr.error(error.error);
            analytics('refund',error.error);
        })
    };

    // $scope.isFocused = false;
    // if($scope.isFocused == true) {
    //     $scope.setState(true);
    // } else {
    //     $scope.setState(false);
    // }

    // Upload image attachment
    $scope.uploadAttachment = function(file, event, flow) {
        if({png:1,gif:1,jpg:1,jpeg:1}[file.getExtension()]){
            var data = new FormData();
            data.append('file', file.file);
            multipartFormdata.uploadFileToUrl(authService.helyxonApi.url,file.file).then(function(response){
                $scope.messageContent.message = response.image[0].filename;
                $scope.sendMessage();
                toastr.success("Image sent successfuly");
            }, function(err){
                toastr.error(err);
                analytics('uploadAttachment',err);
            });
            return true;
        } else {
            alert("Upload only Images");
            analytics('uploadAttachment','upload only inages');
            return false;
        }
        flow.file = [];
   };

 // Show image attachment in popup
    $scope.showImage = function(data) {
        var options = {
            title: '',
            message: '<img class="img-responsive center-block" src="'+data+'"/>',
            size:'medium',
            onEscape: true,
        };
        $ngBootbox.customDialog(options);
    }

 // Show video attachment in popup
    $scope.playVideo = function(data) {
        var options = {
            title: '',
            message: '<video class="center-block" width="520" height="340" controls autoplay src="'+data+'" type="video/mp4"></video>',
            size:'medium',
            onEscape: true,
        };
        $ngBootbox.customDialog(options);
    }

 // Play audio in popup
    $scope.playAudio = function(data) {
        var options = {
            title: 'Voice Mail from patient',
            message: '<center><audio controls><source src="'+data+'"type="audio/wav">Your browser does not support the audio element.</audio></center>',
            size:'medium',
            onEscape: true,
        };
        $ngBootbox.customDialog(options);
    }

 // function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
         'event_category' : 'chatController',
         'event_label' : aLabel
        });
    }  
}]);

'use strict';
angular.module('AngularApp').controller('commonsettingsController', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'commonsettingsService', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, commonsettingsService) {

  $scope.increaseValueinperson = function () {
    var value = parseInt(document.getElementById('numberinperson').value, 10);
    value = isNaN(value) ? 0 : value;
    if (value >= 116) {
      return
    } else {
      value = value + 5;
    }
    document.getElementById('numberinperson').value = value;
  }

  $scope.decreaseValueinperson = function () {
    var value = parseInt(document.getElementById('numberinperson').value, 10);
    value = isNaN(value) ? 0 : value;
    value < 1 ? value = 1 : '';
    if (value <= 1) {
      return
    } else {
      value = value - 5;
    }
    document.getElementById('numberinperson').value = value;
  }

  $scope.increaseValue = function () {
    var value = parseInt(document.getElementById('number').value, 10);
    value = isNaN(value) ? 0 : value;
    if (value >= 116) {
      return
    } else {
      value = value + 5;
    }
    document.getElementById('number').value = value;
  }

  $scope.decreaseValue = function () {
    var value = parseInt(document.getElementById('number').value, 10);
    value = isNaN(value) ? 0 : value;
    value < 1 ? value = 1 : '';
    if (value <= 1) {
      return
    } else {
      value = value - 5;
    }
    document.getElementById('number').value = value;
  }


  $scope.getcommonsettingsdata = function () {
    commonsettingsService.getcommonSettings().then(function (response) {
      $scope.commonsettings = response.data[0]
      // if($scope.commonsettings.notify_doctor == 0){
      //   $scope.commonsettings.notify_doctor = false
      // }else if($scope.commonsettings.notify_doctor == 1){
      //   $scope.commonsettings.notify_doctor = true
      // }
      $scope.enablefloatingvideo = response.data[0].floating_video
      sessionStorage.setItem("enablefloating", $scope.enablefloatingvideo)
      $scope.enableicssettings = response.data[0].ics_consultation
      sessionStorage.setItem("enableics", $scope.enableicssettings)
      console.log(' $scope.commonsettings', $scope.commonsettings);
    }, function (error) {
      toastr.error(error, 'Try again...');
    })
  }
  $scope.getcommonsettingsdata()

$rootScope.whatsapp__chat = function(){
  $rootScope.whatsappchat()
}

  $scope.whatsappchange = function(){
    if($scope.whatsapp_chat == true){
      console.log("data 66", $scope.whatsapp_chat)

      var options = {
        title: '<span style="color:white">Add whatsapp chat mobile number</span>',
        message:'',
        templateUrl: 'views/whatsappchat.htm',
        size:'medium', 
        onEscape: function() {$scope.$apply();},
        buttons: {
            ok:{
                label: " Save",
                className: "btn-primary fa fa-save",
                callback: function() {
                  console.log("whatsappchatnumber", $rootScope.whatsappchatnumber);
                  if($rootScope.whatsappchatnumber.length == 10){
                     var data = {
                       "whatsapp_chat":true,
                       "whatsapp_number": $rootScope.whatsappchatnumber,
                       "account_email": authService.authentication.account_id, 
                       "doctor_id": parseInt(authService.authentication.doctor_id), 
                      }
                      commonsettingsService.addwhatsapp_Settings(data).then(function (response) {
                            toastr.success('Updated Successfully');
                            $rootScope.whatsapp__chat();
                        },function(error) {
                            toastr.error(error);
                      })
                  }
                 
                }

            },
            close:{
                label: " Close",
                className: "btn-danger fa fa-times-circle",
                callback: function() {
                  var data = {
                    "whatsapp_chat":false,
                    "account_email": authService.authentication.account_id, 
                    "doctor_id": parseInt(authService.authentication.doctor_id), 
                   }
                   commonsettingsService.addwhatsapp_Settings(data).then(function (response) {
                         toastr.success('Updated Successfully');
                         $rootScope.whatsappchat();
                     },function(error) {
                         toastr.error(error);
                   })
                }
            }
        }
    };

    $ngBootbox.customDialog(options);

    }else if($scope.whatsapp_chat == false){
      var data = {
        "whatsapp_chat":false,
        "account_email": authService.authentication.account_id, 
        "doctor_id": parseInt(authService.authentication.doctor_id), 
       }
       commonsettingsService.addwhatsapp_Settings(data).then(function (response) {
             toastr.success('Updated Successfully');
             $rootScope.whatsappchat();
         },function(error) {
             toastr.error(error);
       })
    }
  }

  $rootScope.whatsappchat = function(){
    commonsettingsService.getProfile().then(function(response) {
      $rootScope.doctorProfile = response.doctors.profile;
      //  console.log(" $rootScope.doctorProfile 141",  $rootScope.doctorProfile.contact_number_1);
       $rootScope.whatsappchatnumber = $rootScope.doctorProfile.contact_number_1;
    })
       commonsettingsService.whatsappSettings().then(function (response) {
           if(response){
             $scope.whatsapp_chat = response.data[0].whatsapp_chat
              if($scope.whatsapp_chat == true){
                $scope.approval_status = "( "+response.data[0].approval_status+" )"
                $scope.whatsappnumber = response.data[0].whatsapp_number
                console.log("$scope.approval_status", $scope.approval_status);
              }else if($scope.whatsapp_chat == false){
                $scope.approval_status = " "; 
                $scope.whatsappnumber = ""      
              }
           }
      }, function (error) {
        toastr.error(error, 'Try again...');
      })
  }
  $rootScope.whatsappchat()

  $scope.updatecommonsettingsdata = function () {
    $rootScope.whatsappchat();
    var data = {
      "account_email": authService.authentication.account_id,
      "show_default_card": $scope.commonsettings.show_default_card,
      "get_sms": $scope.commonsettings.get_sms,
      "force_wallet": $scope.commonsettings.force_wallet,
      "doctor_id": parseInt(authService.authentication.doctor_id),
      "ics_consultation": $scope.commonsettings.ics_consultation,
      "floating_video": $scope.commonsettings.floating_video,
      "chat_enabled": $scope.commonsettings.chat_enabled,
      "two_factor_authentication": $scope.commonsettings.two_factor_authentication,
      "inperson_advance_session_time": parseInt(document.getElementById('numberinperson').value),
      "tele_advance_session_time": parseInt(document.getElementById('number').value),
      "teleconsultation_reminder": $scope.commonsettings.teleconsultation_reminder,
      "consult_room" : $scope.commonsettings.consult_room,
      "ics_eshop": $scope.commonsettings.ics_eshop,
      "consultation_queue_type": $scope.commonsettings.consultation_queue_type,
      "force_subscription": $scope.commonsettings.force_subscription,
      "prescription_mode": $scope.commonsettings.prescription_mode,
      "toggle_alignment": $scope.commonsettings.toggle_alignment,
      "epharmacy_frontdesk_payment": $scope.commonsettings.epharmacy_frontdesk_payment,
      // "notify_doctor": $scope.commonsettings.notify_doctor?1:0
      "slot_full_message": $scope.commonsettings.slot_full_message,
      "pillmeister_device": $scope.commonsettings.pillmeister_device,
      "one_appointment_day": $scope.commonsettings.one_appointment_day,
      "abha_appointment_token": $scope.commonsettings.abha_appointment_token
    }
    commonsettingsService.updatecommonSettings(data).then(function (response) {
      if (response.status == 1) {
        $scope.getcommonsettingsdata()
        toastr.success("Saved successfully")
        console.log(' $scope.commonsettings', $scope.commonsettings);
      } else {
        toastr.error("Unable to save data")
      }
    }, function (error) {
      toastr.error(error, 'Try again...');
      //analytics('addNewComplaint','Try again');
    })
  }
}]);
'use strict';

angular.module('AngularApp').controller('communityvisitReportController', ['$scope', '$location', '$rootScope', 'toastr', 'authService', 'incentiveService','$ngBootbox', 'multicenterstudyreportService', '$filter', function ($scope, $location, $rootScope, toastr, authService, incentiveService, $ngBootbox, multicenterstudyreportService,$filter) {


    $scope.timeInputDisable = true;
    $scope.selected_day = "1";
    $scope.fromDate = new Date();
    $scope.toDate = new Date();
    $scope.today_dt = new Date();
    $scope.exportType = "";

    var datArr  = getStringDate($scope.fromDate);
    var datArr2 = getStringDate($scope.toDate)
    $scope.selectedFromDate  = datArr[1];
    $scope.selectedFromDate2 = datArr[0];
    $scope.selectedToDate  = datArr2[1];
    $scope.selectedToDate2 = datArr2[0];


    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        }
    };

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }


    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.labelHide = true
    // $( "#piechat_container" ).hide();
    console.log($scope.selectedFromDate2);
    console.log($scope.selectedToDate2);
    console.log($scope.selected_day);

    $scope.getcommunityfollow = function() {
        var data = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id,
            from_date: $scope.selectedFromDate2,
            to_date: $scope.selectedToDate2,
            followup_description : "COMMUNITY VISIT"

        }

        multicenterstudyreportService.getcommunityfollowbydateReport(data).then(function(response) {
        //   if(response.data.dead_after_discharge.length > 0 || response.data.dead_during_discharge.length > 0){
        //     $scope.labelHide = false
        //     $scope.deadvsTimeAfterdelivery = response;
        //     console.log($scope.deadvsTimeAfterdelivery);
        //   } else {
        //     $scope.labelHide = true
        //     $scope.errMsg = 'Data is not available on this period'
        //   }

        $scope.communityfollowResponse = [];
        console.log('response::',response);
        if(response.success == 1){
          if(response.data.length>0){
            $scope.labelHide = false
            $scope.communityfollowResponse = response.data
            console.log($scope.communityfollowResponse);
            homevisitPieChartData(response.baby_status); 
          }else{
            $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
          }

        }else{
            $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
            $( "#piechat_container" ).hide();

        }
            
        },function(error) {
            if(error){
              toastr.error('Select from & to date')
            }
            // toastr.error(error);
            analytics('getDeadvsTimeAfterdeliveryStatus',error);
        })
    };


    function homevisitPieChartData(data) {

        console.log('data::',data);
            
        var tempArray = [
            {
            name: 'Alive',
            y: data.count_alive,
            /*sliced: true,
            selected: true*/
            color: 'lightblue'
            },
            {
            name: 'Expired',
            y: data.count_expired, 
            color: 'pink'
            }
        ];
            
        $scope.showPieChart(tempArray);    
    }

    $scope.showPieChart = function(data) {
    
        $('#pie_container1').highcharts({
        //Highcharts.chart('container', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                borderColor: "black",
                borderRadius:0,
                borderWidth:"0"
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Community Visit Report', 
                style: {
                  fontSize: '22px' 
                }
               
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '{point.percentage:.1f} %'
                    },
                    showInLegend: true
                }
            },
            series: [{
            //name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    
        $( "#piechat_container" ).show();
    }

    $( "#piechat_container" ).hide();
    console.log($( "#piechat_container" ).hide());

    $scope.exportData = function(type) {

      if($scope.communityfollowResponse) {
 
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Community_Visit_Report_"+$scope.formattedDate;
          
          if($scope.selectedFromDate && $scope.selectedToDate){
              filename = "Community_Visit_Report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
          }
          
         /* if(type=='csv') {

              alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
              
          } else*/
          if(type == 'excel') {

              //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                  var blob = new Blob([document.getElementById('printtable2').innerHTML], {
                      type: "application/vnd.ms-excel;charset=utf-8"
                  });
               saveAs(blob, filename+".xls");

          } else if(type=='pdf') {

              var pdf_element = document.getElementById('printtable');
              var opt = {
                  margin:      0,
                  filename:   filename,
                  image:       { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
              };
                  
              //New Promise-based usage:
              html2pdf().set(opt).from(pdf_element).save();
                  
          }
      }
    }

}])
'use strict';

angular.module('AngularApp').controller('complaintController', ['$scope', '$rootScope', '$location', '$route', 'complaintService','$ngBootbox','$uibModal', '$filter','localStorageService','toastr','authService','$sessionStorage','recordService',
	 function ($scope, $rootScope, $location, $route, complaintService,$ngBootbox, $uibModal, $filter,localStorageService,toastr,authService,$sessionStorage,recordService) {
	
	$scope.currentView='growthData';
	$scope.gulcometervalue = 'Fasting';
	$scope.gulcovalue = 'Fasting';
	//var pathArray = window.location.href.split( '/' );
	var pathArray = window.location.hash.split( '/' );
	var recordId = pathArray[2];
	console.log(recordId);
	$scope.patientRecordId ='';

	$scope.popup1 = {
		opened: false
	};

	$scope.fromDate =new Date();
	$scope.maximumDate =new Date();
	$scope.date =new Date();
	$scope.date = $filter('date')($scope.date, "dd-MMM-yyyy  HH:mm");
	$scope.date1 = moment($scope.date).format('hh:mm A');
	$scope.splithours = $scope.date1.split(' ')[1];
	$scope.hours = $scope.date1.split(' ')[0].split(':')[0];
	$scope.min = $scope.date1.split(' ')[0].split(':')[1];

	$rootScope.rangePicker1 = {
		opened: { fromDate:false, toDate:false },
		maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
		dateOptions: {
		  formatYear: 'yyyy',
		  startingDay: 0,
		  maxDate: new Date()
		}
	  };

	// console.log($scope.date1);
	
	// console.log($scope.hours);
	// console.log($scope.min);
	// console.log($scope.splithours);
	
	$scope.Math = window.Math;
	$scope.calculateBMI = function() {
		$scope.growth.bmi = ($scope.growth.weight/Math.pow(($scope.growth.height/100),2)).toFixed(3);
		$scope.growth.bsa = (0.007184*Math.pow($scope.growth.weight,0.425) * (Math.pow(($scope.growth.height/100),0.725))).toFixed(3);
	};

	$scope.calculateFahrenheit = function() {
		if($scope.growth.temperature != undefined){
			$scope.celsius = (($scope.growth.temperature - 32)/1.8).toFixed(2);
		}else{
			$scope.celsius = '';
		}
	};

	$scope.calculateMmol = function() {
		$scope.calcMMol = ($scope.growth.gulcometer_mmol *  0.0555).toFixed(3);
	}

	var countappointmentVitalsData = 0;

	$scope.getLinkedVitalData = function() {
		complaintService.appointmentVitalsData($sessionStorage.get('appointment_id')).then(function(response) {
			$scope.pills = [];
			$scope.injication = [];
			// $scope.addpills();
			// $scope.addinj();
			$scope.growth = response.vitals[0];
			
			//String convert to json
			// if($scope.growth != undefined){
			// var obj = response.vitals[0].glucometer;
			//  var getobj = eval("'"+obj.replace(/["']/g, '"')+"'");
			//  var getgulcoobjval = JSON.parse(getobj);console.log(getgulcoobjval);
			// 	console.log(getgulcoobjval.mmol_value);
			// }

			if($scope.growth == undefined){
				$scope.gulcometervalue = 'Fasting'
				$scope.growth = {
					weight:"", 
					height:"",
					temperature:"",
					arm_circumference:"", 
					head_circumference:"", 
					chest_circumference:"",
					bmi:"",
					heart_rate:"", 
					respiratory_rate:"", 
					bp_systolic:"", 
					bp_diastolic:"", 
					oxygen_saturation:"",
					gulcometer_mmol:"",
					gulcometer_mgdl:""
				};
			}else{
				$scope.growth.height = ($scope.growth.height * 100).toFixed(1);
				$scope.growth.bsa = (0.007184*Math.pow($scope.growth.weight,0.425) * (Math.pow(($scope.growth.height/100),0.725))).toFixed(3); 
				$scope.calculateFahrenheit();
				$scope.growth.gulcometer_mmol = response.vitals[0].glucometer.mmol_value;
				$scope.growth.gulcometer_mgdl = response.vitals[0].glucometer.mgol_value;
				$scope.gulcometervalue = response.vitals[0].glucometer.option;
				//update date 
				var newdate1 = $scope.convertUTCDateToLocalDate(new Date(response.vitals[0].glucometer_measured_date));
            	var toconvert = newdate1.toISOString().slice(0, 10);
           	 	var entereddate = toconvert.slice(0, 4) + '-'+ toconvert.slice(5, 7) + '-'+ toconvert.slice(8, 10);
                $scope.fromDate = new Date(entereddate);
                console.log($scope.fromDate,"$scope.fromDate")
				
				var date = moment.utc(response.vitals[0].glucometer_measured_date).format('YYYY-MM-DD HH:mm:ss');
        		var stillUtc = moment.utc(date).toDate();
				var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');console.log(local);
                
				$scope.date = $scope.fromDate;
				$scope.datestatus = true;

				$scope.splithours = local.split(' ')[1];
				$scope.hours = $scope.splithours.split(' ')[0].split(':')[0];
				$scope.min = $scope.splithours.split(' ')[0].split(':')[1];

				$scope.calculateMmol();
				for(var i=0;i<response.vitals[0].glucometer.pills.length;i++){
					$scope.pills.push({name: response.vitals[0].glucometer.pills[i].name, strength: response.vitals[0].glucometer.pills[i].strength});
				}
				for(var j=0;j<response.vitals[0].glucometer.injection.length;j++){
					$scope.injication.push({name: response.vitals[0].glucometer.injection[j].name, strength: response.vitals[0].glucometer.injection[j].strength});
				}
			}			
		}, function(err) {
			toastr.error(err);
			analytics('getLinkedVitalData',err);
			if(countappointmentVitalsData < 5) {
				countappointmentVitalsData += 1;
				$scope.getLinkedVitalData();
			}
			else if(countappointmentVitalsData = 5) {
				$location.path("/home" );
			}
		})
	};

	$scope.getLinkedVitalData();
	
	$scope.convertUTCDateToLocalDate = function(date) {
		var newDate = new Date(date);
		var offset = date.getTimezoneOffset();
		var minutes = date.getMinutes();
		newDate.setMinutes(minutes - offset);
	  return newDate;   
	};

	// if($scope.growth.weight&&$scope.growth.height){
		// $scope.$watch($scope.growth.weight, calculateBMI);
		// $scope.$watch($scope.growth.height, calculateBMI);
	// }

	$scope.defaultMsg = true;

	$scope.view = "add";

	$scope.pills = [];
	$scope.injication = [];
	$scope.datestatus = false;

	$scope.addpills = function(){
		var newpilss = {};
		$scope.pills.push(newpilss);
	}

	$scope.removepills = function(){
		
	var newItemNo = $scope.pills.length-1;
     if ( newItemNo !== 0 ) {
      $scope.pills.pop();
     }
	}

	$scope.addinj = function(){
		var newinj = {};
		$scope.injication.push(newinj);
	}

	$scope.removeinj = function(){
		
	var newInjNo = $scope.injication.length-1;
     if ( newInjNo !== 0 ) {
      $scope.injication.pop();
     }
	}

	$scope.open1 = function () {

		$scope.popup1.opened = true;
	};

	$scope.getGulcoVal = function(val){
		console.log(val);
		$scope.gulcovalue = val;
	}

	$scope.byRange = function(selctdate){
		$scope.datestatus = true;
		$scope.date = moment(selctdate).format("YYYY-MM-DD");
		console.log('$scope.selectedDate');
		console.log($scope.date);
			
	}

	$scope.gethour = function (val){
		$scope.hours = val;
		$scope.datestatus = true;
	}
	$scope.getmin = function (val){
		$scope.min = val;
		$scope.datestatus = true;
	}

	$scope.submit = function(){
		
		
		$scope.updateDate = new Date();
		var currentDate = new Date();
		
		if($scope.datestatus){
			$scope.updateDate = new Date($scope.date+' '+$scope.hours+':'+$scope.min);
			console.log($scope.date+' '+$scope.hours+':'+$scope.min);
			console.log(new Date($scope.date+' '+$scope.hours+':'+$scope.min));
			if($scope.updateDate == 'Invalid Date'){
				
				var getdate = moment($scope.date).format("DD-MMM-YYYY");
				$scope.updateDate = new Date(getdate+' '+$scope.hours+':'+$scope.min);
				console.log('######');
				console.log($scope.updateDate);
				//updateDate = new Date()
			}
			
		}else{
			$scope.updateDate = new Date()
		}
		console.log($scope.updateDate)
		// console.log($scope.gulcovalue)
		// console.log(JSON.parse(angular.toJson($scope.pills)));
		// console.log(JSON.parse(angular.toJson($scope.injication)));
		
		var getjson = JSON.stringify({'mmol_value':$scope.growth.gulcometer_mmol != undefined ? $scope.growth.gulcometer_mmol.toString() : "",'mgol_value':$scope.growth.gulcometer_mgdl != undefined ? $scope.growth.gulcometer_mgdl.toString() : "",'option':$scope.gulcovalue,'pills':JSON.parse(angular.toJson($scope.pills)),'injection':JSON.parse(angular.toJson($scope.injication))});
        var getjsnonVal = getjson.replace(/["']/g, "'");
		//console.log(getjsnonVal);
	   
		var saveData = {
        //record_id:recordId,
		record_id: $scope.patientRecordId,
        type: "Vitals",
        data: {
            Models: {
                Model: {
                    name: "HelChildVitalSigns",
                    Field: [
						{name: "date" , text: currentDate},
                        {name: "weight", text: $scope.growth.weight != ( undefined || null ) ? $scope.growth.weight.toString() : ""},
                        {name: "height", text: $scope.growth.height != ( undefined || null ) ? (($scope.growth.height/100).toFixed(3)).toString() : ""},
                        {name: "temperature", text: $scope.growth.temperature != ( undefined || null ) ? $scope.growth.temperature.toString() : ""},
                        {name: "arm_circumference", text: $scope.growth.arm_circumference != ( undefined || null ) ? $scope.growth.arm_circumference.toString() : ""},
                        {name: "head_circumference", text: $scope.growth.head_circumference != ( undefined || null ) ? $scope.growth.head_circumference.toString() : ""},
                        {name: "chest_circumference", text: $scope.growth.chest_circumference != ( undefined || null ) ? $scope.growth.chest_circumference.toString() : ""},
						{name: "bmi", text: $scope.growth.bmi != ( undefined || null )? $scope.growth.bmi.toString() : ""},
						{name: "heart_rate", text: $scope.growth.heart_rate != ( undefined || null ) ? $scope.growth.heart_rate.toString() : ""},
						{name: "respiratory_rate", text: $scope.growth.respiratory_rate != ( undefined || null ) ? $scope.growth.respiratory_rate.toString() : ""},
						{name: "bp_systolic", text: $scope.growth.bp_systolic != ( undefined || null ) ? $scope.growth.bp_systolic.toString() : ""},
						{name: "bp_diastolic", text: $scope.growth.bp_diastolic != ( undefined || null ) ? $scope.growth.bp_diastolic.toString() : ""},
						{name: "oxygen_saturation", text: $scope.growth.oxygen_saturation != ( undefined || null ) ? $scope.growth.oxygen_saturation.toString() : ""},
						{name:"glucometer", text:getjsnonVal},
						{name: "glucometer_measured_date", text: $scope.updateDate }
						]
					}
				}
			}
		};
		if(saveData.data.Models.Model.Field[0].text===""&&saveData.data.Models.Model.Field[1].text===""){
			return;
		}

		if($scope.growth.vitals){
			saveData.document_id = $scope.growth.vitals;
			recordService.docupdate(saveData).then(function(response) {
				$scope.growth = {};
				var jsonData = {
					account_email: authService.authentication.account_id,
					link: {
						vitals_id: response.Document.id, 
						appointment_id: $sessionStorage.get('appointment_id')
					}
				};
				complaintService.linkappointmentvitals(jsonData).then(function(response) {
					$scope.currentView='simpleComplaint';
					toastr.success("Data updated successfully");
					$scope.getLinkedVitalData();
				})
			},function(error) {
				toastr.error(error);
				analytics('submit',error);
			})
		}
		else{
			complaintService.saveGrowth(saveData).then(function(response) {
				$scope.growth = {};
				var jsonData = {
					account_email: authService.authentication.account_id,
					link: {
						vitals_id: response.Document.id, 
						appointment_id: $sessionStorage.get('appointment_id')
					}
				};
				complaintService.linkappointmentvitals(jsonData).then(function(response) {
					$scope.currentView='simpleComplaint';
					toastr.success("Data saved successfully");
					$scope.getLinkedVitalData();
				})
			}, function(err) {
				toastr.error(err);
				analytics('submit',err);
			})
		}
	};

	$scope.skip = function(){
		if(($scope.growth.height!=""&&$scope.growth.height!=null)
		||($scope.growth.weight!=""&&$scope.growth.weight!=null)
		||($scope.growth.temperature!=""&&$scope.growth.temperature!=null)
		||($scope.growth.arm_circumference!=""&&$scope.growth.arm_circumference!=null)
		||($scope.growth.head_circumference!=""&&$scope.growth.head_circumference!=null)
		||($scope.growth.chest_circumference!=""&&$scope.growth.chest_circumference!=null)
		||($scope.growth.heart_rate!=""&&$scope.growth.heart_rate!=null)
		||($scope.growth.respiratory_rate!=""&&$scope.growth.respiratory_rate!=null)
		||($scope.growth.bp_systolic!=""&&$scope.growth.bp_systolic!=null)
		||($scope.growth.bp_diastolic!=""&&$scope.growth.bp_diastolic!=null)
		||($scope.growth.oxygen_saturation!=""&&$scope.growth.oxygen_saturation!=null)){
			var options = {
				title : 'You have not saved the data',
				message:'Would you like to save and continue?',
				size : 'small',
				onEscape : function() {$scope.$apply();},
				buttons : {
					ok : {
						label : 'Save',
						className: "btn-primary",
						callback: function() {
							$scope.submit();
						}
					},
					close : {
						label: " Skip",
						className: "btn-danger",
						callback: function() {
							//$scope.growth = {};
							$scope.currentView='simpleComplaint';
							$scope.$apply();
						}
					}
				}
			};
		$ngBootbox.customDialog(options);
	}
	else{
		$scope.growth = {};
		$scope.currentView='simpleComplaint';
	}
	};

	$scope.loadPatientData = function(){
		 $scope.dataLoaded = true;
		 $scope.record = {
		 	name:"",
		 	dob:"",
		 	gender:"male",
		 	image:""
	 	};
		 complaintService.getRecordInfo(recordId).then(function(recordInfoResponse){
			 $scope.patientRecordId = recordInfoResponse.record_info.Record.id;
			 console.log('recID****'+$scope.patientRecordId);
		 	 $scope.record = {
				 	name: recordInfoResponse.record_info.Record.label,
				 	dob: new Date(recordInfoResponse.demographics.bday),
				 	gender:recordInfoResponse.demographics.gender,
				 	mr_number: recordInfoResponse.demographics.mr_number,
				 	image:recordInfoResponse.demographics.image,
				 	mobile: recordInfoResponse.demographics.father_tel_number
			};
			$rootScope.record1 =$scope.record
			$scope.loadVitalSigns();
		   },function (err, response) {
                   $ngBootbox.alert(err.Message);
        });
	};

	$scope.loadPatientData();

	$scope.weightMin = "0";
	$scope.weightMax = "10";
	
	$scope.loadVitalSigns = function(){
		var dobMoment  = moment($scope.record.dob);

		var currentDate = moment(new Date());
		var ageInDays = currentDate.diff(dobMoment,'days');

		$scope.recordAge = {
			years : parseInt(moment().diff(dobMoment,'year',true)),
			months: parseInt(moment().diff(dobMoment,'month',true)%12),
			days: parseInt(moment().diff(dobMoment,'day',true)%365),
			ageInDays: ageInDays
		};

		if($scope.recordAge.years<5) {
			$scope.allowedLimits = {heightMin: "44", heightMax: "120", weightMin: "0", weightMax: "24", headMin: "32", headMax: "54"};
		}else if($scope.recordAge.years>5) {
			$scope.allowedLimits = {heightMin: "44", heightMax: "190", weightMin: "0", weightMax: "190", headMin: "32", headMax: "100"};
		}
	};

		 var countloadComplaintList = 0;
		 $scope.loadComplaintList = function (data, complaint) {
			 $rootScope.complaintList = [];
			 complaintService.getComplaintList(data, complaint).then(function (response) {
				 response.length = 100
				 $rootScope.complaintList = response;
			 }, function (err) {
				 toastr.error(err);
				 analytics('loadComplaintList', err);
				 if (countloadComplaintList < 5) {
					 countloadComplaintList += 1;
					 $scope.loadComplaintList('active', 'ab');
				 }
				 else if (countloadComplaintList = 5) {
					 $location.path("/home");
				 }
			 })
		 };

		 $scope.loadComplaintList('active', 'ab');

		 $scope.getcomplaintsbyfilter = function (data) {
			 if (data != undefined) {
				 $scope.loadComplaintList('active', data);
			 } else {
				 $scope.loadComplaintList('active', 'ab');
			 }

		 }

	$scope.showForm = false;

	var url,patient_email;

	$scope.selectJson = function(){
		patient_email = $sessionStorage.get('patientAccEmail');
		var app_id = $sessionStorage.get('appointment_id');
	//	$scope.complaintForm = {user_type: "doctor", other_information: "", unit: "", temperature: "", medicine_given: "", patient_email: patient_email,appointment_id:app_id,issues:[{category_id:"", days:"", inDaysType:"Days",details:[]}]};
		$scope.getcomplaintsbydr = [{"complaint":[{user_type: "doctor", other_information: "", unit: "", temperature: "", medicine_given: "", patient_email: patient_email,appointment_id:app_id,issues:[{category_id:"", days:"", inDaysType:"Days",details:[]}]}]}];
	};

	$scope.selectJson();

	$scope.setView = function(data){
		$scope.view = data;
		$scope.editComplaint2()
	};

	$scope.openconfirmation = function(){
		var options = {
			title : '<h5  style="color:white">You have not saved the data</h5>',
			message:'Would you like to save and continue?',
			size : 'small',
			onEscape : function() {$scope.$apply();},
			buttons : {
				
				close : {
					label: "Close",
					className: "btn-danger",
					callback: function() {
						$scope.$apply();
					}
				},
				ok : {
					label : 'Save',
					className: "btn-primary",
					callback: function() {
						$scope.saveForm();
					}
				}
			}
		};
		$ngBootbox.customDialog(options);
	}

	$scope.editComplaint = function(){
		patient_email = $sessionStorage.get('patientAccEmail');
		var app_id = $sessionStorage.get('appointment_id');
		$scope.getcomplaintsbydr = [{"complaint":[{user_type: "doctor", other_information: "", unit: "", temperature: "", medicine_given: "", patient_email: patient_email,appointment_id:app_id,issues:[{category_id:"", days:"", inDaysType:"Days",details:[]}]}]}];
			var data = {
						account_email: authService.authentication.account_id,
						user_type: "doctor",
						patient_email: $sessionStorage.get('patientAccEmail'),
						appointment_id: $sessionStorage.get('appointment_id')
					};

			recordService.loadLastComplaint(data).then(function(response){

				for (var i = 0; i < response.complaint.issues.length; i++) {
					if (response.complaint.issues[i].user_type == 'doctor') {
						$scope.getcomplaintsbydr[0].complaint[0].issues.push(response.complaint.issues[i])
					}
				}

				$scope.complaintForm = response.complaint;
				$scope.complaintForm.delete_issues=[];
				$scope.complaintForm.new_issues = [];
				$scope.complaintForm.patient_email = $sessionStorage.get('patientAccEmail');
				$scope.complaintForm.user_type = "doctor";
				$scope.complaintForm.complaint_id = response.complaint.id;
				angular.forEach($scope.complaintForm.issues,function(value) {
					value.complaint_type = value.complaint_category;
					value.category_id = value.complaint_category_id;
				})
				$scope.getcomplaintsbydr[0].complaint[0].delete_issues = []
				$scope.getcomplaintsbydr[0].complaint[0].new_issues = [];
				$scope.getcomplaintsbydr[0].complaint[0].patient_email = $sessionStorage.get('patientAccEmail');
				$scope.getcomplaintsbydr[0].complaint[0].user_type = "doctor";
				$scope.getcomplaintsbydr[0].complaint[0].complaint_id = response.complaint.id;
				$scope.getcomplaintsbydr[0].complaint[0].other_information = response.complaint.other_information
				angular.forEach($scope.getcomplaintsbydr[0].complaint[0].issues,function(value) {
					value.complaint_type = value.complaint_category;
					value.category_id = value.complaint_category_id;
				})

				for(var i = 0;i<$scope.getcomplaintsbydr[0].complaint[0].issues.length;i++){
					if($scope.getcomplaintsbydr[0].complaint[0].issues[i].complaint_category == undefined){
						$scope.getcomplaintsbydr[0].complaint[0].issues.splice(i,1)
					}
					if($scope.getcomplaintsbydr[0].complaint[0].issues.length == 0){
						$scope.getcomplaintsbydr[0].complaint[0].issues.push({details:[]});
					}
				}
			})
		};
	// 
		 $scope.editComplaint2 = function () {
			 
			 $scope.getcomplaintsbypatient = []
			 var data = {
				 account_email: authService.authentication.account_id,
				 user_type: "doctor",
				 patient_email: $sessionStorage.get('patientAccEmail'),
				 appointment_id: $sessionStorage.get('appointment_id')
			 };

			 recordService.loadLastComplaint(data).then(function (response) {
				 $scope.patientcomplaintForm = response.complaint
				 for (var i = 0; i < response.complaint.issues.length; i++) {
					 if (response.complaint.issues[i].user_type == 'patient') {
						 $scope.getcomplaintsbypatient.push(response.complaint.issues[i].complaint_category)
					 }
				 }
				 if ($scope.getcomplaintsbypatient.length == 0) {
					 $scope.patientcomplaintstate = false
				 } else {
					 $scope.patientcomplaintstate = true
					 // 	$rootScope.complaintListTemp = $rootScope.complaintList
					 // 	for (var i = 0; i < $rootScope.complaintListTemp.length; i++) {
					 // 		for (var j = 0; j < $scope.getcomplaintsbypatient.length; j++) {
					 // 		if ($rootScope.complaintListTemp[i].complaint_type == $scope.getcomplaintsbypatient[j]) {
					 // 			var removedElements = $rootScope.complaintListTemp.splice(i, 1);
					 // 			i--; 
					 // 		}
					 // 	}
					 // }
				 }
			 })
		 };

	if($sessionStorage.get('complaint')=="edit"){
		$scope.view = "edit";
		$scope.currentView='simpleComplaint';
		$scope.editComplaint();
	}

	// if($sessionStorage.get('complaint')=="add"){
	// 	// $scope.getcomplaintsbydr = [{"complaint": [{"issues":[]}]}]
	// 	$scope.getcomplaintsbydr[0].complaint[0].issues.push({details:[]});
	// }
	

	$scope.cancelComplaint = function(){
		$scope.currentView='simpleComplaint';
		$scope.editComplaint();
		$scope.view = "edit";
	}

	$scope.submitted = false;

		 $scope.saveForm = function () {
			 var url;
			 if ($sessionStorage.get('complaint') == "edit") {
				 $scope.getduplicatesArr = []
				 if ($scope.getcomplaintsbypatient.length > 0) {
					 for (var i = 0; i < $scope.getcomplaintsbypatient.length; i++) {
						 for (var j = 0; j < $scope.getcomplaintsbydr[0].complaint[0].issues.length; j++) {
							if (($scope.getcomplaintsbypatient[i]).toLowerCase() == ($scope.getcomplaintsbydr[0].complaint[0].issues[j].complaint_type).trim().toLowerCase()) {
								 $scope.getduplicatesArr.push($scope.getcomplaintsbypatient[i])
							 }
						 }
					 }
				 }
				 if ($scope.getduplicatesArr.length > 0) {
					 toastr.error($scope.getduplicatesArr[0] + " already added by Patient")
				 } else {
					 url = "updatecomplaint";
					 $scope.getcomplaintsbydr[0].complaint[0].new_issues = [];
					 // if($scope.complaintForm.issues.length == 1){
					 // 	if( $scope.complaintForm.issues[0].category_id == "" || $scope.complaintForm.issues[0].category_id == undefined){
					 // 		$scope.complaintForm.issues = [];
					 // 		angular.forEach($rootScope.complaintList,function(value){
					 // 			if (value.complaint_type == 'others'){
					 // 				var complaintother = {category_id:value.id,days:0};
					 // 					$scope.complaintForm.issues.push(complaintother);
					 // 			}
					 // 		});
					 // 	}
					 // } else {
					 angular.forEach($scope.getcomplaintsbydr[0].complaint[0].issues, function (value) {
						 if (value.details.length > 0) {
							 if (!value.details[0].issue_id) {
								 value.category_id = value.complaint_category_id;
								 delete value['complaint_category_id'];
								 $scope.getcomplaintsbydr[0].complaint[0].new_issues.push(value);
							 }
						 }
						 else {
							 value.category_id = value.complaint_category_id;
							 $scope.getcomplaintsbydr[0].complaint[0].new_issues.push(value);
						 }
					 });
					 var index = $scope.getcomplaintsbydr[0].complaint[0].issues.length - 1;
					 if (!$scope.getcomplaintsbydr[0].complaint[0].issues[index].category_id) {
						 $scope.getcomplaintsbydr[0].complaint[0].issues.splice(index, 1);
					 }

					 if ($scope.getcomplaintsbydr[0].complaint[0].new_issues) {
						 if ($scope.getcomplaintsbydr[0].complaint[0].new_issues.length > 0) {
							 var index1 = $scope.getcomplaintsbydr[0].complaint[0].new_issues.length - 1;
							 if (!$scope.getcomplaintsbydr[0].complaint[0].new_issues[index1].category_id) {
								 $scope.getcomplaintsbydr[0].complaint[0].new_issues.splice(index1, 1);
							 }
						 }
					 }

					 var final = {
						 account_email: authService.authentication.account_id,
						 doctor_id: authService.authentication.doctor_id,
						 simple_complaint: $scope.getcomplaintsbydr[0].complaint[0]
					 };
					 complaintService.saveComplaint(final, url).then(function (response) {
						 $scope.editComplaint();
						 $scope.isReadonly = true;
						 $scope.submitted = true;
						 $scope.view = 'edit';
						 toastr.success("Saved successfully");
						 $location.path("/home");
					 }, function (err) {
						 $scope.editComplaint();
						 $scope.view = 'edit';
						 toastr.error(err.error);
						 analytics('saveForm', err.error);
					 })
				 }
			 }
			 else {
				 url = "simplecomplaint";
				 // if($scope.complaintForm.issues.length == 1){	
				 // 	if($scope.complaintForm.issues[0].complaint_type) 
				 // 	{
				 // 		// Complaint has been selected by user
				 // 		// Do Nothing
				 // 	}
				 // 	else if($scope.complaintForm.issues[0].category_id == "" || $scope.complaintForm.issues[0].category_id == undefined){
				 // 		$scope.complaintForm.issues = [];
				 // 		angular.forEach($rootScope.complaintList,function(value){
				 // 			if (value.complaint_type == 'others'){
				 // 				var complaintother = {category_id:value.id,complaint_category_id:value.id,days:0}
				 // 					$scope.complaintForm.issues.push(complaintother);
				 // 			}
				 // 		});
				 // 	}
				 // }
				 angular.forEach($scope.getcomplaintsbydr[0].complaint[0].issues, function (value) {
					 value.category_id = value.complaint_category_id;
					 delete value['complaint_category_id'];
				 })

				 var index = $scope.getcomplaintsbydr[0].complaint[0].issues.length - 1;
				 if (!$scope.getcomplaintsbydr[0].complaint[0].issues[index].category_id) {
					 $scope.getcomplaintsbydr[0].complaint[0].issues.splice(index, 1);
				 }

				 if ($scope.getcomplaintsbydr[0].complaint[0].new_issues) {
					 if ($scope.getcomplaintsbydr[0].complaint[0].new_issues.length > 0) {
						 var index1 = $scope.getcomplaintsbydr[0].complaint[0].new_issues.length - 1;
						 if (!$scope.getcomplaintsbydr[0].complaint[0].new_issues[index1].category_id) {
							 $scope.getcomplaintsbydr[0].complaint[0].new_issues.splice(index1, 1);
						 }
					 }
				 }

				 var final = {
					 account_email: authService.authentication.account_id,
					 doctor_id: authService.authentication.doctor_id,
					 simple_complaint: $scope.getcomplaintsbydr[0].complaint[0]
				 };
				 complaintService.saveComplaint(final, url).then(function (response) {
					 $scope.editComplaint();
					 $scope.isReadonly = true;
					 $scope.submitted = true;
					 $scope.view = 'edit';
					 toastr.success("Saved successfully");
					 $location.path("/home");
				 }, function (err) {
					 $scope.editComplaint();
					 $scope.view = 'edit';
					 toastr.error(err.error);
					 analytics('saveForm', err.error);
				 })
			 }

		 };

	$scope.addComplaint = function(data,index) {
		if(data.issue!=""||data.days!=""){
			$scope.getcomplaintsbydr[0].complaint[0].issues.push({details:[]});
		}
	};

	$scope.deleteRow = function(data,index){
	
		if(!data.category_id){
			if($scope.getcomplaintsbydr[0].complaint[0].issues.length>1)
        		$scope.getcomplaintsbydr[0].complaint[0].issues.splice(index,1);
		}else{
			$scope.getcomplaintsbydr[0].complaint[0].delete_issues.push(data);
			$scope.getcomplaintsbydr[0].complaint[0].issues.splice(index,1);
		}
    };

	$scope.onSelect= function(data,index){
		$scope.getcomplaintsbydr[0].complaint[0].issues[index].complaint_category_id =data.id;
		//	Get questions from Complaint Master
		var data1 = "account_email="+authService.authentication.account_id+"&type="+data.complaint_type;
		complaintService.questionget(data1).then(function(complaintResponse) {
			$scope.complaintQuestions = complaintResponse;
			if($scope.complaintQuestions.length > 0){
				if($scope.complaintQuestions[0].questions){
					angular.forEach($scope.complaintQuestions[0].questions,function(value) {
						$scope.getcomplaintsbydr[0].complaint[0].issues[index].details.push({questions:value.question, answers:value.question});
					})
				}
			}
		}, function(error) {
			toastr.error("Unable to get complaint questions. Please refresh.");
			analytics('onSelect','unable to get complaint questions. Please refresh');
		})
	};

	// Add New Complaint Category
	$scope.addNewCategory = function(data) {
		var cat_data = {
			account_email: authService.authentication.account_id,
			categories :[]
		};
		cat_data.categories.push(data);
		complaintService.addNewCategory(cat_data).then(function(response) {
			var id;
			angular.forEach(response, function(value) {
				if(value.complaint_type == data){
					id = value.id;
					return;
				}
			})
			$scope.getcomplaintsbydr[0].complaint[0].issues[$scope.getcomplaintsbydr[0].complaint[0].issues.length-1].category_id = id;
			$scope.getcomplaintsbydr[0].complaint[0].issues[$scope.getcomplaintsbydr[0].complaint[0].issues.length-1].complaint_category_id = id;
		}, function(error) {
			toastr.error(error);
			analytics('addNewCategory',error);
		})

	};

	//function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
		var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'complaintController',
            'event_label' : aLabel
        });
     }

	 $scope.checkForSpecialChar = function(string) {
		console.log(string);
		console.log(string.value)
		var specialChars = "0123456789<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=";
		for( i = 0; i < specialChars.length; i++ ) {
			if( string.value.indexOf(specialChars[i] ) > -1 ) {
				return true
			}
		}
		return false;
	}

}]);


'use strict'
angular.module('AngularApp').controller('complaintMasterController',['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','localStorageService','complaintService','authService','toastr',
    function($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter,localStorageService,complaintService,authService,toastr) {

	/** Complaint Master Screen */
	
	$scope.getComplaintQuestion = function(){
		var failedCount = 0;
		var data = "account_email="+authService.authentication.account_id;
		complaintService.questionget(data).then(function(response) {
			$scope.complaintQuestions = response;
			$rootScope.loadComplaintList('active');
		}, function(error) {
			if(failedCount < 5){
				failedCount += 1;
				$scope.getComplaintQuestion();
			}
			else{
				toastr.error('error','Something went wrong');
				analytics('getComplaintQuestion','Something went wrong');
			}
		})
	};
	$scope.getComplaintQuestion();
	// $scope.addNewQuestion = function() {
	// 	$location.path('/addQuestion');
    // };

    $rootScope.loadComplaintList = function(data){
		$rootScope.complaintList = [];
		complaintService.getComplaintList(data).then(function(response) {
			$rootScope.complaintList = response;
		}, function(err) {
			$rootScope.loadComplaintList('active');
			// toastr.error(err.error);
			analytics('loadComplaintList',err.error);
		})
	};

    $rootScope.addNewCategory = function(data) {
		var cat_data = {
			account_email: authService.authentication.account_id,
			categories :[]
		};
		cat_data.categories.push(data);
		complaintService.addNewCategory(cat_data).then(function(response) {
			angular.forEach(response,function(value){
				if(data == value.complaint_type){
					$rootScope.newComplaint.complaint_type = value.complaint_type;
					$rootScope.complaint_id = value.id;
				}
			})
		}, function(error) {
			toastr.error(error);
			analytics('addNewCategory',error);
		})

	};
	
	$rootScope.onSelectComplaint = function(data,index) {
		$rootScope.complaint_id = data.id;
		angular.forEach($rootScope.complaintList, function(checkExisting){
			if(checkExisting.id == $rootScope.complaint_id){
				$rootScope.otherDetails = { 
					add_examination_findings : checkExisting.examination_findings, 
					add_provisional_diagnosis : checkExisting.provisional_diagnosis
				};
			}
		});
	};
    
    $scope.addNewComplaint = function(type){
		$rootScope.comlaintaction = 'add';
		if(type == 'add'){
			$rootScope.newComplaint = { complaint_type:'', question:''};
			$rootScope.otherDetails = { add_examination_findings : '', add_provisional_diagnosis : '' };
		}

        var options = {
			title : 'Add New Complaint Question',
			message:'',
			templateUrl : 'views/complaint/addupdateComplaintQuestion.htm',
			size : 'medium',
			onEscape : function() {$scope.$apply();},
			buttons : {
				ok : {
					label : 'Save',
					className: "btn-primary fa fa-save",
					callback: function() {
						var data = {
							account_email: authService.authentication.account_id,
							questions : [$rootScope.newComplaint],
							examination_findings : $rootScope.otherDetails.add_examination_findings,
							provisional_diagnosis : $rootScope.otherDetails.add_provisional_diagnosis,
							image : "",
							complaint_id : $rootScope.complaint_id
						};
						complaintService.questionadd(data).then(function(response) {
							$scope.getComplaintQuestion();
							toastr.success('Question added successfully');
							$rootScope.newComplaint = {complaint_type:'',question:''};
						},function(error) {
							toastr.error(error,'Try again...');
							analytics('addNewComplaint','Try again');
						})
					}
				},
				close : {
					label: " Close",
                    className: "btn-danger fa fa-times-circle",
                    callback: function() {$scope.getComplaintQuestion();}
				}
			}
		};
		$ngBootbox.customDialog(options);
    };

    $scope.updateComplaint = function(data){
		var complaint_id = '';
		angular.forEach($rootScope.complaintList,function(value){
			if(value.complaint_type == data.complaint_type){
				complaint_id = value.id;
			}
		});

		$rootScope.comlaintaction = 'update';
        
		$rootScope.otherDetails = { 
			add_examination_findings : data.examination_findings, 
			add_provisional_diagnosis : data.provisional_diagnosis
		};

		if(!data.questions){
			$rootScope.newComplaint = { complaint_type: data.complaint_type, question:''};
			$rootScope.complaint_id = complaint_id;
			$scope.addNewComplaint('update');
			return;
		}
		
		var complaint_type = data.complaint_type;
		$rootScope.editComplaint = {
			complaint_type : data.complaint_type,
			questionData : data.questions
		};
		angular.forEach($rootScope.editComplaint.questionData,function(value){
			value.complaint_type = $rootScope.editComplaint.complaint_type;
		});
		
        var options = {
			title : 'Add New Complaint Question',
			message:'',
			templateUrl : 'views/complaint/addupdateComplaintQuestion.htm',
			size : 'medium',
			onEscape : function() {$scope.$apply();},
			buttons : {
				ok : {
					label : 'Save',
					className: "btn-primary fa fa-save",
					callback: function() {
						var data = {
							account_email: authService.authentication.account_id,
							complaint_id: complaint_id,
							questions : $rootScope.editComplaint.questionData,
							examination_findings : $rootScope.otherDetails.add_examination_findings,
							provisional_diagnosis : $rootScope.otherDetails.add_provisional_diagnosis,
							image : ""
						};
						complaintService.questionedit(data).then(function(response) {
							$scope.getComplaintQuestion();
							toastr.success('Question updated successfully');
							$rootScope.editComplaint = '';
						},function(error) {
							toastr.error(error,'Try again...');
							analytics('updateComplaint', 'Try again..');
						})
					}
				},
				close : {
					label: " Close",
                    className: "btn-danger fa fa-times-circle",
                    callback: function() {}
				}
			}
		};
		$ngBootbox.customDialog(options);
    };

    $scope.deleteComplaint = function(data) {
		if(!data.questions){
			return;
		}
		var options = {
			message: 'Are you sure to delete this question ?',
			size: 'small',
			title: 'Confirmation',
			buttons: {
				warning: {
					label: "Cancel",
					className: "btn-warning"
				},
				success: {
					label: "Yes",
				   	className: "btn-success",
				   	callback: function() {
						var deleteData = { 
							account_email: authService.authentication.account_id,
							id: '',
							complaint_type: data.complaint_type,
							question: ''
						}
						angular.forEach(data.questions,function(value){
							deleteData.id = value.id;
							deleteData.question = value.question;
						});
						complaintService.questiondelete(deleteData).then(function(response) {
							$scope.getComplaintQuestion();
							toastr.success('Deleted successfully');
						},function(error) {
							toastr.error(error,'Try again...');
							analytics('delete complaint','try again');
						})
					}
			   	}
		  	}
	  	};
	  	$ngBootbox.customDialog(options);
	};
    /** */
    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
		var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'complaintMasterController',
            'event_label' : aLabel
        });
     }
    
}]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('complaintchooserController', ['$scope', '$rootScope', 'authService', 'toastr', 'complaintchooserService',
 '$sessionStorage','$ngBootbox',
    function ($scope, $rootScope, authService, toastr, complaintchooserService, $sessionStorage,$ngBootbox) {

        $scope.changecolor = false
        $scope.categorystate = false
        $scope.illnesstate = false
        $scope.newcomplaintcategory = {};

        $scope.region = function () {
            
            complaintchooserService.getregion().then(function (response) {
                if (response.success == "1") {
                    if (response.details.length > 0) {
                        angular.forEach(response.details, function (item) {
                            $scope.regiondetails = response.details
                        })
                    } else {
                        $scope.regionlength = false
                    }
                } else {
                    toastr.error("Unable to fetch details")
                }
            })
        }
        
        $scope.region();

        $scope.showcategory = function (data,bodypart) {
            sessionStorage.setItem("bodypart", data)
            sessionStorage.setItem("titlepart",bodypart)
            $scope.showbodypart = sessionStorage.titlepart
            $scope.changebtncolor()
            $scope.categorystate = true
            $scope.illnesstate = false
            complaintchooserService.getcomplaintCategory(data).then(function (response) {
                if (response.success == "1") {
                    if (response.details.length > 0) {
                        $scope.categorylength = true
                        angular.forEach(response.details, function (item) {
                            $scope.categorydetails = response.details
                        })
                        
                    } else {
                        
                        $scope.categorylength = false
                    }
                } else {
                    toastr.error("Unable to fetch details")
                }
            })
        }

        $scope.showillness = function (data) {
            sessionStorage.setItem("category", data)
            $scope.changecolor = true
            $scope.illnesstate = true
            complaintchooserService.getillnesscategory(data).then(function (response) {
                if (response.success == "1") {
                    if (response.details.length > 0) {
                        $scope.illnesslength = true
                        angular.forEach(response.details, function (item) {
                            $scope.illnessdetails = response.details
                        })
                    } else {
                        $scope.illnesslength = false
                    }
                } else {
                    toastr.error("Unable to fetch details")
                }
            })
        }

        $scope.addcategorycomplaint = function () {
            if($scope.newcomplaintcategory.one == undefined || $scope.newcomplaintcategory.one == ""){
                toastr.error("Please Enter Category name")
            }else {
            var complaintcategoryArr = $scope.newcomplaintcategory.one
            var complaintcategoryArr2 = []
            complaintcategoryArr2.push(complaintcategoryArr)
            var item = {
                body_part_id: sessionStorage.bodypart,
                data: complaintcategoryArr2,
                account_email: authService.authentication.account_id,
                doctor_id: authService.authentication.doctor_id
            }
            complaintchooserService.postcategorycomplaint(item).then(function (response) {
                if (response.success == "1") {
                    toastr.success("Saved successfully")
                    $scope.newcomplaintcategory = {}
                    $scope.showcategory(sessionStorage.bodypart,sessionStorage.titlepart)
                } else if(response.success == "2"){
                    toastr.error(response.message)
                } else {
                    toastr.error("Unable to add")
                }
            })
           }
        }

        $scope.addillnesscomplaint = function () {
            if($scope.newcomplaintcategory.two == undefined || $scope.newcomplaintcategory.two == ""){
                toastr.error("Please Enter Symptoms")
            }
            else {
                var illnessArr = $scope.newcomplaintcategory.two
            var illnessArr2 = []
            illnessArr2.push(illnessArr)
            var item = {
                account_email: authService.authentication.account_id,
                doctor_id: authService.authentication.doctor_id,
                body_part_id: sessionStorage.bodypart,
                category_id: sessionStorage.category,
                data: illnessArr2
            }
            complaintchooserService.postillnesscomplaint(item).then(function (response) {
                if (response.success == "1") {
                    toastr.success("Saved successfully")
                    $scope.newcomplaintcategory = {}
                    $scope.showillness(sessionStorage.category)
                } else if(response.success == "2"){
                    toastr.error(response.message)
                }  else {
                    toastr.error("Unable to add")
                }
            })
            }
        }

        $scope.togglecategory = function (state, categoryid, categoryname) {
            if (state == true) {
                $scope.categorytoggle = 1
            } else if (state == false) {
                $scope.categorytoggle = 0
            }
            var item = {
                account_email: authService.authentication.account_id,
                doctor_id: authService.authentication.doctor_id,
                body_part_id: sessionStorage.bodypart,
                category_id: categoryid,
                category_name: categoryname,
                status: $scope.categorytoggle
            }
            complaintchooserService.postcategorycomplaint(item).then(function (response) {
                if (response.success == "1") {
                    toastr.success("Changed successfully")
                    $scope.showcategory(sessionStorage.bodypart,sessionStorage.titlepart)
                } else {
                    toastr.error("Unable to add")
                }
            })
        }

        $scope.toggleillness = function (state, illnessid, illnessname) {
            if (state == true) {
                $scope.illnesstoggle = 1
            } else if (state == false) {
                $scope.illnesstoggle = 0
            }
            var item = {
                account_email: authService.authentication.account_id,
                doctor_id: authService.authentication.doctor_id,
                category_id: sessionStorage.category,
                sub_category_id: illnessid,
                sub_category_name: illnessname,
                status: $scope.illnesstoggle
            }
            complaintchooserService.postillnesscomplaint(item).then(function (response) {
                if (response.success == "1") {
                    toastr.success("Changed successfully")
                    $scope.showillness(sessionStorage.category)
                } else {
                    toastr.error("Unable to add")
                }
            })
        }
        $rootScope.newcategoryname = {}
        $scope.updatesubcategory = function (categoryid,categoryname) {
            $rootScope.newcategoryname.one = categoryname
            var options = {
                title: '<h5  style="color:white">Update Category</h5>',
                message: '',
                templateUrl: 'views/complaintchooser/updatesubcategory.htm',
                size: 'medium',
                buttons: {
                    ok: {
                        label: "Save",
                        className: "btn-primary",
                        callback: function () {
                            if($rootScope.newcategoryname.one == undefined || $rootScope.newcategoryname.one == ""){
                                toastr.error("Unable to save")
                            }else {
                            var item = {
                                body_part_id: sessionStorage.bodypart,
                                category_id : categoryid,
                                category_name: $rootScope.newcategoryname.one,
                                account_email: authService.authentication.account_id,
                                doctor_id: authService.authentication.doctor_id
                            }
                            complaintchooserService.postcategorycomplaint(item).then(function (response) {
                                if (response.success == "1") {
                                    toastr.success("Saved successfully")
                                    $scope.newcategoryname.one = ""
                                    $scope.showcategory(sessionStorage.bodypart,sessionStorage.titlepart)
                                } else if(response.success == "2"){
                                    toastr.error(response.message)
                                } else {
                                    toastr.error("Unable to add")
                                }
                            })
                           }
                            bootbox.hideAll();
                        }
                    }
                }
            }
            $ngBootbox.customDialog(options);
        }

        $rootScope.newillnessname = {}
        $scope.updateillness = function (subcategoryname,categoryid,illnessname) {
            $rootScope.newillnessname.two = illnessname
            var options = {
                title: '<h5  style="color:white">Update Symptoms</h5>',
                message: '',
                templateUrl: 'views/complaintchooser/updateillness.htm',
                size: 'medium',
                buttons: {
                    ok: {
                        label: "Save",
                        className: "btn-primary",
                        callback: function () {
                            if($rootScope.newillnessname.two == undefined || $rootScope.newillnessname.two == ""){
                                toastr.error("Unable to save")
                            }
                            else {
                            var item = {
                                account_email: authService.authentication.account_id,
                                doctor_id: authService.authentication.doctor_id,
                                category_id: sessionStorage.category,
                                sub_category_id: categoryid,
                                sub_category_name : $rootScope.newillnessname.two
                            }
                            complaintchooserService.postillnesscomplaint(item).then(function (response) {
                                if (response.success == "1") {
                                    toastr.success("Saved successfully")
                                    $scope.newillnessname = {}
                                    $scope.showillness(sessionStorage.category)
                                } else if(response.success == "2"){
                                    toastr.error(response.message)
                                }  else {
                                    toastr.error("Unable to add")
                                }
                            })
                            }
                            bootbox.hideAll();
                        }
                    }
                }
            }
            $ngBootbox.customDialog(options);
        }
        
       $scope.categoryaddpopup = function(){
        if($scope.newcomplaintcategory.one == undefined || $scope.newcomplaintcategory.one == ""){
            toastr.error("Please Enter Category name")
        } else {
            $rootScope.tempcategory = $scope.newcomplaintcategory.one
            var options = {
                title: '<h5  style="color:white">Add Confirmation</h5>',
                message: '',
                templateUrl: 'views/complaintchooser/addcategoryconfirmation.htm',
                size: 'medium',
                buttons: {
                    ok: {
                        label: "Save",
                        className: "btn-primary",
                        callback: function () {
                            $scope.addcategorycomplaint()
                        }
                    },
                    cancel: {
                        label: " Cancel",
                        className: "btn-danger fa fa-times",
                        callback: function() {}
                    }
                }
            }
            $ngBootbox.customDialog(options);
        }
        
       }

       $scope.illnessaddpopup = function(){
        if($scope.newcomplaintcategory.two == undefined || $scope.newcomplaintcategory.two == ""){
            toastr.error("Please Enter Symptoms")
        } else {
            $rootScope.tempillness = $scope.newcomplaintcategory.two
            var options = {
                title: '<h5  style="color:white">Add Confirmation</h5>',
                message: '',
                templateUrl: 'views/complaintchooser/addillnessconfirmation.htm',
                size: 'medium',
                buttons: {
                    ok: {
                        label: "Save",
                        className: "btn-primary",
                        callback: function () {
                            $scope.addillnesscomplaint()
                        }
                    },
                    cancel: {
                        label: " Cancel",
                        className: "btn-danger fa fa-times",
                        callback: function() {}
                    }
                }
            }
            $ngBootbox.customDialog(options);
        }
        
       }

       $scope.toggleconfirmationCategory = function(status,id,name){
       
           if(status == false){
            $rootScope.categorytogglename = "Deactivate"
           } else if (status == true){
            $rootScope.categorytogglename = "Activate"
           }
          
            var options = {
                title: '<h5  style="color:white">Activate/Deactivate Confirmation</h5>',
                message: '',
                templateUrl: 'views/complaintchooser/togglealertCategory.htm',
                size: 'medium',
                buttons: {
                    ok: {
                        label: "Save",
                        className: "btn-primary",
                        callback: function () {
                            $scope.togglecategory(status,id,name)
                        }
                    },
                    cancel: {
                        label: " Cancel",
                        className: "btn-danger fa fa-times",
                        callback: function() {
                            $scope.showcategory(sessionStorage.bodypart,sessionStorage.titlepart)
                        }
                    }
                }
            }
            $ngBootbox.customDialog(options);
       }

       $scope.toggleconfirmationillness = function(status,id,name){
       
        if(status == false){
         $rootScope.illnesstogglename = "Deactivate"
        } else if (status == true){
         $rootScope.illnesstogglename = "Activate"
        }
       
         var options = {
             title: '<h5  style="color:white">Activate/Deactivate Confirmation</h5>',
             message: '',
             templateUrl: 'views/complaintchooser/togglealertIllness.htm',
             size: 'medium',
             buttons: {
                 ok: {
                     label: "Save",
                     className: "btn-primary",
                     callback: function () {
                         $scope.toggleillness(status,id,name)
                     }
                 },
                 cancel: {
                     label: " Cancel",
                     className: "btn-danger fa fa-times",
                     callback: function() {
                        $scope.showillness(sessionStorage.category)
                     }
                 }
             }
         }
         $ngBootbox.customDialog(options);
    }

        $scope.changebtncolor = function (index) {
            $scope.activeBtn = index;
        }
        
        $scope.showmalefront = true
        $scope.rotateimagemodel = function(){
            $scope.showmalefront = !$scope.showmalefront
        }
    }])
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('dashboardController',['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','paymentService','authService','toastr','dashboardService',
function($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter, paymentService, authService, toastr, dashboardService) {
  
$scope.showReviewChart = false;
var barColors = ['#FF8C5A','#FFB235','#FFD935','#AED888','#79C9A1']; 
$scope.typeofService="1";
$scope.totalUsers =  0;
$scope.feedBackFrom = 0;
$scope.totalConsultants = 0;
function createTempArray(){
  var Arr=[]
  for(var i=0;i<5;i++){
    Arr.push({y:0,color:''});
  }
  return Arr;
}
var reviewChartArray = createTempArray();

function reviewChart(barData){
  /*Ratings Chart*/   
    $('#ratings_chart').highcharts({
        chart: {
            type: 'bar',
            spacingBottom: 15,
            spacingTop: 10,
            spacingLeft: 10,
            spacingRight: 10,
            width: 440,
            height: 138
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: ['5', '4', '3', '2', '1'],
            lineWidth: 0,
            minorGridLineWidth: 0,
            gridLineWidth: 0,
            lineColor: 'transparent',
            minorTickLength: 0,
            tickLength: 0,
        },
        yAxis: {
            min: 0,
            title: {
              text: ''
            }, 
            lineWidth: 0,
            gridLineWidth: 0,
            minorGridLineWidth: 0,     
            labels: {
              enabled: false,
            },
            minorTickLength: 0,
            tickLength: 0,
        },
        legend: {
          reversed: true
        },
        tooltip:{
          enabled:false
        }, 
        plotOptions: {
          series: {
            pointWidth: 21,
            pointPadding: 0,
            groupPadding: 0.1,
            dataLabels: {
              enabled: true,
              outside: true,
              align: 'left',
              style: {
                fontWeight: 'light',
                color: 'gray'
              }
            }            
          }
        },
        series: [
          {
          //name: "Rating",
            showInLegend: false, 
            colorByPoint: true,     
            data: barData,
          }
        ],
    });
  /*Ratings Chart ends here*/

}
  
    /**
     * Start of Payment History
     */
   // vm.po = { totalPatients:0, size:20, curruntPage:1, maxSize:5}
   $scope.dt = new Date()
   $scope.reportBy = {
       'By Range':'By Range'
   };
     
   $rootScope.rangePicker1= {
       opened :{ fromDate:false, toDate:false},
       maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
       dateOptions : {
       formatYear: 'yyyy',
       startingDay: 0,
       maxDate: new Date()
     }
   };
   $rootScope.rangePicker2 = {
       opened :{ fromDate:false, toDate:false},
       maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
       dateOptions : {
       formatYear: 'yyyy',
       startingDay: 0,
       maxDate: new Date(),
     //minDate: new Date()
     }
   };
  
/*  $scope.byRange = function(date) {
     /*var data = '';
       $rootScope.rangePicker1.dateOptions = date;
       data = '&date=' + $filter('date')(from, "yyyy-MM-dd");
       $scope.getHistory(data);*/
/*     $scope.date = date;
       var data = '';
       data = $filter('date')($scope.date, "yyyy");
       data = data+'-'+$filter('date')($scope.date, "M");
       data = data+'-'+$filter('date')($scope.date, "d");
       $scope.getHistory(data);
       $scope.date = $filter('date')($scope.date, "dd-MMM-yyyy");
    }
*/

  // UTC to local time conversion
  $scope.convertUTCDateToLocalDate = function(date) {
   var newDate = new Date(date);
   var offset  = date.getTimezoneOffset();
   var minutes = date.getMinutes();
   newDate.setMinutes(minutes - offset);
   return newDate;   
  };


  $scope.printPaymentToPaper = function(id) {
    var innerContents = document.getElementById('printtable').innerHTML;
    var popupWinindow = window.open('', '_blank',
    'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
    popupWinindow.document.close();
  };
  
  $scope.exportData = function (type) {

    $scope.date = new Date();
    $scope.formattedDate =   $filter('date')(new Date(), "dd-MMM-yyyy");
    var filename = "PaymentReport" + $scope.formattedDate;

    if(type == 'CSV') {
        alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#exportable',{headers:true})");
    } else if(type == 'EXCEL') {
     // alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
        var blob = new Blob([document.getElementById('printtable').innerHTML], {
            type: "application/vnd.ms-excel;charset=utf-8"
        })
        saveAs(blob, "DailyCollectionReport.xls");
    } else if(type == 'PDF') {
        html2canvas(document.getElementById('exportable'), {
          onrendered: function (canvas) {
              var data = canvas.toDataURL();
              var docDefinition = {
                  content: [{
                    image: data,
                    width: 500,
                  }]
              };
              pdfMake.createPdf(docDefinition).download("" + filename + ".pdf");
            }
        });
    }
};

$scope.reviewDataObj = function(reviewData) {
  if(reviewChartArray) {
    reviewChartArray = createTempArray();
  }
  for(var i=5; i>=1; i--) {
      angular.forEach(reviewData, function(value) {
        if(value.starrating==i) {           
           reviewChartArray[reviewChartArray.length-value.starrating]={y:value.usercount, color:barColors[i-1]};
        } 
      });
  }
  return reviewChartArray;
}

//$scope.ratingValue = 0;
$scope.getReviewData = function(start_date, end_date) {
  var payload = {
      account_email: authService.authentication.account_id,
      start_dt : start_date,
      end_dt: end_date
  }

  dashboardService.getReviewData(payload).then(function(response) {
  
    if(response.review_details!=null) {
      if(response.review_details.reviews!=null) {

            if(response.usercount_details!=null) {
              if(response.usercount_details.reviews) {
                $scope.totalUsers =  response.usercount_details.reviews.f2.Usercount;
                $scope.feedBackFrom = response.usercount_details.reviews.f3.Feedback;
                $scope.totalConsultants = response.usercount_details.reviews.f1.Total;
              } else {
                $scope.totalUsers =  0;
                $scope.feedBackFrom = 0;
                $scope.totalConsultants = 0;
              }
            } else {
              $scope.totalUsers =  0;
              $scope.feedBackFrom = 0;
              $scope.totalConsultants = 0;
            }

            $scope.showReviewChart = true;
            reviewChart( $scope.reviewDataObj(response.review_details.reviews) );
            
            $scope.totalReviewers = response.review_details.users;
            var ratingValue = parseFloat(response.review_details.rating);
            ratingValue = ratingValue.toFixed(1);
      
            if(ratingValue==0.0||ratingValue==1.0||ratingValue==2.0||ratingValue==3.0||ratingValue==4.0||ratingValue==5.0){
              $scope.ratingValue = parseInt(ratingValue);  
              if($scope.ratingValue>0 && $scope.ratingValue<=5) {       
                 $('#star'+$scope.ratingValue).trigger('click');
              }
            } else { 
                $scope.ratingValue = ratingValue;      
                if($scope.ratingValue>=4.1 && $scope.ratingValue<=4.9) {
                  $('#star4half').trigger('click');
                } else if($scope.ratingValue>=3.1 && $scope.ratingValue<=3.9) {
                  $('#star3half').trigger('click');
                } else if($scope.ratingValue>=2.1 && $scope.ratingValue<=2.9) {
                  $('#star2half').trigger('click');
                } else if($scope.ratingValue>=1.1 && $scope.ratingValue<=1.9) {
                  $('#star1half').trigger('click');
                } else if($scope.ratingValue>=0.1 && $scope.ratingValue<=0.9) {
                  $('#starhalf').trigger('click');
                }
            }
            $(".rating").attr('disabled','disabled');
      } else {
        $scope.showReviewChart = false;
        $scope.totalUsers =  0;
        $scope.feedBackFrom = 0;
        $scope.totalConsultants = 0;
      }
    }else{
      $scope.showReviewChart = false;
      $scope.totalUsers =  0;
      $scope.feedBackFrom = 0;
      $scope.totalConsultants = 0;
    }
  });
}

function stringDate(date){
  var day   = date.getDate();
  var month = date.getMonth()+1;
  var year  = date.getFullYear(); 
 return "" + day + "/" + month + "/" + year;
}

function parseDate(str) {
  var mdy = str.split('/');
 return new Date( mdy[2], mdy[1], mdy[0] );
}
  
function datediff(first, second) {
 return Math.round((second-first)/(1000*60*60*24));
}

$scope.byRange = function(from,to) {
  
  if(from) {
    $rootScope.rangePicker2 = {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date(),
          minDate: from
        }
    };
  }

  if(to) {
    $rootScope.rangePicker1 = {
      opened : {fromDate:false, toDate:false},
      maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
      dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: to
      }
    }
  };

  if(from && to) {
    var days = datediff(parseDate(stringDate(from)), parseDate(stringDate(to)));
    if(days>=0) {
      var start_date = $filter('date')(from, "dd-MM-yyyy");
      var end_date = $filter('date')(to, "dd-MM-yyyy");
      $scope.getReviewData(start_date, end_date);
    } else {
      $scope.showReviewChart = false;
      $scope.totalUsers =  0;
      $scope.feedBackFrom = 0;
      $scope.totalConsultants = 0;
    }
  }

}

$scope.initData = function(){
  $scope.ExportType = "EXCEL";
  $scope.selectedReportType = "Today";
  var date = new Date();
  $scope.fromDate = date;
  $scope.toDate = date;
  $scope.byRange($scope.fromDate, $scope.toDate)
} 
$scope.initData();

/*  jQuery(document).ready(function($) {
      $('.rating .star').hover(function() {
          $(this).addClass('to_rate');
          $(this).parent().find('.star:lt(' + $(this).index() + ')').addClass('to_rate');
          $(this).parent().find('.star:gt(' + $(this).index() + ')').addClass('no_to_rate');
      }).mouseout(function() {
          $(this).parent().find('.star').removeClass('to_rate');
          $(this).parent().find('.star:gt(' + $(this).index() + ')').removeClass('no_to_rate');
      }).click(function() {
          $(this).removeClass('to_rate').addClass('rated');
          $(this).parent().find('.star:lt(' + $(this).index() + ')').removeClass('to_rate').addClass('rated');
          $(this).parent().find('.star:gt(' + $(this).index() + ')').removeClass('no_to_rate').removeClass('rated');
          /*Save your rate*/
          /*TODO*/
          //alert($(this).parent().find('.star:lt(' + $(this).index() + ')').length+1);
      /*    ans4 = $(this).parent().find('.star:lt(' + $(this).index() + ')').length+1;
          ans4 = ""+ans4;
      }); 
    }); */

  

}]);

'use strict';

angular.module('AngularApp').controller('deadvstimeafterdeliveryController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr','multicenterstudyreportService',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr, multicenterstudyreportService) { 
 
    
    $scope.timeInputDisable = true;

    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
        }
    };

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.exportData = function(type) {

      if($scope.deadvsTimeAfterdelivery) {
 
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Dead_vs_Time_After_During_Discharge_report_"+$scope.formattedDate;
          
          if($scope.selectedFromDate && $scope.selectedToDate){
              filename = "Dead_vs_Time_After_During_Discharge_report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
          }
          
         /* if(type=='csv') {

              alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
              
          } else*/
          if(type == 'excel') {

              //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                  var blob = new Blob([document.getElementById('printtable').innerHTML], {
                      type: "application/vnd.ms-excel;charset=utf-8"
                  });
               saveAs(blob, filename+".xls");

          } else if(type=='pdf') {

              var pdf_element = document.getElementById('printtable');
              var opt = {
                  margin:      0.2,
                  filename:   filename,
                  image:       { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
              };
                  
              //New Promise-based usage:
              html2pdf().set(opt).from(pdf_element).save();
                  
          }
      }
  }

    $scope.labelHide = true
    $scope.getDeadvsTimeAfterdeliveryStatus = function() {
        var data = {
            account_email: authService.authentication.account_id,
            start_date: $scope.selectedFromDate2,
            end_date: $scope.selectedToDate2
        }
        multicenterstudyreportService.getDeadvsTimeAfterdelivery(data).then(function(response) {
          if(response.data.dead_after_discharge.length > 0 || response.data.dead_during_discharge.length > 0){
            $scope.labelHide = false
            $scope.deadvsTimeAfterdelivery = response;
            console.log($scope.deadvsTimeAfterdelivery);
          } else {
            $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
          }
            
        },function(error) {
            if(error){
              toastr.error('Select from & to date')
            }
            // toastr.error(error);
            analytics('getDeadvsTimeAfterdeliveryStatus',error);
        })
    };

    // $scope.getDeadvsTimeAfterdeliveryStatus()
 
}]);
'use strict';

var app = angular.module('demo', ['ngSanitize', 'ui.select']);

app.controller('DemoCtrl', function($scope, $http, $timeout) {


  $scope.availableColors = ['Red','Green','Blue','Yellow','Magenta','Maroon','Umbra','Turquoise'];

  $scope.multipleDemo = {};
  $scope.multipleDemo.colors = ['Red'];
  
  $scope.availableUsers = ['Red','Green','Blue','Yellow','Magenta','Maroon','Umbra','Turquoise'];
  $scope.multiple = {};
  $scope.multiple.User = ['Blue','Red'];
});

'use strict';
angular.module('AngularApp').controller('diagnosisController', ['$scope', '$rootScope', '$location', '$route', 'recordService', 'percentileService', '$ngBootbox','$uibModal', '$filter','localStorageService',
	 function ($scope, $rootScope, $location, $route, recordService, percentileService, $ngBootbox, $uibModal, $filter,localStorageService) {

$scope.ldDiag = function(documentId,index){
		$location.path('/patientdiagnosis');
	    $scope.$apply();
		recordService.getDiagnosiss(recordId,documentId).then(function(response){
			$scope.dList = response;
			$scope.diagnosisList={Field:[]};
			$scope.otherissueList = {showTable:false,items:['Issues','Anal','Face','Eyes','Bellybutton','Head','Nose','Mouth', 'Neck', 'Stomach', 'Back ','Leg','Hand', 'Ears','Chest','Painontouch','Pus-formation'],injury:[],skinColor:[],Pain:[],Swelling:[]};
			angular.forEach($scope.dList,function(data){
				if(data.name=="HelChildDiagnosis"){
				angular.forEach(data,function(field){
					if(field!="HelChildDiagnosis")
					$scope.diagnosisList.Field= angular.copy(field);

				});
				}

				if(data.name=="HelChildOtherIssues"){
				angular.forEach(data,function(field){
					if(field[0].text=="injury" || field[14].text=="injury"){
						angular.forEach(field,function(fieldVal){
						$scope.otherissueList.injury.push(fieldVal);
						});
					}
					if(field[0].text=="change in skin color" || field[14].text=="change in skin color"){
						angular.forEach(field,function(fieldVal){
						 $scope.otherissueList.skinColor.push(fieldVal);
						});

					}

					if(field[0].text=="pain" || field[14].text=="pain"){
						angular.forEach(field,function(fieldVal){
						 $scope.otherissueList.Pain.push(fieldVal);
						});
					}
					if(field[0].text=="swelling" ||field[14].text=="swelling" ){
						 angular.forEach(field,function(fieldVal){
						 $scope.otherissueList.Swelling.push(fieldVal);
						});
					}


				});
				}

			});
		});
		$scope.visitList[index].isCollapsed=true;
		for(var i=0;i<=$scope.visitList.length;i++){
						$scope.visitList[i].isCollapsed=true;
		}
	};
}]);

function getTimeString(date) {
    var getHours, getMinutes, getSeconds;

    if(date.getHours()<10) {
        getHours = "0"+date.getHours();
    } else {
        getHours = date.getHours();
    }

    if(date.getMinutes()<10) {
        getMinutes= "0"+date.getMinutes();
    } else {
        getMinutes = date.getMinutes();
    }

    if(date.getSeconds()<10) {
        getSeconds = "0"+date.getSeconds();
    } else {
        getSeconds = date.getSeconds();
    }

   return getHours+":"+getMinutes+":"+getSeconds;
}

'use strict';
angular.module('AngularApp').controller('dischargeController1', ['$scope', '$rootScope', '$filter', '$ngBootbox', '$location', 'toastr', 'authService', 'dischargeService', '$timeout', 'recordService',
    function ($scope, $rootScope, $filter, $ngBootbox, $location, toastr, authService, dischargeService, $timeout, recordService) {
        
        $scope.clicked = function () {  
            $location.path("/manage-doctor");  
        } 
        $scope.admission_time = ""; 
        $scope.dob_time = "";
        $rootScope.discharge_edit = false
        $rootScope.dischargeedit_sncu_id = ""
       
        // $(function(){
        //     var newday = new Date().getDate();
        //     var newmonth = new Date().getMonth()+1;
        //     var newyear = new Date().getFullYear();
        //     if(newday < 10){
        //         new_day = "0"+newday
        //     }else{
        //         new_day = newday
        //     }
        //     if(newmonth < 10){
        //         new_month = "0"+newmonth
        //     }else{
        //         new_month = newmonth
        //     }
        //     console.log('newday',new_day,'newmonth',new_month,'newyear',newyear)
        // });
        $scope.newborn_dates = [
            { 'value' : '< 24 hr' },
            { 'value' : '1 day' },
            { 'value' : '2 days' },
            { 'value' : '3 days' },
            { 'value' : '4 days' },
            { 'value' : '5 days' },
            { 'value' : '6 days' },
            { 'value' : '7 days' },
            { 'value' : '8 days' },
            { 'value' : '9 days' },
            { 'value' : '10 days' },
            { 'value' : '11 days' },
            { 'value' : '12 days' },
            { 'value' : '13 days' },
            { 'value' : '14 days' },
            { 'value' : '15 days' },
            { 'value' : '16 days' },
            { 'value' : '17 days' },
            { 'value' : '18 days' },
            { 'value' : '19 days' },
            { 'value' : '20 days' },
            { 'value' : '21 days' },
            { 'value' : '22 days' },
            { 'value' : '23 days' },
            { 'value' : '24 days' },
            { 'value' : '25 days' },
            { 'value' : '26 days' },
            { 'value' : '27 days' },
            { 'value' : '28 days' },
            { 'value' : '> 28 days' },
            { 'value' : '' }
        
        ];

        $scope.Effective_from = function(e){
            var date = $filter('date')(new Date(e), "yyyy-MM-dd");
            $scope.datepicker_dob.dateOptions.maxDate = new Date(e);
                $scope.newborn_array[1] = date ;
                $scope.newbornage_Calculation();
                console.log('$scope.newborn_array_dob',$scope.newborn_array);
                $rootScope.dischargeSummary.admission.admission_dt = date;
                
                if($scope.admission_time=="") {
                    document.getElementById("admission_dt_error").textContent = "Value is required."; 
                } else {
                    // $rootScope.dischargeSummary.admission.admission_time = date+" "+$scope.admission_time;
                    $rootScope.dischargeSummary.admission.admission_time = $scope.admission_time;
                    document.getElementById("admission_dt_error").textContent = "";  
                }
        }
        $scope.newbornvalue = 30;
        $scope.newBorn_age = "";

         $scope.newborn_array = [];
        $scope.newbornage_Calculation = function(){
            console.log('newborn age caculation',$scope.newborn_array);
            if(($scope.newborn_array[0] && $scope.newborn_array[1]) != null){
                var date_of_birth = new Date($scope.newborn_array[1]);
                var todays_date =  new Date($scope.newborn_array[0]);
                var diffdays = todays_date.getTime() - date_of_birth.getTime();
                var diffDays = diffdays / (1000 * 3600 * 24); 
                console.log('diffDaysdiffDays',Math.abs(diffDays));
                $scope.Diffdays = Math.abs(diffDays);
                console.log(' $scope.Diffdays', $scope.Diffdays);
                if(Math.abs(diffDays) == 0){
                    $rootScope.dischargeSummary.admission.newborn_age = "< 24 hr"; 
                    $scope.newbornvalue = 0;
                    $scope.newBorn_age = false;
                    document.querySelector('#newborn_Boxsize').style.width = '70px';
                 }else if(Math.abs(diffDays) > 28){
                    $rootScope.dischargeSummary.admission.newborn_age = ">"+Math.abs(diffDays) +" "+"days"; 
                    $scope.newbornvalue = 29;
                    $scope.newBorn_age = "true"
                    document.querySelector('#newborn_Boxsize').style.width = '120px';
                 }else if(Math.abs(diffDays) == 1){
                    $rootScope.dischargeSummary.admission.newborn_age = Math.abs(diffDays) +" "+"day";
                    $scope.newbornvalue = 1
                    $scope.newBorn_age = "true"
                    document.querySelector('#newborn_Boxsize').style.width = '120px';
                 }else{
                    $rootScope.dischargeSummary.admission.newborn_age = Math.abs(diffDays) +" "+"days"
                    $scope.newbornvalue = Math.abs(diffDays);
                    $scope.newBorn_age = "true"
                    document.querySelector('#newborn_Boxsize').style.width = '120px';
                 }
            }
        }
        $scope.Effective_from_dateofbirth = function(e){
            var date = $filter('date')(new Date(e), "yyyy-MM-dd");
            $scope.newborn_array[0] = date;
            console.log('$scope.newborn_array',$scope.newborn_array);
            $scope.newbornage_Calculation()
            
            // if($rootScope.dischargeSummary.admission.admission_dt != ''){
            // var date_of_birth = new Date(e);
            // var todays_date =  new Date($rootScope.dischargeSummary.admission.admission_dt);
            //  var diffDays = todays_date.getDate() - date_of_birth.getDate();
            //  console.log('diffDaysdiffDays',diffDays);
            //  if(diffDays != 1){
            //     $rootScope.dischargeSummary.admission.newborn_age = diffDays +" "+"days"; 
            //  }else if(diffDays > 28){
            //     $rootScope.dischargeSummary.admission.newborn_age = ">"+diffDays +" "+"days";
            //  }else if(diffDays == 1){
            //     $rootScope.dischargeSummary.admission.newborn_age = diffDays +" "+"day"
            //  }else{
            //     $rootScope.dischargeSummary.admission.newborn_age = diffDays +" "+"days"
            //  }
            // }else{
            //     alert("Alert :\n    Newborn's Age not corresponding with Date of Birth and Admission Date : Please Check");
            //     $rootScope.dischargeSummary.admission.newborn_age = "";
            // }
             
            $rootScope.dischargeSummary.admission.dob = date;
            if($scope.dob_time=="") {
                document.getElementById("dob_error").textContent = "Value is required."; 
            } else {
                // $rootScope.dischargeSummary.admission.dob_time = date+" "+$scope.dob_time;
                $rootScope.dischargeSummary.admission.dob_time = $scope.dob_time;
                document.getElementById("dob_error").textContent = "";  
            }
        }

        // var d = new Date();
        // var todaysback = d.setDate(d.getDate() - 1);
        $scope.datepicker_addmission = {
          opened:{appointment_date1:false, appointment_date2:false},
          maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
          dateOptions : {
              formatYear: 'yyyy',
              maxDate: new Date(),
          }
      };

      $scope.datepicker_dob = {
        opened:{appointment_date1:false, appointment_date2:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
            formatYear: 'yyyy',
            startingDay:0,
            maxDate: new Date(),
        }
    };
       
        $(function () {
            
            // var newday = new Date().getDate();
            // var newmonth = new Date().getMonth()+1;
            // var newyear = new Date().getFullYear();
            // if(newday < 10){
            //     new_day = "0"+newday
            // }else{
            //     new_day = newday
            // }
            // if(newmonth < 10){
            //     new_month = "0"+newmonth
            // }else{
            //     new_month = newmonth
            // }
            // console.log('newday',new_day,'newmonth',new_month,'newyear',newyear)
            // var maximumdate = newyear+"-"+new_month+"-"+new_day
            // var year = new Date().getFullYear();
            // var today = new Date().getDate();
            // var month = new Date().getMonth();
            // $('#datepicker1').datetimepicker({
            //     format: 'DD/MM/YYYY',
                // useCurrent: true,
                // maxDate:  moment().add(0,'day'),
            // }).on('dp.change', function(e) {
            //     console.log('event datetimepicker',e);
                
            // });
      
            // $('#datepicker2').datetimepicker({
            //     format: 'DD/MM/YYYY',
                //maxDate: moment()
            // }).on('dp.change', function(e) {
           
            //     var date = $filter('date')(new Date(e.date), "yyyy-MM-dd");
            //     $rootScope.dischargeSummary.admission.dob = date;
            //     if($scope.dob_time=="") {
            //         document.getElementById("dob_error").textContent = "Value is required."; 
            //     } else {
            //         $rootScope.dischargeSummary.admission.dob_time = date+" "+$scope.dob_time;
            //         document.getElementById("dob_error").textContent = "";  
            //     }

            // });
              

            $('#timepicker1').datetimepicker({
                format: 'LT'
            }).on('dp.change', function(e) {
               
                var returnTime = getTimeString( new Date(e.date) ); 
                $scope.admission_time = returnTime;   

                if($rootScope.dischargeSummary.admission.admission_dt=="") {
                   document.getElementById("admission_dt_error").textContent = "Value is required."; 
                } else {
                    // $rootScope.dischargeSummary.admission.admission_time = $rootScope.dischargeSummary.admission.admission_dt+" "+returnTime;
                    $rootScope.dischargeSummary.admission.admission_time = returnTime;
                    document.getElementById("admission_dt_error").textContent = "";
                }  
            });
      
            $('#timepicker2').datetimepicker({
                format: 'LT'
            }).on('dp.change', function(e) {
              
                var returnTime = getTimeString( new Date(e.date) );
                $scope.dob_time = returnTime;

                if( $rootScope.dischargeSummary.admission.dob=="" ) {
                    document.getElementById("dob_error").textContent = "Value is required."; 
                } else {
                    // $rootScope.dischargeSummary.admission.dob_time = $rootScope.dischargeSummary.admission.dob+" "+returnTime;
                    $rootScope.dischargeSummary.admission.dob_time = returnTime;
                    document.getElementById("dob_error").textContent = "";
                } 
            
            });
        });

        $("#checkPermanent").prop('disabled',true);

        function getDistricts() {
            var param = {
                account_email: authService.authentication.account_id
            };
            
            $scope.district_list     = [];
            $scope.district_id_list  = [];
            $scope.district_list2    = [];
            $scope.district_id_list2 = [];
            $scope.district_list3    = [];

            dischargeService.getDistrictList(param).then(function (response) {
                $scope.district_list3 = response;
                angular.forEach(response, function(value){
                    $scope.district_list.push(value.districtname);
                    $scope.district_id_list.push(value.id);
                });
                $scope.district_list2    = $scope.district_list;
                $scope.district_id_list2 = $scope.district_id_list;
                $rootScope.dischargeSummary.admission.permanent_address = $scope.permanent_address
                $rootScope.dischargeSummary.admission.permanent_block = $scope.permanent_block
                $rootScope.dischargeSummary.admission.permanent_village = $scope.permanent_village
                $rootScope.dischargeSummary.admission.permanent_village = $scope.permanent_district
            }, function (error) {
                //toastr.error(error);
            });
            
            dischargeService.doctorIncharge(1).then(function (response) {
                console.log('discharge Controller response',response.active_doctor_incharge);
                $scope.doctor_Inchargelist = response.active_doctor_incharge;
            }, function (error) {
                //toastr.error(error);
            });
        }
    
        function getBlocks(id, callback) {    
            var param = { 
                account_email: authService.authentication.account_id,
                id: id
            }     
            dischargeService.getBlockList(param).then(function (response) {
                callback(response);
            }, function (error) {
                //toastr.error(error);
            });
        }
    
        function getVillages(id, callback) {   
            var param = { 
                account_email: authService.authentication.account_id,
                id: id
            }
            dischargeService.getVillageList(param).then(function (response) {
                callback(response);
            }, function (error) {
                //toastr.error(error);
            });      
        }

        $rootScope.callGetBlocks = function(id) {
            $("#checkPermanent").prop('disabled', false); 
            document.getElementById("checkPermanent").checked=false;

            var get_district = ($filter('filter')($scope.district_list3, {'id':id})); 
            $rootScope.dischargeSummary.admission.present_district_id = id;
            $rootScope.dischargeSummary.admission.district_id = id;
            $rootScope.dischargeSummary.admission.present_district = get_district[0].districtname;
            
            $scope.block_list      = [];
            $scope.block_id_list   = [];
            $scope.block_list3     = [];
            $scope.village_list    = [];  
            $scope.village_list3   = [];
            $scope.village_id_list = []; 
            $scope.present_block   = "";
            $scope.present_village = "";

          //document.getElementById("checkPermanent").checked     = false;
            $rootScope.dischargeSummary.admission.present_block   = "";
            $rootScope.dischargeSummary.admission.present_village = ""; 
            $rootScope.dischargeSummary.admission.present_address = "";               
            $rootScope.dischargeSummary.admission.present_pincode = ""; 

            getBlocks(id,function returnGetBlocks(data) { 
                $scope.block_list3 = data;
                angular.forEach(data, function(value) {
                    $scope.block_list.push(value.blockname);
                    $scope.block_id_list.push(value.id);
                });  
                if ($scope.set_updatestatus_flag == true) {
                    $scope.present_block = JSON.stringify($rootScope.dischargeSummary.admission.present_block_id)
                    $scope.block_id = JSON.stringify($rootScope.dischargeSummary.admission.block_id)
                    $rootScope.callGetVillages($scope.present_block)
                }           
               
             /* $scope.permanent_district = "";
                $scope.block_list2        = [];
                $scope.block_id_list2     = [];
                $scope.permanent_block    = "";
                $scope.village_list2      = [];   
                $scope.village_id_list2   = [];  
                $scope.selected_village   = "";
                $scope.permanent_village  = "";
                $rootScope.dischargeSummary.admission.permanent_pincode = ""; */
            }); 
        }

        $rootScope.callGetVillages = function(id) {
            document.getElementById("checkPermanent").checked=false;
            var get_blocks = ($filter('filter')($scope.block_list3, {'id':id}));   
            $rootScope.dischargeSummary.admission.present_block_id = id;
            $rootScope.dischargeSummary.admission.block_id = id;                                  
            $rootScope.dischargeSummary.admission.present_block = get_blocks[0].blockname;
            
            $scope.village_list     = [];
            $scope.village_pin_list = [];
            $scope.village_list3    = [];
          
            $scope.present_village = "";
            $rootScope.dischargeSummary.admission.present_village = "";  
            $rootScope.dischargeSummary.admission.present_address = "";
            $rootScope.dischargeSummary.admission.present_pincode = "";

            getVillages(id,function returnGetVillages(data) { 
                $scope.village_list3 = data;
                angular.forEach(data, function(value) {
                    $scope.village_list.push(value.villagename);
                    // console.log('village_list',$scope.village_list);
                    $scope.village_pin_list.push(value.pincode);
                });
               
                if($scope.set_updatestatus_flag == true){
                    for(var i=0; i<$scope.village_list3.length; i++){
                        if($scope.village_list3[i].id == JSON.stringify($rootScope.dischargeSummary.admission.present_village_id)){
                            $scope.village_list3[i].id == JSON.stringify($rootScope.dischargeSummary.admission.village_id) 
                            console.log( $scope.village_list3[i].id == JSON.stringify($rootScope.dischargeSummary.admission.village_id) );
                            $scope.present_village = i
                            $rootScope.getPinCode( $scope.present_village)
                        }
                    }
                    // $scope.present_village = JSON.stringify($rootScope.dischargeSummary.admission.present_village_id)
                    // $scope.village_id = JSON.stringify($rootScope.dischargeSummary.admission.village_id)
                    // $rootScope.getPinCode( $scope.present_village)
                   
                    // $rootScope.dischargeSummary.admission.present_village = $scope.present_village
                   
                    $rootScope.dischargeSummary.admission.present_address = $scope.present_address_response
                } else {
                    $rootScope.dischargeSummary.admission.present_village = $scope.village_list[0]
                }
            });    
        }

        $rootScope.callGetBlocks2 = function(id){   
            document.getElementById("checkPermanent").checked=false;
            var get_district = ($filter('filter')($scope.district_list3, {'id':id}));   
            $rootScope.dischargeSummary.admission.permanent_district_id = id;                      
            $rootScope.dischargeSummary.admission.permanent_district = get_district[0].districtname;

            $scope.block_list2    = [];
            $scope.block_id_list2 = [];
            $scope.block_list4    = [];

            $scope.village_list2 = [];  
            $scope.village_list4 = [];
            $scope.village_id_list2 = []; 
          
            $scope.permanent_block   = "";
            $scope.permanent_village = "";
            $rootScope.dischargeSummary.admission.permanent_block   = "";
            $rootScope.dischargeSummary.admission.permanent_village = "";
            $rootScope.dischargeSummary.admission.permanent_address = "";
            $rootScope.dischargeSummary.admission.permanent_pincode = "";
           
            getBlocks(id,function returnGetBlocks2(data){ 
                $scope.block_list4 = data;
                angular.forEach(data, function(value){
                    $scope.block_list2.push(value.blockname);
                    $scope.block_id_list2.push(value.id);
                });

                if ($scope.set_updatestatus_flag_permanent == true) {
                    $scope.permanent_block = JSON.stringify($rootScope.dischargeSummary.admission.permanent_block_id)
                    $rootScope.callGetVillages2($scope.permanent_block)
                }
            
            }); 
        }

        $rootScope.callGetVillages2 = function(id) {
            var get_blocks = ($filter('filter')($scope.block_list4, {'id':id})); 
            $rootScope.dischargeSummary.admission.permanent_block_id = id;  
            $rootScope.dischargeSummary.admission.permanent_block = get_blocks[0].blockname;

            $scope.village_list2     = [];
            $scope.village_pin_list2 = [];
            $scope.village_list4     = [];
           
            $scope.permanent_village = "";
            $rootScope.dischargeSummary.admission.permanent_village = "";
            $rootScope.dischargeSummary.admission.permanent_address = "";
            $rootScope.dischargeSummary.admission.permanent_pincode = "";

            getVillages(id,function returnGetVillages2(data){ 
                $scope.village_list4 = data;             
                angular.forEach(data, function(value){
                    $scope.village_list2.push(value.villagename);
                    $scope.village_pin_list2.push(value.pincode);
                });           
                if($scope.set_updatestatus_flag_permanent == true){
                    for(var i=0; i<$scope.village_list4.length; i++){
                        if($scope.village_list4[i].id == JSON.stringify($rootScope.dischargeSummary.admission.permanent_village_id)){
                            $scope.permanent_village = i
                            $rootScope.getPinCode2($scope.permanent_village)
                        }
                    }
                    $rootScope.dischargeSummary.admission.permanent_address = $scope.permanent_address_response
                } else {
                    $rootScope.dischargeSummary.admission.permanent_village = $scope.village_list2[0]
                }
            });    
        }

        $rootScope.getPinCode = function(index) {
            // alert()
            document.getElementById("checkPermanent").checked=false;
            var get_village = ($filter('filter')($scope.village_list3, {'villagename':$scope.village_list[index]}));
            console.log('get_village::',get_village);
            // $rootScope.dischargeSummary.admission.village_id      = get_village[0].id+""; 
            $rootScope.dischargeSummary.admission.present_village_id      = get_village[0].id+""; 
            $rootScope.dischargeSummary.admission.village_id      = get_village[0].id+"";
            console.log('$rootScope.dischargeSummary.admission.village_id::',$rootScope.dischargeSummary.admission.village_id); 
            $rootScope.dischargeSummary.admission.present_village = $scope.village_list[index];
            $scope.set_updatestatus_flag = false
            $scope.getFieldStaffid()
            // console.log('$scope.village_pin_list[index]',$scope.village_pin_list[index]);
            // $rootScope.dischargeSummary.admission.present_pincode = $scope.village_pin_list[index];
        }

        // $rootScope.getPinCode_withid = function(id) {
        //     document.getElementById("checkPermanent").checked=false;
        //     $rootScope.dischargeSummary.admission.village_id      = id; 
        //     console.log($rootScope.dischargeSummary.admission.present_village,"$rootScope.dischargeSummary.admission.present_village")
        //     // console.log('$scope.village_pin_list[index]',$scope.village_pin_list[index]);
        //     // $rootScope.dischargeSummary.admission.present_pincode = $scope.village_pin_list[index];
        // }

        $rootScope.getPinCode2 = function(index) {
            // alert(1)
            var get_village = ($filter('filter')($scope.village_list4, {'villagename':$scope.village_list2[index]}));
            console.log('get_village::',get_village);
            $rootScope.dischargeSummary.admission.village_id      = get_village[0].id+"";
            console.log('$rootScope.dischargeSummary.admission.village_id::',$rootScope.dischargeSummary.admission.village_id);  
            $rootScope.dischargeSummary.admission.permanent_village_id      = get_village[0].id+""; 
          $rootScope.dischargeSummary.admission.permanent_village = $scope.village_list2[index];
          $rootScope.dischargeSummary.admission.permanent_pincode = $scope.village_pin_list2[index];
          $scope.set_updatestatus_flag_permanent = false
        }
        
        getDistricts();
      //getBlocks();
      //getVillages();

      $scope.clear_permanentaddress = function(){
        $scope.permanent_district = "";
        $scope.block_list2        = [];
        $scope.block_list4        = [];
        $scope.block_id_list2     = [];
        $scope.permanent_block    = "";
        $scope.village_list2      = [];   
        $scope.village_list4      = []; 
        $scope.village_id_list2   = [];  
        $scope.selected_village   = "";
        $scope.permanent_village  = "";

        $rootScope.dischargeSummary.admission.permanent_district = "";  
        $rootScope.dischargeSummary.admission.permanent_block    = "";
        $rootScope.dischargeSummary.admission.permanent_village  = "";
        $rootScope.dischargeSummary.admission.permanent_pincode  = "";  
        $rootScope.dischargeSummary.admission.permanent_address  = ""; 
      }

        $rootScope.loadCurrentAddress = function(value) { 
            console.log('value',value); 
            var checked;
            if(value=='click1') {
                if(document.getElementById("checkPermanent").checked==false) {
                    checked=false;
                } else {
                    checked=true;
                }
            } else if(value=='click2') {         
                if(document.getElementById("checkPermanent").checked == false){
                    checked=true;
                    document.getElementById("checkPermanent").checked = true;
                } else {
                    checked=false;
                }
            }

            if(checked==true) {

                $scope.permanent_district = $scope.present_district;
                $scope.block_list2        = $scope.block_list;
                $scope.block_list4        = $scope.block_list;
                $scope.block_id_list2     = $scope.block_id_list;
                $scope.permanent_block    = $scope.present_block;
                $scope.village_list2      = $scope.village_list;
                $scope.village_list4      = $scope.village_list;     
                $scope.village_id_list2   = $scope.village_id_list;

                $rootScope.dischargeSummary.admission.permanent_district = $rootScope.dischargeSummary.admission.present_district;  
                $rootScope.dischargeSummary.admission.permanent_block    = $rootScope.dischargeSummary.admission.present_block;
                $rootScope.dischargeSummary.admission.permanent_village  = $rootScope.dischargeSummary.admission.present_village;
                $rootScope.dischargeSummary.admission.permanent_pincode  = $rootScope.dischargeSummary.admission.present_pincode;  
                $rootScope.dischargeSummary.admission.permanent_address  = $rootScope.dischargeSummary.admission.present_address; 
                
                if($scope.present_village) {
                    if($scope.permanent_village==undefined || $scope.permanent_village=="") {
                       $scope.permanent_village = $scope.present_village
                    } else {      
                       $scope.permanent_village = $scope.present_village
                       $scope.permanent_village  = $scope.present_village
                    }
                } else{
                    $scope.permanent_village = "";
                    $scope.selected_village  = "";
                    $scope.permanent_village = ""
                }
                   
            } else {
                $scope.permanent_district = "";
                $scope.block_list2        = [];
                $scope.block_list4        = [];
                $scope.block_id_list2     = [];
                $scope.permanent_block    = "";
                $scope.village_list2      = [];   
                $scope.village_list4      = []; 
                $scope.village_id_list2   = [];  
                $scope.selected_village   = "";
                $scope.permanent_village  = "";

                $rootScope.dischargeSummary.admission.permanent_district = "";  
                $rootScope.dischargeSummary.admission.permanent_block    = "";
                $rootScope.dischargeSummary.admission.permanent_village  = "";
                $rootScope.dischargeSummary.admission.permanent_pincode  = "";  
                $rootScope.dischargeSummary.admission.permanent_address  = ""; 
            }
        }


    $rootScope.showFooter = false;
    $rootScope.byRange = function (date1,val) {
        
        var date = $filter('date')(date1, "yyyy-MM-dd");

        if ( val == 'admission' ) {
            $rootScope.dischargeSummary.admission.admission_dt = date;
             
        } else if ( val == 'dob' ) {
            $rootScope.dischargeSummary.admission.dob = date;
            
        } else if ( val == 'lmp' ) {
            $rootScope.dischargeSummary.admission.lmp = date;
            var returnDate = addDays(date1, 281);
            $rootScope.dischargeSummary.admission.edd = $filter('date')(returnDate, "yyyy-MM-dd");
            $rootScope.date3 = $filter('date')(returnDate, "dd-MM-yyyy");
             
        } else if ( val == 'discharge_date' ) {
            $rootScope.dischargeEntry.discharge_dt = date;
               
        } else if ( val == 'dicharge_admission_date' ) {
            $rootScope.dischargeEntry.admission_dt = date;
   
        }
        //return date;
    }

    function stringDate(date){
    var day   = date.getDate();
    var month = date.getMonth()+1;
    var year  = date.getFullYear();
      
     return "" + day + "/" + month + "/" + year;
  }
  
  function parseDate(str) {
    var mdy = str.split('/');
     return new Date( mdy[2], mdy[1], mdy[0] );
  }
    
  function datediff(first, second) {
     return Math.round((second-first)/(1000*60*60*24));
  }
  
  $scope.vaccineDate = function(value){
    var date1 = new Date();
    var date2 = value;
    var days  = datediff(parseDate(stringDate(date2)), parseDate(stringDate(date1)));
    $scope.vaccineReminder(days);       
  }


    $rootScope.time24Hrs = function (date,val) {
        var dateTime = new Date(date);
        var todayDate = new Date();
        var date = $filter('date')(todayDate , "yyyy-MM-dd");
        var hours = dateTime.getHours();
        var minutes = dateTime.getMinutes();
        var seconds = dateTime.getSeconds();
            
        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        if (val == 'admission') {
            $scope.dischargeSummary.admission.admission_time =date+"T"+ hours + ":" + minutes + ":" + seconds+"Z";
        } else if (val == 'discharge_time') {
            $rootScope.dischargeEntry.discharge_time = date + "T" + hours + ":" + minutes + ":" + seconds + "Z";
        }
        //return hours + ":" + minutes + ":" + seconds;
    }

    $scope.valuenewborn = "";
    $scope.newBorn_age = true;
    $scope.newborn_age= function(value){
        $scope.valuenewborn = value;
        console.log('value',value)
        if($rootScope.dischargeSummary.admission.admission_dt ==""){
            alert("Newborn's Age not corresponding with Date of Birth and Admission Date : Please Check");
            $rootScope.dischargeSummary.admission.newborn_age = "";
        }else if(value != $scope.Diffdays){
            alert("Newborn's Age not corresponding with Date of Birth and Admission Date : Please Check");
            $rootScope.dischargeSummary.admission.newborn_age = "";
        }else if(value == $scope.Diffdays){
            if(Math.abs(diffDays) == 0){
                $rootScope.dischargeSummary.admission.newborn_age = "< 24 hr"; 
                $scope.newbornvalue = 0;
                $scope.newBorn_age = false;
                document.querySelector('#newborn_Boxsize').style.width = '70px';
             }else if(Math.abs(diffDays) > 28){
                $rootScope.dischargeSummary.admission.newborn_age = ">"+Math.abs(diffDays) +" "+"days"; 
                $scope.newbornvalue = 29;
                $scope.newBorn_age = "true"
                document.querySelector('#newborn_Boxsize').style.width = '120px';
             }else if(Math.abs(diffDays) == 1){
                $rootScope.dischargeSummary.admission.newborn_age = Math.abs(diffDays) +" "+"day";
                $scope.newbornvalue = 1
                $scope.newBorn_age = "true"
                document.querySelector('#newborn_Boxsize').style.width = '120px';
             }else{
                $rootScope.dischargeSummary.admission.newborn_age = Math.abs(diffDays) +" "+"days"
                $scope.newbornvalue = Math.abs(diffDays);
                $scope.newBorn_age = "true"
                document.querySelector('#newborn_Boxsize').style.width = '120px';
             }
        }else{

       console.log('value',value);
        if(value == 0){
            $scope.newBorn_age = false;
            document.querySelector('#newborn_Boxsize').style.width = '70px';
        } else { 
            if($rootScope.dischargeSummary.admission.admission_dt!="") {
                $scope.newBorn_age = true;
                document.querySelector('#newborn_Boxsize').style.width = '120px';
            } else {
                if($rootScope.dischargeSummary.admission.newborn_age != 0){
                   $scope.newBorn_age = true;
                   document.querySelector('#newborn_Boxsize').style.width = '120px';
                } else {
                    alert("Alert :\n    Newborn's Age not corresponding with Date of Birth and Admission Date : Please Check");
                    $rootScope.dischargeSummary.admission.newborn_age = "";
                }
            }
        }
    }
    }
    $scope.dob_time = "";
    $scope.sncu_id_default = "SNCU/KCP/"+new Date().getFullYear()+"/";

    $rootScope.dischargeSummary = {
       admission: {}
    };

    $scope.addDays = function(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + parseInt(days));
      return result;
    }

        var year = new Date().getFullYear() - 10;
        var today = new Date().getDate();
        var month = new Date().getMonth();
    $scope.datepickerLmp = {
        opened:{appointment_date1:false, appointment_date2:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
            formatYear: 'yyyy',
            minDate: new Date(year, month , today),
            maxDate: new Date(),
        }
    };
    $scope.datepickLMP = function(e){
        $scope.dischargeSummary.admission.lmp = moment(e).format('YYYY-MM-DD');
        var returnDate = $scope.addDays(e, 281);
            if( returnDate.getDate()<10 ) {
                getDate = "0"+returnDate.getDate();
            } else {
                getDate = returnDate.getDate();
            }
    
            if( (returnDate.getMonth()+1)<10 ) {
                getMonth = "0"+(returnDate.getMonth()+1);
            } else {
                getMonth = returnDate.getMonth()+1;
            }
    
            getYear = returnDate.getFullYear();
            // document.getElementById('eddValue').setAttribute('value', );
            $scope.dischargeSummary.admission.edd = getYear+"-"+getMonth+"-"+getDate;
            console.log('$scope.dischargeSummary.admission.edd',$scope.dischargeSummary.admission.edd);
    }
    


    $rootScope.dischargeSummary.admission = {
        account_email: authService.authentication.account_id,
        sncu_id: "",
        mr_number: "",
        admission_dt: "",
        admission_time: "",
        admission_type: "",
        mcts_id: "",
        mother_name: "",
        father_name: "",
        sur_name: "",
        doctor_incharge: "",
        delivery_place: "",
        transport_mode: "",
        maturity: "",
        admissionindication: "",
        multiple_indication: "",
        a: "",
        b: "",
        c: "",
        d: "",
        cried_immediate: "",
        wt_at_birth: "",
        wt_on_admission: "",
        gestational_age: "",
        vitamink: "",
        breastfeed: "",
        apgar1: "",
        apgar5: "",
        doctor: authService.authentication.account_id,
        doctor_id: authService.authentication.doctor_id,
        patient: "",
        religion: "",
        dob: "",
        dob_time: "",
        newborn_age: "",
        gender: "",
        resuscitation: "",
            
        present_district: "",
        present_block: "",
        present_subcenter: "",
        present_address: "",
        present_pincode: "",
        permanent_block: "",
        permanent_district: "",
        permanent_subcenter: "",
        permanent_village: "",
        permanent_address: "",
        present_village: "",
        permanent_pincode: "",
        // district_id: "",
        // block_id: "",
        // village_id: "",
            
        first_contact_name: "",
        first_contact_phone: "",
        first_contact_relation: "",
        second_contact_name: "",
        second_contact_phone: "",
        second_contact_relation: "",
        third_contact_name: "",
        third_contact_phone: "",
        third_contact_relation: "",
        temperature: "",
        heart_rate: "",
        apnea: "",
        RR: "",
        BP: "",
        grunting: "",
        chest_drawing: "",
        head_circum: "",
        length: "",
        color: "",
        CRT: "",
        skin_pinch: "",
        cry: "",
        meconium_stained_cord: "",
        tone: "",
        convulsions: "",
        jaundice: "",
        bleeding: "",
        bulging_anterior: "",
        taking_breast_Feed: "",
        sucking: "",
        attachment: "",
        umbilicus: "",
        skin_pustules: "",
        blood_sugar: "",
        oxygen_saturation: "",
        congenital_malformation: "", 
        mother_age: "",
        mother_wt: "",
        age_at_marriage: "",
        consanguity: "",
        lmp: "",
        edd: "",
        birth_spacing: "",
        gestational_Weeks: "",
        gravida: "",
        para: "",
        live_birth: "",
        abortion: "",
        anc_visit: "",
        tt_doses: "",
        hb: "",
        blood_group: "",
        past_pih: "",
        drug: "",
        radiation: "",
        illness: "",
        aph: "",
        gdm: "",
        vdrl: "",
        hbsag: "",
        hiv_testing: "",
        amnioticfluid_vol: "",
        antenatal_steroid: "",
        type_of_steroids:"",
        no_of_doses:"",
        time_between_dose_delivery:"",
        ho_fever: "",
        foul_smelling_discharge: "",
        uterine_tenderness: "",
        leaking_pv: "",
        pih: "",
        pph: "",
        amnioticfluid: "",
        presentation: "",
        labour: "",
        course_of_labour: "",
        eo_fetal_distress: "",
        delivery_type: "",
        indication_caesarean: "",
        delivery_attended_by: "",
        thyroid: "" ,
        general_condition : ""        
    }

 /* $rootScope.dischargeSummary.admission = {
        account_email: authService.authentication.account_id,
        sncu_id: "SNCU/KCP/2019/12380",
        mr_number:"MR8721",
        admission_dt: "",
        admission_time: "",
        admission_type: "",
        mcts_id: "",
        mother_name: "",
        father_name: "",
        sur_name: "",
        doctor_incharge: "",
        delivery_place: "",
        transport_mode: "",
        maturity: "",
        admissionindication: "",
        multiple_indication: "",
        a: "",
        b: "",
        c: "",
        d: "",
        cried_immediate: "",
        wt_at_birth: "",
        gestational_age: "",
        vitamink: "",
        breastfeed: "",
        apgar1: "",
        apgar5: "",
        doctor: authService.authentication.account_id,
        patient: "",
        religion: "",
        dob: "",
        newborn_age: "",
        gender: "",
        resuscitation: "",
        pincode1: "",
        pincode2: "",
        present_block: "",
        present_subcenter: "",
        present_address: "",
        permanent_block: "",
        permanent_subcenter: "",
        permanent_village: "",
        permanent_address: "",
        present_village: "",
        first_contact_name: "",
        first_contact_phone: "",
        first_contact_relation: "",
        second_contact_name: "",
        second_contact_phone: "",
        second_contact_relation: "",
        third_contact_name: "",
        third_contact_phone: "",
        third_contact_relation: "",

        temperature: 0.0,
        heart_rate: "",
        apnea: "",
        RR: "",
        BP: "",
        grunting: "",
        chest_drawing: "",
        head_circum: "",
        length: "",
        color: "",
        CRT: "",
        skin_pinch: "",
        cry: "",
        meconium_stained_cord: "",
        tone: "",
        convulsions: "",
        jaundice: "",
        bleeding: "",
        bulging_anterior: "",
        taking_breast_Feed: "",
        sucking: "",
        attachment: "",
        umbilicus: "",
        skin_pustules: "",
        blood_sugar: 0.0,
        oxygen_saturation: 0.0,
        congenital_malformation: "",

        mother_age: "",
        mother_wt: "",
        age_at_marriage: "",
        consanguity: "",
        lmp: "",
        edd: "",
        birth_spacing: "",
        gestational_Weeks: "",
        gravida: "",
        para: "",
        live_birth: "",
        abortion: "",
        anc_visit: "",
        tt_doses: "",
        hb: "",
        blood_group: "",
        past_pih: "",
        drug: "",
        radiation: "",
        illness: "",
        aph: "",
        gdm: "",
        vdrl: "",
        hbsag: "",
        hiv_testing: "",
        amnioticfluid_vol: "",
        antenatal_steroid: "",
        ho_fever: "",
        foul_smelling_discharge: "",
        uterine_tenderness: "",
        leaking_pv: "",
        pih: "",
        pph: "",
        amnioticfluid: "",
        presentation: "",
        labour: "",
        course_of_labour: "",
        eo_fetal_distress: "",
        delivery_type: "",
        indication_caesarean: "",
        delivery_attended_by: "",
        thyroid: ""
    }*/

 /* $rootScope.dischargeSummary.admission = {
        admission_dt: "",
        mcts_id: "",
        cried_immediate: "",
        wt_at_birth: "",
        gestational_age: "",
        vitamink: "",
        multiple_indication: "",
        a: "",
        b: "",
        c: "",
        d: "",
        breastfeed: "",
        admissionindication: "",
        apgar1: "",
        apgar5: "",
        patient: "",
        religion: "",
        maturity: "",
        admission_time: "",
        admission_type: "",
        mother_name: "",
        father_name: "",
        sur_name: "",
        dob: "",
        newborn_age: "",
        gender: "",
        doctor_incharge: "",
        delivery_place: "",
        transport_mode: "",
        doctor: "rx3@rxcarenet.org",
    };

    $scope.dischargeSummary.babyinfo = {
        temperature: "",
        heart_rate: "",
        apnea: "",
        RR: "",
        BP: "",
        grunting: "",
        chest_drawing: "",
        head_circum: "",
        length: "",
        color: "",
        CRT: "",
        skin_pinch: "",
        cry: "",
        meconium_stained_cord: "",
        tone: "",
        convulsions: "",
        jaundice: "",
        bleeding: "",
        bulging_anterior: "",
        taking_breast_Feed: "",
        sucking: "",
        attachment: "",
        umbilicus: "",
        skin_pustules: "",
        congenital_malformation: "",
        blood_sugar: "",
        oxygen_saturation: "",           
    };

    $scope.dischargeSummary.motherinfo = {
        mother_age: "",
        mother_wt: "",
        age_at_marriage: "",
        consanguity: "",
        LMP: "",
        EDD: "",
        birth_spacing: "",
        gestational_Weeks: "",
        gravida: "",
        para: "",
        live_birth: "",
        abortion: "",
        anc_visit: "",
        tt_doses: "",
        hb: "",
        blood_group: "",
        past_pih: "",
        drug: "",
        radiation: "",
        illness: "",
        aph: "",
        gdm: "",
        thyroid: "",
        vdrl: "",
        hbsag: "",
        hiv_testing: "",
        amnioticfluid_vol: "",
        antenatal_steroid: "",
        ho_fever: "",
        foul_smelling_discharge: "",
        uterine_tenderness: "",
        leaking_pv: "",
        pih: "",
        pph: "",
        amnioticfluid: "",
        presentation: "",
        labour: "",
        course_of_labour: "",
        eo_fetal_distress: "",
        delivery_type: "",
        indication_caesarean: "",
        delivery_attended_by: "",
    };

    $scope.dischargeSummary.address = {
        present_subcenter: "",
        present_address: "",
        permanent_subcenter: "",
        permanent_address: "",
        present_block: "",
        present_village: "",
        permanent_block: "",
        permanent_village: ""
    };

    $scope.dischargeSummary.contact = {
        first_contact_name: "",
        first_contact_phone: "",
        first_contact_relation: "",
        second_contact_name: "",
        second_contact_phone: "",
        second_contact_relation: "",
        third_contact_name: "",
        third_contact_phone: "",
        third_contact_relation: ""
    };
*/

    $rootScope.removeErrorLabel = function(id, value) {

       if( value!="" ) {
            document.getElementById(id+"_error").textContent="";  
       } else {
            document.getElementById(id+"_error").textContent="Value is required.";  
       }
    }    

    $scope.checkAllRequired_Admission = function () {
            var i = 0;
            if (  $rootScope.dischargeSummary.admission.sncu_id == "" ) { document.getElementById("sncu_id_error").textContent="Value is required."; i++;}  
            if (  $rootScope.dischargeSummary.admission.admission_dt == "" ) { document.getElementById("admission_dt_error").textContent="Value is required."; i++;} 
            if (  $rootScope.dischargeSummary.admission.admission_time == "" ) { document.getElementById("admission_dt_error").textContent="Value is required."; i++;}
           
            if (  $rootScope.dischargeSummary.admission.admission_type == "" ) { document.getElementById("admission_type_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.mother_name == "" ) { document.getElementById("mother_name_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.father_name == "" ) { document.getElementById("father_name_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.sur_name == "" ) { document.getElementById("sur_name_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.doctor_incharge == "" ) { document.getElementById("doctor_incharge_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.delivery_place == "" ) { document.getElementById("delivery_place_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.transport_mode == "" ) { document.getElementById("transport_mode_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.wt_on_admission == "" ){ document.getElementById("wt_admission_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.maturity == "" ){ document.getElementById("maturity_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.admissionindication == "" ){ document.getElementById("admissionindication_error").textContent="Value is required."; i++;} 
            if (  $rootScope.dischargeSummary.admission.gestational_age == "" ) { document.getElementById("gestational_age_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.breastfeed == "" ) { document.getElementById("breastfeed_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.religion == "" ) { document.getElementById("religion_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.dob == "" ) { document.getElementById("dob_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.newborn_age == "" ) { document.getElementById("newborn_age_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.gender == "" ) { document.getElementById("gender_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.present_district == "" ) { document.getElementById("present_district_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.present_block == "" ) { document.getElementById("present_block_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.present_address == "" ) { document.getElementById("present_address_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.present_village == "" ) { document.getElementById("present_village_error").textContent="Value is required."; i++;}        
            if (  $rootScope.dischargeSummary.admission.permanent_district == "" || $rootScope.dischargeSummary.admission.permanent_district == undefined  ) { document.getElementById("permanent_district_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.permanent_block == "" || $rootScope.dischargeSummary.admission.permanent_block == undefined ) { document.getElementById("permanent_block_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.permanent_address == "" || $rootScope.dischargeSummary.admission.permanent_address == undefined  ) { document.getElementById("permanent_address_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.permanent_village == ""  || $rootScope.dischargeSummary.admission.permanent_village == undefined  ) { document.getElementById("permanent_village_error").textContent="Value is required."; i++;}        
            if (  $rootScope.dischargeSummary.admission.first_contact_name == "" ) { document.getElementById("first_box_contact_name").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.first_contact_phone == "" ) { document.getElementById("first_contact_phone1_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.first_contact_relation == "" ) { document.getElementById("first_contact_relation1_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.congenital_malformation == "" ) { document.getElementById("congenital_malformation_error").textContent="Value is required."; i++;}    
            if (  $rootScope.dischargeSummary.admission.mother_age == "" ) { document.getElementById("mother_age_error").textContent="Enter Mother's Age."; i++;}
            if (  $rootScope.dischargeSummary.admission.age_at_marriage == "" ) { document.getElementById("age_at_marriage_error").textContent="Enter Age at Marriage."; i++;}
            if (  $rootScope.dischargeSummary.admission.birth_spacing == "" ) { document.getElementById("birth_spacing_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.wt_on_admission == "" ) { document.getElementById("wt_admission_error").textContent="Enter Weight."; i++;}
            if (  $rootScope.dischargeSummary.admission.delivery_attended_by == "" ) { document.getElementById("delivery_attended_by_error").textContent="Value is required."; i++;}
            if (  $rootScope.dischargeSummary.admission.mother_wt == "" ) { document.getElementById("mother_wt_error").textContent="Enter Weight."; i++;}
           
            if( i==0 ) {
                //alert('All required fields filled.');
                $scope.dischargeAdmission();
                $scope.show = true
            } else {
                console.log('i',i)
               alert('Please fill all required fields..');             
            }
    }

    $scope.dischargeAdmissionNull = function() {

        $scope.block_list         = [];
        $scope.block_id_list      = [];
        $scope.block_list3        = [];

        $scope.block_list2        = [];
        $scope.block_id_list2     = [];
        $scope.block_list4        = [];
           
        $scope.village_list       = [];  
        $scope.village_list3      = [];
        $scope.village_id_list    = []; 

        $scope.village_list2      = [];  
        $scope.village_list4      = [];
        $scope.village_id_list2   = []; 
         
        $scope.present_district   = "";
        $scope.permanent_district = "";
        $scope.present_block      = "";
        $scope.present_village    = "";
        $scope.permanent_block    = "";
        $scope.permanent_village  = "";
        $scope.selected_village   = "";

        document.getElementById("checkPermanent").checked = false; 

        $scope.dischargeSummary = {
           admission: {},
        };

        $rootScope.dischargeSummary.admission = {
            
            account_email:  authService.authentication.account_id,
            sncu_id: "SNCU/KCP/2019/12380",
            mr_number: "",
            admission_dt: "",
            admission_time: "",
            admission_type: "",
            mcts_id: "",
            mother_name: "",
            father_name: "",
            sur_name: "",
            doctor_incharge: "",
            delivery_place: "",
            transport_mode: "",
            maturity: "",
            admissionindication: "",
            multiple_indication: "",
            a: "",
            b: "",
            c: "",
            d: "",
            cried_immediate: "",
            wt_at_birth: "",
            wt_on_admission: "",
            gestational_age: "",
            vitamink: "",
            breastfeed: "",
            apgar1: "",
            apgar5: "",
            doctor_id: authService.authentication.doctor_id,
            patient: "",
            religion: "",
            dob: "",
            dob_time: "",
            newborn_age: "",
            gender: "",
            resuscitation: "",
                
            present_district: "",
            present_block: "",
            present_subcenter: "",
            present_address: "",
            present_pincode: "",
            permanent_block: "",
            permanent_district: "",
            permanent_subcenter: "",
            permanent_village: "",
            permanent_address: "",
            present_village: "",
            permanent_pincode: "",
            // district_id: "",
            // block_id: "",
            // village_id: "",
                
            first_contact_name: "",
            first_contact_phone: "",
            first_contact_relation: "",
            second_contact_name: "",
            second_contact_phone: "",
            second_contact_relation: "",
            third_contact_name: "",
            third_contact_phone: "",
            third_contact_relation: "",
            temperature: "",
            heart_rate: "",
            apnea: "",
            RR: "",
            BP: "",
            grunting: "",
            chest_drawing: "",
            head_circum: "",
            length: "",
            color: "",
            CRT: "",
            skin_pinch: "",
            cry: "",
            meconium_stained_cord: "",
            tone: "",
            convulsions: "",
            jaundice: "",
            bleeding: "",
            bulging_anterior: "",
            taking_breast_Feed: "",
            sucking: "",
            attachment: "",
            umbilicus: "",
            skin_pustules: "",
            blood_sugar: "",
            oxygen_saturation: "",
            congenital_malformation: "",
                
            mother_age: "",
            mother_wt: "",
            age_at_marriage: "",
            consanguity: "",
            lmp: "",
            edd: "",
            birth_spacing: "",
            gestational_Weeks: "",
            gravida: "",
            para: "",
            live_birth: "",
            abortion: "",
            anc_visit: "",
            tt_doses: "",
            hb: "",
            blood_group: "",
            past_pih: "",
            drug: "",
            radiation: "",
            illness: "",
            aph: "",
            gdm: "",
            vdrl: "",
            hbsag: "",
            hiv_testing: "",
            amnioticfluid_vol: "",
            antenatal_steroid: "",
            ho_fever: "",
            foul_smelling_discharge: "",
            uterine_tenderness: "",
            leaking_pv: "",
            pih: "",
            pph: "",
            amnioticfluid: "",
            presentation: "",
            labour: "",
            course_of_labour: "",
            eo_fetal_distress: "",
            delivery_type: "",
            indication_caesarean: "",
            delivery_attended_by: "",
            thyroid: ""  
        };           
    }; 

    $scope.sncu = function(data){
        if(isNaN(data)){
            $rootScope.dischargeSummary.admission.sncu_id == ""
            document.getElementById('sncu_id').value = "";
        }
    }

    $scope.dischargeAdmission = function () {
        if ($rootScope.admissionStatus != "update") {
            $rootScope.admissionStatus = 'new';
        }

            if($scope.sncu_id_default) {
                // if($rootScope.admissionStatus == "update"){
                //     $rootScope.dischargeSummary.admission.sncu_id = parseInt($rootScope.dischargeSummary.admission.sncu_id)
                // }
                if(!isNaN($rootScope.dischargeSummary.admission.sncu_id)){
                    $rootScope.dischargeSummary.admission.sncu_id = $scope.sncu_id_default+$rootScope.dischargeSummary.admission.sncu_id;
                }else{
                    $rootScope.dischargeSummary.admission.sncu_id = "";
                }  
            }
            var requestPayload = $rootScope.dischargeSummary.admission;
            // requestPayload.general_condition = null 
    
       if( $rootScope.admissionStatus == "new" ) {
          //$location.path('/admissionList');
          $scope.show = true
            dischargeService.newDischargeAdmission( requestPayload ).then(function (response) {
                $scope.show = false
                if(response.success == 0){
                    $scope.dischargeSummary.admission.sncu_id = '';
                    toastr.error(response.message);
                    $scope.show = true
                }else{
                   toastr.success("Successfully saved.");
                   $scope.show = true
                if(response) {
                //location.reload(true);
                  $location.path('/admissionList');
                }
            }
            }, function (error) {
              //toastr.error(error);
            });

        } else if( $rootScope.admissionStatus == "update" ) {
            console.log('requestPayload',requestPayload);
            requestPayload.account_email = authService.authentication.account_id;
            $scope.show = false
            dischargeService.updateDischargeAdmission( requestPayload ).then(function (response) {
                $scope.show = true
                toastr.success(response.message);
                $location.path('/admissionList');
            }, function (error) {
              //toastr.error(error);
            });  
        }
    };

    $scope.multi_indication1 = true;
    $scope.multi_indicate1 = function(value) {
        $scope.multi_indication1 = value ? false : true;
    }
  

    $rootScope.drugInput_hide = true;
    $scope.drugBoxClick = function (value) {

        if( value == true ) {
            $rootScope.drugInput_hide = false;
        } else {
            $rootScope.drugInput_hide = true;
        }
    }

    $rootScope.referForm_hide = true;
    $scope.referFormShow = function (value) {
        if(value=='outborn1') {
            $rootScope.referForm_hide = false;
        } else {
            $rootScope.referForm_hide= true;
        }
    }
    
    $rootScope.steroid_hide = true;
    $scope.show_steroids = function (value) {
        if(value=='yes') {
            $rootScope.steroid_hide = false;
        } else {
            $rootScope.steroid_hide = true;
            $scope.dischargeSummary.admission.type_of_steroids = null
            // $scope.dischargeSummary.admission.types_of_steriods = null
            $scope.dischargeSummary.admission.no_of_doses = null
        }
    }

    $rootScope.getAdmissionDetails = function(sncu_id) {
        var param = {
            account_email: authService.authentication.account_id,
            sncu_id: sncu_id,
            doctor_id: authService.authentication.doctor_id
        }
        dischargeService.viewAdmissionDetails(param).then(function (response) {
           $rootScope.admissionStatus = "update";
           $scope.set_updatestatus_flag = true
           $scope.set_updatestatus_flag_permanent = true
           $rootScope.dischargeSummary.admission = response[0];
           if($rootScope.dischargeSummary.admission.antenatal_steroid=="yes"){
            $scope.show_steroids("yes")
            $scope.dischargeSummary.admission.type_of_steroids = response[0].type_of_steroids
            $scope.dischargeSummary.admission.no_of_doses = response[0].no_of_doses+""
           }else{
            $scope.dischargeSummary.admission.type_of_steroids = null
           }
           if($rootScope.dischargeSummary.admission.drug==true){
            $scope.drugBoxClick(true)
            $scope.dischargeSummary.admission.drug_name = response[0].drug_name
           }
           if($rootScope.dischargeSummary.admission.RR!=''){
            $rootScope.dischargeSummary.admission.RR = response[0].rr
           }
           if($rootScope.dischargeSummary.admission.BP!=''){
            $rootScope.dischargeSummary.admission.BP = response[0].bp
           }
           if($rootScope.dischargeSummary.admission.crt == true){
            $rootScope.dischargeSummary.admission.CRT = true
           }
           if($rootScope.dischargeSummary.admission.taking_breast_feed == true){
            $rootScope.dischargeSummary.admission.taking_breast_Feed = true
           }
           $rootScope.dischargeSummary.admission.newborn_age = response[0].newborn_age

           $scope.present_address_response = $rootScope.dischargeSummary.admission.present_address
           $scope.present_district = JSON.stringify($rootScope.dischargeSummary.admission.present_district_id)
           $scope.district_id = JSON.stringify($rootScope.dischargeSummary.admission.district_id)
           $timeout(function() {
            $rootScope.callGetBlocks($scope.present_district);
          },200);
          

           $scope.permanent_address_response = $rootScope.dischargeSummary.admission.permanent_address
           $scope.permanent_district = JSON.stringify($rootScope.dischargeSummary.admission.permanent_district_id)
           $timeout(function() {
            $rootScope.callGetBlocks2($scope.permanent_district);
          },300);
           

           var temp_sncu_arr =  response[0].sncu_id.split("/")
           $rootScope.dischargeSummary.admission.sncu_id = temp_sncu_arr[3]
           $scope.sncu_id_default = temp_sncu_arr[0]+"/"+temp_sncu_arr[1]+"/"+temp_sncu_arr[2]+"/"

           $scope.date1 = new Date($rootScope.dischargeSummary.admission.admission_dt)
           $scope.date2 = new Date($rootScope.dischargeSummary.admission.dob)

           if($rootScope.dischargeSummary.admission.admission_time[$rootScope.dischargeSummary.admission.admission_time.length-1] == 'Z'){
            var admission_time_24hr_format = $rootScope.dischargeSummary.admission.admission_time.slice(0, -1); 
            $scope.time1 = tConvert(admission_time_24hr_format)
           } else {
            $scope.time1 = tConvert($rootScope.dischargeSummary.admission.admission_time)
           }
           $scope.admission_time = $scope.time1
           if($rootScope.dischargeSummary.admission.dob_time[$rootScope.dischargeSummary.admission.dob_time.length-1] == 'Z'){
            var dob_time_24hr_format = $rootScope.dischargeSummary.admission.dob_time.slice(0, -1); 
            $scope.time2 = tConvert(dob_time_24hr_format)
           } else {
            $scope.time2 = tConvert($rootScope.dischargeSummary.admission.dob_time)
           }
           $scope.dob_time = $scope.time2

           $scope.Lmp = new Date($rootScope.dischargeSummary.admission.lmp)
           console.log('$scope.Lmp::',$scope.Lmp);

        }, function (error) {
          // toastr.error(error);
        });
    }
    function tConvert (time) {
        // Check correct time format and split into components
        time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      
        if (time.length > 1) { 
          time = time.slice (1);  
          time[5] = +time[0] < 12 ? 'AM' : 'PM'; 
          time[0] = +time[0] % 12 || 12;
        }
        return time.join (''); 
      }

      $scope.getFieldStaffid = function (){

        $scope.fieldStaff = []
        $scope.selected_stafftype = "";
    
        var param = {
            "account_email": authService.authentication.account_id, 
            "doctor_id": authService.authentication.doctor_id, 
            "district_id": $rootScope.dischargeSummary.admission.district_id, 
            "block_id": $rootScope.dischargeSummary.admission.block_id, 
            "village_id": $rootScope.dischargeSummary.admission.village_id,
            "staff_type" : "VHN"
        }
        console.log(param);
    
        recordService.getFieldStaffId(param).then(function(response){
            console.log(response);
            if(response.success == 1){
                $rootScope.dischargeSummary.admission.staffprofile_id = response.data[0].id+""
                console.log('$rootScope.dischargeSummary.admission.staffprofile_id::',$rootScope.dischargeSummary.admission.staffprofile_id);
            }
        })
    }
    
    
    $scope.staffType = function (selected_stafftype) {
        // console.log(selected_stafftype);
        // console.log(selected_stafftype.id);
        // console.log(selected_stafftype.fieldstaff_type);
        // $scope.selected_fieldstafftype = '0'
        $scope.selected_fieldstaffid = selected_stafftype.id+''
        // console.log($scope.selected_fieldstaffid);
        $scope.selected_fieldstafftype = selected_stafftype.fieldstaff_type
        console.log($scope.selected_fieldstafftype);
    }
      
    
}]);

//discharge entry controller
'use strict';
angular.module('AngularApp')
.controller('dischargeController2', ['$scope', '$rootScope','$filter', '$ngBootbox', '$location', 'toastr', 'authService', 'dischargeService',  function ($scope, $rootScope, $filter, $ngBootbox, $location, toastr, authService, dischargeService) {
    
    $rootScope.AntibioticEnable = "true";
    $rootScope.ptherapyEnable = "true";
    $rootScope.oxygenEnable =  "true";
    $rootScope.cpapEnable =  "true";
    $rootScope.ventilatorEnable = "true"; 
    $rootScope.stepEnable = "true";
    $rootScope.kmcEnable = "true";
    $scope.showHideDropdowns = true;
    $scope.showHideLabels = true;
    $scope.showHiderefers = true;
   
    $scope.showHidenFunc = function(value) {

        if(value == "discharged"){
            $scope.showHideDropdowns = true;
            $scope.showHideLabels = true;
            $scope.showHiderefers = true;
        } else if(value == "expired"){
            $scope.showHideDropdowns = false;
            $scope.showHideLabels = false;
            $scope.showHiderefers = true;
        } else if(value=="reffered") {
            $scope.showHideDropdowns = true;
            $scope.showHideLabels = true;
            $scope.showHiderefers = false;
        }

        //   if(value=="reffered"){
        //     $scope.showHideDropdowns = false;
        //   } else {
        //     $scope.showHideDropdowns = true;
        //   }

        //   if(value == "expired"){
        //     $scope.showExpired = false;
            
        //   }else{
        //     $scope.showExpired = true;
        //   }
    }
  
  function parseDate(str) {
    var mdy = str.split('-');
    return new Date( mdy[0], mdy[1], mdy[2]  );
  }
    
  function datediff(first, second) {
     return Math.round((second-first)/(1000*60*60*24));
  }
    
  $scope.getAgeOnDischarge = function() {
          console.log('$scope.dischargeEntry.admission_dt',$scope.dischargeEntry.admission_dt);
          console.log('$scope.dischargeEntry.discharge_dt',$scope.dischargeEntry.discharge_dt);

        if( $scope.dischargeEntry.admission_dt && $scope.dischargeEntry.discharge_dt ) {
           var days = datediff( parseDate( $scope.dischargeEntry.admission_dt ), parseDate(  $scope.dischargeEntry.discharge_dt ) );
           console.log('days age',days);
        //    if( parseInt($scope.dischargeEntry.age_on_discharge)>= 0 ) {
           if( parseInt(days)>= 0 ) {
              $scope.dischargeEntry.age_on_discharge = days;
              console.log('$scope.dischargeEntry.age_on_discharge',$scope.dischargeEntry.age_on_discharge);
           } 
        //    else {
        //       alert('Discharge date should be after admission date.');
        //    }
        }  
    }
    
    
    $scope.Congenital_malformation = false;
    $rootScope.removeErrorLabel2 = function(id, value) {
        console.log('value',value);
        if(value == 'congenital Malformation'){
            $scope.Congenital_malformation = true;
            $scope.dischargeEntry.final_diagnosis = "Congenital Malformation - "+ $scope.dischargeEntry.congenitalmalformation;
        }else{
            $scope.Congenital_malformation = false;
        }
        if( value!="" ) {
             document.getElementById(id+"_error").textContent="";  
        } else {
             document.getElementById(id+"_error").textContent="Value is required.";  
        }
     }  
    $scope.doctor_Inchargelist1 = [];
     dischargeService.doctorIncharge(1).then(function (response) {
        console.log('discharge Controller response',response.active_doctor_incharge);
        $scope.doctor_Inchargelist1 = response.active_doctor_incharge;
    }, function (error) {
        //toastr.error(error);
    });
    
    $scope.enable_DropDown = function(drpName, drpValue) {
        drpValue = drpValue ? false : true;
        console.log('drpName:',drpName);
        console.log('drpValue:',drpValue);
        switch( drpName ) {
            // case 'Antibiotic':
            case 'dischargeEntry.antibiotics':
                // $scope.Antibiotic = true
                $rootScope.AntibioticEnable = drpValue;
            break;
            case 'dischargeEntry.is_phototherapy':
                $rootScope.ptherapyEnable = drpValue;
            break; 
            case 'dischargeEntry.is_oxygen':
                $rootScope.oxygenEnable = drpValue;
            break;
            case 'dischargeEntry.is_cpap':
                $rootScope.cpapEnable = drpValue;
            break;
            case 'dischargeEntry.is_ventilator':
                $rootScope.ventilatorEnable = drpValue; 
            break;
            case 'dischargeEntry.is_step_down_unit':
                $rootScope.stepEnable = drpValue;
            break;   
            case 'dischargeEntry.is_kmc_unit':
                $rootScope.kmcEnable = drpValue;
            break; 
        }
    }

    $scope.discharge_time = "";
    // $scope.Todaydate = function(){
    //     $scope.datepicker3_max_date = moment(new Date()).format('YYYY-MM-DD');
    //     console.log('max_date datepicker',$scope.datepicker3_max_date);
    // }
    // $scope.Todaydate();

    
    
    $(function () {
        // $('#datepicker3').datetimepicker({
        //     format: 'DD/MM/YYYY',
        //     // maxDate: new Date()
        // }).on('dp.change', function(e) {
        //     var date = $filter('date')(new Date(e.date), "yyyy-MM-dd");
        //     console.log('date',date)
        //     $scope.dischargeEntry.discharge_dt = date;
           
        //     if( $scope.discharge_time=="" ) {
        //         document.getElementById("discharge_dt_error").textContent = "Value is required."; 
        //     } else {
        //         $scope.dischargeEntry.discharge_time = date+" "+$scope.discharge_time;
        //         document.getElementById("discharge_dt_error").textContent = "";  
        //     }
        // });
        
        $('#timepicker3').datetimepicker({
            format: 'LT'
        }).on('dp.change', function(e) {
           
            var returnTime = getTimeString( new Date(e.date) );  
            $scope.discharge_time = returnTime;

            if( $scope.dischargeEntry.discharge_dt=="" ) {
                document.getElementById("discharge_dt_error").textContent = "Value is required."; 
            } else {
                $scope.dischargeEntry.discharge_time = $scope.dischargeEntry.discharge_dt+" "+returnTime;
                document.getElementById("discharge_dt_error").textContent = "";
            }
        });
    });

    $scope.showHiderefers = true;
    $scope.showHideDropdowns = true;
    $scope.showHideLabels = true;

    $scope.showHidenFunc = function(value) {
        if( value == "reffered" ) {
            $scope.showHideLabels = true;
            $scope.showHideDropdowns = true;
            $scope.showHiderefers = false;
       } else if(value == "expired"){
            $scope.showHiderefers = true;
            $scope.showHideDropdowns = false;
            $scope.showHideLabels = false;
       }else{
           $scope.showHiderefers = true;
           $scope.showHideDropdowns = true;
           $scope.showHideLabels = true;
       }
    }

    $scope.multiple_indication2 = true;
    $scope.multi_indication2 = function(value) {
        console.log('multiindication',value);
        if(value == false){
            $scope.dischargeEntry = {
                a : "",
                b : "",
                c : "",
                d : "" 
      }
    }
        $scope.multiple_indication2 = value ? false : true;
        
    }
   
    $scope.p_values = ["A 33","P 07.3","P 90","P 07.0","P 28.3","P 05.1","P 07.2","P 07.1","P 29.0","P 25.1","P 24.0","P 22.0","P 22.1","P 21.0","P 70.4","P 59","P 91.6","P 55","R 57","A 09","J 15","G 00","N 17","P 36.9","Q 00.0","P 81.0","P 80","P 52.3","P 60","P 23","Others"]
    
    // $scope.multi_IndicateCheck = function(value){
       
    // }
        
    // $scope.dischargeEntry = {
    //     account_email: authService.authentication.account_id,
    //     sncu_id: "",
    //     admission_dt: "",
    //     discharge_dt: "",
    //     discharge_time: "",
    //     duty_doctor: "",
    //     age_on_discharge: null,
    //     wt_at_discharge: "",

    //     cause_of_death: null,
    //     place_referral: null,
    //     indication_referral: null,

    //     multiple_diagnosis: "",
    //     a: "",
    //     b: "",
    //     c: "",
    //     d: "",
    //     discharge_outcome: "",
    //     doctor_id: authService.authentication.account_id,
    //     final_diagnosis: "",
    //     ri_card: "",
    //     bcg: "",
    //     opv: "",
    //     hep_b: "",
    //     fp_ebf_kmc: "",
    //     follow_counselling: "",
    //     antibiotics: "",
    //     antibiotics_1: "",
    //     antibiotics_2: "",
    //     antibiotics_3: "",
    //     antibiotics_4: "",
    //     phototherapy: "",
    //     oxygen: "",
    //     cpap: "",
    //     step_down_unit: "",
    //     kmc_unit: "",
    //     ventilator: ""
    // };

    $scope.dischargeEntry = {
        account_email: authService.authentication.account_id,
        sncu_id: "",
        admission_dt: "",
        discharge_dt: "",
        discharge_time: "",
        duty_doctor: "",
        age_on_discharge: "",
        wt_at_discharge: "",
        multiple_diagnosis: "",
        a: "",
        b: "",
        c: "",
        d: "",
        discharge_outcome: "",
        doctor_id: authService.authentication.doctor_id,
        doctor: authService.authentication.account_id,
        final_diagnosis: "",
        ri_card: false,
        bcg: false,
        opv: false,
        hep_b: false,
        fp_ebf_kmc: false,
        follow_counselling: false,
        antibiotics: "",
        // antibiotics_s1: "",
        // antibiotics_s2: "",
        // antibiotics_s3: "",
        // antibiotics_s4: "",
        // antibiotics_1: "",
        // antibiotics_2: "",
        // antibiotics_3: "",
        // antibiotics_4: "",
        antibiotics_drug_1: "",
        antibiotics_drug_2: "",
        antibiotics_drug_3: "",
        antibiotics_drug_4: "",
        antibiotics_name_1: "",
        antibiotics_name_2: "",
        antibiotics_name_3: "",
        antibiotics_name_4: "",
        phototherapy: "",
        oxygen: "",
        cpap: "",
        step_down_unit: "",
        kmc_unit: "",
        ventilator: "",
        age_at_death: null,
        weight_at_death: null,
        expired_date: null,
        is_phototherapy: false,
        is_oxygen: false,
        is_cpap: false,
        is_step_down_unit: false,
        is_kmc_unit: false,
        is_ventilator: false
    }

    $scope.byRange2 = function (date, val) {
        console.log("showHideLabels::",$scope.showHideLabels);
        var date = $filter('date')(date, "yyyy-MM-dd");
        $scope.dischargeEntry.discharge_dt = date ;
        
        if( $scope.discharge_time=="" ) {
            document.getElementById("discharge_dt_error").textContent = "Value is required."; 
        } else {
            $scope.dischargeEntry.discharge_time = date+" "+$scope.discharge_time;
            document.getElementById("discharge_dt_error").textContent = "";  
        }

        if(val == 'discharge_date') {
            $scope.dischargeEntry.discharge_dt = date;
            $scope.getAgeOnDischarge();
        } 
        //return date;
    }


    $scope.time24Hrs2 = function (date, val) {
        var dateTime  = new Date(date);
        var todayDate = new Date();
        var date  = $filter('date')(todayDate, "yyyy-MM-dd");
        var hours = dateTime.getHours();
        var minutes = dateTime.getMinutes();
        var seconds = dateTime.getSeconds();

        if(hours < 10) {
          hours = "0" + hours;
        }
        if(minutes < 10) {
          minutes = "0" + minutes;
        }
        if(seconds < 10) {
          seconds = "0" + seconds;
        }
        if(val == 'discharge_time') {
          $scope.dischargeEntry.discharge_time = date + "T" + hours + ":" + minutes + ":" + seconds + "Z";
        }
        //return hours + ":" + minutes + ":" + seconds;
    }

    $scope.getSncuId = function() {
        var param = {
          account_email: authService.authentication.account_id,
          doctor_id: authService.authentication.doctor_id
        }
        dischargeService.getSncuId(param).then(function (response) {
          $rootScope.items = response;
        }, function (error) {
          //toastr.error(error);
        });
    }
    $scope.getSncuId();

    $rootScope.get_dischargeEntry_data = function(){
        var param = {
            "account_email": authService.authentication.account_id,
            "sncu_id" : $rootScope.dischargeedit_sncu_id,
            "doctor_id": authService.authentication.doctor_id
          }
        dischargeService.get_dischargeSummary_data(param).then(function (response) {
            console.log(response)
            $scope.dischargeEntry.discharge_outcome = response[0].discharge_outcome
            $scope.dischargeEntry.duty_doctor = response[0].duty_doctor
            $scope.dischargeEntry.final_diagnosis = response[0].final_diagnosis
            $scope.date3 = new Date(response[0].discharge_dt)
            $scope.dischargeEntry.discharge_dt = response[0].discharge_dt
            var time3_temp =  new Date(response[0].discharge_time)
           
            var tzDifference = time3_temp.getTimezoneOffset();
            
            var offsetTime = new Date(time3_temp.getTime() + tzDifference * 60 * 1000);
           
            $scope.time3 =  formatAMPM(new Date(offsetTime))

            $scope.dischargeEntry.discharge_time = response[0].discharge_time
            $scope.discharge_time = new Date(offsetTime).getHours() + ":" + new Date(offsetTime).getMinutes() + ":" + new Date(offsetTime).getSeconds()

            $scope.dischargeEntry.age_on_discharge = response[0].age_on_discharge

            $scope.dischargeEntry.wt_at_discharge = response[0].wt_at_discharge

            $scope.dischargeEntry.antibiotics = response[0].antibiotics
            $scope.dischargeEntry.antibiotics_drug_1 = response[0].antibiotics_drug_1
            $scope.dischargeEntry.antibiotics_drug_2 = response[0].antibiotics_drug_2
            $scope.dischargeEntry.antibiotics_drug_3 = response[0].antibiotics_drug_3
            $scope.dischargeEntry.antibiotics_drug_4 = response[0].antibiotics_drug_4
            $scope.dischargeEntry.antibiotics_name_1 = response[0].antibiotics_name_1
            $scope.dischargeEntry.antibiotics_name_2 = response[0].antibiotics_name_2
            $scope.dischargeEntry.antibiotics_name_3 = response[0].antibiotics_name_3
            $scope.dischargeEntry.antibiotics_name_4 = response[0].antibiotics_name_4
            $scope.dischargeEntry.phototherapy = response[0].phototherapy
            $scope.dischargeEntry.oxygen = response[0].oxygen
            $scope.dischargeEntry.cpap = response[0].cpap
            $scope.dischargeEntry.step_down_unit = response[0].step_down_unit
            $scope.dischargeEntry.kmc_unit = response[0].kmc_unit
            $scope.dischargeEntry.ventilator = response[0].ventilator
            $scope.dischargeEntry.is_phototherapy = response[0].is_phototherapy
            $scope.dischargeEntry.is_oxygen = response[0].is_oxygen
            $scope.dischargeEntry.is_cpap = response[0].is_cpap
            $scope.dischargeEntry.is_step_down_unit = response[0].is_step_down_unit
            $scope.dischargeEntry.is_kmc_unit = response[0].is_kmc_unit
            $scope.dischargeEntry.is_ventilator = response[0].is_ventilator
            $scope.dischargeEntry.ri_card = response[0].ri_card
            $scope.dischargeEntry.bcg = response[0].bcg
            $scope.dischargeEntry.opv = response[0].opv
            $scope.dischargeEntry.hep_b = response[0].hep_b
            $scope.dischargeEntry.fp_ebf_kmc = response[0].fp_ebf_kmc
            $scope.dischargeEntry.follow_counselling = response[0].follow_counselling
            if(response[0].antibiotics==true){
                $rootScope.AntibioticEnable = false
            }
            if(response[0].is_phototherapy==true){
                $rootScope.ptherapyEnable = false
            }
            if(response[0].is_oxygen==true){
                $rootScope.oxygenEnable = false
            }
            if(response[0].is_cpap==true){
                $rootScope.cpapEnable = false
            }
            if(response[0].is_ventilator==true){
                $rootScope.ventilatorEnable = false
            }
            if(response[0].is_step_down_unit==true){
                $rootScope.stepEnable = false
            }
            if(response[0].is_kmc_unit==true){
                $rootScope.kmcEnable = false
            }
            if(response[0].discharge_outcome=='reffered'){
                $scope.showHidenFunc('reffered')
                $scope.dischargeEntry.place_referral = response[0].place_referral
                $scope.dischargeEntry.indication_referral = response[0].indication_referral
            }
            if(response[0].discharge_outcome=='expired'){
                $scope.showHidenFunc('expired')
                $scope.dischargeEntry.cause_of_death = response[0].cause_of_death
            }
            if(response[0].multiple_diagnosis==true){
                $scope.dischargeEntry.multiple_diagnosis = response[0].multiple_diagnosis
                if(response[0].a!=''){
                    $scope.dischargeEntry.a = response[0].a
                }
                if(response[0].b!=''){
                    $scope.dischargeEntry.b = response[0].b
                }
                if(response[0].c!=''){
                    $scope.dischargeEntry.c = response[0].c
                }
                if(response[0].d!=''){
                    $scope.dischargeEntry.d = response[0].d
                }
            }


        }, function (error) {
            $scope.dischargeEntryspinner= false;
            //toastr.error(error);
        });
    }

    function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
      }

    $scope.admission_dt2 = ""; 
    $scope.select_sncuId = "";
    $rootScope.callBasicInfoApi = function (data) {
        $scope.select_sncuId = data
        if (data != null) {
            $scope.dischargeBasicInfo = {};
            var param = {
                account_email: authService.authentication.account_id,
                sncu_id: data.sncu_id
            }
            $rootScope.dischargeedit_sncu_id = data.sncu_id
            dischargeService.getBasicInfo(param).then(function (response) {
                if (response[0]) {
                    $scope.dischargeBasicInfo = response[0];
                    $rootScope.get_dischargeEntry_data()
                    if (response[0].admission_dt != "") {
                        var splitArray = response[0].admission_dt.split("/");
                        $scope.dischargeEntry.admission_dt = splitArray[2] + "-" + splitArray[1] + "-" + splitArray[0];
                        $scope.admission_dt2 = splitArray[0] + "/" + splitArray[1] + "/" + splitArray[2];

                        $scope.discharge_date = {
                            opened: { appointment_date1: false, appointment_date2: false },
                            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                            dateOptions: {
                                formatYear: 'yyyy',
                                startingDay: 0,
                                maxDate: new Date(),
                                minDate: new Date(splitArray[2], splitArray[1] - 1, splitArray[0]),
                            }
                        };
                        $scope.getAgeOnDischarge();
                    }
                }
            }, function (error) {
                //toastr.error(error);
            });
        }
    }

    $rootScope.callFollowupScheduleApi = function (data) {

        if (data!=null) {
            var param = {
               account_email: authService.authentication.account_id,
               sncu_id: data.sncu_id,
               "search_id":0
            }
  
            dischargeService.getFollowupSchedule(param).then(function (response) {             
                if (response) {
                    $scope.followupData = response.data; 
                }   
            }, function (error) {
                //toastr.error(error);
            });
        }
    }

    $scope.callDischargeEntryApi = function (data) {

        $scope.dischargeEntry = {
            account_email: authService.authentication.account_id,
            sncu_id: "",
            admission_dt: "",
            discharge_dt: "",
            discharge_time: "",
            duty_doctor: "",
            age_on_discharge: "",
            wt_at_discharge: "",
            multiple_diagnosis: "",
 
         /* indication_referral: "",
            place_referral: "",
            cause_of_death: "", */

            a: "",
            b: "",
            c: "",
            d: "",
            discharge_outcome: "",
            doctor_id: authService.authentication.doctor_id,
            doctor: authService.authentication.account_id,
            final_diagnosis: "",
            ri_card: false,
            bcg: false,
            opv: false,
            hep_b: false,
            fp_ebf_kmc: false,
            follow_counselling: false,
            antibiotics: "",
            // antibiotics_1: "",
            // antibiotics_2: "",
            // antibiotics_3: "",
            // antibiotics_4: "",
            antibiotics_drug_1: "",
            antibiotics_drug_2: "",
            antibiotics_drug_3: "",
            antibiotics_drug_4: "",
            antibiotics_name_1: "",
            antibiotics_name_2: "",
            antibiotics_name_3: "",
            antibiotics_name_4: "",
            phototherapy: "",
            oxygen: "",
            cpap: "",
            step_down_unit: "",
            kmc_unit: "",
            ventilator: "",
            is_phototherapy: false,
            is_oxygen: false,
            is_cpap: false,
            is_step_down_unit: false,
            is_kmc_unit: false,
            is_ventilator: false
        };

        $scope.date5 = ""; 
        $rootScope.callBasicInfoApi(data); 
        $rootScope.callFollowupScheduleApi(data);
    }
    
    $scope.dischargeEntryspinner= false;
    $scope.checkAllRequired_Entry = function () {
        var i = 0;
        console.log('values::',$scope.dischargeEntry);
        if($rootScope.discharge_edit == true){
            $scope.select_sncuId = $rootScope.dischargeedit_sncu_id
            $scope.dischargeEntry.sncu_id = $rootScope.dischargeedit_sncu_id
        }
        if ( $scope.select_sncuId == "" ) { document.getElementById("entry_sncu_id_error").textContent="Select Admission Id."; i++;} 
        if ( $scope.dischargeEntry.duty_doctor == "" ) { document.getElementById("duty_doctor_error").textContent="Value is required."; i++;} 
        if ( $scope.dischargeEntry.discharge_outcome == "" ) { document.getElementById("discharge_outcome_error").textContent="Select Outcome."; i++;}
        if ( $scope.dischargeEntry.discharge_dt == "" ) { document.getElementById("discharge_dt_error").textContent="Value is required."; i++;}
        if( $rootScope.date3 == "") { document.getElementById("discharge_dt_error").textContent="Value is required."; i++;}
        if( $scope.dischargeEntry.discharge_time == "") { document.getElementById("discharge_dt_error").textContent="Value is required."; i++;}
        if ( $scope.dischargeEntry.wt_at_discharge == "" ) { document.getElementById("wt_at_discharge_error").textContent="Enter Weight."; i++;}
        if ( $scope.dischargeEntry.final_diagnosis == "" ) { document.getElementById("final_diagnosis_error").textContent="Select Final Diagnosis."; i++;}
      //if ( $scope.dischargeEntry.cause_of_death == "" ) { document.getElementById("cause_of_death_error").textContent="Value is required."; i++;}
      //if ( $scope.dischargeEntry.indication_referral == "" ) { document.getElementById("indication_referral_error").textContent="Value is required."; i++;}
    
        if (i==0) {
            $scope.dischargeSummaryFunc();
            $scope.dischargeEntryspinner = true;
        } else {
            alert('Please fill all required fields..');
            $scope.dischargeEntryspinner= false;
        }
    }

    $scope.dischargeSummaryFunc = function () {
        
        $scope.dischargeEntry.wt_at_discharge = parseFloat($scope.dischargeEntry.wt_at_discharge);
        var requestPayload = $scope.dischargeEntry;
        console.log('request Payload 1584',requestPayload);
        if($scope.showHideLabels==false){
            // alert(1)
            requestPayload.age_at_death = requestPayload.age_on_discharge
            requestPayload.weight_at_death = requestPayload.wt_at_discharge
            requestPayload.expired_date = requestPayload.discharge_dt
            requestPayload.place_referral = null
            requestPayload.indication_referral = null
        }else if($scope.showHiderefers==false){
            requestPayload.cause_of_death = null
        }else if($scope.showHideLabels&&$scope.showHiderefers==true){
            // alert()
            requestPayload.place_referral = null
            requestPayload.indication_referral = null
            requestPayload.cause_of_death = null
        }
        console.log('request Payload 15841',requestPayload);
        if($rootScope.discharge_edit == true){
            dischargeService.updatedischargeSummary(requestPayload).then(function (response) {
                $scope.dischargeEntryspinner= false;
                if(response.status == 0){
                    toastr.error(response.message);
                }else{
                    toastr.success("Successfully saved.");
                    $location.path('/admissionList');
                    $rootScope.discharge_edit = false
                }
            }, function (error) {
                $scope.dischargeEntryspinner= false;
                //toastr.error(error);
            });
        } else {
            $scope.dischargeEntry.sncu_id = $scope.select_sncuId.sncu_id;
            console.log(requestPayload,"requestPayload")
            if($scope.showHideLabels==false){
                // alert()
                requestPayload.age_at_death = requestPayload.age_on_discharge
                requestPayload.weight_at_death = requestPayload.wt_at_discharge
                requestPayload.expired_date = requestPayload.discharge_dt
            }
            console.log(requestPayload,"requestPayload")
            dischargeService.dischargeSummary(requestPayload).then(function (response) {
                $scope.dischargeEntryspinner= false;
                if(response.success == 0){
                    toastr.error(response.message);
                }else{
                    toastr.success("Successfully saved.");
                    $location.path('/admissionList');
                }
            }, function (error) {
                $scope.dischargeEntryspinner= false;
                //toastr.error(error);
            });
        }
    };

    // $scope.clear_update_details = function(){
    //     $rootScope.discharge_edit = false
    // }
    $scope.dischargeEntryPrint = function () {
        if ( $scope.dischargeEntry.discharge_dt != "" ) {
            $scope.dischargeSummaryFunc();
        }
    }

}]);

//discharge card controller
'use strict';
angular.module('AngularApp').controller('dischargeController3', ['$scope', '$rootScope', '$ngBootbox', '$filter', '$location', 'toastr', 'authService', 'dischargeService',
    function ($scope, $rootScope, $ngBootbox, $filter, $location, toastr, authService, dischargeService) {
    
        $scope.now = new Date()
        $scope.datepicker_dischargecard = {
          opened:{appointment_date1:false, appointment_date2:false},
          maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
          dateOptions : {
              formatYear: 'yyyy',
              startingDay:0,
              maxDate: new Date(),
          }
      };

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear();             
       return year+"-"+month+"-"+day;
    }

    $scope.getSncuIdDischargeCard = function (discharge_date) {
    
        var param = {
           account_email: authService.authentication.account_id,
           discharge_dt: getStringDate(discharge_date),
        }
        
        dischargeService.getSncuId_DischargeCard(param).then(function (response) {
            $rootScope.sncu_items = response;
        }, function (error) {
            //toastr.error(error);
        });
    }

    $scope.todaysdate = function(){
        $scope.max_date = moment(new Date()).format('YYYY-MM-DD');
        console.log('max_date',$scope.max_date);
    };
    $scope.todaysdate();

    $(function () {
        $('#datepicker5').datetimepicker({
            format: 'DD/MM/YYYY',
            // maxDate: moment()
        }).on('dp.change', function(e) {

            var date = $filter('date')(new Date(e.date), "yyyy-MM-dd");
            $scope.getSncuIdDischargeCard(date);
           
            // if( $scope.dischargeEntry.discharge_time=="" ) {
            //     //document.getElementById("discharge_carda_dt_error").textContent = "Value is required."; 
            // } else {
            //     $scope.dischargeEntry.discharge_time = $ascope.dischargeEntry.discharge_dt+" "+$scope.dischargeEntry.discharge_time ;
            //     //document.getElementById("discharge_card_dt_error").textContent = "";  
            // }
        });
    });

    $scope.dischargeCard = {
        account_email: authService.authentication.account_id,
        sncu_id: "",
        doctor_id: authService.authentication.doctor_id,       
        presenting_complaints: "",
        cvs: "",
        respiratory: "",
        perabdomen: "",
        cns: "",
        other_significant_findings:"",
        relevant_investigation: "",
        treatment_given_1: "",
        treatment_given_2: "",
        treatment_given_3: "",
        treatment_given_4: "",
        treatment_given_5: "",
        course_treatment: "",
        condition_discharge: "",
        treatment_adviced_1: "",
        treatment_adviced_2: "",
        treatment_adviced_3: "",
        treatment_adviced_4: "",
    };

    

    $scope.selectedSncuid = "";
    $scope.getDischargeCardDetails = function (data) {      
        $rootScope.parent_details = {};
        if(data!=null) {
            $scope.selectedSncuid = data.sncu_id;
            var param = {
                account_email: authService.authentication.account_id,
                sncu_id: data.sncu_id    
            }

            dischargeService.getParentDetails(param).then(function (response) {
                console.log( response );

                if(response[0]) {
                   $rootScope.parent_details.mother_name = response[0].mother_name;
                   $rootScope.parent_details.father_name = response[0].father_name;
                   $rootScope.parent_details.gender = response[0].gender;
                }

            }, function (error) {
                //toastr.error(error);
            });
        }
    };

    $scope.checkAllRequired_Card = function () {

        var i = 0;
        if ( $scope.dischargeCard.condition_discharge == "" ) { document.getElementById("discharge_condition_error").textContent="Value is required."; i++; } 
   
        if ( i==0 ) {
            $scope.dischargeCardFunc(); 
        } else {
            alert('Please fill all required fields.');
        }
    }

    $scope.select_sncuid = function (data) {      
        $rootScope.parent_details = {};
        if(data!=null) {
            $scope.selectedSncuid = data.sncu_id;
            var param = {
                account_email: authService.authentication.account_id,
                sncu_id: data.sncu_id    
            }

            dischargeService.getParentDetails(param).then(function (response) {
                if(response[0]) {
                   $rootScope.parent_details.mother_name = response[0].mother_name;
                   $rootScope.parent_details.father_name = response[0].father_name;
                   $rootScope.parent_details.gender = response[0].gender;
                }

            }, function (error) {
                //toastr.error(error);
            });
        }

    };

    $scope.dischargeCardFunc = function () {

        $scope.dischargeCard.sncu_id = $scope.selectedSncuid;
        console.log('$scope.dischargeCard',$scope.dischargeCard);
        var requestPayload = $scope.dischargeCard;

        if($scope.selectedSncuid!="") {       


              dischargeService.dischargeCard(requestPayload).then(function (response) {
                //toastr.success(response.Message);
                if(response.success == 0){
                    toastr.error(response.message);
                }else{
                  toastr.success("Discharge Card created successfully.");
                }
              }, function (error) {
                 //toastr.error(error);
              });
        } else {
            alert('Please select SNCU Id');
        }
    };

    $scope.dischargeCardFunCall = function (data) {
        if( $scope.dischargeCard.presenting_complaints !="" && ( $scope.dischargeCard.treatment_given_1!= "" || $scope.dischargeCard.treatment_given_2!= "" || $scope.dischargeCard.treatment_given_3!= "" || $scope.dischargeCard.treatment_given_4!= "" ) ) {
            document.getElementById("presenting_Complaints").textContent ="",
            document.getElementById("test_Complaints").textContent ="",
            $scope.dischargeCardFunc();
        }

        if($scope.dischargeCard.presenting_complaints ==""){ document.getElementById("presenting_Complaints").textContent="Please Enter the Required field."}
        if($scope.dischargeCard.treatment_given_1 =="" ){ document.getElementById("test_Complaints").textContent="Please Enter the Required field."}
    }

    $rootScope.dischargeCardPrint = [];
    $scope.getDischargePrintDetails = function() {
       
        if($scope.selectedSncuid!=""){ 
                var param = {
                    account_email: authService.authentication.account_id,
                    sncu_id: $scope.selectedSncuid
                }
                
                dischargeService.dischargeCardDetails(param).then(function (response) {  
                    console.log('response.......',response[0]);
                    $rootScope.dischargeCardPrint = response[0];
                    var timesplit = response[0].discharge_time;
                    var newarray = timesplit.split("t")
                    var date = newarray[0];
                     date = date.split("-").reverse().join("-");
                    $scope.dischargeDate = date;
                    var newtime = newarray[1].split("z")
                    $scope.dischargeTime = newtime[0]; 
                    $scope.admissionTime = response[0].admission_time
                    $rootScope.Admission_time = moment($scope.admissionTime, "HH:mm:ss").format("hh:mm A");
                    $rootScope.dischargeDateandTime = $scope.dischargeDate + " " +moment($scope.dischargeTime, "HH:mm:ss").format("hh:mm A");
                    
                   
                }, function (error) {
                   //toastr.error(error);
                });

        } else {
            alert('Please select SNCU Id');
        }
    };

    $scope.dischargePrint = function(){

        $scope.getDischargePrintDetails();
    if($scope.selectedSncuid!=""){ 
        var options = {
            title: '',
            message:'',
            templateUrl: 'views/discharge/dischargePrint.htm',
            size: 'large',
            onEscape: function() {$scope.$apply();},
            buttons: { }
        }
        $ngBootbox.customDialog(options);
    }
    };

    $scope.downloadPdf = function(){
        var pdfElement = document.getElementById('dischargeCard');
        var opt = {
            margin:      0,
            filename:    'DischargeEntry.pdf',
            image:       { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
        };
        
      //New Promise-based usage:
        html2pdf().set(opt).from(pdfElement).save();
    }
        
    $rootScope.printToCart = function (firstTable) {
        var innerContents = document.getElementById(firstTable).innerHTML;
        var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:100%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: 100px; margin-top:2cm;margin-left:7cm;margin-bottom:2cm;} .form-control{border: 2;height:20px;width:30%;overflow:visible;} table{ font-size: 120%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:150% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 2px; border-radius: 2px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
        popupWinindow.document.close();
    };

}]);

//Admission List controller
'use strict';
angular.module('AngularApp').controller('dischargeController4', ['$scope', '$rootScope', '$ngBootbox', '$location', 'toastr', 'authService', 'dischargeService', '$timeout',
    function ($scope, $rootScope, $ngBootbox, $location, toastr, authService, dischargeService, $timeout) {

        $rootScope.admissionStatus = "new"
        $rootScope.discharge_edit = false
        $rootScope.dischargeedit_sncu_id = ""

        $scope.getAdmissionList = function () {
            
            var param = { 
               account_email: authService.authentication.account_id,
               doctor_id: authService.authentication.doctor_id
            }

            dischargeService.getAdmissionList(param).then(function (response) {
                for (var i=0; i<response.length; i++){
                    if(response[i].admission_time !== null){
                        if(response[i].admission_time[response[i].admission_time.length-1] == 'Z'){
                            var admission_time_24hr_format = response[i].admission_time.slice(0, -1); 
                            response[i].admission_time = tConvert(admission_time_24hr_format)
                        }
                    }
                }
               
                function tConvert (time) {
                    // Check correct time format and split into components
                    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
                  
                    if (time.length > 1) {
                      time = time.slice (1,-1);  
                      time[5] = +time[0] < 12 ? ' AM' : ' PM'; 
                      time[0] = +time[0] % 12 || 12;
                    }
                    return time.join (''); 
                  }
                $scope.admissionList = response;
            }, function (error) {
                //toastr.error(error);
            });
        }
        $scope.getAdmissionList();

        $scope.getPatientAdminDetails = function (val) {
            $location.path('/dischargeSummary');
            $timeout(function() {
                $rootScope.getAdmissionDetails(val.sncu_id);
              },500);
        };
        
        $scope.getPatientdischargeDetails = function (val) {
            $location.path('/dischargeEntry');
            $timeout(function() {
                $rootScope.callBasicInfoApi(val);
                $rootScope.dischargeedit_sncu_id = val.sncu_id
                $rootScope.discharge_edit = true
                $rootScope.get_dischargeEntry_data()
                $rootScope.callFollowupScheduleApi(val)
              },500);
        };

}]);

//Visit followup controller
'use strict';
angular.module('AngularApp').controller('dischargeController5', ['$scope', '$rootScope', '$ngBootbox', '$location', 'toastr', 'authService', 'dischargeService', '$timeout','$filter',
    function ($scope, $rootScope, $ngBootbox, $location, toastr, authService, dischargeService, $timeout,$filter) {
        $rootScope.visit_followup_type = "visit"
        $rootScope.show_alive_options = null
        $rootScope.show_fir_number = null
        $scope.show_date_result = null
        $scope.byRange = function (from, to, range_no) {
            if (range_no == "1") {
                $scope.rangePicker2 = {
                    opened: { fromDate: false, toDate: false },
                    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                    dateOptions: {
                        formatYear: 'yyyy',
                        startingDay: 0,
                        minDate: from
                    }
                };
                $scope.from_date = $filter('date')(from, "yyyy-MM-dd");
            } else if (range_no == "2") {
                $scope.rangePicker1 = {
                    opened: { fromDate: false, toDate: false },
                    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                    dateOptions: {
                        formatYear: 'yyyy',
                        startingDay: 0,
                        maxDate: to
                    }
                }
                $scope.to_date = $filter('date')(to, "yyyy-MM-dd");
            }
            if ($scope.from_date && $scope.to_date) {
                $scope.getFollowupScheduleByDate()

            }
        }

        $rootScope.open5 = function () {
            $scope.popup5.opened = true;
            $rootScope.popup5.opened = true;
        };

        $rootScope.popup5 = {
            opened: false
        };

        $rootScope.changeBabyStatus = function (data) {
            $rootScope.show_baby_status_error = false
            $rootScope.show_fir_number = null
            $rootScope.show_expired_error = false
            $rootScope.followup_schedule_data.sub_babystatus = null
            if (data == 'alive'){
                $rootScope.show_alive_options = true
                $rootScope.followup_schedule_data.baby_status = "Alive"
            } else {
                $rootScope.show_alive_options = false
                $rootScope.followup_schedule_data.baby_status = "Expired"
            }
        }

        $rootScope.setAliveStatus = function (data) {
            $rootScope.followup_schedule_data.sub_babystatus = data
        }

        $rootScope.setExpiredStatus = function (data) {
            $rootScope.show_expired_error = false
            if (data == 'unnatural'){
                $rootScope.show_fir_number = true
                $rootScope.followup_schedule_data.sub_babystatus = "Unnatural Causes including Accident/Murder"
            } else {
                $rootScope.show_fir_number = false
                $rootScope.followup_schedule_data.sub_babystatus = "Natural Causes including Health Issues"
            }
        }

        $scope.getFollowupScheduleByDate = function () {
            var params = {
                "account_email": authService.authentication.account_id,
                "start_date": $scope.from_date,
                "end_date": $scope.to_date,
                "doctor_id": authService.authentication.doctor_id
            }
            dischargeService.getFollowupDetailsByDate(params).then(function (response) {
                $scope.show_date_result = true
                $scope.getPatient = ""
                $scope.followup_schedule_data_by_id = []
                $scope.followup_schedule_data_by_date = []
                if (response.success == 0) {
                    $scope.followup_schedule_data_by_date = []
                } else if (response.success == 1) {
                    $scope.followup_schedule_data_by_date = response.data
                }
            })
        }

        $scope.getFollowupScheduleById = function (data) {
            if (data == "" || data == undefined) {
                $scope.show_error_text = true
            } else {
                $scope.show_error_text = false
                var params = {
                    "account_email": authService.authentication.account_id,
                    "sncu_id": data,
                    "doctor_id": authService.authentication.doctor_id
                }
                dischargeService.getFollowupDetailsById(params).then(function (response) {
                    $scope.show_date_result = false
                    $scope.Date1 = ""
                    $scope.Date2 = ""
                    $scope.from_date = null
                    $scope.to_date = null
                    $scope.followup_schedule_data_by_date = []
                    $scope.followup_schedule_data_by_id = []
                    if (response.success == 2) {
                        toastr.error("SNCU ID does not exist")
                    } else if (response.success == 3) {
                        toastr.error("Patient has expired")
                    }  else {
                        $scope.followup_schedule_data_by_id = response
                    }
                })
            }

        }

        $scope.keyUp = function () {
            $scope.show_error_text = false
        }

        $rootScope.cancelFollowupDetails = function(){
            if ($scope.getPatient == "") {
                $scope.getFollowupScheduleByDate()
            } else {
                $scope.getFollowupScheduleById($rootScope.followup_schedule_data.sncu_id)
            }
            $rootScope.show_alive_options = null
            $rootScope.show_fir_number = null
            $rootScope.show_baby_status_error = null
            $rootScope.show_expired_error = null
            bootbox.hideAll();
        }

        $scope.editFollowupScheduleData = function (data) {
            $rootScope.showdiv = true
            // if(data.actual_date != null){
            //     data.actual_date = $filter('date')(data.actual_date, "dd-MM-yyyy");
            // }
            $rootScope.followup_schedule_data = {}
            $rootScope.device_lattitude1 = data.lattitude
            $rootScope.device_longitude1 = data.longitude
            $rootScope.followup_scheduled_date = $filter('date')(data.scheduled_dt, "dd-MM-yyyy");
            $rootScope.followup_schedule_data = data
            if($rootScope.followup_schedule_data.baby_status == 'Alive'){
                $rootScope.show_alive_options = true
            } else {
                $rootScope.show_alive_options = false
            }
            if ($rootScope.followup_schedule_data.sub_babystatus == 'Unnatural Causes including Accident/Murder'){
                $rootScope.show_fir_number = true
            } else {
                $rootScope.show_fir_number = false
            }
            var options = {
                title: '<h5 style="color:white">Update followup schedule</h5>',
                message: '',
                templateUrl: 'views/discharge/UpdateFollowupSchedule.htm',
                size: 'medium',
                onEscape: function () {
                    if ($scope.getPatient == "") {
                        $scope.getFollowupScheduleByDate()
                    } else {
                        $scope.getFollowupScheduleById(data.sncu_id)
                    }
                },
                buttons: {
                    // warning: {
                    //     label: "Cancel",
                    //     className: "btn-warning",
                    //     callback: function () {
                           
                    //     }
                    // },
                    // success: {
                    //     label: "Ok",
                    //     className: "btn-success",
                    //     callback: function () {
                            
                    //     }
                    // }
                }
            };
            $ngBootbox.customDialog(options);
        }

        $rootScope.saveVisitPhonecallFollowupDetails = function(){
            $rootScope.followup_schedule_data.scheduled_dt = $filter('date')($rootScope.followup_schedule_data.scheduled_dt, "yyyy-MM-dd");
            if ($rootScope.followup_schedule_data.remarks == null || $rootScope.followup_schedule_data.remarks == undefined) {
                $rootScope.followup_schedule_data.remarks = ""
            }
            $rootScope.followup_schedule_data.account_email = authService.authentication.account_id
            if($rootScope.followup_schedule_data.sub_babystatus != 'Unnatural Causes including Accident/Murder'){
                $rootScope.followup_schedule_data.fir_number = ""
            }
            if($rootScope.followup_schedule_data.actual_date == undefined){
                $rootScope.followup_schedule_data.actual_date = null
            }

            if($rootScope.ipfordrlogin=="255.255.255.255"){
                $rootScope.send_device_lattitude = $rootScope.device_lattitude1
                $rootScope.send_device_longitude = $rootScope.device_longitude1
            }else{
                $rootScope.send_device_lattitude = $rootScope.device_lattitude
                $rootScope.send_device_longitude = $rootScope.device_longitude
            }
            console.log('send_device_lattitude',$rootScope.send_device_lattitude);
            console.log('send_device_longitude',$rootScope.send_device_longitude);

            var params = {
                "id": $rootScope.followup_schedule_data.id,
                "sncu_id": $rootScope.followup_schedule_data.sncu_id,
                "mr_number": $rootScope.followup_schedule_data.mr_number,
                "visit_no": $rootScope.followup_schedule_data.visit_no,
                "followup_description": $rootScope.followup_schedule_data.followup_description,
                "remarks": $rootScope.followup_schedule_data.remarks,
                "lattitude": $rootScope.send_device_lattitude,
                "longitude": $rootScope.send_device_longitude,
                "scheduled_dt": $rootScope.followup_schedule_data.scheduled_dt,
                "actual_date": $filter('date')($rootScope.followup_schedule_data.actual_date, "yyyy-MM-dd"),
                "baby_status" : $rootScope.followup_schedule_data.baby_status,
                "sub_babystatus": $rootScope.followup_schedule_data.sub_babystatus,
                "fir_number": $rootScope.followup_schedule_data.fir_number,
                "notes": $rootScope.followup_schedule_data.notes,
                "baby_current_status": "",
                "dangers": "",
                "updated_date": "",
                "mother_feeding": "",
                "my_health_app_usage": "",
                "account_email": authService.authentication.account_id
            }
           if($rootScope.show_alive_options == null){
                $rootScope.show_baby_status_error = true
           } else {
            if($rootScope.show_alive_options == false && $rootScope.show_fir_number == null){
                $rootScope.show_expired_error = true
            } else {
                dischargeService.updateFollowupDetailsById(params).then(function (response) {
                    if (response.success == 1) {
                        toastr.success("Updated successfully");
                        bootbox.hideAll();
                        if ($scope.getPatient == "") {
                            $scope.getFollowupScheduleByDate()
                        } else {
                            $scope.getFollowupScheduleById($rootScope.followup_schedule_data.sncu_id)
                        }
                    } else {
                        toastr.error("Unable to update");
                        // $scope.getFollowupScheduleById($rootScope.followup_schedule_data.sncu_id)
                    }
                })
            }
           }
        }
        $rootScope.showdiv = true
        $rootScope.datechanged = function(){
            $rootScope.showdiv = false
        }

}]);

//telephonic followup controller
'use strict';
angular.module('AngularApp').controller('dischargeController6', ['$scope', '$rootScope', '$ngBootbox', '$location', 'toastr', 'authService', 'dischargeService', '$timeout','$filter',
    function ($scope, $rootScope, $ngBootbox, $location, toastr, authService, dischargeService, $timeout,$filter) {
        $rootScope.visit_followup_type = "phone_call"
        $rootScope.show_alive_options = null
        $rootScope.show_fir_number = null
        $scope.show_date_result = null
        $scope.byRange = function (from, to, range_no) {
            if (range_no == "1") {
                $scope.rangePicker2 = {
                    opened: { fromDate: false, toDate: false },
                    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                    dateOptions: {
                        formatYear: 'yyyy',
                        startingDay: 0,
                        minDate: from
                    }
                };
                $scope.from_date = $filter('date')(from, "yyyy-MM-dd");
            } else if (range_no == "2") {
                $scope.rangePicker1 = {
                    opened: { fromDate: false, toDate: false },
                    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                    dateOptions: {
                        formatYear: 'yyyy',
                        startingDay: 0,
                        maxDate: to
                    }
                }
                $scope.to_date = $filter('date')(to, "yyyy-MM-dd");
            }
            if ($scope.from_date && $scope.to_date) {
                $scope.getFollowupScheduleByDate()

            }
        }

        $rootScope.open5 = function () {
            $scope.popup5.opened = true;
            $rootScope.popup5.opened = true;
        };

        $rootScope.popup5 = {
            opened: false
        };
        
        $rootScope.changeBabyStatus = function (data) {
            $rootScope.show_baby_status_error = false
            $rootScope.show_fir_number = null
            $rootScope.show_expired_error = false
            $rootScope.followup_schedule_data.sub_babystatus = null
            if (data == 'alive'){
                $rootScope.show_alive_options = true
                $rootScope.followup_schedule_data.baby_status = "Alive"
            } else {
                $rootScope.show_alive_options = false
                $rootScope.followup_schedule_data.baby_status = "Expired"
            }
        }

        $rootScope.setAliveStatus = function (data) {
            $rootScope.followup_schedule_data.sub_babystatus = data
        }

        $rootScope.setExpiredStatus = function (data) {
            $rootScope.show_expired_error = false
            if (data == 'unnatural'){
                $rootScope.show_fir_number = true
                $rootScope.followup_schedule_data.sub_babystatus = "Unnatural Causes including Accident/Murder"
            } else {
                $rootScope.show_fir_number = false
                $rootScope.followup_schedule_data.sub_babystatus = "Natural Causes including Health Issues"
            }
        }


        $scope.getFollowupScheduleByDate = function () {
            var params = {
                "account_email": authService.authentication.account_id,
                "start_date": $scope.from_date,
                "end_date": $scope.to_date,
                "doctor_id": authService.authentication.doctor_id
            }
            console.log(params)
            dischargeService.PhoneCallgetFollowupDetailsByDate(params).then(function (response) {
                $scope.show_date_result = true
                $scope.getPatient = ""
                $scope.followup_schedule_data_by_id = []
                $scope.followup_schedule_data_by_date = []
                if (response.success == 1) {
                    $scope.followup_schedule_data_by_date = response.data
                } else if (response.success == 0) {
                    $scope.followup_schedule_data_by_date = []
                }
            })
        }

        $scope.getFollowupScheduleById = function (data) {
            if (data == "" || data == undefined) {
                $scope.show_error_text = true
            } else {
                $scope.show_error_text = false
                var params = {
                    "account_email": authService.authentication.account_id,
                    "sncu_id": data,
                    "doctor_id": authService.authentication.doctor_id
                }
                dischargeService.PhoneCallgetFollowupDetailsById(params).then(function (response) {
                    $scope.show_date_result = false
                    $scope.Date1 = ""
                    $scope.Date2 = ""
                    $scope.from_date = null
                    $scope.to_date = null
                    $scope.followup_schedule_data_by_date = []
                    $scope.followup_schedule_data_by_id = []
                    if (response.success == 1) {
                        $scope.followup_schedule_data_by_id = response.data
                    } else if (response.success == 2) {
                        toastr.error("SNCU ID does no exist")
                    } else if (response.success == 3) {
                        toastr.error("Patient has expired")
                    } else {
                        toastr.error("Unable to get data")
                    }
                })
            }

        }

        $scope.keyUp = function () {
            $scope.show_error_text = false
        }

        $rootScope.cancelFollowupDetails = function(){
            if ($scope.getPatient == "") {
                $scope.getFollowupScheduleByDate()
            } else {
                $scope.getFollowupScheduleById($rootScope.followup_schedule_data.sncu_id)
            }
            $rootScope.show_alive_options = null
            $rootScope.show_fir_number = null
            $rootScope.show_baby_status_error = null
            $rootScope.show_expired_error = null
            bootbox.hideAll();
        }

        $scope.editFollowupScheduleData = function (data) {
            $rootScope.showdiv = true
            // data.actual_date = $filter('date')(data.actual_date, "dd-MM-yyyy");
            $rootScope.followup_schedule_data = {}
            $rootScope.device_lattitude2 = data.lattitude
            $rootScope.device_longitude2 = data.longitude
            $rootScope.followup_scheduled_date = $filter('date')(data.scheduled_dt, "dd-MM-yyyy");
            $rootScope.followup_schedule_data = data
            if($rootScope.followup_schedule_data.baby_status == 'Alive'){
                $rootScope.show_alive_options = true
            } else {
                $rootScope.show_alive_options = false
            }
            if ($rootScope.followup_schedule_data.sub_babystatus == 'Unnatural Causes including Accident/Murder'){
                $rootScope.show_fir_number = true
            } else {
                $rootScope.show_fir_number = false
            }
            var options = {
                title: '<h5 style="color:white">Update followup schedule</h5>',
                message: '',
                templateUrl: 'views/discharge/UpdateFollowupSchedule.htm',
                size: 'medium',
                onEscape: function () {
                    if ($scope.getPatient == "") {
                        $scope.getFollowupScheduleByDate()
                    } else {
                        $scope.getFollowupScheduleById(data.sncu_id)
                    }
                },
                buttons: {
                    
                }
            };
            $ngBootbox.customDialog(options);
        }

        $rootScope.saveVisitPhonecallFollowupDetails = function(){
            $rootScope.followup_schedule_data.scheduled_dt = $filter('date')($rootScope.followup_schedule_data.scheduled_dt, "yyyy-MM-dd");
            if ($rootScope.followup_schedule_data.remarks == null || $rootScope.followup_schedule_data.remarks == undefined) {
                $rootScope.followup_schedule_data.remarks = ""
            }
            $rootScope.followup_schedule_data.account_email = authService.authentication.account_id
            if($rootScope.followup_schedule_data.sub_babystatus != 'Unnatural Causes including Accident/Murder'){
                $rootScope.followup_schedule_data.fir_number = ""
            }
            if($rootScope.followup_schedule_data.actual_date == undefined){
                $rootScope.followup_schedule_data.actual_date = null
            }

            if($rootScope.ipfordrlogin=="255.255.255.255"){
                $rootScope.send_device_lattitude1 = $rootScope.device_lattitude2
                $rootScope.send_device_longitude1 = $rootScope.device_longitude2
            }else{
                $rootScope.send_device_lattitude1 = $rootScope.device_lattitude
                $rootScope.send_device_longitude1 = $rootScope.device_longitude
            }
            console.log('send_device_lattitude1',$rootScope.send_device_lattitude1);
            console.log('send_device_longitude1',$rootScope.send_device_longitude1);
            var params = {
                "id": $rootScope.followup_schedule_data.id,
                "sncu_id": $rootScope.followup_schedule_data.sncu_id,
                "mr_number": $rootScope.followup_schedule_data.mr_number,
                "visit_no": $rootScope.followup_schedule_data.visit_no,
                "followup_description": $rootScope.followup_schedule_data.followup_description,
                "remarks": $rootScope.followup_schedule_data.remarks,
                "lattitude": $rootScope.send_device_lattitude1,
                "longitude": $rootScope.send_device_longitude1,
                "scheduled_dt": $rootScope.followup_schedule_data.scheduled_dt,
                "actual_date": $filter('date')($rootScope.followup_schedule_data.actual_date, "yyyy-MM-dd"),
                "baby_status" : $rootScope.followup_schedule_data.baby_status,
                "sub_babystatus": $rootScope.followup_schedule_data.sub_babystatus,
                "fir_number": $rootScope.followup_schedule_data.fir_number,
                "notes": $rootScope.followup_schedule_data.notes,
                "baby_current_status": $rootScope.followup_schedule_data.baby_current_status,
                "dangers": $rootScope.followup_schedule_data.dangers,
                "updated_date": "",
                "mother_feeding": $rootScope.followup_schedule_data.mother_feeding,
                "my_health_app_usage": $rootScope.followup_schedule_data.my_health_app_usage,
                "account_email": authService.authentication.account_id
            }
           if($rootScope.show_alive_options == null){
                $rootScope.show_baby_status_error = true
           } else {
            if($rootScope.show_alive_options == false && $rootScope.show_fir_number == null){
                $rootScope.show_expired_error = true
            } else {
                dischargeService.updateFollowupDetailsById(params).then(function (response) {
                    if (response.success == 1) {
                        toastr.success("Updated successfully");
                        bootbox.hideAll();
                        if ($scope.getPatient == "") {
                            $scope.getFollowupScheduleByDate()
                        } else {
                            $scope.getFollowupScheduleById($rootScope.followup_schedule_data.sncu_id)
                        }
                    } else {
                        toastr.error("Unable to update");
                        // $scope.getFollowupScheduleById($rootScope.followup_schedule_data.sncu_id)
                    }
                })
            }
           }
        }

        $rootScope.showdiv = true
        $rootScope.datechanged = function(){
            $rootScope.showdiv = false
        }

}]);

function getTimeString(date) {
    var getHours, getMinutes, getSeconds;

    if(date.getHours()<10) {
        getHours = "0"+date.getHours();
    } else {
        getHours = date.getHours();
    }

    if(date.getMinutes()<10) {
        getMinutes= "0"+date.getMinutes();
    } else {
        getMinutes = date.getMinutes();
    }

    if(date.getSeconds()<10) {
        getSeconds = "0"+date.getSeconds();
    } else {
        getSeconds = date.getSeconds();
    }

   return getHours+":"+getMinutes+":"+getSeconds;
}


'use strict'
angular.module('AngularApp').controller('disinterestedBabyController', ['$scope', '$rootScope', '$filter', 'authService', 'multicenterstudyreportService', 'dischargeService', 'toastr',
function($scope, $rootScope, $filter, authService, multicenterstudyreportService, dischargeService, toastr) {

    $scope.reportNameShow = "true";
    $scope.homeVisitReportName = "";
    $scope.labelHide = true;

    var homeVisitUrlArr = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi).split('/');
    var homeVisitUrl = homeVisitUrlArr[homeVisitUrlArr.length-1];

    $rootScope.hv1Show = "false";
    $rootScope.hv2Show = "false";
    $scope.selected_param = "0";

    $scope.errMsg = "";
    $scope.errMsgShow = true;
    $scope.showContainer = false;

    $scope.completeBtnDisable = true;
    $scope.timeInputDisable = true;

    $scope.changeParam = function(value) {
        $scope.selected_param = value;
    }
    
    $scope.exportType = "";
    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        }
    };

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    $scope.exportData = function(type) {

        if($scope.patientRegistrationData) {
   
            $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
            var filename = "Not_Insterested_Baby_"+$scope.formattedDate;
            
            if($scope.selectedFromDate && $scope.selectedToDate){
                filename = "Not_Insterested_Baby_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
            }
            
           /* if(type=='csv') {

                alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
                
            } else*/
            if(type == 'excel') {

                //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                    var blob = new Blob([document.getElementById('printtable2').innerHTML], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    });
                 saveAs(blob, filename+".xls");

            } else if(type=='pdf') {

                var pdf_element = document.getElementById('printtable');
                var opt = {
                    margin:      0.2,
                    filename:   filename,
                    image:       { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF:       { unit: 'in', format: 'a3', orientation: 'landscape' }
                };
                    
                //New Promise-based usage:
                html2pdf().set(opt).from(pdf_element).save();
                    
            }
        }
    }

    $scope.showPieChart = function(data) {
    
            $('#pie_container1').highcharts({
            //Highcharts.chart('container', {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    borderColor: "black",
                    borderRadius:0,
                    borderWidth:"0"
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: 'Baby not interested', 
                    style: {
                      fontSize: '22px' 
                    }
                   
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '{point.percentage:.1f} %'
                        },
                        showInLegend: true
                    }
                },
                series: [{
                //name: 'Brands',
                    colorByPoint: true,
                    data: data
                }]
            });
        
            $( "#piechat_container" ).show();
    }

    function homevisitPieChartData(data) {
      console.log(data,"ppip")
            
        var tempArray = [
            {
            name: 'Not Interested',
            y: data['%_of_noninterested'],
            /*sliced: true,
            selected: true*/
            color: 'lightblue'
            },
            {
            name: 'Not Reachable',
            y: data['%_of_notreachable'], 
            color: 'pink'
            },
            {
            name: 'DroppedOff Inbetween',
            y: data['%_of_notreachable'], 
            color: 'pink'
            }
        ];
            
        $scope.showPieChart(tempArray);    
    }


    $scope.callPatientRegistrationApi = function(payload, callback) {
    
      multicenterstudyreportService.getnotinterestedReport(payload).then(function (response) {
            callback(response);
        }, function (err) {
        //toastr.error(err);         
        });
    }  

    $( "#piechat_container" ).hide();
    $scope.callPatientsReportsApi = function() {  
        
        var requestPayload = {
            account_email: authService.authentication.account_id,
            start_dt: $scope.selectedFromDate2,
            end_dt: $scope.selectedToDate2,
            district_id: $scope.district_id, 
            block_id: $scope.block_id,
            staff_id: $scope.staff_id,
            village_id: $scope.village_id
        }; 

        $scope.callPatientRegistrationApi(requestPayload, function returnCompliance(data) { 
            
            if(data.success == 1) {

                $scope.patientRegistrationData = [];
                $scope.patientTotal = [];

                $scope.patientRegistrationData = data.data;
                if($scope.patientRegistrationData['%_of_droppedoff_inbetween'] == ""){
                  $scope.patientRegistrationData['%_of_droppedoff_inbetween'] = 0
                }
                if($scope.patientRegistrationData['%_of_noninterested'] == ""){
                  $scope.patientRegistrationData['%_of_noninterested'] = 0
                }
                if($scope.patientRegistrationData['%_of_notreachable'] == ""){
                  $scope.patientRegistrationData['%_of_notreachable'] = 0
                }
                if($scope.patientRegistrationData['Total_droppedoff_inbetween'] == ""){
                  $scope.patientRegistrationData['Total_droppedoff_inbetween'] = 0
                }
                if($scope.patientRegistrationData['Total_notinterested'] == ""){
                  $scope.patientRegistrationData['Total_notinterested'] = 0
                }
                if($scope.patientRegistrationData['Total_notreachable'] == ""){
                  $scope.patientRegistrationData['Total_notreachable'] = 0
                }
                // $scope.patientTotal = data.grandtotal;
                    
                homevisitPieChartData(data.data);
                $scope.labelHide = false;
                // $scope.errMsg = "";

              /*$scope.errMsgShow = false;
                $scope.showContainer = true;
                $scope.completeBtnDisable = false;*/
          
            } else {
                $scope.patientRegistrationData = [];
                $scope.patientTotal = [];
                $scope.labelHide = true;
                if(data.message.msg == "unable to get disinterested Baby health status.."){
                  toastr.error('Select from & to date')
                }else{
                $scope.errMsg = data.message.msg;
                }
                $( "#piechat_container" ).hide();
            }
            
        /* else {
              document.getElementById("barchart1").innerHTML = "";
              $scope.errMsg = data.msg;
              $scope.errMsgShow = true;
              $scope.showContainer = false;
              $scope.completeBtnDisable = true;
          } */
        });
    }
    
    $scope.initHomeVisit = function() {
    
        $scope.hidetable2 = 'true';
        $scope.hidetable1 = 'true';
        $scope.exportType = "";
        $scope.selected_day = "1";
        $scope.fromDate = new Date();
        $scope.toDate = new Date();
        $scope.today_dt = new Date();
        
        var datArr  = getStringDate($scope.fromDate);
        var datArr2 = getStringDate($scope.toDate)
        $scope.selectedFromDate  = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.selectedToDate  = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
    }

    $scope.getDistricts = function() {

        $scope.hidetable2 = 'true';
        $scope.hidetable1 = 'true';
        $scope.completeBtnDisable = true;
        
        $scope.district_id = "0";  
        $scope.block_id    = "0";
        $scope.staff_id    = "0";
        $scope.village_id  = "0";

        $scope.selected_district = "";
        $scope.selected_block    = "";
        $scope.selected_vhn      = "";
        $scope.selected_village  = "";

        $scope.selected_district_name = "All";
        $scope.selected_block_name    = "All";
        $scope.selected_vhn_name      = "All";
        $scope.selected_village_name  = "All";
        
        $scope.districts_list = [];
        $scope.blocks_list    = [];
        $scope.vhn_list       = [];
        $scope.villages_list  = [];
        
        var param = {
        account_email: authService.authentication.account_id
        };
        
        dischargeService.getDistrictList(param).then(function (response) {
            $scope.districts_list = response;   
            if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){        
                $scope.selected_district_name = response[0].districtname;
                $scope.selected_district = response[0].id;    
                $scope.getBlocks(response[0].id);
            }
        }, function (error) {
            //toastr.error(error);
        });
    }

    $scope.getBlocks = function(id) {
        $scope.completeBtnDisable = true;

        if(id==null) {
        $scope.district_id = "0"; 
        } else {
        $scope.district_id = id+"";  
        } 

        $scope.hidetable2 = 'true';
        $scope.block_id   = "0";
        $scope.staff_id   = "0";
        $scope.village_id = "0";

        $scope.selected_block   = "";
        $scope.selected_vhn     = "";
        $scope.selected_village = "";

        $scope.selected_block_name   = "All";
        $scope.selected_vhn_name     = "All";
        $scope.selected_village_name = "All";
        
        $scope.blocks_list   = [];
        $scope.vhn_list      = [];
        $scope.villages_list = [];

        var param = { 
        account_email: authService.authentication.account_id,
        id: $scope.district_id 
        }     
        
        dischargeService.getBlockList(param).then(function (response) {
        $scope.blocks_list = response; 
        if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org"  || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){
            $scope.selected_block = response[0].id; 
            $scope.selected_block_name = response[0].blockname;
          //$scope.getVillages(response[0].id); 
            $scope.getVhn(response[0].id);
        }
        }, function (error) {
           //toastr.error(error);
        });
    }

    $scope.getVhn = function(block_id) { 

        $scope.completeBtnDisable = true;
        
        if(block_id==null) {
            $scope.block_id = "0"
            $scope.selected_block_name = "All"; 
        } else {
            $scope.block_id = block_id+""; 
            var tempArr = ($filter('filter')($scope.blocks_list, {'id':block_id})); 
            $scope.selected_block_name = tempArr[0].blockname; 
        }  

        $scope.vhn_id                = "0";
        $scope.village_id            = "0";
        $scope.selected_vhn          = "";
        $scope.selected_village      = "";
        $scope.selected_vhn_name     = "All";
        $scope.selected_village_name = "All";
        $scope.vhn_list              = [];
        $scope.villages_list         = [];
      //$scope.homevisitData();    
        
        var param = {	
            account_email: authService.authentication.account_id,
            id: $scope.block_id
        }
        
        dischargeService.getVhnList(param).then(function (response) {
        $scope.vhn_list = response;
        },function (error) {
        //toastr.error(error);
        });      
    } 
   
    $scope.getVillages = function(staff_id) {  

        $scope.completeBtnDisable = true;
        $scope.hidetable2 = 'true';

        if(staff_id==null) {
            $scope.staff_id          = "0";    
            $scope.selected_vhn_name = "All"; 
        } else {
            $scope.staff_id          = staff_id+""; 
            var tempArr              = ($filter('filter')($scope.vhn_list, {'staffid':staff_id})); 
            $scope.selected_vhn_name = tempArr[0].staffname;
        }
            
        $scope.village_id            = "0"; 
        $scope.selected_village      = "";
        $scope.selected_village_name = "All";
        $scope.villages_list         = [];

        var param = {	
        account_email: authService.authentication.account_id,
        id: $scope.staff_id
        }
        
        dischargeService.getStaffVillageList(param).then(function (response) {
            $scope.villages_list    = response;   
            $scope.selected_village = "";
        },function (error) {
          //toastr.error(error);
        });  
    }

    $scope.initHomeVisit();
    $scope.getDistricts();
 
  /*$scope.getPanchayats = function(id) { 
      $scope.block_id     = id;
      $scope.panchayat_id = "0";
      $scope.village_id   = "0";
    
      $scope.selected_panchayat = "";
      $scope.selected_village   = "";
      $scope.panchayat_list     = [];
      $scope.villages_list      = [];
    //$scope.homevisitData();    
        
      var param = {	
        account_email: authService.authentication.account_id,
        id: id
      }
      
      dischargeService.getPanchayatList(param).then(function (response) {
        $scope.panchayat_list = response;
      }, function (error) {
      //toastr.error(error);
      });      
    }*/

  $scope.changeVillage = function(id) {

    $scope.hidetable1 = 'true';
    if(id==null) {
      $scope.village_id            = "0";
      $scope.selected_village_name = "All";
    } else {
      $scope.village_id            = id+"";
      var tempArr                  = ($filter('filter')($scope.villages_list, {'village_id':id})); 
      $scope.selected_village_name = tempArr[0].villagename;  
      $scope.selected_village      = id;
    }
  }

  $scope.changeDay = function(day) {
 
    if(day=="5") {
      $scope.timeInputDisable = false;
      $scope.fromDate = "";
      $scope.toDate   = "";
      $scope.selectedFromDate = "";
      $scope.selectedToDate = "";
      $scope.selectedFromDate2 = "";
      $scope.selectedToDate2 = "";   
      $scope.hidetable1 = 'true';  
      $scope.hidetable2 = 'true';   

    } else {
      $scope.timeInputDisable = true;
    }
      
    switch (day) {
      case "4":
      //var tempArray = getPreviousDate(1,30);
        var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
        var datArr = getStringDate(new Date(prevMonthFirstDate));
        $scope.selectedFromDate = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.fromDate = new Date(prevMonthFirstDate);
        var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
        var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
        $scope.selectedToDate = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
        $scope.toDate = new Date(prevMonthLastDate); 
      break;
      case "3":
      //var tempArray = getPreviousDate(1,7);
        var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
        var datArr = getStringDate(new Date(startLastWeek));
        $scope.selectedFromDate = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.fromDate = new Date(startLastWeek);
        var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
        var datArr2 = getStringDate(new Date(endLastWeek));
        $scope.selectedToDate = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
        $scope.toDate = new Date(endLastWeek);
      break;
      case "2":
        var tempArray = getPreviousDate(1,1);
        $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
        $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
        $scope.selectedToDate = $scope.selectedFromDate; 
        $scope.selectedToDate2 = $scope.selectedFromDate2;  
        $scope.fromDate = tempArray;
        $scope.toDate   = $scope.fromDate;       
      break;
      case "1": 
        var datArr = getStringDate(new Date());
        $scope.selectedFromDate  = datArr[1];
        $scope.selectedFromDate2 = datArr[0];  
        $scope.selectedToDate  = $scope.selectedFromDate; 
        $scope.selectedToDate2 = $scope.selectedFromDate2;
        $scope.fromDate = new Date();
        $scope.toDate   = $scope.fromDate;
      break;
    }
  }

  $scope.byRange = function(from,to) {

    if(from) {
      $scope.rangePicker2 = {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date(),
          minDate: from
        }
      };
    }
  
    if(to) {
      $scope.rangePicker1 = {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: to
        }
      };    
    };
  
    if(from && to) {
      var datArr = getStringDate(from);
      $scope.selectedFromDate = datArr[1];
      $scope.selectedFromDate2 = datArr[0];
      var datArr2 = getStringDate(to);
      $scope.selectedToDate = datArr2[1];
      $scope.selectedToDate2 = datArr2[0];;
    //$scope.homevisitData();
    }
  }

}]);

'use strict';
angular.module('AngularApp').controller('emailnotifyController', ['$scope','$rootScope', '$location', 'authService','patientlistService','recordService','$ngBootbox', '$route',
function ($scope, $rootScope, $location, authService, patientlistService,recordService, $ngBootbox,$route) {

  $scope.datepicker= {
  opened :false,
  maxDate: new Date(),
  open:function(){
    $scope.datepicker.opened=true;
  },
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 1,

    }
  };
 
  $scope.validate = false;

  $scope.submits = function (sendNotification) {
    $rootScope.showSpinner = true;
    $scope.validate = true;
    if(sendNotification.$valid){
       $scope.data.patientList = [];
       $scope.data.recipients=[];
          if($scope.data.recipient=='allPatients')
          {
           $scope.data.recipients.push($rootScope.doctorAccountId);
          }else if($scope.data.recipient=='group')
          {
            for(i=0; i < $scope.multipleCarenet.colors.length; i++ ){
                $scope.data.recipients.push($scope.multipleCarenet.colors[i]['id']);
              }
           if($scope.multipleCarenet.colors.length==0)
             {
              alert("Choose atleast one group");
              return;
             }
          }
          else if($scope.data.recipient=='choosePatients')
          {
              for(i=0;i<$scope.multiplePatient.patients.length;i++){
                $scope.data.recipients.push($scope.multiplePatient.patients[i]['accountId']);
              };
             if($scope.multiplePatient.patients.length==0)
             {
              alert("Choose atleast one patient");
              return;
             }
          }
    }

    var growthData = {
        "account_id":  $rootScope.doctorAccountId,
        "type": $scope.data.recipient,
        "recipients": $scope.data.recipients,
        "subject": $scope.data.subject,
        "body": $scope.data.message,
        "priority": $scope.data.priority
        };
           recordService.emailData(growthData).then(function(response){
            $route.reload();
            $rootScope.showSpinner = false;
            },function (err, response) {
                       $ngBootbox.alert(err.Message);
                       $rootScope.showSpinner = false;
                       $route.reload();
          });
  };

 

   $scope.getPatientSearch = function(searchTerm){
     //search all patients
            return $rootScope.patientList.filter(function(item){
               
                return item.label.toLowerCase().indexOf(searchTerm.toLowerCase())>=0;
             
            });
     };

     $scope.getGroupSearch = function(searchTerm1){
     //search all groups
            return $rootScope.carenetRecords.filter(function(item){
                return item.name.toLowerCase().indexOf(angular.lowercase(searchTerm1))>=0;

            });
     };



  $scope.multipleCarenet = {};
  $scope.multipleCarenet.colors =[];

  $scope.multiplePatient = {};
  $scope.multiplePatient.patients = [];

  

$scope.searchPatient = function(){
            $location.path('../patientview/'+$scope.selectedRecordId);
             $scope.selectedRecordId1=null;
            $scope.selectedRecordName1 = '';
};


 $scope.patientSearchSelect = function(item, model, label){
        setTimeout(function(){
            $('#txtPatientSearch1').blur();
            $scope.selectedRecordName1 = model;
            $scope.selectedRecordId1 = item.id;
            $scope.$apply();
        },100);
    };

  $scope.GroupSearchSelect = function(item, model, label){
        setTimeout(function(){
            $('#txtGroupSearch1').blur();
            $scope.selectedRecordName2 = model;
            $scope.selectedRecordId2 = item.id;
            $scope.$apply();
        },100);
    };  

}]);
'use strict';
angular.module('AngularApp').controller('engagementController', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'engagementService', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, engagementService) {

    $scope.imageUploadUrl = authService.helyxonApi.url + 'cloud/image/upload/'; 

    $scope.choicesA = [{
        id: 'choice1',
        choicesB: []
    }];

    $scope.addNewChoiceB = function (choice) {
        var newItemNo = choice.choicesB.length + 1;
        choice.choicesB.push({
            'id': 'choice' + newItemNo
        });
    };

    //to count Text content
    $('textarea').keypress(function () {
        if (this.value.length > 160) {
            return false;
        }
        $("#remainingC").html("Remaining characters : " + (160 - this.value.length));
    });

    //button color
    $(document).ready(function () {
        $("input[type='radio']").click(function () {
            $(this).css('background-color', 'red');
        });
    });
       
    $scope.doctor_email         =  authService.authentication.account_id;
    $scope.reminderdays_button  =  false;
    $scope.reminderdays_plus    =  true;
    $scope.reminderdays_minus   =  true;
    $scope.message_status       =  'new';
    $scope.reminderPlusMinus    =  "";
    // $scope.reminder_type        =  "";
    $scope.reminderTitle        =  "Reminder";

    $scope.radiotoggle = function(data){
        console.log("data", data);
        if(data == 1){
            $scope.remain_follow = 1
            $scope.toggleshow = false;
        }else if(data == 2){
            $scope.remain_follow = 2
            $scope.toggleshow = true;
        }
    }

    $scope.radiotoggle(1);

    $scope.reminder_days_button = function (value) {
        console.log("value", value)
        // alert(value)
        $scope.reminderdays_button = true;
        // if($scope.reminderPlusMinus == value) {
        //     $scope.reminderdays_plus = true;
        //     $scope.reminderdays_minus = true;
        //     $scope.reminderPlusMinus = "";
        //     document.getElementById("labSel2").style.color = "black";
        //     document.getElementById("labSel1").style.color = "black"; 
        //     $scope.reminder_type = 0;         
        // }
         if (value == "plus") {
            $scope.reminderdays_plus = false;
            $scope.reminderdays_minus = true;
            // document.getElementById("labSel2").style.color = "#ff6600";
            document.getElementById("labSel2").style.color = "black";
            document.getElementById("labSel1").style.color = "black";
            $scope.reminderPlusMinus = value;
            // $scope.reminder_type = 2
            if($scope.reminderData.reminder_number >= 0){
                $scope.reminderData.reminder_number += 1
            }
        } else if (value == "minus") {
            $scope.reminderdays_plus = true;
            $scope.reminderdays_minus = false;
            document.getElementById("labSel2").style.color = "black";
            document.getElementById("labSel1").style.color = "black";
            // document.getElementById("labSel1").style.color = "#ff6600";
            $scope.reminderPlusMinus = value;
            // $scope.reminder_type = 1;
            if($scope.reminderData.reminder_number > 0){
                $scope.reminderData.reminder_number -= 1
            }
        } else if (value == 'before') {
            $scope.reminder_type = 1
            $scope.reminderPlusMinus = 'minus';
        } else if (value == 'after'){
            $scope.reminder_type = 2
            $scope.reminderPlusMinus = 'plus';
        }
    }


    $scope.reminderData  = { subject: "", body: "", attachments_count: 0, creator: "", message_media: "", message_type: "", reminder_number: 0, reminder_type: 0, attachmentfilepath: "", attachmentfilename: "" };
    $scope.reminderArray = [];

    $scope.reminder_status = 'new';
    $scope.reminder_index  = null;

    $scope.deleteReminder = function (id){
        var payload = {
          account_email: authService.authentication.account_id,
          id: id,
        }
       
        engagementService.deleteReminderMsg(payload).then(function (response) {
            //toastr.success(response.response);
        });
    }

    $scope.saveReminderId = function (id){
        $scope.deletionReminderId = id;
    }

    $scope.reminderPopup = function (status, index, data) {
        console.log("status, index, data", status, index, data);
        console.log("110", $scope.showtitle);

        switch (status) {
            case 'add':
                if ($scope.reminder_status == 'new') {

                    // $scope.reminder_type == ''
                    if ($scope.reminderdays_plus == false) {
                      //$scope.reminder_number = data.reminder_number;
                        $scope.reminder_type = 2;
                    } else if ($scope.reminderdays_minus == false) {
                      //$scope.reminder_number = "-" + data.reminder_number;
                        $scope.reminder_type = 1;
                    } else {
                        $scope.reminder_type = 0;
                    }

                    if ($scope.message_media != undefined && $scope.message_type != undefined && ( data.reminder_number!==" " || data.reminder_number!=="" ) ){
                        
                        if((data.reminder_number!==0 &&  $scope.reminder_type !==0 && $scope.reminder_type !=="" ) || (data.reminder_number===0 && $scope.reminder_type ===0 ) ){
                            if(!$scope.reminderArray){
                            $scope.reminderArray=[];
                            }
                            $('#myModal').modal('hide');
                            $scope.reminderArray.push({ subject: data.subject, body: data.body, attachments_count: 0, creator: $scope.doctor_email, message_media: $scope.message_media, message_type: $scope.message_type, reminder_number: data.reminder_number, reminder_type: $scope.reminder_type, attachmentfilename: "", attachmentfilepath: "" });
                            $scope.reminderData = { subject: "", body: $scope.reminder_content, attachments_count: 0, creator: "", message_media: "", message_type: "", reminder_number: 0, reminder_type: 0, attachmentfilepath: "", attachmentfilename: "" };
                           
                                $scope.multicheck1 = {
                                    media1: null,
                                    media2: null
                                }   
                                $scope.multicheck2 = {
                                    msg1: null,
                                }
                                $scope.message_media = undefined;  
                                $scope.message_type = undefined;
                                document.getElementById("msg_media_check1").checked = false;
                                document.getElementById("msg_media_check2").checked = false;
                                document.getElementById("msg_type_check1").checked = false;
                                document.getElementById("labSel1").style.color = "black";
                                document.getElementById("labSel2").style.color = "black";
                                $scope.reminderdays_plus = true;
                                $scope.reminderdays_minus = true;
                                $scope.reminderPlusMinus = "";
                                $scope.deletionReminderId = undefined;
                    } else {
                            
                              if(data.reminder_number===0 &&  ($scope.reminder_type !==0 && $scope.reminder_type !=="") ) {
                               
                                    alert('Please change days value in Rule (or) Unselect (+/-)');
        
                              } else if(data.reminder_number!==0 &&  ($scope.reminder_type ===0 || $scope.reminder_type ==="") ) {

                                    alert('Please Select any (+/-) in Rule.');
                              }
                        }

                    } else {

                        if(data.reminder_number===0 &&  ($scope.reminder_type !==0 && $scope.reminder_type !=="" && $scope.showtitle != true) ) {
                               
                                alert('Please change days value in Rule (or) Unselect (+/-)');
    
                        } else if(data.reminder_number!==0 &&  ($scope.reminder_type ===0 || $scope.reminder_type ==="") ) {

                                alert('Please Select any (+/-) in Rule.');
                        }

                        if(($scope.message_media == undefined)&& ($scope.showtitle == true)){
                            $scope.message_media = "1001"
                            $scope.message_type = 1
                            console.log("data 181", data);
                            console.log('$scope.reminderArray', $scope.reminderArray);
                            
                            if($scope.reminderArray ){
                                $scope.reminderArray=[];
                            $scope.reminderArray.push({ 
                                subject: data.subject, 
                                body: data.body, 
                                attachments_count: 0, 
                                creator: $scope.doctor_email, 
                                message_media: "1001", 
                                message_type: 1, 
                                reminder_number: 7, 
                                reminder_type: 1, 
                                attachmentfilename: "", 
                                attachmentfilepath: "" 
                            });

                            console.log(" $scope.reminderArray 198",  $scope.reminderArray);
                                            
                            $scope.reminderData = { 
                                subject: "", 
                                body: $scope.reminder_content, 
                                attachments_count: 0, 
                                creator: "", 
                                message_media: "", 
                                message_type: "", 
                                reminder_number: 0, 
                                reminder_type: 0, 
                                attachmentfilepath: "", 
                                attachmentfilename: "" 
                            };
                
                            console.log(" $scope.reminderArray 139",  $scope.reminderArray);
                            $('#myModal').modal('hide');
                        }
                        }
                      
                        if ($scope.message_media == undefined) {
                                alert('Please give message media.');
                        }

                        if ($scope.message_type == undefined) {
                                alert('Please give message type.');
                        }
                       
                    }

                } else if ($scope.reminder_status == 'edit') {

                   if ($scope.message_media != undefined && $scope.message_type != undefined && ( data.reminder_number!==" " || data.reminder_number!=="" ) ){
                        
                    if((data.reminder_number!==0 &&  $scope.reminder_type !==0 && $scope.reminder_type !=="" ) ||  (data.reminder_number===0 && $scope.reminder_type ===0 ) ){

                 /* if ($scope.reminderdays_plus == false) {
                        //$scope.reminder_number = data.reminder_number;
                        $scope.reminder_type = 1;
                    } else if ($scope.reminderdays_minus == false) {
                        //$scope.reminder_number = "-" + data.reminder_number;
                        $scope.reminder_type = 2;
                    } else {
                        //$scope.reminder_number = null;
                        $scope.reminder_type = 0;
                    } */


                    if ($scope.message_media == undefined) {
                        $scope.message_media = data.message_media;
                    }

                    if ($scope.message_type == undefined) {
                        $scope.message_type = data.message_type;
                    }

                    if ($scope.message_media == "1000" || $scope.message_media == 1000) {
                
                        document.getElementById("msg_media_check1").checked = true;
                        document.getElementById("msg_media_check2").checked = true;
                    }else if($scope.message_media == 3) {
                        document.getElementById("msg_media_check1").checked = false;
                        document.getElementById("msg_media_check2").checked = false;
                        document.getElementById("msg_media_check_4").checked = true;
                        document.getElementById("msg_media_check_5").checked = false;

                    }else if($scope.message_media == 4) {
                        document.getElementById("msg_media_check1").checked = false;
                        document.getElementById("msg_media_check2").checked = false;
                        document.getElementById("msg_media_check_5").checked = true;
                        document.getElementById("msg_media_check_4").checked = false;
                    }
                    
                    // else {
                    //     document.getElementById("msg_media_check" + $scope.message_media).checked = true;
                    // }

                    // document.getElementById("msg_type_check" + $scope.message_type).checked = true;

                    if ($scope.reminderArray[$scope.reminder_index].id == undefined) {
                        
                        $('#myModal').modal('hide');
                        $scope.reminderArray[$scope.reminder_index] = { subject: data.subject, body: data.body, attachments_count: 0, creator: $scope.doctor_email, message_media: $scope.message_media, message_type: $scope.message_type, reminder_number: data.reminder_number, reminder_type: $scope.reminder_type, attachmentfilename: "", attachmentfilepath: "" };
                        $scope.reminder_index = null;

                    } else {
                        $('#myModal').modal('hide');
                        $scope.reminderArray[$scope.reminder_index] = { id: $scope.reminderArray[$scope.reminder_index].id, reminder_id: $scope.reminderArray[$scope.reminder_index].reminder_id, message_attachment_id: $scope.reminderArray[$scope.reminder_index].message_attachment_id, subject: data.subject, body: data.body, attachments_count: 0, creator: $scope.doctor_email, message_media: $scope.message_media, message_type: $scope.message_type, reminder_number: data.reminder_number, reminder_type: $scope.reminder_type, attachmentfilename: "", attachmentfilepath: "" };
                        $scope.reminder_index = null;
                     }

                    $scope.reminderData = { subject: "", body: $scope.reminder_content, attachments_count: 0, creator: "", message_media: "", message_type: "", reminder_number: 0, reminder_type: 0, attachmentfilepath: "", attachmentfilename: "" };                
                  
                        $scope.multicheck1 = {
                            media1: null,
                            media2: null
                        }
                        $scope.multicheck2 = {
                            msg1: null,
                        }
                        $scope.message_media = undefined;  
                        $scope.message_type = undefined;
                        document.getElementById("msg_media_check1").checked = false;
                        document.getElementById("msg_media_check2").checked = false;
                        document.getElementById("msg_type_check1").checked = false;
                        document.getElementById("labSel1").style.color = "black";
                        document.getElementById("labSel2").style.color = "black"; 
                        $scope.reminderdays_plus = true;
                        $scope.reminderdays_minus = true;
                        $scope.reminderPlusMinus = "";
                        $scope.deletionReminderId = undefined;

                    } else {

                        if(data.reminder_number===0 &&  ($scope.reminder_type !==0 && $scope.reminder_type !=="" && $scope.showtitle != true) ) {
                               
                            alert('Please change days value in Rule (or) Unselect (+/-)');
    
                        } else if(data.reminder_number!==0 &&  ($scope.reminder_type ===0 || $scope.reminder_type ==="") ) {

                            alert('Please Select any (+/-) in Rule.');
                        }

                    }

                } else {
                    
                    if(data.reminder_number===0 &&  ($scope.reminder_type !==0 && $scope.reminder_type !=="") ) {
                               
                        alert('Please change days value in Rule (or) Unselect (+/-)');

                    } else if(data.reminder_number!==0 &&  ($scope.reminder_type ===0 || $scope.reminder_type ==="") ) {

                        alert('Please Select any (+/-) in Rule.');
                    }

                    console.log("$scope.showtitle0", $scope.showtitle);
                  
                  
                    if ($scope.message_media == undefined) {
                      
                            alert('Please give message media.');
                    }

                    if ($scope.message_type == undefined) {
                            alert('Please give message type.');
                    }
                   
                }
            }              
            break;
            case 'edit':
                $scope.reminder_status = 'edit';
                $scope.reminder_index = index;
                var data = $scope.reminderArray[index];
                 console.log("291", data.reminder_type);
                if(data.reminder_type=="2"){
                    $scope.reminderdays_plus = false;
                    $scope.reminderdays_minus = true;
                    // document.getElementById("labSel2").style.color = "#ff6600";
                    document.getElementById("labSel2").style.color = "black";
                    document.getElementById("labSel1").style.color = "black";
                    $scope.reminderPlusMinus = "plus";
                    $scope.reminder_type = 2;
                    console.log("data 299", data);
                    $scope.reminderData.subject = data.subject;
                    $scope.reminderData.body = data.body;
                } else if(data.reminder_type=="1") {
                    $scope.reminderdays_plus = true;
                    $scope.reminderdays_minus = false;
                    // document.getElementById("labSel1").style.color = "#ff6600";
                    document.getElementById("labSel1").style.color = "black";
                    document.getElementById("labSel2").style.color = "black";
                    $scope.reminderPlusMinus = "minus";
                    $scope.reminder_type = 1;
                    $scope.reminderData.subject = data.subject;
                    $scope.reminderData.body = data.body;
                } else  {
                    console.log("data.reminder_type",data.reminder_type)
                    $scope.reminderdays_plus = true;
                    $scope.reminderdays_minus = true;
                    document.getElementById("labSel1").style.color = "black";
                    document.getElementById("labSel2").style.color = "black";
                    $scope.reminderPlusMinus = "";
                    $scope.reminder_type = 0;
                    $scope.reminderData.subject = data.subject;
                    $scope.reminderData.body = data.body;
                }

                if(data.body!=="" || data.message_type==1){
                    $scope.hide_msg_area = false;
                } else {
                    $scope.hide_msg_area = true;
                }

                if($scope.message_media == undefined) {
                    $scope.message_media = data.message_media;
                }

                if($scope.message_type == undefined) {
                    $scope.message_type = data.message_type;
                }

            


                if(data.message_media == "1000" || data.message_media == 1000) {
                    $scope.multicheck1.media1 = true
                    $scope.multicheck1.media2 = true
                    document.getElementById("msg_media_check1").checked = true;
                    document.getElementById("msg_media_check2").checked = true;
                } else {
                //     document.getElementById("msg_media_check1" + data.message_media).checked = true;
                //    if(document.getElementById("msg_media_check2" + data.message_media).value == "1"){
                //     $scope.multicheck1.media1 = true
                //    } else if(document.getElementById("msg_media_check1" + data.message_media).value){
                //     $scope.multicheck1.media2 = true
                //    }
                }
                document.getElementById("msg_type_check" + data.message_type).checked = true;
                $scope.reminderData = { subject: data.subject, body: data.body, attachments_count: 0, creator: $scope.doctor_email, message_media: $scope.message_media, message_type: $scope.message_type, reminder_number: data.reminder_number, reminder_type: $scope.reminder_type, attachmentfilename: "", attachmentfilepath: "" };
            break;
            case 'delete':
                if($scope.deletionReminderId!=undefined) {
                    if($scope.message_status=='update') {
                        if($scope.reminderArray[$scope.deletionReminderId].id) {
                            $scope.deleteReminder($scope.reminderArray[$scope.deletionReminderId].id);
                            $scope.reminderArray.splice($scope.deletionReminderId, 1);
                            $scope.deletionReminderId = undefined;
                        } else {
                            $scope.reminderArray.splice($scope.deletionReminderId, 1);
                            $scope.deletionReminderId = undefined;
                        }
                    } else {
                        $scope.reminderArray.splice($scope.deletionReminderId, 1);
                        $scope.deletionReminderId = undefined;
                    }
                }
            break;
            case 'new':
                $scope.reminderData = { subject: "", body: $scope.reminder_content, attachments_count: 0, creator: "", message_media: "", message_type: "", reminder_number: 0, reminder_type: 0, attachmentfilepath: "", attachmentfilename: "" };
                $scope.reminder_status = 'new';
                $scope.reminder_index = null;
                $scope.reminderdays_button = false;
                $scope.reminderdays_plus = true;
                $scope.reminderdays_minus = true;
                $scope.reminderPlusMinus = "";
                $scope.hide_msg_area = true;
                $scope.deletionReminderId = undefined;
                document.getElementById("msg_media_check1").checked = false;
                document.getElementById("msg_media_check2").checked = false;
                document.getElementById("msg_type_check1").checked = false;
                document.getElementById("labSel1").style.color = "black";
                document.getElementById("labSel2").style.color = "black";
                // $scope.reminder_type = ''
            break;
            default:
                $scope.reminderData = { subject: "", body: $scope.reminder_content, attachments_count: 0, creator: "", message_media: "", message_type: "", reminder_number: 0, reminder_type: 0, attachmentfilepath: "", attachmentfilename: "" };
                $scope.reminder_status = 'new';
                $scope.reminder_index = null;
                $scope.deletionReminderId = undefined;
            break;
        }
    }

    $scope.select_frequency1 = true;
    $scope.select_frequency2 = true;

    $scope.changeFrequency = function (value) {

        switch (value) {
            case "1":
                $scope.select_frequency1 = true;
                $scope.select_frequency3 = false;
                //$scope.select_frequency2 = false;
                if($scope.updateEngageShow == "false"){
                    $scope.engageTime = {
                      value: new Date(1970, 0, 1, 0, 0, 0)
                    };
                } else if($scope.updateEngageShow == "true") {
                    $scope.updateEngageShow = "false";
                }
            break;
            case "2":
               // $scope.select_frequency2 = true;
                $scope.select_frequency3 = true;      
                $scope.select_frequency1 = false;           
            break;
            case "3":
                //$scope.select_frequency2 = true;
                $scope.select_frequency1 = false;
                $scope.select_frequency3 = false;
            break;
            case "4":
                $scope.select_frequency1 = true;
                $scope.select_frequency3 = false;
                //$scope.select_frequency2 = false;
                if($scope.updateEngageShow == "false"){
                    $scope.engageTime = {
                       value: new Date(1970, 0, 1, 0, 0, 0)
                    };
                } else if($scope.updateEngageShow == "true") {
                    $scope.updateEngageShow = "false";
                }
            break;
            default:
            break;
        }
    }

    $scope.hide_msg_area = true;
    $scope.hide_img_vdo = true; 

    $scope.changeCheckBoxReminder = function (value,bool) {
        switch (value) {
            case "1":
                if($scope.hide_img_vdo!=false){
                    $scope.hide_img_vdo = true;
                }
                if(bool==true){
                    $scope.hide_msg_area = false;
                }else{
                    $scope.hide_msg_area = true; 
                }
            break;
            case "2":
                if($scope.hide_msg_area!=false){
                    $scope.hide_msg_area = true; 
                }
                if(bool==true){
                    $scope.hide_img_vdo = false; 
                }else{
                    $scope.hide_img_vdo = true;
                }               
            break;
            default:
            break;
        }
    }

    $scope.Date = new Date();

    $scope.byRange = function (date) {
        $scope.engage_date = $filter('date')(date, "yyyy-MM-dd");
    }

    function stringDate(date){
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
       return "" + day + "/" + month + "/" + year;
    }
      
    function parseDate(str) {
        var mdy = str.split('/');
       return new Date( mdy[2], mdy[1], mdy[0] );
    }

    function datediff(first, second) {
        return Math.round((second-first)/(1000*60*60*24));
    }

    $scope.rangePicker= {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          minDate: new Date()
        }
    };

    $scope.time24Hrs = function (date) {
        var dateTime = new Date(date);
        var hours = dateTime.getHours();
        var minutes = dateTime.getMinutes();
        var seconds = dateTime.getSeconds();
        if (hours < 10) {
           hours = "0" + hours;
        }
        if (minutes < 10) {
           minutes = "0" + minutes;
        }
        if (seconds < 10) {
           seconds = "0" + seconds;
        }
      return hours + ":" + minutes + ":" + seconds;
    }

    $scope.convert_to_24hrs=function(time_str) {
        var str   = time_str.split(' ');
        var stradd  = str[0].concat(":00");
        var strAMPM = stradd.concat(' '+str[1]);
        var time = strAMPM.match(/(\d+):(\d+):(\d+) (\w)/);
        var hours = Number(time[1]);
        var minutes = Number(time[2]);
        var seconds = Number(time[2]);
        var meridian = time[4].toLowerCase();
      
          if (meridian == 'p' && hours < 12) {
            hours = hours + 12;
          }
          else if (meridian == 'a' && hours == 12) {
            hours = hours - 12;
          } 
    
          hours   = hours < 10 ? '0'+hours : hours;
          minutes = minutes < 10 ? '0'+minutes : minutes;  
          seconds = seconds < 10 ? '0'+seconds : seconds; 
    
          var marktimestr = ''+hours+':'+minutes+':'+seconds;     
      return marktimestr;
    };

    function tConvert (time) {
      //Check correct time format and split into components
        time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
        if (time.length > 1) { // If time format correct
            time = time.slice (1);  // Remove full string match value
            time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        var timeString =  time.join (','); // return adjusted time or original string
        timeString = timeString.split(",");
        var returnTime = "";
        if( parseInt(timeString[0])<10 && parseInt(timeString[0])>0 ) {
           returnTime = '0'+timeString[0]+':'+timeString[2]+' '+timeString[5];
        } else {
           returnTime = timeString[0]+':'+timeString[2]+' '+timeString[5];
        }  
        
      return returnTime;      
    }
          
    $scope.engageTime = {
        value: new Date(1970, 0, 1, 0, 0, 0)
    };

    $scope.checkActive = function (value) {
        
        if(value=='active') {
            $scope.engageData.message_status = true;
        } else if(value=='inactive') {
            $scope.engageData.message_status = false;
        }    
    }

    $scope.change_target_users = function (value) {
            
        $scope.engageData.target_users = value;
        $scope.engageData.engagement_category = "";
        $scope.reminderBtnEnable = "true";

        $(".msg_category1").attr("checked",false);
      /*$(".msg_category2").attr("checked",false);
        $(".msg_category3").attr("checked",false); 
 
        if( value==1 ) {
            $(".msg_category2").prop("disabled",true);
            $(".msg_category2").css({"color":"lightgray"}); 
            $(".msg_category1").prop("disabled",false);
            $(".msg_category1").css({"color":"unset"});
            $(".msg_category3").prop("disabled",false);
            $(".msg_category3").css({"color":"unset"}); 
        } else if( value==2 ) {
            $(".msg_category1").prop("disabled",true);
            $(".msg_category1").css({"color":"lightgray"}); 
            $(".msg_category2").prop("disabled",false);
            $(".msg_category2").css({"color":"unset"});   
            $(".msg_category3").prop("disabled",false);
            $(".msg_category3").css({"color":"unset"});     
        }
      */

    }

    $scope.radio_value = 2;
    $scope.checkRadio = function (value) {
        $scope.engageData.engagement_category = value;
        $scope.reminderBtnEnable = "false";  
        if(value == "11"){
            $scope.setbirthfreq = true
            $scope.engageData.engagement_frequency = "1"
            $scope.select_frequency1 = true;
            $scope.select_frequency3 = false;
        }  else {
            $scope.setbirthfreq = false;
        }
        if(value == '0'){
            $scope.engageData.engagement_category = '2';
            $scope.reminderTitle     =  "Vaccination - Follow Up";
            $scope.reminder_content  =  '<baby name>\n'+
                                            '<vaccination due date>\n'+
                                            '<tiny url>';
           
            $scope.toggleshow = true;
            $scope.showtitle = true
            $rootScope.rule_type = "followup"
        }else if(value=='1') {
            $scope.reminderTitle     =  "Consultation";
            $scope.reminder_content  =  '<baby name>\n'+
                                          '<followup due date>\n'+
                                          '<tiny url>';
            $scope.toggleshow = false;
            $scope.showtitle = false;
            $rootScope.rule_type = "Consultation"
           //document.getElementById("reminderBody").value=reminder_content1; 
        } else if(value=='2') {
            $scope.reminderTitle     =  "Vaccination - Reminder";
            $scope.reminder_content  =  '<baby name>\n'+
                                            '<vaccination due date>\n'+
                                            '<tiny url>';
            $scope.toggleshow = false;
            $scope.showtitle = false;
            $rootScope.rule_type = "Reminder"
           //document.getElementById("reminderBody").value=reminder_content2; 
        } else if(value=='14') {
            $scope.reminderTitle     =  "Broadcast";
            $scope.reminder_content  =  'Dear Parent of <baby name>\n'+
                                        '<Dr Name>';
            $scope.toggleshow = false;
            $scope.showtitle = false;
            $rootScope.rule_type = "Broadcast"
        } else if(value=='11') {
            $scope.reminderTitle     =  "Birthday";
            $scope.reminder_content  =  'Dear <baby_name>\n'+
                                        'Happy Birthday Greetings!\n'+
                                        '<tiny url>';
            $scope.toggleshow = false;
            $scope.showtitle = false;
            $rootScope.rule_type = "Birthday"
        } else if(value=='5'){
            $scope.reminderTitle     =  "Milestone";
            $scope.reminder_content  =  'Dear Parent\n'+
                                        'Please upload <milestone name> milestone details of your baby <baby name> before <milestone due date>.\n'+
                                        '<tiny url>';
            $scope.toggleshow = false;
            $scope.showtitle = false;
            $rootScope.rule_type = "Milestone";
       } else if(value == '27'){
            // alert($scope.engageData.engagement_category)
            $scope.engageData.engagement_category = '27';
            $scope.reminderTitle     =  "Subscription - Followup";
            $scope.reminder_content  =  'Dear <child_name>\n'+
                                        'Your Subscription <plan_name> will end on <date>. Please Renew Your plan.\n'+
                                        '<tiny url>';
            // $scope.reminder_content = document.getElementById('reminderBody').value
            $scope.toggleshow = false;
            $scope.showtitle = false;
            $rootScope.rule_type = "subscription";
       } else {
        $scope.reminderTitle = ""
        $scope.reminder_content = ""
       }
    }
    
    $scope.multicheck1 = {
        media1: null,
        media2: null
    }

    $scope.multicheck2 = {
        msg1: null,
    }

    $scope.multicheck = function(data){
        $scope.multicheck1 = {
            media1: false,
            media2: false
        }

        if(data == 'email'){
            $scope.message_media = "3";
            $scope.ivrs = false;
            // $scope.reminder_type = 1;
            $scope.reminder_number = 0
        }else if(data == 'ivrs'){
            $scope.message_media = "4";
            $scope.email = false;
            // $scope.reminder_type = 1;
            $scope.reminder_number = 0
        }

    }

    $scope.multiCheckFunc = function (key, value) {

        if (key == 1) {

            if ($scope.multicheck1.media1 == true && $scope.multicheck1.media2 == true) {
                $scope.message_media = "1000";
            } else if ($scope.multicheck1.media1 == true ) {
                $scope.message_media = "1";
                $scope.email = false;
                $scope.ivrs = false;
            } else if ($scope.multicheck1.media2 == true) {
                $scope.message_media = "2";
                $scope.email = false;
                $scope.ivrs = false;
            } else {
                $scope.message_media = undefined;
            }

        } else if (key == 2) {

            if (value == true) {
                $scope.message_type = "1";
            } else {
                $scope.message_type = undefined;
            }
        }
    }

    $scope.addEngage = function (data) {

        console.log("data 795", data);

        var engagePayload;
        $scope.byRange($scope.Date);
      //$scope.engage_time = /*$scope.engage_date+"T"+*/$scope.time24Hrs($scope.engageTime.value);//+"Z";

        $scope.freq_daySelected = 'true';
        if(data.engagement_frequency==2) {
            if(data.engagement_frequency_day=="") {
                $scope.freq_daySelected = 'false';
                alert('Please select frequency day.');
            } else {
                $scope.freq_daySelected = 'true';
            }
        }

        var days = datediff( parseDate(stringDate(new Date())), parseDate(stringDate($scope.Date)) );
        $scope.freq_timeSelected  = 'true';
   
        if(data.engagement_frequency==1 || data.engagement_frequency==4) {
            if($scope.engage_time) {
                if( days==0 ) {
                    var d = new Date(); 
                    d = d.getHours();
                    var b = $scope.engage_time.split(":");
                    b = b[0];  

                    if( parseInt(b) <= parseInt(d) ){ 
                        $scope.freq_timeSelected  = 'false'                     
                        alert('Please give future time');
                    }
                } else {
                    $scope.freq_timeSelected  = 'true'; 
                }  

            } else {
               $scope.freq_timeSelected  = 'true';    
               $scope.engage_time = "00:00:00";
            }
        } else {
            $scope.freq_timeSelected  = 'true';    
            $scope.engage_time = "07:00:00";
        }

      //if( ( parseInt(data.start_age) < parseInt(data.end_age) ) && $scope.reminderArray.length != 0 ) {
        if( ((parseInt(data.start_age)==0 &&  parseInt(data.end_age)==0)  ||  (parseInt(data.start_age) < parseInt(data.end_age))) && $scope.reminderArray && $scope.reminderArray.length!=0 && $scope.freq_daySelected!='false' && $scope.freq_timeSelected != 'false') {

            if ($scope.message_status == 'new') {

                engagePayload = {
                    account_email: $scope.doctor_email,
                    engagement_name: data.engagement_name,
                    start_age: data.start_age,
                    end_age: data.end_age,
                    target_users: data.target_users,
                    engagement_frequency: data.engagement_frequency,
                    engagement_frequency_day: data.engagement_frequency_day,
                    engagement_scheduled_time: $scope.engage_time,
                    gender: data.gender,
                    location: data.location,
                    engagement_category: parseInt(data.engagement_category),
                    engagement_scheduled_dt: $scope.engage_date,
                    message_status: data.message_status,
                    reminders: $scope.reminderArray,
                    rule_type: $rootScope.rule_type,
                    doctor_name: authService.authentication.doctor_name,
                };
                  console.log("806 engagePayload", engagePayload);
                engagementService.addEngageMessage(engagePayload).then(function (response) {
                    if(response.status == 0){
                        toastr.error(response.message);
                    }else {
                        toastr.success('Message saved successfully..');
                        $location.path('/engage-master');
                    }
                    
                }
                );

            } else if ( $scope.message_status == 'update' ) {

                engagePayload = {
                    account_email: $scope.doctor_email,
                    engagement_name: data.engagement_name,
                    start_age: data.start_age,
                    end_age: data.end_age,
                    target_users: data.target_users,
                    engagement_frequency: data.engagement_frequency,
                    engagement_frequency_day: data.engagement_frequency_day,
                    gender: data.gender,
                    location: data.location,
                    engagement_category: parseInt(data.engagement_category),
                    engagement_scheduled_dt: $scope.engage_date,
                    engagement_scheduled_time: $scope.engage_time,
                    message_status: data.message_status,
                    id: parseInt($scope.engageUpdateId),
                    reminders: $scope.reminderArray,
                    rule_type: $rootScope.rule_type,
                    doctor_name: authService.authentication.doctor_name,
                };

                sessionStorage.setItem("engageStatus", null);
                sessionStorage.setItem("engageId", null);

                console.log("893 engagePayload", $scope.engagePayload)

                engagementService.updateEngageMessage(engagePayload).then(function (response) {
                    if(response.status == 0){
                        toastr.error(response.message);
                    }else{
                        toastr.success('Message updated successfully..');
                    $scope.message_status = 'new';
                    $location.path('/engage-master');
                    }
                });

            }

        } else {

         /* if (data.engagement_name.length > 50) {
                alert('Please give less than 50 chars to Engagement Name.');
            }

            if (data.engagement_category == '') {
                alert('Please choose Engagement Category.');
            } */

            if( parseInt(data.start_age)==0 && parseInt(data.end_age)==0 ){
            } else  {
                if( parseInt(data.start_age) == parseInt(data.end_age) || (parseInt(data.start_age) > parseInt(data.end_age)) ){
                  alert('Invalid Age range!  End_Age should be bigger than Start_Age.');
                }
            }  

            if ( !$scope.reminderArray || $scope.reminderArray.length==0) {
                alert('Please Add atleast one Reminder.');
            }
        
        }
    }

    $scope.viewEngagement = function (value) {
        
        var payload = {
            account_email: authService.authentication.account_id,
            engagement_status: "true",
        };

        if(value){
            payload.engagement_status = ""+value;
        }
      
        engagementService.viewEngagement(payload).then(function (response) {
            $scope.viewEngageData = response;
        }, function (err) {
            toastr.error(err);
        });
    }
    $scope.viewEngagement();

    $scope.updateEngageView = function (data) {

        var engagedata = data[0];   
        $scope.updateEngageShow = "true";
        $scope.reminderBtnEnable = "false";
        $scope.reminderArray = [];
        $scope.reminderArray = data[0].reminders;

        $scope.engageData = {
            account_email: "",
            engagement_name: engagedata.engagement_name,
            target_users: ""+engagedata.target_users,
            gender: engagedata.gender,
            start_age: engagedata.start_age,
            end_age: engagedata.end_age,
            location: engagedata.location,
            engagement_category: ""+engagedata.engagement_category,
            engagement_frequency: ""+engagedata.engagement_frequency,
            engagement_frequency_day: engagedata.engagement_frequency_day,
            engagement_scheduled_time: "",
            engagement_scheduled_dt: "",
            message_status: engagedata.message_status,
            rule_type: engagedata.rule_type
        };

        console.log("974 engagedata", $scope.engageData);

        $scope.changeFrequency(""+engagedata.engagement_frequency);
        document.getElementById("engage_radio" + engagedata.engagement_category).checked = true;
        document.getElementById("target_users_radio" + engagedata.target_users).checked = true;
        $scope.checkRadio(engagedata.engagement_category);

        console.log("977 engagedata.rule_type", engagedata.rule_type);
        if(engagedata.rule_type == "followup"){
            $scope.radio_value = 0
            document.getElementById("engage_radio1").disabled = true;  
            document.getElementById("engage_radio2").disabled = true;  
            document.getElementById("engage_radio3").disabled = true;  
            document.getElementById("engage_radio11").disabled = true;  
            document.getElementById("engage_radio27").disabled = true;  
            $scope.checkRadio('0');
        }else{
            $scope.radio_value = 2
            document.getElementById("engage_radio0").disabled = true; 
            document.getElementById("engage_radio1").disabled = false;  
            document.getElementById("engage_radio2").disabled = false;  
            document.getElementById("engage_radio3").disabled = false;  
            document.getElementById("engage_radio11").disabled = false;  
            document.getElementById("engage_radio27").disabled = false;  
        }


     /* if( engagedata.target_users==1 ) {
            $(".msg_category2").prop("disabled",true);
            $(".msg_category2").css({"color":"lightgray"}); 
            $(".msg_category1").prop("disabled",false);
            $(".msg_category1").css({"color":"unset"});
            $(".msg_category3").prop("disabled",false);
            $(".msg_category3").css({"color":"unset"});  
        } else if( engagedata.target_users==2 ) {
            $(".msg_category1").prop("disabled",true);
            $(".msg_category1").css({"color":"lightgray"}); 
            $(".msg_category2").prop("disabled",false);
            $(".msg_category2").css({"color":"unset"});   
            $(".msg_category3").prop("disabled",false);
            $(".msg_category3").css({"color":"unset"});    
        } */

        if(engagedata.message_status==true) {
            document.getElementById("engage_status1").checked = true;
        } else if(engagedata.message_status==false) {
            document.getElementById("engage_status2").checked = true;
        }
        
        $scope.Date = new Date(engagedata.engagement_scheduled_dt);
        if(engagedata.engagement_scheduled_time!='') {
        var engage_split_time = engagedata.engagement_scheduled_time.split("Z");
        $scope.engage_time = engage_split_time[0];
      //var engage_split_arr = engage_split[0].split(":");
        var ampmTime = tConvert(engage_split_time[0] );
        $scope.selectedEngageTime =  ampmTime;
        } else {
            $scope.selectedEngageTime = '12:00 AM'; 
        }
     /* $scope.engageTime = {
          value: new Date(1970, 0, 1, parseInt(engage_split_arr[0]), parseInt(engage_split_arr[1]), 0),
        }; */
    }

    $scope.getAllEngagement = function (id) {

        sessionStorage.setItem("engageStatus", '');
        sessionStorage.setItem("engageId", '');

        var payload = {
            account_email: authService.authentication.account_id,
            id: id,
        };

        engagementService.getEngagements(payload).then(function (response) {
            $scope.updateEngageView(response);
        }, function (err) {
            toastr.error(err);
        });
    }

    $scope.updateEngage = function (id) {
        sessionStorage.setItem("engageStatus", "update");
        sessionStorage.setItem("engageId", id);
        $location.path('/engage-content');
    }

    $scope.viewEngage = function (id) {
        $location.path('/engage-content');
    }

    $scope.cancelEngage = function () {
        $location.path('/engage-master');
        sessionStorage.setItem("engageStatus", '');
        sessionStorage.setItem("engageId", '');
    }

    $scope.changeTime = function(value){
       $scope.engage_time = $scope.convert_to_24hrs(value);
    }

    $scope.timeHrs = ['12:00 AM', '01:00 AM', '02:00 AM', '03:00 AM', '04:00 AM', '05:00 AM', '06:00 AM', '07:00 AM', '08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM', '06:00 PM', '07:00 PM', '08:00 PM', '09:00 PM', '10:00 PM', '11:00 PM'];
    $scope.selectedEngageTime = '12:00 AM';
    $scope.engage_time = "00:00:00";

    $scope.engage = function () {     
        $scope.reminder_content="";
        $scope.updateEngageShow = "false";
        $scope.reminderBtnEnable = "true";
        $scope.deletionReminderId = undefined;
        $(".inactiveLabel").prop("disabled",false);
     // $(".msg_category1").prop("disabled",true);
     // $(".msg_category1").css({"color":"lightgray"});
        $(".msg_category2").prop("disabled",true);
        $(".msg_category2").css({"color":"lightgray"});
        $(".msg_category3").prop("disabled",true);
        $(".msg_category3").css({"color":"lightgray"});

        $scope.engageData = {
            account_email: "",
            engagement_name: "",
            target_users: "1",
            gender: "both",
            start_age: 0,
            end_age: 0,
            location: "",
            engagement_category: "",
            engagement_frequency: "1",
            engagement_frequency_day: "",
            engagement_scheduled_time: "1",
            engagement_scheduled_dt: "",
            message_status: "true",
        };
    }

    $scope.engageUpdateId = "";
    if (sessionStorage.getItem("engageStatus") != 'update') {
        $scope.message_status == 'new';
        sessionStorage.setItem("engageStatus", null);
        sessionStorage.setItem("engageId", null);
        $scope.engage();
    } else if (sessionStorage.getItem("engageStatus") == 'update') {
        $scope.message_status = 'update';
        $scope.reminder_status = 'edit';
        $scope.engageUpdateId = sessionStorage.getItem("engageId");
        $scope.getAllEngagement($scope.engageUpdateId);
    }

    $scope.engageMHData = function () {
        engagementService.getMhEngageData().then(function (response) {
            $scope.engageMHArray = response.mh[0].items;
        }, function (err) {
            toastr.error(err);
        });
    }

    // Show image attachment in popup
    $scope.showImage = function (data) {
        var options = {
            title: '',
            message: '<img class="img-responsive center-block" src="' + $scope.imageUploadUrl + data + '"/>',
            size: 'medium',
            onEscape: true,
        };
        $ngBootbox.customDialog(options);
    }

    // Show video attachment in popup
    $scope.playVideo = function (data) {
        var options = {
            title: '',
            message: '<video class="center-block" width="520" height="340" controls autoplay src="' + $scope.imageUploadUrl + data + '" type="video/mp4"></video>',
            size: 'medium',
            onEscape: true,
        };
        $ngBootbox.customDialog(options);
    }

    $scope.oTypeArray = [
      {
        id: '10',
        name: 'Chat'
      },
      {
        id: '11',
        name: 'Appointment Booking'
      },
      {
        id: '12',
        name: 'Baby Profile Screen'
      },
      {
        id: '13',
        name: 'Life Logs'
      },
      {
        id: '14',
        name: 'Vaccination'
      },
      {
        id: '15',
        name: 'Shop'
      },
      {
        id: '16',
        name: 'Growth Chart'
      },
      {
        id: '17',
        name: 'Multi Patient'
      },
      {  
        id: '18',
        name: 'Consultation'
      },
      {
        id: '19',
        name: 'View Lab Reports'
      }
    ];

}]);

 'use strict'
 angular.module('AngularApp').controller('eshopsettingsController', ['$sce','$scope', '$rootScope', 'authService','mainUrl','localStorageService',
     function ($sce,$scope, $rootScope, authService,mainUrl,localStorageService) {
        var authData = localStorageService.get('authorizationData');
        if (authData) {
			$scope.authtoken = authData.token;
        }
        $scope.loadeshop = function(){
        $scope.loadeshopiframe = $sce.trustAsResourceUrl(mainUrl+'/new2/#/eshopsettings/?dmail='+authService.authentication.account_id+'&drid='+authService.authentication.doctor_id+'&token='+$scope.authtoken);
        }
        $scope.loadeshop()
     }])
'use strict';
angular.module('AngularApp').controller('eventController', ['$scope', '$location', function ($scope, $location) {
  $scope.expandMenu = false;
  
	 $scope.tabs = [{Id:1, heading: 'Chart', content: 'Chart' },{Id:2, heading: 'Data', content: 'Data' }];
	 
	 $scope.setTabContent = function(Id) 
	 {
		if(Id==1)
		{
			$scope.tabContentUrl = "views/growthchart/index.htm";
		}
		else
		{
			$scope.tabContentUrl = "views/data.htm";
		}
	 };	
} ]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

 'use strict'
 angular.module('AngularApp').controller('feedbackController', ['$scope', '$rootScope', 'authService', 'toastr', '$sessionStorage', '$sce', 'Pubnub', '$pubnubChannel', '$location', 'localStorageService', 'mainUrl', '$interval',
     function ($scope, $rootScope, authService, toastr, $sessionStorage, $sce, Pubnub, $pubnubChannel, $location, localStorageService, mainUrl, $interval) {
        var authData = localStorageService.get('authorizationData');
        if (authData) {
			$scope.authtoken = authData.token;
        }
         $scope.loadframe = function () {
             $rootScope.newiframe = $sce.trustAsResourceUrl(mainUrl + '/feedback/?' + 'demail=' + authService.authentication.account_id + '&token=' + $scope.authtoken);
         }
         $scope.loadframe()
 
        
     }])
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('followupreportController', ['$scope', '$rootScope', '$filter', 'authService', 'paymentService', 'toastr',
    function ($scope, $rootScope, $filter, authService, paymentService, toastr) {

        $scope.reportNameShow = "true";
        $scope.homeVisitReportName = "";
        $scope.labelHide = true;

        var homeVisitUrlArr = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi).split('/');
        var homeVisitUrl = homeVisitUrlArr[homeVisitUrlArr.length - 1];

        $scope.errMsg = "";
        $scope.errMsgShow = true;
        $scope.showContainer = false;

        $scope.completeBtnDisable = true;
        $scope.timeInputDisable = true;

        $scope.exportType = "";
        $scope.rangePicker1 = {
            opened: { fromDate: false, toDate: false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
            dateOptions: {
                formatYear: 'yyyy',
                startingDay: 0,
            }
        };

        $scope.rangePicker2 = {
            opened: { fromDate: false, toDate: false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
            dateOptions: {
                formatYear: 'yyyy',
                startingDay: 0,
            }
        };

        function start_endOfWeek(date, start, end) {
            var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
            return new Date(date.setDate(diff));
        }

        function start_thisWeek(date, start, end) {
            var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
            return new Date(date.setDate(diff));
        }

        function end_thisWeek(date, start, end) {
            var diff = date.getDate();
            return new Date(date.setDate(diff));
        }

        function getStringDate(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            return [year + "-" + month + "-" + day, day + "-" + month + "-" + year];
        }

        function getPreviousDate(days, value) {
            var dateOffset = parseInt(days * value);
            var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
            return convertDate;
        }

        $scope.exportData = function (type) {

            if ($scope.followupReport) {

                $scope.formattedDate = $filter('date')(new Date(), "dd-MM-yyyy");
                var filename = "consultation_followup_report_" + $scope.formattedDate;

                if ($scope.selectedFromDate && $scope.selectedToDate) {
                    filename = "consultation_followup_report_" + $scope.selectedFromDate + "_to_" + $scope.selectedToDate;
                }

                /* if(type=='csv') {
     
                     alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
                     
                 } else*/
                if (type == 'csv') {

                    alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true,separator:','}) FROM HTML('#printtable',{headers:true,separator:','})");

                } else if (type == 'pdf') {

                    var pdf_element = document.getElementById('printtable');
                    var opt = {
                        margin: 0,
                        filename: filename,
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
                    };

                    //New Promise-based usage:
                    html2pdf().set(opt).from(pdf_element).save();

                }
            }
        }

        $scope.convertUTCDateToLocalDate = function(date) {
            var newDate = new Date(date);
            var offset = date.getTimezoneOffset();
            var minutes = date.getMinutes();
            newDate.setMinutes(minutes - offset);
          return newDate;   
        };

        $scope.callPatientsReportsApi = function () {
            var date1 = $scope.convertUTCDateToLocalDate(new Date($scope.selectedFromDate2));
			var toconvert1 = date1.toISOString().slice(0, 10);
			var from_date = toconvert1.slice(0, 4) + '-'
				+ toconvert1.slice(5, 7) + '-'
				+ toconvert1.slice(8, 10);

            var date2 = $scope.convertUTCDateToLocalDate(new Date($scope.selectedToDate2));
            var toconvert2 = date2.toISOString().slice(0, 10);
            var to_date = toconvert2.slice(0, 4) + '-'
                + toconvert2.slice(5, 7) + '-'
                + toconvert2.slice(8, 10);

            paymentService.followupreport(from_date, to_date).then(function (response) {
                toastr.success("Updated Successfully")
                console.log('here', response);
                if (response.data.length >= 1) {
                    $scope.totalCount = response.data.length
                    angular.forEach(response, function (value) {
                        $scope.followupReport = response.data
                    })
                    $scope.labelHide = false;
                    $scope.errMsg = "";
                }
                else {
                    $scope.followupReport = [];
                    $scope.patientTotal = [];
                    $scope.labelHide = true;
                    $scope.errMsg = "No data available";
                }
            });
        }

        $scope.initHomeVisit = function () {

            $scope.hidetable2 = 'true';
            $scope.hidetable1 = 'true';
            $scope.exportType = "";
            $scope.selected_day = "1";
            $scope.fromDate = new Date();
            $scope.toDate = new Date();
            $scope.today_dt = new Date();

            var datArr = getStringDate($scope.fromDate);
            var datArr2 = getStringDate($scope.toDate)
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
        }
        $scope.initHomeVisit();

        $scope.changeDay = function (day) {

            if (day == "5") {
                $scope.timeInputDisable = false;
                $scope.fromDate = "";
                $scope.toDate = "";
                $scope.selectedFromDate = "";
                $scope.selectedToDate = "";
                $scope.selectedFromDate2 = "";
                $scope.selectedToDate2 = "";
                $scope.hidetable1 = 'true';
                $scope.hidetable2 = 'true';

            } else {
                $scope.timeInputDisable = true;
            }

            switch (day) {
                case "4":
                    //var tempArray = getPreviousDate(1,30);
                    var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
                    var datArr = getStringDate(new Date(prevMonthFirstDate));
                    $scope.selectedFromDate = datArr[1];
                    $scope.selectedFromDate2 = datArr[0];
                    $scope.fromDate = new Date(prevMonthFirstDate);
                    var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
                    var datArr2 = getStringDate(new Date(prevMonthLastDate));
                    $scope.selectedToDate = datArr2[1];
                    $scope.selectedToDate2 = datArr2[0];
                    $scope.toDate = new Date(prevMonthLastDate);
                    break;
                case "3":
                    //var tempArray = getPreviousDate(1,7);
                    var startLastWeek = start_endOfWeek(new Date(), 1, -6).toString();
                    console.log(startLastWeek)
                    var datArr = getStringDate(new Date(startLastWeek));
                    $scope.selectedFromDate = datArr[1];
                    $scope.selectedFromDate2 = datArr[0];
                    $scope.fromDate = new Date(startLastWeek);
                    var endLastWeek = start_endOfWeek(new Date(), -6, 0).toString();
                    var datArr2 = getStringDate(new Date(endLastWeek));
                    $scope.selectedToDate = datArr2[1];
                    $scope.selectedToDate2 = datArr2[0];
                    $scope.toDate = new Date(endLastWeek);
                    break;
                case "6":
                    //var tempArray = getPreviousDate(1,7);
                    var startThisWeek = start_thisWeek(new Date(), -6, 1).toString();
                    var datArr = getStringDate(new Date(startThisWeek));
                    $scope.selectedFromDate = datArr[1];
                    $scope.selectedFromDate2 = datArr[0];
                    $scope.fromDate = new Date(startThisWeek);
                    var endLastWeek = end_thisWeek(new Date(), -6, 0).toString();
                    var datArr2 = getStringDate(new Date(endLastWeek));
                    $scope.selectedToDate = datArr2[1];
                    $scope.selectedToDate2 = datArr2[0];
                    $scope.toDate = new Date(endLastWeek);
                    break;
                case "2":
                    var tempArray = getPreviousDate(1, 1);
                    $scope.selectedFromDate = tempArray.getDate() + '-' + (tempArray.getMonth() + 1) + '-' + tempArray.getFullYear();
                    $scope.selectedFromDate2 = tempArray.getFullYear() + '-' + (tempArray.getMonth() + 1) + '-' + tempArray.getDate();
                    $scope.selectedToDate = $scope.selectedFromDate;
                    $scope.selectedToDate2 = $scope.selectedFromDate2;
                    $scope.fromDate = tempArray;
                    $scope.toDate = $scope.fromDate;
                    break;
                case "1":
                    var datArr = getStringDate(new Date());
                    $scope.selectedFromDate = datArr[1];
                    $scope.selectedFromDate2 = datArr[0];
                    $scope.selectedToDate = $scope.selectedFromDate;
                    $scope.selectedToDate2 = $scope.selectedFromDate2;
                    $scope.fromDate = new Date();
                    $scope.toDate = $scope.fromDate;
                    break;
            }
        }

        $scope.byRange = function (from, to) {

            if (from) {
                $scope.rangePicker2 = {
                    opened: { fromDate: false, toDate: false },
                    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                    dateOptions: {
                        formatYear: 'yyyy',
                        startingDay: 0,
                        minDate: from
                    }
                };
            }

            if (to) {
                $scope.rangePicker1 = {
                    opened: { fromDate: false, toDate: false },
                    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                    dateOptions: {
                        formatYear: 'yyyy',
                        startingDay: 0,
                        
                    }
                };
            };

            if (from && to) {
                var datArr = getStringDate(from);
                $scope.selectedFromDate = datArr[1];
                $scope.selectedFromDate2 = datArr[0];
                var datArr2 = getStringDate(to);
                $scope.selectedToDate = datArr2[1];
                $scope.selectedToDate2 = datArr2[0];;
                //$scope.homevisitData();
            }
        }

    }]);

'use strict';
angular.module('AngularApp').controller('frontdeskController', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'frontdeskService', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, frontdeskService) {

    $scope.imageUploadUrl = authService.helyxonApi.url + 'cloud/image/upload/';

    $scope.front_deskCall = function (id) {
        // $location.path('/frontdesk_content');
        var options = {
            title: '<b>Add Member</b>',
            message: '',
            templateUrl: 'views/frontdesk/frontdesk_content.htm',
            size: 'medium',
            onEscape: function () {
                $scope.$apply();
            },
            buttons: {
            }
        }
        $ngBootbox.customDialog(options);

    }

    $scope.frontdeskData;

    $scope.frontdesk_data = function (value) {

        var payload = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id
        };

        frontdeskService.frontdesk_Data(payload).then(function (response) {
            $scope.frontdeskData = response.details;
            angular.forEach(response.details, function (item) {
                if (item.status == "1") {
                    $scope.togglevalue = false
                } else if (item.status == "0") {
                    $scope.togglevalue = true
                }

            })
            console.log('response', response.details);
        }, function (err) {
            toastr.error(err);
        });
    }
    $scope.frontdesk_data();

    $scope.frontdeskchangealert = function(id, togglevalue) {
		
		if(togglevalue == true){
            var options = {
                message: 'Are you sure to activate this frontdesk ?',
                size: 'small',
                title: 'Confirmation',
                buttons: {
                    warning: {
                        label: "Cancel",
                        className: "btn-warning",
                        callback : function(){
                            $scope.frontdesk_data();
                        }
                    },
                    success: {
                        label: "Yes",
                           className: "btn-success",
                           callback: function() {
                            var payload = {
                                account_email: authService.authentication.account_id,
                                status: 0,
                                id: id
                            }
                            frontdeskService.Status_Toggle(payload).then(function (response) {
                                console.log('staus response', response);
                                toastr.success("Activated successfully")
                                $scope.frontdesk_data();
                            }, function (err) {
                                toastr.error(err);
                            });
                            }
                       }
                  }
              };
        }

        if(togglevalue ==  false){
            var options = {
                message: 'Are you sure to deactivate this frontdesk ?',
                size: 'small',
                title: 'Confirmation',
                buttons: {
                    warning: {
                        label: "Cancel",
                        className: "btn-warning",
                        callback : function(){
                            $scope.frontdesk_data();
                        }
                    },
                    success: {
                        label: "Yes",
                           className: "btn-success",
                           callback: function() {
                            var payload = {
                                account_email: authService.authentication.account_id,
                                status: 1,
                                id: id
                            }
                            frontdeskService.Status_Toggle(payload).then(function (response) {
                                console.log('staus response', response);
                                toastr.success("Deactivated successfully")
                                $scope.frontdesk_data();
                            }, function (err) {
                                toastr.error(err);
                            });
                            }
                       }
                  }
              };
        }
	  	$ngBootbox.customDialog(options);
	};

    $rootScope.update_Frontdesk = function () {
        var id = sessionStorage.getItem("frontdesk_id");
        console.log('id', id)
        $scope.update_data = $("form").serializeArray();
        console.log('data', $scope.update_data);
        var payload = {
            "account_email": authService.authentication.account_id,
            "frontdesk_name": $scope.update_data[0].value,
            "email": $scope.update_data[1].value,
            "with_doctor_id": authService.authentication.doctor_id,
            "country_code": "+91",
            "frontdesk_number": $scope.update_data[2].value,
            "id": id
        }

        console.log('payload', payload);
        frontdeskService.update_Data(payload).then(function (response) {
            console.log('update_response', response);
            if (response.data == 'Updated') {
                bootbox.hideAll()
                toastr.success("Updated successfully")
                $scope.frontdesk_data();
            }
        }, function (err) {
            toastr.error(err);
        });

    }

    $scope.updatefrontdesk = function (data) {
        console.log('data_id', data.id);
        sessionStorage.setItem("frontdeskStatus", "update");
        sessionStorage.setItem("frontdesk_number", data.frontdesk_number);
        sessionStorage.setItem("frontdesk_name", data.frontdesk_name);
        sessionStorage.setItem("frontdesk_email", data.email);
        sessionStorage.setItem("frontdesk_id", data.id);

        $rootScope.name = data.frontdesk_name
        $rootScope.email = data.email
        $rootScope.phone = data.frontdesk_number
        var options = {
            title: '<b>Update Member</b>',
            message: '',
            templateUrl: 'views/frontdesk/update_frontdesk_content.htm',
            size: 'medium',
            onEscape: function () {
                $scope.$apply();
            },
            buttons: {
            }
        }
        $ngBootbox.customDialog(options);

    }

    $rootScope.frontdesk_call = function () {
        $scope.data = $("form").serializeArray();
        console.log('data', $scope.data);
        var payload_data = {
            "account_email": authService.authentication.account_id,
            "frontdesk_name": $scope.data[0].value,
            "email": $scope.data[1].value,
            "with_doctor_id": authService.authentication.doctor_id,
            "country_code": "+91",
            "frontdesk_number": $scope.data[2].value
        }
        console.log('payload', payload_data);
        frontdeskService.frontdesk_postdata(payload_data).then(function (response) {
            console.log('response', response);
            if (response.data == 'created') {
                bootbox.hideAll()
                toastr.success("Created successfully")
                $scope.frontdesk_data();
                $rootScope.user.name = ""
                $rootScope.user.email = ""
                $rootScope.user.phone = ""
            } else {
                toastr.error("Data already exists")
            }
        }, function (err) {
            toastr.error(err);
        });
    }

    return this;
}
]);
'use strict';
angular.module('AngularApp').controller('growthchartReportController', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'paymentService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, authService, paymentService, $ngBootbox, toastr) {

    $scope.growthchartTotal = [];
    $scope.growthchartData  = [];
    $scope.today_dt    = new Date();
    $scope.ExportType  = "";   
    $scope.chartHide   = true;
    
    $scope.exportData = function(type) {

        $scope.date = new Date();
        $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");

        if($scope.selected_days == 1 || $scope.selected_days == 2){
            var filename = authService.authentication.doctor_name+"_growth_chart_Report_" + $scope.from_date;
        }else{
            var filename = authService.authentication.doctor_name+"_growth_chart_Report_" + $scope.from_date + "_to_" + $scope.to_date;
        }

        if(type=='pdf') {
            var pdf_element = document.getElementById('printtable');
            var opt = {
                margin:      0.5,
                filename:    filename+'.pdf',
                image:       { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF:       { unit: 'in', format: 'a3', orientation: 'landscape' }
            };
        
      //New Promise-based usage:
        html2pdf().set(opt).from(pdf_element).save();
        }else if(type == 'csv') {

           // alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true,separator:','}) FROM HTML('#Printingcsv',{headers:true,separator:','})");
            alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true,separator:','}) FROM ?", [$scope.csvformattedarr]);

            
        }
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
            $scope.Date1 = "";
            $scope.Date2 = "";
            $scope.from_date = "";
            $scope.to_date = "";
        }

          
        switch (day) {
          case "4":
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.from_date = datArr[1];
            $scope.Date1 = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.to_date = datArr2[1];
            $scope.Date2 = new Date(prevMonthLastDate); 
            $scope.growthchartReportData();
          break;
          case "3":
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.from_date = datArr[1];
            $scope.Date1 = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.to_date = datArr2[1];
            $scope.Date2 = new Date(endLastWeek);
            $scope.growthchartReportData();
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.from_date  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            //$scope.to_date = $scope.selectedFromDate; 
            $scope.to_date =$scope.from_date;
            $scope.Date1 = tempArray;
            $scope.Date2   = $scope.Date1;  
            $scope.growthchartReportData();     
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.from_date = datArr[1];
            $scope.to_date =$scope.from_date;
            //$scope.to_date = $scope.selectedFromDate; 
            $scope.Date1 = new Date();
            $scope.Date2 = $scope.Date1;
            $scope.growthchartReportData();
          break;
        }
    }

    $scope.growthchartReportData = function() {

        var from_date = $filter('date')( $scope.Date1, "yyyy-MM-dd");
        var to_date = $filter('date')( $scope.Date2, "yyyy-MM-dd");

        if(from_date == undefined || to_date == undefined){
            toastr.error('Select Date Range')
        }

        if($scope.heightchange == undefined){
            $scope.heightchange = 'null'
            console.log($scope.heightchange);
        }else{
            $scope.heightchange
            console.log($scope.heightchange);
        }


        if($scope.weightchange == undefined){
            $scope.weightchange = 'null'
            console.log($scope.weightchange);
        }else{
            $scope.weightchange
            console.log($scope.weightchange);
        }


        if($scope.headcircumferencechange == undefined){
            $scope.headcircumferencechange = 'null'
            console.log($scope.headcircumferencechange);
        }else{
            $scope.headcircumferencechange
            console.log($scope.headcircumferencechange);
        }
        var payload = {
            account_email:authService.authentication.account_id,
            from_date: from_date,
            to_date: to_date,
            height_value: $scope.heightchange,
            weight_value: $scope.weightchange,
            hc_value: $scope.headcircumferencechange
        }  
        console.log(payload);  
       
        paymentService.getgrowthchartreport(payload).then( function(response) {
            if(response.status==1) {
                toastr.success('Updated Successfully');
                if(response.data.length > 0){
                    $scope.hidetable = false;
                    $scope.csvformattedarr = []
                    $scope.growthchartData = response.data
                    for(var i = 0;i < response.data.length;i++){
                        $scope.csvformattedarr.push({
                            "S.No" : i+1,
                            "MR Number" : response.data[i].mrn,
                            "Name" : response.data[i].name,
                            "DOB" : response.data[i].date_of_birth,
                            "Mobile number" : response.data[i].mobile,
                            "Date" : $filter('date')( response.data[i].date, "dd-MM-yyyy"),
                            "Height" : response.data[i].height,
                            "Height Percentile" : response.data[i].height_percentile,
                            "Height Interpretation" : response.data[i].height_interpretation,
                            "Head Circumference" : response.data[i].head_circumference,
                            "Head Circumference Percentile" : response.data[i].head_circumference_percentile,
                            "Head Circumference Interpretation" : response.data[i].head_circumference_interpretation,
                            "Weight" : response.data[i].weight,
                            "Weight Percentile" : response.data[i].weight_percentile,
                            "Weight Interpretation" : response.data[i].weight_interpretation,
                            "BMI" : response.data[i].bmi,

                        })
                    }
                } else {
                    $scope.hidetable = true;
                }
               
            } else {
                $scope.growthchartTotal = [];
                $scope.growthchartData = [];
                $scope.chartHide = true;
                $scope.hidetable = true;
            }
        });
    }
   
    $scope.rangePicker1= {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        minDate: new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 2 + 12) % 12, new Date().getDate())
      }
    };

    $scope.rangePicker2 = {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
      }
    };

    $scope.byRange = function(from, to, range_no) { 

        if(range_no=="1") {

            $scope.rangePicker2 = {
                opened :{ fromDate:false, toDate:false},
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
                dateOptions : {
                  formatYear: 'yyyy',
                  startingDay: 0,
                  maxDate: new Date(),
                  minDate: from
                }
            };

            $scope.from_date = $filter('date')(from, "dd-MMM-yyyy");  

        } else if(range_no=="2"){

            $scope.rangePicker1 = {
                opened : {fromDate:false, toDate:false},
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
                dateOptions : {
                  formatYear: 'yyyy',
                  startingDay: 0,
                  maxDate: to,
                minDate: new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 2 + 12) % 12, new Date().getDate())
                }
              }
                  
            $scope.to_date =  $filter('date')(to, "dd-MMM-yyyy");
        }
 
        if($scope.from_date && $scope.to_date) {
            $scope.growthchartReportData();
        }  
    } 


    $scope.changeHeight = function(data) {
        $scope.heightchange = data
        console.log($scope.heightchange);
        $scope.growthchartReportData()
    }

    $scope.changeWeight = function(data) {
        $scope.weightchange = data
        console.log($scope.weightchange);
        $scope.growthchartReportData()
    }

    $scope.changeHeadcircumference = function(data) {
        $scope.headcircumferencechange = data
        console.log($scope.headcircumferencechange);
        $scope.growthchartReportData()
    }
}]);

'use strict';
angular.module('AngularApp').controller('healthController', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'paymentService', '$ngBootbox', 'toastr', 'engagementService', 'multipartFormdata' , 'serviceBaseUrl', '$sce', function ($scope, $rootScope, $location, $filter, authService, paymentService, $ngBootbox, toastr, engagementService, multipartFormdata, serviceBaseUrl, $sce) {

    authService.loadHelyxonApiUrl();

    $rootScope.doctorCoverImage = ''
    $rootScope.image = false
    $rootScope.video = false
    $rootScope.Linked = false
    $rootScope.app = false
    $rootScope.contentType = ''
    $rootScope.Otype = ''
    $rootScope.link
    $rootScope.bannerNormal = false
    $rootScope.bannerUpdate = false
    $scope.hide = false
    $rootScope.elink = ''

    $scope.engageMHData = function () {

        engagementService.getMhEngageData().then(function (response) {
            console.log(response);
            $scope.engageMHArray = response.mh[0].items;
        }, function (err) {
            toastr.error(err);
        });
    }

    $scope.engageMHData()

    // Show image attachment in popup
    $scope.showImage = function (data) {
        var options = {
            title: '',
            message: '<img class="img-responsive center-block" src="' + data + '"/>',
            size: 'medium',
            onEscape: true,
        };
        $ngBootbox.customDialog(options);
    }

    // Show video attachment in popup
    $scope.playVideo = function (data) {
        var options = {
            title: '',
            message: '<video class="center-block" width="520" height="340" controls autoplay src="' + data + '" type="video/mp4"></video>',
            size: 'medium',
            onEscape: true,
        };
        $ngBootbox.customDialog(options);
    }

    $scope.viewBanner = function () {

        sessionStorage.setItem('bannerStatus','normal')
        $rootScope.selected_type = '' 
        $rootScope.contentType = ''
        // console.log($rootScope.selected_type,'content');
        $rootScope.selected_otype = ''
        $rootScope.Otype = ''
        // console.log($rootScope.selected_otype,'content');
        $rootScope.link = ''
        // console.log($rootScope.link,'content');
        $rootScope.updateId = ''
        // console.log($rootScope.updateId,'id');
        $rootScope.image = false
        $rootScope.doctorCoverImage = ''
        $rootScope.doctorCoverImage1 = ''
        // console.log($rootScope.doctorCoverImage);
        $rootScope.video = false
        $rootScope.Linked = false

        $rootScope.app = false
        $rootScope.loadmilestonevideo = true
        $rootScope.milestonevideouploadsuccess = false
        $rootScope.getIframeSrc = ''
        // console.log($rootScope.getIframeSrc);

        var options = {
            title: '<b>Add Banner</b>',
            message:'',
            templateUrl: 'views/health-content.htm',
            size:'medium', 
            onEscape: function() {
                // $rootScope.selected = [];
                // $scope.milestonesList();
                // $scope.$apply();
                $scope.engageMHData()
                $rootScope.video_guide = null
                $rootScope.saveProfile = null
                $rootScope.saveProfile1 = null
                $rootScope.notUpdatedVideo = ''
                $rootScope.doctorCoverImage = ''
            }
        };

        $ngBootbox.customDialog(options);
        // $location.path('/health-content');
    }


    $rootScope.uploadCoverImage = function (file) {

        console.log(file);
        if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {

            $rootScope.uploadDocCoverImage = file.file;
            var file = file.file;
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $rootScope.doctorCoverImage = evt.target.result;
                    console.log($rootScope.doctorCoverImage,'imageupload');
                    $scope.hide = true
                    console.log($rootScope.uploadDocCoverImage, "uploadDocCoverImage")
                    multipartFormdata.uploadFileToUrl(authService.helyxonApi.url, $rootScope.uploadDocCoverImage).then(function (response) {
                        $rootScope.saveProfile = response.image[0].filename;
                        console.log($rootScope.saveProfile);
                    })
                });
            };
            reader.readAsDataURL(file);

        } else {
            alert("Upload only Images");
        }
    }

    $rootScope.getType = function(content){
        // alert(content)
        if(content == 'image'){
            $rootScope.video = false
            $rootScope.image = true
            $rootScope.Linked = false

            $rootScope.app = false
            $rootScope.contentType = 0
            console.log($rootScope.contentType);
            $rootScope.video_guide = null
            $rootScope.saveProfile = null
            $rootScope.doctorCoverImage = null
            $rootScope.Otype = 0
        }else if(content == 'video'){
            $rootScope.image = false
            $rootScope.video = true
            $rootScope.Linked = false
            $rootScope.app = false
            $rootScope.contentType = 1
            console.log($rootScope.contentType);
            $rootScope.saveProfile = null
            $rootScope.video_guide = null
            $rootScope.getIframeSrc = null
            $rootScope.milestonevideouploadsuccess = false
            $rootScope.notUpdatedVideo = ''
            $rootScope.Otype = 0
        }else if(content == 'links'){
            $rootScope.image = false
            $rootScope.video = false
            $rootScope.Linked = true
            $rootScope.app = false
            $rootScope.contentType = 0
            console.log($rootScope.contentType);
            $rootScope.Otype = 0
            $rootScope.link = ''
        }else if(content == 'app'){
            $rootScope.image = false
            $rootScope.video = false
            $rootScope.Linked = false

            $rootScope.app = true
            $rootScope.contentType = 0
            console.log($rootScope.contentType);
            $rootScope.selected_otype = ''
            // $rootScope.link = 'app'
        }
    }


    $scope.deleteBanner = function(data){
        console.log(data,'de');

        var payload = {
            "mode" : 2,
            "account_email" : authService.authentication.account_id,
            "id" : data.id
        }

        engagementService.viewBanner(payload).then(function (response) {
            console.log(response);
            if(response.mh.success == 1){
                toastr.success('Deleted Successfully')
                $scope.engageMHData()
            }else{
                toastr.error(response.mh.message)
                $scope.engageMHData();
            }
        }, function (err) {
            toastr.error(err);
        });

    }

    $scope.updateBanner = function(data){
        console.log(data,'up');
        sessionStorage.setItem('bannerStatus','update')
        sessionStorage.setItem('bannerItem',JSON.stringify(data))
        // $location.path('/health-content');
        // sessionStorage.setItem('bannerStatus','normal')
        // var con = JSON.parse(sessionStorage.getItem('bannerItem'))
        // if(sessionStorage.getItem('bannerStatus') == 'update'){
            var con = data
            console.log(con,'content');
            $rootScope.selected_type = ''
            // $rootScope.selected_type = '' 
            $rootScope.contentType = ''
            // console.log($rootScope.selected_type,'content');
            $rootScope.selected_otype = ''
            $rootScope.Otype = ''
            // console.log($rootScope.selected_otype,'content');
            $rootScope.link = ''
            // console.log($rootScope.link,'content');
            $rootScope.updateId = ''
            // console.log($rootScope.updateId,'id');
            $rootScope.image = false
            $rootScope.doctorCoverImage = ''
            $rootScope.doctorCoverImage1 = ''
            // console.log($rootScope.doctorCoverImage);
            $rootScope.video = false
            $rootScope.Linked = false
    
            $rootScope.app = false
            $rootScope.loadmilestonevideo = true
            $rootScope.milestonevideouploadsuccess = false
            $rootScope.getIframeSrc = ''
            $rootScope.video_guide = null
            $rootScope.saveProfile = null
            $rootScope.saveProfile1 = null
            $rootScope.notUpdatedVideo = ''
            if(con.type == '0' && (con.elink.endsWith(".png") || con.elink.endsWith(".jpg") || con.elink.endsWith(".jpeg"))){
                // alert(1)
                $rootScope.getType('image')
                $rootScope.selected_type = 'image' 
                console.log($rootScope.selected_type,'content');
                $rootScope.selected_otype = con.otype
                $rootScope.Otype = con.otype
                console.log($rootScope.selected_otype,'content');
                $rootScope.link = con.elink
                console.log($rootScope.link,'content');
                $rootScope.updateId = con.id
                console.log($rootScope.updateId,'id');
                // $rootScope.contentType = 0
                var img = con.elink.split('/')
                console.log(img,'split');
                var rev = img.reverse()
                console.log(rev,'reversed');
                $rootScope.image = true
                $rootScope.doctorCoverImage = authService.helyxonApi.url+"cloud/image/upload/" + rev[0]
                console.log($rootScope.doctorCoverImage);
            }else if(con.type == '1' && (con.elink.endsWith(".mp4") || con.elink.endsWith(".mov"))){
                // alert(2)
                $rootScope.getType('video')
                $rootScope.selected_type = 'video'
                console.log($rootScope.selected_type,'content');
                $rootScope.selected_otype = con.otype
                $rootScope.Otype = con.otype
                console.log($rootScope.selected_otype,'content');
                $rootScope.link = con.elink
                console.log($rootScope.link,'content');
                $rootScope.updateId = con.id
                console.log($rootScope.updateId,'id');
                // $rootScope.contentType = 1
                var vid = con.elink.split('/')
                console.log(vid,'split');
                var rev = vid.reverse()
                console.log(rev,'reversed');
                $rootScope.video = true
                // $rootScope.uploadFilemilestone(vid[6])
                $rootScope.loadmilestonevideo = true
                $rootScope.milestonevideouploadsuccess = true
                $rootScope.notUpdatedVideo = authService.helyxonApi.url+"cloud/image/upload/" + rev[0]
                $rootScope.getIframeSrc = $sce.trustAsResourceUrl(authService.helyxonApi.url+'cloud/image/upload/'+rev[0])
                console.log($rootScope.getIframeSrc);
            }else if(con.type == '0' && (con.elink.startsWith("http:") || con.elink.startsWith("https:")) && con.otype == '0'){
                // alert(3)
                $rootScope.getType('links')
                $rootScope.selected_type = 'links'
                console.log($rootScope.selected_type,'content');
                $rootScope.selected_otype = con.otype
                $rootScope.Otype = con.otype
                console.log($rootScope.selected_otype,'content');
                $rootScope.link = con.elink
                console.log($rootScope.link,'content');
                $rootScope.updateId = con.id
                console.log($rootScope.updateId,'id');
            }else if(con.type == '0' && con.elink == 'app'){
                // alert(4)
                $rootScope.getType('app')
                $rootScope.selected_type = 'app'
                console.log($rootScope.selected_type,'content');
                $rootScope.selected_otype = con.otype
                $rootScope.Otype = con.otype
                console.log($rootScope.selected_otype,'content');
                $rootScope.link = con.elink
                console.log($rootScope.link,'content');
                $rootScope.updateId = con.id
                console.log($rootScope.updateId,'id');
            }
            // console.log($rootScope.selected_type,'content');
            // $rootScope.selected_otype = con.otype
            // $rootScope.Otype = con.otype
            // console.log($rootScope.selected_otype,'content');
            // $rootScope.link = con.elink
            // console.log($rootScope.link,'content');
            // $rootScope.updateId = con.id
            // console.log($rootScope.updateId,'id');
            // if(con.type == '0' && (con.elink.endsWith(".png") || con.elink.endsWith(".jpg") || con.elink.endsWith(".jpeg"))){
            //     var img = con.elink.split('/')
            //     console.log(img,'split');
            //     var rev = img.reverse()
            //     console.log(rev,'reversed');
            //     $rootScope.image = true
            //     $rootScope.doctorCoverImage = authService.helyxonApi.url+"cloud/image/upload/" + rev[0]
            //     console.log($rootScope.doctorCoverImage);
            //     // $scope.uploadCoverImage(img[6])
            // }else if(con.type == '1' && (con.elink.endsWith(".mp4") || con.elink.endsWith(".mov"))){
            //     var vid = con.elink.split('/')
            //     console.log(vid,'split');
            //     var rev = vid.reverse()
            //     console.log(rev,'reversed');
            //     $rootScope.video = true
            //     // $rootScope.uploadFilemilestone(vid[6])
            //     $rootScope.loadmilestonevideo = true
            //     $rootScope.milestonevideouploadsuccess = true
            //     $rootScope.notUpdatedVideo = authService.helyxonApi.url+"cloud/image/upload/" + rev[0]
            //     $rootScope.getIframeSrc = $sce.trustAsResourceUrl(authService.helyxonApi.url+'cloud/image/upload/'+rev[0])
            //     console.log($rootScope.getIframeSrc);
            // }
            
            if((con.type == '1') || (con.type == '0')){
                var img1 = con.URL.split('/')
                console.log(img1,'split');
                var rev = img1.reverse()
                console.log(rev,'reversed');
                // $rootScope.image = true
                $rootScope.doctorCoverImage1 = authService.helyxonApi.url+"cloud/image/upload/" + rev[0]
                console.log($rootScope.doctorCoverImage1,'thumnail');
            }
        // }
        var options = {
            title: '<b>Update Banner</b>',
            message:'',
            templateUrl: 'views/health-contentupdate.htm',
            size:'medium', 
            onEscape: function() {
                // if($rootScope.milestonevideouploadsuccess == false){
                //     e.preventDefault();
                // }
                // $rootScope.selected = [];
                // $scope.milestonesList();
                // $scope.$apply();
                $scope.engageMHData();
                $rootScope.video_guide = null
                $rootScope.saveProfile = null
                $rootScope.saveProfile1 = null
                $rootScope.notUpdatedVideo = ''
                $rootScope.doctorCoverImage = ''
            }
        };

        $ngBootbox.customDialog(options);

    }

    console.log(sessionStorage.getItem('bannerStatus'),'status')

    // if(sessionStorage.getItem('bannerStatus') == 'update'){
    //     $rootScope.bannerUpdate = true
    //     // var con = JSON.parse(sessionStorage.getItem('bannerItem'))
    //     // console.log(con,'content');
    //     // if(con.type == '0'){
    //     //     $rootScope.selected_type = 'image' 
    //     //     $rootScope.contentType = 0
    //     // }else if(con.type == '1'){
    //     //     $rootScope.selected_type = 'video'
    //     //     $rootScope.contentType = 1
    //     // }
    //     // // $rootScope.selected_type = con.type
    //     // console.log($rootScope.selected_type,'content');
    //     // $rootScope.selected_otype = con.otype
    //     // $rootScope.Otype = con.otype
    //     // console.log($rootScope.selected_otype,'content');
    //     // $rootScope.link = con.elink
    //     // console.log($rootScope.link,'content');
    //     // $rootScope.updateId = con.id
    //     // console.log($rootScope.updateId,'id');
    //     // // var img = con.URL.split('/')
    //     // // console.log(img,'split');
    //     // if(con.type == '0'){
    //     //     var img = con.URL.split('/')
    //     //     console.log(img,'split');
    //     //     var rev = img.reverse()
    //     //     console.log(rev,'reversed');
    //     //     $rootScope.image = true
    //     //     $rootScope.doctorCoverImage = authService.helyxonApi.url+"cloud/image/upload/" + rev[0]
    //     //     console.log($rootScope.doctorCoverImage);
    //     //     // $scope.uploadCoverImage(img[6])
    //     // }else if(con.type == '1'){
    //     //     var vid = con.URL.split('/')
    //     //     console.log(vid,'split');
    //     //     var rev = vid.reverse()
    //     //     console.log(rev,'reversed');
    //     //     $rootScope.video = true
    //     //     // $rootScope.uploadFilemilestone(vid[6])
    //     //     $rootScope.loadmilestonevideo = true
    //     //     $rootScope.notUpdatedVideo = authService.helyxonApi.url+"cloud/image/upload/" + rev[0]
    //     //     $rootScope.getIframeSrc = $sce.trustAsResourceUrl(authService.helyxonApi.url+'cloud/image/upload/'+rev[0])
    //     //     console.log($rootScope.getIframeSrc);
    //     // }
    //     // $rootScope.doctorCoverImage = con.URL
    //     // console.log($rootScope.doctorCoverImage,'content');
    // }else if(sessionStorage.getItem('bannerStatus') == 'normal'){
    //     $rootScope.bannerNormal = true
    // }

    $rootScope.getOtype = function(data){
        console.log(data,'otype');
        // alert(data)
        $rootScope.Otype = data
        console.log($rootScope.Otype);
    }

    $rootScope.uploadCoverImage1 = function (file) {

        console.log(file);
        if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {

            $rootScope.uploadDocCoverImage1 = file.file;
            var file = file.file;
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $rootScope.doctorCoverImage1 = evt.target.result;
                    console.log($rootScope.doctorCoverImage1,'imageupload');
                    $scope.hide = true
                    console.log($rootScope.uploadDocCoverImage1, "uploadDocCoverImage")
                    multipartFormdata.uploadFileToUrl(authService.helyxonApi.url, $rootScope.uploadDocCoverImage1).then(function (response) {
                        $rootScope.saveProfile1 = response.image[0].filename;
                        console.log($rootScope.saveProfile1);
                    })
                });
            };
            reader.readAsDataURL(file);

        } else {
            alert("Upload only Images");
        }
    }

    $rootScope.saveBanner = function(){

        console.log($rootScope.saveProfile,'img');
        console.log($rootScope.saveProfile1,'img');
        console.log($rootScope.video_guide,'video');
        console.log($rootScope.contentType,'type'); 
        console.log($rootScope.Otype,'otype');
        console.log($rootScope.link,'link');
        console.log($rootScope.image);
        console.log($rootScope.video);
        console.log($rootScope.Linked);
        console.log($rootScope.app);

        if($rootScope.saveProfile != undefined){
            var URL = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile
            console.log(URL);
        }else if($rootScope.video_guide != undefined){
            var URL2 = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.video_guide
            console.log(URL2);
        }
        else if($rootScope.saveProfile1 != undefined){
            var URL1 = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
            console.log(URL1);
        }

        if($rootScope.image == false && $rootScope.video == false && $rootScope.Linked == false && $rootScope.app == false){
            toastr.error('Please select any upload option')
        }else{
            if($rootScope.image == true){
                // alert(1)
                // console.log('1::',$rootScope.contentType);
                // console.log('1::',$rootScope.saveProfile1);
                // console.log('1::',$rootScope.saveProfile);
                // console.log($rootScope.contentType != '' && $rootScope.saveProfile1 != undefined && $rootScope.saveProfile != undefined);
                // console.log($rootScope.saveProfile1 != undefined && $rootScope.saveProfile != undefined);
                if($rootScope.saveProfile1 != undefined && $rootScope.saveProfile != undefined){
                    var payload = {
                        "mode" : 0,
                        "account_email" : authService.authentication.account_id,
                        "url" : authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1,
                        "type" : $rootScope.contentType,
                        "elink" : authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile,
                        "otype" : $rootScope.Otype
                    }
                    

                    engagementService.viewBanner(payload).then(function (response) {
                        console.log(response);
                        if(response.mh.success == 1){
                            toastr.success(response.mh.message)
                            // $location.path('/health')
                            bootbox.hideAll();
                            $scope.engageMHData();
                            $rootScope.saveProfile1 = ''
                        }else{
                            toastr.error(response.mh.message)
                            bootbox.hideAll();
                            $scope.engageMHData();
                        }
                    }, function (err) {
                        toastr.error(err);
                    });
                }else{
                    toastr.error('Please Fill All Fields')
                }
            }
            else if($rootScope.video == true){
                // alert(2)
                // console.log('2::',$rootScope.contentType);
                // console.log('2::',$rootScope.saveProfile1);
                // console.log('2::',$rootScope.video_guide);
                // console.log($rootScope.saveProfile1 != undefined && $rootScope.video_guide != undefined);
                if($rootScope.saveProfile1 != undefined && $rootScope.video_guide != undefined){
                    var payload = {
                        "mode" : 0,
                        "account_email" : authService.authentication.account_id,
                        "url" : authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1,
                        "type" : $rootScope.contentType,
                        "elink" : authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.video_guide,
                        "otype" : $rootScope.Otype
                    }
                    

                    engagementService.viewBanner(payload).then(function (response) {
                        console.log(response);
                        if(response.mh.success == 1){
                            toastr.success(response.mh.message)
                            // $location.path('/health')
                            bootbox.hideAll();
                            $scope.engageMHData();
                            $rootScope.saveProfile1 = ''
                        }else{
                            toastr.error(response.mh.message)
                            bootbox.hideAll();
                            $scope.engageMHData();
                        }
                    }, function (err) {
                        toastr.error(err);
                    });
                }else{
                    toastr.error('Please Fill All Fields')
                } 
            }
            else if($rootScope.Linked == true){
                // alert(3)
                // console.log('3::',$rootScope.contentType);
                // console.log('3::',$rootScope.saveProfile1);
                // console.log('3::',$rootScope.elink);
                // console.log('3::',$scope.link);
                // console.log('3::',$rootScope.selected.link);
                // console.log($rootScope.saveProfile1 != undefined && $rootScope.link != '');
                // console.log($rootScope.saveProfile1 != undefined && $rootScope.selected.link != '');
                if($rootScope.saveProfile1 != undefined && $rootScope.link != ''){
                    if($rootScope.link.startsWith("http:") || $rootScope.link.startsWith("https:")){
                        var payload = {
                            "mode" : 0,
                            "account_email" : authService.authentication.account_id,
                            "url" : authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1,
                            "type" : $rootScope.contentType,
                            "elink" : $rootScope.link,
                            "otype" : $rootScope.Otype
                        }
                        

                        engagementService.viewBanner(payload).then(function (response) {
                            console.log(response);
                            if(response.mh.success == 1){
                                toastr.success(response.mh.message)
                                // $location.path('/health')
                                bootbox.hideAll();
                                $scope.engageMHData();
                                $rootScope.saveProfile1 = ''
                            }else{
                                toastr.error(response.mh.message)
                                bootbox.hideAll();
                                $scope.engageMHData();
                            }
                            // $scope.engageMHArray = response.mh[0].items;
                        }, function (err) {
                            toastr.error(err);
                        });
                    }else{
                        toastr.error('The web address that you entered seems to be incorrect')
                    }
                }else{
                    toastr.error('Please Fill All Fields')
                } 
            }
            else if($rootScope.app == true){
                // alert(4)
                // console.log('4::',$rootScope.contentType);
                // console.log('4::',$rootScope.saveProfile1);
                // console.log('4::',$rootScope.Otype);
                // console.log($rootScope.saveProfile1 != undefined && $rootScope.Otype != '');
                if($rootScope.saveProfile1 != undefined && $rootScope.Otype != ''){
                    var payload = {
                        "mode" : 0,
                        "account_email" : authService.authentication.account_id,
                        "url" : authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1,
                        "type" : $rootScope.contentType,
                        "elink" : 'app',
                        "otype" : $rootScope.Otype
                    }
                    

                    engagementService.viewBanner(payload).then(function (response) {
                        console.log(response);
                        if(response.mh.success == 1){
                            toastr.success(response.mh.message)
                            // $location.path('/health')
                            bootbox.hideAll();
                            $scope.engageMHData();
                            $rootScope.saveProfile1 = ''
                        }else{
                            toastr.error(response.mh.message)
                            bootbox.hideAll();
                            $scope.engageMHData();
                        }
                        // $scope.engageMHArray = response.mh[0].items;
                    }, function (err) {
                        toastr.error(err);
                    });
                }else{
                    toastr.error('Please Fill All Fields')
                } 
            }
        }
    }


    $rootScope.cancel = function(){
        // $location.path('/health')
        bootbox.hideAll();
        sessionStorage.setItem('bannerStatus','')
        $rootScope.video_guide = ''
        $rootScope.saveProfile = ''
        $rootScope.saveProfile1 = ''
        $rootScope.notUpdatedVideo = ''
        $rootScope.doctorCoverImage = ''
    }

    $rootScope.updateBannerbutton = function(){
        // console.log($rootScope.saveProfile,'img');
        // console.log($rootScope.contentType,'type');
        // console.log($rootScope.Otype,'otype');
        // console.log($rootScope.link,'link');
        // console.log($rootScope.doctorCoverImage,'nci');
        // console.log($rootScope.notUpdatedVideo,'ncv');
        // console.log($rootScope.doctorCoverImage1,'nctni');
        // console.log("id:",$rootScope.updateId);

        if($rootScope.saveProfile != undefined){
            var URL = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile
            console.log(URL);
        }else if($rootScope.video_guide != undefined){
            var URL2 = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.video_guide
            console.log(URL2);
        }else if($rootScope.saveProfile == undefined){
            var URL = $rootScope.doctorCoverImage
            console.log(URL); 
        }else if($rootScope.video_guide == undefined){
            var URL2 = $rootScope.notUpdatedVideo
            console.log(URL2);
        }else if($rootScope.saveProfile1 != undefined){
            var URL1 = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
            console.log(URL1);
        }else if($rootScope.saveProfile1 == undefined){
            var URL1 = $rootScope.doctorCoverImage1
            console.log(URL1);
        }

        // if($rootScope.updateId != '' && $rootScope.Otype != '' && URL != ''){
        //     var payload = {
        //         "mode" : 1,
        //         "account_email" : authService.authentication.account_id,
        //         "url" : URL,
        //         "type" : $rootScope.contentType,
        //         "elink" : $rootScope.link,
        //         "otype" : $rootScope.Otype,
        //         "id" : $rootScope.updateId
        //     }

        //     engagementService.viewBanner(payload).then(function (response) {
        //         console.log(response);
        //         if(response.mh.success == 1){
        //             toastr.success(response.mh.message)
        //             // $location.path('/health')
        //             bootbox.hideAll();
        //             $scope.engageMHData();
        //         }else{
        //             toastr.error(response.mh.message)
        //             bootbox.hideAll();
        //             $scope.engageMHData();
        //         }
        //         // $scope.engageMHArray = response.mh[0].items;
        //     }, function (err) {
        //         toastr.error(err);
        //     });
        // }else{
        //     toastr.error('Please Fill All Fields')
        // }
        if($rootScope.image == true){
            // alert(1)
            console.log('1::',$rootScope.contentType);
            console.log('1::',$rootScope.saveProfile1);
            console.log('1::',$rootScope.saveProfile);
            console.log('1::',URL);
            console.log('1::',URL1);
            if($rootScope.saveProfile1 == '' || $rootScope.saveProfile1 == undefined){
                var UR = $rootScope.doctorCoverImage1
                console.log('1f:',UR);
            }else{
                var UR = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
                console.log('1f::',UR);
            }

            if($rootScope.saveProfile == '' || $rootScope.saveProfile == undefined){
                var EL = $rootScope.doctorCoverImage
                console.log('1fe:',EL);
            }else{
                var EL = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile
                console.log('1fe::',EL);
            }
            // console.log($rootScope.contentType != '' && $rootScope.saveProfile1 != undefined && $rootScope.saveProfile != undefined);
            // console.log($rootScope.saveProfile1 != undefined && $rootScope.saveProfile != undefined);
            console.log(($rootScope.saveProfile1 != undefined || URL1 != '') && ($rootScope.saveProfile != undefined || URL != ''));
            // if($rootScope.saveProfile1 != undefined && $rootScope.saveProfile != undefined ){
            if((UR != '' && UR != null) && (EL != '' && EL != null)){
                var payload = {
                    "mode" : 1,
                    "account_email" : authService.authentication.account_id,
                    "url" : UR,
                    "type" : $rootScope.contentType,
                    "elink" : EL,
                    "otype" : $rootScope.Otype,
                    "id" : $rootScope.updateId
                }
                

                engagementService.viewBanner(payload).then(function (response) {
                    console.log(response);
                    if(response.mh.success == 1){
                        toastr.success(response.mh.message)
                        // $location.path('/health')
                        bootbox.hideAll();
                        $scope.engageMHData();
                        $rootScope.saveProfile1 = ''
                        $rootScope.saveProfile = ''
                    }else{
                        toastr.error(response.mh.message)
                        bootbox.hideAll();
                        $scope.engageMHData();
                    }
                    // $scope.engageMHArray = response.mh[0].items;
                }, function (err) {
                    toastr.error(err);
                });
            }else{
                toastr.error('Please Fill All Fields')
            }
        }
        else if($rootScope.video == true){
            // alert(2)
            console.log('2::',$rootScope.contentType);
            console.log('2::',$rootScope.saveProfile1);
            console.log('2::',$rootScope.video_guide);
            console.log('2::',URL2);
            console.log('2::',URL1);
            if($rootScope.saveProfile1 == '' || $rootScope.saveProfile1 == undefined){
                var UR = $rootScope.doctorCoverImage1
                console.log('2f:',UR);
            }else{
                var UR = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
                console.log('2f::',UR);
            }

            if($rootScope.video_guide == '' || $rootScope.video_guide == undefined){
                var EL = $rootScope.notUpdatedVideo
                console.log('2fe:',EL);
            }else{
                var EL = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.video_guide
                console.log('2fe::',EL);
            }
            console.log($rootScope.saveProfile1 != undefined && $rootScope.video_guide != undefined);
            console.log(($rootScope.saveProfile1 != undefined || URL1 != '') && ($rootScope.video_guide != undefined || URL2 != ''));
            if(($rootScope.saveProfile1 != undefined || UR != '') && ($rootScope.video_guide != undefined || EL != '')){
                var payload = {
                    "mode" : 1,
                    "account_email" : authService.authentication.account_id,
                    "url" : UR,
                    "type" : $rootScope.contentType,
                    "elink" : EL,
                    "otype" : $rootScope.Otype,
                    "id" : $rootScope.updateId
                }
                

                engagementService.viewBanner(payload).then(function (response) {
                    console.log(response);
                    if(response.mh.success == 1){
                        toastr.success(response.mh.message)
                        // $location.path('/health')
                        bootbox.hideAll();
                        $scope.engageMHData();
                        $rootScope.saveProfile1 = ''
                        $rootScope.video_guide = ''
                    }else{
                        toastr.error(response.mh.message)
                        bootbox.hideAll();
                        $scope.engageMHData();
                    }
                    // $scope.engageMHArray = response.mh[0].items;
                }, function (err) {
                    toastr.error(err);
                });
            }else{
                toastr.error('Please Fill All Fields')
            } 
        }
        else if($rootScope.Linked == true){
            // alert(3)
            // $scope.link = ''
            // $rootScope.selected = {}
            console.log('3::',$rootScope.contentType);
            console.log('3::',$rootScope.saveProfile1);
            console.log('3::',$rootScope.elink);
            console.log('3::',$scope.link);
            console.log('3::',URL1);
            console.log('3::');
            if($rootScope.saveProfile1 == '' || $rootScope.saveProfile1 == undefined){
                var UR = $rootScope.doctorCoverImage1
                console.log('3f:',UR);
            }else{
                var UR = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
                console.log('3f::',UR);
            }
            // console.log('3::',$rootScope.selected.link);
            console.log($rootScope.saveProfile1 != undefined && $rootScope.link != '');
            // console.log($rootScope.saveProfile1 != undefined && $rootScope.selected.link != '');
            if(($rootScope.saveProfile1 != undefined || UR != '') && $rootScope.link != ''){
                if($rootScope.link.startsWith("http:") || $rootScope.link.startsWith("https:")){
                    var payload = {
                        "mode" : 1,
                        "account_email" : authService.authentication.account_id,
                        "url" : UR,
                        "type" : $rootScope.contentType,
                        "elink" : $rootScope.link,
                        "otype" : $rootScope.Otype,
                        "id" : $rootScope.updateId
                    }
                    

                    engagementService.viewBanner(payload).then(function (response) {
                        console.log(response);
                        if(response.mh.success == 1){
                            toastr.success(response.mh.message)
                            // $location.path('/health')
                            bootbox.hideAll();
                            $scope.engageMHData();
                            $rootScope.saveProfile1 = ''
                        }else{
                            toastr.error(response.mh.message)
                            bootbox.hideAll();
                            $scope.engageMHData();
                        }
                        // $scope.engageMHArray = response.mh[0].items;
                    }, function (err) {
                        toastr.error(err);
                    });
                }else{
                    toastr.error('The web address that you entered seems to be incorrect')
                }
            }else{
                toastr.error('Please Fill All Fields')
            } 
        }
        else if($rootScope.app == true){
            // alert(4)
            console.log('4::',$rootScope.contentType);
            console.log('4::',$rootScope.saveProfile1);
            console.log('4::',$rootScope.Otype);
            console.log('4::',URL1);
            if($rootScope.saveProfile1 == '' || $rootScope.saveProfile1 == undefined){
                var UR = $rootScope.doctorCoverImage1
                console.log('3f:',UR);
            }else{
                var UR = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
                console.log('3f::',UR);
            }
            console.log($rootScope.saveProfile1 != undefined && $rootScope.Otype != '');
            if(($rootScope.saveProfile1 != undefined || UR != '') && $rootScope.Otype != ''){
                var payload = {
                    "mode" : 1,
                    "account_email" : authService.authentication.account_id,
                    "url" : UR,
                    "type" : $rootScope.contentType,
                    "elink" : 'app',
                    "otype" : $rootScope.Otype,
                    "id" : $rootScope.updateId
                }
                

                engagementService.viewBanner(payload).then(function (response) {
                    console.log(response);
                    if(response.mh.success == 1){
                        toastr.success(response.mh.message)
                        // $location.path('/health')
                        bootbox.hideAll();
                        $scope.engageMHData();
                        $rootScope.saveProfile1 = ''
                    }else{
                        toastr.error(response.mh.message)
                        bootbox.hideAll();
                        $scope.engageMHData();
                    }
                    // $scope.engageMHArray = response.mh[0].items;
                }, function (err) {
                    toastr.error(err);
                });
            }else{
                toastr.error('Please Fill All Fields')
            } 
        }
    }

    $rootScope.loadmilestonevideo = true
    $rootScope.uploadFilemilestone = function(file, event, flow) {
        $rootScope.disablemilestoneupdate = true
        $rootScope.loadmilestonevideo = false
        $rootScope.milestonevideouploadsuccess = false
        if ({ mp4: 1, mov: 1 }[file.getExtension()]) {
            var data = new FormData();
            data.append('file', file.file);
            $rootScope.milestonevideofile = file.file;    
            var reader = new FileReader();
            reader.onload = function(e) {
                multipartFormdata.uploadvideoToUrl(authService.helyxonApi.url,  $rootScope.milestonevideofile).then(function(response){
                    $rootScope.video_guide = response.video[0].filename
                    $rootScope.loadmilestonevideo = true
                    $rootScope.milestonevideouploadsuccess = true
                    $rootScope.disablemilestoneupdate = false
                    $rootScope.getIframeSrc = $sce.trustAsResourceUrl(authService.helyxonApi.url+'cloud/image/upload/'+response.video[0].filename)
                })
           };
           reader.readAsDataURL(file.file);
        }else {
            alert("Upload only Videos");
            return false;
        }
        flow.file = [];
    };

    $rootScope.deleteuploadedvideo = function(){
        $rootScope.getIframeSrc = ""
        $rootScope.video_guide = null
        $rootScope.milestonevideouploadsuccess = false
    }

    $rootScope.deleteuploadedimage = function(){
        $rootScope.doctorCoverImage = ""
        $rootScope.saveProfile = null
    }

    $rootScope.deleteuploadedimagethumb = function(){
        $rootScope.doctorCoverImage1 = ""
        $rootScope.saveProfile1 = null
    }


}]);
'use strict';
angular.module('AngularApp').controller('homeController', ['uiCalendarConfig','$scope', '$rootScope', '$sce', '$location', 'authService',
 'accountService', 'recordService', 'localStorageService', 'locationService', '$filter', '$ngBootbox', '$timeout', 'toastr', '$sessionStorage', 'complaintService','mainUrl', 'Pubnub', '$pubnubChannel', 'chatService', 'inoutService','payoutService','commonsettingsService',
 function( uiCalendarConfig, $scope, $rootScope, $sce, $location,  authService, accountService, recordService, localStorageService, locationService, $filter, $ngBootbox, $timeout, toastr, $sessionStorage, complaintService, mainUrl, Pubnub, $pubnubChannel, chatService, inoutService,payoutService,commonsettingsService) {

    $scope.docdetails = {
       doctordp : authService.authentication.doctor_image,
       doctorname : authService.authentication.doctor_name,
       doctordegree : authService.authentication.doctor_degree,
       hospitalname : authService.authentication.hospital_name
    }

    if(authService.authentication.account_id =="rx4@rxcarenet.org" || authService.authentication.account_id =="rx16165@rxcarenet.org"){
        $rootScope.showpatientdropdown = true;
        $rootScope.showreport = true;
    }else if(authService.authentication.account_id =="rx3@rxcarenet.org"){
        $rootScope.showpatientdropdown = false;
        $rootScope.showreport = false;
    }
    
    $scope.drDasboardStatus = sessionStorage.getItem("drDasboardStatus");
   
    
    $scope.currentProjectUrl = 'https://test.epicare.net/briefprescription/#/';
    // console.log('account_email:'+ authService.authentication.account_id,
    // 'doctor_id:'+ authService.authentication.doctor_id)
    $scope.accID = authService.authentication.account_id;
    $scope.drID = authService.authentication.doctor_id;

    var authData = localStorageService.get('authorizationData');
        if (authData) {
            $scope.authToken = authData.token;
        }
        $scope.getcommonsettingsdata = function () {
            commonsettingsService.getcommonSettings().then(function(response) {
                 $scope.commonsettings = response.data[0]
                 $scope.enablefloatingvideo = response.data[0].floating_video
                 sessionStorage.setItem("enablefloating", $scope.enablefloatingvideo)
                 $scope.enableicssettings = response.data[0].ics_consultation
                 sessionStorage.setItem("enableics",$scope.enableicssettings)
                 console.log(' $scope.commonsettings', $scope.commonsettings);
                 
        
           },function(error) {
                  toastr.error(error,'Try again...');
              })
          }
          $scope.getcommonsettingsdata()

    $scope.check_dashboard = function(status){
        sessionStorage.setItem("drDasboardStatus", status);
        if(status == true) {
            angular.element('#tokenContainer').css('display', 'none');
            angular.element('#drDash').css('color', '#00A0E3');
            angular.element('#drDash').css('font-weight', 'bold');
            angular.element('#drDash').css('font-size', '16px');
            angular.element('#appoint').css('color', '#142E3C');
            angular.element('#appoint').css('font-weight', 'normal');
            angular.element('#appoint').css('font-size', '14px');
        }else{ 
            angular.element('#tokenContainer').css('display', 'block');
            angular.element('#drDash').css('color', '#142E3C');
            angular.element('#drDash').css('font-weight', 'normal');
            angular.element('#drDash').css('font-size', '14px');
            angular.element('#appoint').css('color', '#00A0E3');
            angular.element('#appoint').css('font-weight', 'bold');
            angular.element('#appoint').css('font-size', '16px');
            $scope.callDrDashboard();
        }       
    }

    $scope.callDrDashboard = function() {
		$scope.callprintpopupLoader = true;
		if (mainUrl == 'https://test.epicare.net') {
			$scope.serverurl = 'https://test.epicare.net';
            $scope.serverurltype = 0
		}else{
			$scope.serverurl = 'https://epicare.net';
            $scope.serverurltype = 1
		}
        $scope.fetchRooturl = '/ecDrDashboard/#';
        console.log('fetcDrDashURL****'+$scope.serverurl+$scope.fetchRooturl);
        console.log('params****'+ $scope.accID+'****'+ $scope.drID+'****'+ $scope.authToken);
		$scope.drDashboardUrl = $sce.trustAsResourceUrl(' ');
		setTimeout(function() {
            if(($scope.accID == "rx4@rxcarenet.org" && $scope.drID == 4) ){
                $scope.drDashboardUrl = $sce.trustAsResourceUrl('https://app.powerbi.com/view?r=eyJrIjoiNzUwZmMwYzItYTBiNC00NGZhLThiYzItMTAyMWIyMDVlMmUyIiwidCI6ImM4Y2UyOWU3LTAyYjMtNDVhYi1hOTAwLTk4NzgwZjQ1MDZmNyJ9');
            }else{
                if(($scope.accID == "rx4@rxcarenet.org" && $scope.drID == 3) || ($scope.accID == "rx172060@rxcarenet.org" && $scope.drID == 1)){
                    $scope.drDashboardUrl = $sce.trustAsResourceUrl($scope.serverurl+'/mcs/dashboard/#/'+ '?dmail=' + $scope.accID + '&token=' + $scope.authToken + '&type=' + $scope.serverurltype)
                }else{
                $scope.drDashboardUrl = $sce.trustAsResourceUrl($scope.serverurl+$scope.fetchRooturl+'/DrDashboard'+'?account_email='+$scope.accID+'&doctor_id='+$scope.drID+'&auth_token='+ $scope.authToken);
                }
            }
            $scope.callprintpopupLoader = false;
        }, 300);
	}

     if($scope.drDasboardStatus == null){
        $scope.homescreenDashboardStatus = true;
        $scope.callDrDashboard();
        $scope.check_dashboard(true);
    }else{
        if($scope.drDasboardStatus == 'true'){
            $scope.homescreenDashboardStatus = true;
            $scope.callDrDashboard();
        }
        if($scope.drDasboardStatus == 'false'){
            $scope.homescreenDashboardStatus = false;
        }
        $scope.check_dashboard($scope.homescreenDashboardStatus);
    }
    

$scope.showPopup1 =  true
    $scope.showPopup2 = function(){
$scope.showPopup1 = false
    }

    $scope.docbool = false;
    $scope.togglestatus = function(){
        $scope.docbool = !$scope.docbool;
    }

    $scope.doctor_status = function(docstatus){
        if(docstatus == true){
            $scope.doctorstatus = 1
            var data = {
                "status" : $scope.doctorstatus,
                "account_email": authService.authentication.account_id,
                "doctor_id": $scope.authentication.doctor_id
            }
            console.log(data)
            inoutService.saveinoutstatus(data).then(function (response) {
                console.log(response)
            })
        } else if(docstatus == false){
            $scope.doctorstatus1 = 0
            var data1 = {
                "status" : $scope.doctorstatus1,
                "account_email": authService.authentication.account_id,
                "doctor_id": $scope.authentication.doctor_id
            }
            console.log(data1)
            inoutService.saveinoutstatus(data1).then(function (response) {
                console.log(response)
            })
        }
    }
   
    $scope.homestatus = function(){
        inoutService.getinoutstatus().then(function (response) {
            console.log("getdoctorstatus",response.details)
            if(response.details[0].status == 1){
                $scope.docstatus = true
            } else if(response.details[0].status == 0){
                $scope.docstatus = false
            }
        })
     }
     
     $scope.homestatus()

     $scope.drwalletamount = function () {
        payoutService.getdrwallet().then(function (response) {
            if (response.status == 1) {
               if(response.data.wallet_balance.length>0){
                $scope.walletdetails = response.data.wallet_balance[0].wallet_balance
               }else {
                $scope.walletdetails = "0"
               }
               if(response.data.floating_balance){
                $scope.floatingbalance = response.data.floating_balance
               }else {
                $scope.floatingbalance = "0"
               }
            } 
            // else if (response.status == 0) {
            //     toastr.error("Unable to fetch details")
            // }
        })
    }
    $scope.drwalletamount();

     $scope.viewaptConfigdays = function(){
        recordService.getaptConfigdays().then(function (response) {
            console.log("aptconfigcountresponse",response)
            if(response.success == 1){
                var cdate = response.details[0].date_of_config
                var toconvert = cdate.split("-").reverse().join("-")
                $scope.configureddate = toconvert
                // $scope.remdays = parseInt(7)
                $scope.remdays = parseInt(response.details[0].days)
                if($scope.remdays <= 10){
                    if(sessionStorage.closerem === "true"){
                        return
                    } else {
                        $scope.showremdays = true
                    }
                }
            }
        })
     }
     $scope.viewaptConfigdays()

     if(sessionStorage.changeday == "true"){
        $scope.viewaptConfigdays()
        sessionStorage.removeItem("changeday")
     }

     $scope.closeremalert = function(){
         sessionStorage.setItem("closerem","true")
        $scope.showremdays = false;
     }

     $scope.settingspage = function(){
         $location.path('/inandout')
     }

    // if(1 == 1){
    //     var x = document.getElementById("version").textContent;
    //     console.log('x',x);
    //     var version = x.split(" ");
    //     console.log('version',version[1]);
    //     var ver =  version;
    //     if(version == ver){
    //         alert('versions are same');
    //     }else{
    //         alert('versions are not same')
    //     }

    // }
    // document.location.href="/home";
$('.bootbox.modal').modal('hide');
authService.loadAuthData();

if(!authService.authentication.isAuth) {
    $location.path("/login");
  return;
}

localStorage.setItem("windowOpen", false);
localStorage.setItem("videocall_timestamp", '');

if($rootScope.channel) {
    Pubnub.unsubscribe({
        channels: [$rootScope.channel, 'get_banner_'+$rootScope.channel, 'videocall_'+$rootScope.channel+'_'+authService.authentication.doctor_id, 'vital_criticalityscore_'+$rootScope.channel+'_'+authService.authentication.doctor_id]
    });
}
 
$scope.accountEmail = authService.authentication.account_id;   

authService.loadHelyxonApiUrl();
$rootScope.imageUploadUrl = authService.helyxonApi.url +'cloud/image/upload/';   

$sessionStorage.put('patientDetail', '{}');
$sessionStorage.put('patientAccEmail', '');
$sessionStorage.put('appointment_id', '');
$sessionStorage.put('complaint', '');
$sessionStorage.put('prescription_id', '');
$sessionStorage.put('consult', '');
$sessionStorage.put('enableConsulation', '');
$sessionStorage.put('status', '');
$sessionStorage.put('appt_type', '');
$sessionStorage.put('lastuser', '');

// Stop the 1min bannerCall which is created in patientviewcontroller.js
if($rootScope.bannerCall != undefined) {
    clearInterval($rootScope.bannerCall);
}

$rootScope.showFooter = true;
$rootScope.hideHeader = false;

$rootScope.voice_call_alert = 'false';
$scope.isHomeInit = true;
$scope.patientSearch = "";
$scope.loaded = true;
$scope.date = new Date();
$scope.lastuser = ""; // record the last video call user
$rootScope.printAppointmentToPaper = function(id) {
    // var searchDate = document.getElementById(date1).value;
    // var searchDateTo = document.getElementById(date2).value;
    var innerContents = document.getElementById(id).innerHTML;
    var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' +innerContents + '</html>');
    popupWinindow.document.close();
};

$rootScope.videoScreenShowing = false;
$rootScope.videoCallresponse = '';

/*  $scope.welcomePopup = function(msg) {
        //add a new style 'foo'
        $.notify.addStyle('welcome', {
            html: 
            "<div style='background-image: url( $rootScope.imageUploadUrl +'cover_new.jpg') !important;'>" +
                "<div class='col-md-2' style='top: 5px;'>"+
                    "<img src='$rootScope.imageUploadUrl+mahesh.jpg' width='100' height='80' />" +
                "</div>" +
                "<center><h5><b>Welcome to Dr.Mahesh</b></h5></center>" +
                "<div class='title' data-notify-html='title'/>" +      
                "</div>" +
            "</div>"
        });
            
        $.notify({
            title: 'Happy Morning!',
        //button: 'Join'
        }, { 
            style: 'welcome',
            autoHide: false,
            clickToHide: false
        });              
    } */

$scope.welcomePopup = function(queue) {
    var options = {
        title: '<b>Welcome '+authService.authentication.doctor_name+'</b>',
        templateUrl: 'views/welcomePopup.htm',
        size: 'medium',
        onEscape: true,
        button: {}
    }
    $ngBootbox.customDialog(options);
    $sessionStorage.put('homevisitInit','true');
};

if($sessionStorage.get('homevisitInit')!='true'){
    $scope.welcomePopup();
}
//setTimeout(function(){ $('.notifyjs-welcome-base').trigger('notify-hide'); }, 5000);

$scope.exportData = function (type) {
    $scope.date = new Date();
    $scope.formattedDate =   $filter('date')(new Date(), "dd-MM-yyyy");
    var filename = "Appointment" + $scope.formattedDate;
    if(type == 'EXCEL') {
        alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
    }  
};

$scope.date1 = true;
$scope.vaccineSchedule = {
        currentYear : new Date().getFullYear(),
        yearData:[],
        weekData:{},
        data:[],
        currentMonth: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        weeks:[],
        loaded:false,
        next: function(){
            if(!$scope.vaccineSchedule.loaded)
                return;
            $scope.vaccineSchedule.loaded = false;
            $scope.vaccineSchedule.weeks = [];

            var year = $scope.vaccineSchedule.currentMonth.getFullYear();
            var month = $scope.vaccineSchedule.currentMonth.getMonth() +1 ;
            if(month==12){
                month = 0;
                year++;
            }
            $scope.vaccineSchedule.currentMonth = new Date(year, month, 1);

            if($scope.vaccineSchedule.currentYear<year){
                $scope.vaccineSchedule.currentYear = year;
                $scope.vaccineSchedule.loadData();
            }else{
                $scope.vaccineSchedule.loadWeeks();
            }
        },
        prev: function(){
            if(!$scope.vaccineSchedule.loaded)
                return;
            $scope.vaccineSchedule.loaded = false;
            $scope.vaccineSchedule.weeks = [];
            var year = $scope.vaccineSchedule.currentMonth.getFullYear();
            var month = $scope.vaccineSchedule.currentMonth.getMonth()-1 ;
            if(month==-1){
                month = 11;
                year--;
            }
            $scope.vaccineSchedule.currentMonth = new Date(year, month, 1);

            if($scope.vaccineSchedule.currentYear>year){
                $scope.vaccineSchedule.currentYear = year;
                $scope.vaccineSchedule.loadData();
            }else{
                $scope.vaccineSchedule.loadWeeks();
            }
        },
        loadWeeks : function(){

            var firstWeek = $scope.vaccineSchedule.currentMonth.getWeek();
            var lastWeek = new Date($scope.vaccineSchedule.currentMonth.getFullYear(),$scope.vaccineSchedule.currentMonth.getMonth()+1,0).getWeek();

            $scope.vaccineSchedule.weeks = [];

            //set to start date of week
            var weekDate = new Date($scope.vaccineSchedule.currentMonth);
            weekDate = new Date(weekDate.setDate($scope.vaccineSchedule.currentMonth.getDate() - $scope.vaccineSchedule.currentMonth.getDay()));

            for(var i=firstWeek;i<=lastWeek;i++){
                var firstdate = $filter('date')(weekDate,'dd MMM');
                weekDate.addDays(6); //set to end of week
                var lastdate = $filter('date')(weekDate,'dd MMM');
                weekDate.addDays(1); //set to next week

                $scope.vaccineSchedule.weeks.push({name:firstdate+" - "+ lastdate, week:i});
            }
            $scope.vaccineSchedule.data=[];
            for(var key in $scope.vaccineSchedule.yearData){
                if(key){
                    var vaccineInfo = {name:key};
                    var total = 0;

                    for(var i=firstWeek;i<=lastWeek;i++){
                        var weekcount = $scope.vaccineSchedule.yearData[key].filter(function(item){return item.week==i;});

                        if(weekcount.length>0){
                            vaccineInfo["week_"+i] = weekcount[0].count;
                            total+= weekcount[0].count;
                        }else{
                            vaccineInfo["week_"+i] = 0;
                        }
                    }
                    vaccineInfo.total = total;
                    $scope.vaccineSchedule.data.push(vaccineInfo);
                }
            }
            $scope.vaccineSchedule.loaded = true;
            $scope.vac=true;

        },
        confirmData : function(){

            var firstWeek = $scope.vaccineSchedule.currentMonth.getWeek();
            var lastWeek = new Date($scope.vaccineSchedule.currentMonth.getFullYear(),$scope.vaccineSchedule.currentMonth.getMonth()+1,0).getWeek();

            $scope.vaccineSchedule.weeks = [];

            //set to start date of week
            var weekDate = new Date($scope.vaccineSchedule.currentMonth);
            weekDate = new Date(weekDate.setDate($scope.vaccineSchedule.currentMonth.getDate() - $scope.vaccineSchedule.currentMonth.getDay()));

            for(var i=firstWeek;i<=lastWeek;i++){
                var firstdate = $filter('date')(weekDate,'dd MMM');
                weekDate.addDays(6); //set to end of week
                var lastdate = $filter('date')(weekDate,'dd MMM');
                weekDate.addDays(1); //set to next week

                $scope.vaccineSchedule.weeks.push({name:firstdate+" - "+ lastdate, week:i});
            }
            $scope.vaccineSchedule.data=[];
            for(var key in $scope.vaccineSchedule.yearData){
                if(key) {
                    var vaccineInfo = {name:key};
                    var total = 0;

                    for(var i=firstWeek;i<=lastWeek;i++) {
                        var weekcount = $scope.vaccineSchedule.yearData[key].filter(function(item){return item.week==i;});

                        if(weekcount.length>0){
                            vaccineInfo["week_"+i] = weekcount[0].count;
                            total+= weekcount[0].count;
                        }else{
                            vaccineInfo["week_"+i] = 0;
                        }
                    }
                    vaccineInfo.total = total;
                    $scope.vaccineSchedule.data.push(vaccineInfo);
                }
            }
            $scope.vaccineSchedule.loaded = true;
            $scope.vac=false;
        },
        loadWeekInfo: function(vaccineName, week, count){
            if(count>0){
                if($scope.vaccineSchedule.weekData['week_'+week.week]){
                    $scope.vaccineSchedule.showWeekInfo(vaccineName, week);
                }else{
                    recordService.getVaccineWeekInfo($scope.vaccineSchedule.currentYear, week.week, $rootScope.doctorRecordId).then(function(response){
                       $scope.vaccineSchedule.weekData['week_'+week.week] = response;
                       $scope.vaccineSchedule.showWeekInfo(vaccineName, week);
                      },function (err, response) {
                            $ngBootbox.alert(err.Message);
                    });
                }
            }
        },
        showWeekInfo: function(vaccineName, week){
            var vaccineInfo = $filter('groupBy')($scope.vaccineSchedule.weekData['week_'+week.week], 'product_name_title')[vaccineName];
            $rootScope.vaccineInfoPopupData = vaccineInfo;
            var options = {
            title: '<b>"'+vaccineName+ '" - '+week.name+" - "+ $scope.vaccineSchedule.currentYear+'</b>',
            message :'',
            templateUrl: 'views/viewvaccineinfopopup.htm',
            size:'large',
            onEscape: true,
            buttons: {
            }
        };

        $ngBootbox.customDialog(options);

        },
        loadData: function(){

        //  recordService.getVaccineSchedule($scope.vaccineSchedule.currentYear, $rootScope.doctorRecordId).then(function(response){
        //  $scope.vaccineSchedule.yearData = $filter('groupBy')(response,'product_name_title');
        //  $scope.vaccineSchedule.weekData = {};
        //  $scope.vaccineSchedule.loadWeeks();
        //  $scope.loaded=false;
        // },function (err, response) {
        //  $ngBootbox.alert(err.Message);
        // });
        },
        loadconfirmData: function(){
            recordService.getVaccineAppointment($scope.vaccineSchedule.currentYear, $rootScope.doctorRecordId).then(function(response){
            $scope.vaccineSchedule.yearData = $filter('groupBy')(response,'product_name_title');
            $scope.vaccineSchedule.weekData = {};
            $scope.vaccineSchedule.confirmData();
            $scope.loaded=false;

        },function (err, response) {
            $ngBootbox.alert(err.Message);
        });
        }
    };

    if($rootScope.doctorRecordId) {
        $scope.vaccineSchedule.loadData();
    } else {
            $rootScope.$watch('doctorRecordId',function(){

                if($rootScope.doctorRecordId){
                    $scope.vaccineSchedule.loadData();
                    $rootScope.doctorId =angular.copy($rootScope.doctorRecordId);
                    localStorageService.set('doctorId', { doctorRecordId:$rootScope.doctorRecordId });
                }
            });
    }

    $scope.vac=false;
    $scope.loadvaccine=function(){
        $scope.vac=true;
        $scope.vaccineSchedule.loadconfirmData();
    };

    $scope.schedulevac=function(){
        $scope.vac=false;
        if($rootScope.doctorRecordId)
        $scope.vaccineSchedule.loadData();
    };

    //to load patinets only on first time login
    if(!$rootScope.appInitialized){
    //$rootScope.loadPatientList();
    }

    $scope.setFilter = function() {
        $scope.filterEnabled = true;
        setTimeout(function(){
            $('#txtPatient').focus();
        },100);
    };

    $scope.click = function (id) {
        $location.path("/accountlist/"+ id);
    };

    var d = new Date();
    var n = d.toLocaleString();
    var m = n.split(',');

    var date1 = "Date : " + m[0]
    var time1= "Time : " + m[1]
    var drName = "Name : " + $rootScope.authentication.account_info.Account.fullName;

    $scope.printPriview = function(){
        $scope.name = true;
        $scope.date1 = false;
        $("#printable").print({
            globalStyles: true,
            mediaPrint: true,
            stylesheet: "//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css",
            noPrintSelector: ".no-print",
            iframe: true,
            append: "<br/><footer><center>Helyxon</center></footer>",
            prepend: drName + "<br/>" + date1 + "<br/>" + time1 ,
            manuallyCopyFormValues: false,
            deferred: $.Deferred(),
            timeout: 250
        });
    };

    function stringDate(date){
		var day   = date.getDate();
		var month = date.getMonth()+1;
        var year  = date.getFullYear();
		  
	   return year + "-" + month + "-" + day;
	}
  
	function parseDate(str) {
        var mdy = str.split("-");
        
	   return new Date( parseInt(mdy[0]), parseInt(mdy[1]), parseInt(mdy[2]) );
	}
		
	function datediff(first, second) {
	   return Math.round((second-first)/(1000*60*60*24));
	}
	
	$scope.getCheckedDate = function(date){
        if(date) {
            var days = datediff( parseDate(stringDate(new Date())), parseDate(date) );
            if(days<1) {
                return false;
            }
            return true;	
        }    
    }
    
    $scope.age=function(){
        //console.log(queue.age);
    }

    function getAppCount(data, callback){
        recordService.getAppointmentcount(data).then(function(response){
            return callback(response);
        });
    }
   
    $scope.AppList = [];
    $scope.Appointment=function() {
 
        // $scope.appointment_date1 = date1;
        // $scope.appointment_date2 = date2;
        // $scope.datepicker1.dateOptions.maxDate = date2;
        // $scope.datepicker2.dateOptions.minDate = date1;
        
        var data = {
            "acc_id": authService.authentication.account_id,
            "date1": $filter('date')($scope.appointment_date1, "yyyy-MM-dd"),
            "date2": $filter('date')($scope.appointment_date2, "yyyy-MM-dd"),
        }

        $scope.piecharts = true;
        $scope.chartHide=true;
        $scope.appointmentCount=[];
        $scope.appointmentCount2=[];
          
        var pieChartData1 = getAppCount(data, function callBackFunc(response){

              var tempArr = response.appointment_type;
              var tempArr2 = response.appointment_age_wise;
              if(tempArr[0].total!=0){
                $scope.appointmentCount = tempArr;
                $scope.piecharts = false;
                $scope.chartHide=false;
                  var obj = [{
                      name: 'IVRS',
                      y: tempArr[0].ivrs,
                      sliced: true,
                      selected: true
                    }, {
                      name: 'Website',
                      y: tempArr[0].website
                    }, {
                      name: 'Voicecall',
                      y: tempArr[0].voice_call
                    }, {
                      name: 'Online',
                      y: tempArr[0].online
                    }, {
                      name: 'Appointment',
                      y: tempArr[0].appointment
                    }, {
                      name: 'Video-Call',
                      y:tempArr[0].video_call
                    }, {
                      name: 'Consultation',
                      y: tempArr[0].consultation
                    }, {
                      name: 'Vaccination',
                      y: tempArr[0].vaccination
                    }];

                  pieChart1(obj);
              }else{
                $scope.piecharts = true;
              }
              
            if(tempArr2[0].total!=0){
              $scope.appointmentCount2 = tempArr2;
              $scope.piecharts = false;
                var obj = [{
                    name: '0-6m',
                    y: tempArr2[0].six_months,
                    sliced: true,
                    selected: true
                  },{
                    name: '6m-1yr',
                    y: tempArr2[0].twelve_months,
                  }, {
                    name: '1-3yr',
                    y: tempArr2[0].three_year,
                  }, {
                    name: '>3yrs',
                    y: tempArr2[0].threeyear_above,
                  },];

                pieChart2(obj);
            }else{
              $scope.piecharts = true;
            }
        });
           
        // $scope.Appointment(data);
                if(data.acc_id) {
                    
                    recordService.getAppointments(data).then(function(response) {
                        $scope.AppListConfirmed = 0;
                        $scope.AppListClosed = 0;
                        $scope.AppListCancelled = 0;
                        angular.forEach(response,function(value){
                            if(value.status == 'confirmed'){
                                $scope.AppListConfirmed += 1;
                            } else if(value.status == 'closed'){
                                $scope.AppListClosed += 1;
                            } else if(value.status == 'cancelled'){
                                $scope.AppListCancelled += 1;
                            }
                        });

                        if( response ) {
                                
                            if( authService.authentication.doctor_id ) {
                                $scope.AppList = ($filter('filter')(response, {'with_doctor_id':authService.authentication.doctor_id}));
                            }
                            //$scope.AppList = response;
                        }    
                    },function(err, response) {
                        $ngBootbox.alert(err.Message);
                    });                
                };    
    };

    $scope.initAppointment = function(){
        var date = new Date();
        $scope.appointment_date1 = date;
        $scope.appointment_date2 = date;
        $scope.byRange(" ",date,2);
        $scope.Appointment();
    };

    $scope.datepicker1 = {
        opened:{appointment_date1:false, appointment_date2:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
            formatYear: 'yyyy',
            startingDay:0,
            maxDate: new Date(),
        }
    };
        
    $scope.datepicker2 = {
        opened: { appointment_date1:false,appointment_date2:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay:0,
            minDate:new Date(),
        }
    };

    $scope.byRange = function(from, to, range_no) { 

        if(range_no=="1") {

            $scope.rangePicker2 = {
                opened :{ fromDate:false, toDate:false},
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
                dateOptions : {
                  formatYear: 'yyyy',
                  startingDay: 0,
                  maxDate: new Date(),
                  minDate: from
                }
            };

            $scope.from_date = $filter('date')(from, "dd-MMM-yyyy");  

        } else if(range_no=="2"){

            $scope.rangePicker1 = {
                opened : {fromDate:false, toDate:false},
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
                dateOptions : {
                  formatYear: 'yyyy',
                  startingDay: 0,
                  maxDate: to
                }
              }
                  
            $scope.to_date =  $filter('date')(to, "dd-MMM-yyyy");
        }
 
        if($scope.from_date && $scope.to_date) {
            $scope.Appointment();
        }  
    }


    // $rootScope.details={
    // front_desk_number1:"",
    // front_desk_number2:"",
    // front_desk_cell1:"",
    // front_desk_cell2:"",
    // avg_time_per_patient:""
    //     };

    // $scope.saveDetails=function(details){
    //     $scope.save = false;
    //     $scope.edit2 = true;
    //     $scope.edit = true;
    //     $scope.edit1 = false;

    // var data = {"account_email":authService.authentication.account_id,
    //               "data":{
    //                 "settings": { 
    //                       "front_desk_number1": $rootScope.details.front_desk_number1,
    //                       "front_desk_number2":$rootScope.details.front_desk_number2,
    //                       "front_desk_cell1":$rootScope.details.front_desk_cell1,
    //                       "front_desk_cell2":$rootScope.details.front_desk_cell2,
    //                       "avg_time_per_patient":$rootScope.details.avg_time_per_patient
    //                 }
    //              }
    // }

    // recordService.saveSettings(data).then(function(response){
    //     // location.reload();
    //         $scope.edit = true;
    //         $scope.edit1 = true;
    //         $rootScope.details=response;
    //     },function(err, response){
    //      $ngBootbox.alert(err.Message);


    // };

    var retryGetSettings = 0;
    $scope.getSetting = function() {
        if($sessionStorage.get('avg_time_per_patient') == null) {
            recordService.getSettings().then(function(response) {
                if(response!="error") {
                    $rootScope.details=response;
                    if(response.avg_time_per_patient) {
                        $sessionStorage.put('avg_time_per_patient', JSON.stringify((response.avg_time_per_patient * 60) - 120));
                    }
                } else {$rootScope.details={}}
            },function(error) {
                // toastr.error(error);
                if(retryGetSettings < 3){
                    retryGetSettings ++;
                    $scope.getSetting();
                } else {
                    toastr.error('Check your internet connections',error);
                    $scope.newmem = analytics('getSetting','unable to get dr settings');
                }
            });
        }
    };
    $scope.getSetting();

    $scope.loadLocationList = function (){
        locationService.getLocation().then(function(response){
            $rootScope.locationList = response;
        },function (err, response) {
        toastr.error(err.error);
        $scope.newmem = analytics('loadLocationList',err.error);
        });
    };

    $rootScope.locationStatus = 0;
    $scope.getLocationStatus = function() {
        locationService.getSettings().then(function(response) {
            $sessionStorage.put('preference', JSON.stringify(response));
            $rootScope.locationStatus = response.multilocation;
            $rootScope.isChatEnabled = JSON.parse($sessionStorage.get('preference')).chat;
            chatService.unread().then(function(response){
                $sessionStorage.put('totalUnread', JSON.stringify(response.total_unread));
                $rootScope.totalUnread = JSON.parse($sessionStorage.get('totalUnread'));
            })
            if($rootScope.locationStatus == 1) {
                $scope.loadLocationList();
            }
            else {
            }
        },function(error) {
            // toastr.error(error);
            // console.log(error);
            // $scope.getLocationStatus();
        })
    };
    
    $scope.getLocationStatus();
    $scope.edit  = true;
    $scope.edit1 = true;
    $scope.save  = false;
    $scope.edit2 = true;

    $scope.editDetails=function(details) {
        $scope.edit=false;
        $scope.edit1=false;
        $scope.save=true;
        $scope.edit2=false;
    };

    $scope.complaint = function(data,email,appointId,type){
        $sessionStorage.put('patientAccEmail',email);
        $sessionStorage.put('appointment_id', appointId);
        $sessionStorage.put('complaint',type);
        $location.path('/complaint/'+data);
    };

    $rootScope.pay = {};

    $scope.viewPatient = function(id,status,mr,email,account_id,type,video_conf,ID,payloadData){
        console.log('video_confvideo_conf',id,status,mr,email,account_id,type,video_conf,ID);
        sessionStorage.setItem('conference_type',video_conf);
        sessionStorage.setItem('conference_id',ID);
        if(type == 'video_call'){
            $rootScope.show_conf = 1;
        }else {
            $rootScope.show_conf = 0;
        }

        if(status=='consultation') {
            $sessionStorage.put('consult', "true");
            $rootScope.end_consultation=false;
        } else if(status=='confirmed' || status == 'closed') {
            $sessionStorage.put('consult',"false");
        }
        sessionStorage.setItem('patientid',id)
        $location.path('/patientview/'+id);

        $rootScope.pay.mr = mr;
        $sessionStorage.put('patientAccEmail',email);
        $sessionStorage.put('status', status);
        $sessionStorage.put('appointment_id', account_id);
        $sessionStorage.put('enableConsulation', 'true');
        $sessionStorage.put('appt_type', type);
        if(sessionStorage.enablefloating == 'true'){
//stored and get videocall access token from this controll to anoter controll
if(payloadData){
    recordService.joinVideoCall(payloadData).then(function(response) {
        console.log(response);
        if(response) {
            $rootScope.videoScreenShowing = true;
            
            // $sessionStorage.put('video_room_name', response.room_name);
            // $sessionStorage.put('video_access_token', response.access_token);
            // $sessionStorage.put('video_sid', response.s_id);
            // console.log('homecont***roomname******'+$sessionStorage.get('video_room_name'));
            // console.log('homecont***video_accesstoken******  '+$sessionStorage.get('video_access_token'));
            $sessionStorage.put('floatingVideoScreenStatus','true');
            
            $sessionStorage.put('video_room_name', response.room_name);
            $sessionStorage.put('video_access_token', response.access_token);
            $sessionStorage.put('video_sid', response.s_id);
            
            // $rootScope.videoScreenShowing = $sessionStorage.get('floatingVideoScreenStatus');
            
            console.log('floatingvideo***status******'+$rootScope.videoScreenShowing);
            console.log('homecont***roomname******'+$sessionStorage.get('video_room_name'));
            console.log('homecont***video_accesstoken******  '+$sessionStorage.get('video_access_token'));
        }
    })
  }
        }
        
    };

    $scope.queueStatus = function(item) {
        return (item.status == 'closed' || item.status == 'confirmed' || item.status == 'consultation')
    }

    $scope.cancel = function() {
        location.reload();
    };

    $rootScope.queuelist = [];
    var countQueueAPIFail = 0;
    
    $scope.loadqueue = function() {
        $scope.loaded = 1;
      //$rootScope.connectToChannel();
        recordService.getQueue().then(function(response) {

            $rootScope.loadBanner();
            $rootScope.queuelist = response;
            console.log('$rootScope.queuelist',$rootScope.queuelist);
            angular.forEach($rootScope.queuelist,function(value) {
                if((value.type == "voice_call" || value.type == "emergency_voice_call" )&& value.arrival_time == null){
                    $scope.setarrival(value);
                }
            });
            $scope.loaded = 2;
        
        },function(err, response) {
            $scope.loaded = 2;
            countQueueAPIFail += 1;
            if(countQueueAPIFail <= 3) {
                $scope.loadqueue();
            } else { 
                toastr.error(response);
                countQueueAPIFail = 0;
                $scope.newmem = analytics('loadqueue',response);
            }
        });
    };
    var countClosedQueueAPIFail = 0;
    $scope.patientQueueClosed = function() {

        recordService.patientqueueclosed().then(function(response) {
            $rootScope.queuelist = response;
            $scope.loaded = 2;
        },function(err, response) {
            $scope.loaded = 2;
            countClosedQueueAPIFail += 1;
            
            if(countClosedQueueAPIFail <= 3) {
                $scope.patientQueueClosed();
            } else {
                toastr.error(response);
                countClosedQueueAPIFail = 0;
                $scope.newmem = analytics('patientqueueclosed',response);
            }
        });
    };

    $scope.patient_QueueClosed = function() {

            $scope.loaded = 3;
          //$rootScope.connectToChannel();
            recordService.getQueue().then(function(response) {
                $rootScope.queuelist=[];
                $rootScope.loadBanner();
                for(var i=0;i<response.length;i++){
                    if(response[i].arrival_time != null){
                        $rootScope.queuelist.push(response[i]);
                    }
                }
                angular.forEach($rootScope.queuelist,function(value) {
                    if((value.type == "voice_call" || value.type == "emergency_voice_call" )&& value.arrival_time == null){
                        $scope.setarrival(value);
                    }
                });
                $scope.loaded = 3;
            
            },function(err, response) {
                $scope.loaded = 3;
                countQueueAPIFail += 1;
                if(countQueueAPIFail <= 3) {
                    $scope.loadqueue();
                } else { 
                    toastr.error(response);
                    countQueueAPIFail = 0;
                    $scope.newmem = analytics('loadqueue',response);
                }
            });
    
    };
    $scope.selectQueueType = function(data) {
        if(data === 2) {
            $scope.chooseQueue = 2;
            $scope.patientQueueClosed();
        } else if(data === 1){
            $scope.chooseQueue = 1;
            $scope.loadqueue();
        }else if(data === 4) {
            $scope.chooseQueue = 4;
            $scope.patient_QueueClosed();
        } 
    };

    
    if($scope.accountEmail == 'rx122340@rxcarenet.org'){
        $scope.chooseQueue = 4;
        $scope.selectQueueType(4);
    }else{
        $scope.chooseQueue = 1;
        $scope.selectQueueType(1);
    }
   


    $scope.viewGrowthData = function(patient) {
        $location.path('/init-patient/'+ patient.record_id);
    };

    $scope.vaccineTabs = [{Id:1, heading: 'Appointment Queue'}];
    $scope.settingTabs = [{Id:1, heading: 'Details'}];
    $scope.scheduleTabs = [{Id:1, heading: 'Vaccine Schedule'},{Id:2, heading: 'Vaccine Appointment' }];
    
    $scope.setScheduleTabContent = function(id) { 
        $rootScope.selectedscheduleTab = id;
        if($rootScope.selectedscheduleTab==1){
            $scope.schedulevac();
        }
        if($rootScope.selectedscheduleTab==2) {
            $scope.loadvaccine();
        }
    };
    $scope.setScheduleTabContent(1);

    $scope.setarrival = function(queue) {
        queue.arrival_time = new Date();
        var data = {account_email: authService.authentication.account_id, patient_account: queue.email, appointment_id: queue.id}
        
        recordService.set_patientarrival(data).then(function(response) {
            toastr.success(response.Message , { timeOut: 4500 });
        },function(err, response) {
            toastr.error(err.Message);
            $scope.newmem = analytics('setarrival',err.Message);
        });
        //$rootScope.loadBanner();
    };

    $rootScope.notifyToken = function() {
        var data = {
            "notification_type": "both",
            "account_email": authService.authentication.account_id,
            "patient_email":$rootScope.cancelMsgContent.email,
            "content": $rootScope.cancelMsgContent.msg_content
        }

        recordService.appointmentreschedulenotification(data).then(function(response) {
            response.message?toastr.success(response.message , { timeOut: 4500 }):toastr.success(response , { timeOut: 4500 });
            $rootScope.cancelMsgContent = {};
            $ngBootbox.hideAll();
        }, function(error) {
            toastr.error(error);
            $rootScope.cancelMsgContent = {};
            $ngBootbox.hideAll();
            $scope.newmem = analytics('notifyToken',error);
        });
    };

  /* voice call from front */
  $rootScope.bookVoice = function() {
  
//    console.log('$rootScope.queuelist', $rootScope.queuelist);

   var param_data = {
      account_email: authService.authentication.account_id,
      patient_email: $rootScope.cancel_MsgContent.email,
      doctor_id: authService.authentication.doctor_id,
      a_id:$scope.notifydata.id
   };
   $scope.voiceCallInitiateStatus = "Trying to schedule the voice call...";
    console.log(param_data);
   recordService.startAudioCall(param_data).then( function(response) {
       console.log( response );
       if( response.success==1 ) {
           $scope.voiceCallInitiateStatus = "The Call has been initiated.";
       } else if( response.success==0 ) {
           $scope.voiceCallInitiateStatus = "Unable to create call.";
       }
   }, function(error) {
        toastr.error(error);
   });
//    window.location.href = '../home#/home';
};


    $rootScope.notify_Token = function() {
        
        console.log('$scope.notifydata',$scope.notifydata.type,$scope.notifydata.account_id);
        var data1 = {
            "account_email": authService.authentication.account_id,
            "patient_email":$rootScope.cancel_MsgContent.email,
             "a_type": $scope.notifydata.type,
             "a_id":$scope.notifydata.id,
             "doctor_id": authService.authentication.doctor_id
        }

        recordService.appointmentreschedule_notification(data1).then(function(response) {
            console.log('toaster response',response);
            response.message?toastr.success(response.message , { timeOut: 4500 }):toastr.success(response, { timeOut: 4500 });
            // $scope.showmessage = true;
            // $scope.toastr_array.push(response.message);
            // document.getElementById("to_aster").innerHTML = "";
            // document.getElementById("to_aster").innerHTML  += "<li class='alert alert-success' style='list-style-type:none'>"+response.message+"</li>"+"\n" ;
            $rootScope.cancel_MsgContent = {};
            $ngBootbox.hideAll();
            $scope.loadqueue();
        }, function(error) {
            toastr.error(error);
            $rootScope.cancel_MsgContent = {};
            $ngBootbox.hideAll();
            $scope.newmem = analytics('notify_Token',error);
        });
    };

    $scope.notifyTokenPopup = function(queue) {
        // console.log('queue',queue);
        $rootScope.cancelMsgContent = queue;
        $rootScope.cancelMsgContent.msg_content1 = "Dear "+ queue.name_given+" "+queue.name_family+",\nDue to unavoidable reasons your appointment has been postponed to hh:mm.\nSorry for the inconvenience. Use MyHealth app to re-select your preferences";
        $rootScope.cancelMsgContent.msg_content = $rootScope.cancelMsgContent.msg_content1;
        
        var options = {
            title: '<b>Sent Notification</b>',
            templateUrl: 'views/notifyTokenFromQueue.htm',
            size:'medium',
            onEscape: function() {$rootScope.cancelMsgContent = {};$scope.$apply();}
        }
        $ngBootbox.customDialog(options);
    };

    $scope.notify_callagree = function(queue) {
        console.log('queue',queue);
        $scope.loadqueue();
        if( (queue.allow_status == 1) && (queue.participant_connect_status == 1)){
            $scope.notifydata = queue;
            $rootScope.cancel_MsgContent = queue;
            $rootScope.cancel_MsgContent.msg_content1 = "Dear Doctor!"+"\n"+"This will enable IVRS call to notify the  patient that you are available to start the consultation.";
            $rootScope.cancel_MsgContent.msg_content = $rootScope.cancel_MsgContent.msg_content1;
            
            var options = {
                title: '<b>Send Notification</b>',
                templateUrl: 'views/notify_Token_and_join.htm',
                size:'medium',
                onEscape: function() {$rootScope.cancel_MsgContent = {};$scope.$apply();}
            }
            $ngBootbox.customDialog(options);
            
        } else {

            $scope.notifydata = queue;
            $rootScope.cancel_MsgContent = queue;
            // console.log('$rootScope.cancel_MsgContent', $rootScope.cancel_MsgContent.allow_status);
            $rootScope.cancel_MsgContent.msg_content1 = "Dear Doctor!This will Notify Patient that you are available through ivrs call.";
            $rootScope.cancel_MsgContent.msg_content = $rootScope.cancel_MsgContent.msg_content1;
            
            // var someValue = false;
            // if( $rootScope.cancel_MsgContent.allow_status == 1){
            //     someValue = false;
            // }

            var options = {
                title: '<b>Send Notification</b>',
                templateUrl: 'views/notify_Tokenfromqueue.htm',
                size:'medium',
                onEscape: function() {$rootScope.cancel_MsgContent = {};$scope.$apply();}
            }
            $ngBootbox.customDialog(options);
        }

    };

    function getPatientDetails(mr_number, callback) {           
            
        authService.getPatientSearch( mr_number ).then(function(response) { 
               callback(response);
        }, function (err, response) {                       
                toastr.error(err.error);
                $scope.newmem = analytics('getPatientDetails', err.error);
        });
    }

    $scope.cancelVideoCall = function(payload) {

        recordService.notifyVideoCancel(payload).then(function(response) {
            //console.log(response);
        },function (err) {

        });
    };

    $scope.callJoinRoom = function(sender_id, payload) {
        $rootScope.videoScreenShowing = true;

        // var payload = {
        //    patient_email: $sessionStorage.get('video_call_patient'),
        //    account_email: authService.authentication.account_id,
        //    doctor_id: authService.authentication.doctor_id,
        // }
        console.log(payload);
     
        recordService.joinVideoCall(payload).then(function(response) {
            console.log(response);

            if(response) {

                $rootScope.videoCallresponse = response;
                console.log($rootScope.videoCallresponse)
                // Pubnub.publish({
                //    "channel": "videocall_"+sender_id,
                //    "message": payload2
                // }, function(status, response){
                //    //handle publish response if needed
                // });

                var openUrl;
                $sessionStorage.put('floatingVideoScreenStatus','true');
                $sessionStorage.put('video_room_name', response.room_name);
                $sessionStorage.put('video_access_token', response.access_token);
                $sessionStorage.put('video_sid', response.s_id);

                console.log('home controller');
                console.log('homecont***roomname******'+$sessionStorage.get('video_room_name'));
                console.log('homecont***video_accesstoken******  '+$sessionStorage.get('video_access_token'));

                //commented by justin for floating video
                window.open('https://exp.epicare.net:8000/room/'+$sessionStorage.get('video_room_name')+'/'+$sessionStorage.get('video_access_token'),'_blank');
            }

		},function (err, response) {});
    } 


    $rootScope.doctorJoinCall  = function(){
        console.log('notifydata',$scope.notifydata);
        var senderId = $scope.notifydata.email.replace('@','_').replace('.org', '')+'_'+authService.authentication.doctor_id;
        var payload = {
            patient_email: $scope.notifydata.email,
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id,
            channel_name: senderId,
            a_type: $scope.notifydata.type,                 
            a_id: $scope.notifydata.id
        }
        $location.path("/patientview/"+ $scope.notifydata.record_id);
        $rootScope.calljoinroom = payload ;
        $scope.callJoinRoom(senderId, payload);
        $scope.loadqueue();
        $rootScope.cancelMsgContent = {};
        $ngBootbox.hideAll();
      
    }

    $rootScope.doctorJoinOnClick  = function(queue){
        console.log('notifyonclick_queue',queue);
        console.log('notifycall type',queue.type);
        $rootScope.showiframe = queue.type;
        console.log('$rootScope.showiframe',$rootScope.showiframe);
        sessionStorage.setItem('call_type',queue.type);
        $scope.notifydata = queue;
        var senderId = $scope.notifydata.email.replace('@','_').replace('.org', '')+'_'+authService.authentication.doctor_id;
        var payload = {
            patient_email: $scope.notifydata.email,
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id,
            channel_name: senderId,
            a_type: $scope.notifydata.type,                 
            a_id: $scope.notifydata.id
        }
       // $location.path("/patientview/"+ $scope.notifydata.record_id);
        $scope.viewPatient(queue.record_id,queue.status,queue.mr_number,queue.email,queue.id,queue.type,queue.video_conf,queue.id,payload);
        
        if(sessionStorage.enablefloating == 'false'){
            $scope.callJoinRoom(senderId, payload);
        }
        $scope.loadqueue();
        $rootScope.cancelMsgContent = {};
        setTimeout("startConsultation();", 1000);
        // $location.path('/home');
        $ngBootbox.hideAll();

    }


    $scope.videoCall = function(data, msg) {

        $sessionStorage.put('video_call_patient', data[1]);
       // $sessionStorage.put('video_call_mode', data[2]);

            var senderId = data[1].replace('@','_').replace('.org', '')+'_'+authService.authentication.doctor_id;
            
            var apt_id = '';
            if(data[2]=='video_call') {
                apt_id = data[7];
            }

            if(msg == 'join') {
               
                // payload = {
                    //     "date": "",
                    //     "sender": authService.authentication.account_id,
                    //     "message": "pick",
                    //     "receiver": "",
                    //     "mr_number": data[0],
                    //     "channel_name": data[3],
                    //     "a_type": data[2],                 
                    //     "a_id": apt_id
                // };    
                console.log("***get**patientview_recordId*****"+$sessionStorage.get('appointment_id'))
                    
                    var payload = {
                       // patient_email: $sessionStorage.get('video_call_patient'),
                       patient_email: $sessionStorage.get('video_call_patient'),
                        account_email: authService.authentication.account_id,
                        doctor_id: authService.authentication.doctor_id,
                        //channel_name: data[3],
                        channel_name: senderId,
                        a_type: data[2],                    
                        a_id: apt_id
                    }

                    //console.log(payload);
                    //window.open( 'https://helyxon.com/rtc/test/?'+data.message.room_id,'_blank' ); 
                    //window.open( 'https://appr.tc/r/'+$scope.lastuser_roomid,'_blank' );
                    if(sessionStorage.enablefloating == 'false'){
                        $scope.callJoinRoom(senderId, payload);
                    }
                     
                    // $location.path("/patientview/"+ $sessionStorage.get('appointment_id'));
                    if(sessionStorage.enablefloating == 'true'){
                         $scope.viewPatient($sessionStorage.get('appointment_id'),'','','','','','','',payload);
                    }
                   // $scope.viewPatient($sessionStorage.get('appointment_id'),'','','','','','','',payload);
                    
                } else if(msg == 'cancel') {

                    // payload = {
                    //     "date": "",
                    //     "sender": authService.authentication.account_id,
                    //     "message": "cancel",
                    //     "receiver": "",
                    //     "mr_number": data[0],
                    // };

                    // Pubnub.publish({
                    //     "channel": "videocall_"+senderId,
                    //     "message": payload
                    // }, function(status, response){
                    //     //handle publish response if needed
                    // });

                    var payload =  {
                        account_email: authService.authentication.account_id,
                        doctor_id: authService.authentication.doctor_id,
                        a_id: apt_id,
                        mode: data[2],
                        patient_email: $sessionStorage.get('video_call_patient'),
                        channel_name: data[3]
                    }

                    //var payload = '&doctor_id='+authService.authentication.doctor_id+'&a_id='+apt_id+'&mode='+data[2]+'&patient_email='+$sessionStorage.get('video_call_patient')+'&channel_name='+data[3];            
                    //console.log(payload); 
                    $scope.cancelVideoCall(payload);
                }

            // } else if(msg == '15') {

            //     payload = {
            //         "date": data.message.date,
            //         "sender": authService.authentication.account_id,
            //         "message": "call after 15 mins",
            //         "receiver": data.message.sender,
            //     };

            // } else if(msg == '30') {

            //     payload = {
            //         "date": data.message.date,
            //         "sender": authService.authentication.account_id,
            //         "message": "call after 30 mins",
            //         "receiver": data.message.sender,
            //     };

            // } else if(msg == '1hr') {

            //     payload = {
            //         "date": data.message.date,
            //         "sender": authService.authentication.account_id,
            //         "message": "call after 1 hour",
            //         "receiver": data.message.sender,
            //     };

            // } 

        // } else {
        //     //control for clear
        // }
        
    };

    // $scope.value_call =false;
    // $scope.intiatecall = (value_call) =>{
    //     alert('hello');
    //     console.log('value_call',value_call)
    // }

    $rootScope.notifyFunc = function( data ) {
       console.log('data',data);
        if(data[2] == "emergency_video_call") {

            $.notify.addStyle('video', {
                html: 
                "<div>"+
                    "<h5 style='margin-left: 95px; height: 35px; font-size: 18px; font-weigt: unset;'><b>Emergency Videocall</b><span class='emoji' style='margin-left: 12px; font-size: 22px;'>&#128249;</span></h5>"+
                        "<div class='title' data-notify-html='title'/>"+
                            "<div class='buttons'>"+
                                "<ul style='text-decoration:none; display:inline-block;'>"+
                                    "<li>"+
                                        "<button class='no btn'>Cancel</button>"+   
                                        "<button id='yes' class='btn btn-success' data-notify-text='button'></button>"+                                  
                                "</li>"+
                                "</ul>"+
                            "</div>"+
                        "</div>"+
                "</div>"
            });
        } else if(data[2] == "video_call") {

            $.notify.addStyle('video', {
                html: 
                "<div>"+
                    "<h5 style='margin-left: 135px; height: 35px; font-size: 18px; font-weigt: unset;'><b>Videocall</b><span class='emoji' style='margin-left: 12px; font-size: 22px;'>&#128249;</span></h5>"+
                        "<div class='title' data-notify-html='title'/>"+
                            "<div class='buttons'>"+
                                "<ul style='text-decoration:none; display:inline-block;'>"+
                                    "<li>"+
                                        "<button class='no btn'>Cancel</button>"+   
                                        "<button id='yes' class='btn btn-success' data-notify-text='button'></button>"+                                  
                                "</li>"+
                                "</ul>"+
                            "</div>"+
                        "</div>"+
                "</div>"
            });     
            // alert();               
            // document.getElementById("video_call").innerHTML = "<button id='yes' class='btn btn-success' data-notify-text='button'>join</button>"
               
        }
              
        $.notify({
            title: '<span style="font-family: sans; color: yellow; font-weight: bolder !important; font-size: 14px !important; float: left; margin-left: 10px;">'+
                   '('+data[6]+' - '+data[0]+' - '+data[5]+' - '+data[4]+')'+
                   '</span>', 
            button: 'Join'
        }, { 
            style: 'video',
            autoHide: false,
            clickToHide: false
        });                         

        // //add a new style 'foo'
        // $.notify.addStyle('foo', {
        //     html: 
        //     "<div>"+
        //         "<span class='emoji'>&#128249;</span>&nbsp;<h5><b>Doctor! Incoming Call</b></h5><div class='clearfix'>"+
        //             "<div class='title' data-notify-html='title'/>"+
        //                "<br>"+
        //                "<div class='buttons'>"+
        //                     "<ul style='text-decoration:none;display:inline-block;'>"+
        //                         "<li>"+
        //                             "<button class='yes' data-notify-text='button' value='"+msg.message.mr_number+'/'+msg.message.sender+'/'+msg.message.mode+"'></button>"+                                         
        //                             // "<button value='15' class='no2'>Call after 15 mins</button>"+
        //                             // "<button value='30' class='no3'>Call after 30 mins</button>"+
        //                             // "<button value='1hr' class='no4'>Call after 1 hr</button>"+
        //                             "<button value='"+msg.message.mr_number+'/'+msg.message.sender+'/'+msg.message.mode+"' class='no'>Cancel</button>"+
        //                         "</li>"+
        //                     "</ul>"+
        //                 "</div>"+
        //             "</div>"+
        //     "</div>"
        // });
                
        // $.notify({
        //     title: msg.message.message+' from :'+msg.message.name+' ( Mr Number: '+msg.message.mr_number+', Gender: '+msg.message.gender+', Age: '+msg.message.age+' )',
        //     button: 'Join'
        // }, { 
        //     style: 'foo',
        //     autoHide: false,
        //     clickToHide: false
        // });              
                    
        //var audio = new Audio('Content/vendors/notify_sound2.mp3');    
        var audio = new Audio('Content/vendors/vdocall_ring.wav');  
        
        $scope.play_Promise = function() {
            var playPromise = audio.play();
            if(playPromise !== undefined) {
                playPromise.then(function() {
                    //Automatic playback started!
                }).catch(function(error) {
                    //Automatic playback failed.
                    //Show a UI element to let the user manually start playback.
                });
            }
            $rootScope.audioPromise = $timeout( $scope.play_Promise, 1000);
        }
        $scope.play_Promise();
    }

    //listen for click events from this style
    $(document).on('click', '.notifyjs-video-base .no', function() {       
        if($rootScope.audioPromise) {
            $timeout.cancel($rootScope.audioPromise);
        }
        //var btnVal = $(this).val();
        //programmatically trigger propogating hide event 
        //if($scope.videoCallData!=undefined && $scope.videoCallData.message.mode!=="cancel_ecall") {
        //  $scope.videoCall($scope.videoCallData, 'cancel');
        //}
        var ssnData = localStorage.getItem("next_videocall_detail");
        var spltArray = ssnData.split('/');
        $scope.lastuser_roomid = $sessionStorage.get('lastuser_roomid'); 

        //alert( $scope.lastuser_roomid+' == '+spltArray[3]+'_'+ spltArray[0] );
        //if( $scope.lastuser_roomid == spltArray[3]+'_'+ spltArray[0]) {
            $scope.videoCall(spltArray, 'cancel');
            sessionStorage.setItem("videocall_status", "" );
        //}
        $(this).trigger('notify-hide');
    });

    // //listen for click events from this style
    // $(document).on('click', '.notifyjs-foo-base .no2', function() {       
    //     $scope.videoCall($scope.videoCallData, '15');
    //     $(this).trigger('notify-hide');
    // });
         
    // //listen for click events from this style
    // $(document).on('click', '.notifyjs-foo-base .no3', function() {                
    //     $scope.videoCall($scope.videoCallData, '30');
    //     $(this).trigger('notify-hide');
    // });
         
    // //listen for click events from this style
    // $(document).on('click', '.notifyjs-foo-base .no4', function() {                
    //     $scope.videoCall($scope.videoCallData, '1hr');
    //     $(this).trigger('notify-hide');
    // });

    // funtion to play reload sound when patient is joining the video call room
    $scope.playReloadAlert = function()
    {
        var audio = new Audio('Content/vendors/reload.wav');
        audio.play();
    }

    $scope.showAlert = function() {
        var options = {
            message: 'Please close current consultation.',
            title: 'Confirmation',
            buttons: {
             /* warning: {
                    label: "Cancel",
                    className: "btn-warning"
                }, */
                success: {
                    label: "Ok",
                    className: "btn-success",
                    callback: function() {  }
                }
            }
        };
        $ngBootbox.customDialog(options);
    }

    // $(document).on('click', '.notifyjs-video-base #yes', function() {
    //     alert('clicked..');
    // });
                    
    $(document).on('click', '.notifyjs-video-base #yes', function() {
        //alert('emergency');

        if($rootScope.audioPromise) {
            $timeout.cancel($rootScope.audioPromise);
        }

        var ssnData = localStorage.getItem("next_videocall_detail");
        var spltArray = ssnData.split('/');
        //$scope.lastuser_roomid = $sessionStorage.get('lastuser_roomid'); 
        //if( $scope.lastuser_roomid == spltArray[3]+'_'+spltArray[0] ) {

        var current_timestamp = spltArray[0]+'_'+spltArray[8];
        var previous_timestamp = localStorage.getItem("videocall_timestamp");

        // console.log( current_timestamp );
        // console.log( previous_timestamp );

        if( current_timestamp == previous_timestamp) {

             localStorage.setItem("previous_timestamp", current_timestamp);

                if(sessionStorage.getItem("videocall_status") == '') {
                    if( sessionStorage.getItem("consultStatus") == 'true' ) { 

                        sessionStorage.setItem("videocall_status", 'waiting' );
                        $scope.showAlert();
            
                    } else if( sessionStorage.getItem("consultStatus") == 'false' || sessionStorage.getItem("consultStatus") == undefined ){                         
                               
                        //if( $scope.patientRecord_id ) { 

                            $sessionStorage.put('lastuser_roomid','');
                            var data = {account_email: authService.authentication.account_id, patient_account: spltArray[1], appointment_id: sessionStorage.getItem("videocall_apt_id")};
                                
                            recordService.set_patientarrival(data).then(function(response) {
                                toastr.success(response ,{ timeOut: 4500 });
                            },function(err, response) {
                                toastr.error(err.Message);
                            });

                            sessionStorage.setItem("videocall_status", "" );
                            localStorage.setItem("next_videocall_detail", "");
                            
                            getPatientDetails(spltArray[0], function returnPatientDetails(data) {
                                console.log(spltArray);
                                console.log(data);
                                if(data) {
                                    console.log("***goTopatientview_1*****")
                                    if(sessionStorage.enablefloating == 'false'){
                                        $location.path("/patientview/"+ data[0].record_id);
                                        $sessionStorage.put('consult',"false");  
                                    }
                                    if(sessionStorage.enablefloating == 'true'){
                                        $sessionStorage.put('appointment_id', data[0].record_id);
                                        $scope.videoCall(spltArray, 'join');
                                    }
                                }
                            });                
                           if(sessionStorage.enablefloating == 'false'){
                            $scope.videoCall(spltArray, 'join');
                           }
                       // }
                            // if($scope.videoCallData!=undefined) {
                            //   $scope.videoCall($scope.videoCallData, 'join');
                            // }                   
                    }

                } else {       

                    // if( $scope.patientRecord_id ) {
                    //     $sessionStorage.put('lastuser_roomid',''); 
                    //     //alert('patient record id: '+$scope.patientRecord_id);  
                    //     localStorage.setItem("next_videocall_detail", "");
                    //     sessionStorage.setItem("videocall_status", '');
                    //     $location.path("/patientview/"+$scope.patientRecord_id); 
                    // }
                    
                    getPatientDetails(spltArray[0], function returnPatientDetails(data) {  
                        //console.log(data);
                        if(data) {
                            console.log("***goTopatientview_2*****&&&&")
                            $location.path("/patientview/"+ data[0].record_id);
                            $sessionStorage.put('consult',"false");
                        }
                       // $location.path("/patientview/"+$scope.patientRecord_id); 
                    });
                    $scope.videoCall(spltArray, 'join');   
                }
       // }

        }

        $(this).trigger('notify-hide'); 
        
        /*  //show button text
            //alert($(this).text() + " clicked!");
            if($scope.videoCallData!=undefined) {
              $scope.videoCall($scope.videoCallData, 'join');
            }
            //hide notification
            $(this).trigger('notify-hide');
        */
    });
   
    // $scope.getPatientDetails = function(message,val) {           
    //     authService.getPatientSearch(val).then(function(response) { 
    //         $scope.patientRecord_id = response[0].record_id;
    //         $scope.patientName = response[0].full_name;
    //     }, function (err, response) {                       
    //         toastr.error(err.error);
    //         $scope.newmem = analytics('getPatientDetails', err.error);
    //     });
    // }

   

    $(document).on('click', '.notifyjs-vital_popup-base .yes_vital', function() {
        $(this).trigger('notify-hide');
    });

    $scope.notifyVitalCriticalMsg = function(msg) {
      //add a new style 'vital_popup'
        $.notify.addStyle('vital_popup', {
            html: 
            "<div>"+
                "<h5 style='margin: 3px 0 3px 0 !important; height: 50px; font-size:15px; float: right;'><b>Critical Patient Alert!</b><span class='emoji' style='margin-left: 100px !important;'>&#128161;</span></h5>"+
                    "<div class='title' data-notify-html='title'/>"+
                        "<div class='buttons'>"+
                            "<ul style='text-decoration:none; display:inline-block;'>"+
                                "<li>"+
                                    "<button class='yes_vital' data-notify-text='button'>Yes</button>"+                                   
                                "</li>"+
                            "</ul>"+
                        "</div>"+
                    "</div>"+
            "</div>"
        });
              
        $.notify({
            title: 'Dear Dr, following Patient is reported very sick and waiting for your attention in reception.'+
            '<br>'+
            '<span style="color:yellow; font-weight: bold !important; font-size: 14px !important;">'+
            '( '+msg.message.mrno+' - '+msg.message.baby_name+' - '+msg.message.age+' - '+msg.message.gender+' - Critical Score: '+msg.message.score+' )'+
            '</span>', 
            button: 'Ok'
        }, { 
            style: 'vital_popup',
            autoHide: false,
            clickToHide: false
        });                                
    } 
    
    //Chat demo work
    $rootScope.channel = authService.authentication.account_id.replace('@','_').replace('.org', '');
    $rootScope.uuid = authService.authentication.account_id;

    Pubnub.init({
        publishKey: 'pub-c-c3cecd91-62bc-4365-b2d1-a6333576f17f',
        subscribeKey: 'sub-c-60c79014-12d7-11e8-b32f-5ea260837941',
        uuid: $scope.uuid
    });

    //Subscribing to the �messages-channel� and triggering the message callback
    Pubnub.subscribe({
      //channels: [$rootScope.channel, 'get_banner_'+$rootScope.channel],
        channels: [$rootScope.channel, 'get_banner_'+$rootScope.channel, 'videocall_'+$rootScope.channel+'_'+authService.authentication.doctor_id, 'vital_criticalityscore_'+$rootScope.channel+'_'+authService.authentication.doctor_id, 'voice_' + authService.authentication.account_id+'_'+authService.authentication.doctor_id ,'room_' + authService.authentication.account_id+'_'+authService.authentication.doctor_id],
        withPresence: true,
        triggerEvents: ['callback', 'message', 'presence']
    }); 
 
    // $scope.toastr_array = [];
    $scope.hidemessage = function(){
        $scope.showmessage = false;
        // document.getElementById("to_aster").innerHTML = "";
    }

    Pubnub.addListener({
        presence: function(m) {
          //console.log(m.state)
        },
        message: function( message ) {  
            //console.log( message );

            if( message ) {
                if(message.channel!="") {

                    var splitted_Channel_Name = message.channel.split("_");
                          
                    if(splitted_Channel_Name[0] == 'vital') {
                        
                        $scope.last_user = $sessionStorage.get('lastuser');

                        if(message.message.mrno != $scope.last_user) {
                            $sessionStorage.put('lastuser', message.message.mrno);
                            $scope.notifyVitalCriticalMsg(message);
                        }

                    } else if(splitted_Channel_Name[0] == 'videocall') {
                        
                       // $scope.lastuser_roomid = $sessionStorage.get('lastuser_roomid');    
                        //if( $scope.lastuser_roomid != message.message.room_id+'_'+ message.message.mr_number ) {   

                            if( message.message.mode=="emergency_video_call"){

                                if($rootScope.audioPromise) {
                                    $timeout.cancel($rootScope.audioPromise);
                                }     

                                $sessionStorage.put('video_call_mode', message.message.mode);         
                                $sessionStorage.put("current_videocall_apt_type", message.message.mode);

                                //localStorage.setItem("windowOpen", false);
                                localStorage.setItem("videocall_timestamp", message.message.mr_number+'_'+message.message.timestamp);

                                sessionStorage.setItem("videocall_status", '');
                                localStorage.setItem("next_videocall_detail", message.message.mr_number+'/'+message.message.sender+'/'+message.message.mode+'/'+ message.message.channel +'/' +message.message.age+'/'+ message.message.gender +'/'+ message.message.name +'/'+message.message.a_id +'/'+message.message.timestamp);

                                //$sessionStorage.put("lastuser_roomid", message.message.room_id+'_'+ message.message.mr_number );
                                var sessionData = localStorage.getItem("next_videocall_detail");
                                var spltArr = sessionData.split('/');
                                //console.log(spltArr);
                                $rootScope.notifyFunc( spltArr );
                               
                                //$scope.getPatientDetails(message, message.message.mr_number);
                                $scope.videoCallData = message;    

                            } else if( message.message.mode=="video_call" ) {

                                if($rootScope.audioPromise) {
                                    $timeout.cancel($rootScope.audioPromise);
                                }                        

                                //localStorage.setItem("windowOpen", false);
                                localStorage.setItem("videocall_timestamp", message.message.mr_number+'_'+message.message.timestamp);

                                sessionStorage.setItem("videocall_status", "");
                                localStorage.setItem("next_videocall_detail", message.message.mr_number+'/'+message.message.sender+'/'+message.message.mode+'/'+ message.message.channel +'/' +message.message.age+'/'+ message.message.gender +'/'+ message.message.name+'/'+message.message.a_id +'/'+message.message.timestamp);
                                
                                $sessionStorage.put('video_call_mode', message.message.mode);
                                $sessionStorage.put("current_videocall_apt_type", message.message.mode);
                                //$sessionStorage.put("lastuser_roomid", message.message.room_id+'_'+message.message.mr_number);
                                $sessionStorage.put("videocall_apt_id", message.message.a_id);
                                
                                var sessionData = localStorage.getItem("next_videocall_detail");
                                var spltArr = sessionData.split('/');
                                //console.log(spltArr);
                                $rootScope.notifyFunc( spltArr );
                                //$scope.getPatientDetails(message, message.message.mr_number);
                                //$sessionStorage.put('last_schVideocall_data', message); 
                           
                            } else if( message.message.mode=="cancel_ecall" ) {
                                $scope.videoCallData = message;
                                $(".notifyjs-video-base .no").trigger("click");                
                            } 
                       // }
                    } else if(splitted_Channel_Name[0] == "voice"){
                        // console.log(message.message.message , 'msg');
                        toastr.success( message.message.message.mr_number+" : "+ message.message.message.status , { timeOut: 4500 });
                        // $scope.toastr_array += ( message.message.message.mr_number+" : "+ message.message.message.status );
                        $scope.showmessage = true;
                        // $scope.toastr_array.push( message.message.message.mr_number+" : "+ message.message.message.status );
                        // document.getElementById("to_aster").innerHTML += ( message.message.message.mr_number+" : "+ message.message.message.status );
                        // document.getElementById("to_aster").innerHTML += "<li class='alert alert-success' style='list-style-type:none'>"+( message.message.message.mr_number+" : "+ message.message.message.status )+"</li>"+"\n"
                        console.log('$scope.toastr_array',$scope.toastr_array);
                    }
                    else if (splitted_Channel_Name[0] == "room") {
                        console.log(message.message.message , 'msg');
                        toastr.success( message.message.message ,{ timeOut: 4500 });
                        $scope.playReloadAlert();
                        if($scope.chooseQueue == 4){
                            $scope.patient_QueueClosed();
                        }else{
                        $scope.loadqueue();
                        }
                    } 
                    else {
    
                        chatService.unread().then(function(response) {
                            $sessionStorage.put('totalUnread', JSON.stringify(response.total_unread));
                            $rootScope.totalUnread = JSON.parse($sessionStorage.get('totalUnread'));
                        });

                        if((JSON.parse($sessionStorage.get('preference'))).can_notify_chat===1&&message.message!='banner'){
                            //toastr.info("New message received.")
                        }   
                    }
                }
            }
        }
    });
        
    $scope.companion = {};
    Pubnub.hereNow(
        {
           channels: [$rootScope.channel],
           includeUUIDs: true,
           includeState: true
        },
        function (status, response) {
          // handle status, response
          // angular.forEach(response.channels.$rootScope.channel.occupants, function(value) {
          //   if($scope.uuid!==value.uuid) {
          //      $scope.companion = value;
          //   }
          // });
        }
    );

    // Listening to the callbacks
    $rootScope.$on(Pubnub.getMessageEventNameFor($rootScope.channel), function (ngEvent, envelope) {
        $scope.$apply(function() {
            // add message to the messages list
            chatService.unread().then(function(response) {
               $sessionStorage.put('totalUnread', JSON.stringify(response.total_unread));
               $rootScope.totalUnread = JSON.parse($sessionStorage.get('totalUnread'));
            })
        });
    });

    // A function to display a nice uniq robot avatar 
    // $scope.avatarUrl = function(uuid) {
    //   return 'http://robohash.org/'+uuid+'?set=set2&bgset=bg2&size=70x70';
    // };

    // function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){ dataLayer.push(arguments); }
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net') {
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
           'event_category' : 'homeController',
           'event_label' : aLabel
        });
    }

    
    function pieChart1(data) { 
        $('#pie_container1').highcharts({
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },

            credits: {
                enabled:false
            },
            title: {
                text: '<b>Appointment</b>'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        if(this.y!=0) {
                            return '<b>'+this.key+'</b>'+" ( "+ this.y +" ) ";
                        } else {
                            return "";
                        }
                    },
                }
                },
            },

            series: [{
                name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    }

    function pieChart2(data) { 
        $('#pie_container2').highcharts({
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            credits:{
                enabled: false
            },
            title: {
                text: '<b>Age Category</b>'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        formatter: function(){
                            if(this.y!=0){
                                return '<b>'+this.key+'</b>'+" ( "+ this.y +" ) ";
                            } else {
                                return "";
                            }
                        },
                    }
                }
            },
            series: [{
                name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    }
}]);



/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('homevisitController', ['$scope', '$rootScope', '$sessionStorage', '$location', '$route', '$ngBootbox', '$uibModal', '$filter', 'paymentService', 'authService', 'homevisitService', 'dischargeService', 'dashboardService', 'toastr',
function($scope, $rootScope, $sessionStorage, $location, $route, $ngBootbox, $uibModal, $filter, paymentService, authService, homevisitService, dischargeService, dashboardService, toastr) {

  $scope.reportNameShow      = "true";
  $scope.homeVisitReportName = "";

  var homeVisitUrlArr = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi).split('/');
  var homeVisitUrl    = homeVisitUrlArr[homeVisitUrlArr.length-1];

  $scope.hvReport1 = "false";
  $scope.hvReport2 = "false";
  $scope.hvReport3 = "false";
  $scope.hvReport4 = "false";

  $rootScope.hv1Show = "false";
  $rootScope.hv2Show = "false";
  $scope.selected_param = "0";

  $scope.errMsg = "";
  $scope.errMsgShow = true;
  $scope.showContainer = false;

  $scope.completeBtnDisable = true;
  $scope.timeInputDisable = true;

  switch(homeVisitUrl) {
    case 'hvReport1':
      $scope.hvReport1           = "true";
      $scope.homeVisitReportName = "Ontime % Compliance of Home Visit";
      $scope.printReportName     = "Compliance_Home_Visit_Report";
      $scope.printId             = "1";
    break;
    case 'hvReport2':
      $scope.hvReport2           = "true";
      if($rootScope.showVhn == true){
        $scope.homeVisitReportName = "Supervisor Performance Report"
        $scope.printReportName     = "Supervisor_Performance_Report";
      }else{
        $scope.homeVisitReportName = "VHN Performance Report ";
        $scope.printReportName     = "VHN_Performance_Report";
      }
      // $scope.homeVisitReportName = "VHN Performance Report";
      // $scope.printReportName     = "VHN_Performance_Report";
      $scope.printId             = "2";
    break;
    case 'hvReport3':
      $scope.hvReport3           = "true";
      $scope.homeVisitReportName = "Baby Health Status";
      $scope.printReportName     = "Baby_Health_Status_Report";
      $scope.printId             = "3";
    break;
    case 'hvReport4':
      $scope.hvReport4           = "true";
      $scope.homeVisitReportName = "Baby Growth Status";
      $scope.printReportName     = "Baby_Growth_Status_Report";
      $scope.printId             = "4";
    break;
    default:
    break;
  }

  $scope.changeParam = function(value) {
    $scope.selected_param = value;
  }
  
  $scope.exportType = "";
  $scope.rangePicker1 = {
    opened: { fromDate:false, toDate:false },
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions: {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: new Date()
    }
  };

  $scope.rangePicker2 = {
    opened: { fromDate:false, toDate:false },
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions: {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: new Date(),
    }
  };

  function start_endOfWeek(date,start,end) {
    var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
    return new Date(date.setDate(diff));
  }

  function getStringDate(date) {
    var day   = date.getDate();
    var month = date.getMonth()+1;
    var year  = date.getFullYear(); 
    return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
  }

  function getPreviousDate(days, value){
    var dateOffset  = parseInt(days * value);
    var convertDate = new Date();
        convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
    return convertDate;   
  }

  $scope.exportCompleteReportExcel = function(filename,id) {
    var blob = new Blob([document.getElementById('printcompletetable'+id).innerHTML], {  
      type: "application/vnd.ms-excel;charset=utf-8"
    });
    saveAs(blob, filename+".xls");
  }

  $scope.exportData = function(fileType) {
      var id2;
      if($scope.hv1Show=='true') {
        id2 = "1";
      } else if($scope.hv2Show=='true') {
        id2 = "2";
      }
      
      if(fileType=="EXCEL") {

        var blob = new Blob([document.getElementById('printtable'+$scope.printId+id2).innerHTML], {  
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        saveAs(blob, $scope.printReportName+".xls");

      } else if(fileType=="PDF") {

        html2canvas(document.getElementById('printtable'+$scope.printId+id2), {
          onrendered: function (canvas) {
            var data2 = canvas.toDataURL();
            var docDefinition2 = {
                content: [{
                  image: data2,
                  width: 500,
                }]
            };
            pdfMake.createPdf(docDefinition2).download($scope.printReportName+".pdf");
          }
        });

      }    
  }

  $scope.exportData2 = function(type) {

    $scope.date = new Date();
    $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
      
    var filename2 = "CRC_Village_Wise_Report_"+$scope.formattedDate;
    if($scope.hidetable2=='false') {   
      if($scope.selectedFromDate && $scope.selectedToDate){
        filename2 = "CRC_Village_Wise_Report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
      }
    }

    var filename = "Home_Visit_Report_"+$scope.formattedDate;
    if($scope.selectedFromDate && $scope.selectedToDate) {
      filename = "Home_Visit_Report"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
    }
  
    if(type=='CSV') {
      alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#exportable',{headers:true})");
    } else if(type == 'EXCEL') {
    //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
      var blob = new Blob([document.getElementById('printtable2').innerHTML], {
        type: "application/vnd.ms-excel;charset=utf-8"
      });

      var blob = new Blob([document.getElementById('printtable1').innerHTML], {  
        type: "application/vnd.ms-excel;charset=utf-8"
      });
      saveAs(blob, filename+".xls");

      if($scope.hidetable2=='false') {
        var blob = new Blob([document.getElementById('printtable2').innerHTML], {  
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        saveAs(blob, filename2+".xls");
      }
    } else if(type=='PDF') {
              
   /* if($scope.hidetable2=='false') {  
        html2canvas(document.getElementById('printtable2'), {
          onrendered: function (canvas) {
            var data1 = canvas.toDataURL();
            var docDefinition1 = {
                  content: [{
                    image: data1,
                    width: 500,
                  }]
            };
            pdfMake.createPdf(docDefinition1).download(""+filename2+".pdf");
          }
        });
      } */

      html2canvas(document.getElementById('printtable1'), {
        onrendered: function (canvas) {
          var data2 = canvas.toDataURL();
          var docDefinition2 = {
                content: [{
                  image: data2,
                  width: 500,
                }]
          };
          pdfMake.createPdf(docDefinition2).download(""+filename+".pdf");
        }
      });

    }
  }

/*$('#donutchart').highcharts({
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false
    },
    credits: {
      enabled: false
    },
    title: {
      text: 'Browser<br>shares<br>2017',
      align: 'center',
      verticalAlign: 'middle',
      y: 60
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          distance: -50,
          style: {
            fontWeight: 'bold',
            color: 'white'
          }
        },
        startAngle: -90,
        endAngle: 90,
        center: ['50%', '75%'],
        size: '110%'
      }
    },
    series: [{
      type: 'pie',
      name: 'Browser share',
      innerSize: '50%',
      data: [
        ['Chrome', 58.9],
        ['Firefox', 13.29],
        ['Internet Explorer', 13],
      /*['Edge', 3.78],
        ['Safari', 3.42],*/
      /*{
          name: 'Other',
          y: 7.61,
          dataLabels: {
            enabled: false
          }
        }
      ]
    }]
  }); */

  $scope.showBarChart = function(data,xdata,id,title,subtitle,format) {

      $("#barchart"+id).highcharts({
            chart: {
                type: 'column'
            },
            title: {
                text: title
            },
            credits:{
              enabled: false
            },
            xAxis: {
                categories: xdata
            },
            yAxis: {
                min: 0,
                title: {
                    text: subtitle
                },
            /*  stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                    }
                } */
            },
           /* legend: {
                align: 'right',
                x: -30,
                verticalAlign: 'top',
                y: 25,
                floating: true,
                backgroundColor: 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },*/
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '{series.name}: {point.y:.f}%<br/>Total: {point.stackTotal}%'
            },
            plotOptions: {
              column: {
                  stacking: 'normal',
                  dataLabels: {
                    enabled: true,
                  }
              },
              series: {
                  dataLabels: {
                      enabled: true,
                      format: format,
                      style: {
                        fontWeight: 'bold',
                        color: 'black'
                      }
                  }
              }
            },   
            series: data
      });

   /*   $("#barchart"+id).highcharts({
        chart: {
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: {
          text: title
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          categories: xdata,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: subtitle
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding-right: 2px;">{series.name}:</td>' +
                        '<td>{point.y}</td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            },
            series: {
              dataLabels: {
                enabled: true,
                format: format,
                style: {
                  fontWeight: 'light',
                  color: 'gray'
                }
              }            
            }
          },
          series: data
      });*/
  }

  $scope.showPieChart = function(data,id,title) {

    /*  $('#piechart'+id).highcharts({
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        credits: {
          enabled: false
        },
        title: {
          text: title
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: [{
        /*name: 'Brands',*/
    /*    colorByPoint: true,
          data: data
        }]
      }); */

      // Create the chart
      //Highcharts.chart('container', {
      $('#piechart'+id).highcharts({

          chart: {
              type: 'pie'
          },
          title: {
              text: title
          },
          credits:{
            enabled: false
          },
          subtitle: {
              text: ''
          },
          plotOptions: {
              series: {
                  dataLabels: {
                      enabled: true,
                      format: '{point.name}: {point.y:.f}%'
                  }
              }
          },
          tooltip: {
              headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.f}%</b> of total<br/>'
          },
          series: [
            {
              colorByPoint: true,
              data: data
            }
          ]

        });

  }

  function homevisitPieChartData(data) {

    var id,title;
    if(homeVisitUrl == 'hvReport3') {
      
      id = "1";
      title = "Baby Health Status";
        
      var tempArray = [
        {
          name: 'Alive and Healthy',
          y: data.grandtotal.healthy,
        /*sliced: true,
          selected: true*/
          color: 'green'
        },
        {
          name: 'Needs Opinion',
          y: data.grandtotal.needsopinion, 
          color: 'orange'
        },
        {
          name: 'Needs Reference',
          y: data.grandtotal.needsreference,
          color: 'lime'
        },
        {
          name: 'Re-Admitted',
          y: data.grandtotal.readmitted,
          color: 'yellow'
        },
        {
          name: 'Not Traceable',
          y: data.grandtotal.notreachable,
          color: 'magenta'
        },
        {
          name: 'Not Interested',
          y: data.grandtotal.notinterested,
          color: 'purple'
        },
        {
          name: 'Expired',
          y: data.grandtotal.expired,
          color: 'red'
        }
      ];
          
      $scope.showPieChart(tempArray,id,title);   

    } else if(homeVisitUrl == 'hvReport4') {
      
      id = "2"; 
      title = "Baby Growth Status";
    
      var tempArray = [
        {
          name: 'Normal Growth',
          y: data.grandtotal.normal,
        /*sliced: true,
          selected: true*/
          color: 'green'
        },
        {
          name: 'Low Growth',
          y: data.grandtotal.low, 
          color: 'red'
        },
        {
          name: 'High Growth',
          y: data.grandtotal.high,
        },
        {
          name: 'Abnormal Growth',
          y: data.grandtotal.abnormal,
          color: 'orange'
        },
      ];
        
      $scope.showPieChart(tempArray,id,title);  
    }     
  }

  function homevisitBarChartData(data) {
    
    if(homeVisitUrl == 'hvReport1') {

      var id            = "1";
      var title         = "Ontime % Compliance of Home Visit";
      var subtitle      = "Numbers in Percentage";
      var format        = '{point.y}%';
      var compliance    = [];
      var noncompliance = [];
      var xColumnList   = [];

      if($scope.village_id==0 || $scope.village_id=="0") {

        angular.forEach(data.visitdetails, function(value, key) {	
          compliance.push(value.compliance);
          noncompliance.push(value.noncompliance);
          xColumnList.push(value.staffname);
        });

      } else if($scope.village_id!=0 && $scope.village_id!="0") {

        angular.forEach(data.visitdetails, function(value, key) {	
          compliance.push(value.compliance);
          noncompliance.push(value.noncompliance);
          xColumnList.push(value.villagename);
        });
      }

      var tempArray = [
        {
          name: '% of Ontime Visit Compliance (# Of Visits done on Scheduled Date/ # of Scheduled Visits)*100',
          data: compliance, 
          color: 'Green' 
        },
        {
          name: 'Non-Compliance',
          data: noncompliance,
          color: 'Red'
        }
      ];

      $scope.showBarChart(tempArray,xColumnList,id,title,subtitle,format);
               
    } else if(homeVisitUrl == 'hvReport2') {

        var id          = "2";
        var title       = "Number of Home Visits";
        var subtitle    = "Numbers";
        var format      = '{point.y}';
        var scheduled   = [];
        var visited     = [];
        var notvisited  = [];
        var xColumnList = [];

        if($scope.village_id==0 || $scope.village_id=="0"){

          angular.forEach(data.visitdetails, function(value, key) {	
            scheduled.push(value.scheduled); 
            visited.push(value.visited);
            notvisited.push(value.notvisited);
            xColumnList.push(value.staffname);
          });

        } else if($scope.village_id!=0 && $scope.village_id!="0"){

          angular.forEach(data.visitdetails, function(value, key) {	
            scheduled.push(value.scheduled); 
            visited.push(value.visited);
            notvisited.push(value.notvisited);
            xColumnList.push(value.villagename);
          });
        }

        var tempArray = [
          {
            name: '# of Scheduled Visits',
            data: scheduled, 
          },
          {
            name: '# Of Visits Made',
            data: visited,
            color: 'Green'
          },
          {
            name: '# of Visits Missed',
            data: notvisited,
            color: 'Red'
          }
        ];
      
      $scope.showBarChart(tempArray,xColumnList,id,title,subtitle,format);
    } 
  }
  
  $scope.crcVillageWiseData = function() {

      $scope.crcVillageWiseArray = [];
      var payload = {
        account_email: authService.authentication.account_id,
        from_date: $scope.selectedFromDate,
        to_date: $scope.selectedToDate,
        district_id: $scope.district_id, 
        block_id: $scope.block_id,
        staff_id: $scope.staff_id,
        village_id: $scope.village_id
      }

      homevisitService.getCrcVillageWiseDetails(payload).then(function (response) {

        if(response.length!=0) {
          $scope.crcVillageWiseArray = response;
          $scope.hidetable2 = 'false';
        } else {
          $scope.hidetable2 = 'true';   
        }

      }, function (err) {
        //toastr.error(err);
          $scope.hidetable2 = 'true';
      });
  }

  $scope.callVisitDetailsApi = function(payload, callback) {  

    homevisitService.getVisitDetails(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);   
    });
  }

  $scope.callVillageWiseDetailsApi = function(payload, callback) {  
      
    homevisitService.getCrcVillageWiseDetails(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);            
    });
  }

  $scope.callHomeVisitComplianceApi = function(payload, callback) { 

    homevisitService.getCrcHomeVisitCompliance(payload).then(function (response) {
        callback(response);    
    }, function (err) {
      //toastr.error(err);    
    }); 
  }

  $scope.callVillageWiseVisitComplianceApi = function(payload, callback) {  
     
    homevisitService.getCrcVillageWiseVisitCompliance(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);        
    });
  }

  $scope.callBabyHealthStatusApi = function(payload, callback) {  
    
    homevisitService.getCrcWiseBabyHealthStatus(payload).then(function (response) {
        callback(response);        
    }, function (err) {
      //toastr.error(err);   
    });
  }

  $scope.callVillageWiseBabyHealthStatusApi = function(payload, callback) { 
    
    homevisitService.getVillageWiseBabyHealthStatus(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);
    }); 
  }

  $scope.callBabyGrowthStatusApi = function(payload, callback) {  

    homevisitService.getCrcWiseBabyGrowthStatus(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);            
    });
  }

  $scope.callVillageWiseBabyGrowthStatusApi = function(payload, callback) {
   
    homevisitService.getVillageWiseBabyGrowthStatus(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);         
    });
  }

  $scope.callCompleteComplainceApi = function(payload, callback) {
   
    homevisitService.getCompleteComplaince(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);         
    });
  }

  $scope.callCompletePerformanceApi = function(payload, callback) {
   
    homevisitService.getCompletePerformance(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);         
    });
  }

  $scope.callCompleteHealthStatusApi = function(payload, callback) {
   
    homevisitService.getCompleteHealthStatus(payload).then(function (response) {
        callback(response);   
    }, function (err) {
      //toastr.error(err);         
    });
  }

  $scope.callCompleteGrowthStatusApi = function(payload, callback) {
   
    homevisitService.getCompleteGrowthStatus(payload).then(function (response) {
        callback(response);
    }, function (err) {
      //toastr.error(err);         
    });
  }

  $scope.callCompleteReportsApi = function() {

    var requestPayload = {
      account_email: authService.authentication.account_id,
      start_dt: $scope.selectedFromDate2,
      end_dt: $scope.selectedToDate2,
      district_id: $scope.district_id, 
      block_id: $scope.block_id,
      staff_id: $scope.staff_id,
      village_id: $scope.village_id
    };

    switch(homeVisitUrl) {
      case 'hvReport1':
        $scope.callCompleteComplainceApi(requestPayload, function returnCompliance(data) { 
          $rootScope.completeHvReport1 = []; 
          $rootScope.completeHvReport1 = data;    
            setTimeout(function(){ $scope.exportCompleteReportExcel('CompleteComplainceReport',"1"); }, 1000);
        });
      break;
      case 'hvReport2':
        $scope.callCompletePerformanceApi(requestPayload, function returnPerformance(data) { 
          $rootScope.completeHvReport2 = []; 
          $rootScope.completeHvReport2 = data; 
            setTimeout(function(){  $scope.exportCompleteReportExcel('CompletePerformanceReport',"2"); }, 1000);
        });
      break;
      case 'hvReport3':
        $scope.callCompleteHealthStatusApi(requestPayload, function returnHealthStatus(data) {
          $rootScope.completeHvReport3 = [];  
          $rootScope.completeHvReport3 = data;  
            setTimeout(function(){ $scope.exportCompleteReportExcel('CompleteHealthStatusReport',"3");}, 1000);
        });
      break;
      case 'hvReport4':
        $scope.callCompleteGrowthStatusApi(requestPayload, function returnGrowthStatus(data) { 
          $rootScope.completeHvReport4 = []; 
          $rootScope.completeHvReport4 = data;  
            setTimeout(function(){  $scope.exportCompleteReportExcel('CompleteGrowthStatusReport',"4"); }, 1000);
        });
      break;
    }
  }  
    
  $scope.callHomeVisitReportsApi = function() {  
        
    var requestPayload = {
       account_email: authService.authentication.account_id,
       start_dt: $scope.selectedFromDate2,
       end_dt: $scope.selectedToDate2,
       district_id: $scope.district_id, 
       block_id: $scope.block_id,
       staff_id: $scope.staff_id,
       village_id: $scope.village_id
    }; 

    switch(homeVisitUrl) {
      case 'hvReport1':
        if($scope.village_id==0 || $scope.village_id=="0") {
          $scope.callHomeVisitComplianceApi(requestPayload, function returnCompliance(data) { 
            
            if(data.visitdetails.length!=0) {
              $rootScope.hvReport11 = [];
              $rootScope.hvReport11 = data;
              $rootScope.hv1Show = "true";
              $rootScope.hv2Show = "false";
              
              homevisitBarChartData(data); 

              $scope.errMsgShow = false;
              $scope.showContainer = true;
              $scope.completeBtnDisable = false;
          
            } else {
              document.getElementById("barchart1").innerHTML = "";
      
              $scope.errMsg = data.msg;
              $scope.errMsgShow = true;
              $scope.showContainer = false;
              $scope.completeBtnDisable = true;
           
            }    
          });
        } else if($scope.village_id!=0 && $scope.village_id!="0") {
          $scope.callVillageWiseVisitComplianceApi(requestPayload, function returnVillageCompliance(data) { 
            
            if(data.visitdetails.length!=0) {
              $rootScope.hvReport12 = [];
              $rootScope.hvReport12 = data;
              $rootScope.hv1Show = "false";
              $rootScope.hv2Show = "true";
              $scope.completeBtnDisable = false;
              $scope.errMsgShow = false;
              $scope.showContainer = true;
              homevisitBarChartData(data);
           
            } else {
              document.getElementById("barchart1").innerHTML = "";
              $scope.errMsg = data.msg;
              $scope.errMsgShow = true;
              $scope.showContainer = false;
              $scope.completeBtnDisable = true;
            }
          });
        }           
      break;
      case 'hvReport2':
        if($scope.village_id==0 || $scope.village_id=="0") {
          $scope.callVisitDetailsApi(requestPayload, function returnVisitDetails(data) { 
            
            if(data.visitdetails.length!=0) {
              $rootScope.hvReport21 = [];
              $rootScope.hvReport21 = data;
              $rootScope.hv1Show = "true";
              $rootScope.hv2Show = "false";

              homevisitBarChartData(data);

              $scope.errMsgShow = false;
              $scope.showContainer = true;
              $scope.completeBtnDisable = false;
            } else {

              document.getElementById("barchart2").innerHTML = "";
         
              $scope.errMsg = data.msg;
              $scope.errMsgShow = true;
              $scope.showContainer = false;
              $scope.completeBtnDisable = true;
            }
          });
        } else if($scope.village_id!=0 && $scope.village_id!="0") {
            $scope.callVillageWiseDetailsApi(requestPayload, function returnVillageWiseDetails(data) { 
              
              if(data.visitdetails.length!=0) {
                $rootScope.hvReport22 = [];
                $rootScope.hvReport22 = data;
                $rootScope.hv1Show = "false";
                $rootScope.hv2Show = "true";

                homevisitBarChartData(data);

                $scope.errMsgShow = false;
                $scope.showContainer = true;
                $scope.completeBtnDisable = false;
              } else {

                document.getElementById("barchart2").innerHTML = "";
       
                $scope.errMsg = data.msg;
                $scope.errMsgShow = true;
                $scope.showContainer = false;
                $scope.completeBtnDisable = true;
              }
            });
        }
      break;
      case 'hvReport3':
        if($scope.village_id==0 || $scope.village_id=="0") {
            $scope.callBabyHealthStatusApi(requestPayload, function returnBabyHealthStatus(data) { 
             
                if(data.visitdetails.length!=0) {
                  $rootScope.hvReport31 = [];
                  $rootScope.hvReport31 = data;
                  $rootScope.hv1Show = "true";
                  $rootScope.hv2Show = "false";

                  homevisitPieChartData(data);
  
                  $scope.errMsgShow = false;
                  $scope.showContainer = true;
                  $scope.completeBtnDisable = false;
                } else {

                  document.getElementById("piechart1").innerHTML = "";

                  $scope.errMsg = data.msg;
                  $scope.errMsgShow = true;
                  $scope.showContainer = false;
                  $scope.completeBtnDisable = true;
                 
                }
            });
        } else if($scope.village_id!=0 && $scope.village_id!="0") {
            $scope.callVillageWiseBabyHealthStatusApi(requestPayload, function returnVillageBabyHealthStatus(data) { 
                
                if(data.visitdetails.length!=0) {
                  $rootScope.hvReport32 = [];
                  $rootScope.hvReport32 = data;
                  $rootScope.hv1Show = "false";
                  $rootScope.hv2Show = "true";

                  homevisitPieChartData(data);
                  
                  $scope.errMsgShow = false;
                  $scope.showContainer = true;
                  $scope.completeBtnDisable = false;
                } else {

                  document.getElementById("piechart1").innerHTML = "";

                  $scope.errMsg = data.msg;
                  $scope.errMsgShow = true;
                  $scope.showContainer = false;
                  $scope.completeBtnDisable = true;
                
                }
            });
        } 
      break;
      case 'hvReport4':
        requestPayload.growth = $scope.selected_param;
        if($scope.village_id==0 || $scope.village_id=="0") {
            $scope.callBabyGrowthStatusApi(requestPayload, function returnBabyGrowthStatus(data) { 
                  
              if(data.growthstatus.length!=0) {
                $rootScope.hvReport41 = [];
                $rootScope.hvReport41 = data;
                $rootScope.hv1Show = "true";
                $rootScope.hv2Show = "false";

                homevisitPieChartData(data);
              
                $scope.errMsgShow = false;
                $scope.showContainer = true;
                $scope.completeBtnDisable = false;
              } else {
                document.getElementById("piechart2").innerHTML = "";

                $scope.errMsg = data.msg;
                $scope.errMsgShow = true;
                $scope.showContainer = false;
                $scope.completeBtnDisable = true;          
              }             
            });
        } else if($scope.village_id!=0 && $scope.village_id!="0") {
            $scope.callVillageWiseBabyGrowthStatusApi(requestPayload, function returnVillageBabyGrowthStatus(data) { 
             

              if(data.growthstatus.length!=0) {
                
                $rootScope.hvReport42 = [];
                $rootScope.hvReport42 = data;
                $rootScope.hv1Show = "false";
                $rootScope.hv2Show = "true";

                homevisitPieChartData(data);
                $scope.completeBtnDisable = false;
                $scope.errMsgShow = false;
                $scope.showContainer = true;
              } else {

                document.getElementById("piechart2").innerHTML = "";
                $scope.errMsg = data.msg;
                $scope.errMsgShow = true;
                $scope.showContainer = false;
                $scope.completeBtnDisable = true;  
              }
            });
        }  
      break;    
      default:
      break;
    }
  }
 
  $scope.initHomeVisit = function() {
  //document.getElementById("piechart").innerHTML="";
  //document.getElementById("barchart").innerHTML="";
  //$("#txtdob1").prop( "disabled", true );
  //$("#txtdob2").prop( "disabled", true );  
    $scope.hidetable2 = 'true';
    $scope.hidetable1 = 'true';
    $scope.ExportType = "";
    $scope.selected_day = "1";
    $scope.fromDate = new Date();
    $scope.toDate = new Date();
      
    var datArr  = getStringDate($scope.fromDate);
    var datArr2 = getStringDate($scope.toDate)
    $scope.selectedFromDate  = datArr[1];
    $scope.selectedFromDate2 = datArr[0];
    $scope.selectedToDate  = datArr2[1];
    $scope.selectedToDate2 = datArr2[0];
  }

  $scope.getDistricts = function() {

    $scope.hidetable2 = 'true';
    $scope.hidetable1 = 'true';
    $scope.completeBtnDisable = true;
      
    $scope.district_id = "0";  
    $scope.block_id    = "0";
    $scope.staff_id    = "0";
    $scope.village_id  = "0";

    $scope.selected_district = "";
    $scope.selected_block    = "";
    $scope.selected_vhn      = "";
    $scope.selected_village  = "";

    $scope.selected_district_name = "All";
    $scope.selected_block_name    = "All";
    $scope.selected_vhn_name      = "All";
    $scope.selected_village_name  = "All";
     
    $scope.districts_list = [];
    $scope.blocks_list    = [];
    $scope.vhn_list       = [];
    $scope.villages_list  = [];
    
    var param = {
      account_email: authService.authentication.account_id
    };
      
    dischargeService.getDistrictList(param).then(function (response) {
      $scope.districts_list = response;   
      if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){        
        $scope.selected_district_name = response[0].districtname;
        $scope.selected_district = response[0].id;    
        $scope.getBlocks(response[0].id);
      }
    }, function (error) {
        //toastr.error(error);
    });
  }

  $scope.getBlocks = function(id) {
    $scope.completeBtnDisable = true;

    if(id==null) {
      $scope.district_id = "0"; 
    } else {
      $scope.district_id = id+"";  
    } 

    $scope.hidetable2 = 'true';
    $scope.block_id   = "0";
    $scope.staff_id   = "0";
    $scope.village_id = "0";

    $scope.selected_block   = "";
    $scope.selected_vhn     = "";
    $scope.selected_village = "";

    $scope.selected_block_name   = "All";
    $scope.selected_vhn_name     = "All";
    $scope.selected_village_name = "All";
    
    $scope.blocks_list   = [];
    $scope.vhn_list      = [];
    $scope.villages_list = [];

    var param = { 
      account_email: authService.authentication.account_id,
      id: $scope.district_id 
    }     
      
    dischargeService.getBlockList(param).then(function (response) {
      $scope.blocks_list = response; 
      if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org"  || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){
        $scope.selected_block = response[0].id; 
        $scope.selected_block_name = response[0].blockname;
      //$scope.getVillages(response[0].id); 
        $scope.getVhn(response[0].id);
      }
    }, function (error) {
      //toastr.error(error);
    });
  }

  $scope.getVhn = function(block_id) { 

    $scope.completeBtnDisable = true;
    
    if(block_id==null) {
        $scope.block_id = "0"
        $scope.selected_block_name = "All"; 
    } else {
        $scope.block_id = block_id+""; 
        var tempArr = ($filter('filter')($scope.blocks_list, {'id':block_id})); 
        $scope.selected_block_name = tempArr[0].blockname; 
    }  

    $scope.vhn_id                = "0";
    $scope.village_id            = "0";
    $scope.selected_vhn          = "";
    $scope.selected_village      = "";
    $scope.selected_vhn_name     = "All";
    $scope.selected_village_name = "All";
    $scope.vhn_list              = [];
    $scope.villages_list         = [];
  //$scope.homevisitData();    
       
    var param = {	
      account_email: authService.authentication.account_id,
      id: $scope.block_id
    }
    
    dischargeService.getVhnList(param).then(function (response) {
      $scope.vhn_list = response;
    },function (error) {
      //toastr.error(error);
    });      
  } 
   
  $scope.getVillages = function(staff_id) {  

    $scope.completeBtnDisable = true;
    $scope.hidetable2 = 'true';

    if(staff_id==null) {
      $scope.staff_id          = "0";    
      $scope.selected_vhn_name = "All"; 
    } else {
      $scope.staff_id          = staff_id+""; 
      var tempArr              = ($filter('filter')($scope.vhn_list, {'staffid':staff_id})); 
      $scope.selected_vhn_name = tempArr[0].staffname;
    }
        
    $scope.village_id            = "0"; 
    $scope.selected_village      = "";
    $scope.selected_village_name = "All";
    $scope.villages_list         = [];

    var param = {	
      account_email: authService.authentication.account_id,
      id: $scope.staff_id
    }
    
    dischargeService.getStaffVillageList(param).then(function (response) {
      $scope.villages_list    = response;   
      $scope.selected_village = "";
    },function (error) {
      //toastr.error(error);
    });  
  }

  $scope.initHomeVisit();
  $scope.getDistricts();
 
/*$scope.getPanchayats = function(id) { 
    $scope.block_id     = id;
    $scope.panchayat_id = "0";
    $scope.village_id   = "0";
  
    $scope.selected_panchayat = "";
    $scope.selected_village   = "";
    $scope.panchayat_list     = [];
    $scope.villages_list      = [];
  //$scope.homevisitData();    
       
    var param = {	
      account_email: authService.authentication.account_id,
      id: id
    }
    
    dischargeService.getPanchayatList(param).then(function (response) {
      $scope.panchayat_list = response;
    }, function (error) {
    //toastr.error(error);
    });      
  }*/

  $scope.changeVillage = function(id) {

    $scope.hidetable1 = 'true';
    if(id==null) {
      $scope.village_id            = "0";
      $scope.selected_village_name = "All";
    } else {
      $scope.village_id            = id+"";
      var tempArr                  = ($filter('filter')($scope.villages_list, {'village_id':id})); 
      $scope.selected_village_name = tempArr[0].villagename;  
      $scope.selected_village      = id;
    }
  }

  $scope.changeDay = function(day) {
 
    if(day=="5") {
      $scope.timeInputDisable = false;
      $scope.fromDate = "";
      $scope.toDate   = "";
      $scope.selectedFromDate = "";
      $scope.selectedToDate = "";
      $scope.selectedFromDate2 = "";
      $scope.selectedToDate2 = "";   
      $scope.hidetable1 = 'true';  
      $scope.hidetable2 = 'true';   

    } else {
      $scope.timeInputDisable = true;
    }
      
    switch (day) {
      case "4":
      //var tempArray = getPreviousDate(1,30);
        var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
        var datArr = getStringDate(new Date(prevMonthFirstDate));
        $scope.selectedFromDate = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.fromDate = new Date(prevMonthFirstDate);
        var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
        var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
        $scope.selectedToDate = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
        $scope.toDate = new Date(prevMonthLastDate); 
      break;
      case "3":
      //var tempArray = getPreviousDate(1,7);
        var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
        var datArr = getStringDate(new Date(startLastWeek));
        $scope.selectedFromDate = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.fromDate = new Date(startLastWeek);
        var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
        var datArr2 = getStringDate(new Date(endLastWeek));
        $scope.selectedToDate = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
        $scope.toDate = new Date(endLastWeek);
      break;
      case "2":
        var tempArray = getPreviousDate(1,1);
        $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
        $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
        $scope.selectedToDate = $scope.selectedFromDate; 
        $scope.selectedToDate2 = $scope.selectedFromDate2;  
        $scope.fromDate = tempArray;
        $scope.toDate   = $scope.fromDate;       
      break;
      case "1": 
        var datArr = getStringDate(new Date());
        $scope.selectedFromDate  = datArr[1];
        $scope.selectedFromDate2 = datArr[0];  
        $scope.selectedToDate  = $scope.selectedFromDate; 
        $scope.selectedToDate2 = $scope.selectedFromDate2;
        $scope.fromDate = new Date();
        $scope.toDate   = $scope.fromDate;
      break;
    }
  }

  $scope.byRange = function(from,to) {

    if(from) {
      $scope.rangePicker2 = {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date(),
          minDate: from
        }
      };
    }
  
    if(to) {
      $scope.rangePicker1 = {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: to
        }
      };    
    };
  
    if(from && to) {
      var datArr = getStringDate(from);
      $scope.selectedFromDate = datArr[1];
      $scope.selectedFromDate2 = datArr[0];
      var datArr2 = getStringDate(to);
      $scope.selectedToDate = datArr2[1];
      $scope.selectedToDate2 = datArr2[0];;
    //$scope.homevisitData();
    }
  }

}]);

'use strict';
angular.module('AngularApp').controller('inandoutController', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'inoutService', '$ngBootbox', 'toastr',
    function ($scope, $rootScope, $location, $filter, authService, inoutService, $ngBootbox, toastr) {

        var alertArr = [];
        for (var i = 1; i <= 90; i++) {
            if (i % 5 == 0) {
                alertArr.push(i);
            }
        }
        $scope.alertvalue = alertArr[2]
        $scope.alertbefore = alertArr;

        var totalpatients = [];
        for (var i = 1; i <= 10; i++) {
            totalpatients.push(i);
        }
        $scope.patientsvalue = totalpatients[2]
        $scope.maxpatients = totalpatients;

        var remArr = [];
        for (var i = 1; i <= 10; i++) {
            remArr.push(i);
        }
        $scope.remaindersvalue = remArr[0]
        $scope.numberofrem = remArr;

        var intervalArr = [];
        for (var i = 3; i <= 30; i++) {
            intervalArr.push(i);
        }
        $scope.intervalvalue = intervalArr[0]
        $scope.intervalnotify = intervalArr;

        $scope.savesettings = function () {
            var data = {
                "account_email": authService.authentication.account_id,
                "doctor_id": $scope.authentication.doctor_id,
                "time_period":  $scope.alertvalue,
                "max_patient": $scope.patientsvalue,
                "notification_count": $scope.remaindersvalue,
                "notification_reminder_time": $scope.intervalvalue
            }
            console.log(data)
            inoutService.saveinoutsettings(data).then(function (response) {
                console.log(response)
                if (response.success == 0) {
                    toastr.error(response.message);
                }
                if (response.success == 1) {
                    toastr.success(response.settings);
                }
            }, function (error) {
                toastr.error(error);
            })
        }

    $scope.viewinoutSettings = function () {
        inoutService.getinoutSettings().then(function (response) {
            console.log(response)
            if(response.success == 1){
                $scope.alertvalue =  response.details[0].time_period
                $scope.patientsvalue = response.details[0].max_patient
                $scope.remaindersvalue = response.details[0].notification_count
                $scope.intervalvalue = response.details[0].notification_reminder_time
            } else if (response.success == 0){
                toastr.error("Unable to get details")
            }
        }, function (error) {
            toastr.error(error);
        })
}
$scope.viewinoutSettings();

$scope.redirectLocation = function(){
    $location.path("/settings");
}

    }]);

    // if (response.data.length > 0) {
            //     angular.forEach(response, function (value) {
            //         $scope.obstHistoryDetails = response.data
            //         $scope.obstHist.gravida = response.data[0].gravida
            //         $scope.obstHist.para = response.data[0].para
            //         $scope.obstHist.abortions = response.data[0].abortions
            //         $scope.obstHist.notes = response.data[0].notes
            //     })


            // }
'use strict';

angular.module('AngularApp').controller('incentiveController', ['$scope', '$location', '$rootScope', 'toastr', 'authService', 'incentiveService','$ngBootbox', function ($scope, $location, $rootScope, toastr, authService, incentiveService, $ngBootbox) {
 
    $scope.getIncentiveData = function (){

        $scope.selected_agent = '0'

        incentiveService.getIncentive().then(function (response) {
            console.log(response);
            if(response.success == 1){
                $scope.incentivedata = response.data
                $scope.selected_agent = response.data[0].agent_id
                $scope.getIncentiveData(response.data[0].agent_id)
            }
        })
    }

    $scope.getIncentiveData()


    $scope.update_incentive = function (data){
        console.log(data);
        $rootScope.selected = {}
        $rootScope.selected = data;
        console.log($rootScope.selected);
        var options = {
            title: '<b>Update Incentive</b>',
            message:'',
            templateUrl: 'views/incentive/updateIncentive.htm',
            size:'small', 
        };

        $ngBootbox.customDialog(options);

    }

    $rootScope.updateIncentive = function(){
        var data = {
            account_email: authService.authentication.account_id,
            "id": $rootScope.selected.id,   
            "weightage": $rootScope.selected.weightage, 
            "target": $rootScope.selected.target,
            "agent_id": $rootScope.selected.agent_account_id
        };
        incentiveService.updateIncentive(data).then(function (response) {
        console.log(response,'incentive');
            if(response.success == 1){
            toastr.success('Incentive updated')
            bootbox.hideAll();
            }
        })   
    }

    $scope.getIncentiveData = function(data){

        console.log(data,'data');

        // $scope.selectedAgentid = data

        // console.log($scope.selectedAgentid);

        // console.log($scope.incentivedata,'1');

        // console.log($scope.incentivedataFilter,'2');

        // filter method
        $scope.incentivedataFilter = $scope.incentivedata.filter(function (item) {
            return(item.agent_id == data)
        })

        // console.log($scope.incentivedataFilter,'3');
        // console.log(value,'value');
    }
}]);
'use strict';
angular.module('AngularApp').controller('indexController', ['$scope','$rootScope', '$location', 'authService', 'recordService', 'toastr', 'locationService', '$filter', '$templateCache', '$ngBootbox','$uibModal', '$timeout','$sessionStorage','Pubnub','$pubnubChannel','chatService','serviceBaseUrl','deviceDetector','$http',
    function ($scope, $rootScope, $location, authService, recordService, toastr, locationService, $filter, $templateCache, $ngBootbox,$uibModal,$timeout,$sessionStorage,Pubnub,$pubnubChannel,chatService,serviceBaseUrl,deviceDetector,$http) {

$rootScope.chengalpetDischargeSummary = true; 

$rootScope.showpatientdropdown = false;
$rootScope.showreport = false;
$rootScope.showVhn = false;

$rootScope.deviceDetector = deviceDetector
        $.get("https://api.ipify.org/?format=json").then(function (response) {
            if (response) {
                $rootScope.ipfordrlogin = response.ip

                $.get('https://ipapi.co/json/', function (data) {
                    $rootScope.device_lattitude = data.latitude
                    $rootScope.device_longitude = data.longitude
                })
            }
        }, function (error) {
            $rootScope.ipfordrlogin = "255.255.255.255"
        });

if(authService.authentication.account_id =="rx4@rxcarenet.org" || authService.authentication.account_id =="rx16165@rxcarenet.org" ){
    $rootScope.showpatientdropdown = true;
    $rootScope.showreport = true;
}else if(authService.authentication.account_id =="rx3@rxcarenet.org"){
    $rootScope.showpatientdropdown = false;
    $rootScope.showreport = false;
}


if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx133323@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){   
    $rootScope.reportShow = false;
    $rootScope.showreport = true;
    $rootScope.showpatientdropdown = true;
    if(authService.authentication.account_id == "rx172060@rxcarenet.org"){
        $rootScope.showVhn = true
        // alert($rootScope.showVhn)
    }else{
        $rootScope.showVhn = false
    }

} else {
    $rootScope.reportShow = true; 
}

$rootScope.$location = $location;
$scope.pId = $location.path().split('/');

var serviceUrl = serviceBaseUrl.split('//');
serviceUrl = serviceUrl[1].split(':');
$sessionStorage.put('serviceBaseUrl',serviceUrl[0]);

$rootScope.cdate = new Date(),
$rootScope.ndate = new Date($rootScope.cdate );
$rootScope.ndate.setHours($rootScope.cdate.getHours() + 4);

$rootScope.patId = "";
$rootScope.authentication = authService.authentication;
$scope.navOpen = false;
$scope.selectedCareNet = 0;
$scope.milestoneStatus = 1;

// authService.loadHelyxonApiUrl();
// $rootScope.imageUploadUrl = authService.helyxonApi.url +'cloud/image/upload/';   

// $rootScope.docdetails = {
//     doctordp : authService.authentication.doctor_image,
//     doctorname : authService.authentication.doctor_name,
//     doctordegree : authService.authentication.doctor_degree,
//     hospitalname : authService.authentication.hospital_name
//  }

//  console.log($scope.docdetails,"$scope.docdetails")

// $scope.showPopup1 =  true
//  $scope.showPopup2 = function(){
// $scope.showPopup1 = false
//  }

//  $scope.docbool = false;
//  $scope.togglestatus = function(){
//      $scope.docbool = !$scope.docbool;
//  }

//  $scope.doctor_status = function(docstatus){
//      if(docstatus == true){
//          $scope.doctorstatus = 1
//          var data = {
//              "status" : $scope.doctorstatus,
//              "account_email": authService.authentication.account_id,
//              "doctor_id": $scope.authentication.doctor_id
//          }
//          console.log(data)
//          inoutService.saveinoutstatus(data).then(function (response) {
//              console.log(response)
//          })
//      } else if(docstatus == false){
//          $scope.doctorstatus1 = 0
//          var data1 = {
//              "status" : $scope.doctorstatus1,
//              "account_email": authService.authentication.account_id,
//              "doctor_id": $scope.authentication.doctor_id
//          }
//          console.log(data1)
//          inoutService.saveinoutstatus(data1).then(function (response) {
//              console.log(response)
//          })
//      }
//  }

//  $scope.homestatus = function(){
//      inoutService.getinoutstatus().then(function (response) {
//          console.log("getdoctorstatus",response.details)
//          if(response.details[0].status == 1){
//              $scope.docstatus = true
//          } else if(response.details[0].status == 0){
//              $scope.docstatus = false
//          }
//      })
//   }
  
//  $scope.homestatus()

$scope.getMilestoneStatus = function() {
    locationService.getSettings().then(function(response) {
        if(response.milestone && response.milestone == 1) {
            $scope.milestoneStatus = response.milestone;    
        } else {
            $scope.milestoneStatus = 0;
        }
    },function(error) {
        toastr.error(error);
        analytics('getMilestoneStatus',error);
    })
};

$scope.getMilestoneStatus();
if($rootScope.bannerCall != undefined) {
    clearInterval($rootScope.bannerCall);
}

$rootScope.loadCarenetList = function() {
    $rootScope.doctorRecordId = authService.authentication.docRecord_id;
        recordService.getCarenetList($rootScope.doctorRecordId).then(function(response) {
            if(response) {
                $rootScope.carenetRecords = response.Carenets.Carenet;
                console.log('$rootScope.carenetRecords',$rootScope.carenetRecords);
                $rootScope.carenetRecords.sort(function(a,b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
        },function (err, response) {
            $ngBootbox.alert(err.Message);
        });
};

$rootScope.loadPatientList = function() {
    recordService.getPatients().then(function(response) {
        if(Array.isArray(response.Records.Record)) {
            
            $rootScope.patientList= response.Records.Record.filter(function(item) {
                return item.shared && !item.carenet_id;
            }).map(function(item) {
                item.label = item.label.replace(" (shared)","");
                return item;
            });

            $rootScope.doctorRecordId = response.Records.Record.filter(function(item) {
                return !item.shared;
            })[0].id;

            $rootScope.doctorAccountId = response.Records.Record.filter(function(item){
                return !item.shared;
            })[0].accountId;

        } else {
            $rootScope.doctorRecordId = response.Records.Record.id;
            $rootScope.patientList = [];
        }

            $rootScope.patientList.sort(function(a,b){
                if (a.label < b.label)
                    return -1;
                  if (a.label > b.label)
                    return 1;
                  return 0;
            });
            $rootScope.loadCarenetList();

    },function (err, response) {
        $ngBootbox.alert(err.Message);
    });
};

if($scope.authentication.isAuth && !$rootScope.appInitialized) {
  //$rootScope.loadPatientList();
    $rootScope.loadCarenetList();
    $rootScope.appInitialized = true;
} else {
    $rootScope.appInitialized = false;
}

$scope.getCareNetName = function() {
    if($scope.selectedCareNet==0)
        return "All Care Nets";
     return $rootScope.carenetRecords.filter(function(item) {
        return item.id == $scope.selectedCareNet;
     })[0].name;
};

$scope.setSelectedCareNet = function(careNetId){
    $scope.selectedCareNet = careNetId;
};

$scope.getPatientSearch = function(searchTerm){
    if($scope.selectedCareNet==0){ //search all patients
        return $rootScope.patientList.filter(function(item){
            return item.label.toLowerCase().indexOf(searchTerm.toLowerCase())>=0;
        });
    } else {
    }
};

$scope.searchPatient = function(){
    if($scope.selectedRecordId){
        $location.path('/patientview/'+$scope.selectedRecordId);
        $scope.selectedRecordId=null;
        $scope.selectedRecordName = '';
    }
};
$scope.searchPatient();

$scope.patientSearchSelect = function(item, model, label){
    setTimeout(function(){
        $('#txtPatientSearch').blur();
        $scope.selectedRecordName = model;
        $scope.selectedRecordId = item.id;
        $scope.searchPatient();
        $scope.$apply();
    },100);
};

$scope.$on('$routeChangeSuccess', function(next, current) {
	$scope.navOpen = false;
    var path =  $location.path();
    var noAuthPaths = ["/login","/signup"];

    if(noAuthPaths.indexOf(path)<0)
        if($scope.authentication.isAuth!=true){
          $location.path('/login');
        }
});

$scope.alertModal = {
    title: "",
    message: "",
    type: "success"
};

$scope.popupModal = {
    title: "",
    message: "",
    type: "success",
    buttons: [{
        title: '',
        type: 'primary',
        callback: function () { }
    }]
};

$scope.$on('broadcastAlert', function (event, args) {
    $scope.alertModal = args;
    $('#alertModal').modal('show');
});

$scope.$on('broadcastPopup', function (event, args) {
    $scope.popupModal = args;
    $('#popupModal').modal('show');
});

$scope.closeAlert = function () {
    $('#alertModal').modal('hide');
    if ($scope.alertModal.closeCallback) {
        $scope.alertModal.closeCallback();
    }
};

$scope.closePopup = function (index) {
    if($scope.popupModal.buttons[index].callback) {
        $scope.popupModal.buttons[index].callback();
    }
    $('#popupModal').modal('hide');
};

$rootScope.currentDate = new Date();

$scope.expandMenu = true;
$scope.toogleMenu = function () {
    $scope.expandMenu = !$scope.expandMenu;
};

$scope.logOut = function () {
    sessionStorage.removeItem("closerem")
  //console.log("Pubnub : ",Pubnub.unsubscribe);
    // if(Pubnub.unsubscribe) {
    //     Pubnub.unsubscribe({
    //         channels : [$rootScope.channel, 'get_banner_'+$rootScope.channel, 'videocall_'+$rootScope.channel, 'vital_criticalityscore_'+$rootScope.channel]
    //     });
    //     if($rootScope.end_consultation==true || $rootScope.end_consultation==undefined) {
    //         $sessionStorage.put('patientDetail','{}');
    //         $sessionStorage.put('patientAccEmail','');
    //         $sessionStorage.put('appointment_id','');
    //         $sessionStorage.put('consult','');
    //         $sessionStorage.put('enableConsulation', '');
    //         $sessionStorage.put('homevisitInit','false');

    //         $( $rootScope.popupHide ).trigger('notify-hide');

    //         authService.logOut();
    //         $rootScope.doctorRecordId="";
    //         $rootScope.appInitialized=false;
    //         $rootScope.banner={};
    //         $location.path('/login');
    //       //location.reload();
    //     } else if($rootScope.end_consultation==false) { 
    //         $scope.showPopup();
    //     }
    // } else {
        // $location.path('/home');
        // $scope.apply();

        if($rootScope.channel) {
            Pubnub.unsubscribe({
                channels: [$rootScope.channel, 'get_banner_'+$rootScope.channel, 'videocall_'+$rootScope.channel+'_'+authService.authentication.doctor_id, 'vital_criticalityscore_'+$rootScope.channel]
            });
        }

        if($rootScope.end_consultation==true || $rootScope.end_consultation==undefined) {
            $sessionStorage.put('patientDetail','{}');
            $sessionStorage.put('patientAccEmail','');
            $sessionStorage.put('appointment_id','');
            $sessionStorage.put('consult','');
            $sessionStorage.put('enableConsulation', '');
            if($rootScope.audioPromise) {
              $timeout.cancel($rootScope.audioPromise);
              $( '.notifyjs-video-base' ).trigger('notify-hide');
            }      
            authService.logOut();      
            $rootScope.doctorRecordId="";
            $rootScope.appInitialized=false;
            $rootScope.banner={};
            $location.path('/login');
          //location.reload();
        } else if($rootScope.end_consultation==false) {
            if(sessionStorage.enableics == "false"){
                $scope.showPopup();
            } else if($rootScope.showlostalert == true){
                $scope.icslostpopup('login');
            } else if ($rootScope.showlostalert == false){
                $location.path('/login');
            }  
        }
        
    //}
};

// Pubnub.init({
//  publishKey: 'demo',
//  subscribeKey: 'demo'
// });

 // Listening to the callbacks
    if($rootScope.authentication){
        var channel = authService.authentication.account_id.replace('@','_').replace('.org', '');
        $rootScope.$on(Pubnub.getMessageEventNameFor(channel), function (ngEvent, envelope) {
            $scope.$apply(function () {
                // add message to the messages list
                chatService.unread().then(function(response){
                    $sessionStorage.put('totalUnread', JSON.stringify(response.total_unread));
                    $rootScope.totalUnread = JSON.parse($sessionStorage.get('totalUnread'));
                })
            });
            // if((JSON.parse($sessionStorage.get('preference'))).can_notify_chat===1&&envelope.message.message!='banner'){
            //     toastr.info("New message received.")
            // }
        });
    }

$rootScope.loadBanner=function(){
    recordService.getBanner().then(function (response) {
       if (response != "error") { $rootScope.banner = response; }
       else{$rootScope.banner={}}
    });
};

//$scope.channel = 'get_banner_'+authService.authentication.account_id.replace('@','_');
$rootScope.connectToChannel = function() {
   var channel = 'get_banner_'+authService.authentication.account_id.replace('@','_');  
   $rootScope.bannerChannel = $pubnubChannel(channel);
};
//$rootScope.bannerChannel = $pubnubChannel($scope.channel, { autoload: 30 });

$scope.$watch($rootScope.bannerChannel, function() {
    $rootScope.loadBanner();
    var channel = authService.authentication.account_id.replace('@','_').replace('.org', '')
    $rootScope.$on(Pubnub.getMessageEventNameFor(channel), function (ngEvent, envelope) {
        $scope.$apply(function () {
          //add message to the messages list
            chatService.unread().then(function(response){
                $sessionStorage.put('totalUnread', JSON.stringify(response.total_unread));
                $rootScope.totalUnread = JSON.parse($sessionStorage.get('totalUnread'));
            })
        });
    });

    //Listening to the callbacks
    $rootScope.$on(Pubnub.getMessageEventNameFor('get_banner_'+channel), function (ngEvent, envelope) {
        $scope.$apply(function () {
            $rootScope.loadBanner();
        });
    });
});

$scope.addCarenet = function() {
    if( $rootScope.end_consultation==true || $rootScope.end_consultation==undefined ) {
        $rootScope.addCarenetInfoPopup = {
            label:"",
            validate: false
        };
        var options = {
            title: '<span class="fa fa-users"></span> Create New Carenet',
            message :'',
            templateUrl: 'views/createcarenetpopup.htm',
            buttons: {
                ok: {
                    label: " Confirm",
                    className: "btn-primary fa fa-check",
                    callback: function(e) {
                        if($.trim($rootScope.addCarenetInfoPopup.label)=="") {
                            $rootScope.addCarenetInfoPopup.validate = true;
                            $ngBootbox.customDialog(options);
                        } else {
                            recordService.addCarenet({record_id:$rootScope.doctorRecordId, label: $rootScope.addCarenetInfoPopup.label }).then(function(response) {
                                $rootScope.loadCarenetList();
                                $location.path('/accountlist/'+response.Carenets.Carenet.id);
                            },function (err, response) {
                                $ngBootbox.alert(err.Message);
                            });
                        }
                    }
                },
                cancel: {
                    label: " Cancel",
                    className: "btn-danger fa fa-times",
                    callback: function() {}
                }
            }
        };

        $ngBootbox.customDialog(options);

    } else if( $rootScope.end_consultation==false ) {
        $scope.showPopup();
    }
};

$scope.showPopup = function() {
    var options = {
        message: "Please Click on End Consultation button to continue" ,
        title: '<span class="fa fa-exclamation-triangle">Warning</span>',
        onEscape: true,
        buttons: {
            ok:{
                label: " Close",
                className: "btn-danger fa fa-times-circle",    
            }
        }
    }
  $ngBootbox.customDialog(options);
};

$rootScope.changePwdData = {confirmPassword:"",newPassword:"",password:""};

// $rootScope.vaccineList = function() {
// debugger;
//  recordService.vaccine().then(function(response) {
//    $rootScope.vaccineDict1 = response;
//  }
// )};

//  $rootScope.vaccineList();

    $rootScope.sendNotification = function() {
        var today = new Date();
        today.setHours(0,0,0,0);
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'views/sendnotificationpopup.htm',
            controller: 'sendNotificationPopupController',
            resolve: {
                data: function () {
                   return { message:null, subject:null, measurementDate:today, dob: ""};
                }
            }
        });

        modalInstance.result.then(function (data) {            
            $rootScope.showSpinner = true;
            data.measurementDate.setHours(0,0,0,0);
            var growthData = {
                "record_id": $rootScope.doctorRecordId,
                "type": data.recipient,
                "recipient": data.recipients,
                "subject": data.subject,
                "message": data.message,
                "date": data.measurementDate,
                "severity": data.priority
            };

            recordService.notificationData(growthData).then(function(response) {
            });
        
        },function (err, response) {
            $ngBootbox.alert(err.Message);
        });
    };

    $scope.Consultation_check = function(path) {
        if (sessionStorage.enableics == "false") {
            $rootScope.showlostalert = ""
        }
       
        if( $rootScope.end_consultation==true || $rootScope.end_consultation==undefined ) {
        
            if( path!='hvReport1' && path!='hvReport2' && path!='hvReport3' && path!='hvReport4' ) {
                $location.path(path);
            } else {
                if( authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org" || authService.authentication.account_id == "rx133323@rxcarenet.org") {
                   $location.path(path);      
                }
            }
        } else if ($rootScope.end_consultation == false) {
            if ($rootScope.showlostalert === true) {       
                $scope.icslostpopup(path);
            } else if ($rootScope.showlostalert === false) {   
                $location.path(path);
            } if (sessionStorage.enableics == "false") {
                $scope.showPopup();
            }
        }
        
    };

    $scope.icslostpopup = function(path) {
        var options = {
            message: "Please save and proceed or data will be lost." ,
            title: '<h5  style="color:white">Alert</h5>',
            onEscape: true,
            buttons: {
                close:{
                    label: "Close",
                    
                },
                ok : {
                    label: " Proceed",
                    className: "btn-danger fa fa-times-circle",
                    callback: function() {
                        $location.path(path);
                        $rootScope.showlostalert = false
                    }
                }

            }
        }
      $ngBootbox.customDialog(options);
    };
    
    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
          'event_category' : 'indexController',
          'event_label' : aLabel
        });
    }

}]);


'use strict';

angular.module('AngularApp').controller('institutionalvisitReportController', ['$scope', '$location', '$rootScope', 'toastr', 'authService', 'incentiveService','$ngBootbox', 'multicenterstudyreportService', '$filter', function ($scope, $location, $rootScope, toastr, authService, incentiveService, $ngBootbox, multicenterstudyreportService,$filter) {

    
    $scope.timeInputDisable = true;
    $scope.selected_day = "1";
    $scope.fromDate = new Date();
    $scope.toDate = new Date();
    $scope.today_dt = new Date();
    $scope.exportType = "";

    var datArr  = getStringDate($scope.fromDate);
    var datArr2 = getStringDate($scope.toDate)
    $scope.selectedFromDate  = datArr[1];
    $scope.selectedFromDate2 = datArr[0];
    $scope.selectedToDate  = datArr2[1];
    $scope.selectedToDate2 = datArr2[0];


    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        }
    };

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }


    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.labelHide = true
    $( "#piechat_container" ).hide();
    $scope.getinstitutionalfollow = function() {
        var data = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id,
            from_date: $scope.selectedFromDate2,
            to_date: $scope.selectedToDate2,
            followup_description : "INSTITUTIONAL VISIT"

        }
        multicenterstudyreportService.getinstitutionalfollowbydateReport(data).then(function(response) {
        //   if(response.data.dead_after_discharge.length > 0 || response.data.dead_during_discharge.length > 0){
        //     $scope.labelHide = false
        //     $scope.deadvsTimeAfterdelivery = response;
        //     console.log($scope.deadvsTimeAfterdelivery);
        //   } else {
        //     $scope.labelHide = true
        //     $scope.errMsg = 'Data is not available on this period'
        //   }

        $scope.institutionalfollowResponse = []

        console.log('response::',response);
        if(response.success == 1){
            if(response.data.length>0){
                $scope.labelHide = false
                $scope.institutionalfollowResponse = response.data
                console.log($scope.institutionalfollowResponse);
                homevisitPieChartData(response.baby_status); 
            }else{
                $scope.labelHide = true
                $scope.errMsg = 'Data is not available on this period'
            }

        }else{
            $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
            $( "#piechat_container" ).hide();

        }
            
        },function(error) {
            if(error){
              toastr.error('Select from & to date')
            }
            // toastr.error(error);
            analytics('getDeadvsTimeAfterdeliveryStatus',error);
        })
    };


    function homevisitPieChartData(data) {

        console.log('data::',data);
            
        var tempArray = [
            {
            name: 'Alive',
            y: data.count_alive,
            /*sliced: true,
            selected: true*/
            color: 'lightblue'
            },
            {
            name: 'Expired',
            y: data.count_expired, 
            color: 'pink'
            }
        ];
            
        $scope.showPieChart(tempArray);    
    }

    $scope.showPieChart = function(data) {
    
        $('#pie_container1').highcharts({
        //Highcharts.chart('container', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                borderColor: "black",
                borderRadius:0,
                borderWidth:"0"
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Institutional Visit Report', 
                style: {
                  fontSize: '22px' 
                }
               
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '{point.percentage:.1f} %'
                    },
                    showInLegend: true
                }
            },
            series: [{
            //name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    
        $( "#piechat_container" ).show();
    }


    $scope.exportData = function(type) {

        if($scope.institutionalfollowResponse) {
   
            $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
            var filename = "Institutional_Visit_Report_"+$scope.formattedDate;
            
            if($scope.selectedFromDate && $scope.selectedToDate){
                filename = "Institutional_Visit_Report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
            }
            
           /* if(type=='csv') {
  
                alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
                
            } else*/
            if(type == 'excel') {
  
                //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                    var blob = new Blob([document.getElementById('printtable2').innerHTML], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    });
                 saveAs(blob, filename+".xls");
  
            } else if(type=='pdf') {
  
                var pdf_element = document.getElementById('printtable');
                var opt = {
                    margin:      0,
                    filename:   filename,
                    image:       { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
                };
                    
                //New Promise-based usage:
                html2pdf().set(opt).from(pdf_element).save();
                    
            }
        }
    }

}])
'use strict';
angular.module('AngularApp').controller('ivrsController', ['$http',"$q",'$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService','helyxonApiUrl','ivrsService', function ($http , $q , $scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService,helyxonApiUrl, ivrsService) {
    var helyxonApi_Url = helyxonApiUrl;
    $scope.imageUploadUrl = authService.helyxonApi.url + 'cloud/image/upload/'; 

    $scope.IvrsData;

    $scope.ivrs_data = function (value) {

        var payload = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id
        };

        ivrsService.ivrs_Data(payload).then(function (response) {
            $scope.IvrsData = response.details;
           console.log('response',response);
        }, function (err) {
            toastr.error(err);
        });
    }
    $scope.ivrs_data();

    $scope.masterIvrsData;

    $rootScope.masterivrs_data = function (showmaste) {
     
        var payload = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id
        };

        ivrsService.masterivrs_Data(payload).then(function (response) {
            $rootScope.masterIvrsData = response.details;
           console.log('$scope.masterIvrsData',response.details);
        }, function (err) {
            toastr.error(err);
        });
    }

    $rootScope.masterivrs_data();

    $scope.status = 0;
    $scope.audio;
    $scope.play = function(fname , data){
        console.log(fname , data.id)
        var Data = data.id
        if(Data == data.id){
        $scope.status = 1;
        $scope.audio = new Audio(helyxonApi_Url+'cloud/mp3/upload/'+data.voice_url);
        $scope.audio.play();
        }
    }
    $scope.pause = function(){
        $scope.status = 0;
        $scope.audio.pause();
        $scope.audio.currentTime = 0;
    }

    $scope.remove_ivrs = function (id){
        console.log("Id",id);
       
       var payload ={
            id: id,
            account_email: authService.authentication.account_id,
            is_active : 0
        }
        console.log('payload',payload);
        ivrsService.remove_Ivrs(payload).then(function (response) {
           console.log('staus response',response);
           $scope.ivrs_data();
        }, function (err) {
            toastr.error(err);
        });
    }
  

    $rootScope.ischecked = false;
     $rootScope.selectCheckbox = function(voice_url,lang,voice_type_id,checkbox){
         console.log('datas',voice_url,lang,voice_type_id,checkbox);
         if(checkbox == true){

            var payload = {
                account_email: authService.authentication.account_id,
                doctor_id: authService.authentication.doctor_id,
                voice_type_id: voice_type_id,
                voice_url: voice_url
            };
            console.log('create',payload);
        
            ivrsService.create_IVRS(payload).then(function (response) {
                if(response.data == "created"){
                    $scope.ivrs_data();
                 }
            }, function (err) {
                toastr.error(err);
            });
              
         }
     }

    $scope.create_ivrs = function (data) {
      
    var options = {
            title: '<b>Create IVRS</b>',
            message:'',
            templateUrl: 'views/ivrs/ivrscreate_content.htm',
            size:'large',
            onEscape: function() {
                $scope.$apply();
            },
            buttons: {
          }
      }
      $ngBootbox.customDialog(options);
    }
     
   $rootScope.create_Ivrs = function () {
        $scope.audiourl = sessionStorage.getItem("audio_url");
        sessionStorage.removeItem('audio_url');
        $scope.audiochunks = $scope.audiourl.split('/');
        $scope.finalaudio = $scope.audiochunks[3] + '.mp3';
        console.log('chunks',$scope.finalaudio);
        console.log('audio url', $scope.audiourl);

        var payload_data = {
            "filename": $scope.finalaudio
        }

        ivrsService.audioupload_IVRS(payload_data.filename).then(function (response) {
        console.log('success',response);
        }, function (err) {
        toastr.error(err);
        });

   }

   
   
    
    

   $scope.update_ivrs = function (index , id ) {
    sessionStorage.setItem("updateivrs", index );
    sessionStorage.setItem("voice_id",id );

    var options = {
            title: '<b>Update IVRS</b>',
            message:'',
            templateUrl: 'views/ivrs/updateivrs_content.htm',
            size:'medium',
            onEscape: function() {
                $scope.$apply();
            },
            buttons: {
          }
      }
      $ngBootbox.customDialog(options);
    }
   
    
//     $rootScope.update_Ivrs = function () {
//         $scope.updateivrs_id = sessionStorage.getItem("updateivrs");
//         $scope.voice_id = sessionStorage.getItem("voice_id");
//         // $scope.msg_content = sessionStorage.getItem("msg_content");
//         sessionStorage.removeItem('updateivrs')
//         sessionStorage.removeItem('voice_id')

//         $scope.voice_url = sessionStorage.getItem("VoiceURL");
//         sessionStorage.removeItem('VoiceURL')
//         // sessionStorage.removeItem('msg_content')
           
//         // console.log('res',$scope.updateivrs,$scope.voice_url,$scope.msg_content)
       
//         // var e = document.getElementById("dropdown_Value");
//         // var result = e.value;
//         // console.log('result',result)
//         var audio_data = {
//             voice_url:$scope.voice_url 
//         }

//         ivrsService.audioupload_IVRS(audio_data).then(function (response) {
//             $scope.Data = response;
//             console.log('$scope.Data',$scope.Data);
//         }, function (err) {
//             toastr.error(err);
//         });

//         var payload = {
//          id:  $scope.voice_id,
//          account_email: authService.authentication.account_id,
//          voice_url:$scope.voice_url ,
//      };
//      console.log(payload);
 
//      ivrsService.update_IVRS(payload).then(function (response) {
//          $scope.data = response;
//          if(response.data == "updated"){
//             bootbox.hideAll()
//             $scope.ivrs_data();
//          }
//      }, function (err) {
//          toastr.error(err);
//      });
//     }

    // function myFunction(){
    //     const recordAudio = () =>
    //     new Promise(async (resolve) => {
    //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //         const mediaRecorder = new MediaRecorder(stream);
    //         const audioChunks = [];
    //         mediaRecorder.addEventListener("dataavailable", (event) => {
    //         audioChunks.push(event.data);
    //         });

    //         const start = () => mediaRecorder.start();

    //         const stop = () =>
    //         new Promise((resolve) => {
    //             mediaRecorder.addEventListener("stop", () => {
    //             const audioBlob = new Blob(audioChunks);
    //             const audioUrl = URL.createObjectURL(audioBlob);
    //             console.log(audioUrl)
    //             const audio = new Audio(audioUrl);
    //               $scope.hello(audio);
    //             //   const play = () => audio.play();
    //             resolve({ audioBlob, audioUrl});
    //             });
    //             mediaRecorder.stop();
    //         });
    //         resolve({ start, stop }); 
    //     });

    //     const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time));

    //     var record = true;

    //     const startRecording = async () => {
    //     const recording = await recordAudio();
    //     const recorder = document.getElementById("recorder");
    //     recorder.disabled = true;
    //     recording.start();
    //     while (record == true) {
    //         await sleep(1);
    //     }
    //     const audio = await recording.stop();
    //     await sleep(2000);
    //     //   audio.play();
    //     recorder.disabled = false;
    //     };

        // document.getElementById("recorder").addEventListener("click", (e) => {
        // if (document.getElementById("recorder").classList.contains("recording")) {
        //     document.getElementById("recorder").classList.remove("recording");
        //     document.getElementById("recorder").classList.add("download");
        //     record = false;
        //     setTimeout(function () {
        //     document.getElementById("recorder").classList.remove("download");
        //     document.getElementById("recorder").classList.add("out");
        //     }, 1000);
    //     } else if (
    //         !document.getElementById("recorder").classList.contains("recording") &&
    //         !document.getElementById("recorder").classList.contains("download")
    //     ) {
    //         document.getElementById("recorder").classList.remove("out");
    //         document.getElementById("recorder").classList.add("recording");
    //         record = true;
    //         startRecording();
    //     }
    //     });
    // }
    // myFunction();
    // $rootScope.update_Frontdesk = function (){
    //    var id =  sessionStorage.getItem("frontdesk_id");
    //    console.log('id',id)
    //     $scope.update_data = $("form").serializeArray();
    //     console.log('data',$scope.update_data);
    //     var payload = {
    //         "account_email": authService.authentication.account_id,
    //         "frontdesk_name":$scope.update_data[0].value,
    //         "email":$scope.update_data[1].value,
    //         "with_doctor_id":authService.authentication.doctor_id,
    //         "country_code":"+91",
    //         "frontdesk_number":$scope.update_data[2].value,
    //         "id" : id
    //     }

    //     console.log('payload',payload);
    //     frontdeskService.update_Data(payload).then(function (response) {
    //         console.log('update_response',response);
    //         if(response.data == 'Updated'){
    //             bootbox.hideAll()
    //             $scope.frontdesk_data();
    //         }
    //     }, function (err) {
    //         toastr.error(err);
    //     });
    
// $rootScope.uploadFile = function(){
//     var deferred = $q.defer();
//     var res = sessionStorage.getItem("audio1")
   
//     $http.post(helyxonApi_Url+"cloud/mp3/audio.php", res, {
//         transformRequest: angular.identity,
//         headers: {
//             'Content-Type': 'multipart/form-data',
//             'Process-Data': false
//         }
//     }).success(function(response) {
//         deferred.resolve(response);
//     }).error(function (error) {
//         deferred.reject(error);
//     })
//     return deferred.promise;
// }

$scope.Audiofile ="";
$rootScope.submit = function() {
    var file = document.getElementById("myFileInput").files[0];
    console.log('file',file);
    console.log('file',file.name);
    $scope.Audiofile = file.name ;
    $scope.audio = new Audio(file.name);
     $scope.audio.play();
    ivrsService.upload_AudioFile_IVRS(helyxonApiUrl, file.name).then(function(response) {
        console.log(response);
    });
  }




//webkitURL is deprecated but nevertheless 
URL = window.URL || window.webkitURL;
var gumStream;
//stream from getUserMedia() 
var rec;
//Recorder.js object 
var input;
//MediaStreamAudioSourceNode we'll be recording 
// shim for AudioContext when it's not avb. 
var AudioContext = window.AudioContext || window.webkitAudioContext;
var audioContext = new AudioContext;
//new audio context to help us record 
$scope.record_Button = document.getElementById("record_Button");
$scope.stop_Button = document.getElementById("stop_Button");

$rootScope.stop_Recording = function() {
  
    stop_Button.disabled = true;
    record_Button.disabled = false;
    //pauseButton.disabled = true;
    //reset button just in case the recording is stopped while paused 
    //pauseButton.innerHTML = "Pause";
    //tell the recorder to stop the recording 
    rec.stop(); //stop microphone access 
    gumStream.getAudioTracks()[0].stop();
    //create the wav blob and pass it on to createDownloadLink 
    rec.exportWAV(createDownloadLink);
}

function createDownloadLink(blob) {
    var url = URL.createObjectURL(blob);
    console.log('url',url);
    var au = document.createElement('audio');
    var li = document.createElement('li');
    var link = document.createElement('a');
    //add controls to the <audio> element 
    au.controls = true;
    au.src = url;
    //link the a element to the blob 
    link.href = url;
    link.download = new Date().toISOString() + '.mp3';
    link.innerHTML = link.download;
    //add the new audio and a elements to the li element 
    li.appendChild(au);
    li.appendChild(link);

    console.log('li',li);
    
    //add the li element to the ordered list 
    //recordingsList.appendChild(li);
     console.log('blob',blob);
    ivrsService.upload_AudioFile_IVRS(helyxonApiUrl, blob).then(function(response) {
        console.log(response);
    });
    
}

$rootScope.start_Recording = function() {

    var constraints = {
        audio: true
    } 


    record_Button.disabled = true;
    stop_Button.disabled = false;

    navigator.mediaDevices.getUserMedia(constraints).then(function(stream) { 
        /* assign to gumStream for later use */
        gumStream = stream;
        /* use the stream */
        input = audioContext.createMediaStreamSource(stream);
        /* Create the Recorder object and configure to record mono sound (1 channel) Recording 2 channels will double the file size */
        rec = new Recorder(input, {
            numChannels: 1
        }); 
        //start the recording process 
        rec.record();
    }).catch(function(err) {
        //enable the record button if getUserMedia() fails 
        record_Button.disabled = false;
        stop_Button.disabled = true;
    });
}   



    $scope.dropdown_value ;
    $rootScope.dropdownvalue = function(value){
        $scope.dropdown_value = value
       console.log('value',value);
    }
    $rootScope.arrlist = [{
        "userid": 1,
        "name": "English"
        }, {
        "userid": 2,
        "name": "Tamil"
        }, {
        "userid": 3,
        "name": "Hindi"
        },{
        "userid": 4,
        "name": "Telugu"
        },{
        "userid": 5,
        "name": "Malayalam"
        },];
        $rootScope.userSelect = "3";

    return this;
   }
]);
'use strict';
angular.module('AngularApp').controller('labtestController', ['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','localStorageService','labtestService','authService','toastr',
	 function ($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter,localStorageService,labtestService,authService,toastr) {

         $scope.testPackages = [];

         $scope.loadTestPackages = function() {
            labtestService.getTestPackages('all').then(function(response) {
                $scope.testPackages = response.lab_tests;
                console.log($scope.testPackages);
            }, function(error) {
                toastr.error(error);
                analytics('loadTestPackages',error);
            })
         };

         $scope.loadTestPackages('active');

         $rootScope.newData={};

        //console.log($rootScope.newData);
         $rootScope.saveLabtestData = [{"name": ""}];

        $scope.title = '';
        $scope.description = '';

         $scope.addNewPack = function(){
            $location.path('/newLabtest');
        };

        $scope.groupNewPack = function(){
            $location.path('/newLabtestgroup');
        };

        $scope.savenewtest = function(){
            if($scope.newtestpackenetered == "" || $scope.newtestpackenetered == undefined){
                toastr.error("Please fill test name");
            } else {
                labtestService.searchDrug($scope.newtestpackenetered).then(function(response) {
                    if(response.data.length == 0){
                        var addnewtestpack = {
                                "account_email": authService.authentication.account_id,
                                "new_investigation": [$scope.newtestpackenetered]
                        }
                        labtestService.addlabpacknew(addnewtestpack).then(function(result){
                            toastr.success("New Lab test added successfully");
                            $location.path('/labtestConfig');
                        })
                    } else {
                        toastr.error("Test name exists already");
                    }
                })
            }
        }

        $scope.cancelnewtest = function(){
            $location.path('/labtestConfig');
        };

         $scope.deleteRow = function(data){
            if($rootScope.saveLabtestData.length>1)
            $rootScope.saveLabtestData.splice(data,1);
        };
        $scope.deleteRows = function(data){
            if($rootScope.saveLabtestUpdateData.length>1)
            $rootScope.saveLabtestUpdateData.splice(data,1);
        };

        $scope.back = function(){
            $location.path('/labtestConfig');    
        };
        $scope.backward = function()
        {
            $location.path('/settings'); 
            
        }

        $scope.addLabtest = function(data,index){
            if(data.name!="" && data.name!=undefined){
                $rootScope.saveLabtestData[index]=data;
                $rootScope.saveLabtestData.push({name:""});
            }else{
                toastr.error("Please fill all mandatory fields.");
                analytics('addLabtest','please fill all mandatory fields');
            }
        };
        $scope.addLabtestupdate = function(data,index){
            console.log(data,index)
            if(data.name!="" && data.name!=undefined){
                $rootScope.saveLabtestUpdateData[index]=data;
                $rootScope.saveLabtestUpdateData.push({name:""});
            }else{
                toastr.error("Please fill all mandatory fields.");
                analytics('addLabtestupdate','please fill all mandatory fields.');
            }
        };

        $scope.saveLabtest = function() {
            var length = ($rootScope.saveLabtestData.length)-1;
            if($scope.title == "" || $scope.title == undefined){
                toastr.error("Please fill Category name");
            }
            else if(length==-1||$rootScope.saveLabtestData[length].name==null||$rootScope.saveLabtestData[length].name==""){
                toastr.error("Please fill all mandatory fields");
                analytics('saveLabtest','please fill all mandatory fields');
            }else{
                var labpackItem = [];
                angular.forEach($rootScope.saveLabtestData,function(value,key) {
                    console.log(value);
                    labpackItem.push(value.name);
                })
                var labSaveData = {
                    account_email: authService.authentication.account_id,
                    user_type: "doctor",
                    lab_test: {title: $scope.title,description: $scope.description,tests: labpackItem},
                    doctor_id : authService.authentication.doctor_id
                }
                labtestService.addlabpack(labSaveData).then(function(response){
                    if(response.error == 'duplicate test pack'){
                        toastr.error("Duplicate category");
                    } else {
                        $scope.loadTestPackages('active');
                        $rootScope.saveLabtestData=[];
                        toastr.success("Pack added successfully.");
                        $location.path('/labtestConfig');
                    }
                   
                },function (err, response) {
                    toastr.error(err.error +" please check the data entered.");
                    analytics('saveLabtest','please check the data entered');
                })
            }
        };

        $scope.showUpdate = false;

        $rootScope.saveLabtestUpdateData = [];

        $scope.tempData = {};
        $scope.updateData = function(data) {
            $scope.showUpdate = true;
            $scope.tempData = data;
            $scope.title = data.json.title != undefined? data.json.title : '';
            $scope.description = data.json.description != undefined ? data.json.description : '';
            angular.forEach(data.json.tests, function(value) {
                if(value!=''){
                    $rootScope.saveLabtestUpdateData.push({name:value});
                }
            });
        };


        $scope.saveUpdate = function(title, description) {
            console.log(title, description)
            if(title == "" || title == undefined){
                toastr.error("Please enter Category name");
            } else {
                var labpackItem = [];
                angular.forEach($rootScope.saveLabtestUpdateData,function(value,key) {
                    console.log(value);
                    labpackItem.push(value.name);
                })
            var dataUpdate = {
                                account_email: authService.authentication.account_id,
                                doctor_id: $rootScope.authentication.doctor_id,
                                lab_test: {
                                    doc_id: $scope.tempData.id,
                                    updated: {
                                        title: title != undefined ? title : '',
                                        tests: labpackItem,
                                        description: description != undefined ? description : ''
                                    }
                                }
                            };
console.log(labpackItem,"labpackItem")
            if(labpackItem.length == 0 || labpackItem[0] == undefined || labpackItem[0] == ""){
                toastr.error("Please enter Test name");
            } else {
                labtestService.updatePack(dataUpdate).then(function(response) {
                    if(response.error == "duplicate test pack"){
                        toastr.error("Duplicate category");
                    } else {
                        toastr.success("Updated successfully");
                        $rootScope.saveLabtestUpdateData = [];
                        $scope.showUpdate = false;
                        $scope.loadTestPackages('active');
                    }   
                },function(error) {
                    $scope.showUpdate = true;
                    toastr.error(error);
                    analytics('saveUpdate',error);
                })
            }
            }
           
        };


        $scope.deletePackage = function(data){
            console.log(data.id)
            var options = {
                message: 'Are you sure to delete '+ data.json.title +' package ?',
                size: 'small',
                title: 'Confirmation',
                buttons: {
                    warning: {
                        label: "Cancel",
                        className: "btn-warning"
                    },
                    success: {
                        label: "Yes",
                           className: "btn-success",
                           callback: function() {
                            var labData = { 
                                account_email: authService.authentication.account_id,
                                id: data.id
                            }
                            labtestService.deletelabmaster(labData).then(function(response) {
                                toastr.success(response.message)
                                $scope.loadTestPackages('active');
                            },function(error) {
                                toastr.error(error);
                                analytics('deletePackage',error);
                            })
                        }
                       }
                  }
              };
              $ngBootbox.customDialog(options);
        };

        $scope.searchDrugs = function(packname){
            $rootScope.getpacks11 = []
           return labtestService.searchDrug(packname).then(function(response) {
                $rootScope.getpacks11 = response.data;
                return $rootScope.getpacks11
            }, function(error) {
                toastr.error(error);
                analytics('loadTestPackages',error);
            })
        }

        //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'labtestController',
            'event_label' : aLabel
            });
     }

}]);
'use strict';
angular.module('AngularApp').controller('lifelogController', ['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','localStorageService','lifelogService','authService','toastr',
	 function ($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter,localStorageService,lifelogService,authService,toastr) {
	
    $scope.showList={name: "active"};

    $scope.loaded = true;

    $rootScope.newData={};

    $scope.loadLifelog = function(data){
        lifelogService.getLifelog(data).then(function(response){
            $scope.lifelogConfig = response;
            $scope.loaded = false;
        },function(err,response){
            $ngBootbox.alert(err.Message);
        })
    };
    $scope.loadLifelog('active');

    $scope.modifyList = function(data){
        $scope.loadLifelog(data);
    };

    $rootScope.status = [{name:"Active",value:"true"}, {name:"Inactive",value:"false"}];

    $scope.update = function(data){
        $rootScope.selected = data;
        var options = {
            title: '<b>Update Life Log</b>',
            message:'',
            templateUrl: 'views/lifelog/updateLifelog.htm',
             size:'medium', 
             onEscape: function() { $rootScope.selected = "";$scope.$apply();},
            buttons: {
            	ok:{
                     label: " Update",
                     className: "btn-primary fa fa-save",
                    callback: function() {
                        if(!$rootScope.selected.status){
                            toastr.error("Please select a status.");
                            analytics('update','please select a status');
                        }
                        var updateData= {
                            active : $rootScope.selected.status.value,
                            ailment: $rootScope.selected.ailment,
                            id: $rootScope.selected.id
                        };
                        $scope.$apply(function() { 
                        // every changes goes here
                        $('#desc').val(data); 
                        });
                        var updateLifelogData = {
                            account_email: authService.authentication.account_id,
                            user_type: "doctor",
                            life_log_item: updateData
                        };
                        lifelogService.updateLifelog(updateLifelogData).then(function(response){
                            $scope.lifelogConfig = [];
                            $scope.loadLifelog($scope.showList.name);
                            toastr.success("Life Log updated Successfully.");
                        },function (err, response) {
                            toastr.error(err.error);
                            analytics('update',err.error);
                        })     
                 },
                 close:{
                     label: " Close",
                     className: "btn-danger fa fa-times-circle",
                    callback: function() {}
                    }
                }
            }
        };

        $ngBootbox.customDialog(options);
    };

    $rootScope.saveLifelogData = [{"name": ""}];

    $scope.addNewLifeLog = function(){
        $location.path('/newLifelog');
    };


    $scope.deleteRow = function(data){
        if($rootScope.saveLifelogData.length>1)
        $rootScope.saveLifelogData.splice(data,1);
    };

    $scope.back = function(){
        $location.path('/lifelogConfig');    
    };

    $scope.addLifelog = function(data,index){
        if(data.name!=""){
            $rootScope.saveLifelogData[index]=data;
            $rootScope.saveLifelogData.push({name:""});
        }else{
            toastr.error("Please fill all mandatory fields, before adding new lifelog.");
            analytics('addLifelog','please fill all mandatory fields, before adding new lifelog.');
        }
    };

    $scope.saveLifelog = function() {
        var length = ($rootScope.saveLifelogData.length)-1;
        if(length==-1||$rootScope.saveLifelogData[length].name==null||$rootScope.saveLifelogData[length].name==""){
            toastr.error("Please fill all mandatory fields");
            analytics('saveLifelog','please fill all mandatory fields');
        }else{
            var lifelogItem = [];
            angular.forEach($rootScope.saveLifelogData,function(value,key) {
                console.log(value);
                lifelogItem.push(value.name);
            })
            var lifelogSaveData = {
                account_email: authService.authentication.account_id,
                user_type: "doctor",
                items: lifelogItem
            }
            lifelogService.addlifelogitem(lifelogSaveData).then(function(response){
                $scope.loadLifelog('active');
                $rootScope.saveLifelogData=[];
                toastr.success(response.response);
                $location.path('/lifelogConfig');
            },function (err, response) {
                toastr.error(err.error +" please check the data entered.");
                analytics('saveLifelog',err.error);
            })
        }
    };

    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'lifelogController',
            'event_label' : aLabel
            });
     }

}]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Oct 2017
 */

'use strict'
angular.module('AngularApp').controller('locationController',['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','localStorageService','locationService','authService','toastr',
    function($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter,localStorageService,locationService,authService,toastr) {

        $scope.getLocationStatus = function() {
            locationService.getSettings().then(function(response) {
                $scope.locationStatus = response;
                if($scope.locationStatus.multilocation == 1 && sessionStorage.redirectLocation == "on"){
                    $scope.toggleValue = true;      // Set toggle switch ON
                }
                else{
                    $scope.toggleValue = false;     // Set toggle switch OFF
                        $scope.changed()
                }
            },function(error) {
                toastr.error(error);
                analytics('getLocationStatus',error);
            })
        };

        $scope.loadLocationList = function() {
            locationService.getLocation().then(function(response) {
                $scope.locationList = response;
            },function(error) {
                toastr.error(error);
                analytics('loadLocationList',error);
            })
        };

        // Function called when toggle button changes
        $scope.changed = function (){
            if($scope.toggleValue == false){
                $scope.enableLocation = 0;      // Disable Location 
            }else{
                $scope.enableLocation = 1;      // Enable Location 
                sessionStorage.setItem("redirectLocation","on")
            }
            $scope.locationStatus.multilocation = $scope.enableLocation;
            $scope.locationStatus.account_email = authService.authentication.account_id;
            var data = $scope.locationStatus;
            //  To Enable / Disable the Location Service
            locationService.addSettings(data).then(function(response) {
                if(sessionStorage.redirectLocation == "on"){
                    toastr.success('Location Service Turned ON / OFF Successfully');
                }
                if ($scope.enableLocation == 1){
                    var options = {
                        message: "Location Service Turned ON / OFF Successfully. Please Reconfigure your appointments" ,
                        title: '<span class="fa fa-exclamation-triangle">Redirecting to Appointment Configuration</span>',
                        onEscape: function() { sessionStorage.setItem("popup","on"); $location.path('/apt-config');$scope.$apply();},
                        buttons: {
                            ok:{
                                label: "Ok",
                                callback: function() {
                                    sessionStorage.setItem("popup","on")
                                    $location.path('/apt-config');
                                    $scope.$apply();
                                }
                            }
                        }
                    }
                    $ngBootbox.customDialog(options);
                }
            },function(error) {
                toastr.error(error);
                analytics('changed',error);
            })
        }

        // Redirect to appointment configuraion Page
        $scope.changePath=function(path){
            $location.path(path);
        };

        $scope.getLocationStatus();
        $scope.loadLocationList();
        
        $scope.addNewLocation = function() {
            $location.path('/addLocation');
        };

        $scope.newData = '';

        $scope.saveLocationData = [{"place": ""}];

        // Function called when Add new row button clicked
        $scope.addNewrow = function(data,index){
            if(data!=""){
                $scope.saveLocationData[index]=data;
                $scope.saveLocationData.push({place:""});
            }else{
                toastr.error("Please fill all fields, before adding new location.");
                analytics('addNewrow','please fill all fields before adding new location');
            }
        };

        // Function called when Delete row button clicked
        $scope.deleteRow = function(data){
            if($scope.saveLocationData.length>1)
            $scope.saveLocationData.splice(data,1);
        };

        // Function called when Save Location button clicked
        $scope.saveLocation = function() {
            var locationData = [];
            angular.forEach($scope.saveLocationData,function(value,key) {
                console.log(value);
                locationData.push(value.place);
            })
            var data = {
                account_email: authService.authentication.account_id,
                location : locationData
            }
            locationService.addLocation(data).then(function(response) {
                toastr.success('Saved Successfully');
                $location.path('/location');
                $scope.loadLocationList();
            },function(error) {
                toastr.error(error);
                analytics('saveLocation',error);
            })
        };

        $scope.back = function(){
            $location.path('/location');    
        };

        $rootScope.locationData = {};

        //  Update particular location
        $scope.updateLocation = function(data) {
            $rootScope.actionKind = 'edit';
            $rootScope.locationData = data;
            var options = {
                title: 'Update Location',
                message:'',
                templateUrl: 'views/settings/updateLocation.htm',
                size:'medium', 
                onEscape: function() {$scope.$apply();},
                buttons: {
                    ok:{
                        label: " Save",
                        className: "btn-primary fa fa-save",
                        callback: function() {
                            var data = {
                                        account_email: authService.authentication.account_id,
                                        type: "edit",
                                        id: $rootScope.locationData.id,
                                        location: $rootScope.locationData.location
                                    };

                            locationService.updateLocation(data).then(function(response) {
                                toastr.success('Updated Successfully');
                                $scope.loadLocationList();
                            },function(error) {
                                toastr.error(error);
                                analytics('updateLocation',error);
                            })
                        }

                    },
                    close:{
                        label: " Close",
                        className: "btn-danger fa fa-times-circle",
                        callback: function() {}
                    }
                }
            };

            $ngBootbox.customDialog(options);
        };

        //  Delete particular location
        $scope.deleteLocation = function(data) {
            if($scope.locationList.length > 1){
                $rootScope.actionKind = 'delete';
                $rootScope.locationData = data;
                var options = {
                    title: 'Delete Location',
                    message:'',
                    templateUrl: 'views/settings/updateLocation.htm',
                    size:'medium', 
                    onEscape: function() {$scope.$apply();},
                    buttons: {
                        ok:{
                            label: " Yes",
                            className: "btn-primary fa fa-save",
                            callback: function() {
                                var data = {
                                            account_email: authService.authentication.account_id,
                                            type: "delete",
                                            id: $rootScope.locationData.id,
                                            location: $rootScope.locationData.location
                                        };

                                locationService.updateLocation(data).then(function(response) {
                                    toastr.success('Deleted Successfully');
                                    $scope.loadLocationList();
                                },function(error) {
                                    toastr.error(error);
                                    analytics('deleteLocation',error);
                                })
                            }

                        },
                        close:{
                            label: " Cancel",
                            className: "btn-danger fa fa-times-circle",
                            callback: function() {}
                        }
                    }
                };

            $ngBootbox.customDialog(options);
        }
        else{
            toastr.error("Unable to delete. There must be single location, if the location service is Enabled")
            analytics('deleteLocation','Unable to delete');
        }
        };

        //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'locationController',
            'event_label' : aLabel
            });
     }

}]);
'use strict';
angular.module('AngularApp').controller('loginController', ['$scope', '$rootScope', '$location', 'authService', '$ngBootbox','localStorageService', function ($scope, $rootScope, $location, authService, $ngBootbox,localStorageService) {
    $('.bootbox.modal').modal('hide');
     
    if(!$rootScope.gApiInitialized) {
        $scope.gApiInitialized = false;
    } else {
        $scope.gApiInitialized = true;
    }
    authService.logOut();

    $scope.fbInitStatus = false;

    //login, Forgot password Models
    $scope.loginData = {
        username: "",
        password: ""
    };

    $scope.capsOn = false;
    $('input').keypress(function(e) { 
        $scope.capsOn = false;
        var s = String.fromCharCode( e.which );
        if( s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey ) {
            $scope.capsOn = true;
        }
    });

    //Submit login
    $scope.zero = false;
    $scope.inc = 0;
    $scope.loginError = "";
    $scope.login = function() {
        $scope.validateForm = true;
        $scope.submitted = true;

        if($scope.form.$valid) {
          
            $scope.loginData.password = MD5($scope.loginData.password);
            $scope.loginData.device_details = $rootScope.deviceDetector.os +' '+ $rootScope.deviceDetector.browser
            $scope.loginData.ip_address = $rootScope.ipfordrlogin
            authService.login($scope.loginData).then(function (response) {
                var loginData = response.doctors.login;
                if(loginData.info.account_info.Account.accountType==0) {
                //if(response.account_info.Account.accountType=="0") {
                  //success, redirect to home
                        if(localStorageService.get('twofactorapprove') == "false"){
                          
                                 var params = {
                                     "account_email" : loginData.doctor.demail,
                                     "doctor_id" : loginData.doctor.doctor_id
                                 }
                                 console.log(params,"ekmkenkeninfdiejiji")
                                 authService.initiatedocauthlogin(params).then(function (response) {
                                   
                                     if(response){
                                         sessionStorage.setItem("twostepac",response.auth_code)
                                         $location.path('/verification');
                                     }
                                 })
                        } else {
                            $location.path('/home');
                        }
                    
                    
                    $rootScope.loadBanner();
                } else {   
                    $ngBootbox.alert("Only Doctors / staff members can access through this site. Patients can access the site through <a href='http://nallan.xyz'>nallan.xyz</a>");
                    analytics('login','Patient logging at KC');
                }
                $scope.loginError = "";

            }, function (err) {

                if( err ) {
                    if( err.doctors.Message == "The given UserName and Password do not match." ) {
                        $scope.loginError = "Given Username and Password is not correct.";
                    }
                }
                
                $scope.inc = $scope.inc+1;
                analytics('login','trying wrong password');

                if($scope.inc==5) {
                    $ngBootbox.alert('Try after 30 seconds');
                    analytics('login','try after 30 seconds');
                    $scope.countDown = 30; 
                    $scope.timer1 = false;    
                    var timer = setInterval(function() {
                        $scope.timer1=true;
                        $scope.countDown--;
                        $scope.$apply(); 
                        if($scope.countDown<0) {
                            $scope.timer1=false; 
                            $scope.countDown=0 
                            $scope.zero=true;
                            $scope.$apply(); 
                        return; 
                        }         
                    }, 1000);
            
                } else {
                    $ngBootbox.alert(err.Message);
                }
            });
        }
    };

    //Submit forgot password
    $scope.forgotPassword = function () {
        if($scope.formForgotPwd.$valid) {
            authService.forgotPassword({ UserName: $scope.forgotPwdUserName, Type: userType }).then(function (response) {
                //success, show success alert
                $('#forgotPasswordModal').modal('hide');
                $scope.$emit('emitAlert', ["Forgot Password", response.Message, "success"]);
            }, function (err) {
                //Error, show error message
                $scope.forgotPwdMessage = authService.getErrorDetail(err);
                $scope.forgotPwdUserName = "";
                setTimeout(function () {
                    $('#txtForgotPwd').focus();
                }, 500);
            });
        }
    };

   //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'loginController',
            'event_label' : aLabel
        });
    } 

}]);



'use strict';
angular.module('AngularApp').controller('milestoneController', ['$scope','$rootScope', '$location','$filter', 'authService','milestoneService','$ngBootbox','toastr','multipartFormdata','$sce','$timeout',
function ($scope, $rootScope, $location,$filter , authService, milestoneService, $ngBootbox,toastr,multipartFormdata,$sce,$timeout) {

    $scope.reconfig = 0;
    $scope.loaded = false;

    authService.loadHelyxonApiUrl();
	$scope.helyxonApiUrl = authService.helyxonApi.url;
	$scope.imageUploadUrl = $scope.helyxonApiUrl;  

    $scope.getMilestoneStatus = function() {
        milestoneService.getSettings().then(function(response) {
            $scope.milestoneStatus = response.milestone;
            if($scope.milestoneStatus == 1){
                // Milestone is enabled by Admin
                $scope.milestoneType = response.milestone_type;
                $scope.milestonesList();
                if($scope.milestoneType == 2){
                    $scope.milestonesListBlock();
                    $scope.showTable = "list";
                }
            }
            else{
                // Milestone is disabled by Admin
                toastr.error('Contact Admin to Enable Milestone');
                analytics('getMilestoneStatus','Contact Admin to Enable milestone');    
            }
        },function(error) {
            toastr.error(error);
            analytics('getMilestoneStatus',error);
        })
    };

    $scope.milestonesList = function(){
        milestoneService.milestonesList().then(function(response){
            for(var i = 0;i<response.milestones.length;i++){
                if(response.milestones[i].active == true){
                    response.milestones[i].active = "True"
                }
                if(response.milestones[i].active == false){
                    response.milestones[i].active = "False"
                }
            }
            
                $scope.milestonesListRsp = response.milestones;
                angular.forEach(response.milestones, function(item){
                    var newattachment = []
                        angular.forEach(item.video_guide,function(data){
                            newattachment = []
                            if(item.video_guide != null){
                            if (item.video_guide.startsWith("vid_")) {
                             newattachment.push({"filename":item.video_guide,"defaultname" : "Video guide"})
                            }
                        }
                        })
                        item.new_attachment = newattachment
                })
                if($scope.milestonesListRsp.length > 0){
                    $scope.reconfig = 0;
                    $scope.uniqueType =  $filter('unique')(response.milestones,'type');
                    if($scope.uniqueType.length == 1){
                        if ($scope.uniqueType[0].type == "LEST"){
                            $scope.loadBtn = "TDSC";
                            $scope.loadBtnvalue = 1;
                        }else if($scope.uniqueType[0].type == "TDSC"){
                            $scope.loadBtn = "LEST";
                            $scope.loadBtnvalue = 2;
                        }
                    }
                }
            },function (error) {
                toastr.error(error);
                analytics('milestonesList',error);
        })
    };

    $scope.milestonesListBlock = function(){
        milestoneService.milestonesListBlock().then(function(response){
                $scope.milestonesListBlockRsp = response;
                if($scope.milestonesListBlockRsp.length > 0){
                    
                }
            },function (error) {
                toastr.error(error);
                analytics('milestonesListBlock',error);
        })
    };

    $scope.saveConfig = function(){
        var data = {
            account_email: authService.authentication.account_id,
            milestone_type: $scope.chooseCategory
        };
        //  Add Settings for Milestone_type. 1 (List) / 2 (Block)
        milestoneService.addSettings(data).then(function(response) {
            var dataload = {
                account_email: authService.authentication.account_id,
                category: $scope.chooseCategory,
                type: $scope.chooseType
            };
            //  Load Milesone data with Category(List/Block) and Type(TDSC/LEST)
            milestoneService.loadMilestone(dataload).then(function(response) {
                toastr.success(response.response)
                $scope.getMilestoneStatus();
                $scope.reconfig = 0;
            },function(error) {
                toastr.error(error);
                analytics('saveConfig',error);
            })
        },function(error) {
            toastr.error(error);
            analytics('saveConfig',error);
        })
    }

    //  Load milestone Individually. TDSC / LEST
    $scope.loadMilestoneSep = function(){
        var dataload = {
            account_email: authService.authentication.account_id,
            category: $scope.milestoneType,
            type: $scope.loadBtnvalue
        };
        milestoneService.loadMilestone(dataload).then(function(response) {
            toastr.success(response.response)
            $scope.milestonesList();
            if($scope.milestoneStatus == 1){
                $scope.milestonesListBlock();
            }
            $scope.loadBtn = undefined;
            $scope.reconfig = 0;
        },function(error) {
            toastr.error(error);
            analytics('loadMilestoneSep',error);
        })
    }

    $scope.getMilestoneStatus();

    //  Load the Radio Button data for choosing Category : List / Block
    $scope.modifyCategory = function(data){
        $scope.chooseCategory = data;
    }

    //  Load the Radio Button data for choosing Type : TDSC / LEST
    $scope.modifyType = function(data){
        $scope.chooseType = data;
    }

    //  Enabling Reconfiguration Button
    $scope.reConfigure = function(){
        $scope.reconfig = 1;
    }

    //  Cancel Button to hide the reconfiguration settings
    $scope.cancelConfig = function(){
        $scope.reconfig = 0;
        $location.path('/settings')
    }
    
    //  Milestone Type : Block. Choosing the view, either List or Block.
    $scope.modifyList = function(data){
        $scope.showTable(data);
    }

    // $rootScope.saveMilestoneData = [{"start":"","end":"","item":"","category":"","description":""}];
    // $scope.isEditing = false;
    // $scope.enableSave = false;
    // $scope.showList={name: "all"};
    // $rootScope.selected = {};
    // $scope.selectednew = undefined;
    // $rootScope.newData={};

    // $scope.modifyList = function(data){
    //     $scope.loadMilestone(data);
    // }

    // $scope.addNewMilestone = function(){
    //     $location.path('/newMilestone');
    //     $rootScope.saveMilestoneData.push(milestoneData);
    // };

    // var milestoneData = {"start":"","end":"","item":"","category":"","description":""};

    // $scope.deleteRow = function(data){
    //     if($rootScope.saveMilestoneData.length>1)
    //     $rootScope.saveMilestoneData.splice(data,1);
    // };

    // $scope.addMilestone = function(data,index){
    //     if($rootScope.saveMilestoneData[index].start!="" && $rootScope.saveMilestoneData[index].end!="" && $rootScope.saveMilestoneData[index].item!="" && $rootScope.saveMilestoneData[index].category!=""){
    //         $rootScope.saveMilestoneData[index]=data;
    //         $rootScope.saveMilestoneData.push({"start":"","end":"","item":"","category":"","description":""});
    //     }else{
    //         toastr.error("Please fill all mandatory fields, before adding new milestone.");
    //     }
    // };

    // var categories = [];
    // $rootScope.getCategory = function(current) {
    //     var categoryCopy = categories.slice(0);
    //     // if (current) {
    //     // categoryCopy.unshift(current);
    //     // }
    //     return categoryCopy;
    // };

    // $scope.getCategoryList = function(data){
    //     milestoneService.getCategory(data).then(function(response){
    //         angular.forEach(response, function(value,key){
    //             categories.push({category: value.category,id:value.id});
    //         })
    //         },function (err, response) {
    //                 $ngBootbox.alert(err.Message);
    //     })
    // };

    // $scope.getCategoryList('all');
    // // $scope.onSelect = function (item) {
    // //     $scope.categories.push(item);
    // // };

    // $scope.noResults = false;
    // $scope.newCategories = [];

    // $rootScope.addNewCategory=function(){
    //     var newCatg = document.getElementById('catg').value.charAt(0).toUpperCase() + document.getElementById('catg').value.substr(1).toLowerCase();
    //     // categories.push(newCatg);
    //     var categoryData = {account_email: authService.authentication.account_id, category: newCatg};
    //     milestoneService.addNewCategory(categoryData).then(function(response){
    //         toastr.success('Category added successfully.');
    //         $scope.newCategories.push({name:response.category,id:response.id});
    //         categories = [];
    //         $scope.getCategoryList('all');
    //     },function(err, response){
    //         toastr.error(err.Message);
    //     })
    // };

    // $scope.saveMilestone = function(){
    //     var length = ($rootScope.saveMilestoneData.length)-1;
    //     if(length==-1||$rootScope.saveMilestoneData[length].start==null || $rootScope.saveMilestoneData[length].end==null || $rootScope.saveMilestoneData[length].item==""||$rootScope.saveMilestoneData[length].category==""){
    //         toastr.error("Please fill all mandatory fields");
    //     }else{
    //         angular.forEach($rootScope.saveMilestoneData,function(value, key){
    //             value.start = value.start.toString();
    //             value.end = value.end.toString();
    //             if(value.category.id==undefined){
    //                 angular.forEach($scope.newCategories,function(catvalue, key){
    //                     if(catvalue.name.toUpperCase()==value.category.toUpperCase()){
    //                         value.category_id = catvalue.id;
    //                     }
    //                 })
    //             }else{
    //                 value.category_id = value.category.id;
    //             }
    //             delete value.category;
    //         })
    //         var milestonData = {
    //             "account_email": authService.authentication.account_id,
    //             "milestones": $rootScope.saveMilestoneData
    //         };
    //         milestoneService.saveMilestone(milestonData).then(function(response){
    //             $scope.loadMilestone('all');
    //             $rootScope.saveMilestoneData=[];
    //             toastr.success(response.response);
    //             $location.path('/milestoneConfig');
    //         },function (err, response) {
    //             toastr.error(err.error +" please check the data entered.");
    //         })
    //     }
    // };

    // $scope.cancelMilestoneSave = function(){
    //     $rootScope.saveMilestoneData = [];
    // };

    $scope.cancel = function(){
        $location.path('/milestoneConfig');
        sessionStorage.removeItem('selmilestoneData');
    }

    $rootScope.uploadedVideos = [];
    $rootScope.senduploadedVideos = [];
    $rootScope.uploadedImages = [];
    $rootScope.senduploadedImages = [];

    $rootScope.update = function(data){
        sessionStorage.setItem('selmilestoneData', JSON.stringify(data));
        if (data.active == true || data.active == "True"){
            data.active = "True";
        }
        else {
            data.active = "False";
        }
        $rootScope.selected = data;
        if(data.video_guide==null){
            $rootScope.milestonevideouploadsuccess = false
        }else {
            $rootScope.milestonevideouploadsuccess = true
            $rootScope.uploadedVideos = data.video_guide
            $rootScope.senduploadedVideos = data.video_guide
            sessionStorage.setItem('video_guideM', JSON.stringify(data.video_guide));
            // console.log($rootScope.uploadedVideos,'$rootScope.uploadedVideos--299');
        }
        if(data.image_guide==null){
            $rootScope.milestonevideouploadsuccess1 = false
        }else {
            $rootScope.milestonevideouploadsuccess1 = true
            $rootScope.uploadedImages = data.image_guide
            $rootScope.senduploadedImages = data.image_guide
            sessionStorage.setItem('image_guideM', JSON.stringify(data.image_guide));
            // console.log($rootScope.uploadedImages,'$rootScope.uploadedImages--308');
        }
        $rootScope.getQuestion(data)
        // $rootScope.selected.question = "";
        if(data.question==null||data.question!=""||data.question.length!=0){
            $rootScope.selected.question = '';
        }else{
            $rootScope.selected.question = data.question;
        }
        $rootScope.getIframeSrc = $sce.trustAsResourceUrl($scope.imageUploadUrl+'cloud/image/upload/'+data.video_guide)
        $location.path('/updateMilestone');
        // var options = {
        //     title: '<b>Update Milestone</b>',
        //     message:'',
        //     templateUrl: 'views/milestone/updateMilestone.htm',
        //     size:'large', 
        //     onEscape: function() {
        //         // if($rootScope.milestonevideouploadsuccess == false){
        //         //     e.preventDefault();
        //         // }
        //         $rootScope.selected = [];
        //         $scope.milestonesList();
        //         $scope.$apply();
        //     }
        // };

        // $ngBootbox.customDialog(options);
    };

    $rootScope.questions = [];

    $rootScope.getQuestion = function(data){
        $rootScope.questions = [];
        var data = {
            account_email: authService.authentication.account_id,
            id: data.id
        };

        milestoneService.getMilestonesquestion(data).then(function(response){
            console.log(response,'response');
            if(response.success==1){
                $rootScope.questions = response.data;
            }
        })
    }

    // if(sessionStorage.getItem('selmilestoneData')!=null){
        $rootScope.selected = JSON.parse(sessionStorage.getItem('selmilestoneData'));
        // console.log($rootScope.selected.id,'id');
        // $rootScope.getQuestion($rootScope.selected);
        // $rootScope.update($rootScope.selected);
    // }
    console.log(sessionStorage.getItem('selmilestoneData'),'361');
    if(sessionStorage.getItem('selmilestoneData')!=null){
        $rootScope.getQuestion($rootScope.selected);
    }
    


    // $scope.back = function(){
    //     $location.path('/milestoneConfig');    
    // };

    $scope.milestonedateshowalert = function(){
        var options = {
            title: '<b>Alert</b>',
            message:'',
            templateUrl: 'views/milestone/milestonedateshowalert.htm',
            size:'medium', 
            onEscape: function() { },
            buttons: {
						success: {
								label: "Ok",
								className: "btn-success",
								callback: function() {  }
						}
				}
        };
    
        $ngBootbox.customDialog(options);
    }
   
    $rootScope.updateMilestoneData = function(d){
        
        // console.log($rootScope.uploadedVideos,'$rootScope.senduploadedVideos');
        // console.log($rootScope.senduploadedImages,'$rootScope.senduploadedImages');
        var video_guide;
        var image_guide;
        if($rootScope.uploadedVideos.length > 0){
            var video_guide = $rootScope.uploadedVideos;
        }else{
            var video_guide = $rootScope.selected.video_guide;
        }

        if($rootScope.uploadedImages.length > 0){
            var image_guide = $rootScope.uploadedImages;
        }else{
            var image_guide = $rootScope.selected.image_guide;
        }

        if(parseFloat($rootScope.selected.start)> parseFloat($rootScope.selected.end)){
            $scope.milestonedateshowalert()
        } else {
            if($rootScope.selected.active == "True"){
                $scope.modifiedstatus = true
            } else {
                $scope.modifiedstatus = false
            }
            // sessionStorage.setItem('image_guideM', JSON.stringify($rootScope.uploadedImages));.
            // sessionStorage.setItem('video_guideM', JSON.stringify($rootScope.uploadedVideos));..
            var data = {
                account_email: authService.authentication.account_id,
                milestone: [{
                    item : $rootScope.selected.item,
                    start : parseFloat($rootScope.selected.start),
                    end : parseFloat($rootScope.selected.end),
                    type : $rootScope.selected.type,
                    active : $scope.modifiedstatus,
                    id: $rootScope.selected.id,
                    question: $rootScope.selected.question,
                    video_guide: video_guide,
                    sno: parseInt($rootScope.selected.sno),
                    image_guide: image_guide,
                    engagement_template: $rootScope.selected.engagement_template
                }]
            };
            milestoneService.updateMilestone(data).then(function(response){
                // $rootScope.selected = "";
                // $scope.loadMilestone($scope.showList.name);
                toastr.success("Milestone updated.");
                $scope.milestonesList();
                $rootScope.milestonevideouploadsuccess = false
                if(d==1){
                    $location.path('/milestoneConfig');
                    $rootScope.selected = "";
                }else{
                    bootbox.hideAll();
                    $rootScope.selected = response
                    if (response.active == true || response.active == "True"){
                        response.active = "True";
                    }
                    else {
                        response.active = "False";
                    }
                    $rootScope.selected = response;
                    if(response.video_guide==null){
                        $rootScope.milestonevideouploadsuccess = false
                    }else {
                        $rootScope.milestonevideouploadsuccess = true
                        $rootScope.uploadedVideos = response.video_guide
                        $rootScope.senduploadedVideos = response.video_guide
                        sessionStorage.setItem('video_guideM', JSON.stringify(response.video_guide));
                        // console.log($rootScope.uploadedVideos,'$rootScope.uploadedVideos--299');
                    }
                    if(response.image_guide==null){
                        $rootScope.milestonevideouploadsuccess1 = false
                    }else {
                        $rootScope.milestonevideouploadsuccess1 = true
                        $rootScope.uploadedImages = response.image_guide
                        $rootScope.senduploadedImages = response.image_guide
                        sessionStorage.setItem('image_guideM', JSON.stringify(response.image_guide));
                        // console.log($rootScope.uploadedImages,'$rootScope.uploadedImages--308');
                    }
                    $rootScope.getQuestion(response)
                    // $rootScope.selected.question = "";
                    if(response.question==null||response.question!=""||response.question.length!=0){
                        $rootScope.selected.question = '';
                    }else{
                        $rootScope.selected.question = response.question;
                    }
                }
            },function (err, response) {
                toastr.error(err.error);
                analytics('updateMilestoneData',err.error);
            })
        }
       
    };

    $scope.loaduploadedvideo = function(data){
        window.open($scope.imageUploadUrl+'cloud/image/upload/'+data,'_blank')
        $scope.ccc = $scope.imageUploadUrl+'cloud/image/upload/'+data
    }
    $rootScope.loadmilestonevideo = true
    $rootScope.loadmilestonevideo1 = true
    $rootScope.uploadFilemilestone = function(file, event, flow) {
        $rootScope.disablemilestoneupdate = true
        $rootScope.loadmilestonevideo = false
        $rootScope.milestonevideouploadsuccess = false
        if ({ mp4: 1, mov: 1 }[file.getExtension()]) {
            var data = new FormData();
            data.append('file', file.file);
            $scope.milestonevideofile = file.file;    
            var reader = new FileReader();
            reader.onload = function(e) {
                multipartFormdata.uploadvideoToUrl($scope.imageUploadUrl,  $scope.milestonevideofile).then(function(response){
                    $rootScope.selected.video_guide = response.video[0].filename
                    $rootScope.loadmilestonevideo = true
                    $rootScope.milestonevideouploadsuccess = true
                    $rootScope.disablemilestoneupdate = false
                    $rootScope.getIframeSrc = $sce.trustAsResourceUrl($scope.imageUploadUrl+'cloud/image/upload/'+response.video[0].filename)
                })
           };
           reader.readAsDataURL(file.file);
        }else {
            alert("Upload only Videos");
            return false;
        }
        flow.file = [];
    };

    $rootScope.deleteuploadedvideo = function(){
        $rootScope.getIframeSrc = ""
        $rootScope.selected.video_guide = null
        $rootScope.milestonevideouploadsuccess = false
    }

    // $rootScope.uploadedVideos = [];
    // $rootScope.senduploadedVideos = [];
    // $rootScope.uploadedImages = [];
    // $rootScope.senduploadedImages = [];


    $rootScope.uploadFiles1 = function(file, event, flow) {
        $rootScope.disablemilestoneupdate = true
        $rootScope.loadmilestonevideo = false
        $rootScope.milestonevideouploadsuccess = false
        if ({ mp4: 1, mov: 1 }[file.getExtension()]) {
            var data = new FormData();
            data.append('file', file.file);

            var reader = new FileReader();
            reader.onload = function(e) {
                multipartFormdata.uploadvideoToUrl($scope.imageUploadUrl, file.file).then(function(response){
                    var uploadedVideo = response.video[0].filename;
                    $rootScope.loadmilestonevideo = true
                    $rootScope.milestonevideouploadsuccess = true
                    $rootScope.disablemilestoneupdate = false
                    $rootScope.uploadedVideos.push(uploadedVideo);
                });
            };
            reader.readAsDataURL(file.file);
        } else {
            alert("Upload only Videos");
            return false;
        }
        flow.file = [];
    };

    // $rootScope.uploadEvt = function (file, event, flow) {
    //     alert('uploadEvt');
    //     console.log(file);
    //     console.log(event);
    //     console.log(flow);
    //     $rootScope.disablemilestoneupdate = true
    //     $rootScope.loadmilestonevideo = false
    //     $rootScope.milestonevideouploadsuccess = false
        
    //     if ({ mp4: 1, mov: 1 }[file.getExtension()]) {
    //         var data = new FormData();
    //         data.append('file', file.file);

    //         var reader = new FileReader();
    //         reader.onload = function(e) {
    //             multipartFormdata.uploadvideoToUrl($scope.imageUploadUrl, file.file).then(function(response){
    //                 var uploadedVideo = response.video[0].filename;
    //                 $rootScope.loadmilestonevideo = true
    //                 $rootScope.milestonevideouploadsuccess = true
    //                 $rootScope.disablemilestoneupdate = false
    //                 $rootScope.uploadedVideos.push(uploadedVideo);
    //             });
    //         };
    //         reader.readAsDataURL(file.file);
    //     }else if({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {

    //         $rootScope.uploadDocCoverImage = file.file;
    //         var reader = new FileReader();
    //         reader.onload = function (evt) {
    //             var doctorCoverImage = evt.target.result;
    //             console.log(doctorCoverImage,'imageupload');
    //             multipartFormdata.uploadFileToUrl11(authService.helyxonApi.url , file.file).then(function (response) {
    //                 var uploadImage = response.image[0].filename
    //                 $rootScope.loadmilestonevideo1 = true
    //                 $rootScope.milestonevideouploadsuccess1 = true
    //                 $rootScope.uploadedImages.push(uploadImage);
    //             })
    //         };
    //         reader.readAsDataURL(file.file);

    //     }
    //     else {
    //         toastr.error("Upload either Video or Image");
    //         return false;
    //     }
    //     flow.file = [];
    // }..

    $rootScope.uploadCoverImage2 = function (file) {
        $rootScope.loadmilestonevideo1 = false
        $rootScope.milestonevideouploadsuccess1 = false
        console.log(file);
        if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {

            $rootScope.uploadDocCoverImage = file.file;
            var reader = new FileReader();
            reader.onload = function (evt) {
                var doctorCoverImage = evt.target.result;
                // console.log(doctorCoverImage,'imageupload');
                multipartFormdata.uploadFileToUrl11(authService.helyxonApi.url , file.file).then(function (response) {
                    var uploadImage = response.image[0].filename
                    $rootScope.loadmilestonevideo1 = true
                    $rootScope.milestonevideouploadsuccess1 = true
                    $rootScope.uploadedImages.push(uploadImage);
                })
            };
            reader.readAsDataURL(file.file);

        } else {
            alert("Upload only Images");
        }

    }

    $rootScope.getIframeSrc1 = function(filename) {
        return $sce.trustAsResourceUrl($scope.imageUploadUrl + 'cloud/image/upload/' + filename);
    };

    $rootScope.removeVideo = function(index) {
        $rootScope.uploadedVideos.splice(index, 1);
        // $rootScope.senduploadedVideos.splice(index, 1);
    };

    $rootScope.removeVideom = function(index) {
        $rootScope.uploadedVideosm.splice(index, 1);
        // $rootScope.senduploadedVideos.splice(index, 1);
    };

    $rootScope.removeVideo1 = function(index) {
        $rootScope.uploadedImages.splice(index, 1);
    };
    
    $rootScope.removeVideo1m = function(index) {
        $rootScope.uploadedImagesm.splice(index, 1);
    };


    $rootScope.addQuestion = function(data){
        console.log(data,'data');
        // var data = {
        // account_email: authService.authentication.account_id,
        // id: $rootScope.selected.id,
        // question: $rootScope.selected.question
        // "account_email": authService.authentication.account_id,
        //     "milestone":[
        //         {"item": $rootScope.selected.item,
        //         "start": $rootScope.selected.start,
        //         "end": $rootScope.selected.end,
        //         "type": $rootScope.selected.type,
        //         "active":true,
        //         "question":
        //         [data],
        //         "video_guide":[],
        //         "sno": $rootScope.selected.sno,
        //         "image_guide":[]}
        //     ]            
        // };
        if(data == '' || data == undefined || data == null){
            toastr.error('Please enter Question.');
        }else{
            var data = {
                "account_email": authService.authentication.account_id,
                "milestone_id": $rootScope.selected.id,
                "question": data,
                "video_guide": [],
                "image_guide": []        
            }

            milestoneService.createMilestonequestion(data).then(function(response){
                console.log(response,'response');
                if(response.success==1){
                    toastr.success('Milestone Question added successfully.');
                    // $rootScope.selected.question = data;
                    $rootScope.selected.question = "";
                    $rootScope.getQuestion($rootScope.selected);
                }
            })
        }
    }

    $rootScope.removeQuestion = function(data){
        // console.log($rootScope.selected,'$rootScope.selected.id');
        var data = {
            account_email: authService.authentication.account_id,
            milestone_id: $rootScope.selected.id,
            question_id: data.question_id
        };

        milestoneService.removeMilestonesquestion(data).then(function(response){
            if(response.success==1){
                toastr.success('Milestone Question removed successfully.');
                $rootScope.getQuestion($rootScope.selected);
            }
        })
    }

    $rootScope.editQuestion = function(data){
        console.log(data,'data');
        $rootScope.updationQuestionselected = data;
        $rootScope.questionName = data.question;
        $rootScope.selectedQuestion_id = data.question_id;
        var updateMilestoneque = {
            title: '<b>Update Milestone Question</b>',
            message:'',
            templateUrl: 'views/milestone/updateMilestonequestions.htm',
            size:'medium', 
            onEscape: function() {
                $scope.$apply();
                $rootScope.questionName = '';
                $rootScope.selectedQuestion_id = '';
            },
        };

        $ngBootbox.customDialog(updateMilestoneque);
    }

    $rootScope.milestoneShowcontent = 0
    $rootScope.selectedMilestoneupdation = {}
    $rootScope.uploadedImagesm = [];
    $rootScope.uploadedVideosm = [];
    // let updateMilestoneques6Instance = null;
    // let updateMilestoneques5Instance = null;


    $rootScope.openPop = function(data,value){
        console.log(value,'value');
        if(value=='value'){
            $rootScope.selectedMilestoneupdation = {}
        }else{
            $rootScope.selectedMilestoneupdation = value;
        }
        // console.log($rootScope.selectedMilestoneupdation,'$rootScope.selectedMilestoneupdation');
        if(data==1){
            $rootScope.milestoneShowcontent = 1
            var img = value.image_guide
            if(img!=null){
                $rootScope.uploadedImagesm = img
                $rootScope.milestonevideouploadsuccess1 = true
            }else{
                $rootScope.milestonevideouploadsuccess1 = false
                $rootScope.uploadedImagesm = []
            }
            var updateMilestoneques1 = {
                title: '<b>Update Milestone Question Image</b>',
                message:'',
                templateUrl: 'views/milestone/addMilestone.htm',
                size:'medium', 
                onEscape: function() {
                    $scope.$apply();
                    $rootScope.selectedMilestoneupdation = '';
                    $rootScope.uploadedImagesm = [];
                },
            };

            $ngBootbox.customDialog(updateMilestoneques1);
        }else if(data==2){
            $rootScope.milestoneShowcontent = 2
            var img = value.image_guide
            if(img!=null){
                $rootScope.uploadedImagesm = img
                $rootScope.milestonevideouploadsuccess1 = true
            }else{
                $rootScope.milestonevideouploadsuccess1 = false
                $rootScope.uploadedImagesm = []
            }
            var updateMilestoneques2 = {
                title: '<b>View Milestone Question Image</b>',
                message:'',
                templateUrl: 'views/milestone/addMilestone.htm',
                size:'medium', 
                onEscape: function() {
                    $scope.$apply();
                    $rootScope.selectedMilestoneupdation = '';
                    $rootScope.uploadedImagesm = [];
                },
            };

            $ngBootbox.customDialog(updateMilestoneques2);
        }else if(data==3){
            $rootScope.milestoneShowcontent = 3
            var vid = value.video_guide
            if(vid!=null){
                $rootScope.uploadedVideosm = vid
                $rootScope.milestonevideouploadsuccess = true
            }else{
                $rootScope.milestonevideouploadsuccess = false
                $rootScope.uploadedVideosm = []
            }
            var updateMilestoneques3 = {
                title: '<b>Update Milestone Question Video</b>',
                message:'',
                templateUrl: 'views/milestone/addMilestone.htm',
                size:'medium', 
                onEscape: function() {
                    $scope.$apply();
                    $rootScope.selectedMilestoneupdation = '';
                    $rootScope.uploadedVideosm = [];
                },
            };

            $ngBootbox.customDialog(updateMilestoneques3);
        }else if(data==4){
            $rootScope.milestoneShowcontent = 4
            var vid = value.video_guide
            if(vid!=null){
                $rootScope.uploadedVideosm = vid
                $rootScope.milestonevideouploadsuccess = true
            }else{
                $rootScope.milestonevideouploadsuccess = false
                $rootScope.uploadedVideosm = []
            }
            var updateMilestoneques4 = {
                title: '<b>View Milestone Question Video</b>',
                message:'',
                templateUrl: 'views/milestone/addMilestone.htm',
                size:'medium', 
                onEscape: function() {
                    $scope.$apply();
                    $rootScope.selectedMilestoneupdation = '';
                    $rootScope.uploadedVideosm = [];
                    $rootScope.disablemilestoneupdate = true
                    $rootScope.loadmilestonevideo = false
                    $rootScope.milestonevideouploadsuccess = false
                },
            };

            $ngBootbox.customDialog(updateMilestoneques4);
        }else if(data==5){
            $rootScope.milestoneShowcontent = 5
            // console.log($rootScope.uploadedImages,'$rootScope.uploadedImages');
            // console.log(JSON.parse(sessionStorage.getItem('image_guide')),'sessionStorage.getItem(image_guide)');
            // console.log(JSON.parse(sessionStorage.getItem('image_guideM')),'sessionStorage.getItem(image_guideM)');
            $rootScope.uploadedImages = JSON.parse(sessionStorage.getItem('image_guideM'))
            if($rootScope.uploadedImages.length > 0){
                $rootScope.milestonevideouploadsuccess1 = true
            }else{
                $rootScope.milestonevideouploadsuccess1 = false
            }

            var updateMilestoneques5 = {
                title: '<b>Upload Milestone Image</b>',
                message:'',
                templateUrl: 'views/milestone/addMilestone.htm',
                size:'medium', 
                onEscape: function() {
                    $scope.$apply();
                }
            };
            // $ngBootbox.customDialog($rootScope.updateMilestoneques5);
            $ngBootbox.customDialog(updateMilestoneques5);
        }else if(data==6){
            $rootScope.milestoneShowcontent = 6
            // console.log($rootScope.uploadedVideos,'$rootScope.uploadedVideos');
            $rootScope.uploadedVideos = JSON.parse(sessionStorage.getItem('video_guideM'))
            if($rootScope.uploadedVideos.length > 0){
                $rootScope.milestonevideouploadsuccess = true
            }else{
                $rootScope.milestonevideouploadsuccess = false
            }
            var updateMilestoneques6 = {
                title: '<b>Upload Milestone Image</b>',
                message:'',
                templateUrl: 'views/milestone/addMilestone.htm',
                size:'medium', 
                onEscape: function() {
                    $scope.$apply();
                }
            };
            $ngBootbox.customDialog(updateMilestoneques6);
        }
    }

    $rootScope.updateMilestonequestionimage = function(file){
        console.log(file);
        $rootScope.loadmilestonevideo1 = false
        $rootScope.milestonevideouploadsuccess1 = false
        if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {

            $rootScope.uploadDocCoverImage = file.file;
            var reader = new FileReader();
            reader.onload = function (evt) {
                // $scope.$apply(function ($scope) {
                    var doctorCoverImage = evt.target.result;
                    // console.log(doctorCoverImage,'imageupload');
                    multipartFormdata.uploadFileToUrl11(authService.helyxonApi.url , file.file).then(function (response) {
                        var uploadImage = response.image[0].filename
                        $rootScope.loadmilestonevideo1 = true
                        $rootScope.milestonevideouploadsuccess1 = true
                        $rootScope.uploadedImagesm.push(uploadImage);
                    })
                // });
            };
            reader.readAsDataURL(file.file);

        } else {
            alert("Upload only Images");
        }
        flow.file = [];
    }

    $rootScope.updateMilestonet = function(data){
        if(data==1){
            if($rootScope.uploadedImagesm.length > 0){
                var data = {
                    "account_email": authService.authentication.account_id,
                    "milestone_id": $rootScope.selected.id,
                    "question": $rootScope.selectedMilestoneupdation.question,
                    "question_id": $rootScope.selectedMilestoneupdation.question_id,
                    "video_guide": $rootScope.selectedMilestoneupdation.video_guide,
                    "image_guide": $rootScope.uploadedImagesm        
                }
        
                milestoneService.createMilestonequestion(data).then(function(response){
                    console.log(response,'response');
                    if(response.success==1){
                        toastr.success('Milestone Question Image Updated successfully.');
                        // $rootScope.selectedMilestoneupdation.image_guide = data.image_guide;
                        bootbox.hideAll();
                    }else{
                        toastr.error(response.message);
                    }
                });
            }else{
                toastr.error('Please upload Image.');
            }
        }else if(data==2){
            if($rootScope.uploadedVideosm.length > 0){
                var data = {
                    "account_email": authService.authentication.account_id,
                    "milestone_id": $rootScope.selected.id,
                    "question": $rootScope.selectedMilestoneupdation.question,
                    "question_id": $rootScope.selectedMilestoneupdation.question_id,
                    "video_guide": $rootScope.uploadedVideosm,
                    "image_guide": $rootScope.selectedMilestoneupdation.image_guide        
                }
        
                milestoneService.createMilestonequestion(data).then(function(response){
                    console.log(response,'response');
                    if(response.success==1){
                        toastr.success('Milestone Question Video Updated successfully.');
                        // $rootScope.selectedMilestoneupdation.image_guide = data.image_guide;
                        bootbox.hideAll();
                    }else{
                        toastr.error(response.message);
                    }
                });
            }else{
                toastr.error('Please upload Video.');
            }
        }else if(data==3){
            // if (updateMilestoneques5Instance) {
            //     updateMilestoneques5Instance.modal('hide');
            //     updateMilestoneques5Instance = null; // Clear the reference
            // } else {
            //     console.error('updateMilestoneques4Instance is undefined');
            // }
            // updateMilestoneques5Instance.modal('hide');
            // $('#updateMilestoneques6Dialog').modal('hide');
            // $('#updateMilestoneques5Dialog').modal('hide');
            // if (updateMilestoneques6Instance) {
            //     updateMilestoneques6Instance.modal('hide');
            //     updateMilestoneques6Instance = null; // Clear the reference
            // }
            // if (updateMilestoneques5Instance) {
            //     updateMilestoneques5Instance.modal('hide');
            //     updateMilestoneques5Instance = null; // Clear the reference
            // }
            // $rootScope.updateMilestoneques5.modal('hide');
            // $rootScope.updateMilestoneques6.modal('hide');
            if($rootScope.uploadedImages.length > 0){
                $rootScope.updateMilestoneData(2);
            }else{
                toastr.error('Please upload Image.');
            }
        }else if(data==4){
            // if (updateMilestoneques6Instance) {
            //     updateMilestoneques6Instance.modal('hide');
            //     updateMilestoneques6Instance = null; // Clear the reference
            // } else {
            //     console.error('updateMilestoneques6Instance is undefined');
            // }
            // updateMilestoneques6Instance.modal('hide');
            // $('#updateMilestoneques6Dialog').modal('hide');
            // $('#updateMilestoneques5Dialog').modal('hide');
            // $rootScope.updateMilestoneques5.modal('hide');
            // $rootScope.updateMilestoneques6.modal('hide');
            // if (updateMilestoneques6Instance) {
            //     updateMilestoneques6Instance.modal('hide');
            //     updateMilestoneques6Instance = null; // Clear the reference
            // }
            // if (updateMilestoneques5Instance) {
            //     updateMilestoneques5Instance.modal('hide');
            //     updateMilestoneques5Instance = null; // Clear the reference
            // }
            if($rootScope.uploadedVideos.length > 0){
                $rootScope.updateMilestoneData(2);
            }else{
                toastr.error('Please upload Video.');
            }
        }
    }

    $rootScope.updateMilestonequestionvideo = function(file, event, flow){
        $rootScope.disablemilestoneupdate = true
        $rootScope.loadmilestonevideo = false
        $rootScope.milestonevideouploadsuccess = false
        if ({ mp4: 1, mov: 1 }[file.getExtension()]) {
            var data = new FormData();
            data.append('file', file.file);

            var reader = new FileReader();
            reader.onload = function(e) {
                multipartFormdata.uploadvideoToUrl($scope.imageUploadUrl, file.file).then(function(response){
                    var uploadedVideo = response.video[0].filename;
                    $rootScope.loadmilestonevideo = true
                    $rootScope.milestonevideouploadsuccess = true
                    $rootScope.disablemilestoneupdate = false
                    $rootScope.uploadedVideosm.push(uploadedVideo);

                });
            };
            reader.readAsDataURL(file.file);
        }else {
            alert("Upload only Video");
        }
        flow.file = [];
    }

    $rootScope.updateMilestonequestionp = function(daata){
        // console.log($rootScope.updationQuestionselected,'$rootScope.updationQuestionselected');
        // console.log($rootScope.selected,'$rootScope.selected');
        // console.log($rootScope.questionName,'$rootScope.questionName');
        if($rootScope.questionName == '' || $rootScope.questionName == undefined || $rootScope.questionName == null){
            toastr.error('Please enter Question.');
        }else{
            var data = {
                "account_email": authService.authentication.account_id,
                "milestone_id": $rootScope.selected.id,
                "question": $rootScope.questionName,
                "question_id": $rootScope.updationQuestionselected.question_id,
                "video_guide": [],
                "image_guide": []        
            }

            milestoneService.createMilestonequestion(data).then(function(response){
                console.log(response,'response');
                if(response.success==1){
                    toastr.success('Milestone Question Updated successfully.');
                    // $rootScope.selected.question = data;
                    // $rootScope.selected.question = "";
                    // bootbox.hideAll();
                    $rootScope.getQuestion($rootScope.selected);
                    bootbox.hideAll();
                    // if ($rootScope.innerDialog) {
                        // console.log($rootScope.innerDialog, 'innerDialog'); // Log the dialog reference
                        // $rootScope.innerDialog.modal('hide');
                    // }  
                    // updateMilestoneque.hide();  
                }else{
                    toastr.error(response.message);
                }
            })
        }
    }

    $rootScope.eshopLinkingmilestone = ''
    $rootScope.eshopLinkingmilestoneactivity = ''
    $rootScope.selectedDataforLinking = ''
    $rootScope.selectedOptionssend = [];
    $rootScope.selectedItems = [];
    $rootScope.checkGetmilestoneproduct = [];

    $rootScope.openLinking = function(data){
        // $rootScope.selected = data;
        console.log(data,'data');
        $rootScope.selectedDataforLinking = data;
        // if(data.products!=null){
        //     // $rootScope.selectedItems = data.products;
        //     for(var i=0;i<data.products.length;i++){
        //         $rootScope.selectedItems.push({eshop_product_id:data.products[i].product_id,custom_qa_id:data.id,name: data.products[i].product_name,is_active:true});
        //         $rootScope.selectedOptionssend.push({eshop_product_id:data.products[i].product_id,custom_qa_id:data.id,is_active:true});
        //     }
        //     // var newItem = {
        //     //     eshop_product_id: ,
        //     //     custom_qa_id: $rootScope.selectedDataforLinking.id,
        //     //     name: $rootScope.selectedOption.name__,
        //     //     is_active: true
        //     // };
        //     // var newItem1 = {
        //     //     eshop_product_id: $rootScope.selectedOption.id,
        //     //     custom_qa_id: $rootScope.selectedDataforLinking.id,
        //     //     is_active: true
        //     // };
        //     // $rootScope.selectedOptionssend.push(newItem1);
        //     // $rootScope.selectedItems.push(newItem);
        //     // $rootScope.selectedOption = ''; // Reset the dropdown
        //     // $rootScope.eshopLinkingmilestone = '';
        // }else{
        //     $rootScope.selectedOptionssend = [];
        //     $rootScope.selectedItems = [];
        // }

        $rootScope.getMilestonelinkedproductbyid(data);


        console.log($rootScope.selectedDataforLinking,'selectedData');
        var options = {
            title: '<b>Link Eshop Product</b>',
            message:'',
            templateUrl: 'views/milestone/linkingMilestone.htm',
            size:'medium', 
            onEscape: function() {
                // $rootScope.selected = [];
                // $scope.milestonesList();
                $scope.$apply();
                $rootScope.eshopLinkingmilestone = '';
                $rootScope.searchEsshopProducts = [];
                $rootScope.localDrugArr = [];
                $rootScope.selectedOption = '';
                $rootScope.selectedDataforLinking = '';
                // $rootScope.selectedOption1 = [];
                $rootScope.selectedOptionssend = [];
                $rootScope.selectedItems = [];
            },
        };

        $ngBootbox.customDialog(options);
    }

    $rootScope.getMilestonelinkedproductbyid = function(data){

        var param = {
            account_email: authService.authentication.account_id,
            id: data.id
        }

        milestoneService.getEshopLinkingcoupon(param).then(function(response){
            if(response.success==1){
                // $rootScope.selectedItems = response.data;
                // $rootScope.selectedOptionssend = response.data;
                if(response.data.length>0){
                    $rootScope.selectedItems = response.data.map(function(item) {
                        return {
                          "custom_qa_id": item.custom_qa_id,
                          "eshop_product_id": item.product_id+'',
                          "is_active": item.is_active,
                          "product_name": item.product_name
                        };
                    });
                    $rootScope.selectedOptionssend = response.data.map(function(item) {
                        return {
                          "custom_qa_id": item.custom_qa_id,
                          "eshop_product_id": item.product_id+'',
                          "is_active": item.is_active,
                          "product_name": item.product_name
                        };
                    });
                    $rootScope.checkGetmilestoneproduct = response.data.map(function(item) {
                        return {
                          "custom_qa_id": item.custom_qa_id,
                          "eshop_product_id": item.product_id+'',
                          "is_active": item.is_active,
                          "product_name": item.product_name
                        };
                    });;
                }else{
                    $rootScope.selectedOptionssend = [];
                    $rootScope.selectedItems = [];
                    $rootScope.checkGetmilestoneproduct = [];
                }
            }else{
                $rootScope.selectedOptionssend = [];
                $rootScope.selectedItems = [];
                $rootScope.checkGetmilestoneproduct = [];
            }
        })

    }

    $rootScope.searchEsshopProducts = []
    $rootScope.localDrugArr = []
    $rootScope.selectedOption = ''
    $rootScope.selectedOptionactivity = []
    $rootScope.selectedOption1 = [];
    $rootScope.eshopToggle = false;

    $rootScope.searchProducts = function(){
        
            var pageNumber = 1;
            var data = {
                account_email: authService.authentication.account_id,
                page_no: pageNumber,
                product_name: $rootScope.eshopLinkingmilestone.toLowerCase()
            };

            milestoneService.searchEshopdetails(data).then(function(response){
                console.log(response,'response');
                if(response.success==1){
                    $rootScope.searchEsshopProducts = response.message;
                    // const localMapFun= response.message.map(e=>e);
                    // $rootScope.localDrugArr = localMapFun.map((e)=>({
                    //   name__ : e.name,
                    //   id: e.id
                    // }))
                    var localMapFun = response.message.map(function(e) {
                        return e;
                    });
                      
                    $rootScope.localDrugArr = localMapFun.map(function(e) {
                    return {
                        name__: e.name,
                        id: e.id
                    };
                    });
                    // console.log($rootScope.localDrugArr,'$rootScope.localDrugArr');
                    // toastr.success('Eshop Link added successfully.');
                    // $rootScope.eshopLinkingmilestone = '';
                    // bootbox.hideAll();
                }else{
                    $rootScope.eshopLinkingmilestone = '';
                    $rootScope.searchEsshopProducts = [];
                    $rootScope.localDrugArr = [];
                }
            })
    }

    $rootScope.toggleChangeeshop = function(){
        console.log($rootScope.eshopToggle,'toggle');
        // $rootScope.eshopToggle = !$rootScope.eshopToggle
    }

    $rootScope.searchEshopId = function(){
        $rootScope.localDrugArr = [];
        console.log($rootScope.selectedDataforLinking,'selectedData');
        if($rootScope.eshopLinkingmilestone == '' || $rootScope.eshopLinkingmilestone == undefined || $rootScope.eshopLinkingmilestone == null){
            toastr.error('Please enter Product ID to add.');
        }else{
            var param = {
                account_email: authService.authentication.account_id,
                eshop_product_id: $rootScope.eshopLinkingmilestone,
                id: $rootScope.selectedDataforLinking.id
            }

            milestoneService.searchEshopbyid(param).then(function(response){
                console.log(response,'response');
                if(response.success==1){
                    $rootScope.searchEsshopProducts = response.message;
                    // var localMapFun = response.message.map(function(e) {
                    //     return e;
                    // });
                    
                    // $rootScope.localDrugArr = localMapFun.map(function(e) {
                    // return {
                    //     name__: e.product_name,
                    //     id: e.product_id
                    // };
                    // });
                    var res = []
                    res.push(response.message);
                    var localMapFun = res.map(function(e) {
                        return e;
                    });  
                    $rootScope.localDrugArr = localMapFun.map(function(e) {
                    return {
                        // name__: e.product_name,
                        // id: e.product_id
                        product_name : e.product_name,
                        eshop_product_id: e.product_id,
                        is_active: e.is_active,
                        custom_qa_id: e.custom_qa_id
                    };
                    });
                    $rootScope.selectedOption = $rootScope.localDrugArr[0];
                    // console.log($rootScope.selectedOption,'selectedOption');
                    // $rootScope.localDrugArr.push({product_name :response.message.product_name,eshop_product_id:response.message.product_id,is_active: response.message.is_active,custom_qa_id: response.message.custom_qa_id});
                    // console.log($rootScope.localDrugArr,'$rootScope.localDrugArr');
                    // $rootScope.eshopLinkingmilestone = '';
                    // $rootScope.getMilestonelinkedproductbyid()
                    // $rootScope.selectedOption = []
                    // console.log($rootScope.selectedOption,'selectedOption');
                    // $rootScope.addOption();
                    // console.log($rootScope.selectedItems,'$rootScope.selectedItems1262');
                    var isDuplicate = false;

                    // Use a loop to check for duplicates
                    for (var i = 0; i < $rootScope.selectedItems.length; i++) {
                        if ($rootScope.selectedItems[i].eshop_product_id === $rootScope.selectedOption.eshop_product_id) {
                            isDuplicate = true;
                            console.log('duplicate1'); 
                            break;
                        }
                    }

                    if (isDuplicate) {
                        toastr.error('Product already added.');
                        $rootScope.eshopLinkingmilestone = '';
                    }else{
                        $rootScope.selectedItems.push($rootScope.localDrugArr[0]);
                        // console.log( $rootScope.selectedItems,'$rootScope.selectedItems00');
                        $rootScope.selectedOptionssend.push($rootScope.localDrugArr[0]);
                        // console.log($rootScope.selectedOptionssend,'$rootScope.selectedOptionssend00');
                        $rootScope.eshopLinkingmilestone = '';
                    }
                }else{
                    // $rootScope.eshopLinkingmilestone = '';
                    toastr.error(response.message);
                    $rootScope.searchEsshopProducts = [];
                    $rootScope.localDrugArr = [];
                }
            });
        }
    }

    $rootScope.selectedEshopvalue = function(d){
        console.log(d,'data');
        // console.log($rootScope.selectedOption1,'$rootScope.selectedOption1');
    }

    $rootScope.displayedTexts = [];
    $rootScope.errorMessage = '';

    $rootScope.addOption = function() {
        // console.log($rootScope.selectedOption,'$rootScope.selectedOption');
        // console.log($rootScope.selectedItems,'$rootScope.selectedItems');
        

        var isDuplicate = false;

        // Use a loop to check for duplicates
        for (var i = 0; i < $rootScope.selectedItems.length; i++) {
        //     if($rootScope.selectedItems[i].eshop_product_id){
        //         if ($rootScope.selectedItems[i].eshop_product_id === $rootScope.selectedOption.id) {
        //             isDuplicate = true;
        //             console.log('duplicate1'); 
        //             break;
        //         }
        //     }else{
        //         if ($rootScope.selectedItems[i].id === $rootScope.selectedOption.id) {
        //             isDuplicate = true;
        //             console.log('duplicate2'); 
        //             break;
        //         }
        //     }
        //   if ($rootScope.selectedItems[i].id === $rootScope.selectedOption.id) {
        //     isDuplicate = true;
        //     break;
        //   }

            if ($rootScope.selectedItems[i].eshop_product_id === $rootScope.selectedOption.id) {
                isDuplicate = true;
                console.log('duplicate1'); 
                break;
            }
        }

        if (isDuplicate) {
            // $scope.errorMessage = 'This text has already been selected.';
            toastr.error('Product already added.');
            $rootScope.eshopLinkingmilestone = '';
        }else {
            // var newItem = {
            //     eshop_product_id: $rootScope.selectedOption.id,
            //     custom_qa_id: $rootScope.selectedDataforLinking.id,
            //     product_name: $rootScope.selectedOption.name__,
            //     is_active: true
            // };
            // var newItem1 = {
            //     eshop_product_id: $rootScope.selectedOption.id,
            //     custom_qa_id: $rootScope.selectedDataforLinking.id,
            //     is_active: true
            // };
            $rootScope.selectedItems = $rootScope.selectedOptionssend;
            // console.log( $rootScope.selectedItems,'$rootScope.selectedItems');
            // $rootScope.errorMessage = ''; 
            // console.log($rootScope.selectedOptionssend,'$rootScope.selectedOptionssend1');            
            $rootScope.selectedOptionssend.push($rootScope.localDrugArr[0]);
            // console.log($rootScope.selectedOptionssend,'$rootScope.selectedOptionssend2');
            // $rootScope.selectedItems.push(newItem);
            $rootScope.selectedOption = ''; // Reset the dropdown
            $rootScope.eshopLinkingmilestone = '';
            // checkselectedOption = [];
        }
        // $rootScope.selectedOption = null;
        $rootScope.localDrugArr = []
    };

    $rootScope.removeOption = function(item) {
        console.log(item,'1252');
        // console.log($rootScope.selectedDataforLinking,'$rootScope.selectedDataforLinking--1253');
        
        if(item.custom_qa_id != undefined){
            var param = {
                account_email: authService.authentication.account_id,
                id: item.custom_qa_id,
                product_id: item.eshop_product_id
            }

            milestoneService.removeEshopLinking(param).then(function(response){
                if(response.success==1){
                    toastr.success('Eshop product is removed successfully.');
                    // $rootScope.getMilestonelinkedproductbyid($rootScope.selectedDataforLinking)
                    var index = $rootScope.selectedItems.indexOf(item);
                    if (index > -1) {
                        $rootScope.selectedItems.splice(index, 1);
                    }

                    $rootScope.selectedOptionactivity = $rootScope.selectedItems.map(function(obj) {
                        return obj.eshop_product_id;
                    });
                }else{
                    // console.log($rootScope.selectedItems,'n1');
                    // console.log($rootScope.selectedOptionactivity,'nn1');

                    var index = $rootScope.selectedItems.indexOf(item);
                    if (index > -1) {
                        $rootScope.selectedItems.splice(index, 1);
                    }

                    $rootScope.selectedOptionactivity = $rootScope.selectedItems.map(function(obj) {
                        return obj.eshop_product_id;
                    });

                    // console.log($rootScope.selectedItems,'n2');
                    // console.log($rootScope.selectedOptionactivity,'nn2');
                }
            });
        }else{
            var index = $rootScope.selectedItems.indexOf(item);
            if (index > -1) {
                $rootScope.selectedItems.splice(index, 1);
            }

            $rootScope.selectedOptionactivity = $rootScope.selectedItems.map(function(obj) {
                return obj.eshop_product_id;
            });

            // console.log($rootScope.selectedItems,'n2');
            // console.log($rootScope.selectedOptionactivity,'nn2');
        }
    };

    $rootScope.saveEshopmilestone = function(){
        // console.log($rootScope.selectedDataforLinking,'$rootScope.selectedDataforLinking');
        // console.log($rootScope.selectedOption,'$rootScope.selectedOption');
        // console.log($rootScope.selectedOption1,'$rootScope.selectedOption1');
        // console.log($rootScope.selectedOptionsArray,'$rootScope.selectedOptionsArray');
        // console.log($rootScope.selectedItems,'$rootScope.selectedItems');
        // console.log($rootScope.selectedOptionssend,'$rootScope.selectedOptionssend');
        // console.log($rootScope.checkGetmilestoneproduct,'$rootScope.checkGetmilestoneproduct');
        // console.log($rootScope.eshopLinkingmilestone,'$rootScope.eshopLinkingmilestone');
        // if($rootScope.selectedOption == ''){
        if($rootScope.selectedItems.length<10){
            if($rootScope.selectedItems > $rootScope.checkGetmilestoneproduct){
                if($rootScope.selectedItems.length == 0){
                    toastr.error('Please select Product.');
                }else{
                    var paaram = {
                        products: $rootScope.selectedItems,
                        account_email: authService.authentication.account_id
                    }
    
                    // console.log(paaram,'paaram');
                    
    
                    milestoneService.linkEshopProduct(paaram).then(function(response){
                        console.log(response,'response');
                        if(response.success==1){
                            toastr.success('Eshop product is Linked successfully.');
                            $rootScope.eshopLinkingmilestone = '';
                            $rootScope.searchEsshopProducts = [];
                            $rootScope.localDrugArr = [];
                            $rootScope.selectedOption = '';
                            $rootScope.selectedDataforLinking = '';
                            $rootScope.selectedOption1 = [];
                            bootbox.hideAll();
                            // $rootScope.getMilestonelinkedproductbyid($rootScope.selectedDataforLinking)
                            // $location.path('/milestoneConfig');
                        }else{
                            toastr.error(response.message);
                        }
                    });
                }
            }else{
                toastr.error('Please enter Product Id to add.');
            }
        }else{
            toastr.error('Maximum limit reached.Only Nine product is allowed')
        }
    }

    $rootScope.eshopLinkingmilestoneactivity = ''
    $rootScope.eshopLinked = {};

    $rootScope.addActivity = function(){

        $rootScope.image = false
        $rootScope.video = false
        $rootScope.Linked = false
        $rootScope.app = false
        $rootScope.selected_type = null
        $rootScope.video_guide = null
        $rootScope.saveProfile = null
        $rootScope.saveProfile1 = null
        $rootScope.notUpdatedVideo = null
        $rootScope.doctorCoverImage = null
        $rootScope.doctorCoverImage1 = null
        $rootScope.eshopLinkingmilestoneactivity = '';
        $rootScope.searchEsshopProducts = [];
        $rootScope.localDrugArr = [];
        $rootScope.selectedOption = '';
        $rootScope.selectedDataforLinking = '';
        $rootScope.selectedOptionssend = [];
        $rootScope.selectedItems = [];

        var options = {
            title: '<b>Add Activity Card</b>',
            message:'',
            templateUrl: 'views/milestone/addactivitycard.htm',
            size:'medium', 
            onEscape: function() {
                $rootScope.image = false
                $rootScope.video = false
                $rootScope.Linked = false
                $rootScope.app = false
                $rootScope.selected_type = null
                $rootScope.video_guide = null
                $rootScope.saveProfile = null
                $rootScope.saveProfile1 = null
                $rootScope.notUpdatedVideo = null
                $rootScope.doctorCoverImage = null
                $rootScope.doctorCoverImage1 = null
                $rootScope.eshopLinkingmilestoneactivity = '';
                $rootScope.searchEsshopProducts = [];
                $rootScope.localDrugArr = [];
                $rootScope.selectedOption = '';
                $rootScope.selectedDataforLinking = '';
                // $rootScope.selectedOption1 = [];
                $rootScope.selectedOptionssend = [];
                $rootScope.selectedItems = [];
            },
        };
    
        $ngBootbox.customDialog(options);

    }

    $rootScope.image = false
    $rootScope.video = false
    $rootScope.Linked = false
    $rootScope.app = false

    $rootScope.getType = function(content){
        if(content == 'image'){
            $rootScope.video = false
            $rootScope.image = true
            $rootScope.Linked = false
            $rootScope.app = false
            $rootScope.contentType = 0
            // console.log($rootScope.contentType);
            $rootScope.video_guide = null
            $rootScope.saveProfile = null
            $rootScope.saveProfile1 = null
            $rootScope.doctorCoverImage = null
            $rootScope.doctorCoverImage1 = null
            $rootScope.Otype = 0
            $rootScope.eshopLinkingmilestoneactivity = ''
        }else if(content == 'video'){
            $rootScope.image = false
            $rootScope.video = true
            $rootScope.Linked = false
            $rootScope.app = false
            $rootScope.contentType = 1
            // console.log($rootScope.contentType);
            $rootScope.saveProfile = null
            $rootScope.saveProfile1 = null
            $rootScope.doctorCoverImage = null
            $rootScope.doctorCoverImage1 = null
            $rootScope.video_guide = null
            $rootScope.getIframeSrc = null
            $rootScope.milestonevideouploadsuccess = false
            $rootScope.notUpdatedVideo = ''
            $rootScope.Otype = 0
            $rootScope.eshopLinkingmilestoneactivity = ''
        }else if(content == 'links'){
            $rootScope.image = false
            $rootScope.video = false
            $rootScope.Linked = true
            $rootScope.app = false
            $rootScope.saveProfile = null
            $rootScope.saveProfile1 = null
            $rootScope.doctorCoverImage = null
            $rootScope.doctorCoverImage1 = null
            $rootScope.video_guide = null
            $rootScope.getIframeSrc = null
            $rootScope.contentType = 0
            // console.log($rootScope.contentType);
            $rootScope.Otype = 0
            $rootScope.link = ''
            $rootScope.eshopLinkingmilestoneactivity = ''
        }else if(content == 'app'){
            $rootScope.image = false
            $rootScope.video = false
            $rootScope.Linked = false
            $rootScope.app = true
            $rootScope.saveProfile = null
            $rootScope.saveProfile1 = null
            $rootScope.doctorCoverImage = null
            $rootScope.doctorCoverImage1 = null
            $rootScope.video_guide = null
            $rootScope.getIframeSrc = null
            $rootScope.contentType = 0
            // console.log($rootScope.contentType);
            $rootScope.selected_otype = ''
        }
    }

    $rootScope.uploadCoverImage1 = function (file) {

        console.log(file);
        if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {

            $rootScope.uploadDocCoverImage1 = file.file;
            var file = file.file;
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $rootScope.doctorCoverImage1 = evt.target.result;
                    // console.log($rootScope.doctorCoverImage1,'imageupload');
                    $scope.hide = true
                    // console.log($rootScope.uploadDocCoverImage1, "uploadDocCoverImage")
                    multipartFormdata.uploadFileToUrl(authService.helyxonApi.url, $rootScope.uploadDocCoverImage1).then(function (response) {
                        $rootScope.saveProfile1 = response.image[0].filename;
                        console.log($rootScope.saveProfile1);
                    })
                });
            };
            reader.readAsDataURL(file);

        } else {
            alert("Upload only Images");
        }
    }

    $rootScope.deleteuploadedimagethumb = function(){
        $rootScope.doctorCoverImage1 = ""
        $rootScope.saveProfile1 = null
    }

    $rootScope.uploadCoverImage = function (file) {

        console.log(file);
        if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {

            $rootScope.uploadDocCoverImage = file.file;
            var file = file.file;
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $rootScope.doctorCoverImage = evt.target.result;
                    // console.log($rootScope.doctorCoverImage,'imageupload');
                    $scope.hide = true
                    // console.log($rootScope.uploadDocCoverImage, "uploadDocCoverImage")
                    multipartFormdata.uploadFileToUrl(authService.helyxonApi.url, $rootScope.uploadDocCoverImage).then(function (response) {
                        $rootScope.saveProfile = response.image[0].filename;
                        console.log($rootScope.saveProfile);
                    })
                });
            };
            reader.readAsDataURL(file);

        } else {
            alert("Upload only Images");
        }
    }

    $rootScope.deleteuploadedimage = function(){
        $rootScope.doctorCoverImage = ""
        $rootScope.saveProfile = null
    }

    $rootScope.loadmilestonevideo = true
    $rootScope.uploadFilemilestone = function(file, event, flow) {
        $rootScope.disablemilestoneupdate = true
        $rootScope.loadmilestonevideo = false
        $rootScope.milestonevideouploadsuccess = false
        if ({ mp4: 1, mov: 1 }[file.getExtension()]) {
            var data = new FormData();
            data.append('file', file.file);
            $rootScope.milestonevideofile = file.file;    
            var reader = new FileReader();
            reader.onload = function(e) {
                multipartFormdata.uploadvideoToUrl(authService.helyxonApi.url,  $rootScope.milestonevideofile).then(function(response){
                    $rootScope.video_guide = response.video[0].filename
                    $rootScope.loadmilestonevideo = true
                    $rootScope.milestonevideouploadsuccess = true
                    $rootScope.disablemilestoneupdate = false
                    $rootScope.getIframeSrc = $sce.trustAsResourceUrl(authService.helyxonApi.url+'cloud/image/upload/'+response.video[0].filename)
                })
           };
           reader.readAsDataURL(file.file);
        }else {
            alert("Upload only Videos");
            return false;
        }
        flow.file = [];
    };

    $rootScope.deleteuploadedvideo = function(){
        $rootScope.getIframeSrc = ""
        $rootScope.video_guide = null
        $rootScope.milestonevideouploadsuccess = false
    }

    $rootScope.cancel = function(){
        // $location.path('/health')
        bootbox.hideAll();
        sessionStorage.setItem('bannerStatus','')
        $rootScope.video_guide = null
        $rootScope.saveProfile = null
        $rootScope.saveProfile1 = null
        $rootScope.notUpdatedVideo = null
        $rootScope.doctorCoverImage = null
        $rootScope.image = false
        $rootScope.video = false
        $rootScope.Linked = false
        $rootScope.app = false
        $rootScope.selected_type = null
        $rootScope.doctorCoverImage1 = null
    }

    $scope.activityCarddata = [];

    $rootScope.getActivitycarddata = function(){

        var payload = {
            account_email : authService.authentication.account_id,
            sno: parseInt($rootScope.selected.sno)
        }

        milestoneService.getActivitycard(payload).then(function (response){
            console.log(response);
            if(response.success==1){
                $scope.activityCarddata = response.data
            }else{
                $scope.activityCarddata = [];
            }
        });
    }

    if(sessionStorage.getItem('selmilestoneData')!=null){
        $rootScope.getActivitycarddata();
    }

    $scope.confirmationDeleteactivitycard = function(ID){

        var options = {
            title: '',
            message:'Do you want to delete?',
            size:'small', 
            onEscape: function() {
            },
            buttons: {
                success: {
                    label: "Yes",
                    className: "btn-success",
                    callback: function () {
                        $scope.deleteactivityCard(ID)
                    }
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-danger",
                }
            }
        };
    
        $ngBootbox.customDialog(options);

    }

    $scope.deleteactivityCard = function(ID){

        var payload = {
            account_email: authService.authentication.account_id,
            id: ID.activity_id
        }

        milestoneService.deleteActivitycard(payload).then(function (response){
            console.log(response);
            if(response.success==1){
                toastr.success(response.message);
                $rootScope.getActivitycarddata();
            }else{
                toastr.error(response.message);
                $rootScope.getActivitycarddata();
            }
        });
    }

    // Show image attachment in popup
    $scope.showImage = function (data) {
        var options = {
            title: '',
            message: '<img class="img-responsive center-block" src="' + data + '"/>',
            size: 'medium',
            onEscape: true,
        };
        $ngBootbox.customDialog(options);
    }

    $rootScope.searchEshopbyidactivity = function(data){
        // $rootScope.$apply(function() {
            console.log(data,'daa');
            // console.log($rootScope.eshopLinkingmilestoneactivity, '1925');
        // });
    }

    $rootScope.searchEshopIdactivity = function(data){
        $rootScope.localDrugArr = [];
        $rootScope.selectedOptionactivity = [];
        // console.log(data,'daa');
        // console.log($rootScope.eshopLinkingmilestoneactivity,'1926');
        // console.log($rootScope.selectedOptionactivity,'1752');
        // console.log($rootScope.eshopLinkingmilestone,'c');
        // console.log($rootScope.eshopLinked,'c1');
        if($rootScope.eshopLinked.activitycardValue == '' || $rootScope.eshopLinked.activitycardValue == undefined || $rootScope.eshopLinked.activitycardValue == null){
            toastr.error('Please enter Product ID to add.');
        }else{
            var param = {
                account_email: authService.authentication.account_id,
                eshop_product_id: $rootScope.eshopLinked.activitycardValue,
            }

            milestoneService.searchEshopbyidactivity(param).then(function(response){
                // console.log(response,'response');
                $rootScope.eshopLinkingmilestone = null
                $rootScope.eshopLinked.activitycardValue = ''
                if(response.success==1){
                    $rootScope.searchEsshopProducts = response.message;
                    var res = []
                    res.push(response.message);
                    var localMapFun = res.map(function(e) {
                        return e;
                    });  
                    $rootScope.localDrugArr = localMapFun.map(function(e) {
                    return {
                        product_name : e.product_name,
                        eshop_product_id: e.product_id,
                        is_active: e.is_active,
                        custom_qa_id: e.custom_qa_id
                    };
                    });
                    $rootScope.selectedOption = $rootScope.localDrugArr[0];
                    // $rootScope.selectedOptionactivity.push($rootScope.localDrugArr[0].eshop_product_id)
                    // console.log($rootScope.selectedOptionactivity,'1780');
                    // console.log($rootScope.selectedOption,'selectedOption');
                    // console.log($rootScope.selectedItems,'$rootScope.selectedItems1262');
                    var isDuplicate = false;

                    // Use a loop to check for duplicates
                    for (var i = 0; i < $rootScope.selectedItems.length; i++) {
                        if ($rootScope.selectedItems[i].eshop_product_id === $rootScope.selectedOption.eshop_product_id) {
                            isDuplicate = true;
                            // console.log('duplicate1'); 
                            break;
                        }
                    }

                    if (isDuplicate) {
                        toastr.error('Product already added.');
                        $rootScope.eshopLinkingmilestoneactivity = '';
                        $timeout(function() {
                            $rootScope.eshopLinkingmilestoneactivity = '';
                            // console.log($rootScope.eshopLinkingmilestoneactivity, '1925');
                        }, 0);
                        $rootScope.selectedOptionactivity = $rootScope.selectedItems.map(function(obj) {
                            return obj.eshop_product_id;
                        });
                        // console.log($rootScope.selectedOptionactivity,'1903');
                    }else{
                        // $rootScope.selectedOptionactivity.concat($rootScope.localDrugArr[0].eshop_product_id)
                        // console.log($rootScope.selectedOptionactivity,'1872');
                        $rootScope.selectedItems.push($rootScope.localDrugArr[0]);
                        // console.log( $rootScope.selectedItems,'$rootScope.selectedItems00');
                        $rootScope.selectedOptionssend.push($rootScope.localDrugArr[0]);
                        // console.log($rootScope.selectedOptionssend,'$rootScope.selectedOptionssend00');
                        $rootScope.selectedOptionactivity = $rootScope.selectedItems.map(function(obj) {
                            return obj.eshop_product_id;
                        });
                        // console.log($rootScope.selectedOptionactivity,'1914');
                        $rootScope.eshopLinkingmilestoneactivity = '';
                        $timeout(function() {
                            $rootScope.eshopLinkingmilestoneactivity = '';
                            // console.log($rootScope.eshopLinkingmilestoneactivity, '1925');
                        }, 0);
                    }
                }else{
                    $timeout(function() {
                        $rootScope.eshopLinkingmilestoneactivity = '';
                        // console.log($rootScope.eshopLinkingmilestoneactivity, '1925');
                    }, 0);
                    toastr.error(response.message);
                    $rootScope.searchEsshopProducts = [];
                    $rootScope.localDrugArr = [];
                    $rootScope.selectedOptionactivity = [];
                }
            });
        }
    }

    $rootScope.saveBanner = function(){

        // console.log($rootScope.saveProfile,'img');
        // console.log($rootScope.saveProfile1,'img');
        // console.log($rootScope.video_guide,'video');
        // console.log($rootScope.contentType,'type'); 
        // console.log($rootScope.Otype,'otype');
        // console.log($rootScope.link,'link');
        // console.log($rootScope.image);
        // console.log($rootScope.video);
        // console.log($rootScope.Linked);
        // console.log($rootScope.app);
        // console.log($rootScope.selectedOptionactivity,'1752');

        if($rootScope.saveProfile != undefined){
            var URL = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile
            // console.log(URL);
        }else if($rootScope.video_guide != undefined){
            var URL2 = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.video_guide
            // console.log(URL2);
        }
        else if($rootScope.saveProfile1 != undefined){
            var URL1 = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
            // console.log(URL1);
        }

        if($rootScope.image == false && $rootScope.video == false && $rootScope.Linked == false && $rootScope.app == false){
            toastr.error('Please select any upload option')
        }else{

            if($rootScope.image == true){
                if($rootScope.saveProfile1 != undefined && $rootScope.saveProfile != undefined){
                    var payload = {
                        "account_email": authService.authentication.account_id,
                        "card_type":"Image",
                        "sno": parseInt($rootScope.selected.sno),
                        "external_url": authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile, 
                        "card_image": authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1 
                    }  

                    milestoneService.activitycreate(payload).then(function (response) {
                        console.log(response);
                        if(response.success == 1){
                            toastr.success(response.message)
                            bootbox.hideAll();
                            $rootScope.saveProfile1 = ''
                            $rootScope.doctorCoverImage1 = ''
                            $rootScope.doctorCoverImage = ''
                            $rootScope.getActivitycarddata();
                        }else{
                            toastr.error(response.message)
                            bootbox.hideAll();
                            $rootScope.saveProfile1 = ''
                            $rootScope.doctorCoverImage1 = ''
                            $rootScope.doctorCoverImage = ''
                            $rootScope.getActivitycarddata();
                        }
                    }, function (err) {
                        toastr.error(err);
                    });
                }else{
                    toastr.error('Please Fill All Fields')
                }
            }

            else if($rootScope.video == true){
                if($rootScope.saveProfile1 != undefined && $rootScope.video_guide != undefined){
                    var payload = {
                        "account_email": authService.authentication.account_id,
                        "card_type":"Video",
                        "sno": parseInt($rootScope.selected.sno),
                        "external_url": authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.video_guide, 
                        "card_image": authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1 
                    }

                    milestoneService.activitycreate(payload).then(function (response) {
                        console.log(response);
                        if(response.success == 1){
                            toastr.success(response.message)
                            // $location.path('/health')
                            bootbox.hideAll();
                            $rootScope.getActivitycarddata();
                            $rootScope.saveProfile1 = ''
                            $rootScope.doctorCoverImage1 = ''
                            $rootScope.getIframeSrc = ''
                        }else{
                            toastr.error(response.message)
                            bootbox.hideAll();
                            $rootScope.getActivitycarddata();
                            $rootScope.saveProfile1 = ''
                            $rootScope.doctorCoverImage1 = ''
                            $rootScope.getIframeSrc = ''
                        }
                    }, function (err) {
                        toastr.error(err);
                    });
                }else{
                    toastr.error('Please Fill All Fields')
                } 
            }

            else if($rootScope.Linked == true){
                if($rootScope.saveProfile1 != undefined && $rootScope.link != ''){
                    if($rootScope.link.startsWith("http:") || $rootScope.link.startsWith("https:")){
                        var payload = {
                            "account_email": authService.authentication.account_id,
                            "card_type":"Link",
                            "sno": parseInt($rootScope.selected.sno),
                            "external_url": $rootScope.link, 
                            "card_image": authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1 
                        }
                        

                        milestoneService.activitycreate(payload).then(function (response) {
                            console.log(response);
                            if(response.success == 1){
                                toastr.success(response.message)
                                // $location.path('/health')
                                bootbox.hideAll();
                                $rootScope.getActivitycarddata();
                                $rootScope.saveProfile1 = ''
                                $rootScope.doctorCoverImage1 = ''
                                $rootScope.link = ''
                            }else{
                                toastr.error(response.message)
                                bootbox.hideAll();
                                $rootScope.getActivitycarddata();
                                $rootScope.saveProfile1 = ''
                                $rootScope.doctorCoverImage1 = ''
                                $rootScope.link = ''
                            }
                        }, function (err) {
                            toastr.error(err);
                        });
                    }else{
                        toastr.error('The web address that you entered seems to be incorrect')
                    }
                }else{
                    toastr.error('Please Fill All Fields')
                } 
            }

            else if($rootScope.app == true){
                if($rootScope.saveProfile1 != undefined){
                    if($rootScope.selectedOptionactivity.length==0){
                        toastr.error('Add Eshop Product')
                    }else{
                        var payload = {
                            "account_email": authService.authentication.account_id,
                            "card_type":"Eshop",
                            "sno": parseInt($rootScope.selected.sno),
                            "external_url": $rootScope.selectedOptionactivity, 
                            "card_image": authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1 
                        }    

                        milestoneService.activitycreate(payload).then(function (response) {
                            console.log(response);
                            if(response.success == 1){
                                toastr.success(response.message)
                                // $location.path('/health')
                                bootbox.hideAll();
                                $rootScope.getActivitycarddata();
                                $rootScope.saveProfile1 = ''
                                $rootScope.doctorCoverImage1 = ''
                                $rootScope.selectedOptionactivity = [];
                            }else{
                                toastr.error(response.message)
                                bootbox.hideAll();
                                $rootScope.getActivitycarddata();
                                $rootScope.saveProfile1 = ''
                                $rootScope.doctorCoverImage1 = ''
                            }
                        }, function (err) {
                            toastr.error(err);
                        });
                    }
                }else{
                    toastr.error('Please Fill All Fields')
                } 
            }

        }
    }

    $scope.editActivitycard = function(data){
        console.log(data);

        var updateData = data;
        $rootScope.updateDataactivitycard = data

        if(updateData.card_type=="eshop"||updateData.card_type=="Eshop"){
            $rootScope.getType('app')
            $rootScope.selected_type = 'app' 
            $rootScope.doctorCoverImage1 = updateData.card_image;
            // var valu = JSON.parse(data.external_url);
            // console.log(valu,'V');
            $rootScope.extractedEshopid = $scope.extractValues(data.external_url);
            // console.log($rootScope.extractedEshopid,'E');
            if($rootScope.extractedEshopid.length==1){
                $rootScope.eshopLinked.activitycardValue = $rootScope.extractedEshopid[0]
                $rootScope.searchEshopIdactivity();
            }else{
                for(var i=0;i<$rootScope.extractedEshopid.length;i++){
                    $rootScope.eshopLinked.activitycardValue = $rootScope.extractedEshopid[i]
                    $rootScope.searchEshopIdactivity();
                }
            }
        }else if(updateData.card_type=="image"||updateData.card_type=="Image"){
            $rootScope.getType('image')
            $rootScope.selected_type = 'image' 
            $rootScope.doctorCoverImage1 = updateData.card_image
            $rootScope.doctorCoverImage = updateData.external_url
        }else if(updateData.card_type=="video"||updateData.card_type=="Video"){
            $rootScope.getType('video')
            $rootScope.selected_type = 'video' 
            $rootScope.doctorCoverImage1 = updateData.card_image
            $rootScope.getIframeSrc = updateData.external_url
            // $rootScope.video_guide = updateData.external_url
        }else if(updateData.card_type=="links"||updateData.card_type=="Links"||updateData.card_type=="Link"){
            $rootScope.getType('links')
            $rootScope.selected_type = 'links' 
            $rootScope.doctorCoverImage1 = updateData.card_image
            $rootScope.link = updateData.external_url
        }

        var options = {
            title: '<b>Update Activity Card</b>',
            message:'',
            templateUrl: 'views/milestone/updateactivitycard.htm',
            size:'medium', 
            onEscape: function() {
            },
        };

        $ngBootbox.customDialog(options);

    }

    $rootScope.updateBanner = function(){

        // console.log($rootScope.saveProfile,'img');
        // console.log($rootScope.saveProfile1,'img');
        // console.log($rootScope.video_guide,'video');
        // console.log($rootScope.contentType,'type'); 
        // console.log($rootScope.Otype,'otype');
        // console.log($rootScope.link,'link');
        // console.log($rootScope.image);
        // console.log($rootScope.video);
        // console.log($rootScope.Linked);
        // console.log($rootScope.app);
        // console.log($rootScope.selectedOptionactivity,'1752');
        // console.log($rootScope.updateDataactivitycard,'update');
        

        if($rootScope.image == true){
            if($rootScope.saveProfile1 == '' || $rootScope.saveProfile1 == undefined){
                var UR = $rootScope.doctorCoverImage1
                // console.log('1f:',UR);
            }else{
                var UR = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
                // console.log('1f::',UR);
            }

            if($rootScope.saveProfile == '' || $rootScope.saveProfile == undefined){
                var EL = $rootScope.doctorCoverImage
                // console.log('1fe:',EL);
            }else{
                var EL = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile
                // console.log('1fe::',EL);
            }

            if((UR != '' && UR != null) && (EL != '' && EL != null)){
                var payload = {
                    "account_email": authService.authentication.account_id,
                    "card_type":"Image",
                    "activity_id": $rootScope.updateDataactivitycard.activity_id,
                    "external_url": EL, 
                    "card_image": UR 
                }  

                milestoneService.activitycardUpdate(payload).then(function (response) {
                    console.log(response);
                    if(response.success == 1){
                        toastr.success(response.message)
                        bootbox.hideAll();
                        $rootScope.saveProfile1 = ''
                        $rootScope.doctorCoverImage1 = ''
                        $rootScope.doctorCoverImage = ''
                        $rootScope.getActivitycarddata();
                    }else{
                        toastr.error(response.message)
                        bootbox.hideAll();
                        $rootScope.saveProfile1 = ''
                        $rootScope.doctorCoverImage1 = ''
                        $rootScope.doctorCoverImage = ''
                        $rootScope.getActivitycarddata();
                    }
                }, function (err) {
                    toastr.error(err);
                });
            }else{
                toastr.error('Please Fill All Fields')
            }
        }

        else if($rootScope.video == true){
            if($rootScope.saveProfile1 == '' || $rootScope.saveProfile1 == undefined){
                var UR = $rootScope.doctorCoverImage1
                // console.log('2f:',UR);
            }else{
                var UR = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
                // console.log('2f::',UR);
            }

            if($rootScope.video_guide == '' || $rootScope.video_guide == undefined){
                var EL = $rootScope.notUpdatedVideo
                // console.log('2fe:',EL);
            }else{
                var EL = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.video_guide
                // console.log('2fe::',EL);
            }
            if(($rootScope.saveProfile1 != undefined || UR != '') && ($rootScope.video_guide != undefined || EL != '')){
                var payload = {
                    "account_email": authService.authentication.account_id,
                    "card_type":"Video",
                    "activity_id": $rootScope.updateDataactivitycard.activity_id,
                    "external_url": EL, 
                    "card_image": UR
                }

                milestoneService.activitycardUpdate(payload).then(function (response) {
                    console.log(response);
                    if(response.success == 1){
                        toastr.success(response.message)
                        // $location.path('/health')
                        bootbox.hideAll();
                        $rootScope.getActivitycarddata();
                        $rootScope.saveProfile1 = ''
                        $rootScope.doctorCoverImage1 = ''
                        $rootScope.getIframeSrc = ''
                    }else{
                        toastr.error(response.message)
                        bootbox.hideAll();
                        $rootScope.getActivitycarddata();
                        $rootScope.saveProfile1 = ''
                        $rootScope.doctorCoverImage1 = ''
                        $rootScope.getIframeSrc = ''
                    }
                }, function (err) {
                    toastr.error(err);
                });
            }else{
                toastr.error('Please Fill All Fields')
            } 
        }

        else if($rootScope.Linked == true){
            if($rootScope.saveProfile1 == '' || $rootScope.saveProfile1 == undefined){
                var UR = $rootScope.doctorCoverImage1
                // console.log('3f:',UR);
            }else{
                var UR = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
                // console.log('3f::',UR);
            }
            if(($rootScope.saveProfile1 != undefined || UR != '') && $rootScope.link != ''){
                if($rootScope.link.startsWith("http:") || $rootScope.link.startsWith("https:")){
                    var payload = {
                        "account_email": authService.authentication.account_id,
                        "card_type":"Link",
                        "activity_id": $rootScope.updateDataactivitycard.activity_id,
                        "external_url": $rootScope.link, 
                        "card_image": UR
                    }
                    

                    milestoneService.activitycardUpdate(payload).then(function (response) {
                        console.log(response);
                        if(response.success == 1){
                            toastr.success(response.message)
                            // $location.path('/health')
                            bootbox.hideAll();
                            $rootScope.getActivitycarddata();
                            $rootScope.saveProfile1 = ''
                            $rootScope.doctorCoverImage1 = ''
                            $rootScope.link = ''
                        }else{
                            toastr.error(response.message)
                            bootbox.hideAll();
                            $rootScope.getActivitycarddata();
                            $rootScope.saveProfile1 = ''
                            $rootScope.doctorCoverImage1 = ''
                            $rootScope.link = ''
                        }
                    }, function (err) {
                        toastr.error(err);
                    });
                }else{
                    toastr.error('The web address that you entered seems to be incorrect')
                }
            }else{
                toastr.error('Please Fill All Fields')
            } 
        }

        else if($rootScope.app == true){
            if($rootScope.saveProfile1 == '' || $rootScope.saveProfile1 == undefined){
                var UR = $rootScope.doctorCoverImage1
                // console.log('3f:',UR);
            }else{
                var UR = authService.helyxonApi.url+"cloud/image/upload/"+$rootScope.saveProfile1
                // console.log('3f::',UR);
            }

            // console.log($rootScope.extractedEshopid,'2308');
            // console.log($rootScope.selectedOptionactivity,'2309');
            // if($rootScope.extractedEshopid!=$rootScope.selectedOptionactivity){
            //     var ES = $rootScope.selectedOptionactivity.push($rootScope.extractedEshopid);
            //     console.log(ES,'1');
            //     console.log($rootScope.selectedOptionactivity);
            // }else{
            //     var ES = $rootScope.extractedEshopid
            //     console.log(ES,'2');
            // }

            if(($rootScope.saveProfile1 != undefined || UR != '') && $rootScope.selectedOptionactivity.length != ''){
                if($rootScope.selectedOptionactivity.length==0){
                    toastr.error('Add Eshop Product')
                }else{
                    var payload = {
                        "account_email": authService.authentication.account_id,
                        "card_type":"Eshop",
                        "activity_id": $rootScope.updateDataactivitycard.activity_id,
                        "external_url": $rootScope.selectedOptionactivity, 
                        "card_image": UR 
                    }    

                    milestoneService.activitycardUpdate(payload).then(function (response) {
                        console.log(response);
                        if(response.success == 1){
                            toastr.success(response.message)
                            // $location.path('/health')
                            bootbox.hideAll();
                            $rootScope.getActivitycarddata();
                            $rootScope.saveProfile1 = ''
                            $rootScope.doctorCoverImage1 = ''
                            $rootScope.selectedOptionactivity = [];
                            $rootScope.selectedItems = [];
                        }else{
                            toastr.error(response.message)
                            bootbox.hideAll();
                            $rootScope.getActivitycarddata();
                            $rootScope.saveProfile1 = ''
                            $rootScope.doctorCoverImage1 = ''
                            $rootScope.selectedOptionactivity = [];
                            $rootScope.selectedItems = [];
                        }
                    }, function (err) {
                        toastr.error(err);
                    });
                }
            }else{
                toastr.error('Please Fill All Fields')
            } 
        }
    }

    $scope.extractValues = function(input) {

        return input
          .replace(/[\[\]']/g, "") // Remove brackets and single quotes
          .split(",")              // Split by comma
          .map(function (value) {
            return value.trim();   // Trim spaces
          });
    }

    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'milestoneController',
            'event_label' : aLabel
        });
    }
}]);

'use strict';
angular.module('AngularApp').controller('milestonereportController', ['$scope','$rootScope', '$location','$filter', 'authService','milestoneService','$ngBootbox','toastr','multipartFormdata','$sce',
    function ($scope, $rootScope, $location,$filter , authService, milestoneService, $ngBootbox,toastr,multipartFormdata,$sce) {

        $scope.ExportType = "EXCEL";
        $scope.gender = '';
        $scope.selected_gender = 'both';
        $scope.selected_answer = '0';
        $scope.Date1 = new Date();
        $scope.Date2 = new Date();
        $scope.tru = false;

        function stringDate(date){
          var day   = date.getDate();
          var month = date.getMonth()+1;
          var year  = date.getFullYear();
            
         return "" + day + "/" + month + "/" + year;
        }
    
        function parseDate(str) {
          var mdy = str.split('/');
    
         return new Date( mdy[2], mdy[1], mdy[0] );
        }
          
        function datediff(first, second) {
         return Math.round((second-first)/(1000*60*60*24));
        }
      
        $scope.fromoptions = {
            maxDate: new Date()
        }
    
    
        $scope.milestoneDate = function(){
            // var date1 = new Date();
            // var date2 = value1;
            // var days  = datediff(parseDate(stringDate(date2)), parseDate(stringDate(date1)));
            $scope.value1 = $filter('date')(new Date($scope.Date1),'yyyy-MM-dd');
            $scope.value2 = $filter('date')(new Date($scope.Date2),'yyyy-MM-dd')
            $scope.gender = $scope.selected_gender
            $scope.answerOption = $scope.selected_answer
    
            console.log("vlaue1", $scope.value1)
    
            $scope.fromoptions = {
                maxDate: $scope.value2
                // maxDate: new Date()
            }
    
            $scope.tooptions = {
                minDate: $scope.value1,
                // maxDate:new Date()
            }
    
            // console.log("val1",$scope.value1,$scope.value2);
            // console.log($scope.gender,'gender');
            // console.log($scope.answerOption,'answer');
            
            // if($scope.gender!=''){
            //     $scope.milestoneRep($scope.value1,$scope.value2); 	   
            // }else if($scope.gender==''){
            //     toastr.error('Please Select Gender')
            //     $scope.milestoneData = []
            // }else if($scope.answerOption){
            //     $scope.milestoneRep($scope.value1,$scope.value2);
            // }
        }

        $scope.getMilestoneData = function(){
            if($scope.gender!=''){
                $scope.milestoneRep($scope.value1,$scope.value2); 	   
            }else if($scope.gender==''){
                toastr.error('Please Select Gender')
                $scope.milestoneData = []
            }else if($scope.answerOption){
                $scope.milestoneRep($scope.value1,$scope.value2);
            }
        }
    
      
        $scope.milestoneRep = function(val1, val2){
            console.log("val 102",val1,val2)
            var payload = {
                "account_email" : authService.authentication.account_id,
                "from_day": val1,
                "to_day" : val2,
                "gender": $scope.gender,
                "is_answered": $scope.answerOption
            } 
            
            milestoneService.milestoneDaterange(payload).then(function(response){
                console.log(response,'res');
                $scope.milestoneData = response[0].row_to_json;
            });	
        }

        $scope.milestoneDate();
        // $scope.getMilestoneData();
    
        $scope.printPaymentToPaper = function(id) {
            $scope.tru = true;
            if($scope.milestoneData.users==null){
                toastr.error('No Data Found')
            }
            else {
                var innerContents = document.getElementById('printtable').innerHTML;
                var popupWinindow = window.open('', '_blank',
                'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                popupWinindow.document.open();
                popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
                popupWinindow.document.close();
            }
            $scope.tru = false;
        };
        
        $scope.exportData = function (type) {
            $scope.tru = true;
            console.log($scope.milestone);
            if($scope.milestoneData.users==null){
                toastr.error('No Data Found')
            }
            else {		  
                $scope.date = new Date();
                $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
                var filename='Milestone_Engagement_';
                if(authService.authentication.account_info.Account.fullName) {
                filename = filename+''+authService.authentication.account_info.Account.fullName+"_"+$scope.formattedDate;
                } else {
                filename = filename+''+$scope.formattedDate;
                } 
                if(type == 'CSV') {
                    alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#exportable',{headers:true})");
                } else if(type == 'EXCEL') {
                // alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                    // var blob = new Blob([document.getElementById('printtable').innerHTML], {
                    //     type: "application/vnd.ms-excel;charset=utf-8"
                    // })
                    // saveAs(blob, filename+".xls");
                    var blob = new Blob([document.getElementById('printtable').innerHTML], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    });
                saveAs(blob, filename+".xls");
                $scope.tru = false;
                } else if(type == 'PDF') {
                        html2canvas(document.getElementById('exportable'), {
                            onrendered: function (canvas) {
                                var data = canvas.toDataURL();
                                var docDefinition = {
                                    content: [{
                                        image: data,
                                        width: 500,
                                    }]
                                };
                                pdfMake .createPdf(docDefinition).download("" + filename + ".pdf");
                            }
                        });
                }
            }
        };
}]);

'use strict';
angular.module('AngularApp').controller('multicenterStudyController', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'multicenterStudyService', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, multicenterStudyService) {

    $scope.imageUploadUrl = authService.helyxonApi.url + 'cloud/image/upload/'; 



   //  Update particular location
   $scope.update_multicenterstudy = function(data) {
    // $rootScope.actionKind = 'edit';
    // $rootScope.locationData = data;
    console.log(data,'data');
    $rootScope.multidata = data;
    var options = {
        title: '',
        message:'',
        templateUrl: 'views/settings/multicenterupdate.htm',
        size:'medium', 
        onEscape: function() {$scope.$apply();},
        buttons: {
            ok:{
                label: " Save",
                className: "btn-primary fa fa-save",
                callback: function() {
                    var data = {
                              "s_no": $rootScope.multidata.s_no, 
                              "mobile_no": $rootScope.multidata.mobile_no, 
                              "effective_from": $rootScope.multidata.effective_from, 
                              "doctor_name": $rootScope.multidata.Dr_name, 
                              "account_email": authService.authentication.account_id, 
                              "doctor_id": authService.authentication.doctor_id, 
                              "deactivate_on": $rootScope.multidata.deactivate_on,
                              "type":"discharge"
                            };

                    multicenterStudyService.update_multicenter(data).then(function(response) {
                        toastr.success('Updated Successfully');
                    },function(error) {
                        toastr.error(error);
                    })
                }

            },
            close:{
                label: " Close",
                className: "btn-danger fa fa-times-circle",
                callback: function() {}
            }
        }
    };

    $ngBootbox.customDialog(options);
};

$scope.array1 = [];
$scope.array2 = [];

$scope.select_Queue = function(type){
   
    if(type == 2){
        multicenterStudyService.AllDoctorIncharge(type).then(function (response) {
            console.log('activateDoctorIncharge res',response);
            angular.forEach(response.doctor_incharge , function(value){
                console.log('foreach',value);
                if(value.is_active == true){
                    $scope.array1.push(value)
                }else{
                    $scope.array2.push(value)
                }
            })
            $scope.multicentervalues = '';
            $scope.multicentervalues = $scope.array1.concat($scope.array2);
            console.log('  $scope.multicentervalues',  $scope.multicentervalues);
       }, function (err) {
           toastr.error(err);
       });
    }else if(type == 1){
        multicenterStudyService.activateDoctorIncharge(type).then(function (response) {
            console.log('activateDoctorIncharge res',response.doctor_incharge);
            $scope.multicentervalues = '';
            $scope.multicentervalues = response.active_doctor_incharge;
       }, function (err) {
           toastr.error(err);
       });
    }else if(type == 0){
        multicenterStudyService.deactivateDoctorIncharge(type).then(function (response) {
             console.log('deactivateDoctorIncharge res',response);
             $scope.multicentervalues = '';
             $scope.multicentervalues = response.deactive_doctor_incharge;
        }, function (err) {
            toastr.error(err);
        });
    }
}


$scope.choose_Queue = 1;
$scope.select_Queue(1); 

$scope.docincharge_date =''
$scope.effective_from = function(d1){
    console.log('date',d1 );
    var d4 = moment(d1).format('YYYY-MM-DDThh:mm:ssZ');
    console.log('d4',d4);
    $scope.multicenter.effective_from = d4;
    $scope.docincharge_date  = d4;
}

  $scope.doc_name = false;

  $scope.multicenter = {
        "mobile_no":"", 
        "effective_from":"", 
        "doctor_name":"", 
        "account_email": authService.authentication.account_id, 
        "doctor_id": authService.authentication.doctor_id,
        "type":"discharge"
  }

  $scope.save_multicenterStudy = function(multicenter){

    multicenterStudyService.DoctorIncharge(multicenter).then(function (response) {
        console.log('DoctorIncharge',response);
        if(response.message == 'doctor name already exists'){
           $scope.doc_name = true;
           $scope.date_drincharge = '';
        }else{
            $scope.doc_name = false;
            $scope.select_Queue(1);
            $scope.choose_Queue = 1;
        }
   }, function (err) {
       toastr.error(err);
   });
  }

  $scope.Cancel_multicenter = function(){
    $scope.doc_name = false;
    $scope.multicenter = {
        "mobile_no":"", 
        "effective_from":"", 
        "doctor_name":"",
        "account_email": authService.authentication.account_id, 
        "doctor_id": authService.authentication.doctor_id ,
        "type":"discharge"
  }
     $scope.date_drincharge = '';
  }


//   $scope.delete_multicenter =function(data){
      
//       if(data.is_active == true){
//           $scope.status = 1;
//       }else{
//         $scope.status = 0;
//       }
//       $scope.Data = {
//         "id":data.id, 
//         "status": $scope.status, 
//         "deactivate_on": new Date().toISOString(),
//         "account_email":authService.authentication.account_id
//       }
//     multicenterStudyService.DeleteIncharge($scope.Data).then(function (response) {
//         console.log('Delete',response);
//         if(response.message == 'successfully deactivated doctor inacharge'){
//             // $scope.select_Queue();
//         }
    
//    }, function (err) {
//        toastr.error(err);
//    });
//   }
$scope.delete_multicenter =function(data){
    if(data.is_active == false){

    $rootScope.doctor_name = data;
    var options = {
        title: '',
        message:'',
        templateUrl: 'views/settings/multicenterdelete.htm',
        size:'medium', 
        onEscape: function() {$scope.$apply();},
        buttons: {
            ok:{
                label: " yes",
                className: "btn-primary fa fa-save",
                callback: function(data) {
                    $scope.Data = {
                        "s_no": $rootScope.doctor_name.s_no, 
                        "status": 0, 
                        "deactivate_on": new Date().toISOString(),
                        "account_email":authService.authentication.account_id,
                        "type":"discharge"
                    }

                    multicenterStudyService.DeleteIncharge($scope.Data).then(function(response) {
                        console.log('Delete',response);
                        if(response.message == 'successfully deactivated doctor inacharge'){
                            $scope.choose_Queue = 1;
                            $scope.select_Queue(1);  
                        }
                    },function(error) {
                        toastr.error(error);
                    })
                }

            },
            close:{
                label: " No",
                className: "btn-danger fa fa-times-circle",
                callback: function() {
                    $scope.choose_Queue = 1;
                    $scope.select_Queue(1); 
                }
            }
        }
    };

    $ngBootbox.customDialog(options);
    }
}

  $scope.now = new Date()
  $scope.datepicker1 = {
    opened:{appointment_date1:false, appointment_date2:false},
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
        formatYear: 'yyyy',
        startingDay:0,
        minDate: new Date(),
        maxDate: new Date($scope.now.setDate($scope.now.getDate() + 30)),
    }
};

}]);


'use strict';

angular.module('AngularApp').controller('multicenterstudyreportsController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr) { 

    $scope.gotoReports = function(data) {
        switch (data) {
            case '1':
                // Appointment settings
                $location.path('/baby-registration');
                break;
            case '2':
                // Drug settings
                $location.path('/babiesvs-communityvisit');
                break;
            case '3':
                // LifeLog settings
                $location.path('/deadvs-timeafterdelivery');
                break;
            case '4':
                // LabTest settings
                $location.path('/babygrowth-everystagecommunity');
                break;
            case '5':
                // Advice settings
                $location.path('/babystatusicds');
                break;
            case '6':
                // Payment settings
                $location.path('/babymalnutritionicds');
                break;
            case '7':
                // Payment settings
                $location.path('/notinterestedbabyicds');
                break;
            case '8':
                // Payment settings
                $location.path('/supervisorreport');    
            default:

        }
    };


}]);
'use strict';
angular.module('AngularApp').controller('othersettingController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr', 'othersettingService',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr,othersettingService) {

    $scope.showedit = true
    $scope.disableinput = true;

    $scope.enableinput = function(data) {
        if(data == "Edit"){
            $scope.showedit = !$scope.showedit;
            $scope.disableinput = false;
        }else if(data == "Cancel"){
            // $scope.getPaymentConfiguration();
            // $scope.getWalletStatus();
            $scope.getwaiverdetails()
            $scope.showedit = true
            $scope.disableinput = true;
        }
    };

    $scope.getwaiverdetails = function(){
        othersettingService.getwaiversettings().then(function(response){
            if(response.success == 1){
                $scope.waiverdetails = response.data[0]
            } else {
                toastr.error('Unable to get details')
            }
        })
    }
    $scope.getwaiverdetails()

    $scope.updatesettings = function(){
        $scope.showedit = true
        $scope.disableinput = true;
        var data = {
        "account_email":authService.authentication.account_id,
        "doctor_id":authService.authentication.doctor_id,
        "waived_inperson_days": $scope.waiverdetails.waived_inperson_days,
        "waived_inperson_follow_ups": $scope.waiverdetails.waived_inperson_follow_ups,
        "waived_teleconsultation_days": $scope.waiverdetails.waived_teleconsultation_days,
        "waived_video_calls":$scope.waiverdetails.waived_video_calls
        }
        othersettingService.savewaiversettings(data).then(function(response){
            if(response.success == 1){
                toastr.success("Settings saved successfully")
                $scope.getwaiverdetails()
            } else {
                toastr.error('Unable to save')
            }
        })
    }

}]);

/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('patientRegistrationController', ['$scope', '$rootScope', '$filter', 'authService', 'patientlistService', 'dischargeService', 'toastr',
function($scope, $rootScope, $filter, authService, patientlistService, dischargeService, toastr) {

    $scope.reportNameShow = "true";
    $scope.homeVisitReportName = "";
    $scope.labelHide = true;

    var homeVisitUrlArr = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi).split('/');
    var homeVisitUrl = homeVisitUrlArr[homeVisitUrlArr.length-1];

    $rootScope.hv1Show = "false";
    $rootScope.hv2Show = "false";
    $scope.selected_param = "0";

    $scope.errMsg = "";
    $scope.errMsgShow = true;
    $scope.showContainer = false;

    $scope.completeBtnDisable = true;
    $scope.timeInputDisable = true;

    $scope.changeParam = function(value) {
        $scope.selected_param = value;
    }
    
    $scope.exportType = "";
    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        }
    };

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    $scope.exportData = function(type) {

        if($scope.patientRegistrationData) {
   
            $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
            var filename = "Patient_Registration_Report_"+$scope.formattedDate;
            
            if($scope.selectedFromDate && $scope.selectedToDate){
                filename = "Patient_Registration_Report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
            }
            
           /* if(type=='csv') {

                alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
                
            } else*/
            if(type == 'excel') {

                //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                    var blob = new Blob([document.getElementById('printtable2').innerHTML], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    });
                 saveAs(blob, filename+".xls");

            } else if(type=='pdf') {

                var pdf_element = document.getElementById('printtable');
                var opt = {
                    margin:      0,
                    filename:   filename,
                    image:       { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
                };
                    
                //New Promise-based usage:
                html2pdf().set(opt).from(pdf_element).save();
                    
            }
        }
    }

    $scope.showPieChart = function(data) {
    
            $('#pie_container1').highcharts({
            //Highcharts.chart('container', {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    borderColor: "black",
                    borderRadius:0,
                    borderWidth:"0"
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: 'Patient Registration', 
                    style: {
                      fontSize: '22px' 
                    }
                   
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '{point.percentage:.1f} %'
                        },
                        showInLegend: true
                    }
                },
                series: [{
                //name: 'Brands',
                    colorByPoint: true,
                    data: data
                }]
            });
        
            $( "#piechat_container" ).show();
    }

    function homevisitPieChartData(data) {
            
        var tempArray = [
            {
            name: 'Male',
            y: data.male,
            /*sliced: true,
            selected: true*/
            color: 'lightblue'
            },
            {
            name: 'Female',
            y: data.female, 
            color: 'pink'
            }
        ];
            
        $scope.showPieChart(tempArray);    
    }


    $scope.callPatientRegistrationApi = function(payload, callback) {
    
        patientlistService.getPatientRegistrationList(payload).then(function (response) {
            callback(response);
        }, function (err) {
        //toastr.error(err);         
        });
    }  

    $( "#piechat_container" ).hide();
    $scope.callPatientsReportsApi = function() {  
        
        var requestPayload = {
            account_email: authService.authentication.account_id,
            from_date: $scope.selectedFromDate2,
            to_date: $scope.selectedToDate2,
            district_id: $scope.district_id, 
            block_id: $scope.block_id,
            staff_id: $scope.staff_id,
            village_id: $scope.village_id
        }; 

        $scope.callPatientRegistrationApi(requestPayload, function returnCompliance(data) { 
            
            if(data.patients_count) {
                
                $scope.patientRegistrationData = [];
                $scope.patientTotal = [];

                $scope.patientRegistrationData = data.patients_count;
                $scope.patientTotal = data.grandtotal;
                    
                homevisitPieChartData(data.grandtotal); 
                $scope.labelHide = false;
                $scope.errMsg = "";

              /*$scope.errMsgShow = false;
                $scope.showContainer = true;
                $scope.completeBtnDisable = false;*/
          
            } else {
                $scope.patientRegistrationData = [];
                $scope.patientTotal = [];
                $scope.labelHide = true;

                $scope.errMsg = data.message;
                $( "#piechat_container" ).hide();
            }
            
        /* else {
              document.getElementById("barchart1").innerHTML = "";
              $scope.errMsg = data.msg;
              $scope.errMsgShow = true;
              $scope.showContainer = false;
              $scope.completeBtnDisable = true;
          } */
        });
    }
    
    $scope.initHomeVisit = function() {
    
        $scope.hidetable2 = 'true';
        $scope.hidetable1 = 'true';
        $scope.exportType = "";
        $scope.selected_day = "1";
        $scope.fromDate = new Date();
        $scope.toDate = new Date();
        $scope.today_dt = new Date();
        
        var datArr  = getStringDate($scope.fromDate);
        var datArr2 = getStringDate($scope.toDate)
        $scope.selectedFromDate  = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.selectedToDate  = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
    }

    $scope.getDistricts = function() {

        $scope.hidetable2 = 'true';
        $scope.hidetable1 = 'true';
        $scope.completeBtnDisable = true;
        
        $scope.district_id = "0";  
        $scope.block_id    = "0";
        $scope.staff_id    = "0";
        $scope.village_id  = "0";

        $scope.selected_district = "";
        $scope.selected_block    = "";
        $scope.selected_vhn      = "";
        $scope.selected_village  = "";

        $scope.selected_district_name = "All";
        $scope.selected_block_name    = "All";
        $scope.selected_vhn_name      = "All";
        $scope.selected_village_name  = "All";
        
        $scope.districts_list = [];
        $scope.blocks_list    = [];
        $scope.vhn_list       = [];
        $scope.villages_list  = [];
        
        var param = {
        account_email: authService.authentication.account_id
        };
        
        dischargeService.getDistrictList(param).then(function (response) {
            $scope.districts_list = response;   
            if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){        
                $scope.selected_district_name = response[0].districtname;
                $scope.selected_district = response[0].id;    
                $scope.getBlocks(response[0].id);
            }
        }, function (error) {
            //toastr.error(error);
        });
    }

    $scope.getBlocks = function(id) {
        $scope.completeBtnDisable = true;

        if(id==null) {
        $scope.district_id = "0"; 
        } else {
        $scope.district_id = id+"";  
        } 

        $scope.hidetable2 = 'true';
        $scope.block_id   = "0";
        $scope.staff_id   = "0";
        $scope.village_id = "0";

        $scope.selected_block   = "";
        $scope.selected_vhn     = "";
        $scope.selected_village = "";

        $scope.selected_block_name   = "All";
        $scope.selected_vhn_name     = "All";
        $scope.selected_village_name = "All";
        
        $scope.blocks_list   = [];
        $scope.vhn_list      = [];
        $scope.villages_list = [];

        var param = { 
        account_email: authService.authentication.account_id,
        id: $scope.district_id 
        }     
        
        dischargeService.getBlockList(param).then(function (response) {
        $scope.blocks_list = response; 
        if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org"  || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){
            $scope.selected_block = response[0].id; 
            $scope.selected_block_name = response[0].blockname;
          //$scope.getVillages(response[0].id); 
            $scope.getVhn(response[0].id);
        }
        }, function (error) {
           //toastr.error(error);
        });
    }

    $scope.getVhn = function(block_id) { 

        $scope.completeBtnDisable = true;
        
        if(block_id==null) {
            $scope.block_id = "0"
            $scope.selected_block_name = "All"; 
        } else {
            $scope.block_id = block_id+""; 
            var tempArr = ($filter('filter')($scope.blocks_list, {'id':block_id})); 
            $scope.selected_block_name = tempArr[0].blockname; 
        }  

        $scope.vhn_id                = "0";
        $scope.village_id            = "0";
        $scope.selected_vhn          = "";
        $scope.selected_village      = "";
        $scope.selected_vhn_name     = "All";
        $scope.selected_village_name = "All";
        $scope.vhn_list              = [];
        $scope.villages_list         = [];
      //$scope.homevisitData();    
        
        var param = {	
            account_email: authService.authentication.account_id,
            id: $scope.block_id
        }
        
        dischargeService.getVhnList(param).then(function (response) {
        $scope.vhn_list = response;
        },function (error) {
        //toastr.error(error);
        });      
    } 
   
    $scope.getVillages = function(staff_id) {  

        $scope.completeBtnDisable = true;
        $scope.hidetable2 = 'true';

        if(staff_id==null) {
            $scope.staff_id          = "0";    
            $scope.selected_vhn_name = "All"; 
        } else {
            $scope.staff_id          = staff_id+""; 
            var tempArr              = ($filter('filter')($scope.vhn_list, {'staffid':staff_id})); 
            $scope.selected_vhn_name = tempArr[0].staffname;
        }
            
        $scope.village_id            = "0"; 
        $scope.selected_village      = "";
        $scope.selected_village_name = "All";
        $scope.villages_list         = [];

        var param = {	
        account_email: authService.authentication.account_id,
        id: $scope.staff_id
        }
        
        dischargeService.getStaffVillageList(param).then(function (response) {
            $scope.villages_list    = response;   
            $scope.selected_village = "";
        },function (error) {
          //toastr.error(error);
        });  
    }

    $scope.initHomeVisit();
    $scope.getDistricts();
 
  /*$scope.getPanchayats = function(id) { 
      $scope.block_id     = id;
      $scope.panchayat_id = "0";
      $scope.village_id   = "0";
    
      $scope.selected_panchayat = "";
      $scope.selected_village   = "";
      $scope.panchayat_list     = [];
      $scope.villages_list      = [];
    //$scope.homevisitData();    
        
      var param = {	
        account_email: authService.authentication.account_id,
        id: id
      }
      
      dischargeService.getPanchayatList(param).then(function (response) {
        $scope.panchayat_list = response;
      }, function (error) {
      //toastr.error(error);
      });      
    }*/

  $scope.changeVillage = function(id) {

    $scope.hidetable1 = 'true';
    if(id==null) {
      $scope.village_id            = "0";
      $scope.selected_village_name = "All";
    } else {
      $scope.village_id            = id+"";
      var tempArr                  = ($filter('filter')($scope.villages_list, {'village_id':id})); 
      $scope.selected_village_name = tempArr[0].villagename;  
      $scope.selected_village      = id;
    }
  }

  $scope.changeDay = function(day) {
 
    if(day=="5") {
      $scope.timeInputDisable = false;
      $scope.fromDate = "";
      $scope.toDate   = "";
      $scope.selectedFromDate = "";
      $scope.selectedToDate = "";
      $scope.selectedFromDate2 = "";
      $scope.selectedToDate2 = "";   
      $scope.hidetable1 = 'true';  
      $scope.hidetable2 = 'true';   

    } else {
      $scope.timeInputDisable = true;
    }
      
    switch (day) {
      case "4":
      //var tempArray = getPreviousDate(1,30);
        var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
        var datArr = getStringDate(new Date(prevMonthFirstDate));
        $scope.selectedFromDate = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.fromDate = new Date(prevMonthFirstDate);
        var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
        var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
        $scope.selectedToDate = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
        $scope.toDate = new Date(prevMonthLastDate); 
      break;
      case "3":
      //var tempArray = getPreviousDate(1,7);
        var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
        var datArr = getStringDate(new Date(startLastWeek));
        $scope.selectedFromDate = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.fromDate = new Date(startLastWeek);
        var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
        var datArr2 = getStringDate(new Date(endLastWeek));
        $scope.selectedToDate = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
        $scope.toDate = new Date(endLastWeek);
      break;
      case "2":
        var tempArray = getPreviousDate(1,1);
        $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
        $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
        $scope.selectedToDate = $scope.selectedFromDate; 
        $scope.selectedToDate2 = $scope.selectedFromDate2;  
        $scope.fromDate = tempArray;
        $scope.toDate   = $scope.fromDate;       
      break;
      case "1": 
        var datArr = getStringDate(new Date());
        $scope.selectedFromDate  = datArr[1];
        $scope.selectedFromDate2 = datArr[0];  
        $scope.selectedToDate  = $scope.selectedFromDate; 
        $scope.selectedToDate2 = $scope.selectedFromDate2;
        $scope.fromDate = new Date();
        $scope.toDate   = $scope.fromDate;
      break;
    }
  }

  $scope.byRange = function(from,to) {

    if(from) {
      $scope.rangePicker2 = {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date(),
          minDate: from
        }
      };
    }
  
    if(to) {
      $scope.rangePicker1 = {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: to
        }
      };    
    };
  
    if(from && to) {
      var datArr = getStringDate(from);
      $scope.selectedFromDate = datArr[1];
      $scope.selectedFromDate2 = datArr[0];
      var datArr2 = getStringDate(to);
      $scope.selectedToDate = datArr2[1];
      $scope.selectedToDate2 = datArr2[0];;
    //$scope.homevisitData();
    }
  }

}]);

'use strict';
angular.module('AngularApp').controller('patientlistController', ['$scope','$rootScope', '$location', 'authService','patientlistService','$ngBootbox', 'localStorageService',
function ($scope, $rootScope, $location, authService, patientlistService, $ngBootbox, localStorageService) {

$rootScope.PatientList=[];

$scope.Patientlists = function(){
};

if($rootScope.doctorRecordId) {
} else {
  $rootScope.$watch('doctorRecordId',function() {
    $scope.Patientlists();
  });
}

$scope.viewPatient = function(id,email,tel,mr){
      sessionStorage.setItem('patientid',id)
      $location.path('/patientview/'+id);
      $rootScope.pay = {cell_number:tel,patient_account_email:email,acc_email:$rootScope.authentication.account_id,record_id:id,mr:mr};
      localStorageService.set('authorizationData', {cell_number:tel,patient_account_email:email,acc_email:$rootScope.authentication.account_id,record_id:id,mr:mr});
}

$scope.viewGrowthData = function(patient){
  $location.path('/init-patient/'+ patient.record_id);
};

$scope.count = 0;
$scope.next = function(){
    var inc = 20;
    $scope.count = $scope.count + inc;
    $scope.getPatientLatest($scope.count);
};

$scope.var1=false;
$scope.previous = function(){
      var dec = 20;
     if($scope.count>0){
        $scope.count = $scope.count - dec;
        $scope.getPatientLatest($scope.count);
      }
};

function toSmallLetters(val) {
  if(val!=null && val!="") {
    var stringVal = val;
    var str = stringVal.toLowerCase();   
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else {
    return val;
  }
}

$scope.getPatientSearch=function(val){
  $scope.count=0;
  $scope.btns=true;
  $scope.view=true;
      if(!val){$scope.getPatientLatest();}
      authService.getPatientSearch(val).then(function(response) {
          var dobMoment  = moment();
          var patientlistData = response.map(function(item) {
              return {
                  age: {
                    years: parseInt(moment(item.bday).diff(dobMoment,'year',true)),
                    months: parseInt(moment(item.bday).diff(dobMoment,'month',true)%12),
                    days: parseInt(moment(item.bday).diff(dobMoment,'day',true)%365)
                  },
                  date: new Date(item.bday),
                  bday: new Date(item.bday),
                  mr_number: item.mr_number,
                  name_given: item.name_given,
                  father_name_given: item.father_name_given,
                  mother_name_given: item.mother_name_given,
                  father_tel_number: item.father_tel_number,
                  email: item.email,
                  gender: item.gender,
                  record_id: item.record_id,
                  village_name: toSmallLetters(item.villagename),
                  panchayat_name: toSmallLetters(item.panchayatname),
                  district_name: toSmallLetters(item.districtname),
                  kce_id: item.kce_id,
                  block_name: toSmallLetters(item.blockname),
                  staffprofile_name: toSmallLetters(item.staffname),
              };
          });

          $rootScope.PatientList = patientlistData;
          $scope.PatientList.loaded = true;
          $scope.view = false;
       },function (err, response) {
          $ngBootbox.alert(err.Message);
          analytics('getPatientSearch',err.Message);
       });
};

$scope.count = 0;
$scope.next = function(){
    var inc = 20;
    $scope.count = $scope.count + inc;
    $scope.getPatientLatest($scope.count)
};

$scope.var1=false;
$scope.previous = function(){
  var dec = 20;
     if($scope.count>0){
        $scope.count = $scope.count - dec;
        $scope.getPatientLatest($scope.count)
      }
     };

$scope.btns=false;
$scope.view=false;
$scope.getPatientLatest=function(val){
      if(!val){val=0;}
      $scope.view=true;
      authService.getPatientSearchStart(val).then(function(response){
         var dobMoment  = moment();
                var patientlistData = response.map(function(item){
                    return {
                       age:{
                            years:parseInt(moment(item.bday).diff(dobMoment,'year',true)),
                            months:parseInt(moment(item.bday).diff(dobMoment,'month',true)%12),
                            days:parseInt(moment(item.bday).diff(dobMoment,'day',true)%365)
                       },
                      date: new Date(item.bday),
                      bday:new Date(item.bday),
                      mr_number:item.mr_number,
                      name_given:item.name_given,
                      father_name_given:item.father_name_given,
                      mother_name_given:item.mother_name_given,
                      father_tel_number:item.father_tel_number,
                      email:item.email,
                      gender:item.gender,
                      record_id:item.record_id,
                      village_name: toSmallLetters(item.villagename),
                      panchayat_name: toSmallLetters(item.panchayatname),
                      district_name: toSmallLetters(item.districtname),
                      kce_id: item.kce_id,
                      block_name: toSmallLetters(item.blockname),
                      staff_name: toSmallLetters(item.staffname),
                  };
               });

                $rootScope.PatientList = patientlistData;
                $scope.PatientList.loaded = true;
                $scope.view=false;

       },function (err, response) {
                   $ngBootbox.alert(err.Message);
                   analytics('getPatientLatest',err.Message);
        });

    };

$scope.getPatientLatest();

$scope.getPatientSearchApt=function(val){
       $scope.count = 0;
       $scope.btns=true;
       $scope.view=true;
       $scope.fullView = false;
      if(!val){$scope.getPatientLatest();}
      authService.getPatientSearchApt(val).then(function(response){
         var dobMoment  = moment();
                var patientlistData = response.map(function(item){
                    return {
                       age:{
                            years:parseInt(moment(item.bday).diff(dobMoment,'year',true)),
                            months:parseInt(moment(item.bday).diff(dobMoment,'month',true)%12),
                            days:parseInt(moment(item.bday).diff(dobMoment,'day',true)%365)
                       },
                      date: new Date(item.bday),
                      bday:new Date(item.bday),
                      mr_number:item.mr_number,
                      name_given:item.name_given,
                      father_name_given:item.father_name_given,
                      mother_name_given:item.mother_name_given,
                      father_tel_number:item.father_tel_number,
                      email:item.email,
                      father_email: item.father_email,
                      gender:item.gender,
                      record_id:item.record_id
                  };
               });
            
                $scope.PatientList2 = patientlistData;
                $scope.PatientList.loaded = true;
                 $scope.view=false;
       },function (err, response) {
                   $ngBootbox.alert(err.Message);
                   analytics('getPatientSearchApt',err.Message);
        });


};

$scope.fullView = false;
$scope.viewBookingPage = function(data){
      $scope.walk= false;
      $scope.fullView = true;
      $scope.fullData = data;

    };

 $scope.tomorrow = new Date();
   var date1=$scope.tomorrow.setDate($scope.tomorrow.getDate() + 1);

$rootScope.datepicker1= {
    opened :{ childInfo:false, fatherInfo:false, motherInfo:false},
    minDate: date1,
    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 1,
      today:false
    }
};

$scope.msg = false;
$rootScope.docBookApt = function(data,type){
    $rootScope.fix={'date':'','type':''}
       var options = {
          title: '<b>Booking</b>',
            templateUrl: 'views/fixapt.htm',
             onEscape:true,
            buttons: {
                 ok: {
                     label: " Save",
                     className: "btn-primary fa fa-save",
                      callback: function() {

                        $scope.msg = true;
                        if($rootScope.fix.date!=""){
                        /*var d = $rootScope.fix.date.toLocaleString()
                        var a = d.split(',')
                        var b = a[0].split('/')
                        if(b[0].length<2) var e = '0'+b[0]
                        var c = b[2]+'-'+e +'-'+b[1]+'T12:00:00Z'*/
                        var fixData = {
                          account_email:$rootScope.authentication.account_id,
                          token:'',
                          appt_datetime:$rootScope.fix.date,
                          patient_account:data.email,
                          appt_type: type
                        };

                        authService.bookApt(fixData).then(function(response){
                          if(response.token!=undefined){
                            var options = {
                      size: 'small',
                        message: '<center><b style="color:#142E3C;">'+response.token+'</b></center>' ,
                        title: '<center>Token No</center>',
                        onEscape:  function() { $scope.regDisable = false;$scope.$apply();},
                        buttons: {
                             success: {
                                 label: "  OK",
                                 className: "btn-primary",
                                 callback: function() {
                                    $scope.regDisable = false;$scope.$apply();
                                     }
                                 }
                             }
                        }
                    $scope.msg = false;
                    $ngBootbox.customDialog(options);
                    // $rootScope.loadBanner();
                  }else{
                    $scope.msg = false;
                    $ngBootbox.alert(response.error);
                    $scope.msg = false;
                  }


      },function(err, response){
     $scope.msg = false;
     $ngBootbox.alert(err.error);
     analytics('docBookApt',err.error);
     $scope.msg = false;

    })
                     }else{
                        $ngBootbox.alert("Please choose a date");
                        analytics('bookApt','please choose a date');

                      }

                      }
                 },
                 cancel:{
                     label: " Cancel",
                     className: "btn-danger fa fa-times",
                    callback: function() {
                                          }
                 }
            }

        }
        $scope.msg = false;
        $ngBootbox.customDialog(options);
};


$rootScope.getVaccination = function(vaccine){
    if(vaccine.administration_status_title=='Skipped')
      return 4;
    if(vaccine.administration_status_title=='Not Administered'){
      if(new Date(vaccine.due_date) < new Date()){
        return 3; /*overdue*/
      }

      return 2; /* upcoming*/
    }
    return 1; /*done*/
   };

$rootScope.action3=['BCG','OPV 0','Hep-B 1','DTwP 1','IPV 1','Hep-B 2','Hib 1','Rotavirus 1','PCV 1','DTwP 2','IPV 2','Hib 2','Rotavirus 2','PCV 2','DTwP 3','IPV 3','Hib 3','Rotavirus 3','PCV 3','OPV 1','Hep-B 3','OPV 2','MMR-1'
  ,'Typhoid','Conjugate Vaccine','Hep-A 1','MMR 2','Varicella 1','PCV booster','DTwP B1/DTaP B1','IPV B1','Hib B1','Hep-A 2','Typhoid booster','DTwP B2/DTaP B2','OPV 3','Varicella 2','Tdap/Td','HPV'];
$scope.patientData= {};
$rootScope.docBookApt1 = function(data){
  $scope.patientData = data;
      authService.getVaccineList(data.record_id).then(function(response){
        $rootScope.vaccapplist = response
    })
  $rootScope.fix={'date':'','vaccine':''}
       var options = {
          title: '<b>Booking</b>',
            templateUrl: 'views/vaccaptlist.htm',
             onEscape:true,

        }

        $ngBootbox.customDialog(options);
      };

      $rootScope.bookvacapt=function(data){
          $scope.patientvacData = data;
          $rootScope.fixvapt={'date':'','type':''}
       var options = {
          title: '<b>Booking</b>',
            templateUrl: 'views/fixvacapt.htm',
             onEscape:true,
            buttons: {
                 ok: {
                     label: " Save",
                     className: "btn-primary fa fa-save",
                      callback: function() {
                        $scope.msg = true;

                        if($rootScope.fixvapt.date!=""){
                        d = $rootScope.fixvapt.date.toLocaleString()
                        var a = d.split(',')
                        var b = a[0].split('/')
                        if(b[0].length<2) var e = '0'+b[0]
                        var c = b[2]+'-'+e +'-'+b[1]+'T12:00:00Z'

                   var updateRequest = {
                          type:"Vaccine",
                          vaccine:$scope.patientvacData.product_name_title,
                          record_id:$scope.patientData.record_id, document_id:$scope.patientvacData.__documentid__,
                          account_email: $rootScope.authentication.account_id,
                          appt_type:"vaccination",
                          patient_account:$scope.patientData.email,
                          appt:c,
                          data: {
                            Models: {
                              Model: {
                                "name": "HelImmunization",
                                "Field": [
                                  {name:"batch_id", text:""},
                                  {name:"given_date", text:""},
                                  {name:"due_date", text:$scope.patientvacData.due_date},
                                  {name:"appointment_date",text: c},
                                  {name:"product_name_title", text:$scope.patientvacData.product_name_title},
                                  {name:"administration_status_title", text:$scope.patientvacData.administration_status_title},
                                ]
                              }
                            }
                          }
                        };

                        authService.bookdocApt(updateRequest).then(function(response){
                          $scope.msg = false;
                          if(response.token!=undefined){var options = {
                      size: 'small',
                        message: '<center><b style="color:#142E3C;">'+response.token+'</b></center>' ,
                        title: '<center>Token No</center>',
                        onEscape:  function() { $scope.regDisable = false;$scope.$apply();},
                        buttons: {
                             success: {
                                 label: "  OK",
                                 className: "btn-primary",
                                 callback: function() {
                                    $scope.regDisable = false;$scope.$apply();
                                     }
                                 }
                             }
                        }

                    $ngBootbox.customDialog(options);
                    // $rootScope.loadBanner();
                  }else{
                    $ngBootbox.alert(response.error);
                    analytics('bookvacapt',response.error);
                  }



      },function(err, response){
     $ngBootbox.alert(err.error);

    })

                     }else{
                        $ngBootbox.alert("Please choose a date");
                        analytics('bookvacapt','please choose a date');

                      }
                      }
                 },
                 cancel:{
                     label: " Cancel",
                     className: "btn-danger fa fa-times",
                    callback: function() {
                                          }
                 }
            }

        }

        $ngBootbox.customDialog(options);
      };

$scope.walk= false;
$rootScope.bookwalkin=function(data){
        $scope.walk= true;
        $scope.msg = true;
          authService.bkWalkin(data).then(function(response){
            $scope.msg = false;
            if(response.token!=undefined){
               var options = {
                      size: 'small',
                        message: '<center><b style="color:#142E3C;">'+response.token+'</b></center>' ,
                        title: '<center>Token No</center>',
                        onEscape:  function() { $scope.regDisable = false;$scope.$apply();},
                        buttons: {
                             success: {
                                 label: "  OK",
                                 className: "btn-primary",
                                 callback: function() {
                                    $scope.regDisable = false;$scope.$apply();
                                     }
                                 }
                             }
                        }

                    $ngBootbox.customDialog(options);
            } else {
                $ngBootbox.alert(response.error);
                $scope.walk = false;
                analytics('bookwalkin',response.error);
            }

                    // $rootScope.loadBanner();
                    },function(err, response){
     $ngBootbox.alert(err.error);
     analytics('bookwalkin',err.error);

    })
      };

  //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'patientlistController',
            'event_label' : aLabel
        });
     }
}]);


'use strict'
angular.module('AngularApp').controller('patientoverallcontroller', ['$scope', '$rootScope', '$filter', 'authService', 'patientlistService', 'dischargeService', 'toastr', 'careproviderService',
function($scope, $rootScope, $filter, authService, patientlistService, dischargeService, toastr, careproviderService) {

    $scope.exportType = "";
    $scope.errMsg = "";
    $scope.errMsgShow = true;
    $scope.showContainer = false;
    $scope.completeBtnDisable = true;
    $scope.timeInputDisable = true;


    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        }
    };

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }
    
    $scope.byRange = function(from,to) {

    if(from) {
        $scope.rangePicker2 = {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
            minDate: from
        }
        };
    }
    
    if(to) {
        $scope.rangePicker1 = {
        opened : { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: to
        }
        };    
    };
    
    if(from && to) {
        var datArr = getStringDate(from);
        $scope.selectedFromDate = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        var datArr2 = getStringDate(to);
        $scope.selectedToDate = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];;
    //$scope.homevisitData();
    }
    }
    
    $scope.exportData = function(type) {

        if($scope.patientRegistrationData) {
   
            $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
            var filename = "Overall_Patient_Report_"+$scope.formattedDate;
            
            if($scope.selectedFromDate && $scope.selectedToDate){
                filename = "Overall_Patient_Report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
            }
            
           /* if(type=='csv') {

                alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
                
            } else*/
            if(type == 'excel') {

                //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                    var blob = new Blob([document.getElementById('printtable2').innerHTML], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    });
                 saveAs(blob, filename+".xls");

            } else if(type=='pdf') {

                var pdf_element = document.getElementById('printtable');
                var opt = {
                    margin:      0,
                    filename:   filename,
                    image:       { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
                };
                    
                //New Promise-based usage:
                html2pdf().set(opt).from(pdf_element).save();
                    
            }
        }
    }

    $scope.initHomeVisit = function() {
    
        $scope.hidetable2 = 'true';
        $scope.hidetable1 = 'true';
        $scope.exportType = "";
        $scope.selected_day = "1";
        $scope.fromDate = new Date();
        $scope.toDate = new Date();
        $scope.today_dt = new Date();
        
        var datArr  = getStringDate($scope.fromDate);
        var datArr2 = getStringDate($scope.toDate)
        $scope.selectedFromDate  = datArr[1];
        $scope.selectedFromDate2 = datArr[0];
        $scope.selectedToDate  = datArr2[1];
        $scope.selectedToDate2 = datArr2[0];
        $scope.getreportData = []
        $scope.showType = 1
        $scope.labelHide = true;
        $scope.selected_type = "1";
    }

    $scope.initHomeVisit()

    $scope.callPatientsReportsApi = function(){

        var param = {
            account_email: authService.authentication.account_id,
            fromdate: $scope.selectedFromDate2,
            todate: $scope.selectedToDate2,
        }

        careproviderService.getPatientreport(param).then(function(response) {
            if(response.success==1){
                if(response.message.length>0){
                    $scope.getreportData = response.message
                    // $scope.showType = type
                    $scope.labelHide = false;
                    $scope.errMsg = "";
                }
                else{
                    $scope.labelHide = true;
                    $scope.errMsg = 'No Data Found';
                }
            }else{
                $scope.labelHide = true;
                $scope.errMsg = 'No Data Found';
            }
        })
    }

    $scope.callPatientsReports = function(type){
        if(type==1){
            $scope.showType = 1
        }else{
            $scope.showType = 2
        }
        $scope.callPatientsReportsApi()
    }
}]);

'use strict';
angular.module('AngularApp').controller('patientviewController',
['$scope', '$rootScope', '$sce','$compile', '$injector', '$location', '$route', 'recordService', 'milestoneService',
'percentileService', '$ngBootbox', '$uibModal', '$filter', 'localStorageService', '$timeout', 
'PatientService', 'toastr','RxCUtils','$sessionStorage', 'DrugMasterService', 'complaintService',
'paymentService', 'authService', 'patientlistService', 'profileService', 'VacService', 'labtestService', 'adviceService', 'Pubnub', 'chatService', 'multipartFormdata','tabsService','obstgynecService','mainUrl','uibDateParser','commonsettingsService',
function ($scope, $rootScope, $sce, $compile, $injector, $location, $route, recordService, milestoneService, percentileService,
	$ngBootbox, $uibModal, $filter, localStorageService, $timeout, PatientService, toastr, RxCUtils, $sessionStorage,
	DrugMasterService, complaintService, paymentService, authService, patientlistService, profileService, VacService, 
	labtestService, adviceService, Pubnub, chatService, multipartFormdata,tabsService,obstgynecService,mainUrl,uibDateParser,commonsettingsService) {
		$scope.symp_list = [];
		$scope.dates = [];
		$scope.spo2 = [];
		$scope.temp = [];
		$scope.rr = [];
		$scope.days = [];
		$scope.chartspo2 = [];
		$scope.charttemp = [];
		$scope.chartrr = [];
		$scope.entryList = [];
		var vm=this;	
		$rootScope.callprintprespopup = false;
		$rootScope.callreceiptpopup = false;
		$rootScope.printMr_Num = '';
		$rootScope.printCount = 0;
		$scope.riskPrint = false;
		$scope.pregPrint = false;
		$scope.riskPrintStatus = 0;
		$scope.pregPrintStatus = 0;
		$rootScope.getvitalStatus = false;
		$scope.doctorId = authService.authentication.doctor_id;
		//console.log('doctorid** '+$scope.doctorId);
		console.log('getLocalstorage** '+localStorage.getItem("videocall_top"));

		$rootScope.videoScreenShowing = $sessionStorage.get('floatingVideoScreenStatus');

		console.log('videoScreenShowingStstus**'+$rootScope.videoScreenShowing);
		
		if(localStorage.getItem("videocall_top") == null){
			localStorage.setItem("videocall_top", 245);
		    localStorage.setItem("videocall_left", 20);
		}
		
		if(localStorage.getItem("videocall_width") == null){
			localStorage.setItem("videocall_width", 300);
		    localStorage.setItem("videocall_height", 300);
		}

	$rootScope.imageUploadUrl = authService.helyxonApi.url + 'cloud/image/upload/';  
	// window.location.href = '.../home#/home';
	if(!$route.current.params.Id) {
		$location.path("/home");
	  return;
	}
	$scope.togglefloatingics = function () {
        if(sessionStorage.enablefloating == 'true'){
			$scope.showfloating = true
		} else {
			$scope.showfloating = false
		}

		if(sessionStorage.enableics == 'true'){
			$scope.enableicssettings = true
		} else {
			$scope.enableicssettings = false
		}
      }
      $scope.togglefloatingics();

	  
	  $rootScope.todayDate =new Date();
	  $rootScope.gulcometervalue = 'Fasting';
	$rootScope.date = $filter('date')($scope.date, "dd-MMM-yyyy  HH:mm");
	$rootScope.date1 = moment($rootScope.date).format('hh:mm A');
	$rootScope.splithours = $rootScope.date1.split(' ')[1];
	$rootScope.hours = $rootScope.date1.split(' ')[0].split(':')[0];
	$rootScope.min = $rootScope.date1.split(' ')[0].split(':')[1];

	  $rootScope.fromDate = new Date();
      $scope.toDate = new Date();

	  $scope.selectedfromdate = moment($rootScope.fromDate).format("YYYY-MM-DD");
	  $scope.selectedtodate = moment($scope.toDate).format("YYYY-MM-DD");

	  $rootScope.rangePicker1 = {
		opened: { fromDate:false, toDate:false },
		maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
		dateOptions: {
		  formatYear: 'yyyy',
		  startingDay: 0,
		  maxDate: new Date()
		}
	  };
	
	  $scope.rangePicker2 = {
		opened: { fromDate:false, toDate:false },
		maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
		dateOptions: {
		  formatYear: 'yyyy',
		  startingDay: 0,
		  maxDate: new Date(),
		}
	  };
	  
	// $rootScope.printspinner = false;
	// $scope.mangalabarathi = function(){
	// 	$rootScope.printspinner = false;
	// 	recordService.Mangalabarathi($rootScope.overviewId).then(function(response){
	// 		if(response){
	// 			$rootScope.printspinner = true;
	// 			document.getElementById('mangalabarathi').innerHTML = response;
	// 		}
	// 	})
	// }
	// $scope.general_prescription = function(){
	// 	$rootScope.printspinner = false;
	// 	recordService.general_Prescription($rootScope.overviewId).then(function(response){
	// 		if(response){
	// 			$rootScope.printspinner = true;
	// 			document.getElementById('mangalabarathi').innerHTML = response;
	// 		}
	// 	})
	// }



		var authData = localStorageService.get('authorizationData');
        if (authData) {
			$rootScope.authtoken = authData.token;
        }
		
		if(localStorage.getItem("videocall_width") > 20 && localStorage.getItem("videocall_height") > 20){
			$scope.dragdynamicstyle = {
				"position": "fixed",
				"top" : localStorage.getItem("videocall_top")+"px" ,
				"left" : localStorage.getItem("videocall_left")+"px",
				"width" : localStorage.getItem("videocall_width")+"px",
				"height" : localStorage.getItem("videocall_height")+"px",
			}
		}else{
			$scope.dragdynamicstyle = {
				"position": "fixed",
				"top" : 30 +"px" ,
				"left" : 30 +"px",
				"width" : 30 +"px",
				"height" : 30 +"px",
			}
		}
		

		
		
		$scope.getDates = function (startDate, endDate) {
			var dates = [],
				currentDate = startDate,
				addDays = function (days) {
					var date = new Date(this.valueOf());
					date.setDate(date.getDate() + days);
					return date;
				};
			while (currentDate <= endDate) {
				dates.push(moment(currentDate).format('YYYY-MM-DD'));
				currentDate = addDays.call(currentDate, 1);
			}
			return dates;
		};

		$scope.show = false;
			$scope.email = $sessionStorage.get('patientAccEmail');
			$scope.month = new Date().getMonth() + 1;
			$scope.date = new Date().getDate();
			$scope.dateValue = new Date().getFullYear() + "-" + ($scope.month.toString().length > 1 ? $scope.month : '0' + $scope.month) + "-" + ($scope.date.toString().length > 1 ? $scope.date : '0' + $scope.date);
			$scope.getDate = function(){
				var params = {
					patientemail : $scope.email,
					dateValue : $scope.dateValue
				}
				// //("dateValue",$scope.month,$scope.month.toString().length,$scope.dateValue);
				paymentService.getDates(params).then(function (res){
					$scope.show = res.date ? false : true;
				
					// var end = moment(Date.now() - 14 * 24 * 3600 * 1000).format('YYYY-MM-DD');
					// var startFinalize = moment(end, "YYYY-MM-DD").add(1, 'days').format('YYYY-MM-DD');
					// $scope.dates = $scope.getDates(new Date(startFinalize),new Date($scope.dateValue));
					// console.log("$scope.dates",startFinalize,$scope.dateValue);
					// var startDate = $scope.dateValue;
					// var endDate = res.date ? res.date[0]['14days_ago'] : '';
					var startDate = res.date ? res.date[0]['start_date'] : '';
					var endDate = res.date ? (res.date[0]['start_date'] === res.date[0]['14days_ago']) ? moment(Date.now()).format('YYYY-MM-DD') : res.date[0]['14days_ago'] : '';
					$scope.dates = $scope.getDates(new Date(startDate),new Date(endDate));
					
					if($scope.dates.length < 14) {
						var length = 14 - $scope.dates.length;
						for(var i=0 ;i<length;i++) {
							$scope.dates.push('')
						}
					}
								
					if(startDate && endDate) {
						$scope.chartCalc($scope.email,startDate,endDate);	

						paymentService.covidSurvay($scope.email, startDate, endDate).then(function (response){
							// //("response",response);
							var other_data = response['other_data'];
							
							var entrylevels = [];
							var category = [];
							var dayList = [];
							other_data[0]['data'].forEach(function(index){
								category.push({
									symptom: index.symptom_category
								});
							});
							$scope.dates.forEach(function(index, i){
								var filter = other_data.filter(function(a){
									return (a.date.date === index)
								})
								var dayCount = i+1;
								var dayValue = moment(index).format('DD-MMM-YYYY').split("-");
								dayValue[0] = i+1
								var day = dayValue[0]+"-"+dayValue[1]+"-"+dayValue[2];
								
								if (filter.length != 0) {
									dayList.push({
										date: index,
										dayValue: moment(day).format('Do'),
										dayFormat: moment(index).format('DD-MMM-YYYY'),
										day: (i + 1),
										level: 1,
										values: filter[0]['data'].flat()
									})


									var Object = {
										date: index,
										dayValue: moment(day).format('Do'),
										dayFormat: moment(index).format('DD-MMM-YYYY'),
										day: (i + 1),
										values: []
									}

									filter[0]['data'].forEach(function(k, o){
										//("ooo",k);
										var Weightage_Val = k['Weightage'];
										var symptoms = k['symptom_scale'].toLowerCase();
										var color;
										//("symptoms",symptoms,Weightage_Val);
										// var Weightage_Val = findValue[0]['Weightage']
										// 	var symptoms = findValue[0]['symptom_scale'].toLowerCase();
											var color;
											var Weightage;
											if(symptoms === 'cannot smell') {
												if(Weightage_Val === 15.48) {
													color = 'red'
												}
											}
											if(symptoms === 'can smell well') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											if(symptoms === 'cannot taste') {
												if(Weightage_Val === 15.48) {
													color = 'red'
												}
											}
											if(symptoms === 'can taste well') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											if(symptoms === 'fever (> 104)') {
												if(Weightage_Val === 14.64) {
													color = 'red'
												}
											}
											if(symptoms === 'fever (102 - 104)') {
												if(Weightage_Val === 8.33) {
													color = '#ff85ce'
												}
											}
											if(symptoms === 'fever (100 - 102)') {
												if(Weightage_Val === 4.16) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'fever (98.4 - 100)') {
												if(Weightage_Val === 1.67) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no fever') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											if(symptoms === 'severe dry cough') {
												if(Weightage_Val === 11.27) {
													color = 'red'
												}
											}
											if(symptoms === 'continuous dry cough') {
												if(Weightage_Val === 6.66) {
													color = '#ff85ce'
												}
											}
											if(symptoms === 'intermittent dry cough') {
												if(Weightage_Val === 3.33) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'occasional dry cough') {
												if(Weightage_Val === 0.83) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no cough') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Fatigue
											if(symptoms === 'severe fatigue') {
												if(Weightage_Val === 6.34) {
													color = 'red'
												}
											}
											if(symptoms === 'moderate fatigue') {
												if(Weightage_Val === 0.83) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'mild fatigue') {
												if(Weightage_Val === 0.17) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no fatigue') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Sputum
											if(symptoms === 'colour of sputum-clear,dark yellow / dark green,pink') {
												if(Weightage_Val === 5.56) {
													color = 'red'
												}
											}
											if(symptoms === 'quantity of sputum-low,medium,moderate') {
												if(Weightage_Val === 0.5) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'secretion of sputum-few,many') {
												if(Weightage_Val === 0.08) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no sputum') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Shortness of breath
											if(symptoms === 'severe shortness of breath') {
												if(Weightage_Val === 3.10) {
													color = 'red'
												}
											}
											if(symptoms === 'moderate shortness of breath') {
												if(Weightage_Val === 1.67) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'mild shortness of breath') {
												if(Weightage_Val === 0.83) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no shortness of breath') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Muscle or Joint Pain
											if(symptoms === 'unbearable muscle or joint pain') {
												if(Weightage_Val === 2.46) {
													color = 'red'
												}
											}
											if(symptoms === 'manageable muscle or joint pain') {
												if(Weightage_Val === 1.67) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'tolerable muscle or joint pain') {
												if(Weightage_Val === 0.83) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no muscle or joint pain') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Sore Throat
											if(symptoms === 'difficulty breathing or swallowing sore throat') {
												if(Weightage_Val === 2.31) {
													color = 'red'
												}
											}
											if(symptoms === 'accompanied by pain sore throat') {
												if(Weightage_Val === 1.17) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'scratchy sore throat' || symptoms === 'scratchy  sore throat') {
												//("////&&&&&&&&777")
												if(Weightage_Val === 0.5 || Weightage_Val === 0.50) {
													//("////&&&&&&&&777")
													color = '#ffff66'
												}
											}
											if(symptoms === 'no sore throat') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Headache
											if(symptoms === 'severe headache') {
												if(Weightage_Val === 2.26) {
													color = 'red'
												}
											}
											if(symptoms === 'moderate headache') {
												if(Weightage_Val === 1.17) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'mild headache') {
												if(Weightage_Val === 0.50) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no headache') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Chills
											if(symptoms === 'continuous chills') {
												if(Weightage_Val === 1.90) {
													color = 'red'
												}
											}
											if(symptoms === 'several times a day chills') {
												if(Weightage_Val === 0.83) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'afew times a day chills' || symptoms === 'a few times a day chills') {
												if(Weightage_Val === 0.33) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no chills') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Vomitting
											if(symptoms === 'vomitting') {
												if(Weightage_Val === 0.83) {
													color = 'red'
												}
												if(Weightage_Val === 0.67) {
													color = '#ff85ce'
												}
												if(Weightage_Val === 0.33) {
													color = '#ffda65'
												}
												if(Weightage_Val === 0.17) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no vomitting') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Nasal Congestion
											if(symptoms === 'severe nasal congestion') {
												if(Weightage_Val === 0.80) {
													color = 'red'
												}
											}
											if(symptoms === 'moderate nasal congestion') {
												if(Weightage_Val === 0.03) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'mild nasal congestion') {
												if(Weightage_Val === 0.02) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no nasal congestion') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Diarrhea
											if(symptoms === 'diarrhea') {
												if(Weightage_Val === 0.62) {
													color = 'red'
												}
											}
											if(symptoms === 'no diarrhea') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Coughing up blood
											if(symptoms === 'coughing up blood') {
												if(Weightage_Val === 0.15) {
													color = 'red'
												}
											}
											if(symptoms === 'no coughing up blood') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Pink Eye
											if(symptoms === 'pink eye') {
												if(Weightage_Val === 0.13) {
													color = 'red'
												}
											}
											if(symptoms === 'no pink eye') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Direct Contact
											if(symptoms === 'direct contact') {
												if(Weightage_Val === 16.65) {
													color = 'red'
												}
											}
											if(symptoms === 'no contact history ') {
												if(Weightage_Val === 8.33) {
													color = '#b7c99e'
												}
											}
										Object['values'].push({
											symptom: k['symptom_category'],
											color: color ? color : ''
										})
									})
									$scope.entryList.push(Object);


								} else {

									dayList.push({
										date: index,
										dayValue: moment(day).format('Do'),
										dayFormat: moment(index).format('DD-MMM-YYYY'),
										day: i + 1,
										level: 0,
										values: []
									})
								}

								if (i + 1 === $scope.dates.length) {
									// $scope.entryList = dayList;
									//("$scope.entryList", $scope.entryList);
									$scope.entryList.sort(function(a,b){
										// Turn your strings into dates, and then subtract them
										// to get a value that is either negative, positive, or zero.
										return new Date(b.date) - new Date(a.date);
									});
								}
							})


							category.forEach(function(i) {
								var array = [];
								$scope.dates.forEach(function(j, d){
									var filter = dayList.filter(function(a){
										return (a.date === j)
									});
								
									if (filter.length != 0) {
										var findValue = filter[0]['values'].filter(function(a){
											return (a['symptom_category'] === i.symptom)
										});
										if(findValue.length != 0) {
											var Weightage_Val = findValue[0]['Weightage']
											var symptoms = findValue[0]['symptom_scale'].toLowerCase();
											var color;
											var Weightage;
											if(symptoms === 'cannot smell') {
												if(Weightage_Val === 15.48) {
													color = 'red'
												}
											}
											if(symptoms === 'can smell well') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											if(symptoms === 'cannot taste') {
												if(Weightage_Val === 15.48) {
													color = 'red'
												}
											}
											if(symptoms === 'can taste well') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											if(symptoms === 'fever (> 104)') {
												if(Weightage_Val === 14.64) {
													color = 'red'
												}
											}
											if(symptoms === 'fever (102 - 104)') {
												if(Weightage_Val === 8.33) {
													color = '#ff85ce'
												}
											}
											if(symptoms === 'fever (100 - 102)') {
												if(Weightage_Val === 4.16) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'fever (98.4 - 100)') {
												if(Weightage_Val === 1.67) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no fever') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											if(symptoms === 'severe dry cough') {
												if(Weightage_Val === 11.27) {
													color = 'red'
												}
											}
											if(symptoms === 'continuous dry cough') {
												if(Weightage_Val === 6.66) {
													color = '#ff85ce'
												}
											}
											if(symptoms === 'intermittent dry cough') {
												if(Weightage_Val === 3.33) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'occasional dry cough') {
												if(Weightage_Val === 0.83) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no cough') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Fatigue
											if(symptoms === 'severe fatigue') {
												if(Weightage_Val === 6.34) {
													color = 'red'
												}
											}
											if(symptoms === 'moderate fatigue') {
												if(Weightage_Val === 0.83) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'mild fatigue') {
												if(Weightage_Val === 0.17) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no fatigue') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Sputum
											if(symptoms === 'colour of sputum-clear,dark yellow / dark green,pink') {
												if(Weightage_Val === 5.56) {
													color = 'red'
												}
											}
											if(symptoms === 'quantity of sputum-low,medium,moderate') {
												if(Weightage_Val === 0.5) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'secretion of sputum-few,many') {
												if(Weightage_Val === 0.08) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no sputum') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Shortness of breath
											if(symptoms === 'severe shortness of breath') {
												if(Weightage_Val === 3.10) {
													color = 'red'
												}
											}
											if(symptoms === 'moderate shortness of breath') {
												if(Weightage_Val === 1.67) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'mild shortness of breath') {
												if(Weightage_Val === 0.83) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no shortness of breath') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Muscle or Joint Pain
											if(symptoms === 'unbearable muscle or joint pain') {
												if(Weightage_Val === 2.46) {
													color = 'red'
												}
											}
											if(symptoms === 'manageable muscle or joint pain') {
												if(Weightage_Val === 1.67) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'tolerable muscle or joint pain') {
												if(Weightage_Val === 0.83) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no muscle or joint pain') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Sore Throat
											if(symptoms === 'difficulty breathing or swallowing sore throat') {
												if(Weightage_Val === 2.31) {
													color = 'red'
												}
											}
											if(symptoms === 'accompanied by pain sore throat') {
												if(Weightage_Val === 1.17) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'scratchy sore throat' || symptoms === 'scratchy  sore throat') {
												//("////&&&&&&&&777")
												if(Weightage_Val === 0.5 || Weightage_Val === 0.50) {
													//("////&&&&&&&&777")
													color = '#ffff66'
												}
											}
											if(symptoms === 'no sore throat') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Headache
											if(symptoms === 'severe headache') {
												if(Weightage_Val === 2.26) {
													color = 'red'
												}
											}
											if(symptoms === 'moderate headache') {
												if(Weightage_Val === 1.17) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'mild headache') {
												if(Weightage_Val === 0.50) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no headache') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Chills
											if(symptoms === 'continuous chills') {
												if(Weightage_Val === 1.90) {
													color = 'red'
												}
											}
											if(symptoms === 'several times a day chills') {
												if(Weightage_Val === 0.83) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'afew times a day chills' || symptoms === 'a few times a day chills') {
												if(Weightage_Val === 0.33) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no chills') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Vomitting
											if(symptoms === 'vomitting') {
												if(Weightage_Val === 0.83) {
													color = 'red'
												}
												if(Weightage_Val === 0.67) {
													color = '#ff85ce'
												}
												if(Weightage_Val === 0.33) {
													color = '#ffda65'
												}
												if(Weightage_Val === 0.17) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no vomitting') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Nasal Congestion
											if(symptoms === 'severe nasal congestion') {
												if(Weightage_Val === 0.80) {
													color = 'red'
												}
											}
											if(symptoms === 'moderate nasal congestion') {
												if(Weightage_Val === 0.03) {
													color = '#ffda65'
												}
											}
											if(symptoms === 'mild nasal congestion') {
												if(Weightage_Val === 0.02) {
													color = '#ffff66'
												}
											}
											if(symptoms === 'no nasal congestion') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Diarrhea
											if(symptoms === 'diarrhea') {
												if(Weightage_Val === 0.62) {
													color = 'red'
												}
											}
											if(symptoms === 'no diarrhea') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Coughing up blood
											if(symptoms === 'coughing up blood') {
												if(Weightage_Val === 0.15) {
													color = 'red'
												}
											}
											if(symptoms === 'no coughing up blood') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Pink Eye
											if(symptoms === 'pink eye') {
												if(Weightage_Val === 0.13) {
													color = 'red'
												}
											}
											if(symptoms === 'no pink eye') {
												if(Weightage_Val === 0.00 || Weightage_Val === 0) {
													color = '#b7c99e'
												}
											}
											//Direct Contact
											if(symptoms === 'direct contact') {
												if(Weightage_Val === 16.65) {
													color = 'red'
												}
											}
											if(symptoms === 'no contact history ') {
												if(Weightage_Val === 8.33) {
													color = '#b7c99e'
												}
											}
										}
										// if (Weightage_Val >= 0.0 && Weightage_Val <= 6.0) {
										// 	color = '#b7c99e';
										// }
										// if (Weightage_Val > 6.0 && Weightage_Val < 23.8) {
										// 	color = 'yellow';
										// }
										// if (Weightage_Val > 23.8 && Weightage_Val < 72.0) {
										// 	color = 'orange';
										// }
										// if (Weightage_Val > 72.0 && Weightage_Val < 100.0) {
										// 	color = 'red';
										// }
										// if (findValue.length != 0) {
										// 	Weightage = findValue[0]['Weightage'];
										// 	if (Weightage >= 0.0 && Weightage <= 6.0) {
										// 		color = '#b7c99e';
										// 	}
										// 	if (Weightage > 6.0 && Weightage < 23.8) {
										// 		color = 'yellow';
										// 	}
										// 	if (Weightage > 23.8 && Weightage < 72.0) {
										// 		color = 'orange';
										// 	}
										// 	if (Weightage > 72.0 && Weightage < 100.0) {
										// 		color = 'red';
										// 	}
										// }
										array.push({
											day: d + 1,
											date: j,
											Weightage: Weightage ? Weightage : '',
											color: color ? color : ''
										})

									} else {
										array.push({
											day: d + 1,
											date: j.date,
											Weightage: Weightage,
											color: ''
										})

									}

									if (d + 1 === $scope.dates.length) {

										$scope.symp_list.push({
											symptom: i.symptom,
											list: array
										})
									}
								})
							})
							//("symp_list", $scope.symp_list);
						})
					}
				})
			}

			$scope.getDate();

			/* chart */
			$scope.chartCalc = function (email,startDate,endDate) {
				
				paymentService.ivitalData(email, startDate,endDate).then(function(response) {
					//("IvitalData",response)
					var result = response;
					$scope.dates.forEach(function(index, j){
						// var filter = $scope.dummy_data.filter(a => a.date.date === index);
						var filter = [];
						if(result.length != 0){
							filter = result.filter(function(a){
								return (a.date.date === index)
							});	
						} 
						var spo2 = 0;
						var respiratory_rate = 0;
						var temperature = 0;
						$scope.days.push('Day' + ' ' + (j + 1));
						if (filter.length != 0) {
							//("filter chart",filter)
							filter[0].data.forEach(function(index, i){
								spo2 += Number(index['spo2']);
								respiratory_rate += Number(index['respiratory_rate']);
								temperature += Number(index['temperature']);
								
								if (i + 1 === filter[0]['data'].length) {
									var totalSpo2 = spo2 / filter[0]['data'].length;
									var totalrr = respiratory_rate / filter[0]['data'].length;
									var totaltemperature = temperature / filter[0]['data'].length;
									//("totalSpor",totalSpo2)
									$scope.spo2.push(totalSpo2);
									$scope.rr.push(totalrr);
									$scope.temp.push(totaltemperature);
									$scope.chartspo2.push(totalSpo2);
									$scope.charttemp.push(totalrr);
									$scope.chartrr.push(totaltemperature);
								}
							})
						} else {
							$scope.spo2.push(null);
							$scope.rr.push(null);
							$scope.temp.push(null);
						}

						if (j + 1 === $scope.dates.length) {
							$scope.showChart();
						}
						//("$scope.spo2",$scope.spo2);
						//("rr",$scope.rr);
						//("temp",$scope.temp)
					})
				})

			}

			/* End */
	// $rootScope.imageUploadUrl = authService.helyxonApi.url + 'cloud/image/upload/'; 

	$scope.checkVideoCall_displayStatus = $sessionStorage.get('video_access_token');
	console.log($scope.checkVideo_displayStatus);
	
	var vm = this
		
	authService.loadHelyxonApiUrl();
	authService.loadmainUrl();
	vm.helyxonApiUrl = authService.helyxonApi.url;
	vm.mainUrl = authService.mainUrl.url;
	$rootScope.imageUploadUrl = vm.helyxonApiUrl + 'cloud/image/upload/';  
	$rootScope.pdfViewUrl = vm.helyxonApiUrl + 'cloud/pdf/upload/';
	$rootScope.pdfViewUrldoctor = vm.mainUrl + '/PDF/';

	// window.location.href = '.../home#/home';
	if(!$route.current.params.Id) {
		$location.path("/home");
	  return;
	}

	$scope.showChart = function () {
		//("///")
		Highcharts.setOptions({lang: {noData: "Your custom message"}});
		$('#line-chart-mmhg').highcharts({
			chart: {
				//plotBackgroundColor: null,
				//plotBorderWidth: null,
				plotShadow: false,
				type: 'line',
				// spacingBottom: 15,
				// spacingTop: 10,
				// spacingLeft: 10,
				// spacingRight: 10,
				width: 385,
				height: 197
			},
			credits: {
				enabled: false
			},
			title: {
				text: 'SpO2 in %'
			},
			xAxis: {
				categories: ($scope.chartspo2.length != 0 && $scope.days),
				lineWidth: 0,
				minorGridLineWidth: 0,
				gridLineWidth: 0,
				lineColor: 'transparent',
				minorTickLength: 0,
				tickLength: 0,
				labels : {
					enabled : $scope.chartspo2.length != 0 ? true :  false
				}
			},
			legend: {
				reversed: true
			},
			yAxis: {
				title: {
					text: ''
				},
				min: 1,
				labels:{
					formatter:function(){
						if(this.value != 0){
							return this.value;
						}
					},
					
				}
			},
			plotOptions: {
				series: {
					cursor : 'pointer',
					connectNulls: true // by default
				}
			},
			tooltip: {
				enabled: true,
				formatter: function() {
					return this.x.replace(/ /g,'')+', '+'Value'+":"+this.y;
				}
			},
			series: [{
				name: 'Days',
				data: $scope.spo2
			}]
			
			// lang: {
			// 	noData: "No data"
			// },
			// noData: {
			// 	style: {
			// 		fontWeight: 'bold',
			// 		fontSize: '15px',
			// 		color: '#303030'
			// 	}
			// }
		},function(chart) { // on complete
			console.log("$scope.spo2",$scope.spo2)
			if ($scope.chartspo2.length < 1) { // check series is empty
			  chart.renderer.text('No data available', 140, 120)
				.css({
				  color: '#4572A7',
				  fontSize: '16px'
				})
				.add();
			}
		});

		$('#line-chart-temp').highcharts({
			chart: {
				//plotBackgroundColor: null,
				//plotBorderWidth: null,
				plotShadow: false,
				type: 'line',
				// spacingBottom: 15,
				// spacingTop: 10,
				// spacingLeft: 10,
				// spacingRight: 10,
				width: 385,
				height: 197
			},
			credits: {
				enabled: false
			},
			title: {
				useHTML: true,
				text: 'Temp in &#8457'
			},
			xAxis: {
				categories: ($scope.charttemp.length != 0 && $scope.days),
				lineWidth: 0,
				minorGridLineWidth: 0,
				gridLineWidth: 0,
				lineColor: 'transparent',
				minorTickLength: 0,
				tickLength: 0,
				labels : {
					enabled : $scope.charttemp.length != 0 ? true :  false
				}
			},
			legend: {
				reversed: true
			},
			tooltip: {
				enabled: true,
				formatter: function() {
					return this.x.replace(/ /g,'')+', '+'Value'+":"+this.y;
				}
			},
			yAxis: {
				title: {
					text: ''
				},
				min: 1,
				labels:{
					formatter:function(){
						if(this.value != 0){
							return this.value;
						}
					}
				}
			},
			plotOptions: {
				series: {
					connectNulls: true // by default
				}
			},
			series: [{
				name: 'Days',
				data: $scope.temp
			}]
		},function(chart) { // on complete
			if ($scope.charttemp.length < 1) { // check series is empty
			  chart.renderer.text('No data available', 140, 120)
				.css({
				  color: '#4572A7',
				  fontSize: '16px'
				})
				.add();
			}
		});

		$('#line-chart-rr').highcharts({
			chart: {
				//plotBackgroundColor: null,
				//plotBorderWidth: null,
				plotShadow: false,
				type: 'line',
				// spacingBottom: 15,
				// spacingTop: 10,
				// spacingLeft: 10,
				// spacingRight: 10,
				width: 385,
				height: 197
			},
			credits: {
				enabled: false
			},
			title: {
				text: 'RR in Respiratory Per Minute'
			},
			xAxis: {
				categories: ($scope.chartrr.length != 0 && $scope.days),
				lineWidth: 0,
				minorGridLineWidth: 0,
				gridLineWidth: 0,
				lineColor: 'transparent',
				minorTickLength: 0,
				tickLength: 0,
				labels : {
					enabled : $scope.chartrr.length != 0 ? true :  false
				}
			},
			yAxis: {
				title: {
					text: ''
				},
				min: 1,
				labels:{
					formatter:function(){
						if(this.value != 0){
							return this.value;
						}
					}
				}
			},
			legend: {
				reversed: true
			},
			tooltip: {
				enabled: true,
				formatter: function() {
					return this.x.replace(/ /g,'')+', '+'Value'+":"+this.y;
				}
			},
			// yAxis: {
			// 	title: {
			// 		text: 'Days'
			// 	}
			// },
			plotOptions: {
				series: {
					connectNulls: true // by default
				}
			},
			series: [{
				name: 'Days',
				data: $scope.rr
			}]
		},function(chart) { // on complete
			if ($scope.chartrr.length < 1) { // check series is empty
			  chart.renderer.text('No data available', 140, 120)
				.css({
				  color: '#4572A7',
				  fontSize: '16px'
				})
				.add();
			}
		});

	}

	$scope.showChartPopup = function () {
		//("///")
		$('#line-chart-mmhg1').highcharts({
			chart: {
				//plotBackgroundColor: null,
				//plotBorderWidth: null,
				plotShadow: false,
				type: 'line',
				// spacingBottom: 15,
				// spacingTop: 10,
				// spacingLeft: 10,
				// spacingRight: 10,
				width: 840,
				height: 450
			},
			credits: {
				enabled: false
			},
			title: {
				text: 'SpO2 in %'
			},
			xAxis: {
				categories: $scope.days,
				lineWidth: 0,
				minorGridLineWidth: 0,
				gridLineWidth: 0,
				lineColor: 'transparent',
				minorTickLength: 0,
				tickLength: 0
				
			},
			legend: {
				reversed: true
			},
			tooltip: {
				enabled: true,
				formatter: function() {
					return this.x.replace(/ /g,'')+', '+'Value'+":"+this.y;
				}
			},
			yAxis: {
				title: {
					text: ''
				},
				min: 1,
				labels:{
					formatter:function(){
						if(this.value != 0){
							return this.value;
						}
					}
				}
			},
			plotOptions: {
				series: {
					connectNulls: true // by default
				}
			},
			
			series: [{
				name: 'Days',
				data: $scope.spo2
			}],
			
		},function(chart) { // on complete
			if ($scope.chartspo2.length < 1) { // check series is empty
			  chart.renderer.text('No data available', 200, 120)
				.css({
				  color: '#4572A7',
				  fontSize: '16px'
				})
				.add();
			}
		});

		$('#line-chart-temp1').highcharts({
			chart: {
				//plotBackgroundColor: null,
				//plotBorderWidth: null,
				plotShadow: false,
				type: 'line',
				// spacingBottom: 15,
				// spacingTop: 10,
				// spacingLeft: 10,
				// spacingRight: 10,
				width: 840,
				height: 450
			},
			credits: {
				enabled: false
			},
			title: {
				useHTML: true,
				text:'Temp in &#8457'
			},
			xAxis: {
				categories: $scope.days,
				lineWidth: 0,
				minorGridLineWidth: 0,
				gridLineWidth: 0,
				lineColor: 'transparent',
				minorTickLength: 0,
				tickLength: 0,
			},
			legend: {
				reversed: true
			},
			tooltip: {
				enabled: true,
				formatter: function() {
					return this.x.replace(/ /g,'')+', '+'Value'+":"+this.y;
				}
			},
			yAxis: {
				title: {
					text: ''
				},
				min: 1,
				labels:{
					formatter:function(){
						if(this.value != 0){
							return this.value;
						}
					}
				}
			},
			plotOptions: {
				series: {
					connectNulls: true // by default
				}
			},
			series: [{
				name: 'Days',
				data: $scope.temp
			}]
		},function(chart) { // on complete
			if ($scope.charttemp.length < 1) { // check series is empty
			  chart.renderer.text('No data available', 140, 120)
				.css({
				  color: '#4572A7',
				  fontSize: '16px'
				})
				.add();
			}
		});

		$('#line-chart-rr1').highcharts({
			chart: {
				//plotBackgroundColor: null,
				//plotBorderWidth: null,
				plotShadow: false,
				type: 'line',
				// spacingBottom: 15,
				// spacingTop: 10,
				// spacingLeft: 10,
				// spacingRight: 10,
				width: 840,
				height: 450
			},
			credits: {
				enabled: false
			},
			title: {
				text: 'RR in Respiratory Per Minute'
			},
			xAxis: {
				categories: $scope.days,
				lineWidth: 0,
				minorGridLineWidth: 0,
				gridLineWidth: 0,
				lineColor: 'transparent',
				minorTickLength: 0,
				tickLength: 0,
			},
			yAxis: {
				title: {
					text: ''
				},
				min: 1,
				labels:{
					formatter:function(){
						if(this.value != 0){
							return this.value;
						}
					}
				}
			},
			legend: {
				reversed: true
			},
			tooltip: {
				enabled: true,
				formatter: function() {
					return this.x.replace(/ /g,'')+', '+'Value'+":"+this.y;
				}
			},
			// yAxis: {
			// 	title: {
			// 		text: 'Days'
			// 	}
			// },
			plotOptions: {
				series: {
					connectNulls: true // by default
				}
			},
			series: [{
				name: 'Days',
				data: $scope.rr
			}]
		},function(chart) { // on complete
			if ($scope.chartrr.length < 1) { // check series is empty
			  chart.renderer.text('No data available', 140, 120)
				.css({
				  color: '#4572A7',
				  fontSize: '16px'
				})
				.add();
			}
		});
	}

	$scope.vitalList = [];
		$rootScope.pillsvalues = [];
		$rootScope.injevalues = [];
		$scope.potchartdataseries;
		$scope.gulcochartdataseries;
		$scope.homescreenDashboardStatus = true;
		$scope.unitvalue ='mg/dl'
		$scope.bptext ='mmHg'
		
		$scope.check_viewscreen = function(status){
			$scope.homescreenDashboardStatus = status;
			
		}

		$scope.byRange = function (from, to) {
			
			$scope.selectedfromdate = moment(from).format("YYYY-MM-DD");
			$scope.selectedtodate = moment(to).format("YYYY-MM-DD");

			console.log($scope.selectedfromdate);
			console.log($scope.selectedtodate);
			setTimeout(function(){
				$scope.vitalChart();
			},500);
			

            // if (from) {
            //     $scope.rangePicker2 = {
            //         opened: { fromDate: false, toDate: false },
            //         maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
            //         dateOptions: {
            //             formatYear: 'yyyy',
            //             startingDay: 0,
            //             minDate: from
            //         }
            //     };
            // }

            // if (to) {
            //     $rootScope.rangePicker1 = {
            //         opened: { fromDate: false, toDate: false },
            //         maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
            //         dateOptions: {
            //             formatYear: 'yyyy',
            //             startingDay: 0,
                        
            //         }
            //     };
            // };

            // if (from && to) {
            //     var datArr = getStringDate(from);
            //     $scope.selectedFromDate = datArr[1];
            //     $scope.selectedFromDate2 = datArr[0];
            //     var datArr2 = getStringDate(to);
            //     $scope.selectedToDate = datArr2[1];
            //     $scope.selectedToDate2 = datArr2[0];;
                
            // }
        }
		function getStringDate(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            return [year + "-" + month + "-" + day, day + "-" + month + "-" + year];
        }

	/*Vital Chart*/
	$scope.vitalChart = function (){
		

		recordService.getvitalGulcometer($scope.selectedfromdate,$scope.selectedtodate).then(function(response) {
			$scope.vitalList = response;
		});

		if (mainUrl == 'https://epicare.net') {
			$scope.is_liveurl = 1;
		}else{
			$scope.is_liveurl = 0;
		}

		var sendData = {
			account_email:authService.authentication.account_id,
			patient_email: sessionStorage.getItem('patientAccEmail'),
			from_date:$scope.selectedfromdate,
			to_date: $scope.selectedtodate,
			is_live: $scope.is_liveurl,
			vital:'bp'
		}

		var sendgulcoData = {
			account_email:authService.authentication.account_id,
			//patient_email: ''rx9347@rxcarenet.org'',
			patient_email: sessionStorage.getItem('patientAccEmail'),
			from_date: $scope.selectedfromdate,
			to_date: $scope.selectedtodate,
			is_live: $scope.is_liveurl,
			vital:'glucometer',
			unit_value: "mmol" 
		}

		recordService.getBpdata(sendData).then(function(response) {
			$scope.potchartdataseries = response;
			console.log($scope.potchartdataseries);

			setTimeout(function(){
				$scope.vitalplottedBPChart();
			},600);
		});

		recordService.getBpdata(sendgulcoData).then(function(response) {
			$scope.gulcochartdataseries = response;
			setTimeout(function(){
				$scope.vitalplottedgulcoChart();
			},600);
		})
}

	$scope.vitalplottedBPChart = function (){
		console.log('###');
		console.log($scope.potchartdataseries);
		$('#vitalBPplot').highcharts({
			chart: {
				type: 'scatter',
				//zoomType: 'xy',
				width: 1190,
				height: 400
			},
			accessibility: {
				description: '',
			},
			title: {
				text: 'BP'
			},
		  	xAxis: {
				title: {
					enabled: true,
					text: 'Time'
				},
				startOnTick: true,
				endOnTick: true,
				showLastLabel: true,
				type: 'datetime',
				labels: {
				  //rotation:-25, 
				  formatter: function() {
					//return moment(this.value).format('YYYY-MM-DD HH:mm');
					//return Highcharts.dateFormat("%H:%M %d %b %Y", this.value);
					return Highcharts.dateFormat("%Y-%m-%d %H:%M", this.value);
				  }  
			   }
			},
			yAxis: {
				title: {
					text: $scope.bptext
				}
			},
			legend: {
				layout: 'horizontal',
				align: 'center',
				verticalAlign: 'top',
				 x: 30,
				y: 30,
				//floating: true,
				borderWidth: 1
			},
			credits: {
			  enabled: false
			},
			plotOptions: {
				scatter: {
					lineWidth:2,
					marker: {
						radius: 5,
						states: {
							hover: {
								enabled: true,
								lineColor: 'rgb(100,100,100)'
							}
						}
					},
					
					states: {
						hover: {
							marker: {
								enabled: false
							}
						}
					},
					tooltip: {
						headerFormat: '<b>{series.name}</b><br>',
						pointFormatter: function() {
							return 'Time : '+ Highcharts.dateFormat('%H:%M', this.x ) +','+ $scope.bptext +' : '+  this.y 
						 }
					}
				}
			},
			series: $scope.potchartdataseries
		});
}

$scope.vitalplottedgulcoChart = function (){
	
	$('#vitalGulcoplot').highcharts({
		chart: {
			type: 'scatter',
			zoomType: 'xy',
			width: 1190,
			height: 400
		},
		accessibility: {
			description: '',
		},
		title: {
			text: 'Gulcometer'
		},
		  xAxis: {
			title: {
				enabled: true,
				text: 'Time'
			},
			startOnTick: true,
			endOnTick: true,
			showLastLabel: true,
			type: 'datetime',
			labels: {
			  //rotation:-25, 
			  formatter: function() {
				//return moment(this.value).format('YYYY-MM-DD HH:mm');
				return Highcharts.dateFormat("%Y-%m-%d %H:%M", this.value);
				//return Highcharts.dateFormat("%H:%M", this.value);
			  }  
		   }
		},
		yAxis: {
			title: {
				text: $scope.unitvalue
			}
		},
		legend: {
			layout: 'horizontal',
			align: 'center',
			verticalAlign: 'top',
			x: 100,
			y: 30,
			//floating: true,
			borderWidth: 1
		},
		credits: {
		  enabled: false
		},
		plotOptions: {
			scatter: {
				lineWidth:2,
				marker: {
					radius: 5,
					states: {
						hover: {
							enabled: true,
							lineColor: 'rgb(100,100,100)'
						}
					}
				},
				states: {
					hover: {
						marker: {
							enabled: false
						}
					}
				},
				tooltip: {
					headerFormat: '<b>{series.name}</b><br>',
					pointFormatter: function() {
						return 'Time : '+ Highcharts.dateFormat('%H:%M', this.x ) +','+ $scope.unitvalue +' : '+  this.y 
					 }
				}
			}
		},
		series: $scope.gulcochartdataseries
	});
}
/** */

$scope.openVitalListData = function(name,e,pillsdata) {
	$rootScope.pillsvalues = pillsdata.pills;
	$rootScope.injevalues = pillsdata.injection;

	var options = {
		title: 'Gulcometer Datas',
		message: 'Gulcometer Datas',
		templateUrl: 'views/patient/gulcometerdatas.htm',
		size: 'large', 
		onEscape: function() {$scope.$apply();},
	}
	$ngBootbox.customDialog(options);
	e.stopImmediatePropagation();
}
		// $rootScope.Enable_tab = true;
		// $scope.Tabfalse_count = 0
		$scope.getConsultationTabs = function () {
               
			tabsService.getconsultionSettings().then(function(response) {
				 $scope.consultCheckTabs = response.consultation_setting;
				//  angular.forEach($scope.consultCheckTabs , function(value){
				// 	 if(value.status == true){
				// 		$scope.Tabfalse_count += 1;
				// 		console.log('$scope.Tabfalse_count',$scope.Tabfalse_count);
				// 	 }
				// 	 if($scope.Tabfalse_count > 0){
                //         $rootScope.Enable_tab = false;
				// 	 }
				//  })
					console.log($scope.consultCheckTabs);
				 $scope.growthchartStatus = $scope.consultCheckTabs[0].status;
				 $scope.milestoneStatus = $scope.consultCheckTabs[1].status;
				 $scope.vaccinationStatus = $scope.consultCheckTabs[2].status;
				 $scope.lifelogStatus = $scope.consultCheckTabs[3].status;
				 $scope.labReportStatus = $scope.consultCheckTabs[4].status;
				 $scope.pastmedicalStatus = $scope.consultCheckTabs[5].status;
				 $scope.covidStatus = $scope.consultCheckTabs[6].status
				 $scope.paymentStatus = $scope.consultCheckTabs[7].status;
				 $scope.dischargesStatus = $scope.consultCheckTabs[8].status;
				 $scope.obstgynec = $scope.consultCheckTabs[9].status;
				 $scope.surveyquesStatus = $scope.consultCheckTabs[10].status;
				 $scope.chiefCompliantStatus = $scope.consultCheckTabs[11].status;
				 $scope.examFindingStatus = $scope.consultCheckTabs[12].status;
				 $scope.proDiagnosisStatus = $scope.consultCheckTabs[13].status;
				 $scope.investigatStatus = $scope.consultCheckTabs[14].status;
				 $scope.diagnosisStatus = $scope.consultCheckTabs[15].status;
				 $scope.prescriStatus = $scope.consultCheckTabs[16].status;
				 $scope.adviceStatus = $scope.consultCheckTabs[17].status;
                 $scope.followupStatus = $scope.consultCheckTabs[18].status;

				},function(error) {
				  toastr.error(error,'Try again...');
				  //analytics('addNewComplaint','Try again');
			  })
			}
		  
			$scope.getConsultationTabs();
		  $scope.intitiveconsultation = function(){
			$scope.patient_id =  sessionStorage.getItem('patientid')
			$scope.doctorId = authService.authentication.doctor_id
			console.log('$scope.patient_id', $scope.patient_id ,'doctorid', $scope.doctorId);
			$scope.accountemail = authService.authentication.account_id;
		 
			var url = $scope.url = $location.absUrl();
			var id = url.split("/");
		//    console.log("id", id[id.length-1]);
		   sessionStorage.setItem("id", id[id.length-1]);
		   var patient_id = sessionStorage.getItem("id")
		   console.log("patientid", patient_id);
		   if (mainUrl == 'https://test.epicare.net') {
			$scope.serverurl = 'https://test.epicare.net';
		}else{
			$scope.serverurl = 'https://epicare.net';
		}

			//  https://test.epicare.net/new/#/
			// http://localhost:4200/#/
			// console.log('incu screen Epicare', 'https://test.epicare.net/new/#/?id='+$scope.patient_id+'&dmail='+$scope.accountemail+'&did='+$scope.doctorId+'&mode=1&token=b2F1dGhfdG9rZW49U1lRVTlNRjNmaG53VGJVbUpIOHEmb2F1dGhfdG9rZW5fc2VjcmV0PXlSblVmYWFUV3ZLYmptWlpVd3VpJmFjY291bnRfaWQ9cng0JTQwcnhjYXJlbmV0Lm9yZw%3D%3D');
			$rootScope.intuitive_consultation_screen = $sce.trustAsResourceUrl($scope.serverurl+'/new/#/?id='+patient_id+'&dmail='+$scope.accountemail+'&did='+$scope.doctorId+'&mode=1&token='+$rootScope.authtoken);
		
		}
		$scope.intitiveconsultation()

		window.onmessage = function(e){
			console.log(e)
			if(e.data.message == 'other'){
				$scope.viewics = !$scope.viewics
				$scope.loadVitalSigns();
				$scope.printAllGrowthChart()
			}
			if(e.data.message == 'patient'){
				$scope.recordId = e.data.patient.record_id
				sessionStorage.setItem('patientid',e.data.patient.record_id)
				$location.path('/patientview/' + $scope.recordId);
				$timeout(function () {
					// 0 ms delay to reload the page.
					$route.reload();
				}, 0);
				
			}
			if(e.data.message == 'started'){
				$rootScope.showlostalert = true
				$rootScope.end_consultation = false
			}
			if(e.data.message == 'ended'){
				$rootScope.showlostalert = false
				$rootScope.end_consultation = true
			}
		}
  
		
	$rootScope.printspinner = false;
	$scope.mangalabarathi = function(){
		$rootScope.printspinner = false;
		recordService.Mangalabarathi($rootScope.overviewId).then(function(response){
			if(response){
				$rootScope.printspinner = true;
				console.log('message sent');
				
			}
		})
	}
	$scope.general_prescription = function(){
		$rootScope.printspinner = false;
		recordService.general_Prescription($rootScope.overviewId).then(function(response){
			if(response){
				$rootScope.printspinner = true;
				console.log('message sent');
			}
		})
	}


	console.log('top rootscope');
	console.log($rootScope.videoCallresponse);

	$scope.walletBalance = function() {

		var patient_mail = "";

		if( $sessionStorage.get('video_call_patient')) {
			patient_mail = $sessionStorage.get('video_call_patient')
		} else if( $sessionStorage.get('patientAccEmail') ) {
			patient_mail = $sessionStorage.get('patientAccEmail');
		} 
		
		var data = {
			account_email: $rootScope.authentication.account_id,
			patient_email: patient_mail
		}
	
		paymentService.getWalletBalance(data).then(function(response) {
	
			$rootScope.walletBalance = response.wallet[0].response[0].total;
			$rootScope.pre_walletBalance = $rootScope.walletBalance;
			sessionStorage.setItem("wallet_ballance",$rootScope.walletBalance);
	
		},function(error) {
	
			toastr.error(error);
			var objValue, errLabel = '';
	
			if (typeof error === 'object') {
				objValue = Object.values(error);
				errLabel = objValue[0];
			} else {
				errLabel = error;
			}
			analytics('walletBalance', errLabel);
			
		});	
	};	



	$rootScope.changePaymentCategory = function( selected_category_id){
		//console.log('selected_cate*****',$rootScope.getPayCategoryListview);
        //console.log('selected_category_id',selected_category_id);
		var filterValue = ($filter('filter')($rootScope.getPayCategoryListview, {'id': selected_category_id}));
	       
			$rootScope.selected_category_id = filterValue[0].id;
			$rootScope.selected_doctor_charge = filterValue[0].doctor_charge ;
			$rootScope.selected_category = filterValue[0].module;
			//$rootScope.selected_description = "";
			$rootScope.selected_description = "The Amount of Rs."+$rootScope.selected_doctor_charge+" is Debited for "+$rootScope.selected_category ;	
	}
	$scope.allow_conference == true;
	$scope.getPayCategoryListMtd = function() {
		$scope.walletBalance();	
		
		$rootScope.selected_category_id = "";
		$rootScope.selected_doctor_charge = 0;
		$rootScope.selected_category = "";
		$rootScope.selected_description = "";

		$rootScope.getPayCategoryListview = [];
		paymentService.getPaymentSetting().then(function(response) {
			 $rootScope.getPayCategoryListview = response;
			//console.log( response );
			//console.log("aaptype***"+ $sessionStorage.get("appt_type") );
			// console.log(' $rootScope.getPayCategoryListview', $rootScope.getPayCategoryListview);
			//$scope.getAppointmenttype = sessionStorage.getItem('status');
			$scope.getAppointmenttype = sessionStorage.getItem('appt_type');
			if($scope.getAppointmenttype == 'video_call'){
				$scope.getAppointmenttype = 'video_call_consultation'
			}else if($scope.getAppointmenttype == ""){
				$scope.getAppointmenttype = 'consultation'
			}
			//console.log('$scope.getAppointmenttype***',$scope.getAppointmenttype);
			angular.forEach(response , function(value){
				if(value.module == $scope.getAppointmenttype){
					console.log('value is' , value)
					$rootScope.selected_category_id = value.id;
					var categoryID = value.id;
					var Doctorcharge = value.doctor_charge;
					var apptType = value.module
					$rootScope.changePaymentCategory(categoryID);
				}
			})
			//console.log('$rootScope.selected_category_id'+$rootScope.selected_category_id)

			if( $sessionStorage.get('video_call_mode') == 'emergency_video_call' || $sessionStorage.get('video_call_mode') == 'video_call') {
				var filterValue;
				  
				    if( $sessionStorage.get('video_call_mode') == 'emergency_video_call' ) {
						filterValue = ($filter('filter')(response, {'module': 'emergency_video_call_consultation' }));

						$rootScope.selected_category_id = filterValue[0].id;
						$rootScope.selected_doctor_charge = filterValue[0].doctor_charge;
						$rootScope.selected_category = filterValue[0].module;
						$rootScope.selected_description = "";
				    } else if ( $sessionStorage.get('video_call_mode') == 'video_call' ){
						filterValue = ($filter('filter')(response, {'module': 'video_call_consultation' }));
						
						$rootScope.selected_category_id = filterValue[1].id;
						$rootScope.selected_doctor_charge = filterValue[1].doctor_charge;
						$rootScope.selected_category = filterValue[1].module;
						$rootScope.selected_description = "";
					}

					// console.log( filterValue );
					// console.log( $rootScope.selected_category_id );
					// console.log( $rootScope.selected_category );
					// console.log( $rootScope.selected_doctor_charge );
					// console.log( $rootScope.getPayCategoryListview );

					$sessionStorage.put('video_call_mode', ""); 

			} 


			// angular.forEach(response, function(value) {
			// 	if(value.module != 'appointment') {
			// 	   $rootScope.getPayCategoryListview.push(value);

			// 	   if( value.module == 'emergency_video_call_consultation' ) {		   		
	        //             $scope.selected_category = "emergency_video_call_consultation";
			// 			//$scope.selected_category = value.id;
			// 			$scope.selected_category_name = value.module;
			// 			console.log($scope.selected_category);
			// 	   }

				   
			// 	}
			 /* if($scope.isappconsult == true) {
					if (value.module == 'chat' || value.module == 'consultation' || value.module == 'registration_fee' || value.module == 'voice_call' || value.module == 'emergency_voice_call' ) {
						$rootScope.getPayCategoryListview.push(value);
					}
				} else {
					if (value.module == 'chat' || value.module == 'consultation' || value.module == 'registration_fee' ) {
						$rootScope.getPayCategoryListview.push(value);
					}
				} */
			//});
			
		}, function(err) {
			toastr.error(err.error);
			analytics('getPayCategoryListMtd',err.error);
		});
	
	/*	$rootScope.paymentMaster = [{}]
		paymentService.getPaymentSetting().then(function(response) {
			angular.forEach(response,function(value){
				$rootScope.paymentMaster.push(value);
			});
			$rootScope.update = function() {
				$rootScope.doctor_charges = $rootScope.module;
			}
		}, function(err) {
			toastr.error(err.error);
		} */	
	};
	

	function raisePopupFunction() {
		setTimeout(function(){ $scope.raisePaypopup(); }, 5000);
	}
	
	if( $sessionStorage.get('video_call_mode') == 'emergency_video_call' || $sessionStorage.get('video_call_mode') == 'video_call') {
		$scope.getPayCategoryListMtd();
		//raisePopupFunction(); 
	}


	// Listening to the callbacks
$rootScope.showFooter = true;
$rootScope.$on(Pubnub.getMessageEventNameFor($rootScope.channel), function(ngEvent, envelope) {
	$scope.$apply(function () {
		// add message to the messages list
		chatService.getPatientList().then(function(response){
			$sessionStorage.put('totalUnread', JSON.stringify(response.total_unread));
			$rootScope.totalUnread = JSON.parse($sessionStorage.get('totalUnread'));
		})
	});
});

$rootScope.recordAge = {
  	years : 0,
  	months: 0,
  	days: 0,
    ageInDays: 0,
    ageInMonths: 0
};

$scope.refundAmount = 0;
$scope.billedAmount = 0;

$rootScope.voice_call_alert = 'false';
$rootScope.check_emergency_call = 'false';
$rootScope.voiceFile = '';

$scope.page = 1;
$scope.history = 2;
$scope.showConsultation = $sessionStorage.get('enableConsulation');
$scope.doctorPreference = JSON.parse($sessionStorage.get('preference'));

$scope.setHistory = function(id) {
	$scope.history = id;
	if($scope.history == 7){
		setTimeout(function(){
			$scope.vitalChart();
		},500);
		
	}
};

//$scope.abnormalData = {height:{color:'blue'},weight:{color:'blue'}};
$rootScope.loadBanner();
$scope.changeGrowthChart = function(id) {
	$scope.userChoice = id;
};
$scope.userPreChoice = 0;
$scope.changePrGrowthChart = function(id) {
	$scope.userPreChoice = id;
};
$rootScope.prescriptionPatient = [];
$rootScope.showSpinner = true;
var recordId = $route.current.params.Id;
$scope.recordId = recordId;
$rootScope.recordId = recordId;
$rootScope.patId = recordId;
$scope.currentView = "";
$scope.printnotes=true;
$rootScope.vitalUpdate = undefined;

	
	if($sessionStorage.get('appointment_id')) {
		$rootScope.isappconsult = 'true';
	} else {
	    $rootScope.isappconsult = 'false';	
	}

    $rootScope.getLatestVitals = function () {
		var date = new Date();
		var filt_date = $filter('date')(date, "yyyy-MM-dd");
		$rootScope.vitalDate = filt_date;
		var mr_number = '';
    	if($scope.record.mr_number!=undefined || $scope.record.mr_number!=''){
			mr_number = $scope.record.mr_number;
			$rootScope.printMr_Num = $scope.record.mr_number;
    	}
        var param = '&mr_number='+mr_number+'&date='+filt_date;

        recordService.getLatestVitals(param).then( function(response) {
			console.log('printdata',response[0])
           $rootScope.prescriptionPrintData = response[0];
		});
		recordService.visithistorydetailed(sessionStorage.getoverviewid).then(function(response) {
			$rootScope.presData = response.detailed_prescription;
			$rootScope.drName = $rootScope.presData.doctor_profile.full_name;
			$rootScope.drRegNo = $rootScope.presData.doctor_profile.registration_number;
		});
		$rootScope.printCount = 0;
    }

    $scope.accord1 = $scope.accord2 = $scope.accord3 = $scope.accord4 = $scope.accord5 = $scope.accord6 = $scope.accord7 = true;

    $rootScope.chief_complaint_new = 'false';
    $rootScope.aakash_hospital_complaint = 'false';
	$rootScope.jayakumar_complaint = 'false';
	var arrIndex; 

    if (authService.authentication.account_id == 'rx21735@rxcarenet.org') {
        $rootScope.aakash_hospital_complaint = 'true';
      //$scope.complaintNames  =  ['', 'Abdominal pain', 'Anorexia', 'Cold', 'Cough', 'Chest pain', 'Diarrhea', 'Dyspnoea', 'Difficulty in swallowing', 'Ear pain', 'Bleeding from nose', 'Fever', 'Fast breathing', 'Blood stained vomiting', 'Hematocheisia', 'Blackish stools', 'Oedema', 'Red eye', 'Seizures', 'Vomiting', 'Vaccination', 'Blood stained semisolid stool'];
        $scope.complaintNames  =  ['', 'Abdominal pain', 'Loss of appetite', 'Cold', 'Cough', 'Chest pain', 'Diarrhea', '', 'Difficulty in swallowing', 'Ear pain', 'Bleeding from nose', 'Fever', 'Fast breathing', '', '' ,'Blackish stools', 'Oedema', 'Red eye', 'Seizures', 'Vomiting', 'Vaccination', 'Blood stained semisolid stool', 'Others'];
        arrIndex               =  Array(22);
        $scope.arrIndexVal     =  23;
        $scope.sinceDaysValues =  arrIndex;
        $scope.otInfValues     =  arrIndex;
    } else if (authService.authentication.account_id == "rx3@rxcarenet.org" || authService.authentication.account_id == 'rx23443@rxcarenet.org') {
		$rootScope.jayakumar_complaint   = 'true';
		var complaintsCount              = 23; 
		$scope.complaintIssuesJK         = [];
		$scope.complaintIssuesJK.details = [];
        $scope.selectedComplaintNums     = [];
		for(var i=0; i<complaintsCount; i++) {
			$scope.complaintIssuesJK.details[i] = [];  
			$scope.selectedComplaintNums[i] = [];
		}
	} else if (authService.authentication.account_id == 'rx9680@rxcarenet.org' || authService.authentication.account_id == 'rx4@rxcarenet.org') {
        $rootScope.chief_complaint_new = 'true';
        $scope.complaintNames  = ['', 'Abdominal pain', 'Anorexia', 'Cold', 'Cough', 'Chest pain', 'Diarrhea', 'Dyspnoea', 'Dysphagia', 'Ear pain', 'Epistaxis', 'Fever', 'Fast breathing', 'Haemetemesis', 'Hematocheisia', 'Malena', 'Oedema', 'Red eye', 'Seizures', 'Vomiting', 'Other Complaints'];
        arrIndex               = Array(20);
        $scope.arrIndexVal     = 21;
        $scope.sinceDaysValues = arrIndex;
        $scope.otInfValues     = arrIndex;
    }

    $scope.toggleValue = false;
	$scope.showEdit    = true;
	$scope.showSave    = false;

	$scope.complaintIssues          = [];
	$scope.complaintIssues.details  = [];
	$scope.complaintIssues2         = [];
	$scope.complaintIssues2.details = [];
	$scope.complaintId              = "";

	//function to load the analytics
	function analytics(aEvent,aLabel) {
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
		var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net') {
            gtag('config', 'G-XGBKLLH8JX');
        } else {    
            gtag('config', 'UA-99604994-7');
        }
		gtag('event', aEvent, {
			'event_category' : 'patientviewController',
			'event_label' : aLabel
		});
    } 

	function createIssueArray(val) {
		for(var i=0;i<val;i++) {
			$scope.complaintIssues.details[i]  = [];  
			$scope.complaintIssues2.details[i] = [];    
		}
	}

    if ($scope.arrIndexVal == 23) {
        createIssueArray(23);
    } else if ($scope.arrIndexVal == 21) {
        createIssueArray(21);
    }

function createNewIssues(data){
	$scope.savedIssues=[];
	$scope.savedIssues=data;
			
	var tempArray = [];
	tempArray.issues = [];
	angular.forEach(data, function(value, key) {		
		tempArray.issues.push({category_id : value.complaint_category_id,complaint_category_id: value.complaint_category_id, complaint_type: value.complaint_category,complaint_category:value.complaint_category,date:value.date});							 
		tempArray.issues[key].details=[];
		tempArray.issues[key].details.push(value.details[0]);	
	});
				
	$scope.complaintNewModel=[];
	$scope.complaintNewModel=tempArray;   
  }

function updateComplaintChief(){
	
		var data = {
			account_email: $rootScope.authentication.account_id,
			user_type: "doctor",
			patient_email: $sessionStorage.get('patientAccEmail'),
			appointment_id: $sessionStorage.get('appointment_id')
		};

		recordService.loadLastComplaint(data).then(function(response){
			console.log("complientId****"+ response.complaint.id)
			$scope.complaintId = response.complaint.id;					
			if(response.complaint.issues){
				createNewIssues(response.complaint.issues);
			}			
		//$scope.complaintModels.complaint_id = response.complaint.id;	
		});
}

function saveNewComplaint(){
		//alert("save new com");
	var data = {
		account_email: $rootScope.authentication.account_id,
		simple_complaint: {
			user_type: "doctor",
			issues: $scope.complaintNewModel.issues,
			days:"",
			medicine_given:"",
			temperature: "",
			unit: "",
			other_information:"",
			patient_email: $sessionStorage.get('patientAccEmail'),
			appointment_id: $sessionStorage.get('appointment_id')
		}
	}

	 /* if($sessionStorage.get('complaint')=="edit") {
			data.simple_complaint.new_issues = $scope.complaintModel.new_issues;
			data.simple_complaint.complaint_id = $scope.complaintModel.id;
			if($scope.complaintModel.delete_issues.length!=0){
				data.simple_complaint.delete_issues = $scope.complaintModel.delete_issues;
			}
			//delete data.simple_complaint['appointment_id'];
     	} */

		complaintService.saveComplaint(data,"simplecomplaint").then(function(response) {
			//$scope.complaintId = response.complaint.id;			
		  	$scope.complaintSaved = true;
				$scope.opReview.complaint = response.complaint;
				$scope.closePopup();
				$sessionStorage.put('complaint','');
				toastr.success('Complaint saved successfully.');
				$scope.getOverview();
				updateComplaintChief();
		}, function(error) {
				$scope.closePopup();
				toastr.error(error.error);
				analytics('saveNewComplaint',error.error);
		});
}

function updateNewComplaint(){
	
	var data; 
	if($scope.complaintNewDelModel.issues.length!=0){	
	  
	  data = {
	  	account_email: $rootScope.authentication.account_id,
	  	simple_complaint: {
			user_type: "doctor",
			issues: $scope.complaintNewModel.issues,
			new_issues: $scope.complaintNewUptModel.issues,
			delete_issues:$scope.complaintNewDelModel.issues,
			days:"",
			medicine_given:"",
			temperature: "",
			unit: "",
			other_information:"",
			patient_email: $sessionStorage.get('patientAccEmail'),
			appointment_id: $sessionStorage.get('appointment_id'),
			complaint_id: $scope.complaintId,
	  	}
	  }
		
	} else {

	  	data = {
				account_email: $rootScope.authentication.account_id,
				simple_complaint: {
					user_type: "doctor",
					issues: $scope.complaintNewModel.issues,
					new_issues: $scope.complaintNewUptModel.issues,
					days: "",
					medicine_given: "",
					temperature: "",
					unit: "",
					other_information: "",
					patient_email: $sessionStorage.get('patientAccEmail'),
					appointment_id: $sessionStorage.get('appointment_id'),
					complaint_id: $scope.complaintId, 
					//complaint_id: "b9ce5429-1841-45d0-a43b-f94740b1ebee"
		    }
	  	}
  }

  /*if($sessionStorage.get('complaint')=="edit") {
				data.simple_complaint.new_issues = $scope.complaintModel.new_issues;
				data.simple_complaint.complaint_id = $scope.complaintModel.id;
				if($scope.complaintModel.delete_issues.length!=0){
					data.simple_complaint.delete_issues = $scope.complaintModel.delete_issues;
				}
			//delete data.simple_complaint['appointment_id'];
	} */

complaintService.saveComplaint(data,"updatecomplaint").then(function(response) {
	$scope.complaintId = response.complaint.id;
  	$scope.complaintNewDelModel = [];
    $scope.complaintNewDelModel.issues = [];
	$scope.updatedComplaints = [];		
    $scope.complaintNewUptModel = [];
    $scope.complaintNewUptModel.issues = [];
	$scope.opReview.complaint = response.complaint;
	$scope.closePopup();
	$sessionStorage.put('complaint','');
	toastr.success('Complaint updated successfully.');
	$scope.getOverview();
}, function(error) {
	$scope.closePopup();
	toastr.error(error.error);
	analytics('updateNewComplaint',error.error);
});

}

$scope.complaintNewModel = [];
$scope.complaintNewModel.issues = [];

function createComplaintObj() {
	var initIndex = 0;		

	angular.forEach($scope.existComplaints, function(value, key) {
  
	  angular.forEach($scope.complainTypeIds, function(val, keys) {	

			if(val.complaint_type==value.complaint_Name&&value.deleted=='no') {		
				
                for (var i = 0; i < $scope.arrIndexVal; i++) {
					if(i==value.complaint_No) {

					 $scope.complaintNewModel.issues.push({category_id : val.complaint_id,complaint_category_id: val.complaint_id, complaint_type: value.complaint_Name});							 
					 $scope.complaintNewModel.issues[initIndex].details=[];
								
						 var sinceId = "sinceDay" + value.complaint_No;
						 var otId = "otInform" + value.complaint_No;

						 var answerVal = "";

						 if(value.complaint_Name=="Fever"){

                            var sinceVal  = document.getElementById(sinceId).value;
							var feverTemp = document.getElementById("feverTemp").value;
												
							if( feverTemp >= 93 && feverTemp <= 105 ){
								
								feverTemp ="^~^Temp max "+feverTemp; 
							} else {
								feverTemp = 0;
								feverTemp = "^~^Temp max "+feverTemp; 
							}

							var otVal = document.getElementById(otId).value;
    					    var sinceVal  = document.getElementById(sinceId).value;
								
							if(sinceVal!=""){
								sinceVal  = "^~^Since "+sinceVal+" days";
							}

							if(otVal!=""){
								otVal  = "^~^"+otVal;
							}

							if($scope.complaintIssues2.details[i][0]!=undefined){
										var compIssue1=$scope.complaintIssues2.details[i][0];
                    var compIssue2=$scope.complaintIssues.details[i][0];

										if(compIssue1!=""){
											compIssue1="^~^"+compIssue1;
										}
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
										answerVal = ""+compIssue1+""+compIssue2+""+sinceVal+""+feverTemp+""+otVal; 

					   	} else if($scope.complaintIssues.details[i][0]!=undefined){

										var compIssue2=$scope.complaintIssues.details[i][0];
											
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
											answerVal = ""+compIssue2+""+sinceVal+""+feverTemp+""+otVal; 

							} else {
							      	answerVal = ""+sinceVal+""+feverTemp+""+otVal; 				
							}
							

						 } else if(value.complaint_Name=="Seizures"){
            
						var dateObj = $scope.record.dob;
						var month   = dateObj.getUTCMonth() + 1; //months from 1-12
						var day     = dateObj.getUTCDate();
						var year    = dateObj.getUTCFullYear();
						var newdate = day+"/"+month+"/"+year;

						newdate = newdate + " 00:00";

						var seizureDays = document.getElementById("seizureDays").value;
						var seizureDayss = seizureDays + " 00:00";

            //if( new Date(seizureDayss) > new Date(newdate) ){												 
            //var seizureDays = document.getElementById("seizureDays").value;
							var seizureMins = document.getElementById("seizureMins").value;
							var otVal = document.getElementById(otId).value;

							if(seizureMins!=""){
								seizureMins =	"^~^Seizure last for "+seizureMins+" mins";
							}

							if(seizureDays!=""){
								seizureDays =	"^~^Occured on "+seizureDays;
							}

							if(otVal!=""){
								otVal  = "^~^"+otVal;
							}

							if($scope.complaintIssues2.details[i][0]!=undefined){
										var compIssue1=$scope.complaintIssues2.details[i][0];
										var compIssue2=$scope.complaintIssues.details[i][0];

										if(compIssue1!=""){
											compIssue1="^~^"+compIssue1;
										}
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
										answerVal = ""+compIssue1+""+compIssue2+""+seizureDays+""+seizureMins+""+otVal; 

					     	} else if($scope.complaintIssues.details[i][0]!=undefined){

										var compIssue2=$scope.complaintIssues.details[i][0];
											
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
											answerVal = ""+compIssue2+""+seizureDays+""+seizureMins+""+otVal; 

							} else {
								if(seizureDays!=""||seizureMins!=""){
									answerVal = ""+seizureDays+""+seizureMins+""+otVal; 	
								} 				
							}
					/*} else {
							alert("Please correct the date. Entered date is prior to DOB");							
						}*/

                         } else if (value.complaint_Name == "Other Complaints" || value.complaint_Name == "Vaccination" || value.complaint_Name == "Others") {

						    var otVal  = document.getElementById(otId).value;	
							answerVal  = otVal; 
                
						} else {
                            
							var sinceVal = document.getElementById(sinceId).value;					
							var otVal    = document.getElementById(otId).value;	

							if(sinceVal!=""){
								sinceVal  = "^~^Since "+sinceVal+" days";
							}

							if(otVal!=""){
								otVal  = "^~^"+otVal;
							}

							if($scope.complaintIssues2.details[i][0]!=undefined){
								var compIssue1=$scope.complaintIssues2.details[i][0];
                                var compIssue2=$scope.complaintIssues.details[i][0];
								
								if(compIssue1!=""){
									compIssue1="^~^"+compIssue1;
								}
								
								if(compIssue2!=""){
									compIssue2="^~^"+compIssue2;
								}
								answerVal = ""+compIssue1+""+compIssue2+""+sinceVal+""+otVal;

					     	} else if($scope.complaintIssues.details[i][0]!=undefined){

								var compIssue2=$scope.complaintIssues.details[i][0];
											
								if(compIssue2!=""){
									compIssue2="^~^"+compIssue2;
								}
								answerVal = ""+compIssue2+""+sinceVal+""+otVal; 

							} else {
							    answerVal = ""+sinceVal+""+otVal; 				
							}

						}

					  $scope.complaintNewModel.issues[initIndex].details.push({questions:"",answers:answerVal});					
						initIndex = initIndex+1;
				}
			}	
				 	
		 /* if(i==value.complaint_No) {
					$scope.complaintNewModel.issues[key].details.push({questions:"", answers:"yes"});
		   	} */
			}
		});
	});

	saveNewComplaint();
}


$scope.complaintNewUptModel = [];
$scope.complaintNewUptModel.issues = [];

function updateComplaintObj(){
	
	var initIndex = 0;	

	if($scope.updatedComplaints.length!=0){

  	angular.forEach($scope.updatedComplaints, function(value, key) {
     	angular.forEach($scope.complainTypeIds, function(val, keys) {	

		  	if(val.complaint_type==value.complaint_Name && value.deleted=='no') {			
                for (var i = 0; i < $scope.arrIndexVal; i++){
				    if(i==value.complaint_No){
					
							$scope.complaintNewUptModel.issues.push({category_id : val.complaint_id, complaint_type: value.complaint_Name});							 
							$scope.complaintNewUptModel.issues[initIndex].details=[];
					
							var sinceId = "sinceDay" + value.complaint_No;
							var otId = "otInform" + value.complaint_No;

							var answerVal="";

							if(value.complaint_Name=="Fever"){

								var sinceVal  = document.getElementById(sinceId).value;
								var feverTemp = document.getElementById("feverTemp").value;
												
								if( feverTemp >= 93 && feverTemp <= 105 ){
							
									feverTemp ="^~^Temp max "+feverTemp; 
								} else {
									feverTemp = 0;
									feverTemp = "^~^Temp max "+feverTemp; 
								}

								var otVal = document.getElementById(otId).value;
								var sinceVal  = document.getElementById(sinceId).value;
									
								if(sinceVal!=""){
									sinceVal  = "^~^Since "+sinceVal+" days";
								}

							if(otVal!=""){
								otVal  = "^~^"+otVal;
							}

							if($scope.complaintIssues2.details[i][0]!=undefined){
										var compIssue1=$scope.complaintIssues2.details[i][0];
										var compIssue2=$scope.complaintIssues.details[i][0];

										if(compIssue1!=""){
											compIssue1="^~^"+compIssue1;
										}
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
										answerVal = ""+compIssue1+""+compIssue2+""+sinceVal+""+feverTemp+""+otVal; 

					   	} else if($scope.complaintIssues.details[i][0]!=undefined){

										var compIssue2=$scope.complaintIssues.details[i][0];
											
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
											answerVal = ""+compIssue2+""+sinceVal+""+feverTemp+""+otVal; 

							} else {
							    answerVal = ""+sinceVal+""+feverTemp+""+otVal; 				
							}
							

			} else if(value.complaint_Name=="Seizures"){
            
						var dateObj = $scope.record.dob;
						var month   = dateObj.getUTCMonth() + 1; //months from 1-12
						var day     = dateObj.getUTCDate();
						var year    = dateObj.getUTCFullYear();
						var newdate = day+"/"+month+"/"+year;

						newdate = newdate + " 00:00";

						var seizureDays = document.getElementById("seizureDays").value;
						var seizureDayss = seizureDays + " 00:00";

          //if( new Date(seizureDayss) > new Date(newdate) ){
														 
          //var seizureDays = document.getElementById("seizureDays").value;
						var seizureMins = document.getElementById("seizureMins").value;
						var otVal = document.getElementById(otId).value;

						if(seizureMins!=""){
							seizureMins =	"^~^Seizure last for "+seizureMins+" mins";
						}

						if(seizureDays!=""){
							seizureDays  =	"^~^Occured on "+seizureDays;
						}

						if(otVal!=""){
							otVal  = "^~^"+otVal;
						}

						if($scope.complaintIssues2.details[i][0]!=undefined){
										var compIssue1=$scope.complaintIssues2.details[i][0];
										var compIssue2=$scope.complaintIssues.details[i][0];

										if(compIssue1!=""){
											compIssue1="^~^"+compIssue1;
										}
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
										answerVal = ""+compIssue1+""+compIssue2+""+seizureDays+""+seizureMins+""+otVal; 

					    } else if($scope.complaintIssues.details[i][0]!=undefined){

										var compIssue2=$scope.complaintIssues.details[i][0];
											
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
											answerVal = ""+compIssue2+""+seizureDays+""+seizureMins+""+otVal; 

						} else {
								if(seizureDays!=""||seizureMins!=""){
									answerVal = ""+seizureDays+""+seizureMins+""+otVal; 	
								} 				
						}

					/*} else {
							alert("Please correct the date. Entered date is prior to DOB");							
						}*/

                            } else if (value.complaint_Name == "Other Complaints" || value.complaint_Name == "Vaccination") {

							var otVal  = document.getElementById(otId).value;	
							answerVal  = otVal; 
						
		    		} else {
							
					  	var sinceVal  = document.getElementById(sinceId).value;							
							var otVal     = document.getElementById(otId).value;	

							if(sinceVal!=""){
								sinceVal  = "^~^Since "+sinceVal+" days";
							}

							if(otVal!=""){
								otVal  = "^~^"+otVal;
							}

				
							if($scope.complaintIssues2.details[i][0]!=undefined){
										var compIssue1=$scope.complaintIssues2.details[i][0];
										var compIssue2=$scope.complaintIssues.details[i][0];

										if(compIssue1!=""){
											compIssue1="^~^"+compIssue1;
										}
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
										answerVal = ""+compIssue1+""+compIssue2+""+sinceVal+""+otVal; 
					   	} else if($scope.complaintIssues.details[i][0]!=undefined){

										var compIssue2=$scope.complaintIssues.details[i][0];
											
										if(compIssue2!=""){
											compIssue2="^~^"+compIssue2;
										}
											answerVal = ""+compIssue2+""+sinceVal+""+otVal; 
							} else {
							    	answerVal = ""+sinceVal+""+otVal; 				
							}

						 }

						 $scope.complaintNewUptModel.issues[initIndex].details.push({questions:"",answers:answerVal});
						 initIndex=initIndex+1;

						}
				 }	
				 	
		 /* if(i==value.complaint_No) {
					$scope.complaintNewModel.issues[key].details.push({questions:"", answers:"yes"});
		   	} */
			}
		});
	});

	updateNewComplaint();

} else {

		angular.forEach($scope.openComplaints, function(value, key) {
  
			angular.forEach($scope.complaintNewModel.issues, function(val, keys) {	
			    if(val.complaint_category==value.complaint_Name&&value.deleted=='no') {
			         
                    for (var i = 0; i < $scope.arrIndexVal; i++){
									if(i==value.complaint_No){
								
									 $scope.complaintNewUptModel.issues.push({category_id : val.complaint_category_id,complaint_category_id: val.complaint_category_id, complaint_type: val.complaint_category,complaint_category:val.complaint_category,date:val.date});							 
									 
								angular.forEach(val.details, function(valss, keyss) {		 
									 $scope.complaintNewUptModel.issues[initIndex].details=[];
										
										 var sinceId = "sinceDay" + value.complaint_No;
										 var otId = "otInform" + value.complaint_No;
				
										var answerVal = "";
				
										if(value.complaint_Name=="Fever"){

											var sinceVal  = document.getElementById(sinceId).value;
											var feverTemp = document.getElementById("feverTemp").value;
															
											if( feverTemp >= 93 && feverTemp <= 105 ){
											
												feverTemp ="^~^Temp max "+feverTemp; 
											} else {
												feverTemp = 0;
												feverTemp = "^~^Temp max "+feverTemp; 
											}
				
											var otVal = document.getElementById(otId).value;
											var sinceVal  = document.getElementById(sinceId).value;
												
											if(sinceVal!=""){
												sinceVal  = "^~^Since "+sinceVal+" days";
											}
				
											if(otVal!=""){
												otVal  = "^~^"+otVal;
											}
				
											if($scope.complaintIssues2.details[i][0]!=undefined){
														var compIssue1=$scope.complaintIssues2.details[i][0];
				                    var compIssue2=$scope.complaintIssues.details[i][0];
														if(compIssue1!=""){
															compIssue1="^~^"+compIssue1;
														}
														if(compIssue2!=""){
															compIssue2="^~^"+compIssue2;
														}
														answerVal = ""+compIssue1+""+compIssue2+""+sinceVal+""+feverTemp+""+otVal; 
				
											 } else if($scope.complaintIssues.details[i][0]!=undefined){
				
														var compIssue2=$scope.complaintIssues.details[i][0];
															
														if(compIssue2!=""){
															compIssue2="^~^"+compIssue2;
														}
															answerVal = ""+compIssue2+""+sinceVal+""+feverTemp+""+otVal; 
				
											} else {
															answerVal = ""+sinceVal+""+feverTemp+""+otVal; 				
											}
											
				
										 } else if(value.complaint_Name=="Seizures"){
										
										var dateObj = $scope.record.dob;
										var month   = dateObj.getUTCMonth() + 1; //months from 1-12
										var day     = dateObj.getUTCDate();
										var year    = dateObj.getUTCFullYear();
										var newdate = day+"/"+month+"/"+year;
				
										newdate = newdate + " 00:00";
				
										var seizureDays = document.getElementById("seizureDays").value;
										var seizureDayss = seizureDays + " 00:00";
			
									 // if( new Date(seizureDayss) > new Date(newdate) ){																		 
									 // var seizureDays = document.getElementById("seizureDays").value;
											var seizureMins = document.getElementById("seizureMins").value;
											var otVal = document.getElementById(otId).value;
								
											if(seizureMins!=""){
												seizureMins =	"^~^Seizure last for "+seizureMins+" mins";
											}
								
											if(seizureDays!=""){
												seizureDays  =	"^~^Occured on "+seizureDays;
											}
								
											if(otVal!=""){
												otVal  = "^~^"+otVal;
											}											
				
											if($scope.complaintIssues2.details[i][0]!=undefined){
														var compIssue1=$scope.complaintIssues2.details[i][0];
				                    var compIssue2=$scope.complaintIssues.details[i][0];
														if(compIssue1!=""){
															compIssue1="^~^"+compIssue1;
														}
														if(compIssue2!=""){
															compIssue2="^~^"+compIssue2;
														}
														answerVal = ""+compIssue1+""+compIssue2+""+seizureDays+""+seizureMins+""+otVal; 
				
											 } else if($scope.complaintIssues.details[i][0]!=undefined){
				
														var compIssue2=$scope.complaintIssues.details[i][0];
															
														if(compIssue2!=""){
															compIssue2="^~^"+compIssue2;
														}
															answerVal = ""+compIssue2+""+seizureDays+""+seizureMins+""+otVal; 
				
											} else {
												if(seizureDays!=""||seizureMins!=""){
													answerVal = ""+seizureDays+""+seizureMins+""+otVal; 	
												} 				
											}
							
									/*	} else {
											alert("Please correct the date. Entered date is prior to DOB");
											
										}*/									
				
                                        } else if (value.complaint_Name == "Other Complaints" || value.complaint_Name == "Vaccination") {

											var otVal  = document.getElementById(otId).value;	
										  answerVal  = otVal; 
										
							    } else {
				
											var sinceVal  = document.getElementById(sinceId).value;
											var otVal     = document.getElementById(otId).value;	
				
											if(sinceVal!=""){
												sinceVal  = "^~^Since "+sinceVal+" days";
											}
				
											if(otVal!=""){
												otVal  = "^~^"+otVal;
											}
								
											if($scope.complaintIssues2.details[i][0]!=undefined){
														var compIssue1=$scope.complaintIssues2.details[i][0];
														var compIssue2=$scope.complaintIssues.details[i][0];

														if(compIssue1!=""){
															compIssue1="^~^"+compIssue1;
														}
														if(compIssue2!=""){
															compIssue2="^~^"+compIssue2;
														}
														answerVal = ""+compIssue1+""+compIssue2+""+sinceVal+""+otVal; 
											 } else if($scope.complaintIssues.details[i][0]!=undefined){
				
														var compIssue2=$scope.complaintIssues.details[i][0];
															
														if(compIssue2!=""){
															compIssue2="^~^"+compIssue2;
														}
															answerVal = ""+compIssue2+""+sinceVal+""+otVal; 
											} else {
														answerVal = ""+sinceVal+""+otVal; 				
											}				
				
										 }

										 $scope.complaintNewUptModel.issues[initIndex].details.push({questions:"",answers:answerVal,issue_id:valss.issue_id,days:valss.days});
										 initIndex=initIndex+1;
									});

								}
							}
						}
					 });

				});
						 
			$scope.complaintNewModel = [];
			$scope.complaintNewModel = $scope.complaintNewUptModel;
			$scope.complaintNewUptModel = [];
			$scope.complaintNewUptModel.issues = [];
			
			updateNewComplaint();	
	}
	
}

$scope.uptComplaint=false;

$scope.saveAllValue = function(){
	updateComplaintChief();
	$scope.showSave = true;
	$scope.showEdit = false;  
	
	 if($scope.uptComplaint==false){
			createComplaintObj();
			$scope.uptComplaint=true;
	 }else if($scope.uptComplaint==true){	
	  	updateComplaintObj();
	 }
}

$scope.onUpdate = function(){
	$scope.showSave = true;
	$scope.showEdit = false;
	$scope.uptComplaint = true;	
}

$scope.saveIssueValues2 = function(idVal, compNo, multiVal) {
	var idName = '#'+idVal;
	var labelName = $(idName).attr('value');

    if(multiVal!=undefined) {
  		if($scope.complaintIssues2.details[compNo].length==0) {
			$scope.complaintIssues2.details[compNo].push(labelName);
		} else {
			$scope.complaintIssues2.details[compNo]=[];
			$scope.complaintIssues2.details[compNo].push(labelName);
		}
	}
}

$scope.saveIssueValues = function(idVal,compNo) {	
  //$rootScope.Complaints = {};
	var idName='#'+idVal;
	var labelName = $(idName).attr('value');
			
	if($scope.complaintIssues.details[compNo].length==0) {
		$scope.complaintIssues.details[compNo].push(labelName);
	} else {

		if($scope.complaintIssues.details[compNo]==labelName) {
			
			$scope.complaintIssues.details[compNo]=[];
		  //document.getElementById("labSel17").style.color = "#c3c3a2";
			document.getElementById("labSel1").style.color = "#000000";

		} else {
			$scope.complaintIssues.details[compNo]=[];
			$scope.complaintIssues.details[compNo].push(labelName);
		}
	}

}

$scope.complaintSaved              = false;
$scope.complaintNewDelModel        = [];
$scope.complaintNewDelModel.issues = [];

$scope.removeDiv = function(val,name) {	
	
	var initVal=0;
	for(var i=0; i<$scope.divCounts.length;i++){
		if(val==$scope.divCounts[i].complaint_no){
			if($scope.complaintSaved==true){
					$scope.existComplaints[i] = {"complaint_No":"","complaint_Name":"","deleted":'yes'};
					$scope.openComplaints[i] = {"complaint_No":"","complaint_Name":"","deleted":'yes'};
					if($scope.updatedComplaints.length!=0){
						$scope.updatedComplaints[i] = {"complaint_No":"","complaint_Name":"","deleted":'yes'}; 
					} 
			} else {					
					 $scope.existComplaints[i] = {"complaint_No":"","complaint_Name":"","deleted":'no'};
					 $scope.openComplaints[i] = {"complaint_No":"","complaint_Name":"","deleted":'no'};
					 if($scope.updatedComplaints.length!=0){
							 $scope.updatedComplaints[i] = {"complaint_No":"","complaint_Name":"","deleted":'no'}; 
					 }
			}
	
			var divIdVal = $scope.divCounts[i].complaint_id;
			document.getElementById("inlineCheckbox"+val).style.color = "#337ab7";
			var el = document.getElementById(divIdVal);
					el.remove(); 
					countDiv=countDiv-1;

			if($scope.complaintSaved==true) {

                if($scope.savedIssues) {
					for(var i=0; i<$scope.savedIssues.length; i++) {
								
							if($scope.savedIssues[i].complaint_category==name) {													
									$scope.complaintNewDelModel.issues.push({category_id : $scope.savedIssues[i].complaint_category_id,complaint_category_id: $scope.savedIssues[i].complaint_category_id, complaint_type: $scope.savedIssues[i].complaint_category,complaint_category:$scope.savedIssues[i].complaint_category,date:$scope.savedIssues[i].date});							 
									$scope.complaintNewDelModel.issues[initVal].details=[];
									$scope.complaintNewDelModel.issues[initVal].details.push($scope.savedIssues[i].details[0]);	                           
									initVal++;
							}          
				  	}
				}

			}

        }
	}
		
	/* $scope.openComplaints;
	   $scope.existComplaints;
       $scope.updatedComplaints; */
}

$scope.divCounts = [];

function createDiv(compNum,acNo) {	
	var divIdName     =  "newDivs"+countDiv;
	var panelIdName   =  "#at-birth"+countAccord;
	var panelIdName2  =  "at-birthh"+countAccord;
	var compNo        =  compNum;

	$scope.divCounts.push({complaint_no:compNum,complaint_id:divIdName});

	$(panelIdName).removeClass('in');
	var elem = document.createElement('div');	 
	elem.setAttribute("id", divIdName);

	var cont = document.getElementById(panelIdName2);
	cont.appendChild(elem);

	var el = document.getElementById(divIdName);
    el.setAttribute("ng-include", "'app/baby-profile/Complaints/Complaints_"+compNo+".tpl.html'");
  //angular.element(el).injector().invoke(function($compile){
		$injector.invoke(function($compile){
		var scope = angular.element(el).scope();
		$compile(el)(scope);
	});
}  

var countDiv    = 0;
var countAccord = 1;
var indexAccord = 0;
$scope.existComplaints   = [];
$scope.updatedComplaints = []; 
$scope.openComplaints    = [];

$scope.changeAccord = function(val, id, num) {

	$scope.openComplaints.push({"complaint_No":num,"complaint_Name":$scope.complaintNames[num],"deleted":'no'});

	if($scope.uptComplaint==false){
    	$scope.existComplaints.push({"complaint_No":num,"complaint_Name":$scope.complaintNames[num],"deleted":'no'});
 	} else if($scope.uptComplaint==true){
    	$scope.updatedComplaints.push({"complaint_No":num,"complaint_Name":$scope.complaintNames[num],"deleted":'no'});
	}
	countDiv = countDiv+1;
    
	switch(countDiv){
		case 1:
		$scope.accord1 = false;
	    $scope.accord2 = true;
	    $scope.accord3 = true;
	    $scope.accord4 = true;
	    $scope.accord5 = true;
		$scope.accord6 = true;
		$scope.accord7 = true;
		createDiv(num,val);
		break;
		case 4:
		countAccord=countAccord+1;
		$scope.accord1 = false;
	    $scope.accord2 = false;
	    $scope.accord3 = true;
	    $scope.accord4 = true;
	    $scope.accord5 = true;
		$scope.accord6 = true;
		$scope.accord7 = true;
		createDiv(num,val);
		break;
		case 7:
		countAccord=countAccord+1;
		$scope.accord1 = false;
		$scope.accord2 = false;
		$scope.accord3 = false;
		$scope.accord4 = true;
		$scope.accord5 = true;
		$scope.accord6 = true;
		$scope.accord7 = true;
		createDiv(num,val);
		break;
		case 10:
		countAccord=countAccord+1;
		$scope.accord1 = false;
		$scope.accord2 = false;
		$scope.accord3 = false;
		$scope.accord4 = false;
		$scope.accord5 = true;
		$scope.accord6 = true;
		$scope.accord7 = true;
		createDiv(num,val);
		break;
		case 13:
		countAccord=countAccord+1;
		$scope.accord1 = false;
		$scope.accord2 = false;
		$scope.accord3 = false;
		$scope.accord4 = false;
		$scope.accord5 = false;
		$scope.accord6 = true;
		$scope.accord7 = true;
		createDiv(num,val);
		break;
		case 16:
		countAccord=countAccord+1;
		$scope.accord1 = false;
	    $scope.accord2 = false;
	    $scope.accord3 = false;
	    $scope.accord4 = false;
	    $scope.accord5 = false;
		$scope.accord6 = false;
		$scope.accord7 = true;
		createDiv(num,val);
		break;
		case 19:
		countAccord=countAccord+1;
		$scope.accord1 = false;
	    $scope.accord2 = false;
	    $scope.accord3 = false;
	    $scope.accord4 = false;
	    $scope.accord5 = false;
		$scope.accord6 = false;
		$scope.accord7 = false;
		createDiv(num,val);
		break;
		default:
		if(countDiv!=1 && countDiv!=4 && countDiv!=7 && countDiv!=10 && countDiv!=13 && countDiv!=16 && countDiv!=19){
			createDiv(num,val);
		}
		break;
	}

	document.getElementById(id).style.color = "#ff6600";

	/*switch(val){
	  case 1:
	  $scope.accord1 = false;
	  $scope.accord2 = true;
	  $scope.accord3 = true;
	  $scope.accord4 = true;
	  $scope.accord5 = true;
	  $scope.accord6 = true;
	  createDiv();	
	  break;	
	  case 2:
	  $scope.accord1 = false;
	  $scope.accord2 = false;
	  $scope.accord3 = true;
	  $scope.accord4 = true;
	  $scope.accord5 = true;
	  $scope.accord6 = true;
	  createDiv();	
	  break;
	  case 31:
	  $scope.accord1 = false;
	  $scope.accord2 = false;
	  $scope.accord3 = true;
	  $scope.accord4 = true;
	  $scope.accord5 = true;
	  $scope.accord6 = true;
      createDiv();	
	  break;
	  case 4:
	  $scope.accord1 = true;
	  $scope.accord2 = true;
	  $scope.accord3 = true;
	  $scope.accord4 = false;
	  $scope.accord5 = true;
	  $scope.accord6 = true;
	  createDiv();	
	  break;
	  case 5:
	  $scope.accord1 = true;
	  $scope.accord2 = true;
	  $scope.accord3 = true;
	  $scope.accord4 = true;
	  $scope.accord5 = false;
	  $scope.accord6 = true;
	  createDiv();	
	  break;
	  case 6:
	  $scope.accord1 = true;
	  $scope.accord2 = true;
	  $scope.accord3 = true;
	  $scope.accord4 = true;
	  $scope.accord5 = true;
	  $scope.accord6 = false;
	  createDiv();	
	  break;
	  default:
	  $scope.accord1 = true;
	  $scope.accord2 = true;
	  $scope.accord3 = true;
	  $scope.accord4 = true;
	  $scope.accord5 = true;
	  $scope.accord6 = true;
	  createDiv();	
	}*/
};

$scope.setActive = function(val,compNo,multiVal) {

	if(multiVal=="multi2"){
  	$scope.saveIssueValues2(val,compNo,multiVal);
	} else {
    $scope.saveIssueValues(val,compNo);
	}

	if(val=="labSel1" || val=="labSel2" || val=="labSel3"){
		if(val=="labSel1"){
			document.getElementById("labSel1").style.color = "#ff6600";
			document.getElementById("labSel2").style.color = "#c3c3a2";
			document.getElementById("labSel3").style.color = "#c3c3a2";		
		} else if(val=="labSel2"){
			document.getElementById("labSel1").style.color = "#c3c3a2";
			document.getElementById("labSel2").style.color = "#ff6600";
			document.getElementById("labSel3").style.color = "#c3c3a2";
		} else if(val=="labSel3"){
			document.getElementById("labSel1").style.color = "#c3c3a2";
			document.getElementById("labSel2").style.color = "#c3c3a2";
			document.getElementById("labSel3").style.color = "#ff6600";
		}
	} else if(val=="labSel4"){	
			document.getElementById("labSel4").style.color = "#ff6600";
	} else if(val=="labSel5" || val=="labSel6"){
		if(val=="labSel5"){
			document.getElementById("labSel5").style.color = "#ff6600";
			document.getElementById("labSel6").style.color = "#c3c3a2";			
		} else if(val=="labSel6"){
			document.getElementById("labSel5").style.color = "#c3c3a2";
			document.getElementById("labSel6").style.color = "#ff6600";	
		} 
	}  else if(val=="labSel7" || val=="labSel8"){
		if(val=="labSel7"){
			document.getElementById("labSel7").style.color = "#ff6600";
			document.getElementById("labSel8").style.color = "#c3c3a2";			
		} else if(val=="labSel8"){
			document.getElementById("labSel7").style.color = "#c3c3a2";
			document.getElementById("labSel8").style.color = "#ff6600";
		} 
	}
	else if(val=="labSel9" || val=="labSel10"){
		if(val=="labSel9"){
			document.getElementById("labSel9").style.color = "#ff6600";
			document.getElementById("labSel10").style.color = "#c3c3a2";
			
		} else if(val=="labSel10"){
			document.getElementById("labSel9").style.color = "#c3c3a2";
			document.getElementById("labSel10").style.color = "#ff6600";
		} 
	}	else if(val=="labSel11" || val=="labSel12"){
		if(val=="labSel11"){
			document.getElementById("labSel11").style.color = "#ff6600";
			document.getElementById("labSel12").style.color = "#c3c3a2";			
		} else if(val=="labSel12"){
			document.getElementById("labSel11").style.color = "#c3c3a2";
			document.getElementById("labSel12").style.color = "#ff6600";
		} 
	} else if(val=="labSel13" || val=="labSel14"){
		if(val=="labSel13"){
			document.getElementById("labSel13").style.color = "#ff6600";
			document.getElementById("labSel14").style.color = "#c3c3a2";			
		} else if(val=="labSel14"){
			document.getElementById("labSel13").style.color = "#c3c3a2";
			document.getElementById("labSel14").style.color = "#ff6600";
		} 
	} else if(val=="labSel15") {

				document.getElementById("labSel15").style.color = "#ff6600";

  } else if(val=="labSel16" || val=="labSel17") {
			if(val=="labSel16"){
				document.getElementById("labSel16").style.color = "#ff6600";
				document.getElementById("labSel17").style.color = "#c3c3a2";
				
			} else if(val=="labSel17"){
				document.getElementById("labSel16").style.color = "#c3c3a2";
				document.getElementById("labSel17").style.color = "#ff6600";

			} 
 }
 else if(val=="labSel18" || val=="labSel19") {
	if(val=="labSel18"){
		document.getElementById("labSel18").style.color = "#ff6600";
		document.getElementById("labSel19").style.color = "#c3c3a2";
		
	} else if(val=="labSel19"){
		document.getElementById("labSel18").style.color = "#c3c3a2";
		document.getElementById("labSel19").style.color = "#ff6600";

	} 
}
else if(val=="labSel20" || val=="labSel21"){
	if(val=="labSel20"){
		document.getElementById("labSel20").style.color = "#ff6600";
		document.getElementById("labSel21").style.color = "#c3c3a2";
		
	} else if(val=="labSel21"){
		document.getElementById("labSel20").style.color = "#c3c3a2";
		document.getElementById("labSel21").style.color = "#ff6600";

	} 
}
else if(val=="labSel22" || val=="labSel23"){
	if(val=="labSel22"){
		document.getElementById("labSel22").style.color = "#ff6600";
		document.getElementById("labSel23").style.color = "#c3c3a2";
		
	} else if(val=="labSel23"){
		document.getElementById("labSel22").style.color = "#c3c3a2";
		document.getElementById("labSel23").style.color = "#ff6600";

	} 
} else if(val=="labSel24" || val=="labSel25"){
	if(val=="labSel24"){
		document.getElementById("labSel24").style.color = "#ff6600";
		document.getElementById("labSel25").style.color = "#c3c3a2";
		
	} else if(val=="labSel25"){
		document.getElementById("labSel24").style.color = "#c3c3a2";
		document.getElementById("labSel25").style.color = "#ff6600";

	} 
} else if(val=="labSel26" || val=="labSel27"){
	if(val=="labSel26"){
		document.getElementById("labSel26").style.color = "#ff6600";
		document.getElementById("labSel27").style.color = "#c3c3a2";
		
	} else if(val=="labSel27"){
		document.getElementById("labSel26").style.color = "#c3c3a2";
		document.getElementById("labSel27").style.color = "#ff6600";

	} 
} else if(val=="labSel28" || val=="labSel29"){
	if(val=="labSel28"){
		document.getElementById("labSel28").style.color = "#ff6600";
		document.getElementById("labSel29").style.color = "#c3c3a2";
		
	} else if(val=="labSel29"){
		document.getElementById("labSel28").style.color = "#c3c3a2";
		document.getElementById("labSel29").style.color = "#ff6600";

	} 
} else if(val=="labSel30" || val=="labSel31"){
	if(val=="labSel30"){
		document.getElementById("labSel30").style.color = "#ff6600";
		document.getElementById("labSel31").style.color = "#c3c3a2";
		
	} else if(val=="labSel31"){
		document.getElementById("labSel30").style.color = "#c3c3a2";
		document.getElementById("labSel31").style.color = "#ff6600";

	} 
}
else if(val=="labSel32" || val=="labSel33" || val=="labSel34" || val=="labSel35"){
	if(val=="labSel32"){
		document.getElementById("labSel32").style.color = "#ff6600";
		document.getElementById("labSel33").style.color = "#c3c3a2";
		document.getElementById("labSel34").style.color = "#c3c3a2";
		document.getElementById("labSel35").style.color = "#c3c3a2";
		
	} else if(val=="labSel33"){
		document.getElementById("labSel32").style.color = "#c3c3a2";
		document.getElementById("labSel33").style.color = "#ff6600";
		document.getElementById("labSel34").style.color = "#c3c3a2";
		document.getElementById("labSel35").style.color = "#c3c3a2";

	} else if(val=="labSel34"){
		document.getElementById("labSel32").style.color = "#c3c3a2";
		document.getElementById("labSel33").style.color = "#c3c3a2";
		document.getElementById("labSel34").style.color = "#ff6600";
		document.getElementById("labSel35").style.color = "#c3c3a2";

	} else if(val=="labSel35"){
		document.getElementById("labSel32").style.color = "#c3c3a2";
		document.getElementById("labSel33").style.color = "#c3c3a2";
		document.getElementById("labSel34").style.color = "#c3c3a2";
		document.getElementById("labSel35").style.color = "#ff6600";
	} 
	
}
 else if(val=="labSel36" || val=="labSel37"){
	if(val=="labSel36"){
		document.getElementById("labSel36").style.color = "#ff6600";
		document.getElementById("labSel37").style.color = "#c3c3a2";
		
	} else if(val=="labSel37"){
		document.getElementById("labSel36").style.color = "#c3c3a2";
		document.getElementById("labSel37").style.color = "#ff6600";

	} 
}
 else if(val=="labSel38" || val=="labSel39"|| val=="labSel40" || val=="labSel41"){
	if(val=="labSel38"){
		document.getElementById("labSel38").style.color = "#ff6600";
		document.getElementById("labSel39").style.color = "#c3c3a2";
		document.getElementById("labSel40").style.color = "#c3c3a2";
		document.getElementById("labSel41").style.color = "#c3c3a2";
	} else if(val=="labSel39"){
		document.getElementById("labSel38").style.color = "#c3c3a2";
		document.getElementById("labSel39").style.color = "#ff6600";
		document.getElementById("labSel40").style.color = "#c3c3a2";
		document.getElementById("labSel41").style.color = "#c3c3a2";
	} else if(val=="labSel40"){
		document.getElementById("labSel38").style.color = "#c3c3a2";
		document.getElementById("labSel39").style.color = "#c3c3a2";
		document.getElementById("labSel40").style.color = "#ff6600";
		document.getElementById("labSel41").style.color = "#c3c3a2";
	} else if(val=="labSel41"){
		document.getElementById("labSel38").style.color = "#c3c3a2";
		document.getElementById("labSel39").style.color = "#c3c3a2";
		document.getElementById("labSel40").style.color = "#c3c3a2";
		document.getElementById("labSel41").style.color = "#ff6600";
	}
}
else if(val=="labSel42" || val=="labSel43" || val=="labSel44"){
	if(val=="labSel42"){
		document.getElementById("labSel42").style.color = "#ff6600";
		document.getElementById("labSel43").style.color = "#c3c3a2";	
		document.getElementById("labSel44").style.color = "#c3c3a2";		
	} else if(val=="labSel43"){
		document.getElementById("labSel42").style.color = "#c3c3a2";
		document.getElementById("labSel43").style.color = "#ff6600";
		document.getElementById("labSel44").style.color = "#c3c3a2";	
	} else if(val=="labSel44"){
		document.getElementById("labSel42").style.color = "#c3c3a2";
		document.getElementById("labSel43").style.color = "#c3c3a2";
		document.getElementById("labSel44").style.color = "#ff6600";	
	} 
	
} else if(val=="labSel45" || val=="labSel46"){
	if(val=="labSel45"){
		document.getElementById("labSel45").style.color = "#ff6600";
		document.getElementById("labSel46").style.color = "#c3c3a2";
		
	} else if(val=="labSel46"){
		document.getElementById("labSel45").style.color = "#c3c3a2";
		document.getElementById("labSel46").style.color = "#ff6600";

	} 
} else if(val=="labSel47" || val=="labSel48"){
	if(val=="labSel47"){
		document.getElementById("labSel47").style.color = "#ff6600";
		document.getElementById("labSel48").style.color = "#c3c3a2";
		
	} else if(val=="labSel48"){
		document.getElementById("labSel47").style.color = "#c3c3a2";
		document.getElementById("labSel48").style.color = "#ff6600";

	} 
} else if(val=="labSel49" || val=="labSel50" || val=="labSel51"){
	if(val=="labSel49"){
		document.getElementById("labSel49").style.color = "#ff6600";
		document.getElementById("labSel50").style.color = "#c3c3a2";
		document.getElementById("labSel51").style.color = "#c3c3a2";
		
	} else if(val=="labSel50"){
		document.getElementById("labSel49").style.color = "#c3c3a2";
		document.getElementById("labSel50").style.color   ="#ff6600";
		document.getElementById("labSel51").style.color = "#c3c3a2";

	 	} else if(val=="labSel51"){
		document.getElementById("labSel49").style.color = "#c3c3a2";
		document.getElementById("labSel50").style.color = "#c3c3a2";
		document.getElementById("labSel51").style.color = "#ff6600";

	}
} else {
		document.getElementById(val).style.color = "#ff6600";
	}
}

$scope.complaintsJK = [
    {
	    complaint_no: 1,
	    complaint_tamil_name: 'அழுகை மற்றும் கோலிக்',
	    complaint_name: 'Crying and Colic',	
    },
    {
	    complaint_no: 2,
	    complaint_tamil_name: 'சிறுநீர்தானாகக்கழிதல்',
	    complaint_name: 'Enuresis'
    },
	{
		complaint_no: 3,
		complaint_tamil_name: 'காய்ச்சல்',
		complaint_name: 'Fever'
	},
	{
		complaint_no: 4,
		complaint_tamil_name: 'மயக்கநிலை',
		complaint_name: 'Syncope' 
	},
	{
		complaint_no: 5,
		complaint_tamil_name: 'தொண்டை வலி',
		complaint_name: 'Sore Throat'
	},
	{
		complaint_no: 6,
		complaint_tamil_name: 'மூக்கில் இரத்தக் கசிவுகள்',
		complaint_name: 'Nosebleeds'
	}, 
	{
		complaint_no: 7,
		complaint_tamil_name: 'மூச்சுத்திணறல் மற்றும் ஆஸ்துமா',
		complaint_name: 'Wheezing and Asthma' 
	},
	{
		complaint_no: 8,
		complaint_tamil_name: 'இருமல்',
		complaint_name: 'Cough'
	},
	{
		complaint_no: 9,
		complaint_tamil_name: 'நிணச்சுரப்பிப்புற்று',
		complaint_name: 'Lymphadenopathy'
	},	
	{
		complaint_no: 10,
		complaint_tamil_name: 'நெஞ்சு வலி',
		complaint_name:'Chest Pain' 
	},
	{
		complaint_no: 11,
		complaint_tamil_name: 'சிறுநீர் பாதை நோய்த்தொற்றுகள்',
		complaint_name: 'Urinary Tract Infections'
	},
	{
		complaint_no: 12,
		complaint_tamil_name: 'வளர்ந்து வரும் வலிகள் / குழந்தைப்பருவத்தின் தீங்கற்ற கூட்டு வலிகள்',
		complaint_name: 'Growing Pains/Benign Joint Pains of Childhood' 
	},
	{
		complaint_no: 13,
		complaint_tamil_name: 'வாந்தி',
		complaint_name: 'Vomiting' 
	},
	{
		complaint_no: 14,
		complaint_tamil_name: 'வயிற்றுப்போக்கு',
		complaint_name: 'Diarrhea'
	},
	{
		complaint_no: 15,
		complaint_tamil_name: 'இரைப்பைஉணவுக்குழாய் ரிஃப்ளக்ஸ்',
		complaint_name: 'Gastroesophageal Reflux' 
	},
	{
		complaint_no: 16,
		complaint_tamil_name: 'மலச்சிக்கல்',
		complaint_name: 'Constipation' 
	},
	{
		complaint_no: 17,
		complaint_tamil_name: 'வயிற்று வலி',
		complaint_name: 'Abdominal Pain' 
	},
	{
		complaint_no: 18,
		complaint_tamil_name: 'தலைவலி',
		complaint_name: 'Headache' 
	},
	{
		complaint_no: 19,
		complaint_tamil_name: 'பப்புலோஸ்கமஸ் வெடிப்பு',
		complaint_name: 'Papulosquamous Eruption'
	},
	{
		complaint_no: 20,
		complaint_tamil_name: 'செழிக்கத் தவறியது',
		complaint_name: 'Failure to Thrive'
	},
	{
		complaint_no: 21,
		complaint_tamil_name: 'குழந்தை பருவ உடல் பருமன்	',
		complaint_name: 'Childhood  Obesity'
	},
	{
		complaint_no: 22,
		complaint_tamil_name: 'வலிப்புத்தாக்கங்கள் மற்றும் கால்-கை வலிப்பு',
		complaint_name: 'Seizures and Epilepsy'
	}
];

var complaintsCountJK = 0;
$scope.createAccordianJK = function(id) {

   if($scope.selectedComplaintNums[id-1].length==0) {

	$scope.selectedComplaintNums[id-1]=id;

	document.getElementById("inlineCheckbox"+id).style.color = "#ff6600";
	complaintsCountJK+=1;
	
	var elem1 = document.createElement('div');
	elem1.setAttribute("class", "panel panel-default");
	elem1.setAttribute("id", "accordDiv"+id+"1");

	var con1 = document.getElementById("panelGroup");
	con1.appendChild(elem1);

	var elem2 = document.createElement('div');
	elem2.setAttribute("class", "panel-heading");
	elem2.setAttribute("id", "accordDiv"+id+"2");
	elem2.setAttribute("data-toggle", "collapse");
	elem2.setAttribute("data-parent", "#accordParent");
	elem2.setAttribute("data-target", "#accordDiv"+id+"6");
	elem2.setAttribute("style", "background-color:#e2e2e2;");
	var con2 = document.getElementById("accordDiv"+id+"1");
	con2.appendChild(elem2);

	var elem3 = document.createElement('div');
	elem3.setAttribute("class", "row link");
	elem3.setAttribute("id", "accordDiv"+id+"3");
	var con3 = document.getElementById("accordDiv"+id+"2");
	con3.appendChild(elem3);

	/*var elem4 = document.createElement('div');
	elem4.setAttribute("class", "col-md-1");
	elem4.setAttribute("id", "accordDiv"+id+"4");
	var con4 = document.getElementById("accordDiv"+id+"3");
	con4.appendChild(elem4);
	if(complaintsCountJK>0 && complaintsCountJK<23){
	 document.getElementById("accordDiv"+id+"4").innerHTML = complaintsCountJK;
	} */

	var elem5 = document.createElement('div');
	elem5.setAttribute("class", "col-md-8");
	elem5.setAttribute("id", "accordDiv"+id+"5");	
	var con5 = document.getElementById("accordDiv"+id+"3");
	con5.appendChild(elem5);
	document.getElementById("accordDiv"+id+"5").innerHTML =  $scope.complaintsJK[id-1].complaint_name+"  ( "+$scope.complaintsJK[id-1].complaint_tamil_name+" )";

	var elem_new = document.createElement('div');
	elem_new.setAttribute("class", "col-md-3");
	elem_new.setAttribute("id", "accordDiv"+id+"8");	
	var con_new = document.getElementById("accordDiv"+id+"3");
	con_new.appendChild(elem_new);
	var con_span = document.getElementById("accordDiv"+id+"8");
	var childDiv = document.createElement('div');
	var elem_span = document.createElement('span');	
	childDiv.setAttribute("class", "btn btn-default btn-sm");
	childDiv.setAttribute("id", "accordDiv"+id+"New");
	con_span.appendChild(childDiv);
	var child_div_id = document.getElementById("accordDiv"+id+"New");
	child_div_id.setAttribute("ng-click", "removeAccordianJK("+id+")");
	$injector.invoke(function($compile){
		var scope = angular.element(child_div_id).scope();
		$compile(child_div_id)(scope);
	});
	elem_span.setAttribute("class", "glyphicon glyphicon-trash");
	child_div_id.appendChild(elem_span);

	var elem6 = document.createElement('div');
	elem6.setAttribute("class", "panel-collapse collapse");
	elem6.setAttribute("id", "accordDiv"+id+"6");
	var con6 = document.getElementById("accordDiv"+id+"1");
	con6.appendChild(elem6);

	var elem7 = document.createElement('div');
	elem7.setAttribute("class", "panel-body");	
	elem7.setAttribute("id", "accordDiv"+id+"7");
	var con7 = document.getElementById("accordDiv"+id+"6");
	con7.appendChild(elem7);

	var el = document.getElementById("accordDiv"+id+"7");
	el.setAttribute("ng-include", "'views/patient/ChiefComplaintsJK/chiefComplaintJK_"+id+".htm'");
    //angular.element(el).injector().invoke(function($compile){
		$injector.invoke(function($compile){
		var scope = angular.element(el).scope();
		$compile(el)(scope);
	});
  }
}

$scope.removeAccordianJK = function(id){
	var intVal = parseInt(id)-1;
	$scope.complaintIssuesJK.details[intVal] = [];
	$scope.selectedComplaintNums[parseInt(id)-1] = [];
    var divIdVal = "accordDiv"+id+"1";
	document.getElementById("inlineCheckbox"+id).style.color = "#6495ed";
	var el = document.getElementById(divIdVal);
	el.remove(); 
}

$scope.selectAnswerJK = function(comp_no, quest_no, label_no, labels_array) {
	 	    					
	document.getElementById("labAnsJK"+comp_no+"_"+quest_no+"_"+label_no).style.color="#ff6600";
	for(var i=0; i<labels_array.length; i++){
		var arrValue = labels_array[i];
		document.getElementById("labAnsJK"+comp_no+"_"+quest_no+"_"+arrValue).style.color="unset";
	}		   
		
	var question = document.getElementById("labQuestJK"+comp_no+"_"+quest_no).textContent;
  //var answer   = document.getElementById("labAnsJK"+comp_no+"_"+quest_no+"_"+label_no).textContent;
	var answer   = document.getElementById("labAnsJK"+comp_no+"_"+quest_no+"_"+label_no).value;
	if(answer==undefined){
		answer = $("#labAnsJK"+comp_no+"_"+quest_no+"_"+label_no).attr('value');
	}
		
	if($scope.complaintIssuesJK.details[comp_no-1].length==0) {
		$scope.complaintIssuesJK.details[comp_no-1].push({
			complaint_no: comp_no,
			quest_no: quest_no,
			questions: question,
			answers: answer
		});

	} else {
		var init_val = 0;
		angular.forEach($scope.complaintIssuesJK.details[comp_no-1],function(value,key) {

			if($scope.complaintIssuesJK.details[comp_no-1][key].quest_no!=quest_no) {
				init_val+=1;
			} else {
				$scope.complaintIssuesJK.details[comp_no-1][key].answer = answer;
			}

			if(init_val==$scope.complaintIssuesJK.details[comp_no-1].length) {
				$scope.complaintIssuesJK.details[comp_no-1].push({
					complaint_no: comp_no,
					quest_no: quest_no,
					questions: question,
					answers: answer
				});
			
			}
		});
	}
} 

function saveComplaintsJK(data) {
		
	var data = {
		account_email: $rootScope.authentication.account_id,
		simple_complaint: {
			user_type: "doctor",
			issues: data.issues,
			days: "",
			medicine_given: "",
			temperature: "",
			unit: "",
			other_information: "",
			patient_email: $sessionStorage.get('patientAccEmail'),
			appointment_id: $sessionStorage.get('appointment_id')
		}
	}
	
	complaintService.saveComplaint(data,"simplecomplaint").then(function(response) {
	  //$scope.complaintId = response.complaint.id;			
		$scope.complaintSaved = true;
		$scope.opReview.complaint = response.complaint;
		$scope.closePopup();
		$sessionStorage.put('complaint','');
		toastr.success('Complaint saved successfully.');
		$scope.getOverview();
		updateComplaintChief();
	}, function(error) {
		$scope.closePopup();
		toastr.error(error.error);
		analytics('saveNewComplaint',error.error);
	});
}

$scope.createComplaintsArrayJK = function() { 

	$scope.complaintModelJK = [];
	$scope.complaintModelJK.issues = [];
	var initIndex  = 0;
	var initIndex2 = 0;
	var anyQuestionAnswered = 'No';
	
	angular.forEach( $scope.complaintIssuesJK.details, function( value, key ) {

		if(value.length!=0) {

			initIndex2=initIndex2+1;
  
			angular.forEach( $scope.complainTypeIds, function( val, keys ) {

				if( val.complaint_type ==  $scope.complaintsJK[value[0].complaint_no-1].complaint_name ) {
					
					$scope.complaintModelJK.issues.push({category_id : val.complaint_id,complaint_category_id: val.complaint_id, complaint_type: $scope.complaintsJK[value[0].complaint_no-1].complaint_name });							 
					$scope.complaintModelJK.issues[initIndex].details = [];
					var mergedAnswers = "";

                    for(var i=0; i<value.length; i++) {
						if(i==0) {
						    mergedAnswers += value[i].questions+"^~^"+value[i].answers;
						} else {
							mergedAnswers += "^~^"+value[i].questions+"^~^"+value[i].answers;
						}
					}
										
					switch(value[0].complaint_no) {
						case 2:
							for(var i=1;i<5;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								  mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								  mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 3:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value;		
							}
						break;
						case 4:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value;		
							}
						break;
						case 5:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value;		
							}
						break;
						case 6:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value;		
							}
						break;
						case 7:
							for(var i=1;i<5;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 8:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;   
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value; 
							}
						break;
						case 9:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value;		
							}
						break;
						case 10:
							for(var i=1;i<3;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 12:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value;		
							}
						break;
						case 13:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value;		
							}
						break;
						case 14:
							for(var i=1;i<4;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 15:
							for(var i=1;i<4;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 16:
							for(var i=1;i<5;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								  mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								  mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 17:
							for(var i=1;i<6;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 18:
							for(var i=1;i<3;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 19:
							if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value !=''){
								mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+1).textContent;
								mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+1).value;		
							}
						break;
						case 20:
							for(var i=1;i<3;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 21:
							for(var i=1;i<5;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						case 22:
							for(var i=1;i<3;i++) {
								if(document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value !=''){
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxQuestJK"+value[0].complaint_no+"_"+i).textContent;
								   mergedAnswers += "^~^"+ document.getElementById("txtBoxJK"+value[0].complaint_no+"_"+i).value;
								}
							}
						break;
						default:
						break;
					} 
  
					$scope.complaintModelJK.issues[initIndex].details.push({questions: "", answers: mergedAnswers });
					initIndex += 1;	

					if(mergedAnswers!=""){
                      anyQuestionAnswered = 'Yes';
					}			
				}

			});
		}		
	});	

	if(complaintsCountJK==0 && initIndex2==0) {			
		alert('No data for saving the chief complaint. Please enter data before saving.');
	}  else if(initIndex2==0 && anyQuestionAnswered=='No') { 			
		alert('No questions were answered for One or more of the complaint added, Please check.');
	} else if(initIndex2!=0 && anyQuestionAnswered=='No') {
	 	alert('Unable to save the complaints added, please contact Helyxon sales.');
	} else {
		saveComplaintsJK($scope.complaintModelJK)
	}

}

$scope.feverData = [];

$scope.followOption = {"days":"Days","weeks": "Weeks","months": "Months"};
$scope.saveethaDischargeSummary = false;
$scope.chengalpetDischargeSummary = false;
if(authService.authentication.account_info.Account.fullName == "Saveetha NICU & Neonatology center"){
	$scope.saveethaDischargeSummary = true;
	$scope.saveethaSummary = {};
	$scope.MaternalAge = [];
	for(var i=19;i<=45;i++) {
        $scope.MaternalAge.push(i);
    }
}

if(authService.authentication.account_info.Account.fullName == "Chengalpattu MC"){
	$scope.chengalpetDischargeSummary = true;
	$scope.chengalpetSummary = {};
	$scope.currentDateTime = new Date();
	$scope.currentDateTime.setSeconds(0);
	$scope.currentDateTime.setMilliseconds(0);
	$scope.chengalpetSummary.babyDob = $scope.currentDateTime;
	$scope.chengalpetSummary.babyDateOfAdmission = $scope.currentDateTime;
	$scope.chengalpetSummary.babyDateOfDischarge = $scope.currentDateTime;
	$scope.chengalpetSummary.babyAgeonAdmission = 0;
	$scope.chengalpetSummary.babyAgeonDischarge = 0;
	$scope.chengalpetSummary.maxDate = new Date();
};


$scope.calculateAgeonAdmissionDischarge = function(change){
	var babyDob  = moment($scope.chengalpetSummary.babyDob);
	var babyDateOfAdmission = moment($scope.chengalpetSummary.babyDateOfAdmission);
	var babyDateOfDischarge = moment($scope.chengalpetSummary.babyDateOfDischarge);
	if (change == 'babyAgeonAdmission'){
		$scope.chengalpetSummary.babyAgeonAdmission = babyDateOfAdmission.diff(babyDob,'days');
	}else if (change == 'babyAgeonDischarge'){
		$scope.chengalpetSummary.babyAgeonDischarge = babyDateOfDischarge.diff(babyDob,'days');
	}else{
		$scope.chengalpetSummary.babyAgeonAdmission = babyDateOfAdmission.diff(babyDob,'days');
		$scope.chengalpetSummary.babyAgeonDischarge = babyDateOfDischarge.diff(babyDob,'days');
	}
};

$scope.calculateEDD = function(){
	var data = $scope.chengalpetSummary.motherLMP
	data.addDays(280);
	$scope.chengalpetSummary.motherEDD = data;
};

$scope.visitingDates = function(type,daysToAdd){
	var currentDate = new Date();
	var modifiedDate = currentDate.addDays(daysToAdd);
	
	// Identify whether the day is Weekday or not
	if(modifiedDate.getDay() == 0){	
		modifiedDate.addDays(1);
	}else if(modifiedDate.getDay() == 6){
		modifiedDate.addDays(2);
	}

	// Define final result to scope
	if(type=='8Days'){
		$scope.chengalpetSummary.babyVisit8Days = modifiedDate;
	}else if(type=='1Month'){
		$scope.chengalpetSummary.babyVisit1Month = modifiedDate;
	}else if(type=='3Month'){
		$scope.chengalpetSummary.babyVisit3Month = modifiedDate;
	}else if(type=='6Month'){
		$scope.chengalpetSummary.babyVisit6Month = modifiedDate;
	}else if(type=='1Year'){
		$scope.chengalpetSummary.babyVisit1Year = modifiedDate;
	}
};

$scope.dischargeSummaryOption = function(data){
	if (data == 'edit'){
		$scope.optionBtn = 'edit';
	}
	else if (data == 'save'){
		$scope.optionBtn = 'save';
	}
	else if (data == 'cancel'){
		$scope.optionBtn = 'cancel';
	}
};

$scope.timer = 0;
$scope.generate_dischargesummarypdf = function(){
	var pdfElement = document.getElementById('dischargesummary_print');
        var opt = {
            margin:      0,
            filename:    'DischargeSummary.pdf',
            image:       { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
        };
        
      //New Promise-based usage:
        html2pdf().set(opt).from(pdfElement).save();
}
$scope.callGetScheduleApi = function(callback) {
	recordService.getSchedule().then(function(response) {	
		callback(response.config.avg_time_per_patient);
	}, function(error) {							
		console.log(error);
		$scope.timer = 0;
	});	
}

$scope.setTimer = function() {
	$scope.callGetScheduleApi(function returnFunc(value) {
		$scope.timer = value*60;
		$sessionStorage.put('avg_time_per_patient', value*60);
	});
}
$scope.setTimer();
var	patient_email;

// milestone chart data
$scope.chartData = {data: [], age: null};

var compareValues = function (key) {
  var order='asc';
  return function(a, b) {
    if(!a.hasOwnProperty(key) || 
       !b.hasOwnProperty(key)) {
  	  return 0; 
    }
    
    var varA = (typeof a[key] === 'string') ? 
      a[key].toUpperCase() : a[key];
	var varB = (typeof b[key] === 'string') ? 
      b[key].toUpperCase() : b[key];
      
    var comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order == 'desc') ? 
      (comparison * -1) : comparison
    );
  };
}

$scope.getDoctorProfile = function() {
	var date = new Date();
	var today = date.toString().slice(4,15).split(" ");
	profileService.getProfile().then(function(response) {
		$rootScope.doctorProfile = response;
		$rootScope.doctorProfile.today = today[1]+'-'+today[0]+'-'+today[2];
	})
};

$scope.getDoctorProfile();

DrugMasterService.clearLatestPrescription();
var avg_time_per_patient = parseInt($sessionStorage.get('avg_time_per_patient'));

$scope.initColorValue = 0;
$scope.changeEndConsultBtnColor = function() {
	if ($scope.initColorValue%2 == 0) {
		$("#endConsultBtn").removeClass("btn-danger").addClass("btn-primary");
	} else {
		$("#endConsultBtn").removeClass("btn-primary").addClass("btn-danger");
	}
	++$scope.initColorValue;
	$scope.colorTimeout = $timeout($scope.changeEndConsultBtnColor,500);
}

$scope.onTimeout = function(){
	 $scope.timer--;
	 $scope.myTimeout = $timeout($scope.onTimeout,1000);

	  if( $scope.timer==30 ) {
	 	$("#endConsultBtn").removeClass("btn-success").addClass("btn-danger");
	  }
	 
	 if( $scope.timer==0 ) {
		$timeout.cancel($scope.myTimeout);
		$scope.myTimeout = null;
		$scope.changeEndConsultBtnColor();
	 }
	
	 //  Normal voice call 
	//if ($scope.timer == avg_time_per_patient) {
	  if( $scope.timer == 60 ) {
		if ($sessionStorage.get('status') == 'consultation') {
			if($rootScope.banner.next_patient_appointment_type == 'voice_call' || $rootScope.banner.next_patient_appointment_type == 'emergency_voice_call'){
				$rootScope.voice_call_alert = 'true';
			}
		}
	}

	// Emergency voice call
	if($rootScope.banner.next_patient_appointment_type == 'emergency_voice_call'){
		if($rootScope.check_emergency_call == 'false'){
			$rootScope.check_emergency_call = 'true';
			$rootScope.voice_call_alert = 'true';
		}
	}
};

$rootScope.bannerCall = setInterval(function(){	
	$rootScope.loadBanner();
}, 10000);

// UTC to local time conversion
$scope.convertUTCDateToLocalDate = function(date) {
	var newDate = new Date(date);
	var offset = date.getTimezoneOffset();
	var minutes = date.getMinutes();
	newDate.setMinutes(minutes - offset);
  return newDate;   
};

$rootScope.print_ToPaper = function(id) {

	var innerContents = document.getElementById(id).innerHTML;
	var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	popupWinindow.document.open();
	popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" integrity="sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z" crossorigin="anonymous"><link rel="stylesheet" type="text/css" href="Content/temp.css"/><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:1cm;margin-left:1cm;margin-bottom:1cm;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
	popupWinindow.document.close();
}

$rootScope.snehal_visible = true;
$rootScope.mangalabarathi_visible = true;
$rootScope.visible_alldoctors = true;
$rootScope.accoundID = authService.authentication.account_id;


if(authService.authentication.account_id == 'rx3@rxcarenet.org' || authService.authentication.account_id == 'rx5016@rxcarenet.org'){
	$rootScope.snehal_visible = false;
}else if(authService.authentication.account_id =='rx122340@rxcarenet.org' || authService.authentication.account_id =='rx15@rxcarenet.org'){
	$rootScope.mangalabarathi_visible = false;
}else{
	$rootScope.visible_alldoctors = false;
}

$rootScope.print_To_Paper =function(id,type){
	console.log('type',type);
	if(type == 1){
		var innerContents = document.getElementById(id).innerHTML;
		console.log(' innerContents', innerContents);
		var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
		popupWinindow.document.open();
		popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:5.5cm;margin-left:7.5cm;margin-bottom:2cm;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
		popupWinindow.document.close();
	}else{
		var inner_Contents = document.getElementById(id).innerHTML;
		var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
		popupWinindow.document.open();
		popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css"/><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:1cm;margin-left:1cm;margin-bottom:1cm;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + inner_Contents + '</html>');
	    popupWinindow.document.close();
	}

}

$rootScope.printToPaper = function(id) {
	var innerContents = document.getElementById(id).innerHTML;
	var popupWinindow = window.open('', '_blank', 'width=560,height=794,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	popupWinindow.document.open();
	popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css"/><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;}  .print_none{display: none} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:4.5cm;margin-left:1cm;margin-bottom:1cm;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
	popupWinindow.document.close();	
}

$rootScope.printToPaper_mangalabharathi = function(id){
	var innerContents = document.getElementById(id).innerHTML;
	var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	popupWinindow.document.open();
	popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css"/><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .prescription_th{vertical-align: baseline !important;padding-top:-100px !important;} .print_none{display: none} .regno{position:absolute;height:18cm;} .subpage {padding: 1cm;height: 18cm;}  .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:100%; text-align:center;} .activerow td{padding-top: 1 2px !important;}} @page {font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: A4; margin-top:7cm;margin-left:4cm;margin-bottom:4.5cm;}  table{ font-size: 80%;} #table_width{width:50% !important;} pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } </style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
	popupWinindow.document.close();	
}

$rootScope.printToPaper_forall_doctors = function(id){
	var innerContents = document.getElementById(id).innerHTML;
	var popupWinindow = window.open('', '_blank', 'width=560,height=794,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	popupWinindow.document.open();
	popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css"/><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} #prescriptionlable{font-size:10px !important;margin-top:700px !important;padding:10px !important} .print_none{display: none} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:4.5cm;margin-left:1cm;margin-bottom:1cm;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
	popupWinindow.document.close();	
}

$rootScope.printToPapersS = function(id) {
	var innerContents = document.getElementById(id).innerHTML;
	console.log(' innerContents', innerContents);
	if($scope.vaccinationPrint) {
		var innerContents3 = document.getElementById('printSectionIDVac').innerHTML;
	} else {
		var innerContents3 = '';
	}
	if($scope.milestonePrint) {
		var innerContents2 = document.getElementById('printSectionIdMilestone').innerHTML;
	} else {
		var innerContents2 = '';
	}

	if($scope.growthPrint) {
	    var innerContents1  = document.getElementById('printGrowth').innerHTML;
		var innerContentss1 = document.getElementById('GrowthChartPrint1').innerHTML;
		var innerContentss2 = document.getElementById('GrowthChartPrint2').innerHTML;
		var innerContentss3 = document.getElementById('GrowthChartPrint3').innerHTML;
	} else {
		var innerContents1  = '';
		var innerContentss1 = '';
		var innerContentss2 = '';
		var innerContentss3 = '';
	}

	if($rootScope.presData.patient_demographics.gender=='female') {
        $scope.genderChart = 'Girls';
	} else if($rootScope.presData.patient_demographics.gender=='male') {
        $scope.genderChart = 'Boys';
	}

	var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	popupWinindow.document.open();
	if($rootScope.presData.doctor_profile.template == "Anbezhil") {
		popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:5.5cm;margin-left:7.5cm;margin-bottom:2cm;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents +' <div class="page-break">'+ innerContents1 +'</div><div class="page-break">'+ innerContents2 +'<div class="page-break">'+ innerContents3 + '</html>');
	} else {	
	   	if($scope.growthPrint) {
	  		popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css"/><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:1cm;margin-left:1cm;margin-bottom:1cm;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents +'<div class="col-xs-12" style="page-break-inside:avoid;"><div class="row"><label style="margin-left:13%">WHO '+$scope.genderChart+' Weight for Height / Length</label><label style="margin-left:10%">0 to 5 Years WHO '+$scope.genderChart+' Length/Height,Weight and Head Circumference.</label> </div><div class="row" ><div class="form-group"><div class="col-xs-4" style="margin-left:75px;page-break-inside:avoid;">'+innerContentss1+'</div><div class="col-xs-4" style="margin-left:60px;page-break-inside:avoid;">'+innerContentss2+'</div></div></div><div class="col-xs-12" style="margin-left:130px;"><div class="row" margin-top:20px;font-weight:bold;">'+innerContentss3+'</div></div>'+'<div class="page-break">'+ innerContents2 +'<div class="page-break">'+ innerContents3 + '</html>');
		} else {
			popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css"/><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:1cm;margin-left:1cm;margin-bottom:1cm;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents +'<div class="col-xs-12" style="page-break-inside:avoid;"><div class="row" ><div class="form-group" ><div class="col-xs-4" style="margin-left:75px;page-break-inside:avoid;">'+innerContentss1+'</div><div class="col-xs-4" style="margin-left:60px;page-break-inside:avoid;">'+innerContentss2+'</div></div></div><div class="col-xs-12" style="margin-left:130px;"><div class="row" margin-top:20px;font-weight:bold;">'+innerContentss3+'</div></div>'+'<div class="page-break">'+ innerContents2 +'<div class="page-break">'+ innerContents3 + '</html>');
		}	
	}
	popupWinindow.document.close();
};

$rootScope.printForSaveetha = function(id) {
	var innerContents = document.getElementById(id).innerHTML;
	var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	popupWinindow.document.open();
	popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 0% 1% !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} table{ font-size: 100%; page-break-inside:avoid; } td{ border:1px solid black!important;padding:0% 1% !important;} pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; margin-bottom:0%;}</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
	popupWinindow.document.close();
};

$rootScope.printForChengalpet = function(id) {
	var innerContents = document.getElementById(id).innerHTML;
	var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	popupWinindow.document.open();
	popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .page-break	{ display: block; page-break-before: always; } .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 0% 1% !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} table{ font-size: 100%; page-break-inside:avoid; } td{ border:1px solid black!important;padding:0% 1% !important;} pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; margin-bottom:0%;}</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
	popupWinindow.document.close();
};

// $rootScope.printPaymentToPaper = function(id) {
// 	var innerContents = document.getElementById(id).innerHTML;
// 	var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
// 	popupWinindow.document.open();
// 	popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
// 	popupWinindow.document.close();
// };

$rootScope.printPayment_To_Paper = function() {
	var param = $sessionStorage.get('patient_email');
	console.log('patientemail',param);
	var billno = $sessionStorage.get('billno');
	paymentService.get_printPayment(param,billno).then(function(response) {
		console.log('response',response);
		var innerContents = response;
		var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
		popupWinindow.document.open();
		popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
		popupWinindow.document.close();
	},function (err, response) {
		console.error(err);
  });
};

$scope.printToCart = function(printSectionId) {
	var innerContents = document.getElementById(printSectionId).innerHTML;
  //var age = ($rootScope.recordAge.years ? $rootScope.recordAge.years + " years " : "") + ($rootScope.recordAge.months ? $rootScope.recordAge.months + " months " : "") + ($rootScope.recordAge.days ? $rootScope.recordAge.days + " days" : "");
  //<h3>Name : ' + $scope.record.name + '/' + age + '/' + $scope.record.gender + '/' + $scope.record.mr_number + '<br>DOB : ' + $filter('date')($scope.record.dob, "dd-MMM-yyyy") + '</h3><br>
	var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
		popupWinindow.document.open();
		popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="../../../sass/app/_site.scss" /></head><body onload="window.print()">' + innerContents + '</html>');
		popupWinindow.document.close();
};

$scope.arrivaltime = function(){
	recordService.get_patientarrival(recordId).then(function(response){
		$scope.arrivalTime = response.arrival_time;
		if(response.arrival_time && response.arrival_time!='None'){
			var date = $scope.convertUTCDateToLocalDate(new Date(response.arrival_time));
			$scope.arrivalTime=date;
	  }
	},function (err, response) {
      console.error(err,response);
    }); 
};

$scope.patient_classification = function() {
	recordService.get_patientclassification(recordId).then(function(response) {
		$scope.category = response.category;
	},function (err, response) {
		console.error(err);
  });
};

//$scope.myTimeout = $timeout($scope.onTimeout,1000);
$scope.arrivaltime();
$scope.patient_classification();
$scope.vitalMsg = "There is no appointment for this patient";

$scope.getVitalData = function() {
	if($sessionStorage.get('appointment_id')) {
		complaintService.appointmentVitalsData($sessionStorage.get('appointment_id')).then(function(response) {
			$rootScope.vitalUpdate = response.vitals[0];
			$rootScope.pills =[];
			$rootScope.injication = [];
			if($rootScope.vitalUpdate != undefined) {
				$rootScope.vitalUpdate.height = ($rootScope.vitalUpdate.height * 100).toFixed(1);
				$rootScope.vitalUpdate.bsa = (0.007184*Math.pow($rootScope.vitalUpdate.weight,0.425) * (Math.pow(($rootScope.vitalUpdate.height/100),0.725))).toFixed(3); 
				$rootScope.calculateFahrenheit();
				//update bind gulcometer values
				$rootScope.gulcometer_mmol = response.vitals[0].glucometer.mmol_value;
				$rootScope.gulcometer_mgdl = response.vitals[0].glucometer.mgol_value;
				$rootScope.gulcometervalue = response.vitals[0].glucometer.option;
				//update date 
				var newdate1 = $scope.convertUTCDateToLocalDate(new Date(response.vitals[0].glucometer_measured_date));
            	var toconvert = newdate1.toISOString().slice(0, 10);
           	 	var entereddate = toconvert.slice(0, 4) + '-'+ toconvert.slice(5, 7) + '-'+ toconvert.slice(8, 10);
				$rootScope.fromDate = new Date(entereddate);
                console.log($rootScope.fromDate,"$scope.fromDate")
				
				var date = moment.utc(response.vitals[0].glucometer_measured_date).format('YYYY-MM-DD HH:mm:ss');
        		var stillUtc = moment.utc(date).toDate();
				var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');console.log(local);
                
				$rootScope.date = $rootScope.fromDate;
				$rootScope.datestatus = true;

				$rootScope.splithours = local.split(' ')[1];
				$rootScope.hours = $rootScope.splithours.split(' ')[0].split(':')[0];
				$rootScope.min = $rootScope.splithours.split(' ')[0].split(':')[1];

				$rootScope.calculateMmol();
				for(var i=0;i<response.vitals[0].glucometer.pills.length;i++){
					$rootScope.pills.push({name: response.vitals[0].glucometer.pills[i].name, strength: response.vitals[0].glucometer.pills[i].strength});
				}
				for(var j=0;j<response.vitals[0].glucometer.injection.length;j++){
					$rootScope.injication.push({name: response.vitals[0].glucometer.injection[j].name, strength: response.vitals[0].glucometer.injection[j].strength});
				}
				
				$scope.vitalMsg = "Vital data exist";
			} else {
				$scope.vitalMsg = "Data entry need to be done for this appointment.";
				$rootScope.gulcometer_mmol = "";
				$rootScope.gulcometer_mgdl = "";
				$rootScope.gulcometervalue = 'Fasting';
				$rootScope.pills =[];
				$rootScope.injication = [];
			}
		});
	} else {
		$scope.vitalMsg = "There is no appointment for this patient";
	}
};

$scope.convertUTCDateToLocalDate = function(date) {
		var newDate = new Date(date);
		var offset = date.getTimezoneOffset();
		var minutes = date.getMinutes();
		newDate.setMinutes(minutes - offset);
	  return newDate;   
};

$scope.getAccountemail = function() {
	
	var countAppt = 0;
	var appointmentData = '';
	$scope.appointment_date = new Date();
	var data =	{
		"acc_id":authService.authentication.account_id,
		"date1":$filter('date')($scope.appointment_date, "yyyy-MM-dd"),
		"date2":$filter('date')($scope.appointment_date, "yyyy-MM-dd")
	}
	recordService.getAppointments(data).then(function(response) {
		
		console.log('response  response',response);
		angular.forEach(response, function(value) {
			if(value.record_id == recordId ) {
				if(value.id != undefined) {
					if(value.status =='consultation' || value.status =='confirmed' || value.status =='closed'){
						countAppt = countAppt + 1;
						appointmentData = value;
					}
				}
			}
		});
		if(countAppt == 1) {
			if(appointmentData.record_id == recordId ) {
				if(appointmentData.id != undefined) {
					if(appointmentData.status =='consultation') {
						$sessionStorage.put('appointment_id',appointmentData.id);
						$sessionStorage.put('consult', "true");
						$scope.loadComplaintList('active');
						$scope.consult = 'true';
						$scope.gethistorical();
						$rootScope.end_consultation = false;
						$scope.showConsultation = 'true'
						$sessionStorage.put('enableConsulation','true');
						$scope.getOverview();
					} else if(appointmentData.status =='confirmed' || appointmentData.status =='closed'){
						$sessionStorage.put('appointment_id',appointmentData.id);
						$sessionStorage.put('consult',"false");
						$scope.consult = 'false';
						$scope.showConsultation = 'true';
						$scope.getOverview();
					}
					if(appointmentData.type == 'voice_call' || appointmentData.type == 'emergency_voice_call'){
						$scope.voiceCallConsultation = 'true';
						$sessionStorage.put('appt_type',appointmentData.type)
						recordService.getvoicecallwithreferencenumber($sessionStorage.get('appointment_id')).then(function(response){
							if(response.reference){
								$scope.currentPatientReference = response.reference;
								if(response.voice_file != null){
									if(response.voice_call_type == "VoiceMail"){
										$rootScope.voiceFile = response.voice_file;
										$scope.playVoiceMessage($rootScope.voiceFile);
									}
								}
								else {
									$scope.voiceCallUpdateBfCons($scope.currentPatientReference);
								}
							}
							else if(response.message){
								$rootScope.callNotInitiatedAlert();
							}
						}, function(err){
							toastr.error("Error in getting reference number: ", err);
							analytics('getAccountemail','error in getting reference number');
						});
					}
					$sessionStorage.put('status', appointmentData.status);
					$scope.getVitalData();
				}
			}
		} 
		// AS per requirment it has commanded, consulatation will enable for multi time as same MR no
		// else if(countAppt > 1){
		// 	var options = {
		// 		title: 'Multiple Appointments',
		// 		message:'You have multiple appointments for this patient. So better you can choose the appropriate one from appointment queue.',
		// 		size:'medium',
		// 		onEscape: function() { $location.path('/home');$scope.$apply();},
		// 		buttons: {
		// 			ok:{
		// 				label: "Go to Appointment Queue",
		// 				className: "btn-primary",
		// 				callback: function() {
		// 					$location.path('/home');
		// 					$rootScope.loadBanner();
		// 				}
		// 			}
		// 		}
		// 	}
		// 	$ngBootbox.customDialog(options);
		// }
	});
};

$rootScope.updatedDemo = {};

$scope.$watch('updatedDemo', function() {
    $scope.loadChartData();
});

$scope.demoLoaded = true;
$scope.loadChartData = function() {
	$scope.dataLoaded = true;
	$scope.record = {
		name:"",
		dob:"",
		gender:"male",
		image:""
	};
	recordService.getRecordInfo(recordId).then(function(recordInfoResponse) {
		if( recordInfoResponse.image.startsWith("/") ) {
			recordInfoResponse.image = "data:image/jpeg;base64," + recordInfoResponse.image;
		}
		
		$scope.record = {
			name: recordInfoResponse.record_info.Record.label,
			dob: new Date(recordInfoResponse.demographics.bday),
			corrected_bday: recordInfoResponse.demographics.corrected_bday,
			gender:recordInfoResponse.demographics.gender,
			mr_number: recordInfoResponse.demographics.mr_number,
			image:recordInfoResponse.demographics.image,
			mobile: recordInfoResponse.demographics.father_tel_number,
			birth_weight: recordInfoResponse.demographics.birth_weight,
			birth_height: recordInfoResponse.demographics.birth_height,
			uhid: recordInfoResponse.demographics.uhid
		};
		var dobMoment = moment($scope.record.dob);
		var currentDate = moment(new Date());
		var ageInDays = currentDate.diff(dobMoment,'days');
		var ageInMonths = currentDate.diff(dobMoment,'month');

		$scope.presprintName = $scope.record.name;
		console.log($scope.presprintName);
		$scope.presprintGender = $scope.record.gender;

		$rootScope.recordAge = {
			years : parseInt(moment().diff(dobMoment,'year',true)),
			months: parseInt(moment().diff(dobMoment,'month',true)%12),
			days: parseInt(moment().diff(dobMoment,'day',true)%365),
			ageInDays: ageInDays,
			ageInMonths: ageInMonths
		};
		$rootScope.record1 = $scope.record;

		$scope.presprintAge = ($rootScope.recordAge.years ? $rootScope.recordAge.years + " years " : "") + ($rootScope.recordAge.months ? $rootScope.recordAge.months + " months " : "") + ($rootScope.recordAge.days ? $rootScope.recordAge.days + " days" : "");
		//console.log('year***'+$scope.presprintAge)
		$scope.hideCorrectedDOB = true;
		if($scope.record.corrected_bday != null){
			var dobMoment = moment($scope.record.corrected_bday);
			var currentDate = moment(new Date());
			$scope.correctedMonth = currentDate.diff(dobMoment,'month');
			$scope.hideCorrectedDOB = false;
			$scope.userPreChoice = "1";
		}
		var sessionData = {cell_number:$scope.record.mobile,acc_email:$rootScope.authentication.account_id,record_id:recordId,mr:$scope.record.mr_number,patient_email:recordInfoResponse.record_info.Record.account_email,bday:$scope.record.dob};
		$sessionStorage.put('patientAccEmail',recordInfoResponse.record_info.Record.account_email);
		$sessionStorage.put('patientDetail',JSON.stringify(sessionData));
		$scope.mobilevalidity();

		if($sessionStorage.get('appointment_id') == '') {
			$scope.getAccountemail();
		} else {
			if($sessionStorage.get('status') =='consultation' || $sessionStorage.get('status') ==''){
				$sessionStorage.put('consult', "true");
				$scope.loadComplaintList('active');
				$scope.consult = 'true';
				$scope.gethistorical();
				$rootScope.end_consultation = false;
				$scope.showConsultation = 'true'
				$sessionStorage.put('enableConsulation','true');
				$scope.getOverview();
				/* if($scope.myVar == undefined){
					$scope.autoSave = 'true';
					$scope.myVar = setInterval(function(){
						if($scope.consult && $scope.autoSave == 'true'){
							$scope.count+=1;
							$scope.saveprescription();
						}
						else if($scope.consult && $scope.autoSave == 'false'){
							//	Do nothing
						}
					}, 60000)
				}*/
			} else if($sessionStorage.get('status') =='confirmed' || $sessionStorage.get('status') =='closed') {
				$sessionStorage.put('consult',"false");
				$scope.consult = 'false';
				$scope.showConsultation = 'true';
				$scope.getOverview();
			}
			$scope.getVitalData();
			if($sessionStorage.get('appt_type') == 'voice_call' || $sessionStorage.get('appt_type') == 'emergency_voice_call' ){
				$scope.voiceCallConsultation = 'true';
				recordService.getvoicecallwithreferencenumber($sessionStorage.get('appointment_id')).then(function(response){
					if(response.reference){
						$scope.currentPatientReference = response.reference;
						if(response.voice_file != null) {
							if(response.voice_call_type == "VoiceMail") {
								$rootScope.voiceFile = response.voice_file;
								$scope.playVoiceMessage($rootScope.voiceFile);
							}
						}
						else {
							$scope.voiceCallUpdateBfCons($scope.currentPatientReference);
						}
					}
					else if(response.message) {
						$rootScope.callNotInitiatedAlert();
					}
					
				}, function(err) {
					toastr.error("Error in getting reference number: ", err);
					analytics('loadChartData','error in getting reference number');
				});
				
			}
		}
		$scope.demoLoaded = false;
		$rootScope.patientAcc = {'email_id':''};
		$rootScope.patientAcc.email_id = recordInfoResponse.record_info.Record.account_email;
	},function (err, response) {
		$ngBootbox.alert(err.Message);
	});
};

$rootScope.callNotInitiatedAlert = function(id) {
	var options = {
		title: '<b>Patient has booked the voice call appointment</b>',
		message:'Would you like to initiate the call ?',
		size:'medium',
		onEscape: function(){$scope.createBtn = "Initiate call";},
		buttons: {
			ok:{
				label: "Initiate call to patient",
				className: "btn-success",
				callback: function() {
					if(id) {
					  sessionStorage.setItem('patientid',id)
					   $location.path('/patientview/'+id);
					}
				    $scope.voiceCallConsultation = 'true';
					$rootScope.bookVoiceIfNotInitiated();
				}
			},
			close : {
				label: " Cancel",
				className: "btn-danger",
				callback: function() {
					$scope.createBtn = "Initiate call";
				}
			}
		}
	}
	$ngBootbox.customDialog(options);
};

$scope.playVoiceMessage = function(data){
	var formattedHTML = '<p>Hello Doctor,<br>Patient booked the voice call appointment, hope you are busy at that time.<br>So patient has left you the voice message<br><br></p>';
	var options = {
		title: '',
		// message: formattedHTML + '<a href="'+ data +'" target="_blank">Play</b></a>',
		message: formattedHTML+'<center><audio controls><source src="'+ $rootScope.voiceFile +'" type="audio/wav">Your browser does not support the audio element.</audio></center>',
		size:'medium',
		onEscape: true,
	};
	$ngBootbox.customDialog(options);
};

$scope.oneAtATime = true;
$scope.newDate = new Date().toLocaleDateString();

$scope.loadVitalSigns = function() {
	$scope.dataLoaded = false;
	$rootScope.showSpinner = true;
		
    recordService.getVitalSigns(recordId).then(function(vitalResponse){

		var dobMoment  = moment($scope.record.dob);
		var currentDate = moment(new Date());
		var ageInDays = currentDate.diff(dobMoment,'days');
		var ageInMonths = currentDate.diff(dobMoment,'month');

			$rootScope.recordAge = {
				years: parseInt(moment().diff(dobMoment,'year',true)),
				months: parseInt(moment().diff(dobMoment,'month',true)%12),
				days: parseInt(moment().diff(dobMoment,'day',true)%365),
				ageInDays: ageInDays,
				ageInMonths: ageInMonths
			};

			if($rootScope.recordAge.years<5) {
				$rootScope.allowedLimits = {heightMin: 0, heightMax: 120, weightMin: 0, weightMax: 24, headMin: 0, headMax: 54};
			} else if($rootScope.recordAge.years>5) {
				$rootScope.allowedLimits = {heightMin: 44, heightMax: 190, weightMin: 0, weightMax: 190, headMin: 32, headMax: 100};
			}
				
		 	var vitalData = vitalResponse.map(function(item) {
			 if(item.is_active){
		 		return {
		 			age: {
		 				years: parseInt(moment(item.date).diff(dobMoment,'year',true)),
		 				months: parseInt(moment(item.date).diff(dobMoment,'month',true)%12),
                        days: parseInt(moment(item.date).diff(dobMoment,'day',true)%365)
		 			},
		 			date: new Date(item.date),
		 			agemos:parseFloat(moment(new Date(item.date)).diff(dobMoment, 'months').toFixed(2)),
		 			height:item.height,
		 			weight:item.weight,
						bmi: item.bmi, //item.bmi_value
						bsa : (0.007184*Math.pow(item.weight,0.425) * (Math.pow((item.height),0.725))).toFixed(3),
		 				head: item.head_circumference,
		 				arm: item.arm_circumference,
						chest: item.chest_circumference,
						temperature: item.temperature,
						hr: item.heart_rate,
						rr: item.respiratory_rate,
						bp_diastolic: item.bp_diastolic,
						bp_systolic: item.bp_systolic,
						oxygen_saturation: item.oxygen_saturation,
						id: item.__documentid__,
						newDate: new Date(item.date).toLocaleDateString()
		 			};
				  }
		 		});

				if($rootScope.recordAge.years>=5 && !$scope.userChoice){
					$scope.userChoice = "2";
				}else if($rootScope.recordAge.years<5 && !$scope.userChoice) {
					$scope.userChoice = "1";
				}

		 		$scope.vitalData = vitalData;

		 		$scope.vitalData.sort(function(a,b) {
		 			if (a.date < b.date)
					    return -1;
					  if (a.date > b.date)
					    return 1;
					  return 0;
		 		});
				
				$scope.weightData = [];
				$scope.pretermWeightData = [];
		 		$scope.weightDa = $scope.vitalData.map(function(item){
					 if(item.weight!=null){
						// if(item.agemos<60){
						// 	$scope.weightData.push({x:item.agemos,y:parseFloat(item.weight-1)});
						// }else{
							// $scope.weightData.push({x:item.agemos,y:parseFloat(item.weight)});
						// }
						if($scope.record.corrected_bday != null){
							var correctedDate = new Date($scope.record.corrected_bday);
							if(item.date < correctedDate){
								var dobMoment  = moment(item.date);
								var currentDate = moment(correctedDate);
								var diffDays = 280 - currentDate.diff(dobMoment,'days');
								if(diffDays > 167 && diffDays < 232){
									$scope.pretermWeightData.push({x:diffDays,y:parseFloat(item.weight)});
								}
							}
						}
						$scope.weightData.push({x:item.agemos,y:parseFloat(item.weight)});
					}
					return [item.agemos,parseFloat(item.weight)];
				 });
				 
				$scope.postnatalWeightData = [];
				$scope.postweightData = $scope.vitalData.map(function(item) {	
					if(item.weight!=null) {
						if($scope.record.corrected_bday != null) {
							$scope.postnataldate = new Date();
							$scope.postnataldate = new Date($scope.record.corrected_bday);
							$scope.postnataldate.addDays(168);
							if(item.date < $scope.postnataldate) {
								var dobMoment  = moment(item.date);
								var currentDate = moment($scope.postnataldate);
								var diffDays = 448 - currentDate.diff(dobMoment,'days');
								if(diffDays > 188 && diffDays < 449) {
									$scope.postnatalWeightData.push({x:parseInt(diffDays/7),y:parseFloat(item.weight).toFixed(2)});
								}
							}
						}
					}
		 			return [item.agemos,parseFloat(item.weight).toFixed(2)];
				});
				
				$scope.heightData = [];
				$scope.pretermHeightData = [];
		 		$scope.heightDa = $scope.vitalData.map(function(item){
					 if(item.height!=null){
						if($scope.record.corrected_bday != null){
							var correctedDate = new Date($scope.record.corrected_bday);
							if(item.date < correctedDate){
								var dobMoment  = moment(item.date);
								var currentDate = moment(correctedDate);
								var diffDays = 280 - currentDate.diff(dobMoment,'days');
								if(diffDays > 167 && diffDays < 232){
									$scope.pretermHeightData.push({x:diffDays,y:parseFloat(item.height*100)});
								}
							}
						}
						$scope.heightData.push({x:item.agemos,y:parseFloat((item.height*100).toFixed(2))})
					}
		 			return [item.agemos,parseFloat((item.height*100).toFixed(2))];
		 		});

				$scope.hcData = [];
				$scope.pretermHcData = [];
				$scope.HCData = $scope.vitalData.map(function(item){	
					if(item.head!=null){
						if($scope.record.corrected_bday != null){
							var correctedDate = new Date($scope.record.corrected_bday);
							if(item.date < correctedDate){
								var dobMoment  = moment(item.date);
								var currentDate = moment(correctedDate);
								var diffDays = 280 - currentDate.diff(dobMoment,'days');
								if(diffDays > 167 && diffDays < 232){
									$scope.pretermHcData.push({x:diffDays,y:parseFloat(item.head)});
								}
							}
						}
						$scope.hcData.push({x:item.agemos,y:parseFloat(item.head)});
					}
		 			return [item.agemos,parseFloat(item.head)];
				 });

				$scope.postnatalHcData = [];
				$scope.PostnatalHcDa = $scope.vitalData.map(function(item){	
					if(item.head!=null){
						if($scope.record.corrected_bday != null){
							$scope.postnataldate = new Date();
							$scope.postnataldate = new Date($scope.record.corrected_bday);
							$scope.postnataldate.addDays(168);
							if(item.date < $scope.postnataldate){
								var dobMoment  = moment(item.date);
								var currentDate = moment($scope.postnataldate);
								var diffDays = 448 - currentDate.diff(dobMoment,'days');
								if(diffDays > 188 && diffDays < 449){
									$scope.postnatalHcData.push({x:parseInt(diffDays/7),y:parseFloat(item.head)});
								}
							}
						}
					}
		 			return [item.agemos,parseFloat(item.head)];
				 });

				$scope.postnatalHeightData = [];
				$scope.postHCData = $scope.vitalData.map(function(item){	
					if(item.height!=null){
						if($scope.record.corrected_bday != null){
							$scope.postnataldate = new Date();
							$scope.postnataldate = new Date($scope.record.corrected_bday);
							$scope.postnataldate.addDays(168);
							if(item.date < $scope.postnataldate){
								var dobMoment  = moment(item.date);
								var currentDate = moment($scope.postnataldate);
								var diffDays = 448 - currentDate.diff(dobMoment,'days');
								if(diffDays > 188 && diffDays < 449){
									$scope.postnatalHeightData.push({x:parseInt(diffDays/7),y:parseFloat(item.height*100).toFixed(2)});
								}
							}
						}
					}
		 			return [item.agemos,parseFloat(item.height*100).toFixed(2)];
				 });
				 
				$scope.bmiData = []
		 		$scope.bmiDa = $scope.vitalData.map(function(item){
					 if(item.bmi!=null){
						$scope.bmiData.push({x:item.agemos,y:parseFloat(item.bmi)})
					 }
		 			return [item.agemos,parseFloat(item.bmi)];
		 		});

				$scope.weightheightData = []
				$scope.WeightHeightDa = $scope.vitalData.map(function(item){	
					if(item.height!=null && item.weight!=null){
						$scope.weightheightData.push({x:parseFloat((item.height*100).toFixed(2)),y:item.weight});
					}
		 			return [parseFloat((item.height*100).toFixed(2)),item.weight];
				});
				 
				$scope.whRatioData = [];
				$scope.WHData = $scope.vitalData.map(function(item){	
					if(item.weight!=null && item.height!=null){
						if($scope.record.corrected_bday != null){
							var correctedDate = new Date($scope.record.corrected_bday);
							if(item.date < correctedDate){
								var dobMoment  = moment(item.date);
								var currentDate = moment(correctedDate);
								var diffDays = 280 - currentDate.diff(dobMoment,'days');
								if(diffDays > 167 && diffDays < 232){
									$scope.whRatioData.push({x:diffDays,y:parseFloat(item.weight/(item.height)).toFixed(2)});
								}
							}
						}
					}
		 			return [item.agemos,parseFloat(item.head)];
				});

				/**Chart data */
				$scope.ccmData = {
					weight: $scope.weightData,
					pretermWeight: $scope.pretermWeightData,
					postnatalWeight: $scope.postnatalWeightData,
					height: $scope.heightData, 
					pretermHeight: $scope.pretermHeightData,
					postnatalHeight: $scope.postnatalHeightData,
					hc: $scope.hcData,
					pretermHc: $scope.pretermHcData,
					postnatalHc: $scope.postnatalHcData,
					bmi: $scope.bmiData, 
					hwData: $scope.weightheightData,
					pretermwhRatio:$scope.whRatioData
				};
				/** */
				if($scope.vitalData.length>0 && $scope.vitalData[$scope.vitalData.length-1].agemos >= 24){
					$scope.abnormalData= percentileService.getPercentile({age:$scope.vitalData[$scope.vitalData.length-1].agemos,height:$scope.vitalData[$scope.vitalData.length-1].height*100,weight:$scope.vitalData[$scope.vitalData.length-1].weight})
				}
		 		$scope.vitalData.reverse();
		 		$scope.bmiCategory = 0;

		 		$scope.dataLoaded = true;
		 		$rootScope.showSpinner = false;
		 		if($scope.vitalData.length>0){
		 		$rootScope.patientData={age:(($scope.recordAge.years * 12) + $scope.recordAge.months),bmi:($scope.vitalData[0].weight / (($scope.vitalData[0].height/100.0) * ($scope.vitalData[0].height/100.0))),gender:$scope.record.gender};
		 	  	}
		 	  	},function (err, response) {
            $ngBootbox.alert(err.Message);
        });
	};


$scope.presLoaded = true;
$scope.loadPrescriptionList = function(){
		recordService.getPrescriptionList(recordId,"HelPrescription").then(function(response){
			$scope.prescriptionListOld = response;
			$scope.prescriptionListOld.sort(function(a,b){
		 			if (a.date_of_visit < b.date_of_visit)
					    return 1;
					  if (a.date_of_visit > b.date_of_visit)
					    return -1;
					  return 0;
		 		});

			if($scope.dataLoaded){
				$rootScope.showSpinner = false;
			}
			$scope.presLoaded = false;
		  },function (err, response) {
        });
	};

	$scope.oLmpDateMax = new Date();
	$scope.format = "dd-MM-yyyy"

	$scope.$watch('obstHist.oLmp', function (newValue) {
		$scope.obstHist.oLmp = $filter('date')(newValue, 'dd-MM-yyyy');
	});

	$scope.$watch('obstHist.oEdd', function (newValue) {
		$scope.obstHist.oEdd = $filter('date')(newValue, 'dd-MM-yyyy');
	});

	$scope.$watch('obstHist.actualDelivery', function (newValue) {
		$scope.obstHist.actualDelivery = $filter('date')(newValue, 'dd-MM-yyyy');
	});

	$scope.$watch('currentPregnancy.lmp1', function (newValue) {
		$scope.currentPregnancy.lmp1 = $filter('date')(newValue, 'dd-MM-yyyy');
	});

	$scope.$watch('currentPregnancy.edd1', function (newValue) {
		$scope.currentPregnancy.edd1 = $filter('date')(newValue, 'dd-MM-yyyy');
	});

	$scope.obstHist = {}

	$rootScope.addparaMax = new Date();

	$scope.open1 = function () {
		$scope.lmpresponse = true
		$scope.popup1.opened = true;
	};

	$scope.openedoppup = function () {
		$scope.vitalpopup1.opened = true;
	};

	$rootScope.addnew1 = function () {
		$rootScope.addold1.opened = true;
	};

	$scope.opencp1 = function () {
		$scope.lmpresponse1 = true
		$scope.popup1.opened = true;
	};

	var tt = $scope.oLmpDateMax

	var date = new Date(tt);
	var newdate = new Date(date);

	newdate.setDate(newdate.getDate() + 300);

	var dd = newdate.getDate();
	var mm = newdate.getMonth() + 1;
	var yy = newdate.getFullYear();

	var someFormattedDate = mm + '/' + dd + '/' + yy;
	$scope.oEddDateMax = someFormattedDate
	$scope.oEddDateMin = new Date();

	$scope.eddopen2 = function () {
		$scope.eddresponse = true
		$scope.popup2.opened = true;
	};

	$scope.opencp2 = function () {
		$scope.eddresponse1 = true
		$scope.popup2.opened = true;
	};

	$scope.open3 = function () {
		$scope.adresponse = true
		$scope.popup3.opened = true;
	};
	$scope.dateOptions = {
		formatYear: 'yyyy',
		startingDay: 1
	};
	$rootScope.format = 'dd-MM-yyyy';
	$scope.format = 'dd-MM-yyyy';
	$scope.popup1 = {
		opened: false
	};
	$scope.popup2 = {
		opened: false
	};
	$rootScope.vitalpopup = {
		opened: false
	};
	$scope.popup3 = {
		opened: false
	};

	$scope.vitalpopup1 = {
		opened: false
	};
	$rootScope.addold1 = {
		opened: false
	};


	$rootScope.setdefaultdate1 = function () {
		$rootScope.currentpreg = {}
		$rootScope.currentpreg.date = new Date()
	}

	$scope.getEdd = function () {
		$scope.lmpentered = true
		$scope.lmpmissing = false
		if($scope.obstHist.oLmp == null){
			sessionStorage.setItem("oEdd", null)
			$scope.obstHist.oEdd = ""
		} else {
			var newdate1 = $scope.convertUTCDateToLocalDate(new Date($scope.obstHist.oLmp));
			var toconvert = newdate1.toISOString().slice(0, 10);
			var entereddate = toconvert.slice(0, 4) + '-'
				+ toconvert.slice(5, 7) + '-'
				+ toconvert.slice(8, 10);
			var date1 = $scope.convertUTCDateToLocalDate(new Date(entereddate))
	
			var newdate1 = new Date(date1)
			var newdate2 = new Date(date1)
	
			newdate1.setDate(newdate1.getDate() + 280)
			newdate2.setDate(newdate2.getDate() + 300)
			$scope.obstHist.oEdd = newdate1;
			sessionStorage.setItem("oEdd", $scope.obstHist.oEdd)
	
			// newdate3.setDate(newdate3.getDate() + 280)
			// newdate4.setDate(newdate4.getDate() + 300)
			// $scope.currentPregnancy.edd1 = newdate3;
			// sessionStorage.setItem("cpEdd", $scope.currentPregnancy.edd1)
	
			var changeActual = $scope.convertUTCDateToLocalDate(new Date(entereddate))
			console.log(changeActual, "changeActual")
			var ddActual = changeActual.getDate() - 1;
			var mmActual = changeActual.getMonth() + 1;
			var yyActual = changeActual.getFullYear() + 1;
	
			var someFormattedDateActual = mmActual + '-' + ddActual + '-' + yyActual;
			$scope.oActualDateMax = someFormattedDateActual
	
			var date = $scope.convertUTCDateToLocalDate(new Date($scope.obstHist.oEdd));
			var toconvert = date.toISOString().slice(0, 10);
			var converteddate = toconvert.slice(0, 4) + '-'
				+ toconvert.slice(5, 7) + '-'
				+ toconvert.slice(8, 10);
			var changeActual1 = converteddate;
			var ab = new Date(changeActual1)
	
			ab.setMonth((ab.getMonth() + 1) - 6)
	
			var datead = $scope.convertUTCDateToLocalDate(new Date(ab));
			var toconvert1 = datead.toISOString().slice(0, 10);
			var converteddate1 = toconvert1.slice(0, 4) + '-'
				+ toconvert1.slice(5, 7) + '-'
				+ toconvert1.slice(8, 10);
			$scope.oActualDateMin = converteddate1
		}
		
	}

	$scope.getEddcp = function () {
		$scope.lmpmissing2 = false
		if($scope.currentPregnancy.lmp1 == null){
			sessionStorage.setItem("cpEdd", null)
			$scope.currentPregnancy.edd1 = ""
		} else {
			var newdate1 = $scope.convertUTCDateToLocalDate(new Date($scope.currentPregnancy.lmp1));
			var toconvert = newdate1.toISOString().slice(0, 10);
			var converteddate = toconvert.slice(0, 4) + '-'
				+ toconvert.slice(5, 7) + '-'
				+ toconvert.slice(8, 10);
			console.log(converteddate)
	
			// var toconvert1 = converteddate.split("-").reverse().join("-")
			// var entereddate = toconvert1
			// console.log(entereddate,"entereddate")
			// var entereddatecp = entereddate;
	
			var datecp = new Date(converteddate)
			console.log(datecp, "datecp")
			var newdate3 = new Date(datecp)
			var newdate4 = new Date(datecp)
	
			newdate3.setDate(newdate3.getDate() + 280)
			newdate4.setDate(newdate4.getDate() + 300)
			console.log(newdate3, "newdate3")
			$scope.currentPregnancy.edd1 = newdate3;
			sessionStorage.setItem("cpEdd", $scope.currentPregnancy.edd1)
		}
		
	}

	$scope.changeedd = function () {

		var newdate1 = $scope.convertUTCDateToLocalDate(new Date($scope.obstHist.oEdd));
		var toconvert = newdate1.toISOString().slice(0, 10);
		var entereddate = toconvert.slice(0, 4) + '-'
			+ toconvert.slice(5, 7) + '-'
			+ toconvert.slice(8, 10);
		console.log(entereddate)

		var inputdateEddold = sessionStorage.oEdd
		var changedate0 = new Date(inputdateEddold)
		var dd = changedate0.getDate();
		var mm = changedate0.getMonth() + 1;
		var yy = changedate0.getFullYear();

		var someFormattedDate = dd + '-' + mm + '-' + yy;

		console.log(someFormattedDate, "someFormattedDate")

		var inputdateEdd = entereddate;
		var changedate1 = new Date(inputdateEdd)
		var dd1 = changedate1.getDate();
		var mm1 = changedate1.getMonth() + 1;
		var yy1 = changedate1.getFullYear();

		var someFormattedDate1 = dd1 + '-' + mm1 + '-' + yy1;

		console.log(someFormattedDate1, "someFormattedDate1")

		if (parseInt(yy) <= parseInt(yy1)) {
			if (parseInt(yy) < parseInt(yy1)) {
				toastr.error("Date is greater than LMP+280 days")
			} else if (parseInt(yy) == parseInt(yy1)) {
				if (parseInt(mm) <= parseInt(mm1)) {
					if (parseInt(mm) < parseInt(mm1)) {
						toastr.error("Date is greater than LMP+280 days")
					} else if (parseInt(mm) == parseInt(mm1)) {
						if (parseInt(dd) < parseInt(dd1)) {
							toastr.error("Date is greater than LMP+280 days")
						}
					}
				}
			}
		}
	}

	$scope.changeeddcp = function () {
		var inputdateEddold1 = sessionStorage.cpEdd
		var changedate2 = new Date(inputdateEddold1)
		var dd = changedate2.getDate();
		var mm = changedate2.getMonth() + 1;
		var yy = changedate2.getFullYear();

		var someFormattedDate2 = dd + '-' + mm + '-' + yy;
		console.log(someFormattedDate2, "someFormattedDate2")
		var inputdateEdd1 = $scope.currentPregnancy.edd1;
		var changedate3 = new Date(inputdateEdd1)
		var dd1 = changedate3.getDate();
		var mm1 = changedate3.getMonth() + 1;
		var yy1 = changedate3.getFullYear();

		var someFormattedDate3 = dd1 + '-' + mm1 + '-' + yy1;
		console.log(someFormattedDate3, "someFormattedDate3")
		if (parseInt(yy) <= parseInt(yy1)) {
			if (parseInt(yy) < parseInt(yy1)) {
				toastr.error("Date is greater than LMP+280 days")
			} else if (parseInt(yy) == parseInt(yy1)) {
				if (parseInt(mm) <= parseInt(mm1)) {
					if (parseInt(mm) < parseInt(mm1)) {
						toastr.error("Date is greater than LMP+280 days")
					} else if (parseInt(mm) == parseInt(mm1)) {
						if (parseInt(dd) < parseInt(dd1)) {
							toastr.error("Date is greater than LMP+280 days")
						}
					}
				}
			}
		}
	}

	$scope.para = "0"
	$scope.abortions = "0"
	$scope.gravida = "0"

	$scope.alertbp = function () {
		var options = {
			title: '<h5  style="color:white">Alert</h5>',
			message: '',
			templateUrl: 'views/obstgynec/alertbpvalue.htm',

			size: 'small',
			buttons: {
				ok: {
					label: "ok",
					className: "btn-primary"
				}
			}
		}
		$ngBootbox.customDialog(options);
	}

	$scope.alertfollicleday = function () {
		var options = {
			title: '<h5  style="color:white">Alert</h5>',
			message: '',
			templateUrl: 'views/obstgynec/alertfollicleday.htm',
			size: 'small',
			buttons: {
				ok: {
					label: "ok",
					className: "btn-primary"
				}
			}
		}
		$ngBootbox.customDialog(options);
	}

	$scope.addPara = function () {
		var options = {
			title: '<h5  style="color:white">Para Details</h5>',
			message: '',
			templateUrl: 'views/obstgynec/addparadetails.htm',
			onEscape: function () {
				$scope.closepopup();
				e.preventDefault();
			},
			size: 'large',
			buttons: {
			}
		}
		$ngBootbox.customDialog(options);
	}

	$scope.viewPara = function () {
		var options = {
			title: '<h5  style="color:white">Para Details</h5>',
			message: '',
			templateUrl: 'views/obstgynec/viewparadetails.htm',
			size: 'large',
			buttons: {
			}
		}
		$ngBootbox.customDialog(options);
	}

	$scope.addAbortions = function () {
		var options = {
			title: '<h5 style="color:white">Abortions Details</h5>',
			message: '',
			templateUrl: 'views/obstgynec/addabortionsdetails.htm',
			size: 'large',
			onEscape: function () {
				$scope.closepopup();
				e.preventDefault();
			},
			buttons: {
			}
		}
		$ngBootbox.customDialog(options);
	}

	$scope.viewAbortions = function () {
		var options = {
			title: '<h5 style="color:white">Abortions Details</h5>',
			message: '',
			templateUrl: 'views/obstgynec/viewabortionsdetails.htm',
			size: 'large',
			onEscape: function () { $scope.$apply(); },
			buttons: {
			}
		}
		$ngBootbox.customDialog(options);
	}

	$scope.currentpregrec = function () {
		var options = {
			title: '<h5 style="color:white">Current Pregnancy Details</h5>',
			message: '',
			templateUrl: 'views/obstgynec/currentpregrec.htm',
			size: 'large',
			onEscape: function () {
				$scope.closepopup();
				e.preventDefault();
			},
			buttons: {
			}
		}
		$ngBootbox.customDialog(options);
	}

	$scope.scanpopup = function () {
		var options = {
			title: '<h5 style="color:white">Scan Report Findings</h5>',
			message: '',
			templateUrl: 'views/obstgynec/scanpopup.htm',
			size: 'large',
			onEscape: function () {
				$scope.closepopup();
				e.preventDefault();
			},
			buttons: {
			}
		}
		$ngBootbox.customDialog(options);
	}
	$scope.viewriskHistory = function () {
		var options = {
			title: '<h5  style="color:white">Pregnancy risk history</h5>',
			message: '',
			templateUrl: 'views/obstgynec/viewriskhistory.htm',
			size: 'large',
		}
		$ngBootbox.customDialog(options);
	}

	$scope.folliclestudypopup = function () {
		var options = {
			title: '<h5 style="color:white">Follicle Study Details</h5>',
			message: '',
			templateUrl: 'views/obstgynec/folliclestudypopup.htm',
			size: 'large',
			onEscape: function () {
				$scope.closepopup();
				e.preventDefault();
			},
			buttons: {
			}
		}
		$ngBootbox.customDialog(options);
	}

	$rootScope.closepopup = function () {
		var options = {
			title: '<h5 style="color:white">Cancel confirmation</h5>',
			message: '',
			templateUrl: 'views/obstgynec/cancelconfirmation.htm',
			size: 'small',
			onEscape: function () { $scope.$apply(); },
			buttons: {
				ok: {
					label: "Yes",
					callback: function () {
						$rootScope.addPara = "";
						$rootScope.addabortions = '';
						$rootScope.currentpreg = "";
						$rootScope.folliclestudydate = ""
						$rootScope.folliclestudyday = ""
						$rootScope.rtovary = ""
						$rootScope.ltovary = ""
						$rootScope.follicleendometrium = ""
						$rootScope.folliclecomments = ""
						$rootScope.scanreport = ""
						bootbox.hideAll();
					}
				},
				close: {
					label: "No",
					callback: function () {
						$scope.$apply();
					}
				}
			}
		}
		$ngBootbox.customDialog(options);
		//bootbox.hideAll();
	}

	$rootScope.open4 = function () {
		$scope.popup4.opened = true;
	};

	$rootScope.oAddParaMin = new Date()

	$rootScope.popup4 = {
		opened: false
	};

	$rootScope.open5 = function () {
		$scope.popup5.opened = true;
	};

	$rootScope.oAddAbortionsMax = new Date()

	$rootScope.popup5 = {
		opened: false
	};

	$rootScope.open8 = function () {
		$scope.popup8.opened = true;
	};

	$rootScope.popup8 = {
		opened: false
	};

	$rootScope.addPara = {}
	$rootScope.addabortions = {}
	$scope.obstHist = {}
	
	$scope.addnumbers = function () {
		$scope.obstHist.gravida = $scope.obstHist.para + $scope.obstHist.abortions
	}

	$scope.validateobst = function(){
		if($scope.obstHist.oLmp){
			$scope.addobstHist()
		} else {
			$scope.lmpmissing = true
			$scope.alertlmpmissing()
		}

	}

	$scope.validatecp = function(){
		if($scope.currentPregnancy.lmp1){
			$scope.addcurrentpregnancy();
			$scope.updatescanreport();
			if($scope.riskstatusmodified == true){
				$scope.addrisk();
				$scope.riskstatusmodified = false
			}
			
		} else {
			$scope.lmpmissing2 = true
			$scope.alertlmpmissing2()
		}

	}

	$scope.alertlmpmissing = function () {
		var options = {
			title: '<h5 style="color:white">LMP missing</h5>',
			message: 'LMP is not entered. Do you want to save?',
		//	templateUrl: 'views/obstgynec/cancelconfirmation.htm',
			size: 'medium',
			onEscape: function () { $scope.$apply(); },
			buttons: {
				ok: {
					label: "Yes",
					callback: function () {
						$scope.addobstHist()
						bootbox.hideAll();
					}
				},
				close: {
					label: "No",
					callback: function () {
						$scope.$apply();
					}
				}
			}
		}
		$ngBootbox.customDialog(options);
		//bootbox.hideAll();
	}

	$scope.alertlmpmissing2 = function () {
		var options = {
			title: '<h5 style="color:white">LMP missing</h5>',
			message: 'LMP is not entered. Do you want to save?',
		//	templateUrl: 'views/obstgynec/cancelconfirmation.htm',
			size: 'medium',
			onEscape: function () { $scope.$apply(); },
			buttons: {
				ok: {
					label: "Yes",
					callback: function () {
						$scope.addcurrentpregnancy();
						$scope.updatescanreport();
						if($scope.riskstatusmodified == true){
							$scope.addrisk();
							$scope.riskstatusmodified = false
						}
						//bootbox.hideAll();
					}
				},
				close: {
					label: "No",
					callback: function () {
						$scope.$apply();
					}
				}
			}
		}
		$ngBootbox.customDialog(options);
		//bootbox.hideAll();
	}



	$scope.addobstHist = function () {
		if ($scope.obstHist.notes == undefined) {
			$scope.obstHist.notes = ""
		}

		if ($scope.obstHist.oLmp) {
			var newdate1 = $scope.obstHist.oLmp
			var toconvert1 = newdate1.split("-").reverse().join("-")
			var converteddate1 = toconvert1
		} else {
			var converteddate1 = ""
		}

		if ($scope.obstHist.oEdd) {
			var newdate2 = $scope.obstHist.oEdd
			var toconvert2 = newdate2.split("-").reverse().join("-")
			var converteddate2 = toconvert2
		} else {
			var converteddate2 = ""
		}

		if ($scope.obstHist.actualDelivery) {
			var newdate3 = $scope.obstHist.actualDelivery
			var toconvert3 = newdate3.split("-").reverse().join("-")
			var converteddate3 = toconvert3
		} else {
			var converteddate3 = ""
		}

		var data = {
			"account_email": authService.authentication.account_id,
			"lmp": converteddate1,
			"expected_delivery": converteddate2,
			"actual_delivery": converteddate3,
			"gravida": $scope.obstHist.para + $scope.obstHist.abortions,
			"para": $scope.obstHist.para,
			"abortions": $scope.obstHist.abortions,
			"notes": $scope.obstHist.notes,
			"patient_email": $sessionStorage.get('patientAccEmail'),
			"doctor_id": $scope.authentication.doctor_id
		};
		console.log(data)
		obstgynecService.saveobstHist(data).then(function (response) {
			console.log(response)
			if (response.status == 0) {
				toastr.error(response.message);
			}
			if (response.status == 1) {
				toastr.success(response.message);
				$scope.viewObstHist()
			}
			if (response.status == 2) {
				toastr.error(response.message);
			}
		}, function (error) {
			toastr.error(error);
		})
	}

	$scope.viewObstHist = function () {
		$scope.obstHistoryDetails = [];
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getObstDetails(patient_email).then(function (response) {
				console.log(response.data)
				if (response.data.length > 0) {
					angular.forEach(response, function (value) {
						console.log(response.data[0])
						$scope.obstHist.oLmp = response.data[0].lmp
						$scope.obstHist.oEdd = response.data[0].expected_delivery
						$scope.obstHist.actualDelivery = response.data[0].actual_delivery
						$scope.obstHist.gravida = response.data[0].gravida
						$scope.obstHist.para = response.data[0].para
						$scope.obstHist.abortions = response.data[0].abortions
						$scope.obstHist.notes = response.data[0].notes
					})
				}
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$rootScope.addparadetails = function () {
		var date = $scope.convertUTCDateToLocalDate(new Date($rootScope.addPara.deliverydate));
		var toconvert = date.toISOString().slice(0, 10);
		var converteddate = toconvert.slice(0, 4) + '-'
			+ toconvert.slice(5, 7) + '-'
			+ toconvert.slice(8, 10);
		console.log(converteddate)

		// if($rootScope.addPara.notes){
		//  return $rootScope.addPara.notes
		// } else{
		//  $rootScope.addPara.notes = ""
		// }

		if ($rootScope.addPara.notes == undefined) {
			$rootScope.addPara.notes = ""
		}

		var data = {
			"account_email": authService.authentication.account_id,
			"delivery_date": converteddate,
			"pregnancy_term": $rootScope.addPara.pregnancyterm,
			"delivery_type": $rootScope.addPara.deliverytype,
			"baby_status": $rootScope.addPara.babystatus,
			"doctor_id": $rootScope.authentication.doctor_id,
			"notes": $rootScope.addPara.notes,
			"patient_email": $sessionStorage.get('patientAccEmail'),
		};
		console.log(data)
		obstgynecService.saveParaDetails(data).then(function (response) {
			console.log(response)
			if (response.status == 0) {
				toastr.error(response.message);
			}
			if (response.status == 1) {
				toastr.success(response.message);
			}
			if (response.status == 2) {
				toastr.error(response.message);
			}
			$rootScope.addPara = ""
			bootbox.hideAll();
		})
	}

	$rootScope.paraDetails = [];
	$scope.viewParaDetails = function () {
		$rootScope.paraDetails = [];
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getParaDetails(patient_email).then(function (response) {
				console.log(response.data)
				$rootScope.paraDetails = response.data
				console.log($rootScope.paraDetails)
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$rootScope.addabortionsdetails = function () {
		var date = $scope.convertUTCDateToLocalDate(new Date($rootScope.addabortions.doa));
		var toconvert = date.toISOString().slice(0, 10);
		var converteddate = toconvert.slice(0, 4) + '-'
			+ toconvert.slice(5, 7) + '-'
			+ toconvert.slice(8, 10);
		console.log(converteddate)

		if ($rootScope.addabortions.notes == undefined) {
			$rootScope.addabortions.notes = ""
		}

		var data = {
			"account_email": authService.authentication.account_id,
			"abortion_date": converteddate,
			"abortion_type": $rootScope.addabortions.type,
			"mode": $rootScope.addabortions.term,
			"doctor_id": $rootScope.authentication.doctor_id,
			"notes": $rootScope.addabortions.notes,
			"patient_email": $sessionStorage.get('patientAccEmail'),
		};
		console.log(data)
		obstgynecService.saveAbortionsDetails(data).then(function (response) {
			console.log(response)
			if (response.status == 0) {
				toastr.error(response.message);
			}
			if (response.status == 1) {
				toastr.success(response.message);
			}
			if (response.status == 2) {
				toastr.error(response.message);
			}
			bootbox.hideAll();
			//$rootScope.addabortions = ''
		})
	}

	$rootScope.abortionsDetails = [];
	$scope.viewAbortionsDetails = function () {
		$rootScope.abortionsDetails = [];
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getAbortionsDetails(patient_email).then(function (response) {
				if (response.data.length > 0) {
					angular.forEach(response, function (value) {
						$rootScope.abortionsDetails = response.data
					})
				}
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$scope.currentPregnancy = {}
	$scope.addcurrentpregnancy = function () {

		if ($scope.currentPregnancy.lmp1) {
			var newdate1 = $scope.currentPregnancy.lmp1;
			var toconvert1 = newdate1.split("-").reverse().join("-")
			var converteddate1 = toconvert1
		} else {
			var converteddate1 = ""
		}

		if ($scope.currentPregnancy.edd1) {
			var newdate2 = $scope.currentPregnancy.edd1
			var toconvert2 = newdate2.split("-").reverse().join("-")
			var converteddate2 = toconvert2
		} else {
			var converteddate2 = ""
		}

		// var date = $scope.convertUTCDateToLocalDate(new Date($scope.currentPregnancy.lmp1));
		// var toconvert = date.toISOString().slice(0, 10);
		// var converteddate = toconvert.slice(0, 4) + '-'
		// 	+ toconvert.slice(5, 7) + '-'
		// 	+ toconvert.slice(8, 10);
		// console.log(converteddate)

		// var date1 = $scope.convertUTCDateToLocalDate(new Date($scope.currentPregnancy.edd1));
		// var toconvert1 = date1.toISOString().slice(0, 10);
		// var converteddate1 = toconvert1.slice(0, 4) + '-'
		// 	+ toconvert1.slice(5, 7) + '-'
		// 	+ toconvert1.slice(8, 10);
		// console.log(converteddate1)

		if ($scope.currentPregnancy.obsthistory == undefined) {
			$scope.currentPregnancy.obsthistory = ""
		}
		var data = {
			"account_email": authService.authentication.account_id,
			"lmp": converteddate1,
			"expected_delivery": converteddate2,
			"obst_history": $scope.currentPregnancy.obsthistory,
			"patient_email": $sessionStorage.get('patientAccEmail'),
			"doctor_id": $scope.authentication.doctor_id
		};
		console.log(data)
		obstgynecService.saveCurrentPregnancy(data).then(function (response) {
			console.log(response)
			if (response.status == 0) {
				toastr.error(response.message);
			}
			if (response.status == 1) {
				toastr.success(response.message);
			}
			if (response.status == 2) {
				toastr.error(response.message);
			}
		})
	}

	$scope.currentPregnancy = {}
	$scope.viewcurrentpreg = function () {
		$scope.currentpregDetails = [];
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getCurrentPregnancy(patient_email).then(function (response) {
				if (response.data.length > 0) {
					angular.forEach(response, function (value) {

						//$scope.currentpregDetails = response.data
						$scope.currentPregnancy.lmp1 = response.data[0].lmp
						$scope.currentPregnancy.edd1 = response.data[0].edd
						console.log($scope.currentPregnancy.lmp1, "$scope.currentPregnancy.lmp1")
						console.log($scope.currentPregnancy.edd1, "$scope.currentPregnancy.edd1")
					})
					console.log(response.data[0].obst_history)
					$scope.currentPregnancy.obsthistory = response.data[0].obst_history
				}
			}, function (error) {
				toastr.error(error);
			})
		}
	}
	$rootScope.currentpreg = {}
	$rootScope.savecprecords = function () {
		var date0 = $scope.convertUTCDateToLocalDate(new Date($rootScope.currentpreg.date));
		var toconvert0 = date0.toISOString().slice(0, 10);
		var converteddate0 = toconvert0.slice(0, 4) + '-'
			+ toconvert0.slice(5, 7) + '-'
			+ toconvert0.slice(8, 10);
		console.log(converteddate0)

		if ($rootScope.currentpreg.remarks == undefined) {
			$rootScope.currentpreg.remarks = ""
		}

		if ($rootScope.currentpreg.bp) {
			var bpArr = []
			var splitBp = $rootScope.currentpreg.bp
			var splitBp1 = splitBp.split("")
			bpArr.push({ x: splitBp1 })
			console.log(bpArr[0].x[0])
			if (bpArr[0].x[2] == "/") {
				var sumDia = bpArr[0].x[0] + bpArr[0].x[1]
				// console.log(bpArr[0].x.length)
				if (bpArr[0].x.length == 5) {
					var sumSys = bpArr[0].x[3] + bpArr[0].x[4]
				}
				if (bpArr[0].x.length == 6) {
					var sumSys = bpArr[0].x[3] + bpArr[0].x[4] + + bpArr[0].x[5]
				}
				if (sumDia >= 40 && sumSys >= 60 && sumSys <= 250) {
					$rootScope.currentpreg.bp = parseInt(sumDia) + '/' + parseInt(sumSys)
				} else {
					return $scope.alertbp();
				}
			}

			else if (bpArr[0].x[3] == "/") {
				var sumDia = bpArr[0].x[0] + bpArr[0].x[1] + bpArr[0].x[2]
				if (bpArr[0].x.length == 6) {
					var sumSys = bpArr[0].x[4] + bpArr[0].x[5]
				}
				if (bpArr[0].x.length == 7) {
					var sumSys = bpArr[0].x[4] + bpArr[0].x[5] + + bpArr[0].x[6]
				}
				if (sumDia >= 40 && sumDia <= 200 && sumSys >= 60 && sumSys <= 250) {
					$rootScope.currentpreg.bp = parseInt(sumDia) + '/' + parseInt(sumSys)
				} else {
					return $scope.alertbp();
				}
			} else {
				return $scope.alertbp();
			}
		}
		var data = {
			"account_email": authService.authentication.account_id,
			"date": converteddate0,
			"bp": $rootScope.currentpreg.bp,
			"pa": $rootScope.currentpreg.pa,
			"remarks": $rootScope.currentpreg.remarks,
			"patient_email": $sessionStorage.get('patientAccEmail'),
			"doctor_id": $scope.authentication.doctor_id
		};
		console.log(data)
		obstgynecService.saveCurrentPregnancyRec(data).then(function (response) {
			console.log(response)
			if (response.status == 0) {
				toastr.error(response.message);
			}
			if (response.status == 1) {
				toastr.success(response.message);
			}
			if (response.status == 2) {
				toastr.error(response.message);
			}
			$rootScope.viewCpRecDetails();
			$rootScope.currentpreg = ""
			bootbox.hideAll();
		})
	}

	$rootScope.cprDetails = [];
	$rootScope.viewCpRecDetails = function () {
		$rootScope.cprDetails = [];
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getCurrentPregnancyRec(patient_email).then(function (response) {
				$scope.iscprDetailsExist = response.data
				if (response.data.length > 0) {
					console.log(response)
					angular.forEach(response, function (value) {
						$rootScope.cprDetails = response.data
					})
					// $rootScope.addcpr.bp0 = $rootScope.cprDetails[0].bp
					// $rootScope.addcpr.pa0 = $rootScope.cprDetails[0].pa
					// $rootScope.addcpr.remarks0 = $rootScope.cprDetails[0].remarks
				}
			}, function (error) {
				toastr.error(error);
			})
		}
	}


	$rootScope.cprisSelected = []

	$rootScope.cprexist = function (data) {
		$rootScope.cprisSelected.findIndex(function (el) {
			if (el.id == data) {
				return true
			} else {
				return false
			}
		});
	}
	$rootScope.cprisallSelected = false
	$rootScope.cproptiontoggle = function (data) {
		var indexToDel = $rootScope.cprisSelected.findIndex(function (el) {
			return el.id == data;
		});
		if (indexToDel > -1) {
			$rootScope.cprisSelected.splice(indexToDel, 1)
		} else {
			$rootScope.cprisSelected.push({ id: data })
		}
		//   console.log($rootScope.cprisallSelected,"$rootScope.cprisallSelected")
		//   if($rootScope.cprisallSelected == false){
		// 	  console.log("a")
		// 	if($rootScope.cprisSelected.length == $rootScope.cprDetails.length){
		// 		console.log("a1")
		// 		$rootScope.cprisallSelected = true
		// 	  } 
		// 	//   else {
		// 	// 	$rootScope.cprisallSelected = false
		// 	//   }
		//   }
		//   else if($rootScope.cprisallSelected == true){
		// 	  console.log("b")
		// 	if($rootScope.cprisSelected.length != $rootScope.cprDetails.length){
		// 		console.log("b1")
		// 		$rootScope.cprisallSelected = false
		// 	  } 
		//   }

	}

	//$rootScope.cprisallSelected = false
	$rootScope.cprtoggleAll = function () {
		$rootScope.cprisallSelected = !$rootScope.cprisallSelected
		if ($rootScope.cprisallSelected) {
			angular.forEach($rootScope.cprDetails, function (item) {
				var indexToDel = $rootScope.cprisSelected.findIndex(function (el) {
					return el.id == item.id;
				});
				if (indexToDel >= 0) {
					$rootScope.cprexist = function () {
						return true
					}
				} else {
					$rootScope.cprisSelected.push({ id: item.id })
					$rootScope.cprexist = function () {
						return true
					}
				}
			})
		} else {
			$rootScope.cprisSelected = []
			$rootScope.cprexist = function () {
				return false
			}
		}
	}

	$rootScope.archiveallcpr = function () {
		$scope.viewObstHist()
			var options = {
				title: '<h5 style="color:white">Archive Current Pregnancy records</h5>',
				message: 'Do you want to clear LMP, EDD and Actual delivery?',
				size: 'medium',
				onEscape: function () { $scope.$apply(); },
				buttons: {
					ok: {
						label: "Yes",
						callback: function () {
							if ($scope.obstHist.notes == undefined) {
								$scope.obstHist.notes = ""
							}
							var data = {
								"account_email": authService.authentication.account_id,
								"lmp": "",
								"expected_delivery": "",
								"actual_delivery": "",
								"gravida": $scope.obstHist.para + $scope.obstHist.abortions ? $scope.obstHist.para + $scope.obstHist.abortions : "0",
								"para": $scope.obstHist.para ? $scope.obstHist.para : "0",
								"abortions": $scope.obstHist.abortions ? $scope.obstHist.abortions : "0",
								"notes": $scope.obstHist.notes,
								"patient_email": $sessionStorage.get('patientAccEmail'),
								"doctor_id": $scope.authentication.doctor_id
							};
							console.log(data)
							obstgynecService.saveobstHist(data).then(function (response) {
								console.log(response)
								if (response.status == 0) {
									toastr.error(response.message);
								}
								if (response.status == 1) {
									toastr.success("Updated successfully");
									$scope.viewObstHist()
								}
								if (response.status == 2) {
									toastr.error(response.message);
								}
							}, function (error) {
								toastr.error(error);
							})
					
							if ($scope.currentPregnancy.obsthistory == undefined) {
								$scope.currentPregnancy.obsthistory = ""
							}
							var data = {
								"account_email": authService.authentication.account_id,
								"lmp": "",
								"expected_delivery": "",
								"obst_history": $scope.currentPregnancy.obsthistory,
								"patient_email": $sessionStorage.get('patientAccEmail'),
								"doctor_id": $scope.authentication.doctor_id
							};
							console.log(data)
							obstgynecService.saveCurrentPregnancy(data).then(function (response) {
								console.log(response)
								if (response.status == 0) {
									toastr.error(response.message);
								}
								if (response.status == 1) {
									toastr.success("Updated successfully");
								}
								if (response.status == 2) {
									toastr.error(response.message);
								}
								$scope.viewcurrentpreg()
							})
							
						}
					},
					close: {
						label: "No",
						callback: function () {
							$scope.$apply();
						}
					}
				}
			}
			$ngBootbox.customDialog(options);
		
		if($rootScope.cprisSelected.length>0){
			var data = {
				account_email: authService.authentication.account_id,
				data: $rootScope.cprisSelected
			}
			obstgynecService.saveCurrentPregnancyRec(data).then(function (response) {
				toastr.success("Archived successfully")
				$rootScope.viewCpRecDetails();
				$rootScope.cprisSelected = []
			})
		} else {
			if($scope.iscprDetailsExist.length == 0){
				toastr.error("No record found")
			} else {
				toastr.error("Please select any record")
			}
			
		}
	}

	$rootScope.viewarchivedCpRecDetails = function () {
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getarchivedCurrentPregnancyRec(patient_email).then(function (response) {
				if (response.data.length > 0) {
					$rootScope.showpastcprdetails = true
					$rootScope.archivedcprDetails = response.data
				} else {
					$rootScope.showpastcprdetails = false
				}
				var options = {
					title: '<h5 style="color:white">Past Pregnancy Records</h5>',
					message: '',
					templateUrl: 'views/obstgynec/archivedcprDetails.htm',
					size: 'large',
					onEscape: function () {
					},
					buttons: {
					}
				}
				$ngBootbox.customDialog(options);
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$rootScope.scanreport = {}

	$rootScope.addscanreport = function () {
		if (sessionStorage.appointment_id !== "") {
			var scandate = $filter('date')($rootScope.scanreport.scannedon, "yyyy-MM-dd");
			var nextscandate = $filter('date')($rootScope.scanreport.nextscandate, "yyyy-MM-dd");
			var todayscandate = $filter('date')(new Date(), "yyyy-MM-dd");
			var data = {
				"patient_email": $sessionStorage.get('patientAccEmail'),
				"account_email": authService.authentication.account_id,
				"doctor_id": $scope.authentication.doctor_id,
				"appointment_id": $sessionStorage.get('appointment_id'),
				"scan_date": scandate,
				"scan_findings": $rootScope.scanreport.findings,
				"next_scan_date": nextscandate,
				"date": todayscandate
			}
			obstgynecService.savescanreport(data).then(function (response) {
				if (response.status == 0) {
					toastr.error(response.error)
				} else if (response.status == 1) {
					toastr.success(response.message)
				}
				$scope.createscanid = []

				$scope.createscanid.push(response.id)

				sessionStorage.setItem("createscanid", $scope.createscanid)
				$rootScope.scanreport = ""
				$scope.viewscanreport()
				bootbox.hideAll();
			})
		} else {
			var scandate = $filter('date')($rootScope.scanreport.scannedon, "yyyy-MM-dd");
			var nextscandate = $filter('date')($rootScope.scanreport.nextscandate, "yyyy-MM-dd");
			var todayscandate = $filter('date')(new Date(), "yyyy-MM-dd");
			var data = {
				"patient_email": $sessionStorage.get('patientAccEmail'),
				"account_email": authService.authentication.account_id,
				"doctor_id": $scope.authentication.doctor_id,
				"scan_date": scandate,
				"scan_findings": $rootScope.scanreport.findings,
				"next_scan_date": nextscandate,
				"date": todayscandate
			}
			obstgynecService.savescanreport(data).then(function (response) {
				if (response.status == 0) {
					toastr.error(response.error)
				} else if (response.status == 1) {
					toastr.success(response.message)
				}
				$scope.createscanid = []

				$scope.createscanid.push(response.id)

				sessionStorage.setItem("createscanid", $scope.createscanid)
				$rootScope.scanreport = ""
				$scope.viewscanreport()
				bootbox.hideAll();
			})
		}

	}

	$rootScope.scandetails = [];
	$scope.viewscanreport = function () {
		$rootScope.scandetails = [];
		$scope.getscanid = []
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getscanreport(patient_email).then(function (response) {
				$scope.iscpScanExist = response.data
				if (response.data.length > 0) {
					console.log(response)
					angular.forEach(response, function (value) {
						$rootScope.scandetails = response.data
						angular.forEach(value, function (data) {
							$scope.getscanid.push(data.id)
							data.isSelected = false
						})
					})
				}
				$scope.enablescandetail = function (data) {
					if (parseInt(data) == parseInt(sessionStorage.createscanid)) {
						return false;
					} else {
						return true;
					}
				}
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$scope.setfollowupdate = function (position, nextscandate, date, scandate, findings, checkboxvalue) {
		angular.forEach($rootScope.scandetails, function (item, index) {
			if (position != index)
				item.isSelected = false;
		})
		$scope.checkboxvalue = checkboxvalue
		$scope.nextscanfollowup = nextscandate.split("-").reverse().join("-")
		
		$scope.scancurrentdate = date
		$scope.scannedondate = scandate
		$scope.updatescanfindings = findings
	}

	$scope.updatescanreport = function () {
		if ($scope.checkboxvalue == true) {
			if ($sessionStorage.get('appointment_id')) {
				
				var scandate = $scope.scannedondate.split("-").reverse().join("-")
				var nextscandate = $scope.nextscanfollowup
				$scope.followupModelText.txt = $scope.nextscanfollowup
				var todayscandate = $scope.scancurrentdate.split("-").reverse().join("-")

				var data = {
					"patient_email": $sessionStorage.get('patientAccEmail'),
					"account_email": authService.authentication.account_id,
					"doctor_id": $scope.authentication.doctor_id,
					"scan_date": scandate,
					"scan_findings": $scope.updatescanfindings,
					"next_scan_date": nextscandate,
					"date": todayscandate,
					"appointment_id": $sessionStorage.get('appointment_id'),
					"follow_up": "1"
				}
				if ($scope.updateOP == 1) {
					$scope.updateOverviewData();
					console.log("update")
				}
				else {
					$scope.saveOverviewData();
					console.log("add")
				}
				obstgynecService.savescanreport(data).then(function (response) {
					if (response.status == 0) {
						toastr.error(response.error)
					} else if (response.status == 1) {
						toastr.success(response.message)
					}
					$scope.enablescandetail = function (value) {
						return true
					}
					sessionStorage.removeItem("createscanid")
					$scope.viewscanreport();

				})
			} else {
				var options = {
					title: '<b><span>Alert</span> </b>',
					message: 'There is no previous consultation associated with this patient to set Follow Up date. Please start consultation and enter follow up date.',
					onEscape: function () { $scope.$apply(); },
					buttons: {
						close: {
							label: " Close",
							className: "btn-danger fa fa-times",
							callback: function () { }
						}
					}
				};
				$ngBootbox.customDialog(options);
			}
		} else if ($scope.checkboxvalue == false) {
			return
		}
	}

	$scope.changeDate = function(){
		if($scope.followupModel.day >= 0){
			$scope.followupModelText.txt= '';
		}
	};

	$rootScope.cpScanisSelected = []

	$rootScope.cpScanexist = function (data) {
		$rootScope.cpScanisSelected.findIndex(function (el) {
			if (el.id == data) {
				return true
			} else {
				return false
			}
		});
	}
	$rootScope.cpScanisallSelected = false
	$rootScope.cpScanoptiontoggle = function (data) {
		var indexToDel = $rootScope.cpScanisSelected.findIndex(function (el) {
			return el.id == data;
		});
		console.log(indexToDel, "indexToDel")
		if (indexToDel > -1) {
			$rootScope.cpScanisSelected.splice(indexToDel, 1)
		} else {
			$rootScope.cpScanisSelected.push({ id: data })
		}
	}

	$rootScope.cpScantoggleAll = function () {
		$rootScope.cpScanisallSelected = !$rootScope.cpScanisallSelected
		if ($rootScope.cpScanisallSelected) {
			angular.forEach($rootScope.scandetails, function (item) {
				var indexToDel = $rootScope.cpScanisSelected.findIndex(function (el) {
					return el.id == item.id;
				});
				if (indexToDel >= 0) {
					$rootScope.cpScanexist = function () {
						return true
					}
				} else {
					$rootScope.cpScanisSelected.push({ id: item.id })
					$rootScope.cpScanexist = function () {
						return true
					}
				}
			})
		} else {
			$rootScope.cpScanisSelected = []
			$rootScope.cpScanexist = function () {
				return false
			}
		}
	}

	$rootScope.archiveallcpScan = function () {
		if($rootScope.cpScanisSelected.length>0){
			var data = {
				account_email: authService.authentication.account_id,
				data: $rootScope.cpScanisSelected
			}
			obstgynecService.savescanreport(data).then(function (response) {
				toastr.success("Archived successfully")
				$scope.viewscanreport();
				$rootScope.cpScanisSelected = []
			})
		} else {
			if($scope.iscpScanExist == "no scan reports found"){
				toastr.error("No record found")
			} else {
				toastr.error("Please select any record")
			}
		}
		
	}

	$rootScope.viewarchivedcpScanDetails = function () {
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getarchivedscanreport(patient_email).then(function (response) {
				if (response.data == "no scan reports found") {
					$rootScope.showpastcpScandetails = false
				} else {
					$rootScope.showpastcpScandetails = true
					$rootScope.archivedcpScanDetails = response.data
				}
				var options = {
					title: '<h5 style="color:white">Past Scan report findings</h5>',
					message: '',
					templateUrl: 'views/obstgynec/archivedcpScanDetails.htm',
					size: 'large',
					onEscape: function () {
					},
					buttons: {
					}
				}
				$ngBootbox.customDialog(options);
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$scope.gynecHist = {}
	$scope.open6 = function () {
		$scope.popup6.opened = true;
	};
	$rootScope.gLmpDateMax = new Date()
	$scope.popup6 = {
		opened: false
	};
	$scope.open7 = function () {
		$scope.popup7.opened = true;
	};
	$scope.gDoeDateMax = new Date()

	$scope.popup7 = {
		opened: false
	};

	$scope.addgynecHist = function () {
		if($scope.gynecHist.lmp){
			var date0 = $scope.convertUTCDateToLocalDate(new Date($scope.gynecHist.lmp));
			var toconvert = date0.toISOString().slice(0, 10);
			var converteddate = toconvert.slice(0, 4) + '-'
				+ toconvert.slice(5, 7) + '-'
				+ toconvert.slice(8, 10);
			console.log(converteddate)
		} else {
			var converteddate = ""
		}
		if($scope.gynecHist.doe){
			var date1 = $scope.convertUTCDateToLocalDate(new Date($scope.gynecHist.doe));
			var toconvert1 = date1.toISOString().slice(0, 10);
			var converteddate1 = toconvert1.slice(0, 4) + '-'
				+ toconvert1.slice(5, 7) + '-'
				+ toconvert1.slice(8, 10);
			console.log(converteddate1)
		} else {
			var converteddate1 = ""
		}
		
		if ($scope.gynecHist.menstrualhistory == undefined) {
			$scope.gynecHist.menstrualhistory = ""
		}

		if ($scope.gynecHist.complaints == undefined) {
			$scope.gynecHist.complaints = ""
		}

		if ($scope.gynecHist.gynecnotes == undefined) {
			$scope.gynecHist.gynecnotes = ""
		}

		var data = {
			"account_email": authService.authentication.account_id,
			"lmp": converteddate,
			"date": converteddate1,
			"mensural_history": $scope.gynecHist.menstrualhistory,
			"complaint": $scope.gynecHist.complaints,
			"notes": $scope.gynecHist.gynecnotes,
			"patient_email": $sessionStorage.get('patientAccEmail'),
			"doctor_id": $scope.authentication.doctor_id
		};
		console.log(data)
		obstgynecService.savegynecHist(data).then(function (response) {
			console.log(response)
			if (response.status == 0) {
				toastr.error(response.message);
			}
			if (response.status == 1) {
				toastr.success(response.message);
			}
			if (response.status == 2) {
				toastr.error(response.message);
			}
			$scope.gynecHist.lmp = ""
			$scope.gynecHist.doe = ""
			$scope.gynecHist.menstrualhistory = ""
			$scope.gynecHist.complaints = ""
			$scope.gynecHist.gynecnotes = ""
			$scope.viewGynecHistDetails()
		})
	}

	$scope.gynecHistDetails = [];
	$scope.viewGynecHistDetails = function () {
		$scope.gynecHistDetails = [];
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getgynecHist(patient_email).then(function (response) {
				console.log(response)
				if (response.data.length > 0) {
					angular.forEach(response, function (value) {
						$scope.gynecHistDetails = response.data
					})
				}
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$scope.riskstatusmodifiedfunc = function(){
		$scope.riskstatusmodified = true
	}

	$scope.addrisk = function () {
		$scope.date = new Date();
		$scope.formattedDate = $filter('date')(new Date(), "yyyy-MM-dd");

		var data = {
			"account_email": authService.authentication.account_id,
			"patient_email": $sessionStorage.get('patientAccEmail'),
			"risk_from": $scope.riskfromvalue ? $scope.riskfromvalue : "",
			"risk_to": $scope.currentPregnancy.pregriskvalue,
			"date": $scope.formattedDate

		};
		obstgynecService.saveriskvalue(data).then(function (response) {
			console.log("response", response)
			if (response.status == 0) {
				toastr.error("Pregnancy risk can be changed just once per day");
			}
			// if (response.status == 1) {
			// 	toastr.success(response.message);
			// }
			if (response.status == 2) {
				toastr.error("Pregnancy risk can be changed just once per day");
			}
			$scope.viewriskHistorydetails()
		})
	}

	$scope.viewriskHistorydetails = function () {

		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getriskvalue(patient_email).then(function (response) {
				$scope.pregriskDetails = response.data
				if (response.data == "no risk found") {
					$rootScope.riskdatadetails = "false"
				} else {
					$rootScope.riskdatadetails = "true"
					$scope.riskchangeArr = []
					for (var i = 0; i < response.data.length; i++) {
						$scope.riskchangeArr.push({ date: response.data[i].date, risk_from: response.data[i].risk_from, risk_to: response.data[i].risk_to, id: response.data[i].id })
					}

					angular.forEach($scope.riskchangeArr, function (value) {
						$rootScope.riskchangeHistory = $scope.riskchangeArr
					})
				}
				angular.forEach(response.data, function (value) {
					$scope.currentPregnancy.pregriskvalue = response.data[0].risk_to
					$scope.riskfromvalue = response.data[0].risk_to
				})
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$rootScope.addfollicledata = function () {
		if($rootScope.folliclestudydate){
			var date0 = $scope.convertUTCDateToLocalDate(new Date($rootScope.folliclestudydate));
			var toconvert = date0.toISOString().slice(0, 10);
			var converteddate = toconvert.slice(0, 4) + '-'
				+ toconvert.slice(5, 7) + '-'
				+ toconvert.slice(8, 10);
			console.log(converteddate)
		} else {
			var converteddate = ""
		}

		if($rootScope.folliclestudyday){
			var fsArr = []
			var splitfs = $rootScope.folliclestudyday
			var splitfs1 = splitfs.split("")
			fsArr.push({x: splitfs1})
			console.log(fsArr)
			if(fsArr[0].x.length==2){
				if(fsArr[0].x[0]==2){
					if(fsArr[0].x[1]<=5){
						console.log(fsArr)
					} else {
						return $scope.alertfollicleday();
					}
				}
				if(fsArr[0].x[0]>2){
					return $scope.alertfollicleday();
				}
			}
		} else {
			$rootScope.folliclestudydate = ""
		}
		
		var data = {
			"account_email": authService.authentication.account_id,
			"date": converteddate,
			"day": $rootScope.folliclestudyday ? $rootScope.folliclestudyday : "",
			"rt_ovary": $rootScope.rtovary ? $rootScope.rtovary : "",
			"lt_ovary": $rootScope.ltovary ? $rootScope.ltovary : "",
			"endometrium" : $rootScope.follicleendometrium ? $rootScope.follicleendometrium : "",
			"comments" : $rootScope.folliclecomments ? $rootScope.folliclecomments : "",
			"patient_email": $sessionStorage.get('patientAccEmail'),
			"doctor_id": $rootScope.authentication.doctor_id
		};
		console.log(data)
		obstgynecService.savefollicleStudy(data).then(function (response) {
			if (response.status == 0) {
				toastr.error(response.message);
			}
			if (response.status == 1) {
				toastr.success(response.message);
			}
			$rootScope.folliclestudydate = ""
			$rootScope.folliclestudyday = ""
			$rootScope.rtovary = ""
			$rootScope.ltovary = ""
			$rootScope.follicleendometrium = ""
			$rootScope.folliclecomments = ""
			bootbox.hideAll();
			$scope.viewfollicledata();
			
		})
	}

	$scope.viewfollicledata = function () {
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getfollicleStudy(patient_email).then(function (response) {
				if (response.data.length > 0) {
					angular.forEach(response, function (value) {
						$scope.follicleDetails = response.data
					})
				} else {
					$scope.follicleDetails = []
				}
			}, function (error) {
				toastr.error(error);
			})
		}
	}


	// $scope.dataType = [
	//  { id: 1, colId: ['col1', 'col4'], dataTypeName: 'Date' },
	//  { id: 2, colId: ['col2', 'col3'], dataTypeName: 'Alpha' },
	//  { id: 3, colId: ['col5', 'col6', 'col7', 'col8'], dataTypeName: 'List Value' }
	// ];

	$scope.columns = [{ colId: 'col1', name: '', dataFormat: '', excludedChar: '', maxLength: '' }];

	$scope.addNewColumn = function () {
		var newItemNo = $scope.columns.length + 1;
		$scope.columns.push({ 'colId': 'col' + newItemNo });
	};


	$scope.removeColumn = function (index) {
		// remove the row specified in index
		$scope.columns.splice(index, 1);
		// if no rows left in the array create a blank array
		if ($scope.columns.length() === 0 || $scope.columns.length() == null) {
			alert('no rec');
			$scope.columns.push = [{ "colId": "col1" }];
		}
	};

	$rootScope.follicleisSelected = []

	$rootScope.follicleexist = function (data) {
		$rootScope.follicleisSelected.findIndex(function (el) {
			if (el.id == data) {
				return true
			} else {
				return false
			}
		});
	}
	$rootScope.follicleisallSelected = false
	$rootScope.follicleoptiontoggle = function (data) {
		var indexToDel = $rootScope.follicleisSelected.findIndex(function (el) {
			return el.id == data;
		});
		console.log(indexToDel, "indexToDel")
		if (indexToDel > -1) {
			$rootScope.follicleisSelected.splice(indexToDel, 1)
		} else {
			$rootScope.follicleisSelected.push({ id: data })
		}
	}

	$rootScope.follicletoggleAll = function () {
		$rootScope.follicleisallSelected = !$rootScope.follicleisallSelected
		if ($rootScope.follicleisallSelected) {
			angular.forEach($scope.follicleDetails, function (item) {
				var indexToDel = $rootScope.follicleisSelected.findIndex(function (el) {
					return el.id == item.id;
				});
				if (indexToDel >= 0) {
					$rootScope.follicleexist = function () {
						return true
					}
				} else {
					$rootScope.follicleisSelected.push({ id: item.id })
					$rootScope.follicleexist = function () {
						return true
					}
				}
			})
		} else {
			$rootScope.follicleisSelected = []
			$rootScope.follicleexist = function () {
				return false
			}
		}
	}

	$rootScope.archiveallfollicle = function () {
		if($rootScope.follicleisSelected.length>0){
			var data = {
				account_email: authService.authentication.account_id,
				data: $rootScope.follicleisSelected
			}
			obstgynecService.savefollicleStudy(data).then(function (response) {
				$scope.viewfollicledata();
				toastr.success("Archived successfully")
				$rootScope.follicleisSelected = []
			})
		} else {
			if($scope.follicleDetails.length == 0){
				toastr.error("No record found")
			} else {
				toastr.error("Please select any record")
			}
			
		}
		
	}

	$rootScope.viewarchivedfollicleDetails = function () {
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getarchivedfollicleStudy(patient_email).then(function (response) {
				if (response.data.length > 0) {
					$rootScope.showarchivedfollicledetails = true
					$rootScope.archivedfollicleDetails = response.data
				} else {
					$rootScope.showarchivedfollicledetails = false
				}
				var options = {
					title: '<h5 style="color:white">Past Follicle studies</h5>',
					message: '',
					templateUrl: 'views/obstgynec/archivedfollicleDetails.htm',
					size: 'large',
					onEscape: function () {
					},
					buttons: {
					}
				}
				$ngBootbox.customDialog(options);
			}, function (error) {
				toastr.error(error);
			})
		}
	}

	$rootScope.pregriskisSelected = []

	$rootScope.pregriskexist = function (data) {
		$rootScope.pregriskisSelected.findIndex(function (el) {
			if (el.id == data) {
				return true
			} else {
				return false
			}
		});
	}
	$rootScope.pregriskisallSelected = false
	$rootScope.pregriskoptiontoggle = function (data) {
		var indexToDel = $rootScope.pregriskisSelected.findIndex(function (el) {
			return el.id == data;
		});
		if (indexToDel > -1) {
			$rootScope.pregriskisSelected.splice(indexToDel, 1)
		} else {
			$rootScope.pregriskisSelected.push({ id: data })
		}
	}

	$rootScope.pregrisktoggleAll = function () {
		$rootScope.pregriskisallSelected = !$rootScope.pregriskisallSelected
		console.log($rootScope.pregriskisallSelected)
		if ($rootScope.pregriskisallSelected) {
			angular.forEach($scope.pregriskDetails, function (item) {
				var indexToDel = $rootScope.pregriskisSelected.findIndex(function (el) {
					return el.id == item.id;
				});
				if (indexToDel >= 0) {
					$rootScope.pregriskexist = function () {
						return true
					}
				} else {
					$rootScope.pregriskisSelected.push({ id: item.id })
					$rootScope.pregriskexist = function () {
						return true
					}
				}
			})
		} else {
			$rootScope.pregriskisSelected = []
			$rootScope.pregriskexist = function () {
				return false
			}
		}
	}

	$rootScope.archiveallpregrisk = function () {
		if($rootScope.pregriskisSelected.length>0){
			var data = {
				account_email: authService.authentication.account_id,
				data: $rootScope.pregriskisSelected
			}
			obstgynecService.saveriskvalue(data).then(function (response) {
				$scope.viewriskHistorydetails();
				toastr.success("Archived successfully")
				$rootScope.pregriskisSelected = []
			})
		} else {
			if($scope.pregriskDetails == "no risk found"){
				toastr.error("No record found")
			} else {
				toastr.error("Please select any record")
			}
			
		}
	}

	$rootScope.viewarchivedpregriskDetails = function () {
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
			obstgynecService.getarchivedriskvalue(patient_email).then(function (response) {
				if (response.data == "no risk found") {
					$rootScope.showpastriskdetails = false
				} else {
					$rootScope.showpastriskdetails = true
					$rootScope.archivedpregriskDetails = response.data
				}

				var options = {
					title: '<h5 style="color:white">Past Pregnancy risk details</h5>',
					message: '',
					templateUrl: 'views/obstgynec/archivedpregriskDetails.htm',
					size: 'large',
					onEscape: function () {
					},
					buttons: {
					}
				}
				$ngBootbox.customDialog(options);
			}, function (error) {
				toastr.error(error);
			})
		}
	}



	$scope.loadLabReportList = function () {
		var data = {
			account_email: authService.authentication.account_id,
			patient_email: $sessionStorage.get('patientAccEmail') != null ? $sessionStorage.get('patientAccEmail') : ''
		};

		recordService.getLabReportList(data).then(function (response) {
			console.log(response,"response")
			var newAttachment = [];
			var labtestArr = []
			angular.forEach(response, function (value) {
				labtestArr = [];
				newAttachment = [];
				angular.forEach(value.data, function (test) {
					$scope.labreportui = value.data.length
					angular.forEach(test.lab_test, function(item){
						labtestArr.push(item)
				})

				
				var counter = 1;
				if (test.image_attachments != null) {
					angular.forEach(test.image_attachments, function (items) {
						if (items.startsWith("img_")) {
							newAttachment.push({ 
								name: 'View report ', 
								id: $rootScope.imageUploadUrl + items, 
								replace : 'Replace Attachment', 
								overviewid : test.overview_id, 
								labid : test.lab_id,
								description : test.description,
								comments : test.comments,
								labtest : test.lab_test
							});
						} else {
							newAttachment.push({ 
							name: 'View report ', 
							id:$rootScope.pdfViewUrl + items, 
							replace : 'Replace Attachment', 
							overviewid : test.overview_id, 
							labid : test.lab_id,
							description : test.description,
							comments : test.comments,
							labtest : test.lab_test
						 })
						}
					});
				}
				value.new_attachment = newAttachment;
				value.lab_rep = labtestArr
			})
			})
			
			$scope.labReportList = [];
			angular.forEach(response, function (value) {
				if (value.lab_rep != "" || value.new_attachment != "") {
					$scope.labReportList.push(value);
				}
			});
		}, function (error) {
			toastr.error(error);
			analytics('loadLabReportList', error);
		})
	};

$scope.loadClinicalNotes = function(){
		recordService.getClinicalNotes(recordId).then(function(response){
			$scope.clinicalNoteList = response;
			if($scope.clinicalNoteList.length>0){
				$scope.clinicalNoteList.sort(function(a,b){
			 			if (a.date_of_visit < b.date_of_visit)
						    return 1;
						  if (a.date_of_visit > b.date_of_visit)
						    return -1;
						  return 0;
			 		});
			}

		  },function (err, response) {
        //$ngBootbox.alert(err.Message);
      });
	};

$scope.loadNotes = function(){
		recordService.getNotes(recordId).then(function(response){
			$scope.noteList = response;
			if($scope.noteList.length>0){
				$scope.noteList.sort(function(a,b){
			 			if (a.date < b.date)
						    return 1;
						  if (a.date > b.date)
						    return -1;
						  return 0;
			 		});
			}

		  },function (err, response) {
          $ngBootbox.alert(err.Message);
      });
};

$scope.loadFeverData = function(){
		recordService.getFeverData(recordId).then(function(response){
				$scope.feverData = response.map(function(item){
					return [new Date(item.date),parseFloat(((item.temperature_value * 1.8)+32).toFixed(2))];
				});
		},function (err, response) {
        $ngBootbox.alert(err.Message);
    });
};

$scope.growthChartTabs  = [{Id:1, heading: 'Growth Chart'},{Id:2, heading: 'Data' }];
$scope.feverGraphTabs   = [{Id:1, heading: 'Fever Graph'},{Id:2, heading: 'Data' }];
$scope.milestoneTabs    = [{Id:1, heading: 'Chart'},{Id:2, heading: 'Survey'},{Id:3, heading: 'History'},{Id:4, heading: "Overall"}];
$scope.lifelogChartTabs = [{Id:1, heading: 'Chart'},{Id:2, heading: 'Data' }];

$scope.setGrowthChartTabContent = function(id) {
	$scope.selectedGrowthChartTab = id;
};

$scope.setFeverGraphTabContent = function(id) {
	$scope.selectedFeverGraphTab = id;
};

$scope.setMilestoneTabContent = function(id){
	$scope.selectedMilestoneTab = id;
};

$scope.setLifelogChartTabContent = function(id) {
	$scope.selectedLifelogChartTab = id;
};

$scope.setGrowthChartTabContent(1);
$scope.setFeverGraphTabContent(1);
$scope.setMilestoneTabContent(1);
$scope.setLifelogChartTabContent(1);

$scope.getVaccinationStatus = function(vaccine){
	 	if(vaccine.status=='Administered')
	 		return 1;
		if(vaccine.status=='Deferred')
			 return 4;
		if(vaccine.status == 'rescheduled')
		     return 5;
	 	if(vaccine.status==''){
	 		if(new Date(vaccine.due_date)<new Date()){
	 			return 3; //overdue
	 		}
	 		return 2; // Future
	 	}
	return 1; //done
};

$scope.scrollToWrapper = function(){
	 	setTimeout(function(){
		 	$('html, body').animate({
		        scrollTop: $("#divPageWrapper").offset().top
		    },1);
		 },100);
	 };

$scope.getVac=function(id){
var valu='';

   angular.forEach($rootScope.vaccineDict1, function(value, key){
         if(value.fields.drug_name == id ){
          valu=value.pk;
        }
      });
   return valu;
};

$scope.getVaccineSite = function(){
	VacService.getVaccineSite().then(function(response){
		$rootScope.vaccineSite = response;
	},function(error){
		toastr.error(error)
		analytics('getVaccineSite',error);
	})
};

$scope.getVaccineListMtd = function(){
	$scope.vaccineDataLoaded = false;
	$scope.vaccinationList = [];
	var bday = $filter('date')($scope.record.dob, "yyyy-MM-dd");
	recordService.getVaccineList(bday).then(function(response){	
		$scope.vaccinationList = response;
		$rootScope.vaccinationList = response;
		console.log('$scope.vaccinationList 3227',$scope.vaccinationList);
		$scope.vaccineDataLoaded = true;
	},function (err, response) {
		//$ngBootbox.alert(err.Message);
	});
};


$rootScope.getVaccination = function(dob,sno){
	var bday = $filter('date')($scope.record.dob, "yyyy-MM-dd");
	var today = $filter('date')(new Date(), "yyyy-MM-dd");
		    recordService.getvaccination_listmonth(bday,today,sno).then(function(response){
				if(response.message == 'This patient is above 16 yrs'){
					console.log('response',response);
					$rootScope.Flexabledate = false;
				}else{
					if(response == ''){
                        $rootScope.Flexabledate = false;
					}else{
						$rootScope.Flexabledate = true;
					}
					console.log('fleable date list',response);
					$rootScope.getvaccinelist = response;
					console.log('$rootScope.getvaccinelist',$rootScope.getvaccinelist);
				}
			   console.log('$rootScope.getvaccinelist',$rootScope.getvaccinelist);
			}, function(error) {
				toastr.error(error);
				analytics('administered',error);
			});
}


$rootScope.data = {};
$scope.openUpdateVaccine = function(vaccine,type) {
	console.log('type',type);
	console.log('vaccine 3263',vaccine);
	console.log('vaccinevaccine 3263',vaccine.sno);
	$scope.sno = vaccine.sno;
	$rootScope.getVaccination($scope.record.dob,vaccine.sno);
	console.log('vaccine',vaccine.due_date);
	var actual_date = vaccine.due_date

	var today = new Date();
	today.setHours(0,0,0,0);
	if(vaccine.date_given == "") {
		vaccine.date_given = today;
		vaccine.maxday = today;	
		$rootScope.getVaccination($scope.record.dob,vaccine.sno);
	} else {
		var given = new Date(vaccine.date_given);
		given.setHours(0,0,0,0);
		vaccine.date_given = given;
		vaccine.maxday = today;
		$rootScope.getVaccination($scope.record.dob,vaccine.sno);
	}
	vaccine.type = type;
	console.log('Vaccin_data',vaccine)
	$rootScope.data = vaccine;
	console.log('$rootScope.data.status',$rootScope.data.status)
	
	var options = {
		title: 'Vaccine Administration',
		message:'',
		templateUrl: 'views/patient/updatevaccinepopup.htm',
		size:'medium',
		onEscape: function() { $scope.getVaccineListMtd();$scope.$apply();},
		buttons: {
		}
	}
	$ngBootbox.customDialog(options);	
}

$scope.todaysdate = new Date();
$scope.year  = $scope.todaysdate.getFullYear();
$scope.month = ($scope.todaysdate.getMonth() + 2).toString().padStart(2, "0");
$scope.day   = $scope.todaysdate.getDate().toString().padStart(2, "0");
$rootScope.nextmonth_startdate = $scope.year + '-' + $scope.month + '-' + $scope.day


$rootScope.update_vaccination = function(sno,Vaccinename,Vaccinedate,status,id,site){
    console.log('status',status);
	if(status == 'rescheduled'){
		var patient_email = sessionStorage.getItem('patientAccEmail');
		$scope.send_Data_payload = {
			sno: sno,
			site: site,
			comments: $rootScope.data.comments,
			id: id,
			batch_id: $rootScope.data.batch_id,
			brand_name: $rootScope.data.brand_name,
			date_given: $filter('date')($rootScope.data.date_given, "yyyy-MM-dd"),
			due_date: $filter('date')(Vaccinedate, "yyyy-MM-dd"),
			drug_name: Vaccinename,
			account_email: authService.authentication.account_id,
			patient_email: patient_email,
			user_type: "doctor",
			status: "rescheduled"
		};
         console.log('send_Data',$scope.send_Data_payload);
		recordService.updatecalendardataservice($scope.send_Data_payload).then(function(response){
			console.log('resp',response);
			$scope.vaccinationList = [];
			$rootScope.getVaccination(dob,$scope.sno)
			$scope.getVaccineListMtd(); 
			toastr.success('Rescheduled successfully');
			$rootScope.data = {};
		}, function(error) {
			toastr.error(error);
			analytics('administered',error);
		})
	}else{
	var patient_email = sessionStorage.getItem('patientAccEmail');
	console.log('result',sno,Vaccinename,Vaccinedate);
	var date =$filter('date')(Vaccinedate, "yyyy-MM-dd");
	var data={
		account_email:authService.authentication.account_id, 
		patient_email:patient_email, 
		"sno":sno, 
		"drug_name":Vaccinename, 
		"status":"rescheduled", 
		"due_date": date, 
		"user_type":"doctor" ,
		"site": site
	}
	console.log('datadata',data);
	
	recordService.Addrescheduleddata(data).then(function(response){
		$scope.vaccinationList = [];
		$scope.getVaccineListMtd();
		$rootScope.getVaccination($scope.record.dob,$scope.sno);
		toastr.success('Updated Administrated successfully');
	}, function(error) {
		$ngBootbox.customDialog(options);
		analytics('Update_administered',error);
	}) 	
}

}

$rootScope.administered = function(type){
	var patientData = JSON.parse($sessionStorage.get('patientDetail'));
	var patientAccountEmail = $sessionStorage.get('patientAccEmail');
	var sendData = {
		sno: $rootScope.data.sno,
		site: $rootScope.data.site,
		comments: $rootScope.data.comments,
		id: $rootScope.data.id,
		batch_id: $rootScope.data.batch_id,
		brand_name: $rootScope.data.brand_name,
		date_given: $filter('date')($rootScope.data.date_given, "yyyy-MM-dd"),
		due_date: $rootScope.data.due_date,
		drug_name: $rootScope.data.drug_name,
		account_email: patientData.acc_email,
		patient_email: patientAccountEmail,
		user_type: "doctor",
		status: "Administered"
	};

	if($rootScope.data.type  == 'update'){
		recordService.updatecalendardataservice(sendData).then(function(response){
			$scope.vaccinationList = [];
			$scope.getVaccineListMtd();
			toastr.success('Administrated rescheduled successfully');
			$rootScope.data = {};
			bootbox.hideAll()
			// $rootScope.administered();
		}, function(error) {
			// toastr.error(error);
			analytics('administered',error);
		})
	}else if($rootScope.data.type == 'add' || $rootScope.data.status == ""){
		recordService.addvaccinationcalendarservice(sendData).then(function(response){
			$scope.vaccinationList = [];
			$scope.getVaccineListMtd();
			toastr.success('Administrated successfully');
			$rootScope.data = {};
			bootbox.hideAll();
		}, function(error) {
			// toastr.error(error);
			analytics('administered',error);
		})
	}

	if($rootScope.data.status == "rescheduled"){
		recordService.updatecalendardataservice(sendData).then(function(response){
			$scope.vaccinationList = [];
			$scope.getVaccineListMtd();
			$rootScope.administered();
			toastr.success('Administrated rescheduled successfully');
			$rootScope.data = {};
			bootbox.hideAll();
		}, function(error) {
			// toastr.error(error);
			analytics('administered',error);
		})
	}
}

$scope.administrationinfo = function(data){
	var entry = { "account_email": authService.authentication.account_id,
    "entry": {
        "child_account": $sessionStorage.get('patientAccEmail'),
        "calendar_id": data
    	}
	};
  recordService.administrationInfo(entry).then(function(response){
		$rootScope.result = response;
		var options = {
			title:"Administration Details",
			templateUrl:"views/patient/administrationpopup.htm",
			onEscape:function(){
				$rootScope.result = {};
			}
		}
  	$ngBootbox.customDialog(options);
	},function(error){
		toastr.error(error)
		analytics('administrationinfo',error);
	})
}


$rootScope.dueDate = function(date,lid){
     $rootScope.addshow = lid
	console.log('date3382', $filter('date')(date, "yyyy-MM-dd"));
	sessionStorage.setItem('flexiabledate',$filter('date')(date, "yyyy-MM-dd"))
}

$scope.deferred = function(vacc){
	console.log('vacc 3458',vacc);
	var today = new Date();
	today.setHours(0,0,0,0);
	var patientData = JSON.parse($sessionStorage.get('patientDetail'));
	var patientAccountEmail = $sessionStorage.get('patientAccEmail');
	var sendData = vacc;
	console.log('sendData',sendData);


	
	var options = {
    message: "Are you sure you want to defer vaccine "+ sendData.drug_name +" ?",
    title: 'Defer',
    onEscape: function() { $scope.getVaccineListMtd(); $scope.$apply();},
    buttons: {
      success: {
        label: " OK",
        className: "btn-primary fa fa-check",
        callback: function() {

			if(vacc.status == 'rescheduled'){
				var year = new Date().getFullYear().toString();
				var month = (new Date().getMonth() + 101).toString().substring(1);
				var day = (new Date().getDate() + 100).toString().substring(1);
				sendData.date_given = year + "-" + month + "-" + day;
				sendData.account_email = patientData.acc_email;
				sendData.patient_email = patientAccountEmail;
				sendData.user_type = "doctor";
				sendData.status = "Deferred";

				recordService.updatecalendardataservice(sendData).then(function(response){
					toastr.success(' successfully');
					$rootScope.data = {};
				}, function(error) {
					toastr.error(error);
					analytics('administered',error);
				})
			}else{
				var year = new Date().getFullYear().toString();
				var month = (new Date().getMonth() + 101).toString().substring(1);
				var day = (new Date().getDate() + 100).toString().substring(1);
				sendData.date_given = year + "-" + month + "-" + day;
				sendData.account_email = patientData.acc_email;
				sendData.patient_email = patientAccountEmail;
				sendData.user_type = "doctor";
				sendData.status = "Deferred";

				recordService.addvaccinationcalendarservice(sendData).then(function(response){
					$scope.getVaccineListMtd();
					toastr.success('Deferred successfully');	
				}, function(error) {
						toastr.error(error);
						analytics('deferred',error);
				});
			}
        }
      }
    }
  }
  $ngBootbox.customDialog(options);
};

$scope.imageData = {'image':''};
$rootScope.uploadFile1 = function(file, event, flow){

        if({png:1,gif:1,jpg:1,jpeg:1}[file.getExtension()]){
            var data = new FormData();
            data.append('file', file.file);
            var reader = new FileReader();
            reader.onload = function(e) {
                $scope.imageData.image = reader.result;
            };
            reader.readAsDataURL(file.file);
            return true;
        }else{
            alert("Upload only Images");
            return false;
        }
        flow.file = [];
};


$rootScope.foot = false;
$scope.openAddGrowthData = function(openStatus,getdata){
	
	console.log(getdata);
		
	 var today = new Date();
		today.setHours(0,0,0,0);
		$rootScope.foot = false;

		var modalInstance = $uibModal.open({
	      animation: true,
	      templateUrl: 'views/patient/addgrowthpopup.htm',
	      controller: 'addDataPopupController',
	      resolve: {
	      data: function () {
				if(openStatus == 'Add'){
					return {  weight:null, measurementDate:today, dob:$scope.record.dob}
				}
				else{
					return getdata;
				}
			  }
	      }
	  });
	  $rootScope.foot = true;

	  
    modalInstance.result.then(function (data) {
	    $rootScope.showSpinner = true;
		
		data.measurementDate = new Date(data.measurementDate);
	     var growthData = {
	     	"record_id": recordId,
	     	"type": "Vitals",
	     	"data":
	     		{"Models": {
	     			"Model": {
	     				"name": "HelChildVitalSigns",
	     				"Field": [
	     					{"name": "date","text": data.measurementDate},
	     					{"name": "weight","text": data.weight.toString()},
	     					{"name": "bmi","text": ((data.weight/((data.height/100)*(data.height/100))).toFixed(1)).toString()},
	     					{"name": "height","text": (data.height/100).toString()},
	     					{"name": "arm_circumference","text":  (data.arm == undefined) ? '' : data.arm.toString()},
	     					{"name": "chest_circumference","text":  (data.chest == undefined) ? '' : data.chest.toString()},
	     					{"name": "head_circumference","text":  (data.head == undefined) ? '' : data.head.toString()}
	     				]
	     			}
	     		}
	     	}
	     };

		 if(openStatus == 'Add'){
			recordService.addGrowthData(growthData).then(function(response){
				$scope.loadVitalSigns();
			});
		 }else{
			recordService.updateVaccineStatus(growthData).then(function(response){
				$scope.loadVitalSigns();
			});
		 }

	 
	},function (err, response) {
			toastr.error(response);
      $ngBootbox.alert(err.Message);
      analytics('openAddGrowthData',response);
  });
};

$scope.deletegrowthData = function(docid) {
	
	alert(docid);
	var sendData ={
		account_email: authService.authentication.account_id,
		patient_email: sessionStorage.getItem('patientAccEmail'),
		document_id: docid
	}
	recordService.deletevital(sendData).then(function(response) {
		alert(response.message);
	})
	
};

$scope.openAddFeverData = function(){
		var today = new Date();
		today.setHours(0,0,0,0);
		var modalInstance = $uibModal.open({
	      animation: true,
	      templateUrl: 'views/patient/addfeverpopup.htm',
	      controller: 'addDataPopupController',
	      resolve: {
	        data: function () {
	          return { temperature:null, measurementDate:today,dob:$scope.record.dob};
	        }
	      }
	  });

	  modalInstance.result.then(function (data) {

	  	var Celcius = Math.round((data.temperature - 32) * 5 / 9);
	    data.measurementDate = $filter('date')(data.measurementDate, "yyyy-MM-dd hh:mm:ss a");
	      recordService.addfever({record_id:recordId, data: Celcius +","+ data.measurementDate}).then(function(response){
	     	  $scope.loadFeverData();
	      },function (err, response) {
            $ngBootbox.alert(err.Message);
        });

	  },function (err, response) {
        $ngBootbox.alert(err.Message);
    });
	};
	$scope.pic=true;

	$scope.questcategoryname=[]
	$rootScope.getquestionattachment = function(){
		patient_email =  $sessionStorage.get('patientAccEmail'),
		recordService.getquestionnaire(patient_email).then(function(response){
				$scope.questcategoryname = response.data
				$scope.tempshowquestAttachment()
			},function (error) {
				toastr.error(error);
				analytics('milestonesList',error);
		})
	};

	$scope.tempshowquestAttachment = function(){
		for (var i = 0; i < $scope.questcategoryname.length; i++) {
			if ($scope.questcategoryname[i].category_name == 'general') {
				$scope.showpmhq = true
			}
			if ($scope.questcategoryname[i].category_name == 'personal_health_history') {
				$scope.showphh = true
			}
			if ($scope.questcategoryname[i].category_name == 'past_medical_history') {
				$scope.showpmh = true
			}
			if ($scope.questcategoryname[i].category_name == 'medication_history') {
				$scope.showmh = true
			}
			if ($scope.questcategoryname[i].category_name == 'family_medical_history') {
				$scope.showfmh = true
			}
			if ($scope.questcategoryname[i].category_name == 'social_personal_history') {
				$scope.showsph = true
			}
		}
	}

	$scope.showquestAttachment = function (data) {
		if (data == "1") {
			for (var i = 0; i < $scope.questcategoryname.length; i++) {
				if ($scope.questcategoryname[i].category_name == 'general') {
					window.open(mainUrl + '/PDF/' + $scope.questcategoryname[i].pdf_file)
					$scope.showpmhq = true
				}
			}
		}

		if (data == "2") {
			for (var i = 0; i < $scope.questcategoryname.length; i++) {
				if ($scope.questcategoryname[i].category_name == 'personal_health_history') {
					window.open(mainUrl + '/PDF/' + $scope.questcategoryname[i].pdf_file)
					$scope.showphh = true
				}
			}
		}

		if (data == "3") {
			for (var i = 0; i < $scope.questcategoryname.length; i++) {
				if ($scope.questcategoryname[i].category_name == 'past_medical_history') {
					window.open(mainUrl + '/PDF/' + $scope.questcategoryname[i].pdf_file)
					$scope.showpmh = true
				}
			}
		}

		if (data == "4") {
			for (var i = 0; i < $scope.questcategoryname.length; i++) {
				if ($scope.questcategoryname[i].category_name == 'medication_history') {
					window.open(mainUrl + '/PDF/' + $scope.questcategoryname[i].pdf_file)
					$scope.showmh = true
				}
			}
		}

		if (data == "5") {
			for (var i = 0; i < $scope.questcategoryname.length; i++) {
				if ($scope.questcategoryname[i].category_name == 'family_medical_history') {
					window.open(mainUrl + '/PDF/' + $scope.questcategoryname[i].pdf_file)
					$scope.showfmh = true
				}
			}
		}

		if (data == "6") {
			for (var i = 0; i < $scope.questcategoryname.length; i++) {
				if ($scope.questcategoryname[i].category_name == 'social_personal_history') {
					window.open(mainUrl + '/PDF/' + $scope.questcategoryname[i].pdf_file)
					$scope.showsph = true
				}
			}
		}
	}

$scope.showAttachment = function(prescription) {

	$rootScope.showSpinner = true;
	var respData;
	if (prescription.startsWith("http:") || prescription.endsWith(".png")){
		$rootScope.showSpinner = false;
		respData = prescription;
		var options = {
			title: '',
			message: '<img class="img-responsive center-block" src="'+ respData+'"/>',
			size:'medium',
			onEscape: true,
	    };
	
	    $ngBootbox.customDialog(options);

	} else if (prescription.endsWith(".pdf")) {
		window.open(prescription)
	} else {

		recordService.getAttachment(recordId,prescription).then(function(response){
			if(response.data.startsWith("data:image/")){
				respData = "data:image/jpg;base64," + response.data.split('base64,')[1];
			}
			else {
				respData = "data:image/jpg;base64," + response.data;
			}
			var options = {
				title: '',
				message: '<img class="img-responsive center-block" src="'+ respData+'"/>',
				size:'medium',
				onEscape: true,
			};
			$ngBootbox.customDialog(options);
			$rootScope.showSpinner = false;
		},function (err, response) {
			$ngBootbox.alert('No Images ');
		});
	}
};

/* Print Prescription */

  $scope.PrintPresc = function(printSectionId) {
    var innerContents = document.getElementById(printSectionId).innerHTML;
    var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><head><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="style.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script> </head><body onload="window.print()">' + innerContents + '</html>');
        popupWinindow.document.close();
  }

	$scope.showVacAttachment = function(prescription) {
			$rootScope.showSpinner = true;
			recordService.getAttachment(recordId,prescription.__documentid__).then(function(response){
				var image = (response.data).split('base64,');
				var options = {
						title: '',
						message: '<img class="img-responsive center-block" src="data:image/jpg;base64,'+ image[1]+'"/>',
						size:'medium',
						onEscape: true,
				};

				$ngBootbox.customDialog(options);
				$rootScope.showSpinner = false;

			},function (err, response) {

			    $ngBootbox.alert('No Images');
	        });
    };

// $scope.dr2Note=true;
// $scope.showDocNote1 =function(prec){
//  	$scope.pres={};
//  	$scope.pres=prec;
//  	$scope.dr2Note=false;

//  };

// $scope.back=function(prec){
//  	$scope.dr2Note=true;
//  };


// $scope.prescriptionAdded = function($file, $event, $flow ){
// 		var allowedTypes = ["jpeg","jpg","png","bmp"];
// 		$rootScope.data ={comment:''}
// 		var options = {
//             title: '<b>Prescription Note</b>',
//             message:'',
//             templateUrl: 'views/patient/addprescriptionpopup.htm',
//              size:'medium',
// 			 onEscape: function() { $scope.$apply();},
//             buttons: {
//             	ok:{
//                label: " Save",
//                className: "btn-primary fa fa-save",
//                callback: function() {
//                if(allowedTypes.indexOf($file.getExtension())>=0){
// 							  $rootScope.showSpinner = true;
// 							  var fd = new FormData();
// 							  fd.append('file', $file.file);
// 							  fd.append('type', "HelPrescription");
// 							  fd.append('record_id', recordId);
// 							  fd.append('comment', $rootScope.data.comment);
// 							  recordService.postAttachment(fd).then(function(response){
// 							  	$scope.loadPrescriptionList();
// 							   },function (err, response) {

// 					                   $ngBootbox.alert(err.Message);
// 					                   $rootScope.showSpinner = false;
// 					        });
// 							}else{
// 								$ngBootbox.alert("Unknown file format. Upload Only Image files.");
// 							}
//                     }
//                  },
//                  close:{
//                      label: " Close",
//                      className: "btn-danger fa fa-times-circle",
//                     callback: function() {}
//                  }
//             }
//         };
//         $ngBootbox.customDialog(options);
// };
// $scope.PrescriptionNoteData ={note:""};
// $scope.addprescriptionNote = function(PrescriptionNoteData){
// 		    	if($.trim(PrescriptionNoteData.note)!=''){
//                     		var data =
//                     		{
//                     			type:"Synopsis",
//                     			record_id: recordId,
//                     			data:{
//                     				Models:
//                     				{
//                     					Model:
//                     				  	{
//                     				  		name: "HelPrescription",
//                     				  		Field: [
//                     				  		{
//                     				  			name: "date_of_visit",
//                     				  			text: new Date()
//                     				  		},
//                     				  	 	{
//                     				  	 		name: "comment",
//                     				  	 		text:PrescriptionNoteData.note
//                     				  	 	}
//                     				  	 	]
//                     					}
//                     				}
//                     			}
//                     		};
//                     			recordService.docinsert(data).then(function(response){
//                     			$scope.loadPrescriptionList();
//                     			$scope.PrescriptionNoteData ={note:""};

//                     			$ngBootbox.alert('save successfully');
//                     		  },function (err, response) {
//                  			 	 $ngBootbox.alert(err.Message);
//         					});
//                     	}
// 	};

// $scope.addClinicalNote = function(){
// 		$rootScope.addClinicalNoteData = {};
// 		  var options = {
//             title: '<b>Additional Clinical Note</b>',
//             message:'',
//             templateUrl: 'views/patient/addclinicalnotepopup.htm',
// 			onEscape: function() { $rootScope.addClinicalNoteData = {};$scope.$apply();},
//              size:'large',
//             buttons: {
//             	ok:{
//                      label: " Save",
//                      className: "btn-primary fa fa-save",
//                     callback: function() {
//                     	if($.trim($rootScope.addClinicalNoteData.note)!=''){
//                     		var data =
//                     		{
//                     			type:"SimpleClinicalNote",
//                     			record_id: recordId,
//                     			data:{
//                     				Models:
//                     				{
//                     					Model:
//                     				  	{
//                     				  		name: "SimpleClinicalNote",
//                     				  		Field: [
//                     				  		{
//                     				  			name: "date_of_visit",
//                     				  			text: new Date()
//                     				  		},
//                     				  	 	{
//                     				  	 		name: "content",
//                     				  	 		text:$rootScope.addClinicalNoteData.note
//                     				  	 	}
//                     				  	 	]
//                     					}
//                     				}
//                     			}
//                     		};

//                     		recordService.docinsert(data).then(function(response){
//                     			// $scope.loadClinicalNotes();
//                     		  },function (err, response) {
//                  			 	 $ngBootbox.alert(err.Message);
//         					});
//                     	}else{return false;}

//                     }
//                  },
//                  close:{
//                      label: " Close",
//                      className: "btn-danger fa fa-times-circle",
//                     callback: function() {}
//                  }
//             }
//         };

//         $ngBootbox.customDialog(options);
// 	};


// $scope.lab=true;
// $scope.showLab =function(desc){
// 	$scope.list={};
//  	$scope.list=desc;

// $scope.lab=false;
// };

$scope.viewProfile = function(){
	$scope.showProfile = true;
};
$scope.openAddReports = function(overviewid,labtest,labdate,labid,comments){	
 	$rootScope.replaceoverview = overviewid;
	 $rootScope.labdate = labdate
	 $rootScope.replacelab = labid;
	 $rootScope.labcomments = comments 
	 $rootScope.consultlabtest = labtest
	 var options = {
		 title: '<b>Lab Report Attachment</b>',
		 message: '',
		 templateUrl: 'views/patient/updateLabReport.htm',
		 size: 'medium',
		 onEscape: function() {$scope.$apply();},
		 buttons: {
        ok:{
          label: " Save",
          className: "btn-primary fa fa-save",
					callback: function() {
						  var temp = [];
						  angular.forEach($rootScope.attachedDocument,function(value) {
								temp.push(value.doc_id);
						  })
					  	var data = {
							  lab_results: {
								  attachments : temp,
								   overview_id: $rootScope.replaceoverview ,
								   lab_id : $rootScope.replacelab ,
								  comment: $rootScope.updatelabcomments ? $rootScope.updatelabcomments : ""
							  },
							 account_email: authService.authentication.account_id
						  }
							recordService.attachLabReports(data).then(function(response) {
								toastr.success(response.message);
								$rootScope.attachedDocument = [];
								$rootScope.reportData = {};
								$scope.loadLabReportList();
							}, function(error) {
								toastr.error(error)
								analytics('openAddReports',error);
							});
					 }
					},
          close:{
            label: " Close",
            className: "btn-danger fa fa-times-circle",
            callback: function() {
							$rootScope.attachedDocument = [];
							$rootScope.reportData = {};
				  	}
          }
		  }
	 };
	 $ngBootbox.customDialog(options);
 };

 $rootScope.attachedDocument = [];

 $rootScope.removeDoc = function(data) {
	var index = $rootScope.attachedDocument.indexOf(data);
	$rootScope.attachedDocument.splice(index,1);
	
// 	 console.log(data)
// 	 var setData = {
// 		 record_id: recordId,
// 		 document_id: data.doc_id
// 	 };
// 	 console.log(setData)
// 	recordService.setStatus(setData).then(function(response) {
// 		toastr.success(response);
		
// 	}, function(error) {
// toastr.error(error)
// 	})
 };
 $rootScope.loaddocument = true

$rootScope.labReportsAdded = function($file, $event, $flow ){
		var allowedTypes = ["jpeg","jpg","png","bmp","text","pdf"];
		$rootScope.data = {comment:''};
		var options = {
            title: '<b>Lab Report note</b>',
            message:'',
            templateUrl: 'views/patient/addlabpopup.htm',
            size:'medium',
		      	onEscape: function() {$scope.$apply();},
            buttons: {
            	ok:{
                  label: " Save",
                  className: "btn-primary fa fa-save",
                  callback: function() {
					$rootScope.loaddocument = false
						if(allowedTypes.indexOf($file.getExtension())>=0) {
						 /* $rootScope.showSpinner = true;
							var fd = new FormData();
							fd.append('file', $file.file);
						    fd.append('type', "HelLabResult");
							fd.append('record_id', recordId);
						    fd.append('notes', $rootScope.data.comment)
							recordService.postAttachment(fd).then(function(response){
								$rootScope.attachedDocument.push({name:$rootScope.data.comment,doc_id:response.Doc_Created});
							},function (err, response) {
								$ngBootbox.alert(err.Message);
							    $rootScope.showSpinner = false;
							}); */

							var data = new FormData();
							data.append('file', $file.file);
							var uploadPatientImage = $file.file;     
							var reader = new FileReader();
							reader.onload = function(e) {
								if($file.getExtension() == "pdf"){
									multipartFormdata.uploadpdfToUrl(authService.helyxonApi.url, uploadPatientImage).then(function (response) {
										if(response){
											$rootScope.loaddocument = true
										}
										$rootScope.attachedDocument.push({ name: $rootScope.data.comment, doc_id: response.pdf[0].filename });
										$rootScope.data.comment = ""
									})
								} else {
									multipartFormdata.uploadFileToUrl(authService.helyxonApi.url, uploadPatientImage).then(function (response) {
										if(response){
											$rootScope.loaddocument = true
										}
										$rootScope.attachedDocument.push({ name: $rootScope.data.comment, doc_id: response.image[0].filename });
										$rootScope.data.comment = ""
									})
								}
								
								};
							reader.readAsDataURL($file.file);
							console.log($rootScope.attachedDocument)
		                      
						} else {
				            $ngBootbox.alert("Unknown file format. Upload Only Image files.");
				        }
                  }
              },
              close:{
                label: " Close",
                className: "btn-danger fa fa-times-circle",
                callback: function() {}
              }
            }
        };

    $ngBootbox.customDialog(options);
};


$scope.videocallAccesToken = "/"+$sessionStorage.get('video_access_token');

$scope.viewProfile = function () {
				
	// Remove active classes from tab link and panels
	if(!$scope.showProfile) {
		$('.parenttabs li').removeClass('active');
		$("div.parenttab.active").removeClass("active");
	}
	$scope.showProfile = true;
	//("////",$scope.showProfile)

};

$scope.hideProfile = function () {
	$scope.showProfile = false;	
}

$scope.addToCarenet = function(){

		$rootScope.addPatientToCarenet = {
			carenetRecords: angular.copy($rootScope.carenetRecords),
   			addPatient : function(cr){
              recordService.addCarenetAccount({
                  record_id: recordId,
                  carenet_id: cr.id,
                  write: "false"
                 }).then(function(response){
                 	$ngBootbox.hideAll();
                   },function (err, response) {
                   $ngBootbox.alert(err.Message);
               });
  			}
   		};

      var options = {
          title: '<b><span class="fa fa-users"></span> Add to Carenet</b>',
          message : '',
          templateUrl: 'views/patient/addtocarenetpopup.htm',
			    onEscape: function() {$scope.$apply();},
          buttons: {
            close:{
              label: " Close",
              className: "btn-danger fa fa-times",
              callback: function() {}
            }
          }
      };

	$ngBootbox.customDialog(options);
};


$scope.loadDrNotes = function(){
		recordService.getDrNotes(recordId).then(function(response){
			$scope.drNoteList = response;

			if($scope.drNoteList.length>0){
				$scope.drNoteList.sort(function(a,b){
			 			if (a.date < b.date)
						    return 1;
						  if (a.date > b.date)
						    return -1;
						  return 0;
			 	});
			}

		  },function (err, response) {
          $ngBootbox.alert(err.Message);
      });
	};

$scope.viewPatient = function(id){
	  sessionStorage.setItem('patientid',id)
      $location.path('/patientview/'+id);
};

$rootScope.payinfo=$rootScope.pay;
$rootScope.paymentinfo=false;
 if($rootScope.payinfo==undefined)
   	$rootScope.paymentinfo=true;

$rootScope.record1 = {
	name:"",
	mobile:""
};

$scope.historicaldata = [];
$scope.gethistorical = function() {
	var data = $sessionStorage.get('patientAccEmail')!=null ? $sessionStorage.get('patientAccEmail'): '';
	recordService.gethistoricaldata(data).then(function(response) {
		$scope.historicaldata = response.overview_history;
	})
};

$scope.showAlert = function(data){

	var tempString = "Next token is video call for "+data.name_given+"( "+data.mr_number+" )";

		var options = { 
				message: tempString, 
				title: 'Confirmation',
				buttons: {
				/* warning: {
								label: "Cancel",
								className: "btn-warning"
						}, */
						success: {
								label: "Ok",
								className: "btn-success",
								callback: function() {  }
						}
				}
		};

	  $ngBootbox.customDialog(options);
}

$scope.getNextToken = function() {

	recordService.getQueue().then(function(response){
			var queueArray = response;			
          if(queueArray.length>1){
						  angular.forEach(response,function(value,key) {      
                  if(value.record_id==$scope.patient_record_id){                        
											if(queueArray[key+1].type == "video_call"){
													setTimeout(function(){ 
															$scope.showAlert(queueArray[key+1]);
													}, 30000);
											}
									}
							}); 
					}    

	},function(err){
		console.log(err)
	});

}


$scope.intitiveconsultation = function(){
	$scope.patient_id =  sessionStorage.getItem('patientid')
	$scope.doctorId = authService.authentication.doctor_id
	console.log('$scope.patient_id', $scope.patient_id ,'doctorid', $scope.doctorId);
	$scope.accountemail = authService.authentication.account_id;
 
	var url = $scope.url = $location.absUrl();
	var id = url.split("/");
//    console.log("id", id[id.length-1]);
   sessionStorage.setItem("id", id[id.length-1]);
   var patient_id = sessionStorage.getItem("id")
   var hospital = sessionStorage.getItem("hospital")
   var token = sessionStorage.getItem("token")
   console.log("patientid", patient_id);
   if (mainUrl == 'https://test.epicare.net') {
	$scope.serverurl = 'https://test.epicare.net';
}else{
	$scope.serverurl = 'https://epicare.net';
}
	//  https://test.epicare.net/new/#/
	// http://localhost:4200/#/
	// console.log('incu screen Epicare', 'https://test.epicare.net/new/#/?id='+$scope.patient_id+'&dmail='+$scope.accountemail+'&did='+$scope.doctorId+'&mode=1&token=b2F1dGhfdG9rZW49U1lRVTlNRjNmaG53VGJVbUpIOHEmb2F1dGhfdG9rZW5fc2VjcmV0PXlSblVmYWFUV3ZLYmptWlpVd3VpJmFjY291bnRfaWQ9cng0JTQwcnhjYXJlbmV0Lm9yZw%3D%3D');

	$rootScope.intuitive_consultation_screen = $sce.trustAsResourceUrl($scope.serverurl+'/new/#/?id='+patient_id+'&hospital='+hospital+'&dmail='+$scope.accountemail+'&did='+$scope.doctorId+'&mode=1&token='+token);
   
}
$scope.intitiveconsultation();

$scope.consult = '';
$scope.consult = $sessionStorage.get('consult');

$scope.startConsultation = function () {
	
	$rootScope.isappconsult = 'false';
	$scope.getNextToken();
	$rootScope.rangePicker1 = {
		opened: { fromDate:false, toDate:false },
		maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
		dateOptions : {
			formatYear: 'yyyy',
			startingDay: 0,
			maxDate: new Date(),
			minDate: $scope.record.dob
		}
	};

	recordService.startConsult($sessionStorage.get('patientAccEmail'),$sessionStorage.get('appointment_id')).then(function(response){

		console.log(response);

		$rootScope.isappconsult = 'true';
		sessionStorage.setItem('consultStatus', 'true');
		$scope.consult = 'true';
		$sessionStorage.put('status', 'consultation');
		$scope.getOverview();
		$scope.loadComplaintList('active');
		$scope.gethistorical();
		$rootScope.end_consultation = false;
		$scope.timer = parseInt($sessionStorage.get('avg_time_per_patient'));
			
		if( $scope.myTimeout ) {
			$timeout.cancel( $scope.myTimeout );
			$scope.myTimeout=null;
		}		
			
		console.log( 'Timer: ' + $scope.timer );
		console.log( 'Avg Time: ' + avg_time_per_patient );
		console.log( $rootScope.banner );
	
		$scope.myTimeout = $timeout( $scope.onTimeout,1000 );
	    /*$scope.count = 0;
		if($scope.myVar == undefined) {
			$scope.autoSave = 'true';
			$scope.myVar = setInterval(function(){
				if($scope.consult && $scope.autoSave == 'true'){
					$scope.count+=1;
					$scope.saveprescription();
				} else if($scope.consult && $scope.autoSave == 'false'){
					//Do nothing
				}
			}, 60000);
		}*/
	},function (err, response) {
        toastr.error('Patient has not arrived. Please check in Appointment queue screen');
        analytics('startConsultation','Patient has not arrived. Please check in Appointment queue screen');
	});
	$scope.loadSurveyQuestion('TDSC');
	if ($scope.updateOP == 1){
		$scope.updateOverviewData();
	}
	else	{
		$scope.saveOverviewData();
	}
		

};

$scope.saveOverviewMtd = function() {	
	// if( $scope.consult == 'true' ) {
	    if(authService.authentication.account_id == "rx3@rxcarenet.org" || authService.authentication.account_id == 'rx23443@rxcarenet.org') {
			document.getElementById("followtext").checked = true;
            $scope.followupModelText.txt = "SOS (If necessary)";
		}
		$scope.saveprescription();
		// $scope.autoSave = 'true';
		// $scope.myVar = setInterval(function(){
		// 	if($scope.consult && $scope.autoSave == 'true'){
		// 		$scope.count+=1;
		// 		$scope.saveprescription();
		// 	}
		// 	else if($scope.consult && $scope.autoSave == 'false'){
		// 		//	Do nothing
		// 	}
		// }, 60000);
		// $scope.gethistorical();
	//}
};

$scope.endConsultpaymentStatus = function(apptType) {
	recordService.paymentStatus($sessionStorage.get('appointment_id'),apptType).then(function(response){
		if(response.payment_status == 'yes'){
			$scope.raisedPaymentstatuspopup();
		}
		else{
			if(apptType == 'video_call_consultation' || apptType =='emergency_video_call_consultation'){
				$scope.raisePaypopup_videocall();
			}else{
				$scope.raisePaypopup();
			}
			
		}
		
	});
}
// This is End consultation function
$scope.completeConsultation = function() {
	recordService.endConsult($sessionStorage.get('patientAccEmail'),$sessionStorage.get('appointment_id')).then(function(response){
	  //$rootScope.isappconsult = 'false';
		sessionStorage.setItem('consultStatus', 'false');
		$sessionStorage.put('floatingVideoScreenStatus','false');
		$rootScope.end_consultation = true;
		$scope.timer = null;
		if($scope.myTimeout) {
			$timeout.cancel($scope.myTimeout);
			$scope.myTimeout = null;
		}
		$scope.initColorValue = 0;
		$timeout.cancel($scope.colorTimeout);
		$rootScope.voice_call_alert = 'false';
		$scope.consult = 'false';
		$sessionStorage.put('consult','false');

		$scope.accord1=$scope.accord2=$scope.accord3=$scope.accord4=$scope.accord5=$scope.accord6=$scope.accord7=true;
		$scope.sinceDaysValues = arrIndex;
		$scope.otInfValues = arrIndex;
		$scope.complaintIssues = [];
		$scope.complaintIssues.details = [];			
		$scope.complaintNewUptModel = [];
		$scope.complaintNewUptModel.issues = [];
		$scope.complaintNewModel = [];
		$scope.complaintNewModel.issues = [];
		$scope.uptComplaint = false;
		$scope.divCounts = [];
		$scope.existComplaints = [];
		$scope.openComplaints = [];
		$scope.updatedComplaints = [];
						
		countDiv    = 0;
		countAccord = 1;
		indexAccord = 0;
		$scope.existComplaints = [];
		$scope.updatedComplaints = [];

		$rootScope.babyGrowthMessage = '';
		$rootScope.vitalFatherHgt = '';
		$rootScope.vitalMotherHgt = '';

		// if( localStorage.getItem("next_videocall_detail") ) {
		// 	var sessioData = localStorage.getItem("next_videocall_detail");
		// 	var spltArr = sessioData.split('/');
		// 	//console.log(spltArr);
		// 	// $rootScope.notifyFunc( spltArr );
		// }

		// if( $rootScope.banner.next_patient_appointment_type == 'voice_call' || $rootScope.banner.next_patient_appointment_type == 'emergency_voice_call' ) {
		// 	//$rootScope.bookVoiceCallNextPatient(); 
		// 	//$rootScope.voice_call_alert = 'true';
		// 	recordService.getQueue().then(function(response) {
		// 		//console.log( response );
		// 		var filter_data = $filter('filter')( response, {'id': $rootScope.banner.next_patient_appointment_id});	
		// 		// $rootScope.callNotInitiatedAlert(filter_data[0].record_id); 	
		//    },function(err, response) {
		//    });			
		// }
		
		//if(authService.authentication.account_id!="rx31499@rxcarenet.org" && authService.authentication.account_id!="rx3@rxcarenet.org"){
			
		// $scope.raisePaypopup();

		if(sessionStorage.alertwaiver == 'true'){
			$scope.popupwaiveralert();
		} else {
			recordService.getQueue().then(function(response) {
				// console.log('queue response',response);
		  //      console.log('3989',$sessionStorage.get("appt_type"));
		//   for(var i=0;i<response.length();i++){
			if($sessionStorage.get("appt_type") == 'video_call'){
				$scope.endConsultpaymentStatus('video_call_consultation');
			}else {
				$scope.endConsultpaymentStatus('consultation');
			}
	
			// if($sessionStorage.get("current_videocall_apt_type") == "emergency_video_call"){
			// 	$scope.endConsultpaymentStatus('emergency_video_call_consultation');
			// }
		});
		}
        
		//}

	/*	var options = {
			title: '<b>Go to Home</b>',
			message:'Would you like to redirect to Home page?',
			size:'medium',
			onEscape: true,
			buttons: {
				ok:{
					label: "Go",
					className: "btn-primary",
					callback: function() {
						$location.path('/home');
						$rootScope.loadBanner();
					}
				},
				close : {
					label: " Cancel",
					className: "btn-danger",
					callback: function() {}
				}
			}
		} */

		//$ngBootbox.customDialog(options);
	}); 
};


/**Payment new Category */
$rootScope.addNewPayCategoryMtd = function(data) {
	var cat_data = {
		account_email: authService.authentication.account_id,
		categories: [{category_name:data}]
	};
	paymentService.addNewPayCategory(cat_data).then(function(response) {
		$scope.getPayCategoryListMtd();
		$rootScope.payment.category = data;
		toastr.success('Category added successfully');
	}, function(error) {
		toastr.error(error);
		analytics('addNewPayCategoryMtd',error);
	})
};

$rootScope.pendingPaymentOk = function() {
   $scope.makePaymentMtd();
}

/* Raise payment */
$rootScope.raisePaymentOk = function(value) {

	$rootScope.raiseSuccess  =  true;
	//var doctor_charges  =  parseInt($rootScope.payment.category.doctor_charge);
	var doctor_charges  =  parseInt($rootScope.selected_doctor_charge);
	
	if(value==2) {		
		$scope.confirmationBox();
			
	} else if(value==1) {

		if(doctor_charges > $rootScope.walletBalance) {
			$rootScope.raiseSuccess = false;

			if($rootScope.walletBalance < 0) {
				$rootScope.walletBalance     = 0;				
				$rootScope.pre_walletBalance = $rootScope.walletBalance;
			}
	
			$scope.raiseInvoiceFunc();
			$location.path('/home');

		} else {
			if($rootScope.walletBalance < 0) {
				$rootScope.walletBalance = 0;
			}
	
			$rootScope.raiseSuccess      = true;
			$rootScope.pre_walletBalance = $rootScope.walletBalance;
			$scope.raiseInvoiceFunc();
			$location.path('/home');
		}
	}  
}

$scope.raiseInvoiceFunc = function(doctor_charges) {
	console.log('docotr chares',doctor_charges);
		var patient_mail = $sessionStorage.get('patientAccEmail');
		sessionStorage.setItem('patient_email',patient_mail);
		sessionStorage.setItem('patientAccEmail',patient_mail);
		console.log("patient_mail***"+patient_mail);

		var appt_id = "";
		
		if( $sessionStorage.get('video_call_patient') ) {
			patient_mail = $sessionStorage.get('video_call_patient');
		} else if( $sessionStorage.get('patientAccEmail') ) {
			patient_mail = $sessionStorage.get('patientAccEmail');
			sessionStorage.setItem('patient_email',patient_mail);
		} 

		if( $rootScope.selected_category == 'emergency_video_call_consultation' ) { 
			appt_id = "";
		} else {
		
				if( $sessionStorage.get("current_videocall_apt_type") == 'video_call' ){			
					if($sessionStorage.get("videocall_apt_id")){
						appt_id = $sessionStorage.get("videocall_apt_id");
						$sessionStorage.put("current_videocall_apt_type", '');		
						$sessionStorage.put("videocall_apt_id", '');
					}
			
			} else if( $sessionStorage.get('appointment_id') ) {
				appt_id = $sessionStorage.get('appointment_id');
			}
		}
	
		if( doctor_charges == 0) {
			$rootScope.selected_doctor_charge = "0";
		}

	var data = {
		account_email: $rootScope.authentication.account_id,
		patient_email: patient_mail,
		category: $rootScope.selected_category,
		description: $rootScope.selected_description ? $rootScope.selected_description : "",
		doctor_charges: $rootScope.selected_doctor_charge,
		user_type: "doctor",
		type: 3,
		appointment_id: appt_id,
		doctor_id: $rootScope.authentication.doctor_id
	}

	paymentService.raiseInvoice(data).then(function(response){
	
		toastr.success('Payment raised successfully');

		if(response){
		  $rootScope.bill_no = response.bill_no;
		  sessionStorage.setItem('billno', $rootScope.bill_no);
		  $rootScope.walletBalance = response.wallet;
		  sessionStorage.setItem("wallet_ballance",$rootScope.walletBalance);
		}
		// $scope.getPendingPaymentMtd();
		$scope.payment_receipt_printTemplate($rootScope.bill_no,2);
		$scope.raisePayPrint();
		$scope.sendpatientsms($rootScope.bill_no)
	}, function(error) {
		toastr.error(error);
		analytics('raiseInvoiceFunc',error);
	});
}
var lastaccemail = $sessionStorage.get('patientAccEmail')
sessionStorage.setItem("lastaccemail",lastaccemail)

$rootScope.showraisepayment = function(){
	if(authService.authentication.account_id !=='rx15@rxcarenet.org' || authService.authentication.account_id =='rx5016@rxcarenet.org'){
		var param = {
			status : "0",
			doctor_id: authService.authentication.doctor_id,
			patient_email : $sessionStorage.get('lastaccemail')
		}
		paymentService.Patientreceipt(param,$rootScope.bill_no).then(function(response) {
			 console.log('patient_receipt', response);
			 var inner_Contents = mainUrl+'/PDF/' + response.data;
			 $scope.showAttachment(inner_Contents)
		}, function(error) {
			toastr.error(error);
		})
	} else {
		return
	}
	
}

$scope.raisedPaymentstatuspopup = function(){

	var options = {
		title: '<b>Payment Confirmation</b>',
		message:'Payment has already been raised for this patient. Do you want to charge the patient again?',
		size:'medium',
		onEscape: function(){$scope.$apply();$location.path('/home');},
		buttons: {
			close : {
				label: "No",
				className: "btn-danger",
				callback: function() {
					$scope.$apply();
					$location.path('/home');
				}
			},
			ok:{
				label: "Yes",
				className: "btn-success",
				callback: function() {
					$scope.raisePaypopup();
				}
			},
			
		}
	}
	$ngBootbox.customDialog(options);
};

$scope.raisePaypopup = function(){

	var options = {
		title: '<b>Raise Payment</b>',
		//message:'',
		templateUrl: 'views/payment/raisePay.htm',
		size:'medium',
		onEscape: function() {
			$scope.$apply();
			$location.path('/home');
		},
		buttons: {
	  }
  }
  $ngBootbox.customDialog(options);
};

$scope.raisePaypopup_videocall = function(){
	var options = {
		title: '<b>Raise Payment</b>',
		message:'',
		templateUrl: 'views/payment/raisePay_videocall.htm',
		size:'medium',
		onEscape: function() {
			$scope.$apply();
			$location.path('/home');
		},
		buttons: {
	  }
  }
  $ngBootbox.customDialog(options);
};

$scope.raisePayPrint = function(){

	var options = {
		title: '<b>Payment Confirmation</b>',
		message:'',
		templateUrl: 'views/payment/raisepayPrint.htm',
		size:'medium',
		onEscape: function() {$scope.$apply();},
		buttons: {
	    }
    }
    $ngBootbox.customDialog(options);
};

$scope.confirmationBox = function(){

	var options = {
        message: 'Please confirm to waive the fees',
	    	title: 'Waive Fee Confimation',
        buttons: {
					warning: {
					label: "Cancel",
					className: "btn-warning",
					callback: function() {
						$rootScope.raiseSuccess  =  true; 
						$scope.raisePaypopup();
					}
        },
        success: {
          label: "Ok",
          className: "btn-success",
          callback: function() {
					  $rootScope.raiseSuccess = true;		
				  	//$rootScope.payment.cost = 0;					
						if($rootScope.walletBalance<0){
					     $rootScope.walletBalance = 0;
					  }
					sessionStorage.setItem("wallet_ballance",$rootScope.walletBalance);
					$scope.raiseInvoiceFunc(0);
					$location.path('/home');
				  }
        }
      }
  };

  $ngBootbox.customDialog(options);

/*	var options = {
			title: '<b>Payment Confirmation</b>',
			message:'',
			templateUrl: 'views/payment/raisePay2.htm',
			size:'medium',
			onEscape: function() {$scope.$apply();},
			buttons: {
				}
		}
    $ngBootbox.customDialog(options); */
};

$scope.payment = function(acc,recdId,mobile){
 	$rootScope.payinfo = {cell_number:'',record_id:'',patient_account_email:''}
		 var options = {
            title: '<b>Mobile Access</b>',
            message:'',
            templateUrl: 'views/patient/payment.htm',
            size:'medium',
            onEscape: true,
            buttons: {
            ok:{
              label: " Enable",
              className: "btn-primary fa fa-save",
              callback: function() {
				var patientData = JSON.parse($sessionStorage.get('patientDetail'));
				var patientAccountEmail = $sessionStorage.get('patientAccEmail');
				var sendData = {
					cell_number: patientData.cell_number,
					acc_email: patientData.acc_email,
					record_id: patientData.record_id,
					dr_name: $rootScope.authentication.account_info.Account.fullName,
					mr: patientData.mr,
					patient_account_email: patientAccountEmail
				};
								
				recordService.mobilePayment(sendData).then(function(response){
                  $ngBootbox.alert(response.Message + "<br><br>Username : " + response.username + "<br>Password : " + response.password);
                  $scope.mobilevalidity();
                  $rootScope.payinfo = {};
                });
              }
            },
            close:{
              label: " Cancel",
              className: "btn-danger fa fa-times-circle",
              callback: function() {}
            }
        }
    }
	$ngBootbox.customDialog(options);
};



$rootScope.paymentDue = [];
$scope.getPendingPaymentMtd = function() {
	$rootScope.paymentDue = [];
	if($sessionStorage.get('patientAccEmail')!=null){
		var patient_email = $sessionStorage.get('patientAccEmail');
	
        paymentService.getPendingPayment(patient_email).then(function (response) {

            if (response.length > 0) {
                angular.forEach(response, function (value) {
                    if (value.fee_pending > 0) {
                        $rootScope.paymentDue.push(value);
                    }
                });
            }
            if ($rootScope.paymentDue.length > 0) {
                $rootScope.totalAmount = 0;
                $rootScope.agreePay = 0;
                angular.forEach($rootScope.paymentDue, function (value) {
                    $rootScope.totalAmount = $rootScope.totalAmount + value.fee_pending;
                    value.agreepay = value.fee_pending;
                    $rootScope.agreePay = $rootScope.agreePay + value.agreepay;
                });
            }
        }, function (error) {
            toastr.error(error);
            var objValue, errLabel ='';

            if (typeof error === 'object') {
                objValue = Object.values(error);
                errLabel = objValue[0];
            } else {
                errLabel = error;
            }
         
            analytics('getPendingPaymentMtd', errLabel);
        });
	}
};
//$scope.getPendingPaymentMtd();

$rootScope.calculateAgreePay = function(){
	$rootScope.agreePay = 0;
	angular.forEach($rootScope.paymentDue, function(value){
		$rootScope.agreePay = ( $rootScope.agreePay * 1 ) + ( value.agreepay ? value.agreepay * 1 : 0 );
	})
};

$scope.makePaymentMtd = function() {
	var options = {
		title: '<b>Collect Payment</b>',
		message:'',
		templateUrl: 'views/payment/collectPayment.htm',
		size:'large',
		onEscape: function() {$scope.$apply();$scope.getPendingPaymentMtd();},
		buttons: {
	}
   }
   $ngBootbox.customDialog(options);
};

$rootScope.singlePay = function(payment) {
	payment.fee_paid = payment.agreepay;
	payment.transaction_id = Date.now().toString();
	var data = {
		account_email: $rootScope.authentication.account_id,
		user_type: "doctor",
		data:[payment]
	}

	paymentService.makepayment(data).then(function(response) {
		toastr.success(response.message);
		$scope.getPendingPaymentMtd();
	},function(error) {
		toastr.error(error);
		analytics('singlePay',error);
	})
};

$rootScope.bulkPay = function(payment) {
	$rootScope.paymentinfo = payment;
	angular.forEach($rootScope.paymentinfo, function(value){
		value.fee_paid = value.agreepay;
		value.transaction_id = Date.now().toString();
	})
	var data = {
		account_email: $rootScope.authentication.account_id,
		user_type: "doctor",
		data:$rootScope.paymentinfo
	}
	paymentService.makepayment(data).then(function(response) {
		toastr.success(response.message);
		$scope.getPendingPaymentMtd();
	},function(error) {
		toastr.error(error);
		analytics('bulkPay',error);
	})

}; 

$scope.patient_receipt = function(billno){
	var param = {
		status : "0",
		doctor_id: authService.authentication.doctor_id,
		patient_email : $sessionStorage.get('patientAccEmail')
	}
	paymentService.Patientreceipt(param,billno).then(function(response) {
		 console.log('patient_receipt', response);
		 var inner_Contents = mainUrl+'/PDF/' + response.data;
		 $scope.showAttachment(inner_Contents)
		//  var popupWinindow = window.open('', '_blank',
		//  'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
		//  popupWinindow.document.open();
		//  popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + inner_Contents + '</html>');
		//  popupWinindow.document.close();	
	}, function(error) {
		toastr.error(error);
	})
};



$scope.sendpatientsms = function(billno){
	if(authService.authentication.account_id !=='rx15@rxcarenet.org' || authService.authentication.account_id !=='rx122340@rxcarenet.org' || authService.authentication.account_id !=='rx5016@rxcarenet.org'){
	var param = {
		status : "1",
		doctor_id: authService.authentication.doctor_id,
		patient_email : $sessionStorage.get('lastaccemail')
	}
	paymentService.Patientreceipt(param,billno).then(function(response) {
		 console.log('patient_receipt', response);
		 if(response.status == "1"){
			toastr.success(response.data)
		 } else if(response.status == "0"){
			 toastr.error("Unable to send SMS")
		 }
	}, function(error) {
		toastr.error(error);
	})
}
};

$scope.payment_receipt_printTemplate = function(billno,status){

	var patient_mail = $sessionStorage.get('lastaccemail');
		sessionStorage.setItem('patientAccEmail',patient_mail);
		console.log("patient_mail***"+patient_mail);

	$rootScope.printreceiptBillno = billno;

	$rootScope.printreceiptCategorylist = [];
		$scope.printCategory = {};
		recordService.getpresCate().then(function(response){
		   if(response){
				console.log(response);
				for(var x=0;x<response.data.length;x++) {
					if(response.data[x].category == 2){
						$scope.printCategory = {
							template_id: response.data[x].template_id,
							sub_category: response.data[x].sub_category
					}
						console.log($scope.printCategory);
						$scope.printreceiptCategorylist.push($scope.printCategory)
					}
				}
				console.log($rootScope.printreceiptCategorylist);
				if(status == 1)
				$scope.printTempatePopup();
			}
		})
};

$scope.printTempatePopup =  function(){
	$scope.printreceiptCategorySelected = undefined;
var options = {
	title: '<b>Select Template Category</b>',
	message:'',
	templateUrl: 'views/payment/receiptTemplateCategory.htm',
	size:'medium',
	onEscape: function() {$scope.$apply();},
	buttons: {
	}
}
$ngBootbox.customDialog(options);
}

$rootScope.onreceiptTemplateSelect = function(tempId) {
	//console.log('tempId**'+tempId)
	$rootScope.printrecevalidationerrormsg = '';
	$scope.printreceiptCategorySelected = tempId;
};

$rootScope.receiptTempPrint = function() {

	if($scope.printreceiptCategorySelected == undefined){
		$rootScope.printrecevalidationerrormsg = 'Template category is requird';
		return;
	}
	recordService.receiptTemplate($rootScope.printreceiptBillno,$scope.printreceiptCategorySelected).then(function(response){
	   if(response){
			console.log(response);
			window.open(mainUrl+"/PDF/"+response.data,"_blank");
			$rootScope.printrecevalidationerrormsg = '';
		}
	})

}
$scope.payment_receipt = function(billno){

	if (mainUrl == 'https://test.epicare.net') {
			$scope.presprinturl = 'https://test.epicare.net';
		}else{
			$scope.presprinturl = 'https://epicare.net';
		}
		$scope.patientEmail = $sessionStorage.get('patientAccEmail');
		$rootScope.callreceiptpopup = true;
		//$scope.callprintpopupLoader = true;
		$scope.currenreceiptUrl = $sce.trustAsResourceUrl(' ');
		setTimeout(function() {
			$scope.callprintpopupLoader = false;
			$scope.currenreceiptUrl = $sce.trustAsResourceUrl($scope.presprinturl+'/prescription/#'+'/print'+'?route_path=cashReceipt&account_email='+$rootScope.authentication.account_id+'&patient_email='+$scope.patientEmail+'&bill_num='+billno+'&auth_token='+$rootScope.authtoken);
		}, 500);
};



$scope.getHistory= function(){
	$scope.refundAmount = 0;
	$scope.billedAmount = 0;
	$scope.paymentHistory = [];
	var param = "&patient_email="+$sessionStorage.get('patientAccEmail');
	paymentService.paymentReport(param).then(function(response) {

		if(response.length > 0){
			angular.forEach(response,function(value){
				if(value.fee_pending >= 0){
				    var date = $scope.convertUTCDateToLocalDate(new Date(value.bill_date));
				    value.bill_date = new Date(date);
					if (value.status === "refund"){
						$scope.refundAmount = $scope.refundAmount + value.bill_amount;
					}else if(value.status === "paid" || value.status === "pending"){
						$scope.billedAmount = $scope.billedAmount + value.bill_amount;
					}
					$scope.paymentHistory.push(value);
				}
			});
		}
		if(response.length == 0){
			$scope.norecords == true
			toastr.success('There is no payments raised for this patient');
		}
		if(response.length = []){
			$scope.norecords_data = true
			$scope.norecords = true;
		}
	}, function(error) {
		toastr.error(error);
		analytics('getHistory',error);
	})
};

$rootScope.conf_pay = function(data){
	console.log('7383 data',data);
	if(data == 1){
		paymentService.getPaymentSetting().then(function(response) {
			$rootScope.paymentlist = response;
			console.log('$rootScope.paymentlist',$rootScope.paymentlist)
			angular.forEach(response , function(data){
				if(data.module == "video_call_conference"){
					$rootScope.conference_doctorcharge = data.doctor_charge;
					sessionStorage.setItem('doc_charge', $rootScope.conference_doctorcharge);
					document.getElementById('payinfo').innerHTML = "An Amount of Rs."+data.doctor_charge+" will be Debited for "+data.module;
				}
			})
		});	
	}else if(data == 0){
		document.getElementById('payinfo').innerHTML = " ";
	}

}

$rootScope.getconfvideocall = function(){
	var ID = sessionStorage.getItem('conference_id')
	var data ={
		"app":ID
	}
	console.log('data 7392', data);
	paymentService.getconf_videocall(data).then(function(response) {
		console.log('get videocall', response);	
			$rootScope.conf_videocalldata = response.details;	
   }, function(error) {
	   toastr.error(error);
   })
}


$rootScope.update_confvideocall = function(data){
	bootbox.hideAll();
	$rootScope.conference = {
		"radio": data.chargeable_fee,
		"Name": data.conf_name,
		"Mobile": data.conf_phone_no,
		"Email": data.conf_email,
		"id": data.id
	}
	console.log('$rootScope.conference' , $rootScope.conference);
    
	var options = {
		title: '<b> Update conference VideoCall Details</b>',
		//message:'',
		templateUrl: 'views/payment/updatepatient_tovideocall.htm',
		size:'medium',
		onEscape: function() {
			$scope.$apply();
			// $location.path('/home');
			// bootbox.hideAll()
		},
		buttons: {
	  }
  }
  $ngBootbox.customDialog(options);
	
}

$rootScope.update_anotherperson = function(data){
   console.log('data update 7430', data);
	var payload = {
		"chargeable_fee": data.radio,
		"conf_name": data.Name,
		"patient_account":$sessionStorage.get('patientAccEmail'),
		"conf_phone_no": data.Mobile,
		"conf_email": data.Email,
		"account_email": $rootScope.authentication.account_id,
		"doctor_id": $rootScope.authentication.doctor_id,
		"type":1,
		"id": data.id
	}
	
	console.log('payload',payload);
	paymentService.update_newconferencevideocall(payload).then(function(response) {
		console.log('update conference videocall', response);	
		toastr.success(response.message, { timeOut: 2000 });
		if(response.success == 1){
			$rootScope.conference ='';
		    bootbox.hideAll();
			$rootScope.getconfvideocall();
		}
   }, function(error) {
	   toastr.error(error);
   })
}

$rootScope.deleteConfvideocall = function(data){
	console.log('data deleteConfvideocall',data);

	bootbox.confirm({
		message: " Are you sure to deactivate"+"   "+data.conf_name,
		buttons: {
			confirm: {
				label: 'Deactivate',
				className: 'btn-success'
			},
			cancel: {
				label: 'Cancel',
				className: 'btn-danger'
			}
		},
		callback: function (result) {
			$rootScope.delete_confvideocall(data);
		}
	});

}

$rootScope.delete_confvideocall = function(data){
	var payload = {
		"conf_name": data.conf_name,
		"patient_account":$sessionStorage.get('patientAccEmail'),
		"conf_phone_no": data.conf_phone_no,
		"conf_email": data.conf_email,
		"account_email": $rootScope.authentication.account_id,
		"doctor_id": $rootScope.authentication.doctor_id,
		"type":1,
		"id": data.id,
		"status":0
	}
	paymentService.deactivate_confvideocall(payload).then(function(response) {
		if(response.success == 1){
			$rootScope.getconfvideocall();
			toastr.success( payload.conf_name +"  "+response.message, { timeOut: 2000 });
		}
   }, function(error) {
	   toastr.error(error);
   })
}

$rootScope.add_anotherperson = function(payload){
    var ID = sessionStorage.getItem('conference_id')
	var data ={
		"app":ID
	}
	paymentService.getconf_videocall(data,payload).then(function(response) {
			$scope.allow_book = response.details;
          if($scope.allow_book.length == 0){
			  $rootScope.addAnotherperson(payload);
		    }else{
				toastr.error( 'Sorry Doctor! only one can be added. Delete/update existing one.', { timeOut: 2000 });
	            $rootScope.conference = ''
			}
				
   }, function(error) {
	   toastr.error(error);
   })
}

$rootScope.addAnotherperson = function(data){

    console.log('data 7836', data);
	$scope.doc_charge = $rootScope.conference_doctorcharge;
	console.log('$scope.doc_charge', $scope.doc_charge);
	var conference_type =sessionStorage.getItem('conference_type');
	var conference_id =sessionStorage.getItem('conference_id');
	console.log('conference_type 7519' , conference_type , conference_id);
	    if(data.radio == 1){
			var payload = {
				"chargeable_fee": data.radio,
				"conf_name": data.Name,
				"patient_account":$sessionStorage.get('patientAccEmail'),
				"conf_phone_no": data.Mobile,
				"conf_email": data.Email,
				"account_email": $rootScope.authentication.account_id,
				"doctor_id": $rootScope.authentication.doctor_id,
				"type":1,
				"app" : conference_id
			}
			console.log('payload',payload);
			var data = {
				account_email: $rootScope.authentication.account_id,
				patient_email: $sessionStorage.get('patientAccEmail'),
				category: "video_call_conference",
				description: "fee charged for conference video call",
				doctor_charges: $scope.doc_charge,
				user_type: "doctor",
				type: 3,
				appointment_id: conference_id,
				doctor_id:$rootScope.authentication.doctor_id
				
			}
			paymentService.raiseInvoice(data).then(function(response) {
				 toastr.success('Payment raised successfully');
			});
			paymentService.add_newconferencevideocall(payload).then(function(response) {
				console.log('conference videocall', response);	
				toastr.success(response.message, { timeOut: 2000 });
				if(response.success == 1){
					bootbox.hideAll();
				}
		   }, function(error) {
			   toastr.error(error);
		   })
		}else if(data.radio == 0){
			var payload = {
				"chargeable_fee": data.radio,
				"conf_name": data.Name,
				"patient_account":$sessionStorage.get('patientAccEmail'),
				"conf_phone_no": data.Mobile,
				"conf_email": data.Email,
				"account_email": $rootScope.authentication.account_id,
				"doctor_id": $rootScope.authentication.doctor_id,
				"type":1,
				"app" : conference_id
			}
			console.log('payload',payload);
			paymentService.add_newconferencevideocall(payload).then(function(response) {
				console.log('conference videocall', response);	
				toastr.success(response.message, { timeOut: 2000 });
				if(response.success == 1){
					bootbox.hideAll();
				}
		   }, function(error) {
			   toastr.error(error);
		   })
		}
}

$rootScope.close_conference_refund = function(){
	var conference_type =sessionStorage.getItem('conference_type');
	var conference_id =sessionStorage.getItem('conference_id');
	$scope.docCharge = sessionStorage.getItem('doc_charge');
	
	var Data = {
		account_email: $rootScope.authentication.account_id,
		patient_email: $sessionStorage.get('patientAccEmail'),
		category: "video_call_conference",
		description: "",
		doctor_charges: $scope.docCharge,
		fee_paid: $scope.docCharge,
		user_type: "doctor",
		type: 2,
		appointment_id: conference_id,
		doctor_id: $rootScope.authentication.doctor_id	
	}
	console.log('data 7606', Data);
	paymentService.raiseInvoice(Data).then(function(response) {
		 toastr.success('Refund Completed');
	});
}

$rootScope.close_conference = function(){
	bootbox.hideAll();
}

$scope.addnewpatient_tovideocall = function(){
	var options = {
		title: '<b>Adding a Person to Video Call</b>',
		//message:'',
		templateUrl: 'views/payment/newpatient_tovideocall.htm',
		size:'large',
		onEscape: function() {
			$scope.$apply();
			// $location.path('/home');
			bootbox.hideAll()
		},
		buttons: {
	  }
  }
  $ngBootbox.customDialog(options);
    $rootScope.getconfvideocall()
}

$scope.resentCredentialMtd= function(){
	var patientData = JSON.parse($sessionStorage.get('patientDetail'));
	var patientAccountEmail = $sessionStorage.get('patientAccEmail');
	var sendData = {
		cell_number:patientData.cell_number,
		acc_email:patientData.acc_email,
		record_id:patientData.record_id,
		dr_name:$rootScope.authentication.account_info.Account.fullName,
		bday:patientData.bday,
		mr:patientData.mr,
		patient_account_email:patientAccountEmail
	};
	recordService.resentCredential(sendData).then(function(response){
		$ngBootbox.alert(response.Message + "<br><br>Username : " + response.username + "<br>Password : " + response.password);
	}, function(error) {
		toastr.error(error);
		analytics('resentCredentialMtd',error);
	});
};

$scope.payshow = false;
$rootScope.allow_conference = false;
$scope.mobilevalidity = function(){
	recordService.mobileValidity(recordId).then(function(response){
		if(response.access == "mobile access valid") {
			$scope.payshow = false;
			$scope.valids = response.valid_till.split(' ');
		} else {
			$scope.payshow = true;
		}
	})

	recordService.getPaymentSetting().then(function(response) {
		angular.forEach(response, function (response) { 
			if(response.module == 'video_call_conference' && response.status == 1){
                  $rootScope.allow_conference = true;
			}
		});
		},function(error) {
			toastr.error(error);
		})
};

/** Life log */
	$scope.group = true;
	$scope.open = function(data){
		if(data==true){
			$scope.group = false;
		}else{
			$scope.group = true;
		}
	};

	$scope.lifeLogChart = {data: [], end: ''};

	$scope.loadLifeLog = function() {
		$scope.lifeLogDataLoaded = false;
		var data = {
				account_email: $rootScope.authentication.account_id,
				life_log_entry :{
					user_type: "doctor",
					patient_email:$sessionStorage.get('patientAccEmail')
				}
			}
			
			recordService.loadLifelog(data).then(function(response1) {

				var newLifeLog = response1.entries;
				$scope.lifeLogEntries = newLifeLog;

				if(newLifeLog.length > 0) {
					angular.forEach(newLifeLog, function(value){

						$scope.date = $scope.convertUTCDateToLocalDate(new Date(value.date));
						value.date = new Date($scope.date);
						var dateforx = value.date;
						var getLogString = '';
						
						angular.forEach(value.data, function(getLog) {
							if (getLogString != ''){
								getLogString = getLogString + ', ' + getLog.complaint;
							} else {
								getLogString = getLog.complaint;
							}
						});
						value.log_items = getLogString;

						var chartValue = {item: value.log_items, x: dateforx, y: (3)}
						$scope.lifeLogChart.data.push(chartValue);

						// angular.forEach(value.data, function(value2) {
						// 	var chartValue = {item: value2.complaint, x: dateforx, y: (3)}
						// 	$scope.lifeLogChart.data.push(chartValue);
						// });
					})
				}

				recordService.loadLifelogNew(data).then(function(response2){
				
					var oldLifeLog = response2.entries;
					
					if(oldLifeLog.length > 0) {
						angular.forEach(oldLifeLog, function(value){
	
							$scope.date = $scope.convertUTCDateToLocalDate(new Date(value.date));
							value.date = new Date($scope.date);
	
							if(value.observation!=""){
								value.open = "true";
							}else{
								value.open = "false";
							}
	
							var splitLog = value.log_items.split(', ');
							for(i=1;i<=splitLog.length;i++){
								// var j = i++;
								var chartValue = {item: splitLog[i-1], x: value.date, y: (3*i)}
								$scope.lifeLogChart.data.push(chartValue);
							}
						})
					}

					if(oldLifeLog.length > 0) {
						angular.forEach(oldLifeLog,function(value){
							$scope.lifeLogEntries.push(value);
						});
					}
		
					$scope.lifeLogChart.data.sort(compareValues('x'));
					$scope.lifeLogChart.end = $scope.lifeLogChart.data[$scope.lifeLogChart.data.length-1].x;
					// $scope.lifeLogEntries = $scope.finalResponse;
					$scope.lifeLogDataLoaded = true;

				}, function(error) {
					if(error.h4){
						$scope.loadLifeLog();
					}else {
						toastr.error(error);
						analytics('loadLifelog',error);
					}
				});
			});
};

	$scope.setApproved = function(data) {
		if(data.status==='open'){
			var approvedData = {
				account_email: $rootScope.authentication.account_id,
				life_log_entry: {
					entries: [
						data.entry_id
					]
				}
			};

			recordService.validateentries(approvedData).then(function(response) {
				$scope.loadLifeLog();
			},function(error) {
				toastr.error(error);
				analytics('setApproved',error);
			})
		}
	};

/** */


/*For Milestone */

$scope.ageSelectedbyUser = 0;


$scope.getBlockQuestionsMtd = function(){
	if($scope.milestoneCategory == 'TDSC'){
		var type = 1;
	}else{
		var type = 2;
	}

	if($scope.hideCorrectedDOB == true){
		var month = $scope.normalAge;
	}else{
		var month = $scope.ageSelectedbyUser;
	}

	if(month == 0){
        month = -1;
    }
	
	milestoneService.getBlockQuestions(type,month).then(function(response){
		$scope.milestonesBlockRsp = response;
		
		// SRMC Block Logic : Start
		
		// TDSC Block Logic
		if(type == 1){	
			if(month <= 12){
				$scope.indexScope = 0;
			}else if(month >= 13 && month <= 17){
				$scope.indexScope = 1;
			}else if(month >= 18 && month <=36){
				$scope.indexScope = 2;
			}
		}

		// LEST Block Logic
		if(type == 2){
			if(month <= 11){
				$scope.indexScope = 0;
			}else if(month >= 12 && month <= 14){
				$scope.indexScope = 1;	
			}else if(month >= 15 && month <=20){
				$scope.indexScope = 2;
			}else if(month >= 21){
				$scope.indexScope = 3;
			}
		}
		//SRMC Block Logic : End

		if($scope.milestonesBlockRsp.length == 0){
			toastr.error('No survey questions at this age');
			analytics('getBlockQuestionsMtd','No survey questions at this age');
		}
	},function(error) {
		toastr.error(error);
		analytics('getBlockQuestionsMtd',error);
	})
};

$scope.changeChartList = function(data){
  $scope.milestoneHistory = data;
  $scope.chartData.data = [];
  $scope.milestonesList();
};

//$scope.milestoneHistory = "TDSC";
$scope.milestonesList = function(){
    milestoneService.milestonesList().then(function (response) {
        $scope.milestonesListRsp = response.milestones;
        $scope.chartData.data = [];
        if ($scope.chartData.age == undefined) {
            $scope.chartData.age = $scope.normalAge;
        }
        $scope.milestonesListRsp.sort(compareValues('sno'));
        angular.forEach($scope.milestonesListRsp, function (value) {
            if ($scope.milestoneHistory == "TDSC") {
                if (value.type == "TDSC") {
                    $scope.chartData.data.push(value);
                }
            }
            if ($scope.milestoneHistory == "LEST") {
                if (value.type == "LEST") {
                    $scope.chartData.data.push(value);
                }
            }
        })
        if ($scope.milestonesListRsp.length > 0) {
            $scope.uniqueType = $filter('unique')(response.milestones, 'type');
            if ($scope.uniqueType.length == 1) {
                if ($scope.uniqueType[0].type == "LEST") {
                    $scope.milestoneCategory = "TDSC";
                } else if ($scope.uniqueType[0].type == "TDSC") {
                    $scope.milestoneCategory = "LEST";
                }
            }
        }
        if ($scope.milestoneHistory == "TDSC") {
            $scope.getPatientHistoryMtd('1');
        }
        if ($scope.milestoneHistory == "LEST") {
            $scope.getPatientHistoryMtd('2');
        }
    }, function (error) {
        toastr.error(error);
        var objValue, errLabel = '';

        if (typeof error === 'object') {
            objValue = Object.values(error);
            errLabel = objValue[0];
        } else {
            errLabel = error;
        }
        analytics('milestonesList', errLabel);
    });
};

$scope.tempArray = [];
$scope.surveyDate = {
	"date" : new Date()
};

$scope.changeAgebyDate = function(type){
	$scope.currentDate = moment($scope.surveyDate.date);
	var dateFromSurvey = $scope.currentDate;
	var normal = moment($rootScope.record1.dob);
	$scope.normalAge = dateFromSurvey.diff(normal,'month');
	if($scope.hideCorrectedDOB==false){
		var corrected = moment($rootScope.record1.corrected_bday);
		$scope.correctedAge = dateFromSurvey.diff(corrected,'month');

		if($scope.milestoneAge == 1){
			$scope.changeAge('1',type);
		}else if($scope.milestoneAge == 2){
			$scope.changeAge('2',type);
		}

	}else{
		$scope.ageSelectedbyUser = $scope.normalAge;
		if(type == "survey"){
			if($scope.milestoneCategory != undefined){
				$scope.changeList($scope.milestoneCategory);
			}	
		}else if(type == "chart"){
			$scope.chartData.age = $scope.normalAge;
		}
	}
};
$scope.changeAge = function(data,type){
	if(data == 1){
		$scope.milestoneAge = 1;
		$scope.ageSelectedbyUser = $scope.normalAge;
	}
	if(data == 2){
		$scope.milestoneAge = 2;
		$scope.ageSelectedbyUser = $scope.correctedAge;
	}
	if(type == "survey"){
		if($scope.milestoneCategory != undefined){
			$scope.changeList($scope.milestoneCategory);
		}	
	}else if(type == "chart"){
		$scope.chartData.age = $scope.ageSelectedbyUser;
	}else if(type == "both"){
		if($scope.milestoneCategory != undefined){
			$scope.changeList($scope.milestoneCategory);
		}
		$scope.chartData.age = $scope.ageSelectedbyUser;
	}
	
};

$scope.changeList = function(data){
	$scope.milestoneCategory = data;
	if ($scope.milestoneType == 1){
		$scope.tempArray = [];
		$scope.loadSurveyQuestion();
	}else if ($scope.milestoneType == 2){
		$scope.getBlockQuestionsMtd();
	}	
};
$scope.milestoneCategoryNum = "";
$scope.changeHistoryList = function(data){
	$scope.milestoneCategoryNum = data;
};

$rootScope.milestoneArray = [];
$scope.loadSurveyQuestion = function(val){

	if(val=='TDSC'){
		$scope.milestoneCategory='TDSC';
	}
	$scope.getPatientHistoryMtd('1');
	angular.forEach($scope.milestonesListRsp, function(value) {
  	if(value.start<=$rootScope.recordAge.ageInMonths&&value.end>=$rootScope.recordAge.ageInMonths&&value.type==$scope.milestoneCategory){
			$scope.tempArray.push(value);
	  }
	});
	$rootScope.milestoneArray = $scope.tempArray;

};

  $scope.milestonesList();
//$scope.surveyHistoryListMtd();
	$scope.changeAgebyDate('chart');
	
	Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
	}
	
	$scope.getDrugString = function(data){	 
		var tempStr = "";
		angular.forEach(data, function(value,key){
			if(key==0){  
		  	tempStr = tempStr+value.drug_name;
			} else {
				tempStr = tempStr+" / "+value.drug_name;	
			}
		});
		return tempStr;
	}

$scope.getVaccinationList = function() {
	var param = "&patient_email="+$sessionStorage.get('patientAccEmail')+"&no_of_upcoming_vaccinations=1";

	patientlistService.upcomingVaccinationList(param).then(function(response) {
		if(response.length>1){
			$scope.ageInDays = response[1].age_in_days;
			$scope.drugNames = $scope.getDrugString(response.slice(1));							

      var tempDate = $scope.record.dob.addDays($scope.ageInDays);	
		//var vaccineDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate());
			var monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
			var vaccineDate = monthNames[tempDate.getMonth()]+" "+tempDate.getDate()+", "+tempDate.getFullYear();
		  $rootScope.vaccinationDate = " "+vaccineDate+" ";			
			$rootScope.vaccinationMessage = " "+$scope.drugNames+".";		
		} else {
			$rootScope.vaccinationMessage="No Vaccination due.";
		}
	
		});
}

$scope.getMilestoneListBtn = function(data){
	if(data == -1){
		angular.forEach($scope.milestonesListRsp, function(value) {
			if(value.end<$rootScope.recordAge.ageInMonths&&value.type==$scope.milestoneCategory){
				$scope.tempArray.push(value)
			}
		})
	}
	if(data == 1){
		angular.forEach($scope.milestonesListRsp, function(value) {
			if(value.start>$rootScope.recordAge.ageInMonths&&value.type==$scope.milestoneCategory){
				$scope.tempArray.push(value)
			}
		})
	}
};

$scope.getMilestoneBlockBtn = function(data){
	if(data==-1){
		if($scope.indexScope != 0){
			$scope.indexScope = $scope.indexScope - 1;
		}
	}
	if(data==1){
		if($scope.indexScope != $scope.milestonesBlockRsp.length-1){
			$scope.indexScope = $scope.indexScope +1;
		}
	}
};


$scope.getMilestoneStatus = function() {
	milestoneService.getSettings().then(function(response) {
		$scope.milestoneStatus = response.milestone;
		$scope.milestoneType = response.milestone_type;
		if($scope.milestoneStatus == 1){
			// Milestone is enabled by Admin
			$scope.milestonesList();
		}
		else{
			// Milestone is disabled by Admin
		}
	},function(error) {
		toastr.error(error);
		analytics('getMilestoneStatus',error);
	})
};


$scope.getPatientHistoryMtd = function(type) {
	var patient_email = $sessionStorage.get('patientAccEmail')!=null ? $sessionStorage.get('patientAccEmail'): '';
	milestoneService.getPatientHistory(patient_email, type).then(function(response) {
		$scope.overallMilestoneHistory = response;
		$scope.reportTime = new Date();
		
			if($scope.overallMilestoneHistory.length > 0){
				$scope.milestoneTabColour = 'green';
				angular.forEach($scope.overallMilestoneHistory, function(value) {
					if(value.status == 'Not Yet'){
						$scope.milestoneTabColour = 'red';
					}
					angular.forEach($scope.chartData.data, function(item) {
						if(value.sno==item.sno){
							value.start = item.start;
							value.end = item.end;
						}
					})
				})
			}
			if($scope.overallMilestoneHistory.length!=0){
				$scope.chartData.survey = $scope.overallMilestoneHistory;
			}else {
				$scope.chartData.survey = [];
			}
		
	})
};

$scope.surveyHistoryListMtd = function(){
	var patient_email = $sessionStorage.get('patientAccEmail')!=null ? $sessionStorage.get('patientAccEmail'): '';
	milestoneService.surveyHistoryList(patient_email).then(function(response){
		$scope.milestoneList = response;
	})
};

// $scope.surveyHistoryListMtd();
// $rootScope.milestoneStatus = [{"field":"Achieved","status":"true"},{"field":"Pending","status":"false"}];
$rootScope.surveyData = [];

$scope.saveBlockSurvey = function(){
	$rootScope.surveyData = [];
	$scope.breakfun = false;
	angular.forEach($scope.milestonesBlockRsp, function(value) {
		angular.forEach(value.questions, function(item){
			if(item.status){
				$rootScope.surveyData.push(item);
			}
		})
	})
	var countYes = 0;
	angular.forEach($rootScope.surveyData, function(value){
		if(value.status == "Yes" || value.status == "Sometimes" ){
			countYes ++;
		}
	})
	if (countYes == $rootScope.surveyData.length){
		if($scope.indexScope != $scope.milestonesBlockRsp.length-1){
			$scope.indexScope = $scope.indexScope +1;
			toastr.success('You need to answer these questions also')
			return;
		}
	}
	angular.forEach($scope.milestonesBlockRsp, function(value) {
		angular.forEach(value.questions, function(item){
			if(item.status == "Not Yet"){
				if($scope.indexScope != 0){
					$scope.indexScope = $scope.indexScope - 1;
					toastr.error('You need to answer these questions also')
					analytics('saveBlockSurvey','You need to answer these questions also');
					$scope.breakfun = true;
					return;
				}
			}
		})
	})
	if($scope.breakfun == true && $scope.breakfun != undefined){
		return;
	}
	
	if($scope.milestoneCategory=="TDSC"){
		var type = 1;
	}else if($scope.milestoneCategory=="LEST"){
		var type = 2;
	}

	$scope.surveyDate.date = $filter('date')($scope.surveyDate.date, "yyyy-MM-dd");
	var updateData= {
		"account_email": $rootScope.authentication.account_id,
		"patient_email": $sessionStorage.get('patientAccEmail'),
		"age": $scope.ageSelectedbyUser,
		"type": type,
		"milestone": $rootScope.surveyData,
		"date": $scope.surveyDate.date
	};

	milestoneService.surveyAdd(updateData).then(function(response){
		$scope.surveyHistoryListMtd();
		$rootScope.surveyData = [];
		toastr.success('Survey sumbitted successfully')
		$scope.getPatientHistoryMtd('1');
		// $scope.setMilestoneTabContent(3);
		$scope.milestonesBlockRsp = [];
	},function (err) {
		toastr.error(err.error);
		analytics('saveBlockSurvey',err.error);
	})
};

$scope.updateSurvey = false;
$scope.changeHistoryEdit = function(data){
	$scope.updateSurvey = true;
	$scope.tracker_id = data;
}

$scope.surveyHistoryDetailMtd = function(data) {
	$scope.updateSurvey = false;
	var patient_email = $sessionStorage.get('patientAccEmail')!=null ? $sessionStorage.get('patientAccEmail'): '';
	var tracker_id = data
	milestoneService.surveyHistoryDetail(patient_email,tracker_id).then(function(response) {
		$scope.detailedSurveyHistory = response;
		$scope.tracker_id = "";
	})
};

$scope.cancelSurveyUpdateMtd = function(){
	$scope.surveyHistoryDetailMtd($scope.tracker_id);
}

$scope.updateSurveyMtd = function(){
	var data = {
		"account_email": $rootScope.authentication.account_id,
		"patient_email": $sessionStorage.get('patientAccEmail'),
		"tracker_id" : $scope.tracker_id,
		"milestone":$scope.detailedSurveyHistory
	};
	milestoneService.updateSurvey(data).then(function(response) {
		toastr.success(response.message);
		$scope.surveyHistoryDetailMtd($scope.tracker_id);
	},function (err) {
		toastr.error(err.error);
		$scope.surveyHistoryDetailMtd($scope.tracker_id);
		analytics('updateSurveyMtd',err.error);
	});
}

$scope.saveSurvey = function() {
	for(var x=0;x<$rootScope.surveyData.length;x++) {
		if(!$rootScope.surveyData[x].status || $rootScope.surveyData[x].status == "No") {
			toastr.error("Please enter a response before saving. If you are not sure or don't know choose no.");
			analytics('saveSurvey','Please enter a response before saving. If you are not sure or dont know choose no.');
			return;
		}
		if(!$rootScope.surveyData[x].comments) {
			$rootScope.surveyData[x].comments=null;
		}
		if(!$rootScope.surveyData[x].reported_by_parents) {
			$rootScope.surveyData[x].reported_by_parents= false;
		}
	}
	if($scope.milestoneCategory=="TDSC") {
		var type = 1;
	}else if($scope.milestoneCategory=="LEST") {
		var type = 2;
	}
	$scope.surveyDate.date = $filter('date')($scope.surveyDate.date, "yyyy-MM-dd");
	var updateData = {
		"account_email": $rootScope.authentication.account_id,
		"patient_email": $sessionStorage.get('patientAccEmail'),
		"age": $scope.ageSelectedbyUser,
		"type": type,
		"milestone": $rootScope.surveyData,
		"date": $scope.surveyDate.date
	};

	milestoneService.surveyAdd(updateData).then(function(response) {
	//$scope.setMilestoneTabContent(3);
		$scope.surveyHistoryListMtd();
		$rootScope.surveyData = [];
		toastr.success(response.response);
		$scope.getPatientHistoryMtd('1');
	},function (err, response) {
		toastr.error(response);
		analytics('saveSurvey',response);
	})
};
$scope.open2 = function() {
  $scope.popup2.opened = true;
};

$rootScope.vitalcalenderopen = function() {
	$rootScope.vitalpopup.opened = true;
  };

/* Milestone End */

/* Voice_call logics start	*/

$scope.createBtn = '';
$scope.voiceCallInitiateStatus = '';

$rootScope.bookVoiceIfNotInitiated = function() {

	var param_data = {
	   account_email: authService.authentication.account_id,
	   patient_email: $sessionStorage.get('patientAccEmail'),
	   doctor_id: authService.authentication.doctor_id,
	   a_id: $sessionStorage.get('appointment_id')
	};
	$scope.voiceCallInitiateStatus = "Trying to schedule the voice call...";
	 console.log(param_data);
	recordService.startAudioCall(param_data).then( function(response) {
		console.log( response );
		if( response.success==1 ) {
			$scope.voiceCallInitiateStatus = "The Call has been initiated.";
		} else if( response.success==0 ) {
			$scope.voiceCallInitiateStatus = "Unable to create call.";
		}
	}, function(error) {
	 	toastr.error(error);
	});
       
	// $scope.voiceCallInitiateStatus = 'Trying to schedule the voice call...';
	// var patientData = JSON.parse($sessionStorage.get('patientDetail'));
	// var patientAccountEmail = $sessionStorage.get('patientAccEmail');
	// var newDateObj = moment(new Date()).add(15, 's').toDate();
	// var scheduled_date = $filter('date')(newDateObj, "yyyy-MM-dd HH:mm:ss")
	// var data = {
		// 	Action: "N",
		// 	PatientID: patientAccountEmail,
		// 	PatientMobile: patientData.cell_number,
		// 	DoctorID: $rootScope.authentication.account_id,
		// 	DoctorMobile: $rootScope.doctorProfile.contact_number_1,
		// 	ScheduledDateTime: scheduled_date
	// }

	// // Voice snap API to schedule call
	// recordService.scheduleVoiceCall(data).then(function(response){
	// 	$scope.voiceCallInitiateStatus = 'Voice call sheduled successfully. Waiting for patient response...';
	// 	$scope.currentPatientReference = response[0].Message;
	// 	if ($scope.currentPatientReference) {
	// 		var helyxonvoice = {
	// 			"patient_email": patientAccountEmail,
	// 			"doctor_email": $rootScope.authentication.account_id,
	// 			"scheduled_date": scheduled_date,
	// 			"reference_number": $scope.currentPatientReference,	//	"201807181"
	// 			"call_type": $sessionStorage.get('appt_type') == 'voice_call'?"normal":"emergency",
	// 			"appointment_id": $sessionStorage.get('appointment_id')
	// 		};

	// 		// Helyxon API to log the scheduled call details
	// 		recordService.voiceCallCreate(helyxonvoice).then(function(createresponse){
	// 			$scope.voiceCallInitiateStatus = 'Dear Doctor, soon you will get the call to connect with patient...';
	// 			toastr.success(createresponse);
	// 			$timeout( function(){
	// 				var doctorApprovalData = {
	// 					DoctorNumber : $rootScope.doctorProfile.contact_number_1,
	// 					Referenceno: $scope.currentPatientReference
	// 				}

	// 				// Voice snap API to check patient in on line
	// 				recordService.sendDoctorResponse(doctorApprovalData).then(function(doctorResponse){
	// 					$scope.voiceCallInitiateStatus = '';
	// 					$scope.createBtn = '';
	// 					if (doctorResponse.Status == 1){
	// 						toastr.success("Trying to connect the call");
	// 					}
	// 					else if(doctorResponse.Status == 0){
	// 						toastr.error(doctorResponse.Reason);
	// 						analytics('bookVoiceIfNotInitiated',doctorResponse.Reason);
	// 					}
	// 				}, function(error){
	// 					toastr.error(error);
	// 					analytics('bookVoiceIfNotInitiated',error);
	// 				});
	// 			}, 45000 );
				
	// 		});
	// 	}
	// }, function(error){
	// 	toastr.error(error);
	// 	$rootScope.callNotInitiatedAlert();
	// 	analytics('bookVoiceIfNotInitiated',error);
	// });
	//$location.path('/home');
	// window.location.href = '../home#/home';

};

$scope.showAlert2 = function() {
	var options = {
		message: 'Please End current consultation !',
		title: 'Confirmation',
		buttons: {
		 /* warning: {
				label: "Cancel",
				className: "btn-warning"
			}, */
			success: {
				label: "Ok",
				className: "btn-success",
				callback: function() {  }
			}
		}
	};
	$ngBootbox.customDialog(options);
}

$rootScope.dismissVoiceCallNextPatient = function() {
	$rootScope.voice_call_alert = 'false';
};

$rootScope.bookVoiceCallNextPatient = function() {

	if( sessionStorage.getItem('consultStatus') == 'true' ) {
		$rootScope.voice_call_alert = 'false';
		$scope.showAlert2();
	} else {

		var param_data = {
			account_email: authService.authentication.account_id,
			patient_email: $sessionStorage.get('patientAccEmail'),
			doctor_id: authService.authentication.doctor_id,
			a_id: $sessionStorage.get('appointment_id')
		 };
		 $scope.voiceCallInitiateStatus = "Trying to schedule the voice call.";
		 
		 recordService.startAudioCall(param_data).then( function(response) {
			 console.log( response );
			 if( response.success==1 ) {
				 $scope.voiceCallInitiateStatus = "Call has been initiated.";
			 } else if( response.success==0 ) {
				 $scope.voiceCallInitiateStatus = "Unable to create call.";
			 }
		 }, function(error) {
			  toastr.error(error);
		 });
          
	}
	
//  // Schedule voice call between doctor and patient for next appointment
// 	$scope.callInitiated = true;
// 	var newDateObj = moment(new Date()).add(15, 's').toDate();
// 	var scheduled_date = $filter('date')(newDateObj, "yyyy-MM-dd HH:mm:ss")
// 	var data = {
// 		Action: "N",
// 		PatientID: $rootScope.banner.next_patient_email,
// 		PatientMobile: $rootScope.banner.next_patient_mobile,
// 		DoctorID: $rootScope.authentication.account_id,
// 		DoctorMobile: $rootScope.doctorProfile.contact_number_1,
// 		ScheduledDateTime: scheduled_date
// 	}
// 	$rootScope.voice_call_alert = 'false';

// 	// Voice snap API to schedule call
// 	recordService.scheduleVoiceCall(data).then(function(response){
// 		$scope.nextPatientReferenceNo = response[0].Message;
// 		if ($scope.nextPatientReferenceNo) {
// 			var helyxonvoice = {
// 				"patient_email": $rootScope.banner.next_patient_email,
// 				"doctor_email": $rootScope.authentication.account_id,
// 				"scheduled_date": scheduled_date,
// 				"reference_number": $scope.nextPatientReferenceNo, //"201807181"
// 				"call_type": $rootScope.banner.next_patient_appointment_type == 'voice_call'?"normal":"emergency",
// 				"appointment_id": $rootScope.banner.next_patient_appointment_id,
// 			};

// 			// Helyxon API to log the scheduled call details
// 			recordService.voiceCallCreate(helyxonvoice).then(function(createresponse){
				
// 				$timeout( function(){
// 					var doctorApprovalData = {
// 						DoctorNumber : $rootScope.doctorProfile.contact_number_1,
// 						Referenceno: $scope.nextPatientReferenceNo
// 					}

// 					// Voice snap API to check patient in on line
// 					recordService.sendDoctorResponse(doctorApprovalData).then(function(doctorResponse){
// 						$scope.callInitiated = false;
// 						if (doctorResponse.Status == 1){
// 							toastr.success("Trying to connect the call");
// 						}
// 						else if(doctorResponse.Status == 0){
// 							toastr.error(doctorResponse.Reason);
// 							analytics('bookVoiceCallNextPatient',doctorResponse.Reason);
// 						}
// 					}, function(error){
// 						toastr.error(error);
// 						analytics('bookVoiceCallNextPatient',error);
// 					});
// 				}, 45000 );

// 			}, function(error){
// 				toastr.error(error);
// 				analytics('bookVoiceCallNextPatient',error);
// 			});
// 		}
// 	}, function(error){
// 		toastr.error(error,"Try again");
// 		$rootScope.voice_call_alert = 'true';
// 		$scope.callInitiated = false;
// 		analytics('bookVoiceIfNotInitiated',error);
// 	})
};

var countvoiceCallUpdate = 0;
$scope.voiceCallUpdate = function(data){
	var updateddata = {
		"Referenceno":data
	}
	recordService.getVoiceDetails(updateddata).then(function(voiceDetailsResponse){
		var patientData = JSON.parse($sessionStorage.get('patientDetail'));
	
		var updateVoiceData = {
			"doctor_email": patientData.acc_email,
			"voice_file": voiceDetailsResponse[0].VoiceFileLocation,
			"payment_status": "pending",
			"reference_number": data,
			"call_from": "P2D",
			"call_duration": parseInt(voiceDetailsResponse[0].CallDuration),
			"voice_call_type": voiceDetailsResponse[0].callstatus
		}
		recordService.voiceCallUpdate(updateVoiceData).then(function(updateResponse){
			toastr.success("Voice call history updated");
			$scope.completeConsultation();
		}, function(err) {
			countvoiceCallUpdate += 1;
			if(countvoiceCallUpdate <= 3) {
				$scope.voiceCallUpdate(data);
			} else {
				toastr.error(err);
				countvoiceCallUpdate = 0;
				analytics('voiceCallUpdate',err);
			}
		});
	},function(err) {
		countvoiceCallUpdate += 1;
		if(countvoiceCallUpdate <= 3) {
			$scope.voiceCallUpdate(data);
		} else {
			toastr.error(err);
			countvoiceCallUpdate = 0;
			analytics('voiceCallUpdate',err);
		}
	});
};

$scope.voiceCallUpdateBfCons = function(data){
	var updateddata = {
		"Referenceno":data
	}
	recordService.getVoiceDetails(updateddata).then(function(voiceDetailsResponse){
		var patientData = JSON.parse($sessionStorage.get('patientDetail'));
	
		// angular.forEach(voiceDetailsResponse, function(item){
		// 	if(item.callstatus == "VoiceMail" && item.CallDuration > 0){
		// 		return;
		// 	}
		// });
		
		var updateVoiceData = {
			"doctor_email": patientData.acc_email,
			"voice_file": voiceDetailsResponse[0].VoiceFileLocation,
			"payment_status": "pending",
			"reference_number": data,
			"call_from": "P2D",
			"call_duration": parseInt(voiceDetailsResponse[0].CallDuration),
			"voice_call_type": voiceDetailsResponse[0].callstatus
		}
		recordService.voiceCallUpdate(updateVoiceData).then(function(updateResponse){
			toastr.success("Voice call data updated");
		}, function(err) {
			toastr.error(err);
			analytics('voiceCallUpdateBfCons',err);
		});
	},function(err){
		toastr.error(err);
		analytics('voiceCallUpdateBfCons',err);
	})
};

$scope.currentApptVoice = function(){
	if($scope.currentPatientReference){
		$scope.voiceCallUpdate($scope.currentPatientReference);
	}else{
		recordService.getvoicecallwithreferencenumber($sessionStorage.get('appointment_id')).then(function(response){
			if(response.reference){
				$scope.voiceCallUpdate(response.reference);
			}
			else if(response.message){
				toastr.error(response.message);
				analytics('currentApptVoice',response.message);
			}
		}, function(err){
			toastr.error("Error in getting reference number: ", err);
			analytics('currentApptVoice','error on getting refrence no');
		});
	}
};

$scope.endConsultation = function(data) {
		console.log('default_apptType*****',$sessionStorage.get("appt_type"));
    /*  Commented on march 21,2020 by Rajeev for new voice call flow. */
	/*  if($sessionStorage.get('appt_type') == 'voice_call' || $sessionStorage.get('appt_type') == 'emergency_voice_call' ){
	 	    $scope.currentApptVoice();
	 	    $rootScope.isappconsult = 'false';
	    } else {*/
		    //$sessionStorage.put('appointment_id','');    
			$rootScope.loadBanner();
			$scope.completeConsultation();
		    //$scope.walletBalance();
			$scope.getPayCategoryListMtd();
			// $location.path('/home');
  
	//}
}

/* Voice_call logics end */

/** Allergy */
$scope.allergyList = function() {
	//alert($sessionStorage.get('patientAccEmail'))
	var data = {
		account_email: authService.authentication.account_id,
		patient_email: $sessionStorage.get('patientAccEmail')
	}

	recordService.getAllergies(data).then(function(response) {
		$rootScope.allergies = response.allergy;
		if($rootScope.allergies.modified_at!=undefined) {
			if($rootScope.allergies.doctor_read_status == 1){
				if($rootScope.allergies.food != '' || $rootScope.allergies.drug !='' || $rootScope.allergies.environment!='' || $rootScope.allergies.others !='') {
					$rootScope.allergies.color = {'background-color':'#F08782','color':'white'};
				} else if($rootScope.allergies.food == '' || $rootScope.allergies.drug =='' || $rootScope.allergies.environment=='' || $rootScope.allergies.others =='') {
					
				}
			} else if ($rootScope.allergies.doctor_read_status == 0){
				if($rootScope.allergies.food != '' || $rootScope.allergies.drug !='' || $rootScope.allergies.environment!='' || $rootScope.allergies.others !='') {
					$rootScope.allergies.color = {'background-color':'#fff2f2','color':'black','border': '2px solid #f29490'};
				} else if($rootScope.allergies.food == '' || $rootScope.allergies.drug =='' || $rootScope.allergies.environment=='' || $rootScope.allergies.others =='') {
					
				}
			}
		} else {
			$rootScope.allergies = undefined;
		}
	}, function(error) {

	});
};

$scope.allergyhighlight = function(type,data){
	$rootScope.allergyAdd1 = {
		account_email: authService.authentication.account_id,
		allergy: { 
			food: "", environment : "", drug: "", others: ""
		}
	};
	$rootScope.allergyAdd1.allergy.patient_email = $sessionStorage.get('patientAccEmail');
	if(type=='Seen') {
		$rootScope.allergyAdd1.allergy = data;
		$rootScope.allergyAdd1.allergy.id = data.id;
		$rootScope.allergyAdd1.allergy.doctor_read_status = 1
		$rootScope.allergyAdd1.allergy.patient_email = $sessionStorage.get('patientAccEmail');
	}
	recordService.updateallergies($rootScope.allergyAdd1).then(function(response) {
		$scope.allergyList();
	}, function(error) {
		toastr.error(error);
		analytics('addAllergy',error);
	})
}

$scope.addAllergy = function(type,data) {
	$rootScope.allergyAdd = {
		account_email: authService.authentication.account_id,
		allergy: { 
			food: "", environment : "", drug: "", others: ""
		},
	};
	$rootScope.allergyAdd.allergy.patient_email = $sessionStorage.get('patientAccEmail');
	console.log($rootScope.allergyAdd.allergy.patient_email,"$rootScope.allergyAdd.allergy.patient_email")
	if(type=='Edit') {
		$rootScope.allergyAdd.allergy = data;
		$rootScope.allergyAdd.allergy.id = data.id;
	}
	var options = {
		title: '<b>'+type+' Allergy</b>',
		message:'',
		templateUrl: 'views/patient/allergy.htm',
		size:'medium', 
		onEscape: function() { $rootScope.allergyAdd.allergy ={};$scope.$apply();},
		buttons: {
			ok:{
				label: " Save",
				className: "btn-primary fa fa-save",
				callback: function() {
					if(type=='Add') {
						console.log($rootScope.allergyAdd,"$rootScope.allergyAdd")
						// alert($sessionStorage.get('patientAccEmail'))
						recordService.addallergy($rootScope.allergyAdd).then(function(response) {
							toastr.success("Allergy saved.");
							$scope.allergyList();
						}, function(error) {
							toastr.error(error);
							analytics('addAllergy',error);
						})
					}
					if(type=='Edit') {
						recordService.updateallergies($rootScope.allergyAdd).then(function(response) {
							toastr.success("Allergy updated.");
							$scope.allergyList();
						}, function(error) {
							toastr.error(error);
							analytics('addAllergy',error);
						})	
					}
				}
			},
			close: {
				label: " Close",
				className: "btn-danger fa fa-times-circle",
				callback: function() {}
			}
		}
	};

	$ngBootbox.customDialog(options);
};
/**End */

/** Last visit details and fee */
$scope.showlastvisitdetails = false;
$scope.highlightfollowup = false;
$scope.getlastvisitDetail = function(){
	var apt_id = $sessionStorage.get('appointment_id')
	var appt_type = $sessionStorage.get('appt_type') !== "" ? $sessionStorage.get('appt_type') : 'consultation'
	var doctor_id = authService.authentication.doctor_id
	var patientemail = $sessionStorage.get('patientAccEmail')
	recordService.getlastvisitdetails(apt_id,appt_type,doctor_id,patientemail).then( function(response) {
		console.log( response )
		if( response.success==1 ) {
			$scope.showlastvisitdetails = true

			if(response.data.last_visited == null){
				$scope.patientlastvisit = "N/A";
			} else {
				$scope.patientlastvisit = response.data.last_visited;
			}

			if(response.data.doctor_charges == null){
				$scope.doctorcharges = "N/A";
			} else {
				$scope.doctorcharges = response.data.doctor_charges;
			}

			if(response.data.follow_up_patient == true){
				$scope.highlightfollowup = true;
			} else {
				$scope.highlightfollowup = false;
			}

			if(response.data.fee_status == "not chargeable"){
				// $scope.alertwaiver = true;
				sessionStorage.setItem('alertwaiver',true)
			} else {
				$scope.alertwaiver = false;
				sessionStorage.setItem('alertwaiver',false)
			}
		}
		// $scope.isfollowuppatient = response.data.follow_up_patient;
		// else if( response.success==0 ) {
		// }
	}, function(error) {
		 toastr.error(error);
	});
}

$scope.popupwaiveralert = function(){
	
	var options = {
		title: '<b>Payment Confirmation</b>',
		message:'This is a followup visit. Do you want to charge the patient again?',
		size:'medium',
		onEscape: function(){$scope.$apply();$location.path('/home');},
		buttons: {
			close : {
				label: "No",
				className: "btn-danger",
				callback: function() {
					$scope.$apply();
					$location.path('/home');
				}
			},
			ok:{
				label: "Yes",
				className: "btn-success",
				callback: function() {
					$scope.raisePaypopup();
				}
			},
			
		}
	}
	$ngBootbox.customDialog(options);
};
/**End */

/**Prescription Favourite */
	$rootScope.saveFavourite = function(data) {
		var favData = {
			account_email: authService.authentication.account_id,
			drug_id: data
		};
		recordService.addfavorite(favData).then(function(response) {
			toastr.success("Saved as favourite.");
		},function(error) {
			toastr.error(error);
			analytics('saveFavourite',error);
		});
	};
/**End*/

	/**popup on mouse hover */
	$scope.popupVisible = false;

	$scope.showPopup = function(index,data) {
		$scope.selectedIndex = index;
		$scope.visibleData = {};
		$scope.popupVisible = true;
		$scope.editComplaint = false;
		$scope.visibleData = data;
	};
	$scope.closePopup = function() {
		$scope.selectedIndex = undefined;
		$scope.visibleData = {};
		$scope.editData = {};
		$scope.popupVisible = false;
		$scope.editComplaint = false;
		$scope.templates = {};
	};
	/**End*/

	$scope.tempUnit = ['C','F'];
	$scope.revisit = ['Days','Weeks','Months']
	$scope.editComplaint = false;

	$scope.editComplaintChief = function(){
			var data = {
				account_email: authService.authentication.account_id,
				user_type: "doctor",
				patient_email: $sessionStorage.get('patientAccEmail'),
				appointment_id: $sessionStorage.get('appointment_id')
			};

			recordService.loadLastComplaint(data).then(function(response){

				$scope.complaintModel = response.complaint;
				$scope.complaintModel.patient_email = $sessionStorage.get('patientAccEmail');
				$scope.complaintModel.user_type = "doctor";
				$scope.complaintModel.complaint_id = response.complaint.id;
				$scope.complaintModel.delete_issues=[];
				angular.forEach($scope.complaintModel.issues,function(value) {
					value.complaint_type = value.complaint_category!=undefined ? value.complaint_category : "";
					value.category_id = value.complaint_category_id!=undefined ? value.complaint_category_id : "";
				})
				if($scope.complaintModel.issues.length==0){
					$scope.complaintModel.issues.push({complaint_type:'',category_id:''})
				}
			})
		};

	$scope.showEdit = function(data) {
		$scope.complaintModel = {issues:[{category_id:"",details:[]}]};
		if($sessionStorage.get('appointment_id')){
			if(data == 'edit'){
				$sessionStorage.put('complaint',"edit");
				$scope.editComplaintChief();
			}else{
				$sessionStorage.put('complaint','');
			}
			$scope.editComplaint = !$scope.editComplaint;
			$scope.popupVisible = false;
		}else{
			toastr.error('Please book appointment to add complaints.')
			analytics('showEdit','please book appointment to add complaints');
		}
	};

	$scope.overviewInit = function() {
		$scope.complaintModel = {issues:[{category_id:""}],delete_issues:[]};
		$scope.docnotesModel = {notes:[],txt:''};
		$scope.examinationModel = {findings:[],txt:''};
		$scope.examinationClinicalModel = {txt:''};
		$scope.examinationVitalModel = {txt:''};
		$scope.provisionalModel = {diagnosis:[],txt:''};
		$scope.investigationModel = {investigation:[],txt:''};
		$scope.diagnosisModel = {diagnosis:[],txt:''};
		$scope.adviceModel = {advice:''};
		$scope.followupModel ={final_date:'',value:'',day:''};
		$scope.followupModelText = {final_text:''};
		$rootScope.prescript = $sessionStorage.get('prescription_id');
		$rootScope.edit="";
		$scope.selectedTests = [];
		$scope.investigationModel.list = [];
		$rootScope.prescriptionId = null;
		$rootScope.prescriptionPatient=[];
		$rootScope.prescriptionResult = [];
	};
	$scope.overviewInit();
	var complaintId;
	if(($rootScope.authentication.account_info.Account.fullName).startsWith("Dr. Ar")){
		$scope.followupModel ={final_date:'',value:'Days',day:"4"};
	};
	
	$scope.complainTypeIds = [];
	function createComplaintCategory(data){
		 angular.forEach(data, function(value, key) {
			$scope.complainTypeIds.push({complaint_id:value.id,complaint_type:value.complaint_type});
		 });

	}

	$scope.loadComplaintList = function(data){
		$rootScope.complaintList = [];
		complaintService.getComplaintList(data).then(function(response) {
			$rootScope.complaintList = response;
			createComplaintCategory(response);
		}, function(err) {
			console.log(err.error);
			$scope.loadComplaintList('active');
		})
	};

	// Select complaint from cheif complaint
	$scope.onSelectComplaint = function (data,index) {
		$scope.complaintModel.issues[index].complaint_category_id =data.id;
		// Get questions from Complaint Master
		var data1 = "account_email="+authService.authentication.account_id+"&type="+data.complaint_type;
		complaintService.questionget(data1).then(function(complaintResponse) {
			$scope.complaintQuestions = complaintResponse;
			if($scope.complaintQuestions.length > 0){
				if($scope.complaintQuestions[0].questions){
					angular.forEach($scope.complaintQuestions[0].questions,function(value) {
						$scope.complaintModel.issues[index].details.push({questions:value.question, answers:value.question});
					})
				}
			}
		}, function(error) {
			toastr.error("Unable to get complaint questions. Please refresh.");
			analytics('onSelectComplaint','Unable to get complaint questions. Please refresh.');
		})
	};

	$scope.addComplaint = function(data,index) {
		if(data.issue!=""||data.days!="") {
			$scope.complaintModel.issues.push({details:[]})
		}
	};
	
	$scope.deleteRow = function(data,index) {
		if(!data.category_id) {
			if($scope.complaintModel.issues.length>1)
        		$scope.complaintModel.issues.splice(index,1);
		} else {
			$scope.complaintModel.delete_issues.push(data);
			$scope.complaintModel.issues.splice(index,1);
		}
    };

	/**Complaint new Category */
	$scope.addNewCategory = function(data) {
		var cat_data = {
			account_email: authService.authentication.account_id,
			categories :[]
		};
		cat_data.categories.push(data);
		complaintService.addNewCategory(cat_data).then(function(response) {
			toastr.success('New complaint category added');
			var id;
			angular.forEach(response, function(value) {
				if(value.complaint_type == data){
					id = value.id;
					return;
				}
			})
			$scope.complaintModel.issues[$scope.complaintModel.issues.length-1].category_id = id;
			$scope.complaintModel.issues[$scope.complaintModel.issues.length-1].complaint_category_id = id;
		}, function(error) {
			toastr.error(error);
			analytics('addNewCategory',error);
		})

	};
	/** */

	$scope.saveEditedComplaint = function() {
		var url;
		if($sessionStorage.get('complaint')=="edit") {
			url="updatecomplaint";
			$scope.complaintModel.new_issues = [];
			if($scope.complaintModel.issues.length == 1) {
				if( $scope.complaintModel.issues[0].complaint_category_id == "" || $scope.complaintModel.issues[0].complaint_category_id == undefined){
					$scope.complaintModel.issues = [];
					angular.forEach($rootScope.complaintList,function(value) {
						if (value.complaint_type == 'others') {
							var complaintother = {category_id:value.id,days:0};
								$scope.complaintModel.issues.push(complaintother);
						}
					});
				}
			}
			angular.forEach($scope.complaintModel.issues,function(value) {
				if(value.details.length > 0) {
					if(!value.details[0].issue_id) {
						value.category_id = value.complaint_category_id;
						delete value['complaint_category_id'];
						// var index = $scope.complaintModel.issues.indexOf(value);
						// if(!value.details[0].issue_id){
						$scope.complaintModel.new_issues.push(value);
							// delete value;
						// }
					}
					// else{
					// 	value.category_id = value.complaint_category_id;
					// 	delete value['complaint_category'];
					// 	delete value['complaint_category_id'];
					// 	delete value['complaint_type']
					// 	delete value['details'];
					// 	delete value['id'];	
					// }
				}
				else{
					value.category_id = value.complaint_category_id;
					$scope.complaintModel.new_issues.push(value);
				}
			});
			for (var i = $scope.complaintModel.issues.length - 1; i >= 0; i--) {
				if($scope.complaintModel.issues[i].details.length > 0){
					if (!$scope.complaintModel.issues[i].details[0].issue_id) {
						$scope.complaintModel.issues.splice(i, 1);
					}
				}
				else {
					$scope.complaintModel.issues.splice(i, 1);
				}
			}
		} else {
			url="simplecomplaint";
			if($scope.complaintModel.issues.length == 1){
				if($scope.complaintModel.issues[0].complaint_type) 
				{
					// Complaint has been selected by user
					// Do Nothing
				}
				else if($scope.complaintModel.issues[0].category_id == "" || $scope.complaintModel.issues[0].category_id == undefined){
					// Complaint is not selected by user. 
					// So "Others" is added as complaint category
					$scope.complaintModel.issues = [];
					angular.forEach($rootScope.complaintList,function(value){
						if (value.complaint_type == 'others'){
							var complaintother = {category_id:value.id,complaint_category_id:value.id,days:0}
								$scope.complaintModel.issues.push(complaintother);
						}
					});
				}
			}
			angular.forEach($scope.complaintModel.issues,function(value){
				value.category_id = value.complaint_category_id;
				delete value['complaint_category_id'];
			})
		}
		var index = $scope.complaintModel.issues.length-1;
		if(index>0){
			if(!$scope.complaintModel.issues[index].category_id){
				$scope.complaintModel.issues.splice(index,1);
			}
		}
		 
		var data = {
			account_email: $rootScope.authentication.account_id,
			simple_complaint: {
				user_type: "doctor",
				issues: $scope.complaintModel.issues,
				days:$scope.complaintModel.days!=undefined ? $scope.complaintModel.days : "",
				medicine_given: $scope.complaintModel.medicine_given != undefined ? $scope.complaintModel.medicine_given : "",
				temperature: $scope.complaintModel.temperature != undefined ? $scope.complaintModel.temperature.toString(): "",
				unit: $scope.complaintModel.unit != undefined ? $scope.complaintModel.unit: "",
				other_information: $scope.complaintModel.other_information != undefined ? $scope.complaintModel.other_information:"",
				patient_email: $sessionStorage.get('patientAccEmail'),
				appointment_id: $sessionStorage.get('appointment_id')
			}
		}

		if($sessionStorage.get('complaint')=="edit") {
			data.simple_complaint.new_issues = $scope.complaintModel.new_issues;
			data.simple_complaint.complaint_id = $scope.complaintModel.id;
			if($scope.complaintModel.delete_issues.length!=0){
				data.simple_complaint.delete_issues = $scope.complaintModel.delete_issues;
			}
		  //delete data.simple_complaint['appointment_id'];
		}
		
		complaintService.saveComplaint(data,url).then(function(response) {
			complaintId = response.complaint.id;
			$scope.opReview.complaint = response.complaint;
			$scope.closePopup();
			$sessionStorage.put('complaint','');
			toastr.success('Complaint saved successfully.');
			$scope.getOverview();
		}, function(error) {
			$scope.closePopup();
			toastr.error(error.error);
			analytics('saveEditedComplaint',error.error);
		});

	};

	function include(array, value) {
		return array.indexOf(value);
	}

	$scope.copyNotes = function(type,data) {
		if(type == 'doctor_note') {
			var id = include($scope.docnotesModel.notes, data)
			if(id==-1){
				$scope.docnotesModel.txt += data + "\n";
				$scope.docnotesModel.notes.push(data)
			}
		}
		if(type == 'examFind') {
			var id = include($scope.examinationModel.findings,data)
			if(id==-1){
				if(data.finding){$scope.examinationModel.txt += data.finding + "\n";}
				if(data.physical_examination){$scope.examinationClinicalModel.txt += data.physical_examination + "\n";}
				if(data.measurement_test){$scope.examinationVitalModel.txt += data.measurement_test + "\n";}
				$scope.examinationModel.findings.push(data)
			}
		}
		if(type == 'proDiag') {
			var id = include($scope.provisionalModel.diagnosis,data)
			if(id==-1){
				$scope.provisionalModel.txt += data + "\n";
				$scope.provisionalModel.diagnosis.push(data)
			}
		}
		if(type == 'investigation') {
			var id = include($scope.investigationModel.investigation,data)
			if(id==-1){
				$scope.investigationModel.txt += data + "\n";
				$scope.investigationModel.investigation.push(data)
			}
		}
		if(type == 'diagnosis') {
			var id = include($scope.diagnosisModel.diagnosis,data)
			if(id==-1){
				$scope.diagnosisModel.txt += data + "\n";
				$scope.diagnosisModel.diagnosis.push(data)
			}
		}
		
	};

	$scope.rowSelected = undefined;
	$scope.selectRow = function(index,data,type) {
		$scope.rowSelected = index;
		if(type=='doc_note') {
			$scope.docnotesModel.edit = data;
		}
		if(type=='examFind') {
			$scope.examinationModel.edit = data;
		}
		if(type=='proDiag') {
			$scope.provisionalModel.edit = data;
		}
		if(type=='investigation') {
			$scope.investigationModel.edit = data;
		}
		if(type=='diagnosis') {
			$scope.diagnosisModel.edit = data;
		}
	};

	$scope.clearSelectedRow = function(index,type){
		$scope.rowSelected = undefined;
		if(type=='doc_note'){
			$scope.docnotesModel.notes.splice(index,1)
		}
		if(type=='examFind') {
			$scope.examinationModel.findings.splice(index,1)
		}
		if(type=='proDiag') {
			$scope.provisionalModel.diagnosis.splice(index,1)
		}
		if(type=='investigation') {
			$scope.investigationModel.investigation.splice(index,1);
		}
		if(type=='diagnosis') {
			$scope.diagnosisModel.diagnosis.splice(index,1);
		}
	};

	$scope.newValue = function(type,data) {
		if(type=='doc_note'){
			$scope.docnotesModel.notes[$scope.rowSelected] = $scope.docnotesModel.edit;
		}
		if(type=='examFind') {
			$scope.examinationModel.findings[$scope.rowSelected] = $scope.examinationModel.edit;
		}
		if(type=='proDiag') {
			$scope.provisionalModel.diagnosis[$scope.rowSelected] = $scope.provisionalModel.edit;
		}
		if(type=='investigation') {
			$scope.investigationModel.investigation[$scope.rowSelected] = $scope.investigationModel.edit;
		}
		if(type=='diagnosis') {
			$scope.diagnosisModel.diagnosis[$scope.rowSelected] = $scope.diagnosisModel.edit;
		}

		$scope.rowSelected = undefined;
	};

	$rootScope.getTemplate = function(type,current) {
		if(current!=="") {
			var data = { 
				search: {
					"term": current,
					"item": type
				}, 
				account_email: authService.authentication.account_id
			};
			return recordService.searchTemplate(data).then(function(response) {
				$scope.templates = {};
				return $scope.templates = response.templates;
			})
		}
	};
	
	$rootScope.getTemplateFullList = function(type) {
		var data = { 
			search: {
				"term": "",
				"item": type
			}, account_email: authService.authentication.account_id
		};
		return recordService.searchTemplate(data).then(function(response) {
			$scope.templates = {};
			return $scope.templates = response.templates;
		})
	};

	$rootScope.addNewTemplate = function(item) {
		var data = {
				account_email: authService.authentication.account_id,
				template: {
					screen: "overview"
				}
			};
			if(item=='doc_note'){
				data.template.item='doctor_notes'
				data.template.content=$scope.docnotesModel.addnotes
			}
			if(item=='examFind'){
				data.template.item='examination_findings'
				data.template.content=$scope.examinationModel.addfind
			}
			if(item=='proDiag'){
				data.template.item='provisional_diagnosis'
				data.template.content=$scope.provisionalModel.addDiag
			}
			if(item=='investigation'){
				data.template.item='investigation'
				data.template.content=$scope.investigationModel.addinvestigation
			}
			if(item=='diagnosis'){
				data.template.item='diagnosis'
				data.template.content=$scope.diagnosisModel.addnewdiagnosis
			}

			if(data.template.content!==""){
				recordService.adddoctortemplate(data).then(function(response) {
					if(item=='doc_note'){
						if($scope.docnotesModel.txt==''){
							$scope.docnotesModel.txt += $scope.docnotesModel.addnotes;	
						} else {
							$scope.docnotesModel.txt += "\n"+$scope.docnotesModel.addnotes;	
						}
						$scope.docnotesModel.addnotes = "";
					}
					if(item=='examFind'){
						if($scope.examinationModel.txt=='') {
							$scope.examinationModel.txt += $scope.examinationModel.addfind;
						} else {
							$scope.examinationModel.txt += "\n"+ $scope.examinationModel.addfind;
						}
						$scope.examinationModel.addfind = "";
					}
					if(item=='proDiag'){
						if($scope.provisionalModel.txt==''){
							$scope.provisionalModel.txt += $scope.provisionalModel.addDiag;
						}else {
							$scope.provisionalModel.txt += "\n" + $scope.provisionalModel.addDiag;
						}
					}
					if(item=='investigation'){
						if($scope.investigationModel.txt==''){
							$scope.investigationModel.txt += $scope.investigationModel.addinvestigation;
						} else {
							$scope.investigationModel.txt += "\n" + $scope.investigationModel.addinvestigation;
						}
						$scope.investigationModel.addinvestigation = "";
					}
					if(item=='diagnosis'){
						if($scope.diagnosisModel.txt == ''){
							$scope.diagnosisModel.txt += $scope.diagnosisModel.addnewdiagnosis;
						} else {
							$scope.diagnosisModel.txt += "\n" + $scope.diagnosisModel.addnewdiagnosis;
						}
						$scope.diagnosisModel.addnewdiagnosis = "";
					}				
				});
			}else{
				toastr.error("Nothing to add")
				analytics('addNewTemplate','nothing to add');
			}
	};

	$scope.onSelectPayCategory = function (data,index) {
		$rootScope.payment.category = data;
	};
	$scope.userValue = "";

	$scope.onDelete = function(type,data) {
		var options = {
			message: 'Are you sure to delete this template ?',
			size: 'small',
			title: 'Confirmation',
			buttons: {
				warning: {
					label: "Cancel",
					className: "btn-warning"
				},
				success: {
					label: "Yes",
				   	className: "btn-success",
				   	callback: function() {
						var templateData = { 
							account_email: authService.authentication.account_id,
							content: data.content,
							id: data.id
						}
						recordService.deleteTemplate(templateData).then(function(response) {
							toastr.success(response.response)
							$scope.getTemplateFullList(type);
						},function(error) {
							toastr.error(error);
							analytics('onDelete',error);
						})
					}
			   	}
		  	}
	  	};
	  	$ngBootbox.customDialog(options);
	};

	$scope.onSelect = function (type,item,copy) {
		if(type=='') {
			$scope.userValue += item+"\n";
		}
        if(type=='doc_note'){
			if(copy == 'copied'){
				var id = include($scope.docnotesModel.notes, item.content)
				if(id==-1){
					if($scope.docnotesModel.txt=='') {
						//$scope.docnotesModel.txt += '• ' + item.content;	
						$scope.docnotesModel.txt += '' + item.content;	
					} else {
						//$scope.docnotesModel.txt += "\n• " + item.content;
					  	$scope.docnotesModel.txt += "\n" + item.content;
					}
					$scope.docnotesModel.addnotes = "";
				}
				else{
					$scope.docnotesModel.addnotes = "";
				}
				$scope.getTemplateFullList('doctor_notes');
			}
			else{
				var id = include($scope.docnotesModel.notes, item)
				if(id==-1){
					if($scope.docnotesModel.txt=='') {
						//$scope.docnotesModel.txt += '• ' + item;	
						  $scope.docnotesModel.txt += '' + item;	
					} else {
						//$scope.docnotesModel.txt += "\n• " + item;
						  $scope.docnotesModel.txt += "\n" + item;
					}
					$scope.docnotesModel.addnotes = "";
				}
				else{
					$scope.docnotesModel.addnotes = "";
				}
				$scope.getTemplateFullList('doctor_notes');
			}
			
		}
		if(type=='examFind') {
			if(copy == 'copied') {
				var id = include($scope.examinationModel.findings,item.content)
				if(id==-1){
					if($scope.examinationModel.txt == '') {
						//$scope.examinationModel.txt += '• ' + item.content;
						$scope.examinationModel.txt += '' + item.content;
					} else {
						//$scope.examinationModel.txt += "\n• " + item.content;
						$scope.examinationModel.txt += "\n" + item.content;
					}
					$scope.examinationModel.addfind = "";
				}
				else {
					$scope.examinationModel.addfind = "";	
				}
				$scope.getTemplateFullList('examination_findings');
			}
			else {
				var id = include($scope.examinationModel.findings,item)
				if(id==-1) {
					if($scope.examinationModel.txt == '') {
						//$scope.examinationModel.txt += '• ' + item;
						  $scope.examinationModel.txt += '' + item;
					} else {
						//$scope.examinationModel.txt += "\n• " + item;
					  	$scope.examinationModel.txt += "\n" + item;
					}
					$scope.examinationModel.addfind = "";
				}
				else {
					$scope.examinationModel.addfind = "";	
				}
				$scope.getTemplateFullList('examination_findings');
			}
			
		}
		if(type=='examFindJK') {
			if(copy == 'copied') {
				var id = include($scope.examinationModel.findings,item)
				if(id==-1){
					if($scope.examinationModel.txt == '') {
						//$scope.examinationModel.txt += '• ' + item.content;
						$scope.examinationModel.txt += '' + item;
					} else {
						//$scope.examinationModel.txt += "\n• " + item.content;
						$scope.examinationModel.txt += "\n" + item;
					}
					$scope.examinationModel.addfind = "";
				}
				else {
					$scope.examinationModel.addfind = "";	
				}
				$scope.getTemplateFullList('examination_findings');
			} else {
				var id = include($scope.examinationModel.findings,item)
				if(id==-1) {
					if($scope.examinationModel.txt == '') {
						//$scope.examinationModel.txt += '• ' + item;
						  $scope.examinationModel.txt += '' + item;
					} else {
						//$scope.examinationModel.txt += "\n• " + item;
					  	$scope.examinationModel.txt += "\n" + item;
					}
					$scope.examinationModel.addfind = "";
				}
				else {
					$scope.examinationModel.addfind = "";	
				}
				$scope.getTemplateFullList('examination_findings');
			}
			
		}
		if(type=='proDiag') {
			if(copy == 'copied') {
				var id = include($scope.provisionalModel.diagnosis,item.content)
				if(id==-1) {
					if($scope.provisionalModel.txt==''){
						//$scope.provisionalModel.txt += '• ' + item.content;	
						  $scope.provisionalModel.txt += '' + item.content;	
					}else{
						//$scope.provisionalModel.txt += "\n• "+item.content;
						  $scope.provisionalModel.txt += "\n"+item.content;
					}
					$scope.provisionalModel.addDiag = "";
				}
				else {
					$scope.provisionalModel.addDiag = "";
				}
				$scope.getTemplateFullList('provisional_diagnosis');
			}
			else{
				var id = include($scope.provisionalModel.diagnosis,item)
				if(id==-1){
					if($scope.provisionalModel.txt==''){
						//$scope.provisionalModel.txt += '• ' + item;	
						  $scope.provisionalModel.txt += '' + item;	
					}else{
						 //$scope.provisionalModel.txt += "\n• "+item;
						   $scope.provisionalModel.txt += "\n"+item;
					}
					$scope.provisionalModel.addDiag = "";
				}
				else{
					$scope.provisionalModel.addDiag = "";
				}
				$scope.getTemplateFullList('provisional_diagnosis');
			}
		}
		if(type=='diagnosis') {
			if(copy == 'copied'){
				var id = include($scope.diagnosisModel.diagnosis,item.content)
				if(id==-1){
					if($scope.diagnosisModel.txt==''){
						//$scope.diagnosisModel.txt += '• ' + item.content;
						$scope.diagnosisModel.txt += '' + item.content;
					} else {
						//$scope.diagnosisModel.txt += "\n• " + item.content;
						$scope.diagnosisModel.txt += "\n" + item.content;
					}
					$scope.diagnosisModel.addnewdiagnosis = "";
				}
				else{
					$scope.diagnosisModel.addnewdiagnosis = "";
				}
				$scope.getTemplateFullList('diagnosis');
			}
			else{
				var id = include($scope.diagnosisModel.diagnosis,item)
				if(id==-1){
					if($scope.diagnosisModel.txt==''){
						//$scope.diagnosisModel.txt += '• ' + item;
					  	$scope.diagnosisModel.txt += '' + item;
					} else {
						//$scope.diagnosisModel.txt += "\n• " + item;
					  	$scope.diagnosisModel.txt += "\n" + item;
					}
					$scope.diagnosisModel.addnewdiagnosis = "";
				}
				else{
					$scope.diagnosisModel.addnewdiagnosis = "";
				}
				$scope.getTemplateFullList('diagnosis');
			}
		}
		if(type=='investigation') {
			var id = include($scope.investigationModel.investigation,item.content)
			if(id==-1){
				if($scope.investigationModel.txt==''){
					$scope.investigationModel.txt += item.content;
				} else {
					$scope.investigationModel.txt += "\n" + item.content;
				}
				$scope.investigationModel.addinvestigation = "";
			}
			else{
				$scope.investigationModel.addinvestigation = "";
			}
		}
		if(type=='advice') {
			if($scope.adviceModel.advice=='') {
				//$scope.adviceModel.advice += '• ' + item;
				$scope.adviceModel.advice += '' + item;
			} else {
				//$scope.adviceModel.advice += "\n• " + item;
				$scope.adviceModel.advice += "\n" + item;
			}
		}
    };


	$scope.updateOP  = 0;
	$scope.opReview  = {};
	$scope.opReviews = {};

	/*//	Get H/O presenting illness questions from Complaint Master
	$scope.getPresentingIllnessQuestions = function(){
		if ( $scope.docnotesModel.txt == "" && $scope.opReview.complaint.issues.length > 0) {
			var data = "account_email="+authService.authentication.account_id;
			complaintService.questionget(data).then(function(complaintResponse) {
				$scope.complaintQuestions = complaintResponse;
				
				if($scope.complaintQuestions.length > 0){
					angular.forEach($scope.opReview.complaint.issues,function(value) {
						angular.forEach($scope.complaintQuestions, function(question) {
							if ( value.complaint_category == question.complaint_type ) {
								//	Append to H/O presenting illness text box
								$scope.docnotesModel.txt += question.question + "\n";	
							}
						})
					})
				}
			}, function(error) {
				toastr.error("Unable to get complaint questions. Please refresh.");
			})
		}
	};*/

	//	Get Examination findings from Complaint Master
	$scope.getExaminationFindings = function() {

	if($scope.opReview.complaint.issues){
		//if($scope.examinationModel.txt == "" && $scope.opReview.complaint.issues.length > 0) {
		if($scope.opReview.complaint.issues.length > 0) {
				var data = "account_email="+authService.authentication.account_id;
				complaintService.questionget(data).then(function(complaintResponse) {
					$scope.complaintQuestions = complaintResponse;

				  //Commented this for temporary..
		
		         /* if($scope.complaintQuestions.length > 0){
						angular.forEach($scope.opReview.complaint.issues,function(value) {
							angular.forEach($scope.complaintQuestions, function(question) {
								if( (value.complaint_category == question.complaint_type) && question.examination_findings != null) {
									//	Append to H/O presenting illness text box
									$scope.examinationModel.txt += question.examination_findings + "\n";
								}
							});
						});
					} */
				}, function(error) {
					toastr.error("Unable to get complaint questions. Please refresh.");
					analytics('getExaminationFindings','unable to get complaint questions. Please refresh');
				})
			}
		}
	};

	//	Get Provisional Diagnosis from Complaint Master
	$scope.getProvisionalDiagnosis = function(){
		if($scope.opReview.complaint.issues){
			if ( $scope.provisionalModel.txt == "" && $scope.opReview.complaint.issues.length > 0) {
			
				var data = "account_email="+authService.authentication.account_id;
				complaintService.questionget(data).then(function(complaintResponse) {
					$scope.complaintQuestions = complaintResponse;
					
					if($scope.complaintQuestions.length > 0){
						angular.forEach($scope.opReview.complaint.issues,function(value) {
							angular.forEach($scope.complaintQuestions, function(question) {
								if ( (value.complaint_category == question.complaint_type) && question.provisional_diagnosis != null) {
									//	Append to H/O presenting illness text box
									$scope.provisionalModel.txt += question.provisional_diagnosis + "\n";
								}
							})
						})
					}
				}, function(error) {
					toastr.error('Unable to get complaint questions', 'Please refresh');
					analytics('getProvisionalDiagnosis','unable to get complaint questions, please refresh');
				})
			}
		}
	};

	$scope.getOverview = function() {
		recordService.getopreview($sessionStorage.get('appointment_id')!=""?$sessionStorage.get('appointment_id'):"''").then(function(response) {
			$scope.opReview = response.op_review;
			if(response.op_review.appointment_id){
			  $scope.updateOP = 1;
			}
			//Complaint Data
			if(response.op_review.complaint){
				complaintId = response.op_review.complaint.id;
				angular.forEach($scope.opReview.complaint.issues,function(value) {
					if(value.days < 8) {
						value.inDaysType = 'Days';
					} else if (value.days < 31) {
						value.days = Math.round(value.days / 7);
						value.inDaysType = 'Weeks';
					} else if (value.days > 30) {
						value.days = Math.round(value.days / 30);
						value.inDaysType = 'Months';
					}
				})
			}
			//	H/o Presenting illness
			if (response.op_review.notes){
				$scope.docnotesModel.txt += response.op_review.notes;
			}
			//	Examination Finding
			if (response.op_review.findings){
				$scope.examinationModel.txt = response.op_review.findings;
			}
			if (response.op_review.physical_examination){
				$scope.examinationClinicalModel.txt = response.op_review.physical_examination;
			}
			if (response.op_review.measurement_test){
				$scope.examinationVitalModel.txt = response.op_review.measurement_test;
			}
			//	Provisional Diagnosis
			if (response.op_review.provisional_diagnosis){
				$scope.provisionalModel.txt = response.op_review.provisional_diagnosis;
			}
			//	Investigation
			if (response.op_review.lab_tests){
				$scope.investigationModel.list = response.op_review.lab_tests;
				$scope.opReview.lab_tests = [];
			}
			//	Diagnosis
			if (response.op_review.diagnosis){
				$scope.diagnosisModel.txt = response.op_review.diagnosis;
			}
			// Prescription
			// if (response.op_review.prescription){
			// 	$rootScope.prescriptionResult = angular.forEach(response.prescription, function(value){
			// 		$rootScope.prescriptionResult.push(value);
			// 	})
			// }
			// Prescription
			if (response.op_review.prescription_id){
				$rootScope.prescriptionResult = [];
				$rootScope.prescriptionId = response.op_review.prescription_id;
				$scope.prescriptionUpdate = true;
				angular.forEach(response.op_review.prescription, function(value){
					$rootScope.prescriptionResult.push(value);
				})
				if($rootScope.prescriptionResult.length>0){
					$rootScope.LoadPresRecord();
				}
			} else {
				$scope.prescriptionUpdate = false;
			}
			//	Advice
			if (response.op_review.advice){
				$scope.adviceModel.advice = response.op_review.advice;
			}
			//	follow_up_text
			if (response.op_review.follow_up_text){
				$scope.followupModelText.txt = response.op_review.follow_up_text;
			}
			//	follow_up_date
			if (response.op_review.follow_up_date){
				$scope.followupModel.final_date = response.op_review.follow_up_date;
			}
		}, function(error) {
			toastr.error('Refresh your browser or Contact admin', error.error);
			analytics('getOverview','Refresh your web page or contact admin');
		})

	};

	$rootScope.followupDatepicker= {
		opened :{ childInfo:false, fatherInfo:false, motherInfo:false},
	    maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
	    dateOptions : {
	    formatYear: 'yyyy',
	    startingDay: 1,
        minDate: new Date()
	  }
	};

	$scope.loadAdviceList = function() {
		recordService.listAdvice().then(function(response) {
			$scope.adviceList = response.advice_master;
		},function(error) {
			toastr.error(error);
			analytics('loadAdviceList',error);
		})
	};

	$rootScope.saved = false;

	$scope.consultationinputchanged = function(){
		if ($scope.updateOP == 1){
			$scope.updateOverviewData();
		}
		else	{
			$scope.saveOverviewData();
		}
	}

	$scope.saveprescription = function() {
		if($rootScope.prescriptionPatient.length>0){
			if($scope.prescriptionUpdate == false){
				DrugMasterService.managePrescription('add',$rootScope.prescriptionPatient).then(function(response){
					$rootScope.prescriptionId = response.prescription.id;
					$scope.prescriptionUpdate = true;
					if ($scope.updateOP == 1){
						$scope.updateOverviewData();
					}
					else	{
						$scope.saveOverviewData();
					}
				})
			}else if($scope.prescriptionUpdate == true){
				DrugMasterService.managePrescription('updatePrescription',$rootScope.prescriptionPatient).then(function(response){
					$rootScope.prescriptionId = response.prescription_id;
					$scope.prescriptionUpdate = true;
					if ($scope.updateOP == 1){
						$scope.updateOverviewData();
					}
					else	{
						$scope.saveOverviewData();
					}
				})
			}
		}
		else{
			if ($scope.updateOP == 1){
				$scope.updateOverviewData();
			}
			else	{
				$scope.saveOverviewData();
			}
		}
	};

	$scope.loadclinicalhistory = function () {
		if ($sessionStorage.get('patientAccEmail') != null) {
			var patient_email = $sessionStorage.get('patientAccEmail');
		}

		recordService.getclinicalhistory(patient_email).then(function (response) {
			// $scope.clinicalui = response.prescription.dates.length

			var clinicaldate = []
			var newAttachment = []
			// angular.forEach(response.prescription.dates, function (value) {
			// 	clinicaldate = []
			// 	clinicaldate.push(value.date)
			// 	var counter = 1;
			// 	newAttachment = []
			// 	angular.forEach(value.file_name, function(data){
			// 		if (data.startsWith("img_")) {
			// 			newAttachment.push({ name: 'View report ' + (counter++).toString(), id: $rootScope.imageUploadUrl + data });
			// 		} else {
			// 			newAttachment.push({ name: 'View report ' + (counter++).toString(), id:mainUrl+'/PDF/' + data })
			// 		}
			// 	})
			// 	value.clinical_date = clinicaldate
			// 	value.new_Attachment = newAttachment
			
			// })

			var clinicaldate1 = []
			var newAttachment1 = []
			angular.forEach(response.details, function (value) {
				clinicaldate1 = []
				clinicaldate1.push(value.created_at)
					
				var counter = 1;
				newAttachment1 = []
				angular.forEach(value.compliant_img, function (data) {
					if (data.startsWith("img_")) {
						newAttachment1.push({ name: 'View report ' + (counter++).toString(), id: $rootScope.imageUploadUrl + data });
					} else {
						newAttachment1.push({ name: 'View report ' + (counter++).toString(), id:$rootScope.pdfViewUrl + data })
					}
				})
				value.clinical_date1 = clinicaldate1
				value.new_Attachment1 = newAttachment1
			})


			$scope.clinicaldata = [];
			// angular.forEach(response.prescription.dates, function(data){
			// 	$scope.clinicaldata.push(data)
			// })
			$scope.clinicaldata1 = [];
			angular.forEach(response.details, function(data){
				if(data.compliant_img.length > 0){
					$scope.clinicaldata1.push(data)
				}
			
			})
			
		})
	}

	$scope.saveOverviewData = function() {
		var day;
		if($scope.followupModelText.txt){
			if($scope.followupModelText.txt == "SOS (If necessary)" || $scope.followupModelText.txt == "Next Vaccination Date"){
				var final_text = $scope.followupModelText.txt;
			}
			else if($scope.followupModelText.txt > 0 && $scope.followupModelText.txt < 181){
				$scope.date = new Date();
                $scope.date.setDate($scope.date.getDate() + parseInt($scope.followupModelText.txt));
				final_text = $filter('date')($scope.date, "yyyy-MM-dd");
				$scope.followupModelText.txt = final_text;
			}else{
				final_text = $filter('date')($scope.followupModelText.txt, "yyyy-MM-dd");
				$scope.followupModelText.txt = final_text;
			}
		}else{
			var final_text = '';
		}
		if($scope.followupModel.value && final_text=='') {
			if($scope.followupModel.value=="Months") {
				day = parseInt($scope.followupModel.day) * 30;
			}
			if($scope.followupModel.value=="Weeks") {
				day = parseInt($scope.followupModel.day) * 7;
			}
			if($scope.followupModel.value=="Days") {
				day = parseInt($scope.followupModel.day);
			}
			var date1 = moment(new Date()).add(parseInt(day),'days');

			var date = new Date(date1).getDate()
			var month = new Date(date1).getMonth()+1
			var year = new Date(date1).getFullYear()

			if(month < 10){
				var a;
				if(date < 10){
					a = '-0'
				}
				else {
					a = '-'
				}
				var final_date = year.toString()+'-0'+month.toString()+a+date.toString()
			}else{
				if(date < 10){
					a = '-0'
				}
				else {
					a = '-'
				}
				var final_date = year.toString()+'-'+month.toString()+a+date.toString()
			}
		};
		if(final_date==undefined) {
			final_date = '';
		}

		$scope.followupModel.final_date = final_date;
		$scope.followupModelText.final_text = final_text;		

		if($scope.investigationModel.list.length > 0){
			var labtest = $scope.selectedTests.concat($scope.investigationModel.list);
		}else if($scope.selectedTests.length > 0){
			var labtest = $scope.selectedTests;	
		}else{
			var labtest = [];
		}

		var saveData = {
			account_email: authService.authentication.account_id,
			op_review:{
				patient_email: $sessionStorage.get('patientAccEmail'),
				appointment_id: $sessionStorage.get('appointment_id'),
				complaint_id: complaintId != undefined ? (complaintId || $scope.opReview.complaint.id) : null,
				prescription_id:$rootScope.prescriptionId != undefined  ? $rootScope.prescriptionId : null,
				notes: $scope.docnotesModel.txt ? $scope.docnotesModel.txt : '',
				findings: $scope.examinationModel.txt,
				physical_examination: $scope.examinationClinicalModel.txt ? $scope.examinationClinicalModel.txt : '',
				measurement_test: $scope.examinationVitalModel.txt ? $scope.examinationVitalModel.txt : '',
				provisional_diagnosis: $scope.provisionalModel.txt,
				investigation: $scope.investigationModel.txt,
				lab_tests: labtest,
				diagnosis: $scope.diagnosisModel.txt,
				advice: $scope.adviceModel.advice!=undefined? $scope.adviceModel.advice: '',
				diet_instructions: $scope.adviceModel.dietInstruction!=undefined? $scope.adviceModel.dietInstruction: '',
				food_instructions:$scope.adviceModel.foodInstruction!=undefined? $scope.adviceModel.foodInstruction: '',
				others: $scope.adviceModel.others!=undefined? $scope.adviceModel.others: '',
				follow_up_date: final_date,
				follow_up_text: $scope.followupModelText.final_text
			}
		};
		if($sessionStorage.get('appointment_id')!=null){
			recordService.addopreview(saveData).then(function(response) {
				$rootScope.presData = saveData;
				$rootScope.overviewId = response.id;
				sessionStorage.setItem("getoverviewid",response.id)
				$rootScope.presData.follow_up_date = final_date;
				$rootScope.presData.follow_up_text = $scope.followupModelText.final_text;
				$rootScope.presData.complaint = $scope.opReview.complaint;
				// toastr.success("Data saved");
				$scope.updateOP = 1;
			}, function(error) {
				toastr.error('Unable to save. Please refresh the page');
				console.log(error);
				analytics('saveOverviewData','unable to save please refresh');
			})
		}
	};

	$scope.changeDate = function(){
		if($scope.followupModel.day >= 0){
			$scope.followupModelText.txt= '';
		}
	};

	$scope.updateOverviewData = function() {
		var day;
		if($scope.followupModelText.txt){
			if($scope.followupModelText.txt == "SOS (If necessary)" || $scope.followupModelText.txt == "Next Vaccination Date"){
				var final_text = $scope.followupModelText.txt;
			}
			else if($scope.followupModelText.txt > 0 && $scope.followupModelText.txt < 181){
				$scope.date = new Date();
                $scope.date.setDate($scope.date.getDate() + parseInt($scope.followupModelText.txt));
				final_text = $filter('date')($scope.date, "yyyy-MM-dd");
				$scope.followupModelText.txt = final_text;
			}else{
				final_text = $filter('date')($scope.followupModelText.txt, "yyyy-MM-dd");
				$scope.followupModelText.txt = final_text;
			}
		}else{
			var final_text = '';
		}
		if($scope.followupModel.value && final_text=='') {
			if($scope.followupModel.value=="Months") {
				day = parseInt($scope.followupModel.day) * 30;
			}
			if($scope.followupModel.value=="Weeks") {
				day = parseInt($scope.followupModel.day) * 7;
			}
			if($scope.followupModel.value=="Days") {
				day = parseInt($scope.followupModel.day);
			}
			var date1 = moment(new Date()).add(parseInt(day),'days');

			var date = new Date(date1).getDate()
			var month = new Date(date1).getMonth()+1
			var year = new Date(date1).getFullYear()

			if(month < 10){
				var a;
				if(date < 10){
					a = '-0'
				}
				else {
					a = '-'
				}
				var final_date = year.toString()+'-0'+month.toString()+a+date.toString()
			}else{
				if(date < 10){
					a = '-0'
				}
				else {
					a = '-'
				}
				var final_date = year.toString()+'-'+month.toString()+a+date.toString()
			}
		};
		if(final_date==undefined) {
			final_date = '';
		}

		$scope.followupModel.final_date = final_date;
		$scope.followupModelText.final_text = final_text;		

		if($scope.investigationModel.list.length > 0){
			var labtest = $scope.selectedTests.concat($scope.investigationModel.list);
		}else if($scope.selectedTests.length > 0){
			var labtest = $scope.selectedTests;	
		}else{
			var labtest = [];
		}

		$rootScope.appt_id = $sessionStorage.get('appointment_id');
		$rootScope.follow_date = $filter('date')(final_text, "dd-MM-yyyy");
		
		var saveData = {
			account_email: authService.authentication.account_id,
			op_review:{
				patient_email: $sessionStorage.get('patientAccEmail'),
				appointment_id: $sessionStorage.get('appointment_id'),
				complaint_id: complaintId != undefined ? (complaintId || $scope.opReview.complaint.id) : null,
				prescription_id:$rootScope.prescriptionId != undefined  ? $rootScope.prescriptionId : null,
				notes: $scope.docnotesModel.txt ? $scope.docnotesModel.txt : '',
				findings: $scope.examinationModel.txt,
				physical_examination: $scope.examinationClinicalModel.txt ? $scope.examinationClinicalModel.txt : '',
				measurement_test: $scope.examinationVitalModel.txt ? $scope.examinationVitalModel.txt : '',
				provisional_diagnosis: $scope.provisionalModel.txt,
				investigation: $scope.investigationModel.txt,
				lab_tests: labtest,
				diagnosis: $scope.diagnosisModel.txt,
				advice: $scope.adviceModel.advice!=undefined? $scope.adviceModel.advice: '',
				diet_instructions: $scope.adviceModel.dietInstruction!=undefined? $scope.adviceModel.dietInstruction: '',
				food_instructions:$scope.adviceModel.foodInstruction!=undefined? $scope.adviceModel.foodInstruction: '',
				others: $scope.adviceModel.others!=undefined? $scope.adviceModel.others: '',
				follow_up_date: final_date,
				follow_up_text: $scope.followupModelText.final_text
			}
		};
		if($sessionStorage.get('appointment_id')!=null){
			recordService.updateopreview(saveData).then(function(response) {
				$rootScope.presData = saveData;
				$rootScope.overviewId = response.id;
				sessionStorage.setItem("getoverviewid",response.id)
				$rootScope.presData.follow_up_date = final_date;
				$rootScope.presData.follow_up_text = $scope.followupModelText.final_text;
				$rootScope.presData.complaint = $scope.opReview.complaint;
				if($scope.showResponse == true){
					toastr.success("Data saved");
					$scope.showResponse = false;
				}
			}, function(error) {
				toastr.error('Unable to save. Please refresh the page');
				console.log(error);
				analytics('updateOverviewData','unable to save .Please refresh the page');
			})
		}
	};

	$scope.showResponse = false;
	$scope.updateBtnShowResponse = function(){
		$scope.showResponse = true;
	}
	$rootScope.detailedPres = false;
	$rootScope.prescriptionData = {type: 'simple'}
	/* $scope.simplePrint = function(data,id) {
		$scope.autoSave = 'false';
		recordService.visithistorydetailed($rootScope.overviewId).then(function(response) {
				$rootScope.presData = response.detailed_prescription;
				if($rootScope.presData.complaint.id){
					angular.forEach($rootScope.presData.complaint.issues,function(value) {
						if(value.days < 8){
							value.inDaysType = 'Days';
						}else if (value.days < 31){
							value.days = Math.round(value.days / 7);
							value.inDaysType = 'Weeks';
						}else if (value.days > 30){
							value.days = Math.round(value.days / 30);
							value.inDaysType = 'Months';
						}
					})
				}
				if(response.detailed_prescription.vitals) {
					recordService.getSpecificDoc({record_id: $scope.recordId, document_id:response.detailed_prescription.vitals}).then(function(response) {
						$rootScope.presData.vitalData = response.Models.Model.Field;
					})
				}
			})
		if(data=='detailedPres'){
			$rootScope.prescriptionData.type = 'detailedPres';
			if($rootScope.presData.complaint==undefined){
				$rootScope.presData.complaint="undefined";
			}
		}else{
			$rootScope.prescriptionData.type = 'simple';
		}
		var options = {
            title: '',
            message:'',
            templateUrl: 'views/patient/prescriptionPrint.htm',
            size:'large', 
			onEscape: function() {$scope.$apply();
				$scope.autoSave = 'true';
			},
            buttons: {
            	ok:{
                     label: " Print",
                     className: "btn-primary fa fa-save",
                    callback: function() {
						$scope.printToPaper(id);
						$scope.consult = 'true';
					}
				},
				close:{
                     label: " Close",
                     className: "btn-danger fa fa-times-circle",
                    callback: function() {
						$scope.autoSave = 'true';
					}
                }
			}
		};

		$ngBootbox.customDialog(options);
	}; */

	$scope.simpleConsultationPrint = true;
	// $scope.simpleConsultation_Print = false;
	$scope.milestonePrint = false;
	$scope.growthPrint = false;
	$scope.Checked = false;

	$scope.simplewithmilestone = function(){
		 if( $scope.simpleConsultation_Print){
			$scope.simpleConsultationPrint = true;
			$scope.simpleConsultation_Print = false;
			$scope.Checked = true;
		}else{
			$scope.simpleConsultationPrint = false;
			$scope.simpleConsultation_Print = true;
			// $scope.Checked = true;
		}
	}

	$scope.changeOptionPrint = function() {
		if($scope.detailedConsultationPrint){
			$scope.simpleConsultationPrint = true;
			$scope.detailedConsultationPrint = false;
		}else{
			$scope.simpleConsultationPrint = false;
			$scope.detailedConsultationPrint = true;
		}
	};
	$scope.selectMilestonePrint = function() {
		if($scope.milestonePrint){
			$scope.milestonePrint = false;
		}else{
			$scope.milestonePrint = true;
		}
	}

	$scope.selectVaccinationPrint = function() {
		if($scope.vaccinationPrint){
			$scope.vaccinationPrint = false;
		}else{
			$scope.vaccinationPrint = true;
		}
	}

	$scope.selectRiskPrint = function() {
		if($scope.riskPrint){
			$scope.riskPrint = false;
		}else{
			$scope.riskPrint = true;
		}
	}

	$scope.selectPregPrint = function() {
		if($scope.pregPrint){
			$scope.pregPrint = false;
		}else{
			$scope.pregPrint = true;
		}
	}

	$scope.selectGrowthPrint = function() {
		if($scope.growthPrint){
			$scope.growthPrint = false;
		}else{
			$scope.growthPrint = true;
		}
	}

	$scope.printAllGrowthChart = function() {
		$scope.printAllCons = false;
		$scope.growthPrint = true;
	};

	$scope.prescription = function(){
		
		$rootScope.printspinner = false;
		var options = {
						title: '',
						message: '',
						templateUrl: 'views/patient/prescriptionPrint.htm',
						"className" : "my-custom-class",
						onEscape: function() {$scope.$apply();
							$scope.autoSave = 'true';
						}

						
					};
					$ngBootbox.customDialog(options);
		if(authService.authentication.account_id == 'rx122340@rxcarenet.org'){
			$rootScope.print_type = 1;
			$scope.mangalabarathi()
		}else{
			$rootScope.print_type = 2;
			$scope.general_prescription()
		}
	}

	$scope.printCategorySelected;

	$scope.getprescCategory = function() {
		$scope.printCategorySelected = undefined;
		$scope.printCategorylist = [];
		$scope.printCategory = {};
		recordService.getpresCate().then(function(response){
		   if(response){
				console.log(response);
				for(var x=0;x<response.data.length;x++) {
					if(response.data[x].category == 1){
						$scope.printCategory = {
							template_id: response.data[x].template_id,
							sub_category: response.data[x].sub_category
					}
						console.log($scope.printCategory);
						$scope.printCategorylist.push($scope.printCategory)
					}
				}
				console.log($scope.printCategorylist);
				
			}
		})
	
	}
	
	$scope.printvalidationerrormsg = '';

	$scope.onTemplateSelect = function(task) {
		$scope.printvalidationerrormsg = '';
		$scope.printCategorySelected = task;
	};
	
	$scope.prescriptionPrint = function() {
		
		$scope.callprintpopupLoader = true;
		if($scope.printCategorySelected == undefined){
			$scope.printvalidationerrormsg = 'Prescrption category is requird';
			$scope.callprintpopupLoader = false;
			return;
		}
		recordService.prescTemplate($rootScope.overviewId,$scope.printCategorySelected).then(function(response){
		   if(response){
				console.log(response);
				$scope.callprintpopupLoader = false;
				window.open(mainUrl+"/PDF/"+response.data,"_blank");
			}
		})
	
	}

	$scope.showprescStatus = function() {
		if(($rootScope.accoundID == 'rx15@rxcarenet.org' || $rootScope.accoundID == 'rx122340@rxcarenet.org' || $rootScope.accoundID == 'rx81621@rxcarenet.org') 
		|| ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 3) || ($rootScope.accoundID == 'rx136720@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 2) || ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 7)
		|| ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 1)|| ($rootScope.accoundID == 'rx138310@rxcarenet.org' && $scope.doctorId == 2) || ($rootScope.accoundID == 'rx138310@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 8) || ($rootScope.accoundID == 'rx138824@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx120049@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx120049@rxcarenet.org' && $scope.doctorId == 2) ) {
			$scope.presPrintStatus = false;
		}else{
			$scope.presPrintStatus = true;
			$scope.getprescCategory();
		}
	}

	$scope.callpresPrintPath = function() {
		if(($rootScope.accoundID == 'rx15@rxcarenet.org' || $rootScope.accoundID == 'rx122340@rxcarenet.org' || $rootScope.accoundID == 'rx81621@rxcarenet.org') 
		|| ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 3) || ($rootScope.accoundID == 'rx136720@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 2) || ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 7)
		|| ($rootScope.accoundID == 'rx138310@rxcarenet.org' && $scope.doctorId == 2) || ($rootScope.accoundID == 'rx138310@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 8) || ($rootScope.accoundID == 'rx138824@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx120049@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx120049@rxcarenet.org' && $scope.doctorId == 2) ) {
			$scope.callpresPrint();
		}else {
			$scope.prescription(); $scope.getLatestVitals();//$scope.detailedPrint();
		}
	}

	$scope.callpresPrint = function() {
		
		$scope.vitalheight = '';
		$scope.vitalweight = '';
		$scope.vitaltemp = '';
		
		if(($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 7)
		|| ($rootScope.accoundID == 'rx120049@rxcarenet.org' && $scope.doctorId == 1) || ($rootScope.accoundID == 'rx120049@rxcarenet.org' && $scope.doctorId == 2))
		{
			console.log($rootScope.getvitalStatus)
			if($rootScope.getvitalStatus){
				$scope.vitalheight = $rootScope.vitalUpdate.height;
				$scope.vitalweight = $rootScope.vitalUpdate.weight;
				$scope.vitaltemp = $rootScope.vitalUpdate.temperature;
			}else{
				$scope.vitalheight = '';
				$scope.vitalweight = '';
				$scope.vitaltemp = '';
			}
	   }
		if (mainUrl == 'https://test.epicare.net') {
			$scope.presprinturl = 'https://test.epicare.net';
		}else{
			$scope.presprinturl = 'https://epicare.net';
		}
		
		if($scope.riskPrint){
			$scope.riskPrintStatus = 1;
		}else{$scope.riskPrintStatus = 0;}
		if($scope.pregPrint){
			$scope.pregPrintStatus = 1;
		}else{$scope.pregPrintStatus = 0;}

		if(($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == '2') || ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == '3') || ($rootScope.accoundID == 'rx136720@rxcarenet.org' && $scope.doctorId == '1') ||
		   ($rootScope.accoundID == 'rx138310@rxcarenet.org' && $scope.doctorId == '1') || ($rootScope.accoundID == 'rx138310@rxcarenet.org' && $scope.doctorId == '2') || ($rootScope.accoundID == 'rx4@rxcarenet.org' && $scope.doctorId == 8) || ($rootScope.accoundID == 'rx138824@rxcarenet.org' && $scope.doctorId == 1)){
			$scope.fetchurl = '/briefprescription/#';
		}else{
			$scope.fetchurl = '/prescription/#';
		}
		console.log('$scope.fetchpresurl***'+$scope.fetchurl);
		$scope.patientEmail = $sessionStorage.get('patientAccEmail');
		$rootScope.callprintprespopup = true;
		$scope.callprintpopupLoader = true;
		$scope.currentProjectUrl = $sce.trustAsResourceUrl(' ');
		setTimeout(function() {
			$scope.callprintpopupLoader = false;
			$scope.currentProjectUrl = $sce.trustAsResourceUrl($scope.presprinturl+$scope.fetchurl+'/print'+'?route_path=prescription&account_email='+$rootScope.authentication.account_id+'&overview_Id='+$rootScope.overviewId+'&doctor_Id='+$rootScope.authentication.doctor_id+'&mr_num='+$rootScope.printMr_Num+'&vit_date='+$rootScope.vitalDate+
		'&vacc_date='+$rootScope.vaccinationDate+'&vacc_msg='+$rootScope.vaccinationMessage+'&dr_Name='+$rootScope.drName+'&dr_regNo='+$rootScope.drRegNo+'&auth_token='+$rootScope.authtoken+'&appoint_Id='+$rootScope.appt_id+'&followup_date='+$rootScope.follow_date+'&faliculr_status='+$scope.pregPrintStatus+'&risk_status='+$scope.riskPrintStatus+'&patient_email='+$scope.patientEmail+
		'&vital_weight='+$scope.vitalweight+'&vital_height='+$scope.vitalheight+'&vital_temp='+$scope.vitaltemp+'&pres_printName='+$scope.presprintName+'&pres_printGender='+$scope.presprintGender+'&pres_printAge='+$scope.presprintAge);
		}, 500);
	}

	
	$scope.detailedPrint = function() {
	
		$scope.autoSave = 'false';
		recordService.visithistorydetailed($rootScope.overviewId).then(function(response) {
				$rootScope.presData = response.detailed_prescription;
				//********* Code to assign the header for the various doctor **********//
				if($rootScope.presData.doctor_profile.full_name.startsWith("Dr. Mahesh")) {
					$rootScope.presData.doctor_profile.template = "Satheesh";

				} else if($rootScope.presData.doctor_profile.full_name.startsWith("Dr. Anbezhil")) {
					$rootScope.presData.doctor_profile.template = "Anbezhil";

				} else if($rootScope.presData.doctor_profile.full_name.startsWith("Dr. Satheesh")) {
					$rootScope.presData.doctor_profile.template = "Satheesh";

				} else if($rootScope.presData.doctor_profile.full_name.startsWith("Dr. ArulalanK")) {
					$rootScope.presData.doctor_profile.template = "Dr. ArulalanK"

				} else {
					$rootScope.presData.doctor_profile.template = undefined;
				}
				// if($rootScope.presData.complaint.id){
				// 	angular.forEach($rootScope.presData.complaint.issues,function(value) {
				// 		if(value.days < 8){
				// 			value.inDaysType = 'Days';
				// 		}else if (value.days < 31){
				// 			value.days = Math.round(value.days / 7);
				// 			value.inDaysType = 'Weeks';
				// 		}else if (value.days > 30){
				// 			value.days = Math.round(value.days / 30);
				// 			value.inDaysType = 'Months';
				// 		}
				// 	})
				// }
				if(response.detailed_prescription.vitals) {
					recordService.getSpecificDoc({record_id: $scope.recordId, document_id:response.detailed_prescription.vitals}).then(function(response) {
						$rootScope.presData.vitalData = response.Models.Model.Field;
					})
				}

				if($scope.simpleConsultationPrint) {
				  var data = 'simplePres';
				} else {
				  var data = 'detailedPres';
				}
				if(data=='detailedPres') {
					$rootScope.prescriptionData.type = 'detailedPres';
					if($rootScope.presData.complaint==undefined) {
					  $rootScope.presData.complaint = "undefined";
					}
				} else {
					$rootScope.prescriptionData.type = 'simple';
				}
				if($scope.growthPrint) {
					$scope.printAllCons = true;
					$scope.loadVitalSigns();
				}
				if($scope.milestonePrint) {
					$scope.changeChartList('TDSC');
					$scope.milestonesList();
					$scope.getMilestoneStatus();
					$scope.surveyHistoryListMtd();
					$scope.changeAgebyDate('chart');
					$scope.getPatientHistoryMtd('1');
				}
				if($scope.vaccinationPrint) {
					$scope.getVaccineListMtd();
				}

				if($rootScope.presData.doctor_profile.template != "Anbezhil" && authService.authentication.account_id != 'rx23443@rxcarenet.org' && authService.authentication.account_id != 'rx3@rxcarenet.org' ){
					var options = {
						title: '',
						message: '',
						templateUrl: 'views/patient/prescriptionPrint.htm',
						"className" : "my-custom-class",
						onEscape: function() {$scope.$apply();
							$scope.autoSave = 'true';
						}

						// ,
						// buttons: {
						// 	ok:{
						//      label: " Print",
						//      className: "btn-primary fa fa-save",
						//      callback: function() {
						// 			$scope.printToPaper('printSectionIdPrint');
						// 			$scope.consult = 'true';
						// 		}
						// 	},
						// 	close:{
						//          label: " Close",
						//          className: "btn-danger fa fa-times-circle",
						//         callback: function() {
						// 			$scope.autoSave = 'true';
						// 		}
						//     }
						// }
					};
					$ngBootbox.customDialog(options);

				} else if(authService.authentication.account_id == 'rx23443@rxcarenet.org' || authService.authentication.account_id == 'rx3@rxcarenet.org') {	

			        var options = {
						title: '',
						message: '',
						templateUrl: 'views/patient/prescriptionPrintJK.htm',
						size: 'large', 
						onEscape: function() {$scope.$apply();
							$scope.autoSave = 'true';
						}
					};
					$ngBootbox.customDialog(options);

		        } else if($rootScope.presData.doctor_profile.template == "Anbezhil") {

					var options = {
						title: '',
						message: '',
						templateUrl: 'views/print/prescriptionPrintAnbezhil.htm',
						size: 'large', 
						onEscape: function() {$scope.$apply();
							$scope.autoSave = 'true';
						}
					};
					$ngBootbox.customDialog(options);
				}

			}, function(error) {
				toastr.error("Please Try again...");
				analytics('detailedPrint', 'Please Try again');
			});
	};

	/**History Page */
	$scope.loadSimpleHistory = function() {
		var data = $sessionStorage.get('patientAccEmail')!=null ? $sessionStorage.get('patientAccEmail'): '';
		recordService.simplevisithistory(data).then(function(response) {
			$scope.simpleHistoryList = response.visit_history;
		}, function(error) {
			toastr.error(error);
			analytics('loadSimpleHistory',error);
		})
	};

	$scope.loadDetailedHistory = function(data) {
		recordService.visithistorydetailed(data).then(function(response) {
			$scope.detailedHistory = response.detailed_prescription;	
			if($scope.detailedHistory.complaint.id) {
				angular.forEach($scope.detailedHistory.complaint.issues,function(value) {
					if(value.days < 8) {
						value.inDaysType = 'Days';
					} else if (value.days < 31) {
						value.days = Math.round(value.days / 7);
						value.inDaysType = 'Weeks';
					} else if (value.days > 30) {
						value.days = Math.round(value.days / 30);
						value.inDaysType = 'Months';
					}
				})
			}
			if(response.detailed_prescription.vitals) {
				var data = {
					record_id: $scope.recordId,
					document_id: response.detailed_prescription.vitals
				}
				recordService.getSpecificDoc(data).then(function(response) {
					$scope.detailedHistory.vitalData = response.Models.Model.Field;
				})
			};
		})
	};

	$scope.viewprescription = function(data) {
		$scope.prescriptionimage = mainUrl+'/PDF/' + data
			$scope.showAttachment($scope.prescriptionimage)
	};
	
	/** */

	/**Investigation */
	$scope.loadTestPackages = function() {
            labtestService.getTestPackages('all').then(function(response) {
                $scope.testPackages = angular.forEach(response.lab_tests, function(value) {
					var temp = []
                    value.json = value.json;
					value.json.isAllSelected = false;
					angular.forEach(value.json.tests, function(value){
						temp.push({name:value, isSelected: false})
					}) 
					value.json.tests = temp;
                });
            }, function(error) {
				console.log(error);
				$scope.loadTestPackages('active');
            })
         };

    $scope.loadTestPackages('active');

	$scope.selectedTests = [];
	$scope.investigationModel.list = [];

	$scope.toggleAll = function(index) {
		$scope.testPackages[index].json.tests = angular.forEach($scope.testPackages[index].json.tests, function(value) {
			value.isSelected = $scope.testPackages[index].json.isAllSelected;
			if(value.isSelected){
				$scope.selectedTests.push(value.name);
			}
			else	{
				var indexToDel = $scope.selectedTests.indexOf(value.name);
				$scope.selectedTests.splice(indexToDel, 1);
			}
		})
		$scope.testPackages[index].json.isAllSelected == true ? false : true;
	};

	$scope.optionToggled = function(parent,index,data) {
		$scope.testPackages[parent].json.tests[index].isSelected == true ? false : true;
		if($scope.testPackages[parent].json.tests[index].isSelected == true){
			$scope.selectedTests.push(data.name);
		}else if($scope.testPackages[parent].json.isAllSelected==true){
			$scope.testPackages[parent].json.isAllSelected = false;
		}
		if($scope.testPackages[parent].json.tests[index].isSelected == false){
			var indexToDel = $scope.selectedTests.indexOf(data.name)
			$scope.selectedTests.splice(indexToDel,1);
		}
	};
	/** */
			
	$rootScope.babyGrowthMessage = '';
	$scope.calculateBabyHeight = function(){
					//var fatHgt = (($rootScope.vitalUpdate.height/100).toFixed(3)).toString();
					//var motHgt = (($rootScope.vitalUpdate.height/100).toFixed(3)).toString();
					//var babHgt = (($rootScope.vitalUpdate.height/100).toFixed(3)).toString();

						var calcHeight = ($rootScope.vitalFatherHgt + $rootScope.vitalMotherHgt )/2;							   							
						var babyGenderValue = "";

							if($scope.record.gender == 'male'){
								babyGenderValue = '0';
								calcHeight = calcHeight + 13;	
							} else if($scope.record.gender == 'female'){
								babyGenderValue = '1';
								calcHeight = calcHeight - 13;	
							}

							var currentDate = moment(new Date());
							var dobMoment = moment($scope.record.dob);
							var ageInMonths = currentDate.diff(dobMoment,'month');

					  //if(parseInt(ageInMonths)>60){
						
							var payload = '';
									payload = 'child='+babyGenderValue+'&month='+ageInMonths+'&cheight='+$rootScope.vitalUpdate.height+'&eheight='+calcHeight;													

							patientlistService.patientHeightCalc(payload).then(function(response) {
		
								if(response.mh[0].success == 1) {
									var growthVal = response.mh[0].result.growth;
										 
									if(growthVal==0 || growthVal==2) {													
										$rootScope.babyGrowthMessage = 'Your child’s growth is not in the expected path. Please consult your Doctor';
									} else if(growthVal==1){
										$rootScope.babyGrowthMessage = 'Your child’s growth is good and as per standards.';
									} 
								} 
							// 	else if(response.mh[0].success == 0){
							// 		toastr.error(response.mh[0].message);
							// 		analytics('calculateBabyHeight',response.mh[0].message);
							//   }			
							}, function(error) {							
									toastr.error(error.error);
									analytics('calculateBabyHeight',error.error);
							});	
	}

	/** Add or Update vitals */
	$scope.Math = window.Math;
	$rootScope.calculateBMIPatient = function() {
		$rootScope.vitalUpdate.bmi = ($rootScope.vitalUpdate.weight/Math.pow(($rootScope.vitalUpdate.height/100),2)).toFixed(3);
		$rootScope.vitalUpdate.bsa = (0.007184*Math.pow($rootScope.vitalUpdate.weight,0.425) * (Math.pow(($rootScope.vitalUpdate.height/100),0.725))).toFixed(3);
	};

	$rootScope.calculateFahrenheit = function() {
		if($rootScope.vitalUpdate.temperature != undefined){
			$rootScope.celsius = (($rootScope.vitalUpdate.temperature - 32)/1.8).toFixed(2);
		}else{
			$rootScope.celsius = '';
		}
	};

	$rootScope.calculateMmol = function() {
		$rootScope.calcMMol = ($rootScope.gulcometer_mmol *  0.0555).toFixed(3);
	}
	

	$rootScope.pills = [];
	$rootScope.injication = [];
	$rootScope.gulcovalue = '';
	$rootScope.datestatus = false;

	$rootScope.getGulcoVal = function(val){
		console.log(val);
		$rootScope.gulcovalue = val;
	}


	$rootScope.pillsadd = function () {
		var newpilss = {};
		$rootScope.pills.push(newpilss);
	}

	$rootScope.removepills = function(){
		
	var newItemNo = $scope.pills.length-1;
     if ( newItemNo !== 0 ) {
      $rootScope.pills.pop();
     }
	}

	$rootScope.addinj = function(){
		var newinj = {};
		$rootScope.injication.push(newinj);
	}

	$rootScope.removeinj = function(){
		
	var newInjNo = $scope.injication.length-1;
     if ( newInjNo !== 0 ) {
      $rootScope.injication.pop();
     }
	}

	$rootScope.byRangesel = function(selectdate){
		$rootScope.datestatus = true;
		$rootScope.date = moment(selectdate).format("DD-MMM-YYYY");
		  console.log('$scope.date%%%%')
		  console.log($rootScope.date)
	}

	$rootScope.gethour = function (val){
		$rootScope.hours = val;
		$rootScope.datestatus = true;
		console.log($rootScope.hours)
	}
	$rootScope.getmin = function (val){
		$rootScope.min = val;
		$rootScope.datestatus = true;
		console.log($rootScope.min)
	}

	$scope.openVital = function(data,type) {
		$rootScope.getvitalStatus = true;
		$rootScope.vitalUpdate = data;
		//console.log($rootScope.vitalUpdate);

		//$rootScope.updateDate = new Date();
		
		var options = {
            title: 'Vitals',
            message: '',
            templateUrl: 'views/patient/addorupdatevital.htm',
            size: 'large', 
		    onEscape: function() {$scope.$apply();$scope.loadVitalSigns();},
            buttons: {
            	ok: {
                label: " Save",
                className: "btn-primary fa fa-save",
                callback: function() {
					$scope.calculateBabyHeight();
					var currentDate = new Date();
		
					if($rootScope.datestatus){
						$rootScope.updateDate = new Date($rootScope.date+' '+$rootScope.hours+':'+$rootScope.min);
						console.log('enter@@@@'+$rootScope.updateDate);
						// console.log(new Date($rootScope.date+' '+$rootScope.hours+':'+$rootScope.min));
						if($rootScope.updateDate == 'Invalid Date'){
							var getdate = moment($rootScope.date).format("DD-MMM-YYYY");
							$rootScope.updateDate = new Date(getdate+' '+$rootScope.hours+':'+$rootScope.min);
							console.log('invalid date')
						}
						
					}else{
						$rootScope.updateDate = new Date()
					}

					var getjson = JSON.stringify({'mmol_value':$rootScope.gulcometer_mmol != undefined ? $rootScope.gulcometer_mmol.toString() : "",'mgol_value':$rootScope.gulcometer_mgdl != undefined ? $rootScope.gulcometer_mgdl.toString() : "",'option':$rootScope.gulcovalue,'pills':JSON.parse(angular.toJson($rootScope.pills)),'injection':JSON.parse(angular.toJson($rootScope.injication))});
        			var getjsnonVal = getjson.replace(/["']/g, "'");
					console.log(getjsnonVal);
					console.log($rootScope.updateDate);
			
			  		if(type == 'edit') {
							var saveData = {
								record_id:recordId,
								document_id: data.vitals,
								type: "Vitals",
								data: {
									Models: {
										Model: {
											name: "HelChildVitalSigns",
											Field: [
												{name: "date" , text: currentDate},
												{name: "weight", text: $rootScope.vitalUpdate.weight != ( undefined || null ) ? $rootScope.vitalUpdate.weight.toString() : ""},
												{name: "height", text: $rootScope.vitalUpdate.height != ( undefined || null ) ? (($rootScope.vitalUpdate.height/100).toFixed(3)).toString() : ""},
												{name: "temperature", text: $rootScope.vitalUpdate.temperature != ( undefined || null ) ? $rootScope.vitalUpdate.temperature.toString() : ""},
												{name: "arm_circumference", text: $rootScope.vitalUpdate.arm_circumference != ( undefined || null ) ? $rootScope.vitalUpdate.arm_circumference.toString() : ""},
												{name: "head_circumference", text: $rootScope.vitalUpdate.head_circumference != ( undefined || null ) ? $rootScope.vitalUpdate.head_circumference.toString() : ""},
												{name: "chest_circumference", text: $rootScope.vitalUpdate.chest_circumference != ( undefined || null ) ? $rootScope.vitalUpdate.chest_circumference.toString() : ""},
												{name: "bmi", text: $rootScope.vitalUpdate.bmi != ( undefined || null )? $rootScope.vitalUpdate.bmi.toString() : ""},
												{name: "heart_rate", text: $rootScope.vitalUpdate.heart_rate != ( undefined || null ) ? $rootScope.vitalUpdate.heart_rate.toString() : ""},
												{name: "respiratory_rate", text: $rootScope.vitalUpdate.respiratory_rate != ( undefined || null ) ? $rootScope.vitalUpdate.respiratory_rate.toString() : ""},
												{name: "bp_systolic", text: $rootScope.vitalUpdate.bp_systolic != ( undefined || null ) ? $rootScope.vitalUpdate.bp_systolic.toString() : ""},
												{name: "bp_diastolic", text: $rootScope.vitalUpdate.bp_diastolic != ( undefined || null ) ? $rootScope.vitalUpdate.bp_diastolic.toString() : ""},
												{name: "oxygen_saturation", text: $rootScope.vitalUpdate.oxygen_saturation != ( undefined || null ) ? $rootScope.vitalUpdate.oxygen_saturation.toString() : ""},
												{name:"glucometer", text:getjsnonVal},
												{name: "glucometer_measured_date", text: $rootScope.updateDate }
											]
										}
									}
								}
							};
							recordService.docupdate(saveData).then(function(response) {
								var jsonData = {
									account_email: authService.authentication.account_id,
									link: {
										vitals_id: response.Document.id, 
										appointment_id: $sessionStorage.get('appointment_id')
									}
								};
								complaintService.linkappointmentvitals(jsonData).then(function(response) {
									toastr.success("Vitals updated successfully");
									$scope.getVitalData();
								})
							}, function(err) {
								toastr.error(err);
								analytics('openVital',err);
							})					
						}
						if(type == 'add') {

							var saveData = {
								record_id:recordId,
								type: "Vitals",
								data: {
									Models: {
										Model: {
											name: "HelChildVitalSigns",
											Field: [
												{name: "weight", text: $rootScope.vitalUpdate.weight != ( undefined || null ) ? $rootScope.vitalUpdate.weight.toString() : ""},
												{name: "height", text: $rootScope.vitalUpdate.height != ( undefined || null ) ? (($rootScope.vitalUpdate.height/100).toFixed(3)).toString() : ""},
												{name: "temperature", text: $rootScope.vitalUpdate.temperature != ( undefined || null ) ? $rootScope.vitalUpdate.temperature.toString() : ""},
												{name: "arm_circumference", text: $rootScope.vitalUpdate.arm_circumference != ( undefined || null ) ? $rootScope.vitalUpdate.arm_circumference.toString() : ""},
												{name: "head_circumference", text: $rootScope.vitalUpdate.head_circumference != ( undefined || null ) ? $rootScope.vitalUpdate.head_circumference.toString() : ""},
												{name: "chest_circumference", text: $rootScope.vitalUpdate.chest_circumference != ( undefined || null ) ? $rootScope.vitalUpdate.chest_circumference.toString() : ""},
												{name: "date" , text: currentDate},
												{name: "bmi", text: $rootScope.vitalUpdate.bmi != ( undefined || null )? $rootScope.vitalUpdate.bmi.toString() : ""},
												{name: "heart_rate", text: $rootScope.vitalUpdate.heart_rate != ( undefined || null ) ? $rootScope.vitalUpdate.heart_rate.toString() : ""},
												{name: "respiratory_rate", text: $rootScope.vitalUpdate.respiratory_rate != ( undefined || null ) ? $rootScope.vitalUpdate.respiratory_rate.toString() : ""},
												{name: "bp_systolic", text: $rootScope.vitalUpdate.bp_systolic != ( undefined || null ) ? $rootScope.vitalUpdate.bp_systolic.toString() : ""},
												{name: "bp_diastolic", text: $rootScope.vitalUpdate.bp_diastolic != ( undefined || null ) ? $rootScope.vitalUpdate.bp_diastolic.toString() : ""},
												{name: "oxygen_saturation", text: $rootScope.vitalUpdate.oxygen_saturation != ( undefined || null ) ? $rootScope.vitalUpdate.oxygen_saturation.toString() : ""},
												{name:"glucometer", text:getjsnonVal},
												{name: "glucometer_measured_date", text: $rootScope.updateDate }
												]
										}
									}
								}
							};
							if(saveData.data.Models.Model.Field[0].text===""&&saveData.data.Models.Model.Field[1].text===""){
								return;
							}
					
							complaintService.saveGrowth(saveData).then(function(response) {
								var jsonData = {
									account_email: authService.authentication.account_id,
									link: {
										vitals_id: response.Document.id, 
										appointment_id: $sessionStorage.get('appointment_id')
									}
								};
								complaintService.linkappointmentvitals(jsonData).then(function(response) {
									toastr.success("Data saved successfully");
									$scope.getVitalData();
								})
							}, function(err) {
								toastr.error(err);
								analytics('openVital',err);
							})
						}
					}
				},
				close:{
            label: " Close",
            className: "btn-danger fa fa-times-circle",
            callback: function() {
				$scope.getVitalData();
			}
        }
		}
	};

	$ngBootbox.customDialog(options);
};



	/** Book Walkin */
	$scope.bookWalkin = function(data) {
		$scope.consult = 'false';
		$rootScope.isappconsult = 'true';
		var appt = {
			patient_email: $sessionStorage.get('patientAccEmail'),
			account_email: authService.authentication.account_id
		};
		recordService.bookWalkin(appt).then(function(response) {
			toastr.success("Token "+response.token);
			$sessionStorage.put('appointment_id',response.id);
			$sessionStorage.put('status','confirmed');
			$rootScope.prescriptionPatient = [];
			$scope.overviewInit();
			$scope.getOverview();
			$scope.getVitalData();
			$rootScope.saved = false;
			$scope.showConsultation = 'true';
			$sessionStorage.put('enableConsulation','true');
		var data = {"account_email":authService.authentication.account_id,"patient_account":$sessionStorage.get('patientAccEmail'),appointment_id:response.id}
          recordService.set_patientarrival(data).then(function(response){
				//toastr.success(response.Message);
				$scope.arrivaltime();
			},function(err, response){
				toastr.error(err.Message);
				analytics('bookWalkin',err.Message);
			});
			$rootScope.loadBanner();
			$sessionStorage.put('consult',"false");
		}, function(error) {
            toastr.error(error);
            var objValue, errLabel = '';

            if (typeof error === 'object') {
                objValue = Object.values(error);
                errLabel = objValue[0];
            } else {
                errLabel = error;
            }
			$scope.consult = '';
            analytics('bookWalkin', errLabel);
		})
	};
	/** */

	/** Old History */
	$scope.loadOldHistory = function() {
		var data = $sessionStorage.get('patientAccEmail')!=null ? $sessionStorage.get('patientAccEmail'): '';
		recordService.listmedicalhistory(data).then(function(response) {
			$scope.listMedicalHistory = response.medical_history;
		}, function(error) {
			toastr.error(error);
			analytics('loadOldHistory',error);
		})
	};

	$scope.viewoldcomp = function(data) {
		console.log("viewoldcomp",data)
		$scope.showAttachment($rootScope.imageUploadUrl + data)
	}
	
$rootScope.datepicker = {
		opened :false,
		maxDate: new Date(),
		open:function(){
			$scope.datepicker.opened=true;
		},
		dateOptions : {
			formatYear: 'yyyy',
			startingDay: 1,
		//minDate: new Date(data.dob),
			maxDate: new Date()

		}
	};

	$scope.getCRCSurveyData = function() {

		$scope.surveyArray = [];
		var MR_Number = "";

		if($scope.record.mr_number!=undefined || $scope.record.mr_number!=''){
            MR_Number = $scope.record.mr_number;
		}
		
		var param = {
			account_email: authService.authentication.account_id,
            mr_number: MR_Number,       
		};
		
		authService.getCRCSurveyList(param).then(function(response){
			$scope.surveyArray = response;
		});
	}

	$scope.getCRCSurveyFilterData = function(visit_no) {	
		$scope.surveyArrayFilter = ($filter('filter')($scope.surveyArray, {'visit_no': visit_no})); 
	}

	$scope.addNewHistory = function(type,data) {
		$rootScope.oldHistoryData = data
		if(type == 'Update') {
			$rootScope.oldHistoryData.date = new Date(data.date)
		}
		var options = {
			title: type + ' History',
			message:'',
            templateUrl: 'views/patient/addoldHistory.htm',
			size:'large', 
			onEscape: function() {$scope.$apply();},
            buttons: {
            	ok:{
                     label: " Save",
                     className: "btn-primary fa fa-save",
                    callback: function() {
						var pastmedicaldate = $scope.convertUTCDateToLocalDate(new Date($rootScope.oldHistoryData.date));
						var hist_data = {
							account_email: authService.authentication.account_id,
							medical_history: {
								date: pastmedicaldate.toISOString().slice(0,10),
								doctor_last_name: '',
								doctor_first_name: $rootScope.oldHistoryData.doctor_first_name,
								hospital_name: $rootScope.oldHistoryData.hospital_name,
								problem_type: $rootScope.oldHistoryData.problem_type,
								diagnosis: $rootScope.oldHistoryData.diagnosis,
								prolonged_illness: $rootScope.oldHistoryData.prolonged_illness,
								admission:$rootScope.oldHistoryData.admission,
								comments:$rootScope.oldHistoryData.comments,
								patient_email: $sessionStorage.get('patientAccEmail')
								
							}
							
						};
						if(type=='Add'){
							recordService.medicalhistory(hist_data).then(function(response) {
								toastr.success("Saved successfully");
								$scope.loadOldHistory();
							})
						}
						if(type=='Update'){
							hist_data.medical_history.history_id =data.id; 
							recordService.medicalhistoryUpdate(hist_data).then(function(response) {
								toastr.success("Updated successfully")
								$scope.loadOldHistory();
							})
						}
						
					}
				},
				close:{
                     label: " Close",
                     className: "btn-danger fa fa-times-circle",
                    callback: function() {
						$scope.loadOldHistory();
					}
                }
			}
		};
		$ngBootbox.customDialog(options);
	};
	/** */

	/**Advice Master */
	$rootScope.adviceMaster = {disease:'',description:''};

	$scope.addAdvice = function() {
		var options = {
			title : 'Add Advice',
			message:'',
			templateUrl : 'views/adviceMaster.htm',
			size : 'medium',
			onEscape : function() {$scope.$apply();},
			buttons : {
				ok : {
					label : 'Save',
					className: "btn-primary fa fa-save",
					callback: function() {
						var data = {
							account_email: authService.authentication.account_id,
							doctor_id: authService.authentication.doctor_id,
							items : []
						};
						data.items.push($rootScope.adviceMaster);
						adviceService.addAdvice(data).then(function(response) {
							$scope.loadAdviceList();
							toastr.success('Advice added successfully.');
							$rootScope.adviceMaster = {disease:'',description:''};
						},function(error) {
							toastr.error(error);
							analytics('addAdvice',error);
						})
					}
				},
				close : {
					label: " Close",
          className: "btn-danger fa fa-times-circle",
                    callback: function() {}
				}
			}
		};
		$ngBootbox.customDialog(options);
	};

	$rootScope.templateMaster = "";
	$scope.addTemplate = function(item,type) {
		if(item=='doc_note'){
			$rootScope.templateMaster = $scope.docnotesModel.addnotes;
		}
		if(item=='examFind'){
			$rootScope.templateMaster = $scope.examinationModel.addfind;
		}
		if(item=='proDiag'){
			$rootScope.templateMaster = $scope.provisionalModel.addDiag;
		}
		if(item=='diagnosis'){
			$rootScope.templateMaster = $scope.diagnosisModel.addnewdiagnosis;
		}
		var options = {
			title : 'Add to Master',
			message:'',
			templateUrl : 'views/templateMaster.htm',
			size : 'medium',
			onEscape : function() {$scope.$apply();},
			buttons : {
				ok : {
					label : 'Save',
					className: "btn-primary fa fa-save",
					callback: function() {
						var data = {
							account_email: authService.authentication.account_id,
							template: {
								screen: "overview"
								}
						};
						if(item=='doc_note'){
							data.template.item='doctor_notes'
							data.template.content=$rootScope.templateMaster
							$scope.onSelect('doc_note',$rootScope.templateMaster,'');
							$scope.docnotesModel.addnotes = "";
						}
						if(item=='examFind'){
							$scope.consultationinputchanged();
							data.template.item='examination_findings'
							data.template.content=$rootScope.templateMaster
							$scope.onSelect('examFind',$rootScope.templateMaster,'');
							$scope.examinationModel.addfind = "";
						}
						if(item=='proDiag'){
							$scope,consultationinputchanged()
							data.template.item='provisional_diagnosis'
							data.template.content=$rootScope.templateMaster
							$scope.onSelect('proDiag',$rootScope.templateMaster,'');
							$scope.provisionalModel.addDiag = "";
						}
						if(item=='diagnosis'){
							$scope.consultationinputchanged()
							data.template.item='diagnosis'
							data.template.content=$rootScope.templateMaster
							$scope.onSelect('diagnosis',$rootScope.templateMaster,'');
							$scope.diagnosisModel.addnewdiagnosis = "";
						}
						recordService.adddoctortemplate(data).then(function(response) {
							$rootScope.templateMaster= "";
							$scope.getTemplateFullList(data.template.item);
						},function(error) {
							toastr.error(error);
							analytics('addTemplate',error);
						});
					}
				},
				close : {
					label: " Close",
                    className: "btn-danger fa fa-times-circle",
                    callback: function() {
						if(item=='doc_note'){
							$rootScope.templateMaster= "";
							$scope.docnotesModel.addnotes = "";
							$scope.getTemplateFullList('doctor_notes');
						}
						if(item=='examFind'){
							$rootScope.templateMaster= "";
							$scope.examinationModel.addfind = "";
							$scope.getTemplateFullList('examination_findings');
						}
						if(item=='proDiag'){
							$rootScope.templateMaster= "";
							$scope.provisionalModel.addDiag = "";
							$scope.getTemplateFullList('provisional_diagnosis');
						}
						if(item=='diagnosis'){
							$rootScope.templateMaster= "";
							$scope.diagnosisModel.addnewdiagnosis = "";
							$scope.getTemplateFullList('diagnosis');
						}
					}
				}
			}
		};
		$ngBootbox.customDialog(options);
	};

	$scope.editTemplate = function(type,item) {
		$rootScope.templateMaster = item;
		var options = {
			title : 'Edit Master',
			message:'',
			templateUrl : 'views/templateMaster.htm',
			size : 'medium',
			onEscape : function() {$scope.$apply();},
			buttons : {
				ok : {
					label : 'Save',
					className: "btn-primary fa fa-save",
					callback: function() {
						var data = {
								account_email: authService.authentication.account_id,
								id: $rootScope.templateMaster.id,
								content: $rootScope.templateMaster.content
							}
						recordService.editdoctortemplate(data).then(function(response) {
							toastr.success(response.response);
							$rootScope.templateMaster= "";
							$scope.getTemplateFullList(type);
						},function(error) {
							toastr.error(error);
							analytics('editTemplate',error);
						});
					}
				},
				close : {
					label: " Close",
                    className: "btn-danger fa fa-times-circle",
                    callback: function() {
						$rootScope.templateMaster= "";
						$scope.getTemplateFullList(type);
					}
				}
			}
		};
		$ngBootbox.customDialog(options);
	};


	$scope.viewics = true 

	$scope.toggleviewics = function(){
		$scope.viewics = !$scope.viewics
	}

	/** */

	if ($sessionStorage.get('patientAccEmail')!=null&&$sessionStorage.get('patientAccEmail')!="") {
		var data = $sessionStorage.get('patientAccEmail');
		recordService.getlastvisit(data).then(function(response) {
			$scope.lastVisit = response.last_visit;
			$scope.lastLoginAt = response.last_login_at;
		},function(error) {
			console.log(error);
		});
		$scope.allergyList();
		$scope.loadPrescriptionList();
		$scope.viewcurrentpreg();
		$scope.viewriskHistorydetails();
	}
	
} ]);

angular.module('AngularApp').controller('addDataPopupController', ['$scope','$rootScope', '$uibModalInstance','recordService', 'vaccineService', 'data','percentileService','toastr',function($scope, $rootScope, $uibModalInstance, recordService, vaccineService, data,percentileService,toastr){
$scope.data = data;
$scope.getListBatchExpiry = function(){
	if($scope.vaccineBrand){
		vaccineService.getListBatchExpiry($scope.vaccineBrand.id, data.vaccination_id).then(function(response){
			$scope.batchExpiryList = response;
		});
	}
};
$scope.setExpiryDate = function(){
	$scope.expiryDate = $scope.vaccineBrandBatch.expiry_date;
}

$rootScope.datepicker= {
	opened :false,
	maxDate: new Date(),
	open:function(){
		$scope.datepicker.opened=true;
	},
	dateOptions : {
	  formatYear: 'yyyy',
	  startingDay: 1,
		minDate: new Date(data.dob),
		maxDate: new Date()
	}
};



$scope.validate = false;
$scope.grow = false;

$scope.submitttt = function (frmAddGrowthData) {
	alert(3)
	// $scope.validate = true;
	// if(frmAddGrowthData.$valid){
	// 	$uibModalInstance.close($scope.data);
	// }
};

$scope.validate = false;

$scope.submit = function (frmAddGrowthData) {
	$scope.validate = true;
	if(frmAddGrowthData.$valid){
		$uibModalInstance.close($scope.data);
	}
};

$scope.cancel = function () {
	$uibModalInstance.dismiss('cancel');
};

$scope.getAgemos = function(){
  if($scope.data.weight && $scope.data.height)
  return ($scope.data.weight /(($scope.data.height/100.0) * ($scope.data.height/100.0)));
};

$scope.getBMICategoryid = function(){
  if($scope.getAgemos())
	return percentileService.getBMICategory($rootScope.patientData.age,$scope.getAgemos() , $rootScope.patientData.gender);
};

}]).directive('iframePrintpresc', ['$sce','$sessionStorage', '$rootScope', function($sce,$sessionStorage,$rootScope) {
	return {
	  restrict: 'E',
	  template: '<iframe src="{{ trustedUrl }}"></iframe>',
	  link: function(scope) {
		// scope.trustedUrl = $sce.trustAsResourceUrl('https://epicare.net/prescription/#'+'/print'+'?account_email='+$rootScope.authentication.account_id+'&overview_Id='+$rootScope.overviewId+'&doctor_Id='+$rootScope.authentication.doctor_id+'&mr_num='+$rootScope.printMr_Num+'&vit_date='+$rootScope.vitalDate+
		// '&vacc_date='+$rootScope.vaccinationDate+'&vacc_msg='+$rootScope.vaccinationMessage+'&dr_Name='+$rootScope.drName+'&dr_regNo='+$rootScope.drRegNo+'&auth_token='+$rootScope.authtoken);
		console.log($rootScope.printCount);
		// setTimeout(function() {
		// 			$rootScope.callprintprespopup = false;
		// }, 6000);
		// if($rootScope.printCount == 1) {
		// 	setTimeout(function(){
		// 		$rootScope.callprintprespopup = false;
		// 	}, 10000);
		// }else{
		// 	setTimeout(function() {
		// 		$rootScope.callprintprespopup = false;
		// 	}, 6000);
		// }
	}
		
	}
}]).directive('iframeDirective', ['$sce','$sessionStorage', '$rootScope', function($sce,$sessionStorage,$rootScope) {

	return {
	  restrict: 'E',
	  template: '<iframe ng-if="trustedUrl!=undefined" width="100%" height="100%" src="{{ trustedUrl }}" allow="camera;microphone" frameborder="0" autoplay allowfullscreen></iframe>',
	  link: function(scope) {
		  setTimeout(function(){ 
			scope.trustedUrl = $sce.trustAsResourceUrl('https://exp.epicare.net:8000/room/'+$sessionStorage.get('video_room_name')+'/'+$sessionStorage.get('video_access_token'));    
			console.log('getVideourl***  '+scope.trustedUrl)
		  }, 1000);
		}
	}
}])
.provider('adrConfig', function adrConfigProvider(){
    //defaults
    var defaultConfig = {
      iconPosition: [-15, 0],
      mode: 'all',
      modes: ['all', 'horizontal', 'vertical']
    };
    var config = angular.extend({}, defaultConfig);
    this.$get = [function(){
      return {
        iconPosition: config.iconPosition,
        mode: config.mode,
        modes: config.modes
      };
    }];
  })
  .directive('resize', ['adrConfig', '$document', function(adrConfig, $document) {
    return {
        restrict: 'A',
        link: function(scope, element, attr) {
          var dimension = {};
          var iconPosition = adrConfig.iconPosition;
          var mode = attr.resize && adrConfig.modes.indexOf(attr.resize) > -1 ? attr.resize : adrConfig.mode;
          var position = {};
          //create button for resizing
          var btn = document.createElement("span");
          btn.style.width = '15px';
          btn.style.height = '15px';
          btn.innerHTML = "<svg>\
            <circle cx='12.5' cy='2.5' r='2' fill='#777777'></circle>\
            <circle cx='7.5' cy='7.5' r='2' fill='#777777'></circle>\
            <circle cx='12.5' cy='7.5' r='2' fill='#424242'></circle>\
            <circle cx='2.5' cy='12.5' r='2' fill='#777777'></circle>\
            <circle cx='7.5' cy='12.5' r='2' fill='#424242'></circle>\
            <circle cx='12.5' cy='12.5' r='2' fill='#212121'></circle></svg>"
          ;
          btn.style.bottom = iconPosition[0] + 'px';
          btn.style.right = iconPosition[1] + 'px';
          btn.style.position = 'absolute';
          btn.style.visibility = 'hidden';
          if(mode == 'horizontal') {
            btn.style.cursor = 'ew-resize';
          }
          else if(mode == 'vertical') {
            btn.style.cursor = 'ns-resize';
          }
          else {
            btn.style.cursor = 'nwse-resize';
          }
          //bind resize function to button;
          btn.onmousedown = function($event) {
            $event.stopImmediatePropagation();
            position.x = $event.clientX;
            position.y = $event.clientY;
            dimension.width = element.prop('offsetWidth');
            dimension.height = element.prop('offsetHeight');
          	$document.bind('mousemove', mousemove);
          	$document.bind('mouseup', mouseup);
          	return false;
        	};
        	function mousemove($event) {
            var deltaWidth = dimension.width - (position.x - $event.clientX);
          	var deltaHeight = dimension.height - (position.y - $event.clientY);
			  //console.log('Resizemousemove*****'+element[0].getBoundingClientRect().width + 'px',element[0].getBoundingClientRect().height + 'px')
			  localStorage.setItem("videocall_width", element[0].getBoundingClientRect().width);
			  localStorage.setItem("videocall_height", element[0].getBoundingClientRect().height);
			  var newDimensions = {};
            if(mode == 'horizontal') {
              newDimensions = {
              	width:  deltaWidth + 'px'
            	};
            }
            else if(mode == 'vertical') {
              newDimensions = {
              	height: deltaHeight + 'px'
            	};
            }
            else {
              newDimensions = {
              	width:  deltaWidth + 'px',
              	height: deltaHeight + 'px'
            	};
            }
          	element.css(newDimensions);
          	return false;
        	}
          function mouseup() {
         	  $document.unbind('mousemove', mousemove);
         		$document.unbind('mouseup', mouseup);
        	}
          element.append(btn);
          //show button on hover
          element.bind('mouseover', function() {
            btn.style.visibility = 'visible';
          });
          element.bind('mouseout', function() {
            btn.style.visibility = 'hidden';
          });
        }
    };
  }])
  .directive('draggable', ['$document' ,'recordService','$sessionStorage', function($document,recordService,$sessionStorage) {
    return {
      restrict: 'A',
	 // containment: ".container-fluid",
      link: function(scope, element) {
		var position = {};
      	element.bind('mousedown', function($event) {
          //element.css({position: 'fixed'});
        	position.x = element[0].getBoundingClientRect().left;
        	position.y = element[0].getBoundingClientRect().top;
        	position.initialMouseX = $event.clientX;
          	position.initialMouseY = $event.clientY;
			$document.bind('mousemove', mousemove);
        	$document.bind('mouseup', mouseup);
        	return false;
        });

        function mousemove($event) {
          var dx = $event.clientX - position.initialMouseX;
          var dy = $event.clientY - position.initialMouseY;
		//   var data = $sessionStorage.get('patientAccEmail');
		// recordService.getlastvisit(data).then(function(response) {
		// 	console.log('sucess response*****'+response);
		// },function(error) {
		// 	console.log(error);
		// });
		  //console.log('mousemove*****'+element[0].getBoundingClientRect().left + 'px',element[0].getBoundingClientRect().top + 'px')
		  localStorage.setItem("videocall_top", element[0].getBoundingClientRect().top);
		  localStorage.setItem("videocall_left", element[0].getBoundingClientRect().left);
		  element.css({
          	top:  position.y + dy + 'px',
          	left: position.x + dx + 'px'
          });
        	return false;
        }
        function mouseup() {
          $document.unbind('mousemove', mousemove);
         	$document.unbind('mouseup', mouseup);
}
      }
    };
}]);

/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('paymentController',['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','paymentService','authService','toastr',
function($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter, paymentService, authService, toastr) {

    /**
     * Payment Master
     */

    // $scope.show = false;
    $scope.refundAmount = 0;
    $scope.billedAmount = 0;

    $scope.toggleOption = function(data) {
        if(data == "Edit"){
            $scope.show = !$scope.show;
            $scope.disableWalletToggle = false;
        }else if(data == "Cancel"){
            $scope.getPaymentConfiguration();
            $scope.getWalletStatus();
            $scope.disableWalletToggle = true;
        }
    };


    $scope.creates = function(){
        paymentService.createPaymentSetting().then(function(response){
             console.log('create', response);
             $scope.getPaymentConfiguration()
        })
    }

    $scope.getPaymentConfiguration = function() {
        $scope.remainingAmount = 0;
        paymentService.getPaymentSetting().then(function(response) {
            if(response.length <= 0){
                $scope.shows = true;
            }else{
                $scope.shows = false;
                $scope.show = true;
            }
                // if(response[0].status == 1){
                //     $scope.bool = true;
                //     $scope.walletToggle_Value = $scope.bool;
                // }  else {
                //     $scope.bool = false;
                //     $scope.walletToggle_Value = $scope.bool;
                // }
            

            // angular.forEach(response,function(value){
            //     value.doctor_charge==='0.00' ? null : parseFloat(value.doctor_charge);
                
            //     value.creditcard_charges = (value.doctor_charge != 0) ? ((3 / 100) * value.doctor_charge) + 3 : 0;
            //     // value.creditcard_charges = ( ( 3 / 100 ) * value.doctor_charge ) + 3;

            //     value.tax ? value.tax : value.tax = 0;
            //     value.tax ? value.tax_amount = parseFloat( (value.doctor_charge - (value.doctor_charge / (1 + (value.tax/100)))).toFixed(2) ) : value.tax_amount = 0;
            //     // value.tax ? value.tax_amount = ((value.tax / 100 )* value.doctor_charge).toFixed(2) : value.tax_amount = 0;
                
            //     $scope.remainingAmount = value.doctor_charge - ( value.creditcard_charges + value.tax_amount );

            //     value.service_charge ? value.service_charge : value.service_charge = 0;
            //     value.service_charge ? value.service_charge_amount = ((value.service_charge / 100 ) * ( $scope.remainingAmount )).toFixed(2) : value.service_charge_amount = 0;

            //     value.doctor_charge ? value.doctor_share = (100 - value.service_charge) : value.doctor_share = 0;
            //     value.doctor_charge ? value.doctor_share_amount = ((value.doctor_share / 100 ) * ($scope.remainingAmount)).toFixed(2) : value.doctor_share_amount = 0;

            //     // console.log('value 74', value);
            //     // if(value.module == "video_call_conference" && value.doctor_charge < "80.00"){
            //     //     value.doctor_charge = 100;
            //     // }
            //     // value.service_charge_percent = ((100 - value.tax) * (value.service_charge / 100)).toFixed(2);
            //     // value.doctor_charge_percent = (100 - (value.tax + parseFloat(value.service_charge_percent))).toFixed(2);
            // });
            


angular.forEach(response,function(item){
    console.log(item,"$scope.paymentMaster")
    $scope.paymentMaster = response;
})

            $scope.show = false; 
            
        }, function(error){
            toastr.error(error);
            analytics('getPaymentConfiguration',error);
        })
    };

    $scope.getPaymentConfiguration();

    $scope.checkCharge = function (data) {
    
        if(data.module =='video_call_conference' && data.doctor_charge >= 100){
            data.hideError = true;
            data.hideError_conf = true;
        }else if(data.module =='video_call_conference' && data.doctor_charge < 100){
            data.hideError = true;
            data.hideError_conf = false;
        }else if((data.module !='video_call_conference')&&(data.doctor_charge > 4 || data.doctor_charge == 0)){
            data.hideError = true;
        }else{
            data.hideError = false;
        }        

    };

    $scope.updatePaymentConfiguration = function() {
        $scope.disableWalletToggle = true;
        //$scope.addWalletStatus();

        angular.forEach($scope.paymentMaster,function(value){
            if((value.module != 'video_call_conference' && value.doctor_charge < 5)){
                value.doctor_charge = 0 ;
            }else if((value.module == 'video_call_conference' && value.doctor_charge < 100)){
                value.doctor_charge = 100 ;
            }
        });
        

        var data = { 
            account_email: authService.authentication.account_id,
            doctor_id:authService.authentication.doctor_id,
            data:$scope.paymentMaster
        }
        paymentService.updatePaymentSetting(data).then(function (response) {
            $scope.getPaymentConfiguration();
            toastr.success('Updated successfully');
            $scope.getWalletStatus();
            $scope.paymentMaster = response;
            $scope.show = false;
        }, function(error) {
            toastr.error(error);
            analytics('updatePaymentConfiguration',error);
        })
    };

    $scope.walletToggleValue = false;
    $scope.getWalletStatus = function() {
        paymentService.getDoctorWallet().then(function(response) {
            // console.log( response );
            if(response.success==1){
                // console.log(response.force_wallet);
                $scope.walletToggleValue = response.force_wallet;
            }
        }, function(error){
        });
    }

    $scope.addWalletStatus = function() {      
        var payload = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id,
            force_wallet: $scope.walletToggleValue 
        }
        
        paymentService.addDoctorWalletStatus(payload).then(function(response) {
            console.log( response );
        }, function(error){
        });
    }

    $scope.addWallet_Status = function() {      
        var payload = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id,
            service : $scope.service
        }
        
        paymentService.updatemodulestatus(payload).then(function(response) {
            console.log( response );
        }, function(error){
        });
    }
    $scope.getWalletStatus();
   // $scope.addWalletStatus();


    $scope.chatWallet_Setting = function(value,index) {
        // console.log(index,value,'index');
        // if($scope.paymentMaster[index].status == 1){
        //     alert()
        //     $scope.bool = true;
        // }  else {
        //     $scope.bool = false
        // }
        // console.log('hello',$scope.bool);
        //     $scope.walletToggle_Value = $scope.bool;
            $scope.service = $scope.paymentMaster[index].module;
            // console.log($scope.service);
            $scope.addWallet_Status()
        }

    $scope.chatWalletSetting = function(value) {  
        $scope.walletToggleValue = value;
        $scope.addWalletStatus()
    }
    $scope.disableWalletToggle = true;

     /**
      * End
      */

/*
      function createChart(data){
      
          var pieArray =[
          
            {
                "label": "Chat",
                "value": data.chat,
                "color": "#2484c1"
            },
            {
                "label": "Consultation",
                "value": data.consultation,
                "color": "#0c6197"
            },
            {
				"label": "Appointment",
				"value":  data.appointment,
				"color": "#daca61"
			},
			{
				"label": "Emergency voice call",
				"value":  data.emergency_voice_call,
				"color": "#e4a14b"
			},
			{
				"label": "Voice call",
				"value":  data.voice_call,
				"color": "#e98125"
			},
		/*	{
				"label": "Total refund",
				"value":  data.total_refunded,
				"color": "#cb2121"
            },*/
/*            {
                "label": "Total fee",
                "value": data.total_paid,
                "color": "#4daa4b"
            }, */
           /* {
                "label": "Total pending",
                "value": data.total_pending,
                "color": "#90c469"
            },*/
/*      ];
       pieChart(pieArray);
    }

    var pie;
    function pieChart(data){
        var chartArray = data;

        if(pie!=null){
            $('#pieChart').remove();
            var elem = document.createElement('div');	 
	     	elem.setAttribute("id", "pieChart");

            var cont = document.getElementById("pieChartContainer");
            cont.appendChild(elem);
        }
        
         pie = new d3pie("pieChart", {
               "header": {
                "title": {
                    "text": "Total fee collected:",//+chartArray[5].value,
                    "fontSize": 18,
                    "font": "open sans",
                     "x":"200",
                     "y":"10",

                },
            
               },
           /*  "subtitle": {
                    "text": "A full pie chart to show off label collision detection and resolution.",
                    "color": "#999999",
                    "fontSize": 12,
                    "font": "open sans"
                },
                
            },
            "footer": {
                "color": "#999999",
                "fontSize": 10,
                "font": "open sans",
                "location": "bottom-left"
            },*/
/*          "size": {
                "canvasHeight": 500,
                "canvasWidth": 590,
                "pieOuterRadius": "90%"
            },
            "data": {
                "sortOrder": "value-desc",
                "content": chartArray
            },
            "labels": {
                "outer": {
                    "pieDistance": 32
                },
                "inner": {
                    "format":"value",
                    "hideWhenLessThanPercentage": 3
                },
                "mainLabel": {
                    "font": "open sans",
                    "fontSize": 18
                },
                "percentage": {
                    "color": "#ffffff",
                    "decimalPlaces": 0
                },
                "value": {
                    "color": "#adadad",
                    "fontSize": 14
                },
                "lines": {
                    "enabled": true
                },
                "truncation": {
                    "enabled": true
                }
            },
            "tooltips": {
                "enabled": true,
                "type": "placeholder",
                "string": "{label}: {value}"
            },
            "effects": {
                "pullOutSegmentOnClick": {
                    "effect": "linear",
                    "speed": 400,
                    "size": 8
                }
            },
            "misc": {
                "gradient": {
                    "enabled": true,
                    "percentage": 100
                }
            }
        });
} */
    
  /*
   * Start of Payment History
  */
 
   // vm.po = { totalPatients:0, size:20, curruntPage:1, maxSize:5}
    $scope.dt = new Date()
    $scope.reportBy = {
        'By Range':'By Range'
    };
    $scope.initHistory = function(){
        $scope.ExportType = "EXCEL";
        $scope.selectedReportType = "Today";
        var date = new Date();
        $scope.fromDate = date;
        $scope.toDate = date;
        $scope.selectChoice();
    }    
    $rootScope.rangePicker1= {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
      }
    };
    $rootScope.rangePicker2 = {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        minDate: new Date()
      }
    };

    $scope.selectChoice = function(){
        $scope.selectByRange = false;
        switch($scope.selectedReportType){
           /* case "Today":
                $scope.date = new Date();
                var data = '';
                data = '&date=' + $filter('date')($scope.date, "d");
                data = data+'&month=' + $filter('date')($scope.date, "M");
                data = data+'&year=' + $filter('date')($scope.date, "yyyy");
                $scope.getHistory(data);
                $scope.date = $filter('date')($scope.date, "dd-MMM-yyyy");
                break;

            case "Yesterday":
                $scope.date = new Date();
                $scope.date.setDate($scope.date.getDate() - 1);
                var data = '';
                data = '&date=' + $filter('date')($scope.date, "d");
                data = data+'&month=' + $filter('date')($scope.date, "M");
                data = data+'&year=' + $filter('date')($scope.date, "yyyy");
                $scope.getHistory(data);
                $scope.date = $filter('date')($scope.date, "dd-MMM-yyyy");
                break;

            case "This Week":
                var curr = new Date;
                var first = curr.getDate() - curr.getDay();
                first = first + 0;
                var last = first + 6;
                var sunday = new Date(curr.setDate(first));
                var saturday = new Date(curr.setDate(last));
                var data = '';
                data = '&date_from=' + $filter('date')(sunday, "yyyy-MM-dd");
                data = data+'&date_to=' + $filter('date')(saturday, "yyyy-MM-dd");
                $scope.getHistory(data);
                $scope.date = $filter('date')(sunday, "dd-MMM-yyyy") + ' To ' + $filter('date')(saturday, "dd-MMM-yyyy");
                break;

            case "Last Week":
                var curr = new Date;
                var first = curr.getDate() - curr.getDay();
                first = first + 0;
                var saturday = new Date(curr.setDate(first));
                saturday.setDate(saturday.getDate() - 1);
                var first1 = saturday.getDate() - saturday.getDay();
                first1 = first1 + 0;
                var last1 = first1 + 6;
                var sunday1 = new Date(curr.setDate(first1));
                var saturday1 = new Date(curr.setDate(last1));
                var data = '';
                data = '&date_from=' + $filter('date')(sunday1, "yyyy-MM-dd");
                data = data+'&date_to=' + $filter('date')(saturday1, "yyyy-MM-dd");
                $scope.getHistory(data);
                $scope.date = $filter('date')(sunday1, "dd-MMM-yyyy") + ' To ' + $filter('date')(saturday1, "dd-MMM-yyyy");
                break;

            case "This Month":
                $scope.date = new Date();
                var data = '';
                data = data+'&month=' + $filter('date')($scope.date, "M");
                data = data+'&year=' + $filter('date')($scope.date, "yyyy");
                $scope.getHistory(data);
                $scope.date = $filter('date')($scope.date, "MMM-yyyy");
                break;

            case "Last Month":
                $scope.date = new Date();
                $scope.date.setMonth($scope.date.getMonth() - 1);
                var data = '';
                data = data+'&month=' + $filter('date')($scope.date, "M");
                data = data+'&year=' + $filter('date')($scope.date, "yyyy");
                $scope.getHistory(data);
                $scope.date = $filter('date')($scope.date, "MMM-yyyy");
                break;

            case "This Year":
                $scope.date = new Date();
                var data = '';
                data = data+'&year=' + $filter('date')($scope.date, "yyyy");
                $scope.getHistory(data);
                $scope.date = $filter('date')($scope.date, "yyyy");
                break;

            case "Last Year":
                $scope.date = new Date();
                $scope.date = $scope.date.getFullYear() - 1;
                var data = '';
                data = data+'&year=' + $scope.date;
                $scope.getHistory(data);
                break;*/
                
            case "By Range":
            $scope.selectByRange = true;
            var data = '';
            data = '&date_from=' + $filter('date')($scope.fromDate, "yyyy-MM-dd");
            data = data+'&date_to=' + $filter('date')($scope.toDate, "yyyy-MM-dd");
            $scope.getHistory(data);
            break;
            
        }
    }
    
    $scope.byRange = function(date){
      /*var data = '';
        $rootScope.rangePicker1.dateOptions = date;
        data = '&date=' + $filter('date')(from, "yyyy-MM-dd");
        $scope.getHistory(data);*/
        $scope.date = date;
        var data = '';
        data = $filter('date')($scope.date, "yyyy");
        data = data+'-'+$filter('date')($scope.date, "M");
        data = data+'-'+$filter('date')($scope.date, "d");
        $scope.getHistory(data);
        $scope.date = $filter('date')($scope.date, "dd-MMM-yyyy");
    }

   // UTC to local time conversion
   $scope.convertUTCDateToLocalDate = function(date) {
	var newDate = new Date(date);
	var offset  = date.getTimezoneOffset();
	var minutes = date.getMinutes();
	newDate.setMinutes(minutes - offset);
	return newDate;   
   };

    $scope.getHistory = function(data){
     
        $scope.refundAmount = 0;
        $scope.billedAmount = 0;
        $scope.paymentHistory = [];
        $scope.paymentHistoryBanner = [];
        var param = data;
       
        paymentService.DailyCollection(param).then(function(response) {
                       
          $scope.paymentHistory1 = response;                          
           
            if(response.result.length > 0) {                
                angular.forEach(response.result,function(value) {
                    if(value.fee_pending >= 0) {
                        var date = $scope.convertUTCDateToLocalDate(new Date(value.bill_date));
                        value.bill_date = new Date(date);

                        if(value.status === "refund") {
                            $scope.refundAmount = $scope.refundAmount + value.bill_amount;
                        } else if(value.status === "paid" || value.status === "pending"){
                            $scope.billedAmount = $scope.billedAmount + value.bill_amount;
                        }
                        $scope.paymentHistory.push(value);
                    }
                });
            }
   
         // createChart(response.consolidated[0]);
            
        }, function(error) {
            toastr.error(error);
            analytics('getHistory',error);
        })
    };


    $scope.printPaymentToPaper = function(id) {
        var innerContents = document.getElementById('printtable').innerHTML;
        var popupWinindow = window.open('', '_blank',
        'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
        popupWinindow.document.close();
        
    };

    $scope.exportData = function (type) {

        $scope.date = new Date();
        $scope.formattedDate =   $filter('date')(new Date(), "dd-MMM-yyyy");
        var filename = "PaymentReport" + $scope.formattedDate;
    
        if(type == 'CSV') {
            alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#exportable',{headers:true})");
        } else if(type == 'EXCEL') {
         // alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
            var blob = new Blob([document.getElementById('printtable').innerHTML], {
                type: "application/vnd.ms-excel;charset=utf-8"
            })
            saveAs(blob, "DailyCollectionReport.xls");
        } else if(type == 'PDF'){
                html2canvas(document.getElementById('exportable'), {
                    onrendered: function (canvas) {
                        var data = canvas.toDataURL();
                        var docDefinition = {
                            content: [{
                                image: data,
                                width: 500,
                            }]
                        };
                        pdfMake.createPdf(docDefinition).download("" + filename + ".pdf");
                    }
                });
        }
    };
    /**
     * End of Payment History
     */


    /**
     * Start of Category Master
     */

    $scope.getPayCategoryListMtd = function(){
        $rootScope.payCategoryList = [];
        paymentService.getPayCategoryList().then(function(response){
            $rootScope.payCategoryList = response;    
        }, function(error) {
            toastr.error(error);
            analytics('getPayCategoryListMtd',error);
        })
    }

    $scope.getPayCategoryListMtd();

    $scope.addNewCategoryPopup= function(){
        $rootScope.actionKind = 'add';
        var options = {
            title: '<b>Add Category</b>',
            message:'',
            templateUrl: 'views/payment/addorupdateCategory.htm',
            size:'medium',
            onEscape: function() {$scope.$apply();},
            buttons: {
            }
        }
        $ngBootbox.customDialog(options);    
    };    

    $rootScope.addNewCategory = function(){
        var cat_data = {
            account_email: authService.authentication.account_id,
            categories :[{category_name:$rootScope.categoryMaster.category}]
        };
        paymentService.addNewPayCategory(cat_data).then(function(response) {
            $ngBootbox.hideAll();
            $scope.getPayCategoryListMtd();
            toastr.success('Category added successfully');
        }, function(error) {
            toastr.error(error);
            analytics('addNewCategory',error);
        })
    }

    $scope.updateCategoryPopup = function(data) {
        $rootScope.actionKind = 'edit';
        $rootScope.categoryMaster = data;
        var options = {
            title: 'Update Category',
            message:'',
            templateUrl: 'views/payment/addorupdateCategory.htm',
            size:'medium', 
            onEscape: function() {$scope.$apply();},
            buttons: {
            }
        };
        $ngBootbox.customDialog(options);
    };

    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'paymentController',
            'event_label' : aLabel
            });
     }

    $rootScope.updateCategory = function() {
        var data = {
            account_email: authService.authentication.account_id,
            type: "edit",
            category:{
                id: $rootScope.categoryMaster.id,
                category_name: $rootScope.categoryMaster.category
            }
        };

        paymentService.updatePayCategory(data).then(function(response) {
            $ngBootbox.hideAll();
            $scope.getPayCategoryListMtd();
            toastr.success('Updated Successfully');
        },function(error) {
            toastr.error(error);
            analytics('updateCategory',error);
        })
    }

    $rootScope.closePopup = function(){
        $rootScope.categoryMaster = "";
        $ngBootbox.hideAll();
        $scope.$apply();
    }

    /**
     * End of Category Master
     */
}]);

/*
 * Range Collection Report
 */

'use strict'
angular.module('AngularApp').controller('rangeController',['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','paymentService','authService','toastr',
function($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter, paymentService, authService, toastr) {

    $scope.show = false;
    $scope.refundAmount = 0;
    $scope.billedAmount = 0;

    $scope.toggleOption = function(data) {
        if(data == "Edit"){
            $scope.show = !$scope.show;
        }else if(data == "Cancel"){
            $scope.getPaymentConfiguration();
        }
    };

    $scope.getPaymentConfiguration = function() {
        $scope.remainingAmount = 0;
        paymentService.getPaymentSetting().then(function(response) {
            angular.forEach(response,function(value){
                value.doctor_charge==='0.00' ? null : parseFloat(value.doctor_charge);
                
                value.creditcard_charges = (value.doctor_charge != 0) ? ((3 / 100) * value.doctor_charge) + 3 : 0;
             // value.creditcard_charges = ( ( 3 / 100 ) * value.doctor_charge ) + 3;

                value.tax ? value.tax : value.tax = 0;
                value.tax ? value.tax_amount = parseFloat( (value.doctor_charge - (value.doctor_charge / (1 + (value.tax/100)))).toFixed(2) ) : value.tax_amount = 0;
             // value.tax ? value.tax_amount = ((value.tax / 100 )* value.doctor_charge).toFixed(2) : value.tax_amount = 0;
                
                $scope.remainingAmount = value.doctor_charge - ( value.creditcard_charges + value.tax_amount );

                value.service_charge ? value.service_charge : value.service_charge = 0;
                value.service_charge ? value.service_charge_amount = ((value.service_charge / 100 ) * ( $scope.remainingAmount )).toFixed(2) : value.service_charge_amount = 0;

                value.doctor_charge ? value.doctor_share = (100 - value.service_charge) : value.doctor_share = 0;
                value.doctor_charge ? value.doctor_share_amount = ((value.doctor_share / 100 ) * ($scope.remainingAmount)).toFixed(2) : value.doctor_share_amount = 0;
                // value.service_charge_percent = ((100 - value.tax) * (value.service_charge / 100)).toFixed(2);
                // value.doctor_charge_percent = (100 - (value.tax + parseFloat(value.service_charge_percent))).toFixed(2);
            });
            $scope.paymentMaster = response;
            $scope.show = false;
        }, function(error){
            toastr.error(error);
            analytics('getPaymentConfiguration',error);
        })
    };

    $scope.getPaymentConfiguration();

   
    $scope.updatePaymentConfiguration = function() {
        angular.forEach($scope.paymentMaster,function(value){
            if(value.doctor_charge < 5){
                value.doctor_charge = 0 ;
            }
        });
        
        var data = { account_email: authService.authentication.account_id,
            data:$scope.paymentMaster
        }
        paymentService.updatePaymentSetting(data).then(function (response) {
            $scope.getPaymentConfiguration();
            toastr.success('Updated successfully');
            $scope.paymentMaster = response;
            $scope.show = false;
        }, function(error) {
            toastr.error(error);
            analytics('updatePaymentConfiguration',error);
        })
    };

     /**
      * End
      */
    
    /**
     * Start of Payment History
     */
   // vm.po = { totalPatients:0, size:20, curruntPage:1, maxSize:5}
    $scope.dt = new Date()
    $scope.reportBy = {
        'By Range':'By Range'
    };
    $scope.initHistory = function(){
        $scope.ExportType = "EXCEL";
        $scope.selectedReportType = "byRange";
        var date = new Date();
        $scope.fromDate = '';
        $scope.toDate = '';
      
    }    
    $rootScope.rangePicker1= {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
      }
    };
    $rootScope.rangePicker2= {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        
      }
    };
   
    $scope.byRange = function(from,to){
        if(from && to) {
           var data = '&date_from=' + $filter('date')(from, "yyyy-MM-dd")+'&date_to=' + $filter('date')(to, "yyyy-MM-dd");
           $scope.getHistory1(data);
        }
    }

   // UTC to local time conversion
   $scope.convertUTCDateToLocalDate = function(date) {
	var newDate = new Date(date);
	var offset  = date.getTimezoneOffset();
	var minutes = date.getMinutes();
	newDate.setMinutes(minutes - offset);
	return newDate;   
   };

    $scope.getHistory1= function(data){
     
        $scope.refundAmount = 0;
        $scope.billedAmount = 0;
        $scope.paymentHistory = [];
        $scope.paymentHistoryBanner = [];
        var param = data;
       
        paymentService.rangeCollection(param).then(function(response) {                    
          $scope.paymentHistory1 = response;                                  
            if(response.result.length > 0) {                
                angular.forEach(response.result,function(value) {
                    if(value.fee_pending >= 0) {
                        var date = $scope.convertUTCDateToLocalDate(new Date(value.bill_date));
                        value.bill_date = new Date(date);

                        if(value.status === "refund") {
                            $scope.refundAmount = $scope.refundAmount + value.bill_amount;
                        } else if(value.status === "paid" || value.status === "pending"){
                            $scope.billedAmount = $scope.billedAmount + value.bill_amount;
                        }
                        $scope.paymentHistory.push(value);
                    }
                });
            }
            
        }, function(error) {
            toastr.error(error);
            analytics('getHistory1',error);
        })
    };


    $scope.printPaymentToPaper = function(id) {
        var innerContents = document.getElementById('printtable').innerHTML;
        var popupWinindow = window.open('', '_blank',
        'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
        popupWinindow.document.close();
        
    };

    $scope.exportData = function (type) {

        $scope.date = new Date();
        $scope.formattedDate =   $filter('date')(new Date(), "dd-MMM-yyyy");
        var filename = "PaymentReport" + $scope.formattedDate;
    
        if(type == 'CSV') {
            alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#exportable',{headers:true})");
        } else if(type == 'EXCEL') {
         // alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
            var blob = new Blob([document.getElementById('printtable').innerHTML], {
                type: "application/vnd.ms-excel;charset=utf-8"
            })
            saveAs(blob, "DailyCollectionReport.xls");
        }

        else if(type == 'PDF'){
                html2canvas(document.getElementById('exportable'), {
                    onrendered: function (canvas) {
                        var data = canvas.toDataURL();
                        var docDefinition = {
                            content: [{
                                image: data,
                                width: 500,
                            }]
                        };
                        pdfMake.createPdf(docDefinition).download("" + filename + ".pdf");
                    }
                });
        }
    };
    /**
     * End of Payment History
     */


    /**
     * Start of Category Master
     */
  
    $scope.addNewCategoryPopup= function(){
        $rootScope.actionKind = 'add';
        var options = {
            title: '<b>Add Category</b>',
            message:'',
            templateUrl: 'views/payment/addorupdateCategory.htm',
            size:'medium',
            onEscape: function() {$scope.$apply();},
            buttons: {
            }
        }
        $ngBootbox.customDialog(options);    
    };    

    $rootScope.addNewCategory = function(){
        var cat_data = {
            account_email: authService.authentication.account_id,
            categories :[{category_name:$rootScope.categoryMaster.category}]
        };
        paymentService.addNewPayCategory(cat_data).then(function(response) {
            $ngBootbox.hideAll();
            $scope.getPayCategoryListMtd();
            toastr.success('Category added successfully');
        }, function(error) {
            toastr.error(error);
            analytics('addNewCategory',error);
        })
    }

    $scope.updateCategoryPopup = function(data) {
        $rootScope.actionKind = 'edit';
        $rootScope.categoryMaster = data;
        var options = {
            title: 'Update Category',
            message:'',
            templateUrl: 'views/payment/addorupdateCategory.htm',
            size:'medium', 
            onEscape: function() {$scope.$apply();},
            buttons: {
            }
        };
        $ngBootbox.customDialog(options);
    };

    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-XGBKLLH8JX');
        gtag('event', aEvent, {
            'event_category' : 'paymentsController',
            'event_label' : aLabel
            });
     }

    $rootScope.updateCategory = function() {
        var data = {
            account_email: authService.authentication.account_id,
            type: "edit",
            category:{
                id: $rootScope.categoryMaster.id,
                category_name: $rootScope.categoryMaster.category
            }
        };

        paymentService.updatePayCategory(data).then(function(response) {
            $ngBootbox.hideAll();
            $scope.getPayCategoryListMtd();
            toastr.success('Updated Successfully');
        },function(error) {
            toastr.error(error);
            analytics('updateCategory',error);
        })
    }

    $rootScope.closePopup = function(){
        $rootScope.categoryMaster = "";
        $ngBootbox.hideAll();
        $scope.$apply();
    }

    /**
     * End of Category Master
     */
}]);


/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('payoutController', ['$scope', '$rootScope', 'authService', 'toastr', 'payoutService', '$sessionStorage', 'BudsStore',
    function ($scope, $rootScope, authService, toastr, payoutService, $sessionStorage, BudsStore) {

        $scope.drbankdetails = function () {
            payoutService.getdrBankdetails().then(function (response) {
                if (response.status == 1) {
                    $scope.bankDetails = response.data[0]
                } else if (response.status == 0) {
                    toastr.error("Unable to fetch details")
                }
            })
        }
        $scope.drbankdetails();

        $scope.drwalletamount = function () {
            payoutService.getdrwallet().then(function (response) {
                if (response.status == 1) {
                    if (response.data.wallet_balance.length>0) {
                        $scope.walletdetails = response.data.wallet_balance[0].wallet_balance
                    } else {
                        $scope.walletdetails = "0"
                    }
                } else if (response.status == 0) {
                    toastr.error("Unable to fetch details")
                }
            })
        }
        $scope.drwalletamount();

        $scope.withdrawalfreq = function () {
            payoutService.getwithdrawalfreq().then(function (response) {
                if (response.status == 1) {
                    if (response.data.length > 0) {
                        $scope.showtimefreq = response.data[0].time
                        $scope.showdayfreq = response.data[0].frequency
                        $scope.emailaddress = response.data[0].email
                        if (response.data[0].notify == 1) {
                            $scope.notifymail = true
                        } else if (response.data[0].notify == "0") {
                            $scope.notifymail = false
                        }
                    } else {
                        $scope.notifymail = false
                    }
                } else if (response.status == 0) {
                    toastr.error("Unable to fetch details")
                }
            })
        }
        $scope.withdrawalfreq();

        $scope.togglenotify = function () {
            $scope.notifymail = !$scope.notifymail
        }

        $scope.setwithdrawalFreq = function () {
            if ($scope.notifymail == true) {
                $scope.setnotify = 1
            } else if ($scope.notifymail == false) {
                $scope.setnotify = 0
            }
            var data =
            {
                frequency: $scope.showdayfreq,
                time: $scope.showtimefreq,
                email: $scope.emailaddress,
                doctor_email: authService.authentication.account_id,
                doctor_id: authService.authentication.doctor_id,
                account_email: authService.authentication.account_id,
                notify: $scope.setnotify
            }
            payoutService.createwithdrawalFreq(data).then(function (response) {
                if (response.status == 1) {
                    toastr.success("Saved successfully")
                    $scope.withdrawalfreq();
                } else {
                    toastr.error("Unable to save data")
                }
            })

        }

        var hrs = [], i, j;
        for (i = 0; i < 24; i++) {
            for (j = 0; j < 2; j++) {
                //hrs.push((i<10? "0"+i : i)+(i===0? 12:"")+ ":" + (j===0 ? "00" : 30*j)+(i>=12? "PM":"AM"));
                hrs.push((i < 10 ? '0' + i : i) + ":" + (j === 0 ? "00" : 30 * j) + ":00");
            }
        }
        for (j = 0; j < 1; j++) {
            hrs.push("23:59:00");
        }

        $scope.timeFreq = hrs
    }])
'use strict';

angular.module('AngularApp').controller('phcalltrackReportController', ['$scope', '$location', '$rootScope', 'toastr', 'authService', 'incentiveService','$ngBootbox', 'multicenterstudyreportService', '$filter', function ($scope, $location, $rootScope, toastr, authService, incentiveService, $ngBootbox, multicenterstudyreportService,$filter) {

    
    $scope.timeInputDisable = true;
    $scope.selected_day = "1";
    $scope.fromDate = new Date();
    $scope.toDate = new Date();
    $scope.today_dt = new Date();
    $scope.exportType = "";

    var datArr  = getStringDate($scope.fromDate);
    var datArr2 = getStringDate($scope.toDate)
    $scope.selectedFromDate  = datArr[1];
    $scope.selectedFromDate2 = datArr[0];
    $scope.selectedToDate  = datArr2[1];
    $scope.selectedToDate2 = datArr2[0];


    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        }
    };

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }


    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.labelHide = true
    $( "#piechat_container" ).hide();
    $scope.gettelephonefollow = function() {
        var data = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id,
            from_date: $scope.selectedFromDate2,
            to_date: $scope.selectedToDate2,
            followup_description : "PH_CALL TRACK"

        }
        multicenterstudyreportService.gettelephonefollowbydateReport(data).then(function(response) {
        //   if(response.data.dead_after_discharge.length > 0 || response.data.dead_during_discharge.length > 0){
        //     $scope.labelHide = false
        //     $scope.deadvsTimeAfterdelivery = response;
        //     console.log($scope.deadvsTimeAfterdelivery);
        //   } else {
        //     $scope.labelHide = true
        //     $scope.errMsg = 'Data is not available on this period'
        //   }
        $scope.telephonefollowResponse = []
        console.log('response::',response);
        if(response.success == 1){
            if(response.data.length>0){
                $scope.labelHide = false
                $scope.telephonefollowResponse = response.data
                console.log($scope.telephonefollowResponse);
                homevisitPieChartData(response.baby_status); 
            }else{
                $scope.labelHide = true
                $scope.errMsg = 'Data is not available on this period'
            }

        }else{
            $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
            $( "#piechat_container" ).hide();

        }
            
        },function(error) {
            if(error){
              toastr.error('Select from & to date')
            }
            // toastr.error(error);
            analytics('getDeadvsTimeAfterdeliveryStatus',error);
        })
    };


    function homevisitPieChartData(data) {

        console.log('data::',data);
            
        var tempArray = [
            {
            name: 'Alive',
            y: data.count_alive,
            /*sliced: true,
            selected: true*/
            color: 'lightblue'
            },
            {
            name: 'Expired',
            y: data.count_expired, 
            color: 'pink'
            }
        ];
            
        $scope.showPieChart(tempArray);    
    }

    $scope.showPieChart = function(data) {
    
        $('#pie_container1').highcharts({
        //Highcharts.chart('container', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                borderColor: "black",
                borderRadius:0,
                borderWidth:"0"
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'PH_CALL Track Report', 
                style: {
                  fontSize: '22px' 
                }
               
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '{point.percentage:.1f} %'
                    },
                    showInLegend: true
                }
            },
            series: [{
            //name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    
        $( "#piechat_container" ).show();
    }

    $scope.exportData = function(type) {

        if($scope.telephonefollowResponse) {
   
            $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
            var filename = "Phcall_Track_Report_"+$scope.formattedDate;
            
            if($scope.selectedFromDate && $scope.selectedToDate){
                filename = "Phcall_Track_Report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
            }
            
           /* if(type=='csv') {
  
                alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
                
            } else*/
            if(type == 'excel') {
  
                //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                    var blob = new Blob([document.getElementById('printtable2').innerHTML], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    });
                 saveAs(blob, filename+".xls");
  
            } else if(type=='pdf') {
  
                var pdf_element = document.getElementById('printtable');
                var opt = {
                    margin:      0,
                    filename:   filename,
                    image:       { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
                };
                    
                //New Promise-based usage:
                html2pdf().set(opt).from(pdf_element).save();
                    
            }
        }
    }

}])
'use strict'
angular.module('AngularApp').controller('printoutController', ['$scope', '$rootScope', 'authService', 'toastr', '$sessionStorage', '$sce', 'Pubnub', '$pubnubChannel', '$location', 'localStorageService', 'mainUrl', '$interval', 'printoutService',
    function ($scope, $rootScope, authService, toastr, $sessionStorage, $sce, Pubnub, $pubnubChannel, $location, localStorageService, mainUrl, $interval, printoutService) {

        $scope.showedit = true
        $scope.disableinput = true;

        $scope.enableinput = function (data) {
            if (data == "Edit") {
                $scope.showedit = !$scope.showedit;
                $scope.disableinput = false;
                $scope.default_template_detail = ""
            } else if (data == "Cancel") {
                $scope.getDefaultTemplate()
                $scope.showedit = true
                $scope.disableinput = true;
            }
        };

        $scope.postDefaultTemplate = function () {
            $scope.showedit = true
            $scope.disableinput = true;
            var params = {
                "account_email": authService.authentication.account_id,
                "doctor_id": authService.authentication.doctor_id,
                "template_name": $scope.default_template.template_name,
                "template_id": $scope.default_template.template_id
            }
            printoutService.createPrintoutTemplate(params).then(function (response) {
                toastr.success("Saved successfully")
                $scope.getTemplateDetails()
            }
            )
        }

        $scope.getTemplateDetails = function () {
            printoutService.getPrintoutTemplate().then(function (response) {
                $scope.default_template = response.data
                $scope.default_template_detail = response.data[0].template_name
            }
            )
        }

        $scope.getDefaultTemplate = function () {
            printoutService.defaultTemplate().then(function (response) {
                $scope.default_template_arr = response.data
                $scope.getTemplateDetails()
            }
            )
        }

        $scope.getDefaultTemplate()
    }])
'use strict';
angular.module('AngularApp').controller('profileController', ['$scope', '$rootScope', '$location', '$route', 'profileService', 'multipartFormdata', '$ngBootbox', '$uibModal', '$filter', 'localStorageService', 'toastr', 'authService', '$sessionStorage', '$timeout',
    function ($scope, $rootScope, $location, $route, profileService, multipartFormdata, $ngBootbox, $uibModal, $filter, localStorageService, toastr, authService, $sessionStorage, $timeout) {
        authService.loadHelyxonApiUrl();
        $scope.imageUploadUrl = authService.helyxonApi.url + 'cloud/image/upload/';

        $scope.createProfile = false;
        $scope.doctorImage = undefined;
        $scope.doctorCropImage = "";
        $scope.crop = false;
        $scope.doctorCoverImage = "";
        $scope.showcrop = false

        /*"doctors": {
            "success": 1,
            "profile": {
                "name": "Mahesh",
                "fullname": "Dr.Mahesh Janagan",
                "display_name": "Dr.Mahesh J",
                "role": "1",
                "contact_number_1": "9543225581",
                "avatar": "img_mahesh.jpg",
                "cover_art": "img_cover_new.jpg",
                "hospital_name": "Massachusetts General Hospital",
                "email": null,
                "contact_number_2": "1234567890",
                "speciality": "Pediatric",
                "degree": "MBBS",
                "registration": "",
                "address": "",
                "city": "",
                "state": "Massachusetts",
                "pin_code": "2114",
                "biography": "Dr. Mahesh was an American physician at the center of one of the most sensationalized court cases in modern American history.",
                "vision": "To enable sustainable social impact at scale",
                "mission": "",
                "summary": "",
                "account": ""*/

        $scope.loadProfile = function () {
            $scope.newImageMtd = undefined;
            profileService.getProfile().then(function (response) {

                $scope.showForm = false;
                if (response != "") {
                    $scope.profile = response.doctors.profile;
                    if ($scope.profile.avatar.startsWith("img_")) {
                        $scope.doctorImage = $scope.imageUploadUrl + $scope.profile.avatar;
                        $scope.doctorImagetemp = $scope.imageUploadUrl + $scope.profile.avatar;
                        console.log($scope.doctorImage, "$scope.doctorImage")
                        var xhr = new XMLHttpRequest();
                        xhr.onload = function () {
                            var reader = new FileReader();
                            reader.onloadend = function () {
                                callback(reader.result);
                            }
                            console.log(reader.readAsDataURL(xhr.response))
                        };
                        xhr.open('GET', $scope.doctorImage);
                        xhr.responseType = 'blob';
                        xhr.send();
                    }
                    if ($scope.profile.cover_art.startsWith("img_")) {
                        $scope.doctorCoverImage = $scope.imageUploadUrl + $scope.profile.cover_art;
                    }
                } else {
                    $scope.createProfile = true;
                }
            }, function (err) {
                toastr.error(err);
                analytics('loadProfile', err);
            })
        };
        $scope.loadProfile();

        $scope.handleFileSelect = function (file) {
            $scope.showcrop = true
            $scope.uploadFileImage = null;
            if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {
                console.log(file, "aaa")
                console.log(file.file, "ejjbfeb")

                $scope.uploadFileImage = file.file;
                console.log($scope.uploadFileImage, "$scope.doctorCropImage$scope.doctorCropImage")
                var file = file.file;
                var reader = new FileReader();
                reader.onload = function (evt) {
                    console.log(evt)
                    $scope.$apply(function ($scope) {

                        $scope.doctorImage = evt.target.result;
                        console.log($scope.doctorImage, "eje")
                        multipartFormdata.uploadFileToUrl(authService.helyxonApi.url, $scope.uploadFileImage).then(function (response) {
                            $scope.saveProfile.avatar = response.image[0].filename;
                            // $scope.doctorImage = response.image[0].filename;
                        })
                        //     $scope.doctorCropImage = $scope.saveProfile.avatar;
                        //    $scope.crop = true;
                    });
                };
                reader.readAsDataURL(file);

            } else {
                alert("Upload only Images");
            }
        }

        $scope.croppedprofileimage = function (data) {
            console.log(data, "data")
            $scope.uploadFileImage = null;
            var contentype = "image/jpeg"
            var byteString = data.split(',')[1];
            console.log(contentype)
            var blobtemp = b64toBlob(byteString, contentype);
            console.log(blobtemp, "1")

            multipartFormdata.uploadFileToUrl(authService.helyxonApi.url, blobtemp).then(function (response) {

                $scope.saveProfile.avatar = response.image[0].filename;
                // $scope.doctorImage = response.image[0].filename;
            })
            //     $scope.doctorCropImage = $scope.saveProfile.avatar;
            $scope.crop = true;
        }

        // var cropfunction = function(){
        //     alert()
        // }


        // $timeout(function() { angular.element(document.querySelector('#fileInput')).on('click', cropfunction); },1000, false);

        $scope.uploadCoverImage = function (file) {

            if ({ png: 1, gif: 1, jpg: 1, jpeg: 1 }[file.getExtension()]) {

                $scope.uploadDocCoverImage = file.file;
                var file = file.file;
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.doctorCoverImage = evt.target.result;
                        console.log($scope.uploadDocCoverImage, "uploadDocCoverImage")
                        multipartFormdata.uploadFileToUrl(authService.helyxonApi.url, $scope.uploadDocCoverImage).then(function (response) {
                            $scope.saveProfile.cover_art = response.image[0].filename;
                        })
                    });
                };
                reader.readAsDataURL(file);

            } else {
                alert("Upload only Images");
            }
        }

        //angular.element(document.querySelector('#fileInput')).on('change',handleFileSelect);
        var saveType;
        $scope.create = function (data) {
            saveType = data;
            $scope.showForm = true;
            $scope.saveProfile = $scope.profile ? $scope.profile : {};
        };

        $scope.saveProfile = {};

        $scope.cancel = function () {
            $scope.saveProfile = {};
            $scope.showForm = false;
        };

        $scope.submit = function () {
            /* Dr Profile Photo 
               if($scope.snapshotData!=null){
                 $scope.saveProfile.image = $scope.snapshotData;
               } */

            if ($scope.crop == true || $scope.uploadFileImage != null) {
                console.log($scope.uploadFileImage, "$scope.uploadFileImage")

                $scope.uploadFileImage = null;
                $scope.crop = false;
                $scope.uploadDocCoverImage = null
                $scope.doctorCropImage = "";
                $scope.saveProfileDetails();
                // } else if($scope.uploadFileImage!=null){
                //     console.log($scope.uploadFileImage,"351")
                //         $scope.crop = false;
                //         $scope.uploadFileImage = null;
                //         $scope.uploadDocCoverImage =null
                //         $scope.doctorCropImage = "";
                //         $scope.saveProfileDetails();         

            } else {
                console.log("No update on profile image");
                $scope.saveProfileDetails();
            }
        };

        $scope.saveProfileDetails = function () {
            if ($scope.saveProfile.contact_number_2 == null) {
                $scope.saveProfile.contact_number_2 = "N/A"
            } else {
                $scope.saveProfile.contact_number_2 = $scope.saveProfile.contact_number_2
            }
            var data = {
                "account_email": authService.authentication.account_id,
                "doctor_id": authService.authentication.doctor_id,
                "profile": $scope.saveProfile
            };

            profileService.createProfile(data, saveType).then(function (response) {
                $scope.profile = response;
                toastr.success("Saved successfully");
                $scope.showcrop = false
                $scope.loadProfile();
                $scope.showForm = false;
                $scope.createProfile = false;
            }, function (err) {
                toastr.error(err);
                analytics('saveProfileDetails', err);
            })
        };

        // Dr Profile Photo 
        $scope.uploadFile = function (file, event, flow) {
            $scope.handleFileSelect(file);

            /*$scope.uploadFileImage = null;
            if({png:1,gif:1,jpg:1,jpeg:1}[file.getExtension()]){
                var data = new FormData();
                data.append('file', file.file);
                $scope.uploadFileImage = file.file;
                var reader = new FileReader();
                reader.onload = function(e) {
                    $scope.profile.image = reader.result;
                };
                reader.readAsDataURL(file.file);
                return true;
            }else{
                alert("Upload only Images");
                return false;
            }
            flow.file = [];*/
        };

        //function to load the analytics
        function analytics(aEvent, aLabel) {
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            var url = sessionStorage.getItem('serviceBaseUrl');
            if (url == 'epicare.net') {
                gtag('config', 'G-XGBKLLH8JX');
            } else {
                gtag('config', 'UA-99604994-7');
            }
            gtag('event', aEvent, {
                'event_category': 'profileController',
                'event_label': aLabel
            });
        }

    }]);
'use strict';
angular.module('AngularApp').controller('registerController', ['$scope','$rootScope','$location','$filter','authService','recordService','subscribeService','paymentService','$ngBootbox','$sessionStorage','toastr','tabsService', 'dischargeService', 'careproviderService',
function ($scope, $rootScope, $location, $filter, authService, recordService, subscribeService, paymentService, $ngBootbox, $sessionStorage, toastr, tabsService, dischargeService, careproviderService) {

$scope.regChild      = {childInfo:{ gender:''/*,birthHeight:0,birthWeight:0*/}, fatherInfo:{ appAccess: false }, motherInfo:{ appAccess: false },doctor_email:authService.authentication.account_id, image: null};
$scope.validate      = false;
$scope.regDisable    = false;
$scope.emerDisable   = false;
$scope.noVillage         = false;
$scope.noFieldstaff       = false;
$scope.communityDiasable = false;
$scope.mobileaccess  = false;
$scope.appointment           = false;
$rootScope.data_notsaved     = true;
$rootScope.showRegistration  = false;
$scope.ageInYears            = 0;
angular.element('#checkFatherPhone').focus();

//$scope.word  = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
$scope.word    = "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[‌​a-z0-9-]*[a-z0-9])?\\.){1,2}[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$";
$scope.opened  = false;
$scope.regType = 'General';

$scope.getConsultationTabs = function () {    
    tabsService.getconsultionSettings().then(function(response) {
         $scope.consultCheckTabs = response.consultation_setting;
            console.log($scope.consultCheckTabs);
         $scope.obstgynecgender = $scope.consultCheckTabs[9].status;
        },function(error) {
          toastr.error(error,'Try again...');
          //analytics('addNewComplaint','Try again');
      })
    }
  $scope.getConsultationTabs();

$scope.findRegType = function(regType){
 //$scope.webcam();
   $scope.regChild = {childInfo:{ gender:'male',dob1:(new Date())}, fatherInfo:{ appAccess: true }, motherInfo:{ appAccess: false },doctor_email:authService.authentication.account_id, image: null};
   $scope.validate = false;
   $rootScope.showRegistration = false;
   $scope.regType = regType;
   $scope.getConsultationTabs();
}


$scope.getDistricts = function() {

    $scope.hidetable2 = 'true';
    $scope.hidetable1 = 'true';
    $scope.completeBtnDisable = true;
    
    $scope.district_id = "0";  
    $scope.block_id    = "0";
    $scope.staff_id    = "0";
    $scope.village_id  = "0";

    $scope.selected_district = "";
    $scope.selected_block    = "";
    $scope.selected_vhn      = "";
    $scope.selected_village  = "";
    $scope.selected_stafftype = "";

    $scope.selected_district_name = "All";
    $scope.selected_block_name    = "All";
    $scope.selected_vhn_name      = "All";
    $scope.selected_village_name  = "All";
    
    $scope.districts_list = [];
    $scope.blocks_list    = [];
    $scope.vhn_list       = [];
    $scope.villages_list  = [];
    $scope.fieldStaff     = [];
    
    var param = {
    account_email: authService.authentication.account_id
    };
    
    dischargeService.getDistrictList(param).then(function (response) {
        $scope.districts_list = response;   
        if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org" || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){        
            $scope.selected_district_name = response[0].districtname;
            $scope.selected_district = response[0].id;    
            $scope.getBlocks(response[0].id);
        }
    }, function (error) {
        //toastr.error(error);
    });
}

$scope.getDistricts()


$scope.getBlocks = function(id) {
    $scope.completeBtnDisable = true;

    if(id==null) {
    $scope.district_id = "0"; 
    } else {
    $scope.district_id = id+"";  
    } 

    $scope.hidetable2 = 'true';
    $scope.block_id   = "0";
    $scope.staff_id   = "0";
    $scope.village_id = "0";

    $scope.selected_block   = "";
    $scope.selected_vhn     = "";
    $scope.selected_village = "";
    $scope.selected_stafftype = "";

    $scope.selected_block_name   = "All";
    $scope.selected_vhn_name     = "All";
    $scope.selected_village_name = "All";
    
    $scope.blocks_list   = [];
    $scope.vhn_list      = [];
    $scope.villages_list = [];
    $scope.fieldStaff    = [];

    var param = { 
    account_email: authService.authentication.account_id,
    id: $scope.district_id 
    }     
    
    dischargeService.getBlockList(param).then(function (response) {
    $scope.blocks_list = response; 
    if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org"  || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){
        // $scope.selected_block = response[0].id; 
        $scope.block = "";
        $scope.selected_block_name = response[0].blockname;
        $scope.getVillages(response[0].id); 
        // $scope.getFieldStaffid()
        // $scope.getVhn(response[0].id);
    }
    }, function (error) {
       //toastr.error(error);
    });
}


$scope.getVillages = function(block_id) {  

    $scope.completeBtnDisable = true;
    $scope.hidetable2 = 'true';

    if(block_id==null) {
        $scope.staff_id          = "0";    
        $scope.selected_block_name = "All"; 
        // $scope.selected_vhn_name = "All"; 
    } else {
        $scope.staff_id          = block_id+""; 
        // var tempArr              = ($filter('filter')($scope.vhn_list, {'staffid':staff_id})); 
        // $scope.selected_vhn_name = tempArr[0].staffname;
    }
        
    $scope.village_id            = "0"; 
    $scope.selected_village      = "";
    $scope.selected_village_name = "All";
    $scope.selected_stafftype    = "";
    $scope.villages_list         = [];
    $scope.fieldStaff            = [];

    var param = {	
    account_email: authService.authentication.account_id,
    id: $scope.staff_id
    }
    
    dischargeService.getVillageList(param).then(function (response) {
        if(response.length>0){
            $scope.noVillage = false;
            $scope.communityDiasable = false;
            $scope.villages_list    = response;   
            // $scope.selected_village = "";
            if(authService.authentication.account_id=="rx30500@rxcarenet.org" || authService.authentication.account_id=="rx36631@rxcarenet.org"  || authService.authentication.account_id=="rx34296@rxcarenet.org" || authService.authentication.account_id=="rx32140@rxcarenet.org" || authService.authentication.account_id=="rx4@rxcarenet.org" || authService.authentication.account_id=="rx170374@rxcarenet.org" || authService.authentication.account_id=="rx172060@rxcarenet.org"){
            $scope.selected_village      = "";
            $scope.getFieldStaffid()
            }
        }else{
            $scope.noVillage = true;
            $scope.communityDiasable = true;
            $scope.getFieldStaffid()
        }

    },function (error) {
      //toastr.error(error);
    });  
}


$scope.getFieldStaffid = function (){

    $scope.fieldStaff = []
    $scope.selected_stafftype = "";


    console.log("district_id", $scope.district_id, 
    "block_id", $scope.staff_id, 
    "village_id", $scope.village_id);

    var param = {
        "account_email": authService.authentication.account_id, 
        "doctor_id": authService.authentication.doctor_id, 
        "district_id": $scope.district_id, 
        "block_id": $scope.staff_id, 
        "village_id": $scope.village_id,
        "staff_type" : "SUPERVISOR"
    }
    console.log(param);

    recordService.getFieldStaffId(param).then(function(response){
        console.log(response);
        if(response.success == 1){
            $scope.noFieldstaff = false;
            $scope.communityDiasable = false;
            $scope.fieldStaff = response.data
            $scope.selected_stafftype = "";
            // alert($scope.selected_stafftype)
            $scope.selected_staff_type = response.data[0].fieldstaff_name
        }else{
            $scope.noFieldstaff = true;
            if($scope.noFieldstaff == true){
                $scope.communityDiasable = true;
            }
        }
    })
}


$scope.staffType = function (selected_stafftype) {
    // console.log(selected_stafftype);
    // console.log(selected_stafftype.id);
    // console.log(selected_stafftype.fieldstaff_type);
    // $scope.selected_fieldstafftype = '0'
    $scope.selected_fieldstaffid = selected_stafftype.id+''
    // console.log($scope.selected_fieldstaffid);
    $scope.selected_fieldstafftype = selected_stafftype.fieldstaff_type
    console.log($scope.selected_fieldstafftype);
}

$scope.getVillageid = function (vill_id) {
    if(vill_id == null){
        $scope.village_id = '0'
    }else{
        $scope.village_id = vill_id+''
    }
    // console.log("district_id", $scope.district_id, 
    // "block_id", $scope.staff_id, 
    // "village_id", $scope.village_id);
    $scope.getFieldStaffid()
}


$scope.checkNonNegativeBirthWeight = function(blur){
   if((blur && !!!$scope.regChild.childInfo.birthWeight) || $scope.regChild.childInfo.birthWeight < 0 ){
    $scope.regChild.childInfo.birthWeight = 0;
   }
};

$scope.checkNonNegativeBirthHeight = function(blur){
    if((blur && !!!$scope.regChild.childInfo.birthHeight) || $scope.regChild.childInfo.birthHeight < 0 ){
     $scope.regChild.childInfo.birthHeight = 0;
    }
};

$scope.popup2 = {
    opened: false
};

$scope.open = function($event){
    $event.preventDefault();
    $event.stopPropagation();
    $scope.opened = true;
};

$scope.datepicker = {
	opened :{ childInfo:false, fatherInfo:false, motherInfo:false},
    maxDate: new Date(),
	maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
	dateOptions : {
      maxDate: new Date(),
	  formatYear: 'yyyy',
	  startingDay: 1
	}
};


$scope.prematureShow = function(value) {
    if(value==0 || $scope.weeks==false) {  
        $scope.regChild.weeks=undefined;
        $scope.convertedDate2=undefined;        
        $scope.regChild.childInfo.date1 = undefined;
        $scope.regChild.childInfo.month1 = undefined;
        $scope.regChild.childInfo.year1 = undefined;
    } 

    if(value==0) {
        $scope.convertedDate=undefined;
        $scope.regChild.childInfo.date = undefined;
        $scope.regChild.childInfo.month = undefined;
        $scope.regChild.childInfo.year = undefined;
    }
}

$scope.open2 = function() {
    $scope.popup2.opened = true;
};

$scope.reg = function() {
    $scope.regChild = {childInfo:{ gender:'male'}, fatherInfo:{ appAccess: true }, motherInfo:{ appAccess: false },doctor_email:authService.authentication.account_id, image: null};
    $scope.validate = false;
};

$scope.reg();
$scope.uploadFile = function(file, event, flow){
    if({png:1,gif:1,jpg:1,jpeg:1}[file.getExtension()]){
        var data = new FormData();
        data.append('file', file.file);
        var reader = new FileReader();
        reader.onload = function(e) {
            $scope.regChild.image = reader.result;
        };
        reader.readAsDataURL(file.file);
     return true;
    } else {
     alert("Upload only Images");
     return false;
    }
    flow.file = [];
};

$scope.Dates  = [];
$scope.Months = [];
$scope.Years  = [];

for(var i=1;i<=31;i++) {
    $scope.Dates.push(i);
    if(i<=12) {
        $scope.Months.push(i);
    }
}

var currentYear = new Date().getFullYear();
for(var j=1910;j<=currentYear;j++) {
    $scope.Years.push(j);
};

function subscribeNoneAdd(data) {
    var tempArr = []; 
    angular.forEach(data, function(value) {
        if(value.is_active==true) {
            //if(authService.authentication.account_id == "rx21735@rxcarenet.org"){
            if(authService.authentication.account_id == "rx21735@rxcarenet.org" || authService.authentication.account_id == "rx4@rxcarenet.org"){    
                tempArr.push({ amount: value.amount, created_date: value.created_date, currency_code: value.currency_code, duration_in_days: value.duration_in_days, id: value.id, daysAndAmount:value.duration_in_days+" days, Rs."+value.amount});
            } else {
                if(value.amount!="00.00" && value.amount!="0" && value.amount!=0 && value.amount!="0.0" && value.amount!="00.0" && value.amount!="0.00"){
                  tempArr.push({ amount: value.amount, created_date: value.created_date, currency_code: value.currency_code, duration_in_days: value.duration_in_days, id: value.id, daysAndAmount:value.duration_in_days+" days, Rs."+value.amount});
                }
            }
        }
    });

  //if(authService.authentication.account_id != "rx21735@rxcarenet.org"){
    if(authService.authentication.account_id != "rx21735@rxcarenet.org" && authService.authentication.account_id != "rx4@rxcarenet.org"){    
        tempArr.push({daysAndAmount:"None",duration_in_days: "None", id: "none"});
    }

  return tempArr;  
}   

$scope.registrationFee = "";
$scope.paymentList = function() {       
    paymentService.getPaymentSetting().then(function(response) {    
        angular.forEach(response, function(value){
            if(value.module=="registration_fee" && value.doctor_charge>=0){
            // if(authService.authentication.account_id == "rx21735@rxcarenet.org" || authService.authentication.account_id == "rx32@rxcarenet.org" || authService.authentication.account_id == "rx5593@rxcarenet.org" || authService.authentication.account_id == "rx3@rxcarenet.org" || authService.authentication.account_id == "rx4@rxcarenet.org"){   
                  $scope.registrationFee=value.doctor_charge;
              //}  
            }
        });
    },function(error) {
        toastr.error(error);
        analytics('paymentList',error);
    });
};
$scope.paymentList();

$scope.subscribeModelShow=false;
$scope.subscribeList = function() {       
    subscribeService.getSubscribeList().then(function(response) {    
       if(response.is_subscribed==true){
        $scope.subscribeModelShow=true;   
       }
     //$scope.subscribeModel = response.result;     
       $scope.subscribeModel = subscribeNoneAdd(response.result);

    },function(error) {
        toastr.error(error);
        analytics('subscribeList',error);
    });

};

$scope.saveSubscribeData = function(data) {
    $scope.subscribe_setting_id = data.id;
};

$scope.subscriptionPayment = function(email_id) {

    var data = {
		"account_email":$rootScope.authentication.account_id,
        "patient_email":email_id,
        "type":3,
        "doctor_id": authService.authentication.doctor_id,
        "subscription_setting_id": $scope.subscribe_setting_id,
    }
 
    subscribeService.subscribePayment(data).then(function(response) {    
         toastr.success(response.message);
    },function(error) {
         toastr.error(error);
         analytics('subscribePayment',error);
    });
          
};

$scope.male = function(){
    $scope.regChild.childInfo.gender='male'
}
$scope.initfemale = function(){
    $scope.regChild.childInfo.gender='female'
}
$scope.process = false;

$scope.search = function() {
    if($scope.obstgynecgender == true){
        $scope.initfemale();
    } else if ($scope.obstgynecgender == false){
        $scope.male();
    }
    authService.getPatientSearch($scope.regChild.fatherInfo.phone).then(function(response) {
        $rootScope.patientDetail = response;
        if($rootScope.patientDetail.length > 0){
            var options = {
             title: 'Phone Number Already Exist for <b>'+$rootScope.patientDetail.length+'</b> patient',
             message:'',
             templateUrl: 'views/patient/registerAfterChecking.htm',
             size:'large',
			 onEscape: function() { $scope.$apply();},
            buttons: {
            	ok:{
                     label: " Yes, Create New",
                     className: "btn-primary",
                     callback: function() {
                        $scope.subscribeList();
                        $rootScope.showRegistration = true;
                        toastr.error('Creating account with same phone number');
                        $scope.$apply();
                        analytics('search','creating account with same phone number');
                    }
                 },
                 close:{
                     label: " Cancel Registration",
                     className: "btn-danger",
                     callback: function() {$location.path("/home");$scope.$apply();}
                 }
            }
        };

        $ngBootbox.customDialog(options);

        } else if($rootScope.patientDetail.length == 0) {

            $scope.subscribeList();           
            $rootScope.showRegistration = true;
            toastr.success('Available');
        }

     },function (err, response) {
        toastr.error(err.error);
        analytics('search',err.error);
     });
};

$scope.convertToDate = function(years){
    var dateOffset = parseInt(years * 365);
    var convertDate = new Date();
    $scope.convertedDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
    $scope.convertedDate = convertDate.getDate() + '/' + (convertDate.getMonth() + 1) + '/' + (convertDate.getFullYear());
    $scope.convertedDate3 = new Date(convertDate.getFullYear() + '-' + (convertDate.getMonth() + 1) + '-' + convertDate.getDate()).toISOString()
    $scope.regChild.childInfo.date = convertDate.getDate();
    // $scope.abcde = convertDate.getDate() + 1
    $scope.regChild.childInfo.month = convertDate.getMonth() + 1;
    // $scope.abcd = convertDate.getMonth()
    $scope.regChild.childInfo.year = convertDate.getFullYear();
    // $scope.convertDate3 = (new Date($scope.regChild.childInfo.year,$scope.abcd,$scope.abcde).toISOString());
    // console.log(new Date($scope.regChild.childInfo.date,$scope.regChild.childInfo.month,$scope.regChild.childInfo.year));
}

$scope.convertToDate2 = function(years) {
    var convertDate2;
    var dateOffset = parseInt(years * 7);
    if($scope.convertedDate) {
       var splitDates = $scope.convertedDate.split('/');
       convertDate2 = new Date(splitDates[2], splitDates[1], splitDates[0]);
    } else {
       convertDate2 = new Date( $scope.regChild.childInfo.year, $scope.regChild.childInfo.month, $scope.regChild.childInfo.date);
       $scope.regChild.childInfo.date1 = convertDate2.getDate();
       $scope.regChild.childInfo.month1 = convertDate2.getMonth();
       $scope.regChild.childInfo.year1 = convertDate2.getFullYear();
    }
    $scope.convertedDate2 = new Date(convertDate2.setDate(convertDate2.getDate() - dateOffset));
    $scope.convertedDate2 = convertDate2.getDate() + '/' + convertDate2.getMonth() + '/' + convertDate2.getFullYear();
}

$scope.successfulRegistration = function(data){
    
    if($scope.registrationFee!=""){
      $scope.raiseInvoiceForRegFee(data.Account_info.email);
    }
                 
    if($scope.subscribeModelShow==true){
        if($scope.subscribe_setting_id!="none"){
           $scope.subscriptionPayment(data.Account_info.email); 
        }
    }

    var options = {
        message: "Account successfully created for " + data.Demographics.Record.label + $scope.accessResponse,
        title: 'Account creation successful',
            onEscape: function() {  $scope.reg();$scope.regDisable = false;$scope.process = false;$scope.$apply();},
        buttons: {
                success: {
                    label: " OK",
                    className: "btn-primary fa fa-check",
                    callback: function() {

                        $location.path("/patientview/"+data.Demographics.Record.id);
                        $scope.regDisable = false;
                        $scope.process = false;
                        $scope.$apply();

                        }
                    }
                }
        }
    $ngBootbox.customDialog(options);

};

$scope.successfulRegistrationCommunity = function(data){
    $scope.selected_block       = "";
    $scope.selected_village     = "";
    $scope.selected_stafftype   = "";
    $scope.ageInYears           = "";
    $scope.weeks                = false;
    $scope.regChild.weeks       = ""
    $scope.mobileaccess         = false;

    var options = {
        message: "Account successfully created for " + data.Demographics.Record.label + $scope.accessResponse,
        title: 'Account creation successful',
            onEscape: function() {  $scope.reg();$scope.regDisable = false;$scope.communityDiasable = false;$scope.process = false;$scope.$apply();},
        buttons: {
                // success: {
                //     label: " OK",
                //     className: "btn-primary fa fa-check",
                //     callback: function() {

                //         $location.path("/patientview/"+data.Demographics.Record.id);
                //         $scope.regDisable = false;
                //         $scope.process = false;
                //         $scope.$apply();

                //         }
                //     }
                ok: {
                    label: "Proceed with New Registration",
                    className: 'btn-succes',
                    callback: function() {
                        // alert()
                        $location.path("/register")
                        $scope.communityDiasable = false;
                        $scope.findRegType($scope.regType)
                        $scope.$apply();
                    }
                 },
                 success: {
                     label: " Home",
                     className: "btn-primary fa fa-check",
                     callback: function() {

                        $location.path("/patientview/"+data.Demographics.Record.id);
                        $scope.communityDiasable = false;
                        $scope.$apply();

                        }

                    }
                }
        }
    $ngBootbox.customDialog(options);
}

$scope.raiseInvoiceForRegFee = function(email){
   
    var data = {
        account_email: $rootScope.authentication.account_id,
        patient_email: email,
        category: "registration_fee",
        description: "Fee charged for registration",
        doctor_charges: $scope.registrationFee,
        user_type: "doctor",
        type: 3,
        appointment_id:"",
        doctor_id: $rootScope.authentication.doctor_id
    }
    paymentService.raiseInvoice(data).then(function(response){
        toastr.success('Registration fee deducted successfully');   
        $scope.registrationFee ="";          
    }, function(error) {
        toastr.error(error);
        analytics('raiseInvoiceForRegFee',error);
    });      
}

$scope.register = function(){

    $rootScope.data_notsaved=false;

    // $scope.regDisable=true;
    $scope.validate = true;
    $scope.regChild.childInfo.dob1 = undefined;

    if($scope.frmPatientRegistration.$valid){

        $scope.process = true;
        $scope.regDisable = true;

        // $scope.regChild.childInfo.firstName = document.getElementById('RegisterName').value.charAt(0).toUpperCase() + document.getElementById('RegisterName').value.substr(1).toLowerCase();
        
        if($scope.regChild.childInfo.dob){
            var date = new Date($scope.regChild.childInfo.dob);
            var date3 = $filter('date')(date, "yyyy-MM-dd")
            $scope.regChild.childInfo.dob = date3;
        }

        $scope.regChild.childInfo.dob = $scope.regChild.childInfo.year.toString()+"-"+($scope.regChild.childInfo.month<10?"0"+$scope.regChild.childInfo.month.toString():$scope.regChild.childInfo.month.toString())+"-"+
        ($scope.regChild.childInfo.date<10?"0"+$scope.regChild.childInfo.date.toString():$scope.regChild.childInfo.date.toString())+"T16:30:00.000Z"
        
        // if(new Date($scope.regChild.childInfo.dob.split('T')[0])>=new Date()){
        //     toastr.error("Invaild date of birth");
        //     analytics('register','Invaild date of birth');
        //     $scope.process = false;
        //     $scope.regDisable = false;
        //     return;
        // }
        
        if($scope.regChild.image==null){
            if($scope.snapshotData!=null){
                $scope.regChild.image = $scope.snapshotData;
            }
        }

        if($scope.regChild.weeks!=undefined){
            var week = $scope.regChild.weeks;
            function isInt(n) {
            return n % 1 === 0;
            }
            if(!isInt(week)){
            var days = week.toString().split('.')
            var week = parseInt(days[0])*7
            var day = parseInt(days[1])+ week
            }else{
                var day = week*7;
            }
            var date1 = moment($scope.regChild.childInfo.dob).add(parseInt($scope.regChild.weeks)*7,'days');
            var date2 = $filter('date')(new Date(date1), "yyyy-MM-dd"); 
            $scope.regChild.childInfo.dob1 = date2 ? date2 : '';
        }else if($scope.regChild.childInfo.year1!=undefined && $scope.regChild.childInfo.month1!=undefined && $scope.regChild.childInfo.date1!=undefined){
            var date = new Date($scope.regChild.childInfo.dob1);
            var date3 = $filter('date')(date, "yyyy-MM-dd")
            $scope.regChild.childInfo.dob1 = date3;
        
            $scope.regChild.childInfo.dob1 = $scope.regChild.childInfo.year1.toString()+"-"+($scope.regChild.childInfo.month1<10?"0"+$scope.regChild.childInfo.month1.toString():$scope.regChild.childInfo.month1.toString())+"-"+
            ($scope.regChild.childInfo.date1<10?"0"+$scope.regChild.childInfo.date1.toString():$scope.regChild.childInfo.date1.toString())+"T16:30:00.000Z"
            if(new Date($scope.regChild.childInfo.dob1.split('T')[0])>=new Date()){
                toastr.error("Invaild premature date of birth");
                analytics('register','Invaild premature date of birth');
                $scope.process = false;
                $scope.regDisable = false;
                return;
            }
        }     

        authService.addPatient($scope.regChild).then(function(response){
            $sessionStorage.put('patientAccEmail',response.Account_info.email);
            var sessionData = {
                cell_number:response.Demographics.Record.phone,
                acc_email:$rootScope.authentication.account_id,
                record_id:response.Demographics.Record.id,
                mr:response.Demographics.Record.mr_number
            };
            $sessionStorage.put('patientDetail',JSON.stringify(sessionData));
            
            if($scope.appointment){
                var bookappt = {
                    patient_email: $sessionStorage.get('patientAccEmail'),
                    account_email: $rootScope.authentication.account_id
                };
                recordService.bookWalkin(bookappt).then(function(aptResponse) {
                    toastr.success('Appointment booked');
                }, function(error) {
                    toastr.error('Walkin appointment not booked. Try again later.');
                    analytics('register','Walkin appointment not booked');
                })
            }

            $scope.accessResponse = '';
            if($scope.mobileaccess){
                var sendData = {
                    cell_number:response.Demographics.Record.phone,
                    acc_email:$rootScope.authentication.account_id,
                    record_id:response.Demographics.Record.id,
                    dr_name:$rootScope.authentication.account_info.Account.fullName,
                    mr:response.Demographics.Record.mr_number,
                    patient_account_email:response.Account_info.email
                };
                recordService.mobilePayment(sendData).then(function(accessResponse){
                    $scope.accessResponse = "<br><br>UserName: " + accessResponse.username + "<br>Password: " + accessResponse.password;
                    toastr.success('Mobile Access Given');
                    $scope.successfulRegistration(response);
                }, function(error) {
                    toastr.error('Mobile Access not Enabled. Try again later.');
                    analytics('register','mobileaccess not Enabled');
                })
            }
            else {
                $scope.successfulRegistration(response);
            }
        },
        function (err, response) {
            $ngBootbox.alert(err.Message);
            $scope.process = false;
            $scope.regDisable = false;
        });
    }
    else{
        var options = {
            message: "Please fill all the mandatory fields" ,
            title: '<span class="fa fa-exclamation-triangle">Warning</span>',
            onEscape:  function() { $scope.regDisable = false;$scope.$apply();},
            buttons: {
                    success: {
                        label: "  OK",
                        className: "btn-primary",
                        callback: function() {
                        $scope.regDisable = false;$scope.$apply();
                            }
                        }
                    }
            }

        $ngBootbox.customDialog(options);
    }
};

$scope.Years.reverse();

$scope.emergency = function(){

      //$scope.emerDisable=true;
        $scope.validate = true;

        $scope.regChild.childInfo.dob1 = undefined;

        if($scope.frmEmergencyPatientRegistration.$valid){


          if($scope.regChild.childInfo.gender){

            $scope.regChild.type='1';
            $scope.emerDisable=true;

            if($scope.regChild.childInfo.dob){
                var date = new Date($scope.regChild.childInfo.dob);
                var date3 = $filter('date')(date, "yyyy-MM-dd");
                $scope.regChild.childInfo.dob = date3;
          }
          
          $scope.regChild.childInfo.dob = $scope.regChild.childInfo.year.toString()+"-"+($scope.regChild.childInfo.month<10?"0"+$scope.regChild.childInfo.month.toString():$scope.regChild.childInfo.month.toString())+"-"+
               ($scope.regChild.childInfo.date<10?"0"+$scope.regChild.childInfo.date.toString():$scope.regChild.childInfo.date.toString())+"T16:30:00.000Z"
            //    if(new Date($scope.regChild.childInfo.dob.split('T')[0])>=new Date()){
            //        toastr.error("Invaild date of birth");
            //        analytics('emergency','Invaild date of birth');
            //        $scope.regDisable = false;
            //        return;
            //    }            
               
               if($scope.regChild.weeks!=undefined){
                var week = $scope.regChild.weeks;
                function isInt(n) {
                  return n % 1 === 0;
                }
                if(!isInt(week)){
                  var days = week.toString().split('.')
                  var week = parseInt(days[0])*7
                  var day = parseInt(days[1])+ week
                }else{
                    var day = week*7;
                }
                var date1 = moment($scope.regChild.childInfo.dob).add(parseInt($scope.regChild.weeks)*7,'days');
                var date2 = $filter('date')(new Date(date1), "yyyy-MM-dd"); 
                $scope.regChild.childInfo.dob1 = date2 ? date2 : '';
               }else if($scope.regChild.childInfo.year1!=undefined && $scope.regChild.childInfo.month1!=undefined && $scope.regChild.childInfo.date1!=undefined){
                var date = new Date($scope.regChild.childInfo.dob1);
                var date3 = $filter('date')(date, "yyyy-MM-dd")
                $scope.regChild.childInfo.dob1 = date3;
          
                $scope.regChild.childInfo.dob1 = $scope.regChild.childInfo.year1.toString()+"-"+($scope.regChild.childInfo.month1<10?"0"+$scope.regChild.childInfo.month1.toString():$scope.regChild.childInfo.month1.toString())+"-"+
                ($scope.regChild.childInfo.date1<10?"0"+$scope.regChild.childInfo.date1.toString():$scope.regChild.childInfo.date1.toString())+"T16:30:00.000Z"
                if(new Date($scope.regChild.childInfo.dob1.split('T')[0])>=new Date()){
                    toastr.error("Invaild date");
                    analytics('emergency','Invaild date');
                    $scope.regDisable = false;
                    return;
                }
            }


        authService.addPatient($scope.regChild).then(function(response){      

                    var options = {
                        message: "Account successfully created for " + response.Demographics.Record.label,
                        title: 'Account creation successful',
                         onEscape: function() {  $scope.reg();$scope.emerDisable = false;$scope.$apply();},
                        buttons: {
                             success: {
                                 label: " OK",
                                 className: "btn-primary fa fa-check",
                                 callback: function() {

                                        $location.path("/patientview/"+response.Demographics.Record.id);
                                        $scope.emerDisable = false;
                                        $scope.$apply();

                                       }

                                 }
                             }

                        }

                    $ngBootbox.customDialog(options);

                    
             },
             function (err, response) {
                $ngBootbox.alert(err.Message);
                $scope.emerDisable = false;

            });

        }
           else{

           var options = {
                        message: "Please Choose the Gender" ,
                        title: '<span class="fa fa-exclamation-triangle">Warning</span>',
                        onEscape:  function() { $scope.regDisable = false;$scope.$apply();},
                        buttons: {
                             success: {
                                 label: "  OK",
                                 className: "btn-primary",
                                 callback: function() {
                                    $scope.regDisable = false;$scope.$apply();
                                     }
                                 }
                             }
                        }

                    $ngBootbox.customDialog(options);
           }

       } else {

            var options = {
                        message: "Please fill all the mandatory fields" ,
                        title: '<span class="fa fa-exclamation-triangle">Warning</span>',
                        onEscape:  function() { $scope.emerDisable = false;$scope.$apply();},
                        buttons: {
                             success: {
                                 label: "  OK",
                                 className: "btn-primary",
                                 callback: function() {
                                    $scope.emerDisable = false;$scope.$apply();
                                     }
                                 }
                             }
                        }

                    $ngBootbox.customDialog(options);

        }


    };
    

    $scope.communityRegister = function(){

        // console.log($scope.regChild);
        // console.log(new Date($scope.regChild.childInfo.year,$scope.abcd,$scope.abcde).toISOString());
        // console.log($scope.frmCommunityRegistration);
        if($scope.frmCommunityRegistration.$valid){

            // console.log($scope.frmCommunityRegistration.$valid);
            // console.log($scope.convertedDate3);
            // var DOB = $scope.convertedDate3.split('T')[0] + "T00:00:00.000Z"
            // console.log(DOB,'converted DOB');

            if($scope.regChild.weeks!=undefined){
                var week = $scope.regChild.weeks;
                function isInt(n) {
                return n % 1 === 0;
                }
                if(!isInt(week)){
                var days = week.toString().split('.')
                var week = parseInt(days[0])*7
                var day = parseInt(days[1])+ week
                }else{
                    var day = week*7;
                }
                var date1 = moment($scope.regChild.childInfo.dob).add(parseInt($scope.regChild.weeks)*7,'days');
                var date2 = $filter('date')(new Date(date1), "yyyy-MM-dd"); 
                $scope.regChild.childInfo.dob1 = date2 ? date2 : '';
            }else if($scope.regChild.childInfo.year1!=undefined && $scope.regChild.childInfo.month1!=undefined && $scope.regChild.childInfo.date1!=undefined){
                var date = new Date($scope.regChild.childInfo.dob1);
                var date3 = $filter('date')(date, "yyyy-MM-dd")
                $scope.regChild.childInfo.dob1 = date3;
            
                $scope.regChild.childInfo.dob1 = $scope.regChild.childInfo.year1.toString()+"-"+($scope.regChild.childInfo.month1<10?"0"+$scope.regChild.childInfo.month1.toString():$scope.regChild.childInfo.month1.toString())+"-"+
                ($scope.regChild.childInfo.date1<10?"0"+$scope.regChild.childInfo.date1.toString():$scope.regChild.childInfo.date1.toString())+"T16:30:00.000Z"
                if(new Date($scope.regChild.childInfo.dob1.split('T')[0])>=new Date()){
                    toastr.error("Invaild premature date of birth");
                    analytics('register','Invaild premature date of birth');
                    $scope.process = false;
                    $scope.regDisable = false;
                    return;
                }
            }   

            $scope.regChild.childInfo.dob = $scope.regChild.childInfo.year.toString()+"-"+($scope.regChild.childInfo.month<10?"0"+$scope.regChild.childInfo.month.toString():$scope.regChild.childInfo.month.toString())+"-"+
            ($scope.regChild.childInfo.date<10?"0"+$scope.regChild.childInfo.date.toString():$scope.regChild.childInfo.date.toString()) + "T00:00:00.000Z"

            console.log($scope.regChild.childInfo.dob);

            var param1 = {
                "childInfo": { 
                    "gender": $scope.regChild.childInfo.gender, 
                    "year": $scope.regChild.childInfo.year,
                    "month": $scope.regChild.childInfo.month,
                    "date": $scope.regChild.childInfo.date,            
                    "firstName": $scope.regChild.childInfo.firstName,            
                    "lastName": $scope.regChild.childInfo.lastName,   
                    "birthWeight": $scope.birthWeight,
                    "birthHeight": $scope.birthHeight,     
                    // "birthWeight": $scope.regChild.childInfo.birthWeight==undefined?"":$scope.regChild.childInfo.birthWeight,   
                    "bloodGroup": $scope.regChild.childInfo.bloodGroup==undefined?"":$scope.regChild.childInfo.bloodGroup,            
                    "uhid": "",            
                    // "dob": $scope.convertedDate3   
                    // "dob": "2022-11-03T00:00:00:000Z"
                    // "dob": DOB
                    "dob": $scope.regChild.childInfo.dob         
                },
                "fatherInfo": { 
                    "firstName": "",            
                    "appAccess": true,          
                    "phone": $scope.regChild.fatherInfo.phone
                },            
                "motherInfo": { 
                    "firstName": "",
                    "appAccess": false,            
                    "phone": ""
                },            
                "doctor_email": authService.authentication.account_id,
                "image": "",            
                "address": "",            
                "email": "",            
                "district_id": $scope.district_id,            
                "block_id": $scope.staff_id,            
                "panchayat_id": "0",
                "village_id": $scope.village_id,            
                "staffprofile_id": $scope.selected_fieldstaffid,
                "kce_id": $scope.selected_fieldstafftype,
                "weeks": $scope.regChild.weeks,
                "doctor_id":  authService.authentication.doctor_id
            }

            var param2 = {
                "childInfo": { 
                    "gender": $scope.regChild.childInfo.gender, 
                    "year": $scope.regChild.childInfo.year,
                    "month": $scope.regChild.childInfo.month,
                    "date": $scope.regChild.childInfo.date,            
                    "firstName": $scope.regChild.childInfo.firstName,            
                    "lastName": $scope.regChild.childInfo.lastName,            
                    "birthWeight": $scope.birthWeight,   
                    "birthHeight": $scope.birthHeight,         
                    "bloodGroup": $scope.regChild.childInfo.bloodGroup,            
                    "uhid": "",            
                    // "dob": $scope.convertedDate3   
                    // "dob": DOB
                    "dob": $scope.regChild.childInfo.dob         
                },
                "fatherInfo": { 
                    "firstName": "",            
                    "appAccess": true,                    
                    "phone": $scope.regChild.fatherInfo.phone
                },            
                "motherInfo": { 
                    "firstName": "",
                    "appAccess": false,            
                    "phone": ""
                },            
                "doctor_email": authService.authentication.account_id,
                "image": "",            
                "address": "",            
                "email": "",            
                "district_id": $scope.district_id,            
                "block_id": $scope.staff_id,            
                "panchayat_id": "0",
                "village_id": $scope.village_id,            
                "staffprofile_id": $scope.selected_fieldstaffid,
                "kce_id": $scope.selected_fieldstafftype,
                "doctor_id":  authService.authentication.doctor_id
            }

            console.log(param1);
            console.log(param2);

            if($scope.weeks !=undefined){
                recordService.fieldStaffRegistration(param1).then(function(response){
                    console.log(response);
                    // DOB = '';
                    $scope.accessResponse = '';
                    if($scope.mobileaccess){
                        var sendData = {
                            cell_number:response.Demographics.Record.phone,
                            acc_email:$rootScope.authentication.account_id,
                            record_id:response.Demographics.Record.id,
                            dr_name:$rootScope.authentication.account_info.Account.fullName,
                            mr:response.Demographics.Record.mr_number,
                            patient_account_email:response.Account_info.email
                        };
                        recordService.mobilePayment(sendData).then(function(accessResponse){
                            $scope.accessResponse = "<br><br>UserName: " + accessResponse.username + "<br>Password: " + accessResponse.password;
                            toastr.success('Mobile Access Given');
                            $scope.successfulRegistrationCommunity(response);
                        }, function(error) {
                            toastr.error('Mobile Access not Enabled. Try again later.');
                            analytics('register','mobileaccess not Enabled');
                        })
                    }
                    else{
                        $scope.successfulRegistrationCommunity(response)
                    }
                }
                )
            }else{
                recordService.fieldStaffRegistration(param2).then(function(response){
                    console.log(response);
                    // DOB = '';
                    $scope.accessResponse = '';
                    if($scope.mobileaccess){
                        var sendData = {
                            cell_number:response.Demographics.Record.phone,
                            acc_email:$rootScope.authentication.account_id,
                            record_id:response.Demographics.Record.id,
                            dr_name:$rootScope.authentication.account_info.Account.fullName,
                            mr:response.Demographics.Record.mr_number,
                            patient_account_email:response.Account_info.email
                        };
                        recordService.mobilePayment(sendData).then(function(accessResponse){
                            $scope.accessResponse = "<br><br>UserName: " + accessResponse.username + "<br>Password: " + accessResponse.password;
                            toastr.success('Mobile Access Given');
                            $scope.successfulRegistrationCommunity(response);
                        }, function(error) {
                            toastr.error('Mobile Access not Enabled. Try again later.');
                            analytics('register','mobileaccess not Enabled');
                        })
                    }else{
                        $scope.successfulRegistrationCommunity(response);
                    }
                })
            }
        }else{
            var options = {
                message: "Please fill all the mandatory fields" ,
                title: '<span class="fa fa-exclamation-triangle">Warning</span>',
                onEscape:  function() { $scope.communityDiasable = false;$scope.$apply();},
                buttons: {
                     success: {
                         label: "  OK",
                         className: "btn-primary",
                         callback: function() {
                            $scope.communityDiasable = false;$scope.$apply();
                             }
                        }
                     }
                }

            $ngBootbox.customDialog(options);
        }
    }

    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'registerController',
            'event_label' : aLabel
        });
     }

    $scope.backToHome = function () {
       $location.path('/home');
       $scope.$broadcast('STOP_WEBCAM');
        switchOffWebcam()
    };

    $scope.regChild.fatherInfo.appAccess=true;

}]);

/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Jan 2018
 */

'use strict'
angular.module('AngularApp').controller('reportController',['$scope', '$rootScope', '$location', '$route', '$ngBootbox','$uibModal', '$filter','localStorageService','recordService','authService','toastr',
    function($scope, $rootScope, $location, $route, $ngBootbox, $uibModal, $filter,localStorageService,recordService,authService,toastr) {

    $scope.getReport = function(){
        recordService.getReports().then(function(response){
        $scope.report = response.result;
        })
    };

    $scope.reportsTab = [{Id:1, heading:'Mobile Access'}];
    $scope.setReportTabContent = function(id){
        $rootScope.selectedReportTab = id;
            if($rootScope.selectedReportTab==1){
                $scope.getReport();
            }
    };
    $scope.setReportTabContent(1);


}]);

'use strict';
angular.module('AngularApp').controller('reportmaster_Controller', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'reportmaster_Service', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, reportmaster_Service) {

    $scope.imageUploadUrl = authService.helyxonApi.url + 'cloud/image/upload/'; 

    $scope.frequency_itemsData = ["Daily", "Weekly", "Monthly"];
    $scope.report_itemsData = ["Activity", "Appointment", "Registration","Subscription","Wallet","Wallet History","profile & vaccinationcompletion"];
    

    $scope.reportmasterCall = function (id) {
        // $location.path('/frontdesk_content');
            var options = {
                title: '<b>Add Report</b>',
                message:'',
                templateUrl: 'views/report/report_content.htm',
                size:'medium',
                onEscape: function() {
                    $scope.$apply();
                },
                buttons: {
              }
          }
          $ngBootbox.customDialog(options);
    
    }

    $scope.reportmasterData;

    $scope.reportmaster_data = function (value) {

        var payload = {
            account_email: authService.authentication.account_id,
            doctor_id: authService.authentication.doctor_id
        };

        reportmaster_Service.reportmaster_Data(payload).then(function (response) {
            $scope.reportmasterData = response;
           console.log('reportmasterData',response);
        }, function (err) {
            toastr.error(err);
        });
    }
    $scope.reportmaster_data();
  
    
    $rootScope.reportmaster_call = function(){
        $scope.data = $("form").serializeArray();
       console.log('data',$scope.data);
       $scope.data_1 = $scope.data[0].value.split(":");
       $scope.data_2 = $scope.data[1].value.split(":");
       console.log('$scope.datas',$scope.data_1[1]);
       console.log('$scope.datas',$scope.data_2[1]);
       console.log('doctor id',authService.authentication.doctor_name);
       var payload_data = {
            "account_email": authService.authentication.account_id,
            "report_name":$scope.data_2[1], 
            "doctor_name":authService.authentication.doctor_name, 
            "status":"0", 
            "frequency":$scope.data_1[1], 
            "doctor_id":authService.authentication.doctor_id 
        }
        console.log('payload',payload_data);
        reportmaster_Service.reportmaster_postdata(payload_data).then(function (response) {
            console.log('response',response);
            if(response.message == 'created successfully'){
                $scope.reportmaster_data();
                bootbox.hideAll()
            }else{
                bootbox.hideAll();
            }
        }, function (err) {
            toastr.error(err);
        });
    }
    
    return this;
   }
]);
'use strict';
angular.module('AngularApp').controller('settingsController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr) {

    // $scope.getLocationStatus = function() {
    //     locationService.getSettings().then(function(response) {
    //         $scope.settingsTab = response;
    //         // if($scope.locationStatus == 1){
    //         //     $scope.toggleValue = true;      // Set toggle switch ON
    //         // }
    //         // else{
    //         //     $scope.toggleValue = false;     // Set toggle switch OFF
    //         // }
    //     },function(error) {
    //         toastr.error(error);
    //     })
    // };

    // $scope.getLocationStatus();

    // Enable chat notification
    $scope.getSettings = function() {
        locationService.getSettings().then(function(response) {
            $scope.settingsTab = response;
            if(response.can_notify_chat == 1){
                $scope.toggleValue = true;      // Set toggle switch ON
            }
            else{
                $scope.toggleValue = false;     // Set toggle switch OFF
            }
        },function(error) {
            toastr.error(error);
            analytics('getSettings',error);
        })
    };

    $scope.getSettings();

    $scope.chatSetting = function (){
        if($scope.toggleValue == false){
            $scope.enableNotification = 0;      // Disable notification 
        }else{
            $scope.enableNotification = 1;      // Enable notification 
        }
        var data = {
            account_email: authService.authentication.account_id,
            can_notify_chat: $scope.enableNotification
        };
        locationService.addSettings(data).then(function(response) {
            $sessionStorage.put('preference', JSON.stringify(response));
        },function(error) {
            toastr.error(error);
            $scope.toggleValue = !$scope.toggleValue;
            analytics('chatSetting',error);
        })
    };

    $scope.gotoSettings = function(data) {
        switch (data) {
            case '1':
                // Appointment settings
                $location.path('/apt-config');
                break;
            case '2':
                // Drug settings
                $location.path('/drug-master');
                break;
            case '3':
                // LifeLog settings
                $location.path('/lifelogConfig');
                break;
            case '4':
                // LabTest settings
                $location.path('/labtestConfig');
                break;
            case '5':
                // Advice settings
                $location.path('/advice');
                break;
            case '6':
                // Payment settings
                $location.path('/payment-master');
                break;
            case '7':
                // Milestone settings
                $location.path('/milestoneConfig');
                break;
            case '8':
                // Vaccination settings
                $location.path('/vac-master');
                break;
            case '9':
                // Location settings
                $location.path('/location');
                break;
            case '10':
                // Chat settings
                $location.path('/chatSetting');
                break;
            case '11':
                // Complaint settings
                $location.path('/complaintSetting');
                break;
            case '12':
                $location.path('/engage-master'); 
                break;
                
            case '13':
                //subscription settings
                $location.path('/subscription-master')
                break;
            case '14':
                //report Master
                $location.path('/report_master');
                break;
            case '16':
                //Frontdesk Module
                $location.path('/frontdesk_master');
                break;
            case '15':
                //Ivrs Master
                $location.path('/ivrs_master');
                break;
            case '17':
                //Tabs settings
                $location.path('/tab');
                break;
            case '20':
                //Multi-center Study Module
                $location.path('/multicenterStudy');
                break;
            case '21':
                //Dr In and Out Module
                $location.path('/inandout');
                break;
            case '22':
                //Payout Module
                $location.path('/payout');
                break;
            case '23':
                //Others Module
                $location.path('/others');
                break;
            case '24':
                //Complaintchooser Module
                $location.path('/complaintchooser');
                break;
            case '25':
                //Commonsettings Module
                $location.path('/commonsettings');
                break;
            case '26':
                //Eshopsettings Module
                $location.path('/eshopsettings');
                break;
            case '27':
                //Feedbacksettings Module
                $location.path('/feedbacksettings');
                break;
            case '28':
                //Agents Module
                $location.path('/agentsettings');
                break;
            case '29':
                //Printout Module
                $location.path('/printoutsettings');     
                break;
            case '30':
                // Incentive Module
                $location.path('/incentivesettings')
                break;
            case '32':
                $location.path('/health');
                break;
            case '33':
                $location.path('/redemSettings');
                break;
            case '31':
                // careprovider Module
                $location.path('/careprovidermaster')
            default:

        }
    };

    //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'settingsController',
            'event_label' : aLabel
        });
     }

}]);

'use strict';
angular.module('AngularApp').controller('smsnotifyController', ['$scope','$rootScope', '$location', 'authService','patientlistService','recordService','$ngBootbox', '$route',
function ($scope, $rootScope, $location, authService, patientlistService,recordService, $ngBootbox,$route) {

  $scope.datepicker= {
  opened :false,
  maxDate: new Date(),
  open:function(){
    $scope.datepicker.opened=true;
  },
    dateOptions : {
      formatYear: 'yyyy',
      startingDay: 1,

    }
  };
 
  $scope.validate = false;

  $scope.submits = function (sendNotification) {

    $rootScope.showSpinner = true;
    $scope.validate = true;
    if(sendNotification.$valid){
       $scope.data.patientList = [];
        $scope.data.recipients=[];
          if($scope.data.recipient=='allPatients')
          {
           $scope.data.recipients.push($rootScope.doctorAccountId);
          }else if($scope.data.recipient=='group')
          {
              for(i=0; i < $scope.multipleCarenet.colors.length; i++ ){
                $scope.data.recipients.push($scope.multipleCarenet.colors[i]['id']);

              }
           if($scope.multipleCarenet.colors.length==0)
             {
              alert("Choose atleast one group");
              return;
             }
          }
          else if($scope.data.recipient=='choosePatients')
          {
              for(i=0;i<$scope.multiplePatient.patients.length;i++){
                $scope.data.recipients.push($scope.multiplePatient.patients[i]['accountId']);
              };
             if($scope.multiplePatient.patients.length==0)
             {
              alert("Choose atleast one patient");
              return;
             }
          }
            
    }

    var growthData = {
        "account_id":  $rootScope.doctorAccountId,
        "type": $scope.data.recipient,
        "recipients": $scope.data.recipients,
        "message": $scope.data.message,
        };

           recordService.notificationData(growthData).then(function(response){
             $route.reload();
            $rootScope.showSpinner = false;
            },function (err, response) {
                       $ngBootbox.alert(err.Message);
                       $rootScope.showSpinner = false;
                       $route.reload();
          });
  };

 

$scope.getPatientSearch = function(searchTerm){
     //search all patients
            return $rootScope.patientList.filter(function(item){
               
                return item.label.toLowerCase().indexOf(searchTerm.toLowerCase())>=0;
             
            });
     };

     $scope.getGroupSearch = function(searchTerm1){
     //search all groups
            return $rootScope.carenetRecords.filter(function(item){
                return item.name.toLowerCase().indexOf(angular.lowercase(searchTerm1))>=0;

            });
     };

     //function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'smsnotifyController',
            'event_label' : aLabel
        });
     }



  $scope.multipleCarenet = {};
  $scope.multipleCarenet.colors =[];

  $scope.multiplePatient = {};
  $scope.multiplePatient.patients = [];

  

$scope.searchPatient = function(){
            $location.path('../patientview/'+$scope.selectedRecordId);
             $scope.selectedRecordId1=null;
            $scope.selectedRecordName1 = '';
    };


$scope.patientSearchSelect = function(item, model, label){
        setTimeout(function(){
            $('#txtPatientSearch1').blur();
            $scope.selectedRecordName1 = model;
            $scope.selectedRecordId1 = item.id;
            $scope.$apply();
        },100);
    };

  $scope.GroupSearchSelect = function(item, model, label){
        setTimeout(function(){
            $('#txtGroupSearch1').blur();
            $scope.selectedRecordName2 = model;
            $scope.selectedRecordId2 = item.id;
            $scope.$apply();
        },100);
    };  

}]); 
'use strict';
angular.module('AngularApp').controller('subscriptionController', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'subscriptionService', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, subscriptionService) {

    
    $scope.listofviewSubscription = function (value) {
        
        var payload = {
            account_email: authService.authentication.account_id,
            engagement_status: "true",
        };

        if(value){
            payload.engagement_status = ""+value;
        }
      
        subscriptionService.getListofSubscriptionData().then(function (response) {
            $scope.viewSubscriData = response.result;
        }, function (err) {
            toastr.error(err);
        });
    }
    $scope.listofviewSubscription();

    $scope.addNewSubscription = function(type){
		$rootScope.comlaintaction = 'add';
		if(type == 'add'){
			$rootScope.newSubscription = { plan_name:'', dur_days:'', amount:''};
		}

        var options = {
			title : 'Add New Complaint Question',
			message:'',
			templateUrl : 'views/subscription/addupdateSubscription.htm',
			size : 'medium',
			onEscape : function() {$scope.$apply();},
			buttons : {
				ok : {
					label : 'Save',
					className: "btn-primary fa fa-save",
					callback: function() {
                        console.log($rootScope.newSubscription)
						var data = {
							account_email: authService.authentication.account_id,
                            duration_in_days: $rootScope.newSubscription.dur_days,
                            currency_code: "INR",
                            amount: $rootScope.newSubscription.amount,
                            name:$rootScope.newSubscription.plan_name
						};
						subscriptionService.subscriptionadd(data).then(function(response) {
							if(response.data == "created"){
								toastr.success('Subscription added successfully');
								$scope.listofviewSubscription();
							}
							else {
								toastr.error('Plan already exists');
								$scope.listofviewSubscription();
							}
							$rootScope.newSubscription = { plan_name:'', dur_days:'', amount:''};
						},function(error) {
							toastr.error(error,'Try again...');
							analytics('addNewComplaint','Try again');
						})
					}
				},
				close : {
					label: " Close",
                    className: "btn-danger fa fa-times-circle",
                    callback: function() {$scope.listofviewSubscription();}
				}
			}
		};
		$ngBootbox.customDialog(options);
    };

    $scope.updateComplaint = function(data){
		var complaint_id = '';
		angular.forEach($rootScope.complaintList,function(value){
			if(value.complaint_type == data.complaint_type){
				complaint_id = value.id;
			}
		});

		$rootScope.comlaintaction = 'update';
        
        $rootScope.editSubscription = { plan_name: data.name, dur_days: data.duration_in_days, 
            amount: data.amount, prod_code:data.id};

        var options = {
			title : 'Add New Complaint Question',
			message:'',
			templateUrl : 'views/subscription/addupdateSubscription.htm',
			size : 'medium',
			onEscape : function() {$scope.$apply();},
			buttons : {
				ok : {
					label : 'Save',
					className: "btn-primary fa fa-save",
					callback: function() {
						var data = {
							account_email: authService.authentication.account_id,
							//complaint_id: complaint_id,
							duration_in_days: $rootScope.editSubscription.dur_days,
                            currency_code: "INR",
                            amount: $rootScope.editSubscription.amount,
                            name:$rootScope.editSubscription.plan_name,
                            id: $rootScope.editSubscription.prod_code
						};
						subscriptionService.subscriptionaUpdate(data).then(function(response) {
							$scope.listofviewSubscription();
							toastr.success('Subscription updated successfully');
							$rootScope.editComplaint = '';
						},function(error) {
							toastr.error(error,'Try again...');
							analytics('updateComplaint', 'Try again..');
						})
					}
				},
				close : {
					label: " Close",
                    className: "btn-danger fa fa-times-circle",
                    callback: function() {}
				}
			}
		};
		$ngBootbox.customDialog(options);
	};
	
	$scope.deactiveSubscription = function(produCode) {
		
		var options = {
			message: 'Are you sure to deactive this subscription ?',
			size: 'small',
			title: 'Confirmation',
			buttons: {
				warning: {
					label: "Cancel",
					className: "btn-warning"
				},
				success: {
					label: "Yes",
				   	className: "btn-success",
				   	callback: function() {
						var payload = {
							account_email: authService.authentication.account_id,
							id: produCode,
						}
						
						subscriptionService.subscriptionActive(payload).then(function(response) {
								$scope.listofviewSubscription();
								toastr.success('Deactivated successfully');
							}, function(error){
							});
						}
			   	}
		  	}
	  	};
	  	$ngBootbox.customDialog(options);
	};

	$scope.renewSubscription = function(produCode) {
		
		var options = {
			message: 'Are you sure to renew this subscription ?',
			size: 'small',
			title: 'Confirmation',
			buttons: {
				warning: {
					label: "Cancel",
					className: "btn-warning"
				},
				success: {
					label: "Yes",
				   	className: "btn-success",
				   	callback: function() {
						subscriptionService.renewSubscrip(produCode).then(function(response) {
								$scope.listofviewSubscription();
								toastr.success('Renewed successfully');
							}, function(error){
							});
						}
			   	}
		  	}
	  	};
	  	$ngBootbox.customDialog(options);
	};

    
    

       

    
}]);

'use strict';
angular.module('AngularApp').controller('subexpiryReportController', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'paymentService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, authService, paymentService, $ngBootbox, toastr) {

    $scope.subexpiryTotal = [];
    $scope.subexpiryData = [];
    $scope.today_dt = new Date();
    $scope.ExportType = "";
    $scope.chartHide = true;

    $scope.exportData = function (type) {

        $scope.date = new Date();
        $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");

        if ($scope.selected_days == 1 || $scope.selected_days == 2) {
            var filename = authService.authentication.doctor_name + "_Subscription_Expiry_Report_" + $scope.from_date;
        } else {
            var filename = authService.authentication.doctor_name + "_Subscription_Expiry_Report_" + $scope.from_date + "_to_" + $scope.to_date;
        }

        if (type == 'pdf') {
            var pdf_element = document.getElementById('printtable');
            var opt = {
                margin: 0.7,
                filename: filename + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'a3', orientation: 'landscape' }
            };

            //New Promise-based usage:
            html2pdf().set(opt).from(pdf_element).save();
        } else if (type == 'csv') {

            alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true,separator:','}) FROM HTML('#Printingcsv',{headers:true,separator:','})");

        }

        /*Old monolithic-style usage:
          html2pdf(element, opt);*/

        /*$scope.date = new Date();
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Wallet_Transact_Report" + $scope.formattedDate;
  
          if(type == 'PDF') {
              html2canvas(document.getElementById('printtable'), {
                  onrendered: function (canvas) {
                      var data = canvas.toDataURL();
                      var docDefinition = {
                          content: [{
                              image: data,
                              width: 500,
                          }]
                      };
                      pdfMake.createPdf(docDefinition).download("" + filename + ".pdf");
                  }
              });
          }*/
    }

    function start_endOfWeek(date, start, end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        return [year + "-" + month + "-" + day, day + "-" + month + "-" + year];
    }

    function getPreviousDate(days, value) {
        var dateOffset = parseInt(days * value);
        var convertDate = new Date();
        convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;
    }

    $scope.changeDay = function (day) {

        if (day == "5") {
            $scope.Date1 = "";
            $scope.Date2 = "";
            $scope.from_date = "";
            $scope.to_date = "";
        }


        switch (day) {
            case "4":
                var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
                var datArr = getStringDate(new Date(prevMonthFirstDate));
                $scope.from_date = datArr[1];
                $scope.Date1 = new Date(prevMonthFirstDate);
                var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
                var datArr2 = getStringDate(new Date(prevMonthLastDate));
                $scope.to_date = datArr2[1];
                $scope.Date2 = new Date(prevMonthLastDate);
                $scope.subexpiryReportData();
                break;
            case "3":
                var startLastWeek = start_endOfWeek(new Date(), 1, -6).toString();
                var datArr = getStringDate(new Date(startLastWeek));
                $scope.from_date = datArr[1];
                $scope.Date1 = new Date(startLastWeek);
                var endLastWeek = start_endOfWeek(new Date(), -6, 0).toString();
                var datArr2 = getStringDate(new Date(endLastWeek));
                $scope.to_date = datArr2[1];
                $scope.Date2 = new Date(endLastWeek);
                $scope.subexpiryReportData();
                break;
            case "2":
                var tempArray = getPreviousDate(1, 1);
                $scope.from_date = tempArray.getDate() + '-' + (tempArray.getMonth() + 1) + '-' + tempArray.getFullYear();
                //$scope.to_date = $scope.selectedFromDate; 
                $scope.to_date = $scope.from_date;
                $scope.Date1 = tempArray;
                $scope.Date2 = $scope.Date1;
                $scope.subexpiryReportData();
                break;
            case "1":
                var datArr = getStringDate(new Date());
                $scope.from_date = datArr[1];
                $scope.to_date = $scope.from_date;
                //$scope.to_date = $scope.selectedFromDate; 
                $scope.Date1 = new Date();
                $scope.Date2 = $scope.Date1;
                $scope.subexpiryReportData();
                break;
        }
    }

    $scope.subexpiryReportData = function () {

        var from_date = $filter('date')($scope.Date1, "yyyy-MM-dd");
        var to_date = $filter('date')($scope.Date2, "yyyy-MM-dd");

        var payload = {
            account_email: authService.authentication.account_id,
            doctor_id: parseInt(authService.authentication.doctor_id),
            from_date: from_date,
            to_date: to_date
        }

        paymentService.getsubexpiryreport(payload).then(function (response) {

            toastr.success('Updated Successfully');
            if (response.status == 1) {
                if(response.data.length > 0){
                    $scope.hidetable = false;
                    $scope.subexpiryData = response.data;
                } else {
                    $scope.hidetable = true;
                }
            } else {
                $scope.subexpiryTotal = [];
                $scope.subexpiryData = [];
                $scope.chartHide = true;
                $scope.hidetable = true;
            }
        }, function (error) {
            toastr.error(error);
            $scope.chartHide = true;
        });
    }

    $scope.rangePicker1 = {
        opened: { fromDate: false, toDate: false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate: false, toDate: false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            // maxDate: new Date()
        }
    };

    $scope.byRange = function (from, to, range_no) {

        if (range_no == "1") {

            $scope.rangePicker2 = {
                opened: { fromDate: false, toDate: false },
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                dateOptions: {
                    formatYear: 'yyyy',
                    startingDay: 0,
                    // maxDate: new Date(),
                    minDate: from
                }
            };

            $scope.from_date = $filter('date')(from, "dd-MMM-yyyy");

        } else if (range_no == "2") {

            $scope.rangePicker1 = {
                opened: { fromDate: false, toDate: false },
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear() - 20)),
                dateOptions: {
                    formatYear: 'yyyy',
                    startingDay: 0,
                    maxDate: to
                }
            }

            $scope.to_date = $filter('date')(to, "dd-MMM-yyyy");
        }

        if ($scope.from_date && $scope.to_date) {
            $scope.subexpiryReportData();
        }
    }

}]);


'use strict';

angular.module('AngularApp').controller('supervisorController', ['$scope','$rootScope', '$location','$filter', 'authService', 'locationService', '$ngBootbox','$sessionStorage','toastr','multicenterstudyreportService',
function ($scope, $rootScope, $location,$filter , authService, locationService, $ngBootbox,$sessionStorage,toastr, multicenterstudyreportService) { 
       

    $scope.timeInputDisable = true;

    $scope.exportData = function(type) {

      if($scope.supervisorfollowup) {
 
          $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
          var filename = "Supervisor_followup_report_"+$scope.formattedDate;
          
          if($scope.selectedFromDate && $scope.selectedToDate){
              filename = "Supervisor_followup_report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
          }
          
         /* if(type=='csv') {

              alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
              
          } else*/
          if(type == 'excel') {

              //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                  var blob = new Blob([document.getElementById('printtable').innerHTML], {
                      type: "application/vnd.ms-excel;charset=utf-8"
                  });
               saveAs(blob, filename+".xls");

          } else if(type=='pdf') {

              var pdf_element = document.getElementById('printtable');
              var opt = {
                  margin:      0.2,
                  filename:   filename,
                  image:       { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF:       { unit: 'in', format: 'a2', orientation: 'landscape' }
              };
                  
              //New Promise-based usage:
              html2pdf().set(opt).from(pdf_element).save();
                  
          }
      }
  }

    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
          formatYear: 'yyyy',
          startingDay: 0,
          maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date(),
        }
    };

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }
    $scope.labelHide = true
    $scope.getsupervisorfollowup = function() {
      if($scope.selectedFromDate2 && $scope.selectedToDate2 != ''){
        var data = {
          account_id: authService.authentication.account_id,
          from_date: $scope.selectedFromDate2,
          to_date : $scope.selectedToDate2
      }
      console.log(data,'supervisor');
      multicenterstudyreportService.getsupervisorReport(data).then(function(response) {
        if(response.success == 1){
          if(response.data.length > 0){
            $scope.labelHide = false
            $scope.supervisorfollowup = response;
            console.log($scope.supervisorfollowup);
          } else {
            $scope.labelHide = true
            $scope.errMsg = 'Data is not available on this period'
          }
        }else {
          $scope.labelHide = true
          $scope.errMsg = 'Data is not available on this period'
        }

         
      },function(error) {
          // toastr.error(error);
          // $scope.labelHide = false
          // toastr.error('Enter from & to')
          analytics('getsupervisorfollowupStatus',error);
      })
      }else{
          toastr.error('Enter from & to')
      }
    };

    // $scope.getsupervisorfollowupStatus()
   
}]);
'use strict';
angular.module('AngularApp' ).controller('tabController', ['$scope', '$location', '$rootScope', '$filter', '$ngBootbox', 'BudsStore', 'toastr', 'authService', 'tabsService', function ($scope, $location, $rootScope, $filter, $ngBootbox, BudsStore, toastr, authService, tabsService) {
            $scope.count = 0;
            $scope.consultcount = 0;
            $scope.getConsultationTabs = function () {
              tabsService.getconsultionSettings().then(function(response) {
                   $scope.allTabs = response.consultation_setting;
                   console.log(' $scope.allTabs', $scope.allTabs);
                   for(var i=0;i< ($scope.allTabs.length);i++){
                         if(response.consultation_setting[i].status == true){
                             $scope.count += 1;
                         }
                   }

             },function(error) {
                    toastr.error(error,'Try again...');
                    //analytics('addNewComplaint','Try again');
                })
            }


            $scope.consultation_checkbox = function(data){
                if(data.status == true) {
                    $scope.count += 1;
                    if($scope.count == 9) {
                        $scope.moreTabselectionAlert();
                    }
                }else{ 
                    $scope.count -= 1;
                }       
            }

            $scope.category_checkbox = function(data){
                if(data.status == true) {
                    $scope.consultcount += 1;
                    if($scope.consultcount == 9) {
                        $scope.moreTabselectionAlert();
                    }
                }else{ 
                    $scope.consultcount -= 1;
                }       
            }

            $scope.moreTabselectionAlert = function() {
                var options = {
                    title: '<b>Alert</b>',
                    message:'For best fit and view in Tablets it is recommended to select 8 Tab only',
                    size:'medium',
                   // onEscape: function(){$scope.createBtn = "Initiate call";},
                    buttons: {
                        ok:{
                            label: "ok",
                            className: "btn-success",
                            callback: function() {}
                        },
                    }
                }
                $ngBootbox.customDialog(options);
            };
   
            
            $scope.getCategoryTabs = function () {
               
                tabsService.getcategorySettings().then(function(response) {
                     $scope.allTcategoryabs = response.category_setting;
                     for(var i=0;i< ($scope.allTabs.length);i++){
                        if(response.category_setting[i].status == true){
                            $scope.consultcount += 1;
                        }
                  }
                     
               },function(error) {
                      toastr.error(error,'Try again...');
                      //analytics('addNewComplaint','Try again');
                  })
                 
              }
            
            $scope.getConsultationTabs();
            $scope.getCategoryTabs();

            $scope.enableAllConsultationSettings = function (consultarray) {
                var options = {
                    title: '<b>Alert</b>',
                    message:'All the top layer tabs would be visible',
                    size:'medium',
                   // onEscape: function(){$scope.createBtn = "Initiate call";},
                    buttons: {
                        ok:{
                            label: "Confirm",
                            className: "btn-success",
                            callback: function() {
                                for (var i = 0; i < consultarray.length; i++) {
                                    consultarray[i].status = true;
                                }
                                $scope.saveConsultationSettings(consultarray) 
                            }
                        },
                        close : {
                            label: "Cancel",
                            className: "btn-danger",
                            callback: function() {
                                $scope.createBtn = "Initiate call";
                            }
                        }
                    }
                }
                $ngBootbox.customDialog(options);
            }
            $scope.disableAllConsultationSettings = function (consultarray) {
                var options = {
                    title: '<b>Alert</b>',
                    message:'All the tabs shall be disabled and not available for view except Consultation',
                    size:'medium',
                   // onEscape: function(){$scope.createBtn = "Initiate call";},
                    buttons: {
                        ok:{
                            label: " Confirm",
                            className: "btn-success",
                            callback: function() {
                                $scope.count = 0;
                                for (var i = 0; i < consultarray.length; i++) {
                                    consultarray[i].status = false;
                                }
                                $scope.saveConsultationSettings(consultarray) 
                            }
                        },
                        close : {
                            label: " Cancel",
                            className: "btn-danger",
                            callback: function() {
                                $scope.createBtn = "Initiate call";
                            }
                        }
                    }
                }
                $ngBootbox.customDialog(options);
            }

            $scope.enableAllCategorySettings = function (categoryarray) {
                var options = {
                    title: '<b>Alert</b>',
                    message:'All the top layer tabs would be visible',
                    size:'medium',
                   // onEscape: function(){$scope.createBtn = "Initiate call";},
                    buttons: {
                        ok:{
                            label: "Confirm",
                            className: "btn-success",
                            callback: function() {
                                for (var i = 0; i < categoryarray.length; i++) {
                                    categoryarray[i].status = true;
                                }
                                $scope.saveCategorySettings(categoryarray) 
                            }
                        },
                        close : {
                            label: "Cancel",
                            className: "btn-danger",
                            callback: function() {
                                $scope.createBtn = "Initiate call";
                            }
                        }
                    }
                }
                $ngBootbox.customDialog(options);
            }
            $scope.disableAllCategorySettings = function (categoryarray) {
                var options = {
                    title: '<b>Alert</b>',
                    message:'All the tabs shall be disabled and not available for view except Consultation',
                    size:'medium',
                   // onEscape: function(){$scope.createBtn = "Initiate call";},
                    buttons: {
                        ok:{
                            label: " Confirm",
                            className: "btn-success",
                            callback: function() {
                                $scope.count = 0;
                                for (var i = 0; i < categoryarray.length; i++) {
                                    categoryarray[i].status = false;
                                }
                                $scope.saveCategorySettings(categoryarray) 
                            }
                        },
                        close : {
                            label: " Cancel",
                            className: "btn-danger",
                            callback: function() {
                                $scope.createBtn = "Initiate call";
                            }
                        }
                    }
                }
                $ngBootbox.customDialog(options);
            }

            $scope.saveConsultationSettings = function (consultarray) {
               
            for (var i = 0; i < consultarray.length; i++) {
                if (consultarray[i].status) {
                    consultarray[i].status = true;
                    break;
                }
            }
            var stringJson = JSON.parse(angular.toJson(consultarray));
            console.log('stringJson',stringJson);
                var data = {
                    account_email: authService.authentication.account_id,
                    doctor_id: authService.authentication.doctor_id,
                    consultation_setting: stringJson
                };
                tabsService.tabssettingUpdate(data).then(function(response) {
                   toastr.success('Update successfully');
                    $rootScope.newSubscription = { plan_name:'', dur_days:'', amount:''};
                },function(error) {
                    toastr.error(error,'Try again...');
                    //analytics('addNewComplaint','Try again');
                })
            }

            $scope.saveCategorySettings = function (categoryarray) {
                for (var i = 0; i < categoryarray.length; i++) {
                    if (categoryarray[i].status) {
                        categoryarray[i].status = true;
                        break;
                    }
                }
                var stringJson = JSON.parse(angular.toJson(categoryarray));
                
                    var data = {
                        account_email: authService.authentication.account_id,
                        doctor_id: authService.authentication.doctor_id,
                        category_setting: stringJson
                    };
                    tabsService.categoryssettingUpdate(data).then(function(response) {
                       toastr.success('Update successfully');
                        $rootScope.newSubscription = { plan_name:'', dur_days:'', amount:''};
                    },function(error) {
                        toastr.error(error,'Try again...');
                        //analytics('addNewComplaint','Try again');
                    })
            }
}]);
'use strict';
angular.module('AngularApp').controller('timeController', [ 'uiCalendarConfig','$scope', '$rootScope', '$location', 'authService',
    'accountService', 'recordService', 'localStorageService', '$filter', '$ngBootbox','$timeout',
 function ( uiCalendarConfig, $scope, $rootScope, $location, authService,accountService, recordService, localStorageService, $filter, $ngBootbox, $timeout) {



$rootScope.time1=['06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'];
$rootScope.time2=['06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'];

$scope.changeApp =function(val,slot){

 var $selects = $('#SelEnd');
        var value = val;
        if (value == "") {
            return false;
        }
        $selects.not(this).each(function () {
            $('option', this).each(function () {
                var sel = $(this).val();
                if (sel <= value) {
                    $(this).prop('disabled', true);
                } else {
                    $(this).prop('disabled', false);
                }
            });
        });
alert(slot);
$scope.testtime = []
  var v = val.split(':');
  var t = parseInt(v[0])
 if(slot==1){
  for(var i=0;t<=23;i++){
     var s = t + parseInt(slot);
     if(s.toString().length==1) 
     var a = '0'+s+':00'
     else
      var a = s + ':00'
     $scope.testtime.push(a);
     t = s;
  };
};



  if(slot==2){
  for(var i=0;t<=22;i++){
     var s = t + parseInt(slot);   
     $scope.testtime.push(s);
     t = s;
  };
};

};
} ]);
/**
 * @author Helyxon Healthcare Solutions Private Limited
 * created on Dec 2017
 */

'use strict'
angular.module('AngularApp').controller('twostepverifyController', ['$scope', '$rootScope', 'authService', 'toastr', '$sessionStorage', '$sce', 'Pubnub', '$pubnubChannel', '$location', 'localStorageService', 'mainUrl', '$interval',
    function ($scope, $rootScope, authService, toastr, $sessionStorage, $sce, Pubnub, $pubnubChannel, $location, localStorageService, mainUrl, $interval) {

        $scope.twostepauthcode = sessionStorage.getItem('twostepac');

        $scope.loadframe = function () {
            $rootScope.newiframe = $sce.trustAsResourceUrl(mainUrl + '/docAuth/?' + 'ac=' + $scope.twostepauthcode);
        }
        $scope.loadframe()

        window.onmessage = function (e) {
            if (e.data.message == 'resend') {
                var params = {
                    "account_email": authService.authentication.account_id,
                    "doctor_id": authService.authentication.doctor_id
                }
                authService.initiatedocauthlogin(params).then(function (response) {
                    toastr.success("SMS sent successfully")
                })

            }
            if (e.data.message == 'refresh') {
                $scope.loadstateinfo()
            }
        }

        $rootScope.hideHeader = true
        $rootScope.foot = true
        Pubnub.init({
            publishKey: 'pub-c-c3cecd91-62bc-4365-b2d1-a6333576f17f',
            subscribeKey: 'sub-c-60c79014-12d7-11e8-b32f-5ea260837941',
            uuid: authService.authentication.account_id
        });
        var account_idss = authService.authentication.account_id
        Pubnub.subscribe({
            channels: ['doctor_login_auth_' + account_idss + '_' + authService.authentication.doctor_id],
            withPresence: true,
            triggerEvents: ['callback', 'message', 'presence']
        });

        // Send the messages over PubNub Network
        Pubnub.addListener({
            presence: function (m) {
            },
            message: function (message) {
                if (message.message == "true") {
                    localStorageService.set('twofactorapprove', true)
                    $interval.cancel(promise);
                    $rootScope.hideHeader = false
                    $rootScope.foot = false
                    $location.path('/home');
                    $scope.$apply();
                } else if (message.message == "false") {
                    $interval.cancel(promise);
                    $rootScope.hideHeader = false
                    $rootScope.foot = false
                    toastr.error("Access denied")
                    $location.path('/logout');
                    $scope.$apply();
                }
            }
        });

        $scope.loadstateinfo = function () {
            authService.getstateinfo().then(function (response) {
                if (response.doctors.success == 1) {
                    if (response.doctors.details.status == 2) {                          //0 do nothing , 1 not approved, 2 approved
                        localStorageService.set('twofactorapprove', true)
                        $interval.cancel(promise);
                        $rootScope.hideHeader = false
                        $rootScope.foot = false
                        $location.path('/home');
                        $scope.$apply();
                    } else if (response.doctors.details.status == 1) {
                        $interval.cancel(promise);
                        $rootScope.hideHeader = false
                        $rootScope.foot = false
                        toastr.error("Access denied")
                        $location.path('/logout');
                        $scope.$apply();
                    }
                }
            })
        }
        var promise = $interval(function () { $scope.loadstateinfo(); }, 60 * 1000);
    }])

     //     Pubnub.init({
    //         subscribeKey: "sub-c-60c79014-12d7-11e8-b32f-5ea260837941",
    //   publishKey: "pub-c-c3cecd91-62bc-4365-b2d1-a6333576f17f",
    //   uuid: "rx4@rxcarenet.org",

    //     })
    //     var account_idss = "rx4@rxcarenet.org"
    //     Pubnub.publish({

    //                    "channel": account_idss.replace('@', '_').replace('.org', ''),
    //                    "message": "helllllo"
    //                 }, function(status, response){
    //                    //handle publish response if needed
    //                 });
'use strict';
angular.module('AngularApp').controller('vaccinationController', ['$scope', '$rootScope', '$location', '$route', '$filter', 'recordService', function ($scope, $rootScope, $location, $route, $filter, recordService) {
  	 if (!$route.current.params.Id) {
		$location.path("/home");
	  return;
	 }
	 var recordId = $route.current.params.Id; 
	 $scope.recordId = recordId;


	  $scope.loadChartData = function(){
		 $scope.dataLoaded = false;
	
		 
		 $scope.record = {
		 	name: "",
		 	dob: "",
		 	gender: ""
		 };

		 recordService.getRecordInfo(recordId).then(function(recordInfoResponse){
				 $scope.record = { 	
				 	name: recordInfoResponse.record_info.Record.label,	
				 	dob: new Date(recordInfoResponse.demographics[0].bday),	
				 	gender:recordInfoResponse.demographics[0].gender
				 };
			
		 		var dobMoment  = moment($scope.record.dob);

		 		$scope.recordAge = {
		 			years : parseInt(moment().diff(dobMoment,'year',true)),
		 			months: parseInt(moment().diff(dobMoment,'month',true)%12)
		 		};
		 		$scope.dataLoaded = true;
		 	
		  },function (err, response) {
                   $ngBootbox.alert(err.Message);
                   analytics('loadChartData',err.Message);
        });
	};

	//function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
		var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'vaccinationController',
            'event_label' : aLabel
        });
     }

	$scope.loadChartData();

}]);


'use strict';
angular.module('AngularApp').controller('vaccineReminderController', ['$scope', '$rootScope', '$location', '$route', '$filter', 'authService', 'recordService', 'vaccineService', function ($scope, $rootScope, $location, $route, $filter, authService, recordService, vaccineService) {
	
    $scope.ExportType = "EXCEL";

	function stringDate(date){
	  var day   = date.getDate();
	  var month = date.getMonth()+1;
	  var year  = date.getFullYear();
		
	 return "" + day + "/" + month + "/" + year;
	}

	function parseDate(str) {
	  var mdy = str.split('/');

	 return new Date( mdy[2], mdy[1], mdy[0] );
	}
	  
	function datediff(first, second) {
	 return Math.round((second-first)/(1000*60*60*24));
	}
  
	$scope.fromoptions = {
		maxDate: new Date()
	}


	$scope.vaccineDate = function(){
		// var date1 = new Date();
		// var date2 = value1;
		// var days  = datediff(parseDate(stringDate(date2)), parseDate(stringDate(date1)));
		$scope.value1 = $filter('date')(new Date($scope.Date1),'yyyy-MM-dd');
		$scope.value2 = $filter('date')(new Date($scope.Date2),'yyyy-MM-dd')
		$scope.gender = $scope.selected_gender

		console.log("vlaue1", $scope.value1)

		$scope.fromoptions = {
			maxDate: $scope.value2
			// maxDate: new Date()
		}

		$scope.tooptions = {
			minDate: $scope.value1,
			// maxDate:new Date()
		}

		console.log("val1",$scope.value1,$scope.value2);
        if($scope.gender){
			$scope.vaccineReminder($scope.value1,$scope.value2); 	   
		} 
	}

  
	$scope.vaccineReminder = function(val1, val2){
		console.log("val 102",val1,val2)
		var payload = {
	  	  "account_email" : authService.authentication.account_id,
		  "from_day": val1,
		  "to_day" : val2,
		  "gender": $scope.gender,
		} 
		
		vaccineService.getVaccineReminder(payload).then(function(response){
		   $scope.vaccineReminderData = response[0].row_to_json;
		});	
	}

	$scope.printPaymentToPaper = function(id) {
		if($scope.vaccineReminderData) {
			var innerContents = document.getElementById('printtable').innerHTML;
			var popupWinindow = window.open('', '_blank',
			'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
			popupWinindow.document.open();
			popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="Content/temp.css" /><link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css" rel="stylesheet" media="all"/> <script data-require="angular.js@1.2.x" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.4/angular.min.js" data-semver="1.2.17"></script><style>@media print{#noprint{display:none;} .active th {background-color: lightgrey !important; font-size:110%; text-align:center;} .activerow td{padding: 5px 5px !important;}} @page { font-family:Myriad Pro, Myriad, Helvetica Neue !important; size: auto; margin-top:2cm;margin-left:2cm;margin-bottom:2cm;} .form-control{border: 0;height:20px;width:30%;overflow:visible;} table{ font-size: 90%; page-break-inside:avoid; } pre{ word-break: break-word; white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; font-family:Myriad Pro, Myriad, Helvetica Neue !important;font-size:100% !important; padding: 0px; margin: inherit; line-height: 1; color: 142E3C !important;background-color: #fff; border: 0px; border-radius: 0px; } label{ page-break-inside:avoid; }</style> </head><body onload="window.print()" style="font-size: 120%;">' + innerContents + '</html>');
			popupWinindow.document.close();
		}
    };
	
	$scope.exportData = function (type) {
      if($scope.vaccineReminderData) {		  
        $scope.date = new Date();
		$scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
		var filename='Vaccination_';
		if(authService.authentication.account_info.Account.fullName) {
		   filename = filename+''+authService.authentication.account_info.Account.fullName+"_"+$scope.formattedDate;
		} else {
		   filename = filename+''+$scope.formattedDate;
		} 
        if(type == 'CSV') {
            alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#exportable',{headers:true})");
        } else if(type == 'EXCEL') {
         // alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
            var blob = new Blob([document.getElementById('printtable').innerHTML], {
                type: "application/vnd.ms-excel;charset=utf-8"
            })
            saveAs(blob, filename+".xls");
        } else if(type == 'PDF') {
                html2canvas(document.getElementById('exportable'), {
                    onrendered: function (canvas) {
                        var data = canvas.toDataURL();
                        var docDefinition = {
                            content: [{
                                image: data,
                                width: 500,
                            }]
                        };
                        pdfMake .createPdf(docDefinition).download("" + filename + ".pdf");
                    }
                });
		}
	  }
    };

}]);



'use strict';
angular.module('AngularApp').controller('vendorController', ['$scope','$rootScope', '$location', 'authService','$ngBootbox','vaccineService',
function ($scope, $rootScope, $location, authService, $ngBootbox, vaccineService) {

$rootScope.vendorList=[];
$scope.showVendor=function(){
    vaccineService.listVendor().then(function(response){
        $rootScope.vendorList=response;
   $scope.vendorList.loaded = true;
    });   

};

$scope.showVendor();


$scope.vacciVendor=function(){
    vaccineService.vaccivendorlist().then(function(response){
        $scope.vacci=response['vaccination_vendors'];
        $scope.vacci.loaded = true;
    });   

};
 
 
$scope.vacciVendor();
$scope.order=function(){
  $rootScope.orderdata = [];
    vaccineService.orderList().then(function(response){
        if(response['orders'].length!=0){
          $rootScope.orderdata=response['orders'];
          $scope.orderdata.loaded=true;
          $scope.info=true;
          $scope.noData=false;
        }else{
          $scope.noData=true;
          $scope.info=false;
        }
        
     });   

   };

$scope.order();

$scope.status1=true;
$scope.closed1=false;
$scope.pending=false;
$scope.ok=false;
$scope.saveorder=function(data, id){
$scope.ok=true;
var order1={

    "order_id": id, 

    "order_details":[

        {"order_item_pk":data.order_item_pk, 

         "delivered_qty":parseInt(data.delivered_qty), 

         "comments": data.comments, 

        }
    ]
  }

  vaccineService.updateOrder(order1).then(function(response){
    $rootScope.orderdata = [];
     location.reload();
});
};


$scope.getVac=function(id){
var valu='';

   angular.forEach($rootScope.vaccineDict1, function(value, key){
         if(value.pk ==id ){
          valu=value.fields.drug_name;
        }
      });
   return valu;
};

$scope.cancel1 = function () {  
   $rootScope.orderdata = [];
   $location.path('/order');

};


$scope.addsupplier = function(){
            $rootScope.vendor = {name:"",contact1:"",contact2:"",email:"",address1:"",address2:"",state:"",city:"",pin_code:"",};
            var options = {
          title: '<b><span class="fa fa-users"></span> Add Vendor</b>',
            templateUrl: 'views/addvendor.htm',
             onEscape:true,
            buttons: {
                 ok: {
                     label: " Add",
                     className: "btn-primary fa fa-plus",
                      callback: function() {

                        if($rootScope.vendor.name!=""||$rootScope.vendor.contact1!=""||$rootScope.vendor.email!=""){
                          var data={"account_email":authService.authentication.account_id,
                         "name":$rootScope.vendor.name, 
                         "contact1":$rootScope.vendor.contact1 , 
                         "contact2":$rootScope.vendor.contact2 , 
                         "email":$rootScope.vendor.email , 
                         "address1":$rootScope.vendor.address1 , 
                         "address2":$rootScope.vendor.address2 , 
                         "state":$rootScope.vendor.state , 
                         "city":$rootScope.vendor.city, 
                         "pin_code":$rootScope.vendor.pin_code }
                         
                        vaccineService.addVendor(data).then(function(response){
                            $scope.showVendor();
                            $scope.vacciVendor();
                        });
                      }else{
                        $ngBootbox.alert("Please fill all mandatory fields and try again.");
                      }
                      	

                      }
                 },
                 cancel:{
                     label: " Cancel",
                     className: "btn-danger fa fa-times",
                    callback: function() {
                    }
                 }
            }

        }

        $ngBootbox.customDialog(options);
    };

   
$scope.ed=true;
   
$scope.invList=[];
$scope.showInventory=function(){
 vaccineService.listinventory().then(function(response){
    $scope.invList=response['vaccine_inventory'];	
   for(i=0;i<$scope.invList.length;i++)
   {
if($scope.invList[i].stock>0)
$scope.ed=false;
$scope.invList.loaded = true;  
} 
     }); 
     

};
$scope.showInventory();
$scope.dat=false;

$scope.Stedit=function(){
  $scope.dat=true;
  $scope.ca = true;
};

$scope.closeEdit = function(){
  $scope.dat=false;
  $scope.ca=false;
};


$scope.saveInventry=function(data){

  $scope.dat=false;
  var data1={
    "vaccine_inventory": [
      {
        "pk": data[0].pk,
        "stock": data[0].stock
      },
       {
        "pk": data[1].pk,
        "stock": data[1].stock
      },
      {
        "pk": data[2].pk,
        "stock": data[2].stock
      },
       {
        "pk": data[3].pk,
        "stock": data[3].stock
      },
       {
        "pk": data[4].pk,
        "stock": data[4].stock
      },
      {
        "pk": data[5].pk,
        "stock": data[5].stock
      },
      {
        "pk": data[6].pk,
        "stock": data[6].stock
      },
      {
        "pk": data[7].pk,
        "stock": data[7].stock
      },
      {
        "pk": data[8].pk,
        "stock": data[8].stock
      },
       {
        "pk": data[9].pk,
        "stock": data[9].stock
      },
      {
        "pk": data[10].pk,
        "stock": data[10].stock
      },
      {
        "pk": data[11].pk,
        "stock": data[11].stock
      },
       {
        "pk": data[12].pk,
        "stock": data[12].stock
      },
      {
        "pk": data[13].pk,
        "stock": data[13].stock
      },
       {
        "pk": data[14].pk,
        "stock": data[14].stock
      },
       {
        "pk": data[15].pk,
        "stock": data[15].stock
      },
       {
        "pk": data[16].pk,
        "stock": data[16].stock
      },
      {
        "pk": data[17].pk,
        "stock": data[17].stock
      },
       {
        "pk": data[18].pk,
        "stock": data[18].stock
      },
      {
        "pk": data[19].pk,
        "stock": data[19].stock
      },
       {
        "pk": data[20].pk,
        "stock": data[20].stock
      },
      {
        "pk": data[21].pk,
        "stock": data[21].stock
      },
      {
        "pk": data[22].pk,
        "stock": data[22].stock
      },
       {
        "pk": data[23].pk,
        "stock": data[23].stock
      },
      {
        "pk": data[24].pk,
        "stock": data[24].stock
      },
       {
        "pk": data[25].pk,
        "stock": data[25].stock
      },
       {
        "pk": data[26].pk,
        "stock": data[26].stock
      },
       {
        "pk": data[27].pk,
        "stock": data[27].stock
      },
     {
        "pk": data[28].pk,
        "stock": data[28].stock
      },
      {
        "pk": data[29].pk,
        "stock": data[29].stock
      },
      {
        "pk": data[30].pk,
        "stock": data[30].stock
      },
       {
        "pk": data[31].pk,
        "stock": data[31].stock
      },
      {
        "pk": data[32].pk,
        "stock": data[32].stock
      },
       {
        "pk": data[33].pk,
        "stock": data[33].stock
      },
       {
        "pk": data[34].pk,
        "stock": data[34].stock
      },
       {
        "pk": data[35].pk,
        "stock": data[35].stock
      },
      {
        "pk": data[36].pk,
        "stock": data[36].stock
      },
     {
        "pk": data[37].pk,
        "stock": data[37].stock
      },
       {
        "pk": data[38].pk,
        "stock": data[38].stock
      }
  ]}
    vaccineService.updateInventory(data1).then(function(response){

});

 $scope.showInventory();
};


$scope.update=function(){
   }


$scope.edit=function(){
$scope.editMode = true;     
 if($scope.vac.qty==$scope.vac.delivered_qty)

$scope.editMode = true;
};

 $scope.orderDetails= function(value){
    vaccineService.getOrderDetail(value).then(function(response){
  $rootScope.order_id=response['order'];
  $rootScope.order_item=response['order_items'];
  if($rootScope.order_id!=undefined){
    $location.path("details");
    $scope.$apply();
  }
});      
};


$scope.vendorlist1 = function(value){
  $rootScope.val={vaccine:value.vaccination,lead_time:value.lead_time,pk:value.pk,minimum_order_qty:value.minimum_order_qty,vaccination_id:value.vaccination_id}
      var options = {
          title: '<b><span class="fa fa-users"></span> Choose Vendor</b>',
            templateUrl: 'views/updatevendor.htm',
             onEscape:true,
           
            buttons: {
                 ok: {
                     label: " Save",
                     className: "btn-primary fa fa-save",
                     callback: function() {
                        

                        var data={"vaccination_vendors": [{
                          "vendor_id":$rootScope.vendorData.pk,
                         "pk":$rootScope.val.pk , 
                         "vaccination_id":$rootScope.val.vaccination_id ,
                         "minimum_order_qty":$rootScope.vacci.minimum_order_qty , 
                         "lead_time":$rootScope.vacci.lead_time , 
                          }]}
                         
                        vaccineService.updateVendor(data).then(function(response){
                            $scope.vacciVendor();
                        });
                        $rootScope.vendorData={}
                        $rootScope.vacci={}
                       }
                      
                 },
                 cancel:{
                     label: " Cancel",
                     className: "btn-danger fa fa-times",
                    callback: function() {
                    }
                 }
            }

        }
        
        $ngBootbox.customDialog(options);
    };


}]);
'use strict';
angular.module('AngularApp').controller('videocallController', ['$scope', '$rootScope', '$location', '$filter', '$timeout', '$sessionStorage', 'authService', 'recordService', 'paymentService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, $timeout, $sessionStorage, authService, recordService, paymentService, $ngBootbox, toastr) {
  
    $scope.audioMicShow = 'true';
    $rootScope.hideHeader = true;
    $rootScope.showFooter = false;
    $scope.disconnectNotify = true;
    $scope.showVideoPanel = true;
    $scope.participantConnected = false;
  //$scope.liveVdoHide = true;
    document.getElementById("end_room").disabled = true;
    var audio_mute = false; 
    var video_pause = false; 
    var end_btn_click = false;

    $scope.notifyBar = function( value ) {
        $.notify.addStyle('notibar', {
          html: 
            "<div class='title' style='padding-right: 10px;' data-notify-html='title'/></div>" 
        });
        $.notify({
            title: 'Patient had '+value,
            button: 'Join'
        }, { 
          style: 'notibar',
          autoHide: true,
          clickToHide: false
        });      
    }
    $scope.notifyBar2 = function( value ) {
      $.notify.addStyle('notibar2', {
        html: 
          "<div class='title' style='padding-right: 10px;' data-notify-html='title'/></div>" 
      });
      $.notify({
          title: value,
          button: 'Join'
      }, { 
        style: 'notibar2',
        autoHide: false,
        clickToHide: false
      });      
  }
  //$scope.notifyBar('disconnected.'); 

    var Video = Twilio.Video;
  //var token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImN0eSI6InR3aWxpby1mcGE7dj0xIn0.eyJqdGkiOiJTSzQxY2Q2ZjllNjFiOGFmYjFjYWYwMmJkNDk0MGRmYjA2LTE1ODIyOTI1NDQiLCJncmFudHMiOnsidmlkZW8iOnsicm9vbSI6InJ4NEByeGNhcmVuZXQub3JnXzEifSwiaWRlbnRpdHkiOiJyYWplZXYifSwiaXNzIjoiU0s0MWNkNmY5ZTYxYjhhZmIxY2FmMDJiZDQ5NDBkZmIwNiIsImV4cCI6MTU4MjI5NjE0NCwibmJmIjoxNTgyMjkyNTQ0LCJzdWIiOiJBQ2Y3ZWQzNDQ1NzFlMzA2NzFiODMxYmJkMWE5MzFhYjdjIn0.B7J4te7rrggJwY4v-tAcLvDnztnh3vSldS-7TmygoA0";
    var token = $sessionStorage.get('video_access_token');
  //var room_name = $sessionStorage.get('video_room_name');
    var room_name = authService.authentication.account_id+'_'+authService.authentication.doctor_id;

    Video.connect(token, {name: room_name}).then( function (room) {   
      //console.log("Successfully joined a Room:"+room);
      //console.log("Connected to the Room as LocalParticipant "+localParticipant.identity);

      Video.createLocalVideoTrack().then( function (track) {
        var localMediaContainer = document.getElementById('local-media');
        localMediaContainer.appendChild(track.attach());

        //Log your Client's LocalParticipant in the Room
        var localParticipant = room.localParticipant;

        var muteButton = document.getElementById('mic_audio');
        muteButton.addEventListener('click', function (event) {
          if( audio_mute == false ) { 
           
            localParticipant.audioTracks.forEach(function (track) {
              track.track.disable();
              audio_mute = true;
              document.getElementById('mic_audio').style.backgroundColor = "red";
              $("#mic_image").removeClass("fa-microphone").addClass( "fa-microphone-slash" );
            });
            
          } else if( audio_mute == true ) {
            
            localParticipant.audioTracks.forEach(function (track) {
              track.track.enable();
              audio_mute = false;
              document.getElementById('mic_audio').style.backgroundColor = "#00A0E3";
              $("#mic_image").removeClass("fa-microphone-slash").addClass( "fa-microphone" );
            });
  
          }   
        });

        var videoStop = document.getElementById('video_stop');
        videoStop.addEventListener('click', function (event) {
          if( video_pause == false ) { 
           
            localParticipant.videoTracks.forEach(function (track) {
              track.track.disable();
              video_pause = true;
              document.getElementById('video_stop').style.backgroundColor = "green";
              $("#pause_image").removeClass("fa-pause").addClass( "fa-play" );
            });
            
          } else if( video_pause == true ) {
            
            localParticipant.videoTracks.forEach(function (track) {
              track.track.enable();
              video_pause = false;
              document.getElementById('video_stop').style.backgroundColor = "#00A0E3";
              $("#pause_image").removeClass("fa-play").addClass( "fa-pause" );
            });
  
          }   
        });
          
      //   var buttonElement = document.getElementById('video_stop');
      //   buttonElement.addEventListener('click', function (event) {
      //     //track.stop();
      //     //track.disable();
      //     //track.detach().forEach(element => element.remove());
      //     //localParticipant.unpublishTrack(track);   
      //     //$scope.callEndRoom();
      //   });
      });

      // Log any Participants already connected to the Room
      room.participants.forEach( function (participant) {  
        //console.log(`Participant "${participant.identity}" is connected to the Room`);  
        participant.tracks.forEach( function (publication) {
          if (publication.isSubscribed) {
            var track = publication.track;
          }
        });
        participant.on('trackSubscribed', function (track) {
          document.getElementById("end_room").disabled = false;
          document.getElementById('remote-media').appendChild(track.attach());
         // document.getElementById("connect_name").textContent = "Connected with "+participant.identity;
        
          $scope.participantConnected = true;
          // $scope.liveVdoHide = false;
        });
      });
        
      room.on('participantConnected', function( participant ) {     

        var init_var=0;
        var init_var2=0;
        //console.log("A remote Participant connected: "+participant);  
        participant.tracks.forEach( function (publication) {
          if (publication.isSubscribed) {
            var track = publication.track;
          }
        });
  
        participant.on('trackSubscribed', function (track) {    
          document.getElementById("end_room").disabled = false;          
          var track_item = track.attach();
          var old_item = document.getElementById('remote-media');
          // console.log("old item is"+(old_item.childNodes).length);
          var channel_length = (old_item.childNodes).length;
          console.log("channel_length is"+channel_length);
          if (channel_length > 1 ) {
            old_item.removeChild(old_item.firstChild);
            old_item.replaceChild(track_item , old_item.firstChild);
            for (var i = 1; i < channel_length; i++) {
                try {
                old_item.removeChild(old_item.firstChild);
                old_item.appendChild(track.attach());
                } catch(error) {
                    console.log("error is"+error);
                }
            }

            if( init_var2==0 ) {
              // $scope.notifyBar('rejoined');
              $('.notifyjs-notibar2-base').trigger('notify-hide');
              toastr.success( 'Patient had Rejoined' );
              init_var2++;
            }
          } else {
            // console.log("appending child");
            // console.log('else part channel_length'+channel_length);
            document.getElementById('remote-media').appendChild(track.attach());
            $scope.participantConnected = true;
            if( init_var==0 ) {
              // $scope.notifyBar('connected');
              toastr.success( 'Connected with Patient' );
              init_var++;
            }
           
            document.getElementById("connect_name").textContent = "Connected with "+participant.identity;
          }
          // old_item.replaceChild()
          // document.getElementById("connect_name").textContent = "Connected with "+participant.identity;
          // $scope.liveVdoHide = false;
        });  
      });

      room.on('disconnected', function (room) {
  
        var init_var=0;
        //Detach the local media elements
        room.localParticipant.tracks.forEach( function (publication) {

          if( end_btn_click != true ) {

            if( init_var==0 ) {
              //$scope.notifyBar2("Patient video is paused. Please wait.");
              toastr.error( 'Patient is Disconnected' );
              init_var++;

              $scope.disconnectNotify = false;  
            }
          }
          var attachedElements = publication.track.detach();
                  
          console.log("participant disconnected");
          //$scope.hideDisconnect(); 
          //$scope.disconnect_timer = 15;
         // attachedElements.forEach(element => element.remove());
         // $scope.raiseInvoice();
         // document.getElementById("end_room").disabled = true;
         // $scope.participantConnected = false;
         // $scope.showVideoPanel = false;
        });  
      });

      // $scope.hideDisconnect = function() {
      //   $scope.disconnect_timer--;
      //   if($scope.disconnect_timer==0){
      //     $scope.disconnectNotify = true;
      //     $timeout.cancel($scope.disconnect_promise);
      //   } 
      //   $scope.disconnect_promise = $timeout( $scope.hideDisconnect, 1000);
      // }

      // var buttonElement = document.getElementById('end_room');

      // buttonElement.addEventListener('click', function (event) {
      //   //alert('Element clicked through function!');
      //   //To disconnect from a Room
      //   room.disconnect();
      // });

        //  Log any Participants already connected to the Room
        //  room.participants.forEach(participant => {
        //  console.log(`Participant "${participant.identity}" is connected to the Room`);
        //  });

        //  // Log new Participants as they connect to the Room
        //  room.once('participantConnected', participant => {
        //  console.log(`Participant "${participant.identity}" has connected to the Room`);
        //  });

        //  Log Participants as they disconnect from the Room
        //  room.once('participantDisconnected', participant => {
        //  console.log(`Participant "${participant.identity}" has disconnected from the Room`);
        //  });

        //  room.on('participantConnected', function ( participant ) {
        //  console.log("Participant "+participant.identity+" connected.");
          
        //  participant.tracks.forEach(publication => {
        //    if (publication.isSubscribed) {
        //      const track = publication.track;
        //      document.getElementById('remote-media').appendChild(track.attach());
        //    }
        //  });
          
        //  participant.on('trackSubscribed', function (track ) {
        //     document.getElementById('remote-media').appendChild(track.attach());
        //  });
        // });

    }, function(error) {
        //console.error("Unable to connect to Room: "+error.message);
    });

     
    // Video.createLocalVideoTrack().then( function ( track ) {
    //   var localMediaContainer = document.getElementById('local-media');
    //   localMediaContainer.appendChild(track.attach());
    // });

    // Video.createLocalTracks({
    //     audio: true,
    //     video: { width: 640 }
    // }).then(localTracks => {
    //     return Video.connect(token, {
    //       name: 'rx4@rxcarenet.org_1',
    //       tracks: localTracks
    //     });
    // }).then(room => {
    //     console.log(`Connected to Room: ${room.name}`);
    // });

  /*$scope.callJoinRoom = function() {
      var payload = {
        patient_email: $sessionStorage.get('patientAccEmail'),
        account_email: authService.authentication.account_id,
        doctor_id: authService.authentication.doctor_id,
      }
      recordService.joinVideoCall(payload).then(function(response){
        //console.log(response);
		 	},function (err, response) {
	    });
    }*/

    $scope.callVisitDetailsApi = function(payload, callback) {  
      homevisitService.getVisitDetails(payload).then(function (response) {
          callback(response);
      }, function (err) {
        //toastr.error(err);   
      });
    }

    function getPaymentDetails(callback) {
      paymentService.getPaymentSetting().then(function(response) {
        callback(response);
      });
    }  

    $scope.raiseInvoice = function() {

        $scope.doctor_charge = 0;
        var paymentDetails = getPaymentDetails( function returnCallback(response) {

        //console.log( response );
        var videocall_mode="";
        if( $sessionStorage.get('video_call_mode') ) {
           videocall_mode = $sessionStorage.get('video_call_mode');
        }

        var payArr = ($filter('filter')(response, {'module':  videocall_mode+'_consultation'}));
        //console.log(payArr);

        var appointment_id = "";
        if(videocall_mode=="video_call") {

          if($sessionStorage.get('videocall_apt_id')) {
            appointment_id = $sessionStorage.get('videocall_apt_id');
          }

          if( payArr[0].module == videocall_mode+'_consultation' ) {
              $scope.doctor_charge = payArr[0].doctor_charge;    
          } else if( payArr[1].module == videocall_mode+'_consultation' ){
            $scope.doctor_charge = payArr[1].doctor_charge;  
          }
          
        } else {

          if( payArr[0].module == videocall_mode+'_consultation') {
             $scope.doctor_charge = payArr[0].doctor_charge;
          } else if( payArr[1].module == videocall_mode+'_consultation') {
             $scope.doctor_charge = payArr[1].doctor_charge;
          }

        }

        var invoice_payload = {
          account_email: authService.authentication.account_id,
          patient_email: $sessionStorage.get('video_call_patient'), 
          category: $sessionStorage.get('video_call_mode')+'_consultation',
          description: "",
          doctor_charges: $scope.doctor_charge,
          user_type: "doctor",
          type: 3,
          appointment_id: appointment_id,
          doctor_id:authService.authentication.doctor_id
        }
        paymentService.raiseInvoice(invoice_payload).then(function( response ) {
          toastr.success( 'Payment raised successfully' );             
            
        }, function(error) {
          toastr.error(error);
        });

      });
    
    }

    $scope.callEndRoom = function() {
      end_btn_click = true;
      $scope.disconnectNotify = true;  
      $scope.showVideoPanel = false;

      if($scope.participantConnected == true) {
        document.getElementById("end_room").disabled = true;
        $scope.participantConnected = false;
      }

      var payload = {
        patient_email: $sessionStorage.get('video_call_patient'),
        account_email: authService.authentication.account_id,
        doctor_id: authService.authentication.doctor_id,
        s_id: $sessionStorage.get('video_sid')
      }

      recordService.completeVideoCall(payload).then(function(response) {
        
        $scope.raiseInvoice();
       
      },function (err, response) {
        alert('Room not closed.');
      });
    } 

}]);

'use strict';
angular.module('AngularApp').controller('videocallReportController', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'paymentService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, authService, paymentService, $ngBootbox, toastr) {

    $scope.videocallTotal = [];
    $scope.videocallData  = [];
    $scope.today_dt    = new Date();
    $scope.ExportType  = "";   
    $scope.chartHide   = true;
    
    $scope.exportData = function(type) {

        $scope.date = new Date();
        $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");

        if($scope.selected_days == 1 || $scope.selected_days == 2){
            var filename = authService.authentication.doctor_name+"_Wallet_Transact_Report_" + $scope.from_date;
        }else{
            var filename = authService.authentication.doctor_name+"_Wallet_Transact_Report_" + $scope.from_date + "_to_" + $scope.to_date;
        }

        if(type=='pdf') {
            var pdf_element = document.getElementById('printtable');
            var opt = {
                margin:      0,
                filename:    filename+'.pdf',
                image:       { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
            };
        
      //New Promise-based usage:
        html2pdf().set(opt).from(pdf_element).save();
        }else if(type == 'csv') {

            alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true,separator:','}) FROM HTML('#Printingcsv',{headers:true,separator:','})");
            
        }
        
      /*Old monolithic-style usage:
        html2pdf(element, opt);*/

      /*$scope.date = new Date();
        $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
        var filename = "Wallet_Transact_Report" + $scope.formattedDate;

        if(type == 'PDF') {
            html2canvas(document.getElementById('printtable'), {
                onrendered: function (canvas) {
                    var data = canvas.toDataURL();
                    var docDefinition = {
                        content: [{
                            image: data,
                            width: 500,
                        }]
                    };
                    pdfMake.createPdf(docDefinition).download("" + filename + ".pdf");
                }
            });
        }*/
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
            $scope.Date1 = "";
            $scope.Date2 = "";
            $scope.from_date = "";
            $scope.to_date = "";
        }

          
        switch (day) {
          case "4":
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.from_date = datArr[1];
            $scope.Date1 = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.to_date = datArr2[1];
            $scope.Date2 = new Date(prevMonthLastDate); 
            $scope.videocallReportData();
          break;
          case "3":
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.from_date = datArr[1];
            $scope.Date1 = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.to_date = datArr2[1];
            $scope.Date2 = new Date(endLastWeek);
            $scope.videocallReportData();
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.from_date  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            //$scope.to_date = $scope.selectedFromDate; 
            $scope.to_date =$scope.from_date;
            $scope.Date1 = tempArray;
            $scope.Date2   = $scope.Date1;  
            $scope.videocallReportData();     
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.from_date = datArr[1];
            $scope.to_date =$scope.from_date;
            //$scope.to_date = $scope.selectedFromDate; 
            $scope.Date1 = new Date();
            $scope.Date2 = $scope.Date1;
            $scope.videocallReportData();
          break;
        }
    }

    function pieChart1(data) { 
        
        $('#pie_container_1').highcharts({
        //Highcharts.chart('container', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Mode'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
              //name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    }

    function pieChart2(data) { 

        $('#pie_container_2').highcharts({
          //Highcharts.chart('container', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Call Status'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
              //name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    }

    $scope.videocallReportData = function() {

        var from_date = $filter('date')( $scope.Date1, "dd-MM-yyyy");
        var to_date = $filter('date')( $scope.Date2, "dd-MM-yyyy");

        var payload = {
            account_email:authService.authentication.account_id,
            doctor_id:parseInt(authService.authentication.doctor_id),
            from_date: from_date,
            to_date: to_date
        }    
       
        paymentService.getvideocallhistory(payload).then( function(response) {
            console.log('here',response);
            console.log(response.calls[0].records);
          toastr.success('Updated Successfully');
            if(response.calls[0].success==1) {
                $scope.videocallTotal = response.calls[0].total;
                $scope.videocallData = response.calls[0].records; 
                console.log('Scopedata',$scope.videocallData);
               
                if(response.calls[0].percentage) {

                    var percentage_data = response.calls[0].percentage;
                    var data1 = [
                        {
                            name: 'Scheduled Percent',
                            y: percentage_data.scheduled_percent,
                            color: 'lightblue',
                            sliced: true,
                            selected: true
                        },
                        {
                            name: 'Emergency Percent',
                            y: percentage_data.emergency_percent,
                            color: 'pink'
                        }
                    ];

                    var data2 = [
                        {
                            name: 'Connected Percent',
                            y:  percentage_data.connected_percent,
                            color: 'lightblue',
                            sliced: true,
                            selected: true
                        },
                        {
                            name: 'Missed Percent',
                            y: percentage_data.missed_percent,
                            color: 'pink'
                        }
                    ];

                  ;

                    pieChart1(data1); 
                    pieChart2(data2);  

                    $scope.chartHide = false; 
                }
            } else {
                $scope.videocallTotal = [];
                $scope.videocallData = [];
                $scope.chartHide = true;
            }
        },function(error) {
            toastr.error(error);
            $scope.chartHide = true;
        });
    }
   
    $scope.rangePicker1= {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
      }
    };

    $scope.rangePicker2 = {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
      }
    };

    $scope.byRange = function(from, to, range_no) { 

        if(range_no=="1") {

            $scope.rangePicker2 = {
                opened :{ fromDate:false, toDate:false},
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
                dateOptions : {
                  formatYear: 'yyyy',
                  startingDay: 0,
                  maxDate: new Date(),
                  minDate: from
                }
            };

            $scope.from_date = $filter('date')(from, "dd-MMM-yyyy");  

        } else if(range_no=="2"){

            $scope.rangePicker1 = {
                opened : {fromDate:false, toDate:false},
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
                dateOptions : {
                  formatYear: 'yyyy',
                  startingDay: 0,
                  maxDate: to
                }
              }
                  
            $scope.to_date =  $filter('date')(to, "dd-MMM-yyyy");
        }
 
        if($scope.from_date && $scope.to_date) {
            $scope.videocallReportData();
        }  
    } 

}]);

'use strict';
angular.module('AngularApp').controller('viewnotificationController', ['$scope','$rootScope', '$location', 'authService','patientlistService','$ngBootbox', 'notificationlistService',
function ($scope, $rootScope, $location, authService, patientlistService, $ngBootbox, notificationlistService) {
    
   $rootScope.doctorAccountId=authService.authentication.account_id;
   $rootScope.notificationlist=[];

    $scope.Notificationlist = function(){

   notificationlistService.getnotificationlist($rootScope.doctorAccountId).then(function(recordResponse){
            
            var dobMoment  = moment();
                var notificationlistData = recordResponse.map(function(item){
                    return {    
                     
                        created_at:item.created_at,
                       content:item.content,
                        contact_email:item.contact_email,                    
                      

                  };
               });

                $rootScope.notificationlist = notificationlistData;
           },function (err, response) {
                   $ngBootbox.alert(err.Message);
                   analytics('notificationlist',err.Message);
        });
};

//function to load the analytics
    function analytics(aEvent,aLabel) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        var url = sessionStorage.getItem('serviceBaseUrl');
        if(url=='epicare.net'){
          gtag('config', 'G-XGBKLLH8JX');
        } else {    
          gtag('config', 'UA-99604994-7');
        }
        gtag('event', aEvent, {
            'event_category' : 'viewnotificationController',
            'event_label' : aLabel
        });
     }

  if($rootScope.doctorAccountId){
         $scope.Notificationlist();
    }else{
         $rootScope.$watch('doctorRecordId',function(){
                 $scope.Notificationlist();
         });
    }


}]);
'use strict';
angular.module('AngularApp').controller('visitController', ['$scope', '$rootScope', '$location', 'authService', '$ngBootbox', function ($scope, $rootScope, $location, authService, $ngBootbox) {
    
}]);

'use strict';
angular.module('AngularApp').controller('walletController', ['$scope', '$rootScope', '$location', '$filter', 'authService', 'paymentService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, authService, paymentService, $ngBootbox, toastr) {

    $scope.walletTotal = [];
    $scope.walletData  = [];
    $scope.today_dt    = new Date();
    $scope.ExportType  = "";   
    $scope.chartHide   = true;
    
    $scope.exportData = function(type) {
        $scope.date = new Date();
        $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");

        if($scope.selected_day == 1 || $scope.selected_day == 2){
            var filename = authService.authentication.doctor_name+"_Wallet_Transact_Report_" + $scope.from_date;
        }else{
            var filename = authService.authentication.doctor_name+"_Wallet_Transact_Report_" + $scope.from_date + "_to_" + $scope.to_date;
        }

        if(type=='pdf') {
            var pdf_element = document.getElementById('printtable');
            var opt = {
                margin:      0,
                filename:    filename+'.pdf',
                image:       { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
            };
        
      //New Promise-based usage:
        html2pdf().set(opt).from(pdf_element).save();
        }else if(type == 'csv') {

            alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#Printcsv',{headers:true})");
            
        }
        
      /*Old monolithic-style usage:
        html2pdf(element, opt);*/

      /*$scope.date = new Date();
        $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
        var filename = "Wallet_Transact_Report" + $scope.formattedDate;

        if(type == 'PDF') {
            html2canvas(document.getElementById('printtable'), {
                onrendered: function (canvas) {
                    var data = canvas.toDataURL();
                    var docDefinition = {
                        content: [{
                            image: data,
                            width: 500,
                        }]
                    };
                    pdfMake.createPdf(docDefinition).download("" + filename + ".pdf");
                }
            });
        }*/
    }

    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }

    $scope.changeDay = function(day) {
 
        if(day=="5") {
          //$scope.timeInputDisable = false;
            $scope.Date1 = "";
            $scope.Date2 = "";
            $scope.from_date = "";
            $scope.to_date = "";
          //$scope.selectedFromDate = "";
          //$scope.selectedToDate = ""    
        }
        /*} else {
          //$scope.timeInputDisable = true;
        }*/
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.from_date = datArr[1];
            $scope.Date1 = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.to_date = datArr2[1];
            $scope.Date2 = new Date(prevMonthLastDate); 
            $scope.walletTransactData();
          break;
          case "3":
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.from_date = datArr[1];
            $scope.Date1 = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.to_date = datArr2[1];
            $scope.Date2 = new Date(endLastWeek);
            $scope.walletTransactData();
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.from_date  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            //$scope.to_date = $scope.selectedFromDate; 
            $scope.to_date =$scope.from_date;
            $scope.Date1 = tempArray;
            $scope.Date2   = $scope.Date1;  
            $scope.walletTransactData();     
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.from_date = datArr[1];
            $scope.to_date =$scope.from_date;
            //$scope.to_date = $scope.selectedFromDate; 
            $scope.Date1 = new Date();
            $scope.Date2 = $scope.Date1;
            $scope.walletTransactData();
          break;
        }
    }

    function pieChart1(data) { 
        
        $('#pie_container1').highcharts({
        //Highcharts.chart('container', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Credit'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
              //name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    }

    function pieChart2(data) { 

        $('#pie_container2').highcharts({
          //Highcharts.chart('container', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Debit'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
              //name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    }

    function pieChart3(data) { 

        $('#pie_container3').highcharts({
          //Highcharts.chart('container', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Total'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
              //name: 'Brands',
                colorByPoint: true,
                data: data
            }]
        });
    }

    $scope.walletTransactData = function() {

        var from_date = $filter('date')( $scope.Date1, "dd-MM-yyyy");
        var to_date = $filter('date')( $scope.Date2, "dd-MM-yyyy");
        
        var payload = {
            account_email: authService.authentication.account_id,
            from_date: from_date,
            to_date: to_date
        }    

        paymentService.getWalletHistory(payload).then( function(response) {
          //toastr.success('Updated Successfully');
            if(response.users[0].success==1) {
                $scope.walletTotal = response.users[0].total;
                $scope.walletData = response.users[0].transaction; 
                if(response.users[0].percentage) {
                    var percentage_data = response.users[0].percentage;
                    var data1 = [
                        {
                            name: 'Front Desk',
                            y: percentage_data.FD_credit,
                            color: 'lightblue',
                            sliced: true,
                            selected: true
                        },
                        {
                            name: 'Payment Gateways',
                            y: percentage_data.gateway_credit,
                            color: 'pink'
                        }
                    ];

                    var data2 = [
                        {
                            name: 'MH Activities',
                            y:  percentage_data.mh_activity,
                            color: 'lightblue',
                            sliced: true,
                            selected: true
                        },
                        {
                            name: 'MH Subscription',
                            y: percentage_data.mh_subscription,
                            color: 'pink'
                        },
                        {
                            name: 'eShop',
                            y: percentage_data.eshop,
                            color: 'lightgreen'
                        },
                        {
                            name: 'kc debit',
                            y: percentage_data.kc_debit,
                            color: 'lightgreen'
                        },
                        {
                            name: 'kce debit',
                            y: percentage_data.kce_debit,
                            color: 'lightgreen'
                        },

                    ];

                    var data3 = [
                        {
                            name: '   Total  Credit',
                            y: percentage_data.credit_percent,
                            color: 'lightblue',
                            sliced: true,
                            selected: true
                        },
                        {
                            name: '   Total  Debit',
                            y: percentage_data.debit_percent,
                            color: 'pink'
                        }
                    ];

                    pieChart1(data1); 
                    pieChart2(data2);  
                    pieChart3(data3);

                    $scope.chartHide = false; 
                }
            } else {
                $scope.walletTotal = [];
                $scope.walletData = [];
                $scope.chartHide = true;
            }
        },function(error) {
            toastr.error(error);
            $scope.chartHide = true;
        });
    }

    $scope.rangePicker1= {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
      }
    };

    $scope.rangePicker2 = {
        opened :{ fromDate:false, toDate:false},
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions : {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
      }
    };

    $scope.byRange = function(from, to, range_no) { 

        if(range_no=="1") {

            $scope.rangePicker2 = {
                opened :{ fromDate:false, toDate:false},
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
                dateOptions : {
                  formatYear: 'yyyy',
                  startingDay: 0,
                  maxDate: new Date(),
                  minDate: from
                }
            };

            $scope.from_date = $filter('date')(from, "dd-MMM-yyyy");  

        } else if(range_no=="2"){

            $scope.rangePicker1 = {
                opened : {fromDate:false, toDate:false},
                maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
                dateOptions : {
                  formatYear: 'yyyy',
                  startingDay: 0,
                  maxDate: to
                }
              }
                  
            $scope.to_date =  $filter('date')(to, "dd-MMM-yyyy");
        }
 
        if($scope.from_date && $scope.to_date) {
            $scope.walletTransactData();
        }  
    } 

}]);


'use strict';
angular.module('AngularApp').controller('xenovexController', ['$scope', '$rootScope', '$location', '$filter', '$sessionStorage', 'authService', 'xenovexService', 'recordService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, $sessionStorage, authService, xenovexService, recordService, $ngBootbox, toastr) { 



    $scope.getSectorCode = function() {
        

        $scope.sector_list = [];

        // $scope.selected_sector = "";

        // $scope.selected_sector_name = "All";

        
        var data = {
            account_email: authService.authentication.account_id
        };
        
        xenovexService.getSector(data).then(function (response) {
            console.log(response);
          if(response.success == 1){
            $scope.sector_list = response.data
            $scope.selected_sector = response.data[0].sector_code
            // $scope.selected_sector_name = response.data[0].village_name
            $scope.getXenovexPatientList(response.data[0].sector_code);
          }
        }, function (error) {
            //toastr.error(error);
        });
    }

    $scope.getSectorCode()


    $scope.getXenovexPatientList = function(sector) {
        var data = {
            account_id: authService.authentication.account_id,
            sector_code: sector
        }
        xenovexService.patientList(data).then(function(response) {
          if(response.success == 1){
            if(response.data.StatusCode == '500'){
                toastr.error(response.data)
            }else{
            $scope.xenoPatientlist = response.data
            }
          }
           
        },function(error) {

            // toastr.error(error);
        })
    };

    // $scope.getXenovexPatientList()

    $scope.registerPatient = function (val) {

        $scope.firstName = val.childName
        $scope.dob = val.childDob
        $scope.uhid = val.rchId
        $scope.mobile = val.mobileNo
        if(val.genderType == 1){
            $scope.gender = 'male'
        }else{
            $scope.gender = 'female'
        }
        $scope.dob1 = $scope.dob.split('T')
        console.log($scope.dob1);

        $scope.dob2 =  $scope.dob1[0] + "T16:30:00.000Z"
        console.log($scope.day);

        $scope.date =  $scope.dob1[0].split('-')[2]
        console.log($scope.day);

        $scope.month =  $scope.dob1[0].split('-')[1]
        console.log($scope.month);

        $scope.year =  $scope.dob1[0].split('-')[0]
        console.log($scope.year);



        var data = {
            account_id: authService.authentication.account_id,
            sector_code: val.sectorCode
        }
        xenovexService.getDisBloVill(data).then(function(response) {
        console.log(response);
          if(response.success == 1){

            var params = {
                "childInfo": { 
                    "gender": $scope.gender, 
                    "year": $scope.year,
                    "month": $scope.month,
                    "date": $scope.date,            
                    "firstName": $scope.firstName,            
                    "lastName": '',                        
                    "uhid": $scope.uhid,            
                    // "dob": $scope.convertedDate3   
                    // "dob": DOB
                    "dob": $scope.dob2         
                },
                "fatherInfo": { 
                    "firstName": "",            
                    "appAccess": true,                    
                    "phone": $scope.mobile
                },            
                "motherInfo": { 
                    "firstName": "",
                    "appAccess": false,            
                    "phone": ""
                },            
                "doctor_email": authService.authentication.account_id,
                "image": "",            
                "address": "",            
                "email": "",            
                "district_id": response.data[0].district_id+'',            
                "block_id": response.data[0].block_id+'',            
                "panchayat_id": '0',
                "village_id": response.data[0].village_id+'',          
                "staffprofile_id": response.data[0].staffprofile_id+'',
                "kce_id": 'SUPERVISOR',
                "doctor_id":  authService.authentication.doctor_id
            }

            console.log(params);

            recordService.fieldStaffRegistration(params).then(function(response){ 
                console.log(response);
                $scope
                toastr.success('Account Created with Epicare')
            })
          }
           
        },function(error) {

            // toastr.error(error);
        })


        // $location.path('/xenoregister/' + val.rchId)

        sessionStorage.setItem('detials',JSON.stringify(val))

    };

   
}]);


'use strict';
angular.module('AngularApp').controller('redemController', ['$scope', '$rootScope', '$location', '$filter', '$sessionStorage', 'authService', 'xenovexService', 'recordService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, $sessionStorage, authService, xenovexService, recordService, $ngBootbox, toastr) { 

    // $scope.timeInputDisable = true;
    $scope.selected_day = "1";
    $scope.fromDate = new Date();
    $scope.toDate = new Date();
    $scope.today_dt = new Date();
    $scope.exportType = "";
    $scope.labelHide = true;
    $scope.errMsg = '';
    $scope.age = '';

    var datArr  = getStringDate($scope.fromDate);
    var datArr2 = getStringDate($scope.toDate)
    $scope.selectedFromDate  = datArr[1];
    $scope.selectedFromDate2 = datArr[0];
    $scope.selectedToDate  = datArr2[1];
    $scope.selectedToDate2 = datArr2[0];

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        }
    };

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.getCoupon = function(data){

        $scope.couponList = [];
        
        var data = {
            account_email: authService.authentication.account_id,
            from_date: $scope.selectedFromDate2,
            to_date: $scope.selectedToDate2
        };
        
        xenovexService.getCoupon(data).then(function (response) {
            console.log(response);
            if(response.success == 1){
                if(response.data.length>0){
                    $scope.labelHide = false
                    $scope.couponList = response.data
                }else{
                    $scope.labelHide = true
                }
            }else{
                toastr.error(response.message)
                $scope.labelHide = true
            }
        }, function (error) {
            //toastr.error(error);
        });
    }

    $scope.getCoupon();
    
    $scope.exportData = function(type) {

        if($scope.couponList.length>0) {
   
            $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
            var filename = "Coupon_List_"+$scope.formattedDate;
            
            if($scope.selectedFromDate && $scope.selectedToDate){
                filename = "Coupon_List_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
            }
            
           /* if(type=='csv') {
  
                alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
                
            } else*/
            if(type == 'excel') {
  
                //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                    var blob = new Blob([document.getElementById('printtable2').innerHTML], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    });
                 saveAs(blob, filename+".xls");
  
            } else if(type=='pdf') {
  
                var pdf_element = document.getElementById('printtable');
                var opt = {
                    margin:      0,
                    filename:   filename,
                    image:       { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
                };
                    
                //New Promise-based usage:
                html2pdf().set(opt).from(pdf_element).save();
                    
            }
        }else{
            toastr.error('No Data Found')
        }
    }
    
}]);


'use strict';
angular.module('AngularApp').controller('registrationReportController', ['$scope', '$rootScope', '$location', '$filter', '$sessionStorage', 'authService', 'xenovexService', 'recordService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, $sessionStorage, authService, xenovexService, recordService, $ngBootbox, toastr) { 


    $scope.timeInputDisable = true;
    $scope.selected_day = "1";
    $scope.fromDate = new Date();
    $scope.toDate = new Date();
    $scope.today_dt = new Date();
    $scope.exportType = "";
    $scope.labelHide = true;
    $scope.errMsg = '';
    $scope.age = '';

    var datArr  = getStringDate($scope.fromDate);
    var datArr2 = getStringDate($scope.toDate)
    $scope.selectedFromDate  = datArr[1];
    $scope.selectedFromDate2 = datArr[0];
    $scope.selectedToDate  = datArr2[1];
    $scope.selectedToDate2 = datArr2[0];

    $scope.rangePicker1 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
        }
    };

    $scope.rangePicker2 = {
        opened: { fromDate:false, toDate:false },
        maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
        dateOptions: {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date(),
        }
    };
    
    function start_endOfWeek(date,start,end) {
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? start : end);
        return new Date(date.setDate(diff));
    }

    function getStringDate(date) {
        var day   = date.getDate();
        var month = date.getMonth()+1;
        var year  = date.getFullYear(); 
        return [year+"-"+month+"-"+day, day+"-"+month+"-"+year];
    }

    function getPreviousDate(days, value){
        var dateOffset  = parseInt(days * value);
        var convertDate = new Date();
            convertDate = new Date(convertDate.setDate(convertDate.getDate() - dateOffset));
        return convertDate;   
    }


    $scope.changeDay = function(day) {
 
        if(day=="5") {
          $scope.timeInputDisable = false;
          $scope.fromDate = "";
          $scope.toDate   = "";
          $scope.selectedFromDate = "";
          $scope.selectedToDate = "";
          $scope.selectedFromDate2 = "";
          $scope.selectedToDate2 = "";   
          $scope.hidetable1 = 'true';  
          $scope.hidetable2 = 'true';   
    
        } else {
          $scope.timeInputDisable = true;
        }
          
        switch (day) {
          case "4":
          //var tempArray = getPreviousDate(1,30);
            var prevMonthFirstDate = new Date(new Date().getFullYear() - (new Date().getMonth() > 0 ? 0 : 1), (new Date().getMonth() - 1 + 12) % 12, 1);
            var datArr = getStringDate(new Date(prevMonthFirstDate));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(prevMonthFirstDate);
            var prevMonthLastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
            var datArr2 = getStringDate(new Date(prevMonthLastDate)); 
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(prevMonthLastDate); 
          break;
          case "3":
          //var tempArray = getPreviousDate(1,7);
            var startLastWeek = start_endOfWeek(new Date(),1,-6).toString();
            var datArr = getStringDate(new Date(startLastWeek));
            $scope.selectedFromDate = datArr[1];
            $scope.selectedFromDate2 = datArr[0];
            $scope.fromDate = new Date(startLastWeek);
            var endLastWeek = start_endOfWeek(new Date(),-6,0).toString();
            var datArr2 = getStringDate(new Date(endLastWeek));
            $scope.selectedToDate = datArr2[1];
            $scope.selectedToDate2 = datArr2[0];
            $scope.toDate = new Date(endLastWeek);
          break;
          case "2":
            var tempArray = getPreviousDate(1,1);
            $scope.selectedFromDate  = tempArray.getDate() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getFullYear();
            $scope.selectedFromDate2 = tempArray.getFullYear() +'-'+ (tempArray.getMonth() + 1)+'-'+tempArray.getDate();
            $scope.selectedToDate = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;  
            $scope.fromDate = tempArray;
            $scope.toDate   = $scope.fromDate;       
          break;
          case "1": 
            var datArr = getStringDate(new Date());
            $scope.selectedFromDate  = datArr[1];
            $scope.selectedFromDate2 = datArr[0];  
            $scope.selectedToDate  = $scope.selectedFromDate; 
            $scope.selectedToDate2 = $scope.selectedFromDate2;
            $scope.fromDate = new Date();
            $scope.toDate   = $scope.fromDate;
          break;
        }
    }

    $scope.byRange = function(from,to) {

        if(from) {
          $scope.rangePicker2 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: new Date(),
              minDate: from
            }
          };
        }
      
        if(to) {
          $scope.rangePicker1 = {
            opened : { fromDate:false, toDate:false },
            maxParentDate: new Date((new Date()).setFullYear((new Date()).getFullYear()-20)),
            dateOptions : {
              formatYear: 'yyyy',
              startingDay: 0,
              maxDate: to
            }
          };    
        };
      
        if(from && to) {
          var datArr = getStringDate(from);
          $scope.selectedFromDate = datArr[1];
          $scope.selectedFromDate2 = datArr[0];
          var datArr2 = getStringDate(to);
          $scope.selectedToDate = datArr2[1];
          $scope.selectedToDate2 = datArr2[0];;
        //$scope.homevisitData();
        }
    }

    $scope.getReport = function(data){

        $scope.getreportData = [];

        console.log($scope.age,'ag');
        var data = {};
        if($scope.age==''){
            data = {
                account_email: authService.authentication.account_id,
                from_date: $scope.selectedFromDate,
                to_date: $scope.selectedToDate,
            };
        }else{
            data = {
                account_email: authService.authentication.account_id,
                from_date: $scope.selectedFromDate,
                to_date: $scope.selectedToDate,
                age: $scope.age
            };
        }
        
        xenovexService.getPatientreport(data).then(function (response) {
            console.log(response);
            if(response.success == 1){
                if(response.data.length>0){
                    $scope.getreportData = response.data
                    $scope.labelHide = false;
                    // console.log($scope.getreportData,'data');
                    for(var i=0;i<$scope.getreportData.length;i++){
                        var preDob = $scope.getreportData[i].registration_date
                        var parts = preDob.split("-");
                        $scope.getreportData[i].registration_date = parts[2] + "-" + parts[1] + "-" + parts[0];
                    }
                    // console.log($scope.getreportData);
                }else{
                    $scope.labelHide = true;
                    $scope.errMsg = 'No Data Found'
                }
            }else{
                $scope.labelHide = true;
                $scope.errMsg = response.data
            }

        }, function (error) {
            //toastr.error(error);
        });
    }


    // $scope.getReport()

    $scope.exportData = function(type) {

        if($scope.getreportData.length>0) {
   
            $scope.formattedDate = $filter('date')(new Date(), "dd-MMM-yyyy");
            var filename = "App_Registration_Report_"+$scope.formattedDate;
            
            if($scope.selectedFromDate && $scope.selectedToDate){
                filename = "App_Registration_Report_"+$scope.selectedFromDate+"_to_"+$scope.selectedToDate;
            }
            
           /* if(type=='csv') {
  
                alasql("SELECT * INTO CSV('" + filename + ".csv', {headers:true}) FROM HTML('#printtable',{headers:true})");
                
            } else*/
            if(type == 'excel') {
  
                //alasql("SELECT * INTO XLSX('" + filename + ".xlsx',{headers:true}) FROM HTML('#exportable',{headers:true})");
                    var blob = new Blob([document.getElementById('printtable2').innerHTML], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    });
                 saveAs(blob, filename+".xls");
  
            } else if(type=='pdf') {
  
                var pdf_element = document.getElementById('printtable');
                var opt = {
                    margin:      0,
                    filename:   filename,
                    image:       { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF:       { unit: 'in', format: 'a4', orientation: 'landscape' }
                };
                    
                //New Promise-based usage:
                html2pdf().set(opt).from(pdf_element).save();
                    
            }
        }else{
            toastr.error('No Data Found')
        }
    }
    
}]);


'use strict';
angular.module('AngularApp').controller('redemController1', ['$scope', '$rootScope', '$location', '$filter', '$sessionStorage', 'authService', 'xenovexService', 'recordService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, $sessionStorage, authService, xenovexService, recordService, $ngBootbox, toastr) { 
    
    $scope.routePage = function(data){
        switch (data) {
            case '1':
                // master module
                $location.path('/redeemMaster');
                break;
            case '2':
                // report module
                $location.path('/redeemReports');
                break;
            case '3':
                // Configure Module
                $location.path('/redeemConfig')
            default:
        }
    }

}]);

'use strict';
angular.module('AngularApp').controller('redemController2', ['$scope', '$rootScope', '$location', '$filter', '$sessionStorage', 'authService', 'xenovexService', 'recordService', '$ngBootbox', 'toastr', function ($scope, $rootScope, $location, $filter, $sessionStorage, authService, xenovexService, recordService, $ngBootbox, toastr) { 

    $scope.configList = [];
    $scope.showCouponcreatescreen = 0;
    $scope.buttonType = 0
    $scope.couponCode = ''
    $scope.select_category = ''
    $scope.fromAge = ''
    $scope.toAge = ''
    $scope.whatsapp_status = false    
    $scope.whatsapp_template = ''
    $scope.selectedCouponconfig = ''

    $scope.getList = function(){

        var data = {
            account_email: authService.authentication.account_id
        }

        xenovexService.getCouponconfig(data).then(function (response) {
            console.log(response);
            // $scope.couponList = [];
            $scope.showCouponcreatescreen = 0
            if(response.success == 1){
                $scope.configList = response.data
                console.log($scope.couponList,'list'); 
            }else{
                $scope.configList = [];
            }
        }, function (err) {
            toastr.error(err);
        });
    }

    $scope.getList();

    $scope.updateWhatsappcoupon = function(){
        console.log($scope.whatsapp_status,'status');  
    }

    $scope.changeCategory = function(){
        console.log($scope.select_category,'selected')
    }

    $scope.viewCoupon = function(){

        $scope.showCouponcreatescreen = 1
        $scope.buttonType = 1

        $scope.couponCode = ''
        $scope.select_category = 'appointment'
        $scope.fromAge = ''
        $scope.toAge = ''
        $scope.whatsapp_status = false    
        $scope.whatsapp_template = ''

    }

    $scope.viewUpdatecouponconfig = function(data){
        console.log(data);
       
        $scope.selectedCouponconfig = data
        $scope.buttonType = 2
        $scope.showCouponcreatescreen = 1

        $scope.couponCode = data.coupon_code.toLowerCase()
        $scope.select_category = data.coupon_category.toLowerCase()
        $scope.fromAge = data.from_age
        $scope.toAge = data.to_age
        $scope.whatsapp_status = data.whatsapp_status    
        $scope.whatsapp_template = data.whatsapp_template
    }

    $scope.createCouponconfig = function(){

        var param = {
            "account_email": "rx4@rxcarenet.org",
            "coupon_code": $scope.couponCode,
            "coupon_category": $scope.select_category,
            "from_age": $scope.fromAge,
            "to_age": $scope.toAge,
            "whatsapp_status": $scope.whatsapp_status,
            "whatsapp_template": $scope.whatsapp_template
        }

        xenovexService.createCouponconfig1(param).then(function (response) {
            console.log(response);
            $scope.showCouponcreatescreen = 1
            if(response.success==1){
                toastr.success('Created Successfully')
                $scope.getList();
            }else{
                $scope.getList();
                // if(response.success==0&&response.message=='already exist'){
                //     toastr.error(response.message)
                // }
                // else{
                // }
                toastr.error(response.message)
            }
        }, function (err) {
            toastr.error(err);
        });
    }

    $scope.updateCouponconfig = function(){
       
        var param = {
            "account_email": "rx4@rxcarenet.org",
            "coupon_code": $scope.couponCode,
            "coupon_category": $scope.select_category,
            "from_age": $scope.fromAge,
            "to_age": $scope.toAge,
            "whatsapp_status": $scope.whatsapp_status,
            "whatsapp_template": $scope.whatsapp_template,
            "coupon_id": $scope.selectedCouponconfig.id
        }

        xenovexService.updateCouponconfig1(param).then(function (response) {
            console.log(response);
            $scope.showCouponcreatescreen = 1
            if(response.success==1){
                toastr.success('Updated Successfully')
                $scope.getList();
            }else{
                toastr.error(response.message)
                $scope.getList();
            }
        }, function (err) {
            toastr.error(err);
        });
    }

    $scope.deleteCouponconfig = function(data){
        console.log(data);
        
        var param = {
            "account_email": "rx4@rxcarenet.org",
            "coupon_id": data.id
        }

        xenovexService.deleteCouponconfig1(param).then(function (response) {
            console.log(response);
            $scope.showCouponcreatescreen = 0
            if(response.success==1){
                toastr.success('Deleted Successfully')
                $scope.getList();
            }else{
                toastr.error(response.message)
                $scope.getList();
            }
        }, function (err) {
            toastr.error(err);
        });
    }

}]);

'use strict';
angular.module('AngularApp').controller('redemController3', ['$scope', '$rootScope', '$location', '$filter', '$sessionStorage', 'authService', 'xenovexService', 'recordService', '$ngBootbox', 'toastr', 'milestoneService', function ($scope, $rootScope, $location, $filter, $sessionStorage, authService, xenovexService, recordService, $ngBootbox, toastr, milestoneService) { 

    $scope.couponList = [];
    $scope.couponsettings = {};
    $scope.showCouponcreatescreen = 0;
    $scope.discount_type = 'fixed_type';
    $scope.amount = '';
    $scope.percent = '';
    $scope.select_category = 'appointment';
    $scope.description = '';
    $scope.couponCode = '';
    $scope.buttonType = 0;
    $rootScope.selectedItems = [];
    $rootScope.selectedOptionssend = [];
    $rootScope.eshopLinkingmilestone = '';
    $rootScope.couponLikedlist = [];
    $rootScope.buttonShow = 0;

    $scope.getList = function(){

        var data = {
            account_email: authService.authentication.account_id
        }

        xenovexService.getCoupon1(data).then(function (response) {
            console.log(response);
            // $scope.couponList = [];
            $scope.showCouponcreatescreen = 0
            if(response.success == 1){
                $scope.couponList = response.message
                console.log($scope.couponList,'list'); 
            }else{
                $scope.couponList = []
            }
        }, function (err) {
            toastr.error(err);
        });
    }

    $scope.getList();

    $scope.getCouponmaster = function(){

        var payload = {
            account_email: authService.authentication.account_id
        }

        xenovexService.getCouponmaster(payload).then(function (response) {
            console.log(response);
            $scope.couponsettings = {};
            if(response.success==1){
                $scope.couponsettings = response.message[0]
                console.log($scope.couponsettings,'couponsettings');
            }
        }, function (err) {
            toastr.error(err);
        });
    }

    $scope.getCouponmaster();

    $scope.viewCoupon = function(){
        $scope.showCouponcreatescreen = 1
        $scope.buttonType = 1

        $scope.couponCode = ''
        $scope.description = ''
        $scope.discount_type = 'fixed_product'
        $scope.amount = '' 
        $scope.select_category = 'appointment'

    }

    $scope.updateCouponmaster = function(){

        var payload = {
            "account_email": authService.authentication.account_id,
            "common_coupon_mode": $scope.couponsettings.common_coupon_mode
        }

        xenovexService.updatecouponmaster(payload).then(function (response) {
            console.log(response);
            if(response.success==1){
                toastr.success('Updated Successfully')
                $scope.getCouponmaster();
            }
        }, function (err) {
            toastr.error(err);
        });
        
    }

    $scope.changeDiscount = function(){
        console.log($scope.discount_type,'type');
    }

    $scope.changeCategory = function(){
        console.log($scope.select_category,'selected')
    }

    $scope.createCouponcode = function(){

        var amt;
        var percent;
        if($scope.amount!=''){
            amt = $scope.amount  
            percent = 0
        }else{
            percent = $scope.percent
            amt = 0
        }
        var param = {
            "doctor_id": authService.authentication.doctor_id,
            "coupon_code": $scope.couponCode.toUpperCase(),
            "discount_type": $scope.discount_type,
            "amount": amt,
            "percent": percent,
            "account_email": authService.authentication.account_id,
            "description": $scope.description,
            "coupon_category": $scope.select_category.toUpperCase(), 
            "individual_use" : 0
        }

        xenovexService.createCoupon(param).then(function (response) {
            console.log(response);
            $scope.showCouponcreatescreen = 1
            if(response.success==1){
                toastr.success('Created Successfully')
                $scope.getList();
            }else{
                toastr.error(response.message)
                $scope.getList();
            }
        }, function (err) {
            toastr.error(err);
        });

    }

    $scope.cancel = function(){
        $scope.getList();
    }

    $scope.viewUpdatecoupon = function(data){
        console.log(data);
        $scope.updateCoupondata = data
        $scope.buttonType = 2
        $scope.showCouponcreatescreen = 1

        $scope.couponCode = data.coupon_code.toLowerCase()
        $scope.description = data.description
        $scope.discount_type = data.discount_type
        $scope.amount = data.amount
        $scope.percent = data.percent
        $scope.select_category = data.coupon_category.toLowerCase()
    }

    $scope.updateCouponcode = function(){
        // console.log(data);

        // $scope.buttonType = 2
        // $scope.showCouponcreatescreen = 1

        // $scope.couponCode = data.coupon_code.toLowerCase()
        // $scope.description = data
        // $scope.discount_type = data.discount_type
        // $scope.amount = data.amount
        // $scope.percent = data.percent
        // $scope.select_category = data.coupon_category.toLowerCase()

        var amt;
        var percent;
        if($scope.amount!=''){
            amt = $scope.amount  
            percent = 0
        }else{
            percent = $scope.percent
            amt = 0
        }

        var payload = {
            "doctor_id": authService.authentication.doctor_id,
            "coupon_id": $scope.updateCoupondata.coupon_id,
            "coupon_code": $scope.couponCode.toUpperCase(),
            "discount_type": $scope.discount_type,
            "amount": amt,
            "percent": percent,
            "account_email": authService.authentication.account_id,
            "description": $scope.description,
            "coupon_category": $scope.select_category.toUpperCase(), 
        }

        xenovexService.updateCoupon(payload).then(function (response) {
            console.log(response);
            if(response.success==1){
                toastr.success('Updated Successfully')
                $scope.getList();
            }else{
                toastr.error(response.message)
                $scope.getList();
            }
        }, function (err) {
            toastr.error(err);
        });
        
    }

    $scope.deleteCouponcode = function(data){
        console.log(data);
        
        var payload = {
            "account_email": authService.authentication.account_id,
            "coupon_code": data.coupon_code
        }

        xenovexService.deleteCoupon(payload).then(function (response) {
            console.log(response);
            if(response.success==1){
                toastr.success('Deleted Successfully')
                $scope.getList();
            }
        }, function (err) {
            toastr.error(err);
        });
    }

    $rootScope.openeshopLinking = function(data){
        console.log(data,'selec');
        
        $rootScope.selectedCoupon = data

        $rootScope.getMilestonelinkedproductbyid(data)
        
        var options = {
            title: '<b>Link Eshop Product with Coupon</b>',
            message:'',
            templateUrl: 'views/redeem/linkingCoupon.htm',
            size:'medium', 
            onEscape: function() {
                $scope.$apply();
                $rootScope.searchEsshopProducts = [];
                $rootScope.localDrugArr = [];
                $rootScope.eshopLinkingmilestone = ''
            },
        };

        $ngBootbox.customDialog(options);

    }

    $rootScope.searchgroupingEshopIdcoupon = function(){
        $rootScope.localDrugArr = [];
        console.log($rootScope.selectedDataforLinking,'selectedData');
        if($rootScope.eshopLinkingmilestone == '' || $rootScope.eshopLinkingmilestone == undefined || $rootScope.eshopLinkingmilestone == null){
            toastr.error('Please enter Product ID to add.');
        }else{
            var param = {
                account_email: authService.authentication.account_id,
                eshop_product_id: $rootScope.eshopLinkingmilestone,
            }

            milestoneService.searchEshopbyid(param).then(function(response){
                console.log(response,'response');
                if(response.success==1){
                    $rootScope.searchEsshopProducts = response.message;
                    var res = []
                    res.push(response.message);
                    var localMapFun = res.map(function(e) {
                        return e;
                    });  
                    $rootScope.localDrugArr = localMapFun.map(function(e) {
                    return {
                        product_name : e.product_name,
                        eshop_product_id: e.product_id,
                        is_active: e.is_active,
                        // custom_qa_id: e.custom_qa_id
                    };
                    });
                    $rootScope.selectedOption = $rootScope.localDrugArr[0];
                    var isDuplicate = false;

                    // Use a loop to check for duplicates
                    for (var i = 0; i < $rootScope.selectedItems.length; i++) {
                        if ($rootScope.selectedItems[i].eshop_product_id === $rootScope.selectedOption.eshop_product_id) {
                            isDuplicate = true;
                            console.log('duplicate1'); 
                            break;
                        }
                    }

                    if (isDuplicate) {
                        toastr.error('Product already added.');
                        $rootScope.eshopLinkingmilestone = '';
                    }else{
                        $rootScope.selectedItems.push($rootScope.localDrugArr[0]);
                        $rootScope.selectedOptionssend.push($rootScope.localDrugArr[0].eshop_product_id);
                        $rootScope.eshopLinkingmilestone = '';
                    }
                }else{
                    toastr.error(response.message);
                    $rootScope.searchEsshopProducts = [];
                    $rootScope.localDrugArr = [];
                    $rootScope.eshopLinkingmilestone = '';
                }
            });
        }
    }

    $rootScope.removeOptioncoupon = function(item) {
        console.log(item,'1252');
        // console.log($rootScope.selectedDataforLinking,'$rootScope.selectedDataforLinking--1253');
        
        if(item.custom_qa_id != undefined){
            var param = {
                account_email: authService.authentication.account_id,
                id: item.custom_qa_id,
                product_id: item.eshop_product_id
            }

            milestoneService.removeEshopLinking(param).then(function(response){
                if(response.success==1){
                    toastr.success('Eshop product is removed successfully.');
                    // $rootScope.getMilestonelinkedproductbyid($rootScope.selectedDataforLinking)
                    var index = $rootScope.selectedItems.indexOf(item);
                    if (index > -1) {
                        $rootScope.selectedItems.splice(index, 1);
                    }

                    $rootScope.selectedOptionactivity = $rootScope.selectedItems.map(function(obj) {
                        return obj.eshop_product_id;
                    });
                }else{
                    // console.log($rootScope.selectedItems,'n1');
                    // console.log($rootScope.selectedOptionactivity,'nn1');

                    var index = $rootScope.selectedItems.indexOf(item);
                    if (index > -1) {
                        $rootScope.selectedItems.splice(index, 1);
                    }

                    $rootScope.selectedOptionactivity = $rootScope.selectedItems.map(function(obj) {
                        return obj.eshop_product_id;
                    });

                    // console.log($rootScope.selectedItems,'n2');
                    // console.log($rootScope.selectedOptionactivity,'nn2');
                }
            });
        }else{
            var index = $rootScope.selectedItems.indexOf(item);
            var index1 = $rootScope.selectedOptionssend.indexOf(item);
            if (index > -1) {
                $rootScope.selectedItems.splice(index, 1);
            }

            if(index1 > -1) {
                $rootScope.selectedOptionssend.splice(index, 1)
            }

            $rootScope.selectedOptionactivity = $rootScope.selectedItems.map(function(obj) {
                return obj.eshop_product_id;
            });

            // console.log($rootScope.selectedItems,'n2');
            // console.log($rootScope.selectedOptionactivity,'nn2');
        }
    };

    $rootScope.saveEshopcoupon = function(){
        console.log($rootScope.selectedItems,'sel');
        
        if($rootScope.selectedItems.length<10){
            if($rootScope.selectedItems > $rootScope.checkGetmilestoneproduct){
                if($rootScope.selectedItems.length < 0){
                    toastr.error('Please select Product.');
                }else{
                    var stringArray = $rootScope.selectedOptionssend;
                    var integerArray = stringArray.map(Number);
                    var paaram = {
                        eshop_product: integerArray,
                        coupon_code: $rootScope.selectedCoupon.coupon_code,
                        account_email: authService.authentication.account_id,
                        product_details: $rootScope.selectedItems
                    }                    
    
                    xenovexService.linkEshopcoupon(paaram).then(function(response){
                        console.log(response,'response');
                        if(response.success==1){
                            toastr.success('Eshop product is Linked successfully.');
                            $rootScope.eshopLinkingmilestone = '';
                            $rootScope.searchEsshopProducts = [];
                            $rootScope.localDrugArr = [];
                            $rootScope.selectedOption = '';
                            $rootScope.selectedDataforLinking = '';
                            $rootScope.selectedOption1 = [];
                            bootbox.hideAll();
                            // $rootScope.getMilestonelinkedproductbyid($rootScope.selectedDataforLinking)
                            // $location.path('/milestoneConfig');
                        }else{
                            toastr.error(response.message);
                        }
                    });
                }
            }else{
                toastr.error('Please enter Product Id to add.');
            }
        }else{
            toastr.error('Maximum limit reached.')
        }
    }

    $rootScope.updateEshopcoupon = function(){

        if($rootScope.selectedItems.length<10){
            if($rootScope.selectedItems > $rootScope.checkGetmilestoneproduct){
                if($rootScope.selectedItems.length < 0){
                    toastr.error('Please select Product.');
                }else{
                    var stringArray = $rootScope.selectedOptionssend;
                    var integerArray = stringArray.map(Number);
                    var paaram = {
                        eshop_product: integerArray,
                        coupon_code: $rootScope.selectedCoupon.coupon_code,
                        account_email: authService.authentication.account_id,
                        product_details: $rootScope.selectedItems
                    }                    
    
                    xenovexService.updateLinkedeshopcoupon(paaram).then(function(response){
                        console.log(response,'response');
                        if(response.success==1){
                            toastr.success('Eshop product is updated successfully.');
                            $rootScope.eshopLinkingmilestone = '';
                            $rootScope.searchEsshopProducts = [];
                            $rootScope.localDrugArr = [];
                            $rootScope.selectedOption = '';
                            $rootScope.selectedDataforLinking = '';
                            $rootScope.selectedOption1 = [];
                            bootbox.hideAll();
                            // $rootScope.getMilestonelinkedproductbyid($rootScope.selectedDataforLinking)
                            // $location.path('/milestoneConfig');
                        }else{
                            toastr.error(response.message);
                        }
                    });
                }
            }else{
                toastr.error('Please enter Product Id to add.');
            }
        }else{
            toastr.error('Maximum limit reached.')
        }
    }

    $rootScope.getMilestonelinkedproductbyid = function(data){

        console.log(data,'data')

        var data = {
            account_email: authService.authentication.account_id,
            couponcode: data.coupon_code
        }

        xenovexService.getLinkedproducts(data).then(function (response) {
            console.log(response);
            // $scope.couponList = [];
            // $scope.showCouponcreatescreen = 0
            if(response.success==1){
                // $rootScope.selectedItems = response.data;
                // $rootScope.selectedOptionssend = response.data;
                $rootScope.buttonShow = 1
                if(response.message.length>0){
                    $rootScope.buttonShow = 2
                    $rootScope.selectedItems = response.message[0].product_details.map(function(item) {
                        return {
                          "custom_qa_id": item.custom_qa_id,
                          "eshop_product_id": item.eshop_product_id+'',
                          "is_active": item.is_active,
                          "product_name": item.product_name
                        };
                    });
                    // $rootScope.selectedOptionssend = response.message.map(function(item) {
                    //     return {
                    //       "custom_qa_id": item.custom_qa_id,
                    //       "eshop_product_id": item.product_id+'',
                    //       "is_active": item.is_active,
                    //       "product_name": item.product_name
                    //     };
                    // });
                    $rootScope.selectedOptionssend = response.message[0].product_details.map(function(item) {
                        return parseInt(item.eshop_product_id,10);
                    })
                    $rootScope.checkGetmilestoneproduct = response.message[0].product_details.map(function(item) {
                        return {
                          "custom_qa_id": item.custom_qa_id,
                          "eshop_product_id": item.eshop_product_id+'',
                          "is_active": item.is_active,
                          "product_name": item.product_name
                        };
                    });;
                    console.log($rootScope.selectedItems,'1256');
                    console.log($rootScope.selectedOptionssend,'1257');
                }else{
                    $rootScope.selectedOptionssend = [];
                    $rootScope.selectedItems = [];
                    $rootScope.checkGetmilestoneproduct = [];
                }
            }else{
                $rootScope.selectedOptionssend = [];
                $rootScope.selectedItems = [];
                $rootScope.checkGetmilestoneproduct = [];
            }
        }, function (err) {
            toastr.error(err);
        });

    }


}]);
'use strict';
angular.module('AngularApp').directive('combinedChartFemalePrint', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:9%;padding-top:10%;' viewBox='0 0 930 980'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;
//             .tickFormat(function(d) {
//     return d % 1 ? d + .1 : d;
//   })     

            var heightData = [];
            var weightData = [];

            if(vitalData.height){
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x>59 && vitalData.height[i].x<217) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            if(vitalData.weight) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x>59 && vitalData.weight[i].x<217) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var set1 = [{x:60,y:97.2},{x:66,y:99.8},{x:72,y:102.3},{x:78,y:104.9},{x:84,y:107.4},{x:90,y:110},
                        {x:96,y:112.6},{x:102,y:115.2},{x:108,y:117.8},{x:114,y:120.5},{x:120,y:123.3},{x:126,y:126.1},{x:132,y:128.8},
                        {x:138,y:131.5},{x:144,y:134},{x:150,y:136.3},{x:156,y:138.2},{x:162,y:139.9},{x:168,y:141.3},{x:174,y:142.4},
                        {x:180,y:143.3},{x:186,y:144.1},{x:192,y:144.7},{x:198,y:145.2},{x:204,y:145.7},{x:210,y:146.2},{x:216,y:146.6}];

            var set2 = [{x:60,y:100.5},{x:66,y:103.2},{x:72,y:106},{x:78,y:108.7},{x:84,y:111.4},{x:90,y:114.1},{x:96,y:116.8},
                        {x:102,y:119.6},{x:108,y:122.4},{x:114,y:125.2},{x:120,y:128.1},{x:126,y:130.9},{x:132,y:133.7},
                        {x:138,y:136.4},{x:144,y:138.9},{x:150,y:141.1},{x:156,y:142.9},{x:162,y:144.5},{x:168,y:145.8},{x:174,y:146.8},
                        {x:180,y:147.5},{x:186,y:148.1},{x:192,y:148.6},{x:198,y:149.1},{x:204,y:149.5},{x:210,y:149.8},{x:216,y:150.2}];
                    
            var set3 = [{x:60,y:103.9},{x:66,y:106.8},{x:72,y:109.7},{x:78,y:112.5},{x:84,y:115.4},{x:90,y:118.2},{x:96,y:121.1},
                        {x:102,y:124},{x:108,y:126.9},{x:114,y:129.9},{x:120,y:132.8},{x:126,y:135.7},{x:132,y:138.6},
                        {x:138,y:141.2},{x:144,y:143.7},{x:150,y:145.8},{x:156,y:147.6},{x:162,y:149.1},{x:168,y:150.2},{x:174,y:151.1},
                        {x:180,y:151.8},{x:186,y:152.3},{x:192,y:152.7},{x:198,y:153.1},{x:204,y:153.4},{x:210,y:153.6},{x:216,y:153.9}];

            var set4 = [{x:60,y:107.5},{x:66,y:110.5},{x:72,y:113.5},{x:78,y:116.5},{x:84,y:119.4},{x:90,y:122.4},{x:96,y:125.4},
                        {x:102,y:128.4},{x:108,y:131.4},{x:114,y:134.4},{x:120,y:137.4},{x:126,y:140.4},{x:132,y:143.3},
                        {x:138,y:145.9},{x:144,y:148.4},{x:150,y:150.5},{x:156,y:152.2},{x:162,y:153.6},{x:168,y:154.7},{x:174,y:155.5},
                        {x:180,y:156.1},{x:186,y:156.6},{x:192,y:156.9},{x:198,y:157.2},{x:204,y:157.4},{x:210,y:157.6},{x:216,y:157.8}];

            var set5 = [{x:60,y:111.3},{x:66,y:114.4},{x:72,y:117.4},{x:78,y:120.5},{x:84,y:123.5},{x:90,y:126.6},{x:96,y:129.6},
                        {x:102,y:132.7},{x:108,y:135.8},{x:114,y:138.9},{x:120,y:142},{x:126,y:145},{x:132,y:147.9},
                        {x:138,y:150.6},{x:144,y:153},{x:150,y:155.1},{x:156,y:156.8},{x:162,y:158.2},{x:168,y:159.2},{x:174,y:160},
                        {x:180,y:160.5},{x:186,y:160.9},{x:192,y:161.2},{x:198,y:161.4},{x:204,y:161.6},{x:210,y:161.7},{x:216,y:161.9}];

            var set6 = [{x:60,y:115.2},{x:66,y:118.3},{x:72,y:121.5},{x:78,y:124.6},{x:84,y:127.7},{x:90,y:130.8},{x:96,y:133.9},
                        {x:102,y:137},{x:108,y:140.2},{x:114,y:143.3},{x:120,y:146.4},{x:126,y:149.5},{x:132,y:152.4},
                        {x:138,y:155.1},{x:144,y:157.5},{x:150,y:159.6},{x:156,y:161.3},{x:162,y:162.7},{x:168,y:163.7},{x:174,y:164.5},
                        {x:180,y:165},{x:186,y:165.3},{x:192,y:165.6},{x:198,y:165.7},{x:204,y:165.9},{x:210,y:166},{x:216,y:166.1}];

            var set7 = [{x:60,y:119.3},{x:66,y:122.5},{x:72,y:125.6},{x:78,y:128.7},{x:84,y:131.9},{x:90,y:135},{x:96,y:138.1},
                        {x:102,y:141.3},{x:108,y:144.5},{x:114,y:147.6},{x:120,y:150.8},{x:126,y:153.9},{x:132,y:156.8},
                        {x:138,y:159.6},{x:144,y:162},{x:150,y:164.1},{x:156,y:165.9},{x:162,y:167.2},{x:168,y:168.2},{x:174,y:169},
                        {x:180,y:169.5},{x:186,y:169.8},{x:192,y:170.1},{x:198,y:170.2},{x:204,y:170.4},{x:210,y:170.5},{x:216,y:170.6}];
            
            var set8 = [{x:60,y:12.3},{x:66,y:13},{x:72,y:13.7},{x:78,y:14.4},{x:84,y:15.1},{x:90,y:15.9},{x:96,y:16.7},
                        {x:102,y:17.5},{x:108,y:18.5},{x:114,y:19.5},{x:120,y:20.7},{x:126,y:22},{x:132,y:23.3},
                        {x:138,y:24.8},{x:144,y:26.2},{x:150,y:27.6},{x:156,y:28.9},{x:162,y:30.2},{x:168,y:31.3},{x:174,y:32.3},
                        {x:180,y:33.1},{x:186,y:34},{x:192,y:34.7},{x:198,y:35.5},{x:204,y:36.2},{x:210,y:36.9},{x:216,y:37.6}];

            var set9 = [{x:60,y:13.4},{x:66,y:14.3},{x:72,y:15.1},{x:78,y:15.9},{x:84,y:16.8},{x:90,y:17.7},{x:96,y:18.7},
                        {x:102,y:19.7},{x:108,y:20.9},{x:114,y:22.1},{x:120,y:23.5},{x:126,y:25.1},{x:132,y:26.7},
                        {x:138,y:28.4},{x:144,y:30},{x:150,y:31.6},{x:156,y:33.1},{x:162,y:34.4},{x:168,y:35.6},{x:174,y:36.6},
                        {x:180,y:37.5},{x:186,y:38.3},{x:192,y:39.1},{x:198,y:39.8},{x:204,y:40.5},{x:210,y:41.1},{x:216,y:41.8}];

            var set10 = [{x:60,y:14.8},{x:66,y:15.7},{x:72,y:16.7},{x:78,y:17.7},{x:84,y:18.7},{x:90,y:19.9},{x:96,y:21.1},
                        {x:102,y:22.3},{x:108,y:23.7},{x:114,y:25.3},{x:120,y:26.9},{x:126,y:28.8},{x:132,y:30.7},
                        {x:138,y:32.6},{x:144,y:34.5},{x:150,y:36.3},{x:156,y:37.9},{x:162,y:39.4},{x:168,y:40.6},{x:174,y:41.7},
                        {x:180,y:42.5},{x:186,y:43.3},{x:192,y:44},{x:198,y:44.7},{x:204,y:45.3},{x:210,y:46},{x:216,y:46.6}];

            var set11 = [{x:60,y:16.4},{x:66,y:17.6},{x:72,y:18.7},{x:78,y:19.9},{x:84,y:21.2},{x:90,y:22.5},{x:96,y:24},
                        {x:102,y:25.5},{x:108,y:27.2},{x:114,y:29},{x:120,y:31},{x:126,y:33.2},{x:132,y:35.4},
                        {x:138,y:37.6},{x:144,y:39.8},{x:150,y:41.8},{x:156,y:43.6},{x:162,y:45.1},{x:168,y:46.4},{x:174,y:47.5},
                        {x:180,y:48.4},{x:186,y:49.1},{x:192,y:49.7},{x:198,y:50.3},{x:204,y:50.9},{x:210,y:51.5},{x:216,y:52}];

            var set12 = [{x:60,y:18.5},{x:66,y:19.9},{x:72,y:21.3},{x:78,y:22.7},{x:84,y:24.2},{x:90,y:25.9},{x:96,y:27.6},
                        {x:102,y:29.5},{x:108,y:31.5},{x:114,y:33.6},{x:120,y:36},{x:126,y:38.4},{x:132,y:41},
                        {x:138,y:43.6},{x:144,y:46},{x:150,y:48.2},{x:156,y:50.2},{x:162,y:51.8},{x:168,y:53.2},{x:174,y:54.3},
                        {x:180,y:55.1},{x:186,y:55.8},{x:192,y:56.3},{x:198,y:56.9},{x:204,y:57.3},{x:210,y:57.8},{x:216,y:58.2}];

            var set13 = [{x:60,y:21.3},{x:66,y:22.9},{x:72,y:24.6},{x:78,y:26.3},{x:84,y:28.2},{x:90,y:30.1},{x:96,y:32.2},
                        {x:102,y:34.4},{x:108,y:36.7},{x:114,y:39.3},{x:120,y:42},{x:126,y:44.8},{x:132,y:47.7},
                        {x:138,y:50.6},{x:144,y:53.4},{x:150,y:55.8},{x:156,y:57.9},{x:162,y:59.7},{x:168,y:61.1},{x:174,y:62.2},
                        {x:180,y:62.9},{x:186,y:63.5},{x:192,y:64},{x:198,y:64.4},{x:204,y:64.7},{x:210,y:65},{x:216,y:65.3}];

            var set14 = [{x:60,y:25},{x:66,y:27},{x:72,y:29.1},{x:78,y:31.2},{x:84,y:33.4},{x:90,y:35.7},{x:96,y:38.1},
                        {x:102,y:40.7},{x:108,y:43.4},{x:114,y:46.3},{x:120,y:49.4},{x:126,y:52.6},{x:132,y:55.9},
                        {x:138,y:59.1},{x:144,y:62.1},{x:150,y:64.8},{x:156,y:67.1},{x:162,y:69},{x:168,y:70.4},{x:174,y:71.4},
                        {x:180,y:72.1},{x:186,y:72.5},{x:192,y:72.8},{x:198,y:73.1},{x:204,y:73.3},{x:210,y:73.4},{x:216,y:73.5}];

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrapheight = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var wrapweight = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnterheight = wrapheight.enter().append('g').attr('class', 'd3line').append('g');
            var gEnterweight = wrapweight.enter().append('g').attr('class', 'd3line').append('g');

            gEnterheight.append('g').attr('class', 'lines');
            gEnterheight.append('g').attr('class', 'point-clips');
            gEnterheight.append('g').attr('class', 'point-paths');

            gEnterheight.append('g').attr('class', 'lines');
            gEnterheight.append('g').attr('class', 'point-clips');
            gEnterheight.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("cardinal");
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xVal = [5,5.6,6,6.6,7,7.6,8,8.6,9,9.6,10,10.6,11,11.6,12,12.6,13,13.6,14,14.6,15,15.6,16,16.6,17,17.6,18];
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,190]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,190]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).innerTickSize(-width)
                            .outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };

            // plot user data points
            var heightpoint = wrapheight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
            
            var weightpoint = wrapweight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" Kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -50 )
                .style("text-anchor", "middle")
                .text("IAP Girls Height & Weight Chart");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height - 30)
                .attr("transform", "translate(-980,900) rotate(-90)")
                .style("text-anchor", "middle")
                // .style("font-size","10px")
                .text("Reviesed IAP growth charts for height, weight & body mass index for 5 to 18 year old indian children.");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height - 25)
                .attr("transform", "translate(-970,900) rotate(-90)")
                .style("text-anchor", "middle")
                // .style("font-size","10px")
                .text("V.Khadilkar et al. from Indian Academy of Pediatrics Growth Chart Committee Indian Pediatrics. Jan 2015, volume 52");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,1250) rotate(-90)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", 300 )
                .attr("y", height-10 )
                .attr("transform","rotate(90,575,1150)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,450) rotate(-90)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", -500 )
                .attr("y", height-10 )
                .attr("transform","rotate(90,575,1150)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 760 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 735 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 710 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 680 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 650 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 615 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 575 )
                .style("text-anchor", "start")
                .text("97");

            svg.append("text")
                .attr("x", 690 )
                .attr("y", 215 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 195 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 175 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 155 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 135 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 115 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 90 )
                .style("text-anchor", "start")
                .text("97");

            svg.append("text")
                .attr("x", -25 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("kg");

            svg.append("text")
                .attr("x", width+30 )
                .attr("y", height+20 )
                .style("text-anchor", "end")
                .text("kg");
            
            svg.append("text")
                .attr("x", width+30 )
                .attr("y", -15 )
                .style("text-anchor", "end")
                .text("cm");

            svg.append("text")
                .attr("x", -25 )
                .attr("y", -15 )
                .style("text-anchor", "start")
                .text("cm");
            
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set13),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});
'use strict';
angular.module('AngularApp').directive('combinedChartMalePrint', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:9%;padding-top:10%;' viewBox='0 0 930 980'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var heightData = [];
            var weightData = [];

            if(vitalData.height){
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x>59 && vitalData.height[i].x<217) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            if(vitalData.weight) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x>59 && vitalData.weight[i].x<217) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var set1 = [{x:60,y:99},	{x:66,y:101.6},{x:72,y:104.2},{x:78,y:106.8},{x:84,y:109.3},{x:90,y:111.8},
                        {x:96,y:114.3},{x:102,y:116.7},{x:108,y:119},{x:114,y:121.3},{x:120,y:123.6},{x:126,y:125.9},{x:132,y:128.2},
                        {x:138,y:130.7},{x:144,y:133.2},{x:150,y:135.7},{x:156,y:138.3},{x:162,y:140.9},{x:168,y:143.4},{x:174,y:145.8},
                        {x:180,y:148},{x:186,y:150},{x:192,y:151.8},{x:198,y:153.4},{x:204,y:155},{x:210,y:156.6},{x:216,y:158.1}];

            var set2 = [{x:60,y:102.3},{x:66,y:105},{x:72,y:107.7},{x:78,y:110.4},{x:84,y:113},{x:90,y:115.7},
                        {x:96,y:118.2},{x:102,y:120.8},{x:108,y:123.2},{x:114,y:125.6},{x:120,y:128.1},{x:126,y:130.5},{x:132,y:133},
                        {x:138,y:135.6},{x:144,y:138.3},{x:150,y:141},{x:156,y:143.7},{x:162,y:146.4},{x:168,y:149},{x:174,y:151.5},
                        {x:180,y:153.7},{x:186,y:155.7},{x:192,y:157.4},{x:198,y:159.1},{x:204,y:160.6},{x:210,y:162.1},{x:216,y:163.6}];
                    
            var set3 = [{x:60,y:105.6},{x:66,y:108.4},{x:72,y:111.2},{x:78,y:114},{x:84,y:116.8},{x:90,y:119.6},{x:96,y:122.3},
                        {x:102,y:124.9},{x:108,y:127.5},{x:114,y:130},{x:120,y:132.6},{x:126,y:135.2},{x:132,y:137.8},{x:138,y:140.6},
                        {x:144,y:143.3},{x:150,y:146.2},{x:156,y:149},{x:162,y:151.8},{x:168,y:154.5},{x:174,y:157},
                        {x:180,y:159.2},{x:186,y:161.2},{x:192,y:162.9},{x:198,y:164.5},{x:204,y:165.9},{x:210,y:167.3},{x:216,y:168.7}];

            var set4 = [{x:60,y:108.9},{x:66,y:111.9},{x:72,y:114.8},{x:78,y:117.8},{x:84,y:120.7},{x:90,y:123.5},{x:96,y:126.4},
                        {x:102,y:129.1},{x:108,y:131.8},{x:114,y:134.5},{x:120,y:137.2},{x:126,y:139.9},{x:132,y:142.7},{x:138,y:145.5},
                        {x:144,y:148.4},{x:150,y:151.4},{x:156,y:154.3},{x:162,y:157.2},{x:168,y:159.9},{x:174,y:162.3},
                        {x:180,y:164.5},{x:186,y:166.5},{x:192,y:168.1},{x:198,y:169.6},{x:204,y:171},{x:210,y:172.3},{x:216,y:173.6}];

            var set5 = [{x:60,y:112.4},{x:66,y:115.4},{x:72,y:118.5},{x:78,y:121.6},{x:84,y:124.6},{x:90,y:127.6},{x:96,y:130.5},
                        {x:102,y:133.4},{x:108,y:136.3},{x:114,y:139.1},{x:120,y:141.9},{x:126,y:144.7},{x:132,y:147.6},{x:138,y:150.5},
                        {x:144,y:153.5},{x:150,y:156.5},{x:156,y:159.5},{x:162,y:162.4},{x:168,y:165.1},{x:174,y:167.6},
                        {x:180,y:169.7},{x:186,y:171.6},{x:192,y:173.1},{x:198,y:174.5},{x:204,y:175.8},{x:210,y:177},{x:216,y:178.2}];

            var set6 = [{x:60,y:115.9},{x:66,y:119},{x:72,y:122.2},{x:78,y:125.4},{x:84,y:128.6},{x:90,y:131.7},{x:96,y:134.8},
                        {x:102,y:137.8},{x:108,y:140.7},{x:114,y:143.7},{x:120,y:146.6},{x:126,y:149.5},{x:132,y:152.5},{x:138,y:155.6},
                        {x:144,y:158.6},{x:150,y:161.7},{x:156,y:164.7},{x:162,y:167.6},{x:168,y:170.3},{x:174,y:172.7},
                        {x:180,y:174.8},{x:186,y:176.5},{x:192,y:178},{x:198,y:179.3},{x:204,y:180.4},{x:210,y:181.5},{x:216,y:182.5}];

            var set7 = [{x:60,y:119.4},{x:66,y:122.7},{x:72,y:126},{x:78,y:129.3},{x:84,y:132.6},{x:90,y:135.9},{x:96,y:139.1},
                        {x:102,y:142.2},{x:108,y:145.3},{x:114,y:148.3},{x:120,y:151.4},{x:126,y:154.4},{x:132,y:157.5},{x:138,y:160.6},
                        {x:144,y:163.7},{x:150,y:166.8},{x:156,y:169.9},{x:162,y:172.7},{x:168,y:175.4},{x:174,y:177.7},
                        {x:180,y:179.7},{x:186,y:181.4},{x:192,y:182.7},{x:198,y:183.8},{x:204,y:184.8},{x:210,y:185.8},{x:216,y:186.7}];
            
            var set8 = [{x:60,y:13.2},{x:66,y:13.8},{x:72,y:14.5},{x:78,y:15.3},{x:84,y:16},{x:90,y:16.7},{x:96,y:17.5},
                        {x:102,y:18.3},{x:108,y:19.1},{x:114,y:19.9},{x:120,y:20.7},{x:126,y:21.6},{x:132,y:22.6},{x:138,y:23.8},
                        {x:144,y:24.9},{x:150,y:26.1},{x:156,y:27.5},{x:162,y:29},{x:168,y:30.7},{x:174,y:32.6},
                        {x:180,y:34.5},{x:186,y:36.1},{x:192,y:37.5},{x:198,y:38.7},{x:204,y:39.8},{x:210,y:40.8},{x:216,y:41.8}];

            var set9 = [{x:60,y:14.3},{x:66,y:15},{x:72,y:15.8},{x:78,y:16.8},{x:84,y:17.6},{x:90,y:18.5},{x:96,y:19.5},
                        {x:102,y:20.5},{x:108,y:21.5},{x:114,y:22.4},{x:120,y:23.5},{x:126,y:24.6},{x:132,y:25.9},{x:138,y:27.3},
                        {x:144,y:28.7},{x:150,y:30.2},{x:156,y:31.8},{x:162,y:33.6},{x:168,y:35.5},{x:174,y:37.7},
                        {x:180,y:39.8},{x:186,y:41.6},{x:192,y:43.1},{x:198,y:44.4},{x:204,y:45.6},{x:210,y:46.7},{x:216,y:47.7}];

            var set10 = [{x:60,y:15.6},{x:66,y:16.5},{x:72,y:17.4},{x:78,y:18.6},{x:84,y:19.6},{x:90,y:20.7},{x:96,y:21.9},
                        {x:102,y:23.2},{x:108,y:24.3},{x:114,y:25.6},{x:120,y:26.9},{x:126,y:28.3},{x:132,y:29.8},{x:138,y:31.6},
                        {x:144,y:33.3},{x:150,y:35.1},{x:156,y:37},{x:162,y:39.1},{x:168,y:41.3},{x:174,y:43.7},
                        {x:180,y:45.9},{x:186,y:47.9},{x:192,y:49.5},{x:198,y:50.9},{x:204,y:52.1},{x:210,y:53.2},{x:216,y:54.3}];

            var set11 = [{x:60,y:17.1},{x:66,y:18.2},{x:72,y:19.3},{x:78,y:20.7},{x:84,y:21.9},{x:90,y:23.3},{x:96,y:24.8},
                        {x:102,y:26.4},{x:108,y:27.9},{x:114,y:29.4},{x:120,y:31.1},{x:126,y:32.8},{x:132,y:34.7},{x:138,y:36.9},
                        {x:144,y:39},{x:150,y:41.2},{x:156,y:43.3},{x:162,y:45.7},{x:168,y:48.2},{x:174,y:50.8},
                        {x:180,y:53.1},{x:186,y:55.2},{x:192,y:56.8},{x:198,y:58.2},{x:204,y:59.5},{x:210,y:60.6},{x:216,y:61.6}];

            var set12 = [{x:60,y:19},{x:66,y:20.3},{x:72,y:21.7},{x:78,y:23.3},{x:84,y:24.9},{x:90,y:26.6},{x:96,y:28.5},
                        {x:102,y:30.5},{x:108,y:32.3},{x:114,y:34.3},{x:120,y:36.3},{x:126,y:38.5},{x:132,y:40.9},{x:138,y:43.5},
                        {x:144,y:46},{x:150,y:48.6},{x:156,y:51.1},{x:162,y:53.8},{x:168,y:56.4},{x:174,y:59.1},
                        {x:180,y:61.6},{x:186,y:63.6},{x:192,y:65.2},{x:198,y:66.6},{x:204,y:67.8},{x:210,y:68.7},{x:216,y:69.7}];

            var set13 = [{x:60,y:21.3},{x:66,y:22.9},{x:72,y:24.6},{x:78,y:26.6},{x:84,y:28.6},{x:90,y:30.8},{x:96,y:33.2},
                        {x:102,y:35.7},{x:108,y:38},{x:114,y:40.5},{x:120,y:43},{x:126,y:45.8},{x:132,y:48.7},{x:138,y:51.8},
                        {x:144,y:54.8},{x:150,y:57.8},{x:156,y:60.7},{x:162,y:63.6},{x:168,y:66.3},{x:174,y:69.1},
                        {x:180,y:71.5},{x:186,y:73.4},{x:192,y:74.8},{x:198,y:76.1},{x:204,y:77.1},{x:210,y:77.8},{x:216,y:78.6}];

            var set14 = [{x:60,y:24.2},{x:66,y:26.1},{x:72,y:28.3},{x:78,y:30.8},{x:84,y:33.4},{x:90,y:36.2},{x:96,y:39.4},
                        {x:102,y:42.6},{x:108,y:45.5},{x:114,y:48.6},{x:120,y:51.8},{x:126,y:55.2},{x:132,y:58.7},{x:138,y:62.5},
                        {x:144,y:66.1},{x:150,y:69.5},{x:156,y:72.6},{x:162,y:75.6},{x:168,y:78.3},{x:174,y:80.9},
                        {x:180,y:83.1},{x:186,y:84.7},{x:192,y:85.8},{x:198,y:86.8},{x:204,y:87.5},{x:210,y:88},{x:216,y:88.4}];

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrapheight = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var wrapweight = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnterheight = wrapheight.enter().append('g').attr('class', 'd3line').append('g');
            var gEnterweight = wrapweight.enter().append('g').attr('class', 'd3line').append('g');
            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("cardinal");

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xVal = [5,5.6,6,6.6,7,7.6,8,8.6,9,9.6,10,10.6,11,11.6,12,12.6,13,13.6,14,14.6,15,15.6,16,16.6,17,17.6,18];
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,190]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,190]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).innerTickSize(-width)
                            .outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };
            
            // plot user data points
            var heightpoint = wrapheight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
            
            var weightpoint = wrapweight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +"Kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -50 )
                .style("text-anchor", "middle")
                .text("IAP Boys Height & Weight Chart");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height - 30)
                .attr("transform", "translate(-980,900) rotate(-90)")
                .style("text-anchor", "middle")
                // .style("font-size","10px")
                .text("Reviesed IAP growth charts for height, weight & body mass index for 5 to 18 year old indian children.");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height - 25)
                .attr("transform", "translate(-970,900) rotate(-90)")
                .style("text-anchor", "middle")
                // .style("font-size","10px")
                .text("V.Khadilkar et al. from Indian Academy of Pediatrics Growth Chart Committee Indian Pediatrics. Jan 2015, volume 52");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,1250) rotate(-90)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", 300 )
                .attr("y", height-10 )
                .attr("transform","rotate(90,575,1150)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,450) rotate(-90)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", -500 )
                .attr("y", height-10 )
                .attr("transform","rotate(90,575,1150)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 740 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 710 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 680 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 640 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 600 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 555 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 500 )
                .style("text-anchor", "start")
                .text("97");

            svg.append("text")
                .attr("x", 690 )
                .attr("y", 170 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 145 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 120 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 95 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 70 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 45 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 25 )
                .style("text-anchor", "start")
                .text("97");

            svg.append("text")
                .attr("x", -25 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("kg");

            svg.append("text")
                .attr("x", width+30 )
                .attr("y", height+20 )
                .style("text-anchor", "end")
                .text("kg");
            
            svg.append("text")
                .attr("x", width+30 )
                .attr("y", -15 )
                .style("text-anchor", "end")
                .text("cm");

            svg.append("text")
                .attr("x", -25 )
                .attr("y", -15 )
                .style("text-anchor", "start")
                .text("cm");
            
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set13),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});
'use strict';
angular.module('AngularApp').directive('hlPostnatalChartFemalePrint', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:6%;padding-top:4%;' viewBox='0 0 1010 960'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 1000 - margin.top - margin.bottom;
              var width = 980 - margin.left - margin.right;
  
            var headConst = -20;
            var lengthConst = -14;

            var hcData = [];
            if(vitalData.postnatalHc) {
                for(var i = 0; i < vitalData.postnatalHc.length; i++){
                    hcData.push({x:vitalData.postnatalHc[i].x, y:parseFloat(vitalData.postnatalHc[i].y) + headConst});
                }
            }

            var lengthData = [];
            if(vitalData.postnatalHeight) {
                for(var i = 0; i < vitalData.postnatalHeight.length; i++){
                    lengthData.push({x:vitalData.postnatalHeight[i].x, y:parseFloat(vitalData.postnatalHeight[i].y) + lengthConst});
                }
            }
  
              // Start of Head data
              var set1 = [{x:27,y:20.7+headConst},{x:28,y:22.1+headConst},{x:29,y:23.4+headConst},{x:30,y:24.5+headConst},{x:31,y:25.6+headConst},{x:32,y:26.6+headConst},{x:33,y:27.5+headConst},{x:34,y:28.4+headConst},{x:35,y:29.1+headConst},{x:36,y:29.9+headConst},{x:37,y:30.6+headConst},{x:38,y:31.2+headConst},{x:39,y:31.8+headConst},{x:40,y:32.4+headConst},{x:41,y:32.9+headConst},{x:42,y:33.4+headConst},{x:43,y:33.9+headConst},{x:44,y:34.3+headConst},{x:45,y:34.8+headConst},{x:46,y:35.2+headConst},{x:47,y:35.6+headConst},{x:48,y:35.9+headConst},{x:49,y:36.3+headConst},{x:50,y:36.6+headConst},{x:51,y:36.9+headConst},{x:52,y:37.2+headConst},{x:53,y:37.5+headConst},{x:54,y:37.8+headConst},{x:55,y:38+headConst},{x:56,y:38.3+headConst},{x:57,y:38.5+headConst},{x:58,y:38.8+headConst},{x:59,y:39+headConst},{x:60,y:39.2+headConst},{x:61,y:39.4+headConst},{x:62,y:39.6+headConst},{x:63,y:39.8+headConst},{x:64,y:40+headConst}];
    
              var set2 = [{x:27,y:21.8+headConst},{x:28,y:23.1+headConst},{x:29,y:24.3+headConst},{x:30,y:25.4+headConst},{x:31,y:26.4+headConst},{x:32,y:27.3+headConst},{x:33,y:28.2+headConst},{x:34,y:29+headConst},{x:35,y:29.8+headConst},{x:36,y:30.5+headConst},{x:37,y:31.2+headConst},{x:38,y:31.8+headConst},{x:39,y:32.4+headConst},{x:40,y:33+headConst},{x:41,y:33.5+headConst},{x:42,y:34+headConst},{x:43,y:34.5+headConst},{x:44,y:34.9+headConst},{x:45,y:35.4+headConst},{x:46,y:35.8+headConst},{x:47,y:36.1+headConst},{x:48,y:36.5+headConst},{x:49,y:36.9+headConst},{x:50,y:37.2+headConst},{x:51,y:37.5+headConst},{x:52,y:37.8+headConst},{x:53,y:38.1+headConst},{x:54,y:38.4+headConst},{x:55,y:38.7+headConst},{x:56,y:38.9+headConst},{x:57,y:39.2+headConst},{x:58,y:39.4+headConst},{x:59,y:39.7+headConst},{x:60,y:39.9+headConst},{x:61,y:40.1+headConst},{x:62,y:40.3+headConst},{x:63,y:40.5+headConst},{x:64,y:40.7+headConst}];
                      
              var set3 = [{x:27,y:24+headConst},{x:28,y:25.1+headConst},{x:29,y:26.2+headConst},{x:30,y:27.1+headConst},{x:31,y:28.1+headConst},{x:32,y:28.9+headConst},{x:33,y:29.7+headConst},{x:34,y:30.5+headConst},{x:35,y:31.2+headConst},{x:36,y:31.9+headConst},{x:37,y:32.5+headConst},{x:38,y:33.1+headConst},{x:39,y:33.7+headConst},{x:40,y:34.2+headConst},{x:41,y:34.8+headConst},{x:42,y:35.3+headConst},{x:43,y:35.7+headConst},{x:44,y:36.2+headConst},{x:45,y:36.6+headConst},{x:46,y:37+headConst},{x:47,y:37.4+headConst},{x:48,y:37.8+headConst},{x:49,y:38.1+headConst},{x:50,y:38.5+headConst},{x:51,y:38.8+headConst},{x:52,y:39.2+headConst},{x:53,y:39.5+headConst},{x:54,y:39.8+headConst},{x:55,y:40+headConst},{x:56,y:40.3+headConst},{x:57,y:40.6+headConst},{x:58,y:40.8+headConst},{x:59,y:41.1+headConst},{x:60,y:41.3+headConst},{x:61,y:41.6+headConst},{x:62,y:41.8+headConst},{x:63,y:42+headConst},{x:64,y:42.2+headConst}];
  
              var set4 = [{x:27,y:26.2+headConst},{x:28,y:27.2+headConst},{x:29,y:28.1+headConst},{x:30,y:28.9+headConst},{x:31,y:29.7+headConst},{x:32,y:30.5+headConst},{x:33,y:31.2+headConst},{x:34,y:31.9+headConst},{x:35,y:32.6+headConst},{x:36,y:33.2+headConst},{x:37,y:33.8+headConst},{x:38,y:34.4+headConst},{x:39,y:35+headConst},{x:40,y:35.5+headConst},{x:41,y:36+headConst},{x:42,y:36.5+headConst},{x:43,y:37+headConst},{x:44,y:37.4+headConst},{x:45,y:37.9+headConst},{x:46,y:38.3+headConst},{x:47,y:38.7+headConst},{x:48,y:39.1+headConst},{x:49,y:39.4+headConst},{x:50,y:39.8+headConst},{x:51,y:40.1+headConst},{x:52,y:40.5+headConst},{x:53,y:40.8+headConst},{x:54,y:41.1+headConst},{x:55,y:41.4+headConst},{x:56,y:41.7+headConst},{x:57,y:42+headConst},{x:58,y:42.3+headConst},{x:59,y:42.5+headConst},{x:60,y:42.8+headConst},{x:61,y:43+headConst},{x:62,y:43.3+headConst},{x:63,y:43.5+headConst},{x:64,y:43.7+headConst}];
  
              var set5 = [{x:27,y:27.2+headConst},{x:28,y:28.1+headConst},{x:29,y:28.9+headConst},{x:30,y:29.7+headConst},{x:31,y:30.5+headConst},{x:32,y:31.2+headConst},{x:33,y:31.9+headConst},{x:34,y:32.6+headConst},{x:35,y:33.2+headConst},{x:36,y:33.9+headConst},{x:37,y:34.5+headConst},{x:38,y:35+headConst},{x:39,y:35.6+headConst},{x:40,y:36.1+headConst},{x:41,y:36.6+headConst},{x:42,y:37.1+headConst},{x:43,y:37.6+headConst},{x:44,y:38+headConst},{x:45,y:38.4+headConst},{x:46,y:38.9+headConst},{x:47,y:39.3+headConst},{x:48,y:39.7+headConst},{x:49,y:40+headConst},{x:50,y:40.4+headConst},{x:51,y:40.7+headConst},{x:52,y:41.1+headConst},{x:53,y:41.4+headConst},{x:54,y:41.7+headConst},{x:55,y:42.1+headConst},{x:56,y:42.4+headConst},{x:57,y:42.6+headConst},{x:58,y:42.9+headConst},{x:59,y:43.2+headConst},{x:60,y:43.5+headConst},{x:61,y:43.7+headConst},{x:62,y:44+headConst},{x:63,y:44.2+headConst},{x:64,y:44.5+headConst}];
              // End of Head data
  
              // Start of Length data
              var set6 = [{x:27,y:27.8+lengthConst},{x:28,y:29.7+lengthConst},{x:29,y:31.5+lengthConst},{x:30,y:33.2+lengthConst},{x:31,y:34.8+lengthConst},{x:32,y:36.4+lengthConst},{x:33,y:37.8+lengthConst},{x:34,y:39.2+lengthConst},{x:35,y:40.5+lengthConst},{x:36,y:41.7+lengthConst},{x:37,y:42.9+lengthConst},{x:38,y:44+lengthConst},{x:39,y:45+lengthConst},{x:40,y:46+lengthConst},{x:41,y:47+lengthConst},{x:42,y:47.9+lengthConst},{x:43,y:48.7+lengthConst},{x:44,y:49.6+lengthConst},{x:45,y:50.3+lengthConst},{x:46,y:51.1+lengthConst},{x:47,y:51.8+lengthConst},{x:48,y:52.5+lengthConst},{x:49,y:53.1+lengthConst},{x:50,y:53.8+lengthConst},{x:51,y:54.4+lengthConst},{x:52,y:54.9+lengthConst},{x:53,y:55.5+lengthConst},{x:54,y:56+lengthConst},{x:55,y:56.6+lengthConst},{x:56,y:57.1+lengthConst},{x:57,y:57.6+lengthConst},{x:58,y:58+lengthConst},{x:59,y:58.5+lengthConst},{x:60,y:58.9+lengthConst},{x:61,y:59.4+lengthConst},{x:62,y:59.8+lengthConst},{x:63,y:60.2+lengthConst},{x:64,y:60.6+lengthConst}];
  
              var set7 = [{x:27,y:29+lengthConst},{x:28,y:30.9+lengthConst},{x:29,y:32.7+lengthConst},{x:30,y:34.3+lengthConst},{x:31,y:35.9+lengthConst},{x:32,y:37.5+lengthConst},{x:33,y:38.9+lengthConst},{x:34,y:40.3+lengthConst},{x:35,y:41.5+lengthConst},{x:36,y:42.8+lengthConst},{x:37,y:43.9+lengthConst},{x:38,y:45+lengthConst},{x:39,y:46.1+lengthConst},{x:40,y:47.1+lengthConst},{x:41,y:48+lengthConst},{x:42,y:48.9+lengthConst},{x:43,y:49.8+lengthConst},{x:44,y:50.6+lengthConst},{x:45,y:51.4+lengthConst},{x:46,y:52.1+lengthConst},{x:47,y:52.9+lengthConst},{x:48,y:53.6+lengthConst},{x:49,y:54.2+lengthConst},{x:50,y:54.9+lengthConst},{x:51,y:55.5+lengthConst},{x:52,y:56.1+lengthConst},{x:53,y:56.6+lengthConst},{x:54,y:57.2+lengthConst},{x:55,y:57.7+lengthConst},{x:56,y:58.2+lengthConst},{x:57,y:58.7+lengthConst},{x:58,y:59.2+lengthConst},{x:59,y:59.7+lengthConst},{x:60,y:60.2+lengthConst},{x:61,y:60.6+lengthConst},{x:62,y:61+lengthConst},{x:63,y:61.5+lengthConst},{x:64,y:61.9+lengthConst}];
                      
              var set8 = [{x:27,y:31.7+lengthConst},{x:28,y:33.5+lengthConst},{x:29,y:35.2+lengthConst},{x:30,y:36.8+lengthConst},{x:31,y:38.4+lengthConst},{x:32,y:39.9+lengthConst},{x:33,y:41.3+lengthConst},{x:34,y:42.6+lengthConst},{x:35,y:43.9+lengthConst},{x:36,y:45.1+lengthConst},{x:37,y:46.2+lengthConst},{x:38,y:47.3+lengthConst},{x:39,y:48.3+lengthConst},{x:40,y:49.3+lengthConst},{x:41,y:50.3+lengthConst},{x:42,y:51.2+lengthConst},{x:43,y:52.1+lengthConst},{x:44,y:52.9+lengthConst},{x:45,y:53.7+lengthConst},{x:46,y:54.5+lengthConst},{x:47,y:55.2+lengthConst},{x:48,y:55.9+lengthConst},{x:49,y:56.6+lengthConst},{x:50,y:57.3+lengthConst},{x:51,y:57.9+lengthConst},{x:52,y:58.5+lengthConst},{x:53,y:59.1+lengthConst},{x:54,y:59.7+lengthConst},{x:55,y:60.3+lengthConst},{x:56,y:60.8+lengthConst},{x:57,y:61.3+lengthConst},{x:58,y:61.9+lengthConst},{x:59,y:62.4+lengthConst},{x:60,y:62.9+lengthConst},{x:61,y:63.3+lengthConst},{x:62,y:63.8+lengthConst},{x:63,y:64.2+lengthConst},{x:64,y:64.7+lengthConst}];
  
              var set9 = [{x:27,y:34.6+lengthConst},{x:28,y:36.3+lengthConst},{x:29,y:38+lengthConst},{x:30,y:39.5+lengthConst},{x:31,y:41+lengthConst},{x:32,y:42.4+lengthConst},{x:33,y:43.8+lengthConst},{x:34,y:45.1+lengthConst},{x:35,y:46.3+lengthConst},{x:36,y:47.5+lengthConst},{x:37,y:48.6+lengthConst},{x:38,y:49.7+lengthConst},{x:39,y:50.7+lengthConst},{x:40,y:51.7+lengthConst},{x:41,y:52.7+lengthConst},{x:42,y:53.6+lengthConst},{x:43,y:54.5+lengthConst},{x:44,y:55.3+lengthConst},{x:45,y:56.1+lengthConst},{x:46,y:56.9+lengthConst},{x:47,y:57.7+lengthConst},{x:48,y:58.4+lengthConst},{x:49,y:59.1+lengthConst},{x:50,y:59.8+lengthConst},{x:51,y:60.5+lengthConst},{x:52,y:61.1+lengthConst},{x:53,y:61.7+lengthConst},{x:54,y:62.3+lengthConst},{x:55,y:62.9+lengthConst},{x:56,y:63.5+lengthConst},{x:57,y:64.1+lengthConst},{x:58,y:64.6+lengthConst},{x:59,y:65.2+lengthConst},{x:60,y:65.7+lengthConst},{x:61,y:66.2+lengthConst},{x:62,y:66.7+lengthConst},{x:63,y:67.2+lengthConst},{x:64,y:67.6+lengthConst}];
  
              var set10 = [{x:27,y:36.1+lengthConst},{x:28,y:37.8+lengthConst},{x:29,y:39.3+lengthConst},{x:30,y:40.9+lengthConst},{x:31,y:42.3+lengthConst},{x:32,y:43.7+lengthConst},{x:33,y:45+lengthConst},{x:34,y:46.3+lengthConst},{x:35,y:47.5+lengthConst},{x:36,y:48.7+lengthConst},{x:37,y:49.8+lengthConst},{x:38,y:50.9+lengthConst},{x:39,y:51.9+lengthConst},{x:40,y:52.9+lengthConst},{x:41,y:53.8+lengthConst},{x:42,y:54.7+lengthConst},{x:43,y:55.6+lengthConst},{x:44,y:56.5+lengthConst},{x:45,y:57.3+lengthConst},{x:46,y:58.1+lengthConst},{x:47,y:58.9+lengthConst},{x:48,y:59.6+lengthConst},{x:49,y:60.3+lengthConst},{x:50,y:61+lengthConst},{x:51,y:61.7+lengthConst},{x:52,y:62.4+lengthConst},{x:53,y:63+lengthConst},{x:54,y:63.6+lengthConst},{x:55,y:64.2+lengthConst},{x:56,y:64.8+lengthConst},{x:57,y:65.4+lengthConst},{x:58,y:66+lengthConst},{x:59,y:66.5+lengthConst},{x:60,y:67+lengthConst},{x:61,y:67.6+lengthConst},{x:62,y:68.1+lengthConst},{x:63,y:68.6+lengthConst},{x:64,y:69.1+lengthConst}];
              // End of Length data
              
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([lengthData]);
            var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([65,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([65,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,61]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,61]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%2==0 ? yAxisLeftFake(d):'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%2==0 ? yAxisRightFake(d):'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var yAxisLeftFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return '';
                case 14:return 28;
                case 16:return 30;
                case 18:return 32;
                case 20:return 34;
                case 22:return 36;
                case 24:return 38;
                case 26:return 40;
                case 28:return 42;
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var yAxisRightFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return 32;
                case 14:return 34;
                case 16:return 36;
                case 18:return 38;
                case 20:return 40;
                case 22:return 42;
                case 24:return 44;
                case 26:return 46;
                case 28:return '';
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Postmensural age (weeks)");
            
            svg.append("text")
                .attr("x", 30 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("© University of Oxford");

            svg.append("text")
                .attr("x", 750 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("Villar et al. Lancet Glob Health 2015;3:e681-91");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            

            svg.append("text")
                .attr("x", -860 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -380 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -700 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -260 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 220 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 200 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 170 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 120 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 90 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 640 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 620 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 600 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 580 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 560 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set6),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set8),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set10),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(hcData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                  svg.append("svg:path")
                  .attr({
                    d: datalineFunc(lengthData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('hlPostnatalChartMalePrint', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:4%;' viewBox='0 0 1010 960'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 980 - margin.left - margin.right;

            var headConst = -20;
            var lengthConst = -14;

            var hcData = [];
            if(vitalData.postnatalHc) {
                for(var i = 0; i < vitalData.postnatalHc.length; i++){
                    hcData.push({x:vitalData.postnatalHc[i].x, y:parseFloat(vitalData.postnatalHc[i].y) + headConst});
                }
            }

            var lengthData = [];
            if(vitalData.postnatalHeight) {
                for(var i = 0; i < vitalData.postnatalHeight.length; i++){
                    lengthData.push({x:vitalData.postnatalHeight[i].x, y:parseFloat(vitalData.postnatalHeight[i].y) + lengthConst});
                }
            }

            // Start of Head data
            var set1 = [{x:27,y:21.5+headConst},{x:28,y:22.9+headConst},{x:29,y:24.2+headConst},{x:30,y:25.3+headConst},{x:31,y:26.4+headConst},{x:32,y:27.4+headConst},{x:33,y:28.3+headConst},{x:34,y:29.2+headConst},{x:35,y:29.9+headConst},{x:36,y:30.7+headConst},{x:37,y:31.4+headConst},{x:38,y:32+headConst},{x:39,y:32.6+headConst},{x:40,y:33.2+headConst},{x:41,y:33.7+headConst},{x:42,y:34.2+headConst},{x:43,y:34.7+headConst},{x:44,y:35.1+headConst},{x:45,y:35.6+headConst},{x:46,y:36+headConst},{x:47,y:36.4+headConst},{x:48,y:36.7+headConst},{x:49,y:37.1+headConst},{x:50,y:37.4+headConst},{x:51,y:37.7+headConst},{x:52,y:38+headConst},{x:53,y:38.3+headConst},{x:54,y:38.6+headConst},{x:55,y:38.8+headConst},{x:56,y:39.1+headConst},{x:57,y:39.3+headConst},{x:58,y:39.6+headConst},{x:59,y:39.8+headConst},{x:60,y:40+headConst},{x:61,y:40.2+headConst},{x:62,y:40.4+headConst},{x:63,y:40.6+headConst},{x:64,y:40.8+headConst}];

            var set2 = [{x:27,y:22.6+headConst},{x:28,y:23.9+headConst},{x:29,y:25.1+headConst},{x:30,y:26.2+headConst},{x:31,y:27.2+headConst},{x:32,y:28.1+headConst},{x:33,y:29+headConst},{x:34,y:29.8+headConst},{x:35,y:30.6+headConst},{x:36,y:31.3+headConst},{x:37,y:32+headConst},{x:38,y:32.6+headConst},{x:39,y:33.2+headConst},{x:40,y:33.8+headConst},{x:41,y:34.3+headConst},{x:42,y:34.8+headConst},{x:43,y:35.3+headConst},{x:44,y:35.7+headConst},{x:45,y:36.2+headConst},{x:46,y:36.6+headConst},{x:47,y:36.9+headConst},{x:48,y:37.3+headConst},{x:49,y:37.7+headConst},{x:50,y:38+headConst},{x:51,y:38.3+headConst},{x:52,y:38.6+headConst},{x:53,y:38.9+headConst},{x:54,y:39.2+headConst},{x:55,y:39.5+headConst},{x:56,y:39.7+headConst},{x:57,y:40+headConst},{x:58,y:40.2+headConst},{x:59,y:40.5+headConst},{x:60,y:40.7+headConst},{x:61,y:40.9+headConst},{x:62,y:41.1+headConst},{x:63,y:41.3+headConst},{x:64,y:41.5+headConst}];
                    
            var set3 = [{x:27,y:24.8+headConst},{x:28,y:25.9+headConst},{x:29,y:27+headConst},{x:30,y:27.9+headConst},{x:31,y:28.9+headConst},{x:32,y:29.7+headConst},{x:33,y:30.5+headConst},{x:34,y:31.3+headConst},{x:35,y:32+headConst},{x:36,y:32.7+headConst},{x:37,y:33.3+headConst},{x:38,y:33.9+headConst},{x:39,y:34.5+headConst},{x:40,y:35+headConst},{x:41,y:35.6+headConst},{x:42,y:36.1+headConst},{x:43,y:36.5+headConst},{x:44,y:37+headConst},{x:45,y:37.4+headConst},{x:46,y:37.8+headConst},{x:47,y:38.2+headConst},{x:48,y:38.6+headConst},{x:49,y:38.9+headConst},{x:50,y:39.3+headConst},{x:51,y:39.6+headConst},{x:52,y:40+headConst},{x:53,y:40.3+headConst},{x:54,y:40.6+headConst},{x:55,y:40.8+headConst},{x:56,y:41.1+headConst},{x:57,y:41.4+headConst},{x:58,y:41.6+headConst},{x:59,y:41.9+headConst},{x:60,y:42.1+headConst},{x:61,y:42.4+headConst},{x:62,y:42.6+headConst},{x:63,y:42.8+headConst},{x:64,y:43+headConst}];

            var set4 = [{x:27,y:27+headConst},{x:28,y:28+headConst},{x:29,y:28.9+headConst},{x:30,y:29.7+headConst},{x:31,y:30.5+headConst},{x:32,y:31.3+headConst},{x:33,y:32+headConst},{x:34,y:32.7+headConst},{x:35,y:33.4+headConst},{x:36,y:34+headConst},{x:37,y:34.6+headConst},{x:38,y:35.2+headConst},{x:39,y:35.8+headConst},{x:40,y:36.3+headConst},{x:41,y:36.8+headConst},{x:42,y:37.3+headConst},{x:43,y:37.8+headConst},{x:44,y:38.2+headConst},{x:45,y:38.7+headConst},{x:46,y:39.1+headConst},{x:47,y:39.5+headConst},{x:48,y:39.9+headConst},{x:49,y:40.2+headConst},{x:50,y:40.6+headConst},{x:51,y:40.9+headConst},{x:52,y:41.3+headConst},{x:53,y:41.6+headConst},{x:54,y:41.9+headConst},{x:55,y:42.2+headConst},{x:56,y:42.5+headConst},{x:57,y:42.8+headConst},{x:58,y:43.1+headConst},{x:59,y:43.3+headConst},{x:60,y:43.6+headConst},{x:61,y:43.8+headConst},{x:62,y:44.1+headConst},{x:63,y:44.3+headConst},{x:64,y:44.5+headConst}];

            var set5 = [{x:27,y:28+headConst},{x:28,y:28.9+headConst},{x:29,y:29.7+headConst},{x:30,y:30.5+headConst},{x:31,y:31.3+headConst},{x:32,y:32+headConst},{x:33,y:32.7+headConst},{x:34,y:33.4+headConst},{x:35,y:34+headConst},{x:36,y:34.7+headConst},{x:37,y:35.3+headConst},{x:38,y:35.8+headConst},{x:39,y:36.4+headConst},{x:40,y:36.9+headConst},{x:41,y:37.4+headConst},{x:42,y:37.9+headConst},{x:43,y:38.4+headConst},{x:44,y:38.8+headConst},{x:45,y:39.2+headConst},{x:46,y:39.7+headConst},{x:47,y:40.1+headConst},{x:48,y:40.5+headConst},{x:49,y:40.8+headConst},{x:50,y:41.2+headConst},{x:51,y:41.6+headConst},{x:52,y:41.9+headConst},{x:53,y:42.2+headConst},{x:54,y:42.5+headConst},{x:55,y:42.9+headConst},{x:56,y:43.2+headConst},{x:57,y:43.4+headConst},{x:58,y:43.7+headConst},{x:59,y:44+headConst},{x:60,y:44.3+headConst},{x:61,y:44.5+headConst},{x:62,y:44.8+headConst},{x:63,y:45+headConst},{x:64,y:45.3+headConst}];
            // End of Head data

            // Start of Length data
            var set6 = [{x:27,y:28.7+lengthConst},{x:28,y:30.7+lengthConst},{x:29,y:32.5+lengthConst},{x:30,y:34.3+lengthConst},{x:31,y:36+lengthConst},{x:32,y:37.5+lengthConst},{x:33,y:39+lengthConst},{x:34,y:40.5+lengthConst},{x:35,y:41.8+lengthConst},{x:36,y:43.1+lengthConst},{x:37,y:44.3+lengthConst},{x:38,y:45.4+lengthConst},{x:39,y:46.5+lengthConst},{x:40,y:47.5+lengthConst},{x:41,y:48.5+lengthConst},{x:42,y:49.4+lengthConst},{x:43,y:50.3+lengthConst},{x:44,y:51.1+lengthConst},{x:45,y:51.9+lengthConst},{x:46,y:52.7+lengthConst},{x:47,y:53.4+lengthConst},{x:48,y:54.2+lengthConst},{x:49,y:54.8+lengthConst},{x:50,y:55.5+lengthConst},{x:51,y:56.1+lengthConst},{x:52,y:56.7+lengthConst},{x:53,y:57.3+lengthConst},{x:54,y:57.8+lengthConst},{x:55,y:58.4+lengthConst},{x:56,y:58.9+lengthConst},{x:57,y:59.4+lengthConst},{x:58,y:59.9+lengthConst},{x:59,y:60.4+lengthConst},{x:60,y:60.8+lengthConst},{x:61,y:61.3+lengthConst},{x:62,y:61.7+lengthConst},{x:63,y:62.1+lengthConst},{x:64,y:62.5+lengthConst}];

            var set7 = [{x:27,y:29.9+lengthConst},{x:28,y:31.9+lengthConst},{x:29,y:33.7+lengthConst},{x:30,y:35.4+lengthConst},{x:31,y:37.1+lengthConst},{x:32,y:38.7+lengthConst},{x:33,y:40.1+lengthConst},{x:34,y:41.5+lengthConst},{x:35,y:42.9+lengthConst},{x:36,y:44.1+lengthConst},{x:37,y:45.3+lengthConst},{x:38,y:46.5+lengthConst},{x:39,y:47.5+lengthConst},{x:40,y:48.6+lengthConst},{x:41,y:49.6+lengthConst},{x:42,y:50.5+lengthConst},{x:43,y:51.4+lengthConst},{x:44,y:52.2+lengthConst},{x:45,y:53+lengthConst},{x:46,y:53.8+lengthConst},{x:47,y:54.6+lengthConst},{x:48,y:55.3+lengthConst},{x:49,y:56+lengthConst},{x:50,y:56.6+lengthConst},{x:51,y:57.2+lengthConst},{x:52,y:57.9+lengthConst},{x:53,y:58.4+lengthConst},{x:54,y:59+lengthConst},{x:55,y:59.6+lengthConst},{x:56,y:60.1+lengthConst},{x:57,y:60.6+lengthConst},{x:58,y:61.1+lengthConst},{x:59,y:61.6+lengthConst},{x:60,y:62.1+lengthConst},{x:61,y:62.5+lengthConst},{x:62,y:63+lengthConst},{x:63,y:63.4+lengthConst},{x:64,y:63.8+lengthConst}];
                    
            var set8 = [{x:27,y:32.7+lengthConst},{x:28,y:34.6+lengthConst},{x:29,y:36.3+lengthConst},{x:30,y:38+lengthConst},{x:31,y:39.6+lengthConst},{x:32,y:41.1+lengthConst},{x:33,y:42.6+lengthConst},{x:34,y:44+lengthConst},{x:35,y:45.3+lengthConst},{x:36,y:46.5+lengthConst},{x:37,y:47.7+lengthConst},{x:38,y:48.8+lengthConst},{x:39,y:49.9+lengthConst},{x:40,y:50.9+lengthConst},{x:41,y:51.9+lengthConst},{x:42,y:52.8+lengthConst},{x:43,y:53.7+lengthConst},{x:44,y:54.6+lengthConst},{x:45,y:55.4+lengthConst},{x:46,y:56.2+lengthConst},{x:47,y:57+lengthConst},{x:48,y:57.7+lengthConst},{x:49,y:58.4+lengthConst},{x:50,y:59.1+lengthConst},{x:51,y:59.8+lengthConst},{x:52,y:60.4+lengthConst},{x:53,y:61+lengthConst},{x:54,y:61.6+lengthConst},{x:55,y:62.2+lengthConst},{x:56,y:62.8+lengthConst},{x:57,y:63.3+lengthConst},{x:58,y:63.8+lengthConst},{x:59,y:64.4+lengthConst},{x:60,y:64.9+lengthConst},{x:61,y:65.4+lengthConst},{x:62,y:65.8+lengthConst},{x:63,y:66.3+lengthConst},{x:64,y:66.8+lengthConst}];

            var set9 = [{x:27,y:35.7+lengthConst},{x:28,y:37.5+lengthConst},{x:29,y:39.2+lengthConst},{x:30,y:40.8+lengthConst},{x:31,y:42.3+lengthConst},{x:32,y:43.8+lengthConst},{x:33,y:45.2+lengthConst},{x:34,y:46.5+lengthConst},{x:35,y:47.8+lengthConst},{x:36,y:49+lengthConst},{x:37,y:50.2+lengthConst},{x:38,y:51.3+lengthConst},{x:39,y:52.4+lengthConst},{x:40,y:53.4+lengthConst},{x:41,y:54.4+lengthConst},{x:42,y:55.3+lengthConst},{x:43,y:56.2+lengthConst},{x:44,y:57.1+lengthConst},{x:45,y:57.9+lengthConst},{x:46,y:58.7+lengthConst},{x:47,y:59.5+lengthConst},{x:48,y:60.3+lengthConst},{x:49,y:61+lengthConst},{x:50,y:61.7+lengthConst},{x:51,y:62.4+lengthConst},{x:52,y:63.1+lengthConst},{x:53,y:63.7+lengthConst},{x:54,y:64.3+lengthConst},{x:55,y:64.9+lengthConst},{x:56,y:65.5+lengthConst},{x:57,y:66.1+lengthConst},{x:58,y:66.7+lengthConst},{x:59,y:67.2+lengthConst},{x:60,y:67.8+lengthConst},{x:61,y:68.3+lengthConst},{x:62,y:68.8+lengthConst},{x:63,y:69.3+lengthConst},{x:64,y:69.8+lengthConst}];

            var set10 = [{x:27,y:37.3+lengthConst},{x:28,y:39+lengthConst},{x:29,y:40.6+lengthConst},{x:30,y:42.2+lengthConst},{x:31,y:43.7+lengthConst},{x:32,y:45.1+lengthConst},{x:33,y:46.5+lengthConst},{x:34,y:47.8+lengthConst},{x:35,y:49+lengthConst},{x:36,y:50.2+lengthConst},{x:37,y:51.4+lengthConst},{x:38,y:52.5+lengthConst},{x:39,y:53.6+lengthConst},{x:40,y:54.6+lengthConst},{x:41,y:55.6+lengthConst},{x:42,y:56.5+lengthConst},{x:43,y:57.4+lengthConst},{x:44,y:58.3+lengthConst},{x:45,y:59.1+lengthConst},{x:46,y:60+lengthConst},{x:47,y:60.7+lengthConst},{x:48,y:61.5+lengthConst},{x:49,y:62.3+lengthConst},{x:50,y:63+lengthConst},{x:51,y:63.7+lengthConst},{x:52,y:64.4+lengthConst},{x:53,y:65+lengthConst},{x:54,y:65.7+lengthConst},{x:55,y:66.3+lengthConst},{x:56,y:66.9+lengthConst},{x:57,y:67.5+lengthConst},{x:58,y:68.1+lengthConst},{x:59,y:68.6+lengthConst},{x:60,y:69.2+lengthConst},{x:61,y:69.7+lengthConst},{x:62,y:70.2+lengthConst},{x:63,y:70.8+lengthConst},{x:64,y:71.3+lengthConst}];
            // End of Length data
            
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([lengthData]);
            var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([65,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([65,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,61]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,61]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%2==0 ? yAxisLeftFake(d):'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%2==0 ? yAxisRightFake(d):'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var yAxisLeftFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return '';
                case 14:return 28;
                case 16:return 30;
                case 18:return 32;
                case 20:return 34;
                case 22:return 36;
                case 24:return 38;
                case 26:return 40;
                case 28:return 42;
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var yAxisRightFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return 32;
                case 14:return 34;
                case 16:return 36;
                case 18:return 38;
                case 20:return 40;
                case 22:return 42;
                case 24:return 44;
                case 26:return 46;
                case 28:return '';
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Postmensural age (weeks)");
            
            svg.append("text")
                .attr("x", 30 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("© University of Oxford");

            svg.append("text")
                .attr("x", 750 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("Villar et al. Lancet Glob Health 2015;3:e681-91");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            

            svg.append("text")
                .attr("x", -860 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -380 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -700 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -260 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 200 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 180 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 135 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 85 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 60 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 630 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 610 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 590 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 565 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 550 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set6),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set8),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set10),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(hcData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                  svg.append("svg:path")
                  .attr({
                    d: datalineFunc(lengthData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('hlwPretermChartFemalePrint', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:6%;padding-top:4%;' viewBox='0 0 1010 960'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 1000 - margin.top - margin.bottom;
              var width = 980 - margin.left - margin.right;
  
            var headConst = -17;
            var lengthConst = -2;
            var weightConst = 42;

            var hcData = [];
            if(vitalData.pretermHc) {
                for(var i = 0; i < vitalData.pretermHc.length; i++){
                    hcData.push({x:vitalData.pretermHc[i].x,y:vitalData.pretermHc[i].y + headConst});
                }
            }

            var heightData = [];
            if(vitalData.pretermHeight) {
                for(var i = 0; i < vitalData.pretermHeight.length; i++){
                    heightData.push({x:vitalData.pretermHeight[i].x,y:vitalData.pretermHeight[i].y + lengthConst});
                }
            }
            
            var weightData = [];
            if(vitalData.pretermWeight) {
                for(var i = 0; i < vitalData.pretermWeight.length; i++){
                    weightData.push({x:vitalData.pretermWeight[i].x,y:(vitalData.pretermWeight[i].y *10) + weightConst});
                }
            }
  
              // Start of Head data
              var set1 = [{x:168,y:19.2+headConst},{x:169,y:19.3+headConst},{x:170,y:19.4+headConst},{x:171,y:19.5+headConst},{x:172,y:19.7+headConst},{x:173,y:19.8+headConst},{x:174,y:19.9+headConst},{x:175,y:20+headConst},{x:176,y:20.2+headConst},{x:177,y:20.3+headConst},{x:178,y:20.4+headConst},{x:179,y:20.6+headConst},{x:180,y:20.7+headConst},{x:181,y:20.8+headConst},{x:182,y:20.9+headConst},{x:183,y:21.1+headConst},{x:184,y:21.2+headConst},{x:185,y:21.3+headConst},{x:186,y:21.4+headConst},{x:187,y:21.6+headConst},{x:188,y:21.7+headConst},{x:189,y:21.8+headConst},{x:190,y:21.9+headConst},{x:191,y:22.1+headConst},{x:192,y:22.2+headConst},{x:193,y:22.3+headConst},{x:194,y:22.5+headConst},{x:195,y:22.6+headConst},{x:196,y:22.7+headConst},{x:197,y:22.8+headConst},{x:198,y:23+headConst},{x:199,y:23.1+headConst},{x:200,y:23.2+headConst},{x:201,y:23.3+headConst},{x:202,y:23.5+headConst},{x:203,y:23.6+headConst},{x:204,y:23.7+headConst},{x:205,y:23.8+headConst},{x:206,y:24+headConst},{x:207,y:24.1+headConst},{x:208,y:24.2+headConst},{x:209,y:24.4+headConst},{x:210,y:24.5+headConst},{x:211,y:24.6+headConst},{x:212,y:24.7+headConst},{x:213,y:24.9+headConst},{x:214,y:25+headConst},{x:215,y:25.1+headConst},{x:216,y:25.2+headConst},{x:217,y:25.4+headConst},{x:218,y:25.5+headConst},{x:219,y:25.6+headConst},{x:220,y:25.7+headConst},{x:221,y:25.9+headConst},{x:222,y:26+headConst},{x:223,y:26.1+headConst},{x:224,y:26.3+headConst},{x:225,y:26.4+headConst},{x:226,y:26.5+headConst},{x:227,y:26.6+headConst},{x:228,y:26.8+headConst},{x:229,y:26.9+headConst},{x:230,y:27+headConst}];
    
              var set2 = [{x:168,y:20.1+headConst},{x:169,y:20.2+headConst},{x:170,y:20.3+headConst},{x:171,y:20.5+headConst},{x:172,y:20.6+headConst},{x:173,y:20.7+headConst},{x:174,y:20.9+headConst},{x:175,y:21+headConst},{x:176,y:21.1+headConst},{x:177,y:21.2+headConst},{x:178,y:21.4+headConst},{x:179,y:21.5+headConst},{x:180,y:21.6+headConst},{x:181,y:21.7+headConst},{x:182,y:21.9+headConst},{x:183,y:22+headConst},{x:184,y:22.1+headConst},{x:185,y:22.2+headConst},{x:186,y:22.4+headConst},{x:187,y:22.5+headConst},{x:188,y:22.6+headConst},{x:189,y:22.8+headConst},{x:190,y:22.9+headConst},{x:191,y:23+headConst},{x:192,y:23.1+headConst},{x:193,y:23.3+headConst},{x:194,y:23.4+headConst},{x:195,y:23.5+headConst},{x:196,y:23.6+headConst},{x:197,y:23.8+headConst},{x:198,y:23.9+headConst},{x:199,y:24+headConst},{x:200,y:24.1+headConst},{x:201,y:24.3+headConst},{x:202,y:24.4+headConst},{x:203,y:24.5+headConst},{x:204,y:24.7+headConst},{x:205,y:24.8+headConst},{x:206,y:24.9+headConst},{x:207,y:25+headConst},{x:208,y:25.2+headConst},{x:209,y:25.3+headConst},{x:210,y:25.4+headConst},{x:211,y:25.5+headConst},{x:212,y:25.7+headConst},{x:213,y:25.8+headConst},{x:214,y:25.9+headConst},{x:215,y:26.1+headConst},{x:216,y:26.2+headConst},{x:217,y:26.3+headConst},{x:218,y:26.4+headConst},{x:219,y:26.6+headConst},{x:220,y:26.7+headConst},{x:221,y:26.8+headConst},{x:222,y:26.9+headConst},{x:223,y:27.1+headConst},{x:224,y:27.2+headConst},{x:225,y:27.3+headConst},{x:226,y:27.4+headConst},{x:227,y:27.6+headConst},{x:228,y:27.7+headConst},{x:229,y:27.8+headConst},{x:230,y:28+headConst}];
                      
              var set3 = [{x:168,y:22.1+headConst},{x:169,y:22.2+headConst},{x:170,y:22.3+headConst},{x:171,y:22.5+headConst},{x:172,y:22.6+headConst},{x:173,y:22.7+headConst},{x:174,y:22.9+headConst},{x:175,y:23+headConst},{x:176,y:23.1+headConst},{x:177,y:23.2+headConst},{x:178,y:23.4+headConst},{x:179,y:23.5+headConst},{x:180,y:23.6+headConst},{x:181,y:23.7+headConst},{x:182,y:23.9+headConst},{x:183,y:24+headConst},{x:184,y:24.1+headConst},{x:185,y:24.2+headConst},{x:186,y:24.4+headConst},{x:187,y:24.5+headConst},{x:188,y:24.6+headConst},{x:189,y:24.8+headConst},{x:190,y:24.9+headConst},{x:191,y:25+headConst},{x:192,y:25.1+headConst},{x:193,y:25.3+headConst},{x:194,y:25.4+headConst},{x:195,y:25.5+headConst},{x:196,y:25.6+headConst},{x:197,y:25.8+headConst},{x:198,y:25.9+headConst},{x:199,y:26+headConst},{x:200,y:26.1+headConst},{x:201,y:26.3+headConst},{x:202,y:26.4+headConst},{x:203,y:26.5+headConst},{x:204,y:26.7+headConst},{x:205,y:26.8+headConst},{x:206,y:26.9+headConst},{x:207,y:27+headConst},{x:208,y:27.2+headConst},{x:209,y:27.3+headConst},{x:210,y:27.4+headConst},{x:211,y:27.5+headConst},{x:212,y:27.7+headConst},{x:213,y:27.8+headConst},{x:214,y:27.9+headConst},{x:215,y:28+headConst},{x:216,y:28.2+headConst},{x:217,y:28.3+headConst},{x:218,y:28.4+headConst},{x:219,y:28.6+headConst},{x:220,y:28.7+headConst},{x:221,y:28.8+headConst},{x:222,y:28.9+headConst},{x:223,y:29.1+headConst},{x:224,y:29.2+headConst},{x:225,y:29.3+headConst},{x:226,y:29.4+headConst},{x:227,y:29.6+headConst},{x:228,y:29.7+headConst},{x:229,y:29.8+headConst},{x:230,y:30+headConst}];
  
              var set4 = [{x:168,y:24.1+headConst},{x:169,y:24.2+headConst},{x:170,y:24.3+headConst},{x:171,y:24.5+headConst},{x:172,y:24.6+headConst},{x:173,y:24.7+headConst},{x:174,y:24.8+headConst},{x:175,y:25+headConst},{x:176,y:25.1+headConst},{x:177,y:25.2+headConst},{x:178,y:25.4+headConst},{x:179,y:25.5+headConst},{x:180,y:25.6+headConst},{x:181,y:25.7+headConst},{x:182,y:25.9+headConst},{x:183,y:26+headConst},{x:184,y:26.1+headConst},{x:185,y:26.2+headConst},{x:186,y:26.4+headConst},{x:187,y:26.5+headConst},{x:188,y:26.6+headConst},{x:189,y:26.8+headConst},{x:190,y:26.9+headConst},{x:191,y:27+headConst},{x:192,y:27.1+headConst},{x:193,y:27.3+headConst},{x:194,y:27.4+headConst},{x:195,y:27.5+headConst},{x:196,y:27.6+headConst},{x:197,y:27.8+headConst},{x:198,y:27.9+headConst},{x:199,y:28+headConst},{x:200,y:28.1+headConst},{x:201,y:28.3+headConst},{x:202,y:28.4+headConst},{x:203,y:28.5+headConst},{x:204,y:28.7+headConst},{x:205,y:28.8+headConst},{x:206,y:28.9+headConst},{x:207,y:29+headConst},{x:208,y:29.2+headConst},{x:209,y:29.3+headConst},{x:210,y:29.4+headConst},{x:211,y:29.5+headConst},{x:212,y:29.7+headConst},{x:213,y:29.8+headConst},{x:214,y:29.9+headConst},{x:215,y:30+headConst},{x:216,y:30.2+headConst},{x:217,y:30.3+headConst},{x:218,y:30.4+headConst},{x:219,y:30.6+headConst},{x:220,y:30.7+headConst},{x:221,y:30.8+headConst},{x:222,y:30.9+headConst},{x:223,y:31.1+headConst},{x:224,y:31.2+headConst},{x:225,y:31.3+headConst},{x:226,y:31.4+headConst},{x:227,y:31.6+headConst},{x:228,y:31.7+headConst},{x:229,y:31.8+headConst},{x:230,y:32+headConst}];
  
              var set5 = [{x:168,y:25+headConst},{x:169,y:25.2+headConst},{x:170,y:25.3+headConst},{x:171,y:25.4+headConst},{x:172,y:25.5+headConst},{x:173,y:25.7+headConst},{x:174,y:25.8+headConst},{x:175,y:25.9+headConst},{x:176,y:26+headConst},{x:177,y:26.2+headConst},{x:178,y:26.3+headConst},{x:179,y:26.4+headConst},{x:180,y:26.5+headConst},{x:181,y:26.7+headConst},{x:182,y:26.8+headConst},{x:183,y:26.9+headConst},{x:184,y:27.1+headConst},{x:185,y:27.2+headConst},{x:186,y:27.3+headConst},{x:187,y:27.4+headConst},{x:188,y:27.6+headConst},{x:189,y:27.7+headConst},{x:190,y:27.8+headConst},{x:191,y:27.9+headConst},{x:192,y:28.1+headConst},{x:193,y:28.2+headConst},{x:194,y:28.3+headConst},{x:195,y:28.4+headConst},{x:196,y:28.6+headConst},{x:197,y:28.7+headConst},{x:198,y:28.8+headConst},{x:199,y:29+headConst},{x:200,y:29.1+headConst},{x:201,y:29.2+headConst},{x:202,y:29.3+headConst},{x:203,y:29.5+headConst},{x:204,y:29.6+headConst},{x:205,y:29.7+headConst},{x:206,y:29.8+headConst},{x:207,y:30+headConst},{x:208,y:30.1+headConst},{x:209,y:30.2+headConst},{x:210,y:30.3+headConst},{x:211,y:30.5+headConst},{x:212,y:30.6+headConst},{x:213,y:30.7+headConst},{x:214,y:30.9+headConst},{x:215,y:31+headConst},{x:216,y:31.1+headConst},{x:217,y:31.2+headConst},{x:218,y:31.4+headConst},{x:219,y:31.5+headConst},{x:220,y:31.6+headConst},{x:221,y:31.7+headConst},{x:222,y:31.9+headConst},{x:223,y:32+headConst},{x:224,y:32.1+headConst},{x:225,y:32.3+headConst},{x:226,y:32.4+headConst},{x:227,y:32.5+headConst},{x:228,y:32.6+headConst},{x:229,y:32.8+headConst},{x:230,y:32.9+headConst}];
              // End of Head data
  
              // Start of Length data
              var set6 = [{x:168,y:26.9+lengthConst},{x:169,y:27.1+lengthConst},{x:170,y:27.3+lengthConst},{x:171,y:27.4+lengthConst},{x:172,y:27.6+lengthConst},{x:173,y:27.8+lengthConst},{x:174,y:28+lengthConst},{x:175,y:28.2+lengthConst},{x:176,y:28.4+lengthConst},{x:177,y:28.5+lengthConst},{x:178,y:28.7+lengthConst},{x:179,y:28.9+lengthConst},{x:180,y:29.1+lengthConst},{x:181,y:29.3+lengthConst},{x:182,y:29.4+lengthConst},{x:183,y:29.6+lengthConst},{x:184,y:29.8+lengthConst},{x:185,y:30+lengthConst},{x:186,y:30.2+lengthConst},{x:187,y:30.3+lengthConst},{x:188,y:30.5+lengthConst},{x:189,y:30.7+lengthConst},{x:190,y:30.9+lengthConst},{x:191,y:31.1+lengthConst},{x:192,y:31.3+lengthConst},{x:193,y:31.4+lengthConst},{x:194,y:31.6+lengthConst},{x:195,y:31.8+lengthConst},{x:196,y:32+lengthConst},{x:197,y:32.2+lengthConst},{x:198,y:32.3+lengthConst},{x:199,y:32.5+lengthConst},{x:200,y:32.7+lengthConst},{x:201,y:32.9+lengthConst},{x:202,y:33.1+lengthConst},{x:203,y:33.2+lengthConst},{x:204,y:33.4+lengthConst},{x:205,y:33.6+lengthConst},{x:206,y:33.8+lengthConst},{x:207,y:34+lengthConst},{x:208,y:34.2+lengthConst},{x:209,y:34.3+lengthConst},{x:210,y:34.5+lengthConst},{x:211,y:34.7+lengthConst},{x:212,y:34.9+lengthConst},{x:213,y:35.1+lengthConst},{x:214,y:35.2+lengthConst},{x:215,y:35.4+lengthConst},{x:216,y:35.6+lengthConst},{x:217,y:35.8+lengthConst},{x:218,y:36+lengthConst},{x:219,y:36.2+lengthConst},{x:220,y:36.3+lengthConst},{x:221,y:36.5+lengthConst},{x:222,y:36.7+lengthConst},{x:223,y:36.9+lengthConst},{x:224,y:37.1+lengthConst},{x:225,y:37.2+lengthConst},{x:226,y:37.4+lengthConst},{x:227,y:37.6+lengthConst},{x:228,y:37.8+lengthConst},{x:229,y:38+lengthConst},{x:230,y:38.1+lengthConst}];
  
              var set7 = [{x:168,y:28.5+lengthConst},{x:169,y:28.6+lengthConst},{x:170,y:28.8+lengthConst},{x:171,y:29+lengthConst},{x:172,y:29.2+lengthConst},{x:173,y:29.4+lengthConst},{x:174,y:29.5+lengthConst},{x:175,y:29.7+lengthConst},{x:176,y:29.9+lengthConst},{x:177,y:30.1+lengthConst},{x:178,y:30.3+lengthConst},{x:179,y:30.5+lengthConst},{x:180,y:30.6+lengthConst},{x:181,y:30.8+lengthConst},{x:182,y:31+lengthConst},{x:183,y:31.2+lengthConst},{x:184,y:31.4+lengthConst},{x:185,y:31.5+lengthConst},{x:186,y:31.7+lengthConst},{x:187,y:31.9+lengthConst},{x:188,y:32.1+lengthConst},{x:189,y:32.3+lengthConst},{x:190,y:32.4+lengthConst},{x:191,y:32.6+lengthConst},{x:192,y:32.8+lengthConst},{x:193,y:33+lengthConst},{x:194,y:33.2+lengthConst},{x:195,y:33.4+lengthConst},{x:196,y:33.5+lengthConst},{x:197,y:33.7+lengthConst},{x:198,y:33.9+lengthConst},{x:199,y:34.1+lengthConst},{x:200,y:34.3+lengthConst},{x:201,y:34.4+lengthConst},{x:202,y:34.6+lengthConst},{x:203,y:34.8+lengthConst},{x:204,y:35+lengthConst},{x:205,y:35.2+lengthConst},{x:206,y:35.4+lengthConst},{x:207,y:35.5+lengthConst},{x:208,y:35.7+lengthConst},{x:209,y:35.9+lengthConst},{x:210,y:36.1+lengthConst},{x:211,y:36.3+lengthConst},{x:212,y:36.4+lengthConst},{x:213,y:36.6+lengthConst},{x:214,y:36.8+lengthConst},{x:215,y:37+lengthConst},{x:216,y:37.2+lengthConst},{x:217,y:37.3+lengthConst},{x:218,y:37.5+lengthConst},{x:219,y:37.7+lengthConst},{x:220,y:37.9+lengthConst},{x:221,y:38.1+lengthConst},{x:222,y:38.3+lengthConst},{x:223,y:38.4+lengthConst},{x:224,y:38.6+lengthConst},{x:225,y:38.8+lengthConst},{x:226,y:39+lengthConst},{x:227,y:39.2+lengthConst},{x:228,y:39.3+lengthConst},{x:229,y:39.5+lengthConst},{x:230,y:39.7+lengthConst}];
                      
              var set8 = [{x:168,y:31.8+lengthConst},{x:169,y:32+lengthConst},{x:170,y:32.2+lengthConst},{x:171,y:32.3+lengthConst},{x:172,y:32.5+lengthConst},{x:173,y:32.7+lengthConst},{x:174,y:32.9+lengthConst},{x:175,y:33.1+lengthConst},{x:176,y:33.2+lengthConst},{x:177,y:33.4+lengthConst},{x:178,y:33.6+lengthConst},{x:179,y:33.8+lengthConst},{x:180,y:34+lengthConst},{x:181,y:34.1+lengthConst},{x:182,y:34.3+lengthConst},{x:183,y:34.5+lengthConst},{x:184,y:34.7+lengthConst},{x:185,y:34.9+lengthConst},{x:186,y:35.1+lengthConst},{x:187,y:35.2+lengthConst},{x:188,y:35.4+lengthConst},{x:189,y:35.6+lengthConst},{x:190,y:35.8+lengthConst},{x:191,y:36+lengthConst},{x:192,y:36.1+lengthConst},{x:193,y:36.3+lengthConst},{x:194,y:36.5+lengthConst},{x:195,y:36.7+lengthConst},{x:196,y:36.9+lengthConst},{x:197,y:37+lengthConst},{x:198,y:37.2+lengthConst},{x:199,y:37.4+lengthConst},{x:200,y:37.6+lengthConst},{x:201,y:37.8+lengthConst},{x:202,y:38+lengthConst},{x:203,y:38.1+lengthConst},{x:204,y:38.3+lengthConst},{x:205,y:38.5+lengthConst},{x:206,y:38.7+lengthConst},{x:207,y:38.9+lengthConst},{x:208,y:39+lengthConst},{x:209,y:39.2+lengthConst},{x:210,y:39.4+lengthConst},{x:211,y:39.6+lengthConst},{x:212,y:39.8+lengthConst},{x:213,y:40+lengthConst},{x:214,y:40.1+lengthConst},{x:215,y:40.3+lengthConst},{x:216,y:40.5+lengthConst},{x:217,y:40.7+lengthConst},{x:218,y:40.9+lengthConst},{x:219,y:41+lengthConst},{x:220,y:41.2+lengthConst},{x:221,y:41.4+lengthConst},{x:222,y:41.6+lengthConst},{x:223,y:41.8+lengthConst},{x:224,y:41.9+lengthConst},{x:225,y:42.1+lengthConst},{x:226,y:42.3+lengthConst},{x:227,y:42.5+lengthConst},{x:228,y:42.7+lengthConst},{x:229,y:42.9+lengthConst},{x:230,y:43+lengthConst}];
  
              var set9 = [{x:168,y:35.1+lengthConst},{x:169,y:35.3+lengthConst},{x:170,y:35.5+lengthConst},{x:171,y:35.7+lengthConst},{x:172,y:35.8+lengthConst},{x:173,y:36+lengthConst},{x:174,y:36.2+lengthConst},{x:175,y:36.4+lengthConst},{x:176,y:36.6+lengthConst},{x:177,y:36.8+lengthConst},{x:178,y:36.9+lengthConst},{x:179,y:37.1+lengthConst},{x:180,y:37.3+lengthConst},{x:181,y:37.5+lengthConst},{x:182,y:37.7+lengthConst},{x:183,y:37.8+lengthConst},{x:184,y:38+lengthConst},{x:185,y:38.2+lengthConst},{x:186,y:38.4+lengthConst},{x:187,y:38.6+lengthConst},{x:188,y:38.7+lengthConst},{x:189,y:38.9+lengthConst},{x:190,y:39.1+lengthConst},{x:191,y:39.3+lengthConst},{x:192,y:39.5+lengthConst},{x:193,y:39.7+lengthConst},{x:194,y:39.8+lengthConst},{x:195,y:40+lengthConst},{x:196,y:40.2+lengthConst},{x:197,y:40.4+lengthConst},{x:198,y:40.6+lengthConst},{x:199,y:40.7+lengthConst},{x:200,y:40.9+lengthConst},{x:201,y:41.1+lengthConst},{x:202,y:41.3+lengthConst},{x:203,y:41.5+lengthConst},{x:204,y:41.7+lengthConst},{x:205,y:41.8+lengthConst},{x:206,y:42+lengthConst},{x:207,y:42.2+lengthConst},{x:208,y:42.4+lengthConst},{x:209,y:42.6+lengthConst},{x:210,y:42.7+lengthConst},{x:211,y:42.9+lengthConst},{x:212,y:43.1+lengthConst},{x:213,y:43.3+lengthConst},{x:214,y:43.5+lengthConst},{x:215,y:43.6+lengthConst},{x:216,y:43.8+lengthConst},{x:217,y:44+lengthConst},{x:218,y:44.2+lengthConst},{x:219,y:44.4+lengthConst},{x:220,y:44.6+lengthConst},{x:221,y:44.7+lengthConst},{x:222,y:44.9+lengthConst},{x:223,y:45.1+lengthConst},{x:224,y:45.3+lengthConst},{x:225,y:45.5+lengthConst},{x:226,y:45.6+lengthConst},{x:227,y:45.8+lengthConst},{x:228,y:46+lengthConst},{x:229,y:46.2+lengthConst},{x:230,y:46.4+lengthConst}];
  
              var set10 = [{x:168,y:36.7+lengthConst},{x:169,y:36.9+lengthConst},{x:170,y:37+lengthConst},{x:171,y:37.2+lengthConst},{x:172,y:37.4+lengthConst},{x:173,y:37.6+lengthConst},{x:174,y:37.8+lengthConst},{x:175,y:37.9+lengthConst},{x:176,y:38.1+lengthConst},{x:177,y:38.3+lengthConst},{x:178,y:38.5+lengthConst},{x:179,y:38.7+lengthConst},{x:180,y:38.9+lengthConst},{x:181,y:39+lengthConst},{x:182,y:39.2+lengthConst},{x:183,y:39.4+lengthConst},{x:184,y:39.6+lengthConst},{x:185,y:39.8+lengthConst},{x:186,y:39.9+lengthConst},{x:187,y:40.1+lengthConst},{x:188,y:40.3+lengthConst},{x:189,y:40.5+lengthConst},{x:190,y:40.7+lengthConst},{x:191,y:40.9+lengthConst},{x:192,y:41+lengthConst},{x:193,y:41.2+lengthConst},{x:194,y:41.4+lengthConst},{x:195,y:41.6+lengthConst},{x:196,y:41.8+lengthConst},{x:197,y:41.9+lengthConst},{x:198,y:42.1+lengthConst},{x:199,y:42.3+lengthConst},{x:200,y:42.5+lengthConst},{x:201,y:42.7+lengthConst},{x:202,y:42.8+lengthConst},{x:203,y:43+lengthConst},{x:204,y:43.2+lengthConst},{x:205,y:43.4+lengthConst},{x:206,y:43.6+lengthConst},{x:207,y:43.8+lengthConst},{x:208,y:43.9+lengthConst},{x:209,y:44.1+lengthConst},{x:210,y:44.3+lengthConst},{x:211,y:44.5+lengthConst},{x:212,y:44.7+lengthConst},{x:213,y:44.8+lengthConst},{x:214,y:45+lengthConst},{x:215,y:45.2+lengthConst},{x:216,y:45.4+lengthConst},{x:217,y:45.6+lengthConst},{x:218,y:45.7+lengthConst},{x:219,y:45.9+lengthConst},{x:220,y:46.1+lengthConst},{x:221,y:46.3+lengthConst},{x:222,y:46.5+lengthConst},{x:223,y:46.7+lengthConst},{x:224,y:46.8+lengthConst},{x:225,y:47+lengthConst},{x:226,y:47.2+lengthConst},{x:227,y:47.4+lengthConst},{x:228,y:47.6+lengthConst},{x:229,y:47.7+lengthConst},{x:230,y:47.9+lengthConst}];
              // End of Length data
              
              // Start of Weight data
              var set11 = [{x:168,y:(0.42*10)+weightConst},{x:169,y:(0.43*10)+weightConst},{x:170,y:(0.44*10)+weightConst},{x:171,y:(0.44*10)+weightConst},{x:172,y:(0.45*10)+weightConst},{x:173,y:(0.46*10)+weightConst},{x:174,y:(0.47*10)+weightConst},{x:175,y:(0.48*10)+weightConst},{x:176,y:(0.49*10)+weightConst},{x:177,y:(0.5*10)+weightConst},{x:178,y:(0.51*10)+weightConst},{x:179,y:(0.52*10)+weightConst},{x:180,y:(0.53*10)+weightConst},{x:181,y:(0.54*10)+weightConst},{x:182,y:(0.55*10)+weightConst},{x:183,y:(0.56*10)+weightConst},{x:184,y:(0.57*10)+weightConst},{x:185,y:(0.58*10)+weightConst},{x:186,y:(0.59*10)+weightConst},{x:187,y:(0.6*10)+weightConst},{x:188,y:(0.61*10)+weightConst},{x:189,y:(0.62*10)+weightConst},{x:190,y:(0.63*10)+weightConst},{x:191,y:(0.64*10)+weightConst},{x:192,y:(0.66*10)+weightConst},{x:193,y:(0.67*10)+weightConst},{x:194,y:(0.68*10)+weightConst},{x:195,y:(0.69*10)+weightConst},{x:196,y:(0.7*10)+weightConst},{x:197,y:(0.72*10)+weightConst},{x:198,y:(0.73*10)+weightConst},{x:199,y:(0.74*10)+weightConst},{x:200,y:(0.76*10)+weightConst},{x:201,y:(0.77*10)+weightConst},{x:202,y:(0.78*10)+weightConst},{x:203,y:(0.8*10)+weightConst},{x:204,y:(0.81*10)+weightConst},{x:205,y:(0.83*10)+weightConst},{x:206,y:(0.84*10)+weightConst},{x:207,y:(0.86*10)+weightConst},{x:208,y:(0.87*10)+weightConst},{x:209,y:(0.89*10)+weightConst},{x:210,y:(0.9*10)+weightConst},{x:211,y:(0.92*10)+weightConst},{x:212,y:(0.93*10)+weightConst},{x:213,y:(0.95*10)+weightConst},{x:214,y:(0.97*10)+weightConst},{x:215,y:(0.98*10)+weightConst},{x:216,y:(1*10)+weightConst},{x:217,y:(1.02*10)+weightConst},{x:218,y:(1.03*10)+weightConst},{x:219,y:(1.05*10)+weightConst},{x:220,y:(1.07*10)+weightConst},{x:221,y:(1.09*10)+weightConst},{x:222,y:(1.11*10)+weightConst},{x:223,y:(1.12*10)+weightConst},{x:224,y:(1.14*10)+weightConst},{x:225,y:(1.16*10)+weightConst},{x:226,y:(1.18*10)+weightConst},{x:227,y:(1.2*10)+weightConst},{x:228,y:(1.22*10)+weightConst},{x:229,y:(1.24*10)+weightConst},{x:230,y:(1.26*10)+weightConst}];
  
              var set12 = [{x:168,y:(0.47*10)+weightConst},{x:169,y:(0.48*10)+weightConst},{x:170,y:(0.49*10)+weightConst},{x:171,y:(0.5*10)+weightConst},{x:172,y:(0.51*10)+weightConst},{x:173,y:(0.52*10)+weightConst},{x:174,y:(0.53*10)+weightConst},{x:175,y:(0.54*10)+weightConst},{x:176,y:(0.55*10)+weightConst},{x:177,y:(0.56*10)+weightConst},{x:178,y:(0.57*10)+weightConst},{x:179,y:(0.58*10)+weightConst},{x:180,y:(0.59*10)+weightConst},{x:181,y:(0.6*10)+weightConst},{x:182,y:(0.61*10)+weightConst},{x:183,y:(0.62*10)+weightConst},{x:184,y:(0.64*10)+weightConst},{x:185,y:(0.65*10)+weightConst},{x:186,y:(0.66*10)+weightConst},{x:187,y:(0.67*10)+weightConst},{x:188,y:(0.68*10)+weightConst},{x:189,y:(0.7*10)+weightConst},{x:190,y:(0.71*10)+weightConst},{x:191,y:(0.72*10)+weightConst},{x:192,y:(0.74*10)+weightConst},{x:193,y:(0.75*10)+weightConst},{x:194,y:(0.76*10)+weightConst},{x:195,y:(0.78*10)+weightConst},{x:196,y:(0.79*10)+weightConst},{x:197,y:(0.81*10)+weightConst},{x:198,y:(0.82*10)+weightConst},{x:199,y:(0.83*10)+weightConst},{x:200,y:(0.85*10)+weightConst},{x:201,y:(0.86*10)+weightConst},{x:202,y:(0.88*10)+weightConst},{x:203,y:(0.9*10)+weightConst},{x:204,y:(0.91*10)+weightConst},{x:205,y:(0.93*10)+weightConst},{x:206,y:(0.94*10)+weightConst},{x:207,y:(0.96*10)+weightConst},{x:208,y:(0.98*10)+weightConst},{x:209,y:(0.99*10)+weightConst},{x:210,y:(1.01*10)+weightConst},{x:211,y:(1.03*10)+weightConst},{x:212,y:(1.05*10)+weightConst},{x:213,y:(1.07*10)+weightConst},{x:214,y:(1.08*10)+weightConst},{x:215,y:(1.1*10)+weightConst},{x:216,y:(1.12*10)+weightConst},{x:217,y:(1.14*10)+weightConst},{x:218,y:(1.16*10)+weightConst},{x:219,y:(1.18*10)+weightConst},{x:220,y:(1.2*10)+weightConst},{x:221,y:(1.22*10)+weightConst},{x:222,y:(1.24*10)+weightConst},{x:223,y:(1.26*10)+weightConst},{x:224,y:(1.28*10)+weightConst},{x:225,y:(1.31*10)+weightConst},{x:226,y:(1.33*10)+weightConst},{x:227,y:(1.35*10)+weightConst},{x:228,y:(1.37*10)+weightConst},{x:229,y:(1.4*10)+weightConst},{x:230,y:(1.42*10)+weightConst}];
                      
              var set13 = [{x:168,y:(0.6*10)+weightConst},{x:169,y:(0.61*10)+weightConst},{x:170,y:(0.63*10)+weightConst},{x:171,y:(0.64*10)+weightConst},{x:172,y:(0.65*10)+weightConst},{x:173,y:(0.66*10)+weightConst},{x:174,y:(0.68*10)+weightConst},{x:175,y:(0.69*10)+weightConst},{x:176,y:(0.7*10)+weightConst},{x:177,y:(0.71*10)+weightConst},{x:178,y:(0.73*10)+weightConst},{x:179,y:(0.74*10)+weightConst},{x:180,y:(0.76*10)+weightConst},{x:181,y:(0.77*10)+weightConst},{x:182,y:(0.78*10)+weightConst},{x:183,y:(0.8*10)+weightConst},{x:184,y:(0.81*10)+weightConst},{x:185,y:(0.83*10)+weightConst},{x:186,y:(0.85*10)+weightConst},{x:187,y:(0.86*10)+weightConst},{x:188,y:(0.88*10)+weightConst},{x:189,y:(0.89*10)+weightConst},{x:190,y:(0.91*10)+weightConst},{x:191,y:(0.93*10)+weightConst},{x:192,y:(0.94*10)+weightConst},{x:193,y:(0.96*10)+weightConst},{x:194,y:(0.98*10)+weightConst},{x:195,y:(1*10)+weightConst},{x:196,y:(1.01*10)+weightConst},{x:197,y:(1.03*10)+weightConst},{x:198,y:(1.05*10)+weightConst},{x:199,y:(1.07*10)+weightConst},{x:200,y:(1.09*10)+weightConst},{x:201,y:(1.11*10)+weightConst},{x:202,y:(1.13*10)+weightConst},{x:203,y:(1.15*10)+weightConst},{x:204,y:(1.17*10)+weightConst},{x:205,y:(1.19*10)+weightConst},{x:206,y:(1.21*10)+weightConst},{x:207,y:(1.23*10)+weightConst},{x:208,y:(1.25*10)+weightConst},{x:209,y:(1.27*10)+weightConst},{x:210,y:(1.3*10)+weightConst},{x:211,y:(1.32*10)+weightConst},{x:212,y:(1.34*10)+weightConst},{x:213,y:(1.36*10)+weightConst},{x:214,y:(1.39*10)+weightConst},{x:215,y:(1.41*10)+weightConst},{x:216,y:(1.44*10)+weightConst},{x:217,y:(1.46*10)+weightConst},{x:218,y:(1.49*10)+weightConst},{x:219,y:(1.51*10)+weightConst},{x:220,y:(1.54*10)+weightConst},{x:221,y:(1.56*10)+weightConst},{x:222,y:(1.59*10)+weightConst},{x:223,y:(1.62*10)+weightConst},{x:224,y:(1.64*10)+weightConst},{x:225,y:(1.67*10)+weightConst},{x:226,y:(1.7*10)+weightConst},{x:227,y:(1.73*10)+weightConst},{x:228,y:(1.76*10)+weightConst},{x:229,y:(1.79*10)+weightConst},{x:230,y:(1.82*10)+weightConst}];
  
              var set14 = [{x:168,y:(0.77*10)+weightConst},{x:169,y:(0.79*10)+weightConst},{x:170,y:(0.8*10)+weightConst},{x:171,y:(0.82*10)+weightConst},{x:172,y:(0.83*10)+weightConst},{x:173,y:(0.85*10)+weightConst},{x:174,y:(0.87*10)+weightConst},{x:175,y:(0.88*10)+weightConst},{x:176,y:(0.9*10)+weightConst},{x:177,y:(0.92*10)+weightConst},{x:178,y:(0.93*10)+weightConst},{x:179,y:(0.95*10)+weightConst},{x:180,y:(0.97*10)+weightConst},{x:181,y:(0.99*10)+weightConst},{x:182,y:(1.01*10)+weightConst},{x:183,y:(1.02*10)+weightConst},{x:184,y:(1.04*10)+weightConst},{x:185,y:(1.06*10)+weightConst},{x:186,y:(1.08*10)+weightConst},{x:187,y:(1.1*10)+weightConst},{x:188,y:(1.12*10)+weightConst},{x:189,y:(1.14*10)+weightConst},{x:190,y:(1.16*10)+weightConst},{x:191,y:(1.19*10)+weightConst},{x:192,y:(1.21*10)+weightConst},{x:193,y:(1.23*10)+weightConst},{x:194,y:(1.25*10)+weightConst},{x:195,y:(1.27*10)+weightConst},{x:196,y:(1.3*10)+weightConst},{x:197,y:(1.32*10)+weightConst},{x:198,y:(1.34*10)+weightConst},{x:199,y:(1.37*10)+weightConst},{x:200,y:(1.39*10)+weightConst},{x:201,y:(1.42*10)+weightConst},{x:202,y:(1.44*10)+weightConst},{x:203,y:(1.47*10)+weightConst},{x:204,y:(1.5*10)+weightConst},{x:205,y:(1.52*10)+weightConst},{x:206,y:(1.55*10)+weightConst},{x:207,y:(1.58*10)+weightConst},{x:208,y:(1.6*10)+weightConst},{x:209,y:(1.63*10)+weightConst},{x:210,y:(1.66*10)+weightConst},{x:211,y:(1.69*10)+weightConst},{x:212,y:(1.72*10)+weightConst},{x:213,y:(1.75*10)+weightConst},{x:214,y:(1.78*10)+weightConst},{x:215,y:(1.81*10)+weightConst},{x:216,y:(1.84*10)+weightConst},{x:217,y:(1.87*10)+weightConst},{x:218,y:(1.9*10)+weightConst},{x:219,y:(1.94*10)+weightConst},{x:220,y:(1.97*10)+weightConst},{x:221,y:(2*10)+weightConst},{x:222,y:(2.04*10)+weightConst},{x:223,y:(2.07*10)+weightConst},{x:224,y:(2.11*10)+weightConst},{x:225,y:(2.14*10)+weightConst},{x:226,y:(2.18*10)+weightConst},{x:227,y:(2.21*10)+weightConst},{x:228,y:(2.25*10)+weightConst},{x:229,y:(2.29*10)+weightConst},{x:230,y:(2.33*10)+weightConst}];
  
              var set15 = [{x:168,y:(0.87*10)+weightConst},{x:169,y:(0.88*10)+weightConst},{x:170,y:(0.9*10)+weightConst},{x:171,y:(0.92*10)+weightConst},{x:172,y:(0.94*10)+weightConst},{x:173,y:(0.95*10)+weightConst},{x:174,y:(0.97*10)+weightConst},{x:175,y:(0.99*10)+weightConst},{x:176,y:(1.01*10)+weightConst},{x:177,y:(1.03*10)+weightConst},{x:178,y:(1.05*10)+weightConst},{x:179,y:(1.07*10)+weightConst},{x:180,y:(1.09*10)+weightConst},{x:181,y:(1.11*10)+weightConst},{x:182,y:(1.13*10)+weightConst},{x:183,y:(1.15*10)+weightConst},{x:184,y:(1.17*10)+weightConst},{x:185,y:(1.19*10)+weightConst},{x:186,y:(1.22*10)+weightConst},{x:187,y:(1.24*10)+weightConst},{x:188,y:(1.26*10)+weightConst},{x:189,y:(1.28*10)+weightConst},{x:190,y:(1.31*10)+weightConst},{x:191,y:(1.33*10)+weightConst},{x:192,y:(1.36*10)+weightConst},{x:193,y:(1.38*10)+weightConst},{x:194,y:(1.41*10)+weightConst},{x:195,y:(1.43*10)+weightConst},{x:196,y:(1.46*10)+weightConst},{x:197,y:(1.48*10)+weightConst},{x:198,y:(1.51*10)+weightConst},{x:199,y:(1.54*10)+weightConst},{x:200,y:(1.56*10)+weightConst},{x:201,y:(1.59*10)+weightConst},{x:202,y:(1.62*10)+weightConst},{x:203,y:(1.65*10)+weightConst},{x:204,y:(1.68*10)+weightConst},{x:205,y:(1.71*10)+weightConst},{x:206,y:(1.74*10)+weightConst},{x:207,y:(1.77*10)+weightConst},{x:208,y:(1.8*10)+weightConst},{x:209,y:(1.83*10)+weightConst},{x:210,y:(1.86*10)+weightConst},{x:211,y:(1.9*10)+weightConst},{x:212,y:(1.93*10)+weightConst},{x:213,y:(1.96*10)+weightConst},{x:214,y:(2*10)+weightConst},{x:215,y:(2.03*10)+weightConst},{x:216,y:(2.07*10)+weightConst},{x:217,y:(2.1*10)+weightConst},{x:218,y:(2.14*10)+weightConst},{x:219,y:(2.17*10)+weightConst},{x:220,y:(2.21*10)+weightConst},{x:221,y:(2.25*10)+weightConst},{x:222,y:(2.29*10)+weightConst},{x:223,y:(2.33*10)+weightConst},{x:224,y:(2.37*10)+weightConst},{x:225,y:(2.4*10)+weightConst},{x:226,y:(2.45*10)+weightConst},{x:227,y:(2.49*10)+weightConst},{x:228,y:(2.53*10)+weightConst},{x:229,y:(2.57*10)+weightConst},{x:230,y:(2.61*10)+weightConst}];
              // End of Weight data
              
              var rawSvg = element.find("svg")[0];
              var svg = d3.select(rawSvg)
                          .attr("width",width + margin.left + margin.right)
                          .attr("height",height + margin.top + margin.bottom);
              var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
              var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
              var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
              var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');
              var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
              var gEnter = wrap3.enter().append('g').attr('class', 'd3line').append('g');
  
              var div = d3.select("body").append("div")	
                          .attr("class", "tooltip")				
                          .style("opacity", 0);
  
              var lineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("bundle")
                              .tension(.8);
  
              var datalineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("linear");
  
  
              var g = svg.append("g")
                          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
              
              var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
              var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);
  
              var yScale0 = d3.scale.linear().domain([0,73]).range([height, 0]);
              var yScale1 = d3.scale.linear().domain([0,73]).range([height, 0]);
  
              var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                  return '';
              }).innerTickSize(-height)
                              .outerTickSize(0);
              var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                  return '';
              });
              var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                  return d%2==0 ? yAxisLeftFake(d):'';
              }).innerTickSize(-width)
                      .outerTickSize(0);
              var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                  return d%2==0 ? yAxisRightFake(d):'';
              }).innerTickSize(50)
                      .outerTickSize(50).tickPadding(10);
              
              var yAxisLeftFake = function(d){
                  switch (d){
                  case 0:return 18;
                  case 2:return 19;
                  case 4:return 20;
                  case 6:return 21;
                  case 8:return 22;
                  case 10:return 23;
                  case 12:return 24;
                  case 14:return 25;
                  case 16:return 26;
                  case 18:return 27;
                  case 20:return '';
                  case 22:return 24;
                  case 24:return 26;
                  case 26:return 28;
                  case 28:return 30;
                  case 30:return 32;
                  case 32:return 34;
                  case 34:return 36;
                  case 36:return 38;
                  case 38:return 40;
                  case 40:return 42;
                  case 42:return '';
                  case 44:return 0.2;
                  case 46:return 0.4;
                  case 48:return 0.6;
                  case 50:return 0.8;
                  case 52:return '1.0';
                  case 54:return 1.2;
                  case 56:return 1.4;
                  case 58:return 1.6;
                  case 60:return 1.8;
                  case 62:return '2.0';
                  case 64:return 2.2;
                  case 66:return 2.4;
                  case 68:return 2.6;
                  case 70:return 2.8;
                  case 72:return '3.0';
                  }
              };
  
              var yAxisRightFake = function(d){
                  switch (d){
                  case 0:return 18;
                  case 2:return 19;
                  case 4:return 20;
                  case 6:return 21;
                  case 8:return 22;
                  case 10:return 23;
                  case 12:return 24;
                  case 14:return 25;
                  case 16:return 26;
                  case 18:return 27;
                  case 20:return 28;
                  case 22:return 29;
                  case 24:return 30;
                  case 26:return 31;
                  case 28:return 32;
                  case 30:return 33;
                  case 32:return 34;
                  case 34:return '';
                  case 36:return 38;
                  case 38:return 40;
                  case 40:return 42;
                  case 42:return 44;
                  case 44:return 46;
                  case 46:return 48;
                  case 48:return 50;
                  case 50:return '';
                  case 52:return '1.0';
                  case 54:return 1.2;
                  case 56:return 1.4;
                  case 58:return 1.6;
                  case 60:return 1.8;
                  case 62:return '2.0';
                  case 64:return 2.2;
                  case 66:return 2.4;
                  case 68:return 2.6;
                  case 70:return 2.8;
                  case 72:return '3.0';
                  }
              };
  
              var age = function(data) {
                  if(data <= 24){
                      return data.toString().split('.')[0]+ " months";
                  }
                  if(data <=60) {
                      var mon = data/12;
                      var result = mon.toFixed(1).split('.');
                      var mod = data%12;
                      var res = mod.toString().split('.');
                      return result[0].toString()+ " years " + res[0] + " months";
                  }
              };
              
              // plot user data points
              var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" kg")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
  
              // x-axis
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxisBottom);
              
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0,0)")
                  .call(xAxisTop);
  
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height+37 )
                  .style("text-anchor", "middle")
                  .text("Gestational age at birth (weeks)");
              
            svg.append("text")
                .attr("x", 30 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("© University of Oxford");

            svg.append("text")
                .attr("x", 750 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("Villar et al. Lancet 2016;387:844-5");

              // svg.append("text")
              //     .attr("x", width/2 )
              //     .attr("y", -30 )
              //     .style("text-anchor", "middle")
              //     .text("Head Circumference-for-age BOYS");
  
              // svg.append("text")
              //     .attr("x", width/2 )
              //     .attr("y", -12 )
              //     .style("text-anchor", "middle")
              //     .text("Birth to 5 years (percentiles)");
              
              svg.append("text")
                  .attr("x", -10 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("24");
              
              svg.append("text")
                  .attr("x", 79 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("25");
              
              svg.append("text")
                  .attr("x", 159 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("26");
              
              svg.append("text")
                  .attr("x", 244 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("27");
              
              svg.append("text")
                  .attr("x", 330 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("28");
              
              svg.append("text")
                  .attr("x", 415 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("29");
              
              svg.append("text")
                  .attr("x", 500 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("30");
              
              svg.append("text")
                  .attr("x", 585 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("31");
              
              svg.append("text")
                  .attr("x", 670 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("32");
                     
              svg.append("text")
                  .attr("x", 753 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("33");
  
              svg.append("text")
                  .attr("x", -10 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("24");
              
              svg.append("text")
                  .attr("x", 79 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("25");
              
              svg.append("text")
                  .attr("x", 159 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("26");
              
              svg.append("text")
                  .attr("x", 244 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("27");
              
              svg.append("text")
                  .attr("x", 330 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("28");
              
              svg.append("text")
                  .attr("x", 415 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("29");
              
              svg.append("text")
                  .attr("x", 500 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("30");
              
              svg.append("text")
                  .attr("x", 585 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("31");
              
              svg.append("text")
                  .attr("x", 670 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("32");
                     
              svg.append("text")
                  .attr("x", 753 )
                  .attr("y", -12 )
                  .style("text-anchor", "start")
                  .text("33");
              
  
              svg.append("text")
                  .attr("x", -840 )
                  .attr("y", -35 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Head Circumference (cm)");
              
              svg.append("text")
                  .attr("x", -540 )
                  .attr("y", -35 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Length (cm)");
  
              svg.append("text")
                  .attr("x", -200 )
                  .attr("y", -35 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Birthweight (kg)");
  
              svg.append("text")
                  .attr("x", -700 )
                  .attr("y", 880 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Head Circumference (cm)");
              
              svg.append("text")
                  .attr("x", -400 )
                  .attr("y", 880 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Length (cm)");
  
              svg.append("text")
                  .attr("x", -150 )
                  .attr("y", 880 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Birthweight (kg)");
              
              // svg.append("text")
              //     .attr("x", -50 )
              //     .attr("y", height+15 )
              //     .style("text-anchor", "start")
              //     .text("Months");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 230 )
                  .style("text-anchor", "start")
                  .text("3 rd");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 210 )
                  .style("text-anchor", "start")
                  .text("10 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 155 )
                  .style("text-anchor", "start")
                  .text("50 th");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 90 )
                  .style("text-anchor", "start")
                  .text("90 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 50 )
                  .style("text-anchor", "start")
                  .text("97 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 470 )
                  .style("text-anchor", "start")
                  .text("3 rd");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 450 )
                  .style("text-anchor", "start")
                  .text("10 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 410 )
                  .style("text-anchor", "start")
                  .text("50 th");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 365 )
                  .style("text-anchor", "start")
                  .text("90 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 345 )
                  .style("text-anchor", "start")
                  .text("97 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 815 )
                  .style("text-anchor", "start")
                  .text("3 rd");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 800 )
                  .style("text-anchor", "start")
                  .text("10 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 775 )
                  .style("text-anchor", "start")
                  .text("50 th");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 747 )
                  .style("text-anchor", "start")
                  .text("90 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 735 )
                  .style("text-anchor", "start")
                  .text("97 th");
                  
              // y-axis
              svg.append("g")
                  .attr("class", "y axis")
                  .call(yAxisLeft);	
  
              svg.append("g")				
                  .attr("class", "y axis")	
                  .attr("transform", "translate(" + width + " ,0)")		
                  .call(yAxisRight);
              
              // path lines
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set1),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set2),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set3),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set4),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set5),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set6),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set7),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set8),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set9),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set10),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set11),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set12),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set13),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set14),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set15),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
              
              // user data
            svg.append("svg:path")
                .attr({
                d: datalineFunc(hcData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(heightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(weightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });
  
          }
      }
  });
  
'use strict';
angular.module('AngularApp').directive('hlwPretermChartMalePrint', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:4%;' viewBox='0 0 1010 960'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 980 - margin.left - margin.right;

            var headConst = -17;
            var lengthConst = -2;
            var weightConst = 42;

            var hcData = [];
            if(vitalData.pretermHc) {
                for(var i = 0; i < vitalData.pretermHc.length; i++){
                    hcData.push({x:vitalData.pretermHc[i].x,y:vitalData.pretermHc[i].y + headConst});
                }
            }

            var heightData = [];
            if(vitalData.pretermHeight) {
                for(var i = 0; i < vitalData.pretermHeight.length; i++){
                    heightData.push({x:vitalData.pretermHeight[i].x,y:vitalData.pretermHeight[i].y + lengthConst});
                }
            }
            
            var weightData = [];
            if(vitalData.pretermWeight) {
                for(var i = 0; i < vitalData.pretermWeight.length; i++){
                    weightData.push({x:vitalData.pretermWeight[i].x,y:(vitalData.pretermWeight[i].y *10) + weightConst});
                }
            }

            // Start of Head data
            var set1 = [{x:168,y:19.4+headConst},{x:169,y:19.5+headConst},{x:170,y:19.7+headConst},{x:171,y:19.8+headConst},{x:172,y:19.9+headConst},{x:173,y:20+headConst},{x:174,y:20.2+headConst},{x:175,y:20.3+headConst},{x:176,y:20.4+headConst},{x:177,y:20.5+headConst},{x:178,y:20.7+headConst},{x:179,y:20.8+headConst},{x:180,y:20.9+headConst},{x:181,y:21.1+headConst},{x:182,y:21.2+headConst},{x:183,y:21.3+headConst},{x:184,y:21.4+headConst},{x:185,y:21.6+headConst},{x:186,y:21.7+headConst},{x:187,y:21.8+headConst},{x:188,y:21.9+headConst},{x:189,y:22.1+headConst},{x:190,y:22.2+headConst},{x:191,y:22.3+headConst},{x:192,y:22.5+headConst},{x:193,y:22.6+headConst},{x:194,y:22.7+headConst},{x:195,y:22.8+headConst},{x:196,y:23+headConst},{x:197,y:23.1+headConst},{x:198,y:23.2+headConst},{x:199,y:23.3+headConst},{x:200,y:23.5+headConst},{x:201,y:23.6+headConst},{x:202,y:23.7+headConst},{x:203,y:23.8+headConst},{x:204,y:24+headConst},{x:205,y:24.1+headConst},{x:206,y:24.2+headConst},{x:207,y:24.4+headConst},{x:208,y:24.5+headConst},{x:209,y:24.6+headConst},{x:210,y:24.7+headConst},{x:211,y:24.9+headConst},{x:212,y:25+headConst},{x:213,y:25.1+headConst},{x:214,y:25.2+headConst},{x:215,y:25.4+headConst},{x:216,y:25.5+headConst},{x:217,y:25.6+headConst},{x:218,y:25.7+headConst},{x:219,y:25.9+headConst},{x:220,y:26+headConst},{x:221,y:26.1+headConst},{x:222,y:26.3+headConst},{x:223,y:26.4+headConst},{x:224,y:26.5+headConst},{x:225,y:26.6+headConst},{x:226,y:26.8+headConst},{x:227,y:26.9+headConst},{x:228,y:27+headConst},{x:229,y:27.1+headConst},{x:230,y:27.3+headConst}];

            var set2 = [{x:168,y:20.3+headConst},{x:169,y:20.5+headConst},{x:170,y:20.6+headConst},{x:171,y:20.7+headConst},{x:172,y:20.8+headConst},{x:173,y:21+headConst},{x:174,y:21.1+headConst},{x:175,y:21.2+headConst},{x:176,y:21.4+headConst},{x:177,y:21.5+headConst},{x:178,y:21.6+headConst},{x:179,y:21.7+headConst},{x:180,y:21.9+headConst},{x:181,y:22+headConst},{x:182,y:22.1+headConst},{x:183,y:22.2+headConst},{x:184,y:22.4+headConst},{x:185,y:22.5+headConst},{x:186,y:22.6+headConst},{x:187,y:22.8+headConst},{x:188,y:22.9+headConst},{x:189,y:23+headConst},{x:190,y:23.1+headConst},{x:191,y:23.3+headConst},{x:192,y:23.4+headConst},{x:193,y:23.5+headConst},{x:194,y:23.6+headConst},{x:195,y:23.8+headConst},{x:196,y:23.9+headConst},{x:197,y:24+headConst},{x:198,y:24.1+headConst},{x:199,y:24.3+headConst},{x:200,y:24.4+headConst},{x:201,y:24.5+headConst},{x:202,y:24.7+headConst},{x:203,y:24.8+headConst},{x:204,y:24.9+headConst},{x:205,y:25+headConst},{x:206,y:25.2+headConst},{x:207,y:25.3+headConst},{x:208,y:25.4+headConst},{x:209,y:25.5+headConst},{x:210,y:25.7+headConst},{x:211,y:25.8+headConst},{x:212,y:25.9+headConst},{x:213,y:26+headConst},{x:214,y:26.2+headConst},{x:215,y:26.3+headConst},{x:216,y:26.4+headConst},{x:217,y:26.6+headConst},{x:218,y:26.7+headConst},{x:219,y:26.8+headConst},{x:220,y:26.9+headConst},{x:221,y:27.1+headConst},{x:222,y:27.2+headConst},{x:223,y:27.3+headConst},{x:224,y:27.4+headConst},{x:225,y:27.6+headConst},{x:226,y:27.7+headConst},{x:227,y:27.8+headConst},{x:228,y:28+headConst},{x:229,y:28.1+headConst},{x:230,y:28.2+headConst}];
                    
            var set3 = [{x:168,y:22.3+headConst},{x:169,y:22.5+headConst},{x:170,y:22.6+headConst},{x:171,y:22.7+headConst},{x:172,y:22.8+headConst},{x:173,y:23+headConst},{x:174,y:23.1+headConst},{x:175,y:23.2+headConst},{x:176,y:23.4+headConst},{x:177,y:23.5+headConst},{x:178,y:23.6+headConst},{x:179,y:23.7+headConst},{x:180,y:23.9+headConst},{x:181,y:24+headConst},{x:182,y:24.1+headConst},{x:183,y:24.2+headConst},{x:184,y:24.4+headConst},{x:185,y:24.5+headConst},{x:186,y:24.6+headConst},{x:187,y:24.8+headConst},{x:188,y:24.9+headConst},{x:189,y:25+headConst},{x:190,y:25.1+headConst},{x:191,y:25.3+headConst},{x:192,y:25.4+headConst},{x:193,y:25.5+headConst},{x:194,y:25.6+headConst},{x:195,y:25.8+headConst},{x:196,y:25.9+headConst},{x:197,y:26+headConst},{x:198,y:26.1+headConst},{x:199,y:26.3+headConst},{x:200,y:26.4+headConst},{x:201,y:26.5+headConst},{x:202,y:26.7+headConst},{x:203,y:26.8+headConst},{x:204,y:26.9+headConst},{x:205,y:27+headConst},{x:206,y:27.2+headConst},{x:207,y:27.3+headConst},{x:208,y:27.4+headConst},{x:209,y:27.5+headConst},{x:210,y:27.7+headConst},{x:211,y:27.8+headConst},{x:212,y:27.9+headConst},{x:213,y:28+headConst},{x:214,y:28.2+headConst},{x:215,y:28.3+headConst},{x:216,y:28.4+headConst},{x:217,y:28.6+headConst},{x:218,y:28.7+headConst},{x:219,y:28.8+headConst},{x:220,y:28.9+headConst},{x:221,y:29.1+headConst},{x:222,y:29.2+headConst},{x:223,y:29.3+headConst},{x:224,y:29.4+headConst},{x:225,y:29.6+headConst},{x:226,y:29.7+headConst},{x:227,y:29.8+headConst},{x:228,y:29.9+headConst},{x:229,y:30.1+headConst},{x:230,y:30.2+headConst}];

            var set4 = [{x:168,y:24.3+headConst},{x:169,y:24.5+headConst},{x:170,y:24.6+headConst},{x:171,y:24.7+headConst},{x:172,y:24.8+headConst},{x:173,y:25+headConst},{x:174,y:25.1+headConst},{x:175,y:25.2+headConst},{x:176,y:25.4+headConst},{x:177,y:25.5+headConst},{x:178,y:25.6+headConst},{x:179,y:25.7+headConst},{x:180,y:25.9+headConst},{x:181,y:26+headConst},{x:182,y:26.1+headConst},{x:183,y:26.2+headConst},{x:184,y:26.4+headConst},{x:185,y:26.5+headConst},{x:186,y:26.6+headConst},{x:187,y:26.7+headConst},{x:188,y:26.9+headConst},{x:189,y:27+headConst},{x:190,y:27.1+headConst},{x:191,y:27.3+headConst},{x:192,y:27.4+headConst},{x:193,y:27.5+headConst},{x:194,y:27.6+headConst},{x:195,y:27.8+headConst},{x:196,y:27.9+headConst},{x:197,y:28+headConst},{x:198,y:28.1+headConst},{x:199,y:28.3+headConst},{x:200,y:28.4+headConst},{x:201,y:28.5+headConst},{x:202,y:28.7+headConst},{x:203,y:28.8+headConst},{x:204,y:28.9+headConst},{x:205,y:29+headConst},{x:206,y:29.2+headConst},{x:207,y:29.3+headConst},{x:208,y:29.4+headConst},{x:209,y:29.5+headConst},{x:210,y:29.7+headConst},{x:211,y:29.8+headConst},{x:212,y:29.9+headConst},{x:213,y:30+headConst},{x:214,y:30.2+headConst},{x:215,y:30.3+headConst},{x:216,y:30.4+headConst},{x:217,y:30.6+headConst},{x:218,y:30.7+headConst},{x:219,y:30.8+headConst},{x:220,y:30.9+headConst},{x:221,y:31.1+headConst},{x:222,y:31.2+headConst},{x:223,y:31.3+headConst},{x:224,y:31.4+headConst},{x:225,y:31.6+headConst},{x:226,y:31.7+headConst},{x:227,y:31.8+headConst},{x:228,y:31.9+headConst},{x:229,y:32.1+headConst},{x:230,y:32.2+headConst}];

            var set5 = [{x:168,y:25.3+headConst},{x:169,y:25.4+headConst},{x:170,y:25.5+headConst},{x:171,y:25.7+headConst},{x:172,y:25.8+headConst},{x:173,y:25.9+headConst},{x:174,y:26+headConst},{x:175,y:26.2+headConst},{x:176,y:26.3+headConst},{x:177,y:26.4+headConst},{x:178,y:26.5+headConst},{x:179,y:26.7+headConst},{x:180,y:26.8+headConst},{x:181,y:26.9+headConst},{x:182,y:27.1+headConst},{x:183,y:27.2+headConst},{x:184,y:27.3+headConst},{x:185,y:27.4+headConst},{x:186,y:27.6+headConst},{x:187,y:27.7+headConst},{x:188,y:27.8+headConst},{x:189,y:27.9+headConst},{x:190,y:28.1+headConst},{x:191,y:28.2+headConst},{x:192,y:28.3+headConst},{x:193,y:28.4+headConst},{x:194,y:28.6+headConst},{x:195,y:28.7+headConst},{x:196,y:28.8+headConst},{x:197,y:29+headConst},{x:198,y:29.1+headConst},{x:199,y:29.2+headConst},{x:200,y:29.3+headConst},{x:201,y:29.5+headConst},{x:202,y:29.6+headConst},{x:203,y:29.7+headConst},{x:204,y:29.8+headConst},{x:205,y:30+headConst},{x:206,y:30.1+headConst},{x:207,y:30.2+headConst},{x:208,y:30.3+headConst},{x:209,y:30.5+headConst},{x:210,y:30.6+headConst},{x:211,y:30.7+headConst},{x:212,y:30.9+headConst},{x:213,y:31+headConst},{x:214,y:31.1+headConst},{x:215,y:31.2+headConst},{x:216,y:31.4+headConst},{x:217,y:31.5+headConst},{x:218,y:31.6+headConst},{x:219,y:31.7+headConst},{x:220,y:31.9+headConst},{x:221,y:32+headConst},{x:222,y:32.1+headConst},{x:223,y:32.2+headConst},{x:224,y:32.4+headConst},{x:225,y:32.5+headConst},{x:226,y:32.6+headConst},{x:227,y:32.8+headConst},{x:228,y:32.9+headConst},{x:229,y:33+headConst},{x:230,y:33.1+headConst}];
            // End of Head data

            // Start of Length data
            var set6 = [{x:168,y:27.3+lengthConst},{x:169,y:27.5+lengthConst},{x:170,y:27.7+lengthConst},{x:171,y:27.9+lengthConst},{x:172,y:28.1+lengthConst},{x:173,y:28.2+lengthConst},{x:174,y:28.4+lengthConst},{x:175,y:28.6+lengthConst},{x:176,y:28.8+lengthConst},{x:177,y:29+lengthConst},{x:178,y:29.1+lengthConst},{x:179,y:29.3+lengthConst},{x:180,y:29.5+lengthConst},{x:181,y:29.7+lengthConst},{x:182,y:29.9+lengthConst},{x:183,y:30+lengthConst},{x:184,y:30.2+lengthConst},{x:185,y:30.4+lengthConst},{x:186,y:30.6+lengthConst},{x:187,y:30.8+lengthConst},{x:188,y:31+lengthConst},{x:189,y:31.1+lengthConst},{x:190,y:31.3+lengthConst},{x:191,y:31.5+lengthConst},{x:192,y:31.7+lengthConst},{x:193,y:31.9+lengthConst},{x:194,y:32+lengthConst},{x:195,y:32.2+lengthConst},{x:196,y:32.4+lengthConst},{x:197,y:32.6+lengthConst},{x:198,y:32.8+lengthConst},{x:199,y:32.9+lengthConst},{x:200,y:33.1+lengthConst},{x:201,y:33.3+lengthConst},{x:202,y:33.5+lengthConst},{x:203,y:33.7+lengthConst},{x:204,y:33.9+lengthConst},{x:205,y:34+lengthConst},{x:206,y:34.2+lengthConst},{x:207,y:34.4+lengthConst},{x:208,y:34.6+lengthConst},{x:209,y:34.8+lengthConst},{x:210,y:34.9+lengthConst},{x:211,y:35.1+lengthConst},{x:212,y:35.3+lengthConst},{x:213,y:35.5+lengthConst},{x:214,y:35.7+lengthConst},{x:215,y:35.9+lengthConst},{x:216,y:36+lengthConst},{x:217,y:36.2+lengthConst},{x:218,y:36.4+lengthConst},{x:219,y:36.6+lengthConst},{x:220,y:36.8+lengthConst},{x:221,y:36.9+lengthConst},{x:222,y:37.1+lengthConst},{x:223,y:37.3+lengthConst},{x:224,y:37.5+lengthConst},{x:225,y:37.7+lengthConst},{x:226,y:37.8+lengthConst},{x:227,y:38+lengthConst},{x:228,y:38.2+lengthConst},{x:229,y:38.4+lengthConst},{x:230,y:38.6+lengthConst}];

            var set7 = [{x:168,y:28.9+lengthConst},{x:169,y:29.1+lengthConst},{x:170,y:29.2+lengthConst},{x:171,y:29.4+lengthConst},{x:172,y:29.6+lengthConst},{x:173,y:29.8+lengthConst},{x:174,y:30+lengthConst},{x:175,y:30.2+lengthConst},{x:176,y:30.3+lengthConst},{x:177,y:30.5+lengthConst},{x:178,y:30.7+lengthConst},{x:179,y:30.9+lengthConst},{x:180,y:31.1+lengthConst},{x:181,y:31.2+lengthConst},{x:182,y:31.4+lengthConst},{x:183,y:31.6+lengthConst},{x:184,y:31.8+lengthConst},{x:185,y:32+lengthConst},{x:186,y:32.1+lengthConst},{x:187,y:32.3+lengthConst},{x:188,y:32.5+lengthConst},{x:189,y:32.7+lengthConst},{x:190,y:32.9+lengthConst},{x:191,y:33.1+lengthConst},{x:192,y:33.2+lengthConst},{x:193,y:33.4+lengthConst},{x:194,y:33.6+lengthConst},{x:195,y:33.8+lengthConst},{x:196,y:34+lengthConst},{x:197,y:34.1+lengthConst},{x:198,y:34.3+lengthConst},{x:199,y:34.5+lengthConst},{x:200,y:34.7+lengthConst},{x:201,y:34.9+lengthConst},{x:202,y:35.1+lengthConst},{x:203,y:35.2+lengthConst},{x:204,y:35.4+lengthConst},{x:205,y:35.6+lengthConst},{x:206,y:35.8+lengthConst},{x:207,y:36+lengthConst},{x:208,y:36.1+lengthConst},{x:209,y:36.3+lengthConst},{x:210,y:36.5+lengthConst},{x:211,y:36.7+lengthConst},{x:212,y:36.9+lengthConst},{x:213,y:37+lengthConst},{x:214,y:37.2+lengthConst},{x:215,y:37.4+lengthConst},{x:216,y:37.6+lengthConst},{x:217,y:37.8+lengthConst},{x:218,y:38+lengthConst},{x:219,y:38.1+lengthConst},{x:220,y:38.3+lengthConst},{x:221,y:38.5+lengthConst},{x:222,y:38.7+lengthConst},{x:223,y:38.9+lengthConst},{x:224,y:39+lengthConst},{x:225,y:39.2+lengthConst},{x:226,y:39.4+lengthConst},{x:227,y:39.6+lengthConst},{x:228,y:39.8+lengthConst},{x:229,y:40+lengthConst},{x:230,y:40.1+lengthConst}];
                    
            var set8 = [{x:168,y:32.2+lengthConst},{x:169,y:32.4+lengthConst},{x:170,y:32.6+lengthConst},{x:171,y:32.8+lengthConst},{x:172,y:32.9+lengthConst},{x:173,y:33.1+lengthConst},{x:174,y:33.3+lengthConst},{x:175,y:33.5+lengthConst},{x:176,y:33.7+lengthConst},{x:177,y:33.8+lengthConst},{x:178,y:34+lengthConst},{x:179,y:34.2+lengthConst},{x:180,y:34.4+lengthConst},{x:181,y:34.6+lengthConst},{x:182,y:34.8+lengthConst},{x:183,y:34.9+lengthConst},{x:184,y:35.1+lengthConst},{x:185,y:35.3+lengthConst},{x:186,y:35.5+lengthConst},{x:187,y:35.7+lengthConst},{x:188,y:35.8+lengthConst},{x:189,y:36+lengthConst},{x:190,y:36.2+lengthConst},{x:191,y:36.4+lengthConst},{x:192,y:36.6+lengthConst},{x:193,y:36.8+lengthConst},{x:194,y:36.9+lengthConst},{x:195,y:37.1+lengthConst},{x:196,y:37.3+lengthConst},{x:197,y:37.5+lengthConst},{x:198,y:37.7+lengthConst},{x:199,y:37.8+lengthConst},{x:200,y:38+lengthConst},{x:201,y:38.2+lengthConst},{x:202,y:38.4+lengthConst},{x:203,y:38.6+lengthConst},{x:204,y:38.7+lengthConst},{x:205,y:38.9+lengthConst},{x:206,y:39.1+lengthConst},{x:207,y:39.3+lengthConst},{x:208,y:39.5+lengthConst},{x:209,y:39.7+lengthConst},{x:210,y:39.8+lengthConst},{x:211,y:40+lengthConst},{x:212,y:40.2+lengthConst},{x:213,y:40.4+lengthConst},{x:214,y:40.6+lengthConst},{x:215,y:40.7+lengthConst},{x:216,y:40.9+lengthConst},{x:217,y:41.1+lengthConst},{x:218,y:41.3+lengthConst},{x:219,y:41.5+lengthConst},{x:220,y:41.6+lengthConst},{x:221,y:41.8+lengthConst},{x:222,y:42+lengthConst},{x:223,y:42.2+lengthConst},{x:224,y:42.4+lengthConst},{x:225,y:42.6+lengthConst},{x:226,y:42.7+lengthConst},{x:227,y:42.9+lengthConst},{x:228,y:43.1+lengthConst},{x:229,y:43.3+lengthConst},{x:230,y:43.5+lengthConst}];

            var set9 = [{x:168,y:35.5+lengthConst},{x:169,y:35.7+lengthConst},{x:170,y:35.9+lengthConst},{x:171,y:36.1+lengthConst},{x:172,y:36.3+lengthConst},{x:173,y:36.5+lengthConst},{x:174,y:36.6+lengthConst},{x:175,y:36.8+lengthConst},{x:176,y:37+lengthConst},{x:177,y:37.2+lengthConst},{x:178,y:37.4+lengthConst},{x:179,y:37.5+lengthConst},{x:180,y:37.7+lengthConst},{x:181,y:37.9+lengthConst},{x:182,y:38.1+lengthConst},{x:183,y:38.3+lengthConst},{x:184,y:38.4+lengthConst},{x:185,y:38.6+lengthConst},{x:186,y:38.8+lengthConst},{x:187,y:39+lengthConst},{x:188,y:39.2+lengthConst},{x:189,y:39.4+lengthConst},{x:190,y:39.5+lengthConst},{x:191,y:39.7+lengthConst},{x:192,y:39.9+lengthConst},{x:193,y:40.1+lengthConst},{x:194,y:40.3+lengthConst},{x:195,y:40.4+lengthConst},{x:196,y:40.6+lengthConst},{x:197,y:40.8+lengthConst},{x:198,y:41+lengthConst},{x:199,y:41.2+lengthConst},{x:200,y:41.4+lengthConst},{x:201,y:41.5+lengthConst},{x:202,y:41.7+lengthConst},{x:203,y:41.9+lengthConst},{x:204,y:42.1+lengthConst},{x:205,y:42.3+lengthConst},{x:206,y:42.4+lengthConst},{x:207,y:42.6+lengthConst},{x:208,y:42.8+lengthConst},{x:209,y:43+lengthConst},{x:210,y:43.2+lengthConst},{x:211,y:43.3+lengthConst},{x:212,y:43.5+lengthConst},{x:213,y:43.7+lengthConst},{x:214,y:43.9+lengthConst},{x:215,y:44.1+lengthConst},{x:216,y:44.3+lengthConst},{x:217,y:44.4+lengthConst},{x:218,y:44.6+lengthConst},{x:219,y:44.8+lengthConst},{x:220,y:45+lengthConst},{x:221,y:45.2+lengthConst},{x:222,y:45.3+lengthConst},{x:223,y:45.5+lengthConst},{x:224,y:45.7+lengthConst},{x:225,y:45.9+lengthConst},{x:226,y:46.1+lengthConst},{x:227,y:46.3+lengthConst},{x:228,y:46.4+lengthConst},{x:229,y:46.6+lengthConst},{x:230,y:46.8+lengthConst}];

            var set10 = [{x:168,y:37.1+lengthConst},{x:169,y:37.3+lengthConst},{x:170,y:37.5+lengthConst},{x:171,y:37.6+lengthConst},{x:172,y:37.8+lengthConst},{x:173,y:38+lengthConst},{x:174,y:38.2+lengthConst},{x:175,y:38.4+lengthConst},{x:176,y:38.6+lengthConst},{x:177,y:38.7+lengthConst},{x:178,y:38.9+lengthConst},{x:179,y:39.1+lengthConst},{x:180,y:39.3+lengthConst},{x:181,y:39.5+lengthConst},{x:182,y:39.6+lengthConst},{x:183,y:39.8+lengthConst},{x:184,y:40+lengthConst},{x:185,y:40.2+lengthConst},{x:186,y:40.4+lengthConst},{x:187,y:40.6+lengthConst},{x:188,y:40.7+lengthConst},{x:189,y:40.9+lengthConst},{x:190,y:41.1+lengthConst},{x:191,y:41.3+lengthConst},{x:192,y:41.5+lengthConst},{x:193,y:41.6+lengthConst},{x:194,y:41.8+lengthConst},{x:195,y:42+lengthConst},{x:196,y:42.2+lengthConst},{x:197,y:42.4+lengthConst},{x:198,y:42.5+lengthConst},{x:199,y:42.7+lengthConst},{x:200,y:42.9+lengthConst},{x:201,y:43.1+lengthConst},{x:202,y:43.3+lengthConst},{x:203,y:43.5+lengthConst},{x:204,y:43.6+lengthConst},{x:205,y:43.8+lengthConst},{x:206,y:44+lengthConst},{x:207,y:44.2+lengthConst},{x:208,y:44.4+lengthConst},{x:209,y:44.5+lengthConst},{x:210,y:44.7+lengthConst},{x:211,y:44.9+lengthConst},{x:212,y:45.1+lengthConst},{x:213,y:45.3+lengthConst},{x:214,y:45.4+lengthConst},{x:215,y:45.6+lengthConst},{x:216,y:45.8+lengthConst},{x:217,y:46+lengthConst},{x:218,y:46.2+lengthConst},{x:219,y:46.4+lengthConst},{x:220,y:46.5+lengthConst},{x:221,y:46.7+lengthConst},{x:222,y:46.9+lengthConst},{x:223,y:47.1+lengthConst},{x:224,y:47.3+lengthConst},{x:225,y:47.4+lengthConst},{x:226,y:47.6+lengthConst},{x:227,y:47.8+lengthConst},{x:228,y:48+lengthConst},{x:229,y:48.2+lengthConst},{x:230,y:48.4+lengthConst}];
            // End of Length data
            
            // Start of Weight data
            var set11 = [{x:168,y:(0.44*10)+weightConst},{x:169,y:(0.45*10)+weightConst},{x:170,y:(0.46*10)+weightConst},{x:171,y:(0.47*10)+weightConst},{x:172,y:(0.48*10)+weightConst},{x:173,y:(0.49*10)+weightConst},{x:174,y:(0.5*10)+weightConst},{x:175,y:(0.51*10)+weightConst},{x:176,y:(0.52*10)+weightConst},{x:177,y:(0.53*10)+weightConst},{x:178,y:(0.54*10)+weightConst},{x:179,y:(0.55*10)+weightConst},{x:180,y:(0.56*10)+weightConst},{x:181,y:(0.57*10)+weightConst},{x:182,y:(0.58*10)+weightConst},{x:183,y:(0.59*10)+weightConst},{x:184,y:(0.6*10)+weightConst},{x:185,y:(0.61*10)+weightConst},{x:186,y:(0.62*10)+weightConst},{x:187,y:(0.63*10)+weightConst},{x:188,y:(0.65*10)+weightConst},{x:189,y:(0.66*10)+weightConst},{x:190,y:(0.67*10)+weightConst},{x:191,y:(0.68*10)+weightConst},{x:192,y:(0.69*10)+weightConst},{x:193,y:(0.71*10)+weightConst},{x:194,y:(0.72*10)+weightConst},{x:195,y:(0.73*10)+weightConst},{x:196,y:(0.75*10)+weightConst},{x:197,y:(0.76*10)+weightConst},{x:198,y:(0.77*10)+weightConst},{x:199,y:(0.79*10)+weightConst},{x:200,y:(0.8*10)+weightConst},{x:201,y:(0.82*10)+weightConst},{x:202,y:(0.83*10)+weightConst},{x:203,y:(0.84*10)+weightConst},{x:204,y:(0.86*10)+weightConst},{x:205,y:(0.87*10)+weightConst},{x:206,y:(0.89*10)+weightConst},{x:207,y:(0.91*10)+weightConst},{x:208,y:(0.92*10)+weightConst},{x:209,y:(0.94*10)+weightConst},{x:210,y:(0.95*10)+weightConst},{x:211,y:(0.97*10)+weightConst},{x:212,y:(0.99*10)+weightConst},{x:213,y:(1*10)+weightConst},{x:214,y:(1.02*10)+weightConst},{x:215,y:(1.04*10)+weightConst},{x:216,y:(1.06*10)+weightConst},{x:217,y:(1.08*10)+weightConst},{x:218,y:(1.09*10)+weightConst},{x:219,y:(1.11*10)+weightConst},{x:220,y:(1.13*10)+weightConst},{x:221,y:(1.15*10)+weightConst},{x:222,y:(1.17*10)+weightConst},{x:223,y:(1.19*10)+weightConst},{x:224,y:(1.21*10)+weightConst},{x:225,y:(1.23*10)+weightConst},{x:226,y:(1.25*10)+weightConst},{x:227,y:(1.27*10)+weightConst},{x:228,y:(1.29*10)+weightConst},{x:229,y:(1.32*10)+weightConst},{x:230,y:(1.34*10)+weightConst}];

            var set12 = [{x:168,y:(0.5*10)+weightConst},{x:169,y:(0.51*10)+weightConst},{x:170,y:(0.52*10)+weightConst},{x:171,y:(0.53*10)+weightConst},{x:172,y:(0.54*10)+weightConst},{x:173,y:(0.55*10)+weightConst},{x:174,y:(0.56*10)+weightConst},{x:175,y:(0.57*10)+weightConst},{x:176,y:(0.58*10)+weightConst},{x:177,y:(0.59*10)+weightConst},{x:178,y:(0.6*10)+weightConst},{x:179,y:(0.61*10)+weightConst},{x:180,y:(0.63*10)+weightConst},{x:181,y:(0.64*10)+weightConst},{x:182,y:(0.65*10)+weightConst},{x:183,y:(0.66*10)+weightConst},{x:184,y:(0.67*10)+weightConst},{x:185,y:(0.69*10)+weightConst},{x:186,y:(0.7*10)+weightConst},{x:187,y:(0.71*10)+weightConst},{x:188,y:(0.72*10)+weightConst},{x:189,y:(0.74*10)+weightConst},{x:190,y:(0.75*10)+weightConst},{x:191,y:(0.77*10)+weightConst},{x:192,y:(0.78*10)+weightConst},{x:193,y:(0.79*10)+weightConst},{x:194,y:(0.81*10)+weightConst},{x:195,y:(0.82*10)+weightConst},{x:196,y:(0.84*10)+weightConst},{x:197,y:(0.85*10)+weightConst},{x:198,y:(0.87*10)+weightConst},{x:199,y:(0.88*10)+weightConst},{x:200,y:(0.9*10)+weightConst},{x:201,y:(0.92*10)+weightConst},{x:202,y:(0.93*10)+weightConst},{x:203,y:(0.95*10)+weightConst},{x:204,y:(0.97*10)+weightConst},{x:205,y:(0.98*10)+weightConst},{x:206,y:(1*10)+weightConst},{x:207,y:(1.02*10)+weightConst},{x:208,y:(1.03*10)+weightConst},{x:209,y:(1.05*10)+weightConst},{x:210,y:(1.07*10)+weightConst},{x:211,y:(1.09*10)+weightConst},{x:212,y:(1.11*10)+weightConst},{x:213,y:(1.13*10)+weightConst},{x:214,y:(1.15*10)+weightConst},{x:215,y:(1.17*10)+weightConst},{x:216,y:(1.19*10)+weightConst},{x:217,y:(1.21*10)+weightConst},{x:218,y:(1.23*10)+weightConst},{x:219,y:(1.25*10)+weightConst},{x:220,y:(1.27*10)+weightConst},{x:221,y:(1.29*10)+weightConst},{x:222,y:(1.31*10)+weightConst},{x:223,y:(1.34*10)+weightConst},{x:224,y:(1.36*10)+weightConst},{x:225,y:(1.38*10)+weightConst},{x:226,y:(1.41*10)+weightConst},{x:227,y:(1.43*10)+weightConst},{x:228,y:(1.45*10)+weightConst},{x:229,y:(1.48*10)+weightConst},{x:230,y:(1.5*10)+weightConst}];
                    
            var set13 = [{x:168,y:(0.64*10)+weightConst},{x:169,y:(0.65*10)+weightConst},{x:170,y:(0.66*10)+weightConst},{x:171,y:(0.68*10)+weightConst},{x:172,y:(0.69*10)+weightConst},{x:173,y:(0.7*10)+weightConst},{x:174,y:(0.72*10)+weightConst},{x:175,y:(0.73*10)+weightConst},{x:176,y:(0.74*10)+weightConst},{x:177,y:(0.76*10)+weightConst},{x:178,y:(0.77*10)+weightConst},{x:179,y:(0.79*10)+weightConst},{x:180,y:(0.8*10)+weightConst},{x:181,y:(0.82*10)+weightConst},{x:182,y:(0.83*10)+weightConst},{x:183,y:(0.85*10)+weightConst},{x:184,y:(0.86*10)+weightConst},{x:185,y:(0.88*10)+weightConst},{x:186,y:(0.89*10)+weightConst},{x:187,y:(0.91*10)+weightConst},{x:188,y:(0.93*10)+weightConst},{x:189,y:(0.95*10)+weightConst},{x:190,y:(0.96*10)+weightConst},{x:191,y:(0.98*10)+weightConst},{x:192,y:(1*10)+weightConst},{x:193,y:(1.02*10)+weightConst},{x:194,y:(1.03*10)+weightConst},{x:195,y:(1.05*10)+weightConst},{x:196,y:(1.07*10)+weightConst},{x:197,y:(1.09*10)+weightConst},{x:198,y:(1.11*10)+weightConst},{x:199,y:(1.13*10)+weightConst},{x:200,y:(1.15*10)+weightConst},{x:201,y:(1.17*10)+weightConst},{x:202,y:(1.19*10)+weightConst},{x:203,y:(1.21*10)+weightConst},{x:204,y:(1.24*10)+weightConst},{x:205,y:(1.26*10)+weightConst},{x:206,y:(1.28*10)+weightConst},{x:207,y:(1.3*10)+weightConst},{x:208,y:(1.33*10)+weightConst},{x:209,y:(1.35*10)+weightConst},{x:210,y:(1.37*10)+weightConst},{x:211,y:(1.4*10)+weightConst},{x:212,y:(1.42*10)+weightConst},{x:213,y:(1.45*10)+weightConst},{x:214,y:(1.47*10)+weightConst},{x:215,y:(1.5*10)+weightConst},{x:216,y:(1.52*10)+weightConst},{x:217,y:(1.55*10)+weightConst},{x:218,y:(1.57*10)+weightConst},{x:219,y:(1.6*10)+weightConst},{x:220,y:(1.63*10)+weightConst},{x:221,y:(1.66*10)+weightConst},{x:222,y:(1.68*10)+weightConst},{x:223,y:(1.71*10)+weightConst},{x:224,y:(1.74*10)+weightConst},{x:225,y:(1.77*10)+weightConst},{x:226,y:(1.8*10)+weightConst},{x:227,y:(1.83*10)+weightConst},{x:228,y:(1.86*10)+weightConst},{x:229,y:(1.89*10)+weightConst},{x:230,y:(1.92*10)+weightConst}];

            var set14 = [{x:168,y:(0.82*10)+weightConst},{x:169,y:(0.83*10)+weightConst},{x:170,y:(0.85*10)+weightConst},{x:171,y:(0.87*10)+weightConst},{x:172,y:(0.88*10)+weightConst},{x:173,y:(0.9*10)+weightConst},{x:174,y:(0.92*10)+weightConst},{x:175,y:(0.93*10)+weightConst},{x:176,y:(0.95*10)+weightConst},{x:177,y:(0.97*10)+weightConst},{x:178,y:(0.99*10)+weightConst},{x:179,y:(1.01*10)+weightConst},{x:180,y:(1.03*10)+weightConst},{x:181,y:(1.04*10)+weightConst},{x:182,y:(1.06*10)+weightConst},{x:183,y:(1.08*10)+weightConst},{x:184,y:(1.1*10)+weightConst},{x:185,y:(1.13*10)+weightConst},{x:186,y:(1.15*10)+weightConst},{x:187,y:(1.17*10)+weightConst},{x:188,y:(1.19*10)+weightConst},{x:189,y:(1.21*10)+weightConst},{x:190,y:(1.23*10)+weightConst},{x:191,y:(1.26*10)+weightConst},{x:192,y:(1.28*10)+weightConst},{x:193,y:(1.3*10)+weightConst},{x:194,y:(1.33*10)+weightConst},{x:195,y:(1.35*10)+weightConst},{x:196,y:(1.37*10)+weightConst},{x:197,y:(1.4*10)+weightConst},{x:198,y:(1.42*10)+weightConst},{x:199,y:(1.45*10)+weightConst},{x:200,y:(1.48*10)+weightConst},{x:201,y:(1.5*10)+weightConst},{x:202,y:(1.53*10)+weightConst},{x:203,y:(1.56*10)+weightConst},{x:204,y:(1.58*10)+weightConst},{x:205,y:(1.61*10)+weightConst},{x:206,y:(1.64*10)+weightConst},{x:207,y:(1.67*10)+weightConst},{x:208,y:(1.7*10)+weightConst},{x:209,y:(1.73*10)+weightConst},{x:210,y:(1.76*10)+weightConst},{x:211,y:(1.79*10)+weightConst},{x:212,y:(1.82*10)+weightConst},{x:213,y:(1.85*10)+weightConst},{x:214,y:(1.88*10)+weightConst},{x:215,y:(1.92*10)+weightConst},{x:216,y:(1.95*10)+weightConst},{x:217,y:(1.98*10)+weightConst},{x:218,y:(2.02*10)+weightConst},{x:219,y:(2.05*10)+weightConst},{x:220,y:(2.09*10)+weightConst},{x:221,y:(2.12*10)+weightConst},{x:222,y:(2.16*10)+weightConst},{x:223,y:(2.19*10)+weightConst},{x:224,y:(2.23*10)+weightConst},{x:225,y:(2.27*10)+weightConst},{x:226,y:(2.31*10)+weightConst},{x:227,y:(2.35*10)+weightConst},{x:228,y:(2.38*10)+weightConst},{x:229,y:(2.42*10)+weightConst},{x:230,y:(2.46*10)+weightConst}];

            var set15 = [{x:168,y:(0.92*10)+weightConst},{x:169,y:(0.93*10)+weightConst},{x:170,y:(0.95*10)+weightConst},{x:171,y:(0.97*10)+weightConst},{x:172,y:(0.99*10)+weightConst},{x:173,y:(1.01*10)+weightConst},{x:174,y:(1.03*10)+weightConst},{x:175,y:(1.05*10)+weightConst},{x:176,y:(1.07*10)+weightConst},{x:177,y:(1.09*10)+weightConst},{x:178,y:(1.11*10)+weightConst},{x:179,y:(1.13*10)+weightConst},{x:180,y:(1.15*10)+weightConst},{x:181,y:(1.17*10)+weightConst},{x:182,y:(1.2*10)+weightConst},{x:183,y:(1.22*10)+weightConst},{x:184,y:(1.24*10)+weightConst},{x:185,y:(1.26*10)+weightConst},{x:186,y:(1.29*10)+weightConst},{x:187,y:(1.31*10)+weightConst},{x:188,y:(1.33*10)+weightConst},{x:189,y:(1.36*10)+weightConst},{x:190,y:(1.38*10)+weightConst},{x:191,y:(1.41*10)+weightConst},{x:192,y:(1.44*10)+weightConst},{x:193,y:(1.46*10)+weightConst},{x:194,y:(1.49*10)+weightConst},{x:195,y:(1.52*10)+weightConst},{x:196,y:(1.54*10)+weightConst},{x:197,y:(1.57*10)+weightConst},{x:198,y:(1.6*10)+weightConst},{x:199,y:(1.63*10)+weightConst},{x:200,y:(1.66*10)+weightConst},{x:201,y:(1.69*10)+weightConst},{x:202,y:(1.72*10)+weightConst},{x:203,y:(1.75*10)+weightConst},{x:204,y:(1.78*10)+weightConst},{x:205,y:(1.81*10)+weightConst},{x:206,y:(1.84*10)+weightConst},{x:207,y:(1.87*10)+weightConst},{x:208,y:(1.91*10)+weightConst},{x:209,y:(1.94*10)+weightConst},{x:210,y:(1.97*10)+weightConst},{x:211,y:(2.01*10)+weightConst},{x:212,y:(2.04*10)+weightConst},{x:213,y:(2.08*10)+weightConst},{x:214,y:(2.11*10)+weightConst},{x:215,y:(2.15*10)+weightConst},{x:216,y:(2.19*10)+weightConst},{x:217,y:(2.23*10)+weightConst},{x:218,y:(2.26*10)+weightConst},{x:219,y:(2.3*10)+weightConst},{x:220,y:(2.34*10)+weightConst},{x:221,y:(2.38*10)+weightConst},{x:222,y:(2.42*10)+weightConst},{x:223,y:(2.46*10)+weightConst},{x:224,y:(2.5*10)+weightConst},{x:225,y:(2.55*10)+weightConst},{x:226,y:(2.59*10)+weightConst},{x:227,y:(2.63*10)+weightConst},{x:228,y:(2.68*10)+weightConst},{x:229,y:(2.72*10)+weightConst},{x:230,y:(2.77*10)+weightConst}];
            // End of Weight data
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');
            var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap3.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,73]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,73]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
				return '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                return d%2==0 ? yAxisLeftFake(d):'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                return d%2==0 ? yAxisRightFake(d):'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var yAxisLeftFake = function(d){
                switch (d){
                case 0:return 18;
                case 2:return 19;
                case 4:return 20;
                case 6:return 21;
                case 8:return 22;
                case 10:return 23;
                case 12:return 24;
                case 14:return 25;
                case 16:return 26;
                case 18:return 27;
                case 20:return '';
                case 22:return 24;
                case 24:return 26;
                case 26:return 28;
                case 28:return 30;
                case 30:return 32;
                case 32:return 34;
                case 34:return 36;
                case 36:return 38;
                case 38:return 40;
                case 40:return 42;
                case 42:return '';
                case 44:return 0.2;
                case 46:return 0.4;
                case 48:return 0.6;
                case 50:return 0.8;
                case 52:return '1.0';
                case 54:return 1.2;
                case 56:return 1.4;
                case 58:return 1.6;
                case 60:return 1.8;
                case 62:return '2.0';
                case 64:return 2.2;
                case 66:return 2.4;
                case 68:return 2.6;
                case 70:return 2.8;
                case 72:return '3.0';
                }
            };

            var yAxisRightFake = function(d){
                switch (d){
                case 0:return 18;
                case 2:return 19;
                case 4:return 20;
                case 6:return 21;
                case 8:return 22;
                case 10:return 23;
                case 12:return 24;
                case 14:return 25;
                case 16:return 26;
                case 18:return 27;
                case 20:return 28;
                case 22:return 29;
                case 24:return 30;
                case 26:return 31;
                case 28:return 32;
                case 30:return 33;
                case 32:return 34;
                case 34:return '';
                case 36:return 38;
                case 38:return 40;
                case 40:return 42;
                case 42:return 44;
                case 44:return 46;
                case 46:return 48;
                case 48:return 50;
                case 50:return '';
                case 52:return '1.0';
                case 54:return 1.2;
                case 56:return 1.4;
                case 58:return 1.6;
                case 60:return 1.8;
                case 62:return '2.0';
                case 64:return 2.2;
                case 66:return 2.4;
                case 68:return 2.6;
                case 70:return 2.8;
                case 72:return '3.0';
                }
            };

            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" kg")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Gestational age at birth (weeks)");
            
            svg.append("text")
                .attr("x", 30 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("© University of Oxford");

            svg.append("text")
                .attr("x", 750 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("Villar et al. Lancet 2016;387:844-5");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            
            svg.append("text")
                .attr("x", -10 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("32");
                   
            svg.append("text")
                .attr("x", 753 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -10 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("32");
                   
            svg.append("text")
                .attr("x", 753 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("33");
            

            svg.append("text")
                .attr("x", -840 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -540 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -200 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Birthweight (kg)");

            svg.append("text")
                .attr("x", -700 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -400 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -150 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Birthweight (kg)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 230 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 210 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 155 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 90 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 50 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 470 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 450 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 410 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 365 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 345 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 815 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 800 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 775 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 747 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 735 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set6),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set8),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set10),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set11),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set13),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set15),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });
            
            // user data
            svg.append("svg:path")
                .attr({
                d: datalineFunc(hcData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(heightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(weightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('iapBmiChartMalePrint', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:9%;padding-top:10%;' viewBox='0 0 930 980'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var bmiData = [];

            if(vitalData.bmi){
                for(var i = 0; i < vitalData.bmi.length; i++){
                    if(vitalData.bmi[i].x>59 && vitalData.bmi[i].x<217) {
                        bmiData.push(vitalData.bmi[i]);
                    }
                }
            }

            var set1 = [{x:60,y:12.1},{x:66,y:12.15},{x:72,y:12.2},{x:78,y:12.25},{x:84,y:12.3},{x:90,y:12.4},{x:96,y:12.5},{x:102,y:12.6},
                        {x:108,y:12.7},{x:114,y:12.8},{x:120,y:12.9},{x:126,y:13},{x:132,y:13.1},{x:138,y:13.2},
                        {x:144,y:13.3},{x:150,y:13.4},{x:156,y:13.55},{x:162,y:13.7},{x:168,y:13.8},{x:174,y:14},
                        {x:180,y:14.2},{x:186,y:14.4},{x:192,y:14.6},{x:198,y:14.9},{x:204,y:15.1},{x:210,y:15.4},{x:216,y:15.6}];

            var set2 = [{x:60,y:12.4},{x:66,y:12.4},{x:72,y:12.5},{x:78,y:12.5},{x:84,y:12.6},{x:90,y:12.7},{x:96,y:12.8},{x:102,y:12.9},
                        {x:108,y:13},{x:114,y:13.1},{x:120,y:13.2},{x:126,y:13.3},{x:132,y:13.5},{x:138,y:13.6},
                        {x:144,y:13.8},{x:150,y:13.9},{x:156,y:14},{x:162,y:14.2},{x:168,y:14.3},{x:174,y:14.5},
                        {x:180,y:14.7},{x:186,y:14.9},{x:192,y:15.1},{x:198,y:15.4},{x:204,y:15.6},{x:210,y:15.9},{x:216,y:16.2}];
                    
            var set3 = [{x:60,y:12.8},{x:66,y:12.9},{x:72,y:12.9},{x:78,y:13},{x:84,y:13.1},{x:90,y:13.2},{x:96,y:13.3},{x:102,y:13.4},
                        {x:108,y:13.5},{x:114,y:13.7},{x:120,y:13.8},{x:126,y:14},{x:132,y:14.1},{x:138,y:14.3},
                        {x:144,y:14.5},{x:150,y:14.6},{x:156,y:14.8},{x:162,y:14.9},{x:168,y:15.1},{x:174,y:15.3},
                        {x:180,y:15.5},{x:186,y:15.8},{x:192,y:16},{x:198,y:16.3},{x:204,y:16.6},{x:210,y:16.8},{x:216,y:17.1}];

            var set4 = [{x:60,y:13.6},{x:66,y:13.7},{x:72,y:13.7},{x:78,y:13.8},{x:84,y:13.9},{x:90,y:14.1},{x:96,y:14.2},{x:102,y:14.4},
                        {x:108,y:14.5},{x:114,y:14.7},{x:120,y:14.9},{x:126,y:15.1},{x:132,y:15.4},{x:138,y:15.6},
                        {x:144,y:15.8},{x:150,y:16},{x:156,y:16.3},{x:162,y:16.5},{x:168,y:16.7},{x:174,y:16.9},
                        {x:180,y:17.2},{x:186,y:17.4},{x:192,y:17.7},{x:198,y:18},{x:204,y:18.3},{x:210,y:18.6},{x:216,y:18.9}];

            var set5 = [{x:60,y:14.7},{x:66,y:14.8},{x:72,y:14.9},{x:78,y:15},{x:84,y:15.1},{x:90,y:15.3},{x:96,y:15.5},{x:102,y:15.7},
                        {x:108,y:15.9},{x:114,y:16.2},{x:120,y:16.4},{x:126,y:16.7},{x:132,y:17},{x:138,y:17.3},
                        {x:144,y:17.7},{x:150,y:17.9},{x:156,y:18.2},{x:162,y:18.5},{x:168,y:18.7},{x:174,y:19},
                        {x:180,y:19.3},{x:186,y:19.6},{x:192,y:19.9},{x:198,y:20.2},{x:204,y:20.5},{x:210,y:20.8},{x:216,y:21.1}];

            var set6 = [{x:60,y:15.7},{x:66,y:15.8},{x:72,y:16},{x:78,y:16.1},{x:84,y:16.3},{x:90,y:16.5},{x:96,y:16.7},{x:102,y:17},
                        {x:108,y:17.3},{x:114,y:17.6},{x:120,y:18},{x:126,y:18.3},{x:132,y:18.7},{x:138,y:19.1},
                        {x:144,y:19.5},{x:150,y:19.9},{x:156,y:20.2},{x:162,y:20.5},{x:168,y:20.8},{x:174,y:21.1},
                        {x:180,y:21.4},{x:186,y:21.7},{x:192,y:22},{x:198,y:22.3},{x:204,y:22.6},{x:210,y:22.9},{x:216,y:23.2}];

            var set7 = [{x:60,y:17.5},{x:66,y:17.6},{x:72,y:17.8},{x:78,y:18},{x:84,y:18.2},{x:90,y:18.5},{x:96,y:18.8},{x:102,y:19.2},
                        {x:108,y:19.6},{x:114,y:20.1},{x:120,y:20.5},{x:126,y:21},{x:132,y:21.5},{x:138,y:22.1},
                        {x:144,y:22.6},{x:150,y:23},{x:156,y:23.4},{x:162,y:23.8},{x:168,y:24.2},{x:174,y:24.5},
                        {x:180,y:24.9},{x:186,y:25.2},{x:192,y:25.5},{x:198,y:25.8},{x:204,y:26},{x:210,y:26.3},{x:216,y:26.6}];
            

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([bmiData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            gEnter.append('g').attr('class', 'lines');
            gEnter.append('g').attr('class', 'point-clips');
            gEnter.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([10,35]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([10,35]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 +.1 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 +.1 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(26).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(26).innerTickSize(-width)
                            .outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString())	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("IAP Boys BMI Chart 5 - 18 years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height - 30)
                .attr("transform", "translate(-980,900) rotate(-90)")
                .style("text-anchor", "middle")
                // .style("font-size","10px")
                .text("Reviesed IAP growth charts for height, weight & body mass index for 5 to 18 year old indian children.");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height - 25)
                .attr("transform", "translate(-970,900) rotate(-90)")
                .style("text-anchor", "middle")
                // .style("font-size","10px")
                .text("V.Khadilkar et al. from Indian Academy of Pediatrics Growth Chart Committee Indian Pediatrics. Jan 2015, volume 52");

            svg.append("text")
                .attr("x", 690 )
                .attr("y", 745 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 725 )
                .style("text-anchor", "start")
                .text("5");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 690 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 630 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 540 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 250 )
                .attr("y", 670 )
                .attr("transform", "rotate(-20)")
                .style("text-anchor", "start")
                .text("23 Adult equivalent (Overweight)");
            
            svg.append("text")
                .attr("x", 250 )
                .attr("y", 585 )
                .attr("transform", "rotate(-25)")
                .style("text-anchor", "start")
                .text("27 Adult equivalent (Obesity)");
               
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "orange",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(bmiData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    }
});
'use strict';
angular.module('AngularApp').directive('iapBmiChartFemalePrint', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:9%;padding-top:10%;' viewBox='0 0 930 980'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var bmiData = [];

            if(vitalData.bmi){
                for(var i = 0; i < vitalData.bmi.length; i++){
                    if(vitalData.bmi[i].x>59 && vitalData.bmi[i].x<217) {
                        bmiData.push(vitalData.bmi[i]);
                    }
                }
            }

            var set1 = [{x:60,y:11.9},{x:66,y:11.9},{x:72,y:12},{x:78,y:12.1},{x:84,y:12.1},{x:90,y:12.2},{x:96,y:12.3},{x:102,y:12.3},
                        {x:108,y:12.4},{x:114,y:12.5},{x:120,y:12.7},{x:126,y:12.8},{x:132,y:13},{x:138,y:13.2},
                        {x:144,y:13.4},{x:150,y:13.7},{x:156,y:13.9},{x:162,y:14.1},{x:168,y:14.3},{x:174,y:14.5},
                        {x:180,y:14.7},{x:186,y:14.9},{x:192,y:15},{x:198,y:15.2},{x:204,y:15.4},{x:210,y:15.5},{x:216,y:15.7}];

            var set2 = [{x:60,y:12.1},{x:66,y:12.2},{x:72,y:12.2},{x:78,y:12.3},{x:84,y:12.4},{x:90,y:12.5},{x:96,y:12.6},{x:102,y:12.7},
                        {x:108,y:12.8},{x:114,y:12.9},{x:120,y:13.1},{x:126,y:13.2},{x:132,y:13.4},{x:138,y:13.7},
                        {x:144,y:13.9},{x:150,y:14.2},{x:156,y:14.4},{x:162,y:14.6},{x:168,y:14.9},{x:174,y:15.1},
                        {x:180,y:15.2},{x:186,y:15.4},{x:192,y:15.6},{x:198,y:15.8},{x:204,y:16},{x:210,y:16.1},{x:216,y:16.3}];
                    
            var set3 = [{x:60,y:12.5},{x:66,y:12.6},{x:72,y:12.7},{x:78,y:12.8},{x:84,y:12.8},{x:90,y:12.9},{x:96,y:13.1},{x:102,y:13.2},
                        {x:108,y:13.3},{x:114,y:13.5},{x:120,y:13.7},{x:126,y:13.9},{x:132,y:14.1},{x:138,y:14.4},
                        {x:144,y:14.7},{x:150,y:15},{x:156,y:15.2},{x:162,y:15.5},{x:168,y:15.7},{x:174,y:16},
                        {x:180,y:16.1},{x:186,y:16.3},{x:192,y:16.5},{x:198,y:16.7},{x:204,y:16.9},{x:210,y:17.1},{x:216,y:17.3}];

            var set4 = [{x:60,y:13.3},{x:66,y:13.4},{x:72,y:13.5},{x:78,y:13.6},{x:84,y:13.7},{x:90,y:13.9},{x:96,y:14},{x:102,y:14.2},
                        {x:108,y:14.4},{x:114,y:14.6},{x:120,y:14.9},{x:126,y:15.2},{x:132,y:15.5},{x:138,y:15.8},
                        {x:144,y:16.1},{x:150,y:16.5},{x:156,y:16.8},{x:162,y:17.1},{x:168,y:17.3},{x:174,y:17.6},
                        {x:180,y:17.8},{x:186,y:18},{x:192,y:18.2},{x:198,y:18.4},{x:204,y:18.6},{x:210,y:18.7},{x:216,y:18.9}];

            var set5 = [{x:60,y:14.3},{x:66,y:14.4},{x:72,y:14.5},{x:78,y:14.7},{x:84,y:14.9},{x:90,y:15.1},{x:96,y:15.3},{x:102,y:15.6},
                        {x:108,y:15.8},{x:114,y:16.1},{x:120,y:16.5},{x:126,y:16.8},{x:132,y:17.2},{x:138,y:17.6},
                        {x:144,y:18},{x:150,y:18.4},{x:156,y:18.8},{x:162,y:19.1},{x:168,y:19.4},{x:174,y:19.7},
                        {x:180,y:19.9},{x:186,y:20.1},{x:192,y:20.3},{x:198,y:20.4},{x:204,y:20.6},{x:210,y:20.8},{x:216,y:21}];

            var set6 = [{x:60,y:15.5},{x:66,y:15.7},{x:72,y:15.9},{x:78,y:16.1},{x:84,y:16.4},{x:90,y:16.6},{x:96,y:16.9},{x:102,y:17.2},
                        {x:108,y:17.6},{x:114,y:18},{x:120,y:18.4},{x:126,y:18.8},{x:132,y:19.3},{x:138,y:19.8},
                        {x:144,y:20.2},{x:150,y:20.7},{x:156,y:21.1},{x:162,y:21.5},{x:168,y:21.8},{x:174,y:22},
                        {x:180,y:22.3},{x:186,y:22.4},{x:192,y:22.6},{x:198,y:22.8},{x:204,y:22.9},{x:210,y:23.1},{x:216,y:23.2}];

            var set7 = [{x:60,y:18},{x:66,y:18.3},{x:72,y:18.6},{x:78,y:18.9},{x:84,y:19.3},{x:90,y:19.7},{x:96,y:20.1},{x:102,y:20.5},
                        {x:108,y:21},{x:114,y:21.4},{x:120,y:21.9},{x:126,y:22.5},{x:132,y:23},{x:138,y:23.6},
                        {x:144,y:24.1},{x:150,y:24.7},{x:156,y:25.2},{x:162,y:25.6},{x:168,y:25.9},{x:174,y:26.2},
                        {x:180,y:26.3},{x:186,y:26.4},{x:192,y:26.5},{x:198,y:26.6},{x:204,y:26.7},{x:210,y:26.7},{x:216,y:26.8}];
            

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([bmiData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            gEnter.append('g').attr('class', 'lines');
            gEnter.append('g').attr('class', 'point-clips');
            gEnter.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([10,35]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([10,35]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 +.1 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
    return d/12 % 1 ? d/12 +.1 : d/12;
  }).innerTickSize(-height)
                            .outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(26).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(26).innerTickSize(-width)
                            .outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };
            
            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString())	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -30 )
                .style("text-anchor", "middle")
                .text("IAP Girls BMI Chart 5 - 18 years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height - 30)
                .attr("transform", "translate(-980,900) rotate(-90)")
                .style("text-anchor", "middle")
                // .style("font-size","10px")
                .text("Reviesed IAP growth charts for height, weight & body mass index for 5 to 18 year old indian children.");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height - 25)
                .attr("transform", "translate(-970,900) rotate(-90)")
                .style("text-anchor", "middle")
                // .style("font-size","10px")
                .text("V.Khadilkar et al. from Indian Academy of Pediatrics Growth Chart Committee Indian Pediatrics. Jan 2015, volume 52");

            svg.append("text")
                .attr("x", 690 )
                .attr("y", 735 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 710 )
                .style("text-anchor", "start")
                .text("5");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 680 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 615 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 540 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 350 )
                .attr("y", 610 )
                .attr("transform", "rotate(-15)")
                .style("text-anchor", "start")
                .text("23 Adult equivalent (Overweight)");
            
            svg.append("text")
                .attr("x", 450 )
                .attr("y", 420 )
                .attr("transform", "rotate(-10)")
                .style("text-anchor", "start")
                .text("27 Adult equivalent (Obesity)");
               
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "orange",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(bmiData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    }
});
'use strict';
angular.module('AngularApp').directive('postnatalWeightChartFemalePrint', function() {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:4%;' viewBox='0 0 1010 960'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 980 - margin.left - margin.right;

            var weightData = [];

            if(vitalData.postnatalWeight) {
                for(var i = 0; i < vitalData.postnatalWeight.length; i++){
                    if(vitalData.postnatalWeight[i].y<10.5 && vitalData.postnatalWeight[i].y>0) {
                        weightData.push(vitalData.postnatalWeight[i]);
                    }
                }
            }

            var set1 = [{x:27,y:0.41},{x:28,y:0.52},{x:29,y:0.64},{x:30,y:0.77},{x:31,y:0.91},{x:32,y:1.06},{x:33,y:1.22},{x:34,y:1.38},{x:35,y:1.55},{x:36,y:1.72},{x:37,y:1.89},{x:38,y:2.06},{x:39,y:2.23},{x:40,y:2.41},{x:41,y:2.58},{x:42,y:2.75},{x:43,y:2.91},{x:44,y:3.08},{x:45,y:3.24},{x:46,y:3.4},{x:47,y:3.55},{x:48,y:3.7},{x:49,y:3.85},{x:50,y:3.99},{x:51,y:4.13},{x:52,y:4.26},{x:53,y:4.4},{x:54,y:4.52},{x:55,y:4.64},{x:56,y:4.76},{x:57,y:4.88},{x:58,y:4.99},{x:59,y:5.1},{x:60,y:5.2},{x:61,y:5.3},{x:62,y:5.4},{x:63,y:5.49},{x:64,y:5.58}];

            var set2 = [{x:27,y:0.47},{x:28,y:0.59},{x:29,y:0.72},{x:30,y:0.86},{x:31,y:1.01},{x:32,y:1.18},{x:33,y:1.34},{x:34,y:1.52},{x:35,y:1.7},{x:36,y:1.88},{x:37,y:2.06},{x:38,y:2.25},{x:39,y:2.43},{x:40,y:2.62},{x:41,y:2.8},{x:42,y:2.98},{x:43,y:3.16},{x:44,y:3.34},{x:45,y:3.51},{x:46,y:3.68},{x:47,y:3.84},{x:48,y:4.01},{x:49,y:4.16},{x:50,y:4.32},{x:51,y:4.46},{x:52,y:4.61},{x:53,y:4.75},{x:54,y:4.89},{x:55,y:5.02},{x:56,y:5.15},{x:57,y:5.27},{x:58,y:5.39},{x:59,y:5.51},{x:60,y:5.62},{x:61,y:5.73},{x:62,y:5.83},{x:63,y:5.93},{x:64,y:6.03}];

            var set3 = [{x:27,y:0.61},{x:28,y:0.76},{x:29,y:0.91},{x:30,y:1.09},{x:31,y:1.27},{x:32,y:1.46},{x:33,y:1.65},{x:34,y:1.86},{x:35,y:2.07},{x:36,y:2.28},{x:37,y:2.49},{x:38,y:2.71},{x:39,y:2.92},{x:40,y:3.13},{x:41,y:3.35},{x:42,y:3.55},{x:43,y:3.76},{x:44,y:3.96},{x:45,y:4.16},{x:46,y:4.36},{x:47,y:4.55},{x:48,y:4.74},{x:49,y:4.92},{x:50,y:5.1},{x:51,y:5.27},{x:52,y:5.44},{x:53,y:5.6},{x:54,y:5.76},{x:55,y:5.92},{x:56,y:6.07},{x:57,y:6.21},{x:58,y:6.35},{x:59,y:6.49},{x:60,y:6.62},{x:61,y:6.75},{x:62,y:6.87},{x:63,y:6.99},{x:64,y:7.11}];

            var set4 = [{x:27,y:0.8},{x:28,y:0.97},{x:29,y:1.16},{x:30,y:1.37},{x:31,y:1.58},{x:32,y:1.8},{x:33,y:2.03},{x:34,y:2.27},{x:35,y:2.51},{x:36,y:2.76},{x:37,y:3.01},{x:38,y:3.26},{x:39,y:3.5},{x:40,y:3.75},{x:41,y:3.99},{x:42,y:4.24},{x:43,y:4.48},{x:44,y:4.71},{x:45,y:4.94},{x:46,y:5.17},{x:47,y:5.39},{x:48,y:5.61},{x:49,y:5.82},{x:50,y:6.02},{x:51,y:6.22},{x:52,y:6.42},{x:53,y:6.61},{x:54,y:6.8},{x:55,y:6.98},{x:56,y:7.15},{x:57,y:7.32},{x:58,y:7.49},{x:59,y:7.65},{x:60,y:7.8},{x:61,y:7.95},{x:62,y:8.1},{x:63,y:8.24},{x:64,y:8.38}];

            var set5 = [{x:27,y:0.91},{x:28,y:1.1},{x:29,y:1.3},{x:30,y:1.52},{x:31,y:1.75},{x:32,y:1.99},{x:33,y:2.24},{x:34,y:2.5},{x:35,y:2.76},{x:36,y:3.02},{x:37,y:3.29},{x:38,y:3.55},{x:39,y:3.82},{x:40,y:4.08},{x:41,y:4.34},{x:42,y:4.6},{x:43,y:4.85},{x:44,y:5.11},{x:45,y:5.35},{x:46,y:5.6},{x:47,y:5.83},{x:48,y:6.06},{x:49,y:6.29},{x:50,y:6.51},{x:51,y:6.73},{x:52,y:6.94},{x:53,y:7.14},{x:54,y:7.34},{x:55,y:7.54},{x:56,y:7.73},{x:57,y:7.91},{x:58,y:8.09},{x:59,y:8.26},{x:60,y:8.43},{x:61,y:8.59},{x:62,y:8.75},{x:63,y:8.9},{x:64,y:9.05}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([64,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([64,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0.0,10.5, 0.2)).tickFormat(function(d){
                return d;
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0.0, 10.5, 0.2)).tickFormat(function(d){
                return d;
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Postmenstrual age (Weeks)");

            svg.append("text")
                .attr("x", 30 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("© University of Oxford");

            svg.append("text")
                .attr("x", 750 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("Villar et al. Lancet Glob Health 2015;3:e681-91");

            svg.append("text")
                .attr("x", -450 )
                .attr("y", -35)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (Kg)");
            
            svg.append("text")
                .attr("x", -450 )
                .attr("y", 880)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (Kg)");
            
                svg.append("text")
                .attr("x", 790 )
                .attr("y", 450 )
                .style("text-anchor", "start")
                .text("3rd");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 405 )
                .style("text-anchor", "start")
                .text("10th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 310 )
                .style("text-anchor", "start")
                .text("50th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 200 )
                .style("text-anchor", "start")
                .text("90th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 130 )
                .style("text-anchor", "start")
                .text("97th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('postnatalWeightChartMalePrint', function() {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:4%;' viewBox='0 0 1010 960'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 980 - margin.left - margin.right;

            var weightData = [];

            if(vitalData.postnatalWeight) {
                for(var i = 0; i < vitalData.postnatalWeight.length; i++){
                    if(vitalData.postnatalWeight[i].y<10.5 && vitalData.postnatalWeight[i].y>0) {
                        weightData.push(vitalData.postnatalWeight[i]);
                    }
                }
            }

            var set1 = [{x:27,y:0.45},{x:28,y:0.57},{x:29,y:0.7},{x:30,y:0.85},{x:31,y:1},{x:32,y:1.17},{x:33,y:1.34},{x:34,y:1.51},{x:35,y:1.7},{x:36,y:1.88},{x:37,y:2.07},{x:38,y:2.26},{x:39,y:2.45},{x:40,y:2.64},{x:41,y:2.82},{x:42,y:3.01},{x:43,y:3.19},{x:44,y:3.37},{x:45,y:3.55},{x:46,y:3.72},{x:47,y:3.89},{x:48,y:4.06},{x:49,y:4.22},{x:50,y:4.37},{x:51,y:4.52},{x:52,y:4.67},{x:53,y:4.81},{x:54,y:4.95},{x:55,y:5.09},{x:56,y:5.22},{x:57,y:5.34},{x:58,y:5.47},{x:59,y:5.58},{x:60,y:5.7},{x:61,y:5.81},{x:62,y:5.92},{x:63,y:6.02},{x:64,y:6.12}];

            var set2 = [{x:27,y:0.51},{x:28,y:0.64},{x:29,y:0.79},{x:30,y:0.94},{x:31,y:1.11},{x:32,y:1.29},{x:33,y:1.47},{x:34,y:1.66},{x:35,y:1.86},{x:36,y:2.06},{x:37,y:2.26},{x:38,y:2.46},{x:39,y:2.67},{x:40,y:2.87},{x:41,y:3.07},{x:42,y:3.27},{x:43,y:3.46},{x:44,y:3.66},{x:45,y:3.84},{x:46,y:4.03},{x:47,y:4.21},{x:48,y:4.39},{x:49,y:4.56},{x:50,y:4.73},{x:51,y:4.89},{x:52,y:5.05},{x:53,y:5.2},{x:54,y:5.35},{x:55,y:5.5},{x:56,y:5.64},{x:57,y:5.77},{x:58,y:5.9},{x:59,y:6.03},{x:60,y:6.15},{x:61,y:6.27},{x:62,y:6.39},{x:63,y:6.5},{x:64,y:6.61}];

            var set3 = [{x:27,y:0.67},{x:28,y:0.83},{x:29,y:1},{x:30,y:1.19},{x:31,y:1.39},{x:32,y:1.6},{x:33,y:1.81},{x:34,y:2.04},{x:35,y:2.26},{x:36,y:2.5},{x:37,y:2.73},{x:38,y:2.96},{x:39,y:3.2},{x:40,y:3.43},{x:41,y:3.66},{x:42,y:3.89},{x:43,y:4.12},{x:44,y:4.34},{x:45,y:4.56},{x:46,y:4.78},{x:47,y:4.99},{x:48,y:5.19},{x:49,y:5.39},{x:50,y:5.59},{x:51,y:5.77},{x:52,y:5.96},{x:53,y:6.14},{x:54,y:6.31},{x:55,y:6.48},{x:56,y:6.65},{x:57,y:6.8},{x:58,y:6.96},{x:59,y:7.11},{x:60,y:7.25},{x:61,y:7.39},{x:62,y:7.53},{x:63,y:7.66},{x:64,y:7.79}];

            var set4 = [{x:27,y:0.88},{x:28,y:1.07},{x:29,y:1.27},{x:30,y:1.5},{x:31,y:1.73},{x:32,y:1.98},{x:33,y:2.23},{x:34,y:2.49},{x:35,y:2.75},{x:36,y:3.02},{x:37,y:3.29},{x:38,y:3.57},{x:39,y:3.84},{x:40,y:4.11},{x:41,y:4.38},{x:42,y:4.64},{x:43,y:4.9},{x:44,y:5.16},{x:45,y:5.41},{x:46,y:5.66},{x:47,y:5.9},{x:48,y:6.14},{x:49,y:6.37},{x:50,y:6.6},{x:51,y:6.82},{x:52,y:7.03},{x:53,y:7.24},{x:54,y:7.45},{x:55,y:7.64},{x:56,y:7.83},{x:57,y:8.02},{x:58,y:8.2},{x:59,y:8.38},{x:60,y:8.55},{x:61,y:8.71},{x:62,y:8.87},{x:63,y:9.03},{x:64,y:9.18}];

            var set5 = [{x:27,y:0.99},{x:28,y:1.2},{x:29,y:1.43},{x:30,y:1.67},{x:31,y:1.92},{x:32,y:2.18},{x:33,y:2.46},{x:34,y:2.74},{x:35,y:3.02},{x:36,y:3.31},{x:37,y:3.6},{x:38,y:3.89},{x:39,y:4.18},{x:40,y:4.47},{x:41,y:4.76},{x:42,y:5.04},{x:43,y:5.32},{x:44,y:5.59},{x:45,y:5.86},{x:46,y:6.13},{x:47,y:6.39},{x:48,y:6.64},{x:49,y:6.89},{x:50,y:7.13},{x:51,y:7.37},{x:52,y:7.6},{x:53,y:7.83},{x:54,y:8.04},{x:55,y:8.26},{x:56,y:8.46},{x:57,y:8.66},{x:58,y:8.86},{x:59,y:9.05},{x:60,y:9.23},{x:61,y:9.41},{x:62,y:9.58},{x:63,y:9.75},{x:64,y:9.91}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([64,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([64,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0.0,10.5, 0.2)).tickFormat(function(d){
                return d;
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0.0, 10.5, 0.2)).tickFormat(function(d){
                return d;
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Postmenstrual age (Weeks)");

            svg.append("text")
                .attr("x", 30 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("© University of Oxford");

            svg.append("text")
                .attr("x", 750 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("Villar et al. Lancet Glob Health 2015;3:e681-91");

            svg.append("text")
                .attr("x", -450 )
                .attr("y", -35)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (Kg)");
            
            svg.append("text")
                .attr("x", -450 )
                .attr("y", 880)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (Kg)");
            
                svg.append("text")
                .attr("x", 790 )
                .attr("y", 400 )
                .style("text-anchor", "start")
                .text("3rd");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 350 )
                .style("text-anchor", "start")
                .text("10th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 250 )
                .style("text-anchor", "start")
                .text("50th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 125 )
                .style("text-anchor", "start")
                .text("90th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 55 )
                .style("text-anchor", "start")
                .text("97th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('weightForHeightLengthFemalePrint', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%; padding-top:4%;' viewBox='0 0 1010 960'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 980 - margin.left - margin.right;

            var heightweightData = [];

            if(vitalData.hwData) {
                for(var i = 0; i < vitalData.hwData.length; i++){
                    if(vitalData.hwData[i].x<111 && vitalData.hwData[i].x>44) {
                        if(vitalData.hwData[i].y<28 && vitalData.hwData[i].y>0) {
                            heightweightData.push(vitalData.hwData[i]);
                        }
                    }
                }
            }

            var set1 = [{x:45,y:2},{x:45.5,y:2.1},{x:46,y:2.1},{x:46.5,y:2.2},{x:47,y:2.3},{x:47.5,y:2.4},{x:48,y:2.4},{x:48.5,y:2.5},{x:49,y:2.6},{x:49.5,y:2.7},{x:50,y:2.7},{x:50.5,y:2.8},{x:51,y:2.9},{x:51.5,y:3},{x:52,y:3.1},{x:52.5,y:3.2},{x:53,y:3.3},{x:53.5,y:3.4},{x:54,y:3.5},{x:54.5,y:3.6},{x:55,y:3.7},{x:55.5,y:3.8},{x:56,y:3.9},{x:56.5,y:4},{x:57,y:4.1},{x:57.5,y:4.3},{x:58,y:4.4},{x:58.5,y:4.5},{x:59,y:4.6},{x:59.5,y:4.7},{x:60,y:4.8},{x:60.5,y:4.9},{x:61,y:5},{x:61.5,y:5.1},{x:62,y:5.2},{x:62.5,y:5.3},{x:63,y:5.4},{x:63.5,y:5.5},{x:64,y:5.6},{x:64.5,y:5.7},{x:65,y:5.9},{x:65.5,y:6},{x:66,y:6.1},{x:66.5,y:6.2},{x:67,y:6.3},{x:67.5,y:6.4},{x:68,y:6.4},{x:68.5,y:6.5},{x:69,y:6.6},{x:69.5,y:6.7},{x:70,y:6.8},{x:70.5,y:6.9},{x:71,y:6.9},{x:71.5,y:7},{x:72,y:7.1},{x:72.5,y:7.2},{x:73,y:7.3},{x:73.5,y:7.4},{x:74,y:7.4},{x:74.5,y:7.5},{x:75,y:7.6},{x:75.5,y:7.7},{x:76,y:7.7},{x:76.5,y:7.8},{x:77,y:7.9},{x:77.5,y:8},{x:78,y:8},{x:78.5,y:8.1},{x:79,y:8.2},{x:79.5,y:8.3},{x:80,y:8.4},{x:80.5,y:8.5},{x:81,y:8.6},{x:81.5,y:8.6},{x:82,y:8.7},{x:82.5,y:8.8},{x:83,y:8.9},{x:83.5,y:9},{x:84,y:9.1},{x:84.5,y:9.2},{x:85,y:9.3},{x:85.5,y:9.4},{x:86,y:9.5},{x:86.5,y:9.6},{x:87,y:9.7},{x:87.5,y:9.9},{x:88,y:10},{x:88.5,y:10.1},{x:89,y:10.2},{x:89.5,y:10.3},{x:90,y:10.4},{x:90.5,y:10.5},{x:91,y:10.6},{x:91.5,y:10.7},{x:92,y:10.8},{x:92.5,y:10.9},{x:93,y:11},{x:93.5,y:11.1},{x:94,y:11.2},{x:94.5,y:11.3},{x:95,y:11.4},{x:95.5,y:11.5},{x:96,y:11.6},{x:96.5,y:11.7},{x:97,y:11.8},{x:97.5,y:11.9},{x:98,y:12},{x:98.5,y:12.1},{x:99,y:12.2},{x:99.5,y:12.3},{x:100,y:12.4},{x:100.5,y:12.5},{x:101,y:12.7},{x:101.5,y:12.8},{x:102,y:12.9},{x:102.5,y:13},{x:103,y:13.1},{x:103.5,y:13.3},{x:104,y:13.4},{x:104.5,y:13.5},{x:105,y:13.6},{x:105.5,y:13.8},{x:106,y:13.9},{x:106.5,y:14.1},{x:107,y:14.2},{x:107.5,y:14.3},{x:108,y:14.5},{x:108.5,y:14.6},{x:109,y:14.8},{x:109.5,y:14.9},{x:110,y:15.1}];

            var set2 = [{x:45,y:2.1},{x:45.5,y:2.2},{x:46,y:2.2},{x:46.5,y:2.3},{x:47,y:2.4},{x:47.5,y:2.4},{x:48,y:2.5},{x:48.5,y:2.6},{x:49,y:2.7},{x:49.5,y:2.8},{x:50,y:2.8},{x:50.5,y:2.9},{x:51,y:3},{x:51.5,y:3.1},{x:52,y:3.2},{x:52.5,y:3.3},{x:53,y:3.4},{x:53.5,y:3.5},{x:54,y:3.6},{x:54.5,y:3.7},{x:55,y:3.9},{x:55.5,y:4},{x:56,y:4.1},{x:56.5,y:4.2},{x:57,y:4.3},{x:57.5,y:4.4},{x:58,y:4.5},{x:58.5,y:4.6},{x:59,y:4.8},{x:59.5,y:4.9},{x:60,y:5},{x:60.5,y:5.1},{x:61,y:5.2},{x:61.5,y:5.3},{x:62,y:5.4},{x:62.5,y:5.5},{x:63,y:5.6},{x:63.5,y:5.7},{x:64,y:5.8},{x:64.5,y:5.9},{x:65,y:6.1},{x:65.5,y:6.2},{x:66,y:6.3},{x:66.5,y:6.4},{x:67,y:6.5},{x:67.5,y:6.6},{x:68,y:6.7},{x:68.5,y:6.8},{x:69,y:6.9},{x:69.5,y:7},{x:70,y:7},{x:70.5,y:7.1},{x:71,y:7.2},{x:71.5,y:7.3},{x:72,y:7.4},{x:72.5,y:7.5},{x:73,y:7.6},{x:73.5,y:7.6},{x:74,y:7.7},{x:74.5,y:7.8},{x:75,y:7.9},{x:75.5,y:8},{x:76,y:8},{x:76.5,y:8.1},{x:77,y:8.2},{x:77.5,y:8.3},{x:78,y:8.4},{x:78.5,y:8.4},{x:79,y:8.5},{x:79.5,y:8.6},{x:80,y:8.7},{x:80.5,y:8.8},{x:81,y:8.9},{x:81.5,y:9},{x:82,y:9.1},{x:82.5,y:9.2},{x:83,y:9.3},{x:83.5,y:9.4},{x:84,y:9.5},{x:84.5,y:9.6},{x:85,y:9.7},{x:85.5,y:9.8},{x:86,y:9.9},{x:86.5,y:10},{x:87,y:10.1},{x:87.5,y:10.2},{x:88,y:10.3},{x:88.5,y:10.4},{x:89,y:10.5},{x:89.5,y:10.6},{x:90,y:10.8},{x:90.5,y:10.9},{x:91,y:11},{x:91.5,y:11.1},{x:92,y:11.2},{x:92.5,y:11.3},{x:93,y:11.4},{x:93.5,y:11.5},{x:94,y:11.6},{x:94.5,y:11.7},{x:95,y:11.8},{x:95.5,y:11.9},{x:96,y:12},{x:96.5,y:12.1},{x:97,y:12.2},{x:97.5,y:12.3},{x:98,y:12.4},{x:98.5,y:12.6},{x:99,y:12.7},{x:99.5,y:12.8},{x:100,y:12.9},{x:100.5,y:13},{x:101,y:13.1},{x:101.5,y:13.3},{x:102,y:13.4},{x:102.5,y:13.5},{x:103,y:13.6},{x:103.5,y:13.8},{x:104,y:13.9},{x:104.5,y:14},{x:105,y:14.2},{x:105.5,y:14.3},{x:106,y:14.5},{x:106.5,y:14.6},{x:107,y:14.7},{x:107.5,y:14.9},{x:108,y:15},{x:108.5,y:15.2},{x:109,y:15.4},{x:109.5,y:15.5},{x:110,y:15.7}];

            var set3 = [{x:45,y:2.5},{x:45.5,y:2.5},{x:46,y:2.6},{x:46.5,y:2.7},{x:47,y:2.8},{x:47.5,y:2.9},{x:48,y:3},{x:48.5,y:3.1},{x:49,y:3.2},{x:49.5,y:3.3},{x:50,y:3.4},{x:50.5,y:3.5},{x:51,y:3.6},{x:51.5,y:3.7},{x:52,y:3.8},{x:52.5,y:3.9},{x:53,y:4},{x:53.5,y:4.2},{x:54,y:4.3},{x:54.5,y:4.4},{x:55,y:4.5},{x:55.5,y:4.7},{x:56,y:4.8},{x:56.5,y:5},{x:57,y:5.1},{x:57.5,y:5.2},{x:58,y:5.4},{x:58.5,y:5.5},{x:59,y:5.6},{x:59.5,y:5.7},{x:60,y:5.9},{x:60.5,y:6},{x:61,y:6.1},{x:61.5,y:6.3},{x:62,y:6.4},{x:62.5,y:6.5},{x:63,y:6.6},{x:63.5,y:6.7},{x:64,y:6.9},{x:64.5,y:7},{x:65,y:7.2},{x:65.5,y:7.4},{x:66,y:7.5},{x:66.5,y:7.6},{x:67,y:7.7},{x:67.5,y:7.8},{x:68,y:7.9},{x:68.5,y:8},{x:69,y:8.1},{x:69.5,y:8.2},{x:70,y:8.3},{x:70.5,y:8.4},{x:71,y:8.5},{x:71.5,y:8.6},{x:72,y:8.7},{x:72.5,y:8.8},{x:73,y:8.9},{x:73.5,y:9},{x:74,y:9.1},{x:74.5,y:9.2},{x:75,y:9.3},{x:75.5,y:9.4},{x:76,y:9.5},{x:76.5,y:9.6},{x:77,y:9.6},{x:77.5,y:9.7},{x:78,y:9.8},{x:78.5,y:9.9},{x:79,y:10},{x:79.5,y:10.1},{x:80,y:10.2},{x:80.5,y:10.3},{x:81,y:10.4},{x:81.5,y:10.6},{x:82,y:10.7},{x:82.5,y:10.8},{x:83,y:10.9},{x:83.5,y:11},{x:84,y:11.1},{x:84.5,y:11.3},{x:85,y:11.4},{x:85.5,y:11.5},{x:86,y:11.6},{x:86.5,y:11.8},{x:87,y:11.9},{x:87.5,y:12},{x:88,y:12.1},{x:88.5,y:12.3},{x:89,y:12.4},{x:89.5,y:12.5},{x:90,y:12.6},{x:90.5,y:12.8},{x:91,y:12.9},{x:91.5,y:13},{x:92,y:13.1},{x:92.5,y:13.3},{x:93,y:13.4},{x:93.5,y:13.5},{x:94,y:13.6},{x:94.5,y:13.8},{x:95,y:13.9},{x:95.5,y:14},{x:96,y:14.1},{x:96.5,y:14.3},{x:97,y:14.4},{x:97.5,y:14.5},{x:98,y:14.7},{x:98.5,y:14.8},{x:99,y:14.9},{x:99.5,y:15.1},{x:100,y:15.2},{x:100.5,y:15.4},{x:101,y:15.5},{x:101.5,y:15.7},{x:102,y:15.8},{x:102.5,y:16},{x:103,y:16.1},{x:103.5,y:16.3},{x:104,y:16.4},{x:104.5,y:16.6},{x:105,y:16.8},{x:105.5,y:16.9},{x:106,y:17.1},{x:106.5,y:17.3},{x:107,y:17.5},{x:107.5,y:17.7},{x:108,y:17.8},{x:108.5,y:18},{x:109,y:18.2},{x:109.5,y:18.4},{x:110,y:18.6}];

            var set4 = [{x:45,y:3.1},{x:45.5,y:3.2},{x:46,y:3.3},{x:46.5,y:3.4},{x:47,y:3.5},{x:47.5,y:3.6},{x:48,y:3.7},{x:48.5,y:3.8},{x:49,y:3.9},{x:49.5,y:4.1},{x:50,y:4.2},{x:50.5,y:4.3},{x:51,y:4.4},{x:51.5,y:4.6},{x:52,y:4.7},{x:52.5,y:4.9},{x:53,y:5},{x:53.5,y:5.2},{x:54,y:5.3},{x:54.5,y:5.5},{x:55,y:5.7},{x:55.5,y:5.8},{x:56,y:6},{x:56.5,y:6.2},{x:57,y:6.3},{x:57.5,y:6.5},{x:58,y:6.7},{x:58.5,y:6.8},{x:59,y:7},{x:59.5,y:7.2},{x:60,y:7.3},{x:60.5,y:7.5},{x:61,y:7.6},{x:61.5,y:7.8},{x:62,y:8},{x:62.5,y:8.1},{x:63,y:8.3},{x:63.5,y:8.4},{x:64,y:8.5},{x:64.5,y:8.7},{x:65,y:9},{x:65.5,y:9.2},{x:66,y:9.3},{x:66.5,y:9.4},{x:67,y:9.6},{x:67.5,y:9.7},{x:68,y:9.8},{x:68.5,y:10},{x:69,y:10.1},{x:69.5,y:10.2},{x:70,y:10.3},{x:70.5,y:10.5},{x:71,y:10.6},{x:71.5,y:10.7},{x:72,y:10.8},{x:72.5,y:11},{x:73,y:11.1},{x:73.5,y:11.2},{x:74,y:11.3},{x:74.5,y:11.4},{x:75,y:11.5},{x:75.5,y:11.7},{x:76,y:11.8},{x:76.5,y:11.9},{x:77,y:12},{x:77.5,y:12.1},{x:78,y:12.2},{x:78.5,y:12.3},{x:79,y:12.5},{x:79.5,y:12.6},{x:80,y:12.7},{x:80.5,y:12.8},{x:81,y:13},{x:81.5,y:13.1},{x:82,y:13.2},{x:82.5,y:13.4},{x:83,y:13.5},{x:83.5,y:13.7},{x:84,y:13.8},{x:84.5,y:14},{x:85,y:14.1},{x:85.5,y:14.3},{x:86,y:14.4},{x:86.5,y:14.6},{x:87,y:14.8},{x:87.5,y:14.9},{x:88,y:15.1},{x:88.5,y:15.2},{x:89,y:15.4},{x:89.5,y:15.5},{x:90,y:15.7},{x:90.5,y:15.9},{x:91,y:16},{x:91.5,y:16.2},{x:92,y:16.3},{x:92.5,y:16.5},{x:93,y:16.6},{x:93.5,y:16.8},{x:94,y:16.9},{x:94.5,y:17.1},{x:95,y:17.3},{x:95.5,y:17.4},{x:96,y:17.6},{x:96.5,y:17.8},{x:97,y:17.9},{x:97.5,y:18.1},{x:98,y:18.3},{x:98.5,y:18.4},{x:99,y:18.6},{x:99.5,y:18.8},{x:100,y:19},{x:100.5,y:19.2},{x:101,y:19.4},{x:101.5,y:19.5},{x:102,y:19.7},{x:102.5,y:19.9},{x:103,y:20.2},{x:103.5,y:20.4},{x:104,y:20.6},{x:104.5,y:20.8},{x:105,y:21},{x:105.5,y:21.2},{x:106,y:21.4},{x:106.5,y:21.7},{x:107,y:21.9},{x:107.5,y:22.1},{x:108,y:22.4},{x:108.5,y:22.6},{x:109,y:22.9},{x:109.5,y:23.1},{x:110,y:23.4}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightweightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([110,45]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([110,45]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,26.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,26.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(45, 111, 2)).tickFormat(function(d){
				return d%2==0? '' : d;
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(45, 111, 2)).tickFormat(function(d){
                return d%2==0? '' : d;
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 26.5, 0.5)).tickFormat(function(d){
                return d%0.5==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 26.5, 0.5)).tickFormat(function(d){
                return d%0.5==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " cm<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -40 )
                .style("text-anchor", "middle")
                .text("WHO Girls Weight for Height/Length");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Length (cm)");

                svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 50 )
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("Ref: IAP Growth Charts. Indian Academy of Pediatrics. [updated 2013 18 Oct, cited 2016 14 Jan] Available from: http://www.iapindia.org/page.php?id=79");
            
            svg.append("text")
                .attr("x", -350 )
                .attr("y", -35)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("WHO MGRS 2006 Charts; Acta Paediatrics Suppl. 450:2006");

            svg.append("text")
                .attr("x", -490 )
                .attr("y", 900)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight (kgs)");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 410 )
                .style("text-anchor", "start")
                .text("1(-3)");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 390 )
                .style("text-anchor", "start")
                .text("3(-2)");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 290 )
                .style("text-anchor", "start")
                .text("50(0)");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 115 )
                .style("text-anchor", "start")
                .text("99(+3)");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "yellow",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightweightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('weightForHeightLengthMalePrint', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%; padding-top:4%;' viewBox='0 0 1010 960'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 980 - margin.left - margin.right;

            var heightweightData = [];

            if(vitalData.hwData) {
                for(var i = 0; i < vitalData.hwData.length; i++){
                    if(vitalData.hwData[i].x<111 && vitalData.hwData[i].x>44) {
                        if(vitalData.hwData[i].y<28 && vitalData.hwData[i].y>0) {
                            heightweightData.push(vitalData.hwData[i]);
                        }
                    }
                }
            }

            var set1 = [{x:45,y:2},{x:45.5,y:2.1},{x:46,y:2.1},{x:46.5,y:2.2},{x:47,y:2.3},{x:47.5,y:2.3},{x:48,y:2.4},{x:48.5,y:2.5},{x:49,y:2.6},{x:49.5,y:2.6},{x:50,y:2.7},{x:50.5,y:2.8},{x:51,y:2.9},{x:51.5,y:3},{x:52,y:3.1},{x:52.5,y:3.2},{x:53,y:3.3},{x:53.5,y:3.4},{x:54,y:3.5},{x:54.5,y:3.6},{x:55,y:3.7},{x:55.5,y:3.9},{x:56,y:4},{x:56.5,y:4.1},{x:57,y:4.2},{x:57.5,y:4.4},{x:58,y:4.5},{x:58.5,y:4.6},{x:59,y:4.7},{x:59.5,y:4.8},{x:60,y:5},{x:60.5,y:5.1},{x:61,y:5.2},{x:61.5,y:5.3},{x:62,y:5.4},{x:62.5,y:5.5},{x:63,y:5.6},{x:63.5,y:5.7},{x:64,y:5.8},{x:64.5,y:5.9},{x:65,y:6.2},{x:65.5,y:6.3},{x:66,y:6.4},{x:66.5,y:6.5},{x:67,y:6.6},{x:67.5,y:6.7},{x:68,y:6.8},{x:68.5,y:6.8},{x:69,y:6.9},{x:69.5,y:7},{x:70,y:7.1},{x:70.5,y:7.2},{x:71,y:7.3},{x:71.5,y:7.4},{x:72,y:7.5},{x:72.5,y:7.6},{x:73,y:7.7},{x:73.5,y:7.8},{x:74,y:7.8},{x:74.5,y:7.9},{x:75,y:8},{x:75.5,y:8.1},{x:76,y:8.2},{x:76.5,y:8.2},{x:77,y:8.3},{x:77.5,y:8.4},{x:78,y:8.5},{x:78.5,y:8.5},{x:79,y:8.6},{x:79.5,y:8.7},{x:80,y:8.8},{x:80.5,y:8.9},{x:81,y:8.9},{x:81.5,y:9},{x:82,y:9.1},{x:82.5,y:9.2},{x:83,y:9.3},{x:83.5,y:9.4},{x:84,y:9.5},{x:84.5,y:9.6},{x:85,y:9.7},{x:85.5,y:9.8},{x:86,y:9.9},{x:86.5,y:10},{x:87,y:10.1},{x:87.5,y:10.2},{x:88,y:10.3},{x:88.5,y:10.5},{x:89,y:10.6},{x:89.5,y:10.7},{x:90,y:10.8},{x:90.5,y:10.9},{x:91,y:11},{x:91.5,y:11},{x:92,y:11.1},{x:92.5,y:11.2},{x:93,y:11.3},{x:93.5,y:11.4},{x:94,y:11.5},{x:94.5,y:11.6},{x:95,y:11.7},{x:95.5,y:11.8},{x:96,y:11.9},{x:96.5,y:12},{x:97,y:12.1},{x:97.5,y:12.2},{x:98,y:12.3},{x:98.5,y:12.4},{x:99,y:12.5},{x:99.5,y:12.7},{x:100,y:12.8},{x:100.5,y:12.9},{x:101,y:13},{x:101.5,y:13.1},{x:102,y:13.2},{x:102.5,y:13.3},{x:103,y:13.4},{x:103.5,y:13.6},{x:104,y:13.7},{x:104.5,y:13.8},{x:105,y:13.9},{x:105.5,y:14},{x:106,y:14.2},{x:106.5,y:14.3},{x:107,y:14.4},{x:107.5,y:14.5},{x:108,y:14.7},{x:108.5,y:14.8},{x:109,y:14.9},{x:109.5,y:15.1},{x:110,y:15.2}];

            var set2 = [{x:45,y:2.1},{x:45.5,y:2.1},{x:46,y:2.2},{x:46.5,y:2.3},{x:47,y:2.4},{x:47.5,y:2.4},{x:48,y:2.5},{x:48.5,y:2.6},{x:49,y:2.7},{x:49.5,y:2.7},{x:50,y:2.8},{x:50.5,y:2.9},{x:51,y:3},{x:51.5,y:3.1},{x:52,y:3.2},{x:52.5,y:3.3},{x:53,y:3.4},{x:53.5,y:3.5},{x:54,y:3.6},{x:54.5,y:3.8},{x:55,y:3.9},{x:55.5,y:4},{x:56,y:4.1},{x:56.5,y:4.3},{x:57,y:4.4},{x:57.5,y:4.5},{x:58,y:4.6},{x:58.5,y:4.8},{x:59,y:4.9},{x:59.5,y:5},{x:60,y:5.1},{x:60.5,y:5.3},{x:61,y:5.4},{x:61.5,y:5.5},{x:62,y:5.6},{x:62.5,y:5.7},{x:63,y:5.8},{x:63.5,y:5.9},{x:64,y:6},{x:64.5,y:6.1},{x:65,y:6.4},{x:65.5,y:6.5},{x:66,y:6.6},{x:66.5,y:6.7},{x:67,y:6.8},{x:67.5,y:6.9},{x:68,y:7},{x:68.5,y:7.1},{x:69,y:7.2},{x:69.5,y:7.3},{x:70,y:7.4},{x:70.5,y:7.5},{x:71,y:7.6},{x:71.5,y:7.7},{x:72,y:7.8},{x:72.5,y:7.8},{x:73,y:7.9},{x:73.5,y:8},{x:74,y:8.1},{x:74.5,y:8.2},{x:75,y:8.3},{x:75.5,y:8.4},{x:76,y:8.5},{x:76.5,y:8.5},{x:77,y:8.6},{x:77.5,y:8.7},{x:78,y:8.8},{x:78.5,y:8.8},{x:79,y:8.9},{x:79.5,y:9},{x:80,y:9.1},{x:80.5,y:9.2},{x:81,y:9.3},{x:81.5,y:9.3},{x:82,y:9.4},{x:82.5,y:9.5},{x:83,y:9.6},{x:83.5,y:9.7},{x:84,y:9.8},{x:84.5,y:9.9},{x:85,y:10.1},{x:85.5,y:10.2},{x:86,y:10.3},{x:86.5,y:10.4},{x:87,y:10.5},{x:87.5,y:10.6},{x:88,y:10.7},{x:88.5,y:10.8},{x:89,y:10.9},{x:89.5,y:11},{x:90,y:11.1},{x:90.5,y:11.2},{x:91,y:11.3},{x:91.5,y:11.4},{x:92,y:11.5},{x:92.5,y:11.6},{x:93,y:11.7},{x:93.5,y:11.8},{x:94,y:11.9},{x:94.5,y:12},{x:95,y:12.1},{x:95.5,y:12.2},{x:96,y:12.3},{x:96.5,y:12.4},{x:97,y:12.5},{x:97.5,y:12.7},{x:98,y:12.8},{x:98.5,y:12.9},{x:99,y:13},{x:99.5,y:13.1},{x:100,y:13.2},{x:100.5,y:13.3},{x:101,y:13.4},{x:101.5,y:13.6},{x:102,y:13.7},{x:102.5,y:13.8},{x:103,y:13.9},{x:103.5,y:14},{x:104,y:14.2},{x:104.5,y:14.3},{x:105,y:14.4},{x:105.5,y:14.5},{x:106,y:14.7},{x:106.5,y:14.8},{x:107,y:14.9},{x:107.5,y:15.1},{x:108,y:15.2},{x:108.5,y:15.3},{x:109,y:15.5},{x:109.5,y:15.6},{x:110,y:15.8}];

            var set3 = [{x:45,y:2.4},{x:45.5,y:2.5},{x:46,y:2.6},{x:46.5,y:2.7},{x:47,y:2.8},{x:47.5,y:2.9},{x:48,y:2.9},{x:48.5,y:3},{x:49,y:3.1},{x:49.5,y:3.2},{x:50,y:3.3},{x:50.5,y:3.4},{x:51,y:3.5},{x:51.5,y:3.6},{x:52,y:3.8},{x:52.5,y:3.9},{x:53,y:4},{x:53.5,y:4.1},{x:54,y:4.3},{x:54.5,y:4.4},{x:55,y:4.5},{x:55.5,y:4.7},{x:56,y:4.8},{x:56.5,y:5},{x:57,y:5.1},{x:57.5,y:5.3},{x:58,y:5.4},{x:58.5,y:5.6},{x:59,y:5.7},{x:59.5,y:5.9},{x:60,y:6},{x:60.5,y:6.1},{x:61,y:6.3},{x:61.5,y:6.4},{x:62,y:6.5},{x:62.5,y:6.7},{x:63,y:6.8},{x:63.5,y:6.9},{x:64,y:7},{x:64.5,y:7.1},{x:65,y:7.4},{x:65.5,y:7.6},{x:66,y:7.7},{x:66.5,y:7.8},{x:67,y:7.9},{x:67.5,y:8},{x:68,y:8.1},{x:68.5,y:8.2},{x:69,y:8.4},{x:69.5,y:8.5},{x:70,y:8.6},{x:70.5,y:8.7},{x:71,y:8.8},{x:71.5,y:8.9},{x:72,y:9},{x:72.5,y:9.1},{x:73,y:9.2},{x:73.5,y:9.3},{x:74,y:9.4},{x:74.5,y:9.5},{x:75,y:9.6},{x:75.5,y:9.7},{x:76,y:9.8},{x:76.5,y:9.9},{x:77,y:10},{x:77.5,y:10.1},{x:78,y:10.2},{x:78.5,y:10.3},{x:79,y:10.4},{x:79.5,y:10.5},{x:80,y:10.6},{x:80.5,y:10.7},{x:81,y:10.8},{x:81.5,y:10.9},{x:82,y:11},{x:82.5,y:11.1},{x:83,y:11.2},{x:83.5,y:11.3},{x:84,y:11.4},{x:84.5,y:11.5},{x:85,y:11.7},{x:85.5,y:11.8},{x:86,y:11.9},{x:86.5,y:12},{x:87,y:12.2},{x:87.5,y:12.3},{x:88,y:12.4},{x:88.5,y:12.5},{x:89,y:12.6},{x:89.5,y:12.8},{x:90,y:12.9},{x:90.5,y:13},{x:91,y:13.1},{x:91.5,y:13.2},{x:92,y:13.4},{x:92.5,y:13.5},{x:93,y:13.6},{x:93.5,y:13.7},{x:94,y:13.8},{x:94.5,y:13.9},{x:95,y:14.1},{x:95.5,y:14.2},{x:96,y:14.3},{x:96.5,y:14.4},{x:97,y:14.6},{x:97.5,y:14.7},{x:98,y:14.8},{x:98.5,y:14.9},{x:99,y:15.1},{x:99.5,y:15.2},{x:100,y:15.4},{x:100.5,y:15.5},{x:101,y:15.6},{x:101.5,y:15.8},{x:102,y:15.9},{x:102.5,y:16.1},{x:103,y:16.2},{x:103.5,y:16.4},{x:104,y:16.5},{x:104.5,y:16.7},{x:105,y:16.8},{x:105.5,y:17},{x:106,y:17.2},{x:106.5,y:17.3},{x:107,y:17.5},{x:107.5,y:17.7},{x:108,y:17.8},{x:108.5,y:18},{x:109,y:18.2},{x:109.5,y:18.3},{x:110,y:18.5}];

            var set4 = [{x:45,y:3},{x:45.5,y:3.1},{x:46,y:3.3},{x:46.5,y:3.4},{x:47,y:3.5},{x:47.5,y:3.6},{x:48,y:3.7},{x:48.5,y:3.8},{x:49,y:3.9},{x:49.5,y:4},{x:50,y:4.1},{x:50.5,y:4.2},{x:51,y:4.4},{x:51.5,y:4.5},{x:52,y:4.6},{x:52.5,y:4.8},{x:53,y:4.9},{x:53.5,y:5.1},{x:54,y:5.3},{x:54.5,y:5.4},{x:55,y:5.6},{x:55.5,y:5.8},{x:56,y:5.9},{x:56.5,y:6.1},{x:57,y:6.3},{x:57.5,y:6.5},{x:58,y:6.6},{x:58.5,y:6.8},{x:59,y:7},{x:59.5,y:7.2},{x:60,y:7.3},{x:60.5,y:7.5},{x:61,y:7.7},{x:61.5,y:7.8},{x:62,y:8},{x:62.5,y:8.1},{x:63,y:8.3},{x:63.5,y:8.4},{x:64,y:8.6},{x:64.5,y:8.7},{x:65,y:9.1},{x:65.5,y:9.2},{x:66,y:9.3},{x:66.5,y:9.5},{x:67,y:9.6},{x:67.5,y:9.8},{x:68,y:9.9},{x:68.5,y:10},{x:69,y:10.2},{x:69.5,y:10.3},{x:70,y:10.5},{x:70.5,y:10.6},{x:71,y:10.7},{x:71.5,y:10.9},{x:72,y:11},{x:72.5,y:11.1},{x:73,y:11.3},{x:73.5,y:11.4},{x:74,y:11.5},{x:74.5,y:11.7},{x:75,y:11.8},{x:75.5,y:11.9},{x:76,y:12},{x:76.5,y:12.1},{x:77,y:12.3},{x:77.5,y:12.4},{x:78,y:12.5},{x:78.5,y:12.6},{x:79,y:12.7},{x:79.5,y:12.8},{x:80,y:12.9},{x:80.5,y:13},{x:81,y:13.1},{x:81.5,y:13.3},{x:82,y:13.4},{x:82.5,y:13.5},{x:83,y:13.6},{x:83.5,y:13.8},{x:84,y:13.9},{x:84.5,y:14.1},{x:85,y:14.2},{x:85.5,y:14.3},{x:86,y:14.5},{x:86.5,y:14.6},{x:87,y:14.8},{x:87.5,y:14.9},{x:88,y:15.1},{x:88.5,y:15.2},{x:89,y:15.4},{x:89.5,y:15.5},{x:90,y:15.6},{x:90.5,y:15.8},{x:91,y:15.9},{x:91.5,y:16.1},{x:92,y:16.2},{x:92.5,y:16.3},{x:93,y:16.5},{x:93.5,y:16.6},{x:94,y:16.8},{x:94.5,y:16.9},{x:95,y:17.1},{x:95.5,y:17.2},{x:96,y:17.4},{x:96.5,y:17.5},{x:97,y:17.7},{x:97.5,y:17.9},{x:98,y:18},{x:98.5,y:18.2},{x:99,y:18.4},{x:99.5,y:18.5},{x:100,y:18.7},{x:100.5,y:18.9},{x:101,y:19.1},{x:101.5,y:19.3},{x:102,y:19.5},{x:102.5,y:19.7},{x:103,y:19.9},{x:103.5,y:20.1},{x:104,y:20.3},{x:104.5,y:20.5},{x:105,y:20.7},{x:105.5,y:20.9},{x:106,y:21.1},{x:106.5,y:21.3},{x:107,y:21.5},{x:107.5,y:21.7},{x:108,y:22},{x:108.5,y:22.2},{x:109,y:22.4},{x:109.5,y:22.7},{x:110,y:22.9}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightweightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([110,45]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([110,45]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,26.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,26.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(45, 111, 2)).tickFormat(function(d){
				return d%2==0? '' : d;
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(45, 111, 2)).tickFormat(function(d){
                return d%2==0? '' : d;
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 26.5, 0.5)).tickFormat(function(d){
                return d%0.5==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 26.5, 0.5)).tickFormat(function(d){
                return d%0.5==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " cm<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -40 )
                .style("text-anchor", "middle")
                .text("WHO Boys Weight for Height/Length");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Length (cm)");

                svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 50 )
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("Ref: IAP Growth Charts. Indian Academy of Pediatrics. [updated 2013 18 Oct, cited 2016 14 Jan] Available from: http://www.iapindia.org/page.php?id=79");
            
            svg.append("text")
                .attr("x", -350 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("WHO MGRS 2006 Charts; Acta Paediatrics Suppl. 450:2006");

            svg.append("text")
                .attr("x", -490 )
                .attr("y", 900 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Height (cm)");
            
                svg.append("text")
                .attr("x", 790 )
                .attr("y", 410 )
                .style("text-anchor", "start")
                .text("1(-3)");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 390 )
                .style("text-anchor", "start")
                .text("3(-2)");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 290 )
                .style("text-anchor", "start")
                .text("50(0)");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 115 )
                .style("text-anchor", "start")
                .text("99(+3)");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightweightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('wlhcFemalePrint', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 960'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 1000 - margin.top - margin.bottom;
              var width = 980 - margin.left - margin.right;
  
              var heightData = [];
  
              if(vitalData.height) {
                  for(var i = 0; i < vitalData.height.length; i++){
                      if(vitalData.height[i].x<61) {
                          heightData.push(vitalData.height[i]);
                      }
                  }
              }

            var weightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x<61) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var headData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.hc.length; i++){
                    if(vitalData.hc[i].x<61) {
                        headData.push(vitalData.hc[i]);
                    }
                }
            }
  
            //   Start of Weight data
            var set1 = [{x:0,y:2.3},{x:1,y:3},{x:2,y:3.8},{x:3,y:4.4},{x:4,y:4.8},{x:5,y:5.2},{x:6,y:5.5},{x:7,y:5.8},
                {x:8,y:6},{x:9,y:6.2},{x:10,y:6.4},{x:11,y:6.6},{x:12,y:6.8},{x:13,y:6.9},{x:14,y:7.1},{x:15,y:7.3},
                {x:16,y:7.4},{x:17,y:7.6},{x:18,y:7.8},{x:19,y:7.9},{x:20,y:8.1},{x:21,y:8.2},{x:22,y:8.4},
                {x:23,y:8.5},{x:24,y:8.7},{x:25,y:8.9},{x:26,y:9},{x:27,y:9.2},{x:28,y:9.3},{x:29,y:9.5},{x:30,y:9.6},
                {x:31,y:9.7},{x:32,y:9.9},{x:33,y:10},{x:34,y:10.1},{x:35,y:10.3},{x:36,y:10.4},{x:37,y:10.5},
                {x:38,y:10.6},{x:39,y:10.8},{x:40,y:10.9},{x:41,y:11},{x:42,y:11.1},{x:43,y:11.3},{x:44,y:11.4},
                {x:45,y:11.5},{x:46,y:11.6},{x:47,y:11.7},{x:48,y:11.8},{x:49,y:11.9},{x:50,y:12.1},{x:51,y:12.2},
                {x:52,y:12.3},{x:53,y:12.4},{x:54,y:12.5},{x:55,y:12.6},{x:56,y:12.7},{x:57,y:12.8},{x:58,y:12.9},
                {x:59,y:13.1},{x:60,y:13.2}];

            var set2 = [{x:0,y:2.5},{x:1,y:3.3},{x:2,y:4.1},{x:3,y:4.7},{x:4,y:5.2},{x:5,y:5.6},{x:6,y:6},{x:7,y:6.3},{x:8,y:6.5},
                {x:9,y:6.8},{x:10,y:7},{x:11,y:7.2},{x:12,y:7.3},{x:13,y:7.5},{x:14,y:7.7},{x:15,y:7.9},{x:16,y:8.1},
                {x:17,y:8.2},{x:18,y:8.4},{x:19,y:8.6},{x:20,y:8.7},{x:21,y:8.9},{x:22,y:9.1},{x:23,y:9.2},{x:24,y:9.4},
                {x:25,y:9.6},{x:26,y:9.8},{x:27,y:9.9},{x:28,y:10.1},{x:29,y:10.2},{x:30,y:10.4},{x:31,y:10.5},{x:32,y:10.7},
                {x:33,y:10.8},{x:34,y:11},{x:35,y:11.1},{x:36,y:11.3},{x:37,y:11.4},{x:38,y:11.6},{x:39,y:11.7},{x:40,y:11.8},
                {x:41,y:12},{x:42,y:12.1},{x:43,y:12.2},{x:44,y:12.4},{x:45,y:12.5},{x:46,y:12.6},{x:47,y:12.8},{x:48,y:12.9},
                {x:49,y:13},{x:50,y:13.2},{x:51,y:13.3},{x:52,y:13.4},{x:53,y:13.5},{x:54,y:13.7},{x:55,y:13.8},{x:56,y:13.9},
                {x:57,y:14},{x:58,y:14.2},{x:59,y:14.3},{x:60,y:14.4}];

            var set3 = [{x:0,y:3.2},{x:1,y:4.2},{x:2,y:5.1},{x:3,y:5.8},{x:4,y:6.4},{x:5,y:6.9},{x:6,y:7.3},{x:7,y:7.6},{x:8,y:7.9},
                {x:9,y:8.2},{x:10,y:8.5},{x:11,y:8.7},{x:12,y:8.9},{x:13,y:9.2},{x:14,y:9.4},{x:15,y:9.6},{x:16,y:9.8},
                {x:17,y:10},{x:18,y:10.2},{x:19,y:10.4},{x:20,y:10.6},{x:21,y:10.9},{x:22,y:11.1},{x:23,y:11.3},{x:24,y:11.5},
                {x:25,y:11.7},{x:26,y:11.9},{x:27,y:12.1},{x:28,y:12.3},{x:29,y:12.5},{x:30,y:12.7},{x:31,y:12.9},{x:32,y:13.1},
                {x:33,y:13.3},{x:34,y:13.5},{x:35,y:13.7},{x:36,y:13.9},{x:37,y:14},{x:38,y:14.2},{x:39,y:14.4},{x:40,y:14.6},
                {x:41,y:14.8},{x:42,y:15},{x:43,y:15.2},{x:44,y:15.3},{x:45,y:15.5},{x:46,y:15.7},{x:47,y:15.9},{x:48,y:16.1},
                {x:49,y:16.3},{x:50,y:16.4},{x:51,y:16.6},{x:52,y:16.8},{x:53,y:17},{x:54,y:17.2},{x:55,y:17.3},{x:56,y:17.5},
                {x:57,y:17.7},{x:58,y:17.9},{x:59,y:18},{x:60,y:18.2}];

            var set4 = [{x:0,y:4.2},{x:1,y:5.4},{x:2,y:6.5},{x:3,y:7.4},{x:4,y:8.1},{x:5,y:8.7},{x:6,y:9.2},{x:7,y:9.6},{x:8,y:10},
                {x:9,y:10.4},{x:10,y:10.7},{x:11,y:11},{x:12,y:11.3},{x:13,y:11.6},{x:14,y:11.9},{x:15,y:12.2},{x:16,y:12.5},
                {x:17,y:12.7},{x:18,y:13},{x:19,y:13.3},{x:20,y:13.5},{x:21,y:13.8},{x:22,y:14.1},{x:23,y:14.3},{x:24,y:14.6},
                {x:25,y:14.9},{x:26,y:15.2},{x:27,y:15.4},{x:28,y:15.7},{x:29,y:16},{x:30,y:16.2},{x:31,y:16.5},{x:32,y:16.8},
                {x:33,y:17},{x:34,y:17.3},{x:35,y:17.6},{x:36,y:17.8},{x:37,y:18.1},{x:38,y:18.4},{x:39,y:18.6},{x:40,y:18.9},
                {x:41,y:19.2},{x:42,y:19.5},{x:43,y:19.7},{x:44,y:20},{x:45,y:20.3},{x:46,y:20.6},{x:47,y:20.8},{x:48,y:21.1},
                {x:49,y:21.4},{x:50,y:21.7},{x:51,y:22},{x:52,y:22.2},{x:53,y:22.5},{x:54,y:22.8},{x:55,y:23.1},{x:56,y:23.3},
                {x:57,y:23.6},{x:58,y:23.9},{x:59,y:24.2},{x:60,y:24.4}];
            // End of Weight data

            // Start of Head Circumference data
            var set5 = [{x:0,y:31.7},{x:1,y:34.3},{x:2,y:36},{x:3,y:37.2},{x:4,y:38.2},{x:5,y:39},{x:6,y:39.7},{x:7,y:40.4},
                {x:8,y:40.9},{x:9,y:41.3},{x:10,y:41.7},{x:11,y:42},{x:12,y:42.3},{x:13,y:42.6},{x:14,y:42.9},
                {x:15,y:43.1},{x:16,y:43.3},{x:17,y:43.5},{x:18,y:43.6},{x:19,y:43.8},{x:20,y:44},{x:21,y:44.1},
                {x:22,y:44.3},{x:23,y:44.4},{x:24,y:44.6},{x:25,y:44.7},{x:26,y:44.8},{x:27,y:44.9},{x:28,y:45.1},
                {x:29,y:45.2},{x:30,y:45.3},{x:31,y:45.4},{x:32,y:45.5},{x:33,y:45.6},{x:34,y:45.7},{x:35,y:45.8},
                {x:36,y:45.9},{x:37,y:45.9},{x:38,y:46},{x:39,y:46.1},{x:40,y:46.2},{x:41,y:46.2},{x:42,y:46.3},
                {x:43,y:46.4},{x:44,y:46.4},{x:45,y:46.5},{x:46,y:46.5},{x:47,y:46.6},{x:48,y:46.7},{x:49,y:46.7},
                {x:50,y:46.8},{x:51,y:46.8},{x:52,y:46.9},{x:53,y:46.9},{x:54,y:47},{x:55,y:47},{x:56,y:47.1},
                {x:57,y:47.1},{x:58,y:47.2},{x:59,y:47.2},{x:60,y:47.2}];

            var set6 = [{x:0,y:33.9},{x:1,y:36.5},{x:2,y:38.3},{x:3,y:39.5},{x:4,y:40.6},{x:5,y:41.5},{x:6,y:42.2},{x:7,y:42.8},
                {x:8,y:43.4},{x:9,y:43.8},{x:10,y:44.2},{x:11,y:44.6},{x:12,y:44.9},{x:13,y:45.2},{x:14,y:45.4},{x:15,y:45.7},
                {x:16,y:45.9},{x:17,y:46.1},{x:18,y:46.2},{x:19,y:46.4},{x:20,y:46.6},{x:21,y:46.7},{x:22,y:46.9},{x:23,y:47},
                {x:24,y:47.2},{x:25,y:47.3},{x:26,y:47.5},{x:27,y:47.6},{x:28,y:47.7},{x:29,y:47.8},{x:30,y:47.9},{x:31,y:48},
                {x:32,y:48.1},{x:33,y:48.2},{x:34,y:48.3},{x:35,y:48.4},{x:36,y:48.5},{x:37,y:48.6},{x:38,y:48.7},{x:39,y:48.7},
                {x:40,y:48.8},{x:41,y:48.9},{x:42,y:49},{x:43,y:49},{x:44,y:49.1},{x:45,y:49.2},{x:46,y:49.2},{x:47,y:49.3},
                {x:48,y:49.3},{x:49,y:49.4},{x:50,y:49.4},{x:51,y:49.5},{x:52,y:49.5},{x:53,y:49.6},{x:54,y:49.6},{x:55,y:49.7},
                {x:56,y:49.7},{x:57,y:49.8},{x:58,y:49.8},{x:59,y:49.9},{x:60,y:49.9}];

            var set7 = [{x:0,y:36.1},{x:1,y:38.8},{x:2,y:40.5},{x:3,y:41.9},{x:4,y:43},{x:5,y:43.9},{x:6,y:44.6},{x:7,y:45.3},
                {x:8,y:45.9},{x:9,y:46.3},{x:10,y:46.8},{x:11,y:47.1},{x:12,y:47.5},{x:13,y:47.7},{x:14,y:48},{x:15,y:48.2},
                {x:16,y:48.5},{x:17,y:48.7},{x:18,y:48.8},{x:19,y:49},{x:20,y:49.2},{x:21,y:49.4},{x:22,y:49.5},{x:23,y:49.7},
                {x:24,y:49.8},{x:25,y:49.9},{x:26,y:50.1},{x:27,y:50.2},{x:28,y:50.3},{x:29,y:50.5},{x:30,y:50.6},{x:31,y:50.7},
                {x:32,y:50.8},{x:33,y:50.9},{x:34,y:51},{x:35,y:51.1},{x:36,y:51.2},{x:37,y:51.3},{x:38,y:51.3},{x:39,y:51.4},
                {x:40,y:51.5},{x:41,y:51.6},{x:42,y:51.6},{x:43,y:51.7},{x:44,y:51.8},{x:45,y:51.8},{x:46,y:51.9},{x:47,y:51.9},
                {x:48,y:52},{x:49,y:52.1},{x:50,y:52.1},{x:51,y:52.2},{x:52,y:52.2},{x:53,y:52.3},{x:54,y:52.3},{x:55,y:52.4},
                {x:56,y:52.4},{x:57,y:52.5},{x:58,y:52.5},{x:59,y:52.6},{x:60,y:52.6}];
            // End of Head Circumference data
            
            // Start of Height/Lenght data
            var set8 = [{x:0,y:44.8},{x:1,y:49.1},{x:2,y:52.3},{x:3,y:54.9},{x:4,y:57.1},{x:5,y:58.9},{x:6,y:60.5},{x:7,y:61.9},
                {x:8,y:63.2},{x:9,y:64.5},{x:10,y:65.7},{x:11,y:66.9},{x:12,y:68},{x:13,y:69.1},{x:14,y:70.1},{x:15,y:71.1},
                {x:16,y:72.1},{x:17,y:73},{x:18,y:74},{x:19,y:74.8},{x:20,y:75.7},{x:21,y:76.5},{x:22,y:77.3},{x:23,y:78.1},
                {x:24,y:78.9},{x:25,y:79},{x:26,y:79.7},{x:27,y:80.4},{x:28,y:81.1},{x:29,y:81.8},{x:30,y:82.5},{x:31,y:83.1},
                {x:32,y:83.8},{x:33,y:84.4},{x:34,y:85},{x:35,y:85.6},{x:36,y:86.2},{x:37,y:86.8},{x:38,y:87.4},{x:39,y:87.9},
                {x:40,y:88.5},{x:41,y:89},{x:42,y:89.6},{x:43,y:90.1},{x:44,y:90.7},{x:45,y:91.2},{x:46,y:91.7},{x:47,y:92.2},
                {x:48,y:92.7},{x:49,y:93.2},{x:50,y:93.7},{x:51,y:94.2},{x:52,y:94.7},{x:53,y:95.2},{x:54,y:95.6},{x:55,y:96.1},
                {x:56,y:96.6},{x:57,y:97},{x:58,y:97.5},{x:59,y:97.9},{x:60,y:98.4}];
  
            var set9 = [{x:0,y:45.6},{x:1,y:50},{x:2,y:53.2},{x:3,y:55.8},{x:4,y:58},{x:5,y:59.9},{x:6,y:61.5},{x:7,y:62.9},{x:8,y:64.3},
                {x:9,y:65.6},{x:10,y:66.8},{x:11,y:68},{x:12,y:69.2},{x:13,y:70.3},{x:14,y:71.3},{x:15,y:72.4},{x:16,y:73.3},
                {x:17,y:74.3},{x:18,y:75.2},{x:19,y:76.2},{x:20,y:77},{x:21,y:77.9},{x:22,y:78.7},{x:23,y:79.6},{x:24,y:80.3},
                {x:25,y:80.4},{x:26,y:81.2},{x:27,y:81.9},{x:28,y:82.6},{x:29,y:83.4},{x:30,y:84},{x:31,y:84.7},{x:32,y:85.4},
                {x:33,y:86},{x:34,y:86.7},{x:35,y:87.3},{x:36,y:87.9},{x:37,y:88.5},{x:38,y:89.1},{x:39,y:89.7},{x:40,y:90.3},
                {x:41,y:90.8},{x:42,y:91.4},{x:43,y:92},{x:44,y:92.5},{x:45,y:93},{x:46,y:93.6},{x:47,y:94.1},{x:48,y:94.6},
                {x:49,y:95.1},{x:50,y:95.7},{x:51,y:96.2},{x:52,y:96.7},{x:53,y:97.2},{x:54,y:97.6},{x:55,y:98.1},{x:56,y:98.6},
                {x:57,y:99.1},{x:58,y:99.6},{x:59,y:100},{x:60,y:100.5}];

            var set10 = [{x:0,y:49.1},{x:1,y:53.7},{x:2,y:57.1},{x:3,y:59.8},{x:4,y:62.1},{x:5,y:64},{x:6,y:65.7},{x:7,y:67.3},{x:8,y:68.7},
                {x:9,y:70.1},{x:10,y:71.5},{x:11,y:72.8},{x:12,y:74},{x:13,y:75.2},{x:14,y:76.4},{x:15,y:77.5},{x:16,y:78.6},
                {x:17,y:79.7},{x:18,y:80.7},{x:19,y:81.7},{x:20,y:82.7},{x:21,y:83.7},{x:22,y:84.6},{x:23,y:85.5},{x:24,y:86.4},
                {x:25,y:86.6},{x:26,y:87.4},{x:27,y:88.3},{x:28,y:89.1},{x:29,y:89.9},{x:30,y:90.7},{x:31,y:91.4},{x:32,y:92.2},
                {x:33,y:92.9},{x:34,y:93.6},{x:35,y:94.4},{x:36,y:95.1},{x:37,y:95.7},{x:38,y:96.4},{x:39,y:97.1},{x:40,y:97.7},
                {x:41,y:98.4},{x:42,y:99},{x:43,y:99.7},{x:44,y:100.3},{x:45,y:100.9},{x:46,y:101.5},{x:47,y:102.1},
                {x:48,y:102.7},{x:49,y:103.3},{x:50,y:103.9},{x:51,y:104.5},{x:52,y:105},{x:53,y:105.6},{x:54,y:106.2},
                {x:55,y:106.7},{x:56,y:107.3},{x:57,y:107.8},{x:58,y:108.4},{x:59,y:108.9},{x:60,y:109.4}];
  
            var set11 = [{x:0,y:52.7},{x:1,y:57.4},{x:2,y:60.9},{x:3,y:63.8},{x:4,y:66.2},{x:5,y:68.2},{x:6,y:70},{x:7,y:71.6},{x:8,y:73.2},
                {x:9,y:74.7},{x:10,y:76.1},{x:11,y:77.5},{x:12,y:78.9},{x:13,y:80.2},{x:14,y:81.4},{x:15,y:82.7},{x:16,y:83.9},
                {x:17,y:85},{x:18,y:86.2},{x:19,y:87.3},{x:20,y:88.4},{x:21,y:89.4},{x:22,y:90.5},{x:23,y:91.5},{x:24,y:92.5},
                {x:25,y:92.8},{x:26,y:93.7},{x:27,y:94.6},{x:28,y:95.6},{x:29,y:96.4},{x:30,y:97.3},{x:31,y:98.2},{x:32,y:99},
                {x:33,y:99.8},{x:34,y:100.6},{x:35,y:101.4},{x:36,y:102.2},{x:37,y:103},{x:38,y:103.7},{x:39,y:104.5},
                {x:40,y:105.2},{x:41,y:106},{x:42,y:106.7},{x:43,y:107.4},{x:44,y:108.1},{x:45,y:108.8},{x:46,y:109.5},
                {x:47,y:110.2},{x:48,y:110.8},{x:49,y:111.5},{x:50,y:112.1},{x:51,y:112.8},{x:52,y:113.4},{x:53,y:114.1},
                {x:54,y:114.7},{x:55,y:115.3},{x:56,y:116},{x:57,y:116.6},{x:58,y:117.2},{x:59,y:117.8},{x:60,y:118.4}];
            // End of Height/Lenght data
              
              var rawSvg = element.find("svg")[0];
              var svg = d3.select(rawSvg)
                          .attr("width",width + margin.left + margin.right)
                          .attr("height",height + margin.top + margin.bottom);
              var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
              var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            
              var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
              var gEnter2 = wrap2.enter().append('g').attr('class', 'd3line').append('g');
  
              var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([headData]);
              var gEnter3 = wrap3.enter().append('g').attr('class', 'd3line').append('g');
  
              var div = d3.select("body").append("div")	
                          .attr("class", "tooltip")				
                          .style("opacity", 0);
  
              var lineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("bundle")
                              .tension(.7);
  
              var datalineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("linear");
  
              var g = svg.append("g")
                          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
              
              var xScale0 = d3.scale.linear().domain([60.5,0]).range([width,0]);
              var xScale1 = d3.scale.linear().domain([60.5,0]).range([width,0]);
  
              var yScale0 = d3.scale.linear().domain([0,131.5]).range([height, 0]);
              var yScale1 = d3.scale.linear().domain([0,131.5]).range([height, 0]);
  
              var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(0, 60.5, 1)).tickFormat(function(d){
                  return d%2==0? d : '';
              }).innerTickSize(-height)
                              .outerTickSize(0);
              var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(0, 60.5, 1)).tickFormat(function(d){
                  return d%2==0? d : '';
              });
              var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 131, 3)).tickFormat(function(d){
                  return d%3==0? d : '';
              }).innerTickSize(-width)
                              .outerTickSize(0);
              var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 131, 3)).tickFormat(function(d){
                  return d%3==0? d : '';
              }).innerTickSize(50)
                              .outerTickSize(50).tickPadding(10);
              
              var age = function(data) {
                  if(data <= 24){
                      return data.toString().split('.')[0]+ " months";
                  }
                  if(data <=60) {
                      var mon = data/12;
                      var result = mon.toFixed(1).split('.');
                      var mod = data%12;
                      var res = mod.toString().split('.');
                      return result[0].toString()+ " years " + res[0] + " months";
                  }
              };
  
              // plot user data points
            var heightpoint = wrap.selectAll('circle')
                  .data(function (d) { return d; })
                  .enter().append('circle')
                  .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                  .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                  .attr('r', 5)
                  .attr('fill','red')
                  .on("mouseover", function(d) {		
                      div.transition()		
                          .duration(200)		
                          .style("opacity", .9);		
                      div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                          .style("left", (d3.event.pageX) + "px")		
                          .style("top", (d3.event.pageY - 28) + "px");	
                      })					
                  .on("mouseout", function(d) {		
                      div.transition()		
                          .duration(500)		
                          .style("opacity", 0);	
                  });
  
            var weightpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var headpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

              // x-axis
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxisBottom);
              
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0,0)")
                  .call(xAxisTop);
              
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", -40 )
                  .style("text-anchor", "middle")
                  .text("WHO Girls Height, Weight, Head Charts 0-5 years");
              
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height + 35)
                  .style("text-anchor", "middle")
                  .text("Age in Months");
  
                  svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height + 50 )
                  .style("text-anchor", "middle")
                  .style("font-size","10px")
                  .text("Ref: IAP Growth Charts. Indian Academy of Pediatrics. [updated 2013 18 Oct, cited 2016 14 Jan] Available from: http://www.iapindia.org/page.php?id=79");
              
              svg.append("text")
                  .attr("x", -350 )
                  .attr("y", -35)
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .style("font-size","12px")
                  .text("WHO MGRS 2006 Charts; Acta Paediatrics Suppl. 450:2006");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 240 )
                  .style("text-anchor", "start")
                  .text("1 (-3)");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 225 )
                  .style("text-anchor", "start")
                  .text("3 (-2)");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 160 )
                  .style("text-anchor", "start")
                  .text("50 (0)");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 95 )
                  .style("text-anchor", "start")
                  .text("97 (+2)");

                svg.append("text")
                    .attr("x", 650 )
                    .attr("y", 95 )
                    .style("text-anchor", "start")
                    .text("Height/Lenght");

                svg.append("text")
                    .attr("x", 790 )
                    .attr("y", 610 )
                    .style("text-anchor", "start")
                    .text("3 (-2)");
    
                svg.append("text")
                    .attr("x", 790 )
                    .attr("y", 585 )
                    .style("text-anchor", "start")
                    .text("50 (0)");
                
                svg.append("text")
                    .attr("x", 790 )
                    .attr("y", 565 )
                    .style("text-anchor", "start")
                    .text("97 (+2)");

                svg.append("text")
                    .attr("x", 650 )
                    .attr("y", 565 )
                    .style("text-anchor", "start")
                    .text("Head");
                
                svg.append("text")
                    .attr("x", 790 )
                    .attr("y", 855 )
                    .style("text-anchor", "start")
                    .text("1 (-3)");
              
                svg.append("text")
                    .attr("x", 790 )
                    .attr("y", 840 )
                    .style("text-anchor", "start")
                    .text("3 (-2)");
    
                svg.append("text")
                    .attr("x", 790 )
                    .attr("y", 810 )
                    .style("text-anchor", "start")
                    .text("50 (0)");
                
                svg.append("text")
                    .attr("x", 790 )
                    .attr("y", 770 )
                    .style("text-anchor", "start")
                    .text("97 (+2)");
                    
                svg.append("text")
                    .attr("x", 650 )
                    .attr("y", 770 )
                    .style("text-anchor", "start")
                    .text("Weight");
                  
              // y-axis
              svg.append("g")
                  .attr("class", "y axis")
                  .call(yAxisLeft);	
  
              svg.append("g")				
                  .attr("class", "y axis")	
                  .attr("transform", "translate(" + width + " ,0)")		
                  .call(yAxisRight);
              
              // path lines
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set1),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set2),
                      "stroke": "yellow",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set3),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set4),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set5),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set6),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set7),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set8),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set9),
                      "stroke": "yellow",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set10),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });

                svg.append("svg:path")
                    .attr({
                      d: lineFunc(set11),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              
              // user data
              svg.append("svg:path")
                    .attr({
                      d: datalineFunc(heightData),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(headData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
          }
      };
  });
'use strict';
angular.module('AngularApp').directive('wlhcMalePrint', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 960'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 980 - margin.left - margin.right;

            var heightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x<61) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            var weightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x<61) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var headData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.hc.length; i++){
                    if(vitalData.hc[i].x<61) {
                        headData.push(vitalData.hc[i]);
                    }
                }
            }

            // Start of Weight data
            var set1 = [{x:0,y:2.3},{x:1,y:3.2},{x:2,y:4.1},{x:3,y:4.8},{x:4,y:5.4},{x:5,y:5.8},{x:6,y:6.1},{x:7,y:6.4},{x:8,y:6.7},
                        {x:9,y:6.9},{x:10,y:7.1},{x:11,y:7.3},{x:12,y:7.5},{x:13,y:7.6},{x:14,y:7.8},{x:15,y:8},{x:16,y:8.1},
                        {x:17,y:8.3},{x:18,y:8.4},{x:19,y:8.6},{x:20,y:8.7},{x:21,y:8.9},{x:22,y:9},{x:23,y:9.2},{x:24,y:9.3},
                        {x:25,y:9.5},{x:26,y:9.6},{x:27,y:9.7},{x:28,y:9.9},{x:29,y:10},{x:30,y:10.1},{x:31,y:10.3},{x:32,y:10.4},
                        {x:33,y:10.5},{x:34,y:10.6},{x:35,y:10.7},{x:36,y:10.8},{x:37,y:11},{x:38,y:11.1},{x:39,y:11.2},{x:40,y:11.3},
                        {x:41,y:11.4},{x:42,y:11.5},{x:43,y:11.7},{x:44,y:11.8},{x:45,y:11.9},{x:46,y:12},{x:47,y:12.1},{x:48,y:12.2},
                        {x:49,y:12.3},{x:50,y:12.4},{x:51,y:12.5},{x:52,y:12.6},{x:53,y:12.7},{x:54,y:12.9},{x:55,y:13},{x:56,y:13.1},
                        {x:57,y:13.2},{x:58,y:13.3},{x:59,y:13.4},{x:60,y:13.5}];

            var set2 = [{x:0,y:2.5},{x:1,y:3.4},{x:2,y:4.4},{x:3,y:5.1},{x:4,y:5.6},{x:5,y:6.1},{x:6,y:6.4},{x:7,y:6.7},{x:8,y:7},
                        {x:9,y:7.2},{x:10,y:7.5},{x:11,y:7.7},{x:12,y:7.8},{x:13,y:8},{x:14,y:8.2},{x:15,y:8.4},{x:16,y:8.5},
                        {x:17,y:8.7},{x:18,y:8.9},{x:19,y:9},{x:20,y:9.2},{x:21,y:9.3},{x:22,y:9.5},{x:23,y:9.7},{x:24,y:9.8},
                        {x:25,y:10},{x:26,y:10.1},{x:27,y:10.2},{x:28,y:10.4},{x:29,y:10.5},{x:30,y:10.7},{x:31,y:10.8},{x:32,y:10.9},
                        {x:33,y:11.1},{x:34,y:11.2},{x:35,y:11.3},{x:36,y:11.4},{x:37,y:11.6},{x:38,y:11.7},{x:39,y:11.8},{x:40,y:11.9},
                        {x:41,y:12.1},{x:42,y:12.2},{x:43,y:12.3},{x:44,y:12.4},{x:45,y:12.5},{x:46,y:12.7},{x:47,y:12.8},{x:48,y:12.9},
                        {x:49,y:13},{x:50,y:13.1},{x:51,y:13.3},{x:52,y:13.4},{x:53,y:13.5},{x:54,y:13.6},{x:55,y:13.7},{x:56,y:13.8},
                        {x:57,y:13.9},{x:58,y:14.1},{x:59,y:14.2},{x:60,y:14.3}];

            var set3 = [{x:0,y:3.3},{x:1,y:4.5},{x:2,y:5.6},{x:3,y:6.4},{x:4,y:7},{x:5,y:7.5},{x:6,y:7.9},{x:7,y:8.3},{x:8,y:8.6},
                        {x:9,y:8.9},{x:10,y:9.2},{x:11,y:9.4},{x:12,y:9.6},{x:13,y:9.9},{x:14,y:10.1},{x:15,y:10.3},{x:16,y:10.5},
                        {x:17,y:10.7},{x:18,y:10.9},{x:19,y:11.1},{x:20,y:11.3},{x:21,y:11.5},{x:22,y:11.8},{x:23,y:12},{x:24,y:12.2},
                        {x:25,y:12.4},{x:26,y:12.5},{x:27,y:12.7},{x:28,y:12.9},{x:29,y:13.1},{x:30,y:13.3},{x:31,y:13.5},{x:32,y:13.7},
                        {x:33,y:13.8},{x:34,y:14},{x:35,y:14.2},{x:36,y:14.3},{x:37,y:14.5},{x:38,y:14.7},{x:39,y:14.8},{x:40,y:15},
                        {x:41,y:15.2},{x:42,y:15.3},{x:43,y:15.5},{x:44,y:15.7},{x:45,y:15.8},{x:46,y:16},{x:47,y:16.2},{x:48,y:16.3},
                        {x:49,y:16.5},{x:50,y:16.7},{x:51,y:16.8},{x:52,y:17},{x:53,y:17.2},{x:54,y:17.3},{x:55,y:17.5},{x:56,y:17.7},
                        {x:57,y:17.8},{x:58,y:18},{x:59,y:18.2},{x:60,y:18.3}];

            var set4 = [{x:0,y:4.3},{x:1,y:5.7},{x:2,y:7},{x:3,y:7.9},{x:4,y:8.6},{x:5,y:9.2},{x:6,y:9.7},{x:7,y:10.2},{x:8,y:10.5},
                        {x:9,y:10.9},{x:10,y:11.2},{x:11,y:11.5},{x:12,y:11.8},{x:13,y:12.1},{x:14,y:12.4},{x:15,y:12.7},{x:16,y:12.9},
                        {x:17,y:13.2},{x:18,y:13.5},{x:19,y:13.7},{x:20,y:14},{x:21,y:14.3},{x:22,y:14.5},{x:23,y:14.8},{x:24,y:15.1},
                        {x:25,y:15.3},{x:26,y:15.6},{x:27,y:15.9},{x:28,y:16.1},{x:29,y:16.4},{x:30,y:16.6},{x:31,y:16.9},{x:32,y:17.1},
                        {x:33,y:17.3},{x:34,y:17.6},{x:35,y:17.8},{x:36,y:18},{x:37,y:18.3},{x:38,y:18.5},{x:39,y:18.7},{x:40,y:19},
                        {x:41,y:19.2},{x:42,y:19.4},{x:43,y:19.7},{x:44,y:19.9},{x:45,y:20.1},{x:46,y:20.4},{x:47,y:20.6},{x:48,y:20.9},
                        {x:49,y:21.1},{x:50,y:21.3},{x:51,y:21.6},{x:52,y:21.8},{x:53,y:22.1},{x:54,y:22.3},{x:55,y:22.5},{x:56,y:22.8},
                        {x:57,y:23},{x:58,y:23.3},{x:59,y:23.5},{x:60,y:23.8}];
            // End of Weight data
            
            // Start of Head data
            var set5 = [{x:0,y:32.1},{x:1,y:35.1},{x:2,y:36.9},{x:3,y:38.3},{x:4,y:39.4},{x:5,y:40.3},{x:6,y:41},{x:7,y:41.7},{x:8,y:42.2},
                        {x:9,y:42.6},{x:10,y:43},{x:11,y:43.4},{x:12,y:43.6},{x:13,y:43.9},{x:14,y:44.1},{x:15,y:44.3},{x:16,y:44.5},
                        {x:17,y:44.7},{x:18,y:44.9},{x:19,y:45},{x:20,y:45.2},{x:21,y:45.3},{x:22,y:45.4},{x:23,y:45.6},{x:24,y:45.7},
                        {x:25,y:45.8},{x:26,y:45.9},{x:27,y:46},{x:28,y:46.1},{x:29,y:46.2},{x:30,y:46.3},{x:31,y:46.4},{x:32,y:46.5},
                        {x:33,y:46.6},{x:34,y:46.6},{x:35,y:46.7},{x:36,y:46.8},{x:37,y:46.9},{x:38,y:46.9},{x:39,y:47},{x:40,y:47},
                        {x:41,y:47.1},{x:42,y:47.2},{x:43,y:47.2},{x:44,y:47.3},{x:45,y:47.3},{x:46,y:47.4},{x:47,y:47.4},{x:48,y:47.5},
                        {x:49,y:47.5},{x:50,y:47.5},{x:51,y:47.6},{x:52,y:47.6},{x:53,y:47.7},{x:54,y:47.7},{x:55,y:47.7},{x:56,y:47.8},
                        {x:57,y:47.8},{x:58,y:47.9},{x:59,y:47.9},{x:60,y:47.9}];

            var set6 = [{x:0,y:34.5},{x:1,y:37.3},{x:2,y:39.1},{x:3,y:40.5},{x:4,y:41.6},{x:5,y:42.6},{x:6,y:43.3},{x:7,y:44},{x:8,y:44.5},
                        {x:9,y:45},{x:10,y:45.4},{x:11,y:45.8},{x:12,y:46.1},{x:13,y:46.3},{x:14,y:46.6},{x:15,y:46.8},{x:16,y:47},
                        {x:17,y:47.2},{x:18,y:47.4},{x:19,y:47.5},{x:20,y:47.7},{x:21,y:47.8},{x:22,y:48},{x:23,y:48.1},{x:24,y:48.3},
                        {x:25,y:48.4},{x:26,y:48.5},{x:27,y:48.6},{x:28,y:48.7},{x:29,y:48.8},{x:30,y:48.9},{x:31,y:49},{x:32,y:49.1},
                        {x:33,y:49.2},{x:34,y:49.3},{x:35,y:49.4},{x:36,y:49.5},{x:37,y:49.5},{x:38,y:49.6},{x:39,y:49.7},{x:40,y:49.7},
                        {x:41,y:49.8},{x:42,y:49.9},{x:43,y:49.9},{x:44,y:50},{x:45,y:50.1},{x:46,y:50.1},{x:47,y:50.2},{x:48,y:50.2},
                        {x:49,y:50.3},{x:50,y:50.3},{x:51,y:50.4},{x:52,y:50.4},{x:53,y:50.4},{x:54,y:50.5},{x:55,y:50.5},{x:56,y:50.6},
                        {x:57,y:50.6},{x:58,y:50.7},{x:59,y:50.7},{x:60,y:50.7}];

            var set7 = [{x:0,y:36.9},{x:1,y:39.5},{x:2,y:41.3},{x:3,y:42.7},{x:4,y:43.9},{x:5,y:44.8},{x:6,y:45.6},{x:7,y:46.3},{x:8,y:46.9},
                        {x:9,y:47.4},{x:10,y:47.8},{x:11,y:48.2},{x:12,y:48.5},{x:13,y:48.8},{x:14,y:49},{x:15,y:49.3},{x:16,y:49.5},
                        {x:17,y:49.7},{x:18,y:49.9},{x:19,y:50},{x:20,y:50.2},{x:21,y:50.4},{x:22,y:50.5},{x:23,y:50.7},{x:24,y:50.8},
                        {x:25,y:50.9},{x:26,y:51.1},{x:27,y:51.2},{x:28,y:51.3},{x:29,y:51.4},{x:30,y:51.6},{x:31,y:51.7},{x:32,y:51.8},
                        {x:33,y:51.9},{x:34,y:52},{x:35,y:52},{x:36,y:52.1},{x:37,y:52.2},{x:38,y:52.3},{x:39,y:52.4},{x:40,y:52.4},
                        {x:41,y:52.5},{x:42,y:52.6},{x:43,y:52.7},{x:44,y:52.7},{x:45,y:52.8},{x:46,y:52.8},{x:47,y:52.9},{x:48,y:53},
                        {x:49,y:53},{x:50,y:53.1},{x:51,y:53.1},{x:52,y:53.2},{x:53,y:53.2},{x:54,y:53.3},{x:55,y:53.3},{x:56,y:53.4},
                        {x:57,y:53.4},{x:58,y:53.5},{x:59,y:53.5},{x:60,y:53.5}];
            // End of Head data

            // Start of Height/Lenght data
            var set8 = [{x:0,y:45.5},{x:1,y:50.2},{x:2,y:53.8},{x:3,y:56.7},{x:4,y:59},{x:5,y:61},{x:6,y:62.6},{x:7,y:64.1},{x:8,y:65.5},
                        {x:9,y:66.8},{x:10,y:68},{x:11,y:69.1},{x:12,y:70.2},{x:13,y:71.3},{x:14,y:72.3},{x:15,y:73.3},{x:16,y:74.2},
                        {x:17,y:75.1},{x:18,y:76},{x:19,y:76.8},{x:20,y:77.7},{x:21,y:78.4},{x:22,y:79.2},{x:23,y:80},{x:24,y:80.7},
                        {x:25,y:80.7},{x:26,y:81.4},{x:27,y:82.1},{x:28,y:82.8},{x:29,y:83.4},{x:30,y:84},{x:31,y:84.6},{x:32,y:85.2},
                        {x:33,y:85.8},{x:34,y:86.4},{x:35,y:86.9},{x:36,y:87.5},{x:37,y:88},{x:38,y:88.5},{x:39,y:89.1},{x:40,y:89.6},
                        {x:41,y:90.1},{x:42,y:90.6},{x:43,y:91.1},{x:44,y:91.6},{x:45,y:92.1},{x:46,y:92.6},{x:47,y:93.1},{x:48,y:93.6},
                        {x:49,y:94},{x:50,y:94.5},{x:51,y:95},{x:52,y:95.5},{x:53,y:95.9},{x:54,y:96.4},{x:55,y:96.9},{x:56,y:97.3},
                        {x:57,y:97.8},{x:58,y:98.3},{x:59,y:98.7},{x:60,y:99.2}];
            
            var set9 = [{x:0,y:46.3},{x:1,y:51.1},{x:2,y:54.7},{x:3,y:57.6},{x:4,y:60},{x:5,y:61.9},{x:6,y:63.6},{x:7,y:65.1},{x:8,y:66.5},
                        {x:9,y:67.7},{x:10,y:69},{x:11,y:70.2},{x:12,y:71.3},{x:13,y:72.4},{x:14,y:73.4},{x:15,y:74.4},{x:16,y:75.4},
                        {x:17,y:76.3},{x:18,y:77.2},{x:19,y:78.1},{x:20,y:78.9},{x:21,y:79.7},{x:22,y:80.5},{x:23,y:81.3},{x:24,y:82.1},
                        {x:25,y:82.1},{x:26,y:82.8},{x:27,y:83.5},{x:28,y:84.2},{x:29,y:84.9},{x:30,y:85.5},{x:31,y:86.2},{x:32,y:86.8},
                        {x:33,y:87.4},{x:34,y:88},{x:35,y:88.5},{x:36,y:89.1},{x:37,y:89.7},{x:38,y:90.2},{x:39,y:90.8},{x:40,y:91.3},
                        {x:41,y:91.9},{x:42,y:92.4},{x:43,y:92.9},{x:44,y:93.4},{x:45,y:93.9},{x:46,y:94.4},{x:47,y:94.9},{x:48,y:95.4},
                        {x:49,y:95.9},{x:50,y:96.4},{x:51,y:96.9},{x:52,y:97.4},{x:53,y:97.9},{x:54,y:98.4},{x:55,y:98.8},{x:56,y:99.3},
                        {x:57,y:99.8},{x:58,y:100.3},{x:59,y:100.8},{x:60,y:101.2}];

            var set10 = [{x:0,y:49.9},{x:1,y:54.7},{x:2,y:58.4},{x:3,y:61.4},{x:4,y:63.9},{x:5,y:65.9},{x:6,y:67.6},{x:7,y:69.2},{x:8,y:70.6},
                        {x:9,y:72},{x:10,y:73.3},{x:11,y:74.5},{x:12,y:75.7},{x:13,y:76.9},{x:14,y:78},{x:15,y:79.1},{x:16,y:80.2},{x:17,y:81.2},
                        {x:18,y:82.3},{x:19,y:83.2},{x:20,y:84.2},{x:21,y:85.1},{x:22,y:86},{x:23,y:86.9},{x:24,y:87.8},{x:25,y:88},{x:26,y:88.8},
                        {x:27,y:89.6},{x:28,y:90.4},{x:29,y:91.2},{x:30,y:91.9},{x:31,y:92.7},{x:32,y:93.4},{x:33,y:94.1},{x:34,y:94.8},{x:35,y:95.4},
                        {x:36,y:96.1},{x:37,y:96.7},{x:38,y:97.4},{x:39,y:98},{x:40,y:98.6},{x:41,y:99.2},{x:42,y:99.9},{x:43,y:100.4},{x:44,y:101},
                        {x:45,y:101.6},{x:46,y:102.2},{x:47,y:102.8},{x:48,y:103.3},{x:49,y:103.9},{x:50,y:104.4},{x:51,y:105},{x:52,y:105.6},
                        {x:53,y:106.1},{x:54,y:106.7},{x:55,y:107.2},{x:56,y:107.8},{x:57,y:108.3},{x:58,y:108.9},{x:59,y:109.4},{x:60,y:110}];

            var set11 = [{x:0,y:53.4},{x:1,y:58.4},{x:2,y:62.2},{x:3,y:65.3},{x:4,y:67.8},{x:5,y:69.9},{x:6,y:71.6},{x:7,y:73.2},
                        {x:8,y:74.7},{x:9,y:76.2},{x:10,y:77.6},{x:11,y:78.9},{x:12,y:80.2},{x:13,y:81.5},{x:14,y:82.7},{x:15,y:83.9},
                        {x:16,y:85.1},{x:17,y:86.2},{x:18,y:87.3},{x:19,y:88.4},{x:20,y:89.5},{x:21,y:90.5},{x:22,y:91.6},{x:23,y:92.6},
                        {x:24,y:93.6},{x:25,y:93.8},{x:26,y:94.8},{x:27,y:95.7},{x:28,y:96.6},{x:29,y:97.5},{x:30,y:98.3},{x:31,y:99.2},
                        {x:32,y:100},{x:33,y:100.8},{x:34,y:101.5},{x:35,y:102.3},{x:36,y:103.1},{x:37,y:103.8},{x:38,y:104.5},
                        {x:39,y:105.2},{x:40,y:105.9},{x:41,y:106.6},{x:42,y:107.3},{x:43,y:108},{x:44,y:108.6},{x:45,y:109.3},
                        {x:46,y:109.9},{x:47,y:110.6},{x:48,y:111.2},{x:49,y:111.8},{x:50,y:112.5},{x:51,y:113.1},{x:52,y:113.7},
                        {x:53,y:114.3},{x:54,y:115},{x:55,y:115.6},{x:56,y:116.2},{x:57,y:116.8},{x:58,y:117.4},{x:59,y:118.1},
                        {x:60,y:118.7}];
            // End of Height/Lenght data
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter2 = wrap2.enter().append('g').attr('class', 'd3line').append('g');

            var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([headData]);
            var gEnter3 = wrap3.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([60.5,0]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([60.5,0]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,131.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,131.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(0, 60.5, 1)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(0, 60.5, 1)).tickFormat(function(d){
                return d%2==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 131, 3)).tickFormat(function(d){
                return d%3==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 131, 3)).tickFormat(function(d){
                return d%3==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var headpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -40 )
                .style("text-anchor", "middle")
                .text("WHO Boys Height, Weight, Head Charts 0-5 years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Age in Months");

                svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 50 )
                .style("text-anchor", "middle")
                .style("font-size","10px")
                .text("Ref: IAP Growth Charts. Indian Academy of Pediatrics. [updated 2013 18 Oct, cited 2016 14 Jan] Available from: http://www.iapindia.org/page.php?id=79");
            
            svg.append("text")
                .attr("x", -350 )
                .attr("y", -35)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("WHO MGRS 2006 Charts; Acta Paediatrics Suppl. 450:2006");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 240 )
                .style("text-anchor", "start")
                .text("1 (-3)");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 225 )
                .style("text-anchor", "start")
                .text("3 (-2)");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 160 )
                .style("text-anchor", "start")
                .text("50 (0)");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 95 )
                .style("text-anchor", "start")
                .text("97 (+2)");

              svg.append("text")
                  .attr("x", 650 )
                  .attr("y", 95 )
                  .style("text-anchor", "start")
                  .text("Height/Lenght");

              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 610 )
                  .style("text-anchor", "start")
                  .text("3 (-2)");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 585 )
                  .style("text-anchor", "start")
                  .text("50 (0)");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 565 )
                  .style("text-anchor", "start")
                  .text("97 (+2)");

              svg.append("text")
                  .attr("x", 650 )
                  .attr("y", 565 )
                  .style("text-anchor", "start")
                  .text("Head");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 855 )
                  .style("text-anchor", "start")
                  .text("1 (-3)");
            
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 840 )
                  .style("text-anchor", "start")
                  .text("3 (-2)");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 810 )
                  .style("text-anchor", "start")
                  .text("50 (0)");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 770 )
                  .style("text-anchor", "start")
                  .text("97 (+2)");
                  
              svg.append("text")
                  .attr("x", 650 )
                  .attr("y", 770 )
                  .style("text-anchor", "start")
                  .text("Weight");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(headData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('wlratioChartFemalePrint', function() {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 980'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var wlRatioData = [];

            if(vitalData.pretermwhRatio) {
                for(var i = 0; i < vitalData.pretermwhRatio.length; i++){
                    console.log(vitalData.pretermwhRatio[i]);
                    if(vitalData.pretermwhRatio[i].y<7.1) {
                        wlRatioData.push(vitalData.pretermwhRatio[i]);
                    }
                }
            }

    var set1 = [{x:168,y:1.04},{x:169,y:1.06},{x:170,y:1.07},{x:171,y:1.09},{x:172,y:1.1},{x:173,y:1.12},{x:174,y:1.14},
                {x:175,y:1.15},{x:176,y:1.17},{x:177,y:1.19},{x:178,y:1.21},{x:179,y:1.23},{x:180,y:1.25},{x:181,y:1.27},
                {x:182,y:1.29},{x:183,y:1.31},{x:184,y:1.34},{x:185,y:1.36},{x:186,y:1.39},{x:187,y:1.41},{x:188,y:1.44},
                {x:189,y:1.46},{x:190,y:1.49},{x:191,y:1.52},{x:192,y:1.55},{x:193,y:1.58},{x:194,y:1.61},{x:195,y:1.64},
                {x:196,y:1.67},{x:197,y:1.7},{x:198,y:1.73},{x:199,y:1.77},{x:200,y:1.8},{x:201,y:1.84},{x:202,y:1.87},
                {x:203,y:1.91},{x:204,y:1.95},{x:205,y:1.99},{x:206,y:2.03},{x:207,y:2.07},{x:208,y:2.11},{x:209,y:2.15},
                {x:210,y:2.19},{x:211,y:2.23},{x:212,y:2.28},{x:213,y:2.32},{x:214,y:2.37},{x:215,y:2.42},{x:216,y:2.46},
                {x:217,y:2.51},{x:218,y:2.56},{x:219,y:2.61},{x:220,y:2.66},{x:221,y:2.72},{x:222,y:2.77},{x:223,y:2.82},
                {x:224,y:2.88},{x:225,y:2.93},{x:226,y:2.99},{x:227,y:3.05},{x:228,y:3.11},{x:229,y:3.17},{x:230,y:3.23}];

    var set2 = [{x:168,y:1.4},{x:169,y:1.42},{x:170,y:1.43},{x:171,y:1.45},{x:172,y:1.46},{x:173,y:1.48},{x:174,y:1.49},
                {x:175,y:1.51},{x:176,y:1.53},{x:177,y:1.55},{x:178,y:1.57},{x:179,y:1.59},{x:180,y:1.61},{x:181,y:1.63},
                {x:182,y:1.65},{x:183,y:1.67},{x:184,y:1.7},{x:185,y:1.72},{x:186,y:1.74},{x:187,y:1.77},{x:188,y:1.79},
                {x:189,y:1.82},{x:190,y:1.85},{x:191,y:1.88},{x:192,y:1.91},{x:193,y:1.93},{x:194,y:1.96},{x:195,y:2},
                {x:196,y:2.03},{x:197,y:2.06},{x:198,y:2.09},{x:199,y:2.13},{x:200,y:2.16},{x:201,y:2.2},{x:202,y:2.23},
                {x:203,y:2.27},{x:204,y:2.31},{x:205,y:2.35},{x:206,y:2.38},{x:207,y:2.42},{x:208,y:2.47},{x:209,y:2.51},
                {x:210,y:2.55},{x:211,y:2.59},{x:212,y:2.64},{x:213,y:2.68},{x:214,y:2.73},{x:215,y:2.78},{x:216,y:2.82},
                {x:217,y:2.87},{x:218,y:2.92},{x:219,y:2.97},{x:220,y:3.02},{x:221,y:3.07},{x:222,y:3.13},{x:223,y:3.18},
                {x:224,y:3.24},{x:225,y:3.29},{x:226,y:3.35},{x:227,y:3.41},{x:228,y:3.46},{x:229,y:3.52},{x:230,y:3.58}];
            
    var set3 = [{x:168,y:2.17},{x:169,y:2.18},{x:170,y:2.2},{x:171,y:2.21},{x:172,y:2.23},{x:173,y:2.24},{x:174,y:2.26},
                {x:175,y:2.28},{x:176,y:2.29},{x:177,y:2.31},{x:178,y:2.33},{x:179,y:2.35},{x:180,y:2.37},{x:181,y:2.39},
                {x:182,y:2.41},{x:183,y:2.44},{x:184,y:2.46},{x:185,y:2.48},{x:186,y:2.51},{x:187,y:2.53},{x:188,y:2.56},
                {x:189,y:2.59},{x:190,y:2.61},{x:191,y:2.64},{x:192,y:2.67},{x:193,y:2.7},{x:194,y:2.73},{x:195,y:2.76},
                {x:196,y:2.79},{x:197,y:2.82},{x:198,y:2.86},{x:199,y:2.89},{x:200,y:2.93},{x:201,y:2.96},{x:202,y:3},
                {x:203,y:3.03},{x:204,y:3.07},{x:205,y:3.11},{x:206,y:3.15},{x:207,y:3.19},{x:208,y:3.23},{x:209,y:3.27},
                {x:210,y:3.31},{x:211,y:3.36},{x:212,y:3.4},{x:213,y:3.45},{x:214,y:3.49},{x:215,y:3.54},{x:216,y:3.59},
                {x:217,y:3.64},{x:218,y:3.69},{x:219,y:3.74},{x:220,y:3.79},{x:221,y:3.84},{x:222,y:3.89},{x:223,y:3.95},
                {x:224,y:4},{x:225,y:4.06},{x:226,y:4.11},{x:227,y:4.17},{x:228,y:4.23},{x:229,y:4.29},{x:230,y:4.35}];

    var set4 = [{x:168,y:2.93},{x:169,y:2.95},{x:170,y:2.96},{x:171,y:2.98},{x:172,y:2.99},{x:173,y:3.01},{x:174,y:3.02},
                {x:175,y:3.04},{x:176,y:3.06},{x:177,y:3.08},{x:178,y:3.1},{x:179,y:3.12},{x:180,y:3.14},{x:181,y:3.16},
                {x:182,y:3.18},{x:183,y:3.2},{x:184,y:3.23},{x:185,y:3.25},{x:186,y:3.27},{x:187,y:3.3},{x:188,y:3.32},
                {x:189,y:3.35},{x:190,y:3.38},{x:191,y:3.41},{x:192,y:3.43},{x:193,y:3.46},{x:194,y:3.49},{x:195,y:3.52},
                {x:196,y:3.56},{x:197,y:3.59},{x:198,y:3.62},{x:199,y:3.66},{x:200,y:3.69},{x:201,y:3.73},{x:202,y:3.76},
                {x:203,y:3.8},{x:204,y:3.84},{x:205,y:3.87},{x:206,y:3.91},{x:207,y:3.95},{x:208,y:4},{x:209,y:4.04},
                {x:210,y:4.08},{x:211,y:4.12},{x:212,y:4.17},{x:213,y:4.21},{x:214,y:4.26},{x:215,y:4.31},{x:216,y:4.35},
                {x:217,y:4.4},{x:218,y:4.45},{x:219,y:4.5},{x:220,y:4.55},{x:221,y:4.6},{x:222,y:4.66},{x:223,y:4.71},
                {x:224,y:4.77},{x:225,y:4.82},{x:226,y:4.88},{x:227,y:4.94},{x:228,y:4.99},{x:229,y:5.05},{x:230,y:5.11}];

    var set5 = [{x:168,y:3.29},{x:169,y:3.31},{x:170,y:3.32},{x:171,y:3.33},{x:172,y:3.35},{x:173,y:3.37},{x:174,y:3.38},
                {x:175,y:3.4},{x:176,y:3.42},{x:177,y:3.44},{x:178,y:3.46},{x:179,y:3.47},{x:180,y:3.5},{x:181,y:3.52},
                {x:182,y:3.54},{x:183,y:3.56},{x:184,y:3.58},{x:185,y:3.61},{x:186,y:3.63},{x:187,y:3.66},{x:188,y:3.68},
                {x:189,y:3.71},{x:190,y:3.74},{x:191,y:3.76},{x:192,y:3.79},{x:193,y:3.82},{x:194,y:3.85},{x:195,y:3.88},
                {x:196,y:3.91},{x:197,y:3.95},{x:198,y:3.98},{x:199,y:4.01},{x:200,y:4.05},{x:201,y:4.08},{x:202,y:4.12},
                {x:203,y:4.16},{x:204,y:4.19},{x:205,y:4.23},{x:206,y:4.27},{x:207,y:4.31},{x:208,y:4.35},{x:209,y:4.4},
                {x:210,y:4.44},{x:211,y:4.48},{x:212,y:4.53},{x:213,y:4.57},{x:214,y:4.62},{x:215,y:4.66},{x:216,y:4.71},
                {x:217,y:4.76},{x:218,y:4.81},{x:219,y:4.86},{x:220,y:4.91},{x:221,y:4.96},{x:222,y:5.02},{x:223,y:5.07},
                {x:224,y:5.12},{x:225,y:5.18},{x:226,y:5.24},{x:227,y:5.29},{x:228,y:5.35},{x:229,y:5.41},{x:230,y:5.47}];

            var set6 = [];

            var set7 = [];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([wlRatioData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            }).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<7.1 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<7.1 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Gestational age at birth (weeks)");
            
            svg.append("text")
                .attr("x", 30 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("© University of Oxford");

            svg.append("text")
                .attr("x", 750 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("Villar et al. Pediatr Res 2017");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            
            svg.append("text")
                .attr("x", -10 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("32");
                    
            svg.append("text")
                .attr("x", 753 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -10 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("32");
                    
            svg.append("text")
                .attr("x", 753 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -400 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight-length ratio (kg/m)");

            svg.append("text")
                .attr("x", -400 )
                .attr("y", 860 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight-length ratio (kg/m)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 495 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 442 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 340 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 240 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 190 )
                .style("text-anchor", "start")
                .text("97 th");
                
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            svg.append("svg:path")
                    .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });
            // svg.append("svg:path")
            //       .attr({
            //         d: lineFunc(set6),
            //         "stroke": "black",
            //         "stroke-width": 2,
            //         "fill": "none",
            //         "class": "path"
            //       });
            // svg.append("svg:path")
            //       .attr({
            //         d: lineFunc(set7),
            //         "stroke": "black",
            //         "stroke-width": 2,
            //         "fill": "none",
            //         "class": "path"
            //       });
            
            // user data
            svg.append("svg:path")
                    .attr({
                    d: datalineFunc(wlRatioData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                    });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('wlratioChartMalePrint', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:4%;' viewBox='0 0 1010 980'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 1000 - margin.top - margin.bottom;
            var width = 960 - margin.left - margin.right;

            var wlRatioData = [];

            if(vitalData.pretermwhRatio) {
                for(var i = 0; i < vitalData.pretermwhRatio.length; i++){
                    console.log(vitalData.pretermwhRatio[i]);
                    if(vitalData.pretermwhRatio[i].y<7.1) {
                        wlRatioData.push(vitalData.pretermwhRatio[i]);
                    }
                }
            }

            var set1 = [{x:168,y:1.18},{x:169,y:1.2},{x:170,y:1.21},{x:171,y:1.23},{x:172,y:1.24},{x:173,y:1.26},{x:174,y:1.27},
                        {x:175,y:1.29},{x:176,y:1.31},{x:177,y:1.33},{x:178,y:1.35},{x:179,y:1.37},{x:180,y:1.39},{x:181,y:1.41},
                        {x:182,y:1.43},{x:183,y:1.45},{x:184,y:1.48},{x:185,y:1.5},{x:186,y:1.52},{x:187,y:1.55},{x:188,y:1.57},
                        {x:189,y:1.6},{x:190,y:1.63},{x:191,y:1.66},{x:192,y:1.68},{x:193,y:1.71},{x:194,y:1.74},{x:195,y:1.78},
                        {x:196,y:1.81},{x:197,y:1.84},{x:198,y:1.87},{x:199,y:1.91},{x:200,y:1.94},{x:201,y:1.98},{x:202,y:2.01},
                        {x:203,y:2.05},{x:204,y:2.09},{x:205,y:2.13},{x:206,y:2.16},{x:207,y:2.2},{x:208,y:2.25},{x:209,y:2.29},
                        {x:210,y:2.33},{x:211,y:2.37},{x:212,y:2.42},{x:213,y:2.46},{x:214,y:2.51},{x:215,y:2.56},{x:216,y:2.6},
                        {x:217,y:2.65},{x:218,y:2.7},{x:219,y:2.75},{x:220,y:2.8},{x:221,y:2.85},{x:222,y:2.91},{x:223,y:2.96},
                        {x:224,y:3.02},{x:225,y:3.07},{x:226,y:3.13},{x:227,y:3.19},{x:228,y:3.24},{x:229,y:3.3},{x:230,y:3.36}];

            var set2 = [{x:168,y:1.54},{x:169,y:1.56},{x:170,y:1.57},{x:171,y:1.58},{x:172,y:1.6},{x:173,y:1.62},{x:174,y:1.63},
                        {x:175,y:1.65},{x:176,y:1.67},{x:177,y:1.69},{x:178,y:1.71},{x:179,y:1.73},{x:180,y:1.75},{x:181,y:1.77},
                        {x:182,y:1.79},{x:183,y:1.81},{x:184,y:1.83},{x:185,y:1.86},{x:186,y:1.88},{x:187,y:1.91},{x:188,y:1.93},
                        {x:189,y:1.96},{x:190,y:1.99},{x:191,y:2.01},{x:192,y:2.04},{x:193,y:2.07},{x:194,y:2.1},{x:195,y:2.13},
                        {x:196,y:2.17},{x:197,y:2.2},{x:198,y:2.23},{x:199,y:2.26},{x:200,y:2.3},{x:201,y:2.33},{x:202,y:2.37},
                        {x:203,y:2.41},{x:204,y:2.45},{x:205,y:2.48},{x:206,y:2.52},{x:207,y:2.56},{x:208,y:2.6},{x:209,y:2.65},
                        {x:210,y:2.69},{x:211,y:2.73},{x:212,y:2.78},{x:213,y:2.82},{x:214,y:2.87},{x:215,y:2.91},{x:216,y:2.96},
                        {x:217,y:3.01},{x:218,y:3.06},{x:219,y:3.11},{x:220,y:3.16},{x:221,y:3.21},{x:222,y:3.27},{x:223,y:3.32},
                        {x:224,y:3.37},{x:225,y:3.43},{x:226,y:3.49},{x:227,y:3.54},{x:228,y:3.6},{x:229,y:3.66},{x:230,y:3.72}];
                    
            var set3 = [{x:168,y:2.31},{x:169,y:2.32},{x:170,y:2.33},{x:171,y:2.35},{x:172,y:2.36},{x:173,y:2.38},{x:174,y:2.4},
                        {x:175,y:2.41},{x:176,y:2.43},{x:177,y:2.45},{x:178,y:2.47},{x:179,y:2.49},{x:180,y:2.51},{x:181,y:2.53},
                        {x:182,y:2.55},{x:183,y:2.58},{x:184,y:2.6},{x:185,y:2.62},{x:186,y:2.65},{x:187,y:2.67},{x:188,y:2.7},
                        {x:189,y:2.72},{x:190,y:2.75},{x:191,y:2.78},{x:192,y:2.81},{x:193,y:2.84},{x:194,y:2.87},{x:195,y:2.9},
                        {x:196,y:2.93},{x:197,y:2.96},{x:198,y:3},{x:199,y:3.03},{x:200,y:3.06},{x:201,y:3.1},{x:202,y:3.14},
                        {x:203,y:3.17},{x:204,y:3.21},{x:205,y:3.25},{x:206,y:3.29},{x:207,y:3.33},{x:208,y:3.37},{x:209,y:3.41},
                        {x:210,y:3.45},{x:211,y:3.5},{x:212,y:3.54},{x:213,y:3.59},{x:214,y:3.63},{x:215,y:3.68},{x:216,y:3.73},
                        {x:217,y:3.77},{x:218,y:3.82},{x:219,y:3.87},{x:220,y:3.93},{x:221,y:3.98},{x:222,y:4.03},{x:223,y:4.08},
                        {x:224,y:4.14},{x:225,y:4.19},{x:226,y:4.25},{x:227,y:4.31},{x:228,y:4.37},{x:229,y:4.43},{x:230,y:4.49}];

            var set4 = [{x:168,y:3.07},{x:169,y:3.09},{x:170,y:3.1},{x:171,y:3.11},{x:172,y:3.13},{x:173,y:3.15},{x:174,y:3.16},
                        {x:175,y:3.18},{x:176,y:3.2},{x:177,y:3.22},{x:178,y:3.23},{x:179,y:3.25},{x:180,y:3.28},{x:181,y:3.3},
                        {x:182,y:3.32},{x:183,y:3.34},{x:184,y:3.36},{x:185,y:3.39},{x:186,y:3.41},{x:187,y:3.44},{x:188,y:3.46},
                        {x:189,y:3.49},{x:190,y:3.52},{x:191,y:3.54},{x:192,y:3.57},{x:193,y:3.6},{x:194,y:3.63},{x:195,y:3.66},
                        {x:196,y:3.69},{x:197,y:3.73},{x:198,y:3.76},{x:199,y:3.79},{x:200,y:3.83},{x:201,y:3.86},{x:202,y:3.9},
                        {x:203,y:3.94},{x:204,y:3.97},{x:205,y:4.01},{x:206,y:4.05},{x:207,y:4.09},{x:208,y:4.13},{x:209,y:4.18},
                        {x:210,y:4.22},{x:211,y:4.26},{x:212,y:4.31},{x:213,y:4.35},{x:214,y:4.4},{x:215,y:4.44},{x:216,y:4.49},
                        {x:217,y:4.54},{x:218,y:4.59},{x:219,y:4.64},{x:220,y:4.69},{x:221,y:4.74},{x:222,y:4.8},{x:223,y:4.85},
                        {x:224,y:4.9},{x:225,y:4.96},{x:226,y:5.02},{x:227,y:5.07},{x:228,y:5.13},{x:229,y:5.19},{x:230,y:5.25}];

            var set5 = [{x:168,y:3.43},{x:169,y:3.44},{x:170,y:3.46},{x:171,y:3.47},{x:172,y:3.49},{x:173,y:3.5},{x:174,y:3.52},
                        {x:175,y:3.54},{x:176,y:3.56},{x:177,y:3.57},{x:178,y:3.59},{x:179,y:3.61},{x:180,y:3.63},{x:181,y:3.65},
                        {x:182,y:3.68},{x:183,y:3.7},{x:184,y:3.72},{x:185,y:3.75},{x:186,y:3.77},{x:187,y:3.8},{x:188,y:3.82},
                        {x:189,y:3.85},{x:190,y:3.87},{x:191,y:3.9},{x:192,y:3.93},{x:193,y:3.96},{x:194,y:3.99},{x:195,y:4.02},
                        {x:196,y:4.05},{x:197,y:4.09},{x:198,y:4.12},{x:199,y:4.15},{x:200,y:4.19},{x:201,y:4.22},{x:202,y:4.26},
                        {x:203,y:4.3},{x:204,y:4.33},{x:205,y:4.37},{x:206,y:4.41},{x:207,y:4.45},{x:208,y:4.49},{x:209,y:4.53},
                        {x:210,y:4.58},{x:211,y:4.62},{x:212,y:4.66},{x:213,y:4.71},{x:214,y:4.76},{x:215,y:4.8},{x:216,y:4.85},
                        {x:217,y:4.9},{x:218,y:4.95},{x:219,y:5},{x:220,y:5.05},{x:221,y:5.1},{x:222,y:5.15},{x:223,y:5.21},
                        {x:224,y:5.26},{x:225,y:5.32},{x:226,y:5.37},{x:227,y:5.43},{x:228,y:5.49},{x:229,y:5.55},{x:230,y:5.61}];

            var set6 = [];

            var set7 = [];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([wlRatioData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
				return '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<7.1 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<7.1 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Gestational age at birth (weeks)");
            
            svg.append("text")
                .attr("x", 30 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("© University of Oxford");

            svg.append("text")
                .attr("x", 750 )
                .attr("y", height+45 )
                .style("text-anchor", "middle")
                .style("font-size","12px")
                .text("Villar et al. Pediatr Res 2017");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            
            svg.append("text")
                .attr("x", -10 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("32");
                   
            svg.append("text")
                .attr("x", 753 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -10 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("24");
            
            svg.append("text")
                .attr("x", 79 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 159 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("26");
            
            svg.append("text")
                .attr("x", 244 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("27");
            
            svg.append("text")
                .attr("x", 330 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("28");
            
            svg.append("text")
                .attr("x", 415 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("29");
            
            svg.append("text")
                .attr("x", 500 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("30");
            
            svg.append("text")
                .attr("x", 585 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("31");
            
            svg.append("text")
                .attr("x", 670 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("32");
                   
            svg.append("text")
                .attr("x", 753 )
                .attr("y", -12 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -400 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight-length ratio (kg/m)");

            svg.append("text")
                .attr("x", -400 )
                .attr("y", 860 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight-length ratio (kg/m)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 495 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 442 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 340 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 770 )
                .attr("y", 240 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 770 )
                .attr("y", 190 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            // svg.append("svg:path")
            //       .attr({
            //         d: lineFunc(set6),
            //         "stroke": "black",
            //         "stroke-width": 2,
            //         "fill": "none",
            //         "class": "path"
            //       });
            // svg.append("svg:path")
            //       .attr({
            //         d: lineFunc(set7),
            //         "stroke": "black",
            //         "stroke-width": 2,
            //         "fill": "none",
            //         "class": "path"
            //       });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(wlRatioData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('combinedChartFemaleSmall', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;
//             .tickFormat(function(d) {
//     return d % 1 ? d + .1 : d;
//   })     

            var heightData = [];
            var weightData = [];

            if(vitalData.height){
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x>59 && vitalData.height[i].x<217) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            if(vitalData.weight) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x>59 && vitalData.weight[i].x<217) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var set1 = [{x:60,y:97.2},{x:66,y:99.8},{x:72,y:102.3},{x:78,y:104.9},{x:84,y:107.4},{x:90,y:110},
                        {x:96,y:112.6},{x:102,y:115.2},{x:108,y:117.8},{x:114,y:120.5},{x:120,y:123.3},{x:126,y:126.1},{x:132,y:128.8},
                        {x:138,y:131.5},{x:144,y:134},{x:150,y:136.3},{x:156,y:138.2},{x:162,y:139.9},{x:168,y:141.3},{x:174,y:142.4},
                        {x:180,y:143.3},{x:186,y:144.1},{x:192,y:144.7},{x:198,y:145.2},{x:204,y:145.7},{x:210,y:146.2},{x:216,y:146.6}];

            var set2 = [{x:60,y:100.5},{x:66,y:103.2},{x:72,y:106},{x:78,y:108.7},{x:84,y:111.4},{x:90,y:114.1},{x:96,y:116.8},
                        {x:102,y:119.6},{x:108,y:122.4},{x:114,y:125.2},{x:120,y:128.1},{x:126,y:130.9},{x:132,y:133.7},
                        {x:138,y:136.4},{x:144,y:138.9},{x:150,y:141.1},{x:156,y:142.9},{x:162,y:144.5},{x:168,y:145.8},{x:174,y:146.8},
                        {x:180,y:147.5},{x:186,y:148.1},{x:192,y:148.6},{x:198,y:149.1},{x:204,y:149.5},{x:210,y:149.8},{x:216,y:150.2}];
                    
            var set3 = [{x:60,y:103.9},{x:66,y:106.8},{x:72,y:109.7},{x:78,y:112.5},{x:84,y:115.4},{x:90,y:118.2},{x:96,y:121.1},
                        {x:102,y:124},{x:108,y:126.9},{x:114,y:129.9},{x:120,y:132.8},{x:126,y:135.7},{x:132,y:138.6},
                        {x:138,y:141.2},{x:144,y:143.7},{x:150,y:145.8},{x:156,y:147.6},{x:162,y:149.1},{x:168,y:150.2},{x:174,y:151.1},
                        {x:180,y:151.8},{x:186,y:152.3},{x:192,y:152.7},{x:198,y:153.1},{x:204,y:153.4},{x:210,y:153.6},{x:216,y:153.9}];

            var set4 = [{x:60,y:107.5},{x:66,y:110.5},{x:72,y:113.5},{x:78,y:116.5},{x:84,y:119.4},{x:90,y:122.4},{x:96,y:125.4},
                        {x:102,y:128.4},{x:108,y:131.4},{x:114,y:134.4},{x:120,y:137.4},{x:126,y:140.4},{x:132,y:143.3},
                        {x:138,y:145.9},{x:144,y:148.4},{x:150,y:150.5},{x:156,y:152.2},{x:162,y:153.6},{x:168,y:154.7},{x:174,y:155.5},
                        {x:180,y:156.1},{x:186,y:156.6},{x:192,y:156.9},{x:198,y:157.2},{x:204,y:157.4},{x:210,y:157.6},{x:216,y:157.8}];

            var set5 = [{x:60,y:111.3},{x:66,y:114.4},{x:72,y:117.4},{x:78,y:120.5},{x:84,y:123.5},{x:90,y:126.6},{x:96,y:129.6},
                        {x:102,y:132.7},{x:108,y:135.8},{x:114,y:138.9},{x:120,y:142},{x:126,y:145},{x:132,y:147.9},
                        {x:138,y:150.6},{x:144,y:153},{x:150,y:155.1},{x:156,y:156.8},{x:162,y:158.2},{x:168,y:159.2},{x:174,y:160},
                        {x:180,y:160.5},{x:186,y:160.9},{x:192,y:161.2},{x:198,y:161.4},{x:204,y:161.6},{x:210,y:161.7},{x:216,y:161.9}];

            var set6 = [{x:60,y:115.2},{x:66,y:118.3},{x:72,y:121.5},{x:78,y:124.6},{x:84,y:127.7},{x:90,y:130.8},{x:96,y:133.9},
                        {x:102,y:137},{x:108,y:140.2},{x:114,y:143.3},{x:120,y:146.4},{x:126,y:149.5},{x:132,y:152.4},
                        {x:138,y:155.1},{x:144,y:157.5},{x:150,y:159.6},{x:156,y:161.3},{x:162,y:162.7},{x:168,y:163.7},{x:174,y:164.5},
                        {x:180,y:165},{x:186,y:165.3},{x:192,y:165.6},{x:198,y:165.7},{x:204,y:165.9},{x:210,y:166},{x:216,y:166.1}];

            var set7 = [{x:60,y:119.3},{x:66,y:122.5},{x:72,y:125.6},{x:78,y:128.7},{x:84,y:131.9},{x:90,y:135},{x:96,y:138.1},
                        {x:102,y:141.3},{x:108,y:144.5},{x:114,y:147.6},{x:120,y:150.8},{x:126,y:153.9},{x:132,y:156.8},
                        {x:138,y:159.6},{x:144,y:162},{x:150,y:164.1},{x:156,y:165.9},{x:162,y:167.2},{x:168,y:168.2},{x:174,y:169},
                        {x:180,y:169.5},{x:186,y:169.8},{x:192,y:170.1},{x:198,y:170.2},{x:204,y:170.4},{x:210,y:170.5},{x:216,y:170.6}];
            
            var set8 = [{x:60,y:12.3},{x:66,y:13},{x:72,y:13.7},{x:78,y:14.4},{x:84,y:15.1},{x:90,y:15.9},{x:96,y:16.7},
                        {x:102,y:17.5},{x:108,y:18.5},{x:114,y:19.5},{x:120,y:20.7},{x:126,y:22},{x:132,y:23.3},
                        {x:138,y:24.8},{x:144,y:26.2},{x:150,y:27.6},{x:156,y:28.9},{x:162,y:30.2},{x:168,y:31.3},{x:174,y:32.3},
                        {x:180,y:33.1},{x:186,y:34},{x:192,y:34.7},{x:198,y:35.5},{x:204,y:36.2},{x:210,y:36.9},{x:216,y:37.6}];

            var set9 = [{x:60,y:13.4},{x:66,y:14.3},{x:72,y:15.1},{x:78,y:15.9},{x:84,y:16.8},{x:90,y:17.7},{x:96,y:18.7},
                        {x:102,y:19.7},{x:108,y:20.9},{x:114,y:22.1},{x:120,y:23.5},{x:126,y:25.1},{x:132,y:26.7},
                        {x:138,y:28.4},{x:144,y:30},{x:150,y:31.6},{x:156,y:33.1},{x:162,y:34.4},{x:168,y:35.6},{x:174,y:36.6},
                        {x:180,y:37.5},{x:186,y:38.3},{x:192,y:39.1},{x:198,y:39.8},{x:204,y:40.5},{x:210,y:41.1},{x:216,y:41.8}];

            var set10 = [{x:60,y:14.8},{x:66,y:15.7},{x:72,y:16.7},{x:78,y:17.7},{x:84,y:18.7},{x:90,y:19.9},{x:96,y:21.1},
                        {x:102,y:22.3},{x:108,y:23.7},{x:114,y:25.3},{x:120,y:26.9},{x:126,y:28.8},{x:132,y:30.7},
                        {x:138,y:32.6},{x:144,y:34.5},{x:150,y:36.3},{x:156,y:37.9},{x:162,y:39.4},{x:168,y:40.6},{x:174,y:41.7},
                        {x:180,y:42.5},{x:186,y:43.3},{x:192,y:44},{x:198,y:44.7},{x:204,y:45.3},{x:210,y:46},{x:216,y:46.6}];

            var set11 = [{x:60,y:16.4},{x:66,y:17.6},{x:72,y:18.7},{x:78,y:19.9},{x:84,y:21.2},{x:90,y:22.5},{x:96,y:24},
                        {x:102,y:25.5},{x:108,y:27.2},{x:114,y:29},{x:120,y:31},{x:126,y:33.2},{x:132,y:35.4},
                        {x:138,y:37.6},{x:144,y:39.8},{x:150,y:41.8},{x:156,y:43.6},{x:162,y:45.1},{x:168,y:46.4},{x:174,y:47.5},
                        {x:180,y:48.4},{x:186,y:49.1},{x:192,y:49.7},{x:198,y:50.3},{x:204,y:50.9},{x:210,y:51.5},{x:216,y:52}];

            var set12 = [{x:60,y:18.5},{x:66,y:19.9},{x:72,y:21.3},{x:78,y:22.7},{x:84,y:24.2},{x:90,y:25.9},{x:96,y:27.6},
                        {x:102,y:29.5},{x:108,y:31.5},{x:114,y:33.6},{x:120,y:36},{x:126,y:38.4},{x:132,y:41},
                        {x:138,y:43.6},{x:144,y:46},{x:150,y:48.2},{x:156,y:50.2},{x:162,y:51.8},{x:168,y:53.2},{x:174,y:54.3},
                        {x:180,y:55.1},{x:186,y:55.8},{x:192,y:56.3},{x:198,y:56.9},{x:204,y:57.3},{x:210,y:57.8},{x:216,y:58.2}];

            var set13 = [{x:60,y:21.3},{x:66,y:22.9},{x:72,y:24.6},{x:78,y:26.3},{x:84,y:28.2},{x:90,y:30.1},{x:96,y:32.2},
                        {x:102,y:34.4},{x:108,y:36.7},{x:114,y:39.3},{x:120,y:42},{x:126,y:44.8},{x:132,y:47.7},
                        {x:138,y:50.6},{x:144,y:53.4},{x:150,y:55.8},{x:156,y:57.9},{x:162,y:59.7},{x:168,y:61.1},{x:174,y:62.2},
                        {x:180,y:62.9},{x:186,y:63.5},{x:192,y:64},{x:198,y:64.4},{x:204,y:64.7},{x:210,y:65},{x:216,y:65.3}];

            var set14 = [{x:60,y:25},{x:66,y:27},{x:72,y:29.1},{x:78,y:31.2},{x:84,y:33.4},{x:90,y:35.7},{x:96,y:38.1},
                        {x:102,y:40.7},{x:108,y:43.4},{x:114,y:46.3},{x:120,y:49.4},{x:126,y:52.6},{x:132,y:55.9},
                        {x:138,y:59.1},{x:144,y:62.1},{x:150,y:64.8},{x:156,y:67.1},{x:162,y:69},{x:168,y:70.4},{x:174,y:71.4},
                        {x:180,y:72.1},{x:186,y:72.5},{x:192,y:72.8},{x:198,y:73.1},{x:204,y:73.3},{x:210,y:73.4},{x:216,y:73.5}];

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrapheight = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var wrapweight = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnterheight = wrapheight.enter().append('g').attr('class', 'd3line').append('g');
            var gEnterweight = wrapweight.enter().append('g').attr('class', 'd3line').append('g');

            gEnterheight.append('g').attr('class', 'lines');
            gEnterheight.append('g').attr('class', 'point-clips');
            gEnterheight.append('g').attr('class', 'point-paths');

            gEnterheight.append('g').attr('class', 'lines');
            gEnterheight.append('g').attr('class', 'point-clips');
            gEnterheight.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("cardinal");
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xVal = [5,5.6,6,6.6,7,7.6,8,8.6,9,9.6,10,10.6,11,11.6,12,12.6,13,13.6,14,14.6,15,15.6,16,16.6,17,17.6,18];
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,190]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,190]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
                return d/12 % 1 ? '' : d/12;
            }).innerTickSize(-height).outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
                return '';
            }).innerTickSize(-height).outerTickSize(0);
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(26).tickValues(d3.range(0, 190, 20)).tickFormat(function(d) {
                return d%20==0 ? d : '';
            }).innerTickSize(-width).outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(26).tickValues(d3.range(0, 190, 20)).tickFormat(function(d) {
                return '';
            }).innerTickSize(-width).outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };

            // plot user data points
            var heightpoint = wrapheight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
            
            var weightpoint = wrapweight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" Kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -7 )
                .style("text-anchor", "middle")
                .text("IAP Girls Height & Weight Chart");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,1250) rotate(-90)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", 300 )
                .attr("y", height-10 )
                .attr("transform","rotate(90,575,1150)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,450) rotate(-90)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", -500 )
                .attr("y", height-10 )
                .attr("transform","rotate(90,575,1150)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 760 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 735 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 710 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 680 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 650 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 615 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 575 )
                .style("text-anchor", "start")
                .text("97");

            svg.append("text")
                .attr("x", 690 )
                .attr("y", 215 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 195 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 175 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 155 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 135 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 115 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 90 )
                .style("text-anchor", "start")
                .text("97");
            
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set13),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});
'use strict';
angular.module('AngularApp').directive('combinedChartMaleSmall', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;

            var heightData = [];
            var weightData = [];

            if(vitalData.height){
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x>59 && vitalData.height[i].x<217) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            if(vitalData.weight) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x>59 && vitalData.weight[i].x<217) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var set1 = [{x:60,y:99},	{x:66,y:101.6},{x:72,y:104.2},{x:78,y:106.8},{x:84,y:109.3},{x:90,y:111.8},
                        {x:96,y:114.3},{x:102,y:116.7},{x:108,y:119},{x:114,y:121.3},{x:120,y:123.6},{x:126,y:125.9},{x:132,y:128.2},
                        {x:138,y:130.7},{x:144,y:133.2},{x:150,y:135.7},{x:156,y:138.3},{x:162,y:140.9},{x:168,y:143.4},{x:174,y:145.8},
                        {x:180,y:148},{x:186,y:150},{x:192,y:151.8},{x:198,y:153.4},{x:204,y:155},{x:210,y:156.6},{x:216,y:158.1}];

            var set2 = [{x:60,y:102.3},{x:66,y:105},{x:72,y:107.7},{x:78,y:110.4},{x:84,y:113},{x:90,y:115.7},
                        {x:96,y:118.2},{x:102,y:120.8},{x:108,y:123.2},{x:114,y:125.6},{x:120,y:128.1},{x:126,y:130.5},{x:132,y:133},
                        {x:138,y:135.6},{x:144,y:138.3},{x:150,y:141},{x:156,y:143.7},{x:162,y:146.4},{x:168,y:149},{x:174,y:151.5},
                        {x:180,y:153.7},{x:186,y:155.7},{x:192,y:157.4},{x:198,y:159.1},{x:204,y:160.6},{x:210,y:162.1},{x:216,y:163.6}];
                    
            var set3 = [{x:60,y:105.6},{x:66,y:108.4},{x:72,y:111.2},{x:78,y:114},{x:84,y:116.8},{x:90,y:119.6},{x:96,y:122.3},
                        {x:102,y:124.9},{x:108,y:127.5},{x:114,y:130},{x:120,y:132.6},{x:126,y:135.2},{x:132,y:137.8},{x:138,y:140.6},
                        {x:144,y:143.3},{x:150,y:146.2},{x:156,y:149},{x:162,y:151.8},{x:168,y:154.5},{x:174,y:157},
                        {x:180,y:159.2},{x:186,y:161.2},{x:192,y:162.9},{x:198,y:164.5},{x:204,y:165.9},{x:210,y:167.3},{x:216,y:168.7}];

            var set4 = [{x:60,y:108.9},{x:66,y:111.9},{x:72,y:114.8},{x:78,y:117.8},{x:84,y:120.7},{x:90,y:123.5},{x:96,y:126.4},
                        {x:102,y:129.1},{x:108,y:131.8},{x:114,y:134.5},{x:120,y:137.2},{x:126,y:139.9},{x:132,y:142.7},{x:138,y:145.5},
                        {x:144,y:148.4},{x:150,y:151.4},{x:156,y:154.3},{x:162,y:157.2},{x:168,y:159.9},{x:174,y:162.3},
                        {x:180,y:164.5},{x:186,y:166.5},{x:192,y:168.1},{x:198,y:169.6},{x:204,y:171},{x:210,y:172.3},{x:216,y:173.6}];

            var set5 = [{x:60,y:112.4},{x:66,y:115.4},{x:72,y:118.5},{x:78,y:121.6},{x:84,y:124.6},{x:90,y:127.6},{x:96,y:130.5},
                        {x:102,y:133.4},{x:108,y:136.3},{x:114,y:139.1},{x:120,y:141.9},{x:126,y:144.7},{x:132,y:147.6},{x:138,y:150.5},
                        {x:144,y:153.5},{x:150,y:156.5},{x:156,y:159.5},{x:162,y:162.4},{x:168,y:165.1},{x:174,y:167.6},
                        {x:180,y:169.7},{x:186,y:171.6},{x:192,y:173.1},{x:198,y:174.5},{x:204,y:175.8},{x:210,y:177},{x:216,y:178.2}];

            var set6 = [{x:60,y:115.9},{x:66,y:119},{x:72,y:122.2},{x:78,y:125.4},{x:84,y:128.6},{x:90,y:131.7},{x:96,y:134.8},
                        {x:102,y:137.8},{x:108,y:140.7},{x:114,y:143.7},{x:120,y:146.6},{x:126,y:149.5},{x:132,y:152.5},{x:138,y:155.6},
                        {x:144,y:158.6},{x:150,y:161.7},{x:156,y:164.7},{x:162,y:167.6},{x:168,y:170.3},{x:174,y:172.7},
                        {x:180,y:174.8},{x:186,y:176.5},{x:192,y:178},{x:198,y:179.3},{x:204,y:180.4},{x:210,y:181.5},{x:216,y:182.5}];

            var set7 = [{x:60,y:119.4},{x:66,y:122.7},{x:72,y:126},{x:78,y:129.3},{x:84,y:132.6},{x:90,y:135.9},{x:96,y:139.1},
                        {x:102,y:142.2},{x:108,y:145.3},{x:114,y:148.3},{x:120,y:151.4},{x:126,y:154.4},{x:132,y:157.5},{x:138,y:160.6},
                        {x:144,y:163.7},{x:150,y:166.8},{x:156,y:169.9},{x:162,y:172.7},{x:168,y:175.4},{x:174,y:177.7},
                        {x:180,y:179.7},{x:186,y:181.4},{x:192,y:182.7},{x:198,y:183.8},{x:204,y:184.8},{x:210,y:185.8},{x:216,y:186.7}];
            
            var set8 = [{x:60,y:13.2},{x:66,y:13.8},{x:72,y:14.5},{x:78,y:15.3},{x:84,y:16},{x:90,y:16.7},{x:96,y:17.5},
                        {x:102,y:18.3},{x:108,y:19.1},{x:114,y:19.9},{x:120,y:20.7},{x:126,y:21.6},{x:132,y:22.6},{x:138,y:23.8},
                        {x:144,y:24.9},{x:150,y:26.1},{x:156,y:27.5},{x:162,y:29},{x:168,y:30.7},{x:174,y:32.6},
                        {x:180,y:34.5},{x:186,y:36.1},{x:192,y:37.5},{x:198,y:38.7},{x:204,y:39.8},{x:210,y:40.8},{x:216,y:41.8}];

            var set9 = [{x:60,y:14.3},{x:66,y:15},{x:72,y:15.8},{x:78,y:16.8},{x:84,y:17.6},{x:90,y:18.5},{x:96,y:19.5},
                        {x:102,y:20.5},{x:108,y:21.5},{x:114,y:22.4},{x:120,y:23.5},{x:126,y:24.6},{x:132,y:25.9},{x:138,y:27.3},
                        {x:144,y:28.7},{x:150,y:30.2},{x:156,y:31.8},{x:162,y:33.6},{x:168,y:35.5},{x:174,y:37.7},
                        {x:180,y:39.8},{x:186,y:41.6},{x:192,y:43.1},{x:198,y:44.4},{x:204,y:45.6},{x:210,y:46.7},{x:216,y:47.7}];

            var set10 = [{x:60,y:15.6},{x:66,y:16.5},{x:72,y:17.4},{x:78,y:18.6},{x:84,y:19.6},{x:90,y:20.7},{x:96,y:21.9},
                        {x:102,y:23.2},{x:108,y:24.3},{x:114,y:25.6},{x:120,y:26.9},{x:126,y:28.3},{x:132,y:29.8},{x:138,y:31.6},
                        {x:144,y:33.3},{x:150,y:35.1},{x:156,y:37},{x:162,y:39.1},{x:168,y:41.3},{x:174,y:43.7},
                        {x:180,y:45.9},{x:186,y:47.9},{x:192,y:49.5},{x:198,y:50.9},{x:204,y:52.1},{x:210,y:53.2},{x:216,y:54.3}];

            var set11 = [{x:60,y:17.1},{x:66,y:18.2},{x:72,y:19.3},{x:78,y:20.7},{x:84,y:21.9},{x:90,y:23.3},{x:96,y:24.8},
                        {x:102,y:26.4},{x:108,y:27.9},{x:114,y:29.4},{x:120,y:31.1},{x:126,y:32.8},{x:132,y:34.7},{x:138,y:36.9},
                        {x:144,y:39},{x:150,y:41.2},{x:156,y:43.3},{x:162,y:45.7},{x:168,y:48.2},{x:174,y:50.8},
                        {x:180,y:53.1},{x:186,y:55.2},{x:192,y:56.8},{x:198,y:58.2},{x:204,y:59.5},{x:210,y:60.6},{x:216,y:61.6}];

            var set12 = [{x:60,y:19},{x:66,y:20.3},{x:72,y:21.7},{x:78,y:23.3},{x:84,y:24.9},{x:90,y:26.6},{x:96,y:28.5},
                        {x:102,y:30.5},{x:108,y:32.3},{x:114,y:34.3},{x:120,y:36.3},{x:126,y:38.5},{x:132,y:40.9},{x:138,y:43.5},
                        {x:144,y:46},{x:150,y:48.6},{x:156,y:51.1},{x:162,y:53.8},{x:168,y:56.4},{x:174,y:59.1},
                        {x:180,y:61.6},{x:186,y:63.6},{x:192,y:65.2},{x:198,y:66.6},{x:204,y:67.8},{x:210,y:68.7},{x:216,y:69.7}];

            var set13 = [{x:60,y:21.3},{x:66,y:22.9},{x:72,y:24.6},{x:78,y:26.6},{x:84,y:28.6},{x:90,y:30.8},{x:96,y:33.2},
                        {x:102,y:35.7},{x:108,y:38},{x:114,y:40.5},{x:120,y:43},{x:126,y:45.8},{x:132,y:48.7},{x:138,y:51.8},
                        {x:144,y:54.8},{x:150,y:57.8},{x:156,y:60.7},{x:162,y:63.6},{x:168,y:66.3},{x:174,y:69.1},
                        {x:180,y:71.5},{x:186,y:73.4},{x:192,y:74.8},{x:198,y:76.1},{x:204,y:77.1},{x:210,y:77.8},{x:216,y:78.6}];

            var set14 = [{x:60,y:24.2},{x:66,y:26.1},{x:72,y:28.3},{x:78,y:30.8},{x:84,y:33.4},{x:90,y:36.2},{x:96,y:39.4},
                        {x:102,y:42.6},{x:108,y:45.5},{x:114,y:48.6},{x:120,y:51.8},{x:126,y:55.2},{x:132,y:58.7},{x:138,y:62.5},
                        {x:144,y:66.1},{x:150,y:69.5},{x:156,y:72.6},{x:162,y:75.6},{x:168,y:78.3},{x:174,y:80.9},
                        {x:180,y:83.1},{x:186,y:84.7},{x:192,y:85.8},{x:198,y:86.8},{x:204,y:87.5},{x:210,y:88},{x:216,y:88.4}];

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrapheight = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var wrapweight = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnterheight = wrapheight.enter().append('g').attr('class', 'd3line').append('g');
            var gEnterweight = wrapweight.enter().append('g').attr('class', 'd3line').append('g');
            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("cardinal");

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                                return xScale0(d.x);
                            })
                            .y(function (d) {
                                return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xVal = [5,5.6,6,6.6,7,7.6,8,8.6,9,9.6,10,10.6,11,11.6,12,12.6,13,13.6,14,14.6,15,15.6,16,16.6,17,17.6,18];
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,190]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,190]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
                return d/12 % 1 ? '' : d/12;
            }).innerTickSize(-height).outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
                return '';
            }).innerTickSize(-height).outerTickSize(0);
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(26).tickValues(d3.range(0, 190, 20)).tickFormat(function(d) {
                return d%20==0 ? d : '';
            }).innerTickSize(-width).outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(26).tickValues(d3.range(0, 190, 20)).tickFormat(function(d) {
                return '';
            }).innerTickSize(-width).outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };
            
            // plot user data points
            var heightpoint = wrapheight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
            
            var weightpoint = wrapweight.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +"Kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -7 )
                .style("text-anchor", "middle")
                .text("IAP Boys Height & Weight Chart");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,1250) rotate(-90)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", 300 )
                .attr("y", height-10 )
                .attr("transform","rotate(90,575,1150)")
                .style("text-anchor", "middle")
                .text("WEIGHT(Kg)");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height )
                .attr("transform", "translate(-970,450) rotate(-90)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", -500 )
                .attr("y", height-10 )
                .attr("transform","rotate(90,575,1150)")
                .style("text-anchor", "middle")
                .text("STATURE(CM)");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 740 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 710 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 680 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 640 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 600 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 555 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 500 )
                .style("text-anchor", "start")
                .text("97");

            svg.append("text")
                .attr("x", 690 )
                .attr("y", 170 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 145 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 120 )
                .style("text-anchor", "start")
                .text("25");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 95 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 70 )
                .style("text-anchor", "start")
                .text("75");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 45 )
                .style("text-anchor", "start")
                .text("90");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 25 )
                .style("text-anchor", "start")
                .text("97");
            
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set13),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});
'use strict';
angular.module('AngularApp').directive('hlPostnatalFemaleSmall', function() {
    return {
            restrict: 'EA',
            template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
            link: function(scope, element, attrs){
                var vitalData = scope[attrs.chartData];
                var margin = { top: 20, right: 100, bottom: 40, left: 100 };
                var height = 250 - margin.top - margin.bottom;
                var width = 370 - margin.left - margin.right;
    
            var headConst = -20;
            var lengthConst = -14;

            var hcData = [];
            if(vitalData.postnatalHc) {
                for(var i = 0; i < vitalData.postnatalHc.length; i++){
                    hcData.push({x:vitalData.postnatalHc[i].x, y:parseFloat(vitalData.postnatalHc[i].y) + headConst});
                }
            }

            var lengthData = [];
            if(vitalData.postnatalHeight) {
                for(var i = 0; i < vitalData.postnatalHeight.length; i++){
                    lengthData.push({x:vitalData.postnatalHeight[i].x, y:parseFloat(vitalData.postnatalHeight[i].y) + lengthConst});
                }
            }
  
              // Start of Head data
              var set1 = [{x:27,y:20.7+headConst},{x:28,y:22.1+headConst},{x:29,y:23.4+headConst},{x:30,y:24.5+headConst},{x:31,y:25.6+headConst},{x:32,y:26.6+headConst},{x:33,y:27.5+headConst},{x:34,y:28.4+headConst},{x:35,y:29.1+headConst},{x:36,y:29.9+headConst},{x:37,y:30.6+headConst},{x:38,y:31.2+headConst},{x:39,y:31.8+headConst},{x:40,y:32.4+headConst},{x:41,y:32.9+headConst},{x:42,y:33.4+headConst},{x:43,y:33.9+headConst},{x:44,y:34.3+headConst},{x:45,y:34.8+headConst},{x:46,y:35.2+headConst},{x:47,y:35.6+headConst},{x:48,y:35.9+headConst},{x:49,y:36.3+headConst},{x:50,y:36.6+headConst},{x:51,y:36.9+headConst},{x:52,y:37.2+headConst},{x:53,y:37.5+headConst},{x:54,y:37.8+headConst},{x:55,y:38+headConst},{x:56,y:38.3+headConst},{x:57,y:38.5+headConst},{x:58,y:38.8+headConst},{x:59,y:39+headConst},{x:60,y:39.2+headConst},{x:61,y:39.4+headConst},{x:62,y:39.6+headConst},{x:63,y:39.8+headConst},{x:64,y:40+headConst}];
    
              var set2 = [{x:27,y:21.8+headConst},{x:28,y:23.1+headConst},{x:29,y:24.3+headConst},{x:30,y:25.4+headConst},{x:31,y:26.4+headConst},{x:32,y:27.3+headConst},{x:33,y:28.2+headConst},{x:34,y:29+headConst},{x:35,y:29.8+headConst},{x:36,y:30.5+headConst},{x:37,y:31.2+headConst},{x:38,y:31.8+headConst},{x:39,y:32.4+headConst},{x:40,y:33+headConst},{x:41,y:33.5+headConst},{x:42,y:34+headConst},{x:43,y:34.5+headConst},{x:44,y:34.9+headConst},{x:45,y:35.4+headConst},{x:46,y:35.8+headConst},{x:47,y:36.1+headConst},{x:48,y:36.5+headConst},{x:49,y:36.9+headConst},{x:50,y:37.2+headConst},{x:51,y:37.5+headConst},{x:52,y:37.8+headConst},{x:53,y:38.1+headConst},{x:54,y:38.4+headConst},{x:55,y:38.7+headConst},{x:56,y:38.9+headConst},{x:57,y:39.2+headConst},{x:58,y:39.4+headConst},{x:59,y:39.7+headConst},{x:60,y:39.9+headConst},{x:61,y:40.1+headConst},{x:62,y:40.3+headConst},{x:63,y:40.5+headConst},{x:64,y:40.7+headConst}];
                      
              var set3 = [{x:27,y:24+headConst},{x:28,y:25.1+headConst},{x:29,y:26.2+headConst},{x:30,y:27.1+headConst},{x:31,y:28.1+headConst},{x:32,y:28.9+headConst},{x:33,y:29.7+headConst},{x:34,y:30.5+headConst},{x:35,y:31.2+headConst},{x:36,y:31.9+headConst},{x:37,y:32.5+headConst},{x:38,y:33.1+headConst},{x:39,y:33.7+headConst},{x:40,y:34.2+headConst},{x:41,y:34.8+headConst},{x:42,y:35.3+headConst},{x:43,y:35.7+headConst},{x:44,y:36.2+headConst},{x:45,y:36.6+headConst},{x:46,y:37+headConst},{x:47,y:37.4+headConst},{x:48,y:37.8+headConst},{x:49,y:38.1+headConst},{x:50,y:38.5+headConst},{x:51,y:38.8+headConst},{x:52,y:39.2+headConst},{x:53,y:39.5+headConst},{x:54,y:39.8+headConst},{x:55,y:40+headConst},{x:56,y:40.3+headConst},{x:57,y:40.6+headConst},{x:58,y:40.8+headConst},{x:59,y:41.1+headConst},{x:60,y:41.3+headConst},{x:61,y:41.6+headConst},{x:62,y:41.8+headConst},{x:63,y:42+headConst},{x:64,y:42.2+headConst}];
  
              var set4 = [{x:27,y:26.2+headConst},{x:28,y:27.2+headConst},{x:29,y:28.1+headConst},{x:30,y:28.9+headConst},{x:31,y:29.7+headConst},{x:32,y:30.5+headConst},{x:33,y:31.2+headConst},{x:34,y:31.9+headConst},{x:35,y:32.6+headConst},{x:36,y:33.2+headConst},{x:37,y:33.8+headConst},{x:38,y:34.4+headConst},{x:39,y:35+headConst},{x:40,y:35.5+headConst},{x:41,y:36+headConst},{x:42,y:36.5+headConst},{x:43,y:37+headConst},{x:44,y:37.4+headConst},{x:45,y:37.9+headConst},{x:46,y:38.3+headConst},{x:47,y:38.7+headConst},{x:48,y:39.1+headConst},{x:49,y:39.4+headConst},{x:50,y:39.8+headConst},{x:51,y:40.1+headConst},{x:52,y:40.5+headConst},{x:53,y:40.8+headConst},{x:54,y:41.1+headConst},{x:55,y:41.4+headConst},{x:56,y:41.7+headConst},{x:57,y:42+headConst},{x:58,y:42.3+headConst},{x:59,y:42.5+headConst},{x:60,y:42.8+headConst},{x:61,y:43+headConst},{x:62,y:43.3+headConst},{x:63,y:43.5+headConst},{x:64,y:43.7+headConst}];
  
              var set5 = [{x:27,y:27.2+headConst},{x:28,y:28.1+headConst},{x:29,y:28.9+headConst},{x:30,y:29.7+headConst},{x:31,y:30.5+headConst},{x:32,y:31.2+headConst},{x:33,y:31.9+headConst},{x:34,y:32.6+headConst},{x:35,y:33.2+headConst},{x:36,y:33.9+headConst},{x:37,y:34.5+headConst},{x:38,y:35+headConst},{x:39,y:35.6+headConst},{x:40,y:36.1+headConst},{x:41,y:36.6+headConst},{x:42,y:37.1+headConst},{x:43,y:37.6+headConst},{x:44,y:38+headConst},{x:45,y:38.4+headConst},{x:46,y:38.9+headConst},{x:47,y:39.3+headConst},{x:48,y:39.7+headConst},{x:49,y:40+headConst},{x:50,y:40.4+headConst},{x:51,y:40.7+headConst},{x:52,y:41.1+headConst},{x:53,y:41.4+headConst},{x:54,y:41.7+headConst},{x:55,y:42.1+headConst},{x:56,y:42.4+headConst},{x:57,y:42.6+headConst},{x:58,y:42.9+headConst},{x:59,y:43.2+headConst},{x:60,y:43.5+headConst},{x:61,y:43.7+headConst},{x:62,y:44+headConst},{x:63,y:44.2+headConst},{x:64,y:44.5+headConst}];
              // End of Head data
  
              // Start of Length data
              var set6 = [{x:27,y:27.8+lengthConst},{x:28,y:29.7+lengthConst},{x:29,y:31.5+lengthConst},{x:30,y:33.2+lengthConst},{x:31,y:34.8+lengthConst},{x:32,y:36.4+lengthConst},{x:33,y:37.8+lengthConst},{x:34,y:39.2+lengthConst},{x:35,y:40.5+lengthConst},{x:36,y:41.7+lengthConst},{x:37,y:42.9+lengthConst},{x:38,y:44+lengthConst},{x:39,y:45+lengthConst},{x:40,y:46+lengthConst},{x:41,y:47+lengthConst},{x:42,y:47.9+lengthConst},{x:43,y:48.7+lengthConst},{x:44,y:49.6+lengthConst},{x:45,y:50.3+lengthConst},{x:46,y:51.1+lengthConst},{x:47,y:51.8+lengthConst},{x:48,y:52.5+lengthConst},{x:49,y:53.1+lengthConst},{x:50,y:53.8+lengthConst},{x:51,y:54.4+lengthConst},{x:52,y:54.9+lengthConst},{x:53,y:55.5+lengthConst},{x:54,y:56+lengthConst},{x:55,y:56.6+lengthConst},{x:56,y:57.1+lengthConst},{x:57,y:57.6+lengthConst},{x:58,y:58+lengthConst},{x:59,y:58.5+lengthConst},{x:60,y:58.9+lengthConst},{x:61,y:59.4+lengthConst},{x:62,y:59.8+lengthConst},{x:63,y:60.2+lengthConst},{x:64,y:60.6+lengthConst}];
  
              var set7 = [{x:27,y:29+lengthConst},{x:28,y:30.9+lengthConst},{x:29,y:32.7+lengthConst},{x:30,y:34.3+lengthConst},{x:31,y:35.9+lengthConst},{x:32,y:37.5+lengthConst},{x:33,y:38.9+lengthConst},{x:34,y:40.3+lengthConst},{x:35,y:41.5+lengthConst},{x:36,y:42.8+lengthConst},{x:37,y:43.9+lengthConst},{x:38,y:45+lengthConst},{x:39,y:46.1+lengthConst},{x:40,y:47.1+lengthConst},{x:41,y:48+lengthConst},{x:42,y:48.9+lengthConst},{x:43,y:49.8+lengthConst},{x:44,y:50.6+lengthConst},{x:45,y:51.4+lengthConst},{x:46,y:52.1+lengthConst},{x:47,y:52.9+lengthConst},{x:48,y:53.6+lengthConst},{x:49,y:54.2+lengthConst},{x:50,y:54.9+lengthConst},{x:51,y:55.5+lengthConst},{x:52,y:56.1+lengthConst},{x:53,y:56.6+lengthConst},{x:54,y:57.2+lengthConst},{x:55,y:57.7+lengthConst},{x:56,y:58.2+lengthConst},{x:57,y:58.7+lengthConst},{x:58,y:59.2+lengthConst},{x:59,y:59.7+lengthConst},{x:60,y:60.2+lengthConst},{x:61,y:60.6+lengthConst},{x:62,y:61+lengthConst},{x:63,y:61.5+lengthConst},{x:64,y:61.9+lengthConst}];
                      
              var set8 = [{x:27,y:31.7+lengthConst},{x:28,y:33.5+lengthConst},{x:29,y:35.2+lengthConst},{x:30,y:36.8+lengthConst},{x:31,y:38.4+lengthConst},{x:32,y:39.9+lengthConst},{x:33,y:41.3+lengthConst},{x:34,y:42.6+lengthConst},{x:35,y:43.9+lengthConst},{x:36,y:45.1+lengthConst},{x:37,y:46.2+lengthConst},{x:38,y:47.3+lengthConst},{x:39,y:48.3+lengthConst},{x:40,y:49.3+lengthConst},{x:41,y:50.3+lengthConst},{x:42,y:51.2+lengthConst},{x:43,y:52.1+lengthConst},{x:44,y:52.9+lengthConst},{x:45,y:53.7+lengthConst},{x:46,y:54.5+lengthConst},{x:47,y:55.2+lengthConst},{x:48,y:55.9+lengthConst},{x:49,y:56.6+lengthConst},{x:50,y:57.3+lengthConst},{x:51,y:57.9+lengthConst},{x:52,y:58.5+lengthConst},{x:53,y:59.1+lengthConst},{x:54,y:59.7+lengthConst},{x:55,y:60.3+lengthConst},{x:56,y:60.8+lengthConst},{x:57,y:61.3+lengthConst},{x:58,y:61.9+lengthConst},{x:59,y:62.4+lengthConst},{x:60,y:62.9+lengthConst},{x:61,y:63.3+lengthConst},{x:62,y:63.8+lengthConst},{x:63,y:64.2+lengthConst},{x:64,y:64.7+lengthConst}];
  
              var set9 = [{x:27,y:34.6+lengthConst},{x:28,y:36.3+lengthConst},{x:29,y:38+lengthConst},{x:30,y:39.5+lengthConst},{x:31,y:41+lengthConst},{x:32,y:42.4+lengthConst},{x:33,y:43.8+lengthConst},{x:34,y:45.1+lengthConst},{x:35,y:46.3+lengthConst},{x:36,y:47.5+lengthConst},{x:37,y:48.6+lengthConst},{x:38,y:49.7+lengthConst},{x:39,y:50.7+lengthConst},{x:40,y:51.7+lengthConst},{x:41,y:52.7+lengthConst},{x:42,y:53.6+lengthConst},{x:43,y:54.5+lengthConst},{x:44,y:55.3+lengthConst},{x:45,y:56.1+lengthConst},{x:46,y:56.9+lengthConst},{x:47,y:57.7+lengthConst},{x:48,y:58.4+lengthConst},{x:49,y:59.1+lengthConst},{x:50,y:59.8+lengthConst},{x:51,y:60.5+lengthConst},{x:52,y:61.1+lengthConst},{x:53,y:61.7+lengthConst},{x:54,y:62.3+lengthConst},{x:55,y:62.9+lengthConst},{x:56,y:63.5+lengthConst},{x:57,y:64.1+lengthConst},{x:58,y:64.6+lengthConst},{x:59,y:65.2+lengthConst},{x:60,y:65.7+lengthConst},{x:61,y:66.2+lengthConst},{x:62,y:66.7+lengthConst},{x:63,y:67.2+lengthConst},{x:64,y:67.6+lengthConst}];
  
              var set10 = [{x:27,y:36.1+lengthConst},{x:28,y:37.8+lengthConst},{x:29,y:39.3+lengthConst},{x:30,y:40.9+lengthConst},{x:31,y:42.3+lengthConst},{x:32,y:43.7+lengthConst},{x:33,y:45+lengthConst},{x:34,y:46.3+lengthConst},{x:35,y:47.5+lengthConst},{x:36,y:48.7+lengthConst},{x:37,y:49.8+lengthConst},{x:38,y:50.9+lengthConst},{x:39,y:51.9+lengthConst},{x:40,y:52.9+lengthConst},{x:41,y:53.8+lengthConst},{x:42,y:54.7+lengthConst},{x:43,y:55.6+lengthConst},{x:44,y:56.5+lengthConst},{x:45,y:57.3+lengthConst},{x:46,y:58.1+lengthConst},{x:47,y:58.9+lengthConst},{x:48,y:59.6+lengthConst},{x:49,y:60.3+lengthConst},{x:50,y:61+lengthConst},{x:51,y:61.7+lengthConst},{x:52,y:62.4+lengthConst},{x:53,y:63+lengthConst},{x:54,y:63.6+lengthConst},{x:55,y:64.2+lengthConst},{x:56,y:64.8+lengthConst},{x:57,y:65.4+lengthConst},{x:58,y:66+lengthConst},{x:59,y:66.5+lengthConst},{x:60,y:67+lengthConst},{x:61,y:67.6+lengthConst},{x:62,y:68.1+lengthConst},{x:63,y:68.6+lengthConst},{x:64,y:69.1+lengthConst}];
              // End of Length data
                
              var rawSvg = element.find("svg")[0];
              var svg = d3.select(rawSvg)
                          .attr("width",width + margin.left + margin.right)
                          .attr("height",height + margin.top + margin.bottom);
              var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
              var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
              var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([lengthData]);
              var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');
  
              var div = d3.select("body").append("div")	
                          .attr("class", "tooltip")				
                          .style("opacity", 0);
  
              var lineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("bundle")
                              .tension(.8);
  
              var datalineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("linear");
  
  
              var g = svg.append("g")
                          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
              
              var xScale0 = d3.scale.linear().domain([65,27]).range([width,0]);
              var xScale1 = d3.scale.linear().domain([65,27]).range([width,0]);
  
              var yScale0 = d3.scale.linear().domain([0,61]).range([height, 0]);
              var yScale1 = d3.scale.linear().domain([0,61]).range([height, 0]);
  
              var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                  return xAxisBottomFake(d);
              }).innerTickSize(-height)
                              .outerTickSize(0);
              var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                  return xAxisBottomFake(d);
              });
              var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                  return d%5==0 ? yAxisLeftFake(d):'';
              }).innerTickSize(-width)
                      .outerTickSize(0);
              var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                  return d%5==0 ? yAxisRightFake(d):'';
              }).innerTickSize(50)
                      .outerTickSize(50).tickPadding(10);
              
              var xAxisBottomFake = function(d){
                  switch (d){
                  case 28:return 28;
                  case 38:return 38;
                  case 48:return 48;
                  case 58:return 58;
                  case 64:return 64;
                  default: return '';
                  }
              };
              var yAxisLeftFake = function(d){
                  switch (d){
                  case 0:return 20;
                  case 2:return 22;
                  case 4:return 24;
                  case 6:return 26;
                  case 8:return 28;
                  case 10:return 30;
                  case 12:return '';
                  case 14:return 28;
                  case 16:return 30;
                  case 18:return 32;
                  case 20:return 34;
                  case 22:return 36;
                  case 24:return 38;
                  case 26:return 40;
                  case 28:return 42;
                  case 30:return 44;
                  case 32:return 46;
                  case 34:return 48;
                  case 36:return 50;
                  case 38:return 52;
                  case 40:return 54;
                  case 42:return 56;
                  case 44:return 58;
                  case 46:return 60;
                  case 48:return 62;
                  case 50:return 64;
                  case 52:return 66;
                  case 54:return 68;
                  case 56:return 70;
                  case 58:return 72;
                  case 60:return 74;
                  }
              };
  
              var yAxisRightFake = function(d){
                  switch (d){
                  case 0:return 20;
                  case 2:return 22;
                  case 4:return 24;
                  case 6:return 26;
                  case 8:return 28;
                  case 10:return 30;
                  case 12:return 32;
                  case 14:return 34;
                  case 16:return 36;
                  case 18:return 38;
                  case 20:return 40;
                  case 22:return 42;
                  case 24:return 44;
                  case 26:return 46;
                  case 28:return '';
                  case 30:return 44;
                  case 32:return 46;
                  case 34:return 48;
                  case 36:return 50;
                  case 38:return 52;
                  case 40:return 54;
                  case 42:return 56;
                  case 44:return 58;
                  case 46:return 60;
                  case 48:return 62;
                  case 50:return 64;
                  case 52:return 66;
                  case 54:return 68;
                  case 56:return 70;
                  case 58:return 72;
                  case 60:return 74;
                  }
              };
  
              var age = function(data) {
                  if(data <= 24){
                      return data.toString().split('.')[0]+ " months";
                  }
                  if(data <=60) {
                      var mon = data/12;
                      var result = mon.toFixed(1).split('.');
                      var mod = data%12;
                      var res = mod.toString().split('.');
                      return result[0].toString()+ " years " + res[0] + " months";
                  }
              };
              
              // plot user data points
              var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
  
              // x-axis
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxisBottom);
              
              // svg.append("g")
              //     .attr("class", "x axis")
              //     .attr("transform", "translate(0,0)")
              //     .call(xAxisTop);
  
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", -7 )
                  .style("text-anchor", "middle")
                  .text("Postnatal Growth - Head, Length");
  
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height+37 )
                  .style("text-anchor", "middle")
                  .text("Postmensural age (weeks)");
              
              // svg.append("text")
              //     .attr("x", width/2 )
              //     .attr("y", -30 )
              //     .style("text-anchor", "middle")
              //     .text("Head Circumference-for-age BOYS");
  
              // svg.append("text")
              //     .attr("x", width/2 )
              //     .attr("y", -12 )
              //     .style("text-anchor", "middle")
              //     .text("Birth to 5 years (percentiles)");
              
  
              svg.append("text")
                  .attr("x", -860 )
                  .attr("y", -35 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Head Circumference (cm)");
              
              svg.append("text")
                  .attr("x", -380 )
                  .attr("y", -35 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Length (cm)");
  
              svg.append("text")
                  .attr("x", -700 )
                  .attr("y", 880 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Head Circumference (cm)");
              
              svg.append("text")
                  .attr("x", -260 )
                  .attr("y", 880 )
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Length (cm)");
              
              // svg.append("text")
              //     .attr("x", -50 )
              //     .attr("y", height+15 )
              //     .style("text-anchor", "start")
              //     .text("Months");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 200 )
                  .style("text-anchor", "start")
                  .text("3 rd");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 180 )
                  .style("text-anchor", "start")
                  .text("10 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 135 )
                  .style("text-anchor", "start")
                  .text("50 th");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 85 )
                  .style("text-anchor", "start")
                  .text("90 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 60 )
                  .style("text-anchor", "start")
                  .text("97 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 630 )
                  .style("text-anchor", "start")
                  .text("3 rd");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 610 )
                  .style("text-anchor", "start")
                  .text("10 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 590 )
                  .style("text-anchor", "start")
                  .text("50 th");
              
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 565 )
                  .style("text-anchor", "start")
                  .text("90 th");
  
              svg.append("text")
                  .attr("x", 790 )
                  .attr("y", 550 )
                  .style("text-anchor", "start")
                  .text("97 th");
                  
              // y-axis
              svg.append("g")
                  .attr("class", "y axis")
                  .call(yAxisLeft);	
  
              // svg.append("g")				
              //     .attr("class", "y axis")	
              //     .attr("transform", "translate(" + width + " ,0)")		
              //     .call(yAxisRight);
              
              // path lines
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set1),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set2),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set3),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set4),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set5),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set6),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set7),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set8),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set9),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
  
              svg.append("svg:path")
                  .attr({
                      d: lineFunc(set10),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                  });
              
              // user data
              svg.append("svg:path")
                    .attr({
                      d: datalineFunc(hcData),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(lengthData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
  
          }
      }
  });
  
'use strict';
angular.module('AngularApp').directive('hlPostnatalMaleSmall', function() {
return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;

            var headConst = -20;
            var lengthConst = -14;

            var hcData = [];
            if(vitalData.postnatalHc) {
                for(var i = 0; i < vitalData.postnatalHc.length; i++){
                    hcData.push({x:vitalData.postnatalHc[i].x, y:parseFloat(vitalData.postnatalHc[i].y) + headConst});
                }
            }

            var lengthData = [];
            if(vitalData.postnatalHeight) {
                for(var i = 0; i < vitalData.postnatalHeight.length; i++){
                    lengthData.push({x:vitalData.postnatalHeight[i].x, y:parseFloat(vitalData.postnatalHeight[i].y) + lengthConst});
                }
            }

            // Start of Head data
            var set1 = [{x:27,y:21.5+headConst},{x:28,y:22.9+headConst},{x:29,y:24.2+headConst},{x:30,y:25.3+headConst},{x:31,y:26.4+headConst},{x:32,y:27.4+headConst},{x:33,y:28.3+headConst},{x:34,y:29.2+headConst},{x:35,y:29.9+headConst},{x:36,y:30.7+headConst},{x:37,y:31.4+headConst},{x:38,y:32+headConst},{x:39,y:32.6+headConst},{x:40,y:33.2+headConst},{x:41,y:33.7+headConst},{x:42,y:34.2+headConst},{x:43,y:34.7+headConst},{x:44,y:35.1+headConst},{x:45,y:35.6+headConst},{x:46,y:36+headConst},{x:47,y:36.4+headConst},{x:48,y:36.7+headConst},{x:49,y:37.1+headConst},{x:50,y:37.4+headConst},{x:51,y:37.7+headConst},{x:52,y:38+headConst},{x:53,y:38.3+headConst},{x:54,y:38.6+headConst},{x:55,y:38.8+headConst},{x:56,y:39.1+headConst},{x:57,y:39.3+headConst},{x:58,y:39.6+headConst},{x:59,y:39.8+headConst},{x:60,y:40+headConst},{x:61,y:40.2+headConst},{x:62,y:40.4+headConst},{x:63,y:40.6+headConst},{x:64,y:40.8+headConst}];

            var set2 = [{x:27,y:22.6+headConst},{x:28,y:23.9+headConst},{x:29,y:25.1+headConst},{x:30,y:26.2+headConst},{x:31,y:27.2+headConst},{x:32,y:28.1+headConst},{x:33,y:29+headConst},{x:34,y:29.8+headConst},{x:35,y:30.6+headConst},{x:36,y:31.3+headConst},{x:37,y:32+headConst},{x:38,y:32.6+headConst},{x:39,y:33.2+headConst},{x:40,y:33.8+headConst},{x:41,y:34.3+headConst},{x:42,y:34.8+headConst},{x:43,y:35.3+headConst},{x:44,y:35.7+headConst},{x:45,y:36.2+headConst},{x:46,y:36.6+headConst},{x:47,y:36.9+headConst},{x:48,y:37.3+headConst},{x:49,y:37.7+headConst},{x:50,y:38+headConst},{x:51,y:38.3+headConst},{x:52,y:38.6+headConst},{x:53,y:38.9+headConst},{x:54,y:39.2+headConst},{x:55,y:39.5+headConst},{x:56,y:39.7+headConst},{x:57,y:40+headConst},{x:58,y:40.2+headConst},{x:59,y:40.5+headConst},{x:60,y:40.7+headConst},{x:61,y:40.9+headConst},{x:62,y:41.1+headConst},{x:63,y:41.3+headConst},{x:64,y:41.5+headConst}];
                    
            var set3 = [{x:27,y:24.8+headConst},{x:28,y:25.9+headConst},{x:29,y:27+headConst},{x:30,y:27.9+headConst},{x:31,y:28.9+headConst},{x:32,y:29.7+headConst},{x:33,y:30.5+headConst},{x:34,y:31.3+headConst},{x:35,y:32+headConst},{x:36,y:32.7+headConst},{x:37,y:33.3+headConst},{x:38,y:33.9+headConst},{x:39,y:34.5+headConst},{x:40,y:35+headConst},{x:41,y:35.6+headConst},{x:42,y:36.1+headConst},{x:43,y:36.5+headConst},{x:44,y:37+headConst},{x:45,y:37.4+headConst},{x:46,y:37.8+headConst},{x:47,y:38.2+headConst},{x:48,y:38.6+headConst},{x:49,y:38.9+headConst},{x:50,y:39.3+headConst},{x:51,y:39.6+headConst},{x:52,y:40+headConst},{x:53,y:40.3+headConst},{x:54,y:40.6+headConst},{x:55,y:40.8+headConst},{x:56,y:41.1+headConst},{x:57,y:41.4+headConst},{x:58,y:41.6+headConst},{x:59,y:41.9+headConst},{x:60,y:42.1+headConst},{x:61,y:42.4+headConst},{x:62,y:42.6+headConst},{x:63,y:42.8+headConst},{x:64,y:43+headConst}];

            var set4 = [{x:27,y:27+headConst},{x:28,y:28+headConst},{x:29,y:28.9+headConst},{x:30,y:29.7+headConst},{x:31,y:30.5+headConst},{x:32,y:31.3+headConst},{x:33,y:32+headConst},{x:34,y:32.7+headConst},{x:35,y:33.4+headConst},{x:36,y:34+headConst},{x:37,y:34.6+headConst},{x:38,y:35.2+headConst},{x:39,y:35.8+headConst},{x:40,y:36.3+headConst},{x:41,y:36.8+headConst},{x:42,y:37.3+headConst},{x:43,y:37.8+headConst},{x:44,y:38.2+headConst},{x:45,y:38.7+headConst},{x:46,y:39.1+headConst},{x:47,y:39.5+headConst},{x:48,y:39.9+headConst},{x:49,y:40.2+headConst},{x:50,y:40.6+headConst},{x:51,y:40.9+headConst},{x:52,y:41.3+headConst},{x:53,y:41.6+headConst},{x:54,y:41.9+headConst},{x:55,y:42.2+headConst},{x:56,y:42.5+headConst},{x:57,y:42.8+headConst},{x:58,y:43.1+headConst},{x:59,y:43.3+headConst},{x:60,y:43.6+headConst},{x:61,y:43.8+headConst},{x:62,y:44.1+headConst},{x:63,y:44.3+headConst},{x:64,y:44.5+headConst}];

            var set5 = [{x:27,y:28+headConst},{x:28,y:28.9+headConst},{x:29,y:29.7+headConst},{x:30,y:30.5+headConst},{x:31,y:31.3+headConst},{x:32,y:32+headConst},{x:33,y:32.7+headConst},{x:34,y:33.4+headConst},{x:35,y:34+headConst},{x:36,y:34.7+headConst},{x:37,y:35.3+headConst},{x:38,y:35.8+headConst},{x:39,y:36.4+headConst},{x:40,y:36.9+headConst},{x:41,y:37.4+headConst},{x:42,y:37.9+headConst},{x:43,y:38.4+headConst},{x:44,y:38.8+headConst},{x:45,y:39.2+headConst},{x:46,y:39.7+headConst},{x:47,y:40.1+headConst},{x:48,y:40.5+headConst},{x:49,y:40.8+headConst},{x:50,y:41.2+headConst},{x:51,y:41.6+headConst},{x:52,y:41.9+headConst},{x:53,y:42.2+headConst},{x:54,y:42.5+headConst},{x:55,y:42.9+headConst},{x:56,y:43.2+headConst},{x:57,y:43.4+headConst},{x:58,y:43.7+headConst},{x:59,y:44+headConst},{x:60,y:44.3+headConst},{x:61,y:44.5+headConst},{x:62,y:44.8+headConst},{x:63,y:45+headConst},{x:64,y:45.3+headConst}];
            // End of Head data

            // Start of Length data
            var set6 = [{x:27,y:28.7+lengthConst},{x:28,y:30.7+lengthConst},{x:29,y:32.5+lengthConst},{x:30,y:34.3+lengthConst},{x:31,y:36+lengthConst},{x:32,y:37.5+lengthConst},{x:33,y:39+lengthConst},{x:34,y:40.5+lengthConst},{x:35,y:41.8+lengthConst},{x:36,y:43.1+lengthConst},{x:37,y:44.3+lengthConst},{x:38,y:45.4+lengthConst},{x:39,y:46.5+lengthConst},{x:40,y:47.5+lengthConst},{x:41,y:48.5+lengthConst},{x:42,y:49.4+lengthConst},{x:43,y:50.3+lengthConst},{x:44,y:51.1+lengthConst},{x:45,y:51.9+lengthConst},{x:46,y:52.7+lengthConst},{x:47,y:53.4+lengthConst},{x:48,y:54.2+lengthConst},{x:49,y:54.8+lengthConst},{x:50,y:55.5+lengthConst},{x:51,y:56.1+lengthConst},{x:52,y:56.7+lengthConst},{x:53,y:57.3+lengthConst},{x:54,y:57.8+lengthConst},{x:55,y:58.4+lengthConst},{x:56,y:58.9+lengthConst},{x:57,y:59.4+lengthConst},{x:58,y:59.9+lengthConst},{x:59,y:60.4+lengthConst},{x:60,y:60.8+lengthConst},{x:61,y:61.3+lengthConst},{x:62,y:61.7+lengthConst},{x:63,y:62.1+lengthConst},{x:64,y:62.5+lengthConst}];

            var set7 = [{x:27,y:29.9+lengthConst},{x:28,y:31.9+lengthConst},{x:29,y:33.7+lengthConst},{x:30,y:35.4+lengthConst},{x:31,y:37.1+lengthConst},{x:32,y:38.7+lengthConst},{x:33,y:40.1+lengthConst},{x:34,y:41.5+lengthConst},{x:35,y:42.9+lengthConst},{x:36,y:44.1+lengthConst},{x:37,y:45.3+lengthConst},{x:38,y:46.5+lengthConst},{x:39,y:47.5+lengthConst},{x:40,y:48.6+lengthConst},{x:41,y:49.6+lengthConst},{x:42,y:50.5+lengthConst},{x:43,y:51.4+lengthConst},{x:44,y:52.2+lengthConst},{x:45,y:53+lengthConst},{x:46,y:53.8+lengthConst},{x:47,y:54.6+lengthConst},{x:48,y:55.3+lengthConst},{x:49,y:56+lengthConst},{x:50,y:56.6+lengthConst},{x:51,y:57.2+lengthConst},{x:52,y:57.9+lengthConst},{x:53,y:58.4+lengthConst},{x:54,y:59+lengthConst},{x:55,y:59.6+lengthConst},{x:56,y:60.1+lengthConst},{x:57,y:60.6+lengthConst},{x:58,y:61.1+lengthConst},{x:59,y:61.6+lengthConst},{x:60,y:62.1+lengthConst},{x:61,y:62.5+lengthConst},{x:62,y:63+lengthConst},{x:63,y:63.4+lengthConst},{x:64,y:63.8+lengthConst}];
                    
            var set8 = [{x:27,y:32.7+lengthConst},{x:28,y:34.6+lengthConst},{x:29,y:36.3+lengthConst},{x:30,y:38+lengthConst},{x:31,y:39.6+lengthConst},{x:32,y:41.1+lengthConst},{x:33,y:42.6+lengthConst},{x:34,y:44+lengthConst},{x:35,y:45.3+lengthConst},{x:36,y:46.5+lengthConst},{x:37,y:47.7+lengthConst},{x:38,y:48.8+lengthConst},{x:39,y:49.9+lengthConst},{x:40,y:50.9+lengthConst},{x:41,y:51.9+lengthConst},{x:42,y:52.8+lengthConst},{x:43,y:53.7+lengthConst},{x:44,y:54.6+lengthConst},{x:45,y:55.4+lengthConst},{x:46,y:56.2+lengthConst},{x:47,y:57+lengthConst},{x:48,y:57.7+lengthConst},{x:49,y:58.4+lengthConst},{x:50,y:59.1+lengthConst},{x:51,y:59.8+lengthConst},{x:52,y:60.4+lengthConst},{x:53,y:61+lengthConst},{x:54,y:61.6+lengthConst},{x:55,y:62.2+lengthConst},{x:56,y:62.8+lengthConst},{x:57,y:63.3+lengthConst},{x:58,y:63.8+lengthConst},{x:59,y:64.4+lengthConst},{x:60,y:64.9+lengthConst},{x:61,y:65.4+lengthConst},{x:62,y:65.8+lengthConst},{x:63,y:66.3+lengthConst},{x:64,y:66.8+lengthConst}];

            var set9 = [{x:27,y:35.7+lengthConst},{x:28,y:37.5+lengthConst},{x:29,y:39.2+lengthConst},{x:30,y:40.8+lengthConst},{x:31,y:42.3+lengthConst},{x:32,y:43.8+lengthConst},{x:33,y:45.2+lengthConst},{x:34,y:46.5+lengthConst},{x:35,y:47.8+lengthConst},{x:36,y:49+lengthConst},{x:37,y:50.2+lengthConst},{x:38,y:51.3+lengthConst},{x:39,y:52.4+lengthConst},{x:40,y:53.4+lengthConst},{x:41,y:54.4+lengthConst},{x:42,y:55.3+lengthConst},{x:43,y:56.2+lengthConst},{x:44,y:57.1+lengthConst},{x:45,y:57.9+lengthConst},{x:46,y:58.7+lengthConst},{x:47,y:59.5+lengthConst},{x:48,y:60.3+lengthConst},{x:49,y:61+lengthConst},{x:50,y:61.7+lengthConst},{x:51,y:62.4+lengthConst},{x:52,y:63.1+lengthConst},{x:53,y:63.7+lengthConst},{x:54,y:64.3+lengthConst},{x:55,y:64.9+lengthConst},{x:56,y:65.5+lengthConst},{x:57,y:66.1+lengthConst},{x:58,y:66.7+lengthConst},{x:59,y:67.2+lengthConst},{x:60,y:67.8+lengthConst},{x:61,y:68.3+lengthConst},{x:62,y:68.8+lengthConst},{x:63,y:69.3+lengthConst},{x:64,y:69.8+lengthConst}];

            var set10 = [{x:27,y:37.3+lengthConst},{x:28,y:39+lengthConst},{x:29,y:40.6+lengthConst},{x:30,y:42.2+lengthConst},{x:31,y:43.7+lengthConst},{x:32,y:45.1+lengthConst},{x:33,y:46.5+lengthConst},{x:34,y:47.8+lengthConst},{x:35,y:49+lengthConst},{x:36,y:50.2+lengthConst},{x:37,y:51.4+lengthConst},{x:38,y:52.5+lengthConst},{x:39,y:53.6+lengthConst},{x:40,y:54.6+lengthConst},{x:41,y:55.6+lengthConst},{x:42,y:56.5+lengthConst},{x:43,y:57.4+lengthConst},{x:44,y:58.3+lengthConst},{x:45,y:59.1+lengthConst},{x:46,y:60+lengthConst},{x:47,y:60.7+lengthConst},{x:48,y:61.5+lengthConst},{x:49,y:62.3+lengthConst},{x:50,y:63+lengthConst},{x:51,y:63.7+lengthConst},{x:52,y:64.4+lengthConst},{x:53,y:65+lengthConst},{x:54,y:65.7+lengthConst},{x:55,y:66.3+lengthConst},{x:56,y:66.9+lengthConst},{x:57,y:67.5+lengthConst},{x:58,y:68.1+lengthConst},{x:59,y:68.6+lengthConst},{x:60,y:69.2+lengthConst},{x:61,y:69.7+lengthConst},{x:62,y:70.2+lengthConst},{x:63,y:70.8+lengthConst},{x:64,y:71.3+lengthConst}];
            // End of Length data
            
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([lengthData]);
            var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([65,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([65,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,61]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,61]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
				return xAxisBottomFake(d);
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 1)).tickFormat(function(d){
                return xAxisBottomFake(d);
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%5==0 ? yAxisLeftFake(d):'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 61,1)).tickFormat(function(d){
                return d%5==0 ? yAxisRightFake(d):'';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var xAxisBottomFake = function(d){
                switch (d){
                case 28:return 28;
                case 38:return 38;
                case 48:return 48;
                case 58:return 58;
                case 64:return 64;
                default: return '';
                }
            };
            var yAxisLeftFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return '';
                case 14:return 28;
                case 16:return 30;
                case 18:return 32;
                case 20:return 34;
                case 22:return 36;
                case 24:return 38;
                case 26:return 40;
                case 28:return 42;
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var yAxisRightFake = function(d){
                switch (d){
                case 0:return 20;
                case 2:return 22;
                case 4:return 24;
                case 6:return 26;
                case 8:return 28;
                case 10:return 30;
                case 12:return 32;
                case 14:return 34;
                case 16:return 36;
                case 18:return 38;
                case 20:return 40;
                case 22:return 42;
                case 24:return 44;
                case 26:return 46;
                case 28:return '';
                case 30:return 44;
                case 32:return 46;
                case 34:return 48;
                case 36:return 50;
                case 38:return 52;
                case 40:return 54;
                case 42:return 56;
                case 44:return 58;
                case 46:return 60;
                case 48:return 62;
                case 50:return 64;
                case 52:return 66;
                case 54:return 68;
                case 56:return 70;
                case 58:return 72;
                case 60:return 74;
                }
            };

            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<61 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<61 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            // svg.append("g")
            //     .attr("class", "x axis")
            //     .attr("transform", "translate(0,0)")
            //     .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -7 )
                .style("text-anchor", "middle")
                .text("Postnatal Growth - Head, Length");

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Postmensural age (weeks)");
            
            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -30 )
            //     .style("text-anchor", "middle")
            //     .text("Head Circumference-for-age BOYS");

            // svg.append("text")
            //     .attr("x", width/2 )
            //     .attr("y", -12 )
            //     .style("text-anchor", "middle")
            //     .text("Birth to 5 years (percentiles)");
            

            svg.append("text")
                .attr("x", -860 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -380 )
                .attr("y", -35 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");

            svg.append("text")
                .attr("x", -700 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Head Circumference (cm)");
            
            svg.append("text")
                .attr("x", -260 )
                .attr("y", 880 )
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Length (cm)");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 200 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 180 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 135 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 85 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 60 )
                .style("text-anchor", "start")
                .text("97 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 630 )
                .style("text-anchor", "start")
                .text("3 rd");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 610 )
                .style("text-anchor", "start")
                .text("10 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 590 )
                .style("text-anchor", "start")
                .text("50 th");
            
            svg.append("text")
                .attr("x", 790 )
                .attr("y", 565 )
                .style("text-anchor", "start")
                .text("90 th");

            svg.append("text")
                .attr("x", 790 )
                .attr("y", 550 )
                .style("text-anchor", "start")
                .text("97 th");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            // svg.append("g")				
            //     .attr("class", "y axis")	
            //     .attr("transform", "translate(" + width + " ,0)")		
            //     .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set6),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set8),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set10),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(hcData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                  svg.append("svg:path")
                  .attr({
                    d: datalineFunc(lengthData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('hlwPretermChartFemaleSmall', function() {
    return {
            restrict: 'EA',
            template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
            link: function(scope, element, attrs){
                var vitalData = scope[attrs.chartData];
                var margin = { top: 20, right: 100, bottom: 40, left: 100 };
                var height = 250 - margin.top - margin.bottom;
                var width = 370 - margin.left - margin.right;
    
            var headConst = -17;
            var lengthConst = -2;
            var weightConst = 42;

            var hcData = [];
            if(vitalData.pretermHc) {
                for(var i = 0; i < vitalData.pretermHc.length; i++){
                    hcData.push({x:vitalData.pretermHc[i].x,y:vitalData.pretermHc[i].y + headConst});
                }
            }

            var heightData = [];
            if(vitalData.pretermHeight) {
                for(var i = 0; i < vitalData.pretermHeight.length; i++){
                    heightData.push({x:vitalData.pretermHeight[i].x,y:vitalData.pretermHeight[i].y + lengthConst});
                }
            }
            
            var weightData = [];
            if(vitalData.pretermWeight) {
                for(var i = 0; i < vitalData.pretermWeight.length; i++){
                    weightData.push({x:vitalData.pretermWeight[i].x,y:(vitalData.pretermWeight[i].y *10) + weightConst});
                }
            }
    
                // Start of Head data
                var set1 = [{x:168,y:19.2+headConst},{x:169,y:19.3+headConst},{x:170,y:19.4+headConst},{x:171,y:19.5+headConst},{x:172,y:19.7+headConst},{x:173,y:19.8+headConst},{x:174,y:19.9+headConst},{x:175,y:20+headConst},{x:176,y:20.2+headConst},{x:177,y:20.3+headConst},{x:178,y:20.4+headConst},{x:179,y:20.6+headConst},{x:180,y:20.7+headConst},{x:181,y:20.8+headConst},{x:182,y:20.9+headConst},{x:183,y:21.1+headConst},{x:184,y:21.2+headConst},{x:185,y:21.3+headConst},{x:186,y:21.4+headConst},{x:187,y:21.6+headConst},{x:188,y:21.7+headConst},{x:189,y:21.8+headConst},{x:190,y:21.9+headConst},{x:191,y:22.1+headConst},{x:192,y:22.2+headConst},{x:193,y:22.3+headConst},{x:194,y:22.5+headConst},{x:195,y:22.6+headConst},{x:196,y:22.7+headConst},{x:197,y:22.8+headConst},{x:198,y:23+headConst},{x:199,y:23.1+headConst},{x:200,y:23.2+headConst},{x:201,y:23.3+headConst},{x:202,y:23.5+headConst},{x:203,y:23.6+headConst},{x:204,y:23.7+headConst},{x:205,y:23.8+headConst},{x:206,y:24+headConst},{x:207,y:24.1+headConst},{x:208,y:24.2+headConst},{x:209,y:24.4+headConst},{x:210,y:24.5+headConst},{x:211,y:24.6+headConst},{x:212,y:24.7+headConst},{x:213,y:24.9+headConst},{x:214,y:25+headConst},{x:215,y:25.1+headConst},{x:216,y:25.2+headConst},{x:217,y:25.4+headConst},{x:218,y:25.5+headConst},{x:219,y:25.6+headConst},{x:220,y:25.7+headConst},{x:221,y:25.9+headConst},{x:222,y:26+headConst},{x:223,y:26.1+headConst},{x:224,y:26.3+headConst},{x:225,y:26.4+headConst},{x:226,y:26.5+headConst},{x:227,y:26.6+headConst},{x:228,y:26.8+headConst},{x:229,y:26.9+headConst},{x:230,y:27+headConst}];
    
                var set2 = [{x:168,y:20.1+headConst},{x:169,y:20.2+headConst},{x:170,y:20.3+headConst},{x:171,y:20.5+headConst},{x:172,y:20.6+headConst},{x:173,y:20.7+headConst},{x:174,y:20.9+headConst},{x:175,y:21+headConst},{x:176,y:21.1+headConst},{x:177,y:21.2+headConst},{x:178,y:21.4+headConst},{x:179,y:21.5+headConst},{x:180,y:21.6+headConst},{x:181,y:21.7+headConst},{x:182,y:21.9+headConst},{x:183,y:22+headConst},{x:184,y:22.1+headConst},{x:185,y:22.2+headConst},{x:186,y:22.4+headConst},{x:187,y:22.5+headConst},{x:188,y:22.6+headConst},{x:189,y:22.8+headConst},{x:190,y:22.9+headConst},{x:191,y:23+headConst},{x:192,y:23.1+headConst},{x:193,y:23.3+headConst},{x:194,y:23.4+headConst},{x:195,y:23.5+headConst},{x:196,y:23.6+headConst},{x:197,y:23.8+headConst},{x:198,y:23.9+headConst},{x:199,y:24+headConst},{x:200,y:24.1+headConst},{x:201,y:24.3+headConst},{x:202,y:24.4+headConst},{x:203,y:24.5+headConst},{x:204,y:24.7+headConst},{x:205,y:24.8+headConst},{x:206,y:24.9+headConst},{x:207,y:25+headConst},{x:208,y:25.2+headConst},{x:209,y:25.3+headConst},{x:210,y:25.4+headConst},{x:211,y:25.5+headConst},{x:212,y:25.7+headConst},{x:213,y:25.8+headConst},{x:214,y:25.9+headConst},{x:215,y:26.1+headConst},{x:216,y:26.2+headConst},{x:217,y:26.3+headConst},{x:218,y:26.4+headConst},{x:219,y:26.6+headConst},{x:220,y:26.7+headConst},{x:221,y:26.8+headConst},{x:222,y:26.9+headConst},{x:223,y:27.1+headConst},{x:224,y:27.2+headConst},{x:225,y:27.3+headConst},{x:226,y:27.4+headConst},{x:227,y:27.6+headConst},{x:228,y:27.7+headConst},{x:229,y:27.8+headConst},{x:230,y:28+headConst}];
                        
                var set3 = [{x:168,y:22.1+headConst},{x:169,y:22.2+headConst},{x:170,y:22.3+headConst},{x:171,y:22.5+headConst},{x:172,y:22.6+headConst},{x:173,y:22.7+headConst},{x:174,y:22.9+headConst},{x:175,y:23+headConst},{x:176,y:23.1+headConst},{x:177,y:23.2+headConst},{x:178,y:23.4+headConst},{x:179,y:23.5+headConst},{x:180,y:23.6+headConst},{x:181,y:23.7+headConst},{x:182,y:23.9+headConst},{x:183,y:24+headConst},{x:184,y:24.1+headConst},{x:185,y:24.2+headConst},{x:186,y:24.4+headConst},{x:187,y:24.5+headConst},{x:188,y:24.6+headConst},{x:189,y:24.8+headConst},{x:190,y:24.9+headConst},{x:191,y:25+headConst},{x:192,y:25.1+headConst},{x:193,y:25.3+headConst},{x:194,y:25.4+headConst},{x:195,y:25.5+headConst},{x:196,y:25.6+headConst},{x:197,y:25.8+headConst},{x:198,y:25.9+headConst},{x:199,y:26+headConst},{x:200,y:26.1+headConst},{x:201,y:26.3+headConst},{x:202,y:26.4+headConst},{x:203,y:26.5+headConst},{x:204,y:26.7+headConst},{x:205,y:26.8+headConst},{x:206,y:26.9+headConst},{x:207,y:27+headConst},{x:208,y:27.2+headConst},{x:209,y:27.3+headConst},{x:210,y:27.4+headConst},{x:211,y:27.5+headConst},{x:212,y:27.7+headConst},{x:213,y:27.8+headConst},{x:214,y:27.9+headConst},{x:215,y:28+headConst},{x:216,y:28.2+headConst},{x:217,y:28.3+headConst},{x:218,y:28.4+headConst},{x:219,y:28.6+headConst},{x:220,y:28.7+headConst},{x:221,y:28.8+headConst},{x:222,y:28.9+headConst},{x:223,y:29.1+headConst},{x:224,y:29.2+headConst},{x:225,y:29.3+headConst},{x:226,y:29.4+headConst},{x:227,y:29.6+headConst},{x:228,y:29.7+headConst},{x:229,y:29.8+headConst},{x:230,y:30+headConst}];
    
                var set4 = [{x:168,y:24.1+headConst},{x:169,y:24.2+headConst},{x:170,y:24.3+headConst},{x:171,y:24.5+headConst},{x:172,y:24.6+headConst},{x:173,y:24.7+headConst},{x:174,y:24.8+headConst},{x:175,y:25+headConst},{x:176,y:25.1+headConst},{x:177,y:25.2+headConst},{x:178,y:25.4+headConst},{x:179,y:25.5+headConst},{x:180,y:25.6+headConst},{x:181,y:25.7+headConst},{x:182,y:25.9+headConst},{x:183,y:26+headConst},{x:184,y:26.1+headConst},{x:185,y:26.2+headConst},{x:186,y:26.4+headConst},{x:187,y:26.5+headConst},{x:188,y:26.6+headConst},{x:189,y:26.8+headConst},{x:190,y:26.9+headConst},{x:191,y:27+headConst},{x:192,y:27.1+headConst},{x:193,y:27.3+headConst},{x:194,y:27.4+headConst},{x:195,y:27.5+headConst},{x:196,y:27.6+headConst},{x:197,y:27.8+headConst},{x:198,y:27.9+headConst},{x:199,y:28+headConst},{x:200,y:28.1+headConst},{x:201,y:28.3+headConst},{x:202,y:28.4+headConst},{x:203,y:28.5+headConst},{x:204,y:28.7+headConst},{x:205,y:28.8+headConst},{x:206,y:28.9+headConst},{x:207,y:29+headConst},{x:208,y:29.2+headConst},{x:209,y:29.3+headConst},{x:210,y:29.4+headConst},{x:211,y:29.5+headConst},{x:212,y:29.7+headConst},{x:213,y:29.8+headConst},{x:214,y:29.9+headConst},{x:215,y:30+headConst},{x:216,y:30.2+headConst},{x:217,y:30.3+headConst},{x:218,y:30.4+headConst},{x:219,y:30.6+headConst},{x:220,y:30.7+headConst},{x:221,y:30.8+headConst},{x:222,y:30.9+headConst},{x:223,y:31.1+headConst},{x:224,y:31.2+headConst},{x:225,y:31.3+headConst},{x:226,y:31.4+headConst},{x:227,y:31.6+headConst},{x:228,y:31.7+headConst},{x:229,y:31.8+headConst},{x:230,y:32+headConst}];
    
                var set5 = [{x:168,y:25+headConst},{x:169,y:25.2+headConst},{x:170,y:25.3+headConst},{x:171,y:25.4+headConst},{x:172,y:25.5+headConst},{x:173,y:25.7+headConst},{x:174,y:25.8+headConst},{x:175,y:25.9+headConst},{x:176,y:26+headConst},{x:177,y:26.2+headConst},{x:178,y:26.3+headConst},{x:179,y:26.4+headConst},{x:180,y:26.5+headConst},{x:181,y:26.7+headConst},{x:182,y:26.8+headConst},{x:183,y:26.9+headConst},{x:184,y:27.1+headConst},{x:185,y:27.2+headConst},{x:186,y:27.3+headConst},{x:187,y:27.4+headConst},{x:188,y:27.6+headConst},{x:189,y:27.7+headConst},{x:190,y:27.8+headConst},{x:191,y:27.9+headConst},{x:192,y:28.1+headConst},{x:193,y:28.2+headConst},{x:194,y:28.3+headConst},{x:195,y:28.4+headConst},{x:196,y:28.6+headConst},{x:197,y:28.7+headConst},{x:198,y:28.8+headConst},{x:199,y:29+headConst},{x:200,y:29.1+headConst},{x:201,y:29.2+headConst},{x:202,y:29.3+headConst},{x:203,y:29.5+headConst},{x:204,y:29.6+headConst},{x:205,y:29.7+headConst},{x:206,y:29.8+headConst},{x:207,y:30+headConst},{x:208,y:30.1+headConst},{x:209,y:30.2+headConst},{x:210,y:30.3+headConst},{x:211,y:30.5+headConst},{x:212,y:30.6+headConst},{x:213,y:30.7+headConst},{x:214,y:30.9+headConst},{x:215,y:31+headConst},{x:216,y:31.1+headConst},{x:217,y:31.2+headConst},{x:218,y:31.4+headConst},{x:219,y:31.5+headConst},{x:220,y:31.6+headConst},{x:221,y:31.7+headConst},{x:222,y:31.9+headConst},{x:223,y:32+headConst},{x:224,y:32.1+headConst},{x:225,y:32.3+headConst},{x:226,y:32.4+headConst},{x:227,y:32.5+headConst},{x:228,y:32.6+headConst},{x:229,y:32.8+headConst},{x:230,y:32.9+headConst}];
                // End of Head data
    
                // Start of Length data
                var set6 = [{x:168,y:26.9+lengthConst},{x:169,y:27.1+lengthConst},{x:170,y:27.3+lengthConst},{x:171,y:27.4+lengthConst},{x:172,y:27.6+lengthConst},{x:173,y:27.8+lengthConst},{x:174,y:28+lengthConst},{x:175,y:28.2+lengthConst},{x:176,y:28.4+lengthConst},{x:177,y:28.5+lengthConst},{x:178,y:28.7+lengthConst},{x:179,y:28.9+lengthConst},{x:180,y:29.1+lengthConst},{x:181,y:29.3+lengthConst},{x:182,y:29.4+lengthConst},{x:183,y:29.6+lengthConst},{x:184,y:29.8+lengthConst},{x:185,y:30+lengthConst},{x:186,y:30.2+lengthConst},{x:187,y:30.3+lengthConst},{x:188,y:30.5+lengthConst},{x:189,y:30.7+lengthConst},{x:190,y:30.9+lengthConst},{x:191,y:31.1+lengthConst},{x:192,y:31.3+lengthConst},{x:193,y:31.4+lengthConst},{x:194,y:31.6+lengthConst},{x:195,y:31.8+lengthConst},{x:196,y:32+lengthConst},{x:197,y:32.2+lengthConst},{x:198,y:32.3+lengthConst},{x:199,y:32.5+lengthConst},{x:200,y:32.7+lengthConst},{x:201,y:32.9+lengthConst},{x:202,y:33.1+lengthConst},{x:203,y:33.2+lengthConst},{x:204,y:33.4+lengthConst},{x:205,y:33.6+lengthConst},{x:206,y:33.8+lengthConst},{x:207,y:34+lengthConst},{x:208,y:34.2+lengthConst},{x:209,y:34.3+lengthConst},{x:210,y:34.5+lengthConst},{x:211,y:34.7+lengthConst},{x:212,y:34.9+lengthConst},{x:213,y:35.1+lengthConst},{x:214,y:35.2+lengthConst},{x:215,y:35.4+lengthConst},{x:216,y:35.6+lengthConst},{x:217,y:35.8+lengthConst},{x:218,y:36+lengthConst},{x:219,y:36.2+lengthConst},{x:220,y:36.3+lengthConst},{x:221,y:36.5+lengthConst},{x:222,y:36.7+lengthConst},{x:223,y:36.9+lengthConst},{x:224,y:37.1+lengthConst},{x:225,y:37.2+lengthConst},{x:226,y:37.4+lengthConst},{x:227,y:37.6+lengthConst},{x:228,y:37.8+lengthConst},{x:229,y:38+lengthConst},{x:230,y:38.1+lengthConst}];
    
                var set7 = [{x:168,y:28.5+lengthConst},{x:169,y:28.6+lengthConst},{x:170,y:28.8+lengthConst},{x:171,y:29+lengthConst},{x:172,y:29.2+lengthConst},{x:173,y:29.4+lengthConst},{x:174,y:29.5+lengthConst},{x:175,y:29.7+lengthConst},{x:176,y:29.9+lengthConst},{x:177,y:30.1+lengthConst},{x:178,y:30.3+lengthConst},{x:179,y:30.5+lengthConst},{x:180,y:30.6+lengthConst},{x:181,y:30.8+lengthConst},{x:182,y:31+lengthConst},{x:183,y:31.2+lengthConst},{x:184,y:31.4+lengthConst},{x:185,y:31.5+lengthConst},{x:186,y:31.7+lengthConst},{x:187,y:31.9+lengthConst},{x:188,y:32.1+lengthConst},{x:189,y:32.3+lengthConst},{x:190,y:32.4+lengthConst},{x:191,y:32.6+lengthConst},{x:192,y:32.8+lengthConst},{x:193,y:33+lengthConst},{x:194,y:33.2+lengthConst},{x:195,y:33.4+lengthConst},{x:196,y:33.5+lengthConst},{x:197,y:33.7+lengthConst},{x:198,y:33.9+lengthConst},{x:199,y:34.1+lengthConst},{x:200,y:34.3+lengthConst},{x:201,y:34.4+lengthConst},{x:202,y:34.6+lengthConst},{x:203,y:34.8+lengthConst},{x:204,y:35+lengthConst},{x:205,y:35.2+lengthConst},{x:206,y:35.4+lengthConst},{x:207,y:35.5+lengthConst},{x:208,y:35.7+lengthConst},{x:209,y:35.9+lengthConst},{x:210,y:36.1+lengthConst},{x:211,y:36.3+lengthConst},{x:212,y:36.4+lengthConst},{x:213,y:36.6+lengthConst},{x:214,y:36.8+lengthConst},{x:215,y:37+lengthConst},{x:216,y:37.2+lengthConst},{x:217,y:37.3+lengthConst},{x:218,y:37.5+lengthConst},{x:219,y:37.7+lengthConst},{x:220,y:37.9+lengthConst},{x:221,y:38.1+lengthConst},{x:222,y:38.3+lengthConst},{x:223,y:38.4+lengthConst},{x:224,y:38.6+lengthConst},{x:225,y:38.8+lengthConst},{x:226,y:39+lengthConst},{x:227,y:39.2+lengthConst},{x:228,y:39.3+lengthConst},{x:229,y:39.5+lengthConst},{x:230,y:39.7+lengthConst}];
                        
                var set8 = [{x:168,y:31.8+lengthConst},{x:169,y:32+lengthConst},{x:170,y:32.2+lengthConst},{x:171,y:32.3+lengthConst},{x:172,y:32.5+lengthConst},{x:173,y:32.7+lengthConst},{x:174,y:32.9+lengthConst},{x:175,y:33.1+lengthConst},{x:176,y:33.2+lengthConst},{x:177,y:33.4+lengthConst},{x:178,y:33.6+lengthConst},{x:179,y:33.8+lengthConst},{x:180,y:34+lengthConst},{x:181,y:34.1+lengthConst},{x:182,y:34.3+lengthConst},{x:183,y:34.5+lengthConst},{x:184,y:34.7+lengthConst},{x:185,y:34.9+lengthConst},{x:186,y:35.1+lengthConst},{x:187,y:35.2+lengthConst},{x:188,y:35.4+lengthConst},{x:189,y:35.6+lengthConst},{x:190,y:35.8+lengthConst},{x:191,y:36+lengthConst},{x:192,y:36.1+lengthConst},{x:193,y:36.3+lengthConst},{x:194,y:36.5+lengthConst},{x:195,y:36.7+lengthConst},{x:196,y:36.9+lengthConst},{x:197,y:37+lengthConst},{x:198,y:37.2+lengthConst},{x:199,y:37.4+lengthConst},{x:200,y:37.6+lengthConst},{x:201,y:37.8+lengthConst},{x:202,y:38+lengthConst},{x:203,y:38.1+lengthConst},{x:204,y:38.3+lengthConst},{x:205,y:38.5+lengthConst},{x:206,y:38.7+lengthConst},{x:207,y:38.9+lengthConst},{x:208,y:39+lengthConst},{x:209,y:39.2+lengthConst},{x:210,y:39.4+lengthConst},{x:211,y:39.6+lengthConst},{x:212,y:39.8+lengthConst},{x:213,y:40+lengthConst},{x:214,y:40.1+lengthConst},{x:215,y:40.3+lengthConst},{x:216,y:40.5+lengthConst},{x:217,y:40.7+lengthConst},{x:218,y:40.9+lengthConst},{x:219,y:41+lengthConst},{x:220,y:41.2+lengthConst},{x:221,y:41.4+lengthConst},{x:222,y:41.6+lengthConst},{x:223,y:41.8+lengthConst},{x:224,y:41.9+lengthConst},{x:225,y:42.1+lengthConst},{x:226,y:42.3+lengthConst},{x:227,y:42.5+lengthConst},{x:228,y:42.7+lengthConst},{x:229,y:42.9+lengthConst},{x:230,y:43+lengthConst}];
    
                var set9 = [{x:168,y:35.1+lengthConst},{x:169,y:35.3+lengthConst},{x:170,y:35.5+lengthConst},{x:171,y:35.7+lengthConst},{x:172,y:35.8+lengthConst},{x:173,y:36+lengthConst},{x:174,y:36.2+lengthConst},{x:175,y:36.4+lengthConst},{x:176,y:36.6+lengthConst},{x:177,y:36.8+lengthConst},{x:178,y:36.9+lengthConst},{x:179,y:37.1+lengthConst},{x:180,y:37.3+lengthConst},{x:181,y:37.5+lengthConst},{x:182,y:37.7+lengthConst},{x:183,y:37.8+lengthConst},{x:184,y:38+lengthConst},{x:185,y:38.2+lengthConst},{x:186,y:38.4+lengthConst},{x:187,y:38.6+lengthConst},{x:188,y:38.7+lengthConst},{x:189,y:38.9+lengthConst},{x:190,y:39.1+lengthConst},{x:191,y:39.3+lengthConst},{x:192,y:39.5+lengthConst},{x:193,y:39.7+lengthConst},{x:194,y:39.8+lengthConst},{x:195,y:40+lengthConst},{x:196,y:40.2+lengthConst},{x:197,y:40.4+lengthConst},{x:198,y:40.6+lengthConst},{x:199,y:40.7+lengthConst},{x:200,y:40.9+lengthConst},{x:201,y:41.1+lengthConst},{x:202,y:41.3+lengthConst},{x:203,y:41.5+lengthConst},{x:204,y:41.7+lengthConst},{x:205,y:41.8+lengthConst},{x:206,y:42+lengthConst},{x:207,y:42.2+lengthConst},{x:208,y:42.4+lengthConst},{x:209,y:42.6+lengthConst},{x:210,y:42.7+lengthConst},{x:211,y:42.9+lengthConst},{x:212,y:43.1+lengthConst},{x:213,y:43.3+lengthConst},{x:214,y:43.5+lengthConst},{x:215,y:43.6+lengthConst},{x:216,y:43.8+lengthConst},{x:217,y:44+lengthConst},{x:218,y:44.2+lengthConst},{x:219,y:44.4+lengthConst},{x:220,y:44.6+lengthConst},{x:221,y:44.7+lengthConst},{x:222,y:44.9+lengthConst},{x:223,y:45.1+lengthConst},{x:224,y:45.3+lengthConst},{x:225,y:45.5+lengthConst},{x:226,y:45.6+lengthConst},{x:227,y:45.8+lengthConst},{x:228,y:46+lengthConst},{x:229,y:46.2+lengthConst},{x:230,y:46.4+lengthConst}];
    
                var set10 = [{x:168,y:36.7+lengthConst},{x:169,y:36.9+lengthConst},{x:170,y:37+lengthConst},{x:171,y:37.2+lengthConst},{x:172,y:37.4+lengthConst},{x:173,y:37.6+lengthConst},{x:174,y:37.8+lengthConst},{x:175,y:37.9+lengthConst},{x:176,y:38.1+lengthConst},{x:177,y:38.3+lengthConst},{x:178,y:38.5+lengthConst},{x:179,y:38.7+lengthConst},{x:180,y:38.9+lengthConst},{x:181,y:39+lengthConst},{x:182,y:39.2+lengthConst},{x:183,y:39.4+lengthConst},{x:184,y:39.6+lengthConst},{x:185,y:39.8+lengthConst},{x:186,y:39.9+lengthConst},{x:187,y:40.1+lengthConst},{x:188,y:40.3+lengthConst},{x:189,y:40.5+lengthConst},{x:190,y:40.7+lengthConst},{x:191,y:40.9+lengthConst},{x:192,y:41+lengthConst},{x:193,y:41.2+lengthConst},{x:194,y:41.4+lengthConst},{x:195,y:41.6+lengthConst},{x:196,y:41.8+lengthConst},{x:197,y:41.9+lengthConst},{x:198,y:42.1+lengthConst},{x:199,y:42.3+lengthConst},{x:200,y:42.5+lengthConst},{x:201,y:42.7+lengthConst},{x:202,y:42.8+lengthConst},{x:203,y:43+lengthConst},{x:204,y:43.2+lengthConst},{x:205,y:43.4+lengthConst},{x:206,y:43.6+lengthConst},{x:207,y:43.8+lengthConst},{x:208,y:43.9+lengthConst},{x:209,y:44.1+lengthConst},{x:210,y:44.3+lengthConst},{x:211,y:44.5+lengthConst},{x:212,y:44.7+lengthConst},{x:213,y:44.8+lengthConst},{x:214,y:45+lengthConst},{x:215,y:45.2+lengthConst},{x:216,y:45.4+lengthConst},{x:217,y:45.6+lengthConst},{x:218,y:45.7+lengthConst},{x:219,y:45.9+lengthConst},{x:220,y:46.1+lengthConst},{x:221,y:46.3+lengthConst},{x:222,y:46.5+lengthConst},{x:223,y:46.7+lengthConst},{x:224,y:46.8+lengthConst},{x:225,y:47+lengthConst},{x:226,y:47.2+lengthConst},{x:227,y:47.4+lengthConst},{x:228,y:47.6+lengthConst},{x:229,y:47.7+lengthConst},{x:230,y:47.9+lengthConst}];
                // End of Length data
                
                // Start of Weight data
                var set11 = [{x:168,y:(0.42*10)+weightConst},{x:169,y:(0.43*10)+weightConst},{x:170,y:(0.44*10)+weightConst},{x:171,y:(0.44*10)+weightConst},{x:172,y:(0.45*10)+weightConst},{x:173,y:(0.46*10)+weightConst},{x:174,y:(0.47*10)+weightConst},{x:175,y:(0.48*10)+weightConst},{x:176,y:(0.49*10)+weightConst},{x:177,y:(0.5*10)+weightConst},{x:178,y:(0.51*10)+weightConst},{x:179,y:(0.52*10)+weightConst},{x:180,y:(0.53*10)+weightConst},{x:181,y:(0.54*10)+weightConst},{x:182,y:(0.55*10)+weightConst},{x:183,y:(0.56*10)+weightConst},{x:184,y:(0.57*10)+weightConst},{x:185,y:(0.58*10)+weightConst},{x:186,y:(0.59*10)+weightConst},{x:187,y:(0.6*10)+weightConst},{x:188,y:(0.61*10)+weightConst},{x:189,y:(0.62*10)+weightConst},{x:190,y:(0.63*10)+weightConst},{x:191,y:(0.64*10)+weightConst},{x:192,y:(0.66*10)+weightConst},{x:193,y:(0.67*10)+weightConst},{x:194,y:(0.68*10)+weightConst},{x:195,y:(0.69*10)+weightConst},{x:196,y:(0.7*10)+weightConst},{x:197,y:(0.72*10)+weightConst},{x:198,y:(0.73*10)+weightConst},{x:199,y:(0.74*10)+weightConst},{x:200,y:(0.76*10)+weightConst},{x:201,y:(0.77*10)+weightConst},{x:202,y:(0.78*10)+weightConst},{x:203,y:(0.8*10)+weightConst},{x:204,y:(0.81*10)+weightConst},{x:205,y:(0.83*10)+weightConst},{x:206,y:(0.84*10)+weightConst},{x:207,y:(0.86*10)+weightConst},{x:208,y:(0.87*10)+weightConst},{x:209,y:(0.89*10)+weightConst},{x:210,y:(0.9*10)+weightConst},{x:211,y:(0.92*10)+weightConst},{x:212,y:(0.93*10)+weightConst},{x:213,y:(0.95*10)+weightConst},{x:214,y:(0.97*10)+weightConst},{x:215,y:(0.98*10)+weightConst},{x:216,y:(1*10)+weightConst},{x:217,y:(1.02*10)+weightConst},{x:218,y:(1.03*10)+weightConst},{x:219,y:(1.05*10)+weightConst},{x:220,y:(1.07*10)+weightConst},{x:221,y:(1.09*10)+weightConst},{x:222,y:(1.11*10)+weightConst},{x:223,y:(1.12*10)+weightConst},{x:224,y:(1.14*10)+weightConst},{x:225,y:(1.16*10)+weightConst},{x:226,y:(1.18*10)+weightConst},{x:227,y:(1.2*10)+weightConst},{x:228,y:(1.22*10)+weightConst},{x:229,y:(1.24*10)+weightConst},{x:230,y:(1.26*10)+weightConst}];
    
                var set12 = [{x:168,y:(0.47*10)+weightConst},{x:169,y:(0.48*10)+weightConst},{x:170,y:(0.49*10)+weightConst},{x:171,y:(0.5*10)+weightConst},{x:172,y:(0.51*10)+weightConst},{x:173,y:(0.52*10)+weightConst},{x:174,y:(0.53*10)+weightConst},{x:175,y:(0.54*10)+weightConst},{x:176,y:(0.55*10)+weightConst},{x:177,y:(0.56*10)+weightConst},{x:178,y:(0.57*10)+weightConst},{x:179,y:(0.58*10)+weightConst},{x:180,y:(0.59*10)+weightConst},{x:181,y:(0.6*10)+weightConst},{x:182,y:(0.61*10)+weightConst},{x:183,y:(0.62*10)+weightConst},{x:184,y:(0.64*10)+weightConst},{x:185,y:(0.65*10)+weightConst},{x:186,y:(0.66*10)+weightConst},{x:187,y:(0.67*10)+weightConst},{x:188,y:(0.68*10)+weightConst},{x:189,y:(0.7*10)+weightConst},{x:190,y:(0.71*10)+weightConst},{x:191,y:(0.72*10)+weightConst},{x:192,y:(0.74*10)+weightConst},{x:193,y:(0.75*10)+weightConst},{x:194,y:(0.76*10)+weightConst},{x:195,y:(0.78*10)+weightConst},{x:196,y:(0.79*10)+weightConst},{x:197,y:(0.81*10)+weightConst},{x:198,y:(0.82*10)+weightConst},{x:199,y:(0.83*10)+weightConst},{x:200,y:(0.85*10)+weightConst},{x:201,y:(0.86*10)+weightConst},{x:202,y:(0.88*10)+weightConst},{x:203,y:(0.9*10)+weightConst},{x:204,y:(0.91*10)+weightConst},{x:205,y:(0.93*10)+weightConst},{x:206,y:(0.94*10)+weightConst},{x:207,y:(0.96*10)+weightConst},{x:208,y:(0.98*10)+weightConst},{x:209,y:(0.99*10)+weightConst},{x:210,y:(1.01*10)+weightConst},{x:211,y:(1.03*10)+weightConst},{x:212,y:(1.05*10)+weightConst},{x:213,y:(1.07*10)+weightConst},{x:214,y:(1.08*10)+weightConst},{x:215,y:(1.1*10)+weightConst},{x:216,y:(1.12*10)+weightConst},{x:217,y:(1.14*10)+weightConst},{x:218,y:(1.16*10)+weightConst},{x:219,y:(1.18*10)+weightConst},{x:220,y:(1.2*10)+weightConst},{x:221,y:(1.22*10)+weightConst},{x:222,y:(1.24*10)+weightConst},{x:223,y:(1.26*10)+weightConst},{x:224,y:(1.28*10)+weightConst},{x:225,y:(1.31*10)+weightConst},{x:226,y:(1.33*10)+weightConst},{x:227,y:(1.35*10)+weightConst},{x:228,y:(1.37*10)+weightConst},{x:229,y:(1.4*10)+weightConst},{x:230,y:(1.42*10)+weightConst}];
                        
                var set13 = [{x:168,y:(0.6*10)+weightConst},{x:169,y:(0.61*10)+weightConst},{x:170,y:(0.63*10)+weightConst},{x:171,y:(0.64*10)+weightConst},{x:172,y:(0.65*10)+weightConst},{x:173,y:(0.66*10)+weightConst},{x:174,y:(0.68*10)+weightConst},{x:175,y:(0.69*10)+weightConst},{x:176,y:(0.7*10)+weightConst},{x:177,y:(0.71*10)+weightConst},{x:178,y:(0.73*10)+weightConst},{x:179,y:(0.74*10)+weightConst},{x:180,y:(0.76*10)+weightConst},{x:181,y:(0.77*10)+weightConst},{x:182,y:(0.78*10)+weightConst},{x:183,y:(0.8*10)+weightConst},{x:184,y:(0.81*10)+weightConst},{x:185,y:(0.83*10)+weightConst},{x:186,y:(0.85*10)+weightConst},{x:187,y:(0.86*10)+weightConst},{x:188,y:(0.88*10)+weightConst},{x:189,y:(0.89*10)+weightConst},{x:190,y:(0.91*10)+weightConst},{x:191,y:(0.93*10)+weightConst},{x:192,y:(0.94*10)+weightConst},{x:193,y:(0.96*10)+weightConst},{x:194,y:(0.98*10)+weightConst},{x:195,y:(1*10)+weightConst},{x:196,y:(1.01*10)+weightConst},{x:197,y:(1.03*10)+weightConst},{x:198,y:(1.05*10)+weightConst},{x:199,y:(1.07*10)+weightConst},{x:200,y:(1.09*10)+weightConst},{x:201,y:(1.11*10)+weightConst},{x:202,y:(1.13*10)+weightConst},{x:203,y:(1.15*10)+weightConst},{x:204,y:(1.17*10)+weightConst},{x:205,y:(1.19*10)+weightConst},{x:206,y:(1.21*10)+weightConst},{x:207,y:(1.23*10)+weightConst},{x:208,y:(1.25*10)+weightConst},{x:209,y:(1.27*10)+weightConst},{x:210,y:(1.3*10)+weightConst},{x:211,y:(1.32*10)+weightConst},{x:212,y:(1.34*10)+weightConst},{x:213,y:(1.36*10)+weightConst},{x:214,y:(1.39*10)+weightConst},{x:215,y:(1.41*10)+weightConst},{x:216,y:(1.44*10)+weightConst},{x:217,y:(1.46*10)+weightConst},{x:218,y:(1.49*10)+weightConst},{x:219,y:(1.51*10)+weightConst},{x:220,y:(1.54*10)+weightConst},{x:221,y:(1.56*10)+weightConst},{x:222,y:(1.59*10)+weightConst},{x:223,y:(1.62*10)+weightConst},{x:224,y:(1.64*10)+weightConst},{x:225,y:(1.67*10)+weightConst},{x:226,y:(1.7*10)+weightConst},{x:227,y:(1.73*10)+weightConst},{x:228,y:(1.76*10)+weightConst},{x:229,y:(1.79*10)+weightConst},{x:230,y:(1.82*10)+weightConst}];
    
                var set14 = [{x:168,y:(0.77*10)+weightConst},{x:169,y:(0.79*10)+weightConst},{x:170,y:(0.8*10)+weightConst},{x:171,y:(0.82*10)+weightConst},{x:172,y:(0.83*10)+weightConst},{x:173,y:(0.85*10)+weightConst},{x:174,y:(0.87*10)+weightConst},{x:175,y:(0.88*10)+weightConst},{x:176,y:(0.9*10)+weightConst},{x:177,y:(0.92*10)+weightConst},{x:178,y:(0.93*10)+weightConst},{x:179,y:(0.95*10)+weightConst},{x:180,y:(0.97*10)+weightConst},{x:181,y:(0.99*10)+weightConst},{x:182,y:(1.01*10)+weightConst},{x:183,y:(1.02*10)+weightConst},{x:184,y:(1.04*10)+weightConst},{x:185,y:(1.06*10)+weightConst},{x:186,y:(1.08*10)+weightConst},{x:187,y:(1.1*10)+weightConst},{x:188,y:(1.12*10)+weightConst},{x:189,y:(1.14*10)+weightConst},{x:190,y:(1.16*10)+weightConst},{x:191,y:(1.19*10)+weightConst},{x:192,y:(1.21*10)+weightConst},{x:193,y:(1.23*10)+weightConst},{x:194,y:(1.25*10)+weightConst},{x:195,y:(1.27*10)+weightConst},{x:196,y:(1.3*10)+weightConst},{x:197,y:(1.32*10)+weightConst},{x:198,y:(1.34*10)+weightConst},{x:199,y:(1.37*10)+weightConst},{x:200,y:(1.39*10)+weightConst},{x:201,y:(1.42*10)+weightConst},{x:202,y:(1.44*10)+weightConst},{x:203,y:(1.47*10)+weightConst},{x:204,y:(1.5*10)+weightConst},{x:205,y:(1.52*10)+weightConst},{x:206,y:(1.55*10)+weightConst},{x:207,y:(1.58*10)+weightConst},{x:208,y:(1.6*10)+weightConst},{x:209,y:(1.63*10)+weightConst},{x:210,y:(1.66*10)+weightConst},{x:211,y:(1.69*10)+weightConst},{x:212,y:(1.72*10)+weightConst},{x:213,y:(1.75*10)+weightConst},{x:214,y:(1.78*10)+weightConst},{x:215,y:(1.81*10)+weightConst},{x:216,y:(1.84*10)+weightConst},{x:217,y:(1.87*10)+weightConst},{x:218,y:(1.9*10)+weightConst},{x:219,y:(1.94*10)+weightConst},{x:220,y:(1.97*10)+weightConst},{x:221,y:(2*10)+weightConst},{x:222,y:(2.04*10)+weightConst},{x:223,y:(2.07*10)+weightConst},{x:224,y:(2.11*10)+weightConst},{x:225,y:(2.14*10)+weightConst},{x:226,y:(2.18*10)+weightConst},{x:227,y:(2.21*10)+weightConst},{x:228,y:(2.25*10)+weightConst},{x:229,y:(2.29*10)+weightConst},{x:230,y:(2.33*10)+weightConst}];
    
                var set15 = [{x:168,y:(0.87*10)+weightConst},{x:169,y:(0.88*10)+weightConst},{x:170,y:(0.9*10)+weightConst},{x:171,y:(0.92*10)+weightConst},{x:172,y:(0.94*10)+weightConst},{x:173,y:(0.95*10)+weightConst},{x:174,y:(0.97*10)+weightConst},{x:175,y:(0.99*10)+weightConst},{x:176,y:(1.01*10)+weightConst},{x:177,y:(1.03*10)+weightConst},{x:178,y:(1.05*10)+weightConst},{x:179,y:(1.07*10)+weightConst},{x:180,y:(1.09*10)+weightConst},{x:181,y:(1.11*10)+weightConst},{x:182,y:(1.13*10)+weightConst},{x:183,y:(1.15*10)+weightConst},{x:184,y:(1.17*10)+weightConst},{x:185,y:(1.19*10)+weightConst},{x:186,y:(1.22*10)+weightConst},{x:187,y:(1.24*10)+weightConst},{x:188,y:(1.26*10)+weightConst},{x:189,y:(1.28*10)+weightConst},{x:190,y:(1.31*10)+weightConst},{x:191,y:(1.33*10)+weightConst},{x:192,y:(1.36*10)+weightConst},{x:193,y:(1.38*10)+weightConst},{x:194,y:(1.41*10)+weightConst},{x:195,y:(1.43*10)+weightConst},{x:196,y:(1.46*10)+weightConst},{x:197,y:(1.48*10)+weightConst},{x:198,y:(1.51*10)+weightConst},{x:199,y:(1.54*10)+weightConst},{x:200,y:(1.56*10)+weightConst},{x:201,y:(1.59*10)+weightConst},{x:202,y:(1.62*10)+weightConst},{x:203,y:(1.65*10)+weightConst},{x:204,y:(1.68*10)+weightConst},{x:205,y:(1.71*10)+weightConst},{x:206,y:(1.74*10)+weightConst},{x:207,y:(1.77*10)+weightConst},{x:208,y:(1.8*10)+weightConst},{x:209,y:(1.83*10)+weightConst},{x:210,y:(1.86*10)+weightConst},{x:211,y:(1.9*10)+weightConst},{x:212,y:(1.93*10)+weightConst},{x:213,y:(1.96*10)+weightConst},{x:214,y:(2*10)+weightConst},{x:215,y:(2.03*10)+weightConst},{x:216,y:(2.07*10)+weightConst},{x:217,y:(2.1*10)+weightConst},{x:218,y:(2.14*10)+weightConst},{x:219,y:(2.17*10)+weightConst},{x:220,y:(2.21*10)+weightConst},{x:221,y:(2.25*10)+weightConst},{x:222,y:(2.29*10)+weightConst},{x:223,y:(2.33*10)+weightConst},{x:224,y:(2.37*10)+weightConst},{x:225,y:(2.4*10)+weightConst},{x:226,y:(2.45*10)+weightConst},{x:227,y:(2.49*10)+weightConst},{x:228,y:(2.53*10)+weightConst},{x:229,y:(2.57*10)+weightConst},{x:230,y:(2.61*10)+weightConst}];
                // End of Weight data
                
                var rawSvg = element.find("svg")[0];
                var svg = d3.select(rawSvg)
                            .attr("width",width + margin.left + margin.right)
                            .attr("height",height + margin.top + margin.bottom);
                var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
                var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
                var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
                var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');
                var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
                var gEnter = wrap3.enter().append('g').attr('class', 'd3line').append('g');
    
                var div = d3.select("body").append("div")	
                            .attr("class", "tooltip")				
                            .style("opacity", 0);
    
                var lineFunc = d3.svg.line()
                                .x(function (d) {
                                  return xScale0(d.x);
                                })
                                .y(function (d) {
                                  return yScale0(d.y);
                                })
                                .interpolate("bundle")
                                .tension(.8);
    
                var datalineFunc = d3.svg.line()
                                .x(function (d) {
                                  return xScale0(d.x);
                                })
                                .y(function (d) {
                                  return yScale0(d.y);
                                })
                                .interpolate("linear");
    
    
                var g = svg.append("g")
                            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                
                var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
                var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);
    
                var yScale0 = d3.scale.linear().domain([0,73]).range([height, 0]);
                var yScale1 = d3.scale.linear().domain([0,73]).range([height, 0]);
    
                var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                    return '';
                }).innerTickSize(-height)
                                .outerTickSize(0);
                var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                    return '';
                });
                var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 73,2)).tickFormat(function(d){
                    return d%4==0 ? yAxisLeftFake(d):'';
                }).innerTickSize(-width)
                        .outerTickSize(0);
                var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                    return '';
                }).innerTickSize(50)
                        .outerTickSize(50).tickPadding(10);
                
                var yAxisLeftFake = function(d){
                    switch (d){
                    case 0:return 18;
                    case 2:return 19;
                    case 4:return 20;
                    case 6:return 21;
                    case 8:return 22;
                    case 10:return 23;
                    case 12:return 24;
                    case 14:return 25;
                    case 16:return 26;
                    case 18:return 27;
                    case 20:return '';
                    case 22:return 24;
                    case 24:return 26;
                    case 26:return 28;
                    case 28:return 30;
                    case 30:return 32;
                    case 32:return 34;
                    case 34:return 36;
                    case 36:return 38;
                    case 38:return 40;
                    case 40:return 42;
                    case 42:return '';
                    case 44:return 0.2;
                    case 46:return 0.4;
                    case 48:return 0.6;
                    case 50:return 0.8;
                    case 52:return '1.0';
                    case 54:return 1.2;
                    case 56:return 1.4;
                    case 58:return 1.6;
                    case 60:return 1.8;
                    case 62:return '2.0';
                    case 64:return 2.2;
                    case 66:return 2.4;
                    case 68:return 2.6;
                    case 70:return 2.8;
                    case 72:return '3.0';
                    }
                };
    
                var age = function(data) {
                    if(data <= 24){
                        return data.toString().split('.')[0]+ " months";
                    }
                    if(data <=60) {
                        var mon = data/12;
                        var result = mon.toFixed(1).split('.');
                        var mod = data%12;
                        var res = mod.toString().split('.');
                        return result[0].toString()+ " years " + res[0] + " months";
                    }
                };
                
                // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" kg")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
    
                // x-axis
                svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + height + ")")
                    .call(xAxisBottom);
                
                // svg.append("g")
                //     .attr("class", "x axis")
                //     .attr("transform", "translate(0,0)")
                //     .call(xAxisTop);
    
                svg.append("text")
                    .attr("x", width/2 )
                    .attr("y", -7 )
                    .style("text-anchor", "middle")
                    .text("Combined");
    
                svg.append("text")
                    .attr("x", width/2 )
                    .attr("y", height+37 )
                    .style("text-anchor", "middle")
                    .text("Gestational age at birth (weeks)");
                
                svg.append("text")
                    .attr("x", -10 )
                    .attr("y", height+20 )
                    .style("text-anchor", "start")
                    .text("24");
                       
                svg.append("text")
                    .attr("x", 158 )
                    .attr("y", height+20 )
                    .style("text-anchor", "start")
                    .text("33");
                
                // svg.append("text")
                //     .attr("x", -50 )
                //     .attr("y", height+15 )
                //     .style("text-anchor", "start")
                //     .text("Months");
                    
                // y-axis
                svg.append("g")
                    .attr("class", "y axis")
                    .call(yAxisLeft);
                
                // path lines
                svg.append("svg:path")
                      .attr({
                        d: lineFunc(set1),
                        "stroke": "red",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                      });
                svg.append("svg:path")
                      .attr({
                        d: lineFunc(set2),
                        "stroke": "black",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                      });
                svg.append("svg:path")
                      .attr({
                        d: lineFunc(set3),
                        "stroke": "green",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                      });
                svg.append("svg:path")
                      .attr({
                        d: lineFunc(set4),
                        "stroke": "black",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                      });
                svg.append("svg:path")
                      .attr({
                        d: lineFunc(set5),
                        "stroke": "red",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                      });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set6),
                        "stroke": "red",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set7),
                        "stroke": "black",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set8),
                        "stroke": "green",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set9),
                        "stroke": "black",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set10),
                        "stroke": "red",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set11),
                        "stroke": "red",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set12),
                        "stroke": "black",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set13),
                        "stroke": "green",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set14),
                        "stroke": "black",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
    
                svg.append("svg:path")
                    .attr({
                        d: lineFunc(set15),
                        "stroke": "red",
                        "stroke-width": 2,
                        "fill": "none",
                        "class": "path"
                    });
                
                // user data
                svg.append("svg:path")
                .attr({
                d: datalineFunc(hcData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(heightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(weightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });
    
            }
        }
    });
    
'use strict';
angular.module('AngularApp').directive('hlwPretermChartMaleSmall', function() {
return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;

            var headConst = -17;
            var lengthConst = -2;
            var weightConst = 42;

            var hcData = [];
            if(vitalData.pretermHc) {
                for(var i = 0; i < vitalData.pretermHc.length; i++){
                    hcData.push({x:vitalData.pretermHc[i].x,y:vitalData.pretermHc[i].y + headConst});
                }
            }

            var heightData = [];
            if(vitalData.pretermHeight) {
                for(var i = 0; i < vitalData.pretermHeight.length; i++){
                    heightData.push({x:vitalData.pretermHeight[i].x,y:vitalData.pretermHeight[i].y + lengthConst});
                }
            }
            
            var weightData = [];
            if(vitalData.pretermWeight) {
                for(var i = 0; i < vitalData.pretermWeight.length; i++){
                    weightData.push({x:vitalData.pretermWeight[i].x,y:(vitalData.pretermWeight[i].y *10) + weightConst});
                }
            }

            // Start of Head data
            var set1 = [{x:168,y:19.4+headConst},{x:169,y:19.5+headConst},{x:170,y:19.7+headConst},{x:171,y:19.8+headConst},{x:172,y:19.9+headConst},{x:173,y:20+headConst},{x:174,y:20.2+headConst},{x:175,y:20.3+headConst},{x:176,y:20.4+headConst},{x:177,y:20.5+headConst},{x:178,y:20.7+headConst},{x:179,y:20.8+headConst},{x:180,y:20.9+headConst},{x:181,y:21.1+headConst},{x:182,y:21.2+headConst},{x:183,y:21.3+headConst},{x:184,y:21.4+headConst},{x:185,y:21.6+headConst},{x:186,y:21.7+headConst},{x:187,y:21.8+headConst},{x:188,y:21.9+headConst},{x:189,y:22.1+headConst},{x:190,y:22.2+headConst},{x:191,y:22.3+headConst},{x:192,y:22.5+headConst},{x:193,y:22.6+headConst},{x:194,y:22.7+headConst},{x:195,y:22.8+headConst},{x:196,y:23+headConst},{x:197,y:23.1+headConst},{x:198,y:23.2+headConst},{x:199,y:23.3+headConst},{x:200,y:23.5+headConst},{x:201,y:23.6+headConst},{x:202,y:23.7+headConst},{x:203,y:23.8+headConst},{x:204,y:24+headConst},{x:205,y:24.1+headConst},{x:206,y:24.2+headConst},{x:207,y:24.4+headConst},{x:208,y:24.5+headConst},{x:209,y:24.6+headConst},{x:210,y:24.7+headConst},{x:211,y:24.9+headConst},{x:212,y:25+headConst},{x:213,y:25.1+headConst},{x:214,y:25.2+headConst},{x:215,y:25.4+headConst},{x:216,y:25.5+headConst},{x:217,y:25.6+headConst},{x:218,y:25.7+headConst},{x:219,y:25.9+headConst},{x:220,y:26+headConst},{x:221,y:26.1+headConst},{x:222,y:26.3+headConst},{x:223,y:26.4+headConst},{x:224,y:26.5+headConst},{x:225,y:26.6+headConst},{x:226,y:26.8+headConst},{x:227,y:26.9+headConst},{x:228,y:27+headConst},{x:229,y:27.1+headConst},{x:230,y:27.3+headConst}];

            var set2 = [{x:168,y:20.3+headConst},{x:169,y:20.5+headConst},{x:170,y:20.6+headConst},{x:171,y:20.7+headConst},{x:172,y:20.8+headConst},{x:173,y:21+headConst},{x:174,y:21.1+headConst},{x:175,y:21.2+headConst},{x:176,y:21.4+headConst},{x:177,y:21.5+headConst},{x:178,y:21.6+headConst},{x:179,y:21.7+headConst},{x:180,y:21.9+headConst},{x:181,y:22+headConst},{x:182,y:22.1+headConst},{x:183,y:22.2+headConst},{x:184,y:22.4+headConst},{x:185,y:22.5+headConst},{x:186,y:22.6+headConst},{x:187,y:22.8+headConst},{x:188,y:22.9+headConst},{x:189,y:23+headConst},{x:190,y:23.1+headConst},{x:191,y:23.3+headConst},{x:192,y:23.4+headConst},{x:193,y:23.5+headConst},{x:194,y:23.6+headConst},{x:195,y:23.8+headConst},{x:196,y:23.9+headConst},{x:197,y:24+headConst},{x:198,y:24.1+headConst},{x:199,y:24.3+headConst},{x:200,y:24.4+headConst},{x:201,y:24.5+headConst},{x:202,y:24.7+headConst},{x:203,y:24.8+headConst},{x:204,y:24.9+headConst},{x:205,y:25+headConst},{x:206,y:25.2+headConst},{x:207,y:25.3+headConst},{x:208,y:25.4+headConst},{x:209,y:25.5+headConst},{x:210,y:25.7+headConst},{x:211,y:25.8+headConst},{x:212,y:25.9+headConst},{x:213,y:26+headConst},{x:214,y:26.2+headConst},{x:215,y:26.3+headConst},{x:216,y:26.4+headConst},{x:217,y:26.6+headConst},{x:218,y:26.7+headConst},{x:219,y:26.8+headConst},{x:220,y:26.9+headConst},{x:221,y:27.1+headConst},{x:222,y:27.2+headConst},{x:223,y:27.3+headConst},{x:224,y:27.4+headConst},{x:225,y:27.6+headConst},{x:226,y:27.7+headConst},{x:227,y:27.8+headConst},{x:228,y:28+headConst},{x:229,y:28.1+headConst},{x:230,y:28.2+headConst}];
                    
            var set3 = [{x:168,y:22.3+headConst},{x:169,y:22.5+headConst},{x:170,y:22.6+headConst},{x:171,y:22.7+headConst},{x:172,y:22.8+headConst},{x:173,y:23+headConst},{x:174,y:23.1+headConst},{x:175,y:23.2+headConst},{x:176,y:23.4+headConst},{x:177,y:23.5+headConst},{x:178,y:23.6+headConst},{x:179,y:23.7+headConst},{x:180,y:23.9+headConst},{x:181,y:24+headConst},{x:182,y:24.1+headConst},{x:183,y:24.2+headConst},{x:184,y:24.4+headConst},{x:185,y:24.5+headConst},{x:186,y:24.6+headConst},{x:187,y:24.8+headConst},{x:188,y:24.9+headConst},{x:189,y:25+headConst},{x:190,y:25.1+headConst},{x:191,y:25.3+headConst},{x:192,y:25.4+headConst},{x:193,y:25.5+headConst},{x:194,y:25.6+headConst},{x:195,y:25.8+headConst},{x:196,y:25.9+headConst},{x:197,y:26+headConst},{x:198,y:26.1+headConst},{x:199,y:26.3+headConst},{x:200,y:26.4+headConst},{x:201,y:26.5+headConst},{x:202,y:26.7+headConst},{x:203,y:26.8+headConst},{x:204,y:26.9+headConst},{x:205,y:27+headConst},{x:206,y:27.2+headConst},{x:207,y:27.3+headConst},{x:208,y:27.4+headConst},{x:209,y:27.5+headConst},{x:210,y:27.7+headConst},{x:211,y:27.8+headConst},{x:212,y:27.9+headConst},{x:213,y:28+headConst},{x:214,y:28.2+headConst},{x:215,y:28.3+headConst},{x:216,y:28.4+headConst},{x:217,y:28.6+headConst},{x:218,y:28.7+headConst},{x:219,y:28.8+headConst},{x:220,y:28.9+headConst},{x:221,y:29.1+headConst},{x:222,y:29.2+headConst},{x:223,y:29.3+headConst},{x:224,y:29.4+headConst},{x:225,y:29.6+headConst},{x:226,y:29.7+headConst},{x:227,y:29.8+headConst},{x:228,y:29.9+headConst},{x:229,y:30.1+headConst},{x:230,y:30.2+headConst}];

            var set4 = [{x:168,y:24.3+headConst},{x:169,y:24.5+headConst},{x:170,y:24.6+headConst},{x:171,y:24.7+headConst},{x:172,y:24.8+headConst},{x:173,y:25+headConst},{x:174,y:25.1+headConst},{x:175,y:25.2+headConst},{x:176,y:25.4+headConst},{x:177,y:25.5+headConst},{x:178,y:25.6+headConst},{x:179,y:25.7+headConst},{x:180,y:25.9+headConst},{x:181,y:26+headConst},{x:182,y:26.1+headConst},{x:183,y:26.2+headConst},{x:184,y:26.4+headConst},{x:185,y:26.5+headConst},{x:186,y:26.6+headConst},{x:187,y:26.7+headConst},{x:188,y:26.9+headConst},{x:189,y:27+headConst},{x:190,y:27.1+headConst},{x:191,y:27.3+headConst},{x:192,y:27.4+headConst},{x:193,y:27.5+headConst},{x:194,y:27.6+headConst},{x:195,y:27.8+headConst},{x:196,y:27.9+headConst},{x:197,y:28+headConst},{x:198,y:28.1+headConst},{x:199,y:28.3+headConst},{x:200,y:28.4+headConst},{x:201,y:28.5+headConst},{x:202,y:28.7+headConst},{x:203,y:28.8+headConst},{x:204,y:28.9+headConst},{x:205,y:29+headConst},{x:206,y:29.2+headConst},{x:207,y:29.3+headConst},{x:208,y:29.4+headConst},{x:209,y:29.5+headConst},{x:210,y:29.7+headConst},{x:211,y:29.8+headConst},{x:212,y:29.9+headConst},{x:213,y:30+headConst},{x:214,y:30.2+headConst},{x:215,y:30.3+headConst},{x:216,y:30.4+headConst},{x:217,y:30.6+headConst},{x:218,y:30.7+headConst},{x:219,y:30.8+headConst},{x:220,y:30.9+headConst},{x:221,y:31.1+headConst},{x:222,y:31.2+headConst},{x:223,y:31.3+headConst},{x:224,y:31.4+headConst},{x:225,y:31.6+headConst},{x:226,y:31.7+headConst},{x:227,y:31.8+headConst},{x:228,y:31.9+headConst},{x:229,y:32.1+headConst},{x:230,y:32.2+headConst}];

            var set5 = [{x:168,y:25.3+headConst},{x:169,y:25.4+headConst},{x:170,y:25.5+headConst},{x:171,y:25.7+headConst},{x:172,y:25.8+headConst},{x:173,y:25.9+headConst},{x:174,y:26+headConst},{x:175,y:26.2+headConst},{x:176,y:26.3+headConst},{x:177,y:26.4+headConst},{x:178,y:26.5+headConst},{x:179,y:26.7+headConst},{x:180,y:26.8+headConst},{x:181,y:26.9+headConst},{x:182,y:27.1+headConst},{x:183,y:27.2+headConst},{x:184,y:27.3+headConst},{x:185,y:27.4+headConst},{x:186,y:27.6+headConst},{x:187,y:27.7+headConst},{x:188,y:27.8+headConst},{x:189,y:27.9+headConst},{x:190,y:28.1+headConst},{x:191,y:28.2+headConst},{x:192,y:28.3+headConst},{x:193,y:28.4+headConst},{x:194,y:28.6+headConst},{x:195,y:28.7+headConst},{x:196,y:28.8+headConst},{x:197,y:29+headConst},{x:198,y:29.1+headConst},{x:199,y:29.2+headConst},{x:200,y:29.3+headConst},{x:201,y:29.5+headConst},{x:202,y:29.6+headConst},{x:203,y:29.7+headConst},{x:204,y:29.8+headConst},{x:205,y:30+headConst},{x:206,y:30.1+headConst},{x:207,y:30.2+headConst},{x:208,y:30.3+headConst},{x:209,y:30.5+headConst},{x:210,y:30.6+headConst},{x:211,y:30.7+headConst},{x:212,y:30.9+headConst},{x:213,y:31+headConst},{x:214,y:31.1+headConst},{x:215,y:31.2+headConst},{x:216,y:31.4+headConst},{x:217,y:31.5+headConst},{x:218,y:31.6+headConst},{x:219,y:31.7+headConst},{x:220,y:31.9+headConst},{x:221,y:32+headConst},{x:222,y:32.1+headConst},{x:223,y:32.2+headConst},{x:224,y:32.4+headConst},{x:225,y:32.5+headConst},{x:226,y:32.6+headConst},{x:227,y:32.8+headConst},{x:228,y:32.9+headConst},{x:229,y:33+headConst},{x:230,y:33.1+headConst}];
            // End of Head data

            // Start of Length data
            var set6 = [{x:168,y:27.3+lengthConst},{x:169,y:27.5+lengthConst},{x:170,y:27.7+lengthConst},{x:171,y:27.9+lengthConst},{x:172,y:28.1+lengthConst},{x:173,y:28.2+lengthConst},{x:174,y:28.4+lengthConst},{x:175,y:28.6+lengthConst},{x:176,y:28.8+lengthConst},{x:177,y:29+lengthConst},{x:178,y:29.1+lengthConst},{x:179,y:29.3+lengthConst},{x:180,y:29.5+lengthConst},{x:181,y:29.7+lengthConst},{x:182,y:29.9+lengthConst},{x:183,y:30+lengthConst},{x:184,y:30.2+lengthConst},{x:185,y:30.4+lengthConst},{x:186,y:30.6+lengthConst},{x:187,y:30.8+lengthConst},{x:188,y:31+lengthConst},{x:189,y:31.1+lengthConst},{x:190,y:31.3+lengthConst},{x:191,y:31.5+lengthConst},{x:192,y:31.7+lengthConst},{x:193,y:31.9+lengthConst},{x:194,y:32+lengthConst},{x:195,y:32.2+lengthConst},{x:196,y:32.4+lengthConst},{x:197,y:32.6+lengthConst},{x:198,y:32.8+lengthConst},{x:199,y:32.9+lengthConst},{x:200,y:33.1+lengthConst},{x:201,y:33.3+lengthConst},{x:202,y:33.5+lengthConst},{x:203,y:33.7+lengthConst},{x:204,y:33.9+lengthConst},{x:205,y:34+lengthConst},{x:206,y:34.2+lengthConst},{x:207,y:34.4+lengthConst},{x:208,y:34.6+lengthConst},{x:209,y:34.8+lengthConst},{x:210,y:34.9+lengthConst},{x:211,y:35.1+lengthConst},{x:212,y:35.3+lengthConst},{x:213,y:35.5+lengthConst},{x:214,y:35.7+lengthConst},{x:215,y:35.9+lengthConst},{x:216,y:36+lengthConst},{x:217,y:36.2+lengthConst},{x:218,y:36.4+lengthConst},{x:219,y:36.6+lengthConst},{x:220,y:36.8+lengthConst},{x:221,y:36.9+lengthConst},{x:222,y:37.1+lengthConst},{x:223,y:37.3+lengthConst},{x:224,y:37.5+lengthConst},{x:225,y:37.7+lengthConst},{x:226,y:37.8+lengthConst},{x:227,y:38+lengthConst},{x:228,y:38.2+lengthConst},{x:229,y:38.4+lengthConst},{x:230,y:38.6+lengthConst}];

            var set7 = [{x:168,y:28.9+lengthConst},{x:169,y:29.1+lengthConst},{x:170,y:29.2+lengthConst},{x:171,y:29.4+lengthConst},{x:172,y:29.6+lengthConst},{x:173,y:29.8+lengthConst},{x:174,y:30+lengthConst},{x:175,y:30.2+lengthConst},{x:176,y:30.3+lengthConst},{x:177,y:30.5+lengthConst},{x:178,y:30.7+lengthConst},{x:179,y:30.9+lengthConst},{x:180,y:31.1+lengthConst},{x:181,y:31.2+lengthConst},{x:182,y:31.4+lengthConst},{x:183,y:31.6+lengthConst},{x:184,y:31.8+lengthConst},{x:185,y:32+lengthConst},{x:186,y:32.1+lengthConst},{x:187,y:32.3+lengthConst},{x:188,y:32.5+lengthConst},{x:189,y:32.7+lengthConst},{x:190,y:32.9+lengthConst},{x:191,y:33.1+lengthConst},{x:192,y:33.2+lengthConst},{x:193,y:33.4+lengthConst},{x:194,y:33.6+lengthConst},{x:195,y:33.8+lengthConst},{x:196,y:34+lengthConst},{x:197,y:34.1+lengthConst},{x:198,y:34.3+lengthConst},{x:199,y:34.5+lengthConst},{x:200,y:34.7+lengthConst},{x:201,y:34.9+lengthConst},{x:202,y:35.1+lengthConst},{x:203,y:35.2+lengthConst},{x:204,y:35.4+lengthConst},{x:205,y:35.6+lengthConst},{x:206,y:35.8+lengthConst},{x:207,y:36+lengthConst},{x:208,y:36.1+lengthConst},{x:209,y:36.3+lengthConst},{x:210,y:36.5+lengthConst},{x:211,y:36.7+lengthConst},{x:212,y:36.9+lengthConst},{x:213,y:37+lengthConst},{x:214,y:37.2+lengthConst},{x:215,y:37.4+lengthConst},{x:216,y:37.6+lengthConst},{x:217,y:37.8+lengthConst},{x:218,y:38+lengthConst},{x:219,y:38.1+lengthConst},{x:220,y:38.3+lengthConst},{x:221,y:38.5+lengthConst},{x:222,y:38.7+lengthConst},{x:223,y:38.9+lengthConst},{x:224,y:39+lengthConst},{x:225,y:39.2+lengthConst},{x:226,y:39.4+lengthConst},{x:227,y:39.6+lengthConst},{x:228,y:39.8+lengthConst},{x:229,y:40+lengthConst},{x:230,y:40.1+lengthConst}];
                    
            var set8 = [{x:168,y:32.2+lengthConst},{x:169,y:32.4+lengthConst},{x:170,y:32.6+lengthConst},{x:171,y:32.8+lengthConst},{x:172,y:32.9+lengthConst},{x:173,y:33.1+lengthConst},{x:174,y:33.3+lengthConst},{x:175,y:33.5+lengthConst},{x:176,y:33.7+lengthConst},{x:177,y:33.8+lengthConst},{x:178,y:34+lengthConst},{x:179,y:34.2+lengthConst},{x:180,y:34.4+lengthConst},{x:181,y:34.6+lengthConst},{x:182,y:34.8+lengthConst},{x:183,y:34.9+lengthConst},{x:184,y:35.1+lengthConst},{x:185,y:35.3+lengthConst},{x:186,y:35.5+lengthConst},{x:187,y:35.7+lengthConst},{x:188,y:35.8+lengthConst},{x:189,y:36+lengthConst},{x:190,y:36.2+lengthConst},{x:191,y:36.4+lengthConst},{x:192,y:36.6+lengthConst},{x:193,y:36.8+lengthConst},{x:194,y:36.9+lengthConst},{x:195,y:37.1+lengthConst},{x:196,y:37.3+lengthConst},{x:197,y:37.5+lengthConst},{x:198,y:37.7+lengthConst},{x:199,y:37.8+lengthConst},{x:200,y:38+lengthConst},{x:201,y:38.2+lengthConst},{x:202,y:38.4+lengthConst},{x:203,y:38.6+lengthConst},{x:204,y:38.7+lengthConst},{x:205,y:38.9+lengthConst},{x:206,y:39.1+lengthConst},{x:207,y:39.3+lengthConst},{x:208,y:39.5+lengthConst},{x:209,y:39.7+lengthConst},{x:210,y:39.8+lengthConst},{x:211,y:40+lengthConst},{x:212,y:40.2+lengthConst},{x:213,y:40.4+lengthConst},{x:214,y:40.6+lengthConst},{x:215,y:40.7+lengthConst},{x:216,y:40.9+lengthConst},{x:217,y:41.1+lengthConst},{x:218,y:41.3+lengthConst},{x:219,y:41.5+lengthConst},{x:220,y:41.6+lengthConst},{x:221,y:41.8+lengthConst},{x:222,y:42+lengthConst},{x:223,y:42.2+lengthConst},{x:224,y:42.4+lengthConst},{x:225,y:42.6+lengthConst},{x:226,y:42.7+lengthConst},{x:227,y:42.9+lengthConst},{x:228,y:43.1+lengthConst},{x:229,y:43.3+lengthConst},{x:230,y:43.5+lengthConst}];

            var set9 = [{x:168,y:35.5+lengthConst},{x:169,y:35.7+lengthConst},{x:170,y:35.9+lengthConst},{x:171,y:36.1+lengthConst},{x:172,y:36.3+lengthConst},{x:173,y:36.5+lengthConst},{x:174,y:36.6+lengthConst},{x:175,y:36.8+lengthConst},{x:176,y:37+lengthConst},{x:177,y:37.2+lengthConst},{x:178,y:37.4+lengthConst},{x:179,y:37.5+lengthConst},{x:180,y:37.7+lengthConst},{x:181,y:37.9+lengthConst},{x:182,y:38.1+lengthConst},{x:183,y:38.3+lengthConst},{x:184,y:38.4+lengthConst},{x:185,y:38.6+lengthConst},{x:186,y:38.8+lengthConst},{x:187,y:39+lengthConst},{x:188,y:39.2+lengthConst},{x:189,y:39.4+lengthConst},{x:190,y:39.5+lengthConst},{x:191,y:39.7+lengthConst},{x:192,y:39.9+lengthConst},{x:193,y:40.1+lengthConst},{x:194,y:40.3+lengthConst},{x:195,y:40.4+lengthConst},{x:196,y:40.6+lengthConst},{x:197,y:40.8+lengthConst},{x:198,y:41+lengthConst},{x:199,y:41.2+lengthConst},{x:200,y:41.4+lengthConst},{x:201,y:41.5+lengthConst},{x:202,y:41.7+lengthConst},{x:203,y:41.9+lengthConst},{x:204,y:42.1+lengthConst},{x:205,y:42.3+lengthConst},{x:206,y:42.4+lengthConst},{x:207,y:42.6+lengthConst},{x:208,y:42.8+lengthConst},{x:209,y:43+lengthConst},{x:210,y:43.2+lengthConst},{x:211,y:43.3+lengthConst},{x:212,y:43.5+lengthConst},{x:213,y:43.7+lengthConst},{x:214,y:43.9+lengthConst},{x:215,y:44.1+lengthConst},{x:216,y:44.3+lengthConst},{x:217,y:44.4+lengthConst},{x:218,y:44.6+lengthConst},{x:219,y:44.8+lengthConst},{x:220,y:45+lengthConst},{x:221,y:45.2+lengthConst},{x:222,y:45.3+lengthConst},{x:223,y:45.5+lengthConst},{x:224,y:45.7+lengthConst},{x:225,y:45.9+lengthConst},{x:226,y:46.1+lengthConst},{x:227,y:46.3+lengthConst},{x:228,y:46.4+lengthConst},{x:229,y:46.6+lengthConst},{x:230,y:46.8+lengthConst}];

            var set10 = [{x:168,y:37.1+lengthConst},{x:169,y:37.3+lengthConst},{x:170,y:37.5+lengthConst},{x:171,y:37.6+lengthConst},{x:172,y:37.8+lengthConst},{x:173,y:38+lengthConst},{x:174,y:38.2+lengthConst},{x:175,y:38.4+lengthConst},{x:176,y:38.6+lengthConst},{x:177,y:38.7+lengthConst},{x:178,y:38.9+lengthConst},{x:179,y:39.1+lengthConst},{x:180,y:39.3+lengthConst},{x:181,y:39.5+lengthConst},{x:182,y:39.6+lengthConst},{x:183,y:39.8+lengthConst},{x:184,y:40+lengthConst},{x:185,y:40.2+lengthConst},{x:186,y:40.4+lengthConst},{x:187,y:40.6+lengthConst},{x:188,y:40.7+lengthConst},{x:189,y:40.9+lengthConst},{x:190,y:41.1+lengthConst},{x:191,y:41.3+lengthConst},{x:192,y:41.5+lengthConst},{x:193,y:41.6+lengthConst},{x:194,y:41.8+lengthConst},{x:195,y:42+lengthConst},{x:196,y:42.2+lengthConst},{x:197,y:42.4+lengthConst},{x:198,y:42.5+lengthConst},{x:199,y:42.7+lengthConst},{x:200,y:42.9+lengthConst},{x:201,y:43.1+lengthConst},{x:202,y:43.3+lengthConst},{x:203,y:43.5+lengthConst},{x:204,y:43.6+lengthConst},{x:205,y:43.8+lengthConst},{x:206,y:44+lengthConst},{x:207,y:44.2+lengthConst},{x:208,y:44.4+lengthConst},{x:209,y:44.5+lengthConst},{x:210,y:44.7+lengthConst},{x:211,y:44.9+lengthConst},{x:212,y:45.1+lengthConst},{x:213,y:45.3+lengthConst},{x:214,y:45.4+lengthConst},{x:215,y:45.6+lengthConst},{x:216,y:45.8+lengthConst},{x:217,y:46+lengthConst},{x:218,y:46.2+lengthConst},{x:219,y:46.4+lengthConst},{x:220,y:46.5+lengthConst},{x:221,y:46.7+lengthConst},{x:222,y:46.9+lengthConst},{x:223,y:47.1+lengthConst},{x:224,y:47.3+lengthConst},{x:225,y:47.4+lengthConst},{x:226,y:47.6+lengthConst},{x:227,y:47.8+lengthConst},{x:228,y:48+lengthConst},{x:229,y:48.2+lengthConst},{x:230,y:48.4+lengthConst}];
            // End of Length data
            
            // Start of Weight data
            var set11 = [{x:168,y:(0.44*10)+weightConst},{x:169,y:(0.45*10)+weightConst},{x:170,y:(0.46*10)+weightConst},{x:171,y:(0.47*10)+weightConst},{x:172,y:(0.48*10)+weightConst},{x:173,y:(0.49*10)+weightConst},{x:174,y:(0.5*10)+weightConst},{x:175,y:(0.51*10)+weightConst},{x:176,y:(0.52*10)+weightConst},{x:177,y:(0.53*10)+weightConst},{x:178,y:(0.54*10)+weightConst},{x:179,y:(0.55*10)+weightConst},{x:180,y:(0.56*10)+weightConst},{x:181,y:(0.57*10)+weightConst},{x:182,y:(0.58*10)+weightConst},{x:183,y:(0.59*10)+weightConst},{x:184,y:(0.6*10)+weightConst},{x:185,y:(0.61*10)+weightConst},{x:186,y:(0.62*10)+weightConst},{x:187,y:(0.63*10)+weightConst},{x:188,y:(0.65*10)+weightConst},{x:189,y:(0.66*10)+weightConst},{x:190,y:(0.67*10)+weightConst},{x:191,y:(0.68*10)+weightConst},{x:192,y:(0.69*10)+weightConst},{x:193,y:(0.71*10)+weightConst},{x:194,y:(0.72*10)+weightConst},{x:195,y:(0.73*10)+weightConst},{x:196,y:(0.75*10)+weightConst},{x:197,y:(0.76*10)+weightConst},{x:198,y:(0.77*10)+weightConst},{x:199,y:(0.79*10)+weightConst},{x:200,y:(0.8*10)+weightConst},{x:201,y:(0.82*10)+weightConst},{x:202,y:(0.83*10)+weightConst},{x:203,y:(0.84*10)+weightConst},{x:204,y:(0.86*10)+weightConst},{x:205,y:(0.87*10)+weightConst},{x:206,y:(0.89*10)+weightConst},{x:207,y:(0.91*10)+weightConst},{x:208,y:(0.92*10)+weightConst},{x:209,y:(0.94*10)+weightConst},{x:210,y:(0.95*10)+weightConst},{x:211,y:(0.97*10)+weightConst},{x:212,y:(0.99*10)+weightConst},{x:213,y:(1*10)+weightConst},{x:214,y:(1.02*10)+weightConst},{x:215,y:(1.04*10)+weightConst},{x:216,y:(1.06*10)+weightConst},{x:217,y:(1.08*10)+weightConst},{x:218,y:(1.09*10)+weightConst},{x:219,y:(1.11*10)+weightConst},{x:220,y:(1.13*10)+weightConst},{x:221,y:(1.15*10)+weightConst},{x:222,y:(1.17*10)+weightConst},{x:223,y:(1.19*10)+weightConst},{x:224,y:(1.21*10)+weightConst},{x:225,y:(1.23*10)+weightConst},{x:226,y:(1.25*10)+weightConst},{x:227,y:(1.27*10)+weightConst},{x:228,y:(1.29*10)+weightConst},{x:229,y:(1.32*10)+weightConst},{x:230,y:(1.34*10)+weightConst}];

            var set12 = [{x:168,y:(0.5*10)+weightConst},{x:169,y:(0.51*10)+weightConst},{x:170,y:(0.52*10)+weightConst},{x:171,y:(0.53*10)+weightConst},{x:172,y:(0.54*10)+weightConst},{x:173,y:(0.55*10)+weightConst},{x:174,y:(0.56*10)+weightConst},{x:175,y:(0.57*10)+weightConst},{x:176,y:(0.58*10)+weightConst},{x:177,y:(0.59*10)+weightConst},{x:178,y:(0.6*10)+weightConst},{x:179,y:(0.61*10)+weightConst},{x:180,y:(0.63*10)+weightConst},{x:181,y:(0.64*10)+weightConst},{x:182,y:(0.65*10)+weightConst},{x:183,y:(0.66*10)+weightConst},{x:184,y:(0.67*10)+weightConst},{x:185,y:(0.69*10)+weightConst},{x:186,y:(0.7*10)+weightConst},{x:187,y:(0.71*10)+weightConst},{x:188,y:(0.72*10)+weightConst},{x:189,y:(0.74*10)+weightConst},{x:190,y:(0.75*10)+weightConst},{x:191,y:(0.77*10)+weightConst},{x:192,y:(0.78*10)+weightConst},{x:193,y:(0.79*10)+weightConst},{x:194,y:(0.81*10)+weightConst},{x:195,y:(0.82*10)+weightConst},{x:196,y:(0.84*10)+weightConst},{x:197,y:(0.85*10)+weightConst},{x:198,y:(0.87*10)+weightConst},{x:199,y:(0.88*10)+weightConst},{x:200,y:(0.9*10)+weightConst},{x:201,y:(0.92*10)+weightConst},{x:202,y:(0.93*10)+weightConst},{x:203,y:(0.95*10)+weightConst},{x:204,y:(0.97*10)+weightConst},{x:205,y:(0.98*10)+weightConst},{x:206,y:(1*10)+weightConst},{x:207,y:(1.02*10)+weightConst},{x:208,y:(1.03*10)+weightConst},{x:209,y:(1.05*10)+weightConst},{x:210,y:(1.07*10)+weightConst},{x:211,y:(1.09*10)+weightConst},{x:212,y:(1.11*10)+weightConst},{x:213,y:(1.13*10)+weightConst},{x:214,y:(1.15*10)+weightConst},{x:215,y:(1.17*10)+weightConst},{x:216,y:(1.19*10)+weightConst},{x:217,y:(1.21*10)+weightConst},{x:218,y:(1.23*10)+weightConst},{x:219,y:(1.25*10)+weightConst},{x:220,y:(1.27*10)+weightConst},{x:221,y:(1.29*10)+weightConst},{x:222,y:(1.31*10)+weightConst},{x:223,y:(1.34*10)+weightConst},{x:224,y:(1.36*10)+weightConst},{x:225,y:(1.38*10)+weightConst},{x:226,y:(1.41*10)+weightConst},{x:227,y:(1.43*10)+weightConst},{x:228,y:(1.45*10)+weightConst},{x:229,y:(1.48*10)+weightConst},{x:230,y:(1.5*10)+weightConst}];
                    
            var set13 = [{x:168,y:(0.64*10)+weightConst},{x:169,y:(0.65*10)+weightConst},{x:170,y:(0.66*10)+weightConst},{x:171,y:(0.68*10)+weightConst},{x:172,y:(0.69*10)+weightConst},{x:173,y:(0.7*10)+weightConst},{x:174,y:(0.72*10)+weightConst},{x:175,y:(0.73*10)+weightConst},{x:176,y:(0.74*10)+weightConst},{x:177,y:(0.76*10)+weightConst},{x:178,y:(0.77*10)+weightConst},{x:179,y:(0.79*10)+weightConst},{x:180,y:(0.8*10)+weightConst},{x:181,y:(0.82*10)+weightConst},{x:182,y:(0.83*10)+weightConst},{x:183,y:(0.85*10)+weightConst},{x:184,y:(0.86*10)+weightConst},{x:185,y:(0.88*10)+weightConst},{x:186,y:(0.89*10)+weightConst},{x:187,y:(0.91*10)+weightConst},{x:188,y:(0.93*10)+weightConst},{x:189,y:(0.95*10)+weightConst},{x:190,y:(0.96*10)+weightConst},{x:191,y:(0.98*10)+weightConst},{x:192,y:(1*10)+weightConst},{x:193,y:(1.02*10)+weightConst},{x:194,y:(1.03*10)+weightConst},{x:195,y:(1.05*10)+weightConst},{x:196,y:(1.07*10)+weightConst},{x:197,y:(1.09*10)+weightConst},{x:198,y:(1.11*10)+weightConst},{x:199,y:(1.13*10)+weightConst},{x:200,y:(1.15*10)+weightConst},{x:201,y:(1.17*10)+weightConst},{x:202,y:(1.19*10)+weightConst},{x:203,y:(1.21*10)+weightConst},{x:204,y:(1.24*10)+weightConst},{x:205,y:(1.26*10)+weightConst},{x:206,y:(1.28*10)+weightConst},{x:207,y:(1.3*10)+weightConst},{x:208,y:(1.33*10)+weightConst},{x:209,y:(1.35*10)+weightConst},{x:210,y:(1.37*10)+weightConst},{x:211,y:(1.4*10)+weightConst},{x:212,y:(1.42*10)+weightConst},{x:213,y:(1.45*10)+weightConst},{x:214,y:(1.47*10)+weightConst},{x:215,y:(1.5*10)+weightConst},{x:216,y:(1.52*10)+weightConst},{x:217,y:(1.55*10)+weightConst},{x:218,y:(1.57*10)+weightConst},{x:219,y:(1.6*10)+weightConst},{x:220,y:(1.63*10)+weightConst},{x:221,y:(1.66*10)+weightConst},{x:222,y:(1.68*10)+weightConst},{x:223,y:(1.71*10)+weightConst},{x:224,y:(1.74*10)+weightConst},{x:225,y:(1.77*10)+weightConst},{x:226,y:(1.8*10)+weightConst},{x:227,y:(1.83*10)+weightConst},{x:228,y:(1.86*10)+weightConst},{x:229,y:(1.89*10)+weightConst},{x:230,y:(1.92*10)+weightConst}];

            var set14 = [{x:168,y:(0.82*10)+weightConst},{x:169,y:(0.83*10)+weightConst},{x:170,y:(0.85*10)+weightConst},{x:171,y:(0.87*10)+weightConst},{x:172,y:(0.88*10)+weightConst},{x:173,y:(0.9*10)+weightConst},{x:174,y:(0.92*10)+weightConst},{x:175,y:(0.93*10)+weightConst},{x:176,y:(0.95*10)+weightConst},{x:177,y:(0.97*10)+weightConst},{x:178,y:(0.99*10)+weightConst},{x:179,y:(1.01*10)+weightConst},{x:180,y:(1.03*10)+weightConst},{x:181,y:(1.04*10)+weightConst},{x:182,y:(1.06*10)+weightConst},{x:183,y:(1.08*10)+weightConst},{x:184,y:(1.1*10)+weightConst},{x:185,y:(1.13*10)+weightConst},{x:186,y:(1.15*10)+weightConst},{x:187,y:(1.17*10)+weightConst},{x:188,y:(1.19*10)+weightConst},{x:189,y:(1.21*10)+weightConst},{x:190,y:(1.23*10)+weightConst},{x:191,y:(1.26*10)+weightConst},{x:192,y:(1.28*10)+weightConst},{x:193,y:(1.3*10)+weightConst},{x:194,y:(1.33*10)+weightConst},{x:195,y:(1.35*10)+weightConst},{x:196,y:(1.37*10)+weightConst},{x:197,y:(1.4*10)+weightConst},{x:198,y:(1.42*10)+weightConst},{x:199,y:(1.45*10)+weightConst},{x:200,y:(1.48*10)+weightConst},{x:201,y:(1.5*10)+weightConst},{x:202,y:(1.53*10)+weightConst},{x:203,y:(1.56*10)+weightConst},{x:204,y:(1.58*10)+weightConst},{x:205,y:(1.61*10)+weightConst},{x:206,y:(1.64*10)+weightConst},{x:207,y:(1.67*10)+weightConst},{x:208,y:(1.7*10)+weightConst},{x:209,y:(1.73*10)+weightConst},{x:210,y:(1.76*10)+weightConst},{x:211,y:(1.79*10)+weightConst},{x:212,y:(1.82*10)+weightConst},{x:213,y:(1.85*10)+weightConst},{x:214,y:(1.88*10)+weightConst},{x:215,y:(1.92*10)+weightConst},{x:216,y:(1.95*10)+weightConst},{x:217,y:(1.98*10)+weightConst},{x:218,y:(2.02*10)+weightConst},{x:219,y:(2.05*10)+weightConst},{x:220,y:(2.09*10)+weightConst},{x:221,y:(2.12*10)+weightConst},{x:222,y:(2.16*10)+weightConst},{x:223,y:(2.19*10)+weightConst},{x:224,y:(2.23*10)+weightConst},{x:225,y:(2.27*10)+weightConst},{x:226,y:(2.31*10)+weightConst},{x:227,y:(2.35*10)+weightConst},{x:228,y:(2.38*10)+weightConst},{x:229,y:(2.42*10)+weightConst},{x:230,y:(2.46*10)+weightConst}];

            var set15 = [{x:168,y:(0.92*10)+weightConst},{x:169,y:(0.93*10)+weightConst},{x:170,y:(0.95*10)+weightConst},{x:171,y:(0.97*10)+weightConst},{x:172,y:(0.99*10)+weightConst},{x:173,y:(1.01*10)+weightConst},{x:174,y:(1.03*10)+weightConst},{x:175,y:(1.05*10)+weightConst},{x:176,y:(1.07*10)+weightConst},{x:177,y:(1.09*10)+weightConst},{x:178,y:(1.11*10)+weightConst},{x:179,y:(1.13*10)+weightConst},{x:180,y:(1.15*10)+weightConst},{x:181,y:(1.17*10)+weightConst},{x:182,y:(1.2*10)+weightConst},{x:183,y:(1.22*10)+weightConst},{x:184,y:(1.24*10)+weightConst},{x:185,y:(1.26*10)+weightConst},{x:186,y:(1.29*10)+weightConst},{x:187,y:(1.31*10)+weightConst},{x:188,y:(1.33*10)+weightConst},{x:189,y:(1.36*10)+weightConst},{x:190,y:(1.38*10)+weightConst},{x:191,y:(1.41*10)+weightConst},{x:192,y:(1.44*10)+weightConst},{x:193,y:(1.46*10)+weightConst},{x:194,y:(1.49*10)+weightConst},{x:195,y:(1.52*10)+weightConst},{x:196,y:(1.54*10)+weightConst},{x:197,y:(1.57*10)+weightConst},{x:198,y:(1.6*10)+weightConst},{x:199,y:(1.63*10)+weightConst},{x:200,y:(1.66*10)+weightConst},{x:201,y:(1.69*10)+weightConst},{x:202,y:(1.72*10)+weightConst},{x:203,y:(1.75*10)+weightConst},{x:204,y:(1.78*10)+weightConst},{x:205,y:(1.81*10)+weightConst},{x:206,y:(1.84*10)+weightConst},{x:207,y:(1.87*10)+weightConst},{x:208,y:(1.91*10)+weightConst},{x:209,y:(1.94*10)+weightConst},{x:210,y:(1.97*10)+weightConst},{x:211,y:(2.01*10)+weightConst},{x:212,y:(2.04*10)+weightConst},{x:213,y:(2.08*10)+weightConst},{x:214,y:(2.11*10)+weightConst},{x:215,y:(2.15*10)+weightConst},{x:216,y:(2.19*10)+weightConst},{x:217,y:(2.23*10)+weightConst},{x:218,y:(2.26*10)+weightConst},{x:219,y:(2.3*10)+weightConst},{x:220,y:(2.34*10)+weightConst},{x:221,y:(2.38*10)+weightConst},{x:222,y:(2.42*10)+weightConst},{x:223,y:(2.46*10)+weightConst},{x:224,y:(2.5*10)+weightConst},{x:225,y:(2.55*10)+weightConst},{x:226,y:(2.59*10)+weightConst},{x:227,y:(2.63*10)+weightConst},{x:228,y:(2.68*10)+weightConst},{x:229,y:(2.72*10)+weightConst},{x:230,y:(2.77*10)+weightConst}];
            // End of Weight data
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([hcData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var gEnter = wrap2.enter().append('g').attr('class', 'd3line').append('g');
            var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap3.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,73]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,73]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
				return '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0, 73,2)).tickFormat(function(d){
                return d%4==0 ? yAxisLeftFake(d):'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0, 73,1)).tickFormat(function(d){
                return '';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(10);
            
            var yAxisLeftFake = function(d){
                switch (d){
                case 0:return 18;
                case 2:return 19;
                case 4:return 20;
                case 6:return 21;
                case 8:return 22;
                case 10:return 23;
                case 12:return 24;
                case 14:return 25;
                case 16:return 26;
                case 18:return 27;
                case 20:return '';
                case 22:return 24;
                case 24:return 26;
                case 26:return 28;
                case 28:return 30;
                case 30:return 32;
                case 32:return 34;
                case 34:return 36;
                case 36:return 38;
                case 38:return 40;
                case 40:return 42;
                case 42:return '';
                case 44:return 0.2;
                case 46:return 0.4;
                case 48:return 0.6;
                case 50:return 0.8;
                case 52:return '1.0';
                case 54:return 1.2;
                case 56:return 1.4;
                case 58:return 1.6;
                case 60:return 1.8;
                case 62:return '2.0';
                case 64:return 2.2;
                case 66:return 2.4;
                case 68:return 2.6;
                case 70:return 2.8;
                case 72:return '3.0';
                }
            };

            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var lengthpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<73 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<73 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html((d.x) + "<br/>"  + (d.y).toString() +" kg")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            // svg.append("g")
            //     .attr("class", "x axis")
            //     .attr("transform", "translate(0,0)")
            //     .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -7 )
                .style("text-anchor", "middle")
                .text("Combined");

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Gestational age at birth (weeks)");
            
            svg.append("text")
                .attr("x", -10 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("24");
                   
            svg.append("text")
                .attr("x", 158 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("33");
            
            // svg.append("text")
            //     .attr("x", -50 )
            //     .attr("y", height+15 )
            //     .style("text-anchor", "start")
            //     .text("Months");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set6),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set8),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set9),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set10),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set11),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set12),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set13),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set14),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });

            svg.append("svg:path")
                .attr({
                    d: lineFunc(set15),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                });
            
            // user data
            svg.append("svg:path")
                .attr({
                d: datalineFunc(hcData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(heightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

            svg.append("svg:path")
                .attr({
                d: datalineFunc(weightData),
                "stroke": "green",
                "stroke-width": 2,
                "fill": "none",
                "class": "path"
                });

        }
    }
});

'use strict';
angular.module('AngularApp').directive('iapBmiChartMaleSmall', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;

            var bmiData = [];

            if(vitalData.bmi){
                for(var i = 0; i < vitalData.bmi.length; i++){
                    if(vitalData.bmi[i].x>59 && vitalData.bmi[i].x<217) {
                        bmiData.push(vitalData.bmi[i]);
                    }
                }
            }

            var set1 = [{x:60,y:12.1},{x:66,y:12.15},{x:72,y:12.2},{x:78,y:12.25},{x:84,y:12.3},{x:90,y:12.4},{x:96,y:12.5},{x:102,y:12.6},
                        {x:108,y:12.7},{x:114,y:12.8},{x:120,y:12.9},{x:126,y:13},{x:132,y:13.1},{x:138,y:13.2},
                        {x:144,y:13.3},{x:150,y:13.4},{x:156,y:13.55},{x:162,y:13.7},{x:168,y:13.8},{x:174,y:14},
                        {x:180,y:14.2},{x:186,y:14.4},{x:192,y:14.6},{x:198,y:14.9},{x:204,y:15.1},{x:210,y:15.4},{x:216,y:15.6}];

            var set2 = [{x:60,y:12.4},{x:66,y:12.4},{x:72,y:12.5},{x:78,y:12.5},{x:84,y:12.6},{x:90,y:12.7},{x:96,y:12.8},{x:102,y:12.9},
                        {x:108,y:13},{x:114,y:13.1},{x:120,y:13.2},{x:126,y:13.3},{x:132,y:13.5},{x:138,y:13.6},
                        {x:144,y:13.8},{x:150,y:13.9},{x:156,y:14},{x:162,y:14.2},{x:168,y:14.3},{x:174,y:14.5},
                        {x:180,y:14.7},{x:186,y:14.9},{x:192,y:15.1},{x:198,y:15.4},{x:204,y:15.6},{x:210,y:15.9},{x:216,y:16.2}];
                    
            var set3 = [{x:60,y:12.8},{x:66,y:12.9},{x:72,y:12.9},{x:78,y:13},{x:84,y:13.1},{x:90,y:13.2},{x:96,y:13.3},{x:102,y:13.4},
                        {x:108,y:13.5},{x:114,y:13.7},{x:120,y:13.8},{x:126,y:14},{x:132,y:14.1},{x:138,y:14.3},
                        {x:144,y:14.5},{x:150,y:14.6},{x:156,y:14.8},{x:162,y:14.9},{x:168,y:15.1},{x:174,y:15.3},
                        {x:180,y:15.5},{x:186,y:15.8},{x:192,y:16},{x:198,y:16.3},{x:204,y:16.6},{x:210,y:16.8},{x:216,y:17.1}];

            var set4 = [{x:60,y:13.6},{x:66,y:13.7},{x:72,y:13.7},{x:78,y:13.8},{x:84,y:13.9},{x:90,y:14.1},{x:96,y:14.2},{x:102,y:14.4},
                        {x:108,y:14.5},{x:114,y:14.7},{x:120,y:14.9},{x:126,y:15.1},{x:132,y:15.4},{x:138,y:15.6},
                        {x:144,y:15.8},{x:150,y:16},{x:156,y:16.3},{x:162,y:16.5},{x:168,y:16.7},{x:174,y:16.9},
                        {x:180,y:17.2},{x:186,y:17.4},{x:192,y:17.7},{x:198,y:18},{x:204,y:18.3},{x:210,y:18.6},{x:216,y:18.9}];

            var set5 = [{x:60,y:14.7},{x:66,y:14.8},{x:72,y:14.9},{x:78,y:15},{x:84,y:15.1},{x:90,y:15.3},{x:96,y:15.5},{x:102,y:15.7},
                        {x:108,y:15.9},{x:114,y:16.2},{x:120,y:16.4},{x:126,y:16.7},{x:132,y:17},{x:138,y:17.3},
                        {x:144,y:17.7},{x:150,y:17.9},{x:156,y:18.2},{x:162,y:18.5},{x:168,y:18.7},{x:174,y:19},
                        {x:180,y:19.3},{x:186,y:19.6},{x:192,y:19.9},{x:198,y:20.2},{x:204,y:20.5},{x:210,y:20.8},{x:216,y:21.1}];

            var set6 = [{x:60,y:15.7},{x:66,y:15.8},{x:72,y:16},{x:78,y:16.1},{x:84,y:16.3},{x:90,y:16.5},{x:96,y:16.7},{x:102,y:17},
                        {x:108,y:17.3},{x:114,y:17.6},{x:120,y:18},{x:126,y:18.3},{x:132,y:18.7},{x:138,y:19.1},
                        {x:144,y:19.5},{x:150,y:19.9},{x:156,y:20.2},{x:162,y:20.5},{x:168,y:20.8},{x:174,y:21.1},
                        {x:180,y:21.4},{x:186,y:21.7},{x:192,y:22},{x:198,y:22.3},{x:204,y:22.6},{x:210,y:22.9},{x:216,y:23.2}];

            var set7 = [{x:60,y:17.5},{x:66,y:17.6},{x:72,y:17.8},{x:78,y:18},{x:84,y:18.2},{x:90,y:18.5},{x:96,y:18.8},{x:102,y:19.2},
                        {x:108,y:19.6},{x:114,y:20.1},{x:120,y:20.5},{x:126,y:21},{x:132,y:21.5},{x:138,y:22.1},
                        {x:144,y:22.6},{x:150,y:23},{x:156,y:23.4},{x:162,y:23.8},{x:168,y:24.2},{x:174,y:24.5},
                        {x:180,y:24.9},{x:186,y:25.2},{x:192,y:25.5},{x:198,y:25.8},{x:204,y:26},{x:210,y:26.3},{x:216,y:26.6}];
            

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([bmiData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            gEnter.append('g').attr('class', 'lines');
            gEnter.append('g').attr('class', 'point-clips');
            gEnter.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([10,35]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([10,35]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
                return d/12 % 1 ? '' : d/12;
            }).innerTickSize(-height).outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
                return '';
            }).innerTickSize(-height).outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(26).tickValues(d3.range(10, 35, 2)).tickFormat(function(d) {
                return d%2==0 ? d : '';
              }).innerTickSize(-width).outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(26).tickValues(d3.range(10, 35, 2)).tickFormat(function(d) {
                return '';
              }).innerTickSize(-width).outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString())	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -7 )
                .style("text-anchor", "middle")
                .text("IAP Boys BMI Chart 5 - 18 years");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 745 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 725 )
                .style("text-anchor", "start")
                .text("5");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 690 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 630 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 540 )
                .style("text-anchor", "start")
                .text("50");
            
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "gray",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "orange",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(bmiData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    }
});
'use strict';
angular.module('AngularApp').directive('iapBmiChartFemaleSmall', function($window) {
    return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;

            var bmiData = [];

            if(vitalData.bmi){
                for(var i = 0; i < vitalData.bmi.length; i++){
                    if(vitalData.bmi[i].x>59 && vitalData.bmi[i].x<217) {
                        bmiData.push(vitalData.bmi[i]);
                    }
                }
            }

            var set1 = [{x:60,y:11.9},{x:66,y:11.9},{x:72,y:12},{x:78,y:12.1},{x:84,y:12.1},{x:90,y:12.2},{x:96,y:12.3},{x:102,y:12.3},
                        {x:108,y:12.4},{x:114,y:12.5},{x:120,y:12.7},{x:126,y:12.8},{x:132,y:13},{x:138,y:13.2},
                        {x:144,y:13.4},{x:150,y:13.7},{x:156,y:13.9},{x:162,y:14.1},{x:168,y:14.3},{x:174,y:14.5},
                        {x:180,y:14.7},{x:186,y:14.9},{x:192,y:15},{x:198,y:15.2},{x:204,y:15.4},{x:210,y:15.5},{x:216,y:15.7}];

            var set2 = [{x:60,y:12.1},{x:66,y:12.2},{x:72,y:12.2},{x:78,y:12.3},{x:84,y:12.4},{x:90,y:12.5},{x:96,y:12.6},{x:102,y:12.7},
                        {x:108,y:12.8},{x:114,y:12.9},{x:120,y:13.1},{x:126,y:13.2},{x:132,y:13.4},{x:138,y:13.7},
                        {x:144,y:13.9},{x:150,y:14.2},{x:156,y:14.4},{x:162,y:14.6},{x:168,y:14.9},{x:174,y:15.1},
                        {x:180,y:15.2},{x:186,y:15.4},{x:192,y:15.6},{x:198,y:15.8},{x:204,y:16},{x:210,y:16.1},{x:216,y:16.3}];
                    
            var set3 = [{x:60,y:12.5},{x:66,y:12.6},{x:72,y:12.7},{x:78,y:12.8},{x:84,y:12.8},{x:90,y:12.9},{x:96,y:13.1},{x:102,y:13.2},
                        {x:108,y:13.3},{x:114,y:13.5},{x:120,y:13.7},{x:126,y:13.9},{x:132,y:14.1},{x:138,y:14.4},
                        {x:144,y:14.7},{x:150,y:15},{x:156,y:15.2},{x:162,y:15.5},{x:168,y:15.7},{x:174,y:16},
                        {x:180,y:16.1},{x:186,y:16.3},{x:192,y:16.5},{x:198,y:16.7},{x:204,y:16.9},{x:210,y:17.1},{x:216,y:17.3}];

            var set4 = [{x:60,y:13.3},{x:66,y:13.4},{x:72,y:13.5},{x:78,y:13.6},{x:84,y:13.7},{x:90,y:13.9},{x:96,y:14},{x:102,y:14.2},
                        {x:108,y:14.4},{x:114,y:14.6},{x:120,y:14.9},{x:126,y:15.2},{x:132,y:15.5},{x:138,y:15.8},
                        {x:144,y:16.1},{x:150,y:16.5},{x:156,y:16.8},{x:162,y:17.1},{x:168,y:17.3},{x:174,y:17.6},
                        {x:180,y:17.8},{x:186,y:18},{x:192,y:18.2},{x:198,y:18.4},{x:204,y:18.6},{x:210,y:18.7},{x:216,y:18.9}];

            var set5 = [{x:60,y:14.3},{x:66,y:14.4},{x:72,y:14.5},{x:78,y:14.7},{x:84,y:14.9},{x:90,y:15.1},{x:96,y:15.3},{x:102,y:15.6},
                        {x:108,y:15.8},{x:114,y:16.1},{x:120,y:16.5},{x:126,y:16.8},{x:132,y:17.2},{x:138,y:17.6},
                        {x:144,y:18},{x:150,y:18.4},{x:156,y:18.8},{x:162,y:19.1},{x:168,y:19.4},{x:174,y:19.7},
                        {x:180,y:19.9},{x:186,y:20.1},{x:192,y:20.3},{x:198,y:20.4},{x:204,y:20.6},{x:210,y:20.8},{x:216,y:21}];

            var set6 = [{x:60,y:15.5},{x:66,y:15.7},{x:72,y:15.9},{x:78,y:16.1},{x:84,y:16.4},{x:90,y:16.6},{x:96,y:16.9},{x:102,y:17.2},
                        {x:108,y:17.6},{x:114,y:18},{x:120,y:18.4},{x:126,y:18.8},{x:132,y:19.3},{x:138,y:19.8},
                        {x:144,y:20.2},{x:150,y:20.7},{x:156,y:21.1},{x:162,y:21.5},{x:168,y:21.8},{x:174,y:22},
                        {x:180,y:22.3},{x:186,y:22.4},{x:192,y:22.6},{x:198,y:22.8},{x:204,y:22.9},{x:210,y:23.1},{x:216,y:23.2}];

            var set7 = [{x:60,y:18},{x:66,y:18.3},{x:72,y:18.6},{x:78,y:18.9},{x:84,y:19.3},{x:90,y:19.7},{x:96,y:20.1},{x:102,y:20.5},
                        {x:108,y:21},{x:114,y:21.4},{x:120,y:21.9},{x:126,y:22.5},{x:132,y:23},{x:138,y:23.6},
                        {x:144,y:24.1},{x:150,y:24.7},{x:156,y:25.2},{x:162,y:25.6},{x:168,y:25.9},{x:174,y:26.2},
                        {x:180,y:26.3},{x:186,y:26.4},{x:192,y:26.5},{x:198,y:26.6},{x:204,y:26.7},{x:210,y:26.7},{x:216,y:26.8}];
            

            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([bmiData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            gEnter.append('g').attr('class', 'lines');
            gEnter.append('g').attr('class', 'point-clips');
            gEnter.append('g').attr('class', 'point-paths');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);
            
            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([216,60]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([216,60]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([10,35]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([10,35]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
                return d/12 % 1 ? '' : d/12;
            }).innerTickSize(-height).outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(60, 217, 6)).tickFormat(function(d) {
                return '';
            }).innerTickSize(-height).outerTickSize(0);
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(26).tickValues(d3.range(10, 35, 2)).tickFormat(function(d) {
                return d%2==0 ? d : '';
              }).innerTickSize(-width).outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(26).tickValues(d3.range(10, 35, 2)).tickFormat(function(d) {
                return '';
              }).innerTickSize(-width).outerTickSize(0);
            
            var age = function(data) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years ";
            };
            
            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return xScale0(d.x); })
                .attr('cy', function (d) { return yScale0(d.y); })
                .attr('r', 5)
                .attr('fill','green')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString())	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0,0)")
                .call(xAxisTop);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+30 )
                .style("text-anchor", "middle")
                .text("Age in Years");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -7 )
                .style("text-anchor", "middle")
                .text("IAP Girls BMI Chart 5 - 18 years");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 735 )
                .style("text-anchor", "start")
                .text("3");
            
            svg.append("text")
                .attr("x", 690 )
                .attr("y", 710 )
                .style("text-anchor", "start")
                .text("5");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 680 )
                .style("text-anchor", "start")
                .text("10");

            svg.append("text")
                .attr("x", 680 )
                .attr("y", 615 )
                .style("text-anchor", "start")
                .text("25");
            
            svg.append("text")
                .attr("x", 680 )
                .attr("y", 540 )
                .style("text-anchor", "start")
                .text("50");
               
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);	

            svg.append("g")				
                .attr("class", "y axis")	
                .attr("transform", "translate(" + width + " ,0)")		
                .call(yAxisRight);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "orange",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(bmiData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    }
});
'use strict';
angular.module('AngularApp').directive('postnatalWeightFemaleSmall', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;

            var weightData = [];

            if(vitalData.postnatalWeight) {
                for(var i = 0; i < vitalData.postnatalWeight.length; i++){
                    if(vitalData.postnatalWeight[i].y<10.5 && vitalData.postnatalWeight[i].y>0) {
                        weightData.push(vitalData.postnatalWeight[i]);
                    }
                }
            }

            var set1 = [{x:27,y:0.41},{x:28,y:0.52},{x:29,y:0.64},{x:30,y:0.77},{x:31,y:0.91},{x:32,y:1.06},{x:33,y:1.22},{x:34,y:1.38},{x:35,y:1.55},{x:36,y:1.72},{x:37,y:1.89},{x:38,y:2.06},{x:39,y:2.23},{x:40,y:2.41},{x:41,y:2.58},{x:42,y:2.75},{x:43,y:2.91},{x:44,y:3.08},{x:45,y:3.24},{x:46,y:3.4},{x:47,y:3.55},{x:48,y:3.7},{x:49,y:3.85},{x:50,y:3.99},{x:51,y:4.13},{x:52,y:4.26},{x:53,y:4.4},{x:54,y:4.52},{x:55,y:4.64},{x:56,y:4.76},{x:57,y:4.88},{x:58,y:4.99},{x:59,y:5.1},{x:60,y:5.2},{x:61,y:5.3},{x:62,y:5.4},{x:63,y:5.49},{x:64,y:5.58}];

            var set2 = [{x:27,y:0.47},{x:28,y:0.59},{x:29,y:0.72},{x:30,y:0.86},{x:31,y:1.01},{x:32,y:1.18},{x:33,y:1.34},{x:34,y:1.52},{x:35,y:1.7},{x:36,y:1.88},{x:37,y:2.06},{x:38,y:2.25},{x:39,y:2.43},{x:40,y:2.62},{x:41,y:2.8},{x:42,y:2.98},{x:43,y:3.16},{x:44,y:3.34},{x:45,y:3.51},{x:46,y:3.68},{x:47,y:3.84},{x:48,y:4.01},{x:49,y:4.16},{x:50,y:4.32},{x:51,y:4.46},{x:52,y:4.61},{x:53,y:4.75},{x:54,y:4.89},{x:55,y:5.02},{x:56,y:5.15},{x:57,y:5.27},{x:58,y:5.39},{x:59,y:5.51},{x:60,y:5.62},{x:61,y:5.73},{x:62,y:5.83},{x:63,y:5.93},{x:64,y:6.03}];

            var set3 = [{x:27,y:0.61},{x:28,y:0.76},{x:29,y:0.91},{x:30,y:1.09},{x:31,y:1.27},{x:32,y:1.46},{x:33,y:1.65},{x:34,y:1.86},{x:35,y:2.07},{x:36,y:2.28},{x:37,y:2.49},{x:38,y:2.71},{x:39,y:2.92},{x:40,y:3.13},{x:41,y:3.35},{x:42,y:3.55},{x:43,y:3.76},{x:44,y:3.96},{x:45,y:4.16},{x:46,y:4.36},{x:47,y:4.55},{x:48,y:4.74},{x:49,y:4.92},{x:50,y:5.1},{x:51,y:5.27},{x:52,y:5.44},{x:53,y:5.6},{x:54,y:5.76},{x:55,y:5.92},{x:56,y:6.07},{x:57,y:6.21},{x:58,y:6.35},{x:59,y:6.49},{x:60,y:6.62},{x:61,y:6.75},{x:62,y:6.87},{x:63,y:6.99},{x:64,y:7.11}];

            var set4 = [{x:27,y:0.8},{x:28,y:0.97},{x:29,y:1.16},{x:30,y:1.37},{x:31,y:1.58},{x:32,y:1.8},{x:33,y:2.03},{x:34,y:2.27},{x:35,y:2.51},{x:36,y:2.76},{x:37,y:3.01},{x:38,y:3.26},{x:39,y:3.5},{x:40,y:3.75},{x:41,y:3.99},{x:42,y:4.24},{x:43,y:4.48},{x:44,y:4.71},{x:45,y:4.94},{x:46,y:5.17},{x:47,y:5.39},{x:48,y:5.61},{x:49,y:5.82},{x:50,y:6.02},{x:51,y:6.22},{x:52,y:6.42},{x:53,y:6.61},{x:54,y:6.8},{x:55,y:6.98},{x:56,y:7.15},{x:57,y:7.32},{x:58,y:7.49},{x:59,y:7.65},{x:60,y:7.8},{x:61,y:7.95},{x:62,y:8.1},{x:63,y:8.24},{x:64,y:8.38}];

            var set5 = [{x:27,y:0.91},{x:28,y:1.1},{x:29,y:1.3},{x:30,y:1.52},{x:31,y:1.75},{x:32,y:1.99},{x:33,y:2.24},{x:34,y:2.5},{x:35,y:2.76},{x:36,y:3.02},{x:37,y:3.29},{x:38,y:3.55},{x:39,y:3.82},{x:40,y:4.08},{x:41,y:4.34},{x:42,y:4.6},{x:43,y:4.85},{x:44,y:5.11},{x:45,y:5.35},{x:46,y:5.6},{x:47,y:5.83},{x:48,y:6.06},{x:49,y:6.29},{x:50,y:6.51},{x:51,y:6.73},{x:52,y:6.94},{x:53,y:7.14},{x:54,y:7.34},{x:55,y:7.54},{x:56,y:7.73},{x:57,y:7.91},{x:58,y:8.09},{x:59,y:8.26},{x:60,y:8.43},{x:61,y:8.59},{x:62,y:8.75},{x:63,y:8.9},{x:64,y:9.05}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([64,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([64,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 3)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 3)).tickFormat(function(d){
                return d%2==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0.0,10.5, 2)).tickFormat(function(d){
                return d;
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0.0, 10.5, 2)).tickFormat(function(d){
                return d;
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("text")
                .attr("x", 10 )
                .attr("y", -7 )
                .style("text-anchor", "start")
                .text("Postnatal Growth - Weight");

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Postmenstrual age (Weeks)");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('postnatalWeightMaleSmall', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;

            var weightData = [];

            if(vitalData.postnatalWeight) {
                for(var i = 0; i < vitalData.postnatalWeight.length; i++){
                    if(vitalData.postnatalWeight[i].y<10.5 && vitalData.postnatalWeight[i].y>0) {
                        weightData.push(vitalData.postnatalWeight[i]);
                    }
                }
            }

            var set1 = [{x:27,y:0.45},{x:28,y:0.57},{x:29,y:0.7},{x:30,y:0.85},{x:31,y:1},{x:32,y:1.17},{x:33,y:1.34},{x:34,y:1.51},{x:35,y:1.7},{x:36,y:1.88},{x:37,y:2.07},{x:38,y:2.26},{x:39,y:2.45},{x:40,y:2.64},{x:41,y:2.82},{x:42,y:3.01},{x:43,y:3.19},{x:44,y:3.37},{x:45,y:3.55},{x:46,y:3.72},{x:47,y:3.89},{x:48,y:4.06},{x:49,y:4.22},{x:50,y:4.37},{x:51,y:4.52},{x:52,y:4.67},{x:53,y:4.81},{x:54,y:4.95},{x:55,y:5.09},{x:56,y:5.22},{x:57,y:5.34},{x:58,y:5.47},{x:59,y:5.58},{x:60,y:5.7},{x:61,y:5.81},{x:62,y:5.92},{x:63,y:6.02},{x:64,y:6.12}];

            var set2 = [{x:27,y:0.51},{x:28,y:0.64},{x:29,y:0.79},{x:30,y:0.94},{x:31,y:1.11},{x:32,y:1.29},{x:33,y:1.47},{x:34,y:1.66},{x:35,y:1.86},{x:36,y:2.06},{x:37,y:2.26},{x:38,y:2.46},{x:39,y:2.67},{x:40,y:2.87},{x:41,y:3.07},{x:42,y:3.27},{x:43,y:3.46},{x:44,y:3.66},{x:45,y:3.84},{x:46,y:4.03},{x:47,y:4.21},{x:48,y:4.39},{x:49,y:4.56},{x:50,y:4.73},{x:51,y:4.89},{x:52,y:5.05},{x:53,y:5.2},{x:54,y:5.35},{x:55,y:5.5},{x:56,y:5.64},{x:57,y:5.77},{x:58,y:5.9},{x:59,y:6.03},{x:60,y:6.15},{x:61,y:6.27},{x:62,y:6.39},{x:63,y:6.5},{x:64,y:6.61}];

            var set3 = [{x:27,y:0.67},{x:28,y:0.83},{x:29,y:1},{x:30,y:1.19},{x:31,y:1.39},{x:32,y:1.6},{x:33,y:1.81},{x:34,y:2.04},{x:35,y:2.26},{x:36,y:2.5},{x:37,y:2.73},{x:38,y:2.96},{x:39,y:3.2},{x:40,y:3.43},{x:41,y:3.66},{x:42,y:3.89},{x:43,y:4.12},{x:44,y:4.34},{x:45,y:4.56},{x:46,y:4.78},{x:47,y:4.99},{x:48,y:5.19},{x:49,y:5.39},{x:50,y:5.59},{x:51,y:5.77},{x:52,y:5.96},{x:53,y:6.14},{x:54,y:6.31},{x:55,y:6.48},{x:56,y:6.65},{x:57,y:6.8},{x:58,y:6.96},{x:59,y:7.11},{x:60,y:7.25},{x:61,y:7.39},{x:62,y:7.53},{x:63,y:7.66},{x:64,y:7.79}];

            var set4 = [{x:27,y:0.88},{x:28,y:1.07},{x:29,y:1.27},{x:30,y:1.5},{x:31,y:1.73},{x:32,y:1.98},{x:33,y:2.23},{x:34,y:2.49},{x:35,y:2.75},{x:36,y:3.02},{x:37,y:3.29},{x:38,y:3.57},{x:39,y:3.84},{x:40,y:4.11},{x:41,y:4.38},{x:42,y:4.64},{x:43,y:4.9},{x:44,y:5.16},{x:45,y:5.41},{x:46,y:5.66},{x:47,y:5.9},{x:48,y:6.14},{x:49,y:6.37},{x:50,y:6.6},{x:51,y:6.82},{x:52,y:7.03},{x:53,y:7.24},{x:54,y:7.45},{x:55,y:7.64},{x:56,y:7.83},{x:57,y:8.02},{x:58,y:8.2},{x:59,y:8.38},{x:60,y:8.55},{x:61,y:8.71},{x:62,y:8.87},{x:63,y:9.03},{x:64,y:9.18}];

            var set5 = [{x:27,y:0.99},{x:28,y:1.2},{x:29,y:1.43},{x:30,y:1.67},{x:31,y:1.92},{x:32,y:2.18},{x:33,y:2.46},{x:34,y:2.74},{x:35,y:3.02},{x:36,y:3.31},{x:37,y:3.6},{x:38,y:3.89},{x:39,y:4.18},{x:40,y:4.47},{x:41,y:4.76},{x:42,y:5.04},{x:43,y:5.32},{x:44,y:5.59},{x:45,y:5.86},{x:46,y:6.13},{x:47,y:6.39},{x:48,y:6.64},{x:49,y:6.89},{x:50,y:7.13},{x:51,y:7.37},{x:52,y:7.6},{x:53,y:7.83},{x:54,y:8.04},{x:55,y:8.26},{x:56,y:8.46},{x:57,y:8.66},{x:58,y:8.86},{x:59,y:9.05},{x:60,y:9.23},{x:61,y:9.41},{x:62,y:9.58},{x:63,y:9.75},{x:64,y:9.91}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([64,27]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([64,27]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,10.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(27, 65, 3)).tickFormat(function(d){
				return d%2==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(27, 65, 3)).tickFormat(function(d){
                return d%2==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0.0,10.5, 2)).tickFormat(function(d){
                return d;
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0.0, 10.5, 2)).tickFormat(function(d){
                return d;
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("text")
                .attr("x", 10 )
                .attr("y", -7 )
                .style("text-anchor", "start")
                .text("Postnatal Growth - Weight");

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Postmenstrual age (Weeks)");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('weightForHeightLengthFemaleSmall', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:5%;padding-top:6%;' viewBox='0 0 410 240'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 220 - margin.top - margin.bottom;
              var width = 400 - margin.left - margin.right;
  
              var heightweightData = [];

            if(vitalData.hwData) {
                for(var i = 0; i < vitalData.hwData.length; i++){
                    if(vitalData.hwData[i].x<111 && vitalData.hwData[i].x>44) {
                        if(vitalData.hwData[i].y<28 && vitalData.hwData[i].y>0) {
                            heightweightData.push(vitalData.hwData[i]);
                        }
                    }
                }
            }
  
              var set1 = [{x:45,y:2},{x:45.5,y:2.1},{x:46,y:2.1},{x:46.5,y:2.2},{x:47,y:2.3},{x:47.5,y:2.4},{x:48,y:2.4},{x:48.5,y:2.5},{x:49,y:2.6},{x:49.5,y:2.7},{x:50,y:2.7},{x:50.5,y:2.8},{x:51,y:2.9},{x:51.5,y:3},{x:52,y:3.1},{x:52.5,y:3.2},{x:53,y:3.3},{x:53.5,y:3.4},{x:54,y:3.5},{x:54.5,y:3.6},{x:55,y:3.7},{x:55.5,y:3.8},{x:56,y:3.9},{x:56.5,y:4},{x:57,y:4.1},{x:57.5,y:4.3},{x:58,y:4.4},{x:58.5,y:4.5},{x:59,y:4.6},{x:59.5,y:4.7},{x:60,y:4.8},{x:60.5,y:4.9},{x:61,y:5},{x:61.5,y:5.1},{x:62,y:5.2},{x:62.5,y:5.3},{x:63,y:5.4},{x:63.5,y:5.5},{x:64,y:5.6},{x:64.5,y:5.7},{x:65,y:5.9},{x:65.5,y:6},{x:66,y:6.1},{x:66.5,y:6.2},{x:67,y:6.3},{x:67.5,y:6.4},{x:68,y:6.4},{x:68.5,y:6.5},{x:69,y:6.6},{x:69.5,y:6.7},{x:70,y:6.8},{x:70.5,y:6.9},{x:71,y:6.9},{x:71.5,y:7},{x:72,y:7.1},{x:72.5,y:7.2},{x:73,y:7.3},{x:73.5,y:7.4},{x:74,y:7.4},{x:74.5,y:7.5},{x:75,y:7.6},{x:75.5,y:7.7},{x:76,y:7.7},{x:76.5,y:7.8},{x:77,y:7.9},{x:77.5,y:8},{x:78,y:8},{x:78.5,y:8.1},{x:79,y:8.2},{x:79.5,y:8.3},{x:80,y:8.4},{x:80.5,y:8.5},{x:81,y:8.6},{x:81.5,y:8.6},{x:82,y:8.7},{x:82.5,y:8.8},{x:83,y:8.9},{x:83.5,y:9},{x:84,y:9.1},{x:84.5,y:9.2},{x:85,y:9.3},{x:85.5,y:9.4},{x:86,y:9.5},{x:86.5,y:9.6},{x:87,y:9.7},{x:87.5,y:9.9},{x:88,y:10},{x:88.5,y:10.1},{x:89,y:10.2},{x:89.5,y:10.3},{x:90,y:10.4},{x:90.5,y:10.5},{x:91,y:10.6},{x:91.5,y:10.7},{x:92,y:10.8},{x:92.5,y:10.9},{x:93,y:11},{x:93.5,y:11.1},{x:94,y:11.2},{x:94.5,y:11.3},{x:95,y:11.4},{x:95.5,y:11.5},{x:96,y:11.6},{x:96.5,y:11.7},{x:97,y:11.8},{x:97.5,y:11.9},{x:98,y:12},{x:98.5,y:12.1},{x:99,y:12.2},{x:99.5,y:12.3},{x:100,y:12.4},{x:100.5,y:12.5},{x:101,y:12.7},{x:101.5,y:12.8},{x:102,y:12.9},{x:102.5,y:13},{x:103,y:13.1},{x:103.5,y:13.3},{x:104,y:13.4},{x:104.5,y:13.5},{x:105,y:13.6},{x:105.5,y:13.8},{x:106,y:13.9},{x:106.5,y:14.1},{x:107,y:14.2},{x:107.5,y:14.3},{x:108,y:14.5},{x:108.5,y:14.6},{x:109,y:14.8},{x:109.5,y:14.9},{x:110,y:15.1}];
  
              var set2 = [{x:45,y:2.1},{x:45.5,y:2.2},{x:46,y:2.2},{x:46.5,y:2.3},{x:47,y:2.4},{x:47.5,y:2.4},{x:48,y:2.5},{x:48.5,y:2.6},{x:49,y:2.7},{x:49.5,y:2.8},{x:50,y:2.8},{x:50.5,y:2.9},{x:51,y:3},{x:51.5,y:3.1},{x:52,y:3.2},{x:52.5,y:3.3},{x:53,y:3.4},{x:53.5,y:3.5},{x:54,y:3.6},{x:54.5,y:3.7},{x:55,y:3.9},{x:55.5,y:4},{x:56,y:4.1},{x:56.5,y:4.2},{x:57,y:4.3},{x:57.5,y:4.4},{x:58,y:4.5},{x:58.5,y:4.6},{x:59,y:4.8},{x:59.5,y:4.9},{x:60,y:5},{x:60.5,y:5.1},{x:61,y:5.2},{x:61.5,y:5.3},{x:62,y:5.4},{x:62.5,y:5.5},{x:63,y:5.6},{x:63.5,y:5.7},{x:64,y:5.8},{x:64.5,y:5.9},{x:65,y:6.1},{x:65.5,y:6.2},{x:66,y:6.3},{x:66.5,y:6.4},{x:67,y:6.5},{x:67.5,y:6.6},{x:68,y:6.7},{x:68.5,y:6.8},{x:69,y:6.9},{x:69.5,y:7},{x:70,y:7},{x:70.5,y:7.1},{x:71,y:7.2},{x:71.5,y:7.3},{x:72,y:7.4},{x:72.5,y:7.5},{x:73,y:7.6},{x:73.5,y:7.6},{x:74,y:7.7},{x:74.5,y:7.8},{x:75,y:7.9},{x:75.5,y:8},{x:76,y:8},{x:76.5,y:8.1},{x:77,y:8.2},{x:77.5,y:8.3},{x:78,y:8.4},{x:78.5,y:8.4},{x:79,y:8.5},{x:79.5,y:8.6},{x:80,y:8.7},{x:80.5,y:8.8},{x:81,y:8.9},{x:81.5,y:9},{x:82,y:9.1},{x:82.5,y:9.2},{x:83,y:9.3},{x:83.5,y:9.4},{x:84,y:9.5},{x:84.5,y:9.6},{x:85,y:9.7},{x:85.5,y:9.8},{x:86,y:9.9},{x:86.5,y:10},{x:87,y:10.1},{x:87.5,y:10.2},{x:88,y:10.3},{x:88.5,y:10.4},{x:89,y:10.5},{x:89.5,y:10.6},{x:90,y:10.8},{x:90.5,y:10.9},{x:91,y:11},{x:91.5,y:11.1},{x:92,y:11.2},{x:92.5,y:11.3},{x:93,y:11.4},{x:93.5,y:11.5},{x:94,y:11.6},{x:94.5,y:11.7},{x:95,y:11.8},{x:95.5,y:11.9},{x:96,y:12},{x:96.5,y:12.1},{x:97,y:12.2},{x:97.5,y:12.3},{x:98,y:12.4},{x:98.5,y:12.6},{x:99,y:12.7},{x:99.5,y:12.8},{x:100,y:12.9},{x:100.5,y:13},{x:101,y:13.1},{x:101.5,y:13.3},{x:102,y:13.4},{x:102.5,y:13.5},{x:103,y:13.6},{x:103.5,y:13.8},{x:104,y:13.9},{x:104.5,y:14},{x:105,y:14.2},{x:105.5,y:14.3},{x:106,y:14.5},{x:106.5,y:14.6},{x:107,y:14.7},{x:107.5,y:14.9},{x:108,y:15},{x:108.5,y:15.2},{x:109,y:15.4},{x:109.5,y:15.5},{x:110,y:15.7}];
  
              var set3 = [{x:45,y:2.5},{x:45.5,y:2.5},{x:46,y:2.6},{x:46.5,y:2.7},{x:47,y:2.8},{x:47.5,y:2.9},{x:48,y:3},{x:48.5,y:3.1},{x:49,y:3.2},{x:49.5,y:3.3},{x:50,y:3.4},{x:50.5,y:3.5},{x:51,y:3.6},{x:51.5,y:3.7},{x:52,y:3.8},{x:52.5,y:3.9},{x:53,y:4},{x:53.5,y:4.2},{x:54,y:4.3},{x:54.5,y:4.4},{x:55,y:4.5},{x:55.5,y:4.7},{x:56,y:4.8},{x:56.5,y:5},{x:57,y:5.1},{x:57.5,y:5.2},{x:58,y:5.4},{x:58.5,y:5.5},{x:59,y:5.6},{x:59.5,y:5.7},{x:60,y:5.9},{x:60.5,y:6},{x:61,y:6.1},{x:61.5,y:6.3},{x:62,y:6.4},{x:62.5,y:6.5},{x:63,y:6.6},{x:63.5,y:6.7},{x:64,y:6.9},{x:64.5,y:7},{x:65,y:7.2},{x:65.5,y:7.4},{x:66,y:7.5},{x:66.5,y:7.6},{x:67,y:7.7},{x:67.5,y:7.8},{x:68,y:7.9},{x:68.5,y:8},{x:69,y:8.1},{x:69.5,y:8.2},{x:70,y:8.3},{x:70.5,y:8.4},{x:71,y:8.5},{x:71.5,y:8.6},{x:72,y:8.7},{x:72.5,y:8.8},{x:73,y:8.9},{x:73.5,y:9},{x:74,y:9.1},{x:74.5,y:9.2},{x:75,y:9.3},{x:75.5,y:9.4},{x:76,y:9.5},{x:76.5,y:9.6},{x:77,y:9.6},{x:77.5,y:9.7},{x:78,y:9.8},{x:78.5,y:9.9},{x:79,y:10},{x:79.5,y:10.1},{x:80,y:10.2},{x:80.5,y:10.3},{x:81,y:10.4},{x:81.5,y:10.6},{x:82,y:10.7},{x:82.5,y:10.8},{x:83,y:10.9},{x:83.5,y:11},{x:84,y:11.1},{x:84.5,y:11.3},{x:85,y:11.4},{x:85.5,y:11.5},{x:86,y:11.6},{x:86.5,y:11.8},{x:87,y:11.9},{x:87.5,y:12},{x:88,y:12.1},{x:88.5,y:12.3},{x:89,y:12.4},{x:89.5,y:12.5},{x:90,y:12.6},{x:90.5,y:12.8},{x:91,y:12.9},{x:91.5,y:13},{x:92,y:13.1},{x:92.5,y:13.3},{x:93,y:13.4},{x:93.5,y:13.5},{x:94,y:13.6},{x:94.5,y:13.8},{x:95,y:13.9},{x:95.5,y:14},{x:96,y:14.1},{x:96.5,y:14.3},{x:97,y:14.4},{x:97.5,y:14.5},{x:98,y:14.7},{x:98.5,y:14.8},{x:99,y:14.9},{x:99.5,y:15.1},{x:100,y:15.2},{x:100.5,y:15.4},{x:101,y:15.5},{x:101.5,y:15.7},{x:102,y:15.8},{x:102.5,y:16},{x:103,y:16.1},{x:103.5,y:16.3},{x:104,y:16.4},{x:104.5,y:16.6},{x:105,y:16.8},{x:105.5,y:16.9},{x:106,y:17.1},{x:106.5,y:17.3},{x:107,y:17.5},{x:107.5,y:17.7},{x:108,y:17.8},{x:108.5,y:18},{x:109,y:18.2},{x:109.5,y:18.4},{x:110,y:18.6}];
  
              var set4 = [{x:45,y:3.1},{x:45.5,y:3.2},{x:46,y:3.3},{x:46.5,y:3.4},{x:47,y:3.5},{x:47.5,y:3.6},{x:48,y:3.7},{x:48.5,y:3.8},{x:49,y:3.9},{x:49.5,y:4.1},{x:50,y:4.2},{x:50.5,y:4.3},{x:51,y:4.4},{x:51.5,y:4.6},{x:52,y:4.7},{x:52.5,y:4.9},{x:53,y:5},{x:53.5,y:5.2},{x:54,y:5.3},{x:54.5,y:5.5},{x:55,y:5.7},{x:55.5,y:5.8},{x:56,y:6},{x:56.5,y:6.2},{x:57,y:6.3},{x:57.5,y:6.5},{x:58,y:6.7},{x:58.5,y:6.8},{x:59,y:7},{x:59.5,y:7.2},{x:60,y:7.3},{x:60.5,y:7.5},{x:61,y:7.6},{x:61.5,y:7.8},{x:62,y:8},{x:62.5,y:8.1},{x:63,y:8.3},{x:63.5,y:8.4},{x:64,y:8.5},{x:64.5,y:8.7},{x:65,y:9},{x:65.5,y:9.2},{x:66,y:9.3},{x:66.5,y:9.4},{x:67,y:9.6},{x:67.5,y:9.7},{x:68,y:9.8},{x:68.5,y:10},{x:69,y:10.1},{x:69.5,y:10.2},{x:70,y:10.3},{x:70.5,y:10.5},{x:71,y:10.6},{x:71.5,y:10.7},{x:72,y:10.8},{x:72.5,y:11},{x:73,y:11.1},{x:73.5,y:11.2},{x:74,y:11.3},{x:74.5,y:11.4},{x:75,y:11.5},{x:75.5,y:11.7},{x:76,y:11.8},{x:76.5,y:11.9},{x:77,y:12},{x:77.5,y:12.1},{x:78,y:12.2},{x:78.5,y:12.3},{x:79,y:12.5},{x:79.5,y:12.6},{x:80,y:12.7},{x:80.5,y:12.8},{x:81,y:13},{x:81.5,y:13.1},{x:82,y:13.2},{x:82.5,y:13.4},{x:83,y:13.5},{x:83.5,y:13.7},{x:84,y:13.8},{x:84.5,y:14},{x:85,y:14.1},{x:85.5,y:14.3},{x:86,y:14.4},{x:86.5,y:14.6},{x:87,y:14.8},{x:87.5,y:14.9},{x:88,y:15.1},{x:88.5,y:15.2},{x:89,y:15.4},{x:89.5,y:15.5},{x:90,y:15.7},{x:90.5,y:15.9},{x:91,y:16},{x:91.5,y:16.2},{x:92,y:16.3},{x:92.5,y:16.5},{x:93,y:16.6},{x:93.5,y:16.8},{x:94,y:16.9},{x:94.5,y:17.1},{x:95,y:17.3},{x:95.5,y:17.4},{x:96,y:17.6},{x:96.5,y:17.8},{x:97,y:17.9},{x:97.5,y:18.1},{x:98,y:18.3},{x:98.5,y:18.4},{x:99,y:18.6},{x:99.5,y:18.8},{x:100,y:19},{x:100.5,y:19.2},{x:101,y:19.4},{x:101.5,y:19.5},{x:102,y:19.7},{x:102.5,y:19.9},{x:103,y:20.2},{x:103.5,y:20.4},{x:104,y:20.6},{x:104.5,y:20.8},{x:105,y:21},{x:105.5,y:21.2},{x:106,y:21.4},{x:106.5,y:21.7},{x:107,y:21.9},{x:107.5,y:22.1},{x:108,y:22.4},{x:108.5,y:22.6},{x:109,y:22.9},{x:109.5,y:23.1},{x:110,y:23.4}];
              
              var rawSvg = element.find("svg")[0];
              var svg = d3.select(rawSvg)
                          .attr("width",width + margin.left + margin.right)
                          .attr("height",height + margin.top + margin.bottom);
              var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightweightData]);
              var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
  
              var div = d3.select("body").append("div")	
                          .attr("class", "tooltip")				
                          .style("opacity", 0);
  
              var lineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("bundle")
                              .tension(.7);
  
              var datalineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("linear");
  
              var g = svg.append("g")
                          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
              
              var xScale0 = d3.scale.linear().domain([110,45]).range([width,0]);
              var xScale1 = d3.scale.linear().domain([110,45]).range([width,0]);
  
              var yScale0 = d3.scale.linear().domain([0,26.5]).range([height, 0]);
              var yScale1 = d3.scale.linear().domain([0,26.5]).range([height, 0]);
  
              var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(45, 111, 5)).tickFormat(function(d){
                  return d%10==0? d : '';
              }).innerTickSize(-height)
                              .outerTickSize(0);
              var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(45, 111, 5)).tickFormat(function(d){
                  return d%10==0? d : '';
              });
              var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 26.5, 2)).tickFormat(function(d){
                  return d%2==0? d : '';
              }).innerTickSize(-width)
                              .outerTickSize(0);
              var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 26.5, 2)).tickFormat(function(d){
                  return d%2==0? d : '';
              }).innerTickSize(50)
                              .outerTickSize(50).tickPadding(10);
              
              var age = function(data) {
                  if(data <= 24){
                      return data.toString().split('.')[0]+ " months";
                  }
                  if(data <=60) {
                      var mon = data/12;
                      var result = mon.toFixed(1).split('.');
                      var mod = data%12;
                      var res = mod.toString().split('.');
                      return result[0].toString()+ " years " + res[0] + " months";
                  }
              };
  
              // plot user data points
              var heightpoint = wrap.selectAll('circle')
                  .data(function (d) { return d; })
                  .enter().append('circle')
                  .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                  .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                  .attr('r', 5)
                  .attr('fill','red')
                  .on("mouseover", function(d) {		
                      div.transition()		
                          .duration(200)		
                          .style("opacity", .9);		
                      div	.html((d.x) + " cm<br/>"  + (d.y).toString() +" kg")	
                          .style("left", (d3.event.pageX) + "px")		
                          .style("top", (d3.event.pageY - 28) + "px");	
                      })					
                  .on("mouseout", function(d) {		
                      div.transition()		
                          .duration(500)		
                          .style("opacity", 0);	
                  });
  
              // x-axis
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxisBottom);
              
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", -5 )
                  .style("text-anchor", "middle")
                  .text("WHO Girls Weight for Height/Length");
              
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height + 35)
                  .style("text-anchor", "middle")
                  .text("Child Wasting");
  
              svg.append("text")
                  .attr("x", -600 )
                  .attr("y", -35)
                  .attr("transform", "translate(0,0) rotate(-90)")
                  .style("text-anchor", "middle")
                  .text("Weight in Kg");
                  
              // y-axis
              svg.append("g")
                  .attr("class", "y axis")
                  .call(yAxisLeft);
              
              // path lines
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set1),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set2),
                      "stroke": "yellow",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set3),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set4),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              
              // user data
              svg.append("svg:path")
                    .attr({
                      d: datalineFunc(heightweightData),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
          }
      };
  });
'use strict';
angular.module('AngularApp').directive('weightForHeightLengthMaleSmall', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:5%;padding-top:6%;' viewBox='0 0 410 240'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 220 - margin.top - margin.bottom;
            var width = 400 - margin.left - margin.right;

            var heightweightData = [];

            if(vitalData.hwData) {
                for(var i = 0; i < vitalData.hwData.length; i++){
                    if(vitalData.hwData[i].x<111 && vitalData.hwData[i].x>44) {
                        if(vitalData.hwData[i].y<28 && vitalData.hwData[i].y>0) {
                            heightweightData.push(vitalData.hwData[i]);
                        }
                    }
                }
            }

            var set1 = [{x:45,y:2},{x:45.5,y:2.1},{x:46,y:2.1},{x:46.5,y:2.2},{x:47,y:2.3},{x:47.5,y:2.3},{x:48,y:2.4},{x:48.5,y:2.5},{x:49,y:2.6},{x:49.5,y:2.6},{x:50,y:2.7},{x:50.5,y:2.8},{x:51,y:2.9},{x:51.5,y:3},{x:52,y:3.1},{x:52.5,y:3.2},{x:53,y:3.3},{x:53.5,y:3.4},{x:54,y:3.5},{x:54.5,y:3.6},{x:55,y:3.7},{x:55.5,y:3.9},{x:56,y:4},{x:56.5,y:4.1},{x:57,y:4.2},{x:57.5,y:4.4},{x:58,y:4.5},{x:58.5,y:4.6},{x:59,y:4.7},{x:59.5,y:4.8},{x:60,y:5},{x:60.5,y:5.1},{x:61,y:5.2},{x:61.5,y:5.3},{x:62,y:5.4},{x:62.5,y:5.5},{x:63,y:5.6},{x:63.5,y:5.7},{x:64,y:5.8},{x:64.5,y:5.9},{x:65,y:6.2},{x:65.5,y:6.3},{x:66,y:6.4},{x:66.5,y:6.5},{x:67,y:6.6},{x:67.5,y:6.7},{x:68,y:6.8},{x:68.5,y:6.8},{x:69,y:6.9},{x:69.5,y:7},{x:70,y:7.1},{x:70.5,y:7.2},{x:71,y:7.3},{x:71.5,y:7.4},{x:72,y:7.5},{x:72.5,y:7.6},{x:73,y:7.7},{x:73.5,y:7.8},{x:74,y:7.8},{x:74.5,y:7.9},{x:75,y:8},{x:75.5,y:8.1},{x:76,y:8.2},{x:76.5,y:8.2},{x:77,y:8.3},{x:77.5,y:8.4},{x:78,y:8.5},{x:78.5,y:8.5},{x:79,y:8.6},{x:79.5,y:8.7},{x:80,y:8.8},{x:80.5,y:8.9},{x:81,y:8.9},{x:81.5,y:9},{x:82,y:9.1},{x:82.5,y:9.2},{x:83,y:9.3},{x:83.5,y:9.4},{x:84,y:9.5},{x:84.5,y:9.6},{x:85,y:9.7},{x:85.5,y:9.8},{x:86,y:9.9},{x:86.5,y:10},{x:87,y:10.1},{x:87.5,y:10.2},{x:88,y:10.3},{x:88.5,y:10.5},{x:89,y:10.6},{x:89.5,y:10.7},{x:90,y:10.8},{x:90.5,y:10.9},{x:91,y:11},{x:91.5,y:11},{x:92,y:11.1},{x:92.5,y:11.2},{x:93,y:11.3},{x:93.5,y:11.4},{x:94,y:11.5},{x:94.5,y:11.6},{x:95,y:11.7},{x:95.5,y:11.8},{x:96,y:11.9},{x:96.5,y:12},{x:97,y:12.1},{x:97.5,y:12.2},{x:98,y:12.3},{x:98.5,y:12.4},{x:99,y:12.5},{x:99.5,y:12.7},{x:100,y:12.8},{x:100.5,y:12.9},{x:101,y:13},{x:101.5,y:13.1},{x:102,y:13.2},{x:102.5,y:13.3},{x:103,y:13.4},{x:103.5,y:13.6},{x:104,y:13.7},{x:104.5,y:13.8},{x:105,y:13.9},{x:105.5,y:14},{x:106,y:14.2},{x:106.5,y:14.3},{x:107,y:14.4},{x:107.5,y:14.5},{x:108,y:14.7},{x:108.5,y:14.8},{x:109,y:14.9},{x:109.5,y:15.1},{x:110,y:15.2}];

            var set2 = [{x:45,y:2.1},{x:45.5,y:2.1},{x:46,y:2.2},{x:46.5,y:2.3},{x:47,y:2.4},{x:47.5,y:2.4},{x:48,y:2.5},{x:48.5,y:2.6},{x:49,y:2.7},{x:49.5,y:2.7},{x:50,y:2.8},{x:50.5,y:2.9},{x:51,y:3},{x:51.5,y:3.1},{x:52,y:3.2},{x:52.5,y:3.3},{x:53,y:3.4},{x:53.5,y:3.5},{x:54,y:3.6},{x:54.5,y:3.8},{x:55,y:3.9},{x:55.5,y:4},{x:56,y:4.1},{x:56.5,y:4.3},{x:57,y:4.4},{x:57.5,y:4.5},{x:58,y:4.6},{x:58.5,y:4.8},{x:59,y:4.9},{x:59.5,y:5},{x:60,y:5.1},{x:60.5,y:5.3},{x:61,y:5.4},{x:61.5,y:5.5},{x:62,y:5.6},{x:62.5,y:5.7},{x:63,y:5.8},{x:63.5,y:5.9},{x:64,y:6},{x:64.5,y:6.1},{x:65,y:6.4},{x:65.5,y:6.5},{x:66,y:6.6},{x:66.5,y:6.7},{x:67,y:6.8},{x:67.5,y:6.9},{x:68,y:7},{x:68.5,y:7.1},{x:69,y:7.2},{x:69.5,y:7.3},{x:70,y:7.4},{x:70.5,y:7.5},{x:71,y:7.6},{x:71.5,y:7.7},{x:72,y:7.8},{x:72.5,y:7.8},{x:73,y:7.9},{x:73.5,y:8},{x:74,y:8.1},{x:74.5,y:8.2},{x:75,y:8.3},{x:75.5,y:8.4},{x:76,y:8.5},{x:76.5,y:8.5},{x:77,y:8.6},{x:77.5,y:8.7},{x:78,y:8.8},{x:78.5,y:8.8},{x:79,y:8.9},{x:79.5,y:9},{x:80,y:9.1},{x:80.5,y:9.2},{x:81,y:9.3},{x:81.5,y:9.3},{x:82,y:9.4},{x:82.5,y:9.5},{x:83,y:9.6},{x:83.5,y:9.7},{x:84,y:9.8},{x:84.5,y:9.9},{x:85,y:10.1},{x:85.5,y:10.2},{x:86,y:10.3},{x:86.5,y:10.4},{x:87,y:10.5},{x:87.5,y:10.6},{x:88,y:10.7},{x:88.5,y:10.8},{x:89,y:10.9},{x:89.5,y:11},{x:90,y:11.1},{x:90.5,y:11.2},{x:91,y:11.3},{x:91.5,y:11.4},{x:92,y:11.5},{x:92.5,y:11.6},{x:93,y:11.7},{x:93.5,y:11.8},{x:94,y:11.9},{x:94.5,y:12},{x:95,y:12.1},{x:95.5,y:12.2},{x:96,y:12.3},{x:96.5,y:12.4},{x:97,y:12.5},{x:97.5,y:12.7},{x:98,y:12.8},{x:98.5,y:12.9},{x:99,y:13},{x:99.5,y:13.1},{x:100,y:13.2},{x:100.5,y:13.3},{x:101,y:13.4},{x:101.5,y:13.6},{x:102,y:13.7},{x:102.5,y:13.8},{x:103,y:13.9},{x:103.5,y:14},{x:104,y:14.2},{x:104.5,y:14.3},{x:105,y:14.4},{x:105.5,y:14.5},{x:106,y:14.7},{x:106.5,y:14.8},{x:107,y:14.9},{x:107.5,y:15.1},{x:108,y:15.2},{x:108.5,y:15.3},{x:109,y:15.5},{x:109.5,y:15.6},{x:110,y:15.8}];

            var set3 = [{x:45,y:2.4},{x:45.5,y:2.5},{x:46,y:2.6},{x:46.5,y:2.7},{x:47,y:2.8},{x:47.5,y:2.9},{x:48,y:2.9},{x:48.5,y:3},{x:49,y:3.1},{x:49.5,y:3.2},{x:50,y:3.3},{x:50.5,y:3.4},{x:51,y:3.5},{x:51.5,y:3.6},{x:52,y:3.8},{x:52.5,y:3.9},{x:53,y:4},{x:53.5,y:4.1},{x:54,y:4.3},{x:54.5,y:4.4},{x:55,y:4.5},{x:55.5,y:4.7},{x:56,y:4.8},{x:56.5,y:5},{x:57,y:5.1},{x:57.5,y:5.3},{x:58,y:5.4},{x:58.5,y:5.6},{x:59,y:5.7},{x:59.5,y:5.9},{x:60,y:6},{x:60.5,y:6.1},{x:61,y:6.3},{x:61.5,y:6.4},{x:62,y:6.5},{x:62.5,y:6.7},{x:63,y:6.8},{x:63.5,y:6.9},{x:64,y:7},{x:64.5,y:7.1},{x:65,y:7.4},{x:65.5,y:7.6},{x:66,y:7.7},{x:66.5,y:7.8},{x:67,y:7.9},{x:67.5,y:8},{x:68,y:8.1},{x:68.5,y:8.2},{x:69,y:8.4},{x:69.5,y:8.5},{x:70,y:8.6},{x:70.5,y:8.7},{x:71,y:8.8},{x:71.5,y:8.9},{x:72,y:9},{x:72.5,y:9.1},{x:73,y:9.2},{x:73.5,y:9.3},{x:74,y:9.4},{x:74.5,y:9.5},{x:75,y:9.6},{x:75.5,y:9.7},{x:76,y:9.8},{x:76.5,y:9.9},{x:77,y:10},{x:77.5,y:10.1},{x:78,y:10.2},{x:78.5,y:10.3},{x:79,y:10.4},{x:79.5,y:10.5},{x:80,y:10.6},{x:80.5,y:10.7},{x:81,y:10.8},{x:81.5,y:10.9},{x:82,y:11},{x:82.5,y:11.1},{x:83,y:11.2},{x:83.5,y:11.3},{x:84,y:11.4},{x:84.5,y:11.5},{x:85,y:11.7},{x:85.5,y:11.8},{x:86,y:11.9},{x:86.5,y:12},{x:87,y:12.2},{x:87.5,y:12.3},{x:88,y:12.4},{x:88.5,y:12.5},{x:89,y:12.6},{x:89.5,y:12.8},{x:90,y:12.9},{x:90.5,y:13},{x:91,y:13.1},{x:91.5,y:13.2},{x:92,y:13.4},{x:92.5,y:13.5},{x:93,y:13.6},{x:93.5,y:13.7},{x:94,y:13.8},{x:94.5,y:13.9},{x:95,y:14.1},{x:95.5,y:14.2},{x:96,y:14.3},{x:96.5,y:14.4},{x:97,y:14.6},{x:97.5,y:14.7},{x:98,y:14.8},{x:98.5,y:14.9},{x:99,y:15.1},{x:99.5,y:15.2},{x:100,y:15.4},{x:100.5,y:15.5},{x:101,y:15.6},{x:101.5,y:15.8},{x:102,y:15.9},{x:102.5,y:16.1},{x:103,y:16.2},{x:103.5,y:16.4},{x:104,y:16.5},{x:104.5,y:16.7},{x:105,y:16.8},{x:105.5,y:17},{x:106,y:17.2},{x:106.5,y:17.3},{x:107,y:17.5},{x:107.5,y:17.7},{x:108,y:17.8},{x:108.5,y:18},{x:109,y:18.2},{x:109.5,y:18.3},{x:110,y:18.5}];

            var set4 = [{x:45,y:3},{x:45.5,y:3.1},{x:46,y:3.3},{x:46.5,y:3.4},{x:47,y:3.5},{x:47.5,y:3.6},{x:48,y:3.7},{x:48.5,y:3.8},{x:49,y:3.9},{x:49.5,y:4},{x:50,y:4.1},{x:50.5,y:4.2},{x:51,y:4.4},{x:51.5,y:4.5},{x:52,y:4.6},{x:52.5,y:4.8},{x:53,y:4.9},{x:53.5,y:5.1},{x:54,y:5.3},{x:54.5,y:5.4},{x:55,y:5.6},{x:55.5,y:5.8},{x:56,y:5.9},{x:56.5,y:6.1},{x:57,y:6.3},{x:57.5,y:6.5},{x:58,y:6.6},{x:58.5,y:6.8},{x:59,y:7},{x:59.5,y:7.2},{x:60,y:7.3},{x:60.5,y:7.5},{x:61,y:7.7},{x:61.5,y:7.8},{x:62,y:8},{x:62.5,y:8.1},{x:63,y:8.3},{x:63.5,y:8.4},{x:64,y:8.6},{x:64.5,y:8.7},{x:65,y:9.1},{x:65.5,y:9.2},{x:66,y:9.3},{x:66.5,y:9.5},{x:67,y:9.6},{x:67.5,y:9.8},{x:68,y:9.9},{x:68.5,y:10},{x:69,y:10.2},{x:69.5,y:10.3},{x:70,y:10.5},{x:70.5,y:10.6},{x:71,y:10.7},{x:71.5,y:10.9},{x:72,y:11},{x:72.5,y:11.1},{x:73,y:11.3},{x:73.5,y:11.4},{x:74,y:11.5},{x:74.5,y:11.7},{x:75,y:11.8},{x:75.5,y:11.9},{x:76,y:12},{x:76.5,y:12.1},{x:77,y:12.3},{x:77.5,y:12.4},{x:78,y:12.5},{x:78.5,y:12.6},{x:79,y:12.7},{x:79.5,y:12.8},{x:80,y:12.9},{x:80.5,y:13},{x:81,y:13.1},{x:81.5,y:13.3},{x:82,y:13.4},{x:82.5,y:13.5},{x:83,y:13.6},{x:83.5,y:13.8},{x:84,y:13.9},{x:84.5,y:14.1},{x:85,y:14.2},{x:85.5,y:14.3},{x:86,y:14.5},{x:86.5,y:14.6},{x:87,y:14.8},{x:87.5,y:14.9},{x:88,y:15.1},{x:88.5,y:15.2},{x:89,y:15.4},{x:89.5,y:15.5},{x:90,y:15.6},{x:90.5,y:15.8},{x:91,y:15.9},{x:91.5,y:16.1},{x:92,y:16.2},{x:92.5,y:16.3},{x:93,y:16.5},{x:93.5,y:16.6},{x:94,y:16.8},{x:94.5,y:16.9},{x:95,y:17.1},{x:95.5,y:17.2},{x:96,y:17.4},{x:96.5,y:17.5},{x:97,y:17.7},{x:97.5,y:17.9},{x:98,y:18},{x:98.5,y:18.2},{x:99,y:18.4},{x:99.5,y:18.5},{x:100,y:18.7},{x:100.5,y:18.9},{x:101,y:19.1},{x:101.5,y:19.3},{x:102,y:19.5},{x:102.5,y:19.7},{x:103,y:19.9},{x:103.5,y:20.1},{x:104,y:20.3},{x:104.5,y:20.5},{x:105,y:20.7},{x:105.5,y:20.9},{x:106,y:21.1},{x:106.5,y:21.3},{x:107,y:21.5},{x:107.5,y:21.7},{x:108,y:22},{x:108.5,y:22.2},{x:109,y:22.4},{x:109.5,y:22.7},{x:110,y:22.9}];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightweightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([110,45]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([110,45]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,26.5]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,26.5]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(45, 111, 5)).tickFormat(function(d){
				return d%10==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(45, 111, 5)).tickFormat(function(d){
                return d%10==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 26.5, 2)).tickFormat(function(d){
                return d%2==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 26.5, 2)).tickFormat(function(d){
                return d%2==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<28 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<28 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html((d.x) + " cm<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -5 )
                .style("text-anchor", "middle")
                .text("WHO Boys Weight for Height/Length");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Child Wasting");

            svg.append("text")
                .attr("x", -600 )
                .attr("y", -35)
                .attr("transform", "translate(0,0) rotate(-90)")
                .style("text-anchor", "middle")
                .text("Weight in Kg");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightweightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('wlhcFemaleSmall', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:6%;padding-top:5%;' viewBox='0 0 410 240'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 220 - margin.top - margin.bottom;
              var width = 400 - margin.left - margin.right;
  
              var heightData = [];
  
              if(vitalData.height) {
                  for(var i = 0; i < vitalData.height.length; i++){
                      if(vitalData.height[i].x<61) {
                          heightData.push(vitalData.height[i]);
                      }
                  }
              }

            var weightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x<61) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var headData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.hc.length; i++){
                    if(vitalData.hc[i].x<61) {
                        headData.push(vitalData.hc[i]);
                    }
                }
            }
  
            //   Start of Weight data
            var set1 = [{x:0,y:2.3},{x:1,y:3},{x:2,y:3.8},{x:3,y:4.4},{x:4,y:4.8},{x:5,y:5.2},{x:6,y:5.5},{x:7,y:5.8},
                {x:8,y:6},{x:9,y:6.2},{x:10,y:6.4},{x:11,y:6.6},{x:12,y:6.8},{x:13,y:6.9},{x:14,y:7.1},{x:15,y:7.3},
                {x:16,y:7.4},{x:17,y:7.6},{x:18,y:7.8},{x:19,y:7.9},{x:20,y:8.1},{x:21,y:8.2},{x:22,y:8.4},
                {x:23,y:8.5},{x:24,y:8.7},{x:25,y:8.9},{x:26,y:9},{x:27,y:9.2},{x:28,y:9.3},{x:29,y:9.5},{x:30,y:9.6},
                {x:31,y:9.7},{x:32,y:9.9},{x:33,y:10},{x:34,y:10.1},{x:35,y:10.3},{x:36,y:10.4},{x:37,y:10.5},
                {x:38,y:10.6},{x:39,y:10.8},{x:40,y:10.9},{x:41,y:11},{x:42,y:11.1},{x:43,y:11.3},{x:44,y:11.4},
                {x:45,y:11.5},{x:46,y:11.6},{x:47,y:11.7},{x:48,y:11.8},{x:49,y:11.9},{x:50,y:12.1},{x:51,y:12.2},
                {x:52,y:12.3},{x:53,y:12.4},{x:54,y:12.5},{x:55,y:12.6},{x:56,y:12.7},{x:57,y:12.8},{x:58,y:12.9},
                {x:59,y:13.1},{x:60,y:13.2}];

            var set2 = [{x:0,y:2.5},{x:1,y:3.3},{x:2,y:4.1},{x:3,y:4.7},{x:4,y:5.2},{x:5,y:5.6},{x:6,y:6},{x:7,y:6.3},{x:8,y:6.5},
                {x:9,y:6.8},{x:10,y:7},{x:11,y:7.2},{x:12,y:7.3},{x:13,y:7.5},{x:14,y:7.7},{x:15,y:7.9},{x:16,y:8.1},
                {x:17,y:8.2},{x:18,y:8.4},{x:19,y:8.6},{x:20,y:8.7},{x:21,y:8.9},{x:22,y:9.1},{x:23,y:9.2},{x:24,y:9.4},
                {x:25,y:9.6},{x:26,y:9.8},{x:27,y:9.9},{x:28,y:10.1},{x:29,y:10.2},{x:30,y:10.4},{x:31,y:10.5},{x:32,y:10.7},
                {x:33,y:10.8},{x:34,y:11},{x:35,y:11.1},{x:36,y:11.3},{x:37,y:11.4},{x:38,y:11.6},{x:39,y:11.7},{x:40,y:11.8},
                {x:41,y:12},{x:42,y:12.1},{x:43,y:12.2},{x:44,y:12.4},{x:45,y:12.5},{x:46,y:12.6},{x:47,y:12.8},{x:48,y:12.9},
                {x:49,y:13},{x:50,y:13.2},{x:51,y:13.3},{x:52,y:13.4},{x:53,y:13.5},{x:54,y:13.7},{x:55,y:13.8},{x:56,y:13.9},
                {x:57,y:14},{x:58,y:14.2},{x:59,y:14.3},{x:60,y:14.4}];

            var set3 = [{x:0,y:3.2},{x:1,y:4.2},{x:2,y:5.1},{x:3,y:5.8},{x:4,y:6.4},{x:5,y:6.9},{x:6,y:7.3},{x:7,y:7.6},{x:8,y:7.9},
                {x:9,y:8.2},{x:10,y:8.5},{x:11,y:8.7},{x:12,y:8.9},{x:13,y:9.2},{x:14,y:9.4},{x:15,y:9.6},{x:16,y:9.8},
                {x:17,y:10},{x:18,y:10.2},{x:19,y:10.4},{x:20,y:10.6},{x:21,y:10.9},{x:22,y:11.1},{x:23,y:11.3},{x:24,y:11.5},
                {x:25,y:11.7},{x:26,y:11.9},{x:27,y:12.1},{x:28,y:12.3},{x:29,y:12.5},{x:30,y:12.7},{x:31,y:12.9},{x:32,y:13.1},
                {x:33,y:13.3},{x:34,y:13.5},{x:35,y:13.7},{x:36,y:13.9},{x:37,y:14},{x:38,y:14.2},{x:39,y:14.4},{x:40,y:14.6},
                {x:41,y:14.8},{x:42,y:15},{x:43,y:15.2},{x:44,y:15.3},{x:45,y:15.5},{x:46,y:15.7},{x:47,y:15.9},{x:48,y:16.1},
                {x:49,y:16.3},{x:50,y:16.4},{x:51,y:16.6},{x:52,y:16.8},{x:53,y:17},{x:54,y:17.2},{x:55,y:17.3},{x:56,y:17.5},
                {x:57,y:17.7},{x:58,y:17.9},{x:59,y:18},{x:60,y:18.2}];

            var set4 = [{x:0,y:4.2},{x:1,y:5.4},{x:2,y:6.5},{x:3,y:7.4},{x:4,y:8.1},{x:5,y:8.7},{x:6,y:9.2},{x:7,y:9.6},{x:8,y:10},
                {x:9,y:10.4},{x:10,y:10.7},{x:11,y:11},{x:12,y:11.3},{x:13,y:11.6},{x:14,y:11.9},{x:15,y:12.2},{x:16,y:12.5},
                {x:17,y:12.7},{x:18,y:13},{x:19,y:13.3},{x:20,y:13.5},{x:21,y:13.8},{x:22,y:14.1},{x:23,y:14.3},{x:24,y:14.6},
                {x:25,y:14.9},{x:26,y:15.2},{x:27,y:15.4},{x:28,y:15.7},{x:29,y:16},{x:30,y:16.2},{x:31,y:16.5},{x:32,y:16.8},
                {x:33,y:17},{x:34,y:17.3},{x:35,y:17.6},{x:36,y:17.8},{x:37,y:18.1},{x:38,y:18.4},{x:39,y:18.6},{x:40,y:18.9},
                {x:41,y:19.2},{x:42,y:19.5},{x:43,y:19.7},{x:44,y:20},{x:45,y:20.3},{x:46,y:20.6},{x:47,y:20.8},{x:48,y:21.1},
                {x:49,y:21.4},{x:50,y:21.7},{x:51,y:22},{x:52,y:22.2},{x:53,y:22.5},{x:54,y:22.8},{x:55,y:23.1},{x:56,y:23.3},
                {x:57,y:23.6},{x:58,y:23.9},{x:59,y:24.2},{x:60,y:24.4}];
            // End of Weight data

            // Start of Head Circumference data
            var set5 = [{x:0,y:31.7},{x:1,y:34.3},{x:2,y:36},{x:3,y:37.2},{x:4,y:38.2},{x:5,y:39},{x:6,y:39.7},{x:7,y:40.4},
                {x:8,y:40.9},{x:9,y:41.3},{x:10,y:41.7},{x:11,y:42},{x:12,y:42.3},{x:13,y:42.6},{x:14,y:42.9},
                {x:15,y:43.1},{x:16,y:43.3},{x:17,y:43.5},{x:18,y:43.6},{x:19,y:43.8},{x:20,y:44},{x:21,y:44.1},
                {x:22,y:44.3},{x:23,y:44.4},{x:24,y:44.6},{x:25,y:44.7},{x:26,y:44.8},{x:27,y:44.9},{x:28,y:45.1},
                {x:29,y:45.2},{x:30,y:45.3},{x:31,y:45.4},{x:32,y:45.5},{x:33,y:45.6},{x:34,y:45.7},{x:35,y:45.8},
                {x:36,y:45.9},{x:37,y:45.9},{x:38,y:46},{x:39,y:46.1},{x:40,y:46.2},{x:41,y:46.2},{x:42,y:46.3},
                {x:43,y:46.4},{x:44,y:46.4},{x:45,y:46.5},{x:46,y:46.5},{x:47,y:46.6},{x:48,y:46.7},{x:49,y:46.7},
                {x:50,y:46.8},{x:51,y:46.8},{x:52,y:46.9},{x:53,y:46.9},{x:54,y:47},{x:55,y:47},{x:56,y:47.1},
                {x:57,y:47.1},{x:58,y:47.2},{x:59,y:47.2},{x:60,y:47.2}];

            var set6 = [{x:0,y:33.9},{x:1,y:36.5},{x:2,y:38.3},{x:3,y:39.5},{x:4,y:40.6},{x:5,y:41.5},{x:6,y:42.2},{x:7,y:42.8},
                {x:8,y:43.4},{x:9,y:43.8},{x:10,y:44.2},{x:11,y:44.6},{x:12,y:44.9},{x:13,y:45.2},{x:14,y:45.4},{x:15,y:45.7},
                {x:16,y:45.9},{x:17,y:46.1},{x:18,y:46.2},{x:19,y:46.4},{x:20,y:46.6},{x:21,y:46.7},{x:22,y:46.9},{x:23,y:47},
                {x:24,y:47.2},{x:25,y:47.3},{x:26,y:47.5},{x:27,y:47.6},{x:28,y:47.7},{x:29,y:47.8},{x:30,y:47.9},{x:31,y:48},
                {x:32,y:48.1},{x:33,y:48.2},{x:34,y:48.3},{x:35,y:48.4},{x:36,y:48.5},{x:37,y:48.6},{x:38,y:48.7},{x:39,y:48.7},
                {x:40,y:48.8},{x:41,y:48.9},{x:42,y:49},{x:43,y:49},{x:44,y:49.1},{x:45,y:49.2},{x:46,y:49.2},{x:47,y:49.3},
                {x:48,y:49.3},{x:49,y:49.4},{x:50,y:49.4},{x:51,y:49.5},{x:52,y:49.5},{x:53,y:49.6},{x:54,y:49.6},{x:55,y:49.7},
                {x:56,y:49.7},{x:57,y:49.8},{x:58,y:49.8},{x:59,y:49.9},{x:60,y:49.9}];

            var set7 = [{x:0,y:36.1},{x:1,y:38.8},{x:2,y:40.5},{x:3,y:41.9},{x:4,y:43},{x:5,y:43.9},{x:6,y:44.6},{x:7,y:45.3},
                {x:8,y:45.9},{x:9,y:46.3},{x:10,y:46.8},{x:11,y:47.1},{x:12,y:47.5},{x:13,y:47.7},{x:14,y:48},{x:15,y:48.2},
                {x:16,y:48.5},{x:17,y:48.7},{x:18,y:48.8},{x:19,y:49},{x:20,y:49.2},{x:21,y:49.4},{x:22,y:49.5},{x:23,y:49.7},
                {x:24,y:49.8},{x:25,y:49.9},{x:26,y:50.1},{x:27,y:50.2},{x:28,y:50.3},{x:29,y:50.5},{x:30,y:50.6},{x:31,y:50.7},
                {x:32,y:50.8},{x:33,y:50.9},{x:34,y:51},{x:35,y:51.1},{x:36,y:51.2},{x:37,y:51.3},{x:38,y:51.3},{x:39,y:51.4},
                {x:40,y:51.5},{x:41,y:51.6},{x:42,y:51.6},{x:43,y:51.7},{x:44,y:51.8},{x:45,y:51.8},{x:46,y:51.9},{x:47,y:51.9},
                {x:48,y:52},{x:49,y:52.1},{x:50,y:52.1},{x:51,y:52.2},{x:52,y:52.2},{x:53,y:52.3},{x:54,y:52.3},{x:55,y:52.4},
                {x:56,y:52.4},{x:57,y:52.5},{x:58,y:52.5},{x:59,y:52.6},{x:60,y:52.6}];
            // End of Head Circumference data
            
            // Start of Height/Lenght data
            var set8 = [{x:0,y:44.8},{x:1,y:49.1},{x:2,y:52.3},{x:3,y:54.9},{x:4,y:57.1},{x:5,y:58.9},{x:6,y:60.5},{x:7,y:61.9},
                {x:8,y:63.2},{x:9,y:64.5},{x:10,y:65.7},{x:11,y:66.9},{x:12,y:68},{x:13,y:69.1},{x:14,y:70.1},{x:15,y:71.1},
                {x:16,y:72.1},{x:17,y:73},{x:18,y:74},{x:19,y:74.8},{x:20,y:75.7},{x:21,y:76.5},{x:22,y:77.3},{x:23,y:78.1},
                {x:24,y:78.9},{x:25,y:79},{x:26,y:79.7},{x:27,y:80.4},{x:28,y:81.1},{x:29,y:81.8},{x:30,y:82.5},{x:31,y:83.1},
                {x:32,y:83.8},{x:33,y:84.4},{x:34,y:85},{x:35,y:85.6},{x:36,y:86.2},{x:37,y:86.8},{x:38,y:87.4},{x:39,y:87.9},
                {x:40,y:88.5},{x:41,y:89},{x:42,y:89.6},{x:43,y:90.1},{x:44,y:90.7},{x:45,y:91.2},{x:46,y:91.7},{x:47,y:92.2},
                {x:48,y:92.7},{x:49,y:93.2},{x:50,y:93.7},{x:51,y:94.2},{x:52,y:94.7},{x:53,y:95.2},{x:54,y:95.6},{x:55,y:96.1},
                {x:56,y:96.6},{x:57,y:97},{x:58,y:97.5},{x:59,y:97.9},{x:60,y:98.4}];
  
            var set9 = [{x:0,y:45.6},{x:1,y:50},{x:2,y:53.2},{x:3,y:55.8},{x:4,y:58},{x:5,y:59.9},{x:6,y:61.5},{x:7,y:62.9},{x:8,y:64.3},
                {x:9,y:65.6},{x:10,y:66.8},{x:11,y:68},{x:12,y:69.2},{x:13,y:70.3},{x:14,y:71.3},{x:15,y:72.4},{x:16,y:73.3},
                {x:17,y:74.3},{x:18,y:75.2},{x:19,y:76.2},{x:20,y:77},{x:21,y:77.9},{x:22,y:78.7},{x:23,y:79.6},{x:24,y:80.3},
                {x:25,y:80.4},{x:26,y:81.2},{x:27,y:81.9},{x:28,y:82.6},{x:29,y:83.4},{x:30,y:84},{x:31,y:84.7},{x:32,y:85.4},
                {x:33,y:86},{x:34,y:86.7},{x:35,y:87.3},{x:36,y:87.9},{x:37,y:88.5},{x:38,y:89.1},{x:39,y:89.7},{x:40,y:90.3},
                {x:41,y:90.8},{x:42,y:91.4},{x:43,y:92},{x:44,y:92.5},{x:45,y:93},{x:46,y:93.6},{x:47,y:94.1},{x:48,y:94.6},
                {x:49,y:95.1},{x:50,y:95.7},{x:51,y:96.2},{x:52,y:96.7},{x:53,y:97.2},{x:54,y:97.6},{x:55,y:98.1},{x:56,y:98.6},
                {x:57,y:99.1},{x:58,y:99.6},{x:59,y:100},{x:60,y:100.5}];

            var set10 = [{x:0,y:49.1},{x:1,y:53.7},{x:2,y:57.1},{x:3,y:59.8},{x:4,y:62.1},{x:5,y:64},{x:6,y:65.7},{x:7,y:67.3},{x:8,y:68.7},
                {x:9,y:70.1},{x:10,y:71.5},{x:11,y:72.8},{x:12,y:74},{x:13,y:75.2},{x:14,y:76.4},{x:15,y:77.5},{x:16,y:78.6},
                {x:17,y:79.7},{x:18,y:80.7},{x:19,y:81.7},{x:20,y:82.7},{x:21,y:83.7},{x:22,y:84.6},{x:23,y:85.5},{x:24,y:86.4},
                {x:25,y:86.6},{x:26,y:87.4},{x:27,y:88.3},{x:28,y:89.1},{x:29,y:89.9},{x:30,y:90.7},{x:31,y:91.4},{x:32,y:92.2},
                {x:33,y:92.9},{x:34,y:93.6},{x:35,y:94.4},{x:36,y:95.1},{x:37,y:95.7},{x:38,y:96.4},{x:39,y:97.1},{x:40,y:97.7},
                {x:41,y:98.4},{x:42,y:99},{x:43,y:99.7},{x:44,y:100.3},{x:45,y:100.9},{x:46,y:101.5},{x:47,y:102.1},
                {x:48,y:102.7},{x:49,y:103.3},{x:50,y:103.9},{x:51,y:104.5},{x:52,y:105},{x:53,y:105.6},{x:54,y:106.2},
                {x:55,y:106.7},{x:56,y:107.3},{x:57,y:107.8},{x:58,y:108.4},{x:59,y:108.9},{x:60,y:109.4}];
  
            var set11 = [{x:0,y:52.7},{x:1,y:57.4},{x:2,y:60.9},{x:3,y:63.8},{x:4,y:66.2},{x:5,y:68.2},{x:6,y:70},{x:7,y:71.6},{x:8,y:73.2},
                {x:9,y:74.7},{x:10,y:76.1},{x:11,y:77.5},{x:12,y:78.9},{x:13,y:80.2},{x:14,y:81.4},{x:15,y:82.7},{x:16,y:83.9},
                {x:17,y:85},{x:18,y:86.2},{x:19,y:87.3},{x:20,y:88.4},{x:21,y:89.4},{x:22,y:90.5},{x:23,y:91.5},{x:24,y:92.5},
                {x:25,y:92.8},{x:26,y:93.7},{x:27,y:94.6},{x:28,y:95.6},{x:29,y:96.4},{x:30,y:97.3},{x:31,y:98.2},{x:32,y:99},
                {x:33,y:99.8},{x:34,y:100.6},{x:35,y:101.4},{x:36,y:102.2},{x:37,y:103},{x:38,y:103.7},{x:39,y:104.5},
                {x:40,y:105.2},{x:41,y:106},{x:42,y:106.7},{x:43,y:107.4},{x:44,y:108.1},{x:45,y:108.8},{x:46,y:109.5},
                {x:47,y:110.2},{x:48,y:110.8},{x:49,y:111.5},{x:50,y:112.1},{x:51,y:112.8},{x:52,y:113.4},{x:53,y:114.1},
                {x:54,y:114.7},{x:55,y:115.3},{x:56,y:116},{x:57,y:116.6},{x:58,y:117.2},{x:59,y:117.8},{x:60,y:118.4}];
            // End of Height/Lenght data
              
              var rawSvg = element.find("svg")[0];
              var svg = d3.select(rawSvg)
                          .attr("width",width + margin.left + margin.right)
                          .attr("height",height + margin.top + margin.bottom);
              var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
              var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
            
              var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
              var gEnter2 = wrap2.enter().append('g').attr('class', 'd3line').append('g');
  
              var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([headData]);
              var gEnter3 = wrap3.enter().append('g').attr('class', 'd3line').append('g');
  
              var div = d3.select("body").append("div")	
                          .attr("class", "tooltip")				
                          .style("opacity", 0);
  
              var lineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("bundle")
                              .tension(.7);
  
              var datalineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("linear");
  
              var g = svg.append("g")
                          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
              
              var xScale0 = d3.scale.linear().domain([60.5,0]).range([width,0]);
              var xScale1 = d3.scale.linear().domain([60.5,0]).range([width,0]);
  
              var yScale0 = d3.scale.linear().domain([0,131]).range([height, 0]);
              var yScale1 = d3.scale.linear().domain([0,131]).range([height, 0]);
  
              var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(0, 60.5, 5)).tickFormat(function(d){
                  return d%10==0? d : '';
              }).innerTickSize(-height)
                              .outerTickSize(0);
              var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(0, 60.5, 5)).tickFormat(function(d){
                  return d%10==0? d : '';
              });
              var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 131, 5)).tickFormat(function(d){
                  return d%10==0? d : '';
              }).innerTickSize(-width)
                              .outerTickSize(0);
              var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 131, 5)).tickFormat(function(d){
                  return d%10==0? d : '';
              }).innerTickSize(50)
                              .outerTickSize(50).tickPadding(10);
              
              var age = function(data) {
                  if(data <= 24){
                      return data.toString().split('.')[0]+ " months";
                  }
                  if(data <=60) {
                      var mon = data/12;
                      var result = mon.toFixed(1).split('.');
                      var mod = data%12;
                      var res = mod.toString().split('.');
                      return result[0].toString()+ " years " + res[0] + " months";
                  }
              };
  
              // plot user data points
              var heightpoint = wrap.selectAll('circle')
                  .data(function (d) { return d; })
                  .enter().append('circle')
                  .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                  .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                  .attr('r', 5)
                  .attr('fill','red')
                  .on("mouseover", function(d) {		
                      div.transition()		
                          .duration(200)		
                          .style("opacity", .9);		
                      div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                          .style("left", (d3.event.pageX) + "px")		
                          .style("top", (d3.event.pageY - 28) + "px");	
                      })					
                  .on("mouseout", function(d) {		
                      div.transition()		
                          .duration(500)		
                          .style("opacity", 0);	
                  });
  
            var weightpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var headpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

              // x-axis
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxisBottom);
              
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", -4 )
                  .style("text-anchor", "middle")
                  .text("WHO Girls Height, Weight, Head Charts");
              
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height + 35)
                  .style("text-anchor", "middle")
                  .text("Child Stunting");
                  
              // y-axis
              svg.append("g")
                  .attr("class", "y axis")
                  .call(yAxisLeft);
              
              // path lines
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set1),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set2),
                      "stroke": "yellow",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set3),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set4),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set5),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set6),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set7),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set8),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set9),
                      "stroke": "yellow",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set10),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
                
                svg.append("svg:path")
                    .attr({
                      d: lineFunc(set11),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              
              // user data
              svg.append("svg:path")
                    .attr({
                      d: datalineFunc(heightData),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });

                svg.append("svg:path")
                    .attr({
                      d: datalineFunc(weightData),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
  
                svg.append("svg:path")
                    .attr({
                      d: datalineFunc(headData),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
          }
      };
  });
'use strict';
angular.module('AngularApp').directive('wlhcMaleSmall', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:6%;padding-top:5%;' viewBox='0 0 410 240'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 220 - margin.top - margin.bottom;
            var width = 400 - margin.left - margin.right;

            var heightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.height.length; i++){
                    if(vitalData.height[i].x<61) {
                        heightData.push(vitalData.height[i]);
                    }
                }
            }

            var weightData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.weight.length; i++){
                    if(vitalData.weight[i].x<61) {
                        weightData.push(vitalData.weight[i]);
                    }
                }
            }

            var headData = [];

            if(vitalData.height) {
                for(var i = 0; i < vitalData.hc.length; i++){
                    if(vitalData.hc[i].x<61) {
                        headData.push(vitalData.hc[i]);
                    }
                }
            }

            // Start of Weight data
            var set1 = [{x:0,y:2.3},{x:1,y:3.2},{x:2,y:4.1},{x:3,y:4.8},{x:4,y:5.4},{x:5,y:5.8},{x:6,y:6.1},{x:7,y:6.4},{x:8,y:6.7},
                {x:9,y:6.9},{x:10,y:7.1},{x:11,y:7.3},{x:12,y:7.5},{x:13,y:7.6},{x:14,y:7.8},{x:15,y:8},{x:16,y:8.1},
                {x:17,y:8.3},{x:18,y:8.4},{x:19,y:8.6},{x:20,y:8.7},{x:21,y:8.9},{x:22,y:9},{x:23,y:9.2},{x:24,y:9.3},
                {x:25,y:9.5},{x:26,y:9.6},{x:27,y:9.7},{x:28,y:9.9},{x:29,y:10},{x:30,y:10.1},{x:31,y:10.3},{x:32,y:10.4},
                {x:33,y:10.5},{x:34,y:10.6},{x:35,y:10.7},{x:36,y:10.8},{x:37,y:11},{x:38,y:11.1},{x:39,y:11.2},{x:40,y:11.3},
                {x:41,y:11.4},{x:42,y:11.5},{x:43,y:11.7},{x:44,y:11.8},{x:45,y:11.9},{x:46,y:12},{x:47,y:12.1},{x:48,y:12.2},
                {x:49,y:12.3},{x:50,y:12.4},{x:51,y:12.5},{x:52,y:12.6},{x:53,y:12.7},{x:54,y:12.9},{x:55,y:13},{x:56,y:13.1},
                {x:57,y:13.2},{x:58,y:13.3},{x:59,y:13.4},{x:60,y:13.5}];

            var set2 = [{x:0,y:2.5},{x:1,y:3.4},{x:2,y:4.4},{x:3,y:5.1},{x:4,y:5.6},{x:5,y:6.1},{x:6,y:6.4},{x:7,y:6.7},{x:8,y:7},
                        {x:9,y:7.2},{x:10,y:7.5},{x:11,y:7.7},{x:12,y:7.8},{x:13,y:8},{x:14,y:8.2},{x:15,y:8.4},{x:16,y:8.5},
                        {x:17,y:8.7},{x:18,y:8.9},{x:19,y:9},{x:20,y:9.2},{x:21,y:9.3},{x:22,y:9.5},{x:23,y:9.7},{x:24,y:9.8},
                        {x:25,y:10},{x:26,y:10.1},{x:27,y:10.2},{x:28,y:10.4},{x:29,y:10.5},{x:30,y:10.7},{x:31,y:10.8},{x:32,y:10.9},
                        {x:33,y:11.1},{x:34,y:11.2},{x:35,y:11.3},{x:36,y:11.4},{x:37,y:11.6},{x:38,y:11.7},{x:39,y:11.8},{x:40,y:11.9},
                        {x:41,y:12.1},{x:42,y:12.2},{x:43,y:12.3},{x:44,y:12.4},{x:45,y:12.5},{x:46,y:12.7},{x:47,y:12.8},{x:48,y:12.9},
                        {x:49,y:13},{x:50,y:13.1},{x:51,y:13.3},{x:52,y:13.4},{x:53,y:13.5},{x:54,y:13.6},{x:55,y:13.7},{x:56,y:13.8},
                        {x:57,y:13.9},{x:58,y:14.1},{x:59,y:14.2},{x:60,y:14.3}];

            var set3 = [{x:0,y:3.3},{x:1,y:4.5},{x:2,y:5.6},{x:3,y:6.4},{x:4,y:7},{x:5,y:7.5},{x:6,y:7.9},{x:7,y:8.3},{x:8,y:8.6},
                        {x:9,y:8.9},{x:10,y:9.2},{x:11,y:9.4},{x:12,y:9.6},{x:13,y:9.9},{x:14,y:10.1},{x:15,y:10.3},{x:16,y:10.5},
                        {x:17,y:10.7},{x:18,y:10.9},{x:19,y:11.1},{x:20,y:11.3},{x:21,y:11.5},{x:22,y:11.8},{x:23,y:12},{x:24,y:12.2},
                        {x:25,y:12.4},{x:26,y:12.5},{x:27,y:12.7},{x:28,y:12.9},{x:29,y:13.1},{x:30,y:13.3},{x:31,y:13.5},{x:32,y:13.7},
                        {x:33,y:13.8},{x:34,y:14},{x:35,y:14.2},{x:36,y:14.3},{x:37,y:14.5},{x:38,y:14.7},{x:39,y:14.8},{x:40,y:15},
                        {x:41,y:15.2},{x:42,y:15.3},{x:43,y:15.5},{x:44,y:15.7},{x:45,y:15.8},{x:46,y:16},{x:47,y:16.2},{x:48,y:16.3},
                        {x:49,y:16.5},{x:50,y:16.7},{x:51,y:16.8},{x:52,y:17},{x:53,y:17.2},{x:54,y:17.3},{x:55,y:17.5},{x:56,y:17.7},
                        {x:57,y:17.8},{x:58,y:18},{x:59,y:18.2},{x:60,y:18.3}];

            var set4 = [{x:0,y:4.3},{x:1,y:5.7},{x:2,y:7},{x:3,y:7.9},{x:4,y:8.6},{x:5,y:9.2},{x:6,y:9.7},{x:7,y:10.2},{x:8,y:10.5},
                        {x:9,y:10.9},{x:10,y:11.2},{x:11,y:11.5},{x:12,y:11.8},{x:13,y:12.1},{x:14,y:12.4},{x:15,y:12.7},{x:16,y:12.9},
                        {x:17,y:13.2},{x:18,y:13.5},{x:19,y:13.7},{x:20,y:14},{x:21,y:14.3},{x:22,y:14.5},{x:23,y:14.8},{x:24,y:15.1},
                        {x:25,y:15.3},{x:26,y:15.6},{x:27,y:15.9},{x:28,y:16.1},{x:29,y:16.4},{x:30,y:16.6},{x:31,y:16.9},{x:32,y:17.1},
                        {x:33,y:17.3},{x:34,y:17.6},{x:35,y:17.8},{x:36,y:18},{x:37,y:18.3},{x:38,y:18.5},{x:39,y:18.7},{x:40,y:19},
                        {x:41,y:19.2},{x:42,y:19.4},{x:43,y:19.7},{x:44,y:19.9},{x:45,y:20.1},{x:46,y:20.4},{x:47,y:20.6},{x:48,y:20.9},
                        {x:49,y:21.1},{x:50,y:21.3},{x:51,y:21.6},{x:52,y:21.8},{x:53,y:22.1},{x:54,y:22.3},{x:55,y:22.5},{x:56,y:22.8},
                        {x:57,y:23},{x:58,y:23.3},{x:59,y:23.5},{x:60,y:23.8}];
            // End of Weight data
            
            // Start of Head data
            var set5 = [{x:0,y:32.1},{x:1,y:35.1},{x:2,y:36.9},{x:3,y:38.3},{x:4,y:39.4},{x:5,y:40.3},{x:6,y:41},{x:7,y:41.7},{x:8,y:42.2},
                        {x:9,y:42.6},{x:10,y:43},{x:11,y:43.4},{x:12,y:43.6},{x:13,y:43.9},{x:14,y:44.1},{x:15,y:44.3},{x:16,y:44.5},
                        {x:17,y:44.7},{x:18,y:44.9},{x:19,y:45},{x:20,y:45.2},{x:21,y:45.3},{x:22,y:45.4},{x:23,y:45.6},{x:24,y:45.7},
                        {x:25,y:45.8},{x:26,y:45.9},{x:27,y:46},{x:28,y:46.1},{x:29,y:46.2},{x:30,y:46.3},{x:31,y:46.4},{x:32,y:46.5},
                        {x:33,y:46.6},{x:34,y:46.6},{x:35,y:46.7},{x:36,y:46.8},{x:37,y:46.9},{x:38,y:46.9},{x:39,y:47},{x:40,y:47},
                        {x:41,y:47.1},{x:42,y:47.2},{x:43,y:47.2},{x:44,y:47.3},{x:45,y:47.3},{x:46,y:47.4},{x:47,y:47.4},{x:48,y:47.5},
                        {x:49,y:47.5},{x:50,y:47.5},{x:51,y:47.6},{x:52,y:47.6},{x:53,y:47.7},{x:54,y:47.7},{x:55,y:47.7},{x:56,y:47.8},
                        {x:57,y:47.8},{x:58,y:47.9},{x:59,y:47.9},{x:60,y:47.9}];

            var set6 = [{x:0,y:34.5},{x:1,y:37.3},{x:2,y:39.1},{x:3,y:40.5},{x:4,y:41.6},{x:5,y:42.6},{x:6,y:43.3},{x:7,y:44},{x:8,y:44.5},
                        {x:9,y:45},{x:10,y:45.4},{x:11,y:45.8},{x:12,y:46.1},{x:13,y:46.3},{x:14,y:46.6},{x:15,y:46.8},{x:16,y:47},
                        {x:17,y:47.2},{x:18,y:47.4},{x:19,y:47.5},{x:20,y:47.7},{x:21,y:47.8},{x:22,y:48},{x:23,y:48.1},{x:24,y:48.3},
                        {x:25,y:48.4},{x:26,y:48.5},{x:27,y:48.6},{x:28,y:48.7},{x:29,y:48.8},{x:30,y:48.9},{x:31,y:49},{x:32,y:49.1},
                        {x:33,y:49.2},{x:34,y:49.3},{x:35,y:49.4},{x:36,y:49.5},{x:37,y:49.5},{x:38,y:49.6},{x:39,y:49.7},{x:40,y:49.7},
                        {x:41,y:49.8},{x:42,y:49.9},{x:43,y:49.9},{x:44,y:50},{x:45,y:50.1},{x:46,y:50.1},{x:47,y:50.2},{x:48,y:50.2},
                        {x:49,y:50.3},{x:50,y:50.3},{x:51,y:50.4},{x:52,y:50.4},{x:53,y:50.4},{x:54,y:50.5},{x:55,y:50.5},{x:56,y:50.6},
                        {x:57,y:50.6},{x:58,y:50.7},{x:59,y:50.7},{x:60,y:50.7}];

            var set7 = [{x:0,y:36.9},{x:1,y:39.5},{x:2,y:41.3},{x:3,y:42.7},{x:4,y:43.9},{x:5,y:44.8},{x:6,y:45.6},{x:7,y:46.3},{x:8,y:46.9},
                        {x:9,y:47.4},{x:10,y:47.8},{x:11,y:48.2},{x:12,y:48.5},{x:13,y:48.8},{x:14,y:49},{x:15,y:49.3},{x:16,y:49.5},
                        {x:17,y:49.7},{x:18,y:49.9},{x:19,y:50},{x:20,y:50.2},{x:21,y:50.4},{x:22,y:50.5},{x:23,y:50.7},{x:24,y:50.8},
                        {x:25,y:50.9},{x:26,y:51.1},{x:27,y:51.2},{x:28,y:51.3},{x:29,y:51.4},{x:30,y:51.6},{x:31,y:51.7},{x:32,y:51.8},
                        {x:33,y:51.9},{x:34,y:52},{x:35,y:52},{x:36,y:52.1},{x:37,y:52.2},{x:38,y:52.3},{x:39,y:52.4},{x:40,y:52.4},
                        {x:41,y:52.5},{x:42,y:52.6},{x:43,y:52.7},{x:44,y:52.7},{x:45,y:52.8},{x:46,y:52.8},{x:47,y:52.9},{x:48,y:53},
                        {x:49,y:53},{x:50,y:53.1},{x:51,y:53.1},{x:52,y:53.2},{x:53,y:53.2},{x:54,y:53.3},{x:55,y:53.3},{x:56,y:53.4},
                        {x:57,y:53.4},{x:58,y:53.5},{x:59,y:53.5},{x:60,y:53.5}];
            // End of Head data

            // Start of Height/Lenght data
            var set8 = [{x:0,y:45.5},{x:1,y:50.2},{x:2,y:53.8},{x:3,y:56.7},{x:4,y:59},{x:5,y:61},{x:6,y:62.6},{x:7,y:64.1},{x:8,y:65.5},
                        {x:9,y:66.8},{x:10,y:68},{x:11,y:69.1},{x:12,y:70.2},{x:13,y:71.3},{x:14,y:72.3},{x:15,y:73.3},{x:16,y:74.2},
                        {x:17,y:75.1},{x:18,y:76},{x:19,y:76.8},{x:20,y:77.7},{x:21,y:78.4},{x:22,y:79.2},{x:23,y:80},{x:24,y:80.7},
                        {x:25,y:80.7},{x:26,y:81.4},{x:27,y:82.1},{x:28,y:82.8},{x:29,y:83.4},{x:30,y:84},{x:31,y:84.6},{x:32,y:85.2},
                        {x:33,y:85.8},{x:34,y:86.4},{x:35,y:86.9},{x:36,y:87.5},{x:37,y:88},{x:38,y:88.5},{x:39,y:89.1},{x:40,y:89.6},
                        {x:41,y:90.1},{x:42,y:90.6},{x:43,y:91.1},{x:44,y:91.6},{x:45,y:92.1},{x:46,y:92.6},{x:47,y:93.1},{x:48,y:93.6},
                        {x:49,y:94},{x:50,y:94.5},{x:51,y:95},{x:52,y:95.5},{x:53,y:95.9},{x:54,y:96.4},{x:55,y:96.9},{x:56,y:97.3},
                        {x:57,y:97.8},{x:58,y:98.3},{x:59,y:98.7},{x:60,y:99.2}];
            
            var set9 = [{x:0,y:46.3},{x:1,y:51.1},{x:2,y:54.7},{x:3,y:57.6},{x:4,y:60},{x:5,y:61.9},{x:6,y:63.6},{x:7,y:65.1},{x:8,y:66.5},
                        {x:9,y:67.7},{x:10,y:69},{x:11,y:70.2},{x:12,y:71.3},{x:13,y:72.4},{x:14,y:73.4},{x:15,y:74.4},{x:16,y:75.4},
                        {x:17,y:76.3},{x:18,y:77.2},{x:19,y:78.1},{x:20,y:78.9},{x:21,y:79.7},{x:22,y:80.5},{x:23,y:81.3},{x:24,y:82.1},
                        {x:25,y:82.1},{x:26,y:82.8},{x:27,y:83.5},{x:28,y:84.2},{x:29,y:84.9},{x:30,y:85.5},{x:31,y:86.2},{x:32,y:86.8},
                        {x:33,y:87.4},{x:34,y:88},{x:35,y:88.5},{x:36,y:89.1},{x:37,y:89.7},{x:38,y:90.2},{x:39,y:90.8},{x:40,y:91.3},
                        {x:41,y:91.9},{x:42,y:92.4},{x:43,y:92.9},{x:44,y:93.4},{x:45,y:93.9},{x:46,y:94.4},{x:47,y:94.9},{x:48,y:95.4},
                        {x:49,y:95.9},{x:50,y:96.4},{x:51,y:96.9},{x:52,y:97.4},{x:53,y:97.9},{x:54,y:98.4},{x:55,y:98.8},{x:56,y:99.3},
                        {x:57,y:99.8},{x:58,y:100.3},{x:59,y:100.8},{x:60,y:101.2}];

            var set10 = [{x:0,y:49.9},{x:1,y:54.7},{x:2,y:58.4},{x:3,y:61.4},{x:4,y:63.9},{x:5,y:65.9},{x:6,y:67.6},{x:7,y:69.2},{x:8,y:70.6},
                        {x:9,y:72},{x:10,y:73.3},{x:11,y:74.5},{x:12,y:75.7},{x:13,y:76.9},{x:14,y:78},{x:15,y:79.1},{x:16,y:80.2},{x:17,y:81.2},
                        {x:18,y:82.3},{x:19,y:83.2},{x:20,y:84.2},{x:21,y:85.1},{x:22,y:86},{x:23,y:86.9},{x:24,y:87.8},{x:25,y:88},{x:26,y:88.8},
                        {x:27,y:89.6},{x:28,y:90.4},{x:29,y:91.2},{x:30,y:91.9},{x:31,y:92.7},{x:32,y:93.4},{x:33,y:94.1},{x:34,y:94.8},{x:35,y:95.4},
                        {x:36,y:96.1},{x:37,y:96.7},{x:38,y:97.4},{x:39,y:98},{x:40,y:98.6},{x:41,y:99.2},{x:42,y:99.9},{x:43,y:100.4},{x:44,y:101},
                        {x:45,y:101.6},{x:46,y:102.2},{x:47,y:102.8},{x:48,y:103.3},{x:49,y:103.9},{x:50,y:104.4},{x:51,y:105},{x:52,y:105.6},
                        {x:53,y:106.1},{x:54,y:106.7},{x:55,y:107.2},{x:56,y:107.8},{x:57,y:108.3},{x:58,y:108.9},{x:59,y:109.4},{x:60,y:110}];

            var set11 = [{x:0,y:53.4},{x:1,y:58.4},{x:2,y:62.2},{x:3,y:65.3},{x:4,y:67.8},{x:5,y:69.9},{x:6,y:71.6},{x:7,y:73.2},
                        {x:8,y:74.7},{x:9,y:76.2},{x:10,y:77.6},{x:11,y:78.9},{x:12,y:80.2},{x:13,y:81.5},{x:14,y:82.7},{x:15,y:83.9},
                        {x:16,y:85.1},{x:17,y:86.2},{x:18,y:87.3},{x:19,y:88.4},{x:20,y:89.5},{x:21,y:90.5},{x:22,y:91.6},{x:23,y:92.6},
                        {x:24,y:93.6},{x:25,y:93.8},{x:26,y:94.8},{x:27,y:95.7},{x:28,y:96.6},{x:29,y:97.5},{x:30,y:98.3},{x:31,y:99.2},
                        {x:32,y:100},{x:33,y:100.8},{x:34,y:101.5},{x:35,y:102.3},{x:36,y:103.1},{x:37,y:103.8},{x:38,y:104.5},
                        {x:39,y:105.2},{x:40,y:105.9},{x:41,y:106.6},{x:42,y:107.3},{x:43,y:108},{x:44,y:108.6},{x:45,y:109.3},
                        {x:46,y:109.9},{x:47,y:110.6},{x:48,y:111.2},{x:49,y:111.8},{x:50,y:112.5},{x:51,y:113.1},{x:52,y:113.7},
                        {x:53,y:114.3},{x:54,y:115},{x:55,y:115.6},{x:56,y:116.2},{x:57,y:116.8},{x:58,y:117.4},{x:59,y:118.1},
                        {x:60,y:118.7}];
            // End of Height/Lenght data
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([heightData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var wrap2 = d3.select(rawSvg).selectAll('d.d3line').data([weightData]);
            var gEnter2 = wrap2.enter().append('g').attr('class', 'd3line').append('g');

            var wrap3 = d3.select(rawSvg).selectAll('d.d3line').data([headData]);
            var gEnter3 = wrap3.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.7);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");

            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([60.5,0]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([60.5,0]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0,131]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0,131]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(0, 60.5, 5)).tickFormat(function(d){
				return d%10==0? d : '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(0, 60.5, 5)).tickFormat(function(d){
                return d%10==0? d : '';
            });
	        var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(17).tickValues(d3.range(0, 131, 5)).tickFormat(function(d){
                return d%10==0? d : '';
            }).innerTickSize(-width)
                            .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(17).tickValues(d3.range(0, 131, 5)).tickFormat(function(d){
                return d%10==0? d : '';
            }).innerTickSize(50)
                            .outerTickSize(50).tickPadding(10);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };

            // plot user data points
            var heightpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var weightpoint = wrap2.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" kg")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            var headpoint = wrap3.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<120 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<120 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                        .style("left", (d3.event.pageX) + "px")		
                        .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", -4 )
                .style("text-anchor", "middle")
                .text("WHO Boys Height, Weight, Head Charts");
            
            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height + 35)
                .style("text-anchor", "middle")
                .text("Child Stunting");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set6),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set7),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set8),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set9),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set10),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set11),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(heightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(weightData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

                svg.append("svg:path")
                  .attr({
                    d: datalineFunc(headData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
        }
    };
});
'use strict';
angular.module('AngularApp').directive('wlratioChartFemaleSmall', function() {
    return {
          restrict: 'EA',
          template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
          link: function(scope, element, attrs){
              var vitalData = scope[attrs.chartData];
              var margin = { top: 20, right: 100, bottom: 40, left: 100 };
              var height = 250 - margin.top - margin.bottom;
              var width = 370 - margin.left - margin.right;
  
            var wlRatioData = [];

            if(vitalData.pretermwhRatio) {
                for(var i = 0; i < vitalData.pretermwhRatio.length; i++){
                    console.log(vitalData.pretermwhRatio[i]);
                    if(vitalData.pretermwhRatio[i].y<7.1) {
                        wlRatioData.push(vitalData.pretermwhRatio[i]);
                    }
                }
            }
  
    var set1 = [{x:168,y:1.04},{x:169,y:1.06},{x:170,y:1.07},{x:171,y:1.09},{x:172,y:1.1},{x:173,y:1.12},{x:174,y:1.14},
                {x:175,y:1.15},{x:176,y:1.17},{x:177,y:1.19},{x:178,y:1.21},{x:179,y:1.23},{x:180,y:1.25},{x:181,y:1.27},
                {x:182,y:1.29},{x:183,y:1.31},{x:184,y:1.34},{x:185,y:1.36},{x:186,y:1.39},{x:187,y:1.41},{x:188,y:1.44},
                {x:189,y:1.46},{x:190,y:1.49},{x:191,y:1.52},{x:192,y:1.55},{x:193,y:1.58},{x:194,y:1.61},{x:195,y:1.64},
                {x:196,y:1.67},{x:197,y:1.7},{x:198,y:1.73},{x:199,y:1.77},{x:200,y:1.8},{x:201,y:1.84},{x:202,y:1.87},
                {x:203,y:1.91},{x:204,y:1.95},{x:205,y:1.99},{x:206,y:2.03},{x:207,y:2.07},{x:208,y:2.11},{x:209,y:2.15},
                {x:210,y:2.19},{x:211,y:2.23},{x:212,y:2.28},{x:213,y:2.32},{x:214,y:2.37},{x:215,y:2.42},{x:216,y:2.46},
                {x:217,y:2.51},{x:218,y:2.56},{x:219,y:2.61},{x:220,y:2.66},{x:221,y:2.72},{x:222,y:2.77},{x:223,y:2.82},
                {x:224,y:2.88},{x:225,y:2.93},{x:226,y:2.99},{x:227,y:3.05},{x:228,y:3.11},{x:229,y:3.17},{x:230,y:3.23}];

    var set2 = [{x:168,y:1.4},{x:169,y:1.42},{x:170,y:1.43},{x:171,y:1.45},{x:172,y:1.46},{x:173,y:1.48},{x:174,y:1.49},
                {x:175,y:1.51},{x:176,y:1.53},{x:177,y:1.55},{x:178,y:1.57},{x:179,y:1.59},{x:180,y:1.61},{x:181,y:1.63},
                {x:182,y:1.65},{x:183,y:1.67},{x:184,y:1.7},{x:185,y:1.72},{x:186,y:1.74},{x:187,y:1.77},{x:188,y:1.79},
                {x:189,y:1.82},{x:190,y:1.85},{x:191,y:1.88},{x:192,y:1.91},{x:193,y:1.93},{x:194,y:1.96},{x:195,y:2},
                {x:196,y:2.03},{x:197,y:2.06},{x:198,y:2.09},{x:199,y:2.13},{x:200,y:2.16},{x:201,y:2.2},{x:202,y:2.23},
                {x:203,y:2.27},{x:204,y:2.31},{x:205,y:2.35},{x:206,y:2.38},{x:207,y:2.42},{x:208,y:2.47},{x:209,y:2.51},
                {x:210,y:2.55},{x:211,y:2.59},{x:212,y:2.64},{x:213,y:2.68},{x:214,y:2.73},{x:215,y:2.78},{x:216,y:2.82},
                {x:217,y:2.87},{x:218,y:2.92},{x:219,y:2.97},{x:220,y:3.02},{x:221,y:3.07},{x:222,y:3.13},{x:223,y:3.18},
                {x:224,y:3.24},{x:225,y:3.29},{x:226,y:3.35},{x:227,y:3.41},{x:228,y:3.46},{x:229,y:3.52},{x:230,y:3.58}];
            
    var set3 = [{x:168,y:2.17},{x:169,y:2.18},{x:170,y:2.2},{x:171,y:2.21},{x:172,y:2.23},{x:173,y:2.24},{x:174,y:2.26},
                {x:175,y:2.28},{x:176,y:2.29},{x:177,y:2.31},{x:178,y:2.33},{x:179,y:2.35},{x:180,y:2.37},{x:181,y:2.39},
                {x:182,y:2.41},{x:183,y:2.44},{x:184,y:2.46},{x:185,y:2.48},{x:186,y:2.51},{x:187,y:2.53},{x:188,y:2.56},
                {x:189,y:2.59},{x:190,y:2.61},{x:191,y:2.64},{x:192,y:2.67},{x:193,y:2.7},{x:194,y:2.73},{x:195,y:2.76},
                {x:196,y:2.79},{x:197,y:2.82},{x:198,y:2.86},{x:199,y:2.89},{x:200,y:2.93},{x:201,y:2.96},{x:202,y:3},
                {x:203,y:3.03},{x:204,y:3.07},{x:205,y:3.11},{x:206,y:3.15},{x:207,y:3.19},{x:208,y:3.23},{x:209,y:3.27},
                {x:210,y:3.31},{x:211,y:3.36},{x:212,y:3.4},{x:213,y:3.45},{x:214,y:3.49},{x:215,y:3.54},{x:216,y:3.59},
                {x:217,y:3.64},{x:218,y:3.69},{x:219,y:3.74},{x:220,y:3.79},{x:221,y:3.84},{x:222,y:3.89},{x:223,y:3.95},
                {x:224,y:4},{x:225,y:4.06},{x:226,y:4.11},{x:227,y:4.17},{x:228,y:4.23},{x:229,y:4.29},{x:230,y:4.35}];

    var set4 = [{x:168,y:2.93},{x:169,y:2.95},{x:170,y:2.96},{x:171,y:2.98},{x:172,y:2.99},{x:173,y:3.01},{x:174,y:3.02},
                {x:175,y:3.04},{x:176,y:3.06},{x:177,y:3.08},{x:178,y:3.1},{x:179,y:3.12},{x:180,y:3.14},{x:181,y:3.16},
                {x:182,y:3.18},{x:183,y:3.2},{x:184,y:3.23},{x:185,y:3.25},{x:186,y:3.27},{x:187,y:3.3},{x:188,y:3.32},
                {x:189,y:3.35},{x:190,y:3.38},{x:191,y:3.41},{x:192,y:3.43},{x:193,y:3.46},{x:194,y:3.49},{x:195,y:3.52},
                {x:196,y:3.56},{x:197,y:3.59},{x:198,y:3.62},{x:199,y:3.66},{x:200,y:3.69},{x:201,y:3.73},{x:202,y:3.76},
                {x:203,y:3.8},{x:204,y:3.84},{x:205,y:3.87},{x:206,y:3.91},{x:207,y:3.95},{x:208,y:4},{x:209,y:4.04},
                {x:210,y:4.08},{x:211,y:4.12},{x:212,y:4.17},{x:213,y:4.21},{x:214,y:4.26},{x:215,y:4.31},{x:216,y:4.35},
                {x:217,y:4.4},{x:218,y:4.45},{x:219,y:4.5},{x:220,y:4.55},{x:221,y:4.6},{x:222,y:4.66},{x:223,y:4.71},
                {x:224,y:4.77},{x:225,y:4.82},{x:226,y:4.88},{x:227,y:4.94},{x:228,y:4.99},{x:229,y:5.05},{x:230,y:5.11}];

    var set5 = [{x:168,y:3.29},{x:169,y:3.31},{x:170,y:3.32},{x:171,y:3.33},{x:172,y:3.35},{x:173,y:3.37},{x:174,y:3.38},
                {x:175,y:3.4},{x:176,y:3.42},{x:177,y:3.44},{x:178,y:3.46},{x:179,y:3.47},{x:180,y:3.5},{x:181,y:3.52},
                {x:182,y:3.54},{x:183,y:3.56},{x:184,y:3.58},{x:185,y:3.61},{x:186,y:3.63},{x:187,y:3.66},{x:188,y:3.68},
                {x:189,y:3.71},{x:190,y:3.74},{x:191,y:3.76},{x:192,y:3.79},{x:193,y:3.82},{x:194,y:3.85},{x:195,y:3.88},
                {x:196,y:3.91},{x:197,y:3.95},{x:198,y:3.98},{x:199,y:4.01},{x:200,y:4.05},{x:201,y:4.08},{x:202,y:4.12},
                {x:203,y:4.16},{x:204,y:4.19},{x:205,y:4.23},{x:206,y:4.27},{x:207,y:4.31},{x:208,y:4.35},{x:209,y:4.4},
                {x:210,y:4.44},{x:211,y:4.48},{x:212,y:4.53},{x:213,y:4.57},{x:214,y:4.62},{x:215,y:4.66},{x:216,y:4.71},
                {x:217,y:4.76},{x:218,y:4.81},{x:219,y:4.86},{x:220,y:4.91},{x:221,y:4.96},{x:222,y:5.02},{x:223,y:5.07},
                {x:224,y:5.12},{x:225,y:5.18},{x:226,y:5.24},{x:227,y:5.29},{x:228,y:5.35},{x:229,y:5.41},{x:230,y:5.47}];
  
              var set6 = [];
  
              var set7 = [];
              
              var rawSvg = element.find("svg")[0];
              var svg = d3.select(rawSvg)
                          .attr("width",width + margin.left + margin.right)
                          .attr("height",height + margin.top + margin.bottom);
              var wrap = d3.select(rawSvg).selectAll('d.d3line').data([wlRatioData]);
              var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');
  
              var div = d3.select("body").append("div")	
                          .attr("class", "tooltip")				
                          .style("opacity", 0);
  
              var lineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("bundle")
                              .tension(.8);
  
              var datalineFunc = d3.svg.line()
                              .x(function (d) {
                                return xScale0(d.x);
                              })
                              .y(function (d) {
                                return yScale0(d.y);
                              })
                              .interpolate("linear");
  
  
              var g = svg.append("g")
                          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
              
              var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
              var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);
  
              var yScale0 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);
              var yScale1 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);
  
              var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                  return '';
              }).innerTickSize(-height)
                              .outerTickSize(0);
              var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                  return '';
              });
              var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                  return d%0.5==0? d:'';
              }).innerTickSize(-width)
                      .outerTickSize(0);
              var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                  return '';
              }).innerTickSize(50)
                      .outerTickSize(50).tickPadding(5);
              
              var age = function(data) {
                  if(data <= 24){
                      return data.toString().split('.')[0]+ " months";
                  }
                  if(data <=60) {
                      var mon = data/12;
                      var result = mon.toFixed(1).split('.');
                      var mod = data%12;
                      var res = mod.toString().split('.');
                      return result[0].toString()+ " years " + res[0] + " months";
                  }
              };
              
              // plot user data points
              var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<7.1 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<7.1 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });
  
              // x-axis
              svg.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxisBottom);
  
              svg.append("text")
                  .attr("x", width/2 )
                  .attr("y", height+37 )
                  .style("text-anchor", "middle")
                  .text("Gestational age at birth (weeks)");
              
              svg.append("text")
                  .attr("x", -10 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("24");

            svg.append("text")
                  .attr("x", -25 )
                  .attr("y", -7 )
                  .style("text-anchor", "start")
                  .text("Very Preterm Infants Weight-Length Ratio");
                     
              svg.append("text")
                  .attr("x", 158 )
                  .attr("y", height+20 )
                  .style("text-anchor", "start")
                  .text("33");
                  
              // y-axis
              svg.append("g")
                  .attr("class", "y axis")
                  .call(yAxisLeft);
              
              // path lines
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set1),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set2),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set3),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set4),
                      "stroke": "black",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              svg.append("svg:path")
                    .attr({
                      d: lineFunc(set5),
                      "stroke": "red",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
              
              // user data
              svg.append("svg:path")
                    .attr({
                      d: datalineFunc(wlRatioData),
                      "stroke": "green",
                      "stroke-width": 2,
                      "fill": "none",
                      "class": "path"
                    });
  
          }
      }
  });
  
'use strict';
angular.module('AngularApp').directive('wlratioChartMaleSmall', function() {
  return {
        restrict: 'EA',
        template: "<svg id='printSectionId' style='padding-left:7%;padding-top:7%;' viewBox='0 0 360 270'></svg>",
        link: function(scope, element, attrs){
            var vitalData = scope[attrs.chartData];
            var margin = { top: 20, right: 100, bottom: 40, left: 100 };
            var height = 250 - margin.top - margin.bottom;
            var width = 370 - margin.left - margin.right;

            var wlRatioData = [];

            if(vitalData.pretermwhRatio) {
                for(var i = 0; i < vitalData.pretermwhRatio.length; i++){
                    console.log(vitalData.pretermwhRatio[i]);
                    if(vitalData.pretermwhRatio[i].y<7.1) {
                        wlRatioData.push(vitalData.pretermwhRatio[i]);
                    }
                }
            }

            var set1 = [{x:168,y:1.18},{x:169,y:1.2},{x:170,y:1.21},{x:171,y:1.23},{x:172,y:1.24},{x:173,y:1.26},{x:174,y:1.27},
                        {x:175,y:1.29},{x:176,y:1.31},{x:177,y:1.33},{x:178,y:1.35},{x:179,y:1.37},{x:180,y:1.39},{x:181,y:1.41},
                        {x:182,y:1.43},{x:183,y:1.45},{x:184,y:1.48},{x:185,y:1.5},{x:186,y:1.52},{x:187,y:1.55},{x:188,y:1.57},
                        {x:189,y:1.6},{x:190,y:1.63},{x:191,y:1.66},{x:192,y:1.68},{x:193,y:1.71},{x:194,y:1.74},{x:195,y:1.78},
                        {x:196,y:1.81},{x:197,y:1.84},{x:198,y:1.87},{x:199,y:1.91},{x:200,y:1.94},{x:201,y:1.98},{x:202,y:2.01},
                        {x:203,y:2.05},{x:204,y:2.09},{x:205,y:2.13},{x:206,y:2.16},{x:207,y:2.2},{x:208,y:2.25},{x:209,y:2.29},
                        {x:210,y:2.33},{x:211,y:2.37},{x:212,y:2.42},{x:213,y:2.46},{x:214,y:2.51},{x:215,y:2.56},{x:216,y:2.6},
                        {x:217,y:2.65},{x:218,y:2.7},{x:219,y:2.75},{x:220,y:2.8},{x:221,y:2.85},{x:222,y:2.91},{x:223,y:2.96},
                        {x:224,y:3.02},{x:225,y:3.07},{x:226,y:3.13},{x:227,y:3.19},{x:228,y:3.24},{x:229,y:3.3},{x:230,y:3.36}];

            var set2 = [{x:168,y:1.54},{x:169,y:1.56},{x:170,y:1.57},{x:171,y:1.58},{x:172,y:1.6},{x:173,y:1.62},{x:174,y:1.63},
                        {x:175,y:1.65},{x:176,y:1.67},{x:177,y:1.69},{x:178,y:1.71},{x:179,y:1.73},{x:180,y:1.75},{x:181,y:1.77},
                        {x:182,y:1.79},{x:183,y:1.81},{x:184,y:1.83},{x:185,y:1.86},{x:186,y:1.88},{x:187,y:1.91},{x:188,y:1.93},
                        {x:189,y:1.96},{x:190,y:1.99},{x:191,y:2.01},{x:192,y:2.04},{x:193,y:2.07},{x:194,y:2.1},{x:195,y:2.13},
                        {x:196,y:2.17},{x:197,y:2.2},{x:198,y:2.23},{x:199,y:2.26},{x:200,y:2.3},{x:201,y:2.33},{x:202,y:2.37},
                        {x:203,y:2.41},{x:204,y:2.45},{x:205,y:2.48},{x:206,y:2.52},{x:207,y:2.56},{x:208,y:2.6},{x:209,y:2.65},
                        {x:210,y:2.69},{x:211,y:2.73},{x:212,y:2.78},{x:213,y:2.82},{x:214,y:2.87},{x:215,y:2.91},{x:216,y:2.96},
                        {x:217,y:3.01},{x:218,y:3.06},{x:219,y:3.11},{x:220,y:3.16},{x:221,y:3.21},{x:222,y:3.27},{x:223,y:3.32},
                        {x:224,y:3.37},{x:225,y:3.43},{x:226,y:3.49},{x:227,y:3.54},{x:228,y:3.6},{x:229,y:3.66},{x:230,y:3.72}];
                    
            var set3 = [{x:168,y:2.31},{x:169,y:2.32},{x:170,y:2.33},{x:171,y:2.35},{x:172,y:2.36},{x:173,y:2.38},{x:174,y:2.4},
                        {x:175,y:2.41},{x:176,y:2.43},{x:177,y:2.45},{x:178,y:2.47},{x:179,y:2.49},{x:180,y:2.51},{x:181,y:2.53},
                        {x:182,y:2.55},{x:183,y:2.58},{x:184,y:2.6},{x:185,y:2.62},{x:186,y:2.65},{x:187,y:2.67},{x:188,y:2.7},
                        {x:189,y:2.72},{x:190,y:2.75},{x:191,y:2.78},{x:192,y:2.81},{x:193,y:2.84},{x:194,y:2.87},{x:195,y:2.9},
                        {x:196,y:2.93},{x:197,y:2.96},{x:198,y:3},{x:199,y:3.03},{x:200,y:3.06},{x:201,y:3.1},{x:202,y:3.14},
                        {x:203,y:3.17},{x:204,y:3.21},{x:205,y:3.25},{x:206,y:3.29},{x:207,y:3.33},{x:208,y:3.37},{x:209,y:3.41},
                        {x:210,y:3.45},{x:211,y:3.5},{x:212,y:3.54},{x:213,y:3.59},{x:214,y:3.63},{x:215,y:3.68},{x:216,y:3.73},
                        {x:217,y:3.77},{x:218,y:3.82},{x:219,y:3.87},{x:220,y:3.93},{x:221,y:3.98},{x:222,y:4.03},{x:223,y:4.08},
                        {x:224,y:4.14},{x:225,y:4.19},{x:226,y:4.25},{x:227,y:4.31},{x:228,y:4.37},{x:229,y:4.43},{x:230,y:4.49}];

            var set4 = [{x:168,y:3.07},{x:169,y:3.09},{x:170,y:3.1},{x:171,y:3.11},{x:172,y:3.13},{x:173,y:3.15},{x:174,y:3.16},
                        {x:175,y:3.18},{x:176,y:3.2},{x:177,y:3.22},{x:178,y:3.23},{x:179,y:3.25},{x:180,y:3.28},{x:181,y:3.3},
                        {x:182,y:3.32},{x:183,y:3.34},{x:184,y:3.36},{x:185,y:3.39},{x:186,y:3.41},{x:187,y:3.44},{x:188,y:3.46},
                        {x:189,y:3.49},{x:190,y:3.52},{x:191,y:3.54},{x:192,y:3.57},{x:193,y:3.6},{x:194,y:3.63},{x:195,y:3.66},
                        {x:196,y:3.69},{x:197,y:3.73},{x:198,y:3.76},{x:199,y:3.79},{x:200,y:3.83},{x:201,y:3.86},{x:202,y:3.9},
                        {x:203,y:3.94},{x:204,y:3.97},{x:205,y:4.01},{x:206,y:4.05},{x:207,y:4.09},{x:208,y:4.13},{x:209,y:4.18},
                        {x:210,y:4.22},{x:211,y:4.26},{x:212,y:4.31},{x:213,y:4.35},{x:214,y:4.4},{x:215,y:4.44},{x:216,y:4.49},
                        {x:217,y:4.54},{x:218,y:4.59},{x:219,y:4.64},{x:220,y:4.69},{x:221,y:4.74},{x:222,y:4.8},{x:223,y:4.85},
                        {x:224,y:4.9},{x:225,y:4.96},{x:226,y:5.02},{x:227,y:5.07},{x:228,y:5.13},{x:229,y:5.19},{x:230,y:5.25}];

            var set5 = [{x:168,y:3.43},{x:169,y:3.44},{x:170,y:3.46},{x:171,y:3.47},{x:172,y:3.49},{x:173,y:3.5},{x:174,y:3.52},
                        {x:175,y:3.54},{x:176,y:3.56},{x:177,y:3.57},{x:178,y:3.59},{x:179,y:3.61},{x:180,y:3.63},{x:181,y:3.65},
                        {x:182,y:3.68},{x:183,y:3.7},{x:184,y:3.72},{x:185,y:3.75},{x:186,y:3.77},{x:187,y:3.8},{x:188,y:3.82},
                        {x:189,y:3.85},{x:190,y:3.87},{x:191,y:3.9},{x:192,y:3.93},{x:193,y:3.96},{x:194,y:3.99},{x:195,y:4.02},
                        {x:196,y:4.05},{x:197,y:4.09},{x:198,y:4.12},{x:199,y:4.15},{x:200,y:4.19},{x:201,y:4.22},{x:202,y:4.26},
                        {x:203,y:4.3},{x:204,y:4.33},{x:205,y:4.37},{x:206,y:4.41},{x:207,y:4.45},{x:208,y:4.49},{x:209,y:4.53},
                        {x:210,y:4.58},{x:211,y:4.62},{x:212,y:4.66},{x:213,y:4.71},{x:214,y:4.76},{x:215,y:4.8},{x:216,y:4.85},
                        {x:217,y:4.9},{x:218,y:4.95},{x:219,y:5},{x:220,y:5.05},{x:221,y:5.1},{x:222,y:5.15},{x:223,y:5.21},
                        {x:224,y:5.26},{x:225,y:5.32},{x:226,y:5.37},{x:227,y:5.43},{x:228,y:5.49},{x:229,y:5.55},{x:230,y:5.61}];

            var set6 = [];

            var set7 = [];
            
            var rawSvg = element.find("svg")[0];
            var svg = d3.select(rawSvg)
                        .attr("width",width + margin.left + margin.right)
                        .attr("height",height + margin.top + margin.bottom);
            var wrap = d3.select(rawSvg).selectAll('d.d3line').data([wlRatioData]);
            var gEnter = wrap.enter().append('g').attr('class', 'd3line').append('g');

            var div = d3.select("body").append("div")	
                        .attr("class", "tooltip")				
                        .style("opacity", 0);

            var lineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("bundle")
                            .tension(.8);

            var datalineFunc = d3.svg.line()
                            .x(function (d) {
                              return xScale0(d.x);
                            })
                            .y(function (d) {
                              return yScale0(d.y);
                            })
                            .interpolate("linear");


            var g = svg.append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            var xScale0 = d3.scale.linear().domain([231,168]).range([width,0]);
            var xScale1 = d3.scale.linear().domain([231,168]).range([width,0]);

            var yScale0 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);
            var yScale1 = d3.scale.linear().domain([0.0,7.0]).range([height, 0]);

            var xAxisBottom = d3.svg.axis().scale(xScale1).orient("bottom").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
				return '';
			}).innerTickSize(-height)
                            .outerTickSize(0);
            var xAxisTop = d3.svg.axis().scale(xScale0).orient("top").ticks(27).tickValues(d3.range(168, 232, 7)).tickFormat(function(d){
                return '';
            });
            var yAxisLeft = d3.svg.axis().scale(yScale1).orient("left").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return d%0.5==0? d:'';
            }).innerTickSize(-width)
                    .outerTickSize(0);
            var yAxisRight = d3.svg.axis().scale(yScale0).orient("right").ticks(39).tickValues(d3.range(0.0, 7.1,0.1)).tickFormat(function(d){
                return '';
            }).innerTickSize(50)
                    .outerTickSize(50).tickPadding(5);
            
            var age = function(data) {
                if(data <= 24){
                    return data.toString().split('.')[0]+ " months";
                }
                if(data <=60) {
                    var mon = data/12;
                    var result = mon.toFixed(1).split('.');
                    var mod = data%12;
                    var res = mod.toString().split('.');
                    return result[0].toString()+ " years " + res[0] + " months";
                }
            };
            
            // plot user data points
            var headpoint = wrap.selectAll('circle')
                .data(function (d) { return d; })
                .enter().append('circle')
                .attr('cx', function (d) { return d.y<7.1 && d.y > 0 ? xScale0(d.x): -100; })
                .attr('cy', function (d) { return d.y<7.1 && d.y > 0 ? yScale0(d.y): -100; })
                .attr('r', 5)
                .attr('fill','red')
                .on("mouseover", function(d) {		
                    div.transition()		
                        .duration(200)		
                        .style("opacity", .9);		
                    // div	.html(age(d.x) + "<br/>"  + (d.y).toString() +" cm")	
                    //     .style("left", (d3.event.pageX) + "px")		
                    //     .style("top", (d3.event.pageY - 28) + "px");	
                    })					
                .on("mouseout", function(d) {		
                    div.transition()		
                        .duration(500)		
                        .style("opacity", 0);	
                });

            // x-axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxisBottom);

            svg.append("text")
                .attr("x", width/2 )
                .attr("y", height+37 )
                .style("text-anchor", "middle")
                .text("Gestational age at birth (weeks)");
            
            svg.append("text")
                .attr("x", -10 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("24");
                   
            svg.append("text")
                .attr("x", 158 )
                .attr("y", height+20 )
                .style("text-anchor", "start")
                .text("33");

            svg.append("text")
                .attr("x", -25 )
                .attr("y", -7 )
                .style("text-anchor", "start")
                .text("Very Preterm Infants Weight-Length Ratio");
				
            // y-axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxisLeft);
            
            // path lines
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set1),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set2),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set3),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set4),
                    "stroke": "black",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            svg.append("svg:path")
                  .attr({
                    d: lineFunc(set5),
                    "stroke": "red",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });
            
            // user data
            svg.append("svg:path")
                  .attr({
                    d: datalineFunc(wlRatioData),
                    "stroke": "green",
                    "stroke-width": 2,
                    "fill": "none",
                    "class": "path"
                  });

        }
    }
});

angular.module("AngularApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/apt-book/apt-cancel.tpl.html","<h2 class=\"page-title\"><i class=\"fa fa-trash-o\"></i> Cancel Appointment</h2><br><form><div class=\"row text-center\"><div class=\"col-md-12\"><div class=\"form-group\"><input type=\"radio\" class=\"mgr mgr-primary mgr-lg\" ng-model=\"apt.searchBy\" name=\"type\" value=\"dt\" ng-change=\"apt.calender=[];apt.fresh=true;\" checked=\"checked\"> By Date <input type=\"radio\" class=\"mgr mgr-primary mgr-lg\" ng-model=\"apt.searchBy\" name=\"type\" value=\"mr\" ng-change=\"apt.calender=[];apt.fresh=true;\"> By MR Number</div></div></div><div class=\"row\"><div class=\"col-md-2\"><div ng-if=\"apt.searchBy===\'mr\'\" class=\"form-group\"><input autofocus=\"\" type=\"text\" class=\"form-control\" placeholder=\"Enter MR Number\" style=\"text-transform:uppercase\" autocomplete=\"OFF\" ng-model=\"apt.mr_number\" ng-keyup=\"$event.keyCode == 13 && apt.getBookings()\"></div><div ng-if=\"apt.searchBy===\'dt\'\" class=\"input-group\"><input autofocus=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"apt.date\" is-open=\"apt.opened\" datepicker-options=\"options\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"apt.opened=!apt.opened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-10 pull-right\"><button ng-click=\"apt.getBookings()\" class=\"btn btn-primary\" style=\"margin-left: 20px;\">&nbsp;&nbsp;&nbsp;&nbsp;Go&nbsp;&nbsp;&nbsp;&nbsp;</button></div></div></form><hr><div ng-show=\"apt.searchBy===\'mr\'\" style=\"overflow-y: auto; height: 300px;padding-bottom: 3%\"><table class=\"table table-bordered\"><tr><th>Date</th><th>Token No</th><th>Slot</th><th>Type</th><th>Status</th><th>&nbsp;</th></tr><tr ng-repeat=\"token in apt.calender\"><td>{{token.localSlot| date:\'dd-MMM-yyyy\'}}</td><td>{{token.token}}</td><td>{{token.localSlot| date:\'h:mm a\'}}</td><td>{{token.type}}</td><td>{{token.status}}</td><td><center><button ng-if=\"token.status===\'confirmed\' && token.button\" ng-click=\"apt.cancelBookings(token)\" class=\"btn btn-primary\">Cancel</button></center></td></tr></table></div><div ng-show=\"apt.searchBy===\'dt\'\" class=\"row\"><div class=\"col-md-8\"><table class=\"table table-bordered\"><tr ng-show=\"apt.calender.slots.length && apt.calender.slots.length>0\"><th style=\"width:40px;\">&nbsp;</th><th style=\"width:85px;\">Minutes<i class=\"fa fa-long-arrow-right\"></i></th><th ng-repeat=\"slot in apt.calender.slots\">{{slot}}</th></tr><tr ng-repeat=\"chunk in apt.calender._chunked\"><td><input type=\"checkbox\" class=\"mgc mgc-primary mgc-lg\" ng-model=\"chunk.cancel\" ng-change=\"apt.toggleChunk(chunk)\"></td><td>{{chunk[0].token}} - {{chunk[chunk.length-1].token}}</td><td class=\"text-center\" ng-repeat=\"token in chunk\" ng-class=\"{\'btn-danger\':token.available && !token.dummy}\"><input ng-if=\"!token.dummy && token.available\" type=\"checkbox\" class=\"mgc mgc-primary mgc-circle mgc-lg\" ng-model=\"token.cancel\" <=\"\" td=\"\"></td></tr></table><div class=\"row\" ng-show=\"apt.calender.slots.length && apt.calender.slots.length>0\"><div class=\"col-md-4\">&nbsp;</div><div class=\"col-md-4 btn-danger text-center\">Booked and available to cancel</div><div class=\"col-md-4\">&nbsp;</div></div></div><div class=\"col-md-4\" ng-show=\"apt.calender.slots.length && apt.calender.slots.length>0\"><table class=\"table table-bordered\"><tr><th>Token number &amp; Time of selected tokens for cancellation.</th></tr><tr><td><div ng-repeat=\"chunk in apt.calender._chunked\"><div class=\"text-center\" ng-repeat=\"token in chunk\" ng-if=\"token.cancel\">{{token.token}} - {{token.start_local}}</div></div></td></tr></table><button ng-click=\"apt.cancelBookings()\" class=\"btn btn-primary pull-right\">Cancel Appointment(s)</button></div></div><div ng-if=\"!apt.calender || apt.calender.length===0\" class=\"text-center\"><span ng-hide=\"apt.fresh\">No tokens available. Try seach again.</span></div>");
$templateCache.put("app/apt-book/view.tpl.html","<div class=\"row\"><div class=\"col-md-6\"><h2 class=\"page-title\"><span class=\"\"><img class=\"baby\" src=\"Content/Images/baby1.png\" alt=\"Kiwi standing on oval\"></span> Book Appointment</h2></div><div class=\"col-md-6\"><form style=\"max-width:98%;\"><div class=\"form-group\" style=\"margin-left:20px;\"><div class=\"input-group\"><input id=\"txtPatientSearch\" class=\"form-control\" placeholder=\"Enter Patient Phone Number or MR Number or UHID or Name, press Enter to Search\" autocomplete=\"OFF\" autofocus=\"\" type=\"text\" ng-model=\"Search\" ng-keyup=\"$event.keyCode == 13 && apt.getPatientSearchApt(Search)\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"apt.getPatientSearchApt(Search)\"><span class=\"glyphicon glyphicon-search patient-search\"></span></button></span></div></div></form></div></div><h3>Patient Details</h3><div class=\"row\"><div class=\"col-md-12\" style=\"border-right:solid 3px #ddd;\"><div class=\"table-responsive bg-color\"><table class=\"table table-hover table-bordered\"><thead><tr><th>S No</th><th>Patient Id</th><th>Name</th><th>Gender</th><th>DOB</th><th>Contact#</th><th ng-if=\"apt.selectedRecord\">&nbsp;</th></tr></thead><tbody ng-hide=\"view\"><tr class=\"link\" ng-class=\"{\'active\':Patient.mr_number==apt.selectedRecord.mr_number}\" ng-if=\"!apt.selectedRecord\" ng-repeat=\"Patient in apt.PatientList2| limitTo:20\" ng-click=\"apt.setSelectedRecord(Patient)\"><td>{{count +($index + 1)}}</td><td>{{Patient.mr_number}}</td><td>{{Patient.name_given}}</td><td>{{Patient.gender}}</td><td>{{Patient.bday | date:\'dd-MMM-yyyy\'}}</td><td><span ng-if=\"Patient.father_tel_number !=\'9000000000\'\">{{Patient.father_tel_number}}</span><span ng-if=\"Patient.father_tel_number ==\'9000000000\'\">Not Provided</span></td></tr><tr ng-if=\"!apt.PatientList2\"><td colspan=\"10\">Search Patient</td></tr><tr ng-if=\"apt.selectedRecord\"><td>1</td><td>{{apt.selectedRecord.mr_number}}</td><td>{{apt.selectedRecord.name_given}}</td><td>{{apt.selectedRecord.gender}}</td><td>{{apt.selectedRecord.bday | date:\'dd-MMM-yyyy\'}}</td><td><span ng-if=\"apt.selectedRecord.father_tel_number !=\'9000000000\'\">{{apt.selectedRecord.father_tel_number}}</span> <span ng-if=\"apt.selectedRecord.father_tel_number ==\'9000000000\'\">Not Provided</span></td><td class=\"text-center link\" ng-click=\"apt.selectedRecord=undefined;\"><i class=\"fa fa-times-circle-o\"></i></td></tr><tr ng-if=\"apt.PatientList2.length==0\"><td colspan=\"6\">No results found</td></tr><tr ng-show=\"!apt.PatientList.loaded\"><td colspan=\"10\" class=\"text-center\"><span class=\"fa fa-spinner fa-2x fa-spin\"></span></td></tr></tbody></table></div></div></div><br><wizard hide-indicators=\"true\" on-finish=\"apt.bookAppointment()\" ng-if=\"apt.selectedRecord\"><wz-step wz-title=\"Step 1\"><div class=\"row\"><div class=\"col-md-4\"><h5>Appointment Type</h5><form class=\"form-horizontal\"><div class=\"form-group\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"apt.type\" name=\"radios\" id=\"radios-0\" value=\"consultation\" checked=\"checked\"> Consultation</label> <label class=\"radio-inline\">&nbsp;&nbsp;<input type=\"radio\" ng-model=\"apt.type\" name=\"radios\" id=\"radios-1\" value=\"vaccination\"> Vaccination</label> <label class=\"radio-inline\" ng-if=\"apt.showvoicecall == true\">&nbsp;&nbsp;<input type=\"radio\" ng-model=\"apt.type\" name=\"radios\" id=\"radios-2\" value=\"voice_call\"> Voice call</label> <label class=\"radio-inline\" ng-if=\"apt.showvideocall == true\">&nbsp;&nbsp;<input type=\"radio\" ng-model=\"apt.type\" name=\"radios\" id=\"radios-3\" value=\"video_call\"> Video call</label></div></form></div><div class=\"col-md-2\" ng-if=\"apt.locationStatus == \'1\'\"><h5>Location</h5><form class=\"form-horizontal\"><div class=\"form-group\"><select ng-model=\"apt.location\" class=\"form-control\" required=\"\"><option ng-repeat=\"location in apt.locationList\" value=\"{{location.location}}\">{{location.location}}</option></select></div></form></div><div class=\"col-md-1\"></div><div class=\"col-md-3\"><h5>Choose your appointment date</h5><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"apt.date\" is-open=\"apt.opened\" datepicker-options=\"options\" ng-required=\"true\" close-text=\"Close\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"apt.opened=!apt.opened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><hr><div class=\"clearfix\"><button wz-next=\"apt.getAvailability()\" ng-if=\"apt.locationStatus == \'0\'\" class=\"btn btn-primary\">Next <i class=\"fa fa-long-arrow-right\"></i></button> <button wz-next=\"apt.getAvailability()\" ng-if=\"apt.locationStatus == \'1\' && apt.location\" class=\"btn btn-primary\">Next <i class=\"fa fa-long-arrow-right\"></i></button></div><hr></wz-step><wz-step wz-title=\"Step 3\" canenter=\"apt.canEnterToSelectSlots\"><div ng-if=\"apt.spinner\"><center><span class=\"fa fa-spinner fa-2x fa-spin\"></span></center></div><div ng-if=\"apt.calenderData\"><h3>Select a token</h3><table class=\"table table-bordered\" ng-if=\"apt.type === \'consultation\'\"><tr><th style=\"width:150px;\">&nbsp;</th><th style=\"width:85px;\">Minutes<i class=\"fa fa-long-arrow-right\"></i></th><th ng-repeat=\"slot in apt.calender.slots\">{{slot}}</th></tr><tr ng-repeat=\"chunk in apt.calender._chunked\"><td>{{chunk[0].start_local}} - {{chunk[chunk.length-1].start_local}}</td><td>{{chunk[0].token}} - {{chunk[chunk.length-1].token}}</td><td ng-repeat=\"token in chunk\" ng-class=\"{\'btn-danger\':!token.available && !token.dummy, \'btn-success\':token.available && !token.isSelected && token.allow_click!==false && token.location_match!==false && !token.dummy, \'btn-primary\':token.isSelected && !token.dummy && token.available, \'custom-bg-color\': token.allow_click===false && !token.isSelected && token.available && !token.dummy}\" ng-click=\"apt.selectToken(token)\">{{((token.dummy===true)?\"\":token.token)}}</td></tr></table><table class=\"table table-bordered\" ng-if=\"apt.type === \'vaccination\'\"><tr><th style=\"width:150px;\">&nbsp;</th><th style=\"width:85px;\">Minutes<i class=\"fa fa-long-arrow-right\"></i></th><th ng-repeat=\"slot in apt.calender.slots\">{{slot}}</th></tr><tr ng-repeat=\"chunk in apt.calender._chunked\"><td>{{chunk[0].start_local}} - {{chunk[chunk.length-1].start_local}}</td><td>{{chunk[0].token}} - {{chunk[chunk.length-1].token}}</td><td ng-repeat=\"token in chunk\" ng-class=\"{\'btn-danger\':!token.available && !token.dummy, \'btn-success\':token.available && !token.isSelected && token.allow_click!==false && token.location_match!==false && !token.dummy, \'btn-primary\':token.isSelected && !token.dummy && token.available, \'custom-bg-color\': token.allow_click===false && !token.isSelected && token.available && !token.dummy}\" ng-click=\"apt.selectToken(token)\">{{((token.dummy===true)?\"\":token.token)}}</td></tr></table><table class=\"table table-bordered\" ng-if=\"apt.type === \'voice_call\'\"><tr><th style=\"width:150px;\">&nbsp;</th><th style=\"width:85px;\">Minutes<i class=\"fa fa-long-arrow-right\"></i></th><th ng-repeat=\"slot in apt.calender.slots\">{{slot}}</th></tr><tr ng-repeat=\"chunk in apt.calender._chunked\"><td>{{chunk[0].start_local}} - {{chunk[chunk.length-1].start_local}}</td><td>{{chunk[0].token}} - {{chunk[chunk.length-1].token}}</td><td ng-repeat=\"token in chunk\" ng-class=\"{\'btn-danger\':!token.available && !token.dummy, \'btn-success\':token.available && !token.isSelected && token.allow_click!==false && token.location_match!==false && !token.dummy, \'btn-primary\':token.isSelected && !token.dummy && token.available, \'custom-bg-color\': token.allow_click===false && !token.isSelected && token.available && !token.dummy}\" ng-click=\"apt.selectToken(token)\">{{((token.dummy===true)?\"\":token.token)}}</td></tr></table><table class=\"table table-bordered\" ng-if=\"apt.type === \'video_call\'\"><tr><th style=\"width:150px;\">&nbsp;</th><th style=\"width:85px;\">Minutes<i class=\"fa fa-long-arrow-right\"></i></th><th ng-repeat=\"slot in apt.calender.slots\">{{slot}}</th></tr><tr ng-repeat=\"chunk in apt.calender._chunked\"><td>{{chunk[0].start_local}} - {{chunk[chunk.length-1].start_local}}</td><td>{{chunk[0].token}} - {{chunk[chunk.length-1].token}}</td><td ng-repeat=\"token in chunk\" ng-class=\"{\'btn-danger\':!token.available && !token.dummy, \'btn-success\':token.available && !token.isSelected && token.allow_click!==false && token.location_match!==false && !token.dummy, \'btn-primary\':token.isSelected && !token.dummy && token.available, \'custom-bg-color\': token.allow_click===false && !token.isSelected && token.available && !token.dummy}\" ng-click=\"apt.selectToken(token)\">{{((token.dummy===true)?\"\":token.token)}}</td></tr></table><div class=\"row\"><div class=\"col-md-5\">&nbsp;</div><div class=\"col-md-1 btn-danger\">Booked</div><div class=\"col-md-1 btn-success\">Available</div><div class=\"col-md-1 btn-primary\">Selected</div><div class=\"col-md-4\">&nbsp;</div></div><hr><div class=\"clearfix\"><button wz-previous=\"\" class=\"btn btn-secondary\" ng-click=\"apt.clearSelected();\"><i class=\"fa fa-long-arrow-left\"></i> Back</button> <button wz-next=\"\" class=\"btn btn-primary\">Next <i class=\"fa fa-long-arrow-right\"></i></button> <button wz-cancel=\"\" class=\"btn btn-default\" ng-click=\"apt.clearSelected();\">Cancel</button></div><hr></div></wz-step><wz-step wz-title=\"Step 4\" canenter=\"apt.canEnterToConfirm\"><h3>Please read the below details and confirm</h3><div class=\"bg-info\" style=\"padding: 30px;\"><p>You have selected token number {{apt.selectedToken.token}} for {{apt.showtype}} appointment on {{apt.selectedToken.start|date:\'dd-MMM-yyyy @ \'}} {{apt.selectedToken.start_local}} Hours at {{apt.location}}</p><p>For patient {{apt.selectedRecord.mr_number}} : {{apt.selectedRecord.name_given}}</p><p ng-if=\"apt.type===\'vaccination\'\">You have selected {{apt.vaccine}} vaccine.</p></div><hr><div class=\"clearfix\"><button wz-previous=\"\" class=\"btn btn-secondary\"><i class=\"fa fa-long-arrow-left\"></i> Back</button> <button wz-next=\"\" class=\"btn btn-primary\">Confirm</button> <button wz-cancel=\"\" class=\"btn btn-default\">Cancel</button></div><hr></wz-step></wizard>");
$templateCache.put("app/apt-config/_form_sessions.tpl.html","<style>\n    .error {\nborder-color: red;\n}\n</style><form id=\"apptConfig\" name=\"apptConfig\" class=\"form-horizontal\" style=\"padding: 40px;\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Average time for <strong style=\"font-weight: bold; color: black;\">In-Person consultation (MM:SS)</strong></label><div class=\"col-sm-2\"><select ng-model=\"config.settings.avg_time_per_patient\" class=\"form-control\" ng-options=\"option for option in config.avgTime\" ng-disabled=\"!config.reconfig\" ng-change=\"config.avgTimeChanged(config.sessions);\" required=\"\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Average time for <strong style=\"font-weight: bolder; color: black;\">Tele consultation (Voice/Video) (MM:SS)</strong></label><div class=\"col-sm-2\"><select ng-model=\"config.settings.avg_time_per_patient_tele\" class=\"form-control\" ng-options=\"option for option in config.avgTime\" ng-disabled=\"!config.reconfig\" ng-change=\"config.avgTimeChanged(config.sessions);\" required=\"\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Appointment by :</label><div class=\"col-sm-8\"><p class=\"form-control-static\">Token number</p></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">You have appointments booked till :</label><div class=\"col-sm-8\"><p class=\"form-control-static\">{{config.aptSettings.last_appointment | date:\'dd-MMM-yyyy\'}}</p></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Emergency call allowed :</label><div class=\"col-md-4\"><label><input type=\"checkbox\" ng-model=\"config.settings.emergency_call\" ng-change=\"config.settings.emergency_call?true:false\" ng-disabled=\"!config.reconfig\">&nbsp;&nbsp;Yes</label></div></div><table class=\"table table-bordered\" ng-if=\"config.sessions.length > 0\"><thead><tr><th>Session</th><th>Start time</th><th>End time</th><th ng-if=\"config.locationStatus == \'1\'\">Location</th><th>Online<img style=\"float: right;margin-top: 3px;margin-right: 3px;cursor: pointer;\" src=\"Content/Images/helpiconreconfigurelite.svg\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"This accounts for the inPerson Slots available only for My+Health Mobile app\"></th><th>Web<img style=\"float: right;margin-top: 3px;margin-right: 3px;cursor: pointer;\" src=\"Content/Images/helpiconreconfigurelite.svg\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"This accounts for the inPerson Slots available only for Online Booking Site\"></th><th>IVRS<img style=\"float: right;margin-top: 3px;margin-right: 3px;cursor: pointer;\" src=\"Content/Images/helpiconreconfigurelite.svg\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"This accounts both inPerson and Tele-Consultation available for IVRS\"></th><th>Tele<img style=\"float: right;margin-top: 3px;margin-right: 3px;cursor: pointer;\" src=\"Content/Images/helpiconreconfigurelite.svg\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"This accounts only the Tele-Consultation Slots available for My+Health and Online Booking Site\"></th><th>Walk-in<img style=\"float: right;margin-top: 3px;margin-right: 3px;cursor: pointer;\" src=\"Content/Images/helpiconreconfigurelite.svg\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Only available for ECEnabler and EPICare direct hospital/clinic walk-in patients\"></th><th>Mon</th><th>Tue</th><th>Wed</th><th>Thu</th><th>Fri</th><th>Sat</th><th>Sun</th><th ng-if=\"config.reconfig\">&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"session in config.sessions track by $index\"><td>Session {{$index+1}}</td><td><select ng-model=\"session.start_time\" id=\"start_{{$index}}\" class=\"form-control\" ng-options=\"option for option in config.hrs\" ng-disabled=\"!config.reconfig\" ng-change=\"config.timeChanged(session,\'startTime\',$index);\"></select></td><td><select ng-model=\"session.end_time\" id=\"end_{{$index}}\" class=\"form-control\" ng-options=\"option disable when session.start_time.selected for option in config.hrs\" ng-disabled=\"!config.reconfig\" ng-change=\"config.timeChanged(session,\'endTime\',$index);\"></select></td><td ng-if=\"config.locationStatus == \'1\'\"><select ng-model=\"session.location\" class=\"form-control\" required=\"\" ng-options=\"option for option in config.locationList\" ng-disabled=\"!config.reconfig\"></select></td><td class=\"col-md-1\"><input type=\"number\" onkeypress=\"return event.charCode >= 37 && event.charCode <= 39\" min=\"0\" max=\"{{session.total}}\" ng-change=\"config.changeOnline(session);\" ng-model=\"session.online\" ng-disabled=\"!config.reconfig\" placeholder=\"online appointments\" class=\"form-control input-md\"></td><td class=\"col-md-1\"><input type=\"number\" onkeypress=\"return event.charCode >= 37 && event.charCode <= 39\" min=\"0\" max=\"{{session.total}}\" ng-change=\"config.changeWeb(session);\" ng-model=\"session.web\" ng-disabled=\"!config.reconfig\" placeholder=\"web appointments\" class=\"form-control input-md\"></td><td class=\"col-md-1\"><input type=\"number\" onkeypress=\"return event.charCode >= 37 && event.charCode <= 39\" min=\"0\" max=\"{{session.total}}\" ng-change=\"config.changeIvrs(session);\" ng-model=\"session.ivrs\" ng-disabled=\"!config.reconfig\" placeholder=\"ivrs appointments\" class=\"form-control input-md\"></td><td class=\"col-md-1\"><input type=\"number\" onkeypress=\"return event.charCode >= 37 && event.charCode <= 39\" min=\"0\" max=\"{{session.teleMax}}\" ng-change=\"config.changeTele(session);\" ng-model=\"session.tele\" ng-disabled=\"!config.reconfig\" placeholder=\"tele appointments\" class=\"form-control input-md\"></td><td class=\"col-md-1\"><input type=\"number\" min=\"0\" max=\"60\" ng-model=\"session.offline\" disabled=\"\" placeholder=\"offline appointments\" class=\"form-control input-md\"></td><td><input type=\"checkbox\" class=\"mgc mgc-primary mgc-lg\" ng-model=\"session.days.mon\" ng-disabled=\"!config.reconfig\"></td><td><input type=\"checkbox\" class=\"mgc mgc-primary mgc-lg\" ng-model=\"session.days.tue\" ng-disabled=\"!config.reconfig\"></td><td><input type=\"checkbox\" class=\"mgc mgc-primary mgc-lg\" ng-model=\"session.days.wed\" ng-disabled=\"!config.reconfig\"></td><td><input type=\"checkbox\" class=\"mgc mgc-primary mgc-lg\" ng-model=\"session.days.thu\" ng-disabled=\"!config.reconfig\"></td><td><input type=\"checkbox\" class=\"mgc mgc-primary mgc-lg\" ng-model=\"session.days.fri\" ng-disabled=\"!config.reconfig\"></td><td><input type=\"checkbox\" class=\"mgc mgc-primary mgc-lg\" ng-model=\"session.days.sat\" ng-disabled=\"!config.reconfig\"></td><td><input type=\"checkbox\" class=\"mgc mgc-primary mgc-lg\" ng-model=\"session.days.sun\" ng-disabled=\"!config.reconfig\"></td><td ng-if=\"config.reconfig\"><a ng-click=\"config.manageSession(\'remove\',$index)\" ng-if=\"config.sessions.length > 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></a> <a ng-click=\"config.manageSession(\'add\',$index+1)\" ng-if=\"($index+1)==config.sessions.length\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div class=\"alert alert-dismissible alert-warning\" ng-disabled=\"!config.reconfig\" ng-if=\"config.reconfig && config.locationStatus == \'1\'\"><h4>Note <i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i></h4><p>If location has not choosen then the session is not considered</p></div></form>");
$templateCache.put("app/apt-config/alertmessage.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-2 col-lg-2\"><img src=\"Content/Images/add.svg\" height=\"50px\" width=\"50px\" alt=\"addslot\"></div><div class=\"col-md-10 col-lg-10\"><span>Dr, For the session time you can add one more slot either in<br>Tele-consultation or in others.</span></div></div></div>");
$templateCache.put("app/apt-config/newPlan.html","<style>\n    .actcolor {\n        color: #258e25;\n    }\n\n    .deactcolor {\n        color: #cc0000;\n    }\n\n    .switch {\n        position: relative;\n        display: inline-block;\n        width: 60px;\n        height: 34px;\n    }\n\n    .switch input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    .slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #cc0000;\n        -webkit-transition: .4s;\n        transition: .4s;\n    }\n\n    .slider:before {\n        position: absolute;\n        content: \"\";\n        height: 26px;\n        width: 26px;\n        left: 4px;\n        bottom: 4px;\n        background-color: white;\n        -webkit-transition: .4s;\n        transition: .4s;\n    }\n\n    input:checked+.slider {\n        background-color: #258e25;\n    }\n\n\n    input:focus+.slider {\n        box-shadow: 0 0 1px #258e25;\n    }\n\n\n    input:checked+.slider:before {\n        -webkit-transform: translateX(26px);\n        -ms-transform: translateX(26px);\n        transform: translateX(26px);\n    }\n\n    /* Rounded sliders */\n    .slider.round {\n        border-radius: 34px;\n    }\n\n    .slider.round:before {\n        border-radius: 50%;\n    }\n</style><div class=\"row\"><div class=\"col-md-3\">Date <span style=\"color: red;\">*</span></div><div class=\"col-md-3\"><div class=\"input-group form-group\" style=\"width: 150px !important;\"><input type=\"text\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"apt.opened\" onkeydown=\"return event.keyCode == 37\" datepicker-options=\"{maxDate: maxDate, minDate: minDate}\" class=\"form-control\" required=\"\" ng-model=\"addData.date\" min-date=\"datepicker.minDate\" placeholder=\"Start Date\" style=\"padding-left: 15px;\"> <label for=\"txtdob1\" ng-click=\"apt.opened=!apt.opened\" class=\"input-group-addon link\"><span class=\"fa fa-calendar\"></span></label></div></div><div class=\"col-md-2\">To</div><div class=\"col-md-3\"><div class=\"input-group form-group\" style=\"width: 150px !important;\"><input type=\"text\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"apt.opened1\" onkeydown=\"return event.keyCode == 37\" datepicker-options=\"{minDate: addData.date}\" class=\"form-control\" ng-model=\"addData.todate\" placeholder=\"End Date\" style=\"padding-left: 15px;\"> <label for=\"txtdob2\" ng-click=\"apt.opened1=!apt.opened1\" class=\"input-group-addon link\"><span class=\"fa fa-calendar\"></span></label></div></div></div><div class=\"row\"><div class=\"col-md-3\">Start Time <span style=\"color:red;\">*</span></div><div class=\"col-md-2\"><select class=\"form-control\" ng-model=\"timeData.startTime\" ng-options=\"option for option in times\" ng-change=\"changed();\"></select></div><div class=\"col-md-1\"></div><div class=\"col-md-2\">End Time <span style=\"color: red;\">*</span></div><div class=\"col-md-2\"><select class=\"form-control\" ng-model=\"timeData.endTime\" ng-options=\"option for option in times\" ng-change=\"changed();\"></select></div><div class=\"col-md-2\" ng-if=\"showTimeRangeError==\'true\'\" style=\"padding-top: 6px; margin-left: -20px;\"><span style=\"color: red;\">Invalid time range</span></div></div><div class=\"row\" style=\"padding-top: 20px;\" ng-if=\"showCreate\"><div class=\"col-md-3\">Sms to be sent to Patients</div><div class=\"col-md-2\"><label class=\"switch\"><input type=\"checkbox\" ng-model=\"holidaysmsvalue\" ng-init=\"holidaysmsvalue = false\" ng-change=\"toggleholidaysms()\"> <span class=\"slider round\" id=\"slider\"></span></label></div><div class=\"col-md-1\"></div><div ng-if=\"holidaysmsvalue == true\"><div class=\"col-md-2\">Patient Visited <span style=\"color: red;\">*</span></div><div class=\"col-md-3\"><select class=\"form-control\" style=\"width: 125px;\" ng-model=\"addData.patientduration\" required=\"\"><option value=\"\" disabled=\"\">Select</option><option value=\"1\">Last 1 Month</option><option value=\"3\">Last 3 Months</option><option value=\"6\">Last 6 Months</option><option value=\"0\">All Patients</option></select></div></div></div><div class=\"row\" style=\"padding-top: 20px;\"><div class=\"col-md-3\">Reason <span style=\"color: red;\">*</span></div><div class=\"col-md-5\"><textarea required=\"\" class=\"form-control\" ng-model=\"addData.reason\" name=\"\" id=\"\" placeholder=\"Reason\"></textarea></div></div><br><div class=\"row\"><div class=\"col-md-3\">Notes</div><div class=\"col-md-5\"><textarea class=\"form-control\" ng-model=\"addData.notes\" name=\"\" id=\"\" placeholder=\"Notes\"></textarea></div></div>");
$templateCache.put("app/apt-config/plan.html","<h4><i class=\"fa fa-th\"></i> Holiday / Busy Plan<button class=\"btn btn-link\" ng-click=\"addNew(\'create\',\' \')\" style=\"margin-right:0px !Important;\"><span class=\"fa-stack fa-lg\"><i class=\"fa fa-circle fa-stack-2x\"></i> <i class=\"fa fa-plus fa-stack-1x fa-inverse\"></i></span></button></h4><table class=\"table table-bordered\"><thead><tr><th>SNo</th><th>Start Date</th><th>Start Time</th><th>End Date</th><th>End Time</th><th>Reason</th><th>Notes</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"plan in holidayList | orderBy: \'-start_time\'\"><td>{{$index+1}}</td><td>{{plan.start_time | date: \'dd-MMM-yyyy\'}}</td><td>{{plan.start_time | date: \'HH:mm\'}}</td><td>{{plan.end_time | date: \'dd-MMM-yyyy\'}}</td><td>{{plan.end_time | date: \'HH:mm\'}}</td><td>{{plan.reason}}</td><td>{{plan.notes}}</td><td><center><i class=\"fa fa-pencil link\" ng-click=\"addNew(\'update\',plan)\" ng-if=\"plan.showEdit\"></i> &nbsp;&nbsp; <i class=\"fa fa-trash link\" ng-click=\"deletePlan(plan)\" ng-if=\"plan.showEdit\"></i></center></td></tr><tr ng-if=\"holidayList.length == 0\"><td colspan=\"7\">No Plans found</td></tr></tbody></table>");
$templateCache.put("app/apt-config/view.tpl.html","<style>\n    .info {\n        background-color: #e7f3fe;\n        border-left: 6px solid #2196F3;\n        font-size: 20px;\n        /* color: skyblue; */\n        padding: 4px 12px;\n    }\n\n    .remdaysred{\n        color: red;\n    }\n    .remdaysblue{\n        color: skyblue;\n    }\n</style><h3><span class=\"fa fa-cogs\"></span> Appointment Configuration</h3><div class=\"row pull-right\"><button ng-if=\"config.sessions.length > 0\" class=\"btn btn-primary\" ng-click=\"config.changepath()\">Holiday / Busy Plan</button></div><br><div style=\"margin-top: 30px;\"><div class=\"row info\"><p><strong style=\"color:blue;\">Alert !</strong><br><span ng-class=\"{\'remdaysred\' : config.showredalert === true ,\'remdaysblue\' : config.showredalert === false}\">Last Appointment Configuration Date: {{config.configureddate}}</span><br><span ng-class=\"{\'remdaysred\' : config.showredalert === true ,\'remdaysblue\' : config.showredalert === false}\">Next Reconfiguration Due in: {{config.remdays}}</span></p></div></div><wizard hide-indicators=\"true\"><wz-step wz-title=\"View schedule\"><div ng-show=\"!config.loaded\"><center><span class=\"fa fa-spinner fa-2x fa-spin\"></span></center></div><ng-include ng-show=\"config.loaded && config.sessions.length > 0\" src=\"\'app/apt-config/_form_sessions.tpl.html\'\"></ng-include><div style=\"padding-bottom: 80px;\"><button ng-if=\"config.sessions.length > 0\" ng-click=\"config.reconfigConsent()\" class=\"btn btn-primary pull-right\">Reconfigure</button> <button ng-if=\"config.sessions.length < 1\" wz-next=\"config.manageSession(\'add\',1)\" class=\"btn btn-primary pull-right\">Configure now</button></div></wz-step><wz-step wz-title=\"Update schedule\" canenter=\"apt.hasReconfigConsent()\"><ng-include src=\"\'app/apt-config/_form_sessions.tpl.html\'\"></ng-include><div class=\"pull-right\" style=\"padding-bottom: 80px;\"><button wz-previous=\"config.getSchedule()\" ng-click=\"config.redirectLocation()\" class=\"btn btn-default\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"config.saveStep1()\">Save</button></div></wz-step></wizard><br ng-if=\"config.bottomnote == true\"><br ng-if=\"config.bottomnote == true\"><br ng-if=\"config.bottomnote == true\"><div class=\"info\" style=\"margin-bottom: 4vh;\"><p style=\"color: skyblue;\"><strong style=\"color:blue;\">Note !</strong><br>Appointment configurations will be automatically configured for the Next 30 Days automatically<br>Once in 7 days, it will be rescheduled for the next 30 days</p></div>");
$templateCache.put("app/baby-profile/baby-details.tpl.html","<h2 class=\"page-title\">Patient Details</h2><div class=\"row\"><div class=\"col-md-12 tabset\"><uib-tabset type=\"pills\"><uib-tab heading=\"Mothers Antenatal Record\"><div ng-include=\"\'app/baby-profile/mother.tpl.html\'\"></div></uib-tab><uib-tab heading=\"Baby History\"><div ng-include=\"\'app/baby-profile/history.tpl.html\'\"></div></uib-tab><uib-tab heading=\"Family History\"><div ng-include=\"\'app/baby-profile/fam-history.tpl.html\'\"></div></uib-tab><uib-tab heading=\"Social History\"><div ng-include=\"\'app/baby-profile/soc-history.tpl.html\'\"></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("app/baby-profile/basic.tpl.html","<div class=\"row\"><div class=\"col-md-6 text-left\"></div><div class=\"col-md-6\"><br><button ng-show=\"vm.mode_basic!=\'edit\'\" ng-click=\"vm.mode_basic=\'edit\';\" class=\"btn btn-primary\"><i class=\"fa fa-pencil-square\">Update</i></button> <button ng-show=\"vm.mode_basic==\'edit\'\" ng-click=\"vm.updateProfile();\" class=\"btn btn-primary\"><i class=\"fa fa-save\">Save</i></button> <button ng-show=\"vm.mode_basic==\'edit\'\" ng-click=\"vm.mode_basic=\'view\';vm.clearForm(\'basic\');\" class=\"btn btn-danger\"><i class=\"fa fa-close\">Cancel</i></button></div></div><br><div class=\"panel panel-primary\"><div class=\"panel-body\"><div ng-show=\"vm.mode_basic==\'edit\'\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"row\"><div class=\"col-xs-8\" flow-init=\"{singleFile:true}\" flow-name=\"flowUpload\" flow-file-added=\"vm.uploadFile($file, $event, $flow)\"><div class=\"thumbnail\" style=\"margin:0px;\"><div class=\"pull-right\"><i ng-show=\"vm.mode_basic==\'edit\'\" tooltip=\"Upload photo\" class=\"fa fa-camera cursor text-primary flow-container link\" flow-btn=\"\" flow-attrs=\"{accept:\'image/*\'}\"></i></div><div class=\"clearfix\"></div><div><a><img ng-show=\"!vm.basic.image || vm.basic.image==\'No profile picture\'\" ng-src=\"{{vm.basic.childInfo.gender==\'female\' && \'Content/Images/users/avatar-female.png\'||\'Content/Images/users/avatar-male.png\'}}\"> <img ng-if=\"vm.basic.image && vm.basic.image!=\'No profile picture\'\" ng-src=\"{{vm.helyxonApiUrl}}cloud/image/upload/{{vm.basic.image}}\" style=\"max-height: 105px; max-width:125px;\"></a></div><div class=\"clearfix\"></div></div></div></div></div><div class=\"col-md-9\" style=\"margin-bottom:20px;\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-6 form-group\"><label for=\"txtFirstName\">First Name<span class=\"text-danger\">*</span></label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" autofocus=\"\" class=\"form-control\" id=\"RegisterName\" ng-model=\"vm.basic.childInfo.firstName\" placeholder=\"Child\'s First Name\" maxlength=\"50\" required=\"\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtLastName\">Last Name<span class=\"text-danger\">*</span></label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"inputTextBox\" ng-model=\"vm.basic.childInfo.lastName\" placeholder=\"Child\'s Last Name\" required=\"\" maxlength=\"50\"></div><div class=\"col-sm-6 form-group\"><label>Gender<span class=\"text-danger\">*</span></label> <span style=\"color: #f10a06;font-size: 16px;\"></span> <label class=\"radio-inline\"><input type=\"radio\" ng-disabled=\"vm.mode_basic!=\'edit\'\" name=\"rbGender\" ng-model=\"vm.basic.childInfo.gender\" value=\"male\" checked=\"checked\" radio-tabbable=\"\" required=\"\"> Male</label> <label class=\"radio-inline\"><input type=\"radio\" ng-disabled=\"vm.mode_basic!=\'edit\'\" name=\"rbGender\" ng-model=\"vm.basic.childInfo.gender\" value=\"female\" radio-tabbable=\"\" required=\"\"> Female</label></div><div class=\"col-sm-6 form-group dob\"><label for=\"txtdob\">Date of Birth (dd/mm/yyyy) <span class=\"text-danger\">*</span></label><div class=\"input-group form-group\"><input id=\"txtdob\" type=\"text\" class=\"form-control\" ng-disabled=\"vm.mode_basic!=\'edit\'\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.basic.childInfo.dob\" is-open=\"vm.basic.opened\" datepicker-options=\"vm.childDatePicker.dateOptions\" close-text=\"Close\" onkeydown=\"return false\" placeholder=\"Date of Birth\" required=\"\"><div class=\"input-group-addon link\" ng-click=\"vm.basic.opened=!vm.basic.opened\"><i class=\"fa fa-calendar\"></i></div></div></div><div class=\"col-sm-6 form-group\"><label>Blood Group</label><br><select ng-disabled=\"vm.mode_basic!=\'edit\'\" ng-model=\"vm.basic.childInfo.bloodGroup\" class=\"form-control\" ng-options=\"option for option in vm.bloodGroups\"><option value=\"\" disabled=\"\" selected=\"\">Select a blood group</option></select></div><div class=\"col-sm-6 form-group dob1\"><label for=\"txtdob1\">Expected Birth (dd/mm/yyyy)</label><div class=\"input-group form-group\"><input id=\"txtdob1\" type=\"text\" class=\"form-control\" ng-disabled=\"vm.mode_basic!=\'edit\'\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.basic.childInfo.dob1\" is-open=\"vm.basic.opened3\" datepicker-options=\"vm.childDatePicker.dateOptions\" close-text=\"Close\" onkeydown=\"return false\" placeholder=\"Date of Birth\" datepicker-timezone=\"\"><div class=\"input-group-addon link\" ng-click=\"vm.basic.opened3=!vm.basic.opened3\"><i class=\"fa fa-calendar\"></i></div></div></div><div class=\"col-sm-6 form-group\"><label for=\"txtBirthWeight\">Birth Weight &nbsp;(kg)</label> <input type=\"number\" ng-disabled=\"vm.mode_basic!=\'edit\'\" autofocus=\"\" class=\"form-control\" ng-model=\"vm.basic.childInfo.birthWeight\" placeholder=\"Child\'s Birth Weight\" maxlength=\"50\" required=\"\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtBirthHeight\">Birth Height &nbsp;(cm)</label> <input type=\"number\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" ng-model=\"vm.basic.childInfo.birthHeight\" placeholder=\"Child\'s Birth Height\" required=\"\" maxlength=\"50\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtFatherFirstName\">Father\'s First Name</label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"txtFatherFirstName\" ng-model=\"vm.basic.fatherInfo.firstName\" placeholder=\"Father\'s First Name\" maxlength=\"50\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtFatherLastName\">Father\'s Last Name</label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"txtFatherLastName\" ng-model=\"vm.basic.fatherInfo.lastName\" placeholder=\"Father\'s Last Name\" maxlength=\"50\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtMotherFirstName\">Mother\'s First Name</label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"txtMotherFirstName\" ng-model=\"vm.basic.motherInfo.firstName\" placeholder=\"Mother\'s First Name\" maxlength=\"50\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtMotherLastName\">Mother\'s Last Name</label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"txtMotherLastName\" ng-model=\"vm.basic.motherInfo.lastName\" placeholder=\"Mother\'s Last Name\" maxlength=\"50\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtFatherFirstName\">Father DOB</label><div class=\"input-group form-group\"><input id=\"txtFatherFirstName\" type=\"text\" class=\"form-control\" ng-disabled=\"vm.mode_basic!=\'edit\'\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.basic.fatherInfo.dob\" is-open=\"vm.basic.opened1\" datepicker-options=\"vm.childDatePicker.dateOptions\" close-text=\"Close\" onkeydown=\"return false\" placeholder=\"Date of Birth\" required=\"\" datepicker-timezone=\"\"><div class=\"input-group-addon link\" ng-click=\"vm.basic.opened1=!vm.basic.opened1\"><i class=\"fa fa-calendar\"></i></div></div></div><div class=\"col-sm-6 form-group\"><label for=\"txtMotherFirstName\">Mother DOB</label><div class=\"input-group form-group\"><input id=\"txtMotherFirstName\" type=\"text\" class=\"form-control\" ng-disabled=\"vm.mode_basic!=\'edit\'\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.basic.motherInfo.dob\" is-open=\"vm.basic.opened2\" datepicker-options=\"vm.childDatePicker.dateOptions\" close-text=\"Close\" onkeydown=\"return false\" placeholder=\"Date of Birth\" required=\"\" datepicker-timezone=\"\"><div class=\"input-group-addon link\" ng-click=\"vm.basic.opened2=!vm.basic.opened2\"><i class=\"fa fa-calendar\"></i></div></div></div><div class=\"col-sm-6 form-group\"><label for=\"txtFatherPhone\">Phone<span class=\"text-danger\">*</span></label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"txtFatherPhone\" ng-minlength=\"10\" numbers-only=\"\" ng-model=\"vm.basic.fatherInfo.phone\" placeholder=\"Phone\" maxlength=\"10\" required=\"\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtMotherPhone\">Alternate Phone</label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"txtMotherPhone\" ng-minlength=\"10\" numbers-only=\"\" ng-model=\"vm.basic.motherInfo.phone\" placeholder=\"Phone\" maxlength=\"10\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtAddress\">Address</label> <input type=\"text\" class=\"form-control\" id=\"txtStreet\" ng-model=\"vm.basic.address.street\" ng-pattern=\"word\" placeholder=\"Street\" maxlength=\"200\"><br><input type=\"text\" class=\"form-control\" id=\"txtRegion\" ng-model=\"vm.basic.address.region\" ng-pattern=\"word\" placeholder=\"Region\" maxlength=\"200\"><br><input type=\"text\" class=\"form-control\" id=\"txtPostal\" ng-model=\"vm.basic.address.postalcode\" ng-pattern=\"number\" numbers-only=\"\" placeholder=\"Postal Code\" maxlength=\"6\"><br><input type=\"text\" class=\"form-control\" id=\"txtCity\" ng-model=\"vm.basic.address.city\" ng-pattern=\"word\" placeholder=\"City\" maxlength=\"200\"><br><input type=\"text\" class=\"form-control\" id=\"txtCountry\" ng-model=\"vm.basic.address.country\" ng-pattern=\"word\" placeholder=\"Country\" maxlength=\"200\"></div><div class=\"col-sm-6 form-group\"><label for=\"txtFatherEmail\">Email</label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"txtEmail\" ng-model=\"vm.basic.fatherInfo.email\" ng-pattern=\"word\" placeholder=\"Email\" maxlength=\"200\"><br><label for=\"txtUHID\">UHID</label> <input type=\"text\" ng-disabled=\"vm.mode_basic!=\'edit\'\" class=\"form-control\" id=\"inputTextBox\" ng-model=\"vm.basic.childInfo.uhid\" placeholder=\"UHID\" maxlength=\"25\"></div></div></div></div></div></div></div></div><div ng-show=\"vm.mode_basic!=\'edit\'\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"row\"><div class=\"col-xs-8\" flow-init=\"{singleFile:true}\" flow-name=\"flowUpload\" flow-file-added=\"vm.uploadFile($file, $event, $flow)\"><div class=\"thumbnail\" style=\"margin:0px;\"><div class=\"pull-right\"><i ng-show=\"vm.mode_basic==\'edit\'\" tooltip=\"Upload photo\" class=\"fa fa-camera cursor text-primary flow-container link\" flow-btn=\"\" flow-attrs=\"{accept:\'image/*\'}\"></i></div><div class=\"clearfix\"></div><div><a><img ng-show=\"!vm.basic.image || vm.basic.image==\'No profile picture\'\" ng-src=\"{{vm.basic.childInfo.gender==\'female\' && \'Content/Images/users/avatar-female.png\'||\'Content/Images/users/avatar-male.png\'}}\"> <img ng-if=\"vm.basic.image && vm.basic.image!=\'No profile picture\'\" ng-src=\"{{vm.helyxonApiUrl}}cloud/image/upload/{{vm.basic.image}}\" style=\"max-height: 105px; max-width:125px;\"></a></div><div class=\"clearfix\"></div></div></div></div></div><div class=\"col-md-9\" style=\"margin-bottom:20px;\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtFirstName\">Name<span class=\"text-danger\">*</span></label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.childInfo.firstName | capitalize}}</label> <label for=\"\">{{vm.basic.childInfo.lastName | capitalize}}</label></div></div><br><div class=\"row\" style=\"height:40px;\" ng-if=\"vm.basic.childInfo.uhid\"><div class=\"col-md-3\"><label>UHID</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.childInfo.uhid | capitalize}}</label></div></div><div class=\"row\"><div class=\"col-md-3\"><label>Gender<span class=\"text-danger\">*</span></label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.childInfo.gender | capitalize}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtdob\">Date of Birth<span class=\"text-danger\">*</span></label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.childInfo.dob | date:\'dd-MMM-yyyy\'}}</label></div></div><br><div class=\"row\" style=\"height:40px;\" ng-if=\"vm.basic.childInfo.dob1 != null\"><div class=\"col-md-3\"><label for=\"txtdob1\">Expected Birth<span class=\"text-danger\">*</span></label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.childInfo.dob1 | date:\'dd-MMM-yyyy\'}}</label></div></div><div class=\"row\"><div class=\"col-md-3\"><label>Blood Group</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.childInfo.bloodGroup}}</label></div></div><br><div class=\"row\" style=\"height:40px;\"><div class=\"col-md-3\"><label>Birth Weight</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.childInfo.birthWeight}} &nbsp;kg</label></div></div><div class=\"row\"><div class=\"col-md-3\"><label>Birth Height</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.childInfo.birthHeight}} &nbsp;cm</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtFatherFirstName\">Father\'s First Name</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.fatherInfo.firstName | capitalize}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtFatherFirstName\">Father\'s Last Name</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.fatherInfo.lastName | capitalize}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtFatherFirstName\">Father DOB</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.fatherInfo.dob | date:\'dd-MMM-yyyy\'}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtMotherFirstName\">Mother\'s First Name</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.motherInfo.firstName | capitalize}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtMotherFirstName\">Mother\'s Last Name</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.motherInfo.lastName | capitalize}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtMotherFirstName\">Mother DOB</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.motherInfo.dob | date:\'dd-MMM-yyyy\'}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtFatherPhone\">Phone<span class=\"text-danger\">*</span></label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.fatherInfo.phone}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtMotherPhone\">Alternate Phone</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.motherInfo.phone}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtFatherEmail\">Email</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.fatherInfo.email}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtAddress\">Address</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.address.street | capitalize}} {{vm.basic.address.region | capitalize}} {{vm.basic.address.postalcode}} {{vm.basic.address.city | capitalize}} {{vm.basic.address.country | capitalize}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtMotherPhone\">Alternate Phone</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.motherInfo.phone}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtPicmeBaby\">PICME No</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.picme_baby}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtDistrictId\">District Id</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.district_id}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtBlockId\">Block Id</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.block_id}}</label></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label for=\"txtVillageId\">Village Id</label></div><div class=\"col-md-4\"><label for=\"\">{{vm.basic.village_id}}</label></div></div><br></div></div></div></div></div></div></div></div><br><br><br>");
$templateCache.put("app/baby-profile/fam_history.tpl.html","<br><div class=\"row\"><div class=\"col-md-6 text-left\"></div></div><div class=\"row link\" style=\"padding-bottom: 40px;\"><div class=\"col-sm-11\"><div class=\"panel-group\" id=\"accordion2\"><div class=\"panel panel-primary\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-parent=\"#accordion2\" data-target=\"#parentshistory\"><h4 class=\"panel-title\"><span class=\"collapsed\">Parents</span></h4></div><div id=\"parentshistory\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div ng-include=\"\'app/baby-profile/fam_history_parents.tpl.html\'\"></div></div></div></div><div class=\"panel panel-primary\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-parent=\"#accordion2\" data-target=\"#siblingshistory\"><h4 class=\"panel-title\"><span class=\"collapsed\">Siblings</span></h4></div><div id=\"siblingshistory\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div ng-include=\"\'app/baby-profile/fam_history_siblings.tpl.html\'\"></div></div></div></div></div></div></div><br><br>");
$templateCache.put("app/baby-profile/fam_history_parents.tpl.html","<div id=\"parentsHistory\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"col-md-10 col-md-offset-1\" ng-repeat=\"p in vm.parents_history\"><div class=\"text-right\"><button ng-show=\"p.mode!=\'edit\'\" ng-click=\"p.mode=\'edit\'\" class=\"btn btn-primary\"><i class=\"fa fa-pencil-square\">Update</i></button> <button ng-show=\"p.mode==\'edit\'\" ng-click=\"p.mode=\'view\';vm.updateParentsHistory(p);\" class=\"btn btn-primary\"><i class=\"fa fa-save\">Save</i></button> <button ng-show=\"p.mode==\'edit\'\" ng-click=\"p.mode=\'view\';vm.clearForm(\'parents\')\" class=\"btn btn-danger\"><i class=\"fa fa-close\">Cancel</i></button></div><div class=\"row\"><div class=\"col-md-4\"><span>Relation</span></div><div class=\"col-md-3\">{{(p.relation===\"mother\"? \"Mother\":p.relation==\"Mother\"?\"Mother\":\"Father\")}}</div></div><br><br><div class=\"row\"><div class=\"col-md-4\">Major Known Health issues:</div><div class=\"col-md-4 space\"><input class=\"form-control\" ng-if=\"p.mode==\'edit\'\" ng-disabled=\"p.mode!=\'edit\'\" ng-model=\"p.health_issues\" type=\"text\" size=\"30\"> <label ng-if=\"p.mode!=\'edit\'\" for=\"\">{{p.health_issues}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>Any daily Medication ?</span></div><div class=\"col-md-6\"><label ng-if=\"p.mode==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"p.mode!=\'edit\'\" ng-model=\"p.medication\" ng-value=\"\'True\'\" type=\"radio\" name=\"medication{{$index}}\"> True</label> <label ng-if=\"p.mode==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"p.mode!=\'edit\'\" ng-model=\"p.medication\" ng-value=\"\'False\'\" type=\"radio\" name=\"medication{{$index}}\"> False</label> <label ng-if=\"p.mode!=\'edit\'\" for=\"\">{{p.medication==\'True\' ? \'Yes\' : p.medication==\'False\' ? \'No\' : \'\'}}</label></div></div><br><div class=\"row\" ng-if=\"p.medication===\'True\'\"><div class=\"col-md-4\"><span class=\"textcolor\">Please Describe</span></div><div class=\"col-md-4\"><input class=\"form-control\" ng-if=\"p.mode==\'edit\'\" ng-disabled=\"p.mode!=\'edit\'\" ng-model=\"p.medication_text\" type=\"text\" size=\"30\"> <label ng-if=\"p.mode!=\'edit\'\" for=\"\">{{p.medication_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>Was there any Hospitalization ?</span></div><div class=\"col-md-6\"><label ng-if=\"p.mode==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"p.mode!=\'edit\'\" ng-model=\"p.hospitalization\" ng-value=\"\'True\'\" type=\"radio\" name=\"hospitalization{{$index}}\"> True</label><label ng-if=\"p.mode==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"p.mode!=\'edit\'\" ng-model=\"p.hospitalization\" ng-value=\"\'False\'\" type=\"radio\" name=\"hospitalization{{$index}}\"> False</label> <label ng-if=\"p.mode!=\'edit\'\" for=\"\">{{p.hospitalization==\'True\' ? \'Yes\' : p.hospitalization==\'False\' ? \'No\' : \'\'}}</label></div><br><br></div><div class=\"row\" ng-if=\"p.hospitalization===\'True\'\"><div class=\"col-md-4\"><span class=\"textcolor\">Please Describe</span></div><div class=\"col-md-4\"><input class=\"form-control\" ng-if=\"p.mode==\'edit\'\" ng-disabled=\"p.mode!=\'edit\'\" ng-model=\"p.hospitalization_text\" type=\"text\" size=\"30\"> <label ng-if=\"p.mode!=\'edit\'\" for=\"\">{{p.hospitalization_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>Food Type :</span></div><div class=\"col-md-8\"><label ng-if=\"p.mode==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"p.mode!=\'edit\'\" type=\"radio\" name=\"food{{$index}}\" ng-model=\"p.food_type\" value=\"vegetarian\"> Vegetarian</label> <label ng-if=\"p.mode==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"p.mode!=\'edit\'\" type=\"radio\" name=\"food{{$index}}\" ng-model=\"p.food_type\" value=\"non-vegetarian\"> Non-Veg</label> <label ng-if=\"p.mode==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"p.mode!=\'edit\'\" type=\"radio\" name=\"food{{$index}}\" ng-model=\"p.food_type\" value=\"only-egg\"> Egg + Vegetarian</label> <label ng-if=\"p.mode!=\'edit\'\" for=\"\">{{p.food_type}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\">Any Diseases running in a family<br>(Hereditary Diseases)</div><div class=\"col-md-4\"><input class=\"form-control\" ng-if=\"p.mode==\'edit\'\" ng-disabled=\"p.mode!=\'edit\'\" ng-model=\"p.hereditary_disease\" type=\"text\" size=\"30\"> <label ng-if=\"p.mode!=\'edit\'\" for=\"\">{{p.hereditary_disease}}</label></div></div><hr></div></div></div>");
$templateCache.put("app/baby-profile/fam_history_siblings.tpl.html","<div class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div ng-repeat=\"sib_his in vm.sibling_history\"><form name=\"myForm\"><div class=\"clearfix\" name=\"myForm\"><div><button ng-if=\"($index+1)===vm.sibling_history.length\" ng-show=\"vm.mode_sibHis!=\'edit\'\" ng-click=\"vm.sibling_history.push({\'new\':true});\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-plus-square\">Add more..</i></button></div><button ng-show=\"sib_his.new===true\" ng-click=\"vm.mode_sibHis=\'view\';vm.sibling_history.splice($index,1);\" class=\"btn btn-danger pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-close\">Remove</i></button> <button ng-show=\"vm.mode_sibHis!=\'edit\'\" ng-click=\"vm.mode_sibHis=\'edit\';vm.toggle()\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-pencil-square\" ng-click=\"vm.toggle()\">Update</i></button> <button ng-show=\"vm.mode_sibHis==\'edit\'\" ng-click=\"vm.mode_sibHis=\'view\';vm.clearForm(\'sibling\');\" class=\"btn btn-danger pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-close\">Cancel</i></button><div><button ng-show=\"vm.mode_sibHis==\'edit\'\" ng-click=\"vm.updateSiblingHistory(sib_his);vm.toggle();vm.myFunc();\" ng-disabled=\"myForm.Name.$dirty && myForm.Name.$invalid\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-save\">Save</i></button></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>Name of the Sibling</span> <span class=\"text-danger\">*</span></div><div class=\"col-md-3\"><input type=\"text\" ng-if=\"vm.mode_sibHis==\'edit\'\" ng-minlength=\"1\" name=\"Name\" ng-disabled=\"vm.mode_sibHis!=\'edit\'\" class=\"form-control\" ng-required=\"true\" ng-model=\"sib_his.first_name\" placeholder=\"First Name\"> <span ng-show=\"myForm.Name.$error.required\" style=\"color: red;\"></span> <label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.first_name}}</label> <label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.last_name}}</label></div><div class=\"col-md-3\"><input type=\"text\" ng-if=\"vm.mode_sibHis==\'edit\'\" name=\"Last\" ng-disabled=\"vm.mode_sibHis!=\'edit\'\" class=\"form-control\" ng-model=\"sib_his.last_name\" placeholder=\"Last Name\" required=\"\"> <span ng-show=\"myForm.Last.$error.required\" style=\"color: red;\"></span></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>D.O.B</span></div><div class=\"col-md-3\"><div ng-if=\"vm.mode_sibHis==\'edit\'\" class=\"input-group form-group\"><input ng-disabled=\"vm.mode_sibHis!=\'edit\'\" id=\"txtdob\" onkeydown=\"return false\" type=\"text\" uib-datepicker-popup=\"dd/MM/yyyy\" class=\"form-control\" ng-model=\"sib_his.dob\" is-open=\"sib_his.opened\" datepicker-options=\"datepicker.dateOptions\" close-text=\"Close\" placeholder=\"DoB\"><div class=\"input-group-addon link\" ng-click=\"sib_his.opened=!sib_his.opened\"><i class=\"fa fa-calendar\"></i></div></div><label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.dob | date:\'dd-MMM-yyyy\'}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>Gender</span></div><div ng-if=\"vm.mode_sibHis==\'edit\'\" class=\"col-md-4\"><span><a class=\"btn\" ng-disabled=\"vm.mode_sibHis!=\'edit\'\" href=\"\" ng-click=\"sib_his.gender=\'male\'\" ng-class=\"{\'genderClass\':sib_his.gender==\'male\'}\"><i class=\"fa fa-2x fa-male\"></i></a>| <a class=\"btn\" ng-disabled=\"vm.mode_sibHis!=\'edit\'\" href=\"\" ng-click=\"sib_his.gender=\'female\'\" ng-class=\"{\'genderClass\':sib_his.gender==\'female\'}\"><i class=\"fa fa-2x fa-female\"></i></a></span></div><div ng-if=\"vm.mode_sibHis!=\'edit\'\" class=\"col-md-4\"><label for=\"\">{{sib_his.gender}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\">Major Known Health issues:</div><div class=\"col-md-3\"><input class=\"form-control\" ng-if=\"vm.mode_sibHis==\'edit\'\" ng-disabled=\"vm.mode_sibHis!=\'edit\'\" ng-model=\"sib_his.health_issues\" type=\"text\" size=\"30\" placeholder=\"Issues\"> <label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.health_issues}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>Any daily Medication ?</span></div><div class=\"col-md-6\"><label ng-if=\"vm.mode_sibHis==\'edit\'\" class=\"radio-inline\"><input type=\"radio\" ng-model=\"sib_his.medication\" ng-value=\"\'True\'\" name=\"sibling{{$index}}\"> Yes</label> <label ng-if=\"vm.mode_sibHis==\'edit\'\" class=\"radio-inline\"><input ng-model=\"sib_his.medication\" ng-value=\"\'False\'\" type=\"radio\" name=\"sibling{{$index}}\"> No</label> <label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.medication==\'True\'? \'Yes\' : sib_his.medication==\'False\' ? \'No\' : \'\'}}</label></div></div><div class=\"row\" ng-if=\"sib_his.medication===\'True\'\"><br><div class=\"col-md-4\"><span class=\"textcolor\" ng-if=\"sib_his.medication\">Please Describe</span></div><div class=\"col-md-3\" ng-if=\"sib_his.medication\"><input class=\"form-control\" ng-if=\"vm.mode_sibHis==\'edit\'\" ng-disabled=\"vm.mode_sibHis!=\'edit\'\" ng-model=\"sib_his.medication_text\" type=\"text\" size=\"30\" placeholder=\"Medication description\"> <label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.medication_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>Was there any Hospitalization ?</span></div><div class=\"col-md-6\"><label ng-if=\"vm.mode_sibHis==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"vm.mode_sibHis!=\'edit\'\" ng-model=\"sib_his.hospitalization\" ng-value=\"\'True\'\" type=\"radio\" name=\"hospitalization{{$index}}\"> Yes</label><label ng-if=\"vm.mode_sibHis==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"vm.mode_sibHis!=\'edit\'\" ng-model=\"sib_his.hospitalization\" ng-value=\"\'False\'\" type=\"radio\" name=\"hospitalization{{$index}}\"> No</label> <label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.hospitalization==\'True\'? \'Yes\' : sib_his.hospitalization==\'False\' ? \'No\' : \'\'}}</label></div><br></div><div class=\"row\" ng-if=\"sib_his.hospitalization===\'True\'\"><br><div class=\"col-md-4\"><span class=\"textcolor\">Please Describe</span></div><div class=\"col-md-3\"><input class=\"form-control\" ng-if=\"vm.mode_sibHis==\'edit\'\" ng-disabled=\"vm.mode_sibHis!=\'edit\'\" ng-model=\"sib_his.hospitalization_text\" type=\"text\" size=\"30\" placeholder=\"Hospitalization description\"> <label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.hospitalization_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-4\"><span>Other details if any..</span></div><div class=\"col-md-3\"><input class=\"form-control\" ng-if=\"vm.mode_sibHis==\'edit\'\" ng-model=\"sib_his.other_details\" type=\"text\" size=\"30\" placeholder=\"Other Details\"> <label ng-if=\"vm.mode_sibHis!=\'edit\'\" for=\"\">{{sib_his.other_details}}</label></div></div><br><hr></form></div></div></div>");
$templateCache.put("app/baby-profile/history.tpl.html","<br><div class=\"row\"><div class=\"col-md-6 text-left\"></div></div><div class=\"row link\"><div class=\"col-sm-11\"><div class=\"panel-group\" id=\"accordion3\"><div class=\"panel panel-primary\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-parent=\"#accordion3\" data-target=\"#at-birth\"><h4 class=\"panel-title\"><span class=\"collapsed\">At Birth</span></h4></div><div id=\"at-birth\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div ng-include=\"\'app/baby-profile/history_atbirth.tpl.html\'\"></div></div></div></div><div class=\"panel panel-primary\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-parent=\"#accordion3\" data-target=\"#new-born\"><h4 class=\"panel-title\"><span class=\"collapsed\">New Born</span></h4></div><div id=\"new-born\" class=\"panel-collapse collapse\"><div class=\"text-right\"><button ng-show=\"mode!=\'edit\'\" ng-click=\"mode=\'edit\'\" class=\"btn btn-primary\"><i class=\"fa fa-pencil-square\">Update</i></button> <button ng-show=\"mode==\'edit\'\" ng-click=\"mode=\'view\';vm.updateBabyHistoryNewBorn()\" class=\"btn btn-primary\"><i class=\"fa fa-save\">Save</i></button> <button ng-show=\"mode==\'edit\'\" ng-click=\"mode=\'view\';vm.clearForm(\'newborn\');\" class=\"btn btn-danger\"><i class=\"fa fa-close\">Cancel</i></button></div><div class=\"panel-body\"><div ng-include=\"\'app/baby-profile/history_newborn.tpl.html\'\"></div></div></div></div></div></div></div><br><br>");
$templateCache.put("app/baby-profile/history_atbirth.tpl.html","<script>\n  function maxLengthCheck(object) {\n    if (object.value.length > object.maxLength){\n      object.value = object.value.slice(0, object.maxLength)\n    }\n    if(object.value > 10){\n        object.value = object.value.slice(0, object.maxLength - 1)\n      }\n  }\n</script><form name=\"frmAtBirth\" action=\"\"><div class=\"text-right\"><a ng-show=\"vm.mode_birth!=\'edit\'\" ng-click=\"vm.changeMode()\" class=\"btn btn-primary\"><i class=\"fa fa-pencil-square\">Update</i></a> <a ng-show=\"vm.mode_birth==\'edit\'\" ng-click=\"vm.updateBabyHistoryAtBirth()\" class=\"btn btn-primary\"><i class=\"fa fa-save\">Save</i></a> <a ng-show=\"vm.mode_birth==\'edit\'\" ng-click=\"vm.mode_birth=\'view\';vm.clearForm(\'atbirth\');\" class=\"btn btn-danger\"><i class=\"fa fa-close\">Cancel</i></a></div><div class=\"col-md-9 col-md-offset-2\"><div class=\"row\"><div class=\"col-md-6\"><span>APGAR Score (0-10)</span></div><div class=\"col-md-3\" name=\"myForm\"><input class=\"form-control\" numbers-only=\"\" ng-if=\"vm.mode_birth==\'edit\'\" name=\"Name\" ng-disabled=\"vm.mode_birth!=\'edit\'\" type=\"text\" min=\"0\" max=\"10\" oninput=\"maxLengthCheck(this)\" maxlength=\"2\" ng-model=\"vm.birth_history.score\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.score}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>What was the Type of Delivery?</span> <span style=\"color: red;\">*</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-model=\"vm.birth_history.delivery\" ng-disabled=\"vm.mode_birth!=\'edit\'\" required=\"\"><option value=\"\" selected=\"\">Select Option</option><option value=\"cesarean\">Cesarean</option><option value=\"vaccum\">Vaccum</option><option value=\"normal\">Normal</option><option value=\"other\">Other</option></select><label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.delivery}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Did Baby Cry at Birth?</span></div><div class=\"col-md-3\"><label ng-if=\"vm.mode_birth==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.cry\" value=\"True\" type=\"radio\" name=\"cryatBirth\"> True</label> <label ng-if=\"vm.mode_birth==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.cry\" value=\"False\" type=\"radio\" name=\"cryatBirth\"> False</label> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.cry==\"True\"?\'Yes\':vm.birth_history.cry==\"False\"?\'No\':\'\'}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>When did Baby pass Urine?</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-model=\"vm.birth_history.urine\" ng-disabled=\"vm.mode_birth!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"before 24 hrs\">Before 24 Hours</option><option value=\"between 24 to 48 hrs\">Between 24 to 48 Hours</option><option value=\"after 48 hrs\">After 48 Hours</option></select><label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.urine}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>When did Baby pass Motion?</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-model=\"vm.birth_history.motion\" ng-disabled=\"vm.mode_birth!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"before 24 hrs\">Before 24 Hours</option><option value=\"between 24 to 48 hrs\">Between 24 to 48 Hours</option><option value=\"after 48 hrs\">After 48 Hours</option></select><label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.motion}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Was there a time delay in giving the baby to Mother, post delivery?</span></div><div class=\"col-md-3\"><label ng-if=\"vm.mode_birth==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.is_time_delay\" value=\"True\" type=\"radio\" name=\"delayatBirth\"> True</label><label ng-if=\"vm.mode_birth==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.is_time_delay\" value=\"False\" type=\"radio\" name=\"delayatBirth\"> False</label> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.is_time_delay==\"True\"?\'Yes\':vm.birth_history.is_time_delay==\"False\"?\'No\':\'\'}}</label><br></div></div><br><div class=\"row\" ng-if=\"vm.birth_history.is_time_delay==\'true\'\"><div class=\"col-md-6\"><span class=\"textcolor\">Why time delay in giving baby to Mother</span></div><div class=\"col-md-3\"><input class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.time_delay\" type=\"text\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.time_delay}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>When was the Breast Feeding started?</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-model=\"vm.birth_history.breast_feeding_start\" ng-disabled=\"vm.mode_birth!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"immediate\">Immediate</option><option value=\"3 to 5 hrs\">3 to 5 Hours</option><option value=\"after 5 hrs\">After 5 Hrs</option></select><label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.breast_feeding_start}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Was baby admitted in NICU?</span></div><div class=\"col-md-3\"><label ng-if=\"vm.mode_birth==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.is_nicu_admission\" value=\"yes\" type=\"radio\" name=\"delayatBirth\"> Yes</label><label ng-if=\"vm.mode_birth==\'edit\'\" class=\"radio-inline\"><input ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.is_nicu_admission\" value=\"no\" type=\"radio\" name=\"delayatBirth\"> No</label> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.is_nicu_admission==\"yes\"?\'Yes\':vm.birth_history.is_nicu_admission==\"no\"?\'No\':\'\'}}</label><br></div></div><br><div class=\"row\" ng-if=\"vm.birth_history.is_nicu_admission==\'yes\'\"><div class=\"col-md-6\"><span class=\"textcolor\">Reason for admission</span> <span style=\"color: red;\">*</span></div><div class=\"col-md-3\"><input class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.nicu_admit_reason\" type=\"text\" required=\"\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.nicu_admit_reason}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>When was the Baby Discharged from Hospital?</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-model=\"vm.birth_history.discharge_duration\" ng-disabled=\"vm.mode_birth!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"24 to 48 hrs\">24 to 48 Hrs</option><option value=\"3 to 5 days\">3 to 5 Days</option><option value=\"after 5 days\">After 5 days (Delay)</option></select><label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.discharge_duration}}</label></div></div><br><div class=\"row\" ng-if=\"vm.birth_history.discharge_duration==\'after 5 days\'\"><div class=\"col-md-6\"><span class=\"textcolor\">Reason for delay in Discharge</span> <span style=\"color: red;\">*</span></div><div class=\"col-md-3\"><input class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.discharge_delay_reason\" type=\"text\" required=\"\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.discharge_delay_reason}}</label></div></div><br><div class=\"row\"><div class=\"col-md-12\"><span>Baby\'s Weight :</span></div><br><div class=\"col-md-12\"><div class=\"col-md-6\">At Birth<br><label class=\"inline\"><label for=\"\">{{vm.basic.childInfo.birthWeight}} &nbsp;kg</label></label></div><div class=\"col-md-6\">At Discharge<br><label class=\"inline\"><input class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-disabled=\"vm.mode_birth!=\'edit\'\" type=\"number\" step=\".1\" ng-model=\"vm.birth_history.discharge_weight\" max=\"250\" min=\"0\" ng-init=\"0\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.discharge_weight==\"NaN\"?\'__\':vm.birth_history.discharge_weight}}</label> &nbsp;kg</label></div></div></div><br><div class=\"row\"><div class=\"col-md-12\"><span>Baby\'s Length :</span></div><div class=\"col-md-12\"><div class=\"col-md-6\">At Birth<br><label class=\"inline\"><label for=\"\">{{vm.basic.childInfo.birthHeight}} &nbsp; cm</label></label></div><div class=\"col-md-6\">At Discharge<br><label class=\"inline\"><input class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-disabled=\"vm.mode_birth!=\'edit\'\" type=\"number\" step=\".01\" ng-model=\"vm.birth_history.discharge_height\" max=\"250\" min=\"0\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.discharge_height==\"NaN\"?\'__\':vm.birth_history.discharge_height}}</label> &nbsp; cm</label></div></div></div><br><div class=\"row\"><div class=\"col-md-12\"><span>Baby\'s Head Circumference:</span></div><div class=\"col-md-12\"><div class=\"col-md-6\">At Birth<br><label class=\"inline\"><input class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-disabled=\"vm.mode_birth!=\'edit\'\" type=\"number\" step=\".01\" ng-model=\"vm.birth_history.birth_head_circumference\" max=\"120\" min=\"0\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.birth_head_circumference==\"NaN\"?\'__\':vm.birth_history.birth_head_circumference}}</label> cm</label></div><div class=\"col-md-6\">At Discharge<br><label class=\"inline\"><input class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-disabled=\"vm.mode_birth!=\'edit\'\" type=\"number\" step=\".01\" ng-model=\"vm.birth_history.discharge_head_circumference\" max=\"120\" min=\"0\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.discharge_head_circumference==\"NaN\"?\'__\':vm.birth_history.discharge_head_circumference}}</label> cm</label></div></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Feeding</span> <span style=\"color: red;\">*</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-model=\"vm.birth_history.feeding\" ng-disabled=\"vm.mode_birth!=\'edit\'\" required=\"\"><option value=\"\" selected=\"\">Select Option</option><option value=\"mother\">Mother</option><option value=\"supplement\">Supplement</option></select><label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.feeding}}</label></div></div><br><div class=\"row\" ng-if=\"vm.birth_history.feeding==\'supplement\'\"><div class=\"col-md-6\"><span>If not breast feeding, reason for not Breast Feeding?</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-model=\"vm.birth_history.supplement_reason\" ng-disabled=\"vm.mode_birth!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"medical\">Medical</option><option value=\"social\">Social</option></select><label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.supplement_reason}}</label></div></div><br><div class=\"row\" ng-if=\"vm.birth_history.supplement_reason==\'medical\'\"><div class=\"col-md-6\"><span>If Medical, what is the Reason ?</span></div><div class=\"col-md-3\"><input class=\"form-control\" ng-if=\"vm.mode_birth==\'edit\'\" ng-disabled=\"vm.mode_birth!=\'edit\'\" ng-model=\"vm.birth_history.medical_reason\" type=\"text\"> <label ng-if=\"vm.mode_birth!=\'edit\'\" for=\"\">{{vm.birth_history.medical_reason}}</label></div></div></div></form><style type=\"text/css\">\n      input.submitted.ng-invalid\n      {\n        border:1px solid #f00;\n      }\n    </style>");
$templateCache.put("app/baby-profile/history_newborn.tpl.html","<div class=\"col-md-9 col-md-offset-2\"><div class=\"row\"><div class=\"col-md-6\"><span>Did Baby have Jaundice ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.jaundice\" value=\"true\" ng-disabled=\"mode!= \'edit\'\" type=\"radio\" name=\"jaundice\"> Yes</label><label ng-if=\"mode== \'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.jaundice\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"jaundice\"> No</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.jaundice\" value=\"dontknow\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"jaundice\"> Don\'t know</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.jaundice==\"true\"?\'yes\':vm.new_born_history.jaundice==\"dontknow\"?\'dontknow\':vm.new_born_history.jaundice==\"false\"?\'no\':\'\'}}</label><br></div></div><br><div class=\"row\" ng-show=\"vm.new_born_history.jaundice==\'true\'\"><div class=\"col-md-6\"><span class=\"textcolor\">What was the Maximum level ?</span></div><div class=\"col-md-1\"><input ng-if=\"mode==\'edit\'\" type=\"number\" step=\"1\" ng-model=\"vm.new_born_history.jaundice_level\" ng-disabled=\"mode!=\'edit\'\" max=\"100\" min=\"0\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.jaundice_level}}</label></div><div class=\"col-md-1\">μmol/l</div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Did baby have problem with Sugar ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.sugar\" value=\"true\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"sugar\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.sugar\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"sugar\"> No</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.sugar\" value=\"dontknow\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"sugar\"> Don\'t know</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.sugar==\"true\"?\'yes\':vm.new_born_history.sugar==\"dontknow\"? \'dont know\':vm.new_born_history.sugar==\"false\"?\'no\':\'\'}}</label><br></div></div><br><div class=\"row\" ng-show=\"vm.new_born_history.sugar==\'true\'\"><div class=\"col-md-6\"><span class=\"textcolor\">What was the lowest blood sugar ?</span></div><div class=\"col-md-1\"><input ng-if=\"mode==\'edit\'\" type=\"number\" ng-model=\"vm.new_born_history.sugar_level\" ng-disabled=\"mode!=\'edit\'\" step=\"1\" max=\"100\" min=\"0\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.sugar_level}}</label></div><div class=\"col-md-1\">mmol/L</div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Did Baby have any infection ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.infection\" value=\"true\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"infection\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.infection\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"infection\"> No</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.infection\" value=\"dontknow\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"infection\"> Don\'t know</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.infection==\"true\"?\'yes\':vm.new_born_history.infection==\"dontknow\"?\'dont know\':vm.new_born_history.infection==\"false\"?\'no\':\'\'}}</label></div></div><br><div class=\"row\" ng-show=\"vm.new_born_history.infection==\'true\'\"><div class=\"col-md-6\"><span class=\"textcolor\">Please Describe</span></div></div><div class=\"row\" ng-show=\"vm.new_born_history.infection==\'true\'\"><div class=\"col-md-8\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.infection_text\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.infection_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Did Baby have any Breath Difficulty ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.breadth_difficulty\" value=\"true\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"breath\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.breadth_difficulty\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"breath\"> No</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.breadth_difficulty\" value=\"dontknow\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"breath\"> Don\'t know</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.breadth_difficulty==\"true\"?\'yes\':vm.new_born_history.breadth_difficulty==\"dontknow\"?\'dont know\':vm.new_born_history.breadth_difficulty==\"false\"?\'no\':\'\'}}</label></div></div><br><div class=\"row\" ng-show=\"vm.new_born_history.breadth_difficulty==\'true\'\"><div class=\"col-md-6\"><span class=\"textcolor\">Please Describe</span></div></div><div class=\"row\" ng-show=\"vm.new_born_history.breadth_difficulty==\'true\'\"><div class=\"col-md-6\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.breadth_difficulty_text\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.breadth_difficulty_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Did Baby have Fits ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.fits\" value=\"true\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"fits\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.fits\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\"> No</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.fits\" value=\"dontknow\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"fits\"> Don\'t know</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.fits==\"true\"?\'yes\':vm.new_born_history.fits==\"dontknow\"?\'dont know\':vm.new_born_history.fits==\"false\"?\'no\':\'\'}}</label></div></div><br><div class=\"row\" ng-if=\"vm.new_born_history.fits==\'true\'\"><div class=\"col-md-6\"><span class=\"textcolor\">Please Describe</span></div></div><div class=\"row\" ng-if=\"vm.new_born_history.fits==\'true\'\"><div class=\"col-md-8\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.fits_text\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.fits_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Did Baby have any problem with Heart ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.heart_problems\" value=\"true\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"heart\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.heart_problems\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"heart\"> No</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.heart_problems\" value=\"dontknow\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"heart\"> Don\'t know</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.heart_problems==\"true\"?\'yes\':vm.new_born_history.heart_problems==\"dontknow\"?\'dont know\':vm.new_born_history.heart_problems==\"false\"?\'no\':\'\'}}</label></div></div><div class=\"row\" ng-show=\"vm.new_born_history.heart_problems==\'true\'\"><div class=\"col-md-6\"><span class=\"textcolor\">Please Describe</span></div></div><div class=\"row\" ng-show=\"vm.new_born_history.heart_problems==\'true\'\"><div class=\"col-md-8\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.heart_problems_text\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.heart_problems_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Any other problem ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.other_problem\" value=\"true\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"other-problem\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.other_problem\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"other-problem\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.other_problem==\"true\"?\'yes\':vm.new_born_history.other_problem==\"dontknow\"?\'dont know\':vm.new_born_history.other_problem==\"false\"?\'no\':\'\'}}</label></div></div><br><div class=\"row\" ng-show=\"vm.new_born_history.other_problem==\'true\'\"><div class=\"col-md-6\"><span class=\"textcolor\">Please Describe</span></div><div class=\"col-md-6\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.other_problem_text\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.other_problem_text}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Physical Finding on Baby at Birth</span></div></div><div class=\"row\"><div class=\"col-md-6\"><span>Normal:</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.physical_findings\" value=\"true\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"baby-birth\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.physical_findings\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"baby-birth\"> No</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.physical_findings\" value=\"dontknow\" type=\"radio\" name=\"baby-birth\">Don\'t know</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.physical_findings==\"true\"? \'yes\':vm.new_born_history.physical_findings==\"dontknow\"?\'dontknow\':vm.new_born_history.physical_findings==\"false\"?\'no\':\'\'}}</label></div></div><br><div class=\"row\" ng-show=\"vm.new_born_history.physical_findings==\'false\'\"><div class=\"col-md-6\"><span class=\"textcolor\">If no, Was testicles descended at birth ?</span></div><div class=\"col-md-6\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.testicles_descended\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.testicles_descended}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Hearing:</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.hearing\" value=\"normal\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"hearing\"> Normal</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.hearing\" value=\"abnormal\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"hearing\"> Abnormal</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.hearing}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Eye (Red Reflex / ROP):</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.eye\" value=\"normal\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"eye\"> Normal</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.eye\" value=\"abnormal\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"eye\"> Abnormal</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.eye}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Thyroid Screening</span></div><div class=\"col-md-6\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.thyroid_screening\" ng-disabled=\"mode!=\'edit\'\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.thyroid_screening}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Other Endocrine Screening / Other metabolic Screening</span></div><div class=\"col-md-6\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.other_screening\" ng-disabled=\"mode!=\'edit\'\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.other_screening}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Hip Examination</span></div><div class=\"col-md-6\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.hip_examination\" ng-disabled=\"mode!=\'edit\'\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.hip_examination}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Femorals</span></div><div class=\"col-md-6\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.femorals\" ng-disabled=\"mode!=\'edit\'\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.femorals}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Pulse Oxymetric Screening</span></div><div class=\"col-md-6\"><input ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.pulse_screening\" ng-disabled=\"mode!=\'edit\'\" type=\"text\" size=\"50\" class=\"notextbox\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.pulse_screening}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Has baby been admitted for any reason in the newborn period ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.admitted\" value=\"true\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"newborn\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.new_born_history.admitted\" value=\"false\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"newborn\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.admitted==\"true\"?\'yes\':vm.new_born_history.admitted==\"false\"?\'no\':\'\'}}</label></div></div><br><div class=\"row\" ng-show=\"vm.new_born_history.admitted==\'true\'\"><div class=\"col-md-6\"><p>If Yes,</p></div><div class=\"col-md-6\"><select ng-if=\"mode==\'edit\'\" ng-model=\"vm.new_born_history.admitted_reason\" ng-disabled=\"mode!=\'edit\'\"><option value=\"\" class=\"\" selected=\"selected\">Select Option</option><option value=\"Nursing\">Nursing</option><option value=\"Special Care\">Special Care</option><option value=\"NICU\">NICU</option></select><label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.new_born_history.admitted_reason}}</label></div></div></div>");
$templateCache.put("app/baby-profile/main.tpl.html","<div class=\"row\" style=\"padding-bottom: 40px;\"><div class=\"tab-container\"><br><ul class=\"nav nav-tabs\" id=\"myTab\" style=\"display: flex\"><li class=\"active\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Basic Profile\"><a data-target=\"#basic\" data-toggle=\"tab\" ng-click=\"closePopup()\">Basic Profile</a></li><li data-toggle=\"tooltip\" data-placement=\"top\" title=\"Mothers Antenatal History\"><a data-target=\"#mother\" data-toggle=\"tab\" ng-click=\"closePopup()\">Mothers Antenatal History</a></li><li data-toggle=\"tooltip\" data-placement=\"top\" title=\"Baby History\"><a data-target=\"#baby\" data-toggle=\"tab\" ng-click=\"closePopup()\">Baby History</a></li><li data-toggle=\"tooltip\" data-placement=\"top\" title=\"Family History\"><a data-target=\"#family\" data-toggle=\"tab\" ng-click=\"closePopup()\">Family History</a></li><li data-toggle=\"tooltip\" data-placement=\"top\" title=\"Social History\"><a data-target=\"#social\" data-toggle=\"tab\" ng-click=\"closePopup()\">Social History</a></li><li data-toggle=\"tooltip\" data-placement=\"top\" title=\"Questionnaire\"><a data-target=\"#question\" data-toggle=\"tab\" ng-click=\"closePopup();getquestionattachment()\">Questionnaire</a></li></ul><div class=\"tab-content\"><div class=\"tab-pane active\" id=\"basic\"><ng-include src=\"\'app/baby-profile/basic.tpl.html\'\"></ng-include></div><div class=\"tab-pane\" id=\"mother\"><ng-include src=\"\'app/baby-profile/mother.tpl.html\'\"></ng-include></div><div class=\"tab-pane\" id=\"baby\"><ng-include src=\"\'app/baby-profile/history.tpl.html\'\"></ng-include></div><div class=\"tab-pane\" id=\"family\"><ng-include src=\"\'app/baby-profile/fam_history.tpl.html\'\"></ng-include></div><div class=\"tab-pane\" id=\"social\"><ng-include src=\"\'app/baby-profile/soc_history.tpl.html\'\"></ng-include></div><div class=\"tab-pane\" id=\"question\"><ng-include src=\"\'app/baby-profile/questionnaire.html\'\"></ng-include></div></div></div></div>");
$templateCache.put("app/baby-profile/med_history.tpl.html","<div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-6 text-left\"><h4>Medical History</h4></div></div><div class=\"row\" style=\"padding-bottom: 40px;\"><div class=\"col-sm-11\"><div class=\"panel-group accr\" id=\"accordion1\"><div class=\"panel panel-primary\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-parent=\"#accordion1\" data-target=\"#hospitalisation\"><h4 class=\"panel-title\">Hospitalisation</h4></div><div id=\"hospitalisation\" class=\"panel-collapse collapse in\" style=\"overflow-x: hidden;overflow-y: auto;\"><div class=\"panel-body\"><div ng-include=\"\'app/baby-profile/med_history_hosp.tpl.html\'\"></div></div></div></div><div class=\"panel panel-primary\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-parent=\"#accordion1\" data-target=\"#opvisits\"><h4 class=\"panel-title\">OP Visits</h4></div><div id=\"opvisits\" class=\"panel-collapse collapse\" style=\"overflow-x: hidden;overflow-y: auto;\"><div class=\"panel-body\"><div ng-include=\"\'app/baby-profile/med_history_opvisit.tpl.html\'\"></div></div></div></div><div class=\"panel panel-primary\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-parent=\"#accordion1\" data-target=\"#medicalproblem\"><h4 class=\"panel-title\">Medical Problem</h4></div><div id=\"medicalproblem\" class=\"panel-collapse collapse\" style=\"overflow-x: hidden;overflow-y: auto;\"><div class=\"panel-body\"><div ng-include=\"\'app/baby-profile/med_history_medpb.tpl.html\'\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/baby-profile/med_history_allergy.tpl.html","<div class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"col-md-9 col-md-offset-2\"><div class=\"row\"><div class=\"col-md-3\">Food</div><div class=\"col-md-9\"><input type=\"text\" size=\"35\" class=\"notextbox\"></div></div><br><div class=\"row\"><div class=\"col-md-3\">Drug</div><div class=\"col-md-9\"><input type=\"text\" size=\"35\" class=\"notextbox\"></div></div><br><div class=\"row\"><div class=\"col-md-3\">Others</div><div class=\"col-md-9\"><input type=\"text\" size=\"35\" class=\"notextbox\"></div></div></div></div></div>");
$templateCache.put("app/baby-profile/med_history_hosp.tpl.html","<div class=\"panel-collapse collapse in scrolltab\"><div class=\"panel-body\"><div ng-repeat=\"hosp in vm.hospitalizations\"><div class=\"row\"><div class=\"col-md-3 text-right\">Admitted on</div><div class=\"col-md-3\"><div class=\"input-group form-group\"><input id=\"admitedon\" type=\"text\" class=\"form-control\" ng-disabled=\"hosp.mode!=\'edit\'\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"hosp.admitted_on\" is-open=\"hosp.opened\" datepicker-append-to-body=\"true\" datepicker-options=\"vm.datepicker.dateOptions\" onkeydown=\"return false\" close-text=\"Close\" required=\"\" placeholder=\"Admitted On\"><div class=\"input-group-addon link\" ng-click=\"hosp.opened=!hosp.opened\"><i class=\"fa fa-calendar\"></i></div></div></div><div class=\"col-md-3 text-right\">Name of Doctor</div><div class=\"col-md-3\"><input ng-model=\"hosp.doctor_name\" type=\"text\" class=\"text-center\" ng-disabled=\"hosp.mode!=\'edit\'\" placeholder=\"Enter Name of Doctor\"></div></div><br><div class=\"row\"><div class=\"col-md-3 text-right\">Name of the Hospital</div><div class=\"col-md-3\"><input ng-model=\"hosp.hospital_name\" type=\"text\" class=\"text-center\" ng-disabled=\"hosp.mode!=\'edit\'\" placeholder=\"Enter Hospital Name\"></div><div class=\"col-md-3 text-right\">Diagnosis</div><div class=\"col-md-3\"><input ng-model=\"hosp.diagnosis\" type=\"text\" class=\"text-center\" ng-disabled=\"hosp.mode!=\'edit\'\" placeholder=\"Good\"></div></div><br><div class=\"clearfix\"><button ng-if=\"($index+1)===vm.hospitalizations.length\" ng-click=\"vm.hospitalizations.push({\'new\':true});\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-plus-square\">Add more...</i></button> <button ng-show=\"hosp.mode==\'edit\'\" ng-click=\"hosp.mode=\'view\';vm.removeItem($index, \'hosp\');\" class=\"btn btn-danger pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-close\">Remove</i></button> <button ng-show=\"hosp.mode!=\'edit\'\" ng-click=\"hosp.mode=\'edit\'\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-pencil-square\">Update</i></button> <button ng-show=\"hosp.mode==\'edit\'\" ng-click=\"hosp.mode=\'view\';vm.clearForm(\'hosp\');\" class=\"btn btn-danger pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-close\">Cancel</i></button> <button ng-show=\"hosp.mode==\'edit\'\" ng-click=\"hosp.mode=\'view\';vm.updateMedHospitalizationHistory(hosp)\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-save\">Save</i></button></div><hr></div></div></div>");
$templateCache.put("app/baby-profile/med_history_medication.tpl.html","<div class=\"panel-collapse collapse in\"><div class=\"panel-body\"><table class=\"table table-hover table-bordered\"><thead><tr><th class=\"thead-color\">Date</th><th class=\"thead-color\">Medication</th></tr></thead><tbody><tr><td><select><option type=\"date\" value=\"20-Jan-2017\" class=\"\" selected=\"selected\">20-Jan-2017</option><option value=\"\" type=\"date\" label=\"3-Mar-2016\">3-Mar-2016</option><option value=\"\" type=\"date\" label=\"7-Jun-2013\">7-Jun-2013</option></select></td><td><select><option value=\"\" class=\"\" selected=\"selected\">Medication</option><option value=\"\" label=\"Diagnosis\">Medication</option><option value=\"\" label=\"Diagnosis\">Medication</option></select></td></tr><tr><td><select><option value=\"\" type=\"date\" label=\"3-Mar-2016\" selected=\"selected\">3-Mar-2016</option><option type=\"date\" value=\"20-Jan-2017\" class=\"\">20-Jan-2017</option><option value=\"\" type=\"date\" label=\"7-Jun-2013\">7-Jun-2013</option></select></td><td><select><option value=\"\" class=\"\" selected=\"selected\">Medication</option><option value=\"\" label=\"Diagnosis\">Medication</option><option value=\"\" label=\"Diagnosis\">Medication</option></select></td></tr><tr><td><select><option value=\"\" type=\"date\" label=\"7-Jun-2013\" selected=\"selected\">7-Jun-2013</option><option type=\"date\" value=\"20-Jan-2017\" class=\"\">20-Jan-2017</option><option value=\"\" type=\"date\" label=\"3-Mar-2016\">3-Mar-2016</option></select></td><td><select><option value=\"\" class=\"\" selected=\"selected\">Medication</option><option value=\"\" label=\"Diagnosis\">Medication</option><option value=\"\" label=\"Diagnosis\">Medication</option></select></td></tr></tbody></table></div></div>");
$templateCache.put("app/baby-profile/med_history_medpb.tpl.html","<div class=\"panel-collapse collapse in scrolltab\"><div class=\"panel-body\"><table class=\"table table-hover table-bordered\"><thead><tr><th class=\"thead-color\">Date</th><th class=\"thead-color\">Diagnosis</th><th></th></tr></thead><tbody><tr ng-repeat=\"medical_problem in vm.medical_problems\"><td><div class=\"input-group\"><input class=\"form-control\" ng-disabled=\"medical_problem.mode!=\'edit\'\" type=\"text\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"medical_problem.date\" is-open=\"medical_problem.opened\" datepicker-options=\"vm.datepicker.dateOptions\" datepicker-append-to-body=\"true\" onkeydown=\"return false\" close-text=\"Close\" required=\"\" placeholder=\"Date\"> <span class=\"input-group-addon link\" ng-click=\"medical_problem.opened=!medical_problem.opened\"><i class=\"fa fa-calendar\"></i></span></div></td><td><input ng-model=\"medical_problem.diagnosis\" type=\"text\" class=\"text-center\" ng-disabled=\"medical_problem.mode!=\'edit\'\" placeholder=\"Good\"></td><td><button ng-if=\"($index+1)===vm.medical_problems.length\" ng-click=\"vm.medical_problems.push({\'new\':true});\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-plus-square\">Add more...</i></button> <button ng-show=\"medical_problem.mode===\'edit\'\" ng-click=\"medical_problem.mode=\'view\';vm.removeItem($index, \'medical_problems\');\" class=\"btn btn-danger pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-close\">Remove</i></button> <button ng-show=\"medical_problem.mode!=\'edit\'\" ng-click=\"medical_problem.mode=\'edit\'\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-pencil-square\">Update</i></button> <button ng-show=\"medical_problem.mode==\'edit\'\" ng-click=\"medical_problem.mode=\'view\';vm.clearForm(\'medpb\');\" class=\"btn btn-danger pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-close\">Cancel</i></button> <button ng-show=\"medical_problem.mode==\'edit\'\" ng-click=\"medical_problem.mode=\'view\';vm.updateMedProblemHistory(medical_problem)\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-save\">Save</i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/baby-profile/med_history_opvisit.tpl.html","<div class=\"panel-collapse collapse in scrolltab\"><div class=\"panel-body\"><div ng-repeat=\"opvist in vm.opvists\"><div class=\"row\"><div class=\"col-md-4 text-right\">Date</div><div class=\"col-md-4\"><div class=\"input-group form-group\"><input ng-disabled=\"opvist.mode!=\'edit\'\" id=\"txtdate\" onkeydown=\"return false\" type=\"text\" uib-datepicker-popup=\"dd/MM/yyyy\" class=\"form-control\" ng-model=\"opvist.date\" is-open=\"opvist.opened\" datepicker-options=\"vm.datepicker.dateOptions\" datepicker-append-to-body=\"true\" close-text=\"Close\" required=\"\" placeholder=\"Date\"><div class=\"input-group-addon link\" ng-click=\"opvist.opened=!opvist.opened\"><i class=\"fa fa-calendar\"></i></div></div></div></div><br><div class=\"row\"><div class=\"col-md-4 text-right\">Name of Doctor</div><div class=\"col-md-6\"><input ng-disabled=\"opvist.mode!=\'edit\'\" ng-model=\"opvist.doctor_name\" type=\"text\" class=\"text-center\" placeholder=\"Doctor Name\"></div></div><br><div class=\"row\"><div class=\"col-md-4 text-right\">Name of the Hospital</div><div class=\"col-md-6\"><input ng-disabled=\"opvist.mode!=\'edit\'\" ng-model=\"opvist.hospital_name\" type=\"text\" class=\"text-center\" placeholder=\"Hospital Name\"></div></div><br><div class=\"row\"><div class=\"col-md-4 text-right\">Diagnosis</div><div class=\"col-md-6\"><input ng-disabled=\"opvist.mode!=\'edit\'\" ng-model=\"opvist.diagnosis\" type=\"text\" class=\"text-center\" placeholder=\"Diagnosis\"></div></div><br><div class=\"clearfix\"><button ng-if=\"($index+1)===vm.opvists.length\" ng-click=\"vm.opvists.push({\'new\':true});\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-plus-square\">Add more...</i></button> <button ng-show=\"opvist.mode===\'edit\'\" ng-click=\"opvist.mode=\'view\';vm.removeItem($index, \'opvisit\');\" class=\"btn btn-danger pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-close\">Remove</i></button> <button ng-show=\"opvist.mode!=\'edit\'\" ng-click=\"opvist.mode=\'edit\'\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-pencil-square\">Update</i></button> <button ng-show=\"opvist.mode==\'edit\'\" ng-click=\"opvist.mode=\'view\';vm.clearForm(\'opvist\');\" class=\"btn btn-danger pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-close\">Cancel</i></button> <button ng-show=\"opvist.mode==\'edit\'\" ng-click=\"opvist.mode=\'view\';vm.updateMedOPHistory(opvist)\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\"><i class=\"fa fa-save\">Save</i></button></div><hr></div></div></div>");
$templateCache.put("app/baby-profile/mother.tpl.html","<form name=\"frmMothers\"><div class=\"row\"><div class=\"col-md-6 text-left\"><h4>Mothers Antenatal History</h4></div><div class=\"col-md-6 pull-right\"><br><button ng-show=\"mode!=\'edit\'\" ng-click=\"mode=\'edit\'\" class=\"btn btn-primary\"><i class=\"fa fa-pencil-square\">Update</i></button> <button ng-show=\"mode==\'edit\'\" ng-click=\"mode=\'view\';vm.updateAntenatal()\" class=\"btn btn-primary\"><i class=\"fa fa-save\">Save</i></button> <button ng-show=\"mode==\'edit\'\" ng-click=\"mode=\'view\';vm.clearForm(\'antenatal\')\" class=\"btn btn-danger\"><i class=\"fa fa-close\">Cancel</i></button></div></div><br><div class=\"row\"><div class=\"col-md-11\"><div class=\"panel panel-primary\"><div class=\"panel-body\"><div class=\"col-md-10 col-md-offset-1\"><div><br><div class=\"row box-pad\"><div class=\"col-md-7\"><p>Where was the checkups done ?</p></div><div class=\"col-md-3\"><label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.antenatal.check_up}}</label> <input class=\"form-control\" ng-if=\"mode==\'edit\'\" ng-model=\"vm.antenatal.check_up\" ng-disabled=\"mode!=\'edit\'\" type=\"text\"></div></div><div class=\"row box-pad\"><div class=\"col-md-7\"><p>Where was the baby delivered ?</p></div><div class=\"col-md-3\"><label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.antenatal.delivery}}</label> <input class=\"form-control\" ng-if=\"mode==\'edit\'\" ng-model=\"vm.antenatal.delivery\" ng-disabled=\"mode!=\'edit\'\" type=\"text\"></div></div><div class=\"row box-pad\"><div class=\"col-md-7\"><p>Did mother have diabetes ?</p></div><div class=\"col-md-5\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input type=\"radio\" ng-model=\"vm.antenatal.diabetes\" name=\"diabetes\" ng-value=\"\'true\'\" ng-disabled=\"mode!=\'edit\'\"> Yes</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input type=\"radio\" ng-model=\"vm.antenatal.diabetes\" name=\"diabetes\" ng-value=\"\'false\'\" ng-disabled=\"mode!=\'edit\'\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.antenatal.diabetes==\'true\'?\'Yes\':vm.antenatal.diabetes==\'false\'?\'No\':\'\'}}</label></div></div><div class=\"row box-pad\"><div class=\"col-md-7\"><p>Did mother have HypoThyroidism?</p></div><div class=\"col-md-5\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.antenatal.hypo_thyroidism\" ng-value=\"\'true\'\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"hypothyroidism\"> Yes</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.antenatal.hypo_thyroidism\" ng-value=\"\'false\'\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"hypothyroidism\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.antenatal.hypo_thyroidism==\'true\'?\'Yes\':vm.antenatal.hypo_thyroidism==\'false\'?\'No\':\'\'}}</label></div></div><div class=\"row box-pad\"><div class=\"col-md-7\"><p>Did mother have FITS?</p></div><div class=\"col-md-5\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.antenatal.fits\" ng-value=\"\'true\'\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"fits\"> Yes</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.antenatal.fits\" ng-value=\"\'false\'\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"fits\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.antenatal.fits==\'true\'?\'Yes\':vm.antenatal.fits==\'false\'?\'No\':\'\'}}</label></div></div><div class=\"row box-pad\"><div class=\"col-md-7\"><p>Did mother have Urinary Infection?</p></div><div class=\"col-md-5\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.antenatal.urinary_infection\" ng-value=\"\'true\'\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"un-infection\"> Yes</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.antenatal.urinary_infection\" ng-value=\"\'false\'\" ng-disabled=\"mode!=\'edit\'\" type=\"radio\" name=\"un-infection\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.antenatal.urinary_infection==\'true\'?\'Yes\':vm.antenatal.urinary_infection==\'false\'?\'No\':\'\'}}</label></div></div></div></div></div></div></div></div><br><br><br></form>");
$templateCache.put("app/baby-profile/questionnaire.html","<h3>Questionnaire</h3><style>\n    .wrapword {\n       word-break: break-word;\n       white-space: pre-wrap;\n       -moz-white-space: pre-wrap;      \n    }\n    </style><div class=\"row\"><div class=\"col-lg-12\" style=\"margin-bottom: 20px;\"><table class=\"table table-bordered\"><thead style=\"background-color: #EAEAEA;\"><tr class=\"text-center\"><th class=\"text-center\">S.No</th><th class=\"text-center\">Category Name</th><th class=\"text-center\">Attachments</th></tr></thead><tbody><tr ng-if=\"showpmhq\"><td class=\"text-center\" style=\"vertical-align: middle\">1</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Past Medical History Questionnnaire</span></td><td class=\"text-center\" style=\"vertical-align: middle\"><span><button class=\"btn btn-warning\" style=\"margin-top: 20px;\" ng-click=\"showquestAttachment(\'1\')\"><img src=\"Content/Images/view.svg\" style=\"margin-top: -1px;\" width=\"17px\" height=\"17px\">&nbsp;&nbsp;View Attachment</button><br><br></span></td></tr><tr ng-if=\"!showpmhq\" style=\"height: 80px;\"><td class=\"text-center\" style=\"vertical-align: middle\">1</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Past Medical History Questionnnaire</span></td><td class=\"text-center\" style=\"vertical-align: middle;color: red;\">No data available</td></tr><tr ng-if=\"showphh\" style=\"vertical-align: middle\"><td class=\"text-center\" style=\"vertical-align: middle\">2</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Personal Health History</span></td><td class=\"text-center\" style=\"vertical-align: middle\"><span><button class=\"btn btn-warning\" style=\"margin-top: 20px;\" ng-click=\"showquestAttachment(\'2\')\"><img src=\"Content/Images/view.svg\" style=\"margin-top: -1px;\" width=\"17px\" height=\"17px\">&nbsp;&nbsp;View Attachment</button><br><br></span></td></tr><tr ng-if=\"!showphh\" style=\"height: 80px;\"><td class=\"text-center\" style=\"vertical-align: middle\">2</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Personal Health History</span></td><td class=\"text-center\" style=\"vertical-align: middle;color: red;\">No data available</td></tr><tr ng-if=\"showpmh\"><td class=\"text-center\" style=\"vertical-align: middle\">3</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Past Medical History</span></td><td class=\"text-center\" style=\"vertical-align: middle\"><span><button class=\"btn btn-warning\" style=\"margin-top: 20px;\" ng-click=\"showquestAttachment(\'3\')\"><img src=\"Content/Images/view.svg\" style=\"margin-top: -1px;\" width=\"17px\" height=\"17px\">&nbsp;&nbsp;View Attachment</button><br><br></span></td></tr><tr ng-if=\"!showpmh\" style=\"height: 80px;\"><td class=\"text-center\" style=\"vertical-align: middle\">3</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Past Medical History</span></td><td class=\"text-center\" style=\"vertical-align: middle;color: red;\">No data available</td></tr><tr ng-if=\"showmh\"><td class=\"text-center\" style=\"vertical-align: middle\">4</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Medication History</span></td><td class=\"text-center\" style=\"vertical-align: middle\"><span><button class=\"btn btn-warning\" style=\"margin-top: 20px;\" ng-click=\"showquestAttachment(\'4\')\"><img src=\"Content/Images/view.svg\" style=\"margin-top: -1px;\" width=\"17px\" height=\"17px\">&nbsp;&nbsp;View Attachment</button><br><br></span></td></tr><tr ng-if=\"!showmh\" style=\"height: 80px;\"><td class=\"text-center\" style=\"vertical-align: middle\">4</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Medication History</span></td><td class=\"text-center\" style=\"vertical-align: middle;color: red;\">No data available</td></tr><tr ng-if=\"showfmh\"><td class=\"text-center\" style=\"vertical-align: middle\">5</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Family Medical History</span></td><td class=\"text-center\" style=\"vertical-align: middle\"><span><button class=\"btn btn-warning\" style=\"margin-top: 20px;\" ng-click=\"showquestAttachment(\'5\')\"><img src=\"Content/Images/view.svg\" style=\"margin-top: -1px;\" width=\"17px\" height=\"17px\">&nbsp;&nbsp;View Attachment</button><br><br></span></td></tr><tr ng-if=\"!showfmh\" style=\"height: 80px;\"><td class=\"text-center\" style=\"vertical-align: middle\">5</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Family Medical History</span></td><td class=\"text-center\" style=\"vertical-align: middle;color: red;\">No data available</td></tr><tr ng-if=\"showsph\"><td class=\"text-center\" style=\"vertical-align: middle\">6</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Social and Personal History</span></td><td class=\"text-center\" style=\"vertical-align: middle\"><span><button class=\"btn btn-warning\" style=\"margin-top: 20px;\" ng-click=\"showquestAttachment(\'6\')\"><img src=\"Content/Images/view.svg\" style=\"margin-top: -1px;\" width=\"17px\" height=\"17px\">&nbsp;&nbsp;View Attachment</button><br><br></span></td></tr><tr ng-if=\"!showsph\" style=\"height: 80px;\"><td class=\"text-center\" style=\"vertical-align: middle\">6</td><td style=\"vertical-align: middle;width: 753px;\"><span style=\"padding-left: 300px;\">Social and Personal History</span></td><td class=\"text-center\" style=\"vertical-align: middle;color: red;\">No data available</td></tr></tbody></table></div></div><div class=\"row\" ng-show=\"questcategoryname.length==0\" style=\"padding-top: 5%\"><center><label>No records found</label></center></div>");
$templateCache.put("app/baby-profile/soc_history.tpl.html","<form name=\"frmSocial\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" ng-show=\"vm.social_history!=\'\' || vm.socialshow==\'yes\'\"><br><button ng-show=\"mode!=\'edit\'\" ng-click=\"mode=\'edit\'\" class=\"btn btn-primary\">Update</button> <button ng-show=\"mode==\'edit\'\" ng-click=\"mode=\'view\';vm.updateSocialHistory()\" class=\"btn btn-primary\">Save</button> <button ng-show=\"mode==\'edit\'\" ng-click=\"mode=\'view\';vm.clearForm(\'soc_history\')\" class=\"btn btn-danger\">Cancel</button></div></div><br><div class=\"panel panel-primary\"><div class=\"panel-body\"><div class=\"col-md-9 col-md-offset-2\"><div class=\"row\"><div class=\"col-md-6\"><span>What type of House ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.house_type\" ng-disabled=\"mode!=\'edit\'\" value=\"kutcha house\" type=\"radio\" name=\"housetype\"> Kutcha House</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.house_type\" ng-disabled=\"mode!=\'edit\'\" value=\"pucca house\" type=\"radio\" name=\"housetype\"> Pucca House</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.house_type}}</label><br></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span class=\"textcolor\">How many people in the house ?</span></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" numbers-only=\"\" ng-if=\"mode==\'edit\'\" ng-disabled=\"mode!=\'edit\'\" ng-model=\"vm.social_history.number_of_people\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.number_of_people}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span class=\"textcolor\">How many rooms in the house ?</span></div><div class=\"col-md-3\"><input class=\"form-control\" numbers-only=\"\" type=\"text\" step=\"1\" ng-if=\"mode==\'edit\'\" ng-disabled=\"mode!=\'edit\'\" ng-model=\"vm.social_history.number_of_rooms\" max=\"20\" min=\"0\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.number_of_rooms}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Any smokers in the house ?</span></div><div class=\"col-md-5\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.smokers\" ng-disabled=\"mode!=\'edit\'\" value=\"true\" type=\"radio\" name=\"smokers\"> Yes</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.smokers\" ng-disabled=\"mode!=\'edit\'\" value=\"false\" type=\"radio\" name=\"smokers\"> No</label> <label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.smokers\" ng-disabled=\"mode!=\'edit\'\" value=\"maybe\" name=\"smokers\" type=\"radio\">May Be</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.smokers==\"true\"? \'yes\': vm.social_history.smokers==\"maybe\"? \'maybe\': vm.social_history.smokers==\"false\"?\'no\':\'\'}}</label><br></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Type of Stove use for Cooking</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"mode==\'edit\'\" ng-model=\"vm.social_history.stove_type\" ng-disabled=\"mode!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"gas\">Gas</option><option value=\"kerosine\">Kerosine</option><option value=\"firewood\">Firewood</option><option value=\"others\">Others</option></select><label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.stove_type}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Distance to Doctor\'s Clinic</span></div><div class=\"col-md-2\"><input class=\"form-control\" ng-if=\"mode==\'edit\'\" type=\"text\" numbers-only=\"\" ng-disabled=\"mode!=\'edit\'\" ng-model=\"vm.social_history.distance\" max=\"500\" min=\"0\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.distance}} {{vm.social_history.distance_units}}</label></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"mode==\'edit\'\" ng-model=\"vm.social_history.distance_units\" ng-disabled=\"mode!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"km\">km</option><option value=\"mile\">mile</option></select></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Type of Transportation</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"mode==\'edit\'\" ng-model=\"vm.social_history.transportation\" ng-disabled=\"mode!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"public transport\">Public Transport</option><option value=\"own vehicle\">Own Vehicle</option></select><label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.transportation}}</label><br></div></div><div class=\"row\"><div class=\"col-md-6\"><span>Any problem preventing Child coming to Hospital?</span></div><div class=\"col-md-3\"><input class=\"form-control\" ng-if=\"mode==\'edit\'\" ng-model=\"vm.social_history.problem_coming_to_hospital\" ng-disabled=\"mode!=\'edit\'\" type=\"text\"> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.problem_coming_to_hospital}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Is the House on the Main Road ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.house_on_main_road\" ng-disabled=\"mode!=\'edit\'\" value=\"true\" type=\"radio\" name=\"mainRoad\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.house_on_main_road\" ng-disabled=\"mode!=\'edit\'\" value=\"false\" type=\"radio\" name=\"mainRoad\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.house_on_main_road==\"true\" ? \'yes\': vm.social_history.house_on_main_road==\"false\"?\'no\':\'\'}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Does the House have Proper Drinking Water ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.drinking_water_available\" ng-disabled=\"mode!=\'edit\'\" value=\"true\" type=\"radio\" name=\"drinkingWater\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.drinking_water_available\" ng-disabled=\"mode!=\'edit\'\" value=\"false\" type=\"radio\" name=\"drinkingWater\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.drinking_water_available==\"true\" ? \'yes\':vm.social_history.drinking_water_available==\"false\"?\'no\':\'\'}}</label></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>Does the House have a toilet ?</span></div><div class=\"col-md-6\"><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.toilet_available\" ng-disabled=\"mode!=\'edit\'\" value=\"true\" type=\"radio\" name=\"house\"> Yes</label><label ng-if=\"mode==\'edit\'\" class=\"radio-inline\"><input ng-model=\"vm.social_history.toilet_available\" ng-disabled=\"mode!=\'edit\'\" value=\"false\" type=\"radio\" name=\"house\"> No</label> <label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.toilet_available==\"true\" ? \'yes\':vm.social_history.toilet_available==\"false\"?\'no\':\'\'}}</label><br></div></div><br><div class=\"row\"><div class=\"col-md-6\"><span>What kind of air and water pollution is in your area ?</span></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"mode==\'edit\'\" ng-model=\"vm.social_history.pollution\" ng-disabled=\"mode!=\'edit\'\"><option value=\"\" selected=\"\">Select Option</option><option value=\"good\">Good</option><option value=\"moderate\">Moderate</option><option value=\"unhealthy\">Unhealthy</option><option value=\"very unhealthy\">Very Unhealthy</option><option value=\"hazardous\">Hazardous</option></select><label ng-if=\"mode!=\'edit\'\" for=\"\">{{vm.social_history.pollution}}</label></div></div><br></div></div></div><br><br></form>");
$templateCache.put("app/patient/dig.tpl.html","<style>\n   .Row\n   {\n   display: table;\n   width: 100%;\n   table-layout: fixed;\n   }\n   .Column\n   {\n   display: table-cell;\n   }\n</style><div class=\"row\"><div class=\"col-sm-2 well well-sm mycontent-left\"><ul class=\"nav nav-pills nav-stacked\"><li role=\"presentation\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><center ng-if=\"dig.record.gender==\'female\'\" style=\"background-color:#FFC0CB;\"><img style=\"margin: 0px auto; height: 110px; width: 110px;\" class=\"img-circle patient-img\" ng-src=\"{{dig.record.image}}\" err-src=\"Content/Images/users/avatar-{{dig.record.gender}}.png\"></center><center ng-if=\"dig.record.gender==\'male\'\" style=\"background-color:#00A0E3;\"><img style=\"margin: 0px auto; height: 110px; width: 110px;\" class=\"img-circle patient-img\" ng-src=\"{{dig.record.image}}\" err-src=\"Content/Images/users/avatar-{{dig.record.gender}}.png\"></center></div><div class=\"col-sm-12 col-xs-12\"><img class=\"pull-left\" width=\"15px\" ng-src=\"Content/Images/{{dig.record.gender}}.png\"><h3 class=\"\">{{dig.record.name}}</h3></div><div class=\"col-sm-12 col-xs-12\">PATIENTID:{{dig.record.mr_number}}<br>DOB: {{dig.record.dob|date:\'dd-MMM-yyyy\'}}<br>Age: (<span ng-hide=\"dig.recordAge.years==0\">{{dig.recordAge.years}} yrs</span> <span ng-hide=\"dig.recordAge.months==0\">{{dig.recordAge.months}} m</span> <span ng-show=\"dig.recordAge.years==0 && dig.recordAge.months==0\">{{dig.recordAge.days}} days</span>)</div><br><div ng-hide=\"dig.vitalData[0].weight==null && dig.vitalData[0].height==null\" class=\"col-sm-12 col-xs-12\">Current Weight: {{dig.vitalData.length>0 && (dig.vitalData[0].weight|number:2) || \'N/A\'}} kg<br>Current Height: {{dig.vitalData.length>0 && ((dig.vitalData[0].height*100)|number:2) || \'N/A\'}} cm</div><br><div ng-hide=\"dig.vitalData[0].bmi==null || dig.recordAge.years<3\" class=\"col-sm-12 col-xs-12\">BMI: {{dig.vitalData.length>0 && ((dig.vitalData[0].bmi)|number:2) || \'N/A\'}} kg/m&sup2;</div><div ng-hide=\"dig.vitalData[0].weight==null && dig.vitalData[0].height==null && dig.vitalData[0].bmi==null\" class=\"col-sm-12 col-xs-12\">As of {{(dig.vitalData[0].date)|date:\'dd-MMM-yyyy\'}}</div></div></li><li role=\"presentation\"><hr style=\"margin:5px;\"></li><li role=\"presentation\" ng-class=\"{active:dig.currentView==\'fever\'}\"><a ng-click=\"dig.currentView=\'fever\';scrollToWrapper();\"><span class=\"fa fa-thermometer-full\"></span> Fever</a></li><li role=\"presentation\" ng-class=\"{active:dig.currentView==\'cold\'}\"><a ng-click=\"dig.currentView=\'cold\';dig.scrollToWrapper();\"><span class=\"fa fa-frown-o\"></span> Cold & Cough <span class=\"fa fa-bell text-danger pull-right\"></span></a></li><li role=\"presentation\" ng-class=\"{active:dig.currentView==\'abd\'}\"><a ng-click=\"dig.currentView=\'abd\';dig.scrollToWrapper(); dig.backIn()\"><span class=\"fa fa-medkit\"></span> Abdominal</a></li><li role=\"presentation\" ng-class=\"{active:dig.currentView==\'mnc\'}\"><a ng-click=\"dig.currentView=\'mnc\';dig.scrollToWrapper();\"><span class=\"fa fa-medkit\"></span> Motion / Constipation</a></li><li role=\"presentation\" ng-class=\"{active:dig.currentView==\'other\'}\"><a ng-click=\"dig.currentView=\'other\';dig.scrollToWrapper(); dig.backLab()\"><span class=\"fa fa-pencil-square-o\"></span> Other Issues</a></li><li role=\"presentation\" ng-class=\"{active:dig.currentView==\'vac\'}\"><a ng-click=\"dig.currentView=\'vac\';dig.scrollToWrapper(); dig.backLab()\"><span class=\"fa fa-pencil-square-o\"></span> Vaccination</a></li></ul><br><br><br></div><br><div class=\"col-sm-10\" id=\"divPageWrapper\"><ng-include src=\"\'app/patient/dig/\'+dig.currentView+\'.tpl.html\'\"></ng-include></div><hr><div class=\"clearfix\"><div class=\"pull-right\" style=\"padding-bottom: 30px;\"><button ng-disabled=\"dig.isDisabled\" class=\"btn btn-success\" ng-click=\"dig.goToView()\">&nbsp; {{(dig.currentView==\'other\'?\"Submit\":\"Next\")}} &nbsp;</button> <a class=\"btn btn-danger\" ng-click=\"dig.goToView(\'cancel\')\">&nbsp;Cancel &nbsp;</a></div></div></div>");
$templateCache.put("app/patient/init.tpl.html","<h2>Growth Data</h2><div class=\"row\"><div class=\"col-md-6 col-sm-12 col-xs-12\"><form name=\"form\" class=\"form-login\" style=\"border-right: 2px solid;\" role=\"form\" autocomplete=\"OFF\" novalidate=\"\"><div><img ng-if=\"patient.record.image\" style=\"margin: 0px auto; height: 110px; width: 110px;\" class=\"img-circle patient-img\" ng-src=\"{{patient.record.image}}\" err-src=\"Content/Images/users/avatar-{{patient.record.demographics[0].gender}}.png\"><br><br></div><div class=\"col-sm-6 form-group\"><div class=\"col-md-6\"><label for=\"txtFirstName\">Name</label></div><div class=\"col-md-6\">{{patient.record.demographics[0].name_given}}</div></div><div class=\"clearfix\"></div><div class=\"col-sm-6 form-group\"><div class=\"col-md-6\"><label for=\"txtFirstName\">Patient ID</label></div><div class=\"col-md-6\">{{patient.record.demographics[0].mr_number}}</div></div><div class=\"clearfix\"></div><div class=\"col-sm-6 form-group\"><div class=\"col-md-6\"><label for=\"txtFirstName\">Date Of Birth</label></div><div class=\"col-md-6\">{{patient.record.demographics[0].bday | date:\'dd-MMM-yyyy\'}}</div></div><div class=\"clearfix\"></div><div class=\"col-sm-6 form-group\"><div class=\"col-md-6\"><label for=\"txtFirstName\">Age</label></div><div class=\"col-md-6\">{{patient.calculateAge(patient.record.demographics[0].bday)}}</div></div><div class=\"clearfix\"></div><div class=\"col-sm-6 form-group\"><div class=\"col-md-6\"><label for=\"txtFirstName\">Gender</label></div><div class=\"col-md-6\">{{patient.record.demographics[0].gender}}</div></div></form></div><div class=\"col-md-6 col-sm-12 col-xs-12 rightdata\"><form name=\"frmGrowthData\"><div ng-repeat=\"vital in patient.vitals.data.Models.Model.Field\" ng-hide=\"$index>5\" class=\"row form-group\"><div class=\"col-md-6\"><label>{{patient.vitalLabels[$index]}}</label></div><div class=\"col-md-2\"><input type=\"number\" min=\"0\" autofocus=\"\" class=\"form-control\" ng-model=\"vital.text\" placeholder=\"{{patient.vitalLabels[$index]}}\" required=\"\"></div></div><div class=\"col-sm-6 form-group\" style=\"float: right;\"><button ng-disabled=\"patient.isDisabled ||!frmGrowthData.$dirty\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"patient.SaveVitals()\">Submit</button> <a href=\"#/dig-patient/{{patient.recordId}}\" class=\"btn btn-info\">Skip</a></div></form></div></div>");
$templateCache.put("app/patient/patient-list.tpl.html","<script>\n    \n    function searchFilter(event, value, search_name) {\n        \n        if(search_name==\"mr_number\") {\n            \n            if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {\n                return true;\n            } else { \n                if (parseInt(value.charAt(0)) != 0) {\n                    var input_value = value + \'\' + event.key;\n                    if (input_value != 0) {\n                        if (input_value > 0 && input_value <= 9999999999) {\n                            var key = event.keyCode;\n                            return ((key >= 48 && key <= 57) || (key >= 96 && key <= 105) || key == 8);\n                        } else {\n                            return false;\n                        }\n                    } else {\n                        return true;\n                    }\n                }\n            }\n\n        } else if(search_name==\"patient_name\") {\n\n            if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {\n                return true;\n            } else {\n                if (value.length <=50) {\n                    var k = event.keyCode;\n                    return ((k >= 65 && k <= 90) || k == 8 || k == 32); \n                } \n            }\n\n        } else if(search_name==\"phone\") {\n\n            if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {\n                return true;\n            } else {\n                \n                if (value.length <= 9) {\n                    var input_value = parseInt(value + \'\' + event.key);\n                    \n                    if (input_value != 0) {\n                        if (input_value > 0 && input_value <= 999999999999) {\n                            var key = event.keyCode;\n                            return ((key >= 48 && key <= 57) || (key >= 96 && key <= 105) || key == 8);\n                        } else {\n                            return false;\n                        }\n                    } else {\n                        return true;\n                    }\n                      \n                } else {\n                    return false;\n                }\n            }\n\n        } else if(search_name==\"picme\") {\n            \n            if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {\n                return true;\n            } else { \n                if (parseInt(value.charAt(0)) != 0) {\n                    var input_value = parseInt(value + \'\' + event.key);\n                    if (input_value != 0) {\n                        if (input_value > 0 && input_value <= 999999999999999) {\n                            var key = event.keyCode;\n                            return ((key >= 48 && key <= 57) || (key >= 96 && key <= 105) || key == 8);\n                        } else {\n                            return false;\n                        }\n                    } else {\n                        return true;\n                    }\n                }\n            }\n\n        }\n    };\n    \n</script><div class=\"row\"><div class=\"col-md-4\"><h2 class=\"page-title\"><span class=\"\"><img class=\"baby\" src=\"Content/Images/baby1.png\" alt=\"Kiwi standing on oval\"></span> Patient List <sup><span class=\"badge\">{{patients.po.totalPatients}}</span></sup></h2></div></div><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-6\"><input type=\"radio\" id=\"mr_id\" name=\"searchRadio\" value=\"all\" ng-click=\"patients.patientRadioCheck(\'all\')\" checked=\"checked\"> <label>All</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type=\"radio\" id=\"mr_id\" name=\"searchRadio\" value=\"mr_number\" ng-click=\"patients.patientRadioCheck(\'mr_number\')\"> <label>MR Number</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type=\"radio\" id=\"patient_id\" name=\"searchRadio\" value=\"patient_name\" ng-click=\"patients.patientRadioCheck(\'patient_name\')\"> <label>Patient Name</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type=\"radio\" id=\"phone_id\" name=\"searchRadio\" value=\"phone\" ng-click=\"patients.patientRadioCheck(\'phone\')\"> <label>Phone</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type=\"radio\" id=\"picme\" name=\"searchRadio\" value=\"picme\" ng-click=\"patients.patientRadioCheck(\'picme\')\"> <label>PICME No</label></div><div class=\"col-md-4\" style=\"margin-left:-110px;margin-top:-8px;\"><form style=\"max-width:98%;\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" id=\"search_bar\" class=\"form-control\" value=\"\" ng-model=\"patients.search_value\" onkeydown=\"return searchFilter(event, value, name);\" ng-keyup=\"$event.keyCode == 13 && patients.getPatientSearch(patients.search_value)\" placeholder=\"{{patients.placeholder}}\" ng-disabled=\"patients.searchBarEnable==\'false\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"patients.getPatientSearch()\" ng-disabled=\"patients.searchBarEnable==\'false\'\"><span class=\"glyphicon glyphicon-search patient-search\"></span></button></span></div></div></form></div></div><div class=\"table-responsive bg-color\"><table class=\"table table-hover table-bordered\"><thead><tr><th>S No</th><th>Patient Id</th><th>Name</th><th>Contact #</th><th>DOB</th><th>Gender</th><th>Registration Date</th><th colspan=\"3\" width=\"20%\"><center>Age</center><table width=\"50\" style=\"border-bottom-style:hidden; border-left-style: hidden;border-right-style: hidden; width:200%; padding-right: 0px; border-color: grey; border-spacing: 1px; border-spacing:50%; padding-left: 0px; padding-bottom: 0px; border-top-style:inherit;\"><tr><hr><td width=\"10%\"><center>Years</center></td><td width=\"10%\"><center>Months</center></td><td width=\"10%\"><center>Days</center></td></tr></table></th><th>Father Name</th><th>Mother Name</th><th>Registered at</th></tr></thead><tbody><tr ng-hide=\"patients.view\" class=\"link\" ng-repeat=\"Patient in patients.PatientList\"><td ng-click=\"patients.viewPatient(Patient)\">{{((patients.po.curruntPage*patients.po.size) - patients.po.size) +($index + 1)}}</td><td ng-click=\"patients.viewPatient(Patient)\">{{Patient.mr_number}} <span ng-if=\"Patient.uhid\">&nbsp;/&nbsp;{{Patient.uhid}}</span></td><td ng-click=\"patients.viewPatient(Patient)\">{{Patient.name_given | capitalize}}</td><td ng-click=\"patients.viewPatient(Patient)\"><span ng-if=\"Patient.father_tel_number !=\'9000000000\'\">{{Patient.father_tel_number}}</span> <span ng-if=\"Patient.father_tel_number ==\'9000000000\'\">Not Provided</span> <span ng-if=\"Patient.mother_tel_number !=\'\' && Patient.mother_tel_number != null\">&nbsp;/&nbsp;{{Patient.mother_tel_number}}</span></td><td ng-click=\"patients.viewPatient(Patient)\">{{Patient.bday | date:\'dd-MMM-yyyy\'}}</td><td ng-click=\"patients.viewPatient(Patient)\">{{Patient.gender | capitalize}}</td><td ng-click=\"patients.viewPatient(Patient)\">{{Patient.registration_date | date:\'dd-MMM-yyyy\'}}</td><td ng-click=\"patients.viewPatient(Patient)\"><center><span ng-hide=\"Patient.age.years==0\">{{(Patient.age.years) * (-1)}} &nbsp;</span></center></td><td><center><span ng-hide=\"Patient.age.months==0\">{{Patient.age.months * (-1)}} &nbsp;</span></center></td><td><center><span ng-show=\"Patient.age.years==0 && Patient.age.months==0\">{{Patient.age.days * (-1)}}&nbsp;</span></center></td><td ng-click=\"patients.viewPatient(Patient)\">{{Patient.father_name_given | capitalize}}</td><td ng-click=\"patients.viewPatient(Patient)\">{{Patient.mother_name_given | capitalize}}</td><td ng-if=\"Patient.kce_id==\'CRC\' || Patient.kce_id==\'CTS\'\" ng-click=\"patients.viewPatient(Patient)\">{{Patient.staff_name}} / {{Patient.village_name}} / {{Patient.block_name}} / {{Patient.district_name}}</td><td ng-if=\"Patient.kce_id!=\'CRC\' && Patient.kce_id!=\'CTS\' && (Patient.kce_id==\'\' || Patient.kce_id==null)\" ng-click=\"patients.viewPatient(Patient)\">EPICare</td><td ng-if=\"Patient.kce_id!=\'CRC\' && Patient.kce_id!=\'CTS\' && Patient.kce_id!=\'\' && Patient.kce_id!=null\">{{Patient.kce_id}}</td></tr><tr ng-if=\"patients.loaded && patients.PatientList.length==0\"><td colspan=\"11\" class=\"text-center\">No results found</td></tr><tr ng-show=\"!patients.loaded\"><td colspan=\"11\" class=\"text-center\"><span class=\"fa fa-spinner fa-2x fa-spin\"></span></td></tr></tbody></table><div class=\"modal fade\" id=\"subscribeModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\">Subscription Plan</div><div class=\"modal-body\"><div class=\"form-group row flex-v-center\"><div class=\"col-xs-4\"><label class=\"control-label\">Subsciption Package<span class=\"text-danger\">*</span></label></div><div class=\"col-xs-6\"><select type=\"text\" class=\"form-control\" ng-model=\"patients.subscribeModel.duration_in_days\" ng-options=\"a.duration_in_days for a in patients.subscribeModel\" ng-change=\"patients.saveSubscribeData(patients.subscribeModel.duration_in_days)\" style=\"text-transform:capitalize\" required=\"\"><option value=\"\">None</option></select></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">Close</button>&nbsp;&nbsp; <button type=\"button\" class=\"btn btn-primary\" ng-click=\"patients.subscriptionPayment()\" data-dismiss=\"modal\">Ok</button></div></div></div></div></div><div class=\"text-center\"><ul uib-pagination=\"\" total-items=\"patients.po.totalPatients\" ng-change=\"patients.pageChanged()\" rotate=\"true\" force-ellipses=\"true\" previous-text=\"<< Previous Page\" next-text=\"Next Page >>\" ng-model=\"patients.po.curruntPage\" items-per-page=\"patients.po.size\" max-size=\"5\" boundary-link-numbers=\"true\"></ul></div></div>");
$templateCache.put("app/prescription/dropdownTemplate.html","<div><ul style=\"padding-left: 10px;\"><li ng-repeat=\"a in match\"><i class=\"fa fa-star-o link\" ng-click=\"$parent.$parent.$parent.$parent.$parent.saveFavourite(a.id)\" ng-if=\"a.brand&&a.favorite==false\"></i> <i class=\"fa fa-star link\" ng-if=\"a.brand&&a.favorite==true\"></i> {{a.formulation}}<i ng-if=\"a.formulation\">.</i>{{a.brand}}<i ng-if=\"a.brand\">-</i>{{a.generic}}<span ng-if=\"a.strength\">(</span>{{a.strength}}<span ng-if=\"a.strength\">)</span></li></ul></div>");
$templateCache.put("app/prescription/drug_master.tpl.html","<div class=\"row\"><div class=\"col-md-4\"><h3><i class=\"glyphicon glyphicon-tint\"></i>Drug Master</h3></div><div class=\"col-md-2\"><a class=\"btn btn-primary\" ng-click=\"vm.loadDrugs()\" ng-if=\"vm.drugs.length==0\">Load Default Drugs</a></div><div class=\"col-md-6\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.drugname\" ng-keyup=\"$event.keyCode == 13 && vm.searchDrug(vm.drugname)\" placeholder=\"Enter Drug Name and press Enter to Search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.searchDrug(vm.drugname)\"><span class=\"glyphicon glyphicon-search patient-search\"></span></button></span></div></div></div><hr><script type=\"text/ng-template\" id=\"form_drug.html\"><form name=\"userForm\" class=\"form-horizontal\" ng-controller=\"DrugEditCtrl as vm\" method=\"post\"> <fieldset> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Drug Name<span class=\"text-danger\">*</span></label> <div class=\"col-md-8\"> <input type=\"text\" placeholder=\"Drug Name\" class=\"form-control input-md\" ng-model=\"vm.drug.brand\" uib-typeahead=\"o.brand as o.brand for o in vm.searchDrugname($viewValue)\" typeahead-wait-ms=\"100\" typeahead-no-results=\"noResults\" ng-disabled=\"saved\" required> <!-- typeahead-on-select=\"vm.searchDrug($item.drug_name)\"--> <ul class=\"dropdown-menu link\" style=\"padding-left: 10px;\"> <li ng-repeat=\"brand.brand in vm.drugs\">{{drugs.brand.brand}}</li> </ul> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Formulation<span class=\"text-danger\">*</span></label> <div class=\"col-md-4\" ng-model=\"vm.drug.formulation\"> <label title=\"tablet\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 100px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"tablet\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\tablet.svg\"><span style=\"position: absolute; top: 65px; left: 32px;\">Tablet</span> </label> <label title=\"lotion\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 1px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"lotion\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\lotion.svg\"> <span style=\"position: absolute; top: 65px; left: 33px;\">Lotion</span> </label> <label title=\"capsules\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:200px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"capsules\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\capsul.svg\"> <span style=\"position: absolute; top: 65px; left: 25px;\">Capsules</span> </label> <label title=\"drops\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 200px; left: 250px;\"> <input type=\"radio\" name=\"foo\" value=\"drops\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\drops.svg\"> <span style=\"position: absolute; top: 65px; left: 35px;\">Drops</span> </label> <label title=\"injection\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:1px;left:50px;\"> <input type=\"radio\" name=\"foo\" value=\"injection\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\injection.svg\"> <span style=\"position: absolute; top: 60px; left: 25px;\">Injection</span> </label> <label title=\"soap\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:100px;left:50px;\"> <input type=\"radio\" name=\"foo\" value=\"soap\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\soap.svg\"> <span style=\"position: absolute; top: 65px; left: 35px;\">Soap</span> </label> <label title=\"cream\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:200px;left:50px;\"> <input type=\"radio\" name=\"foo\" value=\"cream\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\cream.svg\"> <span style=\"position: absolute; top: 65px; left: 33px;\">Cream</span> </label> <label title=\"oil\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:300px;left:50px;\"> <input type=\"radio\" name=\"foo\" value=\"oil\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\oil.svg\"> <span style=\"position: absolute; top: 65px; left: 40px;\">Oil</span> </label> <label title=\"ointment\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:1px; left:250px;\"> <input type=\"radio\" name=\"foo\" value=\"ointment\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\oinment.svg\"> <span style=\"position: absolute; top: 65px; left: 25px;\">Oinment</span> </label> <label title=\"suspension\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:100px; left: 250px;\"> <input type=\"radio\" name=\"foo\" value=\"suspension\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\suspension.svg\"> <span style=\"position: absolute; top: 65px; left: 20px;\">Suspension</span> </label> <label title=\"gel\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:300px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"gel\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\gel.svg\"><span style=\"position: absolute; top: 65px; left: 40px;\">Gel</span> </label> <label title=\"powder\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:300px; left: 250px;\"> <input type=\"radio\" name=\"foo\" value=\"powder\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\powder.svg\"><span style=\"position: absolute; top: 65px; left: 33px;\">Powder</span> </label> <label title=\"syrup\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 400px; left: 50px;\"> <input type=\"radio\" name=\"foo\" value=\"syrup\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\syrup.svg\"> <span style=\"position: absolute; top: 65px; left: 35px;\">Syrup</span> </label> <label title=\"sachet\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 400px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"sachet\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\sachet-new1.png\"> <span style=\"position: absolute; top: 65px; left: 40px;\">Sachet</span> </label> <label title=\"vaccination\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:400px; left: 270px;\"> <input type=\"radio\" name=\"foo\" value=\"vaccination\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\vaccination-new1.png\"> <span style=\"position: absolute; top: 65px; left: 10px;\">Vaccination</span> </label> <label title=\"inhalation\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 500px; left: 65px;\"> <input type=\"radio\" name=\"foo\" value=\"inhalation\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\inhaler-new1.png\"> <span style=\"position: absolute; top: 65px; left: 15px;\">Inhalation</span> </label> <label title=\"others\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 500px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"others\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\drug-others1.png\"> <span style=\"position: absolute; top: 65px; left: 30px;\">Others</span> </label> </div> </div> <div class=\"form-group\" style=\"margin-top:580px;\"> <label class=\"col-md-4 control-label\">Composition Name</label> <div class=\"col-md-8\"> <input ng-model=\"vm.drug.composition_name\" type=\"text\" placeholder=\"Composition name\" class=\"form-control input-md\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Generic Name</label> <div class=\"col-md-8\"> <input ng-model=\"vm.drug.generic\" type=\"text\" placeholder=\"Generic name\" class=\"form-control input-md\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Strength<span class=\"text-danger\">*</span></label> <div class=\"col-md-4\"> <input ng-model=\"vm.drug.strength\" type=\"text\" placeholder=\"Strength\" class=\"form-control input-md\" required> </div> <div class=\"col-md-4\"> <input ng-model=\"vm.drug.strength_unit\" type=\"text\" placeholder=\"Unit\" class=\"form-control input-md\" required> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Dose<span class=\"text-danger\">*</span></label> <div class=\"col-md-4\"> <input ng-model=\"vm.drug.dose\" type=\"text\" placeholder=\"Dose\" class=\"form-control input-md\" required> </div> <div class=\"col-md-4\"> <select ng-model=\"vm.drug.dose_option\" class=\"form-control\" ng-options=\"option for option in vm.doseOption\" required> <option value=\"\" disabled>Select dosage option</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Route</label> <div class=\"col-md-8\"> <select ng-model=\"vm.drug.route\" class=\"form-control\" ng-options=\"option for option in vm.routeofadmin\"> <option value=\"\" disabled>Select Route of Administration</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">When</label> <div class=\"col-md-8\"> <select ng-model=\"vm.drug.when\" class=\"form-control\" ng-options=\"option for option in vm.whenOption\"> <option value=\"\" disabled>Select option</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Spl Instructions</label> <div class=\"col-md-8\"> <input ng-model=\"vm.drug.special_instruction\" type=\"text\" placeholder=\"Special Instructions\" class=\"form-control input-md\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Frequency</label> <div class=\"col-md-8\"> <select ng-model=\"vm.drug.frequency\" class=\"form-control\" ng-options=\"option for option in vm.frequency\"> <option value=\"\" disabled>Select frequency option</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Duration <span class=\"text-danger\">*</span></label> <div class=\"col-md-4\"> <input ng-model=\"vm.drug.duration\" type=\"text\" placeholder=\"Duration\" class=\"form-control input-md\" required> </div> <div class=\"col-md-4\"> <select ng-model=\"vm.drug.duration_type\" class=\"form-control\" ng-options=\"option for option in vm.durationType\" required> <option value=\"\" disabled>Select duration option</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Minimum buyable quantity</label> <div class=\"col-md-8\"> <input ng-model=\"vm.drug.minimum_buyable_qty\" type=\"text\" placeholder=\"Minimum buyable quantity\" class=\"form-control input-md\"> </div> </div> <style> div.col-md-4>label>input { visibility: hidden; } div.col-md-4>label { display: block; margin: 0 0 0 -10px; /**padding: 0 0 20px 0; */ width: 300%; height: 100%; } div.col-md-4>label>img { display: inline-block; height: 70px; width: 70px; background: none; } div.col-md-4>label>input:checked+img { background: url(https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Graukarte.svg/1200px-Graukarte.svg.png); background-repeat: no-repeat; background-position: center center; background-size: 30px 30px; background-color: lightgray; opacity:0.6; } </style> <div class=\"form-group text-center\"> <a ng-if=\"vm.drug.new\" ng-disabled=\"userForm.$invalid\" class=\"btn btn-success\" ng-click=\"vm.manageDrugMaster()\">Save to Master</a> <a ng-if=\"!vm.drug.new\" ng-disabled=\"userForm.$invalid\" class=\"btn btn-success\" ng-click=\"vm.manageDrugMaster()\">Update</a> <a ng-if=\"vm.drug.new\" ng-click=\"vm.clearForm()\" class=\"btn btn-danger\">Cancel</a> </div><br></div> </fieldset> </form></script><div class=\"row\" ng-if=\"vm.drugs.length==0\"><h3>No result found</h3></div><div class=\"row\"><div class=\"col-md-1 form-group\"><a ng-click=\"vm.SelectRecord();\" class=\"btn btn-lg btn-primary\" ng-bootbox-title=\"Add New Drug\" ng-bootbox-custom-dialog=\"\" ng-bootbox-custom-dialog-template=\"form_drug.html\"><span class=\"glyphicon glyphicon-plus\"></span> Add</a></div><div class=\"col-md-3 form-group\"><a ng-if=\"vm.showSave\" ng-click=\"vm.AddRecord()\" class=\"btn btn-lg btn-primary\"><span class=\"glyphicon glyphicon-save\"></span> Save</a><a ng-if=\"vm.selected.id\" class=\"btn btn-lg btn-primary\" ng-bootbox-title=\"Update Drug Master\" ng-bootbox-custom-dialog=\"\" ng-bootbox-custom-dialog-template=\"form_drug.html\"><span class=\"glyphicon glyphicon-edit\"></span> Update</a></div><div class=\"col-md-4\">&nbsp;</div><div class=\"col-md-1\">&nbsp;</div></div><div class=\"row\"><div class=\"col-md-12\" style=\"height: 500px; overflow-y: auto;\"><table class=\"table table-bordered\"><thead style=\"background: #f5f5f5;\"><tr><th class=\"text-center\" rowspan=\"2\">SNo</th><th class=\"text-center\" rowspan=\"2\">Composition Name</th><th class=\"text-center\" rowspan=\"2\">Generic Name</th><th class=\"text-center\" rowspan=\"2\">Drug Name</th><th class=\"text-center\" rowspan=\"2\">Formulation</th><th class=\"text-center\" colspan=\"2\">Strength</th><th class=\"text-center\" colspan=\"2\">Dose</th><th class=\"text-center\" rowspan=\"2\">Route</th><th class=\"text-center\" rowspan=\"2\">When</th><th class=\"text-center\" rowspan=\"2\">Special Instructions</th><th class=\"text-center\" rowspan=\"2\">Frequency</th><th class=\"text-center\" colspan=\"2\">Duration</th><th class=\"text-center\" rowspan=\"2\">Minimum buyable quantity</th><th class=\"text-center\" rowspan=\"2\">Action</th></tr><tr><th class=\"text-center\">Value</th><th class=\"text-center\">Unit</th><th class=\"text-center\">Value</th><th class=\"text-center\">Unit</th><th class=\"text-center\">Value</th><th class=\"text-center\">Unit</th></tr></thead><tbody><tr ng-repeat=\"drug in vm.drugs | orderBy: \'generic\'\" ng-class=\"{\'alert-success\':drug.new,\'alert-info\':drug.id===vm.selected.id,\'alert-danger\':drug.active===false}\"><td ng-click=\"vm.SelectRecord(drug)\">{{($index + 1)}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.composition_name}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.generic}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.brand}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.formulation}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.strength}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.strength_unit}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.dose}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.dose_option}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.route}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.when}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.special_instruction}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.frequency}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.duration}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.duration_type}}</td><td ng-click=\"vm.SelectRecord(drug)\">{{drug.minimum_buyable_qty}}</td><td><center><button class=\"btn btn-default btn-sm\" ng-click=\"vm.deleteDrug(drug)\"><span class=\"glyphicon glyphicon-trash\"></span></button></center></td></tr></tbody></table></div></div>");
$templateCache.put("app/prescription/newprescription.tpl.html","<div ng-controller=\"PrescriptionCntrl as vm\"><div ng-if=\"vm.prescritpionList.length != 0\"><h4>Prescription :</h4><table class=\"table table-bordered\"><thead style=\"background: #81cded;\"><tr><th>S.No</th><th>Formulation. Drug Generic (Strength)</th><th>Dose</th><th>Route of Administration</th><th>Frequency</th><th>Duration</th><th>Total</th><th>BF/AF</th><th>Special Instructions</th><th>Minimum buyable quantity</th></tr></thead><tbody><tr ng-repeat=\"row in vm.prescritpionList\" ng-class=\"{\'alert-success\':row.new,\'alert-info\':row.id===vm.selectedDrug.id}\" ng-if=\"!row.operation\"><td>{{($index + 1)}}</td><td><button ng-click=\"vm.selectedDrug=row;vm.mode=\'edit\';\" ng-disabled=\"vm.disabled||saved\"><span class=\"fa fa-pencil\"></span></button>&nbsp; <button ng-click=\"vm.deletePrescriptionEntry($index);\" ng-disabled=\"vm.disabled||saved\"><span class=\"fa fa-close\"></span></button> {{row.formulation}}. {{row.brand}}<span ng-if=\"row.generic!=\'\'\">- {{row.generic}}</span> ({{row.strength}})</td><td><span ng-bind-html=\"row.dose | fractionSymbol\"></span> {{row.dose_option}}</td><td>{{row.route}}</td><td ng-if=\"row.frequency==\'Others\' || row.frequency==\'As and When Required\'\">{{row.frequencytext}}</td><td ng-if=\"row.frequency!=\'Others\' && row.frequency!=\'As and When Required\'\">{{row.frequency}}</td><td>{{row.duration}} {{row.duration_type}}</td><td>{{row.quantity}}</td><td>{{row.when}}</td><td>{{row.special_instruction}}</td><td>{{row.minimum_buyable_qty}}</td></tr><tr ng-if=\"vm.prescritpionList.length == 0\"><td colspan=\"10\" class=\"text-center\">No Prescription</td></tr></tbody></table><hr></div><div class=\"row\"><h4>Enter Prescription :</h4><div class=\"col-md-5\"><div ng-controller=\"DrugsTypeaheadCtrl as vm1\"><div class=\"input-group\" style=\"z-index: 2;\"><input type=\"text\" ng-model=\"vm.selectedDrug\" placeholder=\"Search medicine by brand / generic name\" uib-typeahead=\"o as o.brand for o in vm1.searchDrug($viewValue)\" typeahead-wait-ms=\"100\" typeahead-loading=\"loadingLocations\" typeahead-no-results=\"noResults\" class=\"form-control\" typeahead-template-url=\"{{vm1.location}}\" typeahead-on-select=\"vm.setTodrug($item,\'select\')\" ng-disabled=\"saved\" ng-change=\"consultationinputchanged()\"> <i ng-show=\"loadingLocations\" class=\"glyphicon glyphicon-refresh\"></i><div ng-show=\"noResults\"><i class=\"glyphicon glyphicon-remove\" ng-click=\"vm1.alertFunction()\"></i> No Results Found</div><span class=\"input-group-addon dropdown-toggle link\" id=\"basic-addon1\" ng-click=\"vm1.getFavourite()\" data-toggle=\"dropdown\" ng-disabled=\"saved\"><i class=\"fa fa-star\"></i></span><ul class=\"dropdown-menu link\" style=\"padding-left: 10px;\"><li ng-repeat=\"fav in vm1.allFavourite\"><i class=\"fa fa-star link\" ng-click=\"vm.removeFavourite(fav)\"></i> <span ng-click=\"vm.setTodrug(fav,\'fav\')\">{{fav.formulation}}<i ng-if=\"fav.formulation\">.</i>{{fav.brand}}<i ng-if=\"fav.brand\">-</i>{{fav.generic}}<span ng-if=\"fav.strength\">(</span>{{fav.strength}}<span ng-if=\"fav.strength\">)</span></span></li><li ng-if=\"!vm1.allFavourite.length>0\">No favourites</li></ul></div></div><br></div><div class=\"col-md-4\"></div><div class=\"col-md-2\"><button class=\"btn btn-primary pull-left\" ng-click=\"vm.SelectRecord()\" ng-bootbox-custom-dialog=\"\" ng-bootbox-custom-dialog-template=\"form_drug.html\" ng-bootbox-title=\"Add New Drug\"><span class=\"glyphicon glyphicon-plus\"></span> Add New Drug</button></div></div><form name=\"prescriptionForm\" autocomplete=\"off\"><div class=\"row\"><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedDrug.brand\" ng-disabled=\"true\" placeholder=\"Brand\" required=\"\"></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedDrug.generic\" ng-disabled=\"true\" placeholder=\"Generic Name\"></div><div class=\"col-md-3\"><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" ng-disabled=\"!vm.selectedDrug\" ng-model=\"vm.selectedDrug.strength\" placeholder=\"Strength\"></div><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" ng-disabled=\"!vm.selectedDrug\" ng-model=\"vm.selectedDrug.strength_unit\" placeholder=\"Unit\"></div></div><div class=\"col-sm-2\"><select ng-model=\"vm.selectedDrug.formulation\" ng-disabled=\"!vm.selectedDrug\" class=\"form-control\" ng-options=\"option for option in vm.formulationOption\"><option value=\"\" disabled=\"\">Select Formulation</option></select></div></div>&nbsp;<div class=\"row\"><div class=\"col-md-2\"><select ng-model=\"vm.selectedDrug.route\" ng-disabled=\"!vm.selectedDrug\" class=\"form-control\" ng-options=\"option for option in vm.routeofadmin\"><option value=\"\" disabled=\"\">Select Route of Administration</option></select></div><div class=\"col-md-2\"><select ng-model=\"vm.selectedDrug.when\" ng-disabled=\"!vm.selectedDrug\" class=\"form-control\" ng-options=\"option for option in vm.whenOption\"><option value=\"\" disabled=\"\">When to take your medicine</option></select></div><div class=\"col-md-3\"><div class=\"col-md-6\"><input type=\"text\" class=\"form-control text-right\" ng-disabled=\"!vm.selectedDrug\" ng-model=\"vm.selectedDrug.dose\" ng-change=\"vm.calculateTotalOfTablets();\" placeholder=\"Dosage\"></div><div class=\"col-md-6 pull-right\"><select ng-model=\"vm.selectedDrug.dose_option\" ng-disabled=\"!vm.selectedDrug\" class=\"form-control\" ng-options=\"option for option in vm.doseOption\" ng-change=\"vm.calculateTotalOfTablets();\"><option value=\"\" disabled=\"\">Select dosage option</option></select></div></div><div class=\"col-sm-2\"><select ng-model=\"vm.selectedDrug.frequency\" ng-disabled=\"!vm.selectedDrug\" class=\"form-control\" ng-options=\"option for option in vm.frequency\" ng-change=\"vm.updateForm();vm.calculateTotalOfTablets();\"><option value=\"\" disabled=\"\">Select Frequency</option></select></div><div class=\"col-sm-2\" ng-if=\"vm.selectedDrug.frequency == \'Others\'||vm.selectedDrug.frequency == \'As and When Required\'\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedDrug.frequencytext\" placeholder=\"Frequency\"></div></div>&nbsp;<div class=\"row\"><div class=\"col-md-3\"><div class=\"col-md-6\"><input type=\"text\" numbers-only=\"\" class=\"form-control text-right\" ng-disabled=\"!vm.selectedDrug\" ng-model=\"vm.selectedDrug.duration\" ng-change=\"vm.calculateTotalOfTablets();\" placeholder=\"Duration\"></div><div class=\"col-md-6\"><select ng-model=\"vm.selectedDrug.duration_type\" ng-disabled=\"!vm.selectedDrug\" class=\"form-control\" ng-options=\"option for option in vm.durationType\" ng-change=\"vm.calculateTotalOfTablets();\"><option value=\"\" disabled=\"\">Select</option></select></div></div><div class=\"col-md-2\" ng-if=\"vm.selectedDrug.formulation!=\'Syrup\'\"><input type=\"text\" class=\"form-control text-right\" ng-disabled=\"!vm.selectedDrug\" ng-model=\"vm.selectedDrug.quantity\" placeholder=\"Total\"></div><div class=\"col-md-3\"><textarea type=\"text\" ng-disabled=\"!vm.selectedDrug\" class=\"form-control\" ng-model=\"vm.selectedDrug.special_instruction\" placeholder=\"Special Instructions (Optional)\"></textarea></div><div class=\"col-md-2\"><input type=\"text\" class=\"form-control text-right\" ng-disabled=\"!vm.selectedDrug\" ng-model=\"vm.selectedDrug.minimum_buyable_qty\" placeholder=\"Minimum buyable quantity\"></div></div><br><div class=\"row\"><div class=\"col-md-6 pull-right\"><a class=\"btn btn-primary pull-right\" ng-click=\"vm.clearForm()\">Clear</a> <button ng-hide=\"vm.mode==\'edit\'\" ng-disabled=\"!prescriptionForm.$valid\" class=\"btn btn-primary pull-right\" ng-click=\"vm.addToList()\" style=\"margin-right: 10px;\">Add</button> <button ng-if=\"vm.mode==\'edit\'\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\" ng-click=\"vm.clearForm();vm.mode=undefined;\">Update</button></div></div></form><hr><div class=\"row\"><div class=\"col-md-12\"><div style=\"margin-right:15px; padding-bottom:20px;\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div style=\"margin-right:15px; padding-bottom:20px;\"></div></div></div></div><script type=\"text/ng-template\" id=\"form_drug.html\"><form name=\"userForm\" class=\"form-horizontal\" ng-controller=\"DrugEditCtrl as vm\" autocomplete=\"off\"> <fieldset> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Drug Name<span class=\"text-danger\">*</span></label> <div class=\"col-md-8\"> <input type=\"text\" placeholder=\"Drug Name\" class=\"form-control input-md\" ng-model=\"vm.drug.brand\" uib-typeahead=\"o.brand as o.brand for o in vm.searchDrugname($viewValue)\" typeahead-wait-ms=\"100\" typeahead-no-results=\"noResults\" ng-disabled=\"saved\" required> <!-- typeahead-on-select=\"vm.searchDrug($item.drug_name)\"--> <ul class=\"dropdown-menu link\" style=\"padding-left: 10px;\"> <li ng-repeat=\"brand.brand in vm.drugs\">{{drugs.brand.brand}}</li> </ul> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Formulation<span class=\"text-danger\">*</span></label> <div class=\"col-md-4\" ng-model=\"vm.drug.formulation\"> <label title=\"tablet\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 100px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"tablet\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\tablet.svg\"><span style=\"position: absolute; top: 65px; left: 32px;\">Tablet</span> </label> <label title=\"lotion\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 1px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"lotion\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\lotion.svg\"> <span style=\"position: absolute; top: 65px; left: 33px;\">Lotion</span> </label> <label title=\"capsules\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:200px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"capsules\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\capsul.svg\"> <span style=\"position: absolute; top: 65px; left: 25px;\">Capsules</span> </label> <label title=\"drops\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 200px; left: 250px;\"> <input type=\"radio\" name=\"foo\" value=\"drops\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\drops.svg\"> <span style=\"position: absolute; top: 65px; left: 35px;\">Drops</span> </label> <label title=\"injection\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:1px;left:50px;\"> <input type=\"radio\" name=\"foo\" value=\"injection\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\injection.svg\"> <span style=\"position: absolute; top: 60px; left: 25px;\">Injection</span> </label> <label title=\"soap\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:100px;left:50px;\"> <input type=\"radio\" name=\"foo\" value=\"soap\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\soap.svg\"> <span style=\"position: absolute; top: 65px; left: 35px;\">Soap</span> </label> <label title=\"cream\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:200px;left:50px;\"> <input type=\"radio\" name=\"foo\" value=\"cream\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\cream.svg\"> <span style=\"position: absolute; top: 65px; left: 33px;\">Cream</span> </label> <label title=\"oil\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:300px;left:50px;\"> <input type=\"radio\" name=\"foo\" value=\"oil\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\oil.svg\"> <span style=\"position: absolute; top: 65px; left: 40px;\">Oil</span> </label> <label title=\"ointment\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:1px; left:250px;\"> <input type=\"radio\" name=\"foo\" value=\"ointment\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\oinment.svg\"> <span style=\"position: absolute; top: 65px; left: 25px;\">Oinment</span> </label> <label title=\"suspension\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:100px; left: 250px;\"> <input type=\"radio\" name=\"foo\" value=\"suspension\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\suspension.svg\"> <span style=\"position: absolute; top: 65px; left: 20px;\">Suspension</span> </label> <label title=\"gel\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:300px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"gel\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\gel.svg\"><span style=\"position: absolute; top: 65px; left: 40px;\">Gel</span> </label> <label title=\"powder\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:300px; left: 250px;\"> <input type=\"radio\" name=\"foo\" value=\"powder\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\powder.svg\"><span style=\"position: absolute; top: 65px; left: 33px;\">Powder</span> </label> <label title=\"syrup\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 400px; left: 50px;\"> <input type=\"radio\" name=\"foo\" value=\"syrup\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\syrup.svg\"> <span style=\"position: absolute; top: 65px; left: 35px;\">Syrup</span> </label> <label title=\"sachet\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 400px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"sachet\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\sachet-new1.png\" > <span style=\"position: absolute; top: 65px; left: 40px;\">Sachet</span> </label> <label title=\"vaccination\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top:400px; left: 270px;\"> <input type=\"radio\" name=\"foo\" value=\"vaccination\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\vaccination-new1.png\"> <span style=\"position: absolute; top: 65px; left: 10px;\">Vaccination</span> </label> <label title=\"inhalation\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 500px; left: 65px;\"> <input type=\"radio\" name=\"foo\" value=\"inhalation\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\inhaler-new1.png\"> <span style=\"position: absolute; top: 65px; left: 20px;\">Inhalation</span> </label> <label title=\"others\" ng-model=\"vm.drug.formulation\" style=\"position: absolute; top: 500px; left: 150px;\"> <input type=\"radio\" name=\"foo\" value=\"others\" ng-model=\"vm.drug.formulation\" /> <img src=\"Content\\Images\\drug-others1.png\"> <span style=\"position: absolute; top: 65px; left: 30px;\">Others</span> </label> </div> </div> <div class=\"form-group\" style=\"margin-top:580px;\"> <label class=\"col-md-4 control-label\">Generic Name</label> <div class=\"col-md-8\"> <input ng-model=\"vm.drug.generic\" type=\"text\" placeholder=\"Generic name\" class=\"form-control input-md\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Strength</label> <div class=\"col-md-4\"> <input ng-model=\"vm.drug.strength\" type=\"text\" placeholder=\"Strength\" class=\"form-control input-md\"> </div> <div class=\"col-md-4\"> <input ng-model=\"vm.drug.strength_unit\" type=\"text\" placeholder=\"Unit\" class=\"form-control input-md\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Dose</label> <div class=\"col-md-4\"> <input ng-model=\"vm.drug.dose\" type=\"text\" placeholder=\"Dose\" class=\"form-control input-md\"> </div> <div class=\"col-md-4\"> <select ng-model=\"vm.drug.dose_option\" class=\"form-control\" ng-options=\"option for option in vm.doseOption\"> <option value=\"\" disabled>Select dosage option</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Route</label> <div class=\"col-md-8\"> <select ng-model=\"vm.drug.route\" class=\"form-control\" ng-options=\"option for option in vm.routeofadmin\"> <option value=\"\" disabled>Select Route of Administration</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">When</label> <div class=\"col-md-8\"> <select ng-model=\"vm.drug.when\" class=\"form-control\" ng-options=\"option for option in vm.whenOption\"> <option value=\"\" disabled>Select option</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Spl Instructions</label> <div class=\"col-md-8\"> <input ng-model=\"vm.drug.special_instruction\" type=\"text\" placeholder=\"Special Instructions\" class=\"form-control input-md\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Frequency</label> <div class=\"col-md-8\"> <select ng-model=\"vm.drug.frequency\" class=\"form-control\" ng-options=\"option for option in vm.frequency\"> <option value=\"\" disabled>Select frequency option</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Duration</label> <div class=\"col-md-4\"> <input ng-model=\"vm.drug.duration\" type=\"text\" placeholder=\"Duration\" class=\"form-control input-md\"> </div> <div class=\"col-md-4\"> <select ng-model=\"vm.drug.duration_type\" class=\"form-control\" ng-options=\"option for option in vm.durationType\"> <option value=\"\" disabled>Select duration option</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Minimum buyable quantity</label> <div class=\"col-md-8\"> <input ng-model=\"vm.drug.minimum_buyable_qty\" type=\"text\" placeholder=\"Minimum buyable quantity\" class=\"form-control input-md\"> </div> </div> <style> div.col-md-4>label>input { visibility: hidden; } div.col-md-4>label { display: block; margin: 0 0 0 -10px; /**padding: 0 0 20px 0; */ width: 300%; height: 100%; } div.col-md-4>label>img { display: inline-block; height: 70px; width: 70px; background: none; } div.col-md-4>label>input:checked+img { background: url(https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Graukarte.svg/1200px-Graukarte.svg.png); background-repeat: no-repeat; background-position: center center; background-size: 30px 30px; background-color: lightgray; opacity:0.6; } </style> <div class=\"form-group text-center\"> <a ng-if=\"vm.drug.new\" ng-disabled=\"userForm.$invalid\" class=\"btn btn-success\" ng-click=\"vm.manageDrugMaster()\">Save to Master</a> <a ng-if=\"!vm.drug.new\" ng-disabled=\"userForm.$invalid\" class=\"btn btn-success\" ng-click=\"vm.manageDrugMaster()\">Update</a> <a ng-if=\"vm.drug.new\" ng-click=\"vm.clearForm()\" class=\"btn btn-danger\">Cancel</a> </div> </fieldset> </form></script>");
$templateCache.put("app/prescription/print_prescription.tpl.html","<div ng-controller=\"patientviewController as vm\" id=\"printSection\"><div class=\"panel panel-primary panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"col-xs-6\"><label>Name: {{authentication.account_info.Account.fullName}}</label></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><div class=\"col-xs-3\"><label>Patient Name</label></div><div class=\"col-xs-4\"><label>{{patient_details.record_info.Record.label}}</label></div></div><div class=\"col-md-6\"><div class=\"col-xs-3\"><label>Patient Id</label></div><div class=\"col-xs-2\"><label>{{patient_details.record_info.Record.mr_number}}</label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"col-xs-3\"><label>Age</label></div><div class=\"col-xs-4\"><span ng-hide=\"recordAge.years==0\">{{recordAge.years}} yrs,</span> <span ng-hide=\"recordAge.months==0\">{{recordAge.months}} m</span> <span ng-show=\"recordAge.years==0 &&recordAge.months==0\">{{recordAge.days}} days</span></div></div><div class=\"col-md-6\"><div class=\"col-xs-3\"><label>Sex</label></div><div class=\"col-xs-2\"><label>{{patient_details.demographics[0].gender}}</label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"col-xs-3\"><label>Visit Date</label></div><div class=\"col-xs-2\"><label>{{doctorProfile.today}}</label></div></div></div></div><div class=\"panel panel-primary\"><div class=\"row\" style=\"margin-left: 0px !important;\"><div class=\"col-xs-12\"><h5><u>ALLERGIES</u></h5>&nbsp;&nbsp;&nbsp; <label ng-if=\"allergies.food==\'\'&&allergies.drug==\'\'&&allergies.environment==\'\'&&allergies.others==\'\'||allergies.food==undefined&&allergies.drug==undefined&&allergies.environment==undefined&&allergies.others==undefined\">No Known Allergy</label> <span>{{allergies.food}} {{allergies.drug}} {{allergies.environment}} {{allergies.others}}</span></div></div><div class=\"row\" ng-if=\"presData.type==\'detailedPres\' && presData.complaint!= \'undefined\'\" style=\"margin-left: 0px !important;\"><div class=\"col-xs-12\"><h5><u>CHIEF COMPLAINTS</u></h5>&nbsp;&nbsp;&nbsp;<span><b ng-repeat=\"issue in presData.complaint.issues\" style=\"color: black;\">{{issue.complaint_category | capitalize}} - {{issue.days}} days</b> {{presData.complaint.medicine_given}} {{presData.complaint.temperature}} {{presData.complaint.unit}} {{presData.complaint.other_information}}</span></div></div><div class=\"row\" style=\"margin-left: 0px !important;display:none;\" id=\"noprint\" ng-if=\"presData.op_review.notes!=\'\'\"><div class=\"col-xs-12\"><h5><u>H/o PRESENTING ILLNESS</u></h5>&nbsp;&nbsp;&nbsp;<span>{{presData.op_review.notes}}</span></div></div><div class=\"row\" style=\"margin-left: 0px !important;\" ng-if=\"presData.vitalData!=\'\'&&presData.vitalData&&presData.vitalData!=undefined\"><div class=\"col-xs-12\"><h5><u>Vitals</u></h5><span ng-repeat=\"data in presData.vitalData\" ng-if=\"data.name!=\'date\'&&data.text\">&nbsp;&nbsp;&nbsp;<div class=\"col-xs-3\"><span>{{data.name | capitalize}}</span></div>&nbsp;&nbsp;<div class=\"col-xs-2\"><span>{{data.text}}</span></div><br></span></div></div><div class=\"row\" ng-if=\"presData.type==\'detailedPres\' && presData.op_review.findings!=\'\' && presData.op_review.findings\" style=\"margin-left: 0px !important;\"><div class=\"col-xs-12\"><h5><u>EXAMINATION FINDINGS</u></h5>&nbsp;&nbsp;&nbsp;<span>{{presData.op_review.findings}}</span></div></div><div class=\"row\" ng-if=\"presData.op_review.lab_tests.length>0 && presData.op_review.lab_tests!=\'\' && presData.op_review.lab_tests.length!=0\" style=\"margin-left: 0px !important;\"><div class=\"col-xs-12\"><h5><u>TESTS REQUESTED</u></h5><span ng-repeat=\"test in presData.op_review.lab_tests\">&nbsp;&nbsp;&nbsp; {{test}}<br></span> <label ng-if=\"presData.op_review.lab_tests.length==0\">&nbsp;&nbsp;&nbsp;No Tests</label></div></div><div class=\"row\" style=\"margin-left: 0px !important;\" ng-if=\"presData.op_review.diagnosis!=\'\'&&presData.op_review.diagnosis&&presData.op_review.diagnosis!=undefined\"><div class=\"col-xs-12\"><h5><u>DIAGNOSIS</u></h5>&nbsp;&nbsp;&nbsp;<span>{{presData.op_review.diagnosis}}</span></div></div><div class=\"row\" ng-if=\"prescriptionList.entries.length>0\" style=\"margin-left: 0px !important; margin-right: 0px !important;\"><div class=\"col-xs-12\"><h5><u>{{(prescriptionList.entries.length > 0 ? \"DRUG PRESCRIPTION\":\"No prescription added.\")}}</u></h5><span ng-repeat=\"row in prescriptionList.entries | orderBy: \'date\'\">&nbsp;&nbsp;&nbsp; {{($index + 1)}}.&nbsp <label>{{row.formulation}}-{{row.generic_name}}-{{row.brand_name}}-{{row.strength}}</label> <span ng-if=\"row.reason!=\'\'\" for=\"\">, {{row.reason}}</span> <span ng-if=\"row.dose!=\'\'\" for=\"\">, Dose - {{row.dose}}</span> <span ng-if=\"row.frequency!=\'\'\" for=\"\">, {{row.frequency}}</span> <span ng-if=\"row.route!=\'\'\" for=\"\">, {{row.route}}</span> <span ng-if=\"row.duration!=\'\'\" for=\"\">, Duration - {{row.duration}}</span> <span ng-if=\"row.quantity!=\" \"\"=\"\" for=\"\">,{{row.quantity}}</span> <span ng-if=\"row.remarks!=\'\'\" for=\"\">, {{row.remarks}}</span><br></span></div></div><div class=\"row\" ng-if=\"presData.op_review.advice!=\'\'&&presData.op_review.advice\" style=\"margin-left: 0px !important;\"><div class=\"col-xs-12\"><h5><u>ADVICE</u></h5><div class=\"row\" ng-if=\"presData.op_review.advice!=\'\'\"><div class=\"col-xs-12\">&nbsp;&nbsp;&nbsp;<span>{{presData.op_review.advice}}</span></div></div></div></div><div class=\"row\" style=\"margin-left: 0px !important;\" ng-if=\"presData.op_review.follow_up_date!=\'\'&&presData.op_review.follow_up_date!=undefined\"><div class=\"col-xs-12\"><h5><u>FOLLOW UP</u></h5><span>&nbsp; {{ presData.op_review.follow_up_date | date: \'dd-MMM-yyyy\'}}</span></div></div><div class=\"row\" style=\"margin-left: 0px !important;\" ng-if=\"presData.op_review.follow_up_text!=\'\'&&presData.op_review.follow_up_text!=undefined\"><div class=\"col-xs-12\"><h5><u>FOLLOW UP</u></h5><span>&nbsp; {{ presData.op_review.follow_up_text}}</span></div></div><br><div class=\"row\" style=\"margin-left: 0px !important;\"><div class=\"col-xs-4 pull-right\"><span>_______________________________</span><br><span style=\"margin-left: 18%;\">Doctor Signature</span></div></div><br></div></div>");
$templateCache.put("app/vac/addbrand.html","<div class=\"row\"><div class=\"col-sm-2 col-md-2 col-lg-2\"></div><div class=\"col-sm-8 col-md-8 col-lg-8\"><input class=\"form-control\" type=\"text\" name=\"userName\" id=\"inputtag\" ng-model=\"taginput\" ng-click=\"changeinput()\" placeholder=\"Add Drug Name\"><br><div id=\"addtag\" style=\"height: 250px; overflow-y: scroll\"><div ng-repeat=\"data in data1\"><div class=\"col-sm-3 col-lg-3 col-md-3\" style=\"border: 1px solid black;padding: 8px !important; border-radius:10px;margin: 8px !important;\">{{data.brand}}<img src=\"Content/Images/canceltag.png\" height=\"20\" width=\"20\" style=\"float:right\" ng-click=\"closetag(data)\"></div></div></div></div><div class=\"col-sm-2 col-md-2 col-lg-2\"><button class=\"btn btn-primary\" ng-click=\"Entervac()\">Enter</button></div></div>");
$templateCache.put("app/vac/addmaster.html","<form name=\"userForm\" class=\"form-horizontal\" ng-controller=\"ListEditCtrl as vme\"><fieldset><div class=\"form-group\"><label class=\"col-md-4 control-label\">Age Category</label><div class=\"col-md-8\"><select class=\"form-control agegroup\" ng-model=\"addmastervaccine.age_group\" style=\"width: 100%;height: 30px;border-radius: 4px;border: 1px solid #00A0E3;\"><option>Birth</option><option>6 Weeks</option><option>10 Weeks</option><option>14 Weeks</option><option>6 Months</option><option>7-8 Months</option><option>9-12 Months</option><option>15-18 Months</option><option>18-24 Months</option><option>4-6 Years</option><option>10 Years</option><option>11-14 Years</option><option>15-18 Years</option></select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Vaccination name<span class=\"text-danger\">*</span></label><div class=\"col-md-8\"><input ng-model=\"addmastervaccine.name\" type=\"text\" placeholder=\"Vaccination name\" class=\"form-control input-md\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Description</label><div class=\"col-md-8\"><textarea ng-model=\"addmastervaccine.description\" class=\"form-control\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Disease</label><div class=\"col-md-8\"><textarea ng-model=\"addmastervaccine.disease\" class=\"form-control\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Gender<span class=\"text-danger\">*</span></label><div class=\"col-md-8\"><select ng-model=\"addmastervaccine.gender\" class=\"form-control\" required=\"\"><option value=\"both\">Both</option><option value=\"male\">Male</option><option value=\"female\">Female</option></select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Site<span class=\"text-danger\">*</span></label><div class=\"col-md-8\"><select ng-model=\"addmastervaccine.site\" class=\"form-control\" required=\"\"><option value=\"Intramuscular (IM)\">Intramuscular (IM)</option><option value=\"Oral\">Oral</option><option value=\"Subcutaneous (SC)\">Subcutaneous (SC)</option></select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Side Effects</label><div class=\"col-md-8\"><textarea ng-model=\"addmastervaccine.side_effects\" class=\"form-control\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Brands <span class=\"text-danger\">*</span></label><div class=\"col-md-8\"><button class=\"btn btn-primary\" ng-click=\"addmasterbrand()\">Add/Edit Brand</button></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Dependency</label><div class=\"col-md-8\"><div class=\"col-md-6\" style=\"padding: 0;\"><input type=\"text\" placeholder=\"vaccine Name\" ng-model=\"addmastervaccine1.vaccinename\" class=\"form-control\"></div><div class=\"col-md-6\"><input type=\"text\" placeholder=\"Enter Days\" ng-model=\"addmastervaccine1.vaccinedays\" class=\"form-control\"></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Remarks</label><div class=\"col-md-8\"><textarea ng-model=\"addmastervaccine.remarks\" class=\"form-control\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Mandatory</label><div class=\"col-md-8\"><select ng-model=\"addmastervaccine.status\" class=\"form-control\" required=\"\"><option value=\"true\">True</option><option value=\"false\">False</option></select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Messaging type</label><div class=\"col-md-8\"><label><input type=\"radio\" id=\"msg_type_check1\" name=\"message_type\" value=\"1\" ng-click=\"callmedia(\'plaintext\')\"> Plain text</label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_2\" name=\"message_type\" value=\"2\" ng-click=\"callmedia(\'Image\')\"> Image</label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_3\" name=\"message_type\" value=\"3\" ng-click=\"callmedia(\'Audio\')\"> Audio</label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_4\" name=\"message_type\" value=\"4\" ng-click=\"callmedia(\'Video\')\"> Video</label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_5\" name=\"message_type\" value=\"5\" ng-click=\"callmedia(\'Links\')\"> Links</label>&nbsp;&nbsp;</div></div><br><div class=\"form-group text-center\"><a class=\"btn btn-success\" ng-click=\"Addmasterdata()\">Add</a> <a class=\"btn btn-danger\" ng-click=\"Addmasterdataclear()\">Clear</a></div></fieldset></form>");
$templateCache.put("app/vac/addmasterbrand.html","<div class=\"row\"><div class=\"col-sm-2 col-md-2 col-lg-2\"></div><div class=\"col-sm-8 col-md-8 col-lg-8\"><input class=\"form-control\" type=\"text\" name=\"userName\" id=\"inputtags\" ng-click=\"changeinputs()\" placeholder=\"Add Drug Name\"><br><div id=\"addtag\" style=\"height: 250px; overflow-y: scroll\"><div ng-repeat=\"data in data2\"><div class=\"col-sm-3 col-lg-3 col-md-3\" style=\"border: 1px solid black;padding: 8px !important; border-radius:10px;margin: 8px !important;\">{{data}}<img src=\"Content/Images/canceltag.png\" height=\"20\" width=\"20\" style=\"float:right\" ng-click=\"closetags(data)\"></div></div></div></div><div class=\"col-sm-2 col-md-2 col-lg-2\"><button class=\"btn btn-primary\" ng-click=\"change_inputs()\">Enter</button></div></div>");
$templateCache.put("app/vac/addmedia.html","<div ng-if=\"media == \'plaintext\'\"><h4>Enter Text :</h4><br><textarea rows=\"3\" cols=\"100\" id=\"textmedia\">\n       \n    </textarea></div><div ng-if=\"media == \'Links\'\"><h4>Links :</h4><br><textarea rows=\"3\" cols=\"100\" id=\"linksmedia\"></textarea></div><div ng-if=\"media == \'Image\'\"><div class=\"col-xs-8 ng-scope\" flow-init=\"{singleFile:true}\" flow-name=\"flowUpload\" flow-file-added=\"uploadmyfile($file, $event, $flow)\"><div class=\"\" style=\"margin:0px;\"><div class=\"\"><i tooltip=\"Upload photo\" class=\"fa fa-upload cursor text-primary flow-container link\" flow-btn=\"\" flow-attrs=\"{accept:\'image/*\'}\">&nbsp;&nbsp; Upload Photo<input type=\"file\" accept=\"image/*\" style=\"visibility: hidden; position: absolute; width: 1px; height: 1px;\"></i></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ng-show=\"uploadingimage\">Uploading Image Please Wait...</div></div></div><div ng-if=\"imagee\"><br><br>Upladed Photo :<br><img src=\"{{imagee}}\" height=\"200\" width=\"200\"></div></div><div ng-if=\"media == \'Audio\'\"><div class=\"col-xs-8 ng-scope\" flow-init=\"{singleFile:true}\" flow-name=\"flowUpload\" flow-file-added=\"uploadaudiofile($file, $event, $flow)\"><div class=\"\" style=\"margin:0px;\"><div class=\"\"><i tooltip=\"Upload mp3\" class=\"fa fa-upload cursor text-primary flow-container link\" flow-btn=\"\" flow-attrs=\"{accept:\'audio/*\'}\">&nbsp;&nbsp; Upload mp3<input type=\"file\" accept=\"audio/*\" style=\"visibility: hidden; position: absolute; width: 1px; height: 1px;\"></i></div><div class=\"clearfix\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ng-show=\"uploadingaudio\">Uploading mp3 Please Wait...</div></div></div><div ng-if=\"audioplays\"><br>Upladed mp3 :<br><audio controls=\"\"><source src=\"https://test.epicare.net/helyxonapi/cloud/mp3/upload/aud_1627896590vzwJI9a4jh.mp3\" type=\"audio/mpeg\"></audio></div></div><div ng-if=\"media == \'Video\'\"><div class=\"col-xs-8 ng-scope\" flow-init=\"{singleFile:true}\" flow-name=\"flowUpload\" flow-file-added=\"uploadvideofile($file, $event, $flow)\"><div class=\"\" style=\"margin:0px;\"><div><i tooltip=\"Upload Video\" class=\"fa fa-upload cursor text-primary flow-container link\" flow-btn=\"\" flow-attrs=\"{accept:\'video/*\'}\">&nbsp;&nbsp; Upload Video<input type=\"file\" accept=\"video/*\" style=\"visibility: hidden; position: absolute; width: 1px; height: 1px;\"></i></div><div class=\"clearfix\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ng-show=\"uploadingvideo\">Uploading Video Please Wait...</div></div></div><div ng-if=\"videoplaysrc\"><video class=\"first\" autoplay=\"autoplay\" muted=\"muted\" loop=\"\" controls=\"\" src=\"{{videoplays}}\" preload=\"metadata\"></video></div><style>\n\n    .loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 60px;\n        height: 60px;\n        animation: spin 2s linear infinite;\n      }\n      \n      @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n      }\n\n</style>");
$templateCache.put("app/vac/combinevac.html","<style>\n.btnstyle{\n    margin: 4px !important;\n}\n</style><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><span>Name : <input type=\"text\" class=\"form-control\"></span> <span>Price : <input type=\"number\" class=\"form-control\" min=\"0\"></span></div><div class=\"col-md-6\"><span>Manufacturer : <input type=\"text\" class=\"form-control\"></span> <span>Dosage : &nbsp; <span><input type=\"text\" class=\"form-control\"></span></span></div></div></div><br><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-md btn-outline-primary btnstyle\" ng-repeat=\"data in groupedvaccines\">{{data.name}} &nbsp;&nbsp;<i class=\"far fa-times-circle\" style=\"font-size: 15px;\" ng-click=\"removecombine(data)\"></i></button></div></div>");
$templateCache.put("app/vac/updateaddbrand.html","<div class=\"row\"><div class=\"col-sm-2 col-md-2 col-lg-2\"></div><div class=\"col-sm-8 col-md-8 col-lg-8\"><div id=\"addtag\" style=\"height: 250px; overflow-y: scroll\"><div ng-repeat=\"data in vacbrands\"><div class=\"col-sm-3 col-lg-3 col-md-3\" style=\"border: 1px solid black;padding: 8px !important; border-radius:15px;margin: 8px !important;\">{{data.brand_name}}<img src=\"Content/Images/canceltag.png\" height=\"20\" width=\"20\" style=\"float:right\" ng-click=\"removetag(data)\"></div></div></div></div><div class=\"col-sm-2 col-md-2 col-lg-2\"></div></div>");
$templateCache.put("app/vac/updatedetails.html","<form name=\"userForm\" class=\"form-horizontal\" ng-controller=\"ListEditCtrl as vme\"><fieldset><div class=\"form-group\"><label class=\"col-md-4 control-label\">Age Category</label><div class=\"col-md-8\"><input ng-model=\"masterdata.age_group\" type=\"text\" placeholder=\"Days\" class=\"form-control input-md\" min=\"0\" required=\"\" disabled=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Vaccination name<span class=\"text-danger\">*</span></label><div class=\"col-md-8\"><input ng-model=\"masterdata.name\" type=\"text\" placeholder=\"Vaccination name\" class=\"form-control input-md\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Description</label><div class=\"col-md-8\"><textarea ng-model=\"masterdata.description\" class=\"form-control\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Disease</label><div class=\"col-md-8\"><textarea ng-model=\"masterdata.disease\" class=\"form-control\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Gender</label><div class=\"col-md-8\"><select ng-model=\"masterdata.gender\" class=\"form-control\" required=\"\"><option value=\"both\">Both</option><option value=\"male\">Male</option><option value=\"female\">Female</option></select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Site</label><div class=\"col-md-8\"><select ng-model=\"masterdata.site\" class=\"form-control\" required=\"\"><option value=\"Intramuscular (IM)\">Intramuscular (IM)</option><option value=\"Oral\">Oral</option><option value=\"Subcutaneous (SC)\">Subcutaneous (SC)</option></select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Side Effects</label><div class=\"col-md-8\"><textarea ng-model=\"masterdata.side_effects\" class=\"form-control\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Brands</label><div class=\"col-md-8\"><button class=\"btn btn-primary\" ng-click=\"addbrand(masterdata,brandsdata)\">Add/Edit Brand</button></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\" ng-if=\"brandsdata.length > 0\">Inventory</label><div class=\"col-lg-8\"><span ng-repeat=\"data in brandsdata track by $index\"><div ng-if=\"brandsdata.length > 0\" class=\"col-lg-6\">{{data.brand_name}}</div><div ng-if=\"brandsdata.length > 0\" class=\"col-lg-6\"><select ng-model=\"inventory_dropdown[data]\" class=\"form-control\" required=\"\" ng-change=\"change_eshop_values(data.brand_name,data.id,inventory_dropdown[data])\"><option ng-repeat=\"item in getinventory_data\" value=\"{{item}}\" ng-selected=\"data.eshop_product_name==item.name\">{{item.name}}</option></select><br></div></span></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Dependency</label><div class=\"col-md-8\"><div class=\"col-md-6\" style=\"padding: 0;\"><input type=\"text\" placeholder=\"vaccine Name\" ng-model=\"dependencydata.vaccinename\" class=\"form-control\"></div><div class=\"col-md-6\"><input type=\"text\" placeholder=\"Enter Days\" ng-model=\"dependencydata.vaccinedays\" class=\"form-control\"></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Remarks</label><div class=\"col-md-8\"><textarea ng-model=\"masterdata.remarks\" class=\"form-control\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Mandatory</label><div class=\"col-md-8\"><select ng-model=\"masterdata.status\" class=\"form-control\" required=\"\"><option value=\"true\">True</option><option value=\"false\">False</option></select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">Messaging type</label><div class=\"col-md-8\"><label><input type=\"radio\" id=\"msg_type_check1\" name=\"message_type\" value=\"1\" ng-click=\"callmedia(\'plaintext\')\"> Plain text</label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_2\" name=\"message_type\" value=\"2\" ng-click=\"callmedia(\'Image\')\"> Image</label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_3\" name=\"message_type\" value=\"3\" ng-click=\"callmedia(\'Audio\')\"> Audio</label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_4\" name=\"message_type\" value=\"4\" ng-click=\"callmedia(\'Video\')\"> Video</label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_5\" name=\"message_type\" value=\"5\" ng-click=\"callmedia(\'Links\')\"> Links</label>&nbsp;&nbsp;</div></div><br><div class=\"form-group text-center\"><a class=\"btn btn-danger\" ng-click=\"clearalldata()\">Cancel</a> &nbsp; <a class=\"btn btn-success\" ng-click=\"Update_Record();updateinventory_data(masterdata.id,masterdata.eshop_product_id,masterdata.eshop_product_name)\">Update</a></div></fieldset></form>");
$templateCache.put("app/vac/vac_content.tpl.html","<h3><i class=\"glyphicon glyphicon-oil\"></i> Vaccination content</h3><hr><script type=\"text/ng-template\" id=\"form_vac_content.html\"><form name=\"userForm\" class=\"form-horizontal\" ng-controller=\"ListEditCtrl as vme\"> <fieldset> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Vaccination</label> <div class=\"col-md-8\"> <select required ng-disabled= \"!vme.o.new\" ng-model=\"vme.o.vaccine\" class=\"form-control\" ng-options=\"option.drug_name for option in vme.vacOptions\"> <option value=\"\" disabled selected>Select a vaccination</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\" >About</label> <div class=\"col-md-8\"> <textarea required rows=\"3\" ng-model=\"vme.o.about\" type=\"text\" placeholder=\"About info\" class=\"form-control input-md\"> </textarea> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\" >Disease</label> <div class=\"col-md-8\"> <textarea required rows=\"3\" ng-model=\"vme.o.disease\" placeholder=\"Disease info\" class=\"form-control input-md\"> </textarea> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Side effects</label> <div class=\"col-md-8\"> <textarea required rows=\"3\" ng-model=\"vme.o.side_effects\" placeholder=\"Side effects\" class=\"form-control input-md\"> </textarea> </div> </div> <div ng-if= \"!vme.o.new\" class=\"form-group\"> <label class=\"col-md-4 control-label\">Active</label> <div class=\"col-md-8\"> <select ng-model = \"vme.o.active\" class=\"form-control\"> <option value=\"true\">True</option> <option value=\"false\">False</option> </select> </div> </div> <div class=\"form-group text-center\"> <a ng-if= \"vme.o.new\" ng-disabled=\"userForm.$invalid\" class=\"btn btn-success\" ng-click=\"vme.addToList(vme.o)\">Add</a> <a ng-if= \"!vme.o.new\" ng-disabled=\"userForm.$invalid\" class=\"btn btn-success\" ng-click=\"vme.UpdateRecord(\'vac-content\')\">Update</a> <a ng-if= \"vme.o.new\" ng-click=\"vme.clearForm()\" class=\"btn btn-danger\">Clear</a> </div> </fieldset> </form></script><div class=\"row\"><div class=\"col-md-1 form-group\"><a ng-click=\"vm.SelectRecord();\" class=\"btn btn-lg btn-primary\" ng-bootbox-title=\"Add Vaccination Content\" ng-bootbox-custom-dialog=\"\" ng-bootbox-custom-dialog-template=\"form_vac_content.html\"><span class=\"glyphicon glyphicon-plus\"></span> Add</a></div><div class=\"col-md-3 form-group\"><a ng-if=\"vm.showSave\" ng-click=\"vm.AddRecord()\" class=\"btn btn-lg btn-primary\"><span class=\"glyphicon glyphicon-save\"></span> Save</a> <a ng-if=\"vm.selected && !vm.selected.new\" class=\"btn btn-lg btn-primary\" ng-bootbox-title=\"Update Vaccination Content\" ng-bootbox-custom-dialog=\"\" ng-bootbox-custom-dialog-template=\"form_vac_content.html\"><span class=\"glyphicon glyphicon-edit\"></span> Update</a></div><div class=\"col-md-4\">&nbsp;</div><div class=\"col-md-3\"><div class=\"form-horizontal pull-right\"><div class=\"form-group\"><input type=\"radio\" ng-change=\"vm.reloadList()\" class=\"mgr mgr-primary mgr-lg\" ng-model=\"vm.showAll\" name=\"radios\" id=\"radios-0\" value=\"all\" checked=\"checked\"> All&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type=\"radio\" ng-change=\"vm.reloadList()\" class=\"mgr mgr-primary mgr-lg\" ng-model=\"vm.showAll\" name=\"radios\" id=\"radios-1\" value=\"active\"> Active&nbsp;&nbsp; <input type=\"radio\" ng-change=\"vm.reloadList()\" class=\"mgr mgr-primary mgr-lg\" ng-model=\"vm.showAll\" name=\"radios\" id=\"radios-3\" value=\"inactive\"> Inactive</div></div></div><div class=\"col-md-1\">&nbsp;</div></div><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-bordered\"><thead style=\"background: #f5f5f5;\"><tr><th>SNo</th><th>Vaccine Name</th><th>About</th><th>Disease</th><th>Side Effects</th></tr></thead><tbody><tr ng-repeat=\"row in vm.records\" ng-click=\"vm.SelectRecord(row)\" ng-class=\"{\'alert-success\':row.new,\'alert-info\':row.vaccination_id===vm.selected.vaccination_id,\'alert-danger\':row.active===\'false\'}\"><td>{{($index + 1)}}</td><td>{{row.vaccination_name || row.vaccine.drug_name || row.vaccination || row.vaccination_id}}</td><td>{{row.about}}</td><td>{{row.disease}}</td><td>{{row.side_effects}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/vac/vac_master.tpl.html","<style>\n  th,td{\n    text-align: center;\n  }\n</style><head><link rel=\"stylesheet\" href=\"https://pro.fontawesome.com/releases/v5.10.0/css/all.css\" integrity=\"sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p\" crossorigin=\"anonymous\"></head><h3 style=\"margin-top:-18px;\"><i class=\"glyphicon glyphicon-tint\"></i>Vaccination Master</h3><script type=\"text/ng-template\" id=\"form_vaccination.html\"><form name=\"userForm\" class=\"form-horizontal\" ng-controller=\"ListEditCtrl as vme\"> <fieldset> <div class=\"form-group\"> <label class=\"col-md-4 control-label\" >Age in Days<span class=\"text-danger\">*</span></label> <div class=\"col-md-8\"> <input ng-model=\"vme.o.age_in_days\" type=\"number\" placeholder=\"Days\" class=\"form-control input-md\" min=\"0\" required> <!-- <span style=\"color:red\">( Note: Age in days should not start from \'0\' )</span> --> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\" >Vaccination name<span class=\"text-danger\">*</span></label> <div class=\"col-md-8\"> <input ng-model=\"vme.o.drug_name\" type=\"text\" placeholder=\"Vaccination name\" class=\"form-control input-md\" required> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\" >Description</label> <div class=\"col-md-8\"> <textarea ng-model=\"vme.o.description\" class=\"form-control\"></textarea> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\" >Disease</label> <div class=\"col-md-8\"> <textarea ng-model=\"vme.o.disease\" class=\"form-control\"></textarea> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Gender</label> <div class=\"col-md-8\"> <select ng-model=\"vme.o.gender\" class=\"form-control\" required> <option value=\"both\">Both</option> <option value=\"male\">Male</option> <option value=\"female\">Female</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Site</label> <div class=\"col-md-8\"> <select ng-model=\"vme.o.site\" class=\"form-control\" required> <option value=\"Intramuscular (IM)\">Intramuscular (IM)</option> <option value=\"Oral\">Oral</option> <option value=\"Subcutaneous (SC)\">Subcutaneous (SC)</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\" >Side Effects</label> <div class=\"col-md-8\"> <textarea ng-model=\"vme.o.side_effects\" class=\"form-control\"></textarea> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\" >Remarks</label> <div class=\"col-md-8\"> <textarea ng-model=\"vme.o.remarks\" class=\"form-control\"></textarea> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Mandatory</label> <div class=\"col-md-8\"> <select ng-model=\"vme.o.mandatory\" class=\"form-control\" required> <option value=\"true\">True</option> <option value=\"false\">False</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Messaging type</label> <div class=\"col-md-8\"> <label><input type=\"radio\" id=\"msg_type_check1\" name=\"message_type\" value=\"1\" ng-click=\"callmedia(\'plaintext\')\"> Plain text </label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_2\" name=\"message_type\" value=\"2\" ng-click=\"callmedia(\'Image\')\"> Image </label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_3\" name=\"message_type\" value=\"3\" ng-click=\"callmedia(\'Audio\')\"> Audio </label>&nbsp;&nbsp; <label><input type=\"radio\" id=\"msg_type_check_4\" name=\"message_type\" value=\"4\" ng-click=\"callmedia(\'Video\')\"> Video </label>&nbsp;&nbsp; </div> </div> <div ng-if= \"!vme.o.new\" class=\"form-group\"> <label class=\"col-md-4 control-label\">Active</label> <div class=\"col-md-8\"> <select ng-model = \"vme.o.active\" class=\"form-control\"> <option value=\"true\">True</option> <option value=\"false\">False</option> </select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">Update Brands</label> <div class=\"col-md-8\"> <span> <button class=\"btn btn-primary\" ng-click=\"addbrand(vme.o)\">Add Brand</button>&nbsp; <button class=\"btn btn-primary\" ng-click=\"Updatebrands(vme.o)\">Update Brand</button> </span> </div> </div> <br> <div class=\"form-group text-center\"> <a ng-if= \"vme.o.new\" ng-disabled=\"userForm.$invalid\" class=\"btn btn-success\" ng-click=\"vme.addToList(vme.o)\">Add</a> <a ng-if= \"!vme.o.new\" ng-disabled=\"userForm.$invalid\" class=\"btn btn-success\" ng-click=\"vme.UpdateRecord(\'vac-master\')\">Update</a> <a ng-if= \"vme.o.new\" ng-click=\"vme.clearForm()\" class=\"btn btn-danger\">Clear</a> </div> </fieldset> </form></script><button class=\"btn btn-md btn-primary mb-2\" ng-click=\"Addmastervaccine()\"><span class=\"glyphicon glyphicon-plus\"></span> Add</button> <button class=\"btn btn-md btn-default mb-2\" style=\"float: right;\" ng-click=\"viewstock()\">View Stock</button><div class=\"row\" ng-hide=\"true\"><div class=\"col-md-1 form-group\"><a ng-click=\"vm.SelectRecord();vm.setPageData();\" class=\"btn btn-lg btn-primary\" ng-bootbox-title=\"Add Vaccination\" ng-bootbox-custom-dialog=\"\" ng-bootbox-custom-dialog-template=\"form_vaccination.html\"><span class=\"glyphicon glyphicon-plus\"></span> Add</a></div><div class=\"col-md-3 form-group\"><a ng-if=\"vm.showSave\" ng-click=\"vm.AddRecord()\" class=\"btn btn-lg btn-primary\"><span class=\"glyphicon glyphicon-save\"></span> Save</a></div><div class=\"col-md-4\">&nbsp;</div><div class=\"col-md-3\" style=\"margin-top:-20px;\"><div class=\"form-horizontal pull-right\"><div class=\"form-group\"><input type=\"radio\" ng-change=\"vm.reloadList()\" class=\"mgr mgr-primary mgr-lg\" ng-model=\"vm.showAll\" name=\"radios\" id=\"radios-0\" value=\"all\" checked=\"checked\"> All&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type=\"radio\" ng-change=\"vm.reloadList()\" class=\"mgr mgr-primary mgr-lg\" ng-model=\"vm.showAll\" name=\"radios\" id=\"radios-1\" value=\"active\"> Active&nbsp;&nbsp; <input type=\"radio\" ng-change=\"vm.reloadList()\" class=\"mgr mgr-primary mgr-lg\" ng-model=\"vm.showAll\" name=\"radios\" id=\"radios-3\" value=\"inactive\"> Inactive</div></div></div><div class=\"col-md-1\">&nbsp;</div></div><div class=\"row\"><div class=\"col-md-12\" style=\"height: 550px; margin-top: 8px;overflow-x: auto;\"><table class=\"table table-bordered\"><thead style=\"background: #f5f5f5;text-align:center;\"><tr><th rowspan=\"2\">SNo</th><th rowspan=\"2\">Age Group</th><th rowspan=\"2\">Vaccine Name</th><th rowspan=\"2\">Description</th><th rowspan=\"2\">Disease</th><th rowspan=\"2\">Gender</th><th rowspan=\"2\">Site</th><th rowspan=\"2\">Side Effects</th><th style=\"text-align: center;\" colspan=\"2\">Brands</th><th rowspan=\"2\">Dependency</th><th rowspan=\"2\">Remarks</th><th rowspan=\"2\">Mandatory</th><th rowspan=\"2\">Media</th><th rowspan=\"2\"></th></tr><tr><th>Brand</th><th>Inventory</th></tr></thead><tbody><tr ng-repeat=\"row in vm.masterlist\"><td>{{($index + 1)}}</td><td>{{row.age_group}}</td><td>{{row.name}}</td><td>{{row.description}}</td><td>{{row.disease}}</td><td>{{row.gender}}</td><td>{{row.site}}</td><td>{{row.side_effects}}</td><td class=\"text-left\" ng-if=\"row.brands.length == 0\" style=\"text-align: center;\">N/A</td><td class=\"text-left\" ng-if=\"row.brands.length > 0\" style=\"text-align: center;width: 150px;\"><span ng-repeat=\"data in row.brands\">{{data.brand_name}}<br></span></td><td class=\"text-left\" ng-if=\"row.brands.length == 0\" style=\"text-align: center;\">N/A</td><td ng-if=\"row.brands.length > 0\" style=\"text-align: center;width: 220px;\"><span ng-repeat=\"data in row.brands\">{{data.eshop_product_name}}<br></span></td><td>{{row.dependency}} <span ng-if=\"row.dependency\">days</span></td><td>{{row.remarks}}</td><td class=\"text-center\" ng-if=\"row.status == true\"><i class=\"glyphicon glyphicon-ok\" style=\"color: green;\"></i></td><td class=\"text-center\" ng-if=\"row.status == false\"><i class=\"glyphicon glyphicon-remove\" style=\"color: red;\"></i></td><td><i class=\"glyphicon glyphicon-play-circle\" style=\"font-size: 20px;\" ng-click=\"vm.openmedia(row)\" ng-if=\"((row.message_url != null)&&(row.message_url != \'\'))\"></i></td><td><span class=\"glyphicon glyphicon-pencil btn btn-default btn-sm\" ng-click=\"vm.updateSelectRecord(row,$index)\"></span></td></tr></tbody></table></div></div><br><br><br>");
$templateCache.put("app/vac/viewinventory.html","<div class=\"row\"><div class=\"col-md-12\" style=\"height: 550px; margin-top: 8px;overflow-x: auto;\"><table class=\"table table-bordered\"><thead style=\"background: #f5f5f5;text-align:center;\"><tr><th>SNo</th><th>Vaccination Image</th><th>Vaccination Name</th><th>Quantity</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"row in getinventory_data\"><td>{{($index + 1)}}</td><td><img ng-if=\"row.images.length == 0\" src=\"Content/Images/vaccine_placeholder.svg\" style=\"height: 50px;width: 50px;\" alt=\"\"> <img ng-if=\"row.images.length > 0\" src=\"{{row.images[0].src}}\" style=\"height: 50px;width: 50px;\" alt=\"\"></td><td>{{row.name}}</td><td>{{row.stock_quantity}}</td><td ng-if=\"row.stock_quantity > 0\" style=\"color: green;\">{{row.stock_status}}</td><td ng-if=\"row.stock_quantity <= 0\" style=\"color: tomato;\">{{row.stock_status}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/vac/viewmedia.html","<div ng-if=\"type == \'t\'\"><div>{{EnteredText}}</div></div><div ng-if=\"type == \'i\'\"><img src=\"{{imagesource}}\" height=\"200\" width=\"200\"></div><div ng-if=\"type == \'a\'\"><audio src=\"{{audiosource}}\" controls=\"\"></audio></div><div ng-if=\"type == \'h\'\"><span id=\"text_area\" style=\"width: 80%;\">{{link_source}}</span><br></div><div ng-if=\"type == \'v\'\"><video class=\"first\" autoplay=\"autoplay\" muted=\"muted\" loop=\"\" controls=\"\" src=\"{{videosource}}\" preload=\"metadata\"></video></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_1.tpl.html","<head><style>\n.red {\n  color: brown;\n}\n\n</style></head><div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(1,\'Abdominal pain\')\"></i><h4>Abdominal pain</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since&nbsp;&nbsp;</label> <input id=\"sinceDay1\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label class=\"labSel\" id=\"labSel1\" value=\"Pain colicky\" ng-click=\"setActive(\'labSel1\',1)\">Pain colicky</label> / <label class=\"labSel\" id=\"labSel2\" value=\"Continuous\" ng-click=\"setActive(\'labSel2\',1)\">Continuous</label> / <label class=\"labSel\" id=\"labSel3\" value=\"Pricking\" ng-click=\"setActive(\'labSel3\',1)\">Pricking</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform1\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_10.tpl.html","<div ng-if=\"aakash_hospital_complaint==\'false\'\" class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(10,\'Epistaxis\')\"></i><h4>Epistaxis</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay10\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel22\" value=\"Small quantity\" ng-click=\"setActive(\'labSel22\',10,\'multi2\')\">Small quantity</label> / <label id=\"labSel23\" value=\"Moderate quantity\" ng-click=\"setActive(\'labSel23\',10,\'multi2\')\">Moderate quantity</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel24\" value=\"Nose picking present\" ng-click=\"setActive(\'labSel24\',10)\">Nose picking present</label> / <label id=\"labSel25\" value=\"Denied\" ng-click=\"setActive(\'labSel25\',10)\">Denied</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform10\"></textarea></div></div></div><div ng-if=\"aakash_hospital_complaint==\'true\'\" class=\"col-sm-4\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(10,\'Bleeding from nose\')\"></i><h4>Bleeding from nose</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay10\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel22\" value=\"Small quantity\" ng-click=\"setActive(\'labSel22\',10,\'multi2\')\">Small quantity</label> / <label id=\"labSel23\" value=\"Moderate quantity\" ng-click=\"setActive(\'labSel23\',10,\'multi2\')\">Moderate quantity</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel24\" value=\"Nose picking present\" ng-click=\"setActive(\'labSel24\',10)\">Nose picking present</label> / <label id=\"labSel25\" value=\"Denied\" ng-click=\"setActive(\'labSel25\',10)\">Denied</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform10\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_11.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #80e5ff;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(11,\'Fever\')\"></i><h4>Fever</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay11\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel26\" value=\"Continuous\" ng-click=\"setActive(\'labSel26\',11,\'multi2\')\">Continuous</label> / <label id=\"labSel27\" value=\"Intermittent\" ng-click=\"setActive(\'labSel27\',11,\'multi2\')\">Intermittent</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel28\" value=\"Associate with chills\" ng-click=\"setActive(\'labSel28\',11)\">Associate with chills</label> / <label id=\"labSel29\" value=\"Not Assc with chills\" ng-click=\"setActive(\'labSel29\',11)\">Not Associate with chills</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label>Temp max. &nbsp;</label> <input id=\"feverTemp\" type=\"number\" name=\"\" onfocus=\"callKeyFunc(this.value)\" min=\"93\" max=\"105\">&nbsp;&#8457;<p id=\"fvrTmp\" style=\"color:red;\"></p></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform11\"></textarea></div></div></div><script>\n       \n    function callKeyFunc(val){\n\n\n       if(val<93 || val>105 ){\n            $(\"#fvrTmp\").text(\"(Please enter value between 93 to 105)\");\n       }\n \n    }\n    </script>");
$templateCache.put("app/baby-profile/Complaints/Complaints_12.tpl.html","<div class=\"col-sm-4 divzindex\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(12,\'Fast breathing\')\"></i><h4>Fast breathing</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay12\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform12\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_13.tpl.html","<div ng-if=\"aakash_hospital_complaint==\'false\'\" class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(13,\'Haemetemesis\')\"></i><h4>Haemetemesis</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay13\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel30\" value=\"Blood bright red\" ng-click=\"setActive(\'labSel30\',13,\'multi2\')\">Blood bright red</label> / <label id=\"labSel31\" value=\"Dark red\" ng-click=\"setActive(\'labSel31\',13,\'multi2\')\">Dark red</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel32\" value=\"Only streaks\" ng-click=\"setActive(\'labSel32\',13)\">Only streaks</label> / <label id=\"labSel33\" value=\"Mild quantity\" ng-click=\"setActive(\'labSel33\',13)\">Mild quantity</label> / <label id=\"labSel34\" value=\"Moderate quantity\" ng-click=\"setActive(\'labSel34\',13)\">Moderate quantity</label> / <label id=\"labSel35\" value=\"Large Quantity\" ng-click=\"setActive(\'labSel35\',13)\">Large Quantity</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform13\"></textarea></div></div></div><div ng-if=\"aakash_hospital_complaint==\'true\'\" class=\"col-sm-4\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(13,\'Blood stained vomiting\')\"></i><h4>Blood stained vomiting</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay13\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel30\" value=\"Blood bright red\" ng-click=\"setActive(\'labSel30\',13,\'multi2\')\">Blood bright red</label> / <label id=\"labSel31\" value=\"Dark red\" ng-click=\"setActive(\'labSel31\',13,\'multi2\')\">Dark red</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel32\" value=\"Only streaks\" ng-click=\"setActive(\'labSel32\',13)\">Only streaks</label> / <label id=\"labSel33\" value=\"Mild quantity\" ng-click=\"setActive(\'labSel33\',13)\">Mild quantity</label> / <label id=\"labSel34\" value=\"Moderate quantity\" ng-click=\"setActive(\'labSel34\',13)\">Moderate quantity</label> / <label id=\"labSel35\" value=\"Large Quantity\" ng-click=\"setActive(\'labSel35\',13)\">Large Quantity</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform13\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_14.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(14,\'Hemetocheisia\')\"></i><h4>Hemetocheisia</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay14\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel36\" value=\"Assc with pain\" ng-click=\"setActive(\'labSel36\',14)\">Assc with pain</label> / <label id=\"labSel37\" value=\"Unassc with pain\" ng-click=\"setActive(\'labSel37\',14)\">Unassc with pain</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform14\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_15.tpl.html","<div ng-if=\"aakash_hospital_complaint==\'false\'\" class=\"col-sm-4 divzindex\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(15,\'Malena\')\"></i><h4>Malena</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay15\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform15\"></textarea></div></div></div><div ng-if=\"aakash_hospital_complaint==\'true\'\" class=\"col-sm-4\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(15,\'Blackish stools\')\"></i><h4>Blackish stools</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay15\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform15\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_16.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(16,\'Oedema\')\"></i><h4>Oedema</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay16\" type=\"number\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel38\" value=\"Pedal Oedema\" ng-click=\"setActive(\'labSel38\',16)\">Pedal Oedema</label> / <label id=\"labSel39\" value=\"Renal Oedema\" ng-click=\"setActive(\'labSel39\',16)\">Renal Oedema</label> / <label id=\"labSel40\" value=\"Carniac Oedema\" ng-click=\"setActive(\'labSel40\',16)\">Carniac Oedema</label> / <label id=\"labSel41\" value=\"Gen. Oedema\" ng-click=\"setActive(\'labSel41\',16)\">Gen. Oedema</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform16\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_17.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(17,\'Red eye\')\"></i><h4>Red eye</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay17\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel42\" value=\"Left\" ng-click=\"setActive(\'labSel42\',17)\">Left</label> / <label id=\"labSel43\" value=\"Right\" ng-click=\"setActive(\'labSel43\',17)\">Right</label> / <label id=\"labSel44\" value=\"Both\" ng-click=\"setActive(\'labSel44\',17)\">Both</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform17\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_18.tpl.html","<div class=\"col-sm-4 divzindex\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(18,\'Seizures\')\"></i><h4>Seizures</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Occured on&nbsp;&nbsp;</label><input id=\"seizureDays\" type=\"text\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"rangePicker1.opened.Date\" datepicker-options=\"rangePicker1.dateOptions\" required=\"\" ng-model=\"Date\" ng-focus=\"rangePicker1.opened.Date=true\" ng-change=\"byRange(Date)\" placeholder=\"Date\"></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel45\" value=\"Generalised\" ng-click=\"setActive(\'labSel45\',18,\'multi2\')\">Generalised</label> / <label id=\"labSel46\" value=\"Focal\" ng-click=\"setActive(\'labSel46\',18,\'multi2\')\">Focal</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel47\" value=\"Associate with fever\" ng-click=\"setActive(\'labSel47\',18)\">Associate with fever</label> / <label id=\"labSel48\" value=\"Not Associate with fever\" ng-click=\"setActive(\'labSel48\',18)\">Not Associate with fever</label></div></div><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Seizure last for&nbsp;</label> <input id=\"seizureMins\" type=\"number\" name=\"\" min=\"1\" max=\"60\">&nbsp; mins</div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform18\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_19.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(19,\'Vomiting\')\"></i><h4>Vomiting</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay19\" type=\"number\" name=\"\" min=\"1\" max=\"5\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label class=\"labSel\" id=\"labSel49\" value=\"Non-bilious\" ng-click=\"setActive(\'labSel49\',19)\">Non-bilious</label> / <label class=\"labSel\" id=\"labSel50\" value=\"Bilious\" ng-click=\"setActive(\'labSel50\',19)\">Bilious</label> / <label class=\"labSel\" id=\"labSel51\" value=\"Hemorrhagic\" ng-click=\"setActive(\'labSel51\',19)\">Hemorrhagic</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform19\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_2.tpl.html","<div ng-if=\"aakash_hospital_complaint==\'false\'\" class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(2,\'Anorexia\')\"></i><h4>Anorexia</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay2\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform2\"></textarea></div></div></div><div ng-if=\"aakash_hospital_complaint==\'true\'\" class=\"col-sm-4\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(2,\'Loss of appetite\')\"></i><h4>Loss of appetite</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay2\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform2\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_20.tpl.html","<div ng-if=\"aakash_hospital_complaint==\'false\'\" class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(20,\'Other Complaints\')\"></i><h4>Other Complaints</h4><div class=\"card card-default\"><div class=\"card-body\"><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform20\"></textarea></div></div></div><div ng-if=\"aakash_hospital_complaint==\'true\'\" class=\"col-sm-4\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(20,\'Vaccination\')\"></i><h4>Vaccination</h4><div class=\"card card-default\"><div class=\"card-body\"><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform20\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_21.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(21,\'Blood stained semisolid stool\')\"></i><h4>Blood stained semisolid stool</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay21\" type=\"number\" name=\"\" min=\"1\" max=\"5\">&nbsp; days</div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform21\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_22.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(22,\'Others\')\"></i><h4>Others</h4><div class=\"card card-default\"><div class=\"card-body\"><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform22\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_3.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(3,\'Cold\')\"></i><h4>Cold</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since&nbsp;&nbsp;</label> <input id=\"sinceDay3\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label class=\"labSel\" id=\"labSel4\" value=\"Nose block present\" ng-click=\"setActive(\'labSel4\',3,\'multi2\')\">Nose block present</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label class=\"labSel\" id=\"labSel5\" value=\"Nasal discharge thin\" ng-click=\"setActive(\'labSel5\',3)\">Nasal discharge thin</label> / <label class=\"labSel\" id=\"labSel6\" value=\"Nasal discharge thick\" ng-click=\"setActive(\'labSel6\',3)\">Nasal discharge thick</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform3\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_4.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(4,\'Cough\')\"></i><h4>Cough</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay4\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label class=\"labSel\" id=\"labSel7\" value=\"Productive\" ng-click=\"setActive(\'labSel7\',4)\">Productive</label> / <label class=\"labSel\" id=\"labSel8\" value=\"Dry\" ng-click=\"setActive(\'labSel8\',4)\">Dry</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform4\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_5.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(5,\'Chest pain\')\"></i><h4>Chest pain</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay5\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label class=\"labSel\" id=\"labSel9\" value=\"On right side\" ng-click=\"setActive(\'labSel9\',5)\">On right side</label> / <label class=\"labSel\" id=\"labSel10\" value=\"On left side\" ng-click=\"setActive(\'labSel10\',5)\">On left side</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform5\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_6.tpl.html","<div class=\"col-sm-4 divzindex\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(6,\'Diarrhea\')\"></i><h4>Diarrhea</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay6\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label class=\"labSel\" id=\"labSel11\" value=\"Stools watery\" ng-click=\"setActive(\'labSel11\',6,\'multi2\')\">Stools watery</label> / <label class=\"labSel\" id=\"labSel12\" value=\"Semi solid\" ng-click=\"setActive(\'labSel12\',6,\'multi2\')\">Semi solid</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label class=\"labSel\" id=\"labSel13\" value=\"Blood in stools present\" ng-click=\"setActive(\'labSel13\',6)\">Blood in stools present</label> / <label class=\"labSel\" id=\"labSel14\" value=\"Blood in stools absent\" ng-click=\"setActive(\'labSel14\',6)\">Blood in stools absent</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform6\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_7.tpl.html","<div class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(7,\'Dyspnoea\')\"></i><h4>Dyspnoea</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay7\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel16\" value=\"On exertion\" ng-click=\"setActive(\'labSel16\',7)\">On exertion</label> / <label id=\"labSel17\" value=\"Even at Rest\" ng-click=\"setActive(\'labSel17\',7)\">Even at Rest</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform7\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_8.tpl.html","<div ng-if=\"aakash_hospital_complaint==\'false\'\" class=\"col-sm-4 divzindex\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(8,\'Dysphagia\')\"></i><h4>Dysphagia</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay8\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform8\"></textarea></div></div></div><div ng-if=\"aakash_hospital_complaint==\'true\'\" class=\"col-sm-4\" style=\"border-right:1px solid #008ae6;\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(8,\'Difficulty in swallowing\')\"></i><h4>Difficulty in swallowing</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay8\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform8\"></textarea></div></div></div>");
$templateCache.put("app/baby-profile/Complaints/Complaints_9.tpl.html","<div class=\"col-sm-4 divzindex\"><i class=\"fa fa-times pull-right\" ng-click=\"removeDiv(9,\'Ear pain\')\"></i><h4>Ear pain</h4><div class=\"card card-default\"><div class=\"card-body\"><div class=\"row1 form-group\" style=\"padding-top:10px;\"><div class=\"col-75\"><label>Since &nbsp;&nbsp;</label> <input id=\"sinceDay9\" type=\"number\" name=\"\" min=\"1\" max=\"365\">&nbsp; days</div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel18\" value=\"Right side\" ng-click=\"setActive(\'labSel18\',9,\'multi2\')\">Right side</label> / <label id=\"labSel19\" value=\"Left side\" ng-click=\"setActive(\'labSel19\',9,\'multi2\')\">Left side</label></div></div><div class=\"row1 form-group\"><div class=\"col-75\"><label id=\"labSel20\" value=\"Ear discharge present\" ng-click=\"setActive(\'labSel20\',9)\">Ear discharge present</label> / <label id=\"labSel21\" value=\"No Ear discharge present\" ng-click=\"setActive(\'labSel21\',9)\">No Ear discharge present</label></div></div><textarea class=\"form-control\" rows=\"4\" placeholder=\"Other information\" id=\"otInform9\"></textarea></div></div></div>");
$templateCache.put("app/patient/dig/abd.tpl.html","<form class=\"form-horizontal\"><h4 class=\"page-title text-center\">STOMACH</h4><hr><div ng-repeat=\"item in dig.stomach\" class=\"form-group\"><label class=\"col-md-4 control-label\">{{item.label}}</label><div ng-if=\"item.opt\" class=\"col-md-4\"><select ng-model=\"item.value\" class=\"form-control\" ng-options=\"option for option in item.opt\"><option value=\"\" disabled=\"\" selected=\"\">Select your option</option></select></div><div ng-if=\"item.bool\" class=\"col-md-4\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.value\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div><h4 class=\"page-title text-center\">VOMITING</h4><hr><div ng-repeat=\"item in dig.vomiting\" class=\"form-group\"><label class=\"col-md-4 control-label\">{{item.label}}</label><div ng-if=\"item.opt\" class=\"col-md-4\"><select ng-model=\"item.value\" class=\"form-control\" ng-options=\"option for option in item.opt\"><option value=\"\" disabled=\"\" selected=\"\">Select your option</option></select></div><div ng-if=\"item.bool\" class=\"col-md-4\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.value\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div><h4 class=\"page-title text-center\">URINE</h4><hr><div ng-repeat=\"item in dig.urine\" class=\"form-group\"><label class=\"col-md-4 control-label\">{{item.label}}</label><div ng-if=\"item.opt\" class=\"col-md-4\"><select ng-model=\"item.value\" class=\"form-control\" ng-options=\"option for option in item.opt\"><option value=\"\" disabled=\"\" selected=\"\">Select your option</option></select></div><div ng-if=\"item.bool\" class=\"col-md-4\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.value\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div></form>");
$templateCache.put("app/patient/dig/cold.tpl.html","<form class=\"form-horizontal\"><h4 class=\"page-title text-center\">COLD</h4><hr><div ng-repeat=\"item in dig.cold\" class=\"form-group\"><label class=\"col-md-4 control-label\">{{item.label}}</label><div ng-if=\"item.opt\" class=\"col-md-4\"><select ng-model=\"item.value\" class=\"form-control\" ng-options=\"option for option in item.opt\"><option value=\"\" disabled=\"\" selected=\"\">Select your option</option></select></div><div ng-if=\"item.bool\" class=\"col-md-4\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.value\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div><h4 class=\"page-title text-center\">COUGH</h4><hr><div ng-repeat=\"item in dig.cough\" class=\"form-group\"><label class=\"col-md-4 control-label\">{{item.label}}</label><div ng-if=\"item.opt\" class=\"col-md-4\"><select ng-model=\"item.value\" class=\"form-control\" ng-options=\"option for option in item.opt\"><option value=\"\" disabled=\"\" selected=\"\">Select your option</option></select></div><div ng-if=\"item.bool\" class=\"col-md-4\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.value\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div></form>");
$templateCache.put("app/patient/dig/fever.tpl.html","<form class=\"form-horizontal\"><h4 class=\"page-title text-center\">FEVER</h4><hr><div ng-repeat=\"item in dig.fever\" class=\"form-group\"><label class=\"col-md-4 control-label\">{{item.label}}</label><div ng-if=\"item.opt\" class=\"col-md-4\"><select ng-model=\"item.value\" class=\"form-control\" ng-options=\"option for option in item.opt\"><option value=\"\" disabled=\"\" selected=\"\">Select your option</option></select></div><div ng-if=\"item.bool\" class=\"col-md-4\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.value\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div></form>");
$templateCache.put("app/patient/dig/mnc.tpl.html","<form class=\"form-horizontal\"><h4 class=\"page-title text-center\">MOTION PROBLEMS</h4><h4 class=\"page-title\">Loose motion</h4><hr><div ng-repeat=\"item in dig.motion\" class=\"form-group\"><label class=\"col-md-4 control-label\">{{item.label}}</label><div ng-if=\"item.opt\" class=\"col-md-4\"><select ng-model=\"item.value\" class=\"form-control\" ng-options=\"option for option in item.opt\"><option value=\"\" disabled=\"\" selected=\"\">Select your option</option></select></div><div ng-if=\"item.bool\" class=\"col-md-4\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.value\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div><h4 class=\"page-title\">Constipation</h4><hr><div ng-repeat=\"item in dig.constipation\" class=\"form-group\"><label class=\"col-md-4 control-label\">{{item.label}}</label><div ng-if=\"item.opt\" class=\"col-md-4\"><select ng-model=\"item.value\" class=\"form-control\" ng-options=\"option for option in item.opt\"><option value=\"\" disabled=\"\" selected=\"\">Select your option</option></select></div><div ng-if=\"item.bool\" class=\"col-md-4\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.value\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div></form>");
$templateCache.put("app/patient/dig/other.tpl.html","<h4 class=\"page-title text-center\">OTHER ISSUES</h4><hr><div class=\"row\" style=\"font-weight: 600;\"><div class=\"col-md-2\">&nbsp;</div><div class=\"col-md-2 text-center\">Pain</div><div class=\"col-md-2 text-center\">Skin Changes</div><div class=\"col-md-2 text-center\">Injury</div><div class=\"col-md-2 text-center\">Swelling</div></div><div ng-repeat=\"item in dig.other\" class=\"row\" style=\"padding: 4px;\"><div class=\"col-md-2\" style=\"font-weight: 600;\">{{item.label}}</div><div class=\"col-md-2 text-center\"><input ng-if=\"!item.bool\" type=\"checkbox\" class=\"mgc mgc-primary mgc-circle\" ng-model=\"item.pain\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div><div class=\"col-md-2 text-center\"><input ng-if=\"!item.bool\" type=\"checkbox\" class=\"mgc mgc-primary mgc-circle\" ng-model=\"item.skin\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div><div class=\"col-md-2 text-center\"><input ng-if=\"!item.bool\" type=\"checkbox\" class=\"mgc mgc-primary mgc-circle\" ng-model=\"item.injury\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div><div class=\"col-md-2 text-center\"><input ng-if=\"!item.bool\" type=\"checkbox\" class=\"mgc mgc-primary mgc-circle\" ng-model=\"item.swelling\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></div></div><div ng-repeat=\"item in dig.otherPain\"><hr><div class=\"row\"><div class=\"col-md-2\" style=\"font-weight: 600;\">{{item.label}}</div><div class=\"col-md-10\"><span class=\"pull-right\"><input type=\"checkbox\" class=\"mgc-switch mgc-lg\" ng-model=\"item.pain\" ng-true-value=\"\'Yes\'\" ng-false-value=\"\'No\'\"></span></div></div></div><hr>");
$templateCache.put("app/patient/dig/vac.tpl.html","<h2 class=\"page-title\"><span class=\"fa fa-tint\"></span> Vaccination</h2><div class=\"table-responsive bg-color col-sm-12\"><table class=\"table table-hover\"><thead><tr><th><center>S No<center></center></center></th><th><center>Name<center></center></center></th><th><center>Batch #<center></center></center></th><th><center>Scheduled Date<center></center></center></th><th><center>Appointment Date<center></center></center></th><th><center>Vaccinated Date<center></center></center></th><th><center>Status<center></center></center></th></tr></thead><tbody><tr ng-repeat=\"Vacc in vaccinationList\"><td><center>{{$index + 1}}<center></center></center></td><td><center>{{Vacc.product_name_title}}<center></center></center></td><td><center>{{Vacc.batch_id}}<center></center></center></td><td><center>{{Vacc.due_date | date:\'dd-MMM-yyyy\'}}<center></center></center></td><td><center>{{Vacc.appointment_date|date:\'dd-MMM-yyyy\'}}<center></center></center></td><td><center>{{(Vacc.given_date!=null && Vacc.administration_status_title!=\'Skipped\') && (Vacc.given_date | date:\'dd-MMM-yyyy\') || \'\'}}<center></center></center></td><td><center><span ng-if=\"getVaccinationStatus(Vacc)==1\" class=\"fa fa-check link\" ng-click=\"showVacAttachment(Vacc)\"></span><span class=\"text-danger link\" ng-if=\"getVaccinationStatus(Vacc)==3\" ng-click=\"openUpdateVaccine(Vacc)\">Overdue</span><span class=\"text-primary\" ng-if=\"getVaccinationStatus(Vacc)==2\">upcoming</span><span class=\"text-primary link\" ng-if=\"getVaccinationStatus(Vacc)==4\" ng-click=\"openUpdateVaccine(Vacc)\">skipped</span><center></center></center></td></tr><tr ng-if=\"vaccinationList.length==0\"><td colspan=\"5\">No results found</td></tr></tbody></table></div>");}]);